
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6fTvc", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");


var $e8Lxy = parcelRequire("e8Lxy");


var $lkYxq = parcelRequire("lkYxq");


var $6ozxE = parcelRequire("6ozxE");


var $k7Uqa = parcelRequire("k7Uqa");


var $2Awp2 = parcelRequire("2Awp2");


var $9A1Zq = parcelRequire("9A1Zq");


var $bYH75 = parcelRequire("bYH75");


var $6mKj3 = parcelRequire("6mKj3");


var $jMyy4 = parcelRequire("jMyy4");


var $1xpoY = parcelRequire("1xpoY");








var $80koo = parcelRequire("80koo");

const $2dccff1e83a4df01$var$WRM_MODULES = [
    'wr!com.atlassian.confluence.plugins.confluence-jira-content:confluence-jira-content-loader'
];
const $2dccff1e83a4df01$export$57a2346a7af5381 = ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $80koo.RequireLegacyWRM), {
            wrm: $2dccff1e83a4df01$var$WRM_MODULES
        }, $2dccff1e83a4df01$var$_temp);
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
function $2dccff1e83a4df01$var$_temp() {
    return null;
}



var $35oAA = parcelRequire("35oAA");

/**
 * @generated SignedSource<<2a24ae49b545ee2628a251c1f83c0d26>>
 * @relayHash c5a07dbab189fd187abde6f42676a1f3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4893dae9319696910a4923704884dd2778e3a2f5b23d8645a3634537b5dddf8d
const $f1561fd74e26a90b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "archived",
                        "current"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PageStatusQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PageStatusQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "c5a07dbab189fd187abde6f42676a1f3",
            "id": "4893dae9319696910a4923704884dd2778e3a2f5b23d8645a3634537b5dddf8d",
            "metadata": {},
            "name": "PageStatusQuery",
            "operationKind": "query",
            "text": "query PageStatusQuery($contentId:ID!){content(id:$contentId,status:[\"archived\",\"current\"]){nodes{id,status}}}"
        }
    };
}();
$f1561fd74e26a90b$var$node.hash = "8340931b8ec5ecd3173ae02fb9acae27";
var $f1561fd74e26a90b$export$2e2bcd8739ae039 = $f1561fd74e26a90b$var$node;


/**
 * @generated SignedSource<<17b590530e3a7102480ead09dd88f26d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $aa248e709e68c0c1$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "PageStatusQueryRelaySpike_content",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "status"
        }
    ],
    "type": "Content"
};
$aa248e709e68c0c1$var$node.hash = "2a176aa4faefb351edd19c84ee87b887";
var $aa248e709e68c0c1$export$2e2bcd8739ae039 = $aa248e709e68c0c1$var$node;


const $cc446e686defbb68$export$6cb5261c46410717 = (0, $aa248e709e68c0c1$export$2e2bcd8739ae039);
const $cc446e686defbb68$export$784933f26864b1a8 = (0, $f1561fd74e26a90b$export$2e2bcd8739ae039);


const $ceee820a34544465$var$SPA = true;
const $ceee820a34544465$var$styles = {
    containerWidth: "_313842dnbC _0adFHsIZbP _1DCdHidnbC _2XsHFMIZbP _39xV02N91d",
    footerSpacing: "_1DCdHiyFLW"
};
const $ceee820a34544465$var$ViewPageContentRenderer = (t0)=>{
    const $ = (0, $bDgLe.c)(44);
    let contentId;
    let data;
    let isArchived;
    let isEmbeddedPage;
    let isSpaceOverview;
    let passThroughProps;
    let t1;
    let t2;
    if ($[0] !== t0) {
        ({ contentId: contentId, data: data, isArchived: isArchived, isEmbeddedPage: isEmbeddedPage, isSpaceOverview: isSpaceOverview, useRendererFragments: t1, hasProgressiveRendering: t2, ...passThroughProps } = t0);
        $[0] = t0;
        $[1] = contentId;
        $[2] = data;
        $[3] = isArchived;
        $[4] = isEmbeddedPage;
        $[5] = isSpaceOverview;
        $[6] = passThroughProps;
        $[7] = t1;
        $[8] = t2;
    } else {
        contentId = $[1];
        data = $[2];
        isArchived = $[3];
        isEmbeddedPage = $[4];
        isSpaceOverview = $[5];
        passThroughProps = $[6];
        t1 = $[7];
        t2 = $[8];
    }
    const useRendererFragments = t1 === undefined ? false : t1;
    const hasProgressiveRendering = t2 === undefined ? true : t2;
    const { versionOverride: versionOverride, embeddedContentRender: embeddedContentRender, queryHash: queryHash } = (0, $35oAA.useViewPageParams)();
    let t3;
    if ($[9] !== data?.content?.nodes?.[0]?.pageContentRendererFragment || $[10] !== data?.space?.pageContentRendererFragment || $[11] !== useRendererFragments) {
        t3 = useRendererFragments ? {
            contentFragmentRef: data?.content?.nodes?.[0]?.pageContentRendererFragment,
            spaceFragmentRef: data?.space?.pageContentRendererFragment
        } : {};
        $[9] = data?.content?.nodes?.[0]?.pageContentRendererFragment;
        $[10] = data?.space?.pageContentRendererFragment;
        $[11] = useRendererFragments;
        $[12] = t3;
    } else t3 = $[12];
    const rendererFragmentProps = t3;
    let t4;
    if ($[13] !== data?.content?.nodes?.[0]?.viewPageContentMode) {
        t4 = Boolean(data?.content?.nodes?.[0]?.viewPageContentMode) && !(0, $1xpoY.default).isKillSwitchOn("confluence_vp_mode_frag_reader") && (0, $6mKj3.expVal)("confluence_exp_vp_document", "isEnabled", false) ? {
            contentModeFragmentRef: data?.content?.nodes?.[0]?.viewPageContentMode
        } : {};
        $[13] = data?.content?.nodes?.[0]?.viewPageContentMode;
        $[14] = t4;
    } else t4 = $[14];
    const contentModeFragmentProps = t4;
    let t5;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, $cozmU.createRef)();
        $[15] = t5;
    } else t5 = $[15];
    const refOfNodeToWatchForChange = t5;
    let t6;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $6mKj3.UNSAFE_isExperimentEnabledNoExposure)("cc-maui-experiment") ? {
            "data-remix-main-content": "true"
        } : {};
        $[16] = t6;
    } else t6 = $[16];
    const t7 = !isSpaceOverview && $ceee820a34544465$var$styles.footerSpacing;
    let t8;
    if ($[17] !== t7) {
        t8 = (0, $w6R6I.cx)($ceee820a34544465$var$styles.containerWidth, t7);
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] !== queryHash) {
        t9 = $ceee820a34544465$var$SPA && refOfNodeToWatchForChange && queryHash ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lkYxq.DeepLinkHandler), {
            scrollTargetId: queryHash,
            refOfNodeToWatchForChange: refOfNodeToWatchForChange,
            scrollTarget: "queryHash"
        }) : null;
        $[19] = queryHash;
        $[20] = t9;
    } else t9 = $[20];
    let t10;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = $ceee820a34544465$var$SPA && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9A1Zq.ScrollToHashLinkHandler), {
            anchorContainer: refOfNodeToWatchForChange
        });
        $[21] = t10;
    } else t10 = $[21];
    let t11;
    if ($[22] !== contentId || $[23] !== data || $[24] !== embeddedContentRender || $[25] !== hasProgressiveRendering || $[26] !== isArchived || $[27] !== isEmbeddedPage || $[28] !== isSpaceOverview || $[29] !== queryHash || $[30] !== versionOverride) {
        t11 = {
            contentId: contentId,
            versionOverride: versionOverride,
            embeddedContentRender: embeddedContentRender,
            queryHash: queryHash,
            data: data,
            isArchived: isArchived,
            isEmbeddedPage: isEmbeddedPage,
            isSpaceOverview: isSpaceOverview,
            hasProgressiveRendering: hasProgressiveRendering
        };
        $[22] = contentId;
        $[23] = data;
        $[24] = embeddedContentRender;
        $[25] = hasProgressiveRendering;
        $[26] = isArchived;
        $[27] = isEmbeddedPage;
        $[28] = isSpaceOverview;
        $[29] = queryHash;
        $[30] = versionOverride;
        $[31] = t11;
    } else t11 = $[31];
    let t12;
    if ($[32] !== contentModeFragmentProps || $[33] !== passThroughProps || $[34] !== rendererFragmentProps || $[35] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e8Lxy.PageContentRenderer), {
            ...contentModeFragmentProps,
            ...t11,
            ...rendererFragmentProps,
            ...passThroughProps
        });
        $[32] = contentModeFragmentProps;
        $[33] = passThroughProps;
        $[34] = rendererFragmentProps;
        $[35] = t11;
        $[36] = t12;
    } else t12 = $[36];
    let t13;
    if ($[37] !== contentId) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bYH75.OnboardingNthUserContentTypeSpotlight), {
            contentType: (0, $bYH75.ContentType).PAGE,
            contentId: contentId
        });
        $[37] = contentId;
        $[38] = t13;
    } else t13 = $[38];
    let t14;
    if ($[39] !== t12 || $[40] !== t13 || $[41] !== t8 || $[42] !== t9) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            id: "content",
            "data-inline-comments-target": "true",
            ...t6,
            "data-testid": "page-content-only",
            ref: (0, $k7Uqa.setPageContentElement),
            className: "highlighter-context page view"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t8,
            ref: refOfNodeToWatchForChange
        }, t9, t10, t12, t13));
        $[39] = t12;
        $[40] = t13;
        $[41] = t8;
        $[42] = t9;
        $[43] = t14;
    } else t14 = $[43];
    return t14;
};
const $ceee820a34544465$export$c30074f2e8af898e = (t0)=>{
    const $ = (0, $bDgLe.c)(38);
    let contentId;
    let contentStatusError;
    let data;
    let hasInlineComments;
    let isArchived;
    let lastModifiedDate;
    let passThroughProps;
    let t1;
    if ($[0] !== t0) {
        ({ contentId: contentId, hasInlineComments: hasInlineComments, hasInlineActions: t1, data: data, lastModifiedDate: lastModifiedDate, isArchived: isArchived, contentStatusError: contentStatusError, ...passThroughProps } = t0);
        $[0] = t0;
        $[1] = contentId;
        $[2] = contentStatusError;
        $[3] = data;
        $[4] = hasInlineComments;
        $[5] = isArchived;
        $[6] = lastModifiedDate;
        $[7] = passThroughProps;
        $[8] = t1;
    } else {
        contentId = $[1];
        contentStatusError = $[2];
        data = $[3];
        hasInlineComments = $[4];
        isArchived = $[5];
        lastModifiedDate = $[6];
        passThroughProps = $[7];
        t1 = $[8];
    }
    const hasInlineActions = t1 === undefined ? true : t1;
    const isFabric = Boolean(data?.content?.nodes?.[0]?.body?.dynamic?.representation === "atlas_doc_format");
    const contentOperationsNode = data?.content?.nodes?.[0];
    let t2;
    if ($[9] !== contentId || $[10] !== contentOperationsNode) {
        t2 = contentOperationsNode?.id === contentId && (0, $6mKj3.expVal)("confluence_inline_comment_relay_content_ops", "isEnabled", false) ? (0, $6ozxE.canAddCommentsFromOperations)(contentOperationsNode.operations) : undefined;
        $[9] = contentId;
        $[10] = contentOperationsNode;
        $[11] = t2;
    } else t2 = $[11];
    const preloadedCanAddComments = t2;
    let t3;
    if ($[12] !== data?.content?.nodes?.[0]) {
        t3 = Boolean(data?.content?.nodes?.[0]) && !(0, $1xpoY.default).isKillSwitchOn("confluence_vp_body_frag_reader") && (0, $6mKj3.expVal)("confluence_exp_vp_document", "isEnabled", false);
        $[12] = data?.content?.nodes?.[0];
        $[13] = t3;
    } else t3 = $[13];
    const useRendererFragments = t3;
    let t4;
    if ($[14] !== contentId || $[15] !== contentStatusError || $[16] !== data || $[17] !== hasInlineComments || $[18] !== isArchived || $[19] !== lastModifiedDate || $[20] !== passThroughProps || $[21] !== preloadedCanAddComments || $[22] !== useRendererFragments) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ceee820a34544465$var$ViewPageContentRenderer, {
            contentId: contentId,
            data: data,
            lastModifiedDate: lastModifiedDate,
            hasInlineComments: hasInlineComments,
            isArchived: isArchived,
            contentStatusError: contentStatusError,
            preloadedCanAddComments: preloadedCanAddComments,
            useRendererFragments: useRendererFragments,
            ...passThroughProps
        });
        $[14] = contentId;
        $[15] = contentStatusError;
        $[16] = data;
        $[17] = hasInlineComments;
        $[18] = isArchived;
        $[19] = lastModifiedDate;
        $[20] = passThroughProps;
        $[21] = preloadedCanAddComments;
        $[22] = useRendererFragments;
        $[23] = t4;
    } else t4 = $[23];
    let t5;
    if ($[24] !== hasInlineActions) {
        t5 = $ceee820a34544465$var$SPA && hasInlineActions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2dccff1e83a4df01$export$57a2346a7af5381), null);
        $[24] = hasInlineActions;
        $[25] = t5;
    } else t5 = $[25];
    let t6;
    if ($[26] !== t4 || $[27] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t4, t5);
        $[26] = t4;
        $[27] = t5;
        $[28] = t6;
    } else t6 = $[28];
    const viewPageContentRenderer = t6;
    if (isFabric) return viewPageContentRenderer;
    let t7;
    if ($[29] !== contentId || $[30] !== contentStatusError || $[31] !== hasInlineComments || $[32] !== isArchived || $[33] !== isFabric || $[34] !== lastModifiedDate || $[35] !== preloadedCanAddComments || $[36] !== viewPageContentRenderer) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Awp2.HighlightActions), {
            contentId: contentId,
            contentType: (0, $bYH75.ContentType).PAGE,
            hasInlineComments: hasInlineComments,
            lastModifiedDate: lastModifiedDate,
            isArchived: isArchived,
            contentStatusError: contentStatusError,
            isFabric: isFabric,
            preloadedCanAddComments: preloadedCanAddComments
        }, viewPageContentRenderer);
        $[29] = contentId;
        $[30] = contentStatusError;
        $[31] = hasInlineComments;
        $[32] = isArchived;
        $[33] = isFabric;
        $[34] = lastModifiedDate;
        $[35] = preloadedCanAddComments;
        $[36] = viewPageContentRenderer;
        $[37] = t7;
    } else t7 = $[37];
    return t7;
};
const $ceee820a34544465$var$ViewPageContentWithFragmentStatus = (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    let data;
    let props;
    if ($[0] !== t0) {
        ({ data: data, ...props } = t0);
        $[0] = t0;
        $[1] = data;
        $[2] = props;
    } else {
        data = $[1];
        props = $[2];
    }
    const contentNode = data?.content?.nodes?.[0] ?? null;
    const statusData = (0, $6SsN4.useFragment)((0, $cc446e686defbb68$export$6cb5261c46410717), contentNode);
    const isArchived = statusData?.status ? statusData.status === "archived" : undefined;
    let t1;
    if ($[3] !== data || $[4] !== isArchived || $[5] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ceee820a34544465$export$c30074f2e8af898e, {
            ...props,
            data: data,
            isArchived: isArchived
        });
        $[3] = data;
        $[4] = isArchived;
        $[5] = props;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
};
const $ceee820a34544465$var$ViewPageContentWithQueryStatus = (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    let contentId;
    let props;
    if ($[0] !== t0) {
        ({ contentId: contentId, ...props } = t0);
        $[0] = t0;
        $[1] = contentId;
        $[2] = props;
    } else {
        contentId = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] !== contentId) {
        t1 = {
            variables: {
                contentId: contentId
            }
        };
        $[3] = contentId;
        $[4] = t1;
    } else t1 = $[4];
    const { data: contentStatusData, error: contentStatusError } = (0, $jMyy4.useQueryInterop)((0, $cc446e686defbb68$export$784933f26864b1a8), {
        ...t1,
        __callerPackage__: "view-page-common"
    });
    const isArchived = contentStatusData ? String(contentStatusData?.content?.nodes?.[0]?.status) === "archived" : undefined;
    let t2;
    if ($[5] !== contentId || $[6] !== contentStatusError || $[7] !== isArchived || $[8] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ceee820a34544465$export$c30074f2e8af898e, {
            ...props,
            contentId: contentId,
            isArchived: isArchived,
            contentStatusError: contentStatusError
        });
        $[5] = contentId;
        $[6] = contentStatusError;
        $[7] = isArchived;
        $[8] = props;
        $[9] = t2;
    } else t2 = $[9];
    return t2;
};
const $ceee820a34544465$export$d60c56cc11a3e27f = (props)=>{
    const $ = (0, $bDgLe.c)(4);
    if (!(0, $1xpoY.default).isKillSwitchOn("confluence_frontend_view_page_relay_fragment_dedup") && (0, $6mKj3.expVal)("confluence_exp_vp_document", "isEnabled", false)) {
        let t0;
        if ($[0] !== props) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ceee820a34544465$var$ViewPageContentWithFragmentStatus, props);
            $[0] = props;
            $[1] = t0;
        } else t0 = $[1];
        return t0;
    }
    let t0;
    if ($[2] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ceee820a34544465$var$ViewPageContentWithQueryStatus, props);
        $[2] = props;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
};
module.exports["ViewPageContent"] = $ceee820a34544465$export$c30074f2e8af898e;
module.exports["ViewPageContentWithStatus"] = $ceee820a34544465$export$d60c56cc11a3e27f;

});

parcelRegister("lkYxq", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $24dab9203569b68b$export$8d3fa3e13233933c = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "f2WXI",
    name: "DeepLinkHandler",
    loader: async ()=>(await (parcelRequire("9CocL"))).DeepLinkHandler
});
module.exports["DeepLinkHandler"] = $24dab9203569b68b$export$8d3fa3e13233933c;

});

parcelRegister("9CocL", function(module, exports) {

let $700a7042f692281f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $700a7042f692281f$var$load("4Guxu").then(()=>parcelRequire('joJKc'));

});

parcelRegister("6ozxE", function(module, exports) {

var $lfBMY = parcelRequire("lfBMY");

const $b3568511a7ce4c14$export$f67dec4694484421 = (operations)=>operations?.some((operation)=>operation?.operation === (0, $lfBMY.OperationTypes).CREATE && operation?.targetType === 'comment') ?? false;
module.exports["canAddCommentsFromOperations"] = $b3568511a7ce4c14$export$f67dec4694484421;

});

parcelRegister("lfBMY", function(module, exports) {
var $93e6e1e47a4562a8$export$64e79c67b77e1326 = /*#__PURE__*/ function(OperationTypes) {
    OperationTypes["USE"] = "use";
    OperationTypes["LIMITED_USE"] = "limited_use";
    OperationTypes["EXTERNAL_COLLABORATOR_USE"] = "external_collaborator_use";
    OperationTypes["CREATE"] = "create";
    OperationTypes["READ"] = "read";
    OperationTypes["UPDATE"] = "update";
    OperationTypes["DELETE"] = "delete";
    OperationTypes["COPY"] = "copy";
    OperationTypes["MOVE"] = "move";
    OperationTypes["EXPORT"] = "export";
    OperationTypes["ARCHIVE"] = "archive";
    OperationTypes["PURGE"] = "purge";
    OperationTypes["PURGE_VERSION"] = "purge_version";
    OperationTypes["ADMINISTER"] = "administer";
    OperationTypes["RESTORE"] = "restore";
    OperationTypes["CREATE_SPACE"] = "create_space";
    OperationTypes["RESTRICT_CONTENT"] = "restrict_content";
    OperationTypes["CLEAR_PERMISSIONS"] = "clear_permissions";
    return OperationTypes;
}({});
module.exports["OperationTypes"] = $93e6e1e47a4562a8$export$64e79c67b77e1326;

});

parcelRegister("k7Uqa", function(module, exports) {
/**
 * Tracks the measured box of the page content element — the
 * `<div id="content" data-testid="page-content-only">` rendered by `ViewPageContent` in
 * `@confluence/view-page-common`.
 *
 * The element registers itself through `setPageContentElement`, which is attached as a callback
 * ref. A callback ref already fires on mount, unmount and replacement, so subscribers never have
 * to search the DOM for the element or keep a `MutationObserver` armed on `document.body` to
 * notice when it changes.
 *
 * State lives at module level so that every subscriber shares a single `ResizeObserver` and a
 * single window `resize` listener, both of which are torn down once the last subscriber leaves.
 */ const $bbcc19b808918c90$export$79d329a70597f7b7 = Object.freeze({
    width: 0,
    left: 0,
    right: 0
});
const $bbcc19b808918c90$export$10aec1dded111643 = (a, b)=>a.width === b.width && a.left === b.left && a.right === b.right;
let $bbcc19b808918c90$var$element = null;
/**
 * Last measurement. Deliberately retained when the element unregisters so consumers keep the last
 * known layout rather than collapsing back to zero, which is how the DOM-lookup implementation
 * this replaces behaved when the element was removed from the page.
 */ let $bbcc19b808918c90$var$rect = $bbcc19b808918c90$export$79d329a70597f7b7;
const $bbcc19b808918c90$var$listeners = new Set();
let $bbcc19b808918c90$var$resizeObserver = null;
let $bbcc19b808918c90$var$pendingFrame = null;
/**
 * `left` and `right` are viewport-relative and nothing here listens to scroll. Vertical scrolling
 * leaves both untouched, so the common case is safe; a document-level *horizontal* scroll does move
 * the element without resizing it, and the values then stay stale until the next resize. That is a
 * deliberate carry-over — the DOM-lookup implementation this replaces had no scroll listener
 * either, so both cohorts drift identically and the experiment is not measuring this difference.
 * If drift is ever reported (the sticky draft bar sitting off-column after scrolling sideways),
 * the fix is a passive `scroll` listener calling `scheduleMeasure`.
 */ const $bbcc19b808918c90$var$measure = ()=>{
    if (!$bbcc19b808918c90$var$element) return;
    const { width: width, left: left, right: right } = $bbcc19b808918c90$var$element.getBoundingClientRect();
    const next = {
        width: width,
        left: left,
        right: right
    };
    if ($bbcc19b808918c90$export$10aec1dded111643($bbcc19b808918c90$var$rect, next)) return;
    $bbcc19b808918c90$var$rect = next;
    $bbcc19b808918c90$var$listeners.forEach((listener)=>listener($bbcc19b808918c90$var$rect));
};
const $bbcc19b808918c90$var$measureOnNextFrame = ()=>{
    $bbcc19b808918c90$var$pendingFrame = null;
    $bbcc19b808918c90$var$measure();
};
/**
 * Used for window resizes only. A resize gesture fires many events per frame and reading layout
 * from an event handler forces a synchronous reflow, so those reads are coalesced to one per
 * frame. `ResizeObserver` callbacks need no coalescing — the browser already delivers at most one
 * per frame, after layout, which makes the read free.
 */ const $bbcc19b808918c90$var$scheduleMeasure = ()=>{
    if ($bbcc19b808918c90$var$pendingFrame !== null) return;
    $bbcc19b808918c90$var$pendingFrame = requestAnimationFrame($bbcc19b808918c90$var$measureOnNextFrame);
};
const $bbcc19b808918c90$var$stopObserving = ()=>{
    if ($bbcc19b808918c90$var$resizeObserver) {
        $bbcc19b808918c90$var$resizeObserver.disconnect();
        $bbcc19b808918c90$var$resizeObserver = null;
        window.removeEventListener('resize', $bbcc19b808918c90$var$scheduleMeasure);
    }
    if ($bbcc19b808918c90$var$pendingFrame !== null) {
        cancelAnimationFrame($bbcc19b808918c90$var$pendingFrame);
        $bbcc19b808918c90$var$pendingFrame = null;
    }
};
const $bbcc19b808918c90$var$syncObservers = ()=>{
    // Read into a local so the null check narrows `el` inside the branch below.
    const el = $bbcc19b808918c90$var$element;
    const shouldObserve = el !== null && $bbcc19b808918c90$var$listeners.size > 0;
    if (shouldObserve && !$bbcc19b808918c90$var$resizeObserver) {
        $bbcc19b808918c90$var$resizeObserver = new ResizeObserver($bbcc19b808918c90$var$measure);
        // Observing delivers an initial callback with the current size, which is what produces the
        // first measurement — no explicit layout read is needed here.
        $bbcc19b808918c90$var$resizeObserver.observe(el);
        window.addEventListener('resize', $bbcc19b808918c90$var$scheduleMeasure);
    } else if (!shouldObserve) $bbcc19b808918c90$var$stopObserving();
};
const $bbcc19b808918c90$export$4afb4d2461842f3 = (nextElement)=>{
    if (nextElement === $bbcc19b808918c90$var$element) return;
    $bbcc19b808918c90$var$element = nextElement;
    // Drop the observer bound to the previous element before re-arming for the new one.
    $bbcc19b808918c90$var$stopObserving();
    $bbcc19b808918c90$var$syncObservers();
};
const $bbcc19b808918c90$export$215bce535b779ebf = ()=>$bbcc19b808918c90$var$rect;
const $bbcc19b808918c90$export$f663065c39c538af = (listener)=>{
    $bbcc19b808918c90$var$listeners.add(listener);
    $bbcc19b808918c90$var$syncObservers();
    return ()=>{
        $bbcc19b808918c90$var$listeners.delete(listener);
        $bbcc19b808918c90$var$syncObservers();
    };
};
const $bbcc19b808918c90$export$b149c544d7667fe3 = ()=>{
    $bbcc19b808918c90$var$listeners.clear();
    $bbcc19b808918c90$var$element = null;
    $bbcc19b808918c90$var$stopObserving();
    $bbcc19b808918c90$var$rect = $bbcc19b808918c90$export$79d329a70597f7b7;
};
module.exports["EMPTY_PAGE_CONTENT_RECT"] = $bbcc19b808918c90$export$79d329a70597f7b7;
module.exports["isSamePageContentRect"] = $bbcc19b808918c90$export$10aec1dded111643;
module.exports["setPageContentElement"] = $bbcc19b808918c90$export$4afb4d2461842f3;
module.exports["getPageContentRect"] = $bbcc19b808918c90$export$215bce535b779ebf;
module.exports["subscribeToPageContentRect"] = $bbcc19b808918c90$export$f663065c39c538af;

});

parcelRegister("9A1Zq", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $hrAmX = parcelRequire("hrAmX");


var $4mV2k = parcelRequire("4mV2k");

const $0149a40c8f0d4063$var$ScrollToHashLinkHandlerInner = (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { anchorContainer: anchorContainer, topOffset: topOffset } = t0;
    const t1 = -topOffset;
    let t2;
    if ($[0] !== anchorContainer || $[1] !== t1) {
        t2 = {
            anchorContainer: anchorContainer,
            scrollCorrectionPixels: t1
        };
        $[0] = anchorContainer;
        $[1] = t1;
        $[2] = t2;
    } else t2 = $[2];
    (0, $4mV2k.useHashLinkScrollHandler)(t2);
    return null;
};
const $0149a40c8f0d4063$export$5b070962e184306f = (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { anchorContainer: anchorContainer } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            (0, $hrAmX.BannerStateContainer)
        ];
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== anchorContainer) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
            to: t1
        }, (bannerState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0149a40c8f0d4063$var$ScrollToHashLinkHandlerInner, {
                anchorContainer: anchorContainer,
                topOffset: bannerState.getTotalHeight()
            }));
        $[1] = anchorContainer;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
};
$0149a40c8f0d4063$export$5b070962e184306f.displayName = 'ScrollToHashLinkHandler';
module.exports["ScrollToHashLinkHandler"] = $0149a40c8f0d4063$export$5b070962e184306f;

});

parcelRegister("hrAmX", function(module, exports) {

var $a4dgs = parcelRequire("a4dgs");


var $8zRYE = parcelRequire("8zRYE");


var $jecot = parcelRequire("jecot");

const $6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME = 'ServerRenderedBanners';
const $6ee3834dea9f6c5c$export$f7df67e8f3ba0620 = (name, inArray)=>inArray.findIndex((banner)=>banner.name === name);
class $6ee3834dea9f6c5c$export$bbac707b3ebb5681 extends (0, $a4dgs.BaseStateContainer) {
    constructor(props = {}){
        super();
        // Resolved unconditionally, even when it is about to be discarded, so that exposure for the
        // nav-height flags is unchanged from before this was extracted into a helper.
        /** Frozen at construction: a mid-session flag flip must not change an instance's arithmetic. */ this.topNavHeight = void 0;
        this.suppressed = void 0;
        this.pendingNotify = null;
        this.unsubscribeFromStore = null;
        this.state = {
            banners: []
        };
        this._updateServerRenderedBanners = (spaBannerHeight)=>{
            if (spaBannerHeight === 0) this.hide($6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME);
            else this.show($6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME, spaBannerHeight);
        };
        /**
     * Adds or updates the specified banner in the list of visible banners.
     * Add the banner is not already in the list, otherwise update the banner's height.
     * Applied on the next microtask; a suppressed container drops the write entirely.
     *
     * @param {string} name Unique name of the banner
     * @param {number} height Height of the banner, in pixels
     */ this.show = (name, height)=>{
            if (this.suppressed) return;
            (0, $8zRYE.showBanner)(name, height);
        };
        /**
     * Removes the specified banner from the list of visible banners
     * Remove the banner if it is in the list, do nothing it is not
     *
     * @param {string} name Unique name of the banner
     */ this.hide = (name)=>{
            if (this.suppressed) return;
            (0, $8zRYE.hideBanner)(name);
        };
        /**
     * Returns the combined height of all banners in the list.
     * @param {boolean} includeTopNav Include `TOP_NAV_HEIGHT` in the calculation
     * if not `false`
     * @returns {number} Combined height of all visible banners
     */ this.getTotalHeight = (includeTopNav)=>this.state.banners.reduce((totalOffset, banner)=>totalOffset + banner.height, includeTopNav !== false ? this.topNavHeight : 0);
        /**
     * Returns list of all banners in visible list in "-" seperated string.
     * @returns {string} Combined names of all banners in visible list seperated by "-"
     */ this.getBannerList = ()=>this.state.banners.map((banner)=>banner.name).join('-');
        /**
     * Detaches from the store. unstated gives containers no teardown hook, so any caller that creates
     * short-lived containers — fixtures, tests, anything mounted more than once — must call this, or
     * the store keeps the listener and with it this instance alive for the lifetime of the module.
     */ this.destroy = ()=>{
            this.unsubscribeFromStore?.();
            this.unsubscribeFromStore = null;
        };
        this.scheduleNotify = ()=>{
            if (this.pendingNotify) return;
            this.pendingNotify = Promise.resolve().then(()=>{
                this.pendingNotify = null;
                return this.notifyListeners();
            });
        };
        const navHeight = (0, $jecot.resolveTopNavHeight)();
        this.topNavHeight = props.hasTopNav === false ? 0 : navHeight;
        this.suppressed = props.suppressed === true;
        if (this.suppressed) return;
        (0, $8zRYE.seedBanners)(props.initialState?.banners ?? []);
        this.state = {
            banners: (0, $8zRYE.getBanners)()
        };
        // The mirror is synchronous so a read straight after a flush is fresh; the notification is
        // coalesced, so a tick's worth of store changes costs one round no matter which container
        // (or hook) wrote them.
        this.unsubscribeFromStore = (0, $8zRYE.subscribeToBanners)(()=>{
            this.state = {
                banners: (0, $8zRYE.getBanners)()
            };
            this.scheduleNotify();
        });
    }
}
module.exports["findBanner"] = $6ee3834dea9f6c5c$export$f7df67e8f3ba0620;
module.exports["BannerStateContainer"] = $6ee3834dea9f6c5c$export$bbac707b3ebb5681;

});

parcelRegister("a4dgs", function(module, exports) {
// unstated is deprecated; new banner state belongs in src/bannerStore.ts
// eslint-disable-next-line no-restricted-imports

var $kNIYN = parcelRequire("kNIYN");

class $5ed4587dbe3a0e20$export$5db0f71585d91cd4 extends (0, $kNIYN.Container) {
    subscribe(fn) {
        this.listeners.add(fn);
    }
    unsubscribe(fn) {
        this.listeners.delete(fn);
    }
    setState(updater, callback) {
        return Promise.resolve().then(()=>{
            const next = typeof updater === 'function' ? updater(this.state) : updater;
            if (next == null) {
                callback?.();
                return;
            }
            this.state = Object.assign({}, this.state, next);
            return this.notifyListeners().then(()=>{
                callback?.();
            });
        });
    }
    notifyListeners() {
        // Snapshot before notifying: a listener's re-render makes unstated's Subscribe unsubscribe
        // and resubscribe, which would mutate the Set mid-iteration.
        const snapshot = Array.from(this.listeners);
        return Promise.all(snapshot.map((listener)=>listener())).then(()=>undefined);
    }
    constructor(...args){
        super(...args);
        this.listeners = new Set();
    }
}
module.exports["BaseStateContainer"] = $5ed4587dbe3a0e20$export$5db0f71585d91cd4;

});

parcelRegister("8zRYE", function(module, exports) {

var $i3jcY = parcelRequire("i3jcY");

/**
 * Module store for the page-top banner stack, read through `useSyncExternalStore`.
 *
 * A module store, not a library: see `docs/llm/agent-instructions/common/state-management.md`.
 *
 * Writes are deferred to a microtask and coalesced here rather than in any caller, so every writer —
 * the container shim and the `useBannerState` hooks — inherits it. Notification is synchronous and
 * several banners still call `show`/`hide` from a render body, so an undeferred write would update
 * other components mid-render.
 *
 * Global and unscoped: only three production containers exist — the client root, the SSR root
 * (mutually exclusive with it), and `WithoutBanners`, which is write-free and read-once.
 *
 * SSR: Tesseract isolates each request, so module state is per-request. `handleReactRender.tsx`
 * serialises the server's list into `window.__SSR_BANNERS__`, which this store reads at module init,
 * so the first render — including the hydrating one — matches the server without waiting on a
 * container. The server has no such global, so its seed is an explicit `seedBanners` call from the
 * SSR entry point; that keeps `ssrBannerManager` out of this module.
 *
 * `stableUI=1` (E2E/VR runs) is honoured here, at all three entry points that can change `banners`,
 * rather than in each writer: `ssrBannerManager` registers banners regardless of the URL param, so
 * an unguarded hydration seed would give a hydrating render banners the SSR render dropped, and the
 * `useBannerState` hooks never see the param at all.
 */ /** Frozen so a consumer cannot mutate it, and stable so `getSnapshot` never triggers a re-render. */ const $827d62b6188a5818$var$NO_BANNERS = Object.freeze([]);
/**
 * Read at module init rather than from a component, so the store is populated before anything
 * renders. Entries are validated because the value is deserialised from the page.
 *
 * No `typeof window` guard: the build substitutes `globalThis`, so `window` is always defined in both
 * environments. On the server the property simply is not set, which the `Array.isArray` check already
 * covers — the server seed comes from `seedBanners` instead.
 */ const $827d62b6188a5818$var$readHydrationBanners = ()=>{
    // `Array.isArray` is deliberately first: it short-circuits on the server, where the global is
    // never set, so the request URI — not available this early in module evaluation — is never read.
    if (!Array.isArray(window.__SSR_BANNERS__) || (0, $i3jcY.isStableUIEnabledForTests)()) return $827d62b6188a5818$var$NO_BANNERS;
    const parsed = window.__SSR_BANNERS__.filter((banner)=>typeof banner?.name === 'string' && typeof banner?.height === 'number');
    return parsed.length > 0 ? parsed : $827d62b6188a5818$var$NO_BANNERS;
};
let $827d62b6188a5818$var$banners = $827d62b6188a5818$var$readHydrationBanners();
const $827d62b6188a5818$var$listeners = new Set();
const $827d62b6188a5818$export$49fd326b255f6ddb = ()=>$827d62b6188a5818$var$banners;
const $827d62b6188a5818$export$7cfac2c025b473e4 = (listener)=>{
    $827d62b6188a5818$var$listeners.add(listener);
    return ()=>{
        $827d62b6188a5818$var$listeners.delete(listener);
    };
};
const $827d62b6188a5818$var$commit = (next)=>{
    $827d62b6188a5818$var$banners = next;
    // Snapshot first: a listener may unsubscribe while being notified.
    Array.from($827d62b6188a5818$var$listeners).forEach((listener)=>listener());
};
let $827d62b6188a5818$var$pending = [];
let $827d62b6188a5818$var$pendingFlush = null;
const $827d62b6188a5818$var$enqueue = (mutate)=>{
    // Evaluated per call rather than memoised at module init: an SPA transition changes
    // `window.location.search`, so the param is not a session constant.
    // Hides are dropped along with shows, which is safe because nothing can enter the store.
    if ((0, $i3jcY.isStableUIEnabledForTests)()) return;
    $827d62b6188a5818$var$pending.push(mutate);
    if ($827d62b6188a5818$var$pendingFlush) return;
    $827d62b6188a5818$var$pendingFlush = Promise.resolve().then(()=>{
        $827d62b6188a5818$var$pendingFlush = null;
        const queued = $827d62b6188a5818$var$pending;
        $827d62b6188a5818$var$pending = [];
        let next = $827d62b6188a5818$var$banners;
        let changed = false;
        for (const run of queued){
            // Applied against the running value, not the pre-flush one, so a name shown twice in a tick
            // resolves against the first write rather than duplicating.
            const result = run(next);
            if (result === undefined) continue;
            next = result;
            changed = true;
        }
        if (changed) $827d62b6188a5818$var$commit(next);
    });
};
const $827d62b6188a5818$export$f5c0eb035ef26e87 = (name, height)=>{
    $827d62b6188a5818$var$enqueue((current)=>{
        const index = current.findIndex((banner)=>banner.name === name);
        if (index === -1) return [
            ...current,
            {
                name: name,
                height: height
            }
        ];
        if (current[index].height !== height) {
            const next = [
                ...current
            ];
            // Replace rather than mutate, so the previous array keeps the old height.
            next[index] = {
                name: name,
                height: height
            };
            return next;
        }
        return undefined;
    });
};
const $827d62b6188a5818$export$11fa8b7d26b756a8 = (name)=>{
    $827d62b6188a5818$var$enqueue((current)=>{
        const index = current.findIndex((banner)=>banner.name === name);
        if (index === -1) return undefined;
        const next = [
            ...current
        ];
        next.splice(index, 1);
        return next;
    });
};
const $827d62b6188a5818$export$468156c225d4c0f9 = (initial)=>{
    if ((0, $i3jcY.isStableUIEnabledForTests)()) return;
    if ($827d62b6188a5818$var$banners.length === 0 && initial.length > 0) $827d62b6188a5818$var$commit([
        ...initial
    ]);
};
const $827d62b6188a5818$export$b3f5cfd1906442cb = ()=>{
    $827d62b6188a5818$var$banners = $827d62b6188a5818$var$NO_BANNERS;
    $827d62b6188a5818$var$listeners.clear();
    $827d62b6188a5818$var$pending = [];
    $827d62b6188a5818$var$pendingFlush = null;
};
module.exports["getBanners"] = $827d62b6188a5818$export$49fd326b255f6ddb;
module.exports["subscribeToBanners"] = $827d62b6188a5818$export$7cfac2c025b473e4;
module.exports["showBanner"] = $827d62b6188a5818$export$f5c0eb035ef26e87;
module.exports["hideBanner"] = $827d62b6188a5818$export$11fa8b7d26b756a8;
module.exports["seedBanners"] = $827d62b6188a5818$export$468156c225d4c0f9;

});

parcelRegister("i3jcY", function(module, exports) {

const $47902e6ccb9229f6$var$STABLE_UI_PARAM = 'stableUI=1';
const $47902e6ccb9229f6$export$c0b9078f666b1acf = ()=>{
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return (window.location.search ?? '').includes($47902e6ccb9229f6$var$STABLE_UI_PARAM);
};
module.exports["isStableUIEnabledForTests"] = $47902e6ccb9229f6$export$c0b9078f666b1acf;

});

parcelRegister("jecot", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");

const $ff48e00b2c36a911$export$756e5b68ec79d923 = ()=>{
    if (// The increased height change is applied when FHS or app switcher improvements are enabled.
    // Ideally we could check `useIsFhsEnabled()` but this has to work outside React too.
    // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    (0, $6mKj3.expVal)('navx-full-height-sidebar-exp', 'isEnabled', false) || (0, $9wGTI.fg)('platform_dst_ads_appswitcher_improvements')) return 56;
    return 48;
};
module.exports["resolveTopNavHeight"] = $ff48e00b2c36a911$export$756e5b68ec79d923;

});

parcelRegister("4mV2k", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $dPJCf = parcelRequire("dPJCf");


var $8WfxO = parcelRequire("8WfxO");


var $9g2Nl = parcelRequire("9g2Nl");


var $fURMF = parcelRequire("fURMF");

const $fc341bafe2c0aa4b$export$d1b2b0eec29df945 = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { anchorContainer: anchorContainer, scrollCorrectionPixels: scrollCorrectionPixels } = t0;
    const { setHash: setHash } = (0, $dPJCf.useRouteActions)();
    const { isATLGeneralWebPanelFixed: isATLGeneralWebPanelFixed, atlGeneralWebPanelHeight: atlGeneralWebPanelHeight } = (0, $8WfxO.useATLGeneralWebPanelListener)();
    const fixedWebPanelHeight = isATLGeneralWebPanelFixed ? atlGeneralWebPanelHeight : 0;
    let t1;
    if ($[0] !== anchorContainer || $[1] !== fixedWebPanelHeight || $[2] !== scrollCorrectionPixels || $[3] !== setHash) {
        t1 = (e)=>{
            if (!anchorContainer.current) return;
            if (e.defaultPrevented) return;
            const options = (0, $9g2Nl.getHashLinkClickOptions)(e, anchorContainer.current);
            if (options) {
                const { anchorElement: anchorElement, hash: hash } = options;
                e.preventDefault();
                (0, $fURMF.scrollToElement)(anchorElement, (scrollCorrectionPixels || 0) - fixedWebPanelHeight);
                setHash(hash);
            }
        };
        $[0] = anchorContainer;
        $[1] = fixedWebPanelHeight;
        $[2] = scrollCorrectionPixels;
        $[3] = setHash;
        $[4] = t1;
    } else t1 = $[4];
    const onClickListener = t1;
    let t2;
    let t3;
    if ($[5] !== onClickListener) {
        t2 = ()=>{
            window.addEventListener("click", onClickListener);
            return ()=>{
                window.removeEventListener("click", onClickListener);
            };
        };
        t3 = [
            onClickListener
        ];
        $[5] = onClickListener;
        $[6] = t2;
        $[7] = t3;
    } else {
        t2 = $[6];
        t3 = $[7];
    }
    (0, $cozmU.useEffect)(t2, t3);
};
module.exports["useHashLinkScrollHandler"] = $fc341bafe2c0aa4b$export$d1b2b0eec29df945;

});

parcelRegister("8WfxO", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $eSLr0 = parcelRequire("eSLr0");


var $ep3mz = parcelRequire("ep3mz");


var $6mKj3 = parcelRequire("6mKj3");


var $dS3n9 = parcelRequire("dS3n9");

const $720c81ac24834d84$export$dc9cc84753faedac = ()=>{
    const $ = (0, $bDgLe.c)(10);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [];
        $[0] = t0;
    } else t0 = $[0];
    const atlGeneralHeightChanges = (0, $cozmU.useRef)(t0);
    const [webPanelHeight, setWebPanelHeight] = (0, $cozmU.useState)($720c81ac24834d84$var$_temp);
    const [t1] = (0, $ep3mz.usePageState)();
    const { contentId: contentId, spaceKey: spaceKey } = t1;
    let t2;
    if ($[1] !== contentId || $[2] !== spaceKey) {
        t2 = {
            location: (0, $eSLr0.ATL_GENERAL),
            fetchPolicy: "cache-first",
            spaceKey: spaceKey,
            contentId: contentId
        };
        $[1] = contentId;
        $[2] = spaceKey;
        $[3] = t2;
    } else t2 = $[3];
    const { panels: panels } = (0, $dS3n9.useWebPanelLocation)(t2);
    const isATLGeneralWebPanelFixed = panels.length > 0;
    let t3;
    let t4;
    if ($[4] !== isATLGeneralWebPanelFixed) {
        t3 = ()=>{
            const listener = (e)=>{
                let newHeight;
                if ((0, $6mKj3.expVal)("confluence_p2m_style_recalc_and_expand_joint_exp", "isEnabled", false)) {
                    setWebPanelHeight(e?.detail?.height ?? 0);
                    newHeight = e?.detail?.height ?? 0;
                } else {
                    setWebPanelHeight($720c81ac24834d84$var$getAtlGeneralWebPanelHeight());
                    newHeight = $720c81ac24834d84$var$getAtlGeneralWebPanelHeight();
                }
                if (typeof window !== "undefined" && Boolean(window.__SSR_RENDERED__)) {
                    const lastHeight = atlGeneralHeightChanges.current.length === 0 ? window.__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__ || 0 : atlGeneralHeightChanges.current[atlGeneralHeightChanges.current.length - 1];
                    if (lastHeight !== newHeight) atlGeneralHeightChanges.current.push(newHeight);
                    window.__ATL_GENERAL_WEBPANEL_HEIGHT_CHANGES__ = atlGeneralHeightChanges.current;
                }
            };
            if (isATLGeneralWebPanelFixed) document.addEventListener("atlGeneralWebPanelHeightUpdated", listener);
            return ()=>{
                if (isATLGeneralWebPanelFixed) document.removeEventListener("atlGeneralWebPanelHeightUpdated", listener);
            };
        };
        t4 = [
            isATLGeneralWebPanelFixed
        ];
        $[4] = isATLGeneralWebPanelFixed;
        $[5] = t3;
        $[6] = t4;
    } else {
        t3 = $[5];
        t4 = $[6];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[7] !== isATLGeneralWebPanelFixed || $[8] !== webPanelHeight) {
        t5 = {
            isATLGeneralWebPanelFixed: isATLGeneralWebPanelFixed,
            atlGeneralWebPanelHeight: webPanelHeight
        };
        $[7] = isATLGeneralWebPanelFixed;
        $[8] = webPanelHeight;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
};
const $720c81ac24834d84$var$getAtlGeneralWebPanelHeight = ()=>{
    if (typeof document === 'undefined') return 0;
    return parseInt(// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    getComputedStyle(document.documentElement).getPropertyValue('--atl-general-webpanel-height')) || 0;
};
function $720c81ac24834d84$var$_temp() {
    if (typeof window !== "undefined" && Boolean(window.__SSR_RENDERED__) && (0, $6mKj3.expVal)("confluence_p2m_style_recalc_and_expand_joint_exp", "isEnabled", false)) {
        const initialHeight = window.__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__;
        return initialHeight ?? 0;
    } else return $720c81ac24834d84$var$getAtlGeneralWebPanelHeight();
}
module.exports["useATLGeneralWebPanelListener"] = $720c81ac24834d84$export$dc9cc84753faedac;

});

parcelRegister("eSLr0", function(module, exports) {
// web items
const $0673dc41d4591954$export$b1fc939aa7feb92f = 'system.content.action';
const $0673dc41d4591954$export$cc265e0ec08cd67d = 'system.content.button';
const $0673dc41d4591954$export$d2beebd05fcd6f70 = 'system.dashboard';
const $0673dc41d4591954$export$9aacf4bfaa57e6fc = 'system.content.byline';
const $0673dc41d4591954$export$1b2697f8e6fa897f = 'system.content.metadata';
const $0673dc41d4591954$export$53635c098825d80c = 'system.attachment';
const $0673dc41d4591954$export$b55f44bb0675280a = 'system.attachment.metadata';
const $0673dc41d4591954$export$932fbff4e94f11bd = 'system.attachment.history';
const $0673dc41d4591954$export$76fccc09e967256f = 'page.metadata.banner';
const $0673dc41d4591954$export$630f26f93c0b82dc = 'system.header/left';
const $0673dc41d4591954$export$67f0ff836865be9e = 'system.header/left.button.group';
const $0673dc41d4591954$export$ac6c373b69972f05 = 'system.help/pages';
const $0673dc41d4591954$export$1835f2a2eaa3b55b = 'system.user';
const $0673dc41d4591954$export$8fc5196f34e2202a = 'system.admin';
const $0673dc41d4591954$export$e83e042e2b565918 = 'system.editor.precursor.buttons';
const $0673dc41d4591954$export$2a98a7a0b026585a = 'system.create.dialog/content';
const $0673dc41d4591954$export$9022327d826319c7 = 'system.create.space.dialog/content';
const $0673dc41d4591954$export$b7555e81ec195340 = 'page.view.selection/action-panel';
const $0673dc41d4591954$export$dbd4ce8bddb36f82 = 'atl.dashboard.secondary';
const $0673dc41d4591954$export$78738b07c213d412 = 'atl.general';
const $0673dc41d4591954$export$45c1e55ebc7a8070 = 'atl.footer';
const $0673dc41d4591954$export$e1325689a3e8f66b = 'atl.page.metadata.banner';
const $0673dc41d4591954$export$e8a1b6a55853b054 = 'atl.page.content.footer.actions';
const $0673dc41d4591954$export$488204faf384ca14 = 'atl.editor.savebar';
const $0673dc41d4591954$export$c7ef8755b728af2b = 'system.admin/siteadministration';
const $0673dc41d4591954$export$a7876e82ed48f038 = 'system.admin/security';
module.exports["TOOLS_MENU_CONTAINER"] = $0673dc41d4591954$export$b1fc939aa7feb92f;
module.exports["PAGE_BUTTONS"] = $0673dc41d4591954$export$cc265e0ec08cd67d;
module.exports["SYSTEM_CONTENT_BYLINE"] = $0673dc41d4591954$export$9aacf4bfaa57e6fc;
module.exports["SYSTEM_CONTENT_METADATA"] = $0673dc41d4591954$export$1b2697f8e6fa897f;
module.exports["SYSTEM_ATTACHMENT"] = $0673dc41d4591954$export$53635c098825d80c;
module.exports["SYSTEM_ATTACHMENT_METADATA"] = $0673dc41d4591954$export$b55f44bb0675280a;
module.exports["SYSTEM_ATTACHMENT_HISTORY"] = $0673dc41d4591954$export$932fbff4e94f11bd;
module.exports["PAGE_METADATA_BANNER"] = $0673dc41d4591954$export$76fccc09e967256f;
module.exports["SYSTEM_HEADER_LEFT"] = $0673dc41d4591954$export$630f26f93c0b82dc;
module.exports["SYSTEM_HELP"] = $0673dc41d4591954$export$ac6c373b69972f05;
module.exports["SYSTEM_USER"] = $0673dc41d4591954$export$1835f2a2eaa3b55b;
module.exports["SYSTEM_ADMIN"] = $0673dc41d4591954$export$8fc5196f34e2202a;
module.exports["SYSTEM_EDITOR_PRECURSOR_BUTTONS"] = $0673dc41d4591954$export$e83e042e2b565918;
module.exports["CREATE_DIALOG"] = $0673dc41d4591954$export$2a98a7a0b026585a;
module.exports["CREATE_SPACE_DIALOG"] = $0673dc41d4591954$export$9022327d826319c7;
module.exports["ACTION_PANEL"] = $0673dc41d4591954$export$b7555e81ec195340;
module.exports["DASHBOARD_SECONDARY"] = $0673dc41d4591954$export$dbd4ce8bddb36f82;
module.exports["ATL_GENERAL"] = $0673dc41d4591954$export$78738b07c213d412;
module.exports["ATL_FOOTER"] = $0673dc41d4591954$export$45c1e55ebc7a8070;
module.exports["ATL_PAGE_METADATA"] = $0673dc41d4591954$export$e1325689a3e8f66b;
module.exports["ATL_PAGE_CONTENT_FOOTER_ACTIONS"] = $0673dc41d4591954$export$e8a1b6a55853b054;
module.exports["ATL_EDITOR_SAVEBAR"] = $0673dc41d4591954$export$488204faf384ca14;
module.exports["SYSTEM_ADMIN_SITE_ADMINISTRATION_SECURITY"] = $0673dc41d4591954$export$a7876e82ed48f038;

});

parcelRegister("dS3n9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jtuBN = parcelRequire("jtuBN");


var $jMyy4 = parcelRequire("jMyy4");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");


var $eSLr0 = parcelRequire("eSLr0");


var $9Z1sw = parcelRequire("9Z1sw");

const $9fffd50bbcc7c343$export$c8daa7260f75e213 = ({ spaceKey: spaceKey, contentId: contentId, location: location, fetchPolicy: // Query is preloaded on the server-side. reused the preloaded data.
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
fetchPolicy = 'cache-and-network', onCompleted: onCompleted })=>{
    const { getQueryParams: getQueryParams } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const queryParams = getQueryParams();
    const spaceIdentifier = spaceKey || (0, $c3Qwv.getSingleParam)(queryParams, 'spaceKey') || (0, $c3Qwv.getSingleParam)(queryParams, 'key');
    const contentIdentifier = contentId || (0, $c3Qwv.getSingleParam)(queryParams, 'pageId');
    const variables = contentIdentifier ? {
        contentId: contentIdentifier,
        location: location
    } : {
        spaceKey: spaceIdentifier,
        location: location
    };
    const batchResult = (0, $9Z1sw.useWebPanelLocationBatchResult)(location);
    const batchResultData = batchResult?.data;
    const batchResultError = batchResult?.error;
    const batchResultLoading = batchResult?.loading;
    const completedBatchResultKeyRef = (0, $cozmU.useRef)(null);
    const baseOptions = {
        variables: variables,
        skip: Boolean(batchResult),
        ...onCompleted && {
            onCompleted: onCompleted
        }
    };
    // Keep watching query for home route to avoid VC90 regression
    const useNoFurtherUpdate = location !== (0, $eSLr0.DASHBOARD_SECONDARY);
    const { loading: loading, data: data, error: error } = useNoFurtherUpdate ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $9Z1sw.WebPanelLocationQuery), {
        ...baseOptions,
        __callerPackage__: "web-panel-location"
    }) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jMyy4.useQueryInterop)((0, $9Z1sw.WebPanelLocationQuery), {
        ...baseOptions,
        fetchPolicy: fetchPolicy,
        __callerPackage__: "web-panel-location"
    });
    const result = batchResult ?? {
        loading: loading,
        data: data,
        error: error
    };
    (0, $cozmU.useEffect)(()=>{
        if (batchResultLoading || batchResultError || !batchResultData || !onCompleted) return;
        const batchResultKey = `${contentIdentifier || ''}:${spaceIdentifier || ''}:${location}`;
        if (completedBatchResultKeyRef.current !== batchResultKey) {
            completedBatchResultKeyRef.current = batchResultKey;
            onCompleted();
        }
    }, [
        batchResultData,
        batchResultError,
        batchResultLoading,
        contentIdentifier,
        location,
        onCompleted,
        spaceIdentifier
    ]);
    const panels = (result.data?.webPanels || []).filter((panel)=>panel);
    return {
        panels: panels,
        loading: result.loading,
        error: result.error
    };
};
module.exports["useWebPanelLocation"] = $9fffd50bbcc7c343$export$c8daa7260f75e213;

});

parcelRegister("9Z1sw", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $eq95w = parcelRequire("eq95w");


var $cozmU = parcelRequire("cozmU");


var $ah4BL = parcelRequire("ah4BL");


var $bavCP = parcelRequire("bavCP");


var $8wW9d = parcelRequire("8wW9d");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $ep3mz = parcelRequire("ep3mz");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");


var $eSLr0 = parcelRequire("eSLr0");


var $3QyBm = parcelRequire("3QyBm");


var $iqPSe = parcelRequire("iqPSe");

const $0aea74171df1eb15$export$d97dfe528d83a912 = (0, $eq95w.default);
const $0aea74171df1eb15$var$WebPanelLocationBatchContext = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $0aea74171df1eb15$export$784950ebf49d8a5f = (location)=>{
    const $ = (0, $bDgLe.c)(3);
    const batchContext = (0, $cozmU.useContext)($0aea74171df1eb15$var$WebPanelLocationBatchContext);
    let t0;
    if ($[0] !== batchContext || $[1] !== location) {
        t0 = batchContext?.locations.includes(location) ? batchContext.getResultForLocation(location) : null;
        $[0] = batchContext;
        $[1] = location;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
};
const $0aea74171df1eb15$var$getUniqueLocations = (locations)=>Array.from(new Set(locations.filter(Boolean)));
const $0aea74171df1eb15$var$groupPanelsByLocation = (webPanels)=>{
    const panelsByLocation = new Map();
    webPanels?.forEach((panel)=>{
        if (panel?.location) {
            const panels = panelsByLocation.get(panel.location) ?? [];
            panels.push(panel);
            panelsByLocation.set(panel.location, panels);
        }
    });
    return panelsByLocation;
};
const $0aea74171df1eb15$var$getWebPanelLocationVariables = ({ location: location, locations: locations, contentIdentifier: contentIdentifier, spaceIdentifier: spaceIdentifier })=>{
    const selectedLocations = locations ?? (location ? [
        location
    ] : []);
    const locationVariables = selectedLocations.length > 1 ? {
        location: null,
        locations: selectedLocations
    } : {
        location: selectedLocations[0]
    };
    return {
        ...locationVariables,
        ...contentIdentifier != null ? {
            contentId: contentIdentifier
        } : {},
        ...contentIdentifier == null && spaceIdentifier != null ? {
            spaceKey: spaceIdentifier
        } : {}
    };
};
const $0aea74171df1eb15$var$useWebPanelLocationIdentifiers = ()=>{
    const $ = (0, $bDgLe.c)(8);
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { getQueryParams: getQueryParams } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    let t0;
    let t1;
    if ($[0] !== contentId || $[1] !== getQueryParams || $[2] !== spaceKey) {
        const queryParams = getQueryParams();
        t0 = spaceKey || (0, $c3Qwv.getSingleParam)(queryParams, "spaceKey") || (0, $c3Qwv.getSingleParam)(queryParams, "key");
        t1 = contentId || (0, $c3Qwv.getSingleParam)(queryParams, "pageId");
        $[0] = contentId;
        $[1] = getQueryParams;
        $[2] = spaceKey;
        $[3] = t0;
        $[4] = t1;
    } else {
        t0 = $[3];
        t1 = $[4];
    }
    let t2;
    if ($[5] !== t0 || $[6] !== t1) {
        t2 = {
            spaceIdentifier: t0,
            contentIdentifier: t1
        };
        $[5] = t0;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
};
const $0aea74171df1eb15$var$UFOWebPanelLocationWrapper = (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, locationName: locationName, panels: panels } = t0;
    const panelHasContent = panels?.length && panels.some($0aea74171df1eb15$var$_temp);
    let t1;
    let t2;
    if ($[0] !== panels) {
        t1 = ()=>{
            (0, $8wW9d.recordNonContentAppKeys)("web-panel", (panels ?? []).map($0aea74171df1eb15$var$_temp2));
        };
        t2 = [
            panels
        ];
        $[0] = panels;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    if (!panelHasContent) return children;
    const t3 = `web-panel-${locationName}`;
    let t4;
    if ($[3] !== children || $[4] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ah4BL.UFOThirdPartySegment), {
            name: t3
        }, children);
        $[3] = children;
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
};
const $0aea74171df1eb15$var$MemoizedAtlGeneralWebPanel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { panel: panel } = t0;
    let t1;
    if ($[0] !== panel.completeKey || $[1] !== panel.html) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqPSe.WebPanel), {
            panelId: panel.completeKey,
            html: panel.html,
            panelLocation: (0, $eSLr0.ATL_GENERAL)
        });
        $[0] = panel.completeKey;
        $[1] = panel.html;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
}, (prevProps, nextProps)=>prevProps.panel.completeKey === nextProps.panel.completeKey);
const $0aea74171df1eb15$var$WebPanelLocationBatchContextProvider = (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { data: data, loading: loading, error: error, locations: locations, children: children } = t0;
    data?.webPanels;
    const t1 = data?.webPanels;
    let t2;
    if ($[0] !== t1) {
        t2 = $0aea74171df1eb15$var$groupPanelsByLocation(t1);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const panelsByLocation = t2;
    let t3;
    if ($[2] !== data || $[3] !== error || $[4] !== loading || $[5] !== panelsByLocation) {
        t3 = (location)=>({
                data: data ? {
                    webPanels: panelsByLocation.get(location) ?? []
                } : data,
                loading: loading,
                error: error
            });
        $[2] = data;
        $[3] = error;
        $[4] = loading;
        $[5] = panelsByLocation;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== locations || $[8] !== t3) {
        t4 = {
            locations: locations,
            getResultForLocation: t3
        };
        $[7] = locations;
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    const contextValue = t4;
    let t5;
    if ($[10] !== children || $[11] !== contextValue) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0aea74171df1eb15$var$WebPanelLocationBatchContext.Provider, {
            value: contextValue
        }, children);
        $[10] = children;
        $[11] = contextValue;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
};
const $0aea74171df1eb15$export$2c530b46a1768809 = (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { locations: locations, children: children } = t0;
    const { spaceIdentifier: spaceIdentifier, contentIdentifier: contentIdentifier } = $0aea74171df1eb15$var$useWebPanelLocationIdentifiers();
    let t1;
    if ($[0] !== locations) {
        t1 = locations.join("\0");
        $[0] = locations;
        $[1] = t1;
    } else t1 = $[1];
    const locationsKey = t1;
    let t2;
    if ($[2] !== locationsKey) {
        t2 = $0aea74171df1eb15$var$getUniqueLocations(locationsKey.split("\0"));
        $[2] = locationsKey;
        $[3] = t2;
    } else t2 = $[3];
    const uniqueLocations = t2;
    let t3;
    if ($[4] !== contentIdentifier || $[5] !== spaceIdentifier || $[6] !== uniqueLocations) {
        t3 = $0aea74171df1eb15$var$getWebPanelLocationVariables({
            locations: uniqueLocations,
            contentIdentifier: contentIdentifier,
            spaceIdentifier: spaceIdentifier
        });
        $[4] = contentIdentifier;
        $[5] = spaceIdentifier;
        $[6] = uniqueLocations;
        $[7] = t3;
    } else t3 = $[7];
    const variables = t3;
    if (spaceIdentifier === "byDraft" || uniqueLocations.length === 0) {
        let t4;
        if ($[8] !== children) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
            $[8] = children;
            $[9] = t4;
        } else t4 = $[9];
        return t4;
    }
    let t4;
    if ($[10] !== children || $[11] !== uniqueLocations) {
        t4 = (t5)=>{
            const { data: data, loading: loading, error: error } = t5;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0aea74171df1eb15$var$WebPanelLocationBatchContextProvider, {
                data: data,
                loading: loading,
                error: error,
                locations: uniqueLocations
            }, children);
        };
        $[10] = children;
        $[11] = uniqueLocations;
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] !== t4 || $[14] !== variables) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bavCP.QueryInterop), {
            query: $0aea74171df1eb15$export$d97dfe528d83a912,
            variables: variables,
            fetchPolicy: "cache-first",
            __callerPackage__: "web-panel-location"
        }, t4);
        $[13] = t4;
        $[14] = variables;
        $[15] = t5;
    } else t5 = $[15];
    return t5;
};
const $0aea74171df1eb15$export$2482f01f112556a = ({ location: location, style: style = {}, renderWhenLoading: renderWhenLoading, fetchPolicy: // Query is preloaded on the server-side. reused the preloaded data.
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
fetchPolicy = 'cache-and-network', children: children, onCompleted: onCompleted })=>{
    const { spaceIdentifier: spaceIdentifier, contentIdentifier: contentIdentifier } = $0aea74171df1eb15$var$useWebPanelLocationIdentifiers();
    const batchResult = $0aea74171df1eb15$export$784950ebf49d8a5f(location);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const completedBatchResultKeyRef = (0, $cozmU.useRef)(null);
    const EXPERIENCE_NAME_BY_LOCATION = {
        [(0, $eSLr0.ATL_FOOTER)]: (0, $irVI7.EXTENSION_POINT_HOME_FOOTER_EXPERIENCE),
        [(0, $eSLr0.ATL_GENERAL)]: (0, $irVI7.EXTENSION_POINT_HOME_HEADER_EXPERIENCE),
        [(0, $eSLr0.ATL_EDITOR_SAVEBAR)]: (0, $irVI7.EXTENSION_POINT_EDITOR_SAVEBAR_EXPERIENCE)
    };
    const experienceName = EXPERIENCE_NAME_BY_LOCATION[location] || null;
    (0, $cozmU.useEffect)(()=>{
        if (experienceName) experienceTracker.start({
            name: experienceName
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const variables = $0aea74171df1eb15$var$getWebPanelLocationVariables({
        location: location,
        contentIdentifier: contentIdentifier,
        spaceIdentifier: spaceIdentifier
    });
    (0, $cozmU.useEffect)(()=>{
        if (batchResult?.loading || batchResult?.error || !batchResult?.data || !onCompleted) return;
        const batchResultKey = `${contentIdentifier || ''}:${spaceIdentifier || ''}:${location}`;
        if (completedBatchResultKeyRef.current !== batchResultKey) {
            completedBatchResultKeyRef.current = batchResultKey;
            onCompleted();
        }
    }, [
        batchResult,
        contentIdentifier,
        location,
        onCompleted,
        spaceIdentifier
    ]);
    // TODO: The task to remove this hack is captured in CFE-1873.
    // There's some weird scenario where the UI ends up with a space key of "byDraft" relating to the way tinymce
    // creates content. Given that it's tinymce specific, I'm applying this hack for now and we can remove it once we're
    // at 100% rollout for the Fabric editor.
    if (spaceIdentifier === 'byDraft') return null;
    const renderWebPanels = ({ data: data, loading: loading, error: error })=>{
        if (!renderWhenLoading) {
            if (error || !data || loading && !(0, $9wGTI.fg)('confluence_web_panel_location_render_loading')) return null;
        }
        let panels = (data?.webPanels || []).filter((panel)=>panel);
        panels = (0, $3QyBm.filterConnectAppsFromExtensionPoints)(location, panels);
        // For panels that don't have a placeholder
        if (!renderWhenLoading && !panels.length) {
            if (experienceName) experienceTracker.succeed({
                name: experienceName
            });
            return null;
        }
        const shouldMemoizeAtlGeneralWebPanel = location === (0, $eSLr0.ATL_GENERAL) && (0, $6mKj3.expValEquals)('confluence_memorize_atl_general_connect', 'isEnabled', true);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0aea74171df1eb15$var$UFOWebPanelLocationWrapper, {
            locationName: location,
            panels: panels
        }, children ? children({
            panels: panels
        }) : panels.map((panel)=>{
            return shouldMemoizeAtlGeneralWebPanel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0aea74171df1eb15$var$MemoizedAtlGeneralWebPanel, {
                key: panel.completeKey,
                panel: panel
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqPSe.WebPanel), {
                key: panel.completeKey,
                panelId: panel.completeKey,
                html: panel.html,
                panelLocation: location
            });
        })), experienceName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: experienceName
        }) : null);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        /* eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */ style: style,
        "data-vc-ignore-if-no-layout-shift": true
    }, batchResult ? renderWebPanels(batchResult) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bavCP.QueryInterop), {
        query: $0aea74171df1eb15$export$d97dfe528d83a912,
        variables: variables,
        fetchPolicy: fetchPolicy,
        onCompleted: onCompleted,
        __callerPackage__: "web-panel-location"
    }, renderWebPanels));
};
function $0aea74171df1eb15$var$_temp(panel) {
    return panel.html !== "";
}
function $0aea74171df1eb15$var$_temp2(panel_0) {
    return panel_0.completeKey;
}
module.exports["WebPanelLocationQuery"] = $0aea74171df1eb15$export$d97dfe528d83a912;
module.exports["useWebPanelLocationBatchResult"] = $0aea74171df1eb15$export$784950ebf49d8a5f;
module.exports["WebPanelLocationBatchProvider"] = $0aea74171df1eb15$export$2c530b46a1768809;
module.exports["WebPanelLocation"] = $0aea74171df1eb15$export$2482f01f112556a;

});

parcelRegister("eq95w", function(module, exports) {
/**
 * @generated SignedSource<<663f21e6dfcd4d4c24754e54b45772e8>>
 * @relayHash 8b133e3996bec5b3feff733a500f3451
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1205b4c053e3bf1a11112543759ae8178f8f0e4161f42e7f549b3c8cdcd56847
const $9206d19da4400201$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "location"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "locations"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "location",
                    "variableName": "location"
                },
                {
                    "kind": "Variable",
                    "name": "locations",
                    "variableName": "locations"
                }
            ],
            "concreteType": "WebPanel",
            "kind": "LinkedField",
            "name": "webPanels",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "moduleKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "completeKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "html"
                },
                {
                    "kind": "ScalarField",
                    "name": "location"
                },
                {
                    "kind": "ScalarField",
                    "name": "label"
                },
                {
                    "kind": "ScalarField",
                    "name": "weight"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "WebPanelLocationQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "WebPanelLocationQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "8b133e3996bec5b3feff733a500f3451",
            "id": "1205b4c053e3bf1a11112543759ae8178f8f0e4161f42e7f549b3c8cdcd56847",
            "metadata": {},
            "name": "WebPanelLocationQuery",
            "operationKind": "query",
            "text": "query WebPanelLocationQuery($location:String,$locations:[String],$contentId:ID,$spaceKey:String){webPanels(location:$location,locations:$locations,contentId:$contentId,key:$spaceKey){moduleKey,completeKey,html,location,label,weight,name}}"
        }
    };
}();
$9206d19da4400201$var$node.hash = "c9e0e68be80f814df706b6c0d828dae1";
var $9206d19da4400201$export$2e2bcd8739ae039 = $9206d19da4400201$var$node;
module.exports["default"] = $9206d19da4400201$export$2e2bcd8739ae039;

});

parcelRegister("bavCP", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $jMyy4 = parcelRequire("jMyy4");

const $86f32d96feea2a1f$export$67f105fad14d18d = (0, $3u0dr.isReactCompilerActiveV2)() ? function QueryInterop(t0) {
    const $ = (0, $bDgLe.c)(7);
    let children;
    let props;
    let query;
    if ($[0] !== t0) {
        ({ children: children, query: query, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
        $[3] = query;
    } else {
        children = $[1];
        props = $[2];
        query = $[3];
    }
    const result = (0, $jMyy4.useQueryInterop)(query, props);
    let t1;
    if ($[4] !== children || $[5] !== result) {
        t1 = children(result);
        $[4] = children;
        $[5] = result;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
} : function QueryInterop({ children: children, query: query, ...props }) {
    const result = (0, $jMyy4.useQueryInterop)(query, props);
    return children(result);
};
module.exports["QueryInterop"] = $86f32d96feea2a1f$export$67f105fad14d18d;

});

parcelRegister("8wW9d", function(module, exports) {
/* eslint-disable check-react-ssr-usage/guard-browser-globals -- Client-only instrumentation; non-content 3P apps are fetched and rendered on the client, never SSRed. */ /**
 * Instrumentation for third-party (3P) apps rendered OUTSIDE of page content
 * (e.g. byline, page banner, context menu, content tools, web panels).
 *
 * Unlike content macros/extensions (which are indexed from the ADF document by
 * `ExtrensionIndexProvider`), these apps are fetched client-side via GraphQL
 * hooks (`useWebItemLocation` / `useExtensionList`) and are therefore invisible
 * to the content-based telemetry.
 *
 * Each non-content surface calls `recordNonContentAppKeys` when its apps resolve.
 * The collected keys are stashed on a dedicated window global and later folded
 * into the page-load metric's `connectAppKeys` attribute (React UFO
 * `extra_properties`) by `pageLoadEventPlugin`, so they land in the same RUM
 * dataset as content app keys.
 */ const $eb9f67592b61ef7c$export$8fb2b6127d91a721 = '::';
const $eb9f67592b61ef7c$export$75dfc4b4563b78a5 = (source, appKeys)=>{
    if (typeof window === 'undefined') return;
    const keys = window.__NON_CONTENT_APP_KEYS__ ?? new Set();
    for (const key of appKeys)if (key) keys.add(`${source}${$eb9f67592b61ef7c$export$8fb2b6127d91a721}${key}`);
    window.__NON_CONTENT_APP_KEYS__ = keys;
};
const $eb9f67592b61ef7c$export$40caeb9e96de3450 = ()=>typeof window === 'undefined' ? new Set() : window.__NON_CONTENT_APP_KEYS__ ?? new Set();
const $eb9f67592b61ef7c$export$d36eed915298b207 = ()=>{
    if (typeof window === 'undefined') return;
    window.__NON_CONTENT_APP_KEYS__ = new Set();
};
module.exports["recordNonContentAppKeys"] = $eb9f67592b61ef7c$export$75dfc4b4563b78a5;
module.exports["getNonContentAppKeys"] = $eb9f67592b61ef7c$export$40caeb9e96de3450;

});

parcelRegister("3QyBm", function(module, exports) {

var $1xpoY = parcelRequire("1xpoY");

const $e9dc2b5b8bc8054b$export$888fec185e58bf9c = (location, items)=>{
    const locationsToHideConnectApps = (0, $1xpoY.default).getStringList('confluence_frontend_hidden_extension_points', []);
    const loc = Array.isArray(location) ? location[0] : location;
    if (locationsToHideConnectApps.includes(loc)) items = items.filter((item)=>!item?.completeKey?.startsWith('com.atlassian.plugins.atlassian-connect-plugin:'));
    return items;
};
module.exports["filterConnectAppsFromExtensionPoints"] = $e9dc2b5b8bc8054b$export$888fec185e58bf9c;

});

parcelRegister("iqPSe", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $brpfO = parcelRequire("brpfO");


var $6mKj3 = parcelRequire("6mKj3");


var $6UM2Q = parcelRequire("6UM2Q");


var $gIaMn = parcelRequire("gIaMn");


var $gEtAQ = parcelRequire("gEtAQ");


var $gH1Fi = parcelRequire("gH1Fi");


var $ep3mz = parcelRequire("ep3mz");


var $eSLr0 = parcelRequire("eSLr0");

function $c50a10795e04dcb9$export$bbe14c99ac0820b3(t0) {
    const $ = (0, $bDgLe.c)(21);
    const { html: html, panelId: panelId, panelLocation: panelLocation } = t0;
    const containerRef = (0, $cozmU.useRef)(null);
    const [t1] = (0, $ep3mz.usePageState)();
    const { contentId: contentId, spaceKey: spaceKey } = t1;
    const dimensionsRef = (0, $gH1Fi.useExtensionDimensions)(panelLocation === (0, $eSLr0.ATL_GENERAL) ? (0, $eSLr0.ATL_GENERAL) : undefined, panelId, contentId || spaceKey || "");
    let t2;
    if ($[0] !== dimensionsRef) {
        t2 = (element)=>{
            containerRef.current = element;
            dimensionsRef(element);
        };
        $[0] = dimensionsRef;
        $[1] = t2;
    } else t2 = $[1];
    const panelRef = t2;
    const [ssrSuccess, setSsrSuccess] = (0, $cozmU.useState)(true);
    let t3;
    if ($[2] !== html) {
        let t4;
        if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
            t4 = /"moduleLocation"\s*:\s*"atl\.general"/;
            $[4] = t4;
        } else t4 = $[4];
        t3 = html.match(t4);
        $[2] = html;
        $[3] = t3;
    } else t3 = $[3];
    const moduleLocationMatch = t3;
    let t4;
    if ($[5] !== moduleLocationMatch) {
        t4 = Boolean(moduleLocationMatch) && (0, $gEtAQ.isSpaceOverview)();
        $[5] = moduleLocationMatch;
        $[6] = t4;
    } else t4 = $[6];
    const isMatchForActivatable = t4;
    let t5;
    if ($[7] !== isMatchForActivatable || $[8] !== ssrSuccess) {
        t5 = ()=>{
            const container = containerRef.current;
            if (!container) return;
            if (isMatchForActivatable && (0, $6mKj3.expVal)("confluence_frontend_early_webpanel_initialization", "isEnabled", false)) {
                if (window?.__HYDRATABLE__) {
                    const scriptElement = container.querySelector("script.ap-iframe-body-script");
                    if (scriptElement) {
                        const scriptContent = scriptElement.textContent || "";
                        const match = scriptContent.match(/"uniqueKey":"([^"]+)"/);
                        if (match) {
                            const uniqueKey = match[1];
                            const iframe = container.querySelector(`iframe[id*="${uniqueKey}"]`);
                            if (iframe) return;
                        }
                    }
                }
                if (ssrSuccess) setSsrSuccess(false);
            }
            (0, $brpfO.evalLegacyConnectInlineScripts)(container, (0, $6mKj3.expVal)("confluence_frontend_early_webpanel_initialization", "isEnabled", false));
        };
        $[7] = isMatchForActivatable;
        $[8] = ssrSuccess;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== html || $[11] !== isMatchForActivatable || $[12] !== panelId || $[13] !== ssrSuccess) {
        t6 = [
            html,
            panelId,
            ssrSuccess,
            isMatchForActivatable
        ];
        $[10] = html;
        $[11] = isMatchForActivatable;
        $[12] = panelId;
        $[13] = ssrSuccess;
        $[14] = t6;
    } else t6 = $[14];
    (0, $cozmU.useLayoutEffect)(t5, t6);
    let t7;
    if ($[15] !== html || $[16] !== isMatchForActivatable || $[17] !== panelId || $[18] !== panelRef || $[19] !== ssrSuccess) {
        t7 = isMatchForActivatable && (0, $6mKj3.expVal)("confluence_frontend_early_webpanel_initialization", "isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: panelRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6UM2Q.ActivatableComponent), {
            id: panelId ?? "WebPanel",
            triggers: [
                {
                    type: (0, $gIaMn.ActivationTriggerType).SSR_ONLY
                }
            ],
            ssrSuccess: ssrSuccess,
            analyticsName: "WebPanel"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-vc-ignore-if-no-layout-shift": true,
            dangerouslySetInnerHTML: {
                __html: html
            }
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: panelRef,
            "data-vc-ignore-if-no-layout-shift": true,
            dangerouslySetInnerHTML: {
                __html: html
            }
        });
        $[15] = html;
        $[16] = isMatchForActivatable;
        $[17] = panelId;
        $[18] = panelRef;
        $[19] = ssrSuccess;
        $[20] = t7;
    } else t7 = $[20];
    return t7;
}
module.exports["WebPanel"] = $c50a10795e04dcb9$export$bbe14c99ac0820b3;

});

parcelRegister("brpfO", function(module, exports) {

var $cpjd2 = parcelRequire("cpjd2");

const $5886a35f608ee97f$var$evalScripts = (allScripts)=>{
    allScripts.forEach((elementScript)=>{
        /**
		 * When evaluating the connect scripts, the eval function inherits the context in which is it called.
		 *
		 * This means that the eval function will have access to the variables and functions
		 * in the current scope. One of these variables is the `require` passed in from Atlaspack's module system.
		 *
		 * Since the eval scripts rely on AMD's require being globally available, and Atlaspack
		 * is now shadowing that variable, we need to evaluate the scripts in the global scope.
		 *
		 * We can do this using "indirect" eval, see the MDN docs for more info:
		 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/eval#direct_and_indirect_eval
		 *
		 * Assigning the eval function to a variable is enough to trigger the indirect eval behavior,
		 * and the scripts will be able to access the global require.
		 */ const evalInGlobalScope = eval;
        evalInGlobalScope(elementScript.innerHTML);
    });
};
function $5886a35f608ee97f$export$5beb7086100d432e(container, isEarlyInitFGEnabled = false) {
    // Connect macros have an inline script that doesn't work automatically when
    // rendered in react using dangerouslySetInnerHTML. This script evaluates any
    // connect macro.
    if (!container) return Promise.reject(new Error('evalLegacyConnectInlineScripts missing container argument'));
    const connectScripts = Array.from(container.querySelectorAll('script.ap-iframe-body-script'));
    const macroScripts = Array.from(container.querySelectorAll('script.cc-macro-body-script'));
    const allScripts = connectScripts.concat(macroScripts);
    // If the connect resources are preloaded, we don't need to download them again, just evaluate the scripts.
    if (window.__CONNECT_RESOURCES_PRELOADED__ && isEarlyInitFGEnabled) {
        $5886a35f608ee97f$var$evalScripts(allScripts);
        return Promise.resolve(null);
    }
    return new Promise((resolve)=>{
        if (allScripts.length > 0) // Download the connect web resources required to render an add-on before evaluating the inline scripts.
        (0, $cpjd2.requireLegacyWRM)([
            // ensure navigator-context misc dep is loaded before navigator-context
            'wr!confluence.web.resources:querystring',
            // resource to provide the context value of AP.navigator.getLocation
            'wr!confluence.web.resources:navigator-context',
            'wr!com.atlassian.plugins.atlassian-connect-plugin:confluence-atlassian-connect-resources-v5'
        ], ()=>{
            $5886a35f608ee97f$var$evalScripts(allScripts);
            resolve(null);
        }, ()=>{});
        else resolve(null);
    });
}
module.exports["evalLegacyConnectInlineScripts"] = $5886a35f608ee97f$export$5beb7086100d432e;

});

parcelRegister("6UM2Q", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $9s45p = parcelRequire("9s45p");


var $75bK2 = parcelRequire("75bK2");


var $hRdzX = parcelRequire("hRdzX");

const $68e0b10beef6f399$export$1db2f2faaee8467f = (0, $3u0dr.isReactCompilerActiveV2)() ? function ActivatableComponent(t0) {
    const $ = (0, $bDgLe.c)(26);
    const { children: children, triggers: triggers, onActivate: onActivate, id: id, analyticsName: analyticsName, ssrSuccess: ssrSuccess } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $9s45p.makeGate)();
        $[0] = t1;
    } else t1 = $[0];
    const gate = t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t2;
    if ($[1] !== children) {
        t2 = ()=>children;
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    const renderChildren = t2;
    let t3;
    if ($[3] !== analyticsName || $[4] !== createAnalyticsEvent || $[5] !== id || $[6] !== onActivate || $[7] !== triggers) {
        t3 = (reason)=>{
            if (gate?.getStatus() === "suspended") {
                onActivate?.(reason);
                if (analyticsName) createAnalyticsEvent({
                    type: "sendOperationalEvent",
                    data: {
                        source: "activatableComponent",
                        action: "activated",
                        actionSubject: "activatableComponent",
                        attributes: {
                            analyticsName: analyticsName,
                            triggers: triggers,
                            boundaryId: id,
                            activationReason: reason
                        }
                    }
                }).fire();
                gate.resolve();
            }
        };
        $[3] = analyticsName;
        $[4] = createAnalyticsEvent;
        $[5] = id;
        $[6] = onActivate;
        $[7] = triggers;
        $[8] = t3;
    } else t3 = $[8];
    const activateComponent = t3;
    let t4;
    if ($[9] !== activateComponent || $[10] !== analyticsName || $[11] !== id || $[12] !== triggers) {
        t4 = {
            triggers: triggers,
            gate: gate,
            activateComponent: activateComponent,
            boundaryId: id,
            analyticsName: analyticsName
        };
        $[9] = activateComponent;
        $[10] = analyticsName;
        $[11] = id;
        $[12] = triggers;
        $[13] = t4;
    } else t4 = $[13];
    const hostRefWithActivation = (0, $hRdzX.useActivationTriggers)(t4);
    let t5;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = gate?.getStatus?.();
        $[14] = t5;
    } else t5 = $[14];
    const t6 = analyticsName || id;
    let t7;
    if ($[15] !== activateComponent || $[16] !== id || $[17] !== renderChildren || $[18] !== ssrSuccess || $[19] !== t6 || $[20] !== triggers) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $75bK2.Boundary), {
            gate: gate,
            id: id,
            render: renderChildren,
            ssrSuccess: ssrSuccess,
            activateComponent: activateComponent,
            resolved: t5 === "resolved",
            boundaryName: t6,
            triggers: triggers
        });
        $[15] = activateComponent;
        $[16] = id;
        $[17] = renderChildren;
        $[18] = ssrSuccess;
        $[19] = t6;
        $[20] = triggers;
        $[21] = t7;
    } else t7 = $[21];
    let t8;
    if ($[22] !== hostRefWithActivation || $[23] !== id || $[24] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: hostRefWithActivation,
            "data-hydration-shield": id
        }, t7);
        $[22] = hostRefWithActivation;
        $[23] = id;
        $[24] = t7;
        $[25] = t8;
    } else t8 = $[25];
    return t8;
} : function ActivatableComponent({ children: children, triggers: triggers, onActivate: onActivate, id: id, analyticsName: analyticsName, ssrSuccess: ssrSuccess }) {
    const gate = (0, $cozmU.useMemo)(()=>(0, $9s45p.makeGate)(), []);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const renderChildren = (0, $cozmU.useCallback)(()=>{
        return children;
    }, [
        children
    ]);
    const activateComponent = (0, $cozmU.useCallback)((reason)=>{
        if (gate?.getStatus() === 'suspended') {
            onActivate?.(reason);
            if (analyticsName) createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    source: 'activatableComponent',
                    action: 'activated',
                    actionSubject: 'activatableComponent',
                    attributes: {
                        analyticsName: analyticsName,
                        triggers: triggers,
                        boundaryId: id,
                        activationReason: reason
                    }
                }
            }).fire();
            gate.resolve();
        }
    }, [
        gate,
        id,
        onActivate,
        createAnalyticsEvent,
        analyticsName,
        triggers
    ]);
    const hostRefWithActivation = (0, $hRdzX.useActivationTriggers)({
        triggers: triggers,
        gate: gate,
        activateComponent: activateComponent,
        boundaryId: id,
        analyticsName: analyticsName
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: hostRefWithActivation,
        "data-hydration-shield": id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $75bK2.Boundary), {
        gate: gate,
        id: id,
        render: renderChildren,
        ssrSuccess: ssrSuccess,
        activateComponent: activateComponent,
        resolved: gate?.getStatus?.() === 'resolved',
        boundaryName: analyticsName || id,
        triggers: triggers
    }));
};
module.exports["ActivatableComponent"] = $68e0b10beef6f399$export$1db2f2faaee8467f;

});

parcelRegister("gEtAQ", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");

const $b5832a8b6d0203e7$export$d9797e3a42403d0f = ()=>Boolean((0, $1NBp8.VIEW_PAGE).match(window.location.pathname));
const $b5832a8b6d0203e7$export$b6ab121b23baa35 = ()=>Boolean((0, $1NBp8.VIEW_BLOG).match(window.location.pathname) || (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).match(window.location.pathname) || (0, $1NBp8.VIEW_BLOG_MOBILE).match(window.location.pathname));
const $b5832a8b6d0203e7$export$99418391c9d4edd1 = ()=>Boolean((0, $1NBp8.HOME).match(window.location.pathname));
const $b5832a8b6d0203e7$export$3b7cd9ec7876f958 = ()=>Boolean((0, $1NBp8.EDIT_PAGE_EMBED).match(window.location.pathname) || (0, $1NBp8.EDIT_PAGE_V2).match(window.location.pathname) || (0, $1NBp8.EDIT_BLOG_V2).match(window.location.pathname) || (0, $1NBp8.EDIT_PAGE).match(window.location.pathname) || (0, $1NBp8.EDIT_BLOG).match(window.location.pathname));
const $b5832a8b6d0203e7$export$3ea67fa37c59fc23 = ()=>Boolean((0, $1NBp8.SPACE_OVERVIEW).match(window.location.pathname));
const $b5832a8b6d0203e7$export$ea39914fa18450ef = (routeName)=>{
    if (routeName !== undefined && routeName !== null) return routeName === (0, $1NBp8.DATABASE_VIEW).name;
    return Boolean((0, $1NBp8.DATABASE_VIEW).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$3a15fff847513284 = (routeName)=>{
    if (routeName !== undefined && routeName !== null) return routeName === (0, $1NBp8.WHITEBOARD_BOARD).name;
    return Boolean((0, $1NBp8.WHITEBOARD_BOARD).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$e40fec4aab490836 = (routeName)=>{
    if (routeName !== undefined && routeName !== null) return routeName === (0, $1NBp8.SLIDES_VIEW).name;
    return Boolean((0, $1NBp8.SLIDES_VIEW).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$49ce8db5bd2e4087 = (routeName)=>{
    if (!routeName) return false;
    const editRoutes = [
        (0, $1NBp8.EDIT_PAGE_EMBED).name,
        (0, $1NBp8.EDIT_PAGE_V2).name,
        (0, $1NBp8.EDIT_BLOG_V2).name,
        (0, $1NBp8.EDIT_PAGE).name,
        (0, $1NBp8.EDIT_BLOG).name
    ];
    return editRoutes.includes(routeName);
};
module.exports["isViewPage"] = $b5832a8b6d0203e7$export$d9797e3a42403d0f;
module.exports["isBlogPage"] = $b5832a8b6d0203e7$export$b6ab121b23baa35;
module.exports["isHomePage"] = $b5832a8b6d0203e7$export$99418391c9d4edd1;
module.exports["isSpaceOverview"] = $b5832a8b6d0203e7$export$3ea67fa37c59fc23;
module.exports["isDatabase"] = $b5832a8b6d0203e7$export$ea39914fa18450ef;
module.exports["isWhiteboard"] = $b5832a8b6d0203e7$export$3a15fff847513284;
module.exports["isSlides"] = $b5832a8b6d0203e7$export$e40fec4aab490836;
module.exports["isEditPage"] = $b5832a8b6d0203e7$export$49ce8db5bd2e4087;

});

parcelRegister("gH1Fi", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9wGTI = parcelRequire("9wGTI");


var $e4o8D = parcelRequire("e4o8D");


var $7W9kD = parcelRequire("7W9kD");

const $46bdebab359d4884$export$8adc0cb9461bf99f = (source, extensionId, contextKey)=>{
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const cleanup = (0, $cozmU.useRef)(undefined);
    // The observation belongs to this page context, even when React reuses its DOM node.
    const observationContext = (0, $cozmU.useMemo)(()=>({
            source: source,
            extensionId: extensionId,
            contextKey: contextKey
        }), [
        source,
        extensionId,
        contextKey
    ]);
    return (0, $cozmU.useCallback)((element)=>{
        const { source: source, extensionId: extensionId } = observationContext;
        cleanup.current?.();
        cleanup.current = undefined;
        if (!renderServerPlaceholder && element && source && extensionId && (0, $9wGTI.fg)('confluence_ufo_banner_extension_dimensions')) cleanup.current = (0, $7W9kD.observeExtensionDimensions)(element, source, extensionId);
    }, [
        observationContext,
        renderServerPlaceholder
    ]);
};
module.exports["useExtensionDimensions"] = $46bdebab359d4884$export$8adc0cb9461bf99f;

});

parcelRegister("7W9kD", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $9f0ae7ee0cebc5b7$var$registrations = new Map();
let $9f0ae7ee0cebc5b7$var$observer;
// Bound the addition to the existing UFO payload, even on tenants with many apps.
const $9f0ae7ee0cebc5b7$var$MAX_REPORTED_EXTENSIONS = 50;
const $9f0ae7ee0cebc5b7$export$dbee8f9a070db66b = (element, source, extensionId)=>{
    if (!extensionId || !window.ResizeObserver || !(0, $9wGTI.fg)('confluence_ufo_banner_extension_dimensions')) return;
    if (!$9f0ae7ee0cebc5b7$var$observer) $9f0ae7ee0cebc5b7$var$observer = new ResizeObserver((entries)=>{
        if (!(0, $9wGTI.fg)('confluence_ufo_banner_extension_dimensions')) return;
        for (const entry of entries){
            const registration = $9f0ae7ee0cebc5b7$var$registrations.get(entry.target);
            if (!registration) continue;
            // These wrappers have no padding/border. contentRect supplies physical CSS
            // pixels after layout, without synchronous layout reads or React updates.
            // This measures allocated host space, including any active preset height.
            const { height: height, width: width } = entry.contentRect;
            if (Number.isFinite(height) && Number.isFinite(width) && height >= 0 && width >= 0) registration.dimensions = {
                height: Math.round(height),
                width: Math.round(width)
            };
        }
    });
    const registration = {
        source: source,
        extensionId: extensionId
    };
    $9f0ae7ee0cebc5b7$var$registrations.set(element, registration);
    $9f0ae7ee0cebc5b7$var$observer.observe(element);
    return ()=>{
        if ($9f0ae7ee0cebc5b7$var$registrations.get(element) !== registration) return;
        $9f0ae7ee0cebc5b7$var$observer?.unobserve(element);
        $9f0ae7ee0cebc5b7$var$registrations.delete(element);
        if ($9f0ae7ee0cebc5b7$var$registrations.size === 0) {
            $9f0ae7ee0cebc5b7$var$observer?.disconnect();
            $9f0ae7ee0cebc5b7$var$observer = undefined;
        }
    };
};
const $9f0ae7ee0cebc5b7$export$e4b460b98000468c = ()=>{
    const groups = new Map();
    for (const [element, { source: source, extensionId: extensionId, dimensions: dimensions }] of $9f0ae7ee0cebc5b7$var$registrations){
        if (!element.isConnected || !dimensions) continue;
        const group = groups.get(source) ?? new Map();
        group.set(extensionId, {
            ...dimensions
        });
        groups.set(source, group);
    }
    let reported = 0;
    let omitted = 0;
    const extensionDimensions = Object.fromEntries(Array.from(groups, ([source, dimensions])=>[
            source,
            Object.fromEntries(Array.from(dimensions).filter(()=>{
                if (reported < $9f0ae7ee0cebc5b7$var$MAX_REPORTED_EXTENSIONS) {
                    reported++;
                    return true;
                }
                omitted++;
                return false;
            }))
        ]));
    return {
        extensionDimensions: extensionDimensions,
        ...omitted ? {
            extensionDimensionsOmittedCount: omitted
        } : {}
    };
};
module.exports["observeExtensionDimensions"] = $9f0ae7ee0cebc5b7$export$dbee8f9a070db66b;
module.exports["getExtensionDimensions"] = $9f0ae7ee0cebc5b7$export$e4b460b98000468c;

});

parcelRegister("9g2Nl", function(module, exports) {
function $4c7822e745f26c41$export$46f5b20a43586060(event, // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
container = document) {
    if (!event) // incorrect input
    return null;
    if (event.button !== 0) // this wasn't a left-click
    return null;
    if (event.type !== 'click') // we only handle clicks. For anchor elements, performing an "enter" on a focused element is equivalent to a left-click
    return null;
    if (event.metaKey || event.altKey || event.ctrlKey || event.shiftKey) // ignore clicks with modifier keys
    return null;
    // This might be the child of an anchor (such as the span inside of a smart card),
    // so check for a parent anchor.
    // The check for e.target.closest is for IE.
    const { target: target } = event;
    // @ts-ignore
    const closest = target ? target['closest'] : null;
    const parentAnchor = closest ? closest.call(target, 'A') : null;
    const eventTarget = parentAnchor || target;
    if (!(eventTarget instanceof HTMLAnchorElement)) // this method doesn't care about non-anchor elements
    return null;
    if (eventTarget.target && eventTarget.target !== '_self') // we should let browser handle targets like "_blank", "_top", or such
    return null;
    if (!eventTarget.hash) // the anchor element does not have a hash defined
    return null;
    const ownerDocument = eventTarget.ownerDocument;
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    if (!ownerDocument || ownerDocument !== document) return null;
    // we are not checking for search strings here explicitly -- even if the search string in
    // link and in the document are different, the assumption is that this is still the same document
    const linkOwnerPath = ownerDocument.location.origin + ownerDocument.location.pathname;
    const linkHrefPath = eventTarget.origin + eventTarget.pathname;
    const isSameDocumentReference = linkOwnerPath === linkHrefPath;
    if (!isSameDocumentReference) // this is a link with a hash, but it doesn't point to the same document it is on
    return null;
    let decodedHash = '';
    try {
        // try to decode the hash
        decodedHash = decodeURIComponent(eventTarget.hash.substring(1));
    } catch (e) {
        // if hash is not encoded, it will throw a URI Malformed error,
        // which we will then return the original hash
        decodedHash = eventTarget.hash.substring(1);
    }
    // `event.target.hash` will be in the form of `#hash-path`.
    // `document.querySelector` might choke on input like "#id>.", so we use `document.getElementById` here
    const anchorElement = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.getElementById(decodedHash) || // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector(`[name="${CSS.escape(decodedHash)}"]`);
    // check if element is nested inside table, if so we need to account for
    // sticky table header overlapping the element
    const hasTableParent = !!anchorElement?.closest('.pm-table-container td');
    if (anchorElement == null) {
        if (decodedHash.toLowerCase() === 'top') //we have a special case. the top hash doesn't need a matching element. This needs to be done manually for nav4
        return {
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            anchorElement: document.documentElement,
            hash: decodedHash.toLowerCase(),
            hasTableParent: hasTableParent
        };
        // this is a link with a hash to the same document it is on, but the hash element does not exist in the DOM
        return null;
    }
    if (!container.contains(anchorElement)) // this is outside of the boundaries that we care about
    return null;
    return {
        anchorElement: anchorElement,
        hash: decodedHash,
        hasTableParent: hasTableParent
    };
}
module.exports["getHashLinkClickOptions"] = $4c7822e745f26c41$export$46f5b20a43586060;

});

parcelRegister("fURMF", function(module, exports) {

var $7W8i8 = parcelRequire("7W8i8");

const $e9d2c346c5e28ee8$var$logger = (0, $7W8i8.getLogger)('scroll-to-element');
/**
 * Returns the HTMLElement that should be used as the scroll root.
 * This is the div with id=AkMainContent when on desktop, falling back to window on mobile.
 */ function $e9d2c346c5e28ee8$var$getScrollRootElement() {
    // On mobile sizes, scroll the window instead of #AkMainContent.
    // The magic number maps to media.above.md @media (min-width: 64rem) = 1024px.
    if (typeof document !== 'undefined' && typeof window !== 'undefined') {
        const akMainContent = document.getElementById('AkMainContent');
        if (window.innerWidth > 1023 && akMainContent) return akMainContent;
        return window;
    }
    return null;
}
const $e9d2c346c5e28ee8$var$explicitScrollListeners = new Set();
function $e9d2c346c5e28ee8$export$73ac910751bb2a9b(listener) {
    $e9d2c346c5e28ee8$var$explicitScrollListeners.add(listener);
    return ()=>$e9d2c346c5e28ee8$var$explicitScrollListeners.delete(listener);
}


function $e9d2c346c5e28ee8$var$invokeExplicitScrollListeners() {
    $e9d2c346c5e28ee8$var$explicitScrollListeners.forEach((listener)=>{
        try {
            listener();
        } catch (error) {
            Promise.all([
                (parcelRequire("2tnYT")),
                (parcelRequire("gBChQ"))
            ]).then(([{ getMonitoringClient: getMonitoringClient }, { Attribution: Attribution }])=>{
                getMonitoringClient().submitError(error, {
                    attribution: Attribution.PAGE_EXTENSIONS
                });
            }).catch(()=>{
            // ignore errors, we can't do anything at this point
            });
        }
    });
}
function $e9d2c346c5e28ee8$var$isSmoothScrollSupported() {
    return typeof document !== 'undefined' && 'scrollBehavior' in document.documentElement.style;
}
function $e9d2c346c5e28ee8$export$9b071b9c6dd786a2(isSmooth = false) {
    $e9d2c346c5e28ee8$var$invokeExplicitScrollListeners();
    const scrollRootElement = $e9d2c346c5e28ee8$var$getScrollRootElement();
    if (scrollRootElement) {
        // scrollRootElement is null during SSR — skip scrolling in that case
        if (isSmooth && $e9d2c346c5e28ee8$var$isSmoothScrollSupported()) scrollRootElement.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
        else scrollRootElement.scrollTo(0, 0);
    }
}
function $e9d2c346c5e28ee8$export$2353115f31f4d15(element, scrollCorrectionPixels, scrollBehavior = 'auto', isLivePage) {
    const scrollRootElement = isLivePage ? typeof document !== 'undefined' ? document.querySelector('.fabric-editor-popup-scroll-parent') : null : $e9d2c346c5e28ee8$var$getScrollRootElement();
    let parentsOffset = 0;
    let currentOffsetParent = element.offsetParent;
    while(currentOffsetParent instanceof HTMLElement && currentOffsetParent != scrollRootElement){
        parentsOffset += currentOffsetParent.offsetTop;
        currentOffsetParent = currentOffsetParent.offsetParent;
    }
    const pageHeaderHeightAdjustment = 56;
    let top = element.offsetTop + (scrollCorrectionPixels || 0) + parentsOffset - pageHeaderHeightAdjustment;
    // check if element is nested inside table, if so we need to account for
    // sticky table header overlapping the element
    const hasTableParent = element?.closest('.pm-table-container td');
    if (hasTableParent && scrollCorrectionPixels) top = top + scrollCorrectionPixels * 1.25;
    $e9d2c346c5e28ee8$var$invokeExplicitScrollListeners();
    let behavior = scrollBehavior;
    if (behavior === 'smooth' && !$e9d2c346c5e28ee8$var$isSmoothScrollSupported()) behavior = 'auto';
    try {
        scrollRootElement?.scroll({
            top: top,
            behavior: behavior
        });
    } catch  {
        $e9d2c346c5e28ee8$var$logger.error`scroll() is not supported on #AkMainContent`;
    }
}
function $e9d2c346c5e28ee8$export$8611df79cae6484f(element) {
    if (typeof document !== 'undefined') {
        const scrollContainer = document.getElementById('AkMainContent');
        const breadcrumbHeaderHeight = 56; // FixedSpaceHeaderContainer (top nav) of the classic full page
        if (scrollContainer && scrollContainer.contains(element)) {
            // Let the browser calculate the exact scroll position
            const savedScroll = scrollContainer.scrollTop;
            element.scrollIntoView({
                behavior: 'instant',
                block: 'start'
            });
            const targetScroll = scrollContainer.scrollTop;
            scrollContainer.scrollTop = savedScroll;
            scrollContainer.scrollTo({
                left: 0,
                top: targetScroll - breadcrumbHeaderHeight,
                behavior: 'smooth'
            });
        } else element.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    }
}
module.exports["scrollToPageStart"] = $e9d2c346c5e28ee8$export$9b071b9c6dd786a2;
module.exports["scrollToElement"] = $e9d2c346c5e28ee8$export$2353115f31f4d15;
module.exports["scrollToBlockForViewPage"] = $e9d2c346c5e28ee8$export$8611df79cae6484f;

});

parcelRegister("2tnYT", function(module, exports) {

let $1cd0e4621aa50ab2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1cd0e4621aa50ab2$var$load("9fiFD").then(()=>parcelRequire('6SqQk'));

});

parcelRegister("gBChQ", function(module, exports) {

let $c16dcd029b34a01f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c16dcd029b34a01f$var$load("fH5Zm").then(()=>parcelRequire('bZmZf'));

});

parcelRegister("bYH75", function(module, exports) {
/* OnboardingNthUserContentTypeSpotlight.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");


var $3cMXh = parcelRequire("3cMXh");


var $lRWIF = parcelRequire("lRWIF");


var $7Sm4c = parcelRequire("7Sm4c");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $eCryJ = parcelRequire("eCryJ");


var $1uFM6 = parcelRequire("1uFM6");


var $ivb8S = parcelRequire("ivb8S");


var $dBcar = parcelRequire("dBcar");


var $lsxnT = parcelRequire("lsxnT");

const $eac5217fab1ddbbe$export$e2e108cbe2e4f865 = (0, $lRWIF.NthUserContentType);
function $eac5217fab1ddbbe$var$isErrorHandled(error) {
    // Mark unauthorized error as handled and not report to monitoring client
    if ((0, $1uFM6.isUnauthorizedError)(error) || error?.graphQLErrors?.[0]?.message === 'unauthorized') {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return true;
    }
    return false;
}
const $eac5217fab1ddbbe$var$i18n = (0, $kSwu1.defineMessages)({
    popularHeading: {
        id: "onboarding-nth-user-setup-modal.content-type-spotlight.nth-user.content-types.popular.heading",
        defaultMessage: "{contentType, select, page {This is the most popular page in your site} whiteboard {This is the most popular whiteboard in your site} liveDoc {This is the most popular live doc in your site} database {This is the most popular database in your site} other {This content is popular on your site}}"
    },
    nonPopularHeading: {
        id: "onboarding-nth-user-setup-modal.content-type-spotlight.nth-user.content-types.non-popular.heading",
        defaultMessage: "{contentType, select, page {This is a sample page in your space} whiteboard {This is a sample whiteboard in your space} liveDoc {This is a sample live doc in your space} database {This is a page on how to use databases} other {This is an example of your selected content type in your space}}"
    },
    contentDescription: {
        id: "onboarding-nth-user-setup-modal.content-type-spotlight.nth-user.content-types.content.description",
        defaultMessage: "{contentType, select, page {Take a quick look at the page and learn how Confluence pages work.} whiteboard {Take a quick look at the whiteboard and learn how Confluence whiteboards work.} liveDoc {Take a quick look at the live doc and learn how Confluence live docs work.} database {Take a quick look at the database and learn how Confluence databases work.} databaseDefault {Take a quick look at the page and learn how Confluence databases work.} other {Take a quick look at the content and learn how Confluence content types work.}}"
    },
    dismissAction: {
        id: "onboarding-nth-user-setup-modal.content-type-spotlight.dismiss.action",
        defaultMessage: "Dismiss"
    }
});
const $eac5217fab1ddbbe$var$styles = {
    fixedSpotlightWrapper: "_1mT5xdy1CL _42Yu6BHOnL _4ApkO2yFLW _2IhTonGXk2",
    relativeSpotlightWrapper: "_1mT5xdRAKS _2IhTonyFLW",
    liveDocSpacing: "_1mT5xdRAKS _2IhTonGXk2"
};
const $eac5217fab1ddbbe$export$38c962029328197d = (contentType)=>{
    switch(contentType){
        case (0, $lRWIF.NthUserContentType).PAGE:
            return {
                messageId: 'onboarding-nth-user-page-content-type-spotlight'
            };
        case (0, $lRWIF.NthUserContentType).LIVE_DOC:
            return {
                messageId: 'onboarding-nth-user-live-doc-content-type-spotlight'
            };
        case (0, $lRWIF.NthUserContentType).WHITEBOARD:
            return {
                messageId: 'onboarding-nth-user-whiteboard-content-type-spotlight'
            };
        case (0, $lRWIF.NthUserContentType).DATABASE:
            return {
                messageId: 'onboarding-nth-user-database-content-type-spotlight'
            };
        default:
            return {
                messageId: ''
            };
    }
};
const $eac5217fab1ddbbe$var$actionSubjectId = 'contentTypeNthUserOnboardingSpotlight';
const $eac5217fab1ddbbe$var$source = 'nthUserContentTypeScreen';
const $eac5217fab1ddbbe$export$f624ac630094c7f0 = ({ contentType: contentType, contentId: contentId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const intl = (0, $kSwu1.useIntl)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { SpotlightCard: SpotlightCard } = (0, $lsxnT.useChoreographerAssets)();
    const [isLocalNudgeShowing, setIsLocalNudgeShowing] = (0, $cozmU.useState)(false);
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)([
        (0, $dBcar.NTH_USER_SETUP_CONTENT_TYPE).NTH_USER_SELECTED_CONTENT_TYPE,
        (0, $dBcar.NTH_USER_SETUP_CONTENT_TYPE).NTH_USER_CONTENT_TYPE_SPOTLIGHT_SEEN,
        (0, $dBcar.NTH_USER_SETUP_CONTENT_TYPE).NTH_USER_CONTENT_TYPE_POPULAR_CONTENT_FOUND,
        (0, $dBcar.NTH_USER_SETUP_CONTENT_TYPE).NTH_USER_CONTENT_TYPE_LANDING_CONTENT_ID
    ]);
    const { nthUserContentTypeSpotlightSeen: nthUserContentTypeSpotlightSeen, nthUserContentTypePopularContentFound: nthUserContentTypePopularContentFound, nthUserSelectedContentType: nthUserSelectedContentType, nthUserContentTypeLandingContentId: nthUserContentTypeLandingContentId } = (0, $ivb8S.deserializeState)(onboardingStateData);
    const isOnboardingStateLoaded = Boolean(!onboardingStateLoading && !onboardingStateError && onboardingStateData);
    const isEligibleForNudge = isOnboardingStateLoaded && !nthUserContentTypeSpotlightSeen && Boolean($eac5217fab1ddbbe$export$38c962029328197d(contentType).messageId);
    const isDefaultDatabaseContent = nthUserSelectedContentType === (0, $lRWIF.NthUserContentType).DATABASE && contentType === (0, $lRWIF.NthUserContentType).PAGE;
    const isTargetContent = (contentType === nthUserSelectedContentType || isDefaultDatabaseContent) && // if there is popular content, ensure the content ids match
    contentId === nthUserContentTypeLandingContentId;
    const hasMetAllSpotlightConditions = isEligibleForNudge && isTargetContent;
    const choreographerMessageId = $eac5217fab1ddbbe$export$38c962029328197d(contentType).messageId;
    (0, $cozmU.useEffect)(()=>{
        if (hasMetAllSpotlightConditions) setIsLocalNudgeShowing(true);
    }, [
        hasMetAllSpotlightConditions
    ]);
    const handleOnDismiss = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'dismissed',
                actionSubject: 'button',
                actionSubjectId: $eac5217fab1ddbbe$var$actionSubjectId,
                source: $eac5217fab1ddbbe$var$source,
                attributes: {
                    contentType: contentType,
                    isPopularContent: nthUserContentTypePopularContentFound ?? false
                }
            }
        }).fire();
        setIsLocalNudgeShowing(false);
    };
    const headingMessage = nthUserContentTypePopularContentFound ? $eac5217fab1ddbbe$var$i18n.popularHeading : $eac5217fab1ddbbe$var$i18n.nonPopularHeading;
    const getLocalizedSelectOptionString = (isHeading = true)=>{
        if (nthUserSelectedContentType === (0, $lRWIF.NthUserContentType).LIVE_DOC) // Select values only accept alphanumeric or underscores characters
        return 'liveDoc';
        if (!nthUserContentTypePopularContentFound && isDefaultDatabaseContent) // the spotlight for database default content shows up on a page
        // the non-popular database heading already adjusts for the database default content
        return isHeading ? (0, $lRWIF.NthUserContentType).DATABASE : 'databaseDefault';
        return contentType;
    };
    const onMessageDispositionCallback = (0, $cozmU.useCallback)((message)=>{
        if (message === (0, $3cMXh.MessageDeliveryStatus).STARTED) {
            createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    name: $eac5217fab1ddbbe$var$actionSubjectId,
                    source: $eac5217fab1ddbbe$var$source,
                    attributes: {
                        contentType: contentType,
                        isPopularContent: nthUserContentTypePopularContentFound ?? false
                    }
                }
            }).fire();
            if (!nthUserContentTypeSpotlightSeen) setOnboardingState({
                key: (0, $dBcar.NTH_USER_SETUP_CONTENT_TYPE).NTH_USER_CONTENT_TYPE_SPOTLIGHT_SEEN,
                value: 'true'
            });
        }
    }, [
        createAnalyticsEvent,
        contentType,
        nthUserContentTypePopularContentFound,
        nthUserContentTypeSpotlightSeen,
        setOnboardingState
    ]);
    if (onboardingStateError && !$eac5217fab1ddbbe$var$isErrorHandled(onboardingStateError)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: onboardingStateError
    }));
    if (!isLocalNudgeShowing) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $eac5217fab1ddbbe$var$styles.fixedSpotlightWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $eac5217fab1ddbbe$var$styles.relativeSpotlightWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)(contentType === (0, $lRWIF.NthUserContentType).LIVE_DOC && $eac5217fab1ddbbe$var$styles.liveDocSpacing)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SpotlightCard, {
        messageId: choreographerMessageId,
        messageType: "engagement",
        width: 275,
        heading: intl.formatMessage(headingMessage, {
            contentType: getLocalizedSelectOptionString()
        }),
        actions: [
            {
                onClick: handleOnDismiss,
                text: intl.formatMessage($eac5217fab1ddbbe$var$i18n.dismissAction)
            }
        ],
        onMessageDisposition: onMessageDispositionCallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$eac5217fab1ddbbe$var$i18n.contentDescription,
        values: {
            contentType: getLocalizedSelectOptionString(false)
        }
    }))))));
};
const $eac5217fab1ddbbe$export$5f3827ac6e1d7daa = ({ contentType: contentType, contentId: contentId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCryJ.GenericErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).CE_MAU,
        renderOnError: ()=>{
            return null;
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($eac5217fab1ddbbe$export$f624ac630094c7f0, {
        contentType: contentType,
        contentId: contentId
    }));
};
module.exports["ContentType"] = $eac5217fab1ddbbe$export$e2e108cbe2e4f865;
module.exports["OnboardingNthUserContentTypeSpotlight"] = $eac5217fab1ddbbe$export$5f3827ac6e1d7daa;

});

parcelRegister("lRWIF", function(module, exports) {
var $eb1132679219975b$export$3e5d0af8e738b082 = /*#__PURE__*/ function(Team) {
    Team["SoftwareDevelopment"] = "software-development";
    Team["ProductManagement"] = "product-management";
    Team["Marketing"] = "marketing";
    Team["Design"] = "design";
    Team["ProjectManagement"] = "project-management";
    Team["Operations"] = "operations";
    Team["ITSupport"] = "it-support";
    Team["Finance"] = "finance";
    Team["HumanResources"] = "human-resources";
    Team["Legal"] = "legal";
    Team["Sales"] = "sales";
    Team["DataScience"] = "data-science";
    Team["CustomerService"] = "customer-service";
    Team["Other"] = "other";
    return Team;
}({});
const $eb1132679219975b$export$77134aba51f821f8 = {
    ["software-development"]: 'onboarding-helpers.team.software.development.modern.branding',
    ["product-management"]: 'onboarding-helpers.team.productManagement',
    ["marketing"]: 'onboarding-helpers.team.marketing.modern.branding',
    ["design"]: 'onboarding-helpers.team.design',
    ["project-management"]: 'onboarding-helpers.team.projectManagement',
    ["operations"]: 'onboarding-helpers.team.operations.modern.branding',
    ["it-support"]: 'onboarding-helpers.team.it.support.modern.branding',
    ["finance"]: 'onboarding-helpers.team.finance.modern.branding',
    ["human-resources"]: 'onboarding-helpers.team.human.resources.modern.branding',
    ["legal"]: 'onboarding-helpers.team.legal.modern.branding',
    ["sales"]: 'onboarding-helpers.team.sales.modern.branding',
    ["data-science"]: 'onboarding-helpers.team.data.science.modern.branding',
    ["customer-service"]: 'onboarding-helpers.team.customer.service.modern.branding',
    ["other"]: 'onboarding-helpers.team.other'
};
var $eb1132679219975b$export$a0b0994d6b76cdaa = /*#__PURE__*/ function(FocusArea) {
    FocusArea["PlanOutProjects"] = "plan-out-projects";
    FocusArea["CreateTechnicalDocumentation"] = "create-technical-documentation";
    FocusArea["CreateMarketingCampaigns"] = "create-marketing-campaigns";
    FocusArea["ShareStatusUpdates"] = "share-status-updates";
    FocusArea["BrainstormAndStrategize"] = "brainstorm-and-strategize";
    FocusArea["PlanAndPrioritize"] = "plan-and-prioritize";
    FocusArea["GetAlignment"] = "get-alignment";
    FocusArea["ImproveTeamProcesses"] = "improve-team-processes";
    FocusArea["ShareUpdatesWithStakeholders"] = "share-updates-with-stakeholders";
    FocusArea["StrategizeOnMarketingContent"] = "strategize-on-marketing-content";
    FocusArea["ShareWeeklyMeetingNotes"] = "share-weekly-meeting-notes";
    return FocusArea;
}({});
const $eb1132679219975b$export$8764a1262502aaf9 = {
    itProjectPoster: 'com.atlassian.confluence.plugins.confluence-business-blueprints:it-project-poster-blueprint',
    sprintPlanning: 'com.atlassian.confluence.plugins.confluence-business-blueprints:sprint-planning-meeting-blueprint',
    productRequirements: 'com.atlassian.confluence.plugins.confluence-software-blueprints:requirements-blueprint',
    softwareArchitectureReview: 'com.atlassian.confluence.plugins.confluence-business-blueprints:software-architecture-review-blueprint',
    howToArticle: 'com.atlassian.confluence.plugins.confluence-knowledge-base:kb-how-to-article-blueprint',
    architectureDiagram: 'com.atlassian.confluence.plugins.confluence-business-blueprints:aws-architecture-diagram-blueprint',
    incidentCommunication: 'com.atlassian.confluence.plugins.confluence-business-blueprints:incident-communication-blueprint',
    experimentPlanAndResults: 'com.atlassian.confluence.plugins.confluence-business-blueprints:experiment-planning-and-results-blueprint',
    dailyStandUp: 'com.atlassian.confluence.plugins.confluence-business-blueprints:daily-stand-up-blueprint',
    projectPlan: 'com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-blueprint',
    strategicPlan: 'com.atlassian.confluence.plugins.confluence-business-blueprints:business-strategy-blueprint',
    productRoadmap: 'com.atlassian.confluence.plugins.confluence-business-blueprints:product-roadmap-blueprint',
    workingAgreements: 'com.atlassian.confluence.plugins.confluence-business-blueprints:working-agreements-blueprint',
    teamPoster: 'com.atlassian.confluence.plugins.confluence-business-blueprints:team-poster-blueprint',
    rolesAndResponsibilities: 'com.atlassian.confluence.plugins.confluence-business-blueprints:roles-responsibilities-blueprint',
    stakeholderCommunications: 'com.atlassian.confluence.plugins.confluence-business-blueprints:stakeholder-communications-blueprint',
    endOfWeekStatusReport: 'com.atlassian.confluence.plugins.confluence-business-blueprints:eow-status-report-blueprint',
    marketingCampaign: 'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-campaign-blueprint',
    marketingPlan: 'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-blueprint',
    brainstorming: 'com.atlassian.confluence.plugins.confluence-business-blueprints:brainstorming-with-remote-teams-blueprint',
    swotAnalysis: 'com.atlassian.confluence.plugins.confluence-business-blueprints:swot-analysis-blueprint',
    competitiveAnalysis: 'com.atlassian.confluence.plugins.confluence-business-blueprints:competitive-analysis-blueprint',
    meetingNotes: 'com.atlassian.confluence.plugins.confluence-business-blueprints:meeting-notes-blueprint',
    daci: 'com.atlassian.confluence.plugins.confluence-business-blueprints:decisions-blueprint',
    customerJourneyMapping: 'com.atlassian.confluence.plugins.confluence-business-blueprints:customer-journey-mapping-blueprint',
    toDoList: 'com.atlassian.confluence.plugins.confluence-business-blueprints:to-do-list-blueprint',
    retrospective: 'com.atlassian.confluence.plugins.confluence-software-blueprints:retrospectives-blueprint',
    devOpsRunbook: 'com.atlassian.confluence.plugins.confluence-business-blueprints:devops-runbook-blueprint',
    sop: 'com.atlassian.confluence.plugins.confluence-business-blueprints:standard-operating-procedure-sop-blueprint',
    itsmKnownErrors: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-known-errors-blueprint',
    businessStatusUpdate: 'com.atlassian.confluence.plugins.confluence-business-blueprints:business-status-update-blueprint',
    workshopPlanner: 'com.atlassian.confluence.plugins.confluence-business-blueprints:workshop-planner-blueprint',
    designSystems: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-systems-blueprint',
    designReview: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-review-blueprint',
    businessPlanOnePager: 'com.atlassian.confluence.plugins.confluence-business-blueprints:business-plan-one-pager-blueprint',
    riskAssessmentMatrix: 'com.atlassian.confluence.plugins.confluence-business-blueprints:risk-assessment-blueprint',
    vendorAgreement: 'com.atlassian.confluence.plugins.confluence-business-blueprints:vendor-agreement-blueprint',
    visionToValues: 'com.atlassian.confluence.plugins.confluence-business-blueprints:vision-to-values-blueprint',
    careerDevelopmentPlan: 'com.atlassian.confluence.plugins.confluence-business-blueprints:career-development-plan-blueprint',
    hrKnowledgeBaseManagement: 'com.atlassian.confluence.plugins.confluence-business-blueprints:hr-knowledge-base-management-blueprint',
    salesAccountPlanning: 'com.atlassian.confluence.plugins.confluence-business-blueprints:account-planning-for-sales-blueprint',
    salesPortal: 'com.atlassian.confluence.plugins.confluence-business-blueprints:sales-portal-template-blueprint',
    smartGoals: 'com.atlassian.confluence.plugins.confluence-business-blueprints:smart-goals-blueprint',
    projectStatus: 'com.atlassian.confluence.plugins.confluence-business-blueprints:project-status-blueprint',
    itsmChangeManagement: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-change-management-blueprint',
    itsmPostIncidentReviews: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-pir-blueprint',
    itsmRunbook: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-runbook-blueprint',
    troubleshootingArticle: 'com.atlassian.confluence.plugins.confluence-knowledge-base:kb-troubleshooting-article-blueprint',
    mvpIdeation: 'com.atlassian.confluence.plugins.confluence-business-blueprints:mvp-ideation-blueprint',
    designSprint: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-sprint-blueprint',
    elevatorPitch: 'com.atlassian.confluence.plugins.confluence-business-blueprints:elevator-pitch-blueprint',
    mutualActionPlan: 'com.atlassian.confluence.plugins.confluence-business-blueprints:mutual-action-plan-blueprint',
    executiveBusinessReview: 'com.atlassian.confluence.plugins.confluence-business-blueprints:executive-business-review-blueprint',
    fiveWhysAnalysis: 'com.atlassian.confluence.plugins.confluence-business-blueprints:5-whys-analysis-blueprint',
    okrs: 'com.atlassian.confluence.plugins.confluence-business-blueprints:okr-blueprint',
    employeeHandbook: 'com.atlassian.confluence.plugins.confluence-business-blueprints:employee-handbook-blueprint',
    hiringProcess: 'com.atlassian.confluence.plugins.confluence-business-blueprints:hiring-process-blueprint',
    contentStrategy: 'com.atlassian.confluence.plugins.confluence-business-blueprints:content-strategy-blueprint',
    blankPage: '',
    customerImpactAssessment: 'com.atlassian.confluence.plugins.confluence-business-blueprints:customer-impact-assessment-blueprint',
    lennysProductRequirements: 'com.atlassian.confluence.plugins.confluence-business-blueprints:lennys-product-requirements-blueprint',
    designDecision: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-decision-blueprint',
    persona: 'com.atlassian.confluence.plugins.confluence-business-blueprints:persona-blueprint',
    messageHouse: 'com.atlassian.confluence.plugins.confluence-business-blueprints:message-house-template-blueprint',
    annualPlanOnePager: 'com.atlassian.confluence.plugins.confluence-business-blueprints:annual-plan-one-pager-blueprint',
    allHandsMeeting: 'com.atlassian.confluence.plugins.confluence-business-blueprints:all-hands-meeting-blueprint',
    customerInterviewReport: 'com.atlassian.confluence.plugins.confluence-business-blueprints:customer-interview-report-blueprint',
    presenterMode: 'com.atlassian.confluence.plugins.confluence-business-blueprints:presenter-mode-blueprint',
    qtcAcquisition: 'com.atlassian.confluence.plugins.confluence-business-blueprints:qtc-acquisition-blueprint',
    jobDescription: 'com.atlassian.confluence.plugins.confluence-business-blueprints:job-description-blueprint',
    ninetyDayPlan: 'com.atlassian.confluence.plugins.confluence-business-blueprints:90-day-plan-blueprint',
    lennysPerformanceReview: 'com.atlassian.confluence.plugins.confluence-business-blueprints:lennys-performance-review-blueprint',
    projectKickoff: 'com.atlassian.confluence.plugins.confluence-business-blueprints:project-kickoff-blueprint'
};
var $eb1132679219975b$export$14416b8d99d47caa = /*#__PURE__*/ function(Template) {
    Template["ITProjectPoster"] = "it-project-poster";
    Template["SprintPlanning"] = "sprint-planning";
    Template["ProductRequirements"] = "product-requirements";
    Template["SoftwareArchitectureReview"] = "software-architecture-review";
    Template["HowToArticle"] = "how-to-article";
    Template["ArchitectureDiagram"] = "architecture-diagram";
    Template["IncidentCommunication"] = "incident-communication";
    Template["ExperimentPlanAndResults"] = "experiment-plan-and-results";
    Template["DailyStandUp"] = "daily-stand-up";
    Template["ProjectPlan"] = "project-plan";
    Template["StrategicPlan"] = "strategic-plan";
    Template["ProductRoadmap"] = "product-roadmap";
    Template["BlankPage"] = "blank-page";
    Template["WorkingAgreements"] = "working-agreements";
    Template["TeamPoster"] = "team-poster";
    Template["RolesAndResponsibilities"] = "roles-and-responsibilities";
    Template["StakeholderCommunications"] = "stakeholder-communications";
    Template["EndOfWeekStatusReport"] = "end-of-week-status-report";
    Template["MarketingCampaign"] = "marketing-campaign";
    Template["MarketingPlan"] = "marketing-plan";
    Template["Brainstorming"] = "brainstorming";
    Template["SWOTAnalysis"] = "swot-analysis";
    Template["CompetitiveAnalysis"] = "competitive-analysis";
    Template["MeetingNotes"] = "meeting-notes";
    Template["DACI"] = "daci";
    Template["CustomerJourneyMapping"] = "customer-journey-mapping";
    Template["ToDoList"] = "to-do-list";
    Template["Retrospective"] = "retrospective";
    Template["DevOpsRunbook"] = "dev-ops-runbook";
    Template["ITSMKnownErrors"] = "itsm-known-errors";
    Template["BusinessStatusUpdate"] = "business-status-update";
    Template["WorkshopPlanner"] = "workshop-planner";
    Template["DesignSystems"] = "design-systems";
    Template["DesignReview"] = "design-review";
    Template["BusinessPlanOnePager"] = "business-plan-one-pager";
    Template["RiskAssessmentMatrix"] = "risk-assessment-matrix";
    Template["VendorAgreement"] = "vendor-agreement";
    Template["VisionToValues"] = "vision-to-values";
    Template["CareerDevelopmentPlan"] = "career-development-plan";
    Template["HRKnowledgeBaseManagement"] = "hr-knowledge-base-management";
    Template["SalesAccountPlanning"] = "sales-account-planning";
    Template["SalesPortal"] = "sales-portal";
    Template["SMARTGoals"] = "smart-goals";
    Template["ProjectStatus"] = "project-status";
    Template["ITSMChangeManagement"] = "itsm-change-management";
    Template["ITSMPostIncidentReviews"] = "itsm-post-incident-reviews";
    Template["ITSMRunbook"] = "itsm-runbook";
    Template["TroubleshootingArticle"] = "troubleshooting-article";
    Template["MVPIdeation"] = "mvp-ideation";
    Template["DesignSprint"] = "design-sprint";
    Template["ElevatorPitch"] = "elevator-pitch";
    Template["MutualActionPlan"] = "mutual-action-plan";
    Template["ExecutiveBusinessReview"] = "executive-business-review";
    Template["FiveWhysAnalysis"] = "five-whys-analysis";
    Template["OKRs"] = "okrs";
    Template["EmployeeHandbook"] = "employee-handbook";
    Template["HiringProcess"] = "hiring-process";
    Template["CustomerImpactAssessment"] = "customer-impact-assessment";
    Template["LennysProductRequirements"] = "lennys-product-requirements";
    Template["ContentStrategy"] = "content-strategy";
    Template["DesignDecision"] = "design-decision";
    Template["Persona"] = "persona";
    Template["MessageHouse"] = "message-house";
    Template["AnnualPlanOnePager"] = "annual-plan-one-pager";
    Template["AllHandsMeeting"] = "all-hands-meeting";
    Template["CustomerInterviewReport"] = "customer-interview-report";
    Template["PresenterMode"] = "presenter-mode";
    Template["QtcAcquisition"] = "qtc-acquisition";
    Template["JobDescription"] = "job-description";
    Template["NinetyDayPlan"] = "ninety-day-plan";
    Template["LennysPerformanceReview"] = "lennys-performance-review";
    Template["ProjectKickoff"] = "project-kickoff";
    return Template;
}({});
var $eb1132679219975b$export$a6ffeca29f180ace = /*#__PURE__*/ function(WhiteboardTemplate) {
    WhiteboardTemplate["Brainwriting"] = "brainwriting";
    // Name: Brainwriting
    WhiteboardTemplate["Flowchart"] = "flow-chart";
    // Name: Flowchart
    WhiteboardTemplate["FourlsRetro"] = "4ls-retro";
    // Name: 4 Ls Retro
    WhiteboardTemplate["PrioritizationMatrix"] = "prioritization";
    // Name: Prioritization matrix
    WhiteboardTemplate["ProductRoadmap"] = "product-roadmap";
    // Name: Product roadmap
    WhiteboardTemplate["SimpleRetrospective"] = "simple-retrospective";
    // Name: Simple retrospective
    WhiteboardTemplate["SwimlanesProcessMap"] = "swimlanes";
    return WhiteboardTemplate;
}({});
var $eb1132679219975b$export$8b6f874ad242ca1b = /*#__PURE__*/ function(KnowledgeHubTemplate) {
    KnowledgeHubTemplate["FAQ"] = "faq";
    KnowledgeHubTemplate["Team"] = "team";
    KnowledgeHubTemplate["Project"] = "project";
    return KnowledgeHubTemplate;
}({});
var $eb1132679219975b$export$32da9fe1f998b96c = /*#__PURE__*/ function(ContentKeys) {
    ContentKeys["BRAINSTORMING"] = "BRAINSTORMING";
    // 'com.atlassian.confluence.plugins.confluence-business-blueprints:brainstorming-with-remote-teams-page'
    ContentKeys["REQUIREMENTS_DOC"] = "REQUIREMENTS_DOC";
    // 'com.atlassian.confluence.plugins.confluence-software-blueprints:requirements-blueprint'
    ContentKeys["TASK_TRACKING"] = "TASK_TRACKING";
    // 'com.atlassian.confluence.plugins.confluence-space-blueprints:task-tracker-template'
    ContentKeys["FLOWCHART_AND_DIAGRAMS"] = "FLOWCHART_AND_DIAGRAMS";
    // 'whiteboard:flow-chart'
    ContentKeys["MEETING_NOTES"] = "MEETING_NOTES";
    // 'com.atlassian.confluence.plugins.confluence-business-blueprints:meeting-notes-page'
    ContentKeys["KNOWLEDGE_HUB"] = "KNOWLEDGE_HUB";
    // 'com.atlassian.confluence.plugins.confluence-knowledge-base:kb-blueprint'
    ContentKeys["PROJECT_PLAN"] = "PROJECT_PLAN";
    // 'com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-page'
    ContentKeys["GANTT_CHART"] = "GANTT_CHART";
    // 'whiteboard:product-roadmap'
    ContentKeys["CREATIVE_BREIFS"] = "CREATIVE_BRIEFS";
    // 'com.atlassian.confluence.plugins.confluence-business-blueprints:creative-brief-blueprint'
    ContentKeys["CUSTOMER_JOURNEYS"] = "CUSTOMER_JOURNEYS";
    // 'com.atlassian.confluence.plugins.confluence-business-blueprints:customer-journey-mapping-blueprint'
    ContentKeys["CAMPAIGN_PLANNING"] = "CAMPAIGN_PLANNING";
    // 'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-campaign-content'
    ContentKeys["PROCESS_MAPPING"] = "PROCESS_MAPPING";
    // 'whiteboard:swimlanes'
    ContentKeys["TEAM_STATUS_UPDATE"] = "TEAM_STATUS_UPDATE";
    return ContentKeys;
}({});
var $eb1132679219975b$export$64e2ed2cf579d2ef = /*#__PURE__*/ function(AccountSetupScreens) {
    AccountSetupScreens["TEAM"] = "onboarding-account-setup-modal.teamScreen";
    AccountSetupScreens["TEAM_NO_SKIP"] = "onboarding-account-setup-modal.teamScreen.branding";
    AccountSetupScreens["JTBD"] = "onboarding-account-setup-modal.jtbdScreen";
    AccountSetupScreens["JTBD_MODERN_BRANDING"] = "onboarding-account-setup-modal.jtbdScreen.branding";
    AccountSetupScreens["LOADING"] = "onboarding-account-setup-modal.loadingScreen";
    AccountSetupScreens["LOADING_MODERN_BRANDING"] = "onboarding-account-setup-modal.loadingScreen.branding";
    AccountSetupScreens["TEMPLATE"] = "onboarding-account-setup-modal.templateScreen";
    AccountSetupScreens["TEMPLATE_MODERN_BRANDING"] = "onboarding-account-setup-modal.templateScreen.branding";
    AccountSetupScreens["INVITE"] = "onboarding-account-setup-modal.inviteScreen";
    AccountSetupScreens["INVITE_MODERN_BRANDING"] = "onboarding-account-setup-modal.inviteScreen.branding";
    AccountSetupScreens["CONTENTTYPE"] = "onboarding-account-setup-modal.contentTypeScreen";
    // founding admin
    AccountSetupScreens["NTH_USER_CONTENT_TYPE"] = "onboarding-account-setup-modal.nthUserContentTypeScreen";
    // nth user
    AccountSetupScreens["SPACESTOFOLLOW"] = "onboarding-account-setup-modal.spacesToFollowScreen";
    AccountSetupScreens["EDITION"] = "onboarding-account-setup-modal.editionCommunicationScreen";
    AccountSetupScreens["AUTOPROVISIONING_EDITION"] = "onboarding-account-setup-modal.autoprovisioningEditionScreen";
    AccountSetupScreens["JTBD_CONTENT"] = "onboarding-account-setup-modal.jtbdContentScreen";
    AccountSetupScreens["USE_CASES"] = "onboarding-account-setup-modal.useCasesScreen";
    AccountSetupScreens["TEAMMATE_CONTENT"] = "onboarding-account-setup-modal.teammateContentScreen";
    AccountSetupScreens["AIFC_CONTENT_TEAM_TYPE"] = "onboarding-account-setup-modal.aifcContentTeamTypeScreen";
    AccountSetupScreens["AIFC_TEAM_TYPE_V2"] = "onboarding-account-setup-modal.aifcTeamTypeV2Screen";
    AccountSetupScreens["AIFC_CONTENT_TYPE_V2"] = "onboarding-account-setup-modal.aifcContentTypeV2Screen";
    AccountSetupScreens["GFC_CONTENT_TEAM_TYPE"] = "onboarding-account-setup-modal.gfcContentTeamTypeScreen";
    AccountSetupScreens["AIFC_ONBOARDING_INPUT"] = "onboarding-account-setup-modal.aifcOnboardingInputScreen";
    AccountSetupScreens["GFC_TEMPLATE_ROVO_CREATE"] = "onboarding-account-setup-modal.gfcTemplateScreen";
    AccountSetupScreens["RECOMMENDED_SPACES"] = "onboarding-account-setup-modal.recommendedSpacesScreen";
    AccountSetupScreens["MULTI_APP_INLINE_CONNECTION"] = "onboarding-account-setup-modal.multiAppInlineConnectionScreen";
    AccountSetupScreens["SINGLE_APP_INLINE_CONNECTION"] = "onboarding-account-setup-modal.singleAppInlineConnectionScreen";
    AccountSetupScreens["CWR_NTH_USER_ONBOARDING"] = "onboarding-account-setup-modal.cwrNthUserOnboardingScreen";
    AccountSetupScreens["CHOOSE_YOUR_PATH"] = "onboarding-account-setup-modal.chooseYourPathScreen";
    AccountSetupScreens["INVITE_XFLOW_TEAM"] = "onboarding-account-setup-modal.inviteScreen.xflowTeam";
    return AccountSetupScreens;
}({});
var $eb1132679219975b$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["PAGE"] = "page";
    ContentType["LIVE_DOC"] = "live-doc";
    ContentType["WHITEBOARD"] = "whiteboard";
    ContentType["DATABASE"] = "database";
    ContentType["KNOWLEDGE_HUB"] = "knowledge-hub";
    return ContentType;
}({});
var $eb1132679219975b$export$6435071f58aaae6a = /*#__PURE__*/ function(NthUserContentType) {
    NthUserContentType["PAGE"] = "page";
    NthUserContentType["WHITEBOARD"] = "whiteboard";
    NthUserContentType["LIVE_DOC"] = "live-doc";
    NthUserContentType["DATABASE"] = "database";
    return NthUserContentType;
}({});
var $eb1132679219975b$export$3a8c8363200890be = /*#__PURE__*/ function(RecommendationType) {
    RecommendationType["POPULAR"] = "popular";
    RecommendationType["TEAM_SPACE"] = "teammates";
    return RecommendationType;
}({});
var $eb1132679219975b$export$68577d543b14ae02 = /*#__PURE__*/ function(ConfluenceEdition) {
    ConfluenceEdition["FREE"] = "FREE";
    ConfluenceEdition["PREMIUM"] = "PREMIUM";
    ConfluenceEdition["STANDARD"] = "STANDARD";
    return ConfluenceEdition;
}({});
module.exports["Team"] = $eb1132679219975b$export$3e5d0af8e738b082;
module.exports["TEAM_ID_MAP"] = $eb1132679219975b$export$77134aba51f821f8;
module.exports["FocusArea"] = $eb1132679219975b$export$a0b0994d6b76cdaa;
module.exports["TemplateBlueprintModuleCompleteKey"] = $eb1132679219975b$export$8764a1262502aaf9;
module.exports["Template"] = $eb1132679219975b$export$14416b8d99d47caa;
module.exports["WhiteboardTemplate"] = $eb1132679219975b$export$a6ffeca29f180ace;
module.exports["KnowledgeHubTemplate"] = $eb1132679219975b$export$8b6f874ad242ca1b;
module.exports["AccountSetupScreens"] = $eb1132679219975b$export$64e2ed2cf579d2ef;
module.exports["ContentType"] = $eb1132679219975b$export$e2e108cbe2e4f865;
module.exports["NthUserContentType"] = $eb1132679219975b$export$6435071f58aaae6a;
module.exports["RecommendationType"] = $eb1132679219975b$export$3a8c8363200890be;
module.exports["ConfluenceEdition"] = $eb1132679219975b$export$68577d543b14ae02;

});

parcelRegister("ivb8S", function(module, exports) {

var $209pV = parcelRequire("209pV");


var $e6fvz = parcelRequire("e6fvz");


var $cozmU = parcelRequire("cozmU");


var $7Sm4c = parcelRequire("7Sm4c");


var $8Lx5S = parcelRequire("8Lx5S");


var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");


var $ij4CE = parcelRequire("ij4CE");


var $cbOce = parcelRequire("cbOce");


var $8Z78B = parcelRequire("8Z78B");

const $6fc4b7bb962289cc$export$75d6c00965e77c = (0, $e6fvz.default);
const $6fc4b7bb962289cc$export$7ca8667598519375 = (data)=>{
    const state = {};
    // new graphQL call returns onboardingState array
    const { onboardingState: onboardingState } = data || {};
    // parse data and populate state accordingly
    if (onboardingState !== undefined && onboardingState !== null) for (const { key: key, value: value } of onboardingState){
        // key comes back as "{prefix}:{property}" format
        // split by ':' to get parsed {property}
        // some keys don't have a prefix, which is why we have the ||
        const parsedKey = key.split(':')[1] || key;
        if (!value) continue;
        if (/(true|false)/g.test(value)) state[parsedKey] = value === 'true';
        else state[parsedKey] = value;
    }
    return state;
};
const $6fc4b7bb962289cc$export$c5bcaee8a4aee6cf = ()=>{
    const [setState, { error: error, called: called }] = (0, $308Wd.useMutationInterop)((0, $209pV.default), {
        update (_cache, { data: data }) {
            const states = data.setOnboardingState;
            (states ?? []).forEach(({ key: key, value: value })=>{
                // writeFragment can only handle a single data item at a time
                (0, $ij4CE.writeFragmentInterop)({
                    fragmentId: `OnboardingState:${key}`,
                    data: {
                        key: key,
                        value: value ?? null,
                        __typename: 'OnboardingState'
                    },
                    __callerPackage__: "onboarding-helpers"
                });
            });
        },
        onError: (error)=>{
            if ((0, $cbOce.isExpectedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        },
        __callerPackage__: "onboarding-helpers"
    });
    const setOnboardingState = (0, $cozmU.useCallback)((newOnboardingState)=>{
        let states;
        if (Array.isArray(newOnboardingState)) // supports batch updates
        states = newOnboardingState;
        else // backwards compability for single key-value pair
        states = [
            newOnboardingState
        ];
        setState({
            variables: {
                states: states
            },
            optimisticResponse: {
                setOnboardingState: states.map(({ key: key, value: value })=>({
                        key: key,
                        value: value,
                        __typename: 'OnboardingState'
                    }))
            }
        });
    }, [
        setState
    ]);
    return {
        setOnboardingState: setOnboardingState,
        error: error,
        called: called
    };
};
// safeguards against empty arrays or strings
const $6fc4b7bb962289cc$var$hasValidKeysToFetch = (key)=>{
    if (Array.isArray(key)) return key.length > 0;
    if (typeof key === 'string') return key.length > 0;
    return false;
};
const $6fc4b7bb962289cc$export$d5e7611ac338ec84 = (key, skip = false)=>{
    const { isLicensed: isLicensed, isGuest: isGuest } = (0, $8Lx5S.useAccessStatus)();
    const isAllowed = isLicensed || isGuest;
    const hasKeysToFetch = $6fc4b7bb962289cc$var$hasValidKeysToFetch(key);
    const skipQuery = skip || !isAllowed || !hasKeysToFetch;
    const { data: data, error: error, loading: loading, refetch: refetch } = (0, $jMyy4.useQueryInterop)((0, $8Z78B.default), {
        variables: {
            key: key
        },
        skip: skipQuery,
        __callerPackage__: "onboarding-helpers"
    });
    return {
        data: data,
        error: error,
        loading: loading,
        refetch: refetch
    };
};
module.exports["deserializeState"] = $6fc4b7bb962289cc$export$7ca8667598519375;
module.exports["useSetOnboardingState"] = $6fc4b7bb962289cc$export$c5bcaee8a4aee6cf;
module.exports["useGetOnboardingState"] = $6fc4b7bb962289cc$export$d5e7611ac338ec84;

});

parcelRegister("209pV", function(module, exports) {
/**
 * @generated SignedSource<<a83598c413cebc1d8cb2388f4b0ca41c>>
 * @relayHash 3faa5f50f8c511a1bae008881ee58062
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1c2e262362f2b7a2909940b7e6956cbd2cb7f92d9a44abb1caff1c81d7518bed
const $4f605ad876f6c5d9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "states"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "states",
                    "variableName": "states"
                }
            ],
            "concreteType": "OnboardingState",
            "kind": "LinkedField",
            "name": "setOnboardingState",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "onboardingStateSetOnboardingStateMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "onboardingStateSetOnboardingStateMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3faa5f50f8c511a1bae008881ee58062",
            "id": "1c2e262362f2b7a2909940b7e6956cbd2cb7f92d9a44abb1caff1c81d7518bed",
            "metadata": {},
            "name": "onboardingStateSetOnboardingStateMutation",
            "operationKind": "mutation",
            "text": "mutation onboardingStateSetOnboardingStateMutation($states:[OnboardingStateInput!]!){setOnboardingState(states:$states){key,value}}"
        }
    };
}();
$4f605ad876f6c5d9$var$node.hash = "90b0af82da00eefb44f28228419e7c9e";
var $4f605ad876f6c5d9$export$2e2bcd8739ae039 = $4f605ad876f6c5d9$var$node;
module.exports["default"] = $4f605ad876f6c5d9$export$2e2bcd8739ae039;

});

parcelRegister("e6fvz", function(module, exports) {
/**
 * @generated SignedSource<<0c17cade527e0c98b3a6d07d61bdb0ec>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6eba286460e57a30$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "onboardingState_state",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ],
    "type": "OnboardingState"
};
$6eba286460e57a30$var$node.hash = "4458ec6e78736741d79615a29b68de83";
var $6eba286460e57a30$export$2e2bcd8739ae039 = $6eba286460e57a30$var$node;
module.exports["default"] = $6eba286460e57a30$export$2e2bcd8739ae039;

});

parcelRegister("8Lx5S", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

/**
 * Checks if the user has any licensed access (either admin or use access).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed admin or use access, otherwise false.
 */ const $30f02aa82d7102bc$var$isLicensed = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
};
/**
 * Checks if the user has licensed admin access.
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed admin access, otherwise false.
 */ const $30f02aa82d7102bc$var$isAdmin = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
};
/**
 * Checks if the user has licensed non-admin access (use access).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed use access, otherwise false.
 */ const $30f02aa82d7102bc$var$isLicensedNonAdmin = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
};
/**
 * Checks if the user is a guest (external collaborator).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user is an external collaborator, otherwise false.
 */ const $30f02aa82d7102bc$var$isGuest = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
};
const $30f02aa82d7102bc$export$ac4f65b11c57a33b = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isLicensed(accessStatus);
};
const $30f02aa82d7102bc$export$99a5e4bc80d231ca = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isAdmin(accessStatus);
};
const $30f02aa82d7102bc$export$a67466804611d2db = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isLicensedNonAdmin(accessStatus);
};
const $30f02aa82d7102bc$export$f9ffae90e66d63e = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isGuest(accessStatus);
};
const $30f02aa82d7102bc$export$41f8700aabec6a40 = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isGuest: $30f02aa82d7102bc$var$isGuest(accessStatus),
        isLicensed: $30f02aa82d7102bc$var$isLicensed(accessStatus),
        isAdmin: $30f02aa82d7102bc$var$isAdmin(accessStatus),
        isLicensedNonAdmin: $30f02aa82d7102bc$var$isLicensedNonAdmin(accessStatus)
    };
};
module.exports["useIsLicensed"] = $30f02aa82d7102bc$export$ac4f65b11c57a33b;
module.exports["useIsAdmin"] = $30f02aa82d7102bc$export$99a5e4bc80d231ca;
module.exports["useIsGuest"] = $30f02aa82d7102bc$export$f9ffae90e66d63e;
module.exports["useAccessStatus"] = $30f02aa82d7102bc$export$41f8700aabec6a40;

});

parcelRegister("d9tcB", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $adbc8f20ade62008$export$9d38595f26d62a61 = /*#__PURE__*/ function(AccessStatus) {
    AccessStatus["ANONYMOUS_ACCESS"] = "ANONYMOUS_ACCESS";
    AccessStatus["EXTERNAL_COLLABORATOR_ACCESS"] = "EXTERNAL_COLLABORATOR_ACCESS";
    AccessStatus["EXTERNAL_SHARE_ACCESS"] = "EXTERNAL_SHARE_ACCESS";
    AccessStatus["LICENSED_ADMIN_ACCESS"] = "LICENSED_ADMIN_ACCESS";
    AccessStatus["LICENSED_USE_ACCESS"] = "LICENSED_USE_ACCESS";
    AccessStatus["NOT_PERMITTED"] = "NOT_PERMITTED";
    AccessStatus["UNLICENSED_AUTHENTICATED_ACCESS"] = "UNLICENSED_AUTHENTICATED_ACCESS";
    return AccessStatus;
}({});
var $adbc8f20ade62008$export$68577d543b14ae02 = /*#__PURE__*/ function(ConfluenceEdition) {
    ConfluenceEdition["FREE"] = "FREE";
    ConfluenceEdition["PREMIUM"] = "PREMIUM";
    ConfluenceEdition["STANDARD"] = "STANDARD";
    return ConfluenceEdition;
}({});
var $adbc8f20ade62008$export$7dc6752a22ab011a = /*#__PURE__*/ function(Environment) {
    Environment["DEVELOPMENT"] = "DEVELOPMENT";
    Environment["PRODUCTION"] = "PRODUCTION";
    Environment["STAGING"] = "STAGING";
    return Environment;
}({});
module.exports["AccessStatus"] = $adbc8f20ade62008$export$9d38595f26d62a61;
module.exports["ConfluenceEdition"] = $adbc8f20ade62008$export$68577d543b14ae02;

});

parcelRegister("cbOce", function(module, exports) {

var $6fil2 = parcelRequire("6fil2");


var $1uFM6 = parcelRequire("1uFM6");

function $2f49c1e50cca9335$export$8715824c16ceeca0(error) {
    const isUnauthorized = error?.graphQLErrors?.[0]?.message === 'unauthorized' || (0, $1uFM6.isUnauthorizedError)(error);
    return isUnauthorized || (0, $6fil2.containsNetworkError)(error);
}
module.exports["isExpectedError"] = $2f49c1e50cca9335$export$8715824c16ceeca0;

});

parcelRegister("8Z78B", function(module, exports) {
/**
 * @generated SignedSource<<abe1bfe242e74d4385961078bad185f8>>
 * @relayHash 56e1784a86c45537dbf4ab9c8bb1ffba
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3ede45193d2890af963c0f976a0d18fc9abdbe45ed83b2480c2ca3bfd8e0f7d7
const $38160060fa19c5ea$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "key"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "key"
                }
            ],
            "concreteType": "OnboardingState",
            "kind": "LinkedField",
            "name": "onboardingState",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "onboardingStateGetOnboardingStateQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "onboardingStateGetOnboardingStateQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "56e1784a86c45537dbf4ab9c8bb1ffba",
            "id": "3ede45193d2890af963c0f976a0d18fc9abdbe45ed83b2480c2ca3bfd8e0f7d7",
            "metadata": {},
            "name": "onboardingStateGetOnboardingStateQuery",
            "operationKind": "query",
            "text": "query onboardingStateGetOnboardingStateQuery($key:[String]){onboardingState(key:$key){key,value}}"
        }
    };
}();
$38160060fa19c5ea$var$node.hash = "201bff99b2bdca3d23c658876502ced3";
var $38160060fa19c5ea$export$2e2bcd8739ae039 = $38160060fa19c5ea$var$node;
module.exports["default"] = $38160060fa19c5ea$export$2e2bcd8739ae039;

});

parcelRegister("dBcar", function(module, exports) {

var $5AFnD = parcelRequire("5AFnD");

const $3c94963df51c0e13$export$4ddca8f5712d2331 = 'onboarding-state:';
const $3c94963df51c0e13$export$f35f2899eb1390e3 = 'peopleNudge';
const $3c94963df51c0e13$export$532485ca1547f1aa = 'legacy';
const $3c94963df51c0e13$export$31c8494ea74d2536 = 'introWorkflow';
const $3c94963df51c0e13$export$1f72e9a162b3795b = 'firstSpaceSelected';
const $3c94963df51c0e13$export$6315bee451a9fcc6 = 'teamSpaceCreated';
const $3c94963df51c0e13$export$c4e14780cf349e73 = 'xflowSpaceCreated';
const $3c94963df51c0e13$export$275d3dda87d2fa7a = 'nthUserOnboardingCompletedTimestamp';
const $3c94963df51c0e13$export$da223e550b96c9d6 = 'help';
const $3c94963df51c0e13$export$ffb6b379ff35f9e = 'onboardingIntents';
const $3c94963df51c0e13$export$d3276a0d758ffd2b = 'isFoundingAdmin';
const $3c94963df51c0e13$export$756b1a5a6b2488c3 = 'isSampleContentV2SpotlightVisible';
const $3c94963df51c0e13$export$8e5a8e09b19b20a8 = 'isMoreActionsTourVisible';
const $3c94963df51c0e13$export$2e10b71f921ae144 = 'isMoreActionsHintVisible';
const $3c94963df51c0e13$export$82fe49566957c443 = 'landOnPath';
const $3c94963df51c0e13$export$f6c79e39ab4496db = 'templateOnboardingViewedTime';
const $3c94963df51c0e13$export$49ac0bbeb4be0a06 = {
    ONBOARDING_INTENT_EXPERIENCES_CLOSED: 'onboarding-intent-experiences:onboardingIntentExperienceClosed',
    ONBOARDING_EXPERIENCE_ELIGIBLE: 'onboarding-intent-experience:isOnboardingExperienceEligibleUser',
    ONBOARDING_INTENT_EXPERIENCES_LAND_NEW_HOME_VIEWED_AT: 'onboarding-intent-experiences:onboardingIntentExperienceLandViewedAt',
    ONBOARDING_INTENT_EXPERIENCES_LAND_NEW_HOME_CLOSED: 'onboarding-intent-experiences:onboardingIntentExperienceLandClosed'
};
const $3c94963df51c0e13$export$6167e5b70dfd11d9 = {
    MODAL_SEEN: 'onboarding-reverse-trial:isModalSeen'
};
const $3c94963df51c0e13$export$49c044e5e3ccc2af = {
    EXPERIMENT_ELIGIBLE: 'templates-collection:isTaggedForTemplatesCollectionExperiment',
    EXPERIMENT_DISMISSED: 'templates-collection:isTemplatesSectionDismissed'
};
const $3c94963df51c0e13$export$dcbccfe8799c3c7b = {
    IS_DISMISSED: 'space-getting-started-tour:tourIsDismissed'
};
const $3c94963df51c0e13$export$305c55ea55928edf = {
    HAS_INVITE_CAPABILITIES: 'persistent-invite:hasInviteCapabilities'
};
const $3c94963df51c0e13$export$8b7e53c326da02ac = 'improvedGetStartedPath';
const $3c94963df51c0e13$export$cfc1794f56ac0d83 = 'improvedGetStartedWhiteboardPath';
const $3c94963df51c0e13$export$39a89660e80fa1a = 'isRedactionsTourVisible';
const $3c94963df51c0e13$export$b99b309b286adebc = 'nav4:isNav4GlobalSpotlightDismissed';
const $3c94963df51c0e13$export$20b0548cf5859d6 = 'nav4:isNav4SpaceTourDismissed';
const $3c94963df51c0e13$export$4d93dfc1d8538d55 = 'nav4:isNav4CollapseReminderSpotlightDismissed';
const $3c94963df51c0e13$export$94a4264abda026cc = 'creation-focused-nav:shouldShowSpotlight';
const $3c94963df51c0e13$export$f0597adb063e4c38 = 'creation-focused-nav:startTime';
const $3c94963df51c0e13$export$7ed75560092630f6 = {
    IS_SPOTLIGHT_DISMISS: 'whats-new-in-confluence:isWhatsNewInConfluneceSpotlightDismissed',
    PULSE_SEEN_AT: 'whats-new-in-confluence:whatsNewInConfluencePulseSeenAt'
};
const $3c94963df51c0e13$export$6c014427ebb0cbae = {
    HAS_SEEN_SPLASH_MODAL: 'create-with-rovo-announcement-splash:hasSeenSplashModal'
};
const $3c94963df51c0e13$export$ebacd4ef7f5400e2 = {
    CHAT_AUTO_OPENED: 'welcome-from-rovo:chatAutoOpened'
};
const $3c94963df51c0e13$export$d1ec748fb682ca97 = {
    NTH_USER_SELECTED_CONTENT_TYPE: 'nth-user-setup:nthUserSelectedContentType',
    NTH_USER_CONTENT_TYPE_SPOTLIGHT_SEEN: 'nth-user-setup:nthUserContentTypeSpotlightSeen',
    NTH_USER_CONTENT_TYPE_POPULAR_CONTENT_FOUND: 'nth-user-setup:nthUserContentTypePopularContentFound',
    NTH_USER_CONTENT_TYPE_LANDING_CONTENT_ID: 'nth-user-setup:nthUserContentTypeLandingContentId'
};
const $3c94963df51c0e13$export$1a3a43cef0acd011 = {
    PROMPT_DISMISSED: 'prompt-whiteboard-competitor-link:isPromptDismissed'
};
const $3c94963df51c0e13$export$5b471e2344a37be7 = {
    DISMISSED: 'prompt-database-competitor-link:isPromptDatabaseDismissed'
};
const $3c94963df51c0e13$export$c81223a0ce3b63df = {
    HAS_AUTO_FOLLOWED_SPACES: 'nth-user-auto-follow-spaces:hasAutoFollowedSpaces'
};
const $3c94963df51c0e13$export$f1328b04dc902e1f = {
    REVAMPED_BPQA_SHOWN_AT: 'land-users-in-editor-with-revamped-bpqa:revampedBpqaShownAt'
};
const $3c94963df51c0e13$export$e986b94fd54d134 = {
    SELECTED_TEMPLATES: 'use-cases-nth-user-onboarding:selectedTemplates',
    VIEWED_AT: 'use-cases-nth-user-onboarding:viewedAt',
    DISMISSED_HEADER: 'use-cases-nth-user-onboarding:headerDismissed',
    VIEWED_HEADER: 'use-cases-nth-user-onboarding:headerViewedAt'
};
const $3c94963df51c0e13$export$bbdc3607431bd9d3 = {
    EMOJI_TITLE_DISCOVERED: 'auto-page-emoji:emojiTitleDiscovered'
};
const $3c94963df51c0e13$export$94df39cf9e5d9804 = {
    TRENDING_PAGES: 'cross-join-nth-user-onboarding:trendingPages',
    DISMISSED: 'cross-join-nth-user-onboarding:dismissed'
};
const $3c94963df51c0e13$export$bfeb2da96277b623 = {
    INTRO_WORKFLOW: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$31c8494ea74d2536}`,
    LEGACY_ONBOARDING_STATE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$532485ca1547f1aa}`,
    IS_FOUNDING_ADMIN: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$d3276a0d758ffd2b}`,
    IS_SAMPLE_CONTENT_V2_SPOTLIGHT_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$756b1a5a6b2488c3}`,
    LAND_ON_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$82fe49566957c443}`,
    TEAM_SPACE_CREATED: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$6315bee451a9fcc6}`,
    IS_MORE_ACTIONS_TOUR_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$8e5a8e09b19b20a8}`,
    IS_MORE_ACTIONS_HINT_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$2e10b71f921ae144}`,
    IMPROVED_GET_STARTED_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$8b7e53c326da02ac}`,
    IMPROVED_GET_STARTED_WHITEBOARD_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$cfc1794f56ac0d83}`,
    IS_REDACTIONS_TOUR_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$39a89660e80fa1a}`,
    XFLOW_SPACE_CREATED: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$c4e14780cf349e73}`,
    TEMPLATE_ONBOARDING_VIEWED_TIME: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$f6c79e39ab4496db}`,
    NTH_USER_ONBOARDING_COMPLETED_TIMESTAMP: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$275d3dda87d2fa7a}`
};
const $3c94963df51c0e13$export$1660a2d7c2fff354 = '__complete__';
const $3c94963df51c0e13$export$66aa87593037fd4a = $3c94963df51c0e13$export$bfeb2da96277b623.LEGACY_ONBOARDING_STATE;
const $3c94963df51c0e13$export$d4f5dd2b883b8982 = [
    $3c94963df51c0e13$export$94a4264abda026cc,
    $3c94963df51c0e13$export$f0597adb063e4c38
];
const $3c94963df51c0e13$export$7a13c575f2c75084 = [
    ...Object.values($3c94963df51c0e13$export$49ac0bbeb4be0a06),
    ...Object.values($3c94963df51c0e13$export$6167e5b70dfd11d9),
    ...Object.values($3c94963df51c0e13$export$49c044e5e3ccc2af),
    ...Object.values($3c94963df51c0e13$export$dcbccfe8799c3c7b),
    ...Object.values($3c94963df51c0e13$export$305c55ea55928edf),
    $3c94963df51c0e13$export$b99b309b286adebc,
    $3c94963df51c0e13$export$20b0548cf5859d6,
    $3c94963df51c0e13$export$4d93dfc1d8538d55,
    $3c94963df51c0e13$export$94a4264abda026cc,
    $3c94963df51c0e13$export$f0597adb063e4c38,
    ...Object.values($3c94963df51c0e13$export$7ed75560092630f6),
    ...Object.values($3c94963df51c0e13$export$6c014427ebb0cbae),
    ...Object.values($3c94963df51c0e13$export$ebacd4ef7f5400e2),
    ...Object.values($3c94963df51c0e13$export$d1ec748fb682ca97),
    ...Object.values($3c94963df51c0e13$export$1a3a43cef0acd011),
    ...Object.values($3c94963df51c0e13$export$5b471e2344a37be7),
    ...Object.values($3c94963df51c0e13$export$bfeb2da96277b623),
    ...Object.values($3c94963df51c0e13$export$c81223a0ce3b63df),
    ...Object.values($3c94963df51c0e13$export$f1328b04dc902e1f),
    ...Object.values($3c94963df51c0e13$export$e986b94fd54d134),
    ...Object.values($3c94963df51c0e13$export$bbdc3607431bd9d3),
    ...Object.values($3c94963df51c0e13$export$94df39cf9e5d9804),
    (0, $5AFnD.LOOM_NUDGE_REMIND_ME),
    (0, $5AFnD.LOOM_NUDGE_LAST_SHOWN_AT)
];
module.exports["ONBOARDING_INTENT_EXPERIENCES"] = $3c94963df51c0e13$export$49ac0bbeb4be0a06;
module.exports["TEMPLATES_COLLECTION"] = $3c94963df51c0e13$export$49c044e5e3ccc2af;
module.exports["PERSISTENT_INVITE"] = $3c94963df51c0e13$export$305c55ea55928edf;
module.exports["IS_NAV_4_COLLAPSE_REMINDER_SPOTLIGHT_DISMISSED"] = $3c94963df51c0e13$export$4d93dfc1d8538d55;
module.exports["CREATION_FOCUSED_NAV_SHOULD_SHOW_SPOTLIGHT"] = $3c94963df51c0e13$export$94a4264abda026cc;
module.exports["CREATION_FOCUSED_NAV_START_TIME"] = $3c94963df51c0e13$export$f0597adb063e4c38;
module.exports["CREATE_WITH_ROVO_ANNOUNCEMENT_SPLASH"] = $3c94963df51c0e13$export$6c014427ebb0cbae;
module.exports["WELCOME_FROM_ROVO_CHAT"] = $3c94963df51c0e13$export$ebacd4ef7f5400e2;
module.exports["NTH_USER_SETUP_CONTENT_TYPE"] = $3c94963df51c0e13$export$d1ec748fb682ca97;
module.exports["PROMPT_WHITEBOARD_COMPETITOR_LINK_DISMISSED"] = $3c94963df51c0e13$export$1a3a43cef0acd011;
module.exports["NTH_USER_AUTO_FOLLOW_SPACES"] = $3c94963df51c0e13$export$c81223a0ce3b63df;
module.exports["LAND_USERS_IN_EDITOR_WITH_REVAMPED_BPQA"] = $3c94963df51c0e13$export$f1328b04dc902e1f;
module.exports["USE_CASES_NTH_USER_ONBOARDING"] = $3c94963df51c0e13$export$e986b94fd54d134;
module.exports["NTH_USER_EMOJI_TITLE_DISCOVERED"] = $3c94963df51c0e13$export$bbdc3607431bd9d3;
module.exports["CROSS_JOIN_NTH_USER_ONBOARDING"] = $3c94963df51c0e13$export$94df39cf9e5d9804;
module.exports["ONBOARDING_EXPERIENCES"] = $3c94963df51c0e13$export$bfeb2da96277b623;
module.exports["COMPLETE"] = $3c94963df51c0e13$export$1660a2d7c2fff354;
module.exports["NAV_EXPERIMENT_ONBOARDING_KEYS"] = $3c94963df51c0e13$export$d4f5dd2b883b8982;
module.exports["OnboardingKeys"] = $3c94963df51c0e13$export$7a13c575f2c75084;

});

parcelRegister("5AFnD", function(module, exports) {
const $00e2d16f0c5935d6$export$477408ab8b02b670 = 'twcg-2202-loom-nudge:remindMe';
const $00e2d16f0c5935d6$export$c98b33a7293cedf4 = 'twcg-2202-loom-nudge:lastShownAt';
module.exports["LOOM_NUDGE_REMIND_ME"] = $00e2d16f0c5935d6$export$477408ab8b02b670;
module.exports["LOOM_NUDGE_LAST_SHOWN_AT"] = $00e2d16f0c5935d6$export$c98b33a7293cedf4;

});

parcelRegister("lsxnT", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $i3jcY = parcelRequire("i3jcY");


var $cryCi = parcelRequire("cryCi");


var $3KdFR = parcelRequire("3KdFR");

const $be0f158b0b06806d$export$20bf42c8a29d776a = ()=>{
    const ctx = (0, $cozmU.useContext)((0, $cryCi.Context));
    if (!ctx) throw new Error('ChoreographerAssetsContext not found, did you include the correct Context provider?');
    const plugin = ctx?.plugin;
    const isDisplayed = Boolean(plugin?.state?.isDisplayingMessage);
    (0, $cozmU.useEffect)(()=>{
        window.__PO_ASSET_DISPLAYED__ = window.__PO_ASSET_DISPLAYED__ || isDisplayed;
    }, [
        isDisplayed
    ]);
    // Stubbed context monkey-patches the original context to prevent Choreographer components
    // from being rendered, to avoid random impact on performance and UI stability tests.
    // This is ONLY intended to use with E2E/playwright/Criterion tests loading Confluence
    // with `?stableUI=1` URL parameter.
    const stubbedContext = (0, $cozmU.useMemo)(()=>({
            ...ctx,
            ...(0, $3KdFR.choreographerContextStub)
        }), [
        ctx
    ]);
    return (0, $i3jcY.isStableUIEnabledForTests)() ? stubbedContext : ctx;
};
module.exports["useChoreographerAssets"] = $be0f158b0b06806d$export$20bf42c8a29d776a;

});

parcelRegister("3KdFR", function(module, exports) {
const $d24b02c281555a47$var$ChoreographerComponentStub = ()=>{
    return null;
};
const $d24b02c281555a47$var$withChoreographerStub = ()=>{
    return ()=>null;
};
const $d24b02c281555a47$export$62522e606ba73c28 = {
    AutoDismissFlag: $d24b02c281555a47$var$ChoreographerComponentStub,
    Banner: $d24b02c281555a47$var$ChoreographerComponentStub,
    ChoreographedComponent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Flag: $d24b02c281555a47$var$ChoreographerComponentStub,
    InlineDialog: $d24b02c281555a47$var$ChoreographerComponentStub,
    Modal: $d24b02c281555a47$var$ChoreographerComponentStub,
    PopoverContent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popper: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popup: $d24b02c281555a47$var$ChoreographerComponentStub,
    Spotlight: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightCard: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightTarget: $d24b02c281555a47$var$ChoreographerComponentStub,
    withChoreographedRender: $d24b02c281555a47$var$withChoreographerStub,
    withChoreographedToggle: $d24b02c281555a47$var$withChoreographerStub
};
module.exports["choreographerContextStub"] = $d24b02c281555a47$export$62522e606ba73c28;

});

parcelRegister("80koo", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cpjd2 = parcelRequire("cpjd2");

const $c65634971abef8c1$export$c2019f6d43c6c1ce = ({ wrm: wrm, children: children })=>{
    const [wrmLoadingState, setWrmLoadingState] = (0, $cozmU.useState)({
        loaded: false,
        modules: []
    });
    (0, $cozmU.useEffect)(()=>{
        (0, $cpjd2.requireLegacyWRM)(wrm, (modules)=>{
            setWrmLoadingState({
                loaded: true,
                modules: modules
            });
        }, ()=>{});
    }, [
        wrm
    ]);
    return wrmLoadingState.loaded && children ? children(wrmLoadingState.modules) : null;
};
module.exports["RequireLegacyWRM"] = $c65634971abef8c1$export$c2019f6d43c6c1ce;

});

parcelRegister("35oAA", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");

function $4fd34c1d209021f7$export$8ed94837713785c3() {
    const $ = (0, $bDgLe.c)(9);
    const { getQueryParams: getQueryParams, getHash: getHash } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    let t0;
    let versionOverride;
    if ($[0] !== getQueryParams) {
        const queryParams = getQueryParams();
        versionOverride = (0, $c3Qwv.getSingleParamInt)(queryParams, "versionOverride", null);
        t0 = (0, $c3Qwv.getSingleParam)(queryParams, "embeddedContentRender") || null;
        $[0] = getQueryParams;
        $[1] = t0;
        $[2] = versionOverride;
    } else {
        t0 = $[1];
        versionOverride = $[2];
    }
    const embeddedContentRender = t0;
    let t1;
    if ($[3] !== getHash) {
        t1 = getHash();
        $[3] = getHash;
        $[4] = t1;
    } else t1 = $[4];
    const queryHash = t1;
    let t2;
    if ($[5] !== embeddedContentRender || $[6] !== queryHash || $[7] !== versionOverride) {
        t2 = {
            versionOverride: versionOverride,
            embeddedContentRender: embeddedContentRender,
            queryHash: queryHash
        };
        $[5] = embeddedContentRender;
        $[6] = queryHash;
        $[7] = versionOverride;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
}
module.exports["useViewPageParams"] = $4fd34c1d209021f7$export$8ed94837713785c3;

});

parcelRegister("3d5UI", function(module, exports) {
function $28507a73a7688e48$var$isDefined(path) {
    return path.split('.').reduce((object, pathPart)=>{
        return object && object[pathPart] ? object[pathPart] : null;
    }, window);
}
const $28507a73a7688e48$var$lines = {};
function $28507a73a7688e48$var$logOnce(message) {}
function $28507a73a7688e48$export$d2adf65b87e47523() {
    for(const key in $28507a73a7688e48$var$lines)delete $28507a73a7688e48$var$lines[key];
}
function $28507a73a7688e48$export$88d492d47be57a7e({ listener: listener, globalProperty: globalProperty, interval: interval = 250 }, callback) {
    if ($28507a73a7688e48$var$isDefined(globalProperty)) {
        $28507a73a7688e48$var$logOnce(`window.${globalProperty} is already available for use by ${listener}.`);
        callback();
        return null;
    }
    const waitForGlobalInterval = setInterval(()=>{
        $28507a73a7688e48$var$logOnce(`${listener} is waiting for window.${globalProperty} to be available`);
        if ($28507a73a7688e48$var$isDefined(globalProperty)) {
            $28507a73a7688e48$var$logOnce(`window.${globalProperty} now available!`);
            clearInterval(waitForGlobalInterval);
            callback();
        }
    }, interval);
}
module.exports["waitForGlobal"] = $28507a73a7688e48$export$88d492d47be57a7e;

});

parcelRegister("9eE57", function(module, exports) {

var $ge2sX = parcelRequire("ge2sX");


var $04e9M = parcelRequire("04e9M");


var $5ZqQS = parcelRequire("5ZqQS");

const $e8c3b9e45ae9a31e$export$1a717feb4df1a945 = (names)=>{
    if (window.performance?.clearMarks) names.forEach((name)=>window.performance.clearMarks(name));
};
const $e8c3b9e45ae9a31e$export$1c64491a086778ac = (name)=>{
    if (window.performance?.getEntriesByType) {
        const entries = window.performance.getEntriesByType(name);
        return entries && entries[0];
    }
};
const $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce = (name)=>{
    if (window.performance?.getEntriesByName) {
        const entries = window.performance.getEntriesByName(name);
        return entries && entries[0];
    }
};
const $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d = (a, b)=>{
    const entryA = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(a);
    const entryB = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(b);
    if (entryA && entryB) return Math.abs(entryA.startTime - entryB.startTime);
    return undefined;
};
const $e8c3b9e45ae9a31e$export$f45af69d005a6ed = (name)=>{
    const mark = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(name);
    if (mark) return mark.startTime;
    return undefined;
};
const $e8c3b9e45ae9a31e$export$91b34dd9e71ad666 = ({ subject: subject, subjectId: subjectId = '' })=>{
    const startMark = `${subject}.${subjectId}.start`;
    const endMark = `${subject}.${subjectId}.end`;
    $e8c3b9e45ae9a31e$export$1a717feb4df1a945([
        startMark,
        endMark
    ]);
    window.performance?.mark?.(startMark);
};
// Filter out feature flags with falsy values to save user bandwidth
const $e8c3b9e45ae9a31e$var$filterFeatureFlags = (flags = {})=>Object.keys(flags).filter((key)=>flags[key]).reduce((acc, key)=>{
        acc[key] = flags[key];
        return acc;
    }, {});
const $e8c3b9e45ae9a31e$var$performanceEnd = async ({ details: details, subject: subject, subjectId: subjectId, includeFeatureFlags: includeFeatureFlags })=>{
    const endMark = `${subject}.${subjectId}.end`;
    window.performance?.mark?.(endMark);
    const duration = $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d(`${subject}.${subjectId}.start`, endMark);
    if (duration === undefined) return;
    try {
        const analyticsClientPromise = (0, $04e9M.getAnalyticsWebClient)();
        const sessionDataPromise = includeFeatureFlags ? (0, $ge2sX.getSessionData)() : Promise.resolve({
            featureFlags: {}
        });
        const [client, { featureFlags: featureFlags }] = await Promise.all([
            analyticsClientPromise,
            sessionDataPromise
        ]);
        const filteredFeatureFlags = $e8c3b9e45ae9a31e$var$filterFeatureFlags(featureFlags);
        client.sendOperationalEvent({
            tags: [
                'performance'
            ],
            source: 'confluence-frontend',
            action: 'done',
            actionSubject: subject,
            actionSubjectId: subjectId,
            attributes: {
                featureFlags: filteredFeatureFlags,
                duration: duration,
                ...details
            }
        });
    } catch (ex) {
        // This is a catch-all no-op, to prevent analytics component from screwing
        // up the user experience in case of any unexpected errors.
        (0, $5ZqQS.getMonitoringClient)().submitError(ex, {
            attribution: 'unknown'
        });
    }
};
const $e8c3b9e45ae9a31e$export$9cbdebb35a11386 = ({ subject: subject, subjectId: subjectId = '', details: details = {}, includeFeatureFlags: includeFeatureFlags = false })=>{
    const endMarkExists = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(`${subject}.${subjectId}.end`);
    if (!endMarkExists) $e8c3b9e45ae9a31e$var$performanceEnd({
        details: details,
        includeFeatureFlags: includeFeatureFlags,
        subject: subject,
        subjectId: subjectId
    });
};
module.exports["clearMarks"] = $e8c3b9e45ae9a31e$export$1a717feb4df1a945;
module.exports["getEntryByName"] = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce;
module.exports["measureMarks"] = $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d;
module.exports["getMark"] = $e8c3b9e45ae9a31e$export$f45af69d005a6ed;
module.exports["perfMarkStart"] = $e8c3b9e45ae9a31e$export$91b34dd9e71ad666;
module.exports["perfMarkEnd"] = $e8c3b9e45ae9a31e$export$9cbdebb35a11386;

});

parcelRegister("i1t43", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $w6R6I = parcelRequire("w6R6I");


var $iDrrr = parcelRequire("iDrrr");


var $7vK9E = parcelRequire("7vK9E");

var $iMnC5 = parcelRequire("iMnC5");

const $7e44050607850249$var$styles = {
    base: "_0bjKvDcjp5 _0WKd3G4z3T",
    visitedLink: "_2nTuUYWfPD _3ADzdEWfPD _1warJ9WfPD _4scvAwWyeI",
    defaultAppearance: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _1UtDYzM7Tp _32C2rk98eZ _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5M7Tp _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _0clgaMM7Tp _3WzCGi98eZ _0NqVRtYbGa _3BKYwu6wH8 _0CMRbkAwSC",
    defaultAppearanceMotion: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYzM7Tp _32C2rk98eZ _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5M7Tp _0DCa9DjOvk _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMM7Tp _3WzCGijOvk _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbkAwSC",
    subtleAppearance: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _1UtDYzZpcK _32C2rk98eZ _0i9AWAYbGa _0mm6KQ6wH8 _10n1R5ZpcK _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0clgaMZpcK _3WzCGi98eZ _0NqVRt0Rl6 _3BKYwu6wH8 _0CMRbky7kJ",
    subtleAppearanceMotion: "_00uqCYjOvk _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYzZpcK _32C2rkjOvk _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5ZpcK _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMZpcK _3WzCGi98eZ _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbky7kJ",
    inverseAppearance: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _1UtDYze5R3 _2nTuUYe5R3 _32C2rk98eZ _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5e5R3 _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _0clgaMe5R3 _3WzCGi98eZ _0NqVRtYbGa _3BKYwu6wH8 _0CMRbke5R3",
    inverseAppearanceMotion: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYze5R3 _2nTuUYe5R3 _32C2rk98eZ _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5e5R3 _0DCa9DjOvk _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMe5R3 _3WzCGijOvk _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbke5R3",
    iconWrapper: "_3iDTPbS8kF _1ANEUSLRg7 _1RrJLiQame _1mT5xdRAKS _2I62gzVQEB"
};
const $7e44050607850249$var$iconStyles = null;
const $7e44050607850249$var$LinkWithoutRef = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(30);
    let children;
    let htmlAttributes;
    let newWindowLabel;
    let t1;
    let target;
    let testId;
    if ($[0] !== t0) {
        const { children: t2, testId: t3, appearance: t4, newWindowLabel: t5, target: t6, className: _preventedClassName, style: _preventedStyle, ...t7 } = t0;
        children = t2;
        testId = t3;
        t1 = t4;
        newWindowLabel = t5;
        target = t6;
        htmlAttributes = t7;
        $[0] = t0;
        $[1] = children;
        $[2] = htmlAttributes;
        $[3] = newWindowLabel;
        $[4] = t1;
        $[5] = target;
        $[6] = testId;
    } else {
        children = $[1];
        htmlAttributes = $[2];
        newWindowLabel = $[3];
        t1 = $[4];
        target = $[5];
        testId = $[6];
    }
    const appearance = t1 === undefined ? "default" : t1;
    let t2;
    if ($[7] !== appearance) {
        t2 = appearance === "default" && ((0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") ? $7e44050607850249$var$styles.defaultAppearanceMotion : $7e44050607850249$var$styles.defaultAppearance);
        $[7] = appearance;
        $[8] = t2;
    } else t2 = $[8];
    let t3;
    if ($[9] !== appearance) {
        t3 = appearance === "subtle" && ((0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") ? $7e44050607850249$var$styles.subtleAppearanceMotion : $7e44050607850249$var$styles.subtleAppearance);
        $[9] = appearance;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    if ($[11] !== appearance) {
        t4 = appearance === "inverse" && ((0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") ? $7e44050607850249$var$styles.inverseAppearanceMotion : $7e44050607850249$var$styles.inverseAppearance);
        $[11] = appearance;
        $[12] = t4;
    } else t4 = $[12];
    const t5 = appearance !== "inverse" && $7e44050607850249$var$styles.visitedLink;
    let t6;
    if ($[13] !== t2 || $[14] !== t3 || $[15] !== t4 || $[16] !== t5) {
        t6 = (0, $w6R6I.cx)($7e44050607850249$var$styles.base, t2, t3, t4, t5);
        $[13] = t2;
        $[14] = t3;
        $[15] = t4;
        $[16] = t5;
        $[17] = t6;
    } else t6 = $[17];
    let t7;
    if ($[18] !== target || $[19] !== testId) {
        t7 = target === "_blank" && /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
            as: "span",
            xcss: $7e44050607850249$var$styles.iconWrapper,
            testId: testId && `${testId}__icon`,
            children: [
                "\uFEFF",
                /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
                    width: "12",
                    height: "12",
                    viewBox: "0 0 12 12",
                    fill: "none",
                    className: (0, $hekY6.default)([
                        "_39xV02YsW8 _0jFU0VYsW8 _0GTcwRu3qR"
                    ]),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                        fill: "currentColor"
                    })
                })
            ]
        });
        $[18] = target;
        $[19] = testId;
        $[20] = t7;
    } else t7 = $[20];
    let t8;
    if ($[21] !== children || $[22] !== htmlAttributes || $[23] !== newWindowLabel || $[24] !== ref || $[25] !== t6 || $[26] !== t7 || $[27] !== target || $[28] !== testId) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $7vK9E.Anchor), {
            ...htmlAttributes,
            target: target,
            ref: ref,
            xcss: t6,
            testId: testId,
            componentName: "Link",
            newWindowLabel: newWindowLabel,
            children: [
                children,
                t7
            ]
        });
        $[21] = children;
        $[22] = htmlAttributes;
        $[23] = newWindowLabel;
        $[24] = ref;
        $[25] = t6;
        $[26] = t7;
        $[27] = target;
        $[28] = testId;
        $[29] = t8;
    } else t8 = $[29];
    return t8;
} : ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: _preventedClassName, // @ts-expect-error
style: _preventedStyle, ...htmlAttributes }, ref)=>/*#__PURE__*/ (0, $8aG6j.jsxs)((0, $7vK9E.Anchor // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    ), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $w6R6I.cx)($7e44050607850249$var$styles.base, appearance === 'default' && ((0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') ? $7e44050607850249$var$styles.defaultAppearanceMotion : $7e44050607850249$var$styles.defaultAppearance), appearance === 'subtle' && ((0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') ? $7e44050607850249$var$styles.subtleAppearanceMotion : $7e44050607850249$var$styles.subtleAppearance), appearance === 'inverse' && ((0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') ? $7e44050607850249$var$styles.inverseAppearanceMotion : $7e44050607850249$var$styles.inverseAppearance), // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $7e44050607850249$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel,
        children: [
            children,
            target === '_blank' && /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
                as: "span",
                xcss: $7e44050607850249$var$styles.iconWrapper,
                testId: testId && `${testId}__icon`,
                children: [
                    "\uFEFF",
                    /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        className: (0, $hekY6.default)([
                            "_39xV02YsW8 _0jFU0VYsW8 _0GTcwRu3qR"
                        ]),
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                            fill: "currentColor"
                        })
                    })
                ]
            })
        ]
    }); // Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $7e44050607850249$var$Link = /*#__PURE__*/ (0, $cozmU.forwardRef)($7e44050607850249$var$LinkWithoutRef);
var $7e44050607850249$export$2e2bcd8739ae039 = $7e44050607850249$var$Link;
module.exports["default"] = $7e44050607850249$export$2e2bcd8739ae039;

});

parcelRegister("ir4h8", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $ac2J9 = parcelRequire("ac2J9");

const $abc73c6f5c74c436$export$6d558eab13290f59 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
} : ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
module.exports["useRouterLink"] = $abc73c6f5c74c436$export$6d558eab13290f59;

});

parcelRegister("ac2J9", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $b797161b98bd0492$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $cozmU.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $b797161b98bd0492$var$RouterLinkProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { routerLinkComponent: routerLinkComponent, children: children } = t0;
    let t1;
    if ($[0] !== routerLinkComponent) {
        t1 = {
            routerLinkComponent: routerLinkComponent
        };
        $[0] = routerLinkComponent;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
            value: t1,
            children: children
        });
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b797161b98bd0492$export$2e2bcd8739ae039 = $b797161b98bd0492$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $b797161b98bd0492$export$2931e0ee690eee88;

});

parcelRegister("8Ss4E", function(module, exports) {

var $3AVOh = parcelRequire("3AVOh");


var $kyKWe = parcelRequire("kyKWe");


var $34MZN = parcelRequire("34MZN");


var $eYg5X = parcelRequire("eYg5X");


var $lTECB = parcelRequire("lTECB");


var $hukUK = parcelRequire("hukUK");


var $9wGTI = parcelRequire("9wGTI");


var $c3Qwv = parcelRequire("c3Qwv");


var $1NBp8 = parcelRequire("1NBp8");


var $cEgMD = parcelRequire("cEgMD");


var $irVI7 = parcelRequire("irVI7");


var $gykrH = parcelRequire("gykrH");


var $aJPUt = parcelRequire("aJPUt");


var $fGzMp = parcelRequire("fGzMp");


var $1A7bE = parcelRequire("1A7bE");


var $7v9li = parcelRequire("7v9li");


var $949zl = parcelRequire("949zl");


var $h10mo = parcelRequire("h10mo");

const $8c50530bac3b9ba1$var$noPermissionOrNotFoundExperiences = [
    (0, $irVI7.NOT_FOUND_EXPERIENCE),
    (0, $irVI7.RESTRICTED_PAGE_EXPERIENCE),
    (0, $irVI7.RESTRICTED_SPACE_EXPERIENCE),
    (0, $irVI7.RESTRICTED_SPACE_FOR_GUEST_EXPERIENCE)
];
const $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound = (0, $1A7bE.collectAny)($8c50530bac3b9ba1$var$noPermissionOrNotFoundExperiences);
const $8c50530bac3b9ba1$var$stopOnConnectAddon = (0, $1A7bE.collectAny)([
    (0, $irVI7.CONNECT_ADDON_EXPERIENCE)
]);
/**
 * Stores the new experiences started due to SPA transition
 */ const $8c50530bac3b9ba1$var$namesStartedInPreviousRoute = [];
/**
 *  Specifies routes that signify completion for each experience.
 *  Used with experienceTracker's collect function to monitor progress of experiences.
 *  For example, 'create page' experience is considered complete when it leads to 'edit page'.
 */ const $8c50530bac3b9ba1$var$redirectRoutesForExperiences = {
    [(0, $irVI7.CREATE_PAGE_EXPERIENCE)]: [
        (0, $1NBp8.EDIT_PAGE_V2).name,
        (0, $1NBp8.EDIT_BLOG_V2).name,
        (0, $1NBp8.EDIT_PAGE).name,
        (0, $1NBp8.EDIT_BLOG).name,
        (0, $1NBp8.VIEW_PAGE).name // CREATE_PAGE_EXPERIENCE -> VIEW_PAGE means a live page was created
    ],
    // Same redirect routes as CREATE_PAGE_EXPERIENCE — the link-creation flow also succeeds when it leads to edit-page (a page was created from an Undefined Link).
    [(0, $irVI7.CREATE_PAGE_FROM_LINK_CREATION_EXPERIENCE)]: [
        (0, $1NBp8.EDIT_PAGE_V2).name,
        (0, $1NBp8.EDIT_BLOG_V2).name,
        (0, $1NBp8.EDIT_PAGE).name,
        (0, $1NBp8.EDIT_BLOG).name,
        (0, $1NBp8.VIEW_PAGE).name
    ],
    [(0, $irVI7.CREATE_WHITEBOARD_EXPERIENCE)]: [
        (0, $1NBp8.WHITEBOARD_BOARD).name
    ],
    [(0, $irVI7.CREATE_SLIDE_EXPERIENCE)]: [
        (0, $1NBp8.SLIDES_VIEW).name
    ],
    [(0, $irVI7.CREATE_DATABASE_EXPERIENCE)]: [
        (0, $1NBp8.DATABASE_VIEW).name
    ],
    [(0, $irVI7.CREATE_EMBED_EXPERIENCE)]: [
        (0, $1NBp8.EMBED_VIEW).name
    ]
};
const $8c50530bac3b9ba1$var$EXPERIENCES_TO_ABORT_ON_ROUTE_CHANGE = [
    (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE)
];
const $8c50530bac3b9ba1$export$4b786e0ae0cc0857 = {
    [(0, $1NBp8.SPACE_OVERVIEW).name]: 'space',
    [(0, $1NBp8.COMPANY_HUB).name]: 'space',
    [(0, $1NBp8.EDIT_PAGE_EMBED).name]: 'page',
    [(0, $1NBp8.EDIT_PAGE_V2).name]: 'page',
    [(0, $1NBp8.EDIT_BLOG_V2).name]: 'blog',
    [(0, $1NBp8.VIEW_PAGE).name]: 'page',
    [(0, $1NBp8.VIEW_BLOG).name]: 'blog',
    [(0, $1NBp8.VIEW_BLOG_DATE_LEGACY).name]: 'blog'
};
const $8c50530bac3b9ba1$export$5396770e9da36673 = (routeName)=>{
    switch(routeName){
        case (0, $1NBp8.EDIT_BLOG).name:
        case (0, $1NBp8.EDIT_PAGE).name:
        case (0, $1NBp8.CREATE_PAGE).name:
            return 'TINY';
        default:
            return 'FABRIC';
    }
};
function $8c50530bac3b9ba1$export$cac1117e2433d80e(match, transitionId, sessionData) {
    if (!match) return;
    const tracker = (0, $fGzMp.getExperienceTracker)();
    // Moves current route data to previous route data to ensure `getExperienceTracker.ts getPreviousRouteExperienceData()` works correctly
    (0, $fGzMp.captureRouteChange)(match.name);
    // Live page's edit-page and session experience starts after the route has finished loading and unsubscribed from the tracker, so it's not in the `startExperienceForRoute` function's namesStartedInPreviousRoute array. We will handle finishing it separately in `finishLivePageExperiences`.
    // It's important that `finishLivePageExperiences` is invoked before we attempt to succeed EDIT_PAGE_EXPERIENCE below, as `finishLivePageExperiences` is responsible for succeeding EDIT_PAGE_EXPERIENCE on live pages while setting the experience attribute `isLivePage
    $8c50530bac3b9ba1$var$finishLivePageExperiences();
    $8c50530bac3b9ba1$var$namesStartedInPreviousRoute.forEach((name)=>{
        const allowedRoutes = $8c50530bac3b9ba1$var$redirectRoutesForExperiences[name];
        // For create content routes, we do not want to abort if it is routing to correct page.
        // But, if it is a create experience and routing to a page is is not supposed to be going to,
        // we can assume something is wrong and we abort it.
        if (allowedRoutes && allowedRoutes.includes(match.name)) return;
        if (// If we were on edit-page or view-page/session experience and leave to another route, we should succeed that experience, not abort it.
        name === (0, $irVI7.EDIT_PAGE_EXPERIENCE) && (0, $7v9li.hasHealthyRunningEditPageExperience)() || name === (0, $irVI7.COMPANY_HUB_EDITOR_EXPERIENCE) && (0, $7v9li.hasHealthyRunningCompanyHubEditExperience)() || name === (0, $irVI7.VIEW_PAGE_SESSION_EXPERIENCE) && (0, $949zl.hasHealthyRunningViewPageExperience)()) {
            tracker.succeed({
                name: name
            });
            return;
        }
        // For all other situations, we still abort.
        tracker.abort({
            name: name,
            reason: 'Aborted due to SPA started a new experience'
        });
    });
    $8c50530bac3b9ba1$var$namesStartedInPreviousRoute.length = 0;
    const unsubscribe = tracker.subscribe((e)=>{
        if (e.action === 'taskStart') $8c50530bac3b9ba1$var$namesStartedInPreviousRoute.push(e.name);
    });
    $8c50530bac3b9ba1$var$EXPERIENCES_TO_ABORT_ON_ROUTE_CHANGE.forEach((name)=>{
        $8c50530bac3b9ba1$var$namesStartedInPreviousRoute.push(name);
    });
    switch(match.name){
        case (0, $1NBp8.COMPANY_HUB_EDIT).name:
            $8c50530bac3b9ba1$var$startCompanyHubEditor(transitionId, sessionData);
            break;
        case (0, $1NBp8.EDIT_PAGE_EMBED).name:
        case (0, $1NBp8.EDIT_PAGE_V2).name:
        case (0, $1NBp8.EDIT_BLOG_V2).name:
        case (0, $1NBp8.EDIT_PAGE).name:
        case (0, $1NBp8.EDIT_BLOG).name:
        case (0, $1NBp8.CREATE_PAGE).name:
        case (0, $1NBp8.HUB_EDIT).name:
            $8c50530bac3b9ba1$var$startEditPage(match, transitionId, sessionData);
            break;
        case (0, $1NBp8.VIEW_PAGE).name:
        case (0, $1NBp8.VIEW_BLOG).name:
        case (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).name:
            $8c50530bac3b9ba1$var$startViewContent(match.params.contentId, transitionId, $8c50530bac3b9ba1$export$4b786e0ae0cc0857[match.name], match.query, sessionData);
            break;
        case (0, $1NBp8.PAGE_SPLIT).name:
            $8c50530bac3b9ba1$var$startSplitPageLoad(match.params.contentId, transitionId);
            break;
        case (0, $1NBp8.EDIT_PAGE_SMART_CREATE).name:
            $8c50530bac3b9ba1$var$startEditPageSmartCreate(match);
            break;
        case (0, $1NBp8.ADMIN_NEW_GLOBAL_PERMISSIONS).name:
            $8c50530bac3b9ba1$var$startViewPublicLinkGlobalSettings(match.query.tab, match.query.space, transitionId);
            break;
        case (0, $1NBp8.EXTERNAL_SHARE).name:
            $8c50530bac3b9ba1$var$startViewPublicLinkSharedPage(match.params.id, transitionId);
            break;
        case (0, $1NBp8.SPACE_OVERVIEW).name:
            $8c50530bac3b9ba1$var$startViewContent(match.params.spaceKey, transitionId, $8c50530bac3b9ba1$export$4b786e0ae0cc0857[match.name], match.query, sessionData, {
                spaceKey: match.params.spaceKey,
                isLandingPage: match.search === '?mode=global'
            });
            break;
        case (0, $1NBp8.COMPANY_HUB).name:
            const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)(sessionData) || '';
            $8c50530bac3b9ba1$var$startViewContent(spaceKey, transitionId, $8c50530bac3b9ba1$export$4b786e0ae0cc0857[match.name], match.query, sessionData, {
                spaceKey: spaceKey
            });
            break;
        case (0, $1NBp8.HOME).name:
            (0, $h10mo.startHome)();
            break;
        case (0, $1NBp8.EDIT_TEMPLATE_SPACE).name:
        case (0, $1NBp8.EDIT_TEMPLATE).name:
            $8c50530bac3b9ba1$var$startTemplateEditPage(match.params.contentId, transitionId);
            break;
        case (0, $1NBp8.CREATE_TEMPLATE_SPACE).name:
        case (0, $1NBp8.CREATE_TEMPLATE).name:
            $8c50530bac3b9ba1$var$startTemplateEditPage(/* id */ undefined, transitionId);
            break;
        case (0, $1NBp8.ADVANCED_SEARCH).name:
            $8c50530bac3b9ba1$var$startAdvancedSearch(match);
            break;
        case (0, $1NBp8.SPACE_ARCHIVED_PAGES).name:
            $8c50530bac3b9ba1$var$startArchivedPagesList();
            break;
        case (0, $1NBp8.SPACE_BULK_TOOLS).name:
            $8c50530bac3b9ba1$var$startContentManager();
            break;
        case (0, $1NBp8.SPACE_DIRECTORY).name:
            $8c50530bac3b9ba1$var$startSpaceDirectory();
            break;
        case (0, $1NBp8.TEMPLATE_GALLERY).name:
            $8c50530bac3b9ba1$var$startTemplateGallery();
            break;
        case (0, $1NBp8.SPACE_PAGES).name:
            $8c50530bac3b9ba1$var$startSpacePages();
            break;
        case (0, $1NBp8.WHITEBOARD_BOARD).name:
            $8c50530bac3b9ba1$var$startWhiteboardBoard(match);
            break;
        case (0, $1NBp8.SLIDES_VIEW).name:
            $8c50530bac3b9ba1$var$startSlideView(match.params.contentId);
            break;
        case (0, $1NBp8.DATABASE_VIEW).name:
            $8c50530bac3b9ba1$var$startDatabaseView(match.params.contentId);
            break;
        case (0, $1NBp8.EMBED_VIEW).name:
            $8c50530bac3b9ba1$var$startEmbedPageView(match.params.contentId);
            break;
        case (0, $1NBp8.FOLDER_VIEW).name:
            $8c50530bac3b9ba1$var$startFolderView(match.params.contentId);
            break;
        case (0, $1NBp8.SPACE_PERMISSIONS_SETTINGS).name:
            //Adding the other space perms uplift tabs at a later date.
            if (match.params.tab === 'public-links') $8c50530bac3b9ba1$var$startViewPublicLinksSpaceSettings();
            break;
        case (0, $1NBp8.ADMIN_ANNOUNCEMENT_BANNER_RENDERER).name:
            $8c50530bac3b9ba1$var$startViewAdminAnnouncementBannerSettings();
            break;
        case (0, $1NBp8.SPACE_MANAGER).name:
            $8c50530bac3b9ba1$var$startSpaceManager();
            break;
        case (0, $1NBp8.ADMIN_COMPANY_HOME_BUILDER).name:
        case (0, $1NBp8.ADMIN_CUSTOMIZE_NAVIGATION).name:
            $8c50530bac3b9ba1$var$startCompanyHomeBuilderLoad();
            break;
    }
    const startCreateOperations = ()=>{
        const subType = typeof match?.query?.subType === 'string' ? match.query.subType : null;
        if (match.name === (0, $1NBp8.CREATE_CONTENT).name) $8c50530bac3b9ba1$var$startCreateContent(match, sessionData, subType);
        else if (match.query.createDialog) {
            $8c50530bac3b9ba1$var$startCreatePage(String(transitionId), transitionId, subType);
            (0, $7v9li.startCreateAndEditPage)();
        }
    };
    startCreateOperations();
    unsubscribe();
}
function $8c50530bac3b9ba1$var$startSplitPageLoad(contentId, transitionId) {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.SPLIT_PAGE_LOAD_EXPERIENCE),
        id: contentId,
        startTime: transitionId === 0 ? 0 : undefined
    });
}
function $8c50530bac3b9ba1$var$startCreatePage(id, transitionId, subType) {
    const experienceTracker = (0, $fGzMp.getExperienceTracker)();
    experienceTracker.start({
        name: (0, $irVI7.CREATE_PAGE_EXPERIENCE),
        id: id,
        attributes: {
            isLivePage: subType?.toLowerCase() === 'live'
        },
        startTime: transitionId === 0 ? 0 : undefined,
        collect (events, experience) {
            experience.stopOn(events.find((event)=>event.action === 'taskFail' && (0, $gykrH.hasName)(event, (0, $irVI7.CREATE_PAGE_LOAD_DIALOG_EXPERIENCE), (0, $irVI7.CREATE_PAGE_TEMPLATE_VARIABLES_EXPERIENCE))));
            experience.stopOn(events.find((event)=>event.action === 'taskSuccess' && (0, $gykrH.hasName)(event, (0, $irVI7.CREATE_PAGE_TEMPLATE_VARIABLES_EXPERIENCE))));
            experience.stopOn(events.find((event)=>event.action === 'taskAbort' && (0, $gykrH.hasName)(event, (0, $irVI7.CREATE_PAGE_TEMPLATE_VARIABLES_EXPERIENCE))));
        }
    });
    experienceTracker.start({
        name: (0, $irVI7.CREATE_PAGE_LOAD_DIALOG_EXPERIENCE),
        id: id,
        timeout: (0, $aJPUt.ExperienceTimeout).CREATE_DIALOG_LOAD
    });
}
function $8c50530bac3b9ba1$export$b9a409823a06b924(experienceName) {
    const activeTrace = (0, $34MZN.getActiveTrace)();
    if (!activeTrace) (0, $eYg5X.default)(experienceName.replace(/\//g, '-'));
}
function $8c50530bac3b9ba1$export$478e84e2cc5ff22d(compoundExperience, editorLoadExperience, editorPublishExperience) {
    const experienceTracker = (0, $fGzMp.getExperienceTracker)();
    const compoundTaskId = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
    const compoundExperienceAttributes = {
        ...compoundExperience.attributes,
        compoundTaskId: compoundTaskId
    };
    experienceTracker.start({
        ...compoundExperience,
        id: compoundTaskId,
        attributes: compoundExperienceAttributes,
        collect: (events, experience)=>{
            experience.stopOn(events.find(({ action: action, name: name })=>action === 'taskFail' && name === editorLoadExperience.name));
            experience.stopOn(events.find(({ action: action, name: name })=>(action === 'taskSuccess' || action === 'taskFail') && name === editorPublishExperience.name));
            if (compoundExperience.collect) compoundExperience.collect(events, experience);
        }
    });
    experienceTracker.start({
        ...editorLoadExperience,
        id: editorLoadExperience.id || compoundExperience.id,
        timeout: editorLoadExperience.timeout || (0, $aJPUt.ExperienceTimeout).EDITOR_LOAD,
        attributes: compoundExperienceAttributes,
        collect: editorLoadExperience.collect
    });
}
function $8c50530bac3b9ba1$export$7df6656d8508e8da(subExperience) {
    const experienceTracker = (0, $fGzMp.getExperienceTracker)();
    // Initialize attributes from the original subExperience
    const attributes = {
        ...subExperience.attributes
    };
    // Extract the compound experience name from the sub-experience name if it follows
    // the naming convention "<compound_experience_name>/<sub_experience>"
    const subExperienceName = subExperience.name;
    const nameParts = subExperienceName.split('/');
    // Only attempt to get compound experience if the name includes a separator
    if (nameParts.length > 1) {
        const compoundExperienceName = nameParts[0];
        const compoundExperienceState = experienceTracker.getExperienceState(compoundExperienceName);
        // If compound experience exists, inherit its compoundTaskId
        if (compoundExperienceState) // Link the compound experience's compoundTaskId if available
        {
            if (compoundExperienceState.attributes?.compoundTaskId) attributes.compoundTaskId = compoundExperienceState.attributes.compoundTaskId;
        }
    }
    // Start the sub-experience with the attributes (original or enhanced with compoundTaskId)
    experienceTracker.start({
        ...subExperience,
        attributes: attributes
    });
}
const $8c50530bac3b9ba1$var$stopOnCloseForEditPage = (events, experience, loadExperienceName, closeExperienceName)=>{
    const loadStopExperience = events.find((event)=>event.name === loadExperienceName && (0, $gykrH.isStop)(event));
    const closeStopExperience = events.find((event)=>event.name === closeExperienceName && (0, $gykrH.isStop)(event));
    if (!closeStopExperience) return;
    // prettier-ignore
    if ((!loadStopExperience || loadStopExperience.action !== "taskSuccess") && closeStopExperience.action === "taskSuccess") // loading incomplete or failed, therefore editing session was broken and close doesn't indicate a success
    experience.abort({
        reason: "Editor closed before load completed",
        attributes: {
            loadExperienceState: loadStopExperience?.action ?? "incomplete"
        }
    });
    else experience.stopOn(closeStopExperience);
};
function $8c50530bac3b9ba1$var$startEditPageSmartCreate(match) {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.EDIT_PAGE_SMART_CREATE_LOAD_EXPERIENCE),
        id: match.params.contentId,
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT,
        collect: (events, experience)=>{
            const hasNoPermissionOrNotFoundEvent = events.find((event)=>(0, $gykrH.isStop)(event) && (0, $gykrH.hasName)(event, ...$8c50530bac3b9ba1$var$noPermissionOrNotFoundExperiences));
            if (hasNoPermissionOrNotFoundEvent) experience.fail({
                error: new Error(`${hasNoPermissionOrNotFoundEvent.name} experience resulted in ${hasNoPermissionOrNotFoundEvent.action} - unexpected for the smart create editor`)
            });
        }
    });
}
function $8c50530bac3b9ba1$var$startEditPage(match, transitionId, sessionData) {
    const isLegacyEditor = $8c50530bac3b9ba1$export$5396770e9da36673(match?.name ?? '') === 'TINY';
    let editPageExperienceName = (0, $irVI7.EDIT_PAGE_EXPERIENCE);
    if (match.name === (0, $1NBp8.EDIT_PAGE_EMBED).name) editPageExperienceName = (0, $irVI7.EDIT_PAGE_EMBED_EXPERIENCE);
    else if (isLegacyEditor) editPageExperienceName = (0, $irVI7.EDIT_LEGACY_PAGE_EXPERIENCE);
    $8c50530bac3b9ba1$export$478e84e2cc5ff22d(/* compoundExperience */ {
        name: editPageExperienceName,
        id: match.params.contentId,
        startTime: transitionId === 0 ? 0 : undefined,
        attributes: {
            editor: $8c50530bac3b9ba1$export$5396770e9da36673(match.name),
            contentType: $8c50530bac3b9ba1$export$4b786e0ae0cc0857[match.name],
            edition: sessionData?.edition,
            shard: sessionData?.shard,
            isCompanyHub: match?.name === (0, $1NBp8.COMPANY_HUB_EDIT).name || match?.name === (0, $1NBp8.HUB_EDIT).name,
            contentId: match.params.contentId,
            isGuest: sessionData?.accessStatus === 'EXTERNAL_COLLABORATOR_ACCESS'
        },
        // override with full-page-editor specific stop/collect behaviour
        collect: (events, experience)=>{
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
            const loadExperienceName = isLegacyEditor ? (0, $irVI7.EDIT_LEGACY_PAGE_LOAD_EXPERIENCE) : (0, $irVI7.EDIT_PAGE_LOAD_EXPERIENCE);
            const closeExperienceName = isLegacyEditor ? (0, $irVI7.EDIT_LEGACY_PAGE_CLOSE_EXPERIENCE) : (0, $irVI7.EDIT_PAGE_CLOSE_EXPERIENCE);
            $8c50530bac3b9ba1$var$stopOnCloseForEditPage(events, experience, loadExperienceName, closeExperienceName);
        }
    }, /* editorLoadExperience */ {
        name: isLegacyEditor ? (0, $irVI7.EDIT_LEGACY_PAGE_LOAD_EXPERIENCE) : (0, $irVI7.EDIT_PAGE_LOAD_EXPERIENCE),
        collect: (events, experience)=>{
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
            const closeExperienceName = isLegacyEditor ? (0, $irVI7.EDIT_LEGACY_PAGE_CLOSE_EXPERIENCE) : (0, $irVI7.EDIT_PAGE_CLOSE_EXPERIENCE);
            const closeExperience = events.find((event)=>(0, $gykrH.isStop)(event) && event.name === closeExperienceName);
            if (closeExperience) experience.abort({
                reason: 'Editor closed before load completed',
                attributes: {
                    closeExperienceState: closeExperience?.action ?? 'incomplete'
                }
            });
        }
    }, /* editorPublishExperience */ {
        name: isLegacyEditor ? (0, $irVI7.EDIT_LEGACY_PAGE_PUBLISH_EXPERIENCE) : (0, $irVI7.EDIT_PAGE_PUBLISH_EXPERIENCE)
    });
}
function $8c50530bac3b9ba1$var$startCompanyHubEditor(transitionId, sessionData) {
    $8c50530bac3b9ba1$export$478e84e2cc5ff22d(/* compoundExperience */ {
        name: (0, $irVI7.COMPANY_HUB_EDITOR_EXPERIENCE),
        startTime: transitionId === 0 ? 0 : undefined,
        attributes: {
            editor: 'FABRIC',
            contentType: 'space',
            edition: sessionData?.edition,
            shard: sessionData?.shard,
            isCompanyHub: true
        },
        collect: (events, experience)=>{
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
            $8c50530bac3b9ba1$var$stopOnCloseForEditPage(events, experience, (0, $irVI7.COMPANY_HUB_EDITOR_LOAD_EXPERIENCE), (0, $irVI7.COMPANY_HUB_EDITOR_CLOSE_EXPERIENCE));
        }
    }, /* editorLoadExperience */ {
        name: (0, $irVI7.COMPANY_HUB_EDITOR_LOAD_EXPERIENCE),
        collect: (events, experience)=>{
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
        }
    }, /* editorPublishExperience */ {
        name: (0, $irVI7.FRONT_COVER_PUBLISH_EXPERIENCE)
    });
}
function $8c50530bac3b9ba1$var$startViewContent(id, transitionId, contentType, query, sessionData, attributes) {
    // WS-3261 - We need to track if the view is coming from an external source (email notification, Slack, etc.)
    const isFromExternal = Boolean(query && query.atlOrigin);
    // Track APDEX part of the content (title and content itself)
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.VIEW_CONTENT_EXPERIENCE),
        id: id,
        startTime: transitionId === 0 ? 0 : undefined,
        timeout: (0, $aJPUt.ExperienceTimeout).PAGE_LOAD,
        attributes: {
            contentType: contentType,
            isFromExternal: isFromExternal,
            edition: sessionData?.edition,
            shard: sessionData?.shard,
            ...attributes
        },
        collect: (events, experience)=>{
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
            $8c50530bac3b9ba1$var$stopOnConnectAddon(events, experience);
        }
    });
}
function $8c50530bac3b9ba1$var$startViewPublicLinkGlobalSettings(tab, space, transitionId) {
    if (tab === 'public-links' && !space) (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.VIEW_PUBLIC_LINK_SITE_SETTINGS_EXPERIENCE),
        id: 'public-links',
        startTime: transitionId === 0 ? 0 : undefined,
        timeout: (0, $aJPUt.ExperienceTimeout).PAGE_LOAD
    });
}
function $8c50530bac3b9ba1$var$startViewPublicLinksSpaceSettings() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.VIEW_PUBLIC_LINKS_SPACE_SETTINGS_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).PAGE_LOAD
    });
}
function $8c50530bac3b9ba1$var$startViewPublicLinkSharedPage(id, transitionId) {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.VIEW_PUBLIC_LINK_SHARED_PAGE_EXPERIENCE),
        id: id,
        startTime: transitionId === 0 ? 0 : undefined,
        timeout: (0, $aJPUt.ExperienceTimeout).PAGE_LOAD
    });
}
function $8c50530bac3b9ba1$var$startTemplateEditPage(id, transitionId) {
    $8c50530bac3b9ba1$export$478e84e2cc5ff22d(/* compoundExperience */ {
        name: (0, $irVI7.TEMPLATE_EDIT_PAGE_EXPERIENCE),
        id: id,
        startTime: transitionId === 0 ? 0 : undefined,
        collect: (events, experience)=>{
            experience.stopOn(events.find((event)=>(0, $gykrH.isStop)(event) && event.name === (0, $irVI7.TEMPLATE_EDIT_PAGE_CLOSE_EXPERIENCE)));
        }
    }, /* editorLoadExperience */ {
        name: (0, $irVI7.TEMPLATE_EDIT_PAGE_LOAD_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).TEMPLATE_EDITOR_LOAD
    }, /* editorPublishExperience */ {
        name: (0, $irVI7.TEMPLATE_EDIT_PAGE_PUBLISH_EXPERIENCE)
    });
}
function $8c50530bac3b9ba1$var$startAdvancedSearch(match) {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.ADVANCED_SEARCH_EXPERIENCE),
        id: (0, $hukUK.objectHash)((0, (/*@__PURE__*/$parcel$interopDefault($3AVOh)))(match.query, [
            'search_id'
        ]))
    });
}
function $8c50530bac3b9ba1$var$startArchivedPagesList() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.SPACE_ARCHIVED_PAGES_EXPERIENCE)
    });
}
function $8c50530bac3b9ba1$var$startContentManager() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.CONTENT_MANAGER_EXPERIENCE)
    });
}
function $8c50530bac3b9ba1$var$startSpaceDirectory() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.SPACE_DIRECTORY_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).SPACE_DIRECTORY
    });
}
function $8c50530bac3b9ba1$var$startTemplateGallery() {
    const TemplateGallerySubExperiences = [
        (0, $irVI7.TEMPLATE_GALLERY_CATEGORIES_EXPERIENCE),
        (0, $irVI7.TEMPLATE_GALLERY_SPACE_SELECTOR_EXPERIENCE),
        (0, $irVI7.TEMPLATE_GALLERY_CARDS_EXPERIENCE),
        (0, $irVI7.TEMPLATE_GALLERY_TEMPLATE_DETAIL_EXPERIENCE)
    ];
    const collectTemplateGalleryLoadExperiences = (events, experience)=>{
        (0, $1A7bE.collectAll)(TemplateGallerySubExperiences)(events, experience);
    };
    const stopOnRestrictedPage = (0, $1A7bE.collectAll)([
        (0, $irVI7.RESTRICTED_PAGE_EXPERIENCE)
    ]);
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.TEMPLATE_GALLERY_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT,
        collect: (events, experience)=>{
            collectTemplateGalleryLoadExperiences(events, experience);
            stopOnRestrictedPage(events, experience);
        }
    });
}
function $8c50530bac3b9ba1$var$startSpacePages() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.SPACE_PAGES_EXPERIENCE)
    });
}
function $8c50530bac3b9ba1$var$startCreateContent(match, sessionData, subType) {
    const queryParams = match.query;
    const isPersonalSpace = queryParams.spaceKey?.[0] !== undefined ? (queryParams.spaceKey[0] === '~').toString() : 'unknown';
    const flow = (0, $c3Qwv.getSingleParam)(queryParams, 'source') || 'createContentRoute';
    if (match.params.contentType === 'whiteboard') (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.CREATE_WHITEBOARD_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).CREATE_CONTENT,
        attributes: {
            flow: flow,
            isPersonalSpace: isPersonalSpace
        },
        collect: (events, experience)=>{
            const whiteboardExperienceStart = events.find((event)=>event.action === 'taskStart' && event.name === (0, $irVI7.WHITEBOARD_EXPERIENCE));
            if (whiteboardExperienceStart) experience.succeed();
        }
    });
    else if (match.params.contentType === 'slide') (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.CREATE_SLIDE_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).CREATE_CONTENT,
        attributes: {
            flow: flow,
            isPersonalSpace: isPersonalSpace
        },
        collect: (events, experience)=>{
            const slideExperienceStart = events.find((event)=>event.action === 'taskStart' && event.name === (0, $irVI7.SLIDE_EXPERIENCE));
            if (slideExperienceStart) experience.succeed();
        }
    });
    else if (match.params.contentType === 'database') (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.CREATE_DATABASE_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).CREATE_CONTENT,
        attributes: {
            flow: flow,
            isPersonalSpace: isPersonalSpace
        },
        collect: (events, experience)=>{
            const databaseExperienceStart = events.find((event)=>event.action === 'taskStart' && event.name === (0, $irVI7.DATABASE_EXPERIENCE));
            if (databaseExperienceStart) experience.succeed();
        }
    });
    else if (match.params.contentType === 'smartLinkEmbed') (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.CREATE_EMBED_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).CREATE_CONTENT,
        attributes: {
            flow: flow,
            isPersonalSpace: isPersonalSpace
        },
        collect: (events, experience)=>{
            const smartLinkEmbedExperienceStart = events.find((event)=>event.action === 'taskStart' && event.name === (0, $irVI7.EMBED_EXPERIENCE));
            if (smartLinkEmbedExperienceStart) experience.succeed();
        }
    });
    else if ([
        'page',
        'blog'
    ].includes(match.params.contentType)) {
        // Undefined Links flows (linkCreation=true) are tracked under a separate non-SLA experience
        // to prevent them from polluting the SLA'd create-page experience
        const isLinkCreationFlow = (0, $9wGTI.fg)('cc_create_page_link_creation_split') && (0, $c3Qwv.getSingleParam)(queryParams, 'linkCreation') === 'true';
        const createPageExperienceName = isLinkCreationFlow ? (0, $irVI7.CREATE_PAGE_FROM_LINK_CREATION_EXPERIENCE) : (0, $irVI7.CREATE_PAGE_EXPERIENCE);
        (0, $fGzMp.getExperienceTracker)().start({
            name: createPageExperienceName,
            timeout: (0, $aJPUt.ExperienceTimeout).CREATE_CONTENT,
            attributes: {
                contentType: match.params.contentType,
                flow: flow,
                isCreateContentRoute: true,
                isPersonalSpace: isPersonalSpace,
                edition: sessionData?.edition,
                shard: sessionData?.shard,
                isLivePage: subType?.toLowerCase() === 'live'
            },
            collect: (events, experience)=>{
                const editPageStarted = events.find((event)=>event.action === 'taskStart' && (event.name === (0, $irVI7.EDIT_PAGE_EXPERIENCE) || event.name === (0, $irVI7.EDIT_LEGACY_PAGE_EXPERIENCE)));
                if (editPageStarted) experience.succeed();
            }
        });
    }
}
function $8c50530bac3b9ba1$var$startWhiteboardBoard(match) {
    const embeddedWhiteboardSubExperiences = [
        (0, $irVI7.WHITEBOARD_CONTENT_EXPERIENCE)
    ];
    const subExperiences = [
        (0, $irVI7.WHITEBOARD_CONTENT_EXPERIENCE),
        (0, $irVI7.CONTENT_TYPES_HEADER_EXPERIENCE)
    ];
    const isEmbedded = (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)();
    const contentId = match.params.contentId;
    $8c50530bac3b9ba1$var$startSubExperiencesForMainExperience(contentId, (0, $irVI7.WHITEBOARD_EXPERIENCE), isEmbedded ? embeddedWhiteboardSubExperiences : subExperiences);
}
function $8c50530bac3b9ba1$var$startSlideView(contentId) {
    const subExperiences = [
        (0, $irVI7.SLIDE_CONTENT_EXPERIENCE),
        (0, $irVI7.CONTENT_TYPES_HEADER_EXPERIENCE)
    ];
    const embeddedSlideSubExperiences = [
        (0, $irVI7.SLIDE_CONTENT_EXPERIENCE)
    ];
    const isEmbedded = (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)();
    $8c50530bac3b9ba1$var$startSubExperiencesForMainExperience(contentId, (0, $irVI7.SLIDE_EXPERIENCE), isEmbedded ? embeddedSlideSubExperiences : subExperiences);
}
function $8c50530bac3b9ba1$var$startDatabaseView(contentId) {
    const subExperiences = [
        (0, $irVI7.DATABASE_CONTENT_EXPERIENCE),
        (0, $irVI7.CONTENT_TYPES_HEADER_EXPERIENCE)
    ];
    const embeddedDatabaseSubExperiences = [
        (0, $irVI7.DATABASE_CONTENT_EXPERIENCE)
    ];
    const isEmbedded = (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)();
    $8c50530bac3b9ba1$var$startSubExperiencesForMainExperience(contentId, (0, $irVI7.DATABASE_EXPERIENCE), isEmbedded ? embeddedDatabaseSubExperiences : subExperiences);
}
function $8c50530bac3b9ba1$var$startSubExperiencesForMainExperience(contentId, mainExperience, subExperiences) {
    (0, $fGzMp.getExperienceTracker)().start({
        name: mainExperience,
        collect: (events, experience)=>{
            (0, $1A7bE.collectAll)(subExperiences)(events, experience);
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
        },
        id: contentId,
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
    });
    subExperiences.forEach((name)=>{
        (0, $fGzMp.getExperienceTracker)().start({
            name: name,
            id: contentId
        });
    });
}
function $8c50530bac3b9ba1$var$startEmbedPageView(contentId) {
    const embedPageSubExperiences = [
        (0, $irVI7.EMBED_CONTENT_EXPERIENCE),
        (0, $irVI7.CONTENT_TYPES_HEADER_EXPERIENCE),
        (0, $irVI7.VIEW_PAGE_FAVORITE_BUTTON_EXPERIENCE)
    ];
    const subExperiences = [
        (0, $irVI7.EMBED_CONTENT_EXPERIENCE),
        (0, $irVI7.CONTENT_TYPES_HEADER_EXPERIENCE)
    ];
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.EMBED_EXPERIENCE),
        collect: (events, experience)=>{
            (0, $1A7bE.collectAll)(subExperiences)(events, experience);
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
        },
        id: contentId,
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
    });
    embedPageSubExperiences.forEach((name)=>{
        (0, $fGzMp.getExperienceTracker)().start({
            name: name,
            id: contentId
        });
    });
}
function $8c50530bac3b9ba1$var$startFolderView(contentId) {
    const folderSubExperiences = [
        (0, $irVI7.FOLDER_CONTENT_EXPERIENCE)
    ];
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.FOLDER_EXPERIENCE),
        collect: (events, experience)=>{
            (0, $1A7bE.collectAll)(folderSubExperiences)(events, experience);
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
        },
        id: contentId,
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
    });
    folderSubExperiences.forEach((name)=>{
        (0, $fGzMp.getExperienceTracker)().start({
            name: name,
            id: contentId
        });
    });
}
function $8c50530bac3b9ba1$var$startViewAdminAnnouncementBannerSettings() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.ADMIN_ANNOUNCEMENT_BANNER_SETTINGS_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
    });
}
function $8c50530bac3b9ba1$var$startSpaceManager() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.SPACE_MANAGER_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
    });
}
function $8c50530bac3b9ba1$var$startCompanyHomeBuilderLoad() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.COMPANY_HOME_BUILDER_LOAD_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
    });
}
function $8c50530bac3b9ba1$var$finishLivePageExperiences() {
    const tracker = (0, $fGzMp.getExperienceTracker)();
    const livePageExperiencesToSucceed = [
        (0, $irVI7.EDIT_PAGE_EXPERIENCE),
        (0, $irVI7.LIVE_PAGE_SESSION_EXPERIENCE)
    ];
    livePageExperiencesToSucceed.forEach((experience)=>{
        const experienceState = tracker.getExperienceState(experience);
        // We want to identify if it's actively running, and if so, succeed it. This aligns with how we succeed non-live-page experiences on transition.
        // We validate the `isLivePage` attribute is `true` before succeeding, to avoid undesirably succeeding edit-page here when it's not a live page
        if (experienceState && !experienceState?.hasStopped && experienceState?.attributes?.isLivePage) tracker.succeed({
            name: experience
        });
    });
}
module.exports["routeNameToContentTypeMap"] = $8c50530bac3b9ba1$export$4b786e0ae0cc0857;
module.exports["startExperienceForRoute"] = $8c50530bac3b9ba1$export$cac1117e2433d80e;
module.exports["startUFOPressTrace"] = $8c50530bac3b9ba1$export$b9a409823a06b924;
module.exports["startEditorExperiences"] = $8c50530bac3b9ba1$export$478e84e2cc5ff22d;
module.exports["startEditorSubExperience"] = $8c50530bac3b9ba1$export$7df6656d8508e8da;

});

parcelRegister("3AVOh", function(module, exports) {

var $79D42 = parcelRequire("79D42");


var $hGc5T = parcelRequire("hGc5T");


var $hcV0q = parcelRequire("hcV0q");


var $aI4Cx = parcelRequire("aI4Cx");


var $bk5x8 = parcelRequire("bk5x8");


var $ezTcL = parcelRequire("ezTcL");


var $jPzTX = parcelRequire("jPzTX");


var $14dnq = parcelRequire("14dnq");

/** Used to compose bitmasks for cloning. */ var $29e193b87644e449$var$CLONE_DEEP_FLAG = 1, $29e193b87644e449$var$CLONE_FLAT_FLAG = 2, $29e193b87644e449$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $29e193b87644e449$var$omit = $jPzTX(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $79D42(paths, function(path) {
        path = $aI4Cx(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $bk5x8(object, $14dnq(object), result);
    if (isDeep) result = $hGc5T(result, $29e193b87644e449$var$CLONE_DEEP_FLAG | $29e193b87644e449$var$CLONE_FLAT_FLAG | $29e193b87644e449$var$CLONE_SYMBOLS_FLAG, $ezTcL);
    var length = paths.length;
    while(length--)$hcV0q(result, paths[length]);
    return result;
});
module.exports = $29e193b87644e449$var$omit;

});

parcelRegister("hGc5T", function(module, exports) {

var $1tgXD = parcelRequire("1tgXD");


var $7aPLP = parcelRequire("7aPLP");


var $aDCaS = parcelRequire("aDCaS");


var $e8WyO = parcelRequire("e8WyO");


var $lunGb = parcelRequire("lunGb");


var $19mn0 = parcelRequire("19mn0");


var $7WBxT = parcelRequire("7WBxT");


var $gwj3d = parcelRequire("gwj3d");


var $j60dZ = parcelRequire("j60dZ");


var $cTBpe = parcelRequire("cTBpe");


var $14dnq = parcelRequire("14dnq");


var $jOCrv = parcelRequire("jOCrv");


var $kGJE1 = parcelRequire("kGJE1");


var $cZmfO = parcelRequire("cZmfO");


var $jFqhM = parcelRequire("jFqhM");


var $1ScXu = parcelRequire("1ScXu");


var $6DVFM = parcelRequire("6DVFM");


var $aBDCC = parcelRequire("aBDCC");


var $izVFW = parcelRequire("izVFW");


var $1ji1e = parcelRequire("1ji1e");


var $f14Rr = parcelRequire("f14Rr");


var $dNyAN = parcelRequire("dNyAN");

/** Used to compose bitmasks for cloning. */ var $cdefbd8efe913551$var$CLONE_DEEP_FLAG = 1, $cdefbd8efe913551$var$CLONE_FLAT_FLAG = 2, $cdefbd8efe913551$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $cdefbd8efe913551$var$argsTag = '[object Arguments]', $cdefbd8efe913551$var$arrayTag = '[object Array]', $cdefbd8efe913551$var$boolTag = '[object Boolean]', $cdefbd8efe913551$var$dateTag = '[object Date]', $cdefbd8efe913551$var$errorTag = '[object Error]', $cdefbd8efe913551$var$funcTag = '[object Function]', $cdefbd8efe913551$var$genTag = '[object GeneratorFunction]', $cdefbd8efe913551$var$mapTag = '[object Map]', $cdefbd8efe913551$var$numberTag = '[object Number]', $cdefbd8efe913551$var$objectTag = '[object Object]', $cdefbd8efe913551$var$regexpTag = '[object RegExp]', $cdefbd8efe913551$var$setTag = '[object Set]', $cdefbd8efe913551$var$stringTag = '[object String]', $cdefbd8efe913551$var$symbolTag = '[object Symbol]', $cdefbd8efe913551$var$weakMapTag = '[object WeakMap]';
var $cdefbd8efe913551$var$arrayBufferTag = '[object ArrayBuffer]', $cdefbd8efe913551$var$dataViewTag = '[object DataView]', $cdefbd8efe913551$var$float32Tag = '[object Float32Array]', $cdefbd8efe913551$var$float64Tag = '[object Float64Array]', $cdefbd8efe913551$var$int8Tag = '[object Int8Array]', $cdefbd8efe913551$var$int16Tag = '[object Int16Array]', $cdefbd8efe913551$var$int32Tag = '[object Int32Array]', $cdefbd8efe913551$var$uint8Tag = '[object Uint8Array]', $cdefbd8efe913551$var$uint8ClampedTag = '[object Uint8ClampedArray]', $cdefbd8efe913551$var$uint16Tag = '[object Uint16Array]', $cdefbd8efe913551$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $cdefbd8efe913551$var$cloneableTags = {};
$cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$argsTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$arrayTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$arrayBufferTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$dataViewTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$boolTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$dateTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$float32Tag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$float64Tag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$int8Tag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$int16Tag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$int32Tag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$mapTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$numberTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$objectTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$regexpTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$setTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$stringTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$symbolTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$uint8Tag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$uint8ClampedTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$uint16Tag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$uint32Tag] = true;
$cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$errorTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$funcTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $cdefbd8efe913551$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $cdefbd8efe913551$var$CLONE_DEEP_FLAG, isFlat = bitmask & $cdefbd8efe913551$var$CLONE_FLAT_FLAG, isFull = bitmask & $cdefbd8efe913551$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$izVFW(value)) return value;
    var isArr = $1ScXu(value);
    if (isArr) {
        result = $kGJE1(value);
        if (!isDeep) return $7WBxT(value, result);
    } else {
        var tag = $jOCrv(value), isFunc = tag == $cdefbd8efe913551$var$funcTag || tag == $cdefbd8efe913551$var$genTag;
        if ($6DVFM(value)) return $19mn0(value, isDeep);
        if (tag == $cdefbd8efe913551$var$objectTag || tag == $cdefbd8efe913551$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $jFqhM(value);
            if (!isDeep) return isFlat ? $j60dZ(value, $lunGb(result, value)) : $gwj3d(value, $e8WyO(result, value));
        } else {
            if (!$cdefbd8efe913551$var$cloneableTags[tag]) return object ? value : {};
            result = $cZmfO(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $1tgXD);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($1ji1e(value)) value.forEach(function(subValue) {
        result.add($cdefbd8efe913551$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($aBDCC(value)) value.forEach(function(subValue, key) {
        result.set(key, $cdefbd8efe913551$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $14dnq : $cTBpe : isFlat ? $dNyAN : $f14Rr;
    var props = isArr ? undefined : keysFunc(value);
    $7aPLP(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $aDCaS(result, key, $cdefbd8efe913551$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = $cdefbd8efe913551$var$baseClone;

});

parcelRegister("7aPLP", function(module, exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $5391a0175a1872c4$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = $5391a0175a1872c4$var$arrayEach;

});

parcelRegister("e8WyO", function(module, exports) {

var $bk5x8 = parcelRequire("bk5x8");


var $f14Rr = parcelRequire("f14Rr");

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $a4bf3cec5f860948$var$baseAssign(object, source) {
    return object && $bk5x8(source, $f14Rr(source), object);
}
module.exports = $a4bf3cec5f860948$var$baseAssign;

});

parcelRegister("lunGb", function(module, exports) {

var $bk5x8 = parcelRequire("bk5x8");


var $dNyAN = parcelRequire("dNyAN");

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $fa4ec48e79e3b749$var$baseAssignIn(object, source) {
    return object && $bk5x8(source, $dNyAN(source), object);
}
module.exports = $fa4ec48e79e3b749$var$baseAssignIn;

});

parcelRegister("gwj3d", function(module, exports) {

var $bk5x8 = parcelRequire("bk5x8");


var $j1qF4 = parcelRequire("j1qF4");

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $c06e699caf978d13$var$copySymbols(source, object) {
    return $bk5x8(source, $j1qF4(source), object);
}
module.exports = $c06e699caf978d13$var$copySymbols;

});

parcelRegister("j60dZ", function(module, exports) {

var $bk5x8 = parcelRequire("bk5x8");


var $ahKsp = parcelRequire("ahKsp");

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $de6ec073df6f66ec$var$copySymbolsIn(source, object) {
    return $bk5x8(source, $ahKsp(source), object);
}
module.exports = $de6ec073df6f66ec$var$copySymbolsIn;

});

parcelRegister("kGJE1", function(module, exports) {
/** Used for built-in method references. */ var $f0fb22f60689ed3d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f0fb22f60689ed3d$var$hasOwnProperty = $f0fb22f60689ed3d$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $f0fb22f60689ed3d$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $f0fb22f60689ed3d$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = $f0fb22f60689ed3d$var$initCloneArray;

});

parcelRegister("cZmfO", function(module, exports) {

var $bAYSF = parcelRequire("bAYSF");


var $2nf4s = parcelRequire("2nf4s");


var $aOXy4 = parcelRequire("aOXy4");


var $cPFvk = parcelRequire("cPFvk");


var $39R3S = parcelRequire("39R3S");

/** `Object#toString` result references. */ var $974c71bfd764326f$var$boolTag = '[object Boolean]', $974c71bfd764326f$var$dateTag = '[object Date]', $974c71bfd764326f$var$mapTag = '[object Map]', $974c71bfd764326f$var$numberTag = '[object Number]', $974c71bfd764326f$var$regexpTag = '[object RegExp]', $974c71bfd764326f$var$setTag = '[object Set]', $974c71bfd764326f$var$stringTag = '[object String]', $974c71bfd764326f$var$symbolTag = '[object Symbol]';
var $974c71bfd764326f$var$arrayBufferTag = '[object ArrayBuffer]', $974c71bfd764326f$var$dataViewTag = '[object DataView]', $974c71bfd764326f$var$float32Tag = '[object Float32Array]', $974c71bfd764326f$var$float64Tag = '[object Float64Array]', $974c71bfd764326f$var$int8Tag = '[object Int8Array]', $974c71bfd764326f$var$int16Tag = '[object Int16Array]', $974c71bfd764326f$var$int32Tag = '[object Int32Array]', $974c71bfd764326f$var$uint8Tag = '[object Uint8Array]', $974c71bfd764326f$var$uint8ClampedTag = '[object Uint8ClampedArray]', $974c71bfd764326f$var$uint16Tag = '[object Uint16Array]', $974c71bfd764326f$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $974c71bfd764326f$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $974c71bfd764326f$var$arrayBufferTag:
            return $bAYSF(object);
        case $974c71bfd764326f$var$boolTag:
        case $974c71bfd764326f$var$dateTag:
            return new Ctor(+object);
        case $974c71bfd764326f$var$dataViewTag:
            return $2nf4s(object, isDeep);
        case $974c71bfd764326f$var$float32Tag:
        case $974c71bfd764326f$var$float64Tag:
        case $974c71bfd764326f$var$int8Tag:
        case $974c71bfd764326f$var$int16Tag:
        case $974c71bfd764326f$var$int32Tag:
        case $974c71bfd764326f$var$uint8Tag:
        case $974c71bfd764326f$var$uint8ClampedTag:
        case $974c71bfd764326f$var$uint16Tag:
        case $974c71bfd764326f$var$uint32Tag:
            return $39R3S(object, isDeep);
        case $974c71bfd764326f$var$mapTag:
            return new Ctor;
        case $974c71bfd764326f$var$numberTag:
        case $974c71bfd764326f$var$stringTag:
            return new Ctor(object);
        case $974c71bfd764326f$var$regexpTag:
            return $aOXy4(object);
        case $974c71bfd764326f$var$setTag:
            return new Ctor;
        case $974c71bfd764326f$var$symbolTag:
            return $cPFvk(object);
    }
}
module.exports = $974c71bfd764326f$var$initCloneByTag;

});

parcelRegister("2nf4s", function(module, exports) {

var $bAYSF = parcelRequire("bAYSF");

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $1ba96b89566301a8$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $bAYSF(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = $1ba96b89566301a8$var$cloneDataView;

});

parcelRegister("aOXy4", function(module, exports) {
/** Used to match `RegExp` flags from their coerced string values. */ var $7e0cc3fe33183417$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $7e0cc3fe33183417$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $7e0cc3fe33183417$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = $7e0cc3fe33183417$var$cloneRegExp;

});

parcelRegister("cPFvk", function(module, exports) {

var $2v1OR = parcelRequire("2v1OR");

/** Used to convert symbols to primitives and strings. */ var $957a7155a4d05ec8$var$symbolProto = $2v1OR ? $2v1OR.prototype : undefined, $957a7155a4d05ec8$var$symbolValueOf = $957a7155a4d05ec8$var$symbolProto ? $957a7155a4d05ec8$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $957a7155a4d05ec8$var$cloneSymbol(symbol) {
    return $957a7155a4d05ec8$var$symbolValueOf ? Object($957a7155a4d05ec8$var$symbolValueOf.call(symbol)) : {};
}
module.exports = $957a7155a4d05ec8$var$cloneSymbol;

});

parcelRegister("aBDCC", function(module, exports) {

var $aPSWx = parcelRequire("aPSWx");


var $gGzL7 = parcelRequire("gGzL7");


var $izBVL = parcelRequire("izBVL");

/* Node.js helper references. */ var $7b8c182c149a3e72$var$nodeIsMap = $izBVL && $izBVL.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $7b8c182c149a3e72$var$isMap = $7b8c182c149a3e72$var$nodeIsMap ? $gGzL7($7b8c182c149a3e72$var$nodeIsMap) : $aPSWx;
module.exports = $7b8c182c149a3e72$var$isMap;

});

parcelRegister("aPSWx", function(module, exports) {

var $jOCrv = parcelRequire("jOCrv");


var $7WFUU = parcelRequire("7WFUU");

/** `Object#toString` result references. */ var $7e3949613e91b78e$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $7e3949613e91b78e$var$baseIsMap(value) {
    return $7WFUU(value) && $jOCrv(value) == $7e3949613e91b78e$var$mapTag;
}
module.exports = $7e3949613e91b78e$var$baseIsMap;

});

parcelRegister("1ji1e", function(module, exports) {

var $l6Y5L = parcelRequire("l6Y5L");


var $gGzL7 = parcelRequire("gGzL7");


var $izBVL = parcelRequire("izBVL");

/* Node.js helper references. */ var $0f458af8916b54b7$var$nodeIsSet = $izBVL && $izBVL.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $0f458af8916b54b7$var$isSet = $0f458af8916b54b7$var$nodeIsSet ? $gGzL7($0f458af8916b54b7$var$nodeIsSet) : $l6Y5L;
module.exports = $0f458af8916b54b7$var$isSet;

});

parcelRegister("l6Y5L", function(module, exports) {

var $jOCrv = parcelRequire("jOCrv");


var $7WFUU = parcelRequire("7WFUU");

/** `Object#toString` result references. */ var $f5e8c58b63155910$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $f5e8c58b63155910$var$baseIsSet(value) {
    return $7WFUU(value) && $jOCrv(value) == $f5e8c58b63155910$var$setTag;
}
module.exports = $f5e8c58b63155910$var$baseIsSet;

});

parcelRegister("hcV0q", function(module, exports) {

var $aI4Cx = parcelRequire("aI4Cx");


var $gO1os = parcelRequire("gO1os");


var $3ye78 = parcelRequire("3ye78");


var $4yN45 = parcelRequire("4yN45");

/** Used for built-in method references. */ var $c86fc6d9079351ab$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c86fc6d9079351ab$var$hasOwnProperty = $c86fc6d9079351ab$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $c86fc6d9079351ab$var$baseUnset(object, path) {
    path = $aI4Cx(path, object);
    // Prevent prototype pollution:
    // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
    // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
    var index = -1, length = path.length;
    if (!length) return true;
    while(++index < length){
        var key = $4yN45(path[index]);
        // Always block "__proto__" anywhere in the path if it's not expected
        if (key === '__proto__' && !$c86fc6d9079351ab$var$hasOwnProperty.call(object, '__proto__')) return false;
        // Block constructor/prototype as non-terminal traversal keys to prevent
        // escaping the object graph into built-in constructors and prototypes.
        if ((key === 'constructor' || key === 'prototype') && index < length - 1) return false;
    }
    var obj = $3ye78(object, path);
    return obj == null || delete obj[$4yN45($gO1os(path))];
}
module.exports = $c86fc6d9079351ab$var$baseUnset;

});

parcelRegister("3ye78", function(module, exports) {

var $5g03W = parcelRequire("5g03W");


var $dAhdV = parcelRequire("dAhdV");

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $295f7eda793e290e$var$parent(object, path) {
    return path.length < 2 ? object : $5g03W(object, $dAhdV(path, 0, -1));
}
module.exports = $295f7eda793e290e$var$parent;

});

parcelRegister("ezTcL", function(module, exports) {

var $etJuK = parcelRequire("etJuK");

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $a9cf2821aeb590cb$var$customOmitClone(value) {
    return $etJuK(value) ? undefined : value;
}
module.exports = $a9cf2821aeb590cb$var$customOmitClone;

});

parcelRegister("jPzTX", function(module, exports) {

var $lyW2B = parcelRequire("lyW2B");


var $e7pPJ = parcelRequire("e7pPJ");


var $d246i = parcelRequire("d246i");

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $e6fea10dbb684687$var$flatRest(func) {
    return $d246i($e7pPJ(func, undefined, $lyW2B), func + '');
}
module.exports = $e6fea10dbb684687$var$flatRest;

});

parcelRegister("lyW2B", function(module, exports) {

var $avFJ9 = parcelRequire("avFJ9");

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $fb29cba7dcd09042$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $avFJ9(array, 1) : [];
}
module.exports = $fb29cba7dcd09042$var$flatten;

});

parcelRegister("avFJ9", function(module, exports) {

var $8kPaX = parcelRequire("8kPaX");


var $eED1E = parcelRequire("eED1E");

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $7a6d2ac83094702e$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $eED1E);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $7a6d2ac83094702e$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $8kPaX(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $7a6d2ac83094702e$var$baseFlatten;

});

parcelRegister("eED1E", function(module, exports) {

var $2v1OR = parcelRequire("2v1OR");


var $bZ5J1 = parcelRequire("bZ5J1");


var $1ScXu = parcelRequire("1ScXu");

/** Built-in value references. */ var $aab312c604d1130a$var$spreadableSymbol = $2v1OR ? $2v1OR.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $aab312c604d1130a$var$isFlattenable(value) {
    return $1ScXu(value) || $bZ5J1(value) || !!($aab312c604d1130a$var$spreadableSymbol && value && value[$aab312c604d1130a$var$spreadableSymbol]);
}
module.exports = $aab312c604d1130a$var$isFlattenable;

});

parcelRegister("hukUK", function(module, exports) {

var $9HkI0 = parcelRequire("9HkI0");


var $1AV5C = parcelRequire("1AV5C");

let $ad68a267ac2e31a8$var$SESSION_SALT;
const $ad68a267ac2e31a8$export$237ebf1f4974c28e = ()=>{
    $ad68a267ac2e31a8$var$SESSION_SALT = (0, (/*@__PURE__*/$parcel$interopDefault($9HkI0)))();
};
const $ad68a267ac2e31a8$var$toStringArray = (arr)=>`[${arr.map((item)=>$ad68a267ac2e31a8$var$toString(item)).join(',')}]`;
const $ad68a267ac2e31a8$var$toString = (o)=>{
    if (o === null) return 'null';
    if (Array.isArray(o)) return $ad68a267ac2e31a8$var$toStringArray(o);
    if (typeof o == 'object') return $ad68a267ac2e31a8$export$66b1d6a1029e925d(o);
    if (typeof o == 'string') return `"${o}"`;
    return `${o.toString()}`;
};
const $ad68a267ac2e31a8$export$66b1d6a1029e925d = (o)=>{
    if (!$ad68a267ac2e31a8$var$SESSION_SALT) $ad68a267ac2e31a8$export$237ebf1f4974c28e();
    const strToHash = `${Object.entries(o).filter(([_, value])=>typeof value !== 'undefined').sort((a, b)=>a[0].localeCompare(b[0])).map(([key, value])=>`${key}:${$ad68a267ac2e31a8$var$toString(value)}`).join()},${$ad68a267ac2e31a8$var$SESSION_SALT}`;
    return (0, $1AV5C.hashData)(strToHash);
};
module.exports["objectHash"] = $ad68a267ac2e31a8$export$66b1d6a1029e925d;

});

parcelRegister("aJPUt", function(module, exports) {
var $bcb0fe1d423eb4f4$export$5e180a90f8d3e374 = /*#__PURE__*/ function(ExperienceTimeout) {
    ExperienceTimeout[ExperienceTimeout["DEFAULT"] = 60000] = "DEFAULT";
    ExperienceTimeout[ExperienceTimeout["CREATE_CONTENT"] = 30000] = "CREATE_CONTENT";
    ExperienceTimeout[ExperienceTimeout["CREATE_DIALOG_LOAD"] = 60000] = "CREATE_DIALOG_LOAD";
    ExperienceTimeout[ExperienceTimeout["MACRO_LOAD"] = 60000] = "MACRO_LOAD";
    ExperienceTimeout[ExperienceTimeout["CREATE_COMMENT_PUBLISH"] = 15000] = "CREATE_COMMENT_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["EDITOR_LOAD"] = 45000] = "EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["EDITOR_PUBLISH"] = 60000] = "EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["LIVE_PAGE_PUBLISH"] = 30000] = "LIVE_PAGE_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_LOAD"] = 90000] = "TEMPLATE_EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_PUBLISH"] = 60000] = "TEMPLATE_EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATE_PANEL_LOAD"] = 20000] = "IN_EDITOR_TEMPLATE_PANEL_LOAD";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR"] = 90000] = "IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR";
    ExperienceTimeout[ExperienceTimeout["HOME"] = 20000] = "HOME";
    ExperienceTimeout[ExperienceTimeout["NAVIGATION_LOAD"] = 30000] = "NAVIGATION_LOAD";
    ExperienceTimeout[ExperienceTimeout["PAGE_LOAD"] = 60000] = "PAGE_LOAD";
    ExperienceTimeout[ExperienceTimeout["SELECT_INLINE_COMMMENT"] = 30000] = "SELECT_INLINE_COMMMENT";
    ExperienceTimeout[ExperienceTimeout["VIEW_INLINE_COMMENT"] = 30000] = "VIEW_INLINE_COMMENT";
    ExperienceTimeout[ExperienceTimeout["VIEW_PAGE_COMMENT"] = 30000] = "VIEW_PAGE_COMMENT";
    ExperienceTimeout[ExperienceTimeout["SPACE_DIRECTORY"] = 60000] = "SPACE_DIRECTORY";
    ExperienceTimeout[ExperienceTimeout["SPACE_VIEWS"] = 20000] = "SPACE_VIEWS";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE"] = 20000] = "TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_PREVIEW"] = 20000] = "TEMPLATE_PREVIEW";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_SUGGESTIONS"] = 20000] = "TEMPLATE_SUGGESTIONS";
    ExperienceTimeout[ExperienceTimeout["LOOM_PAGE_HEADER_CONTENT_INSERTION"] = 20000] = "LOOM_PAGE_HEADER_CONTENT_INSERTION";
    return ExperienceTimeout;
}({});
module.exports["ExperienceTimeout"] = $bcb0fe1d423eb4f4$export$5e180a90f8d3e374;

});

parcelRegister("1A7bE", function(module, exports) {

var $gykrH = parcelRequire("gykrH");

const $812facbbd37978f7$export$feb7963ae429f97f = (experienceNames)=>{
    const experienceNameSet = new Set(experienceNames);
    return (events, experience)=>{
        // Fail as soon as any sub-experience is failed or aborted
        experience.stopOn(events.find((event)=>experienceNameSet.has(event.name) && (event.action === 'taskFail' || event.action === 'taskAbort')), {
            incompleteSubExperiences: [
                ...experienceNameSet
            ].join(', ')
        });
        // If there's a success remove the experience from the set
        // of experiences we're waiting for.
        events.forEach((event)=>{
            if ((0, $gykrH.isStop)(event)) experienceNameSet.delete(event.name);
        });
        // Experience is considered complete if all sub-experiences
        // are complete.
        if (experienceNameSet.size === 0) experience.succeed();
    };
};
const $812facbbd37978f7$export$79dbdd3e43727beb = (experienceNames)=>(events, experience)=>experience.stopOn(events.find((event)=>(0, $gykrH.isStop)(event) && (0, $gykrH.hasName)(event, ...experienceNames)));
module.exports["collectAll"] = $812facbbd37978f7$export$feb7963ae429f97f;
module.exports["collectAny"] = $812facbbd37978f7$export$79dbdd3e43727beb;

});

parcelRegister("h10mo", function(module, exports) {

var $irVI7 = parcelRequire("irVI7");


var $fGzMp = parcelRequire("fGzMp");


var $1A7bE = parcelRequire("1A7bE");

const $49be9d39a158f0e7$var$homeSubExperiences = [
    (0, $irVI7.HOME_OVERVIEW_EXPERIENCE),
    (0, $irVI7.HOME_RECENT_EXPERIENCE),
    (0, $irVI7.HOME_STARRED_EXPERIENCE),
    (0, $irVI7.HOME_WATCHING_EXPERIENCE),
    (0, $irVI7.HOME_DRAFTS_EXPERIENCE)
];
function $49be9d39a158f0e7$export$4278268ff5675d74() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.HOME_EXPERIENCE),
        collect: (0, $1A7bE.collectAny)($49be9d39a158f0e7$var$homeSubExperiences)
    });
}
module.exports["startHome"] = $49be9d39a158f0e7$export$4278268ff5675d74;

});

parcelRegister("l6Xaz", function(module, exports) {
const $372ebd682f0fb003$var$SCRIPT_REGEX = /<script([^>]*)\/*>/gi;
// @ts-expect-error - TS1503 Typescript 5.9.2 upgrade
const $372ebd682f0fb003$var$QUOTES_REGEX = RegExp("^([\"']*)(?<value>.*?)\\1$");
const $372ebd682f0fb003$var$SPACE_REGEX = /\s+/;
function $372ebd682f0fb003$export$79fe7bf3ba344d67(tags, linksMode = false, matcher = $372ebd682f0fb003$var$SCRIPT_REGEX) {
    // Parse <script key="value">/script> into { key: "value" }
    if (linksMode) return Array.isArray(tags) ? tags.map((t)=>({
            src: t
        })) : [];
    if (typeof tags !== 'string') return [];
    const result = [];
    for (const [, attributes] of tags.matchAll(matcher))result.push(Object.fromEntries(attributes.split($372ebd682f0fb003$var$SPACE_REGEX).filter((pair)=>pair).map((pair)=>{
        const pos = pair.indexOf('=');
        if (pos !== -1) {
            const key = pair.substring(0, pos);
            const rawValue = pair.substring(pos + 1);
            const match = rawValue.match($372ebd682f0fb003$var$QUOTES_REGEX);
            const value = match?.groups?.value ?? rawValue;
            return [
                key,
                value
            ];
        } else return [
            pair,
            pair
        ];
    })));
    return result;
}
function $372ebd682f0fb003$export$a0d21c5c067fafcf(attributes) {
    // Convert { key: value } to key="value"
    const result = Object.entries(attributes).map(([key, value])=>value && key !== value ? `${key}="${value}"` : key).join(' ');
    return result ? ` ${result}` : '';
}
function $372ebd682f0fb003$export$eccc4243452442c6(tags) {
    // Jquery is always loaded in packages/confluence-frontend-server/templates/html/dashboard-spa-container.js
    // So we need to remove it from the superbatch tags
    return $372ebd682f0fb003$export$79fe7bf3ba344d67(tags).filter((attrs)=>attrs['data-wrm-key'] !== 'com.atlassian.plugins.jquery:jquery').map((attrs)=>`<script${$372ebd682f0fb003$export$a0d21c5c067fafcf(attrs)}></script>`).join('\n');
}
function $372ebd682f0fb003$export$a26b30913d2c455f(tags) {
    return $372ebd682f0fb003$export$79fe7bf3ba344d67(tags).map((attributes)=>{
        attributes['defer'] = 'defer';
        return `<script${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)}></script>`;
    }).join('\n');
}
const $372ebd682f0fb003$var$srcExtractor = /src=["'](.*?)["']/gi;
function $372ebd682f0fb003$export$7ffad14b7106f714(jsTags) {
    if (!jsTags) return '';
    return [
        ...jsTags.matchAll($372ebd682f0fb003$var$srcExtractor)
    ].map((match)=>match[1]).filter((src)=>!!src).map((src)=>`<link rel="preload" href="${src}" as="script">`).join('\n');
}
function $372ebd682f0fb003$export$893dc3b18722ac51(resource, asyncScript = false) {
    const nonce = window.__SSR_NONCE_VALUE__;
    const attributes = Array.isArray(resource?.attributes) ? Object.fromEntries(resource.attributes.map((attr)=>[
            attr.key,
            attr.value
        ])) : resource.attributes || {};
    if (resource.type === 'css') return `<link rel="stylesheet" nonce="${nonce}" href="${resource.url}"${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)} />`;
    else if (resource.type === 'js') return `<script nonce="${nonce}" src="${resource.url}"${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)}${asyncScript ? ' async fetchpriority="high"' : ''}></script>`;
    return '';
}
module.exports["parseScriptTags"] = $372ebd682f0fb003$export$79fe7bf3ba344d67;
module.exports["removeJquery"] = $372ebd682f0fb003$export$eccc4243452442c6;
module.exports["deferScript"] = $372ebd682f0fb003$export$a26b30913d2c455f;
module.exports["convertSuperBatchResourceToTags"] = $372ebd682f0fb003$export$893dc3b18722ac51;

});

parcelRegister("2iGHk", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b090c2970a43735$export$2e2bcd8739ae039);
var $3b090c2970a43735$export$2e2bcd8739ae039 = (channel)=>(payload)=>(createAnalyticsEvent)=>{
            const consumerEvent = createAnalyticsEvent(payload);
            const clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };

});

parcelRegister("gTPfK", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $gBjHb = parcelRequire("gBjHb");

const $6057e25d3e7f93e3$var$withAnalyticsContext = (defaultData)=>(WrappedComponent)=>{
        const WithAnalyticsContext = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
            const $ = (0, $bDgLe.c)(11);
            let analyticsContext;
            let rest;
            if ($[0] !== t0) {
                ({ analyticsContext: analyticsContext, ...rest } = t0);
                $[0] = t0;
                $[1] = analyticsContext;
                $[2] = rest;
            } else {
                analyticsContext = $[1];
                rest = $[2];
            }
            let t1;
            if ($[3] !== analyticsContext) {
                t1 = {
                    ...defaultData,
                    ...analyticsContext
                };
                $[3] = analyticsContext;
                $[4] = t1;
            } else t1 = $[4];
            const analyticsData = t1;
            const t2 = rest;
            let t3;
            if ($[5] !== ref || $[6] !== t2) {
                t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
                    ...t2,
                    ref: ref
                });
                $[5] = ref;
                $[6] = t2;
                $[7] = t3;
            } else t3 = $[7];
            let t4;
            if ($[8] !== analyticsData || $[9] !== t3) {
                t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
                    data: analyticsData
                }, t3);
                $[8] = analyticsData;
                $[9] = t3;
                $[10] = t4;
            } else t4 = $[10];
            return t4;
        } : ({ analyticsContext: analyticsContext, ...rest }, ref)=>{
            const analyticsData = (0, $cozmU.useMemo)(()=>({
                    ...defaultData,
                    ...analyticsContext
                }), [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
                data: analyticsData
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
                ...rest,
                ref: ref
            }));
        });
        WithAnalyticsContext.displayName = `WithAnalyticsContext(${WrappedComponent.displayName || WrappedComponent.name})`;
        return WithAnalyticsContext;
    };
var $6057e25d3e7f93e3$export$2e2bcd8739ae039 = $6057e25d3e7f93e3$var$withAnalyticsContext;
module.exports["default"] = $6057e25d3e7f93e3$export$2e2bcd8739ae039;

});

parcelRegister("4Uejl", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jlWUB = parcelRequire("jlWUB");


var $lrDw7 = parcelRequire("lrDw7");


var $7BVQi = parcelRequire("7BVQi");


var $g3XYx = parcelRequire("g3XYx");


var $1U6E9 = parcelRequire("1U6E9");


var $jhrdR = parcelRequire("jhrdR");

/**
 * Parses a CSS time value (e.g. `"0.2s"` or `"200ms"`) and returns milliseconds.
 * Falls back to 0 if the value cannot be parsed.
 */ function $8b8583a0a90649e3$var$parseCSSTimeToMs(value) {
    const parsed = parseFloat(value);
    if (Number.isNaN(parsed)) return 0;
    if (value.endsWith('ms')) return parsed;
    return parsed * 1000;
}
/**
 * Returns `true` if any of the dimension(s) being animated have changed
 * between the previous and next measurements.
 */ function $8b8583a0a90649e3$var$hasDimensionChanged(dimension, prev, next) {
    if (dimension === 'width') return prev.width !== next.width;
    if (dimension === 'height') return prev.height !== next.height;
    return prev.width !== next.width || prev.height !== next.height;
}
/**
 * Returns the CSS `transition-property` / `will-change` value for the
 * given dimension(s).
 */ function $8b8583a0a90649e3$var$getDimensionPropertyList(dimension) {
    if (dimension === 'both') return 'width, height';
    return dimension;
}
const $8b8583a0a90649e3$export$a300664a1a230956 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion } = t0;
    const prevDimensions = (0, $cozmU.useRef)();
    const [element, setElementRef] = (0, $lrDw7.useElementRef)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            cleanup: "next-effect"
        };
        $[0] = t1;
    } else t1 = $[0];
    const setTimeout = (0, $1U6E9.useSetTimeout)(t1);
    const requestAnimationFrame = (0, $g3XYx.useRequestAnimationFrame)();
    let t2;
    if ($[1] !== element) {
        t2 = ()=>{
            if ((0, $jlWUB.isReducedMotion)() || !element) return;
            const rect = element.getBoundingClientRect();
            prevDimensions.current = {
                width: rect.width,
                height: rect.height
            };
        };
        $[1] = element;
        $[2] = t2;
    } else t2 = $[2];
    (0, $jhrdR.useSnapshotBeforeUpdate)(t2);
    let t3;
    if ($[3] !== dimension || $[4] !== duration || $[5] !== easing || $[6] !== element || $[7] !== onFinishMotion || $[8] !== requestAnimationFrame || $[9] !== setTimeout) {
        t3 = ()=>{
            if ((0, $jlWUB.isReducedMotion)() || !element || !prevDimensions.current) return;
            element.setAttribute("style", "");
            const rect_0 = element.getBoundingClientRect();
            const nextDimensions = {
                width: rect_0.width,
                height: rect_0.height
            };
            if (!$8b8583a0a90649e3$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
                onFinishMotion?.();
                return;
            }
            const propertyList = $8b8583a0a90649e3$var$getDimensionPropertyList(dimension);
            const newStyles = {
                willChange: propertyList,
                transitionProperty: propertyList,
                transitionDuration: duration,
                boxSizing: "border-box",
                transitionTimingFunction: easing
            };
            if (dimension === "width" || dimension === "both") newStyles.width = `${prevDimensions.current.width}px`;
            if (dimension === "height" || dimension === "both") newStyles.height = `${prevDimensions.current.height}px`;
            Object.assign(element.style, newStyles);
            const resolvedDuration = $8b8583a0a90649e3$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    if (!element) return;
                    if (dimension === "width" || dimension === "both") element.style.width = `${nextDimensions.width}px`;
                    if (dimension === "height" || dimension === "both") element.style.height = `${nextDimensions.height}px`;
                    setTimeout(()=>{
                        if (!element) return;
                        element.setAttribute("style", "");
                        onFinishMotion?.();
                    }, resolvedDuration);
                });
            });
        };
        $[3] = dimension;
        $[4] = duration;
        $[5] = easing;
        $[6] = element;
        $[7] = onFinishMotion;
        $[8] = requestAnimationFrame;
        $[9] = setTimeout;
        $[10] = t3;
    } else t3 = $[10];
    (0, $7BVQi.useLayoutEffect)(t3);
    let t4;
    if ($[11] !== setElementRef) {
        t4 = {
            ref: setElementRef
        };
        $[11] = setElementRef;
        $[12] = t4;
    } else t4 = $[12];
    return t4;
} : ({ dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion })=>{
    const prevDimensions = (0, $cozmU.useRef)();
    const [element, setElementRef] = (0, $lrDw7.useElementRef)();
    const setTimeout = (0, $1U6E9.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $g3XYx.useRequestAnimationFrame)();
    (0, $jhrdR.useSnapshotBeforeUpdate)(()=>{
        if ((0, $jlWUB.isReducedMotion)() || !element) return;
        const rect = element.getBoundingClientRect();
        prevDimensions.current = {
            width: rect.width,
            height: rect.height
        };
    });
    (0, $7BVQi.useLayoutEffect)(()=>{
        if ((0, $jlWUB.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination dimensions first.
        element.setAttribute('style', '');
        const rect_0 = element.getBoundingClientRect();
        const nextDimensions = {
            width: rect_0.width,
            height: rect_0.height
        };
        if (!$8b8583a0a90649e3$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
            onFinishMotion?.();
            return;
        }
        const propertyList = $8b8583a0a90649e3$var$getDimensionPropertyList(dimension);
        const newStyles = {
            willChange: propertyList,
            transitionProperty: propertyList,
            transitionDuration: duration,
            boxSizing: 'border-box',
            transitionTimingFunction: easing
        };
        if (dimension === 'width' || dimension === 'both') newStyles.width = `${prevDimensions.current.width}px`;
        if (dimension === 'height' || dimension === 'both') newStyles.height = `${prevDimensions.current.height}px`;
        Object.assign(element.style, newStyles);
        const resolvedDuration = $8b8583a0a90649e3$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                if (dimension === 'width' || dimension === 'both') element.style.width = `${nextDimensions.width}px`;
                if (dimension === 'height' || dimension === 'both') element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                    onFinishMotion?.();
                }, resolvedDuration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
module.exports["useResizing"] = $8b8583a0a90649e3$export$a300664a1a230956;

});

parcelRegister("lrDw7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $6a66563ef19581ba$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $cozmU.useRef)(null);
    const setRef = (0, $cozmU.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};
module.exports["useElementRef"] = $6a66563ef19581ba$export$ff879f35a69d56b7;

});

parcelRegister("g3XYx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $f8fe10123ae9dc81$var$getHookDeps = (opts)=>{
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
const $f8fe10123ae9dc81$export$1775f27e7c8051ca = (opts = {
    cleanup: 'unmount'
})=>{
    const frames = (0, $cozmU.useRef)([]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (frames.current.length) {
                frames.current.forEach((id)=>cancelAnimationFrame(id));
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $f8fe10123ae9dc81$var$getHookDeps(opts));
    return (0, $cozmU.useCallback)((handler)=>{
        const id = requestAnimationFrame((time)=>{
            frames.current = frames.current.filter((frameId)=>frameId !== id);
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
module.exports["useRequestAnimationFrame"] = $f8fe10123ae9dc81$export$1775f27e7c8051ca;

});

parcelRegister("jhrdR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7BVQi = parcelRequire("7BVQi");

const $8584e1bffd64d1d0$export$9e95200239cd148b = (cb)=>{
    const isFirstRender = (0, $cozmU.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $7BVQi.useLayoutEffect)(()=>{
        isFirstRender.current = false;
    }, []);
};
module.exports["useSnapshotBeforeUpdate"] = $8584e1bffd64d1d0$export$9e95200239cd148b;

});

parcelRegister("as9lu", function(module, exports) {

var $aQ0yV = parcelRequire("aQ0yV");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/identity/user/manifest.ts
var $79c3c4c484846d28$var$identityUserAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $aQ0yV.IdentityUserAriResourceOwner),
    resourceType: (0, $aQ0yV.IdentityUserAriResourceType),
    resourceIdSlug: "{userId}",
    resourceIdSegmentFormats: {
        userId: /[a-zA-Z0-9_\-\:]{1,128}/
    }
};
// src/identity/user/index.ts
var $79c3c4c484846d28$export$1e9d09c2be53e55e = class _IdentityUserAri extends (0, $1gKSA.RegisteredAri) {
    get userId() {
        return this._userId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $79c3c4c484846d28$var$identityUserAriStaticOpts.qualifier,
            platformQualifier: $79c3c4c484846d28$var$identityUserAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $79c3c4c484846d28$var$identityUserAriStaticOpts.resourceOwner,
            resourceType: $79c3c4c484846d28$var$identityUserAriStaticOpts.resourceType,
            resourceId: `${opts.userId}`,
            resourceIdSegmentValues: {
                userId: opts.userId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $79c3c4c484846d28$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $79c3c4c484846d28$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(opts);
    }
    getVariables() {
        return {
            userId: this.userId
        };
    }
    constructor(opts){
        super(opts), this._userId = opts.resourceIdSegmentValues.userId;
    }
};
module.exports["IdentityUserAri"] = $79c3c4c484846d28$export$1e9d09c2be53e55e;

});

parcelRegister("aQ0yV", function(module, exports) {
// src/identity/user/types.ts
var $7e3f325f95b56bab$export$b4c14c54282a779d = "identity", $7e3f325f95b56bab$export$e9b50e20f4fbfb71 = "user";
module.exports["IdentityUserAriResourceOwner"] = $7e3f325f95b56bab$export$b4c14c54282a779d;
module.exports["IdentityUserAriResourceType"] = $7e3f325f95b56bab$export$e9b50e20f4fbfb71;

});

parcelRegister("iEfsZ", function(module, exports) {
/**
 * @generated SignedSource<<50efd21e0db5811e6867b792d80a2f0a>>
 * @relayHash 0006505c7639efb87b37fdf9e06ba577
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 80be86e03026fa8a830d5e044cf1c52c928ef2f41b95e7043d2c72827ef95173
const $7f80a392f18860bd$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "location"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "locations"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "version"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "label"
    }, v7 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v8 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "location",
                    "variableName": "location"
                },
                {
                    "kind": "Variable",
                    "name": "locations",
                    "variableName": "locations"
                },
                {
                    "kind": "Variable",
                    "name": "version",
                    "variableName": "version"
                }
            ],
            "concreteType": "WebSection",
            "kind": "LinkedField",
            "name": "webItemSections",
            "plural": true,
            "selections": [
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "cacheKey"
                },
                v7 /*: any*/ ,
                {
                    "concreteType": "WebItem",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "accessKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "completeKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasCondition"
                        },
                        v5 /*: any*/ ,
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "height"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "width"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        },
                        {
                            "concreteType": "MapOfStringToString",
                            "kind": "LinkedField",
                            "name": "params",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        },
                        v6 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "moduleKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "section"
                        },
                        v7 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "tooltip"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "url"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "urlWithoutContextPath"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "weight"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "WebItemLocationQuery",
            "selections": v8 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "WebItemLocationQuery",
            "selections": v8 /*: any*/ 
        },
        "params": {
            "cacheID": "0006505c7639efb87b37fdf9e06ba577",
            "id": "80be86e03026fa8a830d5e044cf1c52c928ef2f41b95e7043d2c72827ef95173",
            "metadata": {},
            "name": "WebItemLocationQuery",
            "operationKind": "query",
            "text": "query WebItemLocationQuery($location:String,$locations:[String],$contentId:ID,$spaceKey:String,$version:Int){webItemSections(location:$location,locations:$locations,contentId:$contentId,key:$spaceKey,version:$version){id,label,cacheKey,styleClass,items{accessKey,completeKey,hasCondition,id,icon{height,width,path},params{key,value},label,moduleKey,section,styleClass,tooltip,url,urlWithoutContextPath,weight}}}"
        }
    };
}();
$7f80a392f18860bd$var$node.hash = "8e88912bf23040d88bbeb5c8cadae7c2";
var $7f80a392f18860bd$export$2e2bcd8739ae039 = $7f80a392f18860bd$var$node;
module.exports["default"] = $7f80a392f18860bd$export$2e2bcd8739ae039;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$3d2f468c166bad70 = 'confluence:attachmentAction';
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$3d2f468c166bad70,
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_ATTACHMENT_ACTION"] = $af2b0e533822f413$export$3d2f468c166bad70;
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;

});

parcelRegister("iKWdo", function(module, exports) {

var $j6gAQ = parcelRequire("j6gAQ");


var $1Rned = parcelRequire("1Rned");

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $da79ae2b1521df52$var$uniqBy(array, iteratee) {
    return array && array.length ? $1Rned(array, $j6gAQ(iteratee, 2)) : [];
}
module.exports = $da79ae2b1521df52$var$uniqBy;

});

parcelRegister("1Rned", function(module, exports) {

var $dLza3 = parcelRequire("dLza3");


var $gqaVn = parcelRequire("gqaVn");


var $3wyDU = parcelRequire("3wyDU");


var $jG16D = parcelRequire("jG16D");


var $4sYWJ = parcelRequire("4sYWJ");


var $j8WYy = parcelRequire("j8WYy");

/** Used as the size to enable large array optimizations. */ var $15acc2503c30cdc7$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $15acc2503c30cdc7$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $gqaVn, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $3wyDU;
    } else if (length >= $15acc2503c30cdc7$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $4sYWJ(array);
        if (set) return $j8WYy(set);
        isCommon = false;
        includes = $jG16D;
        seen = new $dLza3;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $15acc2503c30cdc7$var$baseUniq;

});

parcelRegister("gqaVn", function(module, exports) {

var $62lK8 = parcelRequire("62lK8");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $bf478c6b28a93eba$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $62lK8(array, value, 0) > -1;
}
module.exports = $bf478c6b28a93eba$var$arrayIncludes;

});

parcelRegister("62lK8", function(module, exports) {

var $7jN2X = parcelRequire("7jN2X");


var $4Jcz7 = parcelRequire("4Jcz7");


var $jMyMb = parcelRequire("jMyMb");

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $4653cbb84a510850$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $jMyMb(array, value, fromIndex) : $7jN2X(array, $4Jcz7, fromIndex);
}
module.exports = $4653cbb84a510850$var$baseIndexOf;

});

parcelRegister("7jN2X", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $55405a69ad8b093d$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $55405a69ad8b093d$var$baseFindIndex;

});

parcelRegister("4Jcz7", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $37151c9a2b945fe4$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $37151c9a2b945fe4$var$baseIsNaN;

});

parcelRegister("jMyMb", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $e66d79db7455d8ea$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $e66d79db7455d8ea$var$strictIndexOf;

});

parcelRegister("3wyDU", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $290f3b94ccd981c7$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $290f3b94ccd981c7$var$arrayIncludesWith;

});

parcelRegister("4sYWJ", function(module, exports) {

var $lE8ES = parcelRequire("lE8ES");


var $jEK83 = parcelRequire("jEK83");


var $j8WYy = parcelRequire("j8WYy");

/** Used as references for various `Number` constants. */ var $34090d9ff4ab3dd6$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $34090d9ff4ab3dd6$var$createSet = !($lE8ES && 1 / $j8WYy(new $lE8ES([
    ,
    -0
]))[1] == $34090d9ff4ab3dd6$var$INFINITY) ? $jEK83 : function(values) {
    return new $lE8ES(values);
};
module.exports = $34090d9ff4ab3dd6$var$createSet;

});

parcelRegister("jEK83", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $e4f588fe3a77f67d$var$noop() {
// No operation performed.
}
module.exports = $e4f588fe3a77f67d$var$noop;

});

parcelRegister("j39Hd", function(module, exports) {

var $2g31M = parcelRequire("2g31M");

const $53f448a1a60c9e76$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
async function $53f448a1a60c9e76$export$b5fe3f66a567bec0(method, url, data, headers, statuses = $53f448a1a60c9e76$var$ALLOWED_RESPONSE_STATUS_CODES) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || statuses?.includes(response.status)) {
            if (statuses.includes(204)) {
                const text = await response.text();
                // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
                return text ? JSON.parse(text) : undefined;
            } else return await response.json();
        }
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new (0, $2g31M.NetworkError)(error);
        throw error;
    }
}
module.exports["request"] = $53f448a1a60c9e76$export$b5fe3f66a567bec0;

});

parcelRegister("2g31M", function(module, exports) {
class $70283a430bb4f4fe$export$bae979e68e4dc802 extends Error {
    constructor(error){
        super(error);
    }
}
module.exports["NetworkError"] = $70283a430bb4f4fe$export$bae979e68e4dc802;

});

parcelRegister("3xsB6", function(module, exports) {
/* eslint-disable require-unicode-regexp */ const $a2c616dead6b3b85$var$GET_LOCAL_ID_FROM_BLOCK_RESOURCE_ID_REGEX = /ari:cloud:blocks:[^:]+:synced-block\/([a-zA-Z0-9-]+)/;
const $a2c616dead6b3b85$var$JIRA_SOURCE_ARI_REGEX = /ari:cloud:jira:.*/;
const $a2c616dead6b3b85$var$CONFLUENCE_SOURCE_ARI_REGEX = /ari:cloud:confluence:.*/;
const $a2c616dead6b3b85$export$e79189cdb9940bc5 = ({ cloudId: cloudId, parentId: parentId, product: product, resourceId: resourceId })=>{
    return `ari:cloud:blocks:${cloudId}:synced-block/${product}/${parentId}/${resourceId}`;
};
const $a2c616dead6b3b85$export$92a2331f8a9ed841 = ({ cloudId: cloudId, resourceId: resourceId })=>{
    return `ari:cloud:blocks:${cloudId}:synced-block/${resourceId}`;
};
const $a2c616dead6b3b85$export$3f0878b0afe5a2c0 = (ari)=>{
    const match = ari.match($a2c616dead6b3b85$var$GET_LOCAL_ID_FROM_BLOCK_RESOURCE_ID_REGEX);
    if (match?.[1]) return match[1];
    throw new Error(`Invalid block ARI: ${ari}`);
};
const $a2c616dead6b3b85$export$c10656f449ea0fb5 = (ari)=>{
    const jiraMatch = ari?.search($a2c616dead6b3b85$var$JIRA_SOURCE_ARI_REGEX);
    if (jiraMatch !== -1) return 'jira-work-item';
    const confluenceMatch = ari?.search($a2c616dead6b3b85$var$CONFLUENCE_SOURCE_ARI_REGEX);
    if (confluenceMatch !== -1) return 'confluence-page';
    return undefined;
};
module.exports["generateBlockAri"] = $a2c616dead6b3b85$export$e79189cdb9940bc5;
module.exports["generateBlockAriFromReference"] = $a2c616dead6b3b85$export$92a2331f8a9ed841;
module.exports["getProductFromSourceAri"] = $a2c616dead6b3b85$export$c10656f449ea0fb5;

});

parcelRegister("79ir6", function(module, exports) {
var $2ca041ce04439e9b$export$686dd843fdf311d4 = /*#__PURE__*/ function(SyncBlockError) {
    SyncBlockError["Errored"] = "errored";
    SyncBlockError["NotFound"] = "not_found";
    SyncBlockError["Forbidden"] = "forbidden";
    SyncBlockError["InvalidRequest"] = "invalid_request";
    SyncBlockError["RateLimited"] = "rate_limited";
    SyncBlockError["Conflict"] = "conflict";
    // attempt to create block that already exists
    SyncBlockError["ServerError"] = "server_error";
    SyncBlockError["InvalidContent"] = "invalid_content";
    // content is not a valid JSON
    SyncBlockError["Offline"] = "offline";
    SyncBlockError["Unpublished"] = "unpublished";
    // request was aborted, typically due to client timeout
    SyncBlockError["Aborted"] = "aborted";
    // block does not exist on this site (e.g. cross-site reference or hard deleted)
    SyncBlockError["EntityNotFound"] = "entity_not_found";
    return SyncBlockError;
}({});
const $2ca041ce04439e9b$export$7486a7adf8b0d591 = 'Data provider not set';
class $2ca041ce04439e9b$export$ca0858d4f5eeeac extends Error {
    constructor(message = $2ca041ce04439e9b$export$7486a7adf8b0d591){
        super(message);
        this.isProviderNotReadyError = true;
        this.name = 'ProviderNotReadyError';
        // Restore prototype chain so instanceof works after transpilation.
        Object.setPrototypeOf(this, $2ca041ce04439e9b$export$ca0858d4f5eeeac.prototype);
    }
}
const $2ca041ce04439e9b$export$7ba508051f94701f = (error)=>{
    if (error instanceof $2ca041ce04439e9b$export$ca0858d4f5eeeac) return true;
    if (typeof error === 'object' && error !== null && error.isProviderNotReadyError === true) return true;
    return error instanceof Error && error.message === $2ca041ce04439e9b$export$7486a7adf8b0d591;
};
module.exports["SyncBlockError"] = $2ca041ce04439e9b$export$686dd843fdf311d4;
module.exports["ProviderNotReadyError"] = $2ca041ce04439e9b$export$ca0858d4f5eeeac;
module.exports["isProviderNotReadyError"] = $2ca041ce04439e9b$export$7ba508051f94701f;

});

parcelRegister("916Gd", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $79ir6 = parcelRequire("79ir6");

const $5f570f8dd9ccb4e4$export$7fc2c997455452c8 = (error)=>{
    try {
        return JSON.stringify(error);
    } catch  {
        return undefined;
    }
};
const $5f570f8dd9ccb4e4$export$74ce7fda6da1109 = (error)=>{
    if (error instanceof Error) return {
        ...error.message && {
            originalMessage: error.message
        },
        ...error.name && {
            originalName: error.name
        }
    };
    return {};
};
const $5f570f8dd9ccb4e4$var$SYNC_BLOCK_ERROR_REASONS = new Set(Object.values((0, $79ir6.SyncBlockError)));
const $5f570f8dd9ccb4e4$export$3bf11deac13e0617 = (error)=>{
    if (error && $5f570f8dd9ccb4e4$var$SYNC_BLOCK_ERROR_REASONS.has(error)) return error;
    return 'unknown';
};
const $5f570f8dd9ccb4e4$export$78792f4ddc3998e8 = (error, statusCode)=>{
    return {
        reason: $5f570f8dd9ccb4e4$export$3bf11deac13e0617(error),
        ...statusCode !== undefined && {
            statusCode: statusCode
        }
    };
};
const $5f570f8dd9ccb4e4$export$9bd766f5cc31fe3b = new Set([
    'source_deleted',
    'source_unpublished',
    'source_unsynced',
    'source_not_found',
    'permission_denied',
    'unauthenticated',
    // Mirror the benign write-path enum equivalents so already-classified errors are
    // treated consistently.
    'not_found',
    'forbidden',
    'unpublished',
    // `offline` is an expected client connectivity state, not a read-path system failure:
    // the error component is rendered for the offline experience, so it should not inflate
    // the true error rate. It still emits `reason` (so its volume can be inspected) but is
    // excluded from true-error counts.
    'offline'
]);
/**
 * Ordered list of substring matchers mapping known free-text fetch/subscribe error
 * strings to a categorical {@link SyncBlockFetchErrorReason}. Each entry is a list of
 * lowercase needles; if ANY needle is found (case-insensitively) in the raw `error`
 * string, the entry's reason is used. Order matters: more specific entries must precede
 * more general ones.
 *
 * Plain `String.includes` substring matching is used deliberately instead of `RegExp`:
 * it sidesteps the `require-unicode-regexp` lint rule AND the declaration build's lower
 * compile target (which rejects the regex `u` flag with TS1501), while being faster and
 * easier to read. Doing this classification in code (rather than in dashboard SQL) keeps
 * the buckets versioned with the source strings that produce them (EDITOR-7862).
 */ const $5f570f8dd9ccb4e4$var$FETCH_REASON_MATCHERS = [
    // Benign: source-state transitions (deletionReason values + free text).
    [
        [
            'source-document-deleted'
        ],
        'source_deleted'
    ],
    [
        [
            'source-block-deleted'
        ],
        'source_deleted'
    ],
    [
        [
            'source-block-unpublished'
        ],
        'source_unpublished'
    ],
    [
        [
            'source-block-unsynced'
        ],
        'source_unsynced'
    ],
    [
        [
            'does not exist'
        ],
        'source_not_found'
    ],
    [
        [
            'unpublished'
        ],
        'source_unpublished'
    ],
    // Working-as-designed permission outcomes.
    [
        [
            'unauthenticated'
        ],
        'unauthenticated'
    ],
    [
        [
            'not permitted to read synced block'
        ],
        'permission_denied'
    ],
    [
        [
            'bulk permission check failed'
        ],
        'permission_denied'
    ],
    [
        [
            'permission denied'
        ],
        'permission_denied'
    ],
    // Genuine system failures.
    [
        [
            'reconnection failed after'
        ],
        'websocket_exhausted'
    ],
    // `reconnect to the subscription` (not a bare `reconnect`) avoids false positives on
    // unrelated DB/GraphQL "reconnect" messages while still matching the WS-drop string.
    [
        [
            'websocket',
            'reconnect to the subscription',
            'subscription terminated'
        ],
        'websocket_drop'
    ],
    [
        [
            '429',
            'rate limit',
            'rate-limit',
            'ratelimit'
        ],
        'rate_limited'
    ],
    // `econnrefused`/`econnreset` (not a bare `econn`, which would also match `reconnect`).
    [
        [
            'network',
            'failed to fetch',
            'econnrefused',
            'econnreset',
            'timed out',
            'timeout'
        ],
        'network'
    ],
    [
        [
            'data provider not set'
        ],
        'data_provider_not_ready'
    ]
];
const $5f570f8dd9ccb4e4$export$b7fb09a58aa76c55 = (error)=>{
    const enumReason = $5f570f8dd9ccb4e4$export$3bf11deac13e0617(error);
    if (enumReason !== 'unknown') return enumReason;
    if (error) {
        const haystack = error.toLowerCase();
        for (const [needles, reason] of $5f570f8dd9ccb4e4$var$FETCH_REASON_MATCHERS){
            if (needles.some((needle)=>haystack.includes(needle))) return reason;
        }
    }
    return 'unknown';
};
const $5f570f8dd9ccb4e4$export$4ae89cef01c11c46 = (error, statusCode, deferred)=>{
    const reason = $5f570f8dd9ccb4e4$export$b7fb09a58aa76c55(error);
    return {
        reason: reason,
        // A deferred (tab-hidden) exhaustion is benign regardless of reason bucket.
        benign: deferred === true || $5f570f8dd9ccb4e4$export$9bd766f5cc31fe3b.has(reason),
        ...statusCode !== undefined && {
            statusCode: statusCode
        },
        ...deferred === true && {
            deferred: true
        }
    };
};
function $5f570f8dd9ccb4e4$export$999ed1af1b20ac2d(actionSubjectId, error, resourceId, sourceProduct, attribution) {
    return {
        action: (0, $krYZG.ACTION).ERROR,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: actionSubjectId,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            error: error,
            ...resourceId && {
                resourceId: resourceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            },
            ...attribution?.reason && {
                reason: attribution.reason
            },
            ...attribution?.statusCode !== undefined && {
                statusCode: attribution.statusCode
            },
            // `benign` is only present on fetch/subscribe attribution (EDITOR-7862). It is a
            // boolean (never UGC); the `'benign' in attribution` check both guards the
            // write-path attribution (which has no `benign`) and narrows the union so
            // `attribution.benign` is accessible.
            ...attribution && 'benign' in attribution && {
                benign: attribution.benign
            },
            // `deferred` is only present on fetch/subscribe attribution, and only when a
            // tab-hidden exhaustion was deferred rather than surfaced. Boolean, never UGC.
            ...attribution && 'deferred' in attribution && attribution.deferred === true && {
                deferred: true
            }
        }
    };
}
const $5f570f8dd9ccb4e4$export$94dcd08406353dba = (error, resourceId, sourceProduct, attribution)=>// Branch on attribution presence so each call resolves to a concrete overload: with
    // attribution it hits the fetch overload (wider `reason`); without it, the
    // no-attribution overload. Both produce a fetch event regardless.
    attribution ? $5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH, error, resourceId, sourceProduct, attribution) : $5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH, error, resourceId, sourceProduct);
const $5f570f8dd9ccb4e4$export$c5131f589148b9d3 = (error, resourceId, sourceProduct)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_GET_SOURCE_INFO, error, resourceId, sourceProduct);
const $5f570f8dd9ccb4e4$export$adc2363832f8735d = (error, resourceId, sourceProduct, attribution)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_UPDATE, error, resourceId, sourceProduct, attribution);
const $5f570f8dd9ccb4e4$export$154595d209a77913 = (error, resourceId, sourceProduct, attribution)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).REFERENCE_SYNCED_BLOCK_UPDATE, error, resourceId, sourceProduct, attribution);
const $5f570f8dd9ccb4e4$export$5d2f0c264cf49280 = (error, resourceId, sourceProduct, attribution)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_CREATE, error, resourceId, sourceProduct, attribution);
const $5f570f8dd9ccb4e4$export$cd0aaab38ff32ec2 = (error, resourceId, sourceProduct, attribution)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_DELETE, error, resourceId, sourceProduct, attribution);
const $5f570f8dd9ccb4e4$export$e40ed1768baf5d1e = (error, resourceId, sourceProduct)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_UPDATE_CACHE, error, resourceId, sourceProduct);
const $5f570f8dd9ccb4e4$export$5665a31a69693485 = (resourceId, sourceProduct, context)=>({
        action: (0, $krYZG.ACTION).ERROR,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_SOURCE_INFO_ORPHANED,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            ...resourceId && {
                resourceId: resourceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            },
            ...context?.hasPendingDeletion !== undefined && {
                hasPendingDeletion: context.hasPendingDeletion
            },
            ...context?.hasSubscribers !== undefined && {
                hasSubscribers: context.hasSubscribers
            }
        }
    });
const $5f570f8dd9ccb4e4$export$82f9608c8438ecb2 = (rescheduleCount, resourceId, sourceProduct)=>({
        action: (0, $krYZG.ACTION).ERROR,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_CACHE_DELETION_FORCED,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            rescheduleCount: rescheduleCount,
            ...resourceId && {
                resourceId: resourceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    });
const $5f570f8dd9ccb4e4$export$ebf3ba305f3f0e1a = (error, resourceId, sourceProduct)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH_REFERENCES, error, resourceId, sourceProduct);
const $5f570f8dd9ccb4e4$export$b20c56c32ea6ad76 = (resourceId, blockInstanceId, sourceProduct)=>({
        action: (0, $krYZG.ACTION).FETCHED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            blockInstanceId: blockInstanceId,
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    });
const $5f570f8dd9ccb4e4$export$5b8e0915870366d0 = (resourceId, sourceProduct)=>{
    return {
        action: (0, $krYZG.ACTION).INSERTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).BODIED_SYNCED_BLOCK,
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        attributes: {
            resourceId: resourceId,
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    };
};
const $5f570f8dd9ccb4e4$export$23e42fbf8039414c = (resourceId, blockInstanceId, sourceProduct, enrichment)=>({
        action: (0, $krYZG.ACTION).INSERTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_CREATE,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            ...blockInstanceId && {
                blockInstanceId: blockInstanceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            },
            ...enrichment?.inputMethod && {
                inputMethod: enrichment.inputMethod
            },
            ...enrichment?.createdEmpty !== undefined && {
                createdEmpty: enrichment.createdEmpty
            },
            ...enrichment?.nodeTypes?.length && {
                nodeTypes: enrichment.nodeTypes
            }
        }
    });
const $5f570f8dd9ccb4e4$export$c76f6dd50db89cda = (resourceId, blockInstanceId, sourceProduct)=>({
        action: (0, $krYZG.ACTION).ADDED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_ADD_CONTENT,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            ...blockInstanceId && {
                blockInstanceId: blockInstanceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    });
const $5f570f8dd9ccb4e4$export$f2b4214fae56af83 = (resourceId, hasReference, sourceProduct)=>({
        action: (0, $krYZG.ACTION).UPDATED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_UPDATE,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            ...hasReference !== undefined && {
                hasReference: hasReference
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    });
const $5f570f8dd9ccb4e4$export$2283f5d682476cde = (resourceId, sourceProduct, enrichment)=>({
        action: (0, $krYZG.ACTION).DELETED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_DELETE,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            ...sourceProduct && {
                sourceProduct: sourceProduct
            },
            ...enrichment?.blockInstanceId && {
                blockInstanceId: enrichment.blockInstanceId
            },
            ...enrichment?.deletionReason && {
                deletionReason: enrichment.deletionReason
            },
            ...enrichment?.mechanism && {
                mechanism: enrichment.mechanism
            }
        }
    });
module.exports["stringifyError"] = $5f570f8dd9ccb4e4$export$7fc2c997455452c8;
module.exports["getPiiSafeOriginalError"] = $5f570f8dd9ccb4e4$export$74ce7fda6da1109;
module.exports["buildErrorAttribution"] = $5f570f8dd9ccb4e4$export$78792f4ddc3998e8;
module.exports["buildFetchErrorAttribution"] = $5f570f8dd9ccb4e4$export$4ae89cef01c11c46;
module.exports["fetchErrorPayload"] = $5f570f8dd9ccb4e4$export$94dcd08406353dba;
module.exports["getSourceInfoErrorPayload"] = $5f570f8dd9ccb4e4$export$c5131f589148b9d3;
module.exports["updateErrorPayload"] = $5f570f8dd9ccb4e4$export$adc2363832f8735d;
module.exports["updateReferenceErrorPayload"] = $5f570f8dd9ccb4e4$export$154595d209a77913;
module.exports["createErrorPayload"] = $5f570f8dd9ccb4e4$export$5d2f0c264cf49280;
module.exports["deleteErrorPayload"] = $5f570f8dd9ccb4e4$export$cd0aaab38ff32ec2;
module.exports["updateCacheErrorPayload"] = $5f570f8dd9ccb4e4$export$e40ed1768baf5d1e;
module.exports["sourceInfoOrphanedPayload"] = $5f570f8dd9ccb4e4$export$5665a31a69693485;
module.exports["cacheDeletionForcedPayload"] = $5f570f8dd9ccb4e4$export$82f9608c8438ecb2;
module.exports["fetchReferencesErrorPayload"] = $5f570f8dd9ccb4e4$export$ebf3ba305f3f0e1a;
module.exports["fetchSuccessPayload"] = $5f570f8dd9ccb4e4$export$b20c56c32ea6ad76;
module.exports["createSuccessPayload"] = $5f570f8dd9ccb4e4$export$5b8e0915870366d0;
module.exports["createSuccessOperationalPayload"] = $5f570f8dd9ccb4e4$export$23e42fbf8039414c;
module.exports["addContentSuccessPayload"] = $5f570f8dd9ccb4e4$export$c76f6dd50db89cda;
module.exports["updateSuccessPayload"] = $5f570f8dd9ccb4e4$export$f2b4214fae56af83;
module.exports["deleteSuccessPayload"] = $5f570f8dd9ccb4e4$export$2283f5d682476cde;

});

parcelRegister("cuwGS", function(module, exports) {

var $kcJaM = parcelRequire("kcJaM");

const $dfc9aeca876e07dc$var$isSyncBlockProduct = (product)=>{
    return (0, $kcJaM.SYNC_BLOCK_PRODUCTS).includes(product);
};
const $dfc9aeca876e07dc$export$8aafdd7901afa57f = (resourceId)=>{
    if (!resourceId) return undefined;
    const [product, contentId, uuid, ...rest] = resourceId.split('/');
    // invalid if any part is missing or there are extra parts
    if (!product || !contentId || !uuid || rest.length > 0) return undefined;
    // invalid if product is not recognized
    if (!$dfc9aeca876e07dc$var$isSyncBlockProduct(product)) return undefined;
    return {
        product: product,
        contentId: contentId,
        uuid: uuid
    };
};
const $dfc9aeca876e07dc$export$cf5895b3b46faf63 = (product, contentId, uuid)=>{
    return `${product}/${contentId}/${uuid}`;
};
module.exports["parseResourceId"] = $dfc9aeca876e07dc$export$8aafdd7901afa57f;
module.exports["createResourceIdForReference"] = $dfc9aeca876e07dc$export$cf5895b3b46faf63;

});

parcelRegister("kcJaM", function(module, exports) {
const $d6e2f975e4365dc3$export$c05408ef703373ad = [
    'confluence-page',
    'jira-work-item'
];
module.exports["SYNC_BLOCK_PRODUCTS"] = $d6e2f975e4365dc3$export$c05408ef703373ad;

});

parcelRegister("d04Ge", function(module, exports) {
/* eslint-disable require-unicode-regexp  */ const $acebaa6737646e6e$var$GET_CONTENT_ID_AND_PRODUCT_REGEX = /^(confluence-page|jira-work-item)\/([^/]+)/;
const $acebaa6737646e6e$var$normalizeSyncBlockJSONContentInternal = (content, options)=>{
    let normalizedContent;
    content.forEach((contentNode, index)=>{
        if (!contentNode) {
            normalizedContent?.push(contentNode);
            return;
        }
        const hasAnnotationMark = contentNode.marks?.some((mark)=>mark.type === 'annotation');
        const shouldConvertPanelC1 = options.convertPanelC1ToPanel && contentNode.type === 'panel_c1';
        const childContent = contentNode.content ? $acebaa6737646e6e$var$normalizeSyncBlockJSONContentInternal(contentNode.content, options) : undefined;
        const hasContentChanged = childContent !== undefined && childContent !== contentNode.content;
        if (!hasAnnotationMark && !shouldConvertPanelC1 && !hasContentChanged) {
            normalizedContent?.push(contentNode);
            return;
        }
        if (!normalizedContent) normalizedContent = content.slice(0, index);
        const normalizedNode = {
            ...contentNode
        };
        if (shouldConvertPanelC1) normalizedNode.type = 'panel';
        if (hasAnnotationMark) {
            const marks = contentNode.marks?.filter((mark)=>mark.type !== 'annotation');
            if (marks && marks.length > 0) normalizedNode.marks = marks;
            else delete normalizedNode.marks;
        }
        if (hasContentChanged && childContent) normalizedNode.content = childContent;
        normalizedContent.push(normalizedNode);
    });
    return normalizedContent ?? content;
};
const $acebaa6737646e6e$export$19bb1d88f473b9c5 = (content)=>{
    return $acebaa6737646e6e$var$normalizeSyncBlockJSONContentInternal(content, {
        convertPanelC1ToPanel: false
    });
};
const $acebaa6737646e6e$export$b223a7607ed061dc = (content)=>{
    return $acebaa6737646e6e$var$normalizeSyncBlockJSONContentInternal(content, {
        convertPanelC1ToPanel: true
    });
};
const $acebaa6737646e6e$export$aafb32b192c8228c = (node)=>{
    const content = node.content.toJSON();
    return {
        blockInstanceId: node.attrs.localId,
        content: content ? $acebaa6737646e6e$export$b223a7607ed061dc(content) : content,
        resourceId: node.attrs.resourceId
    };
};
const $acebaa6737646e6e$export$c5b34fb9069ebb1d = (localId, resourceId)=>{
    return {
        type: 'syncBlock',
        attrs: {
            localId: localId,
            resourceId: resourceId
        }
    };
};
const $acebaa6737646e6e$export$cd9b0caaea319019 = (node)=>{
    if (node.type !== 'syncBlock' || !node.attrs || !('localId' in node.attrs) || !('resourceId' in node.attrs) || typeof node.attrs.localId !== 'string' || typeof node.attrs.resourceId !== 'string') return undefined;
    return $acebaa6737646e6e$export$c5b34fb9069ebb1d(node.attrs.localId, node.attrs.resourceId);
};
const $acebaa6737646e6e$export$648ff8dd259e0d9c = (node)=>{
    if (node.type.name !== 'syncBlock' || !node.attrs?.localId || !node.attrs?.resourceId || typeof node.attrs.localId !== 'string' || typeof node.attrs.resourceId !== 'string') return undefined;
    return $acebaa6737646e6e$export$c5b34fb9069ebb1d(node.attrs.localId, node.attrs.resourceId);
};
const $acebaa6737646e6e$export$18b85168a73dad03 = (nodes)=>{
    return nodes.map((node)=>$acebaa6737646e6e$export$648ff8dd259e0d9c(node)).filter((node)=>node !== undefined);
};
const $acebaa6737646e6e$export$2cf4a74c3e18f31a = (resourceId)=>{
    const match = resourceId.match($acebaa6737646e6e$var$GET_CONTENT_ID_AND_PRODUCT_REGEX);
    if (match?.[2]) return {
        sourceProduct: match[1],
        sourceContentId: match[2]
    };
    throw new Error(`Invalid resourceId: ${resourceId}`);
};
const $acebaa6737646e6e$export$31cbe0bed21e05b1 = (resourceId)=>{
    if (!resourceId) return undefined;
    try {
        return $acebaa6737646e6e$export$2cf4a74c3e18f31a(resourceId).sourceProduct;
    } catch  {
        return undefined;
    }
};
const $acebaa6737646e6e$export$4c6687d128f55da5 = (contentUpdatedAt)=>{
    if (typeof contentUpdatedAt === 'number') try {
        return new Date(contentUpdatedAt).toISOString();
    } catch  {
        return undefined;
    }
    return undefined;
};
module.exports["normalizeSyncBlockJSONContent"] = $acebaa6737646e6e$export$b223a7607ed061dc;
module.exports["convertSyncBlockPMNodeToSyncBlockData"] = $acebaa6737646e6e$export$aafb32b192c8228c;
module.exports["createSyncBlockNode"] = $acebaa6737646e6e$export$c5b34fb9069ebb1d;
module.exports["convertSyncBlockJSONNodeToSyncBlockNode"] = $acebaa6737646e6e$export$cd9b0caaea319019;
module.exports["convertPMNodesToSyncBlockNodes"] = $acebaa6737646e6e$export$18b85168a73dad03;
module.exports["getContentIdAndProductFromResourceId"] = $acebaa6737646e6e$export$2cf4a74c3e18f31a;
module.exports["getSourceProductFromResourceIdSafe"] = $acebaa6737646e6e$export$31cbe0bed21e05b1;
module.exports["convertContentUpdatedAt"] = $acebaa6737646e6e$export$4c6687d128f55da5;

});

parcelRegister("6oMcp", function(module, exports) {
/* eslint-disable require-unicode-regexp  */ const $0dfedb71521ac678$var$CONFLUENCE_PAGE_ARI_REGEX = /ari:cloud:confluence:[^:]+:(page|blogpost)\/(\d+)/;
const $0dfedb71521ac678$export$3c54cf45dfed84ea = ({ pageId: pageId, cloudId: cloudId, pageType: pageType })=>{
    return `ari:cloud:confluence:${cloudId}:${pageType}/${pageId}`;
};
const $0dfedb71521ac678$export$2ee4e689bde04de2 = ({ ari: ari })=>{
    const match = ari.match($0dfedb71521ac678$var$CONFLUENCE_PAGE_ARI_REGEX);
    if (match?.[2]) return {
        type: match[1],
        id: match[2]
    };
    throw new Error(`Invalid page ARI: ${ari}`);
};
module.exports["getConfluencePageAri"] = $0dfedb71521ac678$export$3c54cf45dfed84ea;
module.exports["getPageIdAndTypeFromConfluencePageAri"] = $0dfedb71521ac678$export$2ee4e689bde04de2;

});

parcelRegister("kgNLQ", function(module, exports) {

var $cD1qu = parcelRequire("cD1qu");


var $6mKj3 = parcelRequire("6mKj3");


var $jbF1h = parcelRequire("jbF1h");

var $344a24116515d334$export$ffa1150e6a48f9cd = /*#__PURE__*/ function(CommentType) {
    CommentType["INLINE"] = "inline";
    CommentType["GENERAL"] = "general";
    return CommentType;
}({});
const $344a24116515d334$export$4883f94fcd5fa7aa = {
    ari: '',
    containerAri: '',
    reactionsCount: 0,
    reactionsSummaryForEmoji: [],
    __typename: 'ReactionsSummaryResponse'
};
const $344a24116515d334$export$99a332599a946905 = '998765432100';
const $344a24116515d334$export$c6a7031105fdebc = (commentData, commentId)=>{
    // Search in retreived comments and their replies
    for (const comment of commentData){
        // Check if this is the comment we're looking for
        if (comment?.id === commentId) return comment;
        // Check if it's in the replies
        if (comment?.replies) {
            const foundReply = comment.replies.find((reply)=>reply?.id === commentId);
            if (foundReply) return foundReply;
        }
    }
    // else comment not found
    return undefined;
};
const $344a24116515d334$export$6ba3a6375d12d24f = (commentData, replyParentId)=>{
    // Search through each root level comment's replies
    for (const comment of commentData){
        // Return this comment if it is the parent of the reply, else check if this comment has replies
        // and if any of them have the matching parentId
        if (comment?.id === replyParentId || comment?.replies.find((reply)=>reply?.id === replyParentId)) return comment;
    }
    // else comment not found
    return undefined;
};
const $344a24116515d334$export$3e4a472ec0de2dc6 = (commentData, markerRef)=>{
    // Search in retrieved comments and their replies
    for (const comment of commentData){
        // Check if this comment's marker ref matches
        const location = comment?.location;
        if (location?.inlineMarkerRef === markerRef) return comment;
    }
    return undefined;
};
const $344a24116515d334$export$499492f953d5abba = (comments, commentId, markerRef, contentStatus)=>{
    if (comments.length === 0) return undefined;
    let foundComment;
    if (commentId) foundComment = $344a24116515d334$export$c6a7031105fdebc(comments, commentId);
    else if (markerRef) foundComment = $344a24116515d334$export$3e4a472ec0de2dc6(comments, markerRef);
    if (!foundComment) return undefined;
    // Filter by contentStatus before returning
    const matchesContentStatusFilter = (comment)=>{
        if (!comment || !comment.contentStatus) return false;
        // Convert comment's contentStatus to uppercase to match GraphQLContentStatus format
        const commentStatus = comment.contentStatus.toUpperCase();
        return contentStatus.includes(commentStatus);
    };
    if (matchesContentStatusFilter(foundComment)) return foundComment;
    return undefined;
};
const $344a24116515d334$export$4d95f4b945556294 = (comment, mutationResult)=>{
    const resolveInlineComment = mutationResult?.data?.resolveInlineComment;
    const mutationStatus = resolveInlineComment?.status ?? false;
    const resolveProperties = resolveInlineComment?.resolveProperties ?? undefined;
    return (0, $jbF1h.resolveCommentInCache)({
        comment: comment,
        mutationStatus: mutationStatus,
        resolveProperties: resolveProperties
    });
};
const $344a24116515d334$export$d81a62b32f0e420f = (comment, mutationResult)=>{
    const commentResolutionStates = mutationResult?.data?.confluence_resolveComments?.commentResolutionStates;
    if ((commentResolutionStates?.length ?? 0) > 1) throw new Error('resolveCommentInCacheCallback() only supports one comment resolution state per mutation call');
    const firstResolutionState = commentResolutionStates?.[0] ?? undefined;
    const mutationStatus = firstResolutionState?.status ?? false;
    const partialResolveProperties = firstResolutionState?.resolveProperties ?? undefined;
    // We need to ensure that resolveProperties contains all non-optional properties so we can safely
    // spread it into the comment location resolve properties, so choose defaults for any missing
    // ones.  This is needed because some of the mutations don't request all the properties in their
    // responses.
    const resolveProperties = partialResolveProperties ? {
        resolved: true,
        isDangling: false,
        // These are nullable in the schema, but included to make Typescript happy
        resolvedUser: undefined,
        resolvedFriendlyDate: undefined,
        resolvedTime: undefined,
        // Add any non-null/undefined properties from the mutation result
        ...partialResolveProperties
    } : undefined;
    return (0, $jbF1h.resolveCommentInCache)({
        comment: comment,
        mutationStatus: mutationStatus,
        resolveProperties: resolveProperties
    });
};
const $344a24116515d334$export$aa65246494e3c3e0 = (comment, mutationResult)=>{
    // (The property is called "commentResolutionStates" but there is only one item per mutation call)
    const commentResolutionStates = mutationResult?.data?.confluence_reopenComment?.commentResolutionStates;
    if (commentResolutionStates) {
        const mutationStatus = commentResolutionStates.status ?? false;
        const partialResolveProperties = commentResolutionStates.resolveProperties ?? undefined;
        // We need to ensure that resolveProperties contains all non-optional properties so we can safely
        // spread it into the comment location resolve properties, so choose defaults for any missing
        // ones. This is needed because some of the mutations don't request all the properties - or even
        // the commentResolutionStates property at all in their responses.
        const resolveProperties = {
            resolved: false,
            isDangling: false,
            // These are nullable in the schema, but included to make Typescript happy
            resolvedUser: undefined,
            resolvedFriendlyDate: undefined,
            resolvedTime: undefined,
            // Add any non-null/undefined properties from the mutation result
            ...partialResolveProperties
        };
        return (0, $jbF1h.resolveCommentInCache)({
            comment: comment,
            mutationStatus: mutationStatus,
            resolveProperties: resolveProperties
        });
    }
    // Else commentResolutionStates wasn't returned - assume failure to reopen
    return (0, $jbF1h.resolveCommentInCache)({
        comment: comment,
        mutationStatus: false,
        resolveProperties: undefined
    });
};
const $344a24116515d334$export$e237bdee87974d46 = (pageMode)=>{
    // On view pages, exclude draft comments
    if (pageMode === (0, $cD1qu.PageMode).VIEW) return [
        'CURRENT',
        'ARCHIVED'
    ];
    // On edit and live pages, include all statuses
    return [
        'CURRENT',
        'ARCHIVED',
        'DRAFT'
    ];
};
const $344a24116515d334$export$70df9f207ee9869d = (comment)=>{
    const location = comment?.location;
    if (location) {
        if ('inlineResolveProperties' in location) return location.inlineResolveProperties?.resolved ?? false;
        else if ('commentResolveProperties' in location) return location.commentResolveProperties?.resolved ?? false;
    }
    return false;
};
const $344a24116515d334$export$6036c2c532b2fa41 = (commentsDataMap)=>{
    try {
        const allGeneralComments = Object.values(commentsDataMap.general);
        // To see if there are nested comments, we need to check whether there are any replies whose parentID is not equal to the parent Comment's ID
        // This is because commentsDataMap.general is a flat map of parent comment --> everything below it
        // But each comment has it's own parent id which may be different from it's top level parent
        return allGeneralComments.some((comment)=>{
            return comment?.replies?.some((reply)=>reply && reply.parentId !== comment.id);
        });
    } catch  {
        // Default to false if somehow something goes wrong
        return false;
    }
};
const $344a24116515d334$export$2fa0b601110c277b = (comments, contentStatusFilters)=>{
    const allFilteredComments = [];
    const openComments = [];
    const openInlineComments = [];
    const openFooterComments = [];
    const resolvedComments = [];
    // Transform array-based data to map structure for legacy compatibility
    const commentsDataMap = {
        inline: {},
        general: {}
    };
    // Build flat map of all comments (including replies) for O(1) lookup by commentId
    const flatCommentsMap = {};
    // Build flat map of inline comments keyed by markerRef for O(1) lookup
    const flatMarkerRefMap = {};
    for (const comment of comments)// Filter by content status, which is a string literal type (that is, a set of allowed
    // strings), so be cautious if the definitions or schema change
    if (comment && contentStatusFilters.includes(comment.contentStatus?.toUpperCase())) {
        allFilteredComments.push(comment);
        // Add comment to flat map by commentId
        if (comment?.id) flatCommentsMap[comment.id] = comment;
        // Add inline parent comment to flatMarkerRefMap by markerRef (only parent comments, not replies)
        if (comment?.location?.type === 'INLINE' && !comment?.parentId) {
            const location = comment.location;
            if (location?.inlineMarkerRef) flatMarkerRefMap[location.inlineMarkerRef] = comment;
        }
        // Add all replies to flat map
        if (comment?.replies) {
            for (const reply of comment.replies)if (reply?.id) flatCommentsMap[reply.id] = reply;
        }
        const isOpen = !$344a24116515d334$export$70df9f207ee9869d(comment);
        const commentType = comment.location?.type === 'INLINE' ? "inline" : "general";
        const commentWithProperties = {
            ...comment,
            type: commentType,
            isOpen: isOpen,
            replies: comment.replies?.filter((reply)=>reply !== null && reply !== undefined).map((reply)=>({
                    ...reply
                }))
        };
        if (isOpen) {
            openComments.push(comment);
            if (comment?.location?.type === 'INLINE') openInlineComments.push(comment);
            else if (comment?.location?.type === 'FOOTER') openFooterComments.push(comment);
        // else unknown or missing location type, do nothing
        } else resolvedComments.push(comment);
        if (comment.location?.type === 'INLINE') {
            const threadKey = 'inlineMarkerRef' in comment.location ? comment.location.inlineMarkerRef || comment.id : comment.id;
            commentsDataMap.inline[threadKey] = commentWithProperties;
        } else if (comment.location?.type === 'FOOTER') commentsDataMap.general[comment.id] = commentWithProperties;
    }
    const hasNestedComments = $344a24116515d334$export$6036c2c532b2fa41(commentsDataMap);
    const commentCount = allFilteredComments.length;
    const hasAnyComments = commentCount > 0;
    return {
        allFilteredComments: allFilteredComments,
        openComments: openComments,
        openInlineComments: openInlineComments,
        openFooterComments: openFooterComments,
        resolvedComments: resolvedComments,
        commentsDataMap: commentsDataMap,
        flatCommentsMap: flatCommentsMap,
        flatMarkerRefMap: flatMarkerRefMap,
        hasNestedComments: hasNestedComments,
        commentCount: commentCount,
        hasAnyComments: hasAnyComments
    };
};
const $344a24116515d334$export$5c24224d7e29c719 = ()=>{
    return {
        context: {
            fetchOptions: {
                ignoreNoNetworkError: (0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_offline_fix', 'isEnabled', true)
            }
        }
    };
};
module.exports["CommentType"] = $344a24116515d334$export$ffa1150e6a48f9cd;
module.exports["emptyReactionsSummary"] = $344a24116515d334$export$4883f94fcd5fa7aa;
module.exports["OPTIMISTIC_SAVE_COMMENT_ID"] = $344a24116515d334$export$99a332599a946905;
module.exports["findCommentInData"] = $344a24116515d334$export$c6a7031105fdebc;
module.exports["findRootCommentForReply"] = $344a24116515d334$export$6ba3a6375d12d24f;
module.exports["findAndFilterComment"] = $344a24116515d334$export$499492f953d5abba;
module.exports["resolveInlineCommentInCacheCallback"] = $344a24116515d334$export$4d95f4b945556294;
module.exports["resolveCommentInCacheCallback"] = $344a24116515d334$export$d81a62b32f0e420f;
module.exports["reopenCommentInCacheCallback"] = $344a24116515d334$export$aa65246494e3c3e0;
module.exports["buildDefaultCommentsContentStatusFilters"] = $344a24116515d334$export$e237bdee87974d46;
module.exports["isCommentResolved"] = $344a24116515d334$export$70df9f207ee9869d;
module.exports["categorizeComments"] = $344a24116515d334$export$2fa0b601110c277b;
module.exports["buildMutationContextForNoNetworkError"] = $344a24116515d334$export$5c24224d7e29c719;

});

parcelRegister("cD1qu", function(module, exports) {
var $7825447594ee3eb0$export$6ea4b0c62affbe44 = /*#__PURE__*/ function(PageMode) {
    PageMode["EDIT"] = "edit";
    PageMode["VIEW"] = "view";
    PageMode["LIVE"] = "live";
    return PageMode;
}({});
var $7825447594ee3eb0$export$b2be22e9d5dd3927 = /*#__PURE__*/ function(ContentStatus) {
    ContentStatus["CURRENT"] = "current";
    ContentStatus["DRAFT"] = "draft";
    ContentStatus["ARCHIVED"] = "archived";
    return ContentStatus;
}({});
const $7825447594ee3eb0$export$5d7c5e13dde1e9b8 = [
    "draft"
];
const $7825447594ee3eb0$export$c75005e52070dee = [
    "current"
];
module.exports["PageMode"] = $7825447594ee3eb0$export$6ea4b0c62affbe44;
module.exports["ContentStatus"] = $7825447594ee3eb0$export$b2be22e9d5dd3927;
module.exports["DRAFT_STATUS"] = $7825447594ee3eb0$export$5d7c5e13dde1e9b8;
module.exports["CURRENT_STATUS"] = $7825447594ee3eb0$export$c75005e52070dee;

});

parcelRegister("jbF1h", function(module, exports) {

var $82R8R = parcelRequire("82R8R");


var $6nYhN = parcelRequire("6nYhN");


var $cozmU = parcelRequire("cozmU");


var $ij4CE = parcelRequire("ij4CE");


var $fFmJj = parcelRequire("fFmJj");







// Unfortunately our Relay-friendly type generation tools don't support GQL fragments yet - but in
// order to keep the definition of the comment fields in sync (so the cache update fragment is
// always in sync with the full query) we will need to manually make any changes to one definition
// in any others as well, until our tooling supports fragments and then we move to a more
// fragmented-based approach.  Note there are also comment queries or fragments in the following
// files that need to be kept in sync as well:
// - next/packages/comments-data-manager/src/useAllCommentsData.ts
// - next/packages/comments-data-manager/src/useCommentById.ts
// - next/packages/comments-data-manager/src/useCreateObjectCommentMutation.ts
// - next/packages/comments-data-manager/src/useCreateInlineCommentMutation.ts
// - next/packages/comments-data-manager/src/useCreateInlineReplyMutation.ts
// - next/packages/object-comments/src/components/ObjectCommentContainer.tsx
// TODO: Replace with the exported fragment from useAllCommentsData.ts when our tooling supports
// it, if we are allowed to share fragments between packages/files.  If we are not allowed to share
// fragments, we should move this function - or at least the cache updating parts for the function
// - into the useAllCommentsData.ts file.
const $bd790562493588ff$var$updateCommentInCacheFragment = (0, $6nYhN.default);
// Fragment for reply comments (matches the replies schema from the main fragment)
const $bd790562493588ff$var$updateReplyInCacheFragment = (0, $82R8R.default);
// Type guard to check if a comment is a top-level comment (has replies field)
const $bd790562493588ff$var$isTopLevelComment = (comment)=>{
    return 'replies' in comment;
};
const $bd790562493588ff$export$8ce65958c48a9ac3 = ()=>{
    const readFragment = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: $bd790562493588ff$var$updateCommentInCacheFragment,
        __callerPackage__: "comments-data-manager"
    });
    const writeFragment = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentArtifact: (0, $6nYhN.default),
        fragmentSpec: $bd790562493588ff$var$updateCommentInCacheFragment,
        __callerPackage__: "comments-data-manager"
    });
    const readReplyFragment = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: $bd790562493588ff$var$updateReplyInCacheFragment,
        __callerPackage__: "comments-data-manager"
    });
    const writeReplyFragment = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentArtifact: (0, $82R8R.default),
        fragmentSpec: $bd790562493588ff$var$updateReplyInCacheFragment,
        __callerPackage__: "comments-data-manager"
    });
    /**
   * Function to update a comment in the Apollo cache.
   * @param mutationResult - The result of the mutation that triggered the cache update
   * @param commentId - ID of the comment to update
   * @param updateCallback - Callback function that receives the current comment data
   *                         and returns the updated comment data
   * @param onError - Optional error callback to handle errors during the update process
   * @param isReply - Whether this comment is a reply (true) or top-level comment (false)
   */ const updateCommentInCache = (0, $cozmU.useCallback)(({ mutationResult: mutationResult, commentId: commentId, updateCallback: updateCallback, onError: onError, isReply: isReply = false })=>{
        if (!commentId) {
            onError?.(new Error('Cannot update comment in cache: comment ID is missing'));
            return;
        }
        try {
            // The fragment ID format for Apollo cache
            const fragmentId = `Comment:${commentId}`;
            let cachedComment = null;
            if (isReply) cachedComment = readReplyFragment({
                id: fragmentId
            });
            else cachedComment = readFragment({
                id: fragmentId
            });
            if (!cachedComment) {
                // (There is a slight chance the comment is not in cache - but the mutation that calls
                // this function would have to completed successfully to call us, so presumably the
                // comment existed then. Thus the only legit reason for it to be missing from the cache
                // now is if another user deleted the comment in between the mutation and this cache
                // update call. That is unlikely, so let's log this as an error and return. If in
                // the future we find the legit use case is happening more often, we can change to a
                // warning instead.)
                onError?.(new Error(`Cannot update comment in cache: comment with ID ${commentId} not found in cache`));
                return;
            }
            // Apply the update callback on a copy of the cached comment
            // (Note that the updateCallback should return a new object, not mutate the original - so
            //  make copies of any nested objects you need to change also)
            const updatedComment = updateCallback({
                ...cachedComment
            }, mutationResult);
            // Write the updated comment back to cache using appropriate fragment
            if (isReply) writeReplyFragment({
                fragmentId: fragmentId,
                data: updatedComment
            });
            else writeFragment({
                fragmentId: fragmentId,
                data: updatedComment
            });
        } catch (err) {
            onError?.(new Error(`An error occurred when updating cached comment data: ${err}`));
            return;
        }
    }, [
        readFragment,
        writeFragment,
        readReplyFragment,
        writeReplyFragment
    ]);
    return {
        updateCommentInCache: updateCommentInCache
    };
};
const $bd790562493588ff$export$9e04af313e7174f4 = ({ comment: comment, mutationStatus: mutationStatus, resolveProperties: resolveProperties })=>{
    if (!mutationStatus || !resolveProperties) // Mutation result is missing or incomplete - so just return the comment unchanged
    return comment;
    // Extract isDangling separately since it is handled differently, and exclude __typename since we
    // don't need it and Typescript would complain about it being included in the spread below.
    const { __typename: __typename, isDangling: isDangling, ...otherResolveProperties } = resolveProperties;
    // Defaults for the nullable resolve fields. A partial mutation response (e.g. a reopen that only
    // returns `resolved: false`) leaves these `undefined` in the write data. The interop fragment
    // writer skips `undefined` scalars (setRelayScalarValue), so those fields would be absent in the
    // store and Relay warns "Missing field resolvedFriendlyDate/..." on the next read. Seeding them
    // as explicit `null` (their unresolved value) keeps the resolve-properties record complete; any
    // real value from the mutation response still overrides via the spread below.
    const resolvePropertyDefaults = {
        resolvedUser: null,
        resolvedFriendlyDate: null,
        resolvedTime: null
    };
    // Mark the comment as resolved in the cache, but how to do that depends on the comment type
    const location = comment.location;
    const newLocation = {
        ...location,
        ...'commentResolveProperties' in location ? {
            commentResolveProperties: {
                ...location.commentResolveProperties,
                ...resolvePropertyDefaults,
                ...otherResolveProperties
            }
        } : {},
        ...'inlineResolveProperties' in location ? {
            inlineResolveProperties: {
                ...location.inlineResolveProperties,
                ...resolvePropertyDefaults,
                ...otherResolveProperties,
                isDangling: isDangling
            }
        } : {}
    };
    // @ts-expect-error - FIXME: This error was surfaced after enabling the `typescriptExcludeUndefinedFromNullableUnion`
    // Relay compiler option. Previously, `undefined` was incorrectly included in nullable unions in generated types; this option removes it. The owning team should fix this properly.
    return {
        ...comment,
        location: newLocation
    };
};
const $bd790562493588ff$export$df3d27666bd765d5 = (comment, mutationResult)=>{
    const newBodyValue = mutationResult?.data?.updateComment?.body?.value;
    const updatedBody = {
        ...comment.body,
        // Remember that an empty string is a valid body value, so only skip updating if newBodyValue
        // is null or undefined
        ...newBodyValue || newBodyValue === '' ? {
            value: newBodyValue
        } : {}
    };
    const newVersion = mutationResult?.data?.updateComment?.version;
    const newDisplayName = newVersion?.by?.displayName;
    // If the existing comment's version doesn't have a "by" field, we don't want to add just part
    // of it - so set it to undefined so it won't be included in the updated comment. This probably
    // won't actually ever happen, but it makes Typescript happy just in case.
    const updatedBy = comment.version?.by ? {
        ...comment.version?.by,
        ...newDisplayName ? {
            displayName: newDisplayName
        } : {}
    } : undefined;
    const updatedVersion = {
        ...comment.version,
        ...newVersion?.number ? {
            number: newVersion.number
        } : {},
        ...newVersion?.when ? {
            when: newVersion.when
        } : {},
        ...updatedBy ? {
            by: {
                ...updatedBy
            }
        } : {}
    };
    const baseUpdatedComment = {
        ...comment,
        body: updatedBody,
        version: {
            ...updatedVersion
        }
    };
    // Return with appropriate type casting based on comment type
    return $bd790562493588ff$var$isTopLevelComment(comment) ? baseUpdatedComment : baseUpdatedComment;
};
module.exports["useUpdateCommentInCache"] = $bd790562493588ff$export$8ce65958c48a9ac3;
module.exports["resolveCommentInCache"] = $bd790562493588ff$export$9e04af313e7174f4;
module.exports["updateCommentBodyInCacheCallback"] = $bd790562493588ff$export$df3d27666bd765d5;

});

parcelRegister("82R8R", function(module, exports) {
/**
 * @generated SignedSource<<b6af2e5e8b1c672924f300605e9d9ac3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6ee66e0478f0211a$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v1 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v2 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v4 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v5 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v6 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "useUpdateCommentInCacheReplyFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "id"
            },
            {
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "permissionType"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "accountId"
                            }
                        ],
                        "type": "KnownUser"
                    },
                    {
                        "concreteType": "Icon",
                        "kind": "LinkedField",
                        "name": "profilePicture",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "path"
                            }
                        ]
                    }
                ]
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "representation",
                        "value": "ATLAS_DOC_FORMAT"
                    }
                ],
                "concreteType": "DocumentBody",
                "kind": "LinkedField",
                "name": "body",
                "plural": false,
                "selections": v2 /*: any*/ ,
                "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
            },
            {
                "kind": "ScalarField",
                "name": "contentStatus"
            },
            {
                "concreteType": "ConfluenceDate",
                "kind": "LinkedField",
                "name": "createdAt",
                "plural": false,
                "selections": v2 /*: any*/ 
            },
            {
                "kind": "ScalarField",
                "name": "createdAtNonLocalized"
            },
            {
                "concreteType": "Map_LinkType_String",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "editui"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "webui"
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "name": "location",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "InlineCommentResolveProperties",
                                "kind": "LinkedField",
                                "name": "commentResolveProperties",
                                "plural": false,
                                "selections": [
                                    v3 /*: any*/ ,
                                    v4 /*: any*/ ,
                                    v5 /*: any*/ ,
                                    v6 /*: any*/ 
                                ]
                            }
                        ],
                        "type": "FooterComment"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "inlineMarkerRef"
                            },
                            {
                                "concreteType": "InlineCommentResolveProperties",
                                "kind": "LinkedField",
                                "name": "inlineResolveProperties",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "isDangling"
                                    },
                                    v3 /*: any*/ ,
                                    v4 /*: any*/ ,
                                    v5 /*: any*/ ,
                                    v6 /*: any*/ 
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "name": "inlineText"
                            }
                        ],
                        "type": "InlineComment"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "parentId"
            },
            {
                "concreteType": "CommentPermissions",
                "kind": "LinkedField",
                "name": "permissions",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isEditable"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isRemovable"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isResolvable"
                    }
                ]
            },
            {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "by",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ ,
                            v1 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "number"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "when"
                    }
                ]
            }
        ],
        "type": "Comment"
    };
}();
$6ee66e0478f0211a$var$node.hash = "d793bb57d64855b11bf515ef7082e802";
var $6ee66e0478f0211a$export$2e2bcd8739ae039 = $6ee66e0478f0211a$var$node;
module.exports["default"] = $6ee66e0478f0211a$export$2e2bcd8739ae039;

});

parcelRegister("6nYhN", function(module, exports) {
/**
 * @generated SignedSource<<776c1b585ba7040195aa55b4ce020277>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1d633d5b65e9f4e8$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v3 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v4 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v5 = {
        "kind": "ScalarField",
        "name": "type"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v7 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v8 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v7 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v9 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v10 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v7 /*: any*/ 
    }, v11 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v12 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "editui"
            },
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v13 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v14 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v15 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v16 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v17 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v1 /*: any*/ ,
            v5 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "commentResolveProperties",
                        "plural": false,
                        "selections": [
                            v13 /*: any*/ ,
                            v14 /*: any*/ ,
                            v15 /*: any*/ ,
                            v16 /*: any*/ 
                        ]
                    }
                ],
                "type": "FooterComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "inlineMarkerRef"
                    },
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "inlineResolveProperties",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isDangling"
                            },
                            v13 /*: any*/ ,
                            v14 /*: any*/ ,
                            v15 /*: any*/ ,
                            v16 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "inlineText"
                    }
                ],
                "type": "InlineComment"
            }
        ]
    }, v18 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v19 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v20 = {
        "kind": "LinkedField",
        "name": "contributors",
        "plural": true,
        "selections": [
            v1 /*: any*/ ,
            v2 /*: any*/ ,
            v4 /*: any*/ ,
            v6 /*: any*/ 
        ]
    }, v21 = {
        "kind": "ScalarField",
        "name": "number"
    }, v22 = {
        "kind": "ScalarField",
        "name": "when"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "useUpdateCommentInCacheFragment",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                    v1 /*: any*/ ,
                    v2 /*: any*/ ,
                    v3 /*: any*/ ,
                    v4 /*: any*/ ,
                    v5 /*: any*/ ,
                    v6 /*: any*/ 
                ]
            },
            v8 /*: any*/ ,
            {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "container",
                "plural": false,
                "selections": [
                    v0 /*: any*/ 
                ]
            },
            v9 /*: any*/ ,
            v10 /*: any*/ ,
            v11 /*: any*/ ,
            v12 /*: any*/ ,
            v17 /*: any*/ ,
            v18 /*: any*/ ,
            v19 /*: any*/ ,
            v20 /*: any*/ ,
            {
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "replies",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "LinkedField",
                        "name": "author",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            v2 /*: any*/ ,
                            v3 /*: any*/ ,
                            v6 /*: any*/ ,
                            v4 /*: any*/ 
                        ]
                    },
                    v8 /*: any*/ ,
                    v9 /*: any*/ ,
                    v10 /*: any*/ ,
                    v11 /*: any*/ ,
                    v12 /*: any*/ ,
                    v17 /*: any*/ ,
                    v18 /*: any*/ ,
                    v19 /*: any*/ ,
                    v20 /*: any*/ ,
                    {
                        "concreteType": "Version",
                        "kind": "LinkedField",
                        "name": "version",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "by",
                                "plural": false,
                                "selections": [
                                    v1 /*: any*/ ,
                                    v2 /*: any*/ 
                                ]
                            },
                            v21 /*: any*/ ,
                            v22 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "by",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            v5 /*: any*/ ,
                            v2 /*: any*/ ,
                            v6 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "friendlyWhen"
                    },
                    v21 /*: any*/ ,
                    v22 /*: any*/ 
                ]
            }
        ],
        "type": "Comment"
    };
}();
$1d633d5b65e9f4e8$var$node.hash = "3eaa0227f14e77a83748a865f02fa321";
var $1d633d5b65e9f4e8$export$2e2bcd8739ae039 = $1d633d5b65e9f4e8$var$node;
module.exports["default"] = $1d633d5b65e9f4e8$export$2e2bcd8739ae039;

});

parcelRegister("l1uFv", function(module, exports) {

var $jWnFe = parcelRequire("jWnFe");


var $eqEJl = parcelRequire("eqEJl");


var $iffSy = parcelRequire("iffSy");


var $86okN = parcelRequire("86okN");


var $7M67g = parcelRequire("7M67g");

const $65c7b8940c778902$var$CLIENT_EDGE_TRAVERSAL_PATH_KEY = '__clientEdgeTraversalPath';
function $65c7b8940c778902$var$cloneRelayQueryResult(data) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jWnFe)))(data, (value, key)=>{
        // Relay fragment refs can contain operation descriptors and client-edge reader nodes.
        // Keep that internal metadata by reference while restoring Apollo-compatible mutable data.
        if (key === (0, $eqEJl.FRAGMENT_OWNER_KEY) || key === $65c7b8940c778902$var$CLIENT_EDGE_TRAVERSAL_PATH_KEY) return value;
        return undefined;
    });
}
function $65c7b8940c778902$export$627cb922211284f(params) {
    const operationName = (0, $7M67g.getRelayOperationName)(params.query);
    const source = (0, $iffSy.isRelayEnabled)(params.__callerPackage__, {
        operationName: operationName,
        phase: 'cache'
    }) ? 'relay' : 'apollo';
    // Cache reads stay native to the selected route. The cache bridge only
    // mirrors successful writes/results into the other cache.
    return $65c7b8940c778902$var$readQueryInteropOriginal(params, source);
}
function $65c7b8940c778902$var$readQueryInteropOriginal(params, source) {
    return source === 'relay' ? $65c7b8940c778902$var$readQueryInteropRelay(params) : $65c7b8940c778902$var$readQueryInteropApollo(params);
}
function $65c7b8940c778902$var$readQueryInteropRelay(params) {
    const relayEnv = typeof window !== 'undefined' ? window.GLOBAL_RELAY_ENV : undefined;
    if (!relayEnv) throw new Error(`[Relay migration] Missing GLOBAL_RELAY_ENV for readQueryInterop; ${params.__callerPackage__}.`);
    const queryNode = params.query;
    if (!queryNode?.fragment || !queryNode?.operation) return null;
    const variables = params.variables ?? {};
    const operation = (0, $eqEJl.createOperationDescriptor)(queryNode, variables);
    const snapshot = relayEnv.lookup(operation.fragment);
    return snapshot.isMissingData ? null : $65c7b8940c778902$var$cloneRelayQueryResult(snapshot.data);
}
function $65c7b8940c778902$var$readQueryInteropApollo(params) {
    return window['GLOBAL_APOLLO_CLIENT'].readQuery({
        ...params,
        query: (0, $86okN.toDocumentNode)(params.query)
    });
}
module.exports["readQueryInterop"] = $65c7b8940c778902$export$627cb922211284f;

});

parcelRegister("jWnFe", function(module, exports) {

var $hGc5T = parcelRequire("hGc5T");

/** Used to compose bitmasks for cloning. */ var $e845ca4b0059397d$var$CLONE_DEEP_FLAG = 1, $e845ca4b0059397d$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.cloneWith` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @param {Function} [customizer] The function to customize cloning.
 * @returns {*} Returns the deep cloned value.
 * @see _.cloneWith
 * @example
 *
 * function customizer(value) {
 *   if (_.isElement(value)) {
 *     return value.cloneNode(true);
 *   }
 * }
 *
 * var el = _.cloneDeepWith(document.body, customizer);
 *
 * console.log(el === document.body);
 * // => false
 * console.log(el.nodeName);
 * // => 'BODY'
 * console.log(el.childNodes.length);
 * // => 20
 */ function $e845ca4b0059397d$var$cloneDeepWith(value, customizer) {
    customizer = typeof customizer == 'function' ? customizer : undefined;
    return $hGc5T(value, $e845ca4b0059397d$var$CLONE_DEEP_FLAG | $e845ca4b0059397d$var$CLONE_SYMBOLS_FLAG, customizer);
}
module.exports = $e845ca4b0059397d$var$cloneDeepWith;

});

parcelRegister("6B1vK", function(module, exports) {

var $jyUkr = parcelRequire("jyUkr");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/confluence/page/manifest.ts
var $4cd75eda3ba03299$var$confluencePageAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $jyUkr.ConfluencePageAriResourceOwner),
    resourceType: (0, $jyUkr.ConfluencePageAriResourceType),
    resourceIdSlug: "{pageId}",
    resourceIdSegmentFormats: {
        pageId: /[0-9]+/
    }
};
// src/confluence/page/index.ts
var $4cd75eda3ba03299$export$3f931dd15d96caff = class _ConfluencePageAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get pageId() {
        return this._pageId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $4cd75eda3ba03299$var$confluencePageAriStaticOpts.qualifier,
            platformQualifier: $4cd75eda3ba03299$var$confluencePageAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $4cd75eda3ba03299$var$confluencePageAriStaticOpts.resourceOwner,
            resourceType: $4cd75eda3ba03299$var$confluencePageAriStaticOpts.resourceType,
            resourceId: `${opts.pageId}`,
            resourceIdSegmentValues: {
                pageId: opts.pageId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $4cd75eda3ba03299$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $4cd75eda3ba03299$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            pageId: this.pageId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._pageId = opts.resourceIdSegmentValues.pageId;
    }
};
module.exports["ConfluencePageAri"] = $4cd75eda3ba03299$export$3f931dd15d96caff;

});

parcelRegister("jyUkr", function(module, exports) {
// src/confluence/page/types.ts
var $e3dce2fc5add42f7$export$da53e4f7db4c6a71 = "confluence", $e3dce2fc5add42f7$export$636fc622562a2c5b = "page";
module.exports["ConfluencePageAriResourceOwner"] = $e3dce2fc5add42f7$export$da53e4f7db4c6a71;
module.exports["ConfluencePageAriResourceType"] = $e3dce2fc5add42f7$export$636fc622562a2c5b;

});

parcelRegister("9NPFC", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


const $60cc37ad75899268$var$tileSizePx = {
    xxsmall: 16,
    xsmall: 20,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 48
};
const $60cc37ad75899268$var$styles = {
    root: "_0bjKvD0O7w _4bt5LAnQyn _2WAcuGnQyn _1mT5xdRAKS _3iDTPbccYA _24h04i2Njc _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC _2O5VijdnbC _4ouGXIdnbC _4kiQYAdnbC _1RrJLit2nV",
    border: "_2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67",
    inset: "_3B3jB1IZbP _0LETLXIZbP _4ACwSfIZbP _2Qxi4nIZbP",
    nonInset: "_49oNbqN91d _1tJeXfN91d _0VARMJN91d _27VeLCN91d _3B3jB1N91d _0LETLXN91d _4ACwSfN91d _2Qxi4nN91d _3G0Ib8iObl"
};
const $60cc37ad75899268$var$sizeMap = {
    xxsmall: "_39xV02ey7F _0jFU0Vey7F _4ya3eEuFDC",
    xsmall: "_39xV02SPN1 _0jFU0VSPN1 _4ya3eExpxF",
    small: "_39xV02oWWg _0jFU0VoWWg _4ya3eEEbN9",
    medium: "_39xV02Uofl _0jFU0VUofl _4ya3eEey7F",
    large: "_39xV02UF4f _0jFU0VUF4f _4ya3eESPN1",
    xlarge: "_39xV02pJKa _0jFU0VpJKa _4ya3eEoWWg"
};
const $60cc37ad75899268$var$insetSizeMap = {
    xxsmall: "_49oNbquFDC _1tJeXfuFDC _0VARMJuFDC _27VeLCuFDC _0mzAWiNKBH _3woHNtNKBH _430i96NKBH _1GBPVvNKBH",
    xsmall: "_49oNbqxpxF _1tJeXfxpxF _0VARMJxpxF _27VeLCxpxF _0mzAWiqBG1 _3woHNtqBG1 _430i96qBG1 _1GBPVvqBG1",
    small: "_49oNbqEbN9 _1tJeXfEbN9 _0VARMJEbN9 _27VeLCEbN9 _0mzAWif9wp _3woHNtf9wp _430i96f9wp _1GBPVvf9wp",
    medium: "_49oNbqey7F _1tJeXfey7F _0VARMJey7F _27VeLCey7F _0mzAWiIRC9 _3woHNtIRC9 _430i96IRC9 _1GBPVvIRC9",
    large: "_49oNbqSPN1 _1tJeXfSPN1 _0VARMJSPN1 _27VeLCSPN1 _0mzAWiPcut _3woHNtPcut _430i96Pcut _1GBPVvPcut",
    xlarge: "_49oNbqoWWg _1tJeXfoWWg _0VARMJoWWg _27VeLCoWWg _0mzAWiY6u9 _3woHNtY6u9 _430i96Y6u9 _1GBPVvY6u9"
};
const $60cc37ad75899268$var$backgroundColorMap = {
    white: "_0KLXrut28M",
    black: "_0KLXru52mJ",
    transparent: "_0KLXrujOvk",
    'color.background.accent.lime.subtlest': "_0KLXruXL80",
    'color.background.accent.lime.subtler': "_0KLXruuKDS",
    'color.background.accent.lime.subtle': "_0KLXruZcd0",
    'color.background.accent.lime.bolder': "_0KLXrubYhN",
    'color.background.accent.red.subtlest': "_0KLXrusDFP",
    'color.background.accent.red.subtler': "_0KLXrubV9i",
    'color.background.accent.red.subtle': "_0KLXru0cUQ",
    'color.background.accent.red.bolder': "_0KLXruQrW1",
    'color.background.accent.orange.subtlest': "_0KLXru2QQR",
    'color.background.accent.orange.subtler': "_0KLXruwJ86",
    'color.background.accent.orange.subtle': "_0KLXruuwVU",
    'color.background.accent.orange.bolder': "_0KLXrux4f7",
    'color.background.accent.yellow.subtlest': "_0KLXru56u3",
    'color.background.accent.yellow.subtler': "_0KLXruLv9B",
    'color.background.accent.yellow.subtle': "_0KLXruC29w",
    'color.background.accent.yellow.bolder': "_0KLXruYB6L",
    'color.background.accent.green.subtlest': "_0KLXruV6wL",
    'color.background.accent.green.subtler': "_0KLXruNUep",
    'color.background.accent.green.subtle': "_0KLXru50ZN",
    'color.background.accent.green.bolder': "_0KLXrude1t",
    'color.background.accent.teal.subtlest': "_0KLXruuBpz",
    'color.background.accent.teal.subtler': "_0KLXrunfgW",
    'color.background.accent.teal.subtle': "_0KLXrufjGw",
    'color.background.accent.teal.bolder': "_0KLXruzHaB",
    'color.background.accent.blue.subtlest': "_0KLXruVva3",
    'color.background.accent.blue.subtler': "_0KLXrup9dS",
    'color.background.accent.blue.subtle': "_0KLXru28sy",
    'color.background.accent.blue.bolder': "_0KLXrutfbE",
    'color.background.accent.purple.subtlest': "_0KLXruB8KG",
    'color.background.accent.purple.subtler': "_0KLXruWOdT",
    'color.background.accent.purple.subtle': "_0KLXruf89Q",
    'color.background.accent.purple.bolder': "_0KLXruhdss",
    'color.background.accent.magenta.subtlest': "_0KLXru8frT",
    'color.background.accent.magenta.subtler': "_0KLXruXM4x",
    'color.background.accent.magenta.subtle': "_0KLXrupmfs",
    'color.background.accent.magenta.bolder': "_0KLXruxE6Y",
    'color.background.accent.gray.subtlest': "_0KLXrumhAQ",
    'color.background.accent.gray.subtler': "_0KLXruG6qS",
    'color.background.accent.gray.subtle': "_0KLXrueZ10",
    'color.background.accent.gray.bolder': "_0KLXrurxgm",
    'color.background.inverse.subtle': "_0KLXruB4sa",
    'color.background.neutral': "_0KLXruDMqu",
    'color.background.neutral.bold': "_0KLXrugozt",
    'color.background.brand.subtlest': "_0KLXrunl7T",
    'color.background.brand.bold': "_0KLXruDM2k",
    'color.background.brand.boldest': "_0KLXru2o0p",
    'color.background.danger': "_0KLXruhH7k",
    'color.background.danger.bold': "_0KLXruqsXs",
    'color.background.warning': "_0KLXruhxIM",
    'color.background.warning.bold': "_0KLXruKLKE",
    'color.background.success': "_0KLXruzaZe",
    'color.background.success.bold': "_0KLXruhbjP",
    'color.background.discovery': "_0KLXru94rk",
    'color.background.discovery.bold': "_0KLXruqjHC",
    'color.background.information': "_0KLXrugNg3",
    'color.background.information.bold': "_0KLXruASYT"
}; /**
    * __Tile__
    *
    * A tile is a rounded square that takes an asset and represents a noun.
    *
    */ 
const $60cc37ad75899268$var$Tile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Tile(props) {
    const $ = (0, $bDgLe.c)(17);
    const { children: children, label: label, size: t0, backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: t1, testId: testId } = props;
    const size = t0 === undefined ? "medium" : t0;
    const isInset = t1 === undefined ? true : t1;
    const containerRef = (0, $cozmU.useRef)(null);
    let t2;
    if ($[0] !== size) {
        t2 = ()=>{
            return;
        };
        $[0] = size;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== children || $[3] !== size) {
        t3 = [
            children,
            size
        ];
        $[2] = children;
        $[3] = size;
        $[4] = t3;
    } else t3 = $[4];
    (0, $cozmU.useEffect)(t2, t3);
    const t4 = label !== "" ? label : undefined;
    const t5 = label !== "" ? "img" : undefined;
    const t6 = $60cc37ad75899268$var$sizeMap[size];
    const t7 = isInset ? $60cc37ad75899268$var$styles.inset : $60cc37ad75899268$var$styles.nonInset;
    const t8 = isInset && $60cc37ad75899268$var$insetSizeMap[size];
    const t9 = $60cc37ad75899268$var$backgroundColorMap[backgroundColor || "color.background.neutral"];
    const t10 = hasBorder && $60cc37ad75899268$var$styles.border;
    let t11;
    if ($[5] !== t10 || $[6] !== t6 || $[7] !== t7 || $[8] !== t8 || $[9] !== t9) {
        t11 = (0, $hekY6.default)([
            $60cc37ad75899268$var$styles.root,
            t6,
            t7,
            t8,
            t9,
            t10
        ]);
        $[5] = t10;
        $[6] = t6;
        $[7] = t7;
        $[8] = t8;
        $[9] = t9;
        $[10] = t11;
    } else t11 = $[10];
    let t12;
    if ($[11] !== children || $[12] !== t11 || $[13] !== t4 || $[14] !== t5 || $[15] !== testId) {
        t12 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            ref: containerRef,
            "data-testid": testId,
            "aria-label": t4,
            role: t5,
            className: t11,
            children: children
        });
        $[11] = children;
        $[12] = t11;
        $[13] = t4;
        $[14] = t5;
        $[15] = testId;
        $[16] = t12;
    } else t12 = $[16];
    return t12;
} : function Tile(props) {
    const { children: children, label: label, size: size = 'medium', backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: isInset = true, testId: testId } = props;
    const containerRef = (0, $cozmU.useRef)(null); // Dev-mode only: validate that raster images passed into the tile
    // are square and retina-compatible (at least 2x the rendered tile size).
    (0, $cozmU.useEffect)(()=>{
        return;
    }, [
        children,
        size
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        ref: containerRef,
        "data-testid": testId,
        "aria-label": label !== '' ? label : undefined,
        role: label !== '' ? 'img' : undefined,
        className: (0, $hekY6.default)([
            $60cc37ad75899268$var$styles.root,
            $60cc37ad75899268$var$sizeMap[size],
            isInset ? $60cc37ad75899268$var$styles.inset : $60cc37ad75899268$var$styles.nonInset,
            isInset && $60cc37ad75899268$var$insetSizeMap[size],
            $60cc37ad75899268$var$backgroundColorMap[backgroundColor || 'color.background.neutral'],
            hasBorder && $60cc37ad75899268$var$styles.border
        ]),
        children: children
    });
};
var $60cc37ad75899268$export$2e2bcd8739ae039 = $60cc37ad75899268$var$Tile;
function $60cc37ad75899268$var$_temp(fn) {
    return fn();
}
module.exports["default"] = $60cc37ad75899268$export$2e2bcd8739ae039;

});

parcelRegister("3y1ko", function(module, exports) {

var $xwvlW = parcelRequire("xwvlW");


var $3IBnw = parcelRequire("3IBnw");


var $5ZqQS = parcelRequire("5ZqQS");


var $f7B1p = parcelRequire("f7B1p");

async function $4c06255176f911bc$export$632d1cf1f5c6210f() {
    let enabled = false;
    try {
        const res = await (0, $f7B1p.cfetch)('/wiki/rest/confluenceshortcuts/latest/enabled');
        if (res.ok) enabled = await res.text() === 'true';
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(new Error(`Error fetching keyboard shortcuts enabled state: ${e.message}`), {
            attribution: (0, $3IBnw.Attribution).BACKBONE
        });
    }
    return window.__SHORTCUT_ENABLED__ = enabled;
}
async function $4c06255176f911bc$export$abcdd924245fc03a() {
    const { isLoggedIn: isLoggedIn, isLicensed: isLicensed } = (0, $xwvlW.getPreloaderFnContext)();
    if (isLoggedIn && isLicensed) return await $4c06255176f911bc$export$632d1cf1f5c6210f();
    return false;
}
module.exports["fetchShortcutEnabledState"] = $4c06255176f911bc$export$632d1cf1f5c6210f;
module.exports["preloadShortcutEnabledState"] = $4c06255176f911bc$export$abcdd924245fc03a;

});

parcelRegister("8pcS0", function(module, exports) {
const $6863c3b6124eda1d$export$2400baf28368a887 = {
    TEMPLATE: 'com.atlassian.confluence.template',
    MACRO_CORE: 'com.atlassian.confluence.macro.core',
    MIGRATION: 'com.atlassian.confluence.migration',
    // used for all macros that use Extension API and require references to be rendered
    MACRO_WITH_REFERENCES: 'com.atlassian.confluence.macro.with.references',
    NATIVE: 'com.atlassian.confluence.native'
};
const $6863c3b6124eda1d$export$8e1715e14eb19dce = {
    INVALID: '__confluenceADFMigrationUnsupportedContentInternalExtension__'
};
const $6863c3b6124eda1d$export$a4903313a3329d59 = {
    UNSUPPORTED_EXTENSION: 'unsupportedExtension',
    INVALID_ADF: 'invalidAdf'
};
const $6863c3b6124eda1d$export$84b772adeaf6b683 = 'extension';
const $6863c3b6124eda1d$export$5da07912b4c30471 = 'inlineExtension';
const $6863c3b6124eda1d$export$2af94dcd5e74e23b = 'bodiedExtension';
const $6863c3b6124eda1d$export$43b3eb119fc177ea = 'multiBodiedExtension';
const $6863c3b6124eda1d$export$6e997645168087e1 = [
    {
        content: [],
        type: 'paragraph'
    }
];
const $6863c3b6124eda1d$export$87be616c9ded92ee = [
    {
        type: 'extensionFrame',
        content: [
            {
                type: 'paragraph',
                content: []
            }
        ]
    }
];
const $6863c3b6124eda1d$export$f9804d409e73a2cd = {
    TEMPLATE: 'variable',
    INLINE_EXTERNAL_IMAGE: 'inline-external-image',
    INLINE_MEDIA_IMAGE: 'inline-media-image',
    PRIVACY_MARK: 'privacy-mark',
    ANCHOR: 'anchor',
    PANEL: 'panel',
    SECTION: 'section',
    CHEESE: 'cheese',
    COLUMN: 'column',
    CONTENT_BY_LABEL: 'contentbylabel',
    CONTENT_BY_USER: 'content-by-user',
    CREATE_SPACE_BUTTON: 'create-space-button',
    FAVORITE_PAGES: 'favpages',
    GLOBAL_REPORTS: 'global-reports',
    IM_PRESENCE: 'im',
    LOREMIPSUM: 'loremipsum',
    NAVIGATION_MAP: 'navmap',
    PAGE_TREE: 'pagetree',
    RECENTLY_UPDATED: 'recently-updated',
    RECENTLY_USED_LABELS: 'recently-used-labels',
    SEARCH: 'search',
    SPACE_DETAILS: 'space-details',
    INVALID: '__confluenceADFMigrationUnsupportedContentInternalExtension__',
    REDACTED_MACRO_PLACEHOLDER: 'redactedMacroPlaceholder',
    TOC: 'toc',
    LIVE_SEARCH: 'livesearch',
    CREATE_FROM_TEMPLATE: 'create-from-template',
    CONFLUENCE_DATABASES: 'database-extension',
    DETAILS: 'details',
    DETAILS_SUMMARY: 'detailssummary',
    EXPAND: 'expand',
    EXCERPT: 'excerpt',
    EXCERPT_INCLUDE: 'excerpt-include',
    CHILDREN: 'children',
    PROFILE_PICTURE: 'profile-picture',
    PROFILE: 'profile',
    BLOG_POSTS: 'blog-posts',
    INCLUDE: 'include',
    JIRA: 'jira',
    JIRACHART: 'jirachart',
    LEGACY_CONTENT: 'legacy-content',
    TEAM_CALENDARS: 'calendar',
    CONTRIBUTORS: 'contributors',
    IFRAME: 'iframe',
    LIST_LABELS: 'listlabels',
    POPULAR_LABELS: 'popular-labels',
    TASKS_REPORT_MACRO: 'tasks-report-macro',
    NATIVE_EMBED: 'native-embed',
    HIDE: 'hide',
    PAGE_TREE_SEARCH: 'pagetreesearch',
    WIDGET: 'widget',
    CONTENT_REPORT_TABLE: 'content-report-table',
    CHANGE_HISTORY: 'change-history',
    VIEWPDF: 'viewpdf',
    ATTACHMENTS: 'attachments',
    AGENT_MANAGED_BLOCK: 'agent-managed-block',
    VIEWXLS: 'viewxls'
};
const $6863c3b6124eda1d$export$52ab8a936196819e = [
    'toc',
    'expand',
    'trello-board',
    'status',
    'jiraroadmap'
];
const $6863c3b6124eda1d$export$ab3b6d629a99a505 = [
    $6863c3b6124eda1d$export$f9804d409e73a2cd.TOC,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.ANCHOR,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.LIVE_SEARCH,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS_SUMMARY,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXPAND,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT_INCLUDE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CREATE_FROM_TEMPLATE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.REDACTED_MACRO_PLACEHOLDER,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONFLUENCE_DATABASES,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PROFILE_PICTURE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PROFILE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.ATTACHMENTS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.BLOG_POSTS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.RECENTLY_UPDATED,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.TEAM_CALENDARS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONTRIBUTORS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.IFRAME,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.POPULAR_LABELS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.LIST_LABELS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONTENT_BY_LABEL,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PAGE_TREE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PAGE_TREE_SEARCH,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.INCLUDE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.WIDGET,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONTENT_REPORT_TABLE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CHANGE_HISTORY,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.VIEWPDF,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.TASKS_REPORT_MACRO,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.VIEWXLS
];
const $6863c3b6124eda1d$export$77fa9372f916e938 = new Set([
    $6863c3b6124eda1d$export$84b772adeaf6b683,
    $6863c3b6124eda1d$export$5da07912b4c30471,
    $6863c3b6124eda1d$export$2af94dcd5e74e23b
]);
const $6863c3b6124eda1d$export$12c3fa6b8a339bbd = 255;
const $6863c3b6124eda1d$export$3b4caad8695d985a = [
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CHILDREN,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT_INCLUDE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONTENT_BY_LABEL,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.RECENTLY_UPDATED
];
const $6863c3b6124eda1d$export$b700e56f703b191 = [
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CHILDREN,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PAGE_TREE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.INCLUDE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS_SUMMARY
];
module.exports["EXTENSION_TYPE"] = $6863c3b6124eda1d$export$2400baf28368a887;
module.exports["MIGRATION_EXTENSION_KEYS"] = $6863c3b6124eda1d$export$8e1715e14eb19dce;
module.exports["REGULAR_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$84b772adeaf6b683;
module.exports["INLINE_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$5da07912b4c30471;
module.exports["BODIED_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$2af94dcd5e74e23b;
module.exports["MULTI_BODIED_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$43b3eb119fc177ea;
module.exports["EMPTY_ADF_CONTENT"] = $6863c3b6124eda1d$export$6e997645168087e1;
module.exports["MULTI_BODIED_INITIAL_CONTENT"] = $6863c3b6124eda1d$export$87be616c9ded92ee;
module.exports["EXTENSION_KEY"] = $6863c3b6124eda1d$export$f9804d409e73a2cd;
module.exports["allowedMacrosForInsertMenu"] = $6863c3b6124eda1d$export$52ab8a936196819e;
module.exports["serverRenderedExtensions"] = $6863c3b6124eda1d$export$ab3b6d629a99a505;
module.exports["supportedExtensions"] = $6863c3b6124eda1d$export$77fa9372f916e938;
module.exports["MAX_ATLASSIAN_ALLOWED_FRAGMENT_LENGTH"] = $6863c3b6124eda1d$export$12c3fa6b8a339bbd;
module.exports["MODERENIZED_MACRO_KEYS"] = $6863c3b6124eda1d$export$3b4caad8695d985a;
module.exports["MACROS_WITH_LIVE_DOC_REFERENCE"] = $6863c3b6124eda1d$export$b700e56f703b191;

});

parcelRegister("duklN", function(module, exports) {
/**
 * @generated SignedSource<<cc7770e3fb2fd979845343325dfb00a2>>
 * @relayHash 512d3c288e476ca23b45061d9102b2d6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e2afb2ac9c484784fd55eb2fcafbcb54d438eef15f40b0e4c160a6b625de2a3b
const $78d6c4b2c14ab559$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePageTitlePageTitleQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePageTitlePageTitleQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "512d3c288e476ca23b45061d9102b2d6",
            "id": "e2afb2ac9c484784fd55eb2fcafbcb54d438eef15f40b0e4c160a6b625de2a3b",
            "metadata": {},
            "name": "usePageTitlePageTitleQuery",
            "operationKind": "query",
            "text": "query usePageTitlePageTitleQuery($contentId:ID!){singleContent(id:$contentId){id,title}}"
        }
    };
}();
$78d6c4b2c14ab559$var$node.hash = "49163e20c25d3da0c01ad2e924f87c37";
var $78d6c4b2c14ab559$export$2e2bcd8739ae039 = $78d6c4b2c14ab559$var$node;
module.exports["default"] = $78d6c4b2c14ab559$export$2e2bcd8739ae039;

});

parcelRegister("iaK3p", function(module, exports) {
/**
 * @generated SignedSource<<77901a4d26c14ce3e165e61f1fbc7d81>>
 * @relayHash 5f15c23509e6cb7f2874b0f92de8a11b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8c70e28d771c617ecf7c58416cff6761443cf9b61782cdb47a1bb82fdf95ba9f
const $8d30006ecab20121$var$node = function() {
    var v0 = [
        {
            "concreteType": "DiscoveredFeature",
            "kind": "LinkedField",
            "name": "featureDiscovery",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "pluginKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "featureKey"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useFeatureDiscoveryFeatureDiscoveryQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useFeatureDiscoveryFeatureDiscoveryQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "5f15c23509e6cb7f2874b0f92de8a11b",
            "id": "8c70e28d771c617ecf7c58416cff6761443cf9b61782cdb47a1bb82fdf95ba9f",
            "metadata": {},
            "name": "useFeatureDiscoveryFeatureDiscoveryQuery",
            "operationKind": "query",
            "text": "query useFeatureDiscoveryFeatureDiscoveryQuery{featureDiscovery{pluginKey,featureKey}}"
        }
    };
}();
$8d30006ecab20121$var$node.hash = "8577be880df828fbee71c90a7701eddf";
var $8d30006ecab20121$export$2e2bcd8739ae039 = $8d30006ecab20121$var$node;
module.exports["default"] = $8d30006ecab20121$export$2e2bcd8739ae039;

});

parcelRegister("6m3nS", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $e71ebdc70c2ecd2e$var$initialActiveTriggerState = {
    activeTriggerState: {}
};
const $e71ebdc70c2ecd2e$var$initialTriggerDispatchState = {
    setTriggerState: ()=>{
        // eslint-disable-next-line no-console
        console.error('No Post Office Trigger Context found. Did you remember to add a Post Office Provider?');
    }
};
const $e71ebdc70c2ecd2e$var$TriggerContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext($e71ebdc70c2ecd2e$var$initialActiveTriggerState);
const $e71ebdc70c2ecd2e$var$TriggerDispatchContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext($e71ebdc70c2ecd2e$var$initialTriggerDispatchState);
const $e71ebdc70c2ecd2e$export$e80a5720bb4c8fe3 = ({ children: children })=>{
    const [recordState, setRecordState] = (0, $cozmU.useState)({});
    const setTriggerState = (0, $cozmU.useCallback)(({ isActive: isActive, triggerId: triggerId })=>{
        setRecordState((current)=>{
            if (!!current[triggerId] === isActive) return current;
            if (isActive) return {
                ...current,
                [triggerId]: true
            };
            const { [triggerId]: excludedTrigger, ...rest } = current;
            return rest;
        });
    }, []);
    const triggerContextValue = (0, $cozmU.useMemo)(()=>({
            activeTriggerState: recordState
        }), [
        recordState
    ]);
    const triggerContexDispatchValue = (0, $cozmU.useMemo)(()=>({
            setTriggerState: setTriggerState
        }), [
        setTriggerState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e71ebdc70c2ecd2e$var$TriggerContext.Provider, {
        value: triggerContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e71ebdc70c2ecd2e$var$TriggerDispatchContext.Provider, {
        value: triggerContexDispatchValue
    }, children));
};
const $e71ebdc70c2ecd2e$export$454c1d7c35958f5e = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($e71ebdc70c2ecd2e$var$TriggerContext);
} : ()=>(0, $cozmU.useContext)($e71ebdc70c2ecd2e$var$TriggerContext);
const $e71ebdc70c2ecd2e$export$23cbf084e08bdb93 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($e71ebdc70c2ecd2e$var$TriggerDispatchContext);
} : ()=>(0, $cozmU.useContext)($e71ebdc70c2ecd2e$var$TriggerDispatchContext);
const $e71ebdc70c2ecd2e$export$3b196fe93a948c18 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (triggerId)=>{
    const $ = (0, $bDgLe.c)(3);
    const { activeTriggerState: activeTriggerState } = $e71ebdc70c2ecd2e$export$454c1d7c35958f5e();
    let t0;
    if ($[0] !== activeTriggerState || $[1] !== triggerId) {
        t0 = triggerId ? {
            isActive: !!activeTriggerState[triggerId]
        } : {
            isActive: undefined
        };
        $[0] = activeTriggerState;
        $[1] = triggerId;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (triggerId)=>{
    const { activeTriggerState: activeTriggerState } = $e71ebdc70c2ecd2e$export$454c1d7c35958f5e();
    return triggerId ? {
        isActive: !!activeTriggerState[triggerId]
    } : {
        isActive: undefined
    };
};
const $e71ebdc70c2ecd2e$export$83b33e5fe4cce64 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { triggerId: triggerId } = t0;
    const { setTriggerState: setContextTriggerState } = $e71ebdc70c2ecd2e$export$23cbf084e08bdb93();
    let t1;
    if ($[0] !== setContextTriggerState || $[1] !== triggerId) {
        t1 = (t2)=>{
            const { isActive: isActive } = t2;
            return setContextTriggerState({
                triggerId: triggerId,
                isActive: isActive
            });
        };
        $[0] = setContextTriggerState;
        $[1] = triggerId;
        $[2] = t1;
    } else t1 = $[2];
    const fireTrigger = t1;
    let t2;
    if ($[3] !== fireTrigger) {
        t2 = {
            fireTrigger: fireTrigger
        };
        $[3] = fireTrigger;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ triggerId: triggerId })=>{
    const { setTriggerState: setContextTriggerState } = $e71ebdc70c2ecd2e$export$23cbf084e08bdb93();
    const fireTrigger = (0, $cozmU.useCallback)(({ isActive: isActive })=>{
        return setContextTriggerState({
            triggerId: triggerId,
            isActive: isActive
        });
    }, [
        setContextTriggerState,
        triggerId
    ]);
    return {
        fireTrigger: fireTrigger
    };
};
const $e71ebdc70c2ecd2e$export$e45375ff75169f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (messageId)=>{
    const $ = (0, $bDgLe.c)(17);
    const { isActive: hasMessageStarted } = $e71ebdc70c2ecd2e$export$3b196fe93a948c18(`${messageId}-started`);
    const t0 = `${messageId}-start`;
    let t1;
    if ($[0] !== t0) {
        t1 = {
            triggerId: t0
        };
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { fireTrigger: requestMessageStartTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64(t1);
    const t2 = `${messageId}-dismiss`;
    let t3;
    if ($[2] !== t2) {
        t3 = {
            triggerId: t2
        };
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    const { fireTrigger: fireDismissClickTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64(t3);
    const t4 = `${messageId}-cta-click`;
    let t5;
    if ($[4] !== t4) {
        t5 = {
            triggerId: t4
        };
        $[4] = t4;
        $[5] = t5;
    } else t5 = $[5];
    const { fireTrigger: fireCtaClickTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64(t5);
    let t6;
    if ($[6] !== requestMessageStartTrigger) {
        t6 = ()=>{
            requestMessageStartTrigger({
                isActive: true
            });
        };
        $[6] = requestMessageStartTrigger;
        $[7] = t6;
    } else t6 = $[7];
    const requestMessageStart = t6;
    let t7;
    if ($[8] !== fireDismissClickTrigger) {
        t7 = ()=>{
            fireDismissClickTrigger({
                isActive: true
            });
        };
        $[8] = fireDismissClickTrigger;
        $[9] = t7;
    } else t7 = $[9];
    const dismissMessage = t7;
    let t8;
    if ($[10] !== fireCtaClickTrigger) {
        t8 = ()=>{
            fireCtaClickTrigger({
                isActive: true
            });
        };
        $[10] = fireCtaClickTrigger;
        $[11] = t8;
    } else t8 = $[11];
    const handlePostOfficeClickTracking = t8;
    let t9;
    if ($[12] !== dismissMessage || $[13] !== handlePostOfficeClickTracking || $[14] !== hasMessageStarted || $[15] !== requestMessageStart) {
        t9 = {
            hasMessageStarted: hasMessageStarted,
            requestMessageStart: requestMessageStart,
            dismissMessage: dismissMessage,
            handlePostOfficeClickTracking: handlePostOfficeClickTracking
        };
        $[12] = dismissMessage;
        $[13] = handlePostOfficeClickTracking;
        $[14] = hasMessageStarted;
        $[15] = requestMessageStart;
        $[16] = t9;
    } else t9 = $[16];
    return t9;
} : (messageId)=>{
    // listeners
    const { isActive: hasMessageStarted } = $e71ebdc70c2ecd2e$export$3b196fe93a948c18(`${messageId}-started`);
    // actions
    const { fireTrigger: requestMessageStartTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64({
        triggerId: `${messageId}-start`
    });
    const { fireTrigger: fireDismissClickTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64({
        triggerId: `${messageId}-dismiss`
    });
    const { fireTrigger: fireCtaClickTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64({
        triggerId: `${messageId}-cta-click`
    });
    const requestMessageStart = (0, $cozmU.useCallback)(()=>{
        requestMessageStartTrigger({
            isActive: true
        });
    }, [
        requestMessageStartTrigger
    ]);
    const dismissMessage = (0, $cozmU.useCallback)(()=>{
        fireDismissClickTrigger({
            isActive: true
        });
    }, [
        fireDismissClickTrigger
    ]);
    const handlePostOfficeClickTracking = (0, $cozmU.useCallback)(()=>{
        fireCtaClickTrigger({
            isActive: true
        });
    }, [
        fireCtaClickTrigger
    ]);
    return {
        hasMessageStarted: hasMessageStarted,
        requestMessageStart: requestMessageStart,
        dismissMessage: dismissMessage,
        handlePostOfficeClickTracking: handlePostOfficeClickTracking
    };
};
module.exports["TriggerContextProvider"] = $e71ebdc70c2ecd2e$export$e80a5720bb4c8fe3;
module.exports["useTrigger"] = $e71ebdc70c2ecd2e$export$3b196fe93a948c18;
module.exports["useFirePostOfficeTrigger"] = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64;
module.exports["usePostOfficeExernalMessageProxy"] = $e71ebdc70c2ecd2e$export$e45375ff75169f;

});

parcelRegister("3vgx3", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $ad7Ou = parcelRequire("ad7Ou");


var $fM984 = parcelRequire("fM984");


var $lmzCg = parcelRequire("lmzCg");


var $dpsRj = parcelRequire("dpsRj");


var $5Dlqn = parcelRequire("5Dlqn");


var $aRyr7 = parcelRequire("aRyr7");


var $7sJoX = parcelRequire("7sJoX");


var $4CEP6 = parcelRequire("4CEP6");


var $iDrrr = parcelRequire("iDrrr");


var $4n1IT = parcelRequire("4n1IT");


var $jp2Q3 = parcelRequire("jp2Q3");


var $eLJVM = parcelRequire("eLJVM");


var $iv7mf = parcelRequire("iv7mf");


var $94Dr9 = parcelRequire("94Dr9");


var $ggC1G = parcelRequire("ggC1G");


var $imIsb = parcelRequire("imIsb");


var $eEek6 = parcelRequire("eEek6");

const $53393d8413cfd6c9$var$MAX_HEIGHT = `calc(100vh - 16px)`;
const $53393d8413cfd6c9$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
const $53393d8413cfd6c9$var$getFallbackPlacements = (placement)=>{
    const placementPieces = placement.split('-');
    const mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        const crossAxis = placementPieces[1];
        return [
            `${mainAxis}`,
            `${mainAxis}-${$53393d8413cfd6c9$var$opposites[crossAxis]}`,
            `${$53393d8413cfd6c9$var$opposites[mainAxis]}-${crossAxis}`,
            `${$53393d8413cfd6c9$var$opposites[mainAxis]}`,
            `${$53393d8413cfd6c9$var$opposites[mainAxis]}-${$53393d8413cfd6c9$var$opposites[crossAxis]}`,
            'auto'
        ];
    } else return [
        `${mainAxis}-start`,
        `${mainAxis}-end`,
        `${$53393d8413cfd6c9$var$opposites[mainAxis]}`,
        `${$53393d8413cfd6c9$var$opposites[mainAxis]}-start`,
        `${$53393d8413cfd6c9$var$opposites[mainAxis]}-end`,
        `auto`
    ];
};
function $53393d8413cfd6c9$var$isKeyboardEvent(event) {
    return event !== null && (event instanceof KeyboardEvent || 'nativeEvent' in event && event.nativeEvent instanceof KeyboardEvent);
}
/**
 * Legacy Popper/Popup implementation (hooks run unconditionally when this component mounts).
 */ const $53393d8413cfd6c9$var$DropdownMenuLegacy = (0, $gtMdU.isReactCompilerActivePlatform)() ? function DropdownMenuLegacy(t0) {
    const $ = (0, $bDgLe.c)(63);
    const { autoFocus: t1, children: children, defaultOpen: t2, isLoading: t3, isOpen: isOpen, onOpenChange: t4, placement: t5, shouldFitContainer: t6, shouldFlip: t7, shouldRenderToParent: t8, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: t9, label: label, interactionName: interactionName, strategy: strategy, menuLabel: menuLabel, shouldPreventEscapePropagation: t10, shouldIgnoreCloseEvent: shouldIgnoreCloseEvent } = t0;
    const autoFocus = t1 === undefined ? false : t1;
    const defaultOpen = t2 === undefined ? false : t2;
    const isLoading = t3 === undefined ? false : t3;
    const onOpenChange = t4 === undefined ? (0, $dpsRj.default) : t4;
    const placement = t5 === undefined ? "bottom-start" : t5;
    const shouldFitContainer = t6 === undefined ? false : t6;
    const shouldFlip = t7 === undefined ? true : t7;
    const shouldRenderToParent = t8 === undefined ? false : t8;
    let t11;
    if ($[0] !== t9) {
        t11 = t9 === undefined ? (0, $jp2Q3.layers).modal() : t9;
        $[0] = t9;
        $[1] = t11;
    } else t11 = $[1];
    const zIndex = t11;
    const shouldPreventEscapePropagation = t10 === undefined ? false : t10;
    let t12;
    if ($[2] !== defaultOpen) {
        t12 = ()=>defaultOpen;
        $[2] = defaultOpen;
        $[3] = t12;
    } else t12 = $[3];
    const [isLocalOpen, setLocalIsOpen] = (0, $5Dlqn.default)(isOpen, t12);
    const triggerRef = (0, $cozmU.useRef)(null);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $cozmU.useState)(false);
    const id = (0, $eEek6.default)();
    const itemRef = (0, $imIsb.default)();
    const { currentLevel: currentLevel } = (0, $4CEP6.useLayering)();
    let t13;
    if ($[4] !== placement) {
        t13 = $53393d8413cfd6c9$var$getFallbackPlacements(placement);
        $[4] = placement;
        $[5] = t13;
    } else t13 = $[5];
    const fallbackPlacements = t13;
    let t14;
    if ($[6] !== isLocalOpen || $[7] !== itemRef || $[8] !== onOpenChange || $[9] !== setLocalIsOpen) {
        t14 = (event)=>{
            const newValue = !isLocalOpen;
            const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
            if (type === "keydown") setTriggeredUsingKeyboard(true);
            else {
                if (clientX === 0 || clientY === 0) setTriggeredUsingKeyboard(true);
                else if (detail === 0) setTriggeredUsingKeyboard(true);
                else {
                    itemRef?.current?.focus();
                    setTriggeredUsingKeyboard(false);
                }
            }
            setLocalIsOpen(newValue);
            onOpenChange({
                isOpen: newValue,
                event: event
            });
        };
        $[6] = isLocalOpen;
        $[7] = itemRef;
        $[8] = onOpenChange;
        $[9] = setLocalIsOpen;
        $[10] = t14;
    } else t14 = $[10];
    const handleTriggerClicked = t14;
    let t15;
    if ($[11] !== itemRef || $[12] !== onOpenChange || $[13] !== returnFocusRef || $[14] !== setLocalIsOpen || $[15] !== shouldPreventEscapePropagation) {
        t15 = (event_0, currentLevel_0)=>{
            const isTabLeftOrEscapeKey = $53393d8413cfd6c9$var$isKeyboardEvent(event_0) && (event_0.key === "Tab" || event_0.key === "Escape" || event_0.key === (0, $fM984.KEY_LEFT));
            if (shouldPreventEscapePropagation && $53393d8413cfd6c9$var$isKeyboardEvent(event_0) && (event_0.key === "Escape" || event_0.key === (0, $fM984.KEY_LEFT))) event_0.stopPropagation();
            if (event_0 !== null && !isTabLeftOrEscapeKey && event_0.target instanceof HTMLElement && event_0.target.closest?.(`[id^=${(0, $eEek6.PREFIX)}] [aria-haspopup]`)) {
                if (!currentLevel_0) return;
                const toCloseLevel = itemRef.current?.dataset["ds-Level"];
                if (toCloseLevel && Number(toCloseLevel) < currentLevel_0) return;
            }
            if (returnFocusRef) requestAnimationFrame(()=>{
                returnFocusRef.current?.focus();
            });
            else {
                if ($53393d8413cfd6c9$var$isKeyboardEvent(event_0) && (event_0.key === "Tab" && event_0.shiftKey || event_0.key === "Escape" || event_0.key === (0, $fM984.KEY_LEFT))) requestAnimationFrame(()=>{
                    itemRef.current?.focus();
                });
                else if (triggerRef.current) {
                    const isClickOutsideMenu = event_0?.target instanceof HTMLElement && event_0.target.closest?.("[role=\"menu\"]") === null;
                    const shouldPreventFocus = isClickOutsideMenu && document.activeElement !== document.body;
                    if (!shouldPreventFocus) requestAnimationFrame(()=>{
                        triggerRef.current?.focus();
                    });
                }
            }
            setLocalIsOpen(false);
            onOpenChange({
                isOpen: false,
                event: event_0
            });
        };
        $[11] = itemRef;
        $[12] = onOpenChange;
        $[13] = returnFocusRef;
        $[14] = setLocalIsOpen;
        $[15] = shouldPreventEscapePropagation;
        $[16] = t15;
    } else t15 = $[16];
    const handleOnClose = t15;
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $aRyr7.default)();
    let t16;
    let t17;
    if ($[17] !== handleOnClose || $[18] !== handleTriggerClicked || $[19] !== isFocused || $[20] !== isLocalOpen) {
        t16 = ()=>{
            if (!isFocused) return 0, $dpsRj.default;
            if (isLocalOpen) return 0, $dpsRj.default;
            return (0, $cbY7C.bind)(window, {
                type: "keydown",
                listener: function openOnKeyDown(e) {
                    let isNestedTriggerButton;
                    if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $eEek6.PREFIX)}] [aria-haspopup]`);
                    if (e.key === (0, $fM984.KEY_DOWN) && !isNestedTriggerButton) {
                        e.preventDefault();
                        handleTriggerClicked(e);
                    } else {
                        if ((e.code === (0, $fM984.KEY_SPACE) || e.key === (0, $fM984.KEY_ENTER)) && e.detail === 0) setTriggeredUsingKeyboard(true);
                        else if (e.key === (0, $fM984.KEY_TAB) && isNestedTriggerButton) handleOnClose(e);
                    }
                }
            });
        };
        t17 = [
            isFocused,
            isLocalOpen,
            handleTriggerClicked,
            handleOnClose
        ];
        $[17] = handleOnClose;
        $[18] = handleTriggerClicked;
        $[19] = isFocused;
        $[20] = isLocalOpen;
        $[21] = t16;
        $[22] = t17;
    } else {
        t16 = $[21];
        t17 = $[22];
    }
    (0, $cozmU.useEffect)(t16, t17);
    let t18;
    if ($[23] !== shouldFitContainer || $[24] !== shouldRenderToParent || $[25] !== strategy) {
        t18 = shouldFitContainer ? {
            shouldFitContainer: shouldFitContainer,
            strategy: strategy !== "fixed" ? strategy : undefined
        } : {
            shouldRenderToParent: shouldRenderToParent,
            strategy: strategy
        };
        $[23] = shouldFitContainer;
        $[24] = shouldRenderToParent;
        $[25] = strategy;
        $[26] = t18;
    } else t18 = $[26];
    const conditionalProps = t18;
    const t19 = isLocalOpen ? id : undefined;
    const t20 = returnFocusRef === undefined;
    const t21 = shouldRenderToParent && currentLevel > 0 ? "group" : undefined;
    const t22 = testId && `${testId}--content`;
    let t23;
    if ($[27] !== bindFocus || $[28] !== handleTriggerClicked || $[29] !== interactionName || $[30] !== isLocalOpen || $[31] !== itemRef || $[32] !== label || $[33] !== testId || $[34] !== trigger) {
        t23 = (t24)=>{
            const { ref: ref, "aria-controls": ariaControls, "aria-expanded": ariaExpanded, "aria-haspopup": ariaHasPopup, ...rest } = t24;
            if (typeof trigger === "function") return trigger({
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                ...rest,
                ...bindFocus,
                triggerRef: (0, $lmzCg.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                isSelected: isLocalOpen,
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`
            });
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                ...bindFocus,
                ref: (0, $lmzCg.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isSelected: isLocalOpen,
                iconAfter: $53393d8413cfd6c9$var$_temp,
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`,
                "aria-label": label,
                interactionName: interactionName,
                children: trigger
            });
        };
        $[27] = bindFocus;
        $[28] = handleTriggerClicked;
        $[29] = interactionName;
        $[30] = isLocalOpen;
        $[31] = itemRef;
        $[32] = label;
        $[33] = testId;
        $[34] = trigger;
        $[35] = t23;
    } else t23 = $[35];
    let t24;
    if ($[36] !== autoFocus || $[37] !== children || $[38] !== handleOnClose || $[39] !== isLoading || $[40] !== isTriggeredUsingKeyboard || $[41] !== menuLabel || $[42] !== shouldFitContainer || $[43] !== shouldRenderToParent || $[44] !== spacing || $[45] !== statusLabel || $[46] !== testId) {
        t24 = (t25)=>{
            const { setInitialFocusRef: setInitialFocusRef, update: update } = t25;
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iv7mf.default), {
                onClose: handleOnClose,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $94Dr9.default), {
                    spacing: spacing,
                    maxHeight: $53393d8413cfd6c9$var$MAX_HEIGHT,
                    maxWidth: shouldFitContainer ? undefined : 800,
                    onClose: handleOnClose,
                    onUpdate: update,
                    isLoading: isLoading,
                    statusLabel: statusLabel,
                    setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                    shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                    isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                    autoFocus: autoFocus,
                    testId: testId && `${testId}--menu-wrapper`,
                    menuLabel: menuLabel,
                    children: children
                })
            });
        };
        $[36] = autoFocus;
        $[37] = children;
        $[38] = handleOnClose;
        $[39] = isLoading;
        $[40] = isTriggeredUsingKeyboard;
        $[41] = menuLabel;
        $[42] = shouldFitContainer;
        $[43] = shouldRenderToParent;
        $[44] = spacing;
        $[45] = statusLabel;
        $[46] = testId;
        $[47] = t24;
    } else t24 = $[47];
    let t25;
    if ($[48] !== conditionalProps || $[49] !== fallbackPlacements || $[50] !== handleOnClose || $[51] !== isLocalOpen || $[52] !== placement || $[53] !== shouldFlip || $[54] !== shouldIgnoreCloseEvent || $[55] !== t19 || $[56] !== t20 || $[57] !== t21 || $[58] !== t22 || $[59] !== t23 || $[60] !== t24 || $[61] !== zIndex) {
        t25 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ggC1G.default), {
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4n1IT.Popup), {
                id: t19,
                shouldFlip: shouldFlip,
                isOpen: isLocalOpen,
                shouldReturnFocus: t20,
                onClose: handleOnClose,
                zIndex: zIndex,
                placement: placement,
                role: t21,
                fallbackPlacements: fallbackPlacements,
                testId: t22,
                shouldUseCaptureOnOutsideClick: true,
                shouldIgnoreCloseEvent: shouldIgnoreCloseEvent,
                ...conditionalProps,
                shouldDisableFocusLock: true,
                trigger: t23,
                content: t24
            })
        });
        $[48] = conditionalProps;
        $[49] = fallbackPlacements;
        $[50] = handleOnClose;
        $[51] = isLocalOpen;
        $[52] = placement;
        $[53] = shouldFlip;
        $[54] = shouldIgnoreCloseEvent;
        $[55] = t19;
        $[56] = t20;
        $[57] = t21;
        $[58] = t22;
        $[59] = t23;
        $[60] = t24;
        $[61] = zIndex;
        $[62] = t25;
    } else t25 = $[62];
    return t25;
} : function DropdownMenuLegacy({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $dpsRj.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, shouldFlip: shouldFlip = true, shouldRenderToParent: shouldRenderToParent = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: zIndex = (0, $jp2Q3.layers).modal(), label: label, interactionName: interactionName, strategy: strategy, menuLabel: menuLabel, shouldPreventEscapePropagation: shouldPreventEscapePropagation = false, shouldIgnoreCloseEvent: shouldIgnoreCloseEvent }) {
    const [isLocalOpen, setLocalIsOpen] = (0, $5Dlqn.default)(isOpen, ()=>defaultOpen);
    const triggerRef = (0, $cozmU.useRef)(null);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $cozmU.useState)(false);
    const id = (0, $eEek6.default)();
    const itemRef = (0, $imIsb.default)();
    const { currentLevel: currentLevel } = (0, $4CEP6.useLayering)();
    const fallbackPlacements = (0, $cozmU.useMemo)(()=>$53393d8413cfd6c9$var$getFallbackPlacements(placement), [
        placement
    ]);
    const handleTriggerClicked = (0, $cozmU.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    (event)=>{
        const newValue = !isLocalOpen;
        const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef?.current?.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange,
        itemRef
    ]);
    const handleOnClose = (0, $cozmU.useCallback)((event_0, currentLevel_0)=>{
        const isTabLeftOrEscapeKey = $53393d8413cfd6c9$var$isKeyboardEvent(event_0) && (event_0.key === 'Tab' || event_0.key === 'Escape' || event_0.key === (0, $fM984.KEY_LEFT));
        // Stop propagation on ESCAPE or Left arrow if shouldPreventEscapePropagation is true
        if (shouldPreventEscapePropagation && $53393d8413cfd6c9$var$isKeyboardEvent(event_0) && (event_0.key === 'Escape' || event_0.key === (0, $fM984.KEY_LEFT))) event_0.stopPropagation();
        if (event_0 !== null && !isTabLeftOrEscapeKey && event_0.target instanceof HTMLElement && event_0.target.closest?.(`[id^=${(0, $eEek6.PREFIX)}] [aria-haspopup]`)) {
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel_0) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            const toCloseLevel = itemRef.current?.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel_0) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(()=>{
            returnFocusRef.current?.focus();
        });
        else if ($53393d8413cfd6c9$var$isKeyboardEvent(event_0) && (event_0.key === 'Tab' && event_0.shiftKey || event_0.key === 'Escape' || event_0.key === (0, $fM984.KEY_LEFT))) requestAnimationFrame(()=>{
            itemRef.current?.focus();
        });
        else if (triggerRef.current) {
            // Don't focus the trigger if the click was outside of the menu
            const isClickOutsideMenu = event_0?.target instanceof HTMLElement && event_0.target.closest?.('[role="menu"]') === null;
            const shouldPreventFocus = isClickOutsideMenu && document.activeElement !== document.body; // except if clicking on the body
            if (!shouldPreventFocus) requestAnimationFrame(()=>{
                triggerRef.current?.focus();
            });
        }
        const newValue_0 = false;
        setLocalIsOpen(newValue_0);
        onOpenChange({
            isOpen: newValue_0,
            event: event_0
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen,
        shouldPreventEscapePropagation
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $aRyr7.default)();
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $cozmU.useEffect)(()=>{
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $dpsRj.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $dpsRj.default;
        return (0, $cbY7C.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                let isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $eEek6.PREFIX)}] [aria-haspopup]`);
                if (e.key === (0, $fM984.KEY_DOWN) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $fM984.KEY_SPACE) || e.key === (0, $fM984.KEY_ENTER)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $fM984.KEY_TAB) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
   * The Popup component requires either:
   * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
   * or
   * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
   *
   * But not:
   * - shouldFitContainer={true} and shouldRenderToParent={false}
   *
   * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
   * types are satisfied.
   */ const conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer,
        // When shouldFitContainer is true, `fixed` positions are not allowed
        strategy: strategy !== 'fixed' ? strategy : undefined
    } : {
        shouldRenderToParent: shouldRenderToParent,
        strategy: strategy
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ggC1G.default), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4n1IT.Popup), {
            id: isLocalOpen ? id : undefined,
            shouldFlip: shouldFlip,
            isOpen: isLocalOpen,
            shouldReturnFocus: // If returnFocusRef is provided, we **don't** want to return focus to the trigger.
            // Otherwise, Popup will focus on the dropdown trigger after the `returnFocusRef` element is focused.
            returnFocusRef === undefined,
            onClose: handleOnClose,
            zIndex: zIndex,
            placement: placement,
            role: shouldRenderToParent && currentLevel > 0 ? 'group' : undefined,
            fallbackPlacements: fallbackPlacements,
            testId: testId && `${testId}--content`,
            shouldUseCaptureOnOutsideClick: true,
            shouldIgnoreCloseEvent: shouldIgnoreCloseEvent,
            ...conditionalProps,
            shouldDisableFocusLock: true,
            trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, // DSP-13312 TODO: remove spread props in future major release
            ...rest })=>{
                if (typeof trigger === 'function') return trigger({
                    'aria-controls': ariaControls,
                    'aria-expanded': ariaExpanded,
                    'aria-haspopup': ariaHasPopup,
                    ...rest,
                    ...bindFocus,
                    triggerRef: (0, $lmzCg.default)([
                        ref,
                        triggerRef,
                        itemRef
                    ]),
                    isSelected: isLocalOpen,
                    onClick: handleTriggerClicked,
                    testId: testId && `${testId}--trigger`
                });
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                    ...bindFocus,
                    ref: (0, $lmzCg.default)([
                        ref,
                        triggerRef,
                        itemRef
                    ]),
                    "aria-controls": ariaControls,
                    "aria-expanded": ariaExpanded,
                    "aria-haspopup": ariaHasPopup,
                    isSelected: isLocalOpen,
                    iconAfter: (iconProps)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                            ...iconProps,
                            size: "small"
                        }),
                    onClick: handleTriggerClicked,
                    testId: testId && `${testId}--trigger`,
                    "aria-label": label,
                    interactionName: interactionName,
                    children: trigger
                });
            },
            content: ({ setInitialFocusRef: setInitialFocusRef, update: update })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iv7mf.default), {
                    onClose: handleOnClose,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $94Dr9.default), {
                        spacing: spacing,
                        maxHeight: $53393d8413cfd6c9$var$MAX_HEIGHT,
                        maxWidth: shouldFitContainer ? undefined : 800,
                        onClose: handleOnClose,
                        onUpdate: update,
                        isLoading: isLoading,
                        statusLabel: statusLabel,
                        setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                        shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                        isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                        autoFocus: autoFocus,
                        testId: testId && `${testId}--menu-wrapper`,
                        menuLabel: menuLabel,
                        children: children
                    })
                })
        })
    });
};
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ function $53393d8413cfd6c9$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
        ...iconProps,
        size: "small"
    });
}
const $53393d8413cfd6c9$var$DropdownMenu = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(19);
    const { autoFocus: t0, children: children, defaultOpen: t1, isLoading: t2, isOpen: isOpen, onOpenChange: t3, placement: t4, shouldFitContainer: t5, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, label: label, interactionName: interactionName, menuLabel: menuLabel } = props;
    const autoFocus = t0 === undefined ? false : t0;
    const defaultOpen = t1 === undefined ? false : t1;
    const isLoading = t2 === undefined ? false : t2;
    const onOpenChange = t3 === undefined ? (0, $dpsRj.default) : t3;
    const placement = t4 === undefined ? "bottom-start" : t4;
    const shouldFitContainer = t5 === undefined ? false : t5;
    if ((0, $iDrrr.fg)("platform-dst-top-layer")) {
        let t6;
        if ($[0] !== autoFocus || $[1] !== children || $[2] !== defaultOpen || $[3] !== interactionName || $[4] !== isLoading || $[5] !== isOpen || $[6] !== label || $[7] !== menuLabel || $[8] !== onOpenChange || $[9] !== placement || $[10] !== returnFocusRef || $[11] !== shouldFitContainer || $[12] !== spacing || $[13] !== statusLabel || $[14] !== testId || $[15] !== trigger) {
            t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eLJVM.default), {
                autoFocus: autoFocus,
                children: children,
                defaultOpen: defaultOpen,
                isLoading: isLoading,
                isOpen: isOpen,
                onOpenChange: onOpenChange,
                placement: placement,
                shouldFitContainer: shouldFitContainer,
                returnFocusRef: returnFocusRef,
                spacing: spacing,
                statusLabel: statusLabel,
                testId: testId,
                trigger: trigger,
                label: label,
                interactionName: interactionName,
                menuLabel: menuLabel
            });
            $[0] = autoFocus;
            $[1] = children;
            $[2] = defaultOpen;
            $[3] = interactionName;
            $[4] = isLoading;
            $[5] = isOpen;
            $[6] = label;
            $[7] = menuLabel;
            $[8] = onOpenChange;
            $[9] = placement;
            $[10] = returnFocusRef;
            $[11] = shouldFitContainer;
            $[12] = spacing;
            $[13] = statusLabel;
            $[14] = testId;
            $[15] = trigger;
            $[16] = t6;
        } else t6 = $[16];
        return t6;
    }
    let t6;
    if ($[17] !== props) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)($53393d8413cfd6c9$var$DropdownMenuLegacy, {
            ...props
        });
        $[17] = props;
        $[18] = t6;
    } else t6 = $[18];
    return t6;
} : (props)=>{
    const { autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $dpsRj.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, label: label, interactionName: interactionName, menuLabel: menuLabel } = props;
    if ((0, $iDrrr.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eLJVM.default), {
        autoFocus: autoFocus,
        children: children,
        defaultOpen: defaultOpen,
        isLoading: isLoading,
        isOpen: isOpen,
        onOpenChange: onOpenChange,
        placement: placement,
        shouldFitContainer: shouldFitContainer,
        returnFocusRef: returnFocusRef,
        spacing: spacing,
        statusLabel: statusLabel,
        testId: testId,
        trigger: trigger,
        label: label,
        interactionName: interactionName,
        menuLabel: menuLabel
    });
    // Forward full public props to the legacy Popper/Popup implementation unchanged.
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props -- wrapper delegates entire DropdownMenuProps API
    return /*#__PURE__*/ (0, $8aG6j.jsx)($53393d8413cfd6c9$var$DropdownMenuLegacy, {
        ...props
    });
};
var $53393d8413cfd6c9$export$2e2bcd8739ae039 = $53393d8413cfd6c9$var$DropdownMenu;
module.exports["default"] = $53393d8413cfd6c9$export$2e2bcd8739ae039;

});

parcelRegister("5Dlqn", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a527e5bb9222c5e$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

function $4a527e5bb9222c5e$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $cozmU.useState)(getDefaultPropValue);
    const isControlledRef = (0, $cozmU.useRef)(isControlled);
    (0, $cozmU.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $cozmU.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("aRyr7", function(module, exports) {
$parcel$export(module.exports, "default", () => $09649a4f36a12f35$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

function $09649a4f36a12f35$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $cozmU.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $cozmU.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $cozmU.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("eLJVM", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $cbY7C = parcelRequire("cbY7C");


var $ad7Ou = parcelRequire("ad7Ou");


var $fM984 = parcelRequire("fM984");


var $dpsRj = parcelRequire("dpsRj");


var $5Dlqn = parcelRequire("5Dlqn");


var $aRyr7 = parcelRequire("aRyr7");


var $7sJoX = parcelRequire("7sJoX");


var $6IL1T = parcelRequire("6IL1T");


var $lfoFx = parcelRequire("lfoFx");


var $lBMxH = parcelRequire("lBMxH");


var $aRDbl = parcelRequire("aRDbl");


var $kVXS3 = parcelRequire("kVXS3");


var $juXYb = parcelRequire("juXYb");


var $dV1Zs = parcelRequire("dV1Zs");


var $fb8lP = parcelRequire("fb8lP");


var $iNWdN = parcelRequire("iNWdN");


var $1unCm = parcelRequire("1unCm");


var $ggC1G = parcelRequire("ggC1G");

const $f516bc94b8de2bc9$var$MAX_HEIGHT = `calc(100vh - 16px)`;
const $f516bc94b8de2bc9$var$styles = {
    spinnerContainer: "_3iDTPbQ4SZ _4ouGXIoaux _37wbyuDIqT _46hvQmkG2W _03SyCPkG2W _0xmtkokG2W _0LQT5EkG2W"
}; /**
    * Event types produced by trigger interactions.
    *
    * - `React.MouseEvent<Element>`: from the trigger's `onClick` handler
    * - `React.KeyboardEvent<Element>`: from the trigger's `onClick` when activated via keyboard
    * - `KeyboardEvent`: native event from the ArrowDown `bind(window, ...)` listener
    */ 
function $f516bc94b8de2bc9$var$getRootMenuPopover({ menu: menu }) {
    const parentMenu = menu.parentElement?.closest('[popover][role="menu"]');
    if (!parentMenu) return menu;
    return $f516bc94b8de2bc9$var$getRootMenuPopover({
        menu: parentMenu
    });
} /**
   * Loading indicator for the dropdown menu.
   */ 
const $f516bc94b8de2bc9$var$LoadingIndicator = (0, $gtMdU.isReactCompilerActivePlatform)() ? function LoadingIndicator(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { statusLabel: t1, testId: testId } = t0;
    const statusLabel = t1 === undefined ? "Loading" : t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            $f516bc94b8de2bc9$var$styles.spinnerContainer
        ]);
        $[0] = t2;
    } else t2 = $[0];
    let t3;
    if ($[1] !== statusLabel || $[2] !== testId) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            role: "menuitem",
            className: t2,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lfoFx.default), {
                size: "small",
                label: statusLabel,
                testId: testId
            })
        });
        $[1] = statusLabel;
        $[2] = testId;
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : function LoadingIndicator({ statusLabel: statusLabel = 'Loading', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        role: "menuitem",
        className: (0, $hekY6.default)([
            $f516bc94b8de2bc9$var$styles.spinnerContainer
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lfoFx.default), {
            size: "small",
            label: statusLabel,
            testId: testId
        })
    });
};
/**
 * Top-layer implementation of DropdownMenu.
 *
 * Replaces the legacy `@atlaskit/popup` + `@atlaskit/portal` + `@atlaskit/layering` pipeline
 * with the native Popover API via `@atlaskit/top-layer`.
 *
 * What is no longer needed:
 * - Portal: top layer handles stacking natively
 * - FocusLock / react-focus-lock: popover=auto provides light dismiss
 * - z-index: top layer is always above everything
 * - FocusManager (ref registration): replaced by DOM-query-based `useArrowNavigation`
 * - handle-focus.tsx: replaced by `useArrowNavigation`
 * - Layering context: top layer nesting is handled by the browser
 * - Fallback placements / Popper: CSS Anchor Positioning handles positioning
 */ function $f516bc94b8de2bc9$var$DropdownMenuTopLayer({ children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpenProp, onOpenChange: onOpenChange = (0, $dpsRj.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, label: label, interactionName: interactionName, menuLabel: menuLabel }) {
    const [isLocalOpen, setLocalIsOpen] = (0, $5Dlqn.default)(isOpenProp, ()=>defaultOpen);
    const triggerRef = (0, $cozmU.useRef)(null);
    const popoverRef = (0, $cozmU.useRef)(null);
    const popoverId = (0, $1unCm.usePopoverId)();
    const topLayerPlacement = (0, $cozmU.useMemo)(()=>(0, $aRDbl.fromLegacyPlacement)({
            legacy: placement
        }), [
        placement
    ]); // DropdownMenu has no `shouldFitViewport` equivalent, so neither axis ever
    // fits and `blockSize` stays `'content'` - `MenuGroup`'s `maxHeight` owns the
    // block axis.
    (0, $dV1Zs.useAnchoredPopover)({
        anchorRef: triggerRef,
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isOpen: isLocalOpen,
        inlineSize: shouldFitContainer ? 'min-anchor' : 'content'
    }); // Close handling.
    // Focus restoration is handled natively by the Popover API:
    //   - Escape: browser restores focus to the trigger automatically
    //   - Click-outside: browser does NOT restore (correct behavior)
    //
    // The only custom focus handling needed is `returnFocusRef`: when provided,
    // we redirect focus to a different element than the trigger. We do this
    // in the onClose callback via rAF, which runs after the browser's native
    // restoration, effectively overriding it.
    const handleOnClose = (0, $cozmU.useCallback)(()=>{
        if (returnFocusRef) requestAnimationFrame(()=>{
            returnFocusRef.current?.focus();
        });
        setLocalIsOpen(false);
        onOpenChange({
            isOpen: false,
            event: null
        });
    }, [
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen
    ]); // Trigger click handling.
    const handleTriggerClicked = (0, $cozmU.useCallback)((event)=>{
        const nextIsOpen = !isLocalOpen;
        setLocalIsOpen(nextIsOpen); // Extract the native DOM event for onOpenChange
        const nativeEvent = 'nativeEvent' in event ? event.nativeEvent : event;
        onOpenChange({
            isOpen: nextIsOpen,
            event: nativeEvent
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $aRyr7.default)(); // When trigger is focused, open dropdown on ArrowDown (top-level only).
    // Per WAI-ARIA, ArrowDown opens a menu from a menubar/button trigger,
    // but inside a vertical submenu, ArrowDown navigates between siblings
    // and ArrowRight opens nested menus instead.
    (0, $cozmU.useEffect)(()=>{
        if (!isFocused || isLocalOpen) return;
         // Do not open on ArrowDown if this trigger is inside a parent menu.
        // Nested menus should only be opened via ArrowRight or Enter.
        const isNestedTrigger = Boolean(triggerRef.current?.closest('[role="menu"]'));
        return (0, $cbY7C.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $fM984.KEY_DOWN) && !isNestedTrigger) {
                    e.preventDefault();
                    handleTriggerClicked(e);
                }
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked
    ]);
    const handleNestedOpen = (0, $cozmU.useCallback)(({ trigger: trigger_0 })=>{
        trigger_0.click();
    }, []);
    const handleTabClose = (0, $cozmU.useCallback)(()=>{
        const currentMenu = popoverRef.current;
        if (!currentMenu) return;
         // Hiding the root native popover synchronously closes its descendant popovers and restores
        // focus to the root trigger. The browser can then perform the Tab default action from there.
        $f516bc94b8de2bc9$var$getRootMenuPopover({
            menu: currentMenu
        }).hidePopover();
    }, []);
    (0, $iNWdN.useArrowNavigation)({
        containerRef: popoverRef,
        onClose: handleTabClose,
        onNestedOpen: handleNestedOpen,
        onNestedClose: handleOnClose,
        isEnabled: isLocalOpen,
        filter: (0, $fb8lP.isAtCurrentMenuLevel)
    }); // Close on menu item click.
    // Close when a regular menuitem is clicked, but not checkboxes/radios
    // and not nested triggers (items with aria-haspopup).
    const handleMenuClick = (0, $cozmU.useCallback)((e_0)=>{
        if (!(e_0.target instanceof Element)) return;
        const menuItem = e_0.target.closest?.('[role="menuitem"], [role="menuitemcheckbox"], [role="menuitemradio"]');
        if (!menuItem) return;
        const isCheckboxOrRadio = menuItem.getAttribute('role') === 'menuitemcheckbox' || menuItem.getAttribute('role') === 'menuitemradio'; // Do not close the menu when clicking a nested trigger (aria-haspopup).
        // The nested dropdown will handle its own open/close.
        const isNestedTrigger_0 = menuItem.hasAttribute('aria-haspopup');
        if (!isCheckboxOrRadio && !isNestedTrigger_0) {
            setLocalIsOpen(false);
            onOpenChange({
                isOpen: false,
                event: e_0.nativeEvent
            });
        }
    }, [
        setLocalIsOpen,
        onOpenChange
    ]);
    const ariaAttributes = (0, $lBMxH.getAriaForTrigger)({
        // Intentionally fudging the type here to allow the fudged aria-haspopup cast below,
        // without having to use `as unknown as ...` which would lose even more type safety.
        role: 'menu',
        isOpen: isLocalOpen,
        popoverId: popoverId
    }); // FUDGE(top-layer-api): cast `aria-haspopup` to the narrow shape that adopter
    // public types expect. `@atlaskit/top-layer` types `aria-haspopup` as the wider
    // WAI-ARIA union, but the public `CustomTriggerProps` (extending `@atlaskit/popup`
    // `TriggerProps`) is intentionally kept narrow (`boolean | 'dialog'`) because the
    // top-layer API surface is not yet settled. The runtime value is unchanged; only
    // the TypeScript-visible type is narrowed at this boundary.
    const narrowAriaAttributes = ariaAttributes; /**
       * Custom trigger consumers historically receive a callback ref,
       * and their code assumes it is one.
       * Using this wrapper for compatibility...
       */ 
    const setTriggerRef = (0, $cozmU.useCallback)((node)=>{
        triggerRef.current = node;
    }, []);
    const renderTrigger = ()=>{
        if (typeof trigger === 'function') return trigger({
            ...narrowAriaAttributes,
            onFocus: bindFocus.onFocus,
            onBlur: bindFocus.onBlur,
            triggerRef: setTriggerRef,
            isSelected: isLocalOpen,
            onClick: handleTriggerClicked,
            testId: testId && `${testId}--trigger`
        });
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
            onFocus: bindFocus.onFocus,
            onBlur: bindFocus.onBlur,
            ref: setTriggerRef,
            ...narrowAriaAttributes,
            isSelected: isLocalOpen,
            iconAfter: (iconProps)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                    ...iconProps,
                    size: "small"
                }),
            onClick: handleTriggerClicked,
            testId: testId && `${testId}--trigger`,
            "aria-label": label,
            interactionName: interactionName,
            children: trigger
        });
    };
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $ggC1G.default), {
        children: [
            renderTrigger(),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kVXS3.Popover), {
                ref: popoverRef,
                id: popoverId,
                role: "menu",
                label: menuLabel ?? label ?? (typeof trigger === 'string' ? trigger : 'Menu'),
                isOpen: isLocalOpen,
                onClose: handleOnClose,
                shouldAnimate: true,
                placement: topLayerPlacement,
                testId: testId && `${testId}--content`,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $juXYb.PopoverSurface), {
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6IL1T.default), {
                        maxHeight: $f516bc94b8de2bc9$var$MAX_HEIGHT,
                        maxWidth: shouldFitContainer ? undefined : 800,
                        onClick: handleMenuClick,
                        spacing: spacing,
                        testId: testId && `${testId}--menu-wrapper--menu-group`,
                        children: isLoading ? /*#__PURE__*/ (0, $8aG6j.jsx)($f516bc94b8de2bc9$var$LoadingIndicator, {
                            statusLabel: statusLabel,
                            testId: testId && `${testId}--menu-wrapper--loading-indicator`
                        }) : children
                    })
                })
            })
        ]
    });
}
var $f516bc94b8de2bc9$export$2e2bcd8739ae039 = $f516bc94b8de2bc9$var$DropdownMenuTopLayer;
module.exports["default"] = $f516bc94b8de2bc9$export$2e2bcd8739ae039;

});

parcelRegister("fb8lP", function(module, exports) {
const $6bfdddcadf7826ef$var$menuScope = '[role="menu"]';
/**
 * Recursively walks from `node` toward `container`, returning `true` when
 * `container` is reached without crossing another `role="menu"` ancestor.
 *
 * Used by `isAtCurrentMenuLevel` (pattern 2) to determine if the
 * `closestMenu` is owned by the wrapper container directly. Recursion
 * avoids a mutable `let parent` walk and keeps the function body linear.
 */ function $6bfdddcadf7826ef$var$reachesContainerWithoutNestedMenu(node, container) {
    if (!node || node === container) return node === container;
    if (node.getAttribute('role') === 'menu') return false;
    return $6bfdddcadf7826ef$var$reachesContainerWithoutNestedMenu(node.parentElement, container);
}
function $6bfdddcadf7826ef$export$f1bba0ef464d60af(element, container) {
    const closestMenu = element.closest($6bfdddcadf7826ef$var$menuScope);
    // Container itself has role="menu". Element belongs to this level
    // if its closest menu is the container.
    if (container.getAttribute('role') === 'menu') return closestMenu === container;
    // Container is a wrapper without role="menu" (e.g. dropdown-menu
    // wraps a MenuGroup). The element belongs to the top level if its
    // closest role="menu" ancestor is a direct child of the container,
    // i.e. there is no nested role="menu" between them.
    if (closestMenu === null) return true;
    // Walk up from the closest menu to see if it is "owned" by this
    // container without passing through another role="menu" first.
    return $6bfdddcadf7826ef$var$reachesContainerWithoutNestedMenu(closestMenu.parentElement, container);
}
module.exports["isAtCurrentMenuLevel"] = $6bfdddcadf7826ef$export$f1bba0ef464d60af;

});

parcelRegister("iNWdN", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $1hQ0e = parcelRequire("1hQ0e");


var $fM984 = parcelRequire("fM984");


var $3hJ5V = parcelRequire("3hJ5V");


var $7MWxP = parcelRequire("7MWxP");


var $jzRXW = parcelRequire("jzRXW");

const $341d868aa0ec42f2$var$menuScope = '[role="menu"]';
const $341d868aa0ec42f2$export$23dfbae28e0cc453 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useArrowNavigation(t0) {
    const $ = (0, $bDgLe.c)(11);
    const { containerRef: containerRef, onClose: onClose, onNestedOpen: onNestedOpen, onNestedClose: onNestedClose, isEnabled: t1, filter: filter } = t0;
    const isEnabled = t1 === undefined ? true : t1;
    let t2;
    if ($[0] !== containerRef || $[1] !== filter || $[2] !== onClose || $[3] !== onNestedClose || $[4] !== onNestedOpen) {
        t2 = (event)=>{
            const container = containerRef.current;
            if (!container) return;
            const focused = (0, $1hQ0e.getDocument)()?.activeElement;
            if (focused instanceof HTMLElement) {
                if (filter) {
                    if (!filter(focused, container)) return;
                }
                if (!filter && container.getAttribute("role") === "menu" && focused.closest($341d868aa0ec42f2$var$menuScope) !== container) return;
            }
            if (event.key === (0, $fM984.KEY_DOWN)) {
                event.preventDefault();
                (0, $jzRXW.getNextFocusable)({
                    container: container,
                    direction: "forwards",
                    filter: filter
                })?.focus();
                return;
            }
            if (event.key === (0, $fM984.KEY_UP)) {
                event.preventDefault();
                (0, $jzRXW.getNextFocusable)({
                    container: container,
                    direction: "backwards",
                    filter: filter
                })?.focus();
                return;
            }
            if (event.key === (0, $fM984.KEY_HOME)) {
                event.preventDefault();
                (0, $3hJ5V.getFirstFocusable)({
                    container: container,
                    filter: filter
                })?.focus();
                return;
            }
            if (event.key === (0, $fM984.KEY_END)) {
                event.preventDefault();
                (0, $7MWxP.getLastFocusable)({
                    container: container,
                    filter: filter
                })?.focus();
                return;
            }
            if (event.key === (0, $fM984.KEY_TAB)) {
                onClose();
                return;
            }
            if (event.key === "ArrowRight") {
                if (onNestedOpen && focused instanceof HTMLElement && focused.hasAttribute("aria-haspopup")) {
                    event.preventDefault();
                    onNestedOpen({
                        trigger: focused
                    });
                }
                return;
            }
            if (event.key === "ArrowLeft") {
                if (onNestedClose) {
                    const isNested = container.parentElement?.closest($341d868aa0ec42f2$var$menuScope) !== null;
                    if (isNested) {
                        event.preventDefault();
                        onNestedClose();
                    }
                }
                return;
            }
        };
        $[0] = containerRef;
        $[1] = filter;
        $[2] = onClose;
        $[3] = onNestedClose;
        $[4] = onNestedOpen;
        $[5] = t2;
    } else t2 = $[5];
    const handleKeyDown = t2;
    let t3;
    let t4;
    if ($[6] !== containerRef || $[7] !== handleKeyDown || $[8] !== isEnabled) {
        t3 = ()=>{
            const container_0 = containerRef.current;
            if (!container_0 || !isEnabled) return;
            return (0, $cbY7C.bind)(container_0, {
                type: "keydown",
                listener: handleKeyDown
            });
        };
        t4 = [
            containerRef,
            handleKeyDown,
            isEnabled
        ];
        $[6] = containerRef;
        $[7] = handleKeyDown;
        $[8] = isEnabled;
        $[9] = t3;
        $[10] = t4;
    } else {
        t3 = $[9];
        t4 = $[10];
    }
    (0, $cozmU.useEffect)(t3, t4);
} : function useArrowNavigation({ containerRef: containerRef, onClose: onClose, onNestedOpen: onNestedOpen, onNestedClose: onNestedClose, isEnabled: isEnabled = true, filter: filter }) {
    const handleKeyDown = (0, $cozmU.useCallback)((event)=>{
        const container = containerRef.current;
        if (!container) return;
        // Guard: only handle the event if the currently focused element
        // belongs to this menu level. The focused element's closest
        // [role="menu"] must be this container (not a nested sub-menu).
        // When no filter is provided, fall back to the closest-menu check
        // if the container has role="menu".
        const focused = (0, $1hQ0e.getDocument)()?.activeElement;
        if (focused instanceof HTMLElement) {
            if (filter) {
                if (!filter(focused, container)) return;
            }
            if (!filter && container.getAttribute('role') === 'menu' && focused.closest($341d868aa0ec42f2$var$menuScope) !== container) return;
        }
        if (event.key === (0, $fM984.KEY_DOWN)) {
            // Prevent page scroll while navigating menu items.
            event.preventDefault();
            (0, $jzRXW.getNextFocusable)({
                container: container,
                direction: 'forwards',
                filter: filter
            })?.focus();
            return;
        }
        if (event.key === (0, $fM984.KEY_UP)) {
            // Prevent page scroll while navigating menu items.
            event.preventDefault();
            (0, $jzRXW.getNextFocusable)({
                container: container,
                direction: 'backwards',
                filter: filter
            })?.focus();
            return;
        }
        if (event.key === (0, $fM984.KEY_HOME)) {
            // Prevent browser default (e.g. scrolling to top of page).
            event.preventDefault();
            (0, $3hJ5V.getFirstFocusable)({
                container: container,
                filter: filter
            })?.focus();
            return;
        }
        if (event.key === (0, $fM984.KEY_END)) {
            // Prevent browser default (e.g. scrolling to bottom of page).
            event.preventDefault();
            (0, $7MWxP.getLastFocusable)({
                container: container,
                filter: filter
            })?.focus();
            return;
        }
        if (event.key === (0, $fM984.KEY_TAB)) {
            onClose();
            return;
        }
        // ── Nested menu navigation (WAI-ARIA menu pattern) ──
        // ArrowRight on a menuitem with aria-haspopup opens the submenu.
        if (event.key === 'ArrowRight') {
            if (onNestedOpen && focused instanceof HTMLElement && focused.hasAttribute('aria-haspopup')) {
                event.preventDefault();
                onNestedOpen({
                    trigger: focused
                });
            }
            return;
        }
        // ArrowLeft closes the current menu if it is nested inside a parent menu.
        if (event.key === 'ArrowLeft') {
            if (onNestedClose) {
                // Only close if this container is inside another role="menu"
                // (i.e. it is a submenu, not the top-level menu).
                // Walk up from the parent to avoid matching the container itself.
                const isNested = container.parentElement?.closest($341d868aa0ec42f2$var$menuScope) !== null;
                if (isNested) {
                    event.preventDefault();
                    onNestedClose();
                }
            }
            return;
        }
    }, [
        containerRef,
        onClose,
        onNestedOpen,
        onNestedClose,
        filter
    ]);
    (0, $cozmU.useEffect)(()=>{
        const container_0 = containerRef.current;
        if (!container_0 || !isEnabled) return;
        return (0, $cbY7C.bind)(container_0, {
            type: 'keydown',
            listener: handleKeyDown
        });
    }, [
        containerRef,
        handleKeyDown,
        isEnabled
    ]);
};
module.exports["useArrowNavigation"] = $341d868aa0ec42f2$export$23dfbae28e0cc453;

});

parcelRegister("ggC1G", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lOWpM = parcelRequire("lOWpM");

/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ const $885bea270958798f$var$SelectionStore = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children } = props;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {};
        $[0] = t0;
    } else t0 = $[0];
    const store = (0, $cozmU.useRef)(t0);
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group_0, id_0)=>{
                if (!store.current[group_0]) return;
                return store.current[group_0][id_0];
            },
            setGroupState: (group_1, value_0)=>{
                store.current[group_1] = value_0;
            },
            getGroupState: (group_2)=>store.current[group_2] || {}
        };
        $[1] = t1;
    } else t1 = $[1];
    const context = t1;
    let t2;
    if ($[2] !== children) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lOWpM.SelectionStoreContext).Provider, {
            value: context,
            children: children
        });
        $[2] = children;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : (props)=>{
    const { children: children } = props;
    const store = (0, $cozmU.useRef)({});
    const context = (0, $cozmU.useMemo)(()=>({
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group_0, id_0)=>{
                if (!store.current[group_0]) return undefined;
                return store.current[group_0][id_0];
            },
            setGroupState: (group_1, value_0)=>{
                store.current[group_1] = value_0;
            },
            getGroupState: (group_2)=>{
                return store.current[group_2] || {};
            }
        }), []);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lOWpM.SelectionStoreContext).Provider, {
        value: context,
        children: children
    });
};
var $885bea270958798f$export$2e2bcd8739ae039 = $885bea270958798f$var$SelectionStore;
module.exports["default"] = $885bea270958798f$export$2e2bcd8739ae039;

});

parcelRegister("lOWpM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dpsRj = parcelRequire("dpsRj");

const $db8a5bf4c7b230f3$export$756f795847463ebd = /*#__PURE__*/ (0, $cozmU.createContext)({
    setItemState: (0, $dpsRj.default),
    getItemState: ()=>undefined,
    setGroupState: (0, $dpsRj.default),
    getGroupState: ()=>({})
});
module.exports["SelectionStoreContext"] = $db8a5bf4c7b230f3$export$756f795847463ebd;

});

parcelRegister("iv7mf", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $4CEP6 = parcelRequire("4CEP6");


var $2Bag3 = parcelRequire("2Bag3");


var $6nHMa = parcelRequire("6nHMa");

/**
 * Focus manager logic.
 */ const $f5a399746fdfd30b$var$FocusManager = ({ children: children, onClose: onClose })=>{
    const menuItemRefs = (0, $cozmU.useRef)([]);
    // Used to force a re-render only
    const [refresh, setRefresh] = (0, $cozmU.useState)(0);
    const registerMode = (0, $cozmU.useRef)('ordered');
    registerMode.current = 'ordered';
    const registerRef = (0, $cozmU.useCallback)((ref)=>{
        if (menuItemRefs.current.includes(ref)) return;
        switch(registerMode.current){
            case 'ordered':
                menuItemRefs.current.push(ref);
                break;
            case 'unordered':
                // Reset and force a rerender
                registerMode.current = 'regenerate';
                menuItemRefs.current = [];
                setRefresh(refresh + 1);
                break;
            case 'regenerate':
                break;
            default:
                throw new Error(`Unexpected case of ${registerMode.current}`);
        }
    }, // Updating register ref on force reload will cause `useRegisterItemWithFocusManager` to re-register
    [
        refresh
    ]);
    const { isLayerDisabled: isLayerDisabled, currentLevel: currentLevel } = (0, $4CEP6.useLayering)();
    // Root menu (from a button) is at level 1; first submenu is at level 2. ARIA: Left only closes submenus.
    const isNestedMenu = currentLevel > 1;
    // Intentionally rebinding on each render
    (0, $cozmU.useEffect)(()=>{
        if (registerMode.current === 'ordered') // Use effect is called after rendering is complete and useEffects of the children a called first
        registerMode.current = 'unordered';
    });
    (0, $cozmU.useEffect)(()=>(0, $cbY7C.bind)(window, {
            type: 'keydown',
            listener: (0, $2Bag3.default)(menuItemRefs, isLayerDisabled, onClose, isNestedMenu)
        }), [
        isLayerDisabled,
        onClose,
        isNestedMenu
    ]);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6nHMa.FocusManagerContext).Provider, {
        value: contextValue,
        children: children
    });
};
var $f5a399746fdfd30b$export$2e2bcd8739ae039 = $f5a399746fdfd30b$var$FocusManager;
module.exports["default"] = $f5a399746fdfd30b$export$2e2bcd8739ae039;

});

parcelRegister("2Bag3", function(module, exports) {
$parcel$export(module.exports, "default", () => $b55ec80e24a5f4b9$export$2e2bcd8739ae039);

var $fM984 = parcelRequire("fM984");


var $iDrrr = parcelRequire("iDrrr");


var $eEek6 = parcelRequire("eEek6");

const $b55ec80e24a5f4b9$var$actionMap = {
    [(0, $fM984.KEY_DOWN)]: 'next',
    [(0, $fM984.KEY_UP)]: 'prev',
    [(0, $fM984.KEY_HOME)]: 'first',
    [(0, $fM984.KEY_END)]: 'last'
};
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $b55ec80e24a5f4b9$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx + 1 === refs.length) currentFocusedIdx = 0;
        else currentFocusedIdx++;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $b55ec80e24a5f4b9$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx === 0) currentFocusedIdx = refs.length - 1;
        else currentFocusedIdx--;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
function $b55ec80e24a5f4b9$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose, isNestedMenu = false) {
    return (e)=>{
        const currentRefs = refs.current ?? [];
        const currentFocusedIdx = currentRefs.findIndex(({ current: el })=>el && document.activeElement?.isSameNode(el));
        if ((0, $iDrrr.fg)('platform_dst_popup-disable-focuslock')) {
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            const isNestedDropdown = !!document.activeElement?.closest(`[id^=${(0, $eEek6.PREFIX)}]`);
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $fM984.KEY_TAB) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $fM984.KEY_TAB) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        // Left arrow: only in a submenu — close and return focus to parent. No navigation within menu.
        if (e.key === (0, $fM984.KEY_LEFT)) {
            e.preventDefault();
            if (isNestedMenu) onClose(e);
            return;
        }
        // Right arrow: only when item has submenu — open it. No navigation within menu.
        if (e.key === (0, $fM984.KEY_RIGHT)) {
            const activeElement = document.activeElement;
            if (activeElement instanceof HTMLElement && (activeElement.getAttribute('aria-haspopup') === 'true' || activeElement.getAttribute('aria-haspopup') === 'menu')) {
                e.preventDefault();
                activeElement.click();
            }
            return;
        }
        const action = $b55ec80e24a5f4b9$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                const nextFocusableElement = $b55ec80e24a5f4b9$var$getNextFocusableElement(currentRefs, currentFocusedIdx);
                nextFocusableElement?.focus();
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                const prevFocusableElement = $b55ec80e24a5f4b9$var$getPrevFocusableElement(currentRefs, currentFocusedIdx);
                prevFocusableElement?.focus();
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const firstFocusableElement = $b55ec80e24a5f4b9$var$getNextFocusableElement(currentRefs, -1);
                firstFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const lastFocusableElement = $b55ec80e24a5f4b9$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                lastFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});

parcelRegister("eEek6", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $6JrSr = parcelRequire("6JrSr");

const $bcf8a6c8e532b2af$export$8a682ae47622dbb9 = 'ds--dropdown--';
/**
 * useGeneratedId generates a random string which remains constant across
 * renders when called without any parameter.
 */ const $bcf8a6c8e532b2af$var$useGeneratedId = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useGeneratedId() {
    const id = (0, $6JrSr.useId)();
    return `${$bcf8a6c8e532b2af$export$8a682ae47622dbb9}${id}`;
} : function useGeneratedId() {
    const id = (0, $6JrSr.useId)();
    return `${$bcf8a6c8e532b2af$export$8a682ae47622dbb9}${id}`;
};
var $bcf8a6c8e532b2af$export$2e2bcd8739ae039 = $bcf8a6c8e532b2af$var$useGeneratedId;
module.exports["PREFIX"] = $bcf8a6c8e532b2af$export$8a682ae47622dbb9;
module.exports["default"] = $bcf8a6c8e532b2af$export$2e2bcd8739ae039;

});

parcelRegister("6nHMa", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dpsRj = parcelRequire("dpsRj");

const $f526bd1b7b92569a$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $cozmU.createContext)({
    menuItemRefs: [],
    registerRef: (0, $dpsRj.default)
});
module.exports["FocusManagerContext"] = $f526bd1b7b92569a$export$f18c1d4fc7326096;

});

parcelRegister("94Dr9", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6IL1T = parcelRequire("6IL1T");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $lfoFx = parcelRequire("lfoFx");


var $gsYt4 = parcelRequire("gsYt4");


var $2zAfh = parcelRequire("2zAfh");


var $6nHMa = parcelRequire("6nHMa");

const $9c09f45d8ede8a3c$var$styles = {
    spinnerContainer: "_3iDTPbQ4SZ _4ouGXIoaux _37wbyuDIqT _46hvQmkG2W _03SyCPkG2W _0xmtkokG2W _0LQT5EkG2W"
};
const $9c09f45d8ede8a3c$var$LoadingIndicator = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { statusLabel: t1, testId: testId } = t0;
    const statusLabel = t1 === undefined ? "Loading" : t1;
    let t2;
    if ($[0] !== statusLabel || $[1] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $9c09f45d8ede8a3c$var$styles.spinnerContainer,
            role: "menuitem",
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lfoFx.default), {
                size: "small",
                label: statusLabel,
                testId: testId
            })
        });
        $[0] = statusLabel;
        $[1] = testId;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ statusLabel: statusLabel = 'Loading', testId: testId })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $9c09f45d8ede8a3c$var$styles.spinnerContainer,
        role: "menuitem",
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lfoFx.default), {
            size: "small",
            label: statusLabel,
            testId: testId
        })
    }); /**
          *
          * MenuWrapper wraps all the menu items.
          * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
          * if a CheckboxItem or RadioItem is clicked.
          * It also sets focus to the first menu item when opened.
          */ 
const $9c09f45d8ede8a3c$var$MenuWrapper = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(29);
    const { children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus, menuLabel: menuLabel } = t0;
    const { menuItemRefs: menuItemRefs } = (0, $cozmU.useContext)((0, $6nHMa.FocusManagerContext));
    let t1;
    if ($[0] !== menuItemRefs || $[1] !== onClose) {
        t1 = (e)=>{
            const isTargetMenuItemOrDescendant = menuItemRefs.some((menuItemRef)=>{
                const { current: menuItem } = menuItemRef;
                if (!menuItem) return false;
                const isCheckboxOrRadio = (0, $gsYt4.default)(menuItem) || (0, $2zAfh.default)(menuItem);
                return menuItem.contains(e.target) && !isCheckboxOrRadio;
            });
            if (isTargetMenuItemOrDescendant && onClose) onClose(e);
        };
        $[0] = menuItemRefs;
        $[1] = onClose;
        $[2] = t1;
    } else t1 = $[2];
    const closeOnMenuItemClick = t1;
    let t2;
    if ($[3] !== onUpdate) {
        t2 = ()=>{
            onUpdate();
        };
        $[3] = onUpdate;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== isLoading || $[6] !== onUpdate) {
        t3 = [
            isLoading,
            onUpdate
        ];
        $[5] = isLoading;
        $[6] = onUpdate;
        $[7] = t3;
    } else t3 = $[7];
    (0, $cozmU.useLayoutEffect)(t2, t3);
    let t4;
    let t5;
    if ($[8] !== autoFocus || $[9] !== isTriggeredUsingKeyboard || $[10] !== menuItemRefs || $[11] !== setInitialFocusRef || $[12] !== shouldRenderToParent) {
        t4 = ()=>{
            const firstFocusableRef = menuItemRefs.map($9c09f45d8ede8a3c$var$_temp).find($9c09f45d8ede8a3c$var$_temp2) ?? null;
            if (((0, $iDrrr.fg)("platform_dst_menu_item_focus") || shouldRenderToParent) && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
            setInitialFocusRef?.(firstFocusableRef);
        };
        t5 = [
            menuItemRefs,
            setInitialFocusRef,
            autoFocus,
            shouldRenderToParent,
            isTriggeredUsingKeyboard
        ];
        $[8] = autoFocus;
        $[9] = isTriggeredUsingKeyboard;
        $[10] = menuItemRefs;
        $[11] = setInitialFocusRef;
        $[12] = shouldRenderToParent;
        $[13] = t4;
        $[14] = t5;
    } else {
        t4 = $[13];
        t5 = $[14];
    }
    (0, $cozmU.useEffect)(t4, t5);
    const t6 = testId && `${testId}--menu-group`;
    let t7;
    if ($[15] !== children || $[16] !== isLoading || $[17] !== statusLabel || $[18] !== testId) {
        t7 = isLoading ? /*#__PURE__*/ (0, $8aG6j.jsx)($9c09f45d8ede8a3c$var$LoadingIndicator, {
            statusLabel: statusLabel,
            testId: testId && `${testId}--loading-indicator`
        }) : children;
        $[15] = children;
        $[16] = isLoading;
        $[17] = statusLabel;
        $[18] = testId;
        $[19] = t7;
    } else t7 = $[19];
    let t8;
    if ($[20] !== closeOnMenuItemClick || $[21] !== isLoading || $[22] !== maxHeight || $[23] !== maxWidth || $[24] !== menuLabel || $[25] !== spacing || $[26] !== t6 || $[27] !== t7) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6IL1T.default), {
            isLoading: isLoading,
            maxHeight: maxHeight,
            maxWidth: maxWidth,
            onClick: closeOnMenuItemClick,
            role: "menu",
            spacing: spacing,
            testId: t6,
            menuLabel: menuLabel,
            children: t7
        });
        $[20] = closeOnMenuItemClick;
        $[21] = isLoading;
        $[22] = maxHeight;
        $[23] = maxWidth;
        $[24] = menuLabel;
        $[25] = spacing;
        $[26] = t6;
        $[27] = t7;
        $[28] = t8;
    } else t8 = $[28];
    return t8;
} : ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus, menuLabel: menuLabel })=>{
    const { menuItemRefs: menuItemRefs } = (0, $cozmU.useContext)((0, $6nHMa.FocusManagerContext));
    const closeOnMenuItemClick = (e)=>{
        const isTargetMenuItemOrDescendant = menuItemRefs.some((menuItemRef)=>{
            const { current: menuItem } = menuItemRef;
            if (!menuItem) return false;
            const isCheckboxOrRadio = (0, $gsYt4.default)(menuItem) || (0, $2zAfh.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        }); // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDescendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $cozmU.useLayoutEffect)(()=>{
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $cozmU.useEffect)(()=>{
        const firstFocusableRef = menuItemRefs.map(({ current: current })=>current).find((el)=>!!el && !el.hasAttribute('disabled')) ?? null;
        if (((0, $iDrrr.fg)('platform_dst_menu_item_focus') || shouldRenderToParent) && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
        setInitialFocusRef?.(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6IL1T.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-group`,
        menuLabel: menuLabel,
        children: isLoading ? /*#__PURE__*/ (0, $8aG6j.jsx)($9c09f45d8ede8a3c$var$LoadingIndicator, {
            statusLabel: statusLabel,
            testId: testId && `${testId}--loading-indicator`
        }) : children
    });
};
var $9c09f45d8ede8a3c$export$2e2bcd8739ae039 = $9c09f45d8ede8a3c$var$MenuWrapper;
function $9c09f45d8ede8a3c$var$_temp(t0) {
    const { current: current } = t0;
    return current;
}
function $9c09f45d8ede8a3c$var$_temp2(el) {
    return !!el && !el.hasAttribute("disabled");
}
module.exports["default"] = $9c09f45d8ede8a3c$export$2e2bcd8739ae039;

});

parcelRegister("gsYt4", function(module, exports) {
$parcel$export(module.exports, "default", () => $363009d7887a30e5$export$2e2bcd8739ae039);
function $363009d7887a30e5$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("2zAfh", function(module, exports) {
$parcel$export(module.exports, "default", () => $364a1a3a4c98073c$export$2e2bcd8739ae039);
function $364a1a3a4c98073c$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});

parcelRegister("imIsb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $6nHMa = parcelRequire("6nHMa");

// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programmatically
// control focus on a user navigates using the keyboard.
const $ab7ed338ade85dc7$var$useRegisterItemWithFocusManager = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useRegisterItemWithFocusManager(t0) {
    const $ = (0, $bDgLe.c)(4);
    const hasPopup = t0 === undefined ? false : t0;
    const { registerRef: registerRef } = (0, $cozmU.useContext)((0, $6nHMa.FocusManagerContext));
    const itemRef = (0, $cozmU.useRef)(null);
    let t1;
    let t2;
    if ($[0] !== hasPopup || $[1] !== registerRef) {
        t1 = ()=>{
            if (hasPopup && (0, $iDrrr.fg)("select-avoid-duplicated-registered-ref")) return;
            registerRef(itemRef);
        };
        t2 = [
            registerRef,
            hasPopup
        ];
        $[0] = hasPopup;
        $[1] = registerRef;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return itemRef;
} : function useRegisterItemWithFocusManager(hasPopup = false) {
    const { registerRef: registerRef } = (0, $cozmU.useContext)((0, $6nHMa.FocusManagerContext));
    const itemRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (hasPopup && (0, $iDrrr.fg)('select-avoid-duplicated-registered-ref')) return;
        registerRef(itemRef);
    }, [
        registerRef,
        hasPopup
    ]);
    return itemRef;
};
var $ab7ed338ade85dc7$export$2e2bcd8739ae039 = $ab7ed338ade85dc7$var$useRegisterItemWithFocusManager;
module.exports["default"] = $ab7ed338ade85dc7$export$2e2bcd8739ae039;

});

parcelRegister("is1T6", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $lmzCg = parcelRequire("lmzCg");


var $9d7Pd = parcelRequire("9d7Pd");


var $kD4eB = parcelRequire("kD4eB");


var $8oBbn = parcelRequire("8oBbn");


var $iDrrr = parcelRequire("iDrrr");


var $imIsb = parcelRequire("imIsb");

/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item/usage)
 */ const $94fa0e4252415620$var$DropdownMenuItem = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, interactionName: interactionName, role: role, ...rest }, ref)=>{
    // if the dropdown item has aria-haspopup, we won't register with focus manager
    // since it is a nested trigger, we have registered inside dropdown-menu
    const isNestedTrigger = !!rest['aria-haspopup'];
    const itemRef = (0, $imIsb.default)(isNestedTrigger);
    const handleItemClick = (0, $cozmU.useCallback)((event)=>{
        if (returnFocusRef?.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kD4eB.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $lmzCg.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        interactionName: interactionName,
        ...rest,
        children: children
    });
    else if (href) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8oBbn.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $lmzCg.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        interactionName: interactionName,
        ...rest,
        children: children
    });
    else return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9d7Pd.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $lmzCg.default)([
            ref,
            itemRef
        ]),
        role: role || 'menuitem',
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        interactionName: interactionName,
        ...rest,
        ...isNestedTrigger && (0, $iDrrr.fg)('platform_dst_dropdown_nested_trigger_aria_current') ? {
            'aria-current': undefined
        } : {},
        children: children
    });
});
var $94fa0e4252415620$export$2e2bcd8739ae039 = $94fa0e4252415620$var$DropdownMenuItem;
module.exports["default"] = $94fa0e4252415620$export$2e2bcd8739ae039;

});

parcelRegister("9erVg", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6JrSr = parcelRequire("6JrSr");


var $8FgJC = parcelRequire("8FgJC");


var $eiIYc = parcelRequire("eiIYc");

/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $e544827bc46159a5$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(23);
    let children;
    let hasSeparator;
    let id;
    let isList;
    let isScrollable;
    let rest;
    let testId;
    let title;
    if ($[0] !== t0) {
        ({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, ...rest } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = hasSeparator;
        $[3] = id;
        $[4] = isList;
        $[5] = isScrollable;
        $[6] = rest;
        $[7] = testId;
        $[8] = title;
    } else {
        children = $[1];
        hasSeparator = $[2];
        id = $[3];
        isList = $[4];
        isScrollable = $[5];
        rest = $[6];
        testId = $[7];
        title = $[8];
    }
    const uid = (0, $6JrSr.useId)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    const t1 = title ? titleId : undefined;
    let t2;
    if ($[9] !== title || $[10] !== titleId) {
        t2 = title && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eiIYc.default), {
            id: titleId,
            title: title
        });
        $[9] = title;
        $[10] = titleId;
        $[11] = t2;
    } else t2 = $[11];
    let t3;
    if ($[12] !== children || $[13] !== hasSeparator || $[14] !== id || $[15] !== isList || $[16] !== isScrollable || $[17] !== ref || $[18] !== rest || $[19] !== t1 || $[20] !== t2 || $[21] !== testId) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8FgJC.default), {
            id: id,
            ref: ref,
            isList: isList,
            isScrollable: isScrollable,
            hasSeparator: hasSeparator,
            testId: testId,
            titleId: t1,
            ...rest,
            children: [
                t2,
                children
            ]
        });
        $[12] = children;
        $[13] = hasSeparator;
        $[14] = id;
        $[15] = isList;
        $[16] = isScrollable;
        $[17] = ref;
        $[18] = rest;
        $[19] = t1;
        $[20] = t2;
        $[21] = testId;
        $[22] = t3;
    } else t3 = $[22];
    return t3;
} : ({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, ...rest }, ref)=>{
    const uid = (0, $6JrSr.useId)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8FgJC.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        ...rest,
        children: [
            title && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eiIYc.default), {
                id: titleId,
                title: title
            }),
            children
        ]
    });
});
var $e544827bc46159a5$export$2e2bcd8739ae039 = $e544827bc46159a5$var$DropdownMenuItemGroup;
module.exports["default"] = $e544827bc46159a5$export$2e2bcd8739ae039;

});

parcelRegister("eiIYc", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

const $c2ad6d0f9690e679$var$styles = {
    heading: "_2sNsIgd8bj _4c065UPgdg _2Y7lL45zaO _1UtDYzZpcK"
};
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups.
 *
 * Pre-existing a11y note: uses `role="menuitem"` with `aria-hidden="true"`.
 * WAI-ARIA APG recommends `role="presentation"` for non-interactive group
 * headings, with the group linked via `aria-labelledby`. Out of scope for
 * the top-layer migration — this is legacy behavior.
 *
 * @internal
 */ const $c2ad6d0f9690e679$var$GroupTitle = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { id: id, title: title } = t0;
    let t1;
    if ($[0] !== id || $[1] !== title) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            "data-ds--menu--heading-item": true,
            role: "menuitem",
            id: id,
            "aria-hidden": "true",
            xcss: $c2ad6d0f9690e679$var$styles.heading,
            children: title
        });
        $[0] = id;
        $[1] = title;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ id: id, title: title })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        xcss: $c2ad6d0f9690e679$var$styles.heading,
        children: title
    });
var $c2ad6d0f9690e679$export$2e2bcd8739ae039 = $c2ad6d0f9690e679$var$GroupTitle;
module.exports["default"] = $c2ad6d0f9690e679$export$2e2bcd8739ae039;

});

parcelRegister("etoPX", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $63a5cd591bbe1860$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--rovo-blue-color, #1868db)" fill-rule="evenodd" d="m13.227 16.789-7.154 4.169-3.403-1.96a2.72 2.72 0 0 1-1.362-2.355V7.366c0-.973.518-1.87 1.361-2.354l6.044-3.487-.038.114a3.6 3.6 0 0 0-.172 1.088v9.278c0 1.274.68 2.45 1.786 3.085z" clip-rule="evenodd"/>
    <path fill="var(--rovo-green-color, #6a9a23)" fill-rule="evenodd" d="m11.296 15.671-7.193 4.153 6.607 3.812a2.73 2.73 0 0 0 2.676.026l.048-.033a2.73 2.73 0 0 0 1.232-1.525 2.7 2.7 0 0 0 .127-.822v-3.594z" clip-rule="evenodd"/>
    <path fill="var(--rovo-purple-color, #af59e1)" fill-rule="evenodd" d="m21.477 5.003-4.404-2.539-5.904 4.89 2.69 1.556a3.56 3.56 0 0 1 1.785 3.086v9.277a3.6 3.6 0 0 1-.21 1.202l6.044-3.486a2.71 2.71 0 0 0 1.362-2.355V7.357c0-.97-.521-1.87-1.363-2.354" clip-rule="evenodd"/>
    <path fill="var(--rovo-yellow-color, #fca700)" fill-rule="evenodd" d="M12.74 8.266 9.353 6.312V2.718c0-.283.044-.56.127-.821A2.73 2.73 0 0 1 10.71.372V.37a.4.4 0 0 0 .048-.033 2.73 2.73 0 0 1 2.676.026l6.499 3.75z" clip-rule="evenodd"/>
</svg>
`;
const $63a5cd591bbe1860$export$e23ae35269442b4f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function RovoIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Rovo" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $63a5cd591bbe1860$var$svg,
            label: label,
            type: "rovo",
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : function RovoIcon({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Rovo', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $63a5cd591bbe1860$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["RovoIcon"] = $63a5cd591bbe1860$export$e23ae35269442b4f;

});

parcelRegister("gsyiL", function(module, exports) {

var $eQkRH = parcelRequire("eQkRH");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/confluence/blogpost/manifest.ts
var $bfb9de7804f5bb44$var$confluenceBlogpostAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $eQkRH.ConfluenceBlogpostAriResourceOwner),
    resourceType: (0, $eQkRH.ConfluenceBlogpostAriResourceType),
    resourceIdSlug: "{blogpostId}",
    resourceIdSegmentFormats: {
        blogpostId: /[0-9]+/
    }
};
// src/confluence/blogpost/index.ts
var $bfb9de7804f5bb44$export$8602a2c2f6ac09bc = class _ConfluenceBlogpostAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get blogpostId() {
        return this._blogpostId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $bfb9de7804f5bb44$var$confluenceBlogpostAriStaticOpts.qualifier,
            platformQualifier: $bfb9de7804f5bb44$var$confluenceBlogpostAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $bfb9de7804f5bb44$var$confluenceBlogpostAriStaticOpts.resourceOwner,
            resourceType: $bfb9de7804f5bb44$var$confluenceBlogpostAriStaticOpts.resourceType,
            resourceId: `${opts.blogpostId}`,
            resourceIdSegmentValues: {
                blogpostId: opts.blogpostId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $bfb9de7804f5bb44$var$confluenceBlogpostAriStaticOpts);
        return new _ConfluenceBlogpostAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $bfb9de7804f5bb44$var$confluenceBlogpostAriStaticOpts);
        return new _ConfluenceBlogpostAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            blogpostId: this.blogpostId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._blogpostId = opts.resourceIdSegmentValues.blogpostId;
    }
};
module.exports["ConfluenceBlogpostAri"] = $bfb9de7804f5bb44$export$8602a2c2f6ac09bc;

});

parcelRegister("eQkRH", function(module, exports) {
// src/confluence/blogpost/types.ts
var $ace61b64202bfb2d$export$9389f06bd1d0765c = "confluence", $ace61b64202bfb2d$export$fb777a2d645a4129 = "blogpost";
module.exports["ConfluenceBlogpostAriResourceOwner"] = $ace61b64202bfb2d$export$9389f06bd1d0765c;
module.exports["ConfluenceBlogpostAriResourceType"] = $ace61b64202bfb2d$export$fb777a2d645a4129;

});

parcelRegister("lkYE1", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $1eVGO = parcelRequire("1eVGO");

//      
var $f88a81f3886ec3a5$var$charCodeOfDot = ".".charCodeAt(0);
var $f88a81f3886ec3a5$var$reEscapeChar = /\\(\\)?/g;
var $f88a81f3886ec3a5$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $f88a81f3886ec3a5$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $f88a81f3886ec3a5$var$charCodeOfDot) result.push("");
    string.replace($f88a81f3886ec3a5$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($f88a81f3886ec3a5$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $f88a81f3886ec3a5$var$keysCache = {};
var $f88a81f3886ec3a5$var$keysRegex = /[.[\]]+/;
var $f88a81f3886ec3a5$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($f88a81f3886ec3a5$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $f88a81f3886ec3a5$var$keysCache[key] = key.split($f88a81f3886ec3a5$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $f88a81f3886ec3a5$var$keysCache[key] = $f88a81f3886ec3a5$var$stringToPath(key);
    }
    return $f88a81f3886ec3a5$var$keysCache[key];
};
//      
var $f88a81f3886ec3a5$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $f88a81f3886ec3a5$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $f88a81f3886ec3a5$var$_toPropertyKey(arg) {
    var key = $f88a81f3886ec3a5$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $f88a81f3886ec3a5$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $f88a81f3886ec3a5$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $1eVGO.default)(current, [
                key
            ].map($f88a81f3886ec3a5$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $eb3ax.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $f88a81f3886ec3a5$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $f88a81f3886ec3a5$var$setInRecursor(state, 0, $f88a81f3886ec3a5$var$toPath(key), value1, destroyArrays);
};
var $f88a81f3886ec3a5$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $f88a81f3886ec3a5$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $f88a81f3886ec3a5$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $f88a81f3886ec3a5$export$c52e5867d5879e24(values, name);
    var error = $f88a81f3886ec3a5$export$c52e5867d5879e24(errors, name);
    if (error && error[$f88a81f3886ec3a5$export$735bebc8ffabf28a]) error = error[$f88a81f3886ec3a5$export$735bebc8ffabf28a];
    var submitError = submitErrors && $f88a81f3886ec3a5$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $f88a81f3886ec3a5$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($f88a81f3886ec3a5$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $f88a81f3886ec3a5$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $f88a81f3886ec3a5$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $f88a81f3886ec3a5$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$f88a81f3886ec3a5$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $f88a81f3886ec3a5$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $f88a81f3886ec3a5$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $f88a81f3886ec3a5$var$subscriptionFilter(result, state, previousState, subscription, $f88a81f3886ec3a5$export$41e855cb628c1b55, $f88a81f3886ec3a5$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $f88a81f3886ec3a5$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $f88a81f3886ec3a5$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $f88a81f3886ec3a5$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $f88a81f3886ec3a5$var$subscriptionFilter(result, state, previousState, subscription, $f88a81f3886ec3a5$export$f1ff97b9d1c7a3c3, $f88a81f3886ec3a5$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $f88a81f3886ec3a5$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$f88a81f3886ec3a5$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $f88a81f3886ec3a5$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $f88a81f3886ec3a5$export$83d89fbfd8236492 = "4.20.10";
var $f88a81f3886ec3a5$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $f88a81f3886ec3a5$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $f88a81f3886ec3a5$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $f88a81f3886ec3a5$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $f88a81f3886ec3a5$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $f88a81f3886ec3a5$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $f88a81f3886ec3a5$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $f88a81f3886ec3a5$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($f88a81f3886ec3a5$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $f88a81f3886ec3a5$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $eb3ax.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $eb3ax.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $f88a81f3886ec3a5$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $f88a81f3886ec3a5$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $eb3ax.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $eb3ax.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $eb3ax.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $f88a81f3886ec3a5$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $f88a81f3886ec3a5$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $f88a81f3886ec3a5$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $f88a81f3886ec3a5$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $f88a81f3886ec3a5$export$e6bdf135a54e021b,
                    shallowEqual: $f88a81f3886ec3a5$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $eb3ax.default)({}, state.formState.values)); // clone to avoid writing
            if ($f88a81f3886ec3a5$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($f88a81f3886ec3a5$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $f88a81f3886ec3a5$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $f88a81f3886ec3a5$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $eb3ax.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $eb3ax.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $f88a81f3886ec3a5$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $f88a81f3886ec3a5$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $f88a81f3886ec3a5$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$f88a81f3886ec3a5$export$735bebc8ffabf28a]) {
                    var existing = $f88a81f3886ec3a5$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$f88a81f3886ec3a5$export$735bebc8ffabf28a] = error[$f88a81f3886ec3a5$export$735bebc8ffabf28a];
                    merged = $f88a81f3886ec3a5$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$f88a81f3886ec3a5$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$f88a81f3886ec3a5$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $eb3ax.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $f88a81f3886ec3a5$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $f88a81f3886ec3a5$var$notify(fieldSubscriber, fieldState, lastFieldState, $f88a81f3886ec3a5$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $f88a81f3886ec3a5$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $eb3ax.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($f88a81f3886ec3a5$export$c52e5867d5879e24(formState.values, key), $f88a81f3886ec3a5$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($f88a81f3886ec3a5$export$c52e5867d5879e24(formState.values, key), $f88a81f3886ec3a5$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$f88a81f3886ec3a5$var$hasAnyError(formState.errors) && !(formState.submitErrors && $f88a81f3886ec3a5$var$hasAnyError(formState.submitErrors));
        var nextFormState = $f88a81f3886ec3a5$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $f88a81f3886ec3a5$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $f88a81f3886ec3a5$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $f88a81f3886ec3a5$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $f88a81f3886ec3a5$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $f88a81f3886ec3a5$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $f88a81f3886ec3a5$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $f88a81f3886ec3a5$var$notify(state.subscribers, nextFormState, lastFormState, $f88a81f3886ec3a5$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $eb3ax.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($f88a81f3886ec3a5$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $eb3ax.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $eb3ax.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($f88a81f3886ec3a5$export$c52e5867d5879e24(formState.values, key), $f88a81f3886ec3a5$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $f88a81f3886ec3a5$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $f88a81f3886ec3a5$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $f88a81f3886ec3a5$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $f88a81f3886ec3a5$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $f88a81f3886ec3a5$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $f88a81f3886ec3a5$export$c52e5867d5879e24(state.formState.values, name) === $f88a81f3886ec3a5$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $f88a81f3886ec3a5$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $f88a81f3886ec3a5$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $f88a81f3886ec3a5$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $f88a81f3886ec3a5$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $f88a81f3886ec3a5$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $f88a81f3886ec3a5$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $eb3ax.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $eb3ax.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $eb3ax.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $f88a81f3886ec3a5$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$f88a81f3886ec3a5$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $eb3ax.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $f88a81f3886ec3a5$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $f88a81f3886ec3a5$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $f88a81f3886ec3a5$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $f88a81f3886ec3a5$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}
module.exports["getIn"] = $f88a81f3886ec3a5$export$c52e5867d5879e24;
module.exports["FORM_ERROR"] = $f88a81f3886ec3a5$export$97cd7fc25dd32915;
module.exports["fieldSubscriptionItems"] = $f88a81f3886ec3a5$export$41e855cb628c1b55;
module.exports["formSubscriptionItems"] = $f88a81f3886ec3a5$export$f1ff97b9d1c7a3c3;
module.exports["version"] = $f88a81f3886ec3a5$export$83d89fbfd8236492;
module.exports["createForm"] = $f88a81f3886ec3a5$export$f681a8129d2e9d28;

});

parcelRegister("19ZlF", function(module, exports) {

var $lkYE1 = parcelRequire("lkYE1");

//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $0d863840e9077425$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $0d863840e9077425$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($0d863840e9077425$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $0d863840e9077425$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $lkYE1.getIn)(errors, input.name);
    });
};
//      
var $0d863840e9077425$var$noop = function noop() {};
var $0d863840e9077425$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $0d863840e9077425$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $0d863840e9077425$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $0d863840e9077425$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $0d863840e9077425$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($0d863840e9077425$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$0d863840e9077425$export$2e2bcd8739ae039 = $0d863840e9077425$var$createDecorator;
module.exports["default"] = $0d863840e9077425$export$2e2bcd8739ae039;

});

parcelRegister("lSFbL", function(module, exports) {

var $2itBe = parcelRequire("2itBe");

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $fede975c1f302c4c$var$set(object, path, value) {
    return object == null ? object : $2itBe(object, path, value);
}
module.exports = $fede975c1f302c4c$var$set;

});

parcelRegister("4Qc44", function(module, exports) {
$parcel$export(module.exports, "default", () => $e5936b606760a760$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $e5936b606760a760$export$2e2bcd8739ae039 = (0, $cozmU.forwardRef);

});

parcelRegister("2LyZS", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4j4gm = parcelRequire("4j4gm");


var $4dGdo = parcelRequire("4dGdo");


var $jlWUB = parcelRequire("jlWUB");


var $lrDw7 = parcelRequire("lrDw7");


var $7BVQi = parcelRequire("7BVQi");


var $g3XYx = parcelRequire("g3XYx");


var $1U6E9 = parcelRequire("1U6E9");


var $jhrdR = parcelRequire("jhrdR");

const $88dfee758a89de6e$export$da99457d6430d83 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { duration: t2, timingFunction: t3 } = t1;
    let t4;
    if ($[2] !== t2) {
        t4 = t2 === undefined ? $88dfee758a89de6e$var$_temp : t2;
        $[2] = t2;
        $[3] = t4;
    } else t4 = $[3];
    const calcDuration = t4;
    let t5;
    if ($[4] !== t3) {
        t5 = t3 === undefined ? $88dfee758a89de6e$var$_temp2 : t3;
        $[4] = t3;
        $[5] = t5;
    } else t5 = $[5];
    const calcTimingFunction = t5;
    const prevDimensions = (0, $cozmU.useRef)();
    const [element, setElementRef] = (0, $lrDw7.useElementRef)();
    let t6;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = {
            cleanup: "next-effect"
        };
        $[6] = t6;
    } else t6 = $[6];
    const setTimeout = (0, $1U6E9.useSetTimeout)(t6);
    const requestAnimationFrame = (0, $g3XYx.useRequestAnimationFrame)();
    let t7;
    if ($[7] !== element) {
        t7 = ()=>{
            if ((0, $jlWUB.isReducedMotion)() || !element) return;
            prevDimensions.current = element.getBoundingClientRect();
        };
        $[7] = element;
        $[8] = t7;
    } else t7 = $[8];
    (0, $jhrdR.useSnapshotBeforeUpdate)(t7);
    let t8;
    if ($[9] !== calcDuration || $[10] !== calcTimingFunction || $[11] !== element || $[12] !== requestAnimationFrame || $[13] !== setTimeout) {
        t8 = ()=>{
            if ((0, $jlWUB.isReducedMotion)() || !element || !prevDimensions.current) return;
            element.setAttribute("style", "");
            const nextDimensions = element.getBoundingClientRect();
            if (nextDimensions.height === prevDimensions.current.height) return;
            const duration = calcDuration(prevDimensions.current.height, nextDimensions.height);
            const newStyles = {
                height: `${prevDimensions.current.height}px`,
                willChange: "height",
                transitionProperty: "height",
                transitionDuration: `${duration}ms`,
                boxSizing: "border-box",
                transitionTimingFunction: calcTimingFunction(prevDimensions.current.height, nextDimensions.height, duration)
            };
            Object.assign(element.style, newStyles);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    if (!element) return;
                    element.style.height = `${nextDimensions.height}px`;
                    setTimeout(()=>{
                        if (!element) return;
                        element.setAttribute("style", "");
                    }, duration);
                });
            });
        };
        $[9] = calcDuration;
        $[10] = calcTimingFunction;
        $[11] = element;
        $[12] = requestAnimationFrame;
        $[13] = setTimeout;
        $[14] = t8;
    } else t8 = $[14];
    (0, $7BVQi.useLayoutEffect)(t8);
    let t9;
    if ($[15] !== setElementRef) {
        t9 = {
            ref: setElementRef
        };
        $[15] = setElementRef;
        $[16] = t9;
    } else t9 = $[16];
    return t9;
} : ({ duration: calcDuration = ()=>(0, $4dGdo.durations).medium, timingFunction: calcTimingFunction = ()=>(0, $4j4gm.easeInOut) } = {})=>{
    const prevDimensions = (0, $cozmU.useRef)();
    const [element, setElementRef] = (0, $lrDw7.useElementRef)();
    // We cleanup on the next effect to prevent the previous timeout being called during
    // the next motion - as now the timeout has essentially been extended!
    const setTimeout = (0, $1U6E9.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $g3XYx.useRequestAnimationFrame)();
    (0, $jhrdR.useSnapshotBeforeUpdate)(()=>{
        if ((0, $jlWUB.isReducedMotion)() || !element) return;
        prevDimensions.current = element.getBoundingClientRect();
    });
    (0, $7BVQi.useLayoutEffect)(()=>{
        if ((0, $jlWUB.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination height first.
        element.setAttribute('style', '');
        const nextDimensions = element.getBoundingClientRect();
        if (nextDimensions.height === prevDimensions.current.height) return;
        const duration = calcDuration(prevDimensions.current.height, nextDimensions.height);
        const newStyles = {
            height: `${prevDimensions.current.height}px`,
            willChange: 'height',
            transitionProperty: 'height',
            transitionDuration: `${duration}ms`,
            boxSizing: 'border-box',
            transitionTimingFunction: calcTimingFunction(prevDimensions.current.height, nextDimensions.height, duration)
        };
        Object.assign(element.style, newStyles);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                }, duration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
function $88dfee758a89de6e$var$_temp() {
    return (0, $4dGdo.durations).medium;
}
function $88dfee758a89de6e$var$_temp2() {
    return 0, $4j4gm.easeInOut;
}
module.exports["useResizingHeight"] = $88dfee758a89de6e$export$da99457d6430d83;

});

parcelRegister("2uDbg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $7r5Hr = parcelRequire("7r5Hr");


var $lmzCg = parcelRequire("lmzCg");


var $8c6io = parcelRequire("8c6io");


var $2hGAN = parcelRequire("2hGAN");


var $cAK2R = parcelRequire("cAK2R");


var $kbRVk = parcelRequire("kbRVk");

const $5e9458ef4430c05f$var$checkboxStyles = {
    root: "_30huDKYbGa _1xC2CJsLaB _2xIroY98eZ _497WNwYbGa _2zndICT6kp _39xV02N91d _0jFU0VN91d _034jHtYbGa _0rIjykPgdg _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg _1YKVNsdnbC"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $5e9458ef4430c05f$export$48513f6b9f8ce62d = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function Checkbox(t0, ref) {
    const $ = (0, $bDgLe.c)(59);
    let analyticsContext;
    let className;
    let isCheckedProp;
    let isRequired;
    let label;
    let name;
    let onChangeProps;
    let rest;
    let t1;
    let t2;
    let t3;
    let t4;
    let testId;
    let value;
    let xcss;
    if ($[0] !== t0) {
        ({ isChecked: isCheckedProp, isDisabled: t1, isInvalid: t2, defaultChecked: t3, isIndeterminate: t4, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest } = t0);
        $[0] = t0;
        $[1] = analyticsContext;
        $[2] = className;
        $[3] = isCheckedProp;
        $[4] = isRequired;
        $[5] = label;
        $[6] = name;
        $[7] = onChangeProps;
        $[8] = rest;
        $[9] = t1;
        $[10] = t2;
        $[11] = t3;
        $[12] = t4;
        $[13] = testId;
        $[14] = value;
        $[15] = xcss;
    } else {
        analyticsContext = $[1];
        className = $[2];
        isCheckedProp = $[3];
        isRequired = $[4];
        label = $[5];
        name = $[6];
        onChangeProps = $[7];
        rest = $[8];
        t1 = $[9];
        t2 = $[10];
        t3 = $[11];
        t4 = $[12];
        testId = $[13];
        value = $[14];
        xcss = $[15];
    }
    const isDisabled = t1 === undefined ? false : t1;
    const isInvalid = t2 === undefined ? false : t2;
    const defaultChecked = t3 === undefined ? false : t3;
    const isIndeterminate = t4 === undefined ? false : t4;
    const [isCheckedState, setIsCheckedState] = (0, $cozmU.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    let t5;
    if ($[16] !== onChangeProps) {
        t5 = (e, analyticsEvent)=>{
            setIsCheckedState(e.target.checked);
            if (onChangeProps) onChangeProps(e, analyticsEvent);
        };
        $[16] = onChangeProps;
        $[17] = t5;
    } else t5 = $[17];
    const onChange = t5;
    let t6;
    if ($[18] !== analyticsContext || $[19] !== onChange) {
        t6 = {
            fn: onChange,
            action: "changed",
            analyticsData: analyticsContext,
            componentName: "checkbox",
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        };
        $[18] = analyticsContext;
        $[19] = onChange;
        $[20] = t6;
    } else t6 = $[20];
    const onChangeAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)(t6);
    const internalRef = (0, $cozmU.useRef)(null);
    const mergedRefs = (0, $lmzCg.default)([
        internalRef,
        ref
    ]);
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    let t7;
    if ($[21] !== internalRef || $[22] !== isIndeterminate) {
        t7 = ()=>{
            if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
        };
        $[21] = internalRef;
        $[22] = isIndeterminate;
        $[23] = t7;
    } else t7 = $[23];
    let t8;
    if ($[24] !== isIndeterminate) {
        t8 = [
            isIndeterminate
        ];
        $[24] = isIndeterminate;
        $[25] = t8;
    } else t8 = $[25];
    (0, $cozmU.useEffect)(t7, t8);
    const t9 = label;
    const t10 = rest.id ? `${rest.id}-label` : undefined;
    const t11 = testId && `${testId}--checkbox-label`;
    let t12;
    if ($[26] !== className) {
        t12 = (0, $hekY6.default)([
            $5e9458ef4430c05f$var$checkboxStyles.root,
            className
        ]);
        $[26] = className;
        $[27] = t12;
    } else t12 = $[27];
    const t13 = isInvalid ? "true" : undefined;
    const t14 = testId && `${testId}--hidden-checkbox`;
    const t15 = isInvalid ? "true" : undefined;
    let t16;
    if ($[28] !== isChecked || $[29] !== isDisabled || $[30] !== isRequired || $[31] !== mergedRefs || $[32] !== name || $[33] !== onChangeAnalytics || $[34] !== rest || $[35] !== t12 || $[36] !== t13 || $[37] !== t14 || $[38] !== t15 || $[39] !== value) {
        t16 = /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
            tabIndex: 0,
            ...rest,
            type: "checkbox",
            ref: mergedRefs,
            disabled: isDisabled,
            checked: isChecked,
            value: value,
            name: name,
            required: isRequired,
            className: t12,
            onChange: onChangeAnalytics,
            "aria-invalid": t13,
            "data-testid": t14,
            "data-invalid": t15
        });
        $[28] = isChecked;
        $[29] = isDisabled;
        $[30] = isRequired;
        $[31] = mergedRefs;
        $[32] = name;
        $[33] = onChangeAnalytics;
        $[34] = rest;
        $[35] = t12;
        $[36] = t13;
        $[37] = t14;
        $[38] = t15;
        $[39] = value;
        $[40] = t16;
    } else t16 = $[40];
    let t17;
    if ($[41] !== isChecked || $[42] !== isIndeterminate) {
        t17 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8c6io.default), {
            isIndeterminate: isIndeterminate,
            isChecked: isChecked
        });
        $[41] = isChecked;
        $[42] = isIndeterminate;
        $[43] = t17;
    } else t17 = $[43];
    let t18;
    if ($[44] !== isRequired || $[45] !== label) {
        t18 = label && /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $cAK2R.default), {
            children: [
                label,
                isRequired && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kbRVk.default), {})
            ]
        });
        $[44] = isRequired;
        $[45] = label;
        $[46] = t18;
    } else t18 = $[46];
    let t19;
    if ($[47] !== isChecked || $[48] !== isDisabled || $[49] !== isIndeterminate || $[50] !== isInvalid || $[51] !== t10 || $[52] !== t11 || $[53] !== t16 || $[54] !== t17 || $[55] !== t18 || $[56] !== t9 || $[57] !== xcss) {
        t19 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $2hGAN.default), {
            isDisabled: isDisabled,
            isChecked: isChecked,
            isIndeterminate: isIndeterminate,
            isInvalid: isInvalid,
            label: t9,
            id: t10,
            testId: t11,
            xcss: xcss,
            children: [
                t16,
                t17,
                t18
            ]
        });
        $[47] = isChecked;
        $[48] = isDisabled;
        $[49] = isIndeterminate;
        $[50] = isInvalid;
        $[51] = t10;
        $[52] = t11;
        $[53] = t16;
        $[54] = t17;
        $[55] = t18;
        $[56] = t9;
        $[57] = xcss;
        $[58] = t19;
    } else t19 = $[58];
    return t19;
} : function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $cozmU.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $cozmU.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $cozmU.useRef)(null);
    const mergedRefs = (0, $lmzCg.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $cozmU.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $2hGAN.default), {
        isDisabled: isDisabled,
        isChecked: isChecked,
        isIndeterminate: isIndeterminate,
        isInvalid: isInvalid,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("input" // It is necessary only for Safari. It allows to render focus styles.
            , {
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                className: (0, $hekY6.default)([
                    $5e9458ef4430c05f$var$checkboxStyles.root,
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8c6io.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $cAK2R.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kbRVk.default), {})
                ]
            })
        ]
    });
}));
$5e9458ef4430c05f$export$48513f6b9f8ce62d.displayName = 'Checkbox'; // keep the default export for backwards compatibility
var $5e9458ef4430c05f$export$2e2bcd8739ae039 = $5e9458ef4430c05f$export$48513f6b9f8ce62d;
module.exports["Checkbox"] = $5e9458ef4430c05f$export$48513f6b9f8ce62d;
module.exports["default"] = $5e9458ef4430c05f$export$2e2bcd8739ae039;

});

parcelRegister("8c6io", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $ef6550583d45a5c6$var$svgStyles = {
    root: "_1xC2CJsLaB _4bt5LAnQyn _2WAcuGnQyn _23rrnHXVX0 _0bjKvDKxmn _32BiAhDfsT _1pp6NdYbGa _1UtDYzQPq5 _1rdFvh1XeA _3e6OgrLl21",
    rect: "_23rrnHFqy6 _4gxJYwNvrM _4e1TYvUkr1"
};
function $ef6550583d45a5c6$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
        fill: "inherit"
    });
    if (isChecked) return /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit"
    });
     // No icon
    return null;
}
const $ef6550583d45a5c6$var$CheckboxIcon = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { isIndeterminate: isIndeterminate, isChecked: isChecked } = t0;
    let t1;
    if ($[0] !== isChecked || $[1] !== isIndeterminate) {
        t1 = $ef6550583d45a5c6$var$getIcon(isIndeterminate, isChecked);
        $[0] = isChecked;
        $[1] = isIndeterminate;
        $[2] = t1;
    } else t1 = $[2];
    const icon = t1;
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            $ef6550583d45a5c6$var$svgStyles.root
        ]);
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
            fill: "currentColor",
            x: "5.5",
            y: "5.5",
            width: "13",
            height: "13",
            rx: "1.5",
            className: (0, $hekY6.default)([
                $ef6550583d45a5c6$var$svgStyles.rect
            ])
        });
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== icon) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
            width: 24,
            height: 24,
            viewBox: "0 0 24 24",
            role: "presentation",
            className: t2,
            children: /*#__PURE__*/ (0, $8aG6j.jsxs)("g", {
                fillRule: "evenodd",
                children: [
                    t3,
                    icon
                ]
            })
        });
        $[5] = icon;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : ({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $cozmU.useMemo)(()=>$ef6550583d45a5c6$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        role: "presentation",
        className: (0, $hekY6.default)([
            $ef6550583d45a5c6$var$svgStyles.root
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5",
                    className: (0, $hekY6.default)([
                        $ef6550583d45a5c6$var$svgStyles.rect
                    ])
                }),
                icon
            ]
        })
    });
});
var $ef6550583d45a5c6$export$2e2bcd8739ae039 = $ef6550583d45a5c6$var$CheckboxIcon;
module.exports["default"] = $ef6550583d45a5c6$export$2e2bcd8739ae039;

});

parcelRegister("2hGAN", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $1634ca3e0554fde5$var$baseStyles = null;
const $1634ca3e0554fde5$var$textLabelLayoutStyles = null; // Checked/Indeterminate state
const $1634ca3e0554fde5$var$checkedStyles = null; // Invalid state - must override hover/active to maintain red border
const $1634ca3e0554fde5$var$invalidStyles = null; // Disabled state - must override hover/active to maintain disabled appearance
const $1634ca3e0554fde5$var$disabledStyles = null; // Disabled + Checked/Indeterminate
const $1634ca3e0554fde5$var$disabledCheckedStyles = null;
const $1634ca3e0554fde5$var$Label = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Label(t0) {
    const $ = (0, $bDgLe.c)(13);
    const { children: children, isDisabled: isDisabled, isChecked: isChecked, isIndeterminate: isIndeterminate, isInvalid: isInvalid, testId: testId, label: label, id: id, xcss: xcss } = t0;
    const t1 = label && "_2mHwu8RsfN _2iEGP2a3NQ";
    const t2 = (isChecked || isIndeterminate) && "_49q2vakLmD _0ZqVxakLmD _3jFxiY6BYM _4slB72XLOx _1IEstyXLOx _01wY7FutHW _0R5xzg9r67 _2m1JOU6BYM _1ixXUak5Cz _4dUVtQTxK4 _2o2XD9TxK4";
    const t3 = isInvalid && "_0ZqVxanod9 _1IEstynod9 _0R5xzgnod9 _4dUVtQBvTi";
    const t4 = isDisabled && "_49q2vaVrZW _0ZqVxaVrZW _1UtDYzot27 _0wOv4Qsyl5 _4slB72VrZW _1IEstyVrZW _01wY7FVrZW _0R5xzgVrZW _1ixXUak5Cz _4dUVtQ5l5r _2o2XD95l5r";
    const t5 = isDisabled && (isChecked || isIndeterminate) && "_3jFxiYoM2E _0D4MlqoM2E _2m1JOUoM2E";
    let t6;
    if ($[0] !== t1 || $[1] !== t2 || $[2] !== t3 || $[3] !== t4 || $[4] !== t5 || $[5] !== xcss) {
        t6 = (0, $hekY6.default)([
            "_2sNsIgmnOE _3iDTPbgBM8 _3kOVpyUfmU _21ioM3BY1A _49q2va7Cj1 _0ZqVxaHKt7 _3b00HoYbGa _3jFxiYjOvk _1UtDYzy7kJ _0wOv4Q18ZR _1q8flZXzJH _4slB72qWX3 _01wY7FutHW _0R5xzg9r67 _1ixXUak5Cz _4dUVtQTxK4 _2o2XD9TxK4",
            t1,
            t2,
            t3,
            t4,
            t5,
            xcss
        ]);
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
        $[3] = t4;
        $[4] = t5;
        $[5] = xcss;
        $[6] = t6;
    } else t6 = $[6];
    const t7 = isDisabled || undefined;
    let t8;
    if ($[7] !== children || $[8] !== id || $[9] !== t6 || $[10] !== t7 || $[11] !== testId) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsx)("label", {
            className: t6,
            "data-testid": testId,
            "data-disabled": t7,
            id: id,
            children: children
        });
        $[7] = children;
        $[8] = id;
        $[9] = t6;
        $[10] = t7;
        $[11] = testId;
        $[12] = t8;
    } else t8 = $[12];
    return t8;
} : function Label({ children: children, isDisabled: isDisabled, isChecked: isChecked, isIndeterminate: isIndeterminate, isInvalid: isInvalid, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)("label", {
        className: (0, $hekY6.default)([
            "_2sNsIgmnOE _3iDTPbgBM8 _3kOVpyUfmU _21ioM3BY1A _49q2va7Cj1 _0ZqVxaHKt7 _3b00HoYbGa _3jFxiYjOvk _1UtDYzy7kJ _0wOv4Q18ZR _1q8flZXzJH _4slB72qWX3 _01wY7FutHW _0R5xzg9r67 _1ixXUak5Cz _4dUVtQTxK4 _2o2XD9TxK4",
            label && "_2mHwu8RsfN _2iEGP2a3NQ",
            (isChecked || isIndeterminate) && "_49q2vakLmD _0ZqVxakLmD _3jFxiY6BYM _4slB72XLOx _1IEstyXLOx _01wY7FutHW _0R5xzg9r67 _2m1JOU6BYM _1ixXUak5Cz _4dUVtQTxK4 _2o2XD9TxK4",
            isInvalid && "_0ZqVxanod9 _1IEstynod9 _0R5xzgnod9 _4dUVtQBvTi",
            isDisabled && "_49q2vaVrZW _0ZqVxaVrZW _1UtDYzot27 _0wOv4Qsyl5 _4slB72VrZW _1IEstyVrZW _01wY7FVrZW _0R5xzgVrZW _1ixXUak5Cz _4dUVtQ5l5r _2o2XD95l5r",
            isDisabled && (isChecked || isIndeterminate) && "_3jFxiYoM2E _0D4MlqoM2E _2m1JOUoM2E",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
};
var $1634ca3e0554fde5$export$2e2bcd8739ae039 = $1634ca3e0554fde5$var$Label;
module.exports["default"] = $1634ca3e0554fde5$export$2e2bcd8739ae039;

});

parcelRegister("cAK2R", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $4870a5341200be20$var$labelTextStyles = null;
const $4870a5341200be20$var$LabelText = (0, $gtMdU.isReactCompilerActivePlatform)() ? function LabelText(t0) {
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_1xC2CJvmHw _4xdlr0DIqT"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            className: t1,
            children: children
        });
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : function LabelText({ children: children }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        className: (0, $hekY6.default)([
            "_1xC2CJvmHw _4xdlr0DIqT"
        ]),
        children: children
    });
};
var $4870a5341200be20$export$2e2bcd8739ae039 = $4870a5341200be20$var$LabelText;
module.exports["default"] = $4870a5341200be20$export$2e2bcd8739ae039;

});

parcelRegister("kbRVk", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $126a273b3177dba3$var$requiredIndicatorStyles = null;
const $126a273b3177dba3$var$RequiredIndicator = (0, $gtMdU.isReactCompilerActivePlatform)() ? function RequiredIndicator() {
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            "aria-hidden": true,
            className: (0, $hekY6.default)([
                "_1UtDYzAyGJ _0LQT5EFQfX"
            ]),
            children: "*"
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : function RequiredIndicator() {
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        "aria-hidden": true,
        className: (0, $hekY6.default)([
            "_1UtDYzAyGJ _0LQT5EFQfX"
        ]),
        children: "*"
    });
};
var $126a273b3177dba3$export$2e2bcd8739ae039 = $126a273b3177dba3$var$RequiredIndicator;
module.exports["default"] = $126a273b3177dba3$export$2e2bcd8739ae039;

});

parcelRegister("e3Wrf", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $cozmU = parcelRequire("cozmU");


var $7r5Hr = parcelRequire("7r5Hr");


var $iDrrr = parcelRequire("iDrrr");

const $f7ddda300dd34381$var$packageName = "platform-pkg";
const $f7ddda300dd34381$var$packageVersion = "0.0.0-use.local";
const $f7ddda300dd34381$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $f7ddda300dd34381$var$packageName,
    packageVersion: $f7ddda300dd34381$var$packageVersion
};
const $f7ddda300dd34381$var$lineHeightBase = 20;
const $f7ddda300dd34381$var$lineHeightCompact = 16;
const $f7ddda300dd34381$var$compactVerticalPadding = 2;
const $f7ddda300dd34381$var$verticalPadding = 6;
const $f7ddda300dd34381$var$transitionDuration = '0.2s';
const $f7ddda300dd34381$var$borderWidth = 2;
const $f7ddda300dd34381$var$baseStyles = null;
const $f7ddda300dd34381$var$finessePlaceholderStyles = null;
const $f7ddda300dd34381$var$appearanceStyles = {
    standard: "_3hxITi6wH8 _1mHXSFHKt7 _3OEoix7Cj1 _39nh0ghQC5 _2jpXBkVrZW _31SgFAHKt7 _2zr3nGqWX3 _3LfWyLFQfX _2vsVfZFQfX _2DQpWtXJux _0SosFGXJux _1CDq3qgVvo _2FTXAcgVvo _0tVs2sXJux _3JVwBfXJux _0xkEdpnXvL _1iy5hxutHW _0ui43CPhRM _2UNgvCnXvL _1LO7QkVrZW",
    subtle: "_3hxITi6wH8 _1mHXSFjOvk _3OEoixjOvk _31SgFAHKt7 _2zr3nGqWX3 _3LfWyLFQfX _2vsVfZFQfX _2DQpWtXJux _0SosFGXJux _1CDq3qgVvo _2FTXAcgVvo _3JVwBfXJux _0tVs2sXJux _0xkEdpnXvL _1iy5hxutHW _0ui43CPhRM",
    none: "_3hxITiYbGa _1mHXSFjOvk _3OEoixjOvk _31SgFAjOvk _2zr3nGjOvk _3LfWyLFQfX _0SosFGgVvo _2vsVfZFQfX _2DQpWtgVvo _1CDq3qgVvo _3JVwBfgVvo _2FTXAcgVvo _0tVs2sgVvo _0xkEdpjOvk _1iy5hxjOvk _0ui43Cw5zn"
}; // iOS Safari automatically zooms into form inputs on focus when the font size is less than 16px.
// To prevent this zoom behaviour on mobile devices, the textarea uses font.body.large (16px) by default,
// then switches to the smaller font.body on screens wider than 30rem (desktop).
// @see: https://medium.com/@rares.popescu/2-ways-to-avoid-the-automatic-zoom-in-on-input-fields-8a71479e542e
const $f7ddda300dd34381$var$fontStyles = {
    default: "_2sNsIg20Hp _4kBIzkmnOE",
    monospace: "_2sNsIg20Hp _0WKd3Gfx9v _4kBIzkmnOE _2GdZyqdh5F"
};
const $f7ddda300dd34381$var$resizeStyles = {
    horizontal: "_2HIj7GD4qA",
    vertical: "_2HIj7GbI28",
    auto: "_2HIj7GZSoF",
    smart: "_2HIj7GYbGa",
    none: "_2HIj7GYbGa"
};
const $f7ddda300dd34381$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = $f7ddda300dd34381$var$borderWidth;
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $f7ddda300dd34381$var$InnerTextArea = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(63);
    const ourRef = (0, $cozmU.useRef)(null);
    let onBlur;
    let onChange;
    let onFocus;
    let rest;
    let style;
    let t0;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    let t9;
    let testId;
    let value;
    if ($[0] !== props) {
        ({ resize: t0, appearance: t1, isCompact: t2, isRequired: t3, isReadOnly: t4, isDisabled: t5, isInvalid: t6, isMonospaced: t7, minimumRows: t8, testId: testId, maxHeight: t9, onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props);
        $[0] = props;
        $[1] = onBlur;
        $[2] = onChange;
        $[3] = onFocus;
        $[4] = rest;
        $[5] = style;
        $[6] = t0;
        $[7] = t1;
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
        $[12] = t6;
        $[13] = t7;
        $[14] = t8;
        $[15] = t9;
        $[16] = testId;
        $[17] = value;
    } else {
        onBlur = $[1];
        onChange = $[2];
        onFocus = $[3];
        rest = $[4];
        style = $[5];
        t0 = $[6];
        t1 = $[7];
        t2 = $[8];
        t3 = $[9];
        t4 = $[10];
        t5 = $[11];
        t6 = $[12];
        t7 = $[13];
        t8 = $[14];
        t9 = $[15];
        testId = $[16];
        value = $[17];
    }
    const resize = t0 === undefined ? "smart" : t0;
    const appearance = t1 === undefined ? "standard" : t1;
    const isCompact = t2 === undefined ? false : t2;
    const isRequired = t3 === undefined ? false : t3;
    const isReadOnly = t4 === undefined ? false : t4;
    const isDisabled = t5 === undefined ? false : t5;
    const isInvalid = t6 === undefined ? false : t6;
    const isMonospaced = t7 === undefined ? false : t7;
    const minimumRows = t8 === undefined ? 2 : t8;
    const maxHeight = t9 === undefined ? "50vh" : t9;
    const borderHeight = appearance === "none" ? 2 : 1;
    let t10;
    if ($[18] !== resize) {
        t10 = ()=>{
            const el = ourRef.current;
            if (resize === "smart" && el) $f7ddda300dd34381$var$setSmartHeight(el);
        };
        $[18] = resize;
        $[19] = t10;
    } else t10 = $[19];
    let t11;
    if ($[20] !== resize || $[21] !== value) {
        t11 = [
            resize,
            value
        ];
        $[20] = resize;
        $[21] = value;
        $[22] = t11;
    } else t11 = $[22];
    (0, $cozmU.useEffect)(t10, t11);
    let t12;
    if ($[23] !== onBlur) {
        t12 = {
            fn: (event)=>{
                onBlur && onBlur(event);
            },
            action: "blurred",
            ...$f7ddda300dd34381$var$analyticsParams
        };
        $[23] = onBlur;
        $[24] = t12;
    } else t12 = $[24];
    const onBlurWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)(t12);
    let t13;
    if ($[25] !== onFocus) {
        t13 = {
            fn: (event_0)=>{
                onFocus && onFocus(event_0);
            },
            action: "focused",
            ...$f7ddda300dd34381$var$analyticsParams
        };
        $[25] = onFocus;
        $[26] = t13;
    } else t13 = $[26];
    const onFocusWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)(t13);
    let t14;
    if ($[27] !== ref) {
        t14 = (elementRef)=>{
            ourRef.current = elementRef;
            if (ref && typeof ref === "object") ref.current = elementRef;
            if (ref && typeof ref === "function") ref(elementRef);
        };
        $[27] = ref;
        $[28] = t14;
    } else t14 = $[28];
    const getTextAreaRef = t14;
    let t15;
    if ($[29] !== onChange || $[30] !== resize) {
        t15 = (e)=>{
            const el_0 = ourRef.current;
            if (resize === "smart" && el_0) $f7ddda300dd34381$var$setSmartHeight(el_0);
            onChange && onChange(e);
        };
        $[29] = onChange;
        $[30] = resize;
        $[31] = t15;
    } else t15 = $[31];
    const handleOnChange = t15;
    const t16 = isInvalid ? isInvalid : undefined;
    const t17 = isCompact ? isCompact : undefined;
    const t18 = testId ? testId : undefined;
    let t19;
    if ($[32] !== t16 || $[33] !== t17 || $[34] !== t18) {
        t19 = {
            "data-invalid": t16,
            "data-compact": t17,
            "data-testid": t18
        };
        $[32] = t16;
        $[33] = t17;
        $[34] = t18;
        $[35] = t19;
    } else t19 = $[35];
    const controlProps = t19;
    let t20;
    if ($[36] !== appearance || $[37] !== isMonospaced || $[38] !== resize) {
        t20 = (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _2O5Vij7dHp _3YEZNO7dHp _1bHrqEN91d _0bjKvDKTcp _2sNsIgmnOE _2xIroY98eZ _497WNwYbGa _2zndICT6kp _4bt5LAIZbP _2WAcuGIZbP _23rrnH5Vpu _2V7sgONvrM _3iDTPbvLZJ _24h04i2Njc _39xV02N91d _4ouGXIdnbC _1EqgXlN91d _1mT5xdRAKS _1UtDYzy7kJ _1T2N03wPeg _2IasYonod9 _03v5H87Cj1 _32yk65FKgL _24bGaTot27 _02aXbKsyl5 _0OS5PY7dHp _1kg4OzZqHV _3tCyJvYbGa _2DoaPjYbGa _3pNDujnod9 _1cY5OfqWX3 _0sBZ7MFKgL _30pU6CVrZW _3AxjleKGUX _3MV4MUot27 _1yFQeXQWvZ _3TNCtG1AUN _3OInhJnXvL _1xHRfPutHW _4skx3vPhRM",
            (0, $iDrrr.fg)("platform-dst-tokens-finesse") && "_3AxjleZpcK",
            $f7ddda300dd34381$var$appearanceStyles[appearance],
            $f7ddda300dd34381$var$fontStyles[isMonospaced ? "monospace" : "default"],
            $f7ddda300dd34381$var$resizeStyles[resize],
            "_22P5CgPgdP _2Ombu6q5bj"
        ]);
        $[36] = appearance;
        $[37] = isMonospaced;
        $[38] = resize;
        $[39] = t20;
    } else t20 = $[39];
    const t21 = $f7ddda300dd34381$var$lineHeightCompact * minimumRows + $f7ddda300dd34381$var$compactVerticalPadding * 2 + borderHeight * 2;
    let t22;
    if ($[40] !== t21) {
        t22 = (0, $9aYkv.default)(t21, "px");
        $[40] = t21;
        $[41] = t22;
    } else t22 = $[41];
    const t23 = $f7ddda300dd34381$var$lineHeightBase * minimumRows + $f7ddda300dd34381$var$verticalPadding * 2 + borderHeight * 2;
    let t24;
    if ($[42] !== t23) {
        t24 = (0, $9aYkv.default)(t23, "px");
        $[42] = t23;
        $[43] = t24;
    } else t24 = $[43];
    let t25;
    if ($[44] !== maxHeight || $[45] !== style || $[46] !== t22 || $[47] !== t24) {
        t25 = {
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": t22,
            "--_eorxnz": t24
        };
        $[44] = maxHeight;
        $[45] = style;
        $[46] = t22;
        $[47] = t24;
        $[48] = t25;
    } else t25 = $[48];
    let t26;
    if ($[49] !== controlProps || $[50] !== getTextAreaRef || $[51] !== handleOnChange || $[52] !== isDisabled || $[53] !== isReadOnly || $[54] !== isRequired || $[55] !== minimumRows || $[56] !== onBlurWithAnalytics || $[57] !== onFocusWithAnalytics || $[58] !== rest || $[59] !== t20 || $[60] !== t25 || $[61] !== value) {
        t26 = /*#__PURE__*/ (0, $8aG6j.jsx)("textarea", {
            ...controlProps,
            value: value,
            disabled: isDisabled,
            readOnly: isReadOnly,
            required: isRequired,
            ref: getTextAreaRef,
            onChange: handleOnChange,
            onBlur: onBlurWithAnalytics,
            onFocus: onFocusWithAnalytics,
            rows: minimumRows,
            ...rest,
            className: t20,
            style: t25
        });
        $[49] = controlProps;
        $[50] = getTextAreaRef;
        $[51] = handleOnChange;
        $[52] = isDisabled;
        $[53] = isReadOnly;
        $[54] = isRequired;
        $[55] = minimumRows;
        $[56] = onBlurWithAnalytics;
        $[57] = onFocusWithAnalytics;
        $[58] = rest;
        $[59] = t20;
        $[60] = t25;
        $[61] = value;
        $[62] = t26;
    } else t26 = $[62];
    return t26;
} : (props, ref)=>{
    const ourRef = (0, $cozmU.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props;
    const borderHeight = (0, $cozmU.useMemo)(()=>appearance === 'none' ? 2 : 1, [
        appearance
    ]);
    (0, $cozmU.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $f7ddda300dd34381$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$f7ddda300dd34381$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: (event_0)=>{
            onFocus && onFocus(event_0);
        },
        action: 'focused',
        ...$f7ddda300dd34381$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $cozmU.useCallback)((e)=>{
        const el_0 = ourRef.current;
        if (resize === 'smart' && el_0) $f7ddda300dd34381$var$setSmartHeight(el_0);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        ...rest,
        className: (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _2O5Vij7dHp _3YEZNO7dHp _1bHrqEN91d _0bjKvDKTcp _2sNsIgmnOE _2xIroY98eZ _497WNwYbGa _2zndICT6kp _4bt5LAIZbP _2WAcuGIZbP _23rrnH5Vpu _2V7sgONvrM _3iDTPbvLZJ _24h04i2Njc _39xV02N91d _4ouGXIdnbC _1EqgXlN91d _1mT5xdRAKS _1UtDYzy7kJ _1T2N03wPeg _2IasYonod9 _03v5H87Cj1 _32yk65FKgL _24bGaTot27 _02aXbKsyl5 _0OS5PY7dHp _1kg4OzZqHV _3tCyJvYbGa _2DoaPjYbGa _3pNDujnod9 _1cY5OfqWX3 _0sBZ7MFKgL _30pU6CVrZW _3AxjleKGUX _3MV4MUot27 _1yFQeXQWvZ _3TNCtG1AUN _3OInhJnXvL _1xHRfPutHW _4skx3vPhRM",
            (0, $iDrrr.fg)('platform-dst-tokens-finesse') && "_3AxjleZpcK",
            $f7ddda300dd34381$var$appearanceStyles[appearance],
            $f7ddda300dd34381$var$fontStyles[isMonospaced ? 'monospace' : 'default'],
            $f7ddda300dd34381$var$resizeStyles[resize],
            "_22P5CgPgdP _2Ombu6q5bj"
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": (0, $9aYkv.default)($f7ddda300dd34381$var$lineHeightCompact * minimumRows + $f7ddda300dd34381$var$compactVerticalPadding * 2 + borderHeight * 2, "px"),
            "--_eorxnz": (0, $9aYkv.default)($f7ddda300dd34381$var$lineHeightBase * minimumRows + $f7ddda300dd34381$var$verticalPadding * 2 + borderHeight * 2, "px")
        }
    });
}); /**
     * __Text area__
     *
     * A text area lets users enter long form text which spans over multiple lines.
     *
     * - [Examples](https://atlassian.design/components/textarea/examples)
     * - [Code](https://atlassian.design/components/textarea/code)
     * - [Usage](https://atlassian.design/components/textarea/usage)
     */ 
const $f7ddda300dd34381$var$TextArea = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props || $[1] !== ref) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)($f7ddda300dd34381$var$InnerTextArea, {
            ref: ref,
            ...props
        });
        $[0] = props;
        $[1] = ref;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props, ref)=>/*#__PURE__*/ (0, $8aG6j.jsx)($f7ddda300dd34381$var$InnerTextArea, {
        ref: ref,
        ...props
    })));
$f7ddda300dd34381$var$TextArea.displayName = 'TextArea';
var $f7ddda300dd34381$export$2e2bcd8739ae039 = $f7ddda300dd34381$var$TextArea;
module.exports["default"] = $f7ddda300dd34381$export$2e2bcd8739ae039;

});

parcelRegister("7akNQ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $a2foB = parcelRequire("a2foB");


var $FKQbh = parcelRequire("FKQbh");


var $iXRmn = parcelRequire("iXRmn");


var $lqtHz = parcelRequire("lqtHz");

const $08beb25a8c4ef160$var$getUniqueId = (()=>{
    let count = 0;
    return ()=>`flag-provider-unique-id:${count++}`;
})();
const $08beb25a8c4ef160$export$a4270ab432ac8a58 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function FlagsProvider(t0) {
    const $ = (0, $bDgLe.c)(13);
    const { children: children, shouldRenderToParent: shouldRenderToParent } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [flags, setFlags] = (0, $cozmU.useState)(t1);
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (id)=>{
            setFlags((current)=>current.slice(0).filter((flag)=>flag.id !== id));
        };
        $[1] = t2;
    } else t2 = $[1];
    const removeFlag = t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            showFlag: function show(value) {
                const flag_0 = {
                    ...value,
                    id: value.id || $08beb25a8c4ef160$var$getUniqueId()
                };
                setFlags((current_0)=>{
                    const index = current_0.findIndex((value_0)=>value_0.id === flag_0.id);
                    if (index === -1) return [
                        flag_0,
                        ...current_0
                    ];
                    const shallow = [
                        ...current_0
                    ];
                    shallow[index] = flag_0;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag_0.id);
                };
            },
            hideFlag: removeFlag
        };
        $[2] = t3;
    } else t3 = $[2];
    const api = t3;
    let t4;
    if ($[3] !== children) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iXRmn.FlagContext).Provider, {
            value: api,
            children: children
        });
        $[3] = children;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== flags) {
        t5 = flags.map($08beb25a8c4ef160$var$_temp);
        $[5] = flags;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== shouldRenderToParent || $[8] !== t5) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lqtHz.default), {
            onDismissed: removeFlag,
            shouldRenderToParent: shouldRenderToParent,
            children: t5
        });
        $[7] = shouldRenderToParent;
        $[8] = t5;
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] !== t4 || $[11] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
            children: [
                t4,
                t6
            ]
        });
        $[10] = t4;
        $[11] = t6;
        $[12] = t7;
    } else t7 = $[12];
    return t7;
} : function FlagsProvider({ children: children, shouldRenderToParent: shouldRenderToParent }) {
    const [flags, setFlags] = (0, $cozmU.useState)([]);
    const removeFlag = (0, $cozmU.useCallback)((id)=>{
        setFlags((current)=>{
            return current.slice(0).filter((flag)=>flag.id !== id);
        });
    }, []);
    const api = (0, $cozmU.useMemo)(()=>({
            showFlag: function show(value) {
                const flag_0 = {
                    ...value,
                    id: value.id || $08beb25a8c4ef160$var$getUniqueId()
                };
                setFlags((current_0)=>{
                    const index = current_0.findIndex((value_0)=>value_0.id === flag_0.id);
                    // If flag is not found add it
                    if (index === -1) return [
                        flag_0,
                        ...current_0
                    ];
                    // If flag already exists with the same id, then replace it
                    const shallow = [
                        ...current_0
                    ];
                    shallow[index] = flag_0;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag_0.id);
                };
            },
            hideFlag: removeFlag
        }), [
        removeFlag
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iXRmn.FlagContext).Provider, {
                value: api,
                children: children
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lqtHz.default), {
                onDismissed: removeFlag,
                shouldRenderToParent: shouldRenderToParent,
                children: flags.map((flag_1)=>{
                    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag_1;
                    const FlagType = isAutoDismiss ? (0, $a2foB.default) : (0, $FKQbh.default);
                    return /*#__PURE__*/ (0, $cozmU.createElement)(FlagType, {
                        ...restProps,
                        key: flag_1.id
                    });
                })
            })
        ]
    });
};
function $08beb25a8c4ef160$var$_temp(flag_1) {
    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag_1;
    const FlagType = isAutoDismiss ? (0, $a2foB.default) : (0, $FKQbh.default);
    return /*#__PURE__*/ (0, $cozmU.createElement)(FlagType, {
        ...restProps,
        key: flag_1.id
    });
}
module.exports["FlagsProvider"] = $08beb25a8c4ef160$export$a4270ab432ac8a58;

});

parcelRegister("iXRmn", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $bbe556224ecd1c1b$export$2eb95677cf2465e1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(null);
module.exports["FlagContext"] = $bbe556224ecd1c1b$export$2eb95677cf2465e1;

});

parcelRegister("4MnFz", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $iXRmn = parcelRequire("iXRmn");

const $878d7a55fd1744f7$export$2879604e6aec4ab = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useFlags() {
    const api = (0, $cozmU.useContext)((0, $iXRmn.FlagContext));
    if (api == null) throw new Error("Unable to find FlagProviderContext");
    return api;
} : function useFlags() {
    const api = (0, $cozmU.useContext)((0, $iXRmn.FlagContext));
    if (api == null) throw new Error('Unable to find FlagProviderContext');
    return api;
};
module.exports["useFlags"] = $878d7a55fd1744f7$export$2879604e6aec4ab;

});

parcelRegister("lQXDC", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $emZLc = parcelRequire("emZLc");


var $66Bcq = parcelRequire("66Bcq");


var $gBjHb = parcelRequire("gBjHb");

const $71fb2a898293aa35$export$dc30f43798194b03 = (props)=>{
    const { children: children, sourceName: sourceName, sourceType: sourceType, ...rest } = props;
    const source = sourceName && sourceType ? `${sourceName}${sourceType}` : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($66Bcq)))({
        source: source,
        ...rest
    }, (0, (/*@__PURE__*/$parcel$interopDefault($emZLc))));
};
const $71fb2a898293aa35$export$34282a1f95511a11 = (props)=>{
    const data = $71fb2a898293aa35$export$dc30f43798194b03(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
        data: data
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, props.children));
};
module.exports["ContextWrapper"] = $71fb2a898293aa35$export$34282a1f95511a11;

});

parcelRegister("emZLc", function(module, exports) {
/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */ function $a763071343fcb354$var$isUndefined(value) {
    return value === undefined;
}
module.exports = $a763071343fcb354$var$isUndefined;

});

parcelRegister("hcOES", function(module, exports) {

var $gO1os = parcelRequire("gO1os");


var $jYwtP = parcelRequire("jYwtP");


var $5sm3M = parcelRequire("5sm3M");

const $2b7c6f2b383d7d91$export$34ac71ce24cddec2 = (event, type, payload)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    const clonedEvent = castedEvent.clone();
    if (!clonedEvent) throw new Error("Cannot clone an event after it's been fired.");
    clonedEvent.update({
        ...payload,
        analyticsType: type
    }).fire((0, $jYwtP.ANALYTICS_BRIDGE_CHANNEL));
};
const $2b7c6f2b383d7d91$var$getActionSubjectFromContext = (event)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    return (0, (/*@__PURE__*/$parcel$interopDefault($gO1os)))(castedEvent.context.map((i)=>i.component || i.componentName).filter(Boolean));
};
const $2b7c6f2b383d7d91$export$5d00cd31b1bf8e94 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in UI event');
    const { action: argumentsAction, actionSubject: argumentsActionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $5sm3M.getImperativeAnalyticsDataFromArguments)(rest);
    const castedEvent = event;
    const action = event.payload && event.payload.action || argumentsAction;
    const actionSubject = event.payload && event.payload.actionSubject || argumentsActionSubject || $2b7c6f2b383d7d91$var$getActionSubjectFromContext(castedEvent);
    if (!action) throw new Error('Mandatory "action" field is missing from UI event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from UI event');
    $2b7c6f2b383d7d91$export$34ac71ce24cddec2(event, (0, $jYwtP.UI_EVENT_TYPE), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $2b7c6f2b383d7d91$export$13990ad4625571ed = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Track event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $5sm3M.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Track event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Track event');
    $2b7c6f2b383d7d91$export$34ac71ce24cddec2(event, (0, $jYwtP.TRACK_EVENT_TYPE), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $2b7c6f2b383d7d91$export$79f423cc3fd39762 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Operational event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $5sm3M.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Operational event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Operational event');
    $2b7c6f2b383d7d91$export$34ac71ce24cddec2(event, (0, $jYwtP.OPERATIONAL_EVENT_TYPE), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $2b7c6f2b383d7d91$export$6f46fb37ad7d962b = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Screen event');
    const { attributes: attributes } = (0, $5sm3M.getImperativeAnalyticsDataFromArguments)(rest);
    $2b7c6f2b383d7d91$export$34ac71ce24cddec2(event, (0, $jYwtP.SCREEN_EVENT_TYPE), {
        attributes: attributes
    });
};
module.exports["fireAnalytics"] = $2b7c6f2b383d7d91$export$34ac71ce24cddec2;
module.exports["fireUIAnalytics"] = $2b7c6f2b383d7d91$export$5d00cd31b1bf8e94;
module.exports["fireTrackAnalytics"] = $2b7c6f2b383d7d91$export$13990ad4625571ed;
module.exports["fireOperationalAnalytics"] = $2b7c6f2b383d7d91$export$79f423cc3fd39762;

});

parcelRegister("jYwtP", function(module, exports) {
const $fec988d562d5bfbb$export$f636b5b56f1d624a = 'Screen';
const $fec988d562d5bfbb$export$9d2de6eebf7462b5 = 'Drawer';
const $fec988d562d5bfbb$export$1171103ea9083ffa = 'Modal';
const $fec988d562d5bfbb$export$cae2783c9279926 = 'InlineDialog';
const $fec988d562d5bfbb$export$d1123261ca8831d2 = 'Dropdown';
const $fec988d562d5bfbb$export$a1562d08625f5d7e = 'UI';
const $fec988d562d5bfbb$export$947dac6c72b26f81 = 'TRACK';
const $fec988d562d5bfbb$export$f1d537d508d2945a = 'SCREEN';
const $fec988d562d5bfbb$export$12346a674644c156 = 'OPERATIONAL';
const $fec988d562d5bfbb$export$2ceccf177fae277c = 'analyticsBridge';
module.exports["SCREEN"] = $fec988d562d5bfbb$export$f636b5b56f1d624a;
module.exports["MODAL"] = $fec988d562d5bfbb$export$1171103ea9083ffa;
module.exports["UI_EVENT_TYPE"] = $fec988d562d5bfbb$export$a1562d08625f5d7e;
module.exports["TRACK_EVENT_TYPE"] = $fec988d562d5bfbb$export$947dac6c72b26f81;
module.exports["SCREEN_EVENT_TYPE"] = $fec988d562d5bfbb$export$f1d537d508d2945a;
module.exports["OPERATIONAL_EVENT_TYPE"] = $fec988d562d5bfbb$export$12346a674644c156;
module.exports["ANALYTICS_BRIDGE_CHANNEL"] = $fec988d562d5bfbb$export$2ceccf177fae277c;

});

parcelRegister("5sm3M", function(module, exports) {
const $8f4a194f3d46df20$var$extractDataFromStringAttribute = (string)=>{
    const arr = string.split(' ');
    switch(arr.length){
        case 1:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: arr[0],
                attributes: undefined
            };
        case 2:
            return {
                actionSubject: arr[0],
                action: arr[1],
                actionSubjectId: undefined,
                attributes: undefined
            };
        default:
            throw Error('Event of this type is not supported');
    }
};
const $8f4a194f3d46df20$var$extractDataFromOneAttribute = (one)=>{
    if (typeof one === 'string') return $8f4a194f3d46df20$var$extractDataFromStringAttribute(one);
    if (typeof one === 'object') return {
        actionSubject: undefined,
        action: undefined,
        actionSubjectId: undefined,
        attributes: one
    };
    throw Error('Event of this type is not supported');
};
const $8f4a194f3d46df20$var$extractDataFromTwoAttribute = (one, two)=>{
    if (typeof one === 'string' && typeof two === 'string') {
        const { action: action, actionSubject: actionSubject } = $8f4a194f3d46df20$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: undefined
        };
    }
    if (typeof one === 'string' && typeof two === 'object') {
        const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId } = $8f4a194f3d46df20$var$extractDataFromStringAttribute(one);
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: two
        };
    }
    throw Error('Event of this type is not supported');
};
const $8f4a194f3d46df20$var$extractDataFromThreeAttribute = (one, two, three)=>{
    if (typeof one === 'string' && typeof two === 'string' && typeof three === 'object') {
        const { action: action, actionSubject: actionSubject } = $8f4a194f3d46df20$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: three
        };
    }
    throw Error('Event of this type is not supported');
};
const $8f4a194f3d46df20$export$e6baab532ef8c6bf = (args)=>{
    switch(args.length){
        case 0:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: undefined,
                attributes: undefined
            };
        case 1:
            return $8f4a194f3d46df20$var$extractDataFromOneAttribute(args[0]);
        case 2:
            return $8f4a194f3d46df20$var$extractDataFromTwoAttribute(args[0], args[1]);
        case 3:
            return $8f4a194f3d46df20$var$extractDataFromThreeAttribute(args[0], args[1], args[2]);
        default:
            throw Error('Can not fire an empty event');
    }
};
module.exports["getImperativeAnalyticsDataFromArguments"] = $8f4a194f3d46df20$export$e6baab532ef8c6bf;

});

parcelRegister("1LXnB", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $69NJe = parcelRequire("69NJe");

const $12a75cc47e499450$export$b2ad68b9bc407b80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props.offscreen || $[1] !== props.setWidth) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $69NJe.WidthDetectorObserver), {
            setWidth: props.setWidth,
            offscreen: props.offscreen
        });
        $[0] = props.offscreen;
        $[1] = props.setWidth;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $69NJe.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
module.exports["WidthObserver"] = $12a75cc47e499450$export$b2ad68b9bc407b80;

});

parcelRegister("69NJe", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1zgpZ = parcelRequire("1zgpZ");

const $00e8152189e344b1$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { setWidth: setWidth, offscreen: offscreen } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            threshold: 0
        };
        $[0] = t1;
    } else t1 = $[0];
    const [inViewRef, inView, target] = (0, $1zgpZ.useInView)(t1);
    let t2;
    if ($[1] !== setWidth) {
        t2 = ()=>{
            if (typeof window === "undefined") return null;
            return new ResizeObserver((entries)=>{
                if (!Array.isArray(entries) || !entries.length) return;
                const { width: width } = entries[0].contentRect;
                setWidth(Math.round(width));
            });
        };
        $[1] = setWidth;
        $[2] = t2;
    } else t2 = $[2];
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(t2);
    let t3;
    let t4;
    if ($[3] !== inView || $[4] !== offscreen || $[5] !== target) {
        t3 = ()=>{
            const { current: currentObserver } = observer;
            const resizeObserver = currentObserver();
            if (resizeObserver === null) return;
            if (target) {
                if (inView || offscreen) resizeObserver.observe(target);
                else resizeObserver.unobserve(target);
            }
            return ()=>{
                resizeObserver.disconnect();
            };
        };
        t4 = [
            target,
            inView,
            offscreen
        ];
        $[3] = inView;
        $[4] = offscreen;
        $[5] = target;
        $[6] = t3;
        $[7] = t4;
    } else {
        t3 = $[6];
        t4 = $[7];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t3, t4);
    let t5;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
            display: "block",
            width: "100%",
            position: "absolute"
        };
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== inViewRef) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            style: t5,
            ref: inViewRef
        });
        $[9] = inViewRef;
        $[10] = t6;
    } else t6 = $[10];
    return t6;
} : ({ setWidth: setWidth, offscreen: offscreen })=>{
    const [inViewRef, inView, target] = (0, $1zgpZ.useInView)({
        /* Optional options */ threshold: 0
    });
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(()=>{
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        return new ResizeObserver((entries)=>{
            if (!Array.isArray(entries) || !entries.length) return;
            const { width: width } = entries[0].contentRect;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        const { current: currentObserver } = observer;
        const resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});
module.exports["WidthDetectorObserver"] = $00e8152189e344b1$export$ff983d2a2b6112ea;

});

parcelRegister("1zgpZ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $cbd0258ef583969a$export$2f62ee6831462844 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useInView(t0) {
    const $ = (0, $bDgLe.c)(14);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const options = t1;
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef();
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            inView: false,
            entry: undefined,
            target: undefined
        };
        $[2] = t2;
    } else t2 = $[2];
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(t2);
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    let t3;
    if ($[3] !== root || $[4] !== rootMargin || $[5] !== threshold) {
        t3 = (node)=>{
            observerInstance.current = new IntersectionObserver((entries)=>{
                if (entries && entries.length) {
                    const intersection = entries[0];
                    const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                    if (intersectionRatio >= 0) {
                        const numericThreshold = typeof threshold === "number" ? threshold : 0;
                        let inView = intersectionRatio >= numericThreshold;
                        if (isIntersecting !== undefined) inView = inView && isIntersecting;
                        setState({
                            inView: inView,
                            entry: intersection,
                            target: node
                        });
                    }
                }
            }, {
                threshold: threshold,
                root: root,
                rootMargin: rootMargin
            });
            if (ref.current) observerInstance.current.unobserve(ref.current);
            if (node) observerInstance.current.observe(node);
            ref.current = node;
        };
        $[3] = root;
        $[4] = rootMargin;
        $[5] = threshold;
        $[6] = t3;
    } else t3 = $[6];
    const setRef = t3;
    let t4;
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>()=>{
                if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
            };
        t5 = [];
        $[7] = t4;
        $[8] = t5;
    } else {
        t4 = $[7];
        t5 = $[8];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t4, t5);
    let t6;
    if ($[9] !== setRef || $[10] !== state.entry || $[11] !== state.inView || $[12] !== state.target) {
        t6 = [
            setRef,
            state.inView,
            state.target,
            state.entry
        ];
        $[9] = setRef;
        $[10] = state.entry;
        $[11] = state.inView;
        $[12] = state.target;
        $[13] = t6;
    } else t6 = $[13];
    return t6;
} : function useInView(options = {}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    });
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    const setRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((node)=>{
        observerInstance.current = new IntersectionObserver((entries)=>{
            if (entries && entries.length) {
                const intersection = entries[0];
                const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    let inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
   * Unsubscribe IntersectionObserver before unmounting a component.
   */ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        return ()=>{
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
};
module.exports["useInView"] = $cbd0258ef583969a$export$2f62ee6831462844;

});

parcelRegister("iyIOY", function(module, exports) {
parcelRequire("95IFc");
var $142hz = parcelRequire("142hz");
var $eC9tI = parcelRequire("eC9tI");
var $niMUw = parcelRequire("niMUw");
var $4RrPd = parcelRequire("4RrPd");
var $bJv8O = parcelRequire("bJv8O");

var $d82e2b7f9d9ed58c$var$global = (0, $niMUw.getGlobalObject)();
/** Send Console API calls as Sentry Events */ var $d82e2b7f9d9ed58c$export$25a43cb5b5c58c08 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function CaptureConsole(options) {
        if (options === void 0) options = {};
        /**
         * @inheritDoc
         */ this.name = CaptureConsole.id;
        /**
         * @inheritDoc
         */ this._levels = (0, $142hz.CONSOLE_LEVELS);
        if (options.levels) this._levels = options.levels;
    }
    /**
     * @inheritDoc
     */ CaptureConsole.prototype.setupOnce = function(_, getCurrentHub) {
        if (!('console' in $d82e2b7f9d9ed58c$var$global)) return;
        this._levels.forEach(function(level) {
            if (!(level in $d82e2b7f9d9ed58c$var$global.console)) return;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $eC9tI.fill)($d82e2b7f9d9ed58c$var$global.console, level, function(originalConsoleMethod) {
                return function() {
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    var hub = getCurrentHub();
                    if (hub.getIntegration(CaptureConsole)) hub.withScope(function(scope) {
                        scope.setLevel((0, $bJv8O.severityFromString)(level));
                        scope.setExtra('arguments', args);
                        scope.addEventProcessor(function(event) {
                            event.logger = 'console';
                            return event;
                        });
                        var message = (0, $4RrPd.safeJoin)(args, ' ');
                        if (level === 'assert') {
                            if (args[0] === false) {
                                message = "Assertion failed: " + ((0, $4RrPd.safeJoin)(args.slice(1), ' ') || 'console.assert');
                                scope.setExtra('arguments', args.slice(1));
                                hub.captureMessage(message);
                            }
                        } else if (level === 'error' && args[0] instanceof Error) hub.captureException(args[0]);
                        else hub.captureMessage(message);
                    });
                    // this fails for some browsers. :(
                    if (originalConsoleMethod) originalConsoleMethod.apply($d82e2b7f9d9ed58c$var$global.console, args);
                };
            });
        });
    };
    /**
     * @inheritDoc
     */ CaptureConsole.id = 'CaptureConsole';
    return CaptureConsole;
}();
 //# sourceMappingURL=captureconsole.js.map
module.exports["CaptureConsole"] = $d82e2b7f9d9ed58c$export$25a43cb5b5c58c08;

});

parcelRegister("95IFc", function(module, exports) {
$parcel$export(module.exports, "getGlobalObject", () => (parcelRequire("niMUw")).getGlobalObject);
$parcel$export(module.exports, "isError", () => (parcelRequire("h6HKI")).isError);
$parcel$export(module.exports, "isPlainObject", () => (parcelRequire("h6HKI")).isPlainObject);
$parcel$export(module.exports, "CONSOLE_LEVELS", () => (parcelRequire("142hz")).CONSOLE_LEVELS);
$parcel$export(module.exports, "logger", () => (parcelRequire("142hz")).logger);
$parcel$export(module.exports, "normalize", () => (parcelRequire("11Kkv")).normalize);
$parcel$export(module.exports, "fill", () => (parcelRequire("eC9tI")).fill);
$parcel$export(module.exports, "severityFromString", () => (parcelRequire("bJv8O")).severityFromString);
$parcel$export(module.exports, "safeJoin", () => (parcelRequire("4RrPd")).safeJoin);





parcelRequire("niMUw");


parcelRequire("h6HKI");

parcelRequire("142hz");




var $5kreq = parcelRequire("5kreq");

parcelRequire("11Kkv");

parcelRequire("eC9tI");



parcelRequire("bJv8O");



parcelRequire("4RrPd");




var $6pmA9 = parcelRequire("6pmA9");






 //# sourceMappingURL=index.js.map
$parcel$exportWildcard(module.exports, $5kreq);
$parcel$exportWildcard(module.exports, $6pmA9);

});

parcelRegister("lIxjW", function(module, exports) {

var $niMUw = parcelRequire("niMUw");


var $h6HKI = parcelRequire("h6HKI");

function $fcf78dd05a1f2799$export$5647df6b7814ac86(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $fcf78dd05a1f2799$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $fcf78dd05a1f2799$var$_htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) return '';
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
    });
    else {
        if (elem.id) out.push("#" + elem.id);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $h6HKI.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push("." + classes[i]);
        }
    }
    var allowedAttrs = [
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push("[" + key + "=\"" + attr + "\"]");
    }
    return out.join('');
}
function $fcf78dd05a1f2799$export$1cfafeee2987818b() {
    var global = (0, $niMUw.getGlobalObject)();
    try {
        return global.document.location.href;
    } catch (oO) {
        return '';
    }
} //# sourceMappingURL=browser.js.map
module.exports["htmlTreeAsString"] = $fcf78dd05a1f2799$export$5647df6b7814ac86;

});

parcelRegister("niMUw", function(module, exports) {
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $5kreq = parcelRequire("5kreq");

var $0460b8fabe4a64c2$var$fallbackGlobalObject = {};
function $0460b8fabe4a64c2$export$256479dc0cea61c4() {
    return (0, $5kreq.isNodeEnv)() ? $parcel$global : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
     ? window // eslint-disable-line no-restricted-globals
     : typeof self !== 'undefined' ? self : $0460b8fabe4a64c2$var$fallbackGlobalObject;
}
function $0460b8fabe4a64c2$export$7e223ec222791509(name, creator, obj) {
    var global1 = obj || $0460b8fabe4a64c2$export$256479dc0cea61c4();
    var __SENTRY__ = global1.__SENTRY__ = global1.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
} //# sourceMappingURL=global.js.map
module.exports["getGlobalObject"] = $0460b8fabe4a64c2$export$256479dc0cea61c4;
module.exports["getGlobalSingleton"] = $0460b8fabe4a64c2$export$7e223ec222791509;

});

parcelRegister("5kreq", function(module, exports) {
$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv, (v) => isNodeEnv = v);
$parcel$export(module.exports, "dynamicRequire", () => dynamicRequire, (v) => dynamicRequire = v);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $3HxeM = parcelRequire("3HxeM");


var $1P2f3 = parcelRequire("1P2f3");

function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $3HxeM.isBrowserBundle)() && Object.prototype.toString.call(typeof $1P2f3 !== 'undefined' ? $1P2f3 : 0) === '[object process]';
}
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        var cwd = dynamicRequire(module, 'process').cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    } catch (e) {
    // no-empty
    }
    return mod;
} //# sourceMappingURL=node.js.map

});

parcelRegister("3HxeM", function(module, exports) {
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $2b1f2b7c68d97ced$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
} //# sourceMappingURL=env.js.map
module.exports["isBrowserBundle"] = $2b1f2b7c68d97ced$export$2928c40372e623c0;

});

parcelRegister("h6HKI", function(module, exports) {
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ // eslint-disable-next-line @typescript-eslint/unbound-method
var $c744ef8efbbea969$var$objectToString = Object.prototype.toString;
function $c744ef8efbbea969$export$e6127cc7fe7395c3(wat) {
    switch($c744ef8efbbea969$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $c744ef8efbbea969$export$49034edbe6b62415(wat, Error);
    }
}
function $c744ef8efbbea969$var$isBuiltin(wat, ty) {
    return $c744ef8efbbea969$var$objectToString.call(wat) === "[object " + ty + "]";
}
function $c744ef8efbbea969$export$9f9636d330b71954(wat) {
    return $c744ef8efbbea969$var$isBuiltin(wat, 'ErrorEvent');
}
function $c744ef8efbbea969$export$ef9e2056653f0c8e(wat) {
    return $c744ef8efbbea969$var$isBuiltin(wat, 'DOMError');
}
function $c744ef8efbbea969$export$12e869b2a583f783(wat) {
    return $c744ef8efbbea969$var$isBuiltin(wat, 'DOMException');
}
function $c744ef8efbbea969$export$844ec244b1367d54(wat) {
    return $c744ef8efbbea969$var$isBuiltin(wat, 'String');
}
function $c744ef8efbbea969$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== 'object' && typeof wat !== 'function';
}
function $c744ef8efbbea969$export$53b83ca8eaab0383(wat) {
    return $c744ef8efbbea969$var$isBuiltin(wat, 'Object');
}
function $c744ef8efbbea969$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $c744ef8efbbea969$export$49034edbe6b62415(wat, Event);
}
function $c744ef8efbbea969$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $c744ef8efbbea969$export$49034edbe6b62415(wat, Element);
}
function $c744ef8efbbea969$export$49841c62b9eff15(wat) {
    return $c744ef8efbbea969$var$isBuiltin(wat, 'RegExp');
}
function $c744ef8efbbea969$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
function $c744ef8efbbea969$export$bc2894c7158efbac(wat) {
    return $c744ef8efbbea969$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
function $c744ef8efbbea969$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
function $c744ef8efbbea969$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
} //# sourceMappingURL=is.js.map
module.exports["isError"] = $c744ef8efbbea969$export$e6127cc7fe7395c3;
module.exports["isInstanceOf"] = $c744ef8efbbea969$export$49034edbe6b62415;
module.exports["isString"] = $c744ef8efbbea969$export$844ec244b1367d54;
module.exports["isPrimitive"] = $c744ef8efbbea969$export$c3825b437cbdea5c;
module.exports["isPlainObject"] = $c744ef8efbbea969$export$53b83ca8eaab0383;
module.exports["isEvent"] = $c744ef8efbbea969$export$9671ea99bd126ace;
module.exports["isElement"] = $c744ef8efbbea969$export$45a5e7f76e0caa8d;
module.exports["isRegExp"] = $c744ef8efbbea969$export$49841c62b9eff15;
module.exports["isSyntheticEvent"] = $c744ef8efbbea969$export$bc2894c7158efbac;
module.exports["isNaN"] = $c744ef8efbbea969$export$c9f5652083b8129d;

});

parcelRegister("2Q8PY", function(module, exports) {
var $21174afd68a919a2$export$484b1ea9aec914c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug',
    'critical'
]; //# sourceMappingURL=enums.js.map
module.exports["SeverityLevels"] = $21174afd68a919a2$export$484b1ea9aec914c;

});

parcelRegister("142hz", function(module, exports) {
$parcel$export(module.exports, "logger", () => $0c67ef66515853ff$export$af88d00dbe7f521);

var $fbwmZ = parcelRequire("fbwmZ");


var $4O82D = parcelRequire("4O82D");


var $niMUw = parcelRequire("niMUw");

// TODO: Implement different loggers for different environments
var $0c67ef66515853ff$var$global = (0, $niMUw.getGlobalObject)();
/** Prefix for logging strings */ var $0c67ef66515853ff$var$PREFIX = 'Sentry Logger ';
var $0c67ef66515853ff$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert'
];
function $0c67ef66515853ff$export$cda52e2a8927a2ca(callback) {
    var global = (0, $niMUw.getGlobalObject)();
    if (!('console' in global)) return callback();
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    $0c67ef66515853ff$export$2a2b1d2252a69ecb.forEach(function(level) {
        // TODO(v7): Remove this check as it's only needed for Node 6
        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in global.console && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach(function(level) {
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function $0c67ef66515853ff$var$makeLogger() {
    var enabled = false;
    var logger = {
        enable: function() {
            enabled = true;
        },
        disable: function() {
            enabled = false;
        }
    };
    if (0, $4O82D.IS_DEBUG_BUILD) $0c67ef66515853ff$export$2a2b1d2252a69ecb.forEach(function(name) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (enabled) $0c67ef66515853ff$export$cda52e2a8927a2ca(function() {
                var _a;
                (_a = $0c67ef66515853ff$var$global.console)[name].apply(_a, (0, $fbwmZ.__spread)([
                    $0c67ef66515853ff$var$PREFIX + "[" + name + "]:"
                ], args));
            });
        };
    });
    else $0c67ef66515853ff$export$2a2b1d2252a69ecb.forEach(function(name) {
        logger[name] = function() {
            return undefined;
        };
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
var $0c67ef66515853ff$export$af88d00dbe7f521;
if (0, $4O82D.IS_DEBUG_BUILD) $0c67ef66515853ff$export$af88d00dbe7f521 = (0, $niMUw.getGlobalSingleton)('logger', $0c67ef66515853ff$var$makeLogger);
else $0c67ef66515853ff$export$af88d00dbe7f521 = $0c67ef66515853ff$var$makeLogger();
 //# sourceMappingURL=logger.js.map
module.exports["CONSOLE_LEVELS"] = $0c67ef66515853ff$export$2a2b1d2252a69ecb;

});

parcelRegister("4O82D", function(module, exports) {
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $380211d076ff50e5$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__; //# sourceMappingURL=flags.js.map
module.exports["IS_DEBUG_BUILD"] = $380211d076ff50e5$export$48a8984ec0bf2e44;

});

parcelRegister("aY4rC", function(module, exports) {
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $7fc2f48fbe1d088a$export$8115b0b78e956ab3() {
    var hasWeakSet = typeof WeakSet === 'function';
    var inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(var i = 0; i < inner.length; i++){
            var value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(var i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
} //# sourceMappingURL=memo.js.map
module.exports["memoBuilder"] = $7fc2f48fbe1d088a$export$8115b0b78e956ab3;

});

parcelRegister("11Kkv", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");


var $h6HKI = parcelRequire("h6HKI");


var $aY4rC = parcelRequire("aY4rC");


var $eC9tI = parcelRequire("eC9tI");


var $fgmiz = parcelRequire("fgmiz");

function $0bf9d29200a37024$export$a3295358bff77e(input, depth, maxProperties) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    try {
        // since we're at the outermost level, there is no key
        return $0bf9d29200a37024$export$588732934346abbf('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: "**non-serializable** (" + err + ")"
        };
    }
}
function $0bf9d29200a37024$export$23fbbb20bed71033(object, // Default Node.js REPL depth
depth, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) depth = 3;
    if (maxSize === void 0) maxSize = 102400;
    var normalized = $0bf9d29200a37024$export$a3295358bff77e(object, depth);
    if ($0bf9d29200a37024$var$jsonSize(normalized) > maxSize) return $0bf9d29200a37024$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $0bf9d29200a37024$export$588732934346abbf(key, value, depth, maxProperties, memo) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    if (memo === void 0) memo = (0, $aY4rC.memoBuilder)();
    var _a = (0, $fbwmZ.__read)(memo, 2), memoize = _a[0], unmemoize = _a[1];
    // If the value has a `toJSON` method, see if we can bail and let it do the work
    var valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        return valueWithToJSON.toJSON();
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // Get the simple cases out of the way first
    if (value === null || [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !(0, $h6HKI.isNaN)(value)) return value;
    var stringified = $0bf9d29200a37024$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // We're also done if we've reached the max depth
    if (depth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    var normalized = Array.isArray(value) ? [] : {};
    var numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    var visitable = (0, $h6HKI.isError)(value) || (0, $h6HKI.isEvent)(value) ? (0, $eC9tI.convertToPlainObject)(value) : value;
    for(var visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        var visitValue = visitable[visitKey];
        normalized[visitKey] = $0bf9d29200a37024$export$588732934346abbf(visitKey, visitValue, depth - 1, maxProperties, memo);
        numAdded += 1;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $0bf9d29200a37024$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        // React's SyntheticEvent thingy
        if ((0, $h6HKI.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        // this catches `undefined` (but not `null`, which is a primitive and can be serialized on its own)
        if (value === void 0) return '[undefined]';
        if (typeof value === 'function') return "[Function: " + (0, $fgmiz.getFunctionName)(value) + "]";
        if (typeof value === 'symbol') return "[" + String(value) + "]";
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return "[BigInt: " + String(value) + "]";
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        return "[object " + Object.getPrototypeOf(value).constructor.name + "]";
    } catch (err) {
        return "**non-serializable** (" + err + ")";
    }
}
/** Calculates bytes size of input string */ function $0bf9d29200a37024$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ function $0bf9d29200a37024$var$jsonSize(value) {
    return $0bf9d29200a37024$var$utf8Length(JSON.stringify(value));
} //# sourceMappingURL=normalize.js.map
module.exports["normalize"] = $0bf9d29200a37024$export$a3295358bff77e;

});

parcelRegister("eC9tI", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");


var $lIxjW = parcelRequire("lIxjW");


var $h6HKI = parcelRequire("h6HKI");


var $4RrPd = parcelRequire("4RrPd");

function $aa3bf77b99750f4a$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') try {
        $aa3bf77b99750f4a$export$5c1499e2e5d010ae(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
function $aa3bf77b99750f4a$export$e73679ffaf56810e(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
function $aa3bf77b99750f4a$export$5c1499e2e5d010ae(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    $aa3bf77b99750f4a$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
}
function $aa3bf77b99750f4a$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $aa3bf77b99750f4a$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map(function(key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
    }).join('&');
}
function $aa3bf77b99750f4a$export$62ff257738bf57f5(value) {
    var newObj = value;
    if ((0, $h6HKI.isError)(value)) newObj = (0, $fbwmZ.__assign)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, $aa3bf77b99750f4a$var$getOwnProperties(value));
    else if ((0, $h6HKI.isEvent)(value)) {
        var event_1 = value;
        newObj = (0, $fbwmZ.__assign)({
            type: event_1.type,
            target: $aa3bf77b99750f4a$var$serializeEventTarget(event_1.target),
            currentTarget: $aa3bf77b99750f4a$var$serializeEventTarget(event_1.currentTarget)
        }, $aa3bf77b99750f4a$var$getOwnProperties(event_1));
        if (typeof CustomEvent !== 'undefined' && (0, $h6HKI.isInstanceOf)(value, CustomEvent)) newObj.detail = event_1.detail;
    }
    return newObj;
}
/** Creates a string representation of the target of an `Event` object */ function $aa3bf77b99750f4a$var$serializeEventTarget(target) {
    try {
        return (0, $h6HKI.isElement)(target) ? (0, $lIxjW.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $aa3bf77b99750f4a$var$getOwnProperties(obj) {
    var extractedProps = {};
    for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
    return extractedProps;
}
function $aa3bf77b99750f4a$export$b0244d5063c0b61b(exception, maxLength) {
    if (maxLength === void 0) maxLength = 40;
    var keys = Object.keys($aa3bf77b99750f4a$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $4RrPd.truncate)(keys[0], maxLength);
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $4RrPd.truncate)(serialized, maxLength);
    }
    return '';
}
function $aa3bf77b99750f4a$export$d25f2688db1bb433(val) {
    var e_1, _a;
    if ((0, $h6HKI.isPlainObject)(val)) {
        var rv = {};
        try {
            for(var _b = (0, $fbwmZ.__values)(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                if (typeof val[key] !== 'undefined') rv[key] = $aa3bf77b99750f4a$export$d25f2688db1bb433(val[key]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return rv;
    }
    if (Array.isArray(val)) return val.map($aa3bf77b99750f4a$export$d25f2688db1bb433);
    return val;
}
function $aa3bf77b99750f4a$export$92b78acdbe066b6b(wat) {
    var objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $h6HKI.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
} //# sourceMappingURL=object.js.map
module.exports["fill"] = $aa3bf77b99750f4a$export$9563e054e6f787fb;
module.exports["convertToPlainObject"] = $aa3bf77b99750f4a$export$62ff257738bf57f5;

});

parcelRegister("4RrPd", function(module, exports) {

var $h6HKI = parcelRequire("h6HKI");

function $38a1b21eefbb9b2d$export$6a506b36fdea397d(str, max) {
    if (max === void 0) max = 0;
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : str.substr(0, max) + "...";
}
function $38a1b21eefbb9b2d$export$4215662d762d6f9d(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} " + newLine;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
function $38a1b21eefbb9b2d$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
function $38a1b21eefbb9b2d$export$cdded5b28a5f8c6d(value, pattern) {
    if (!(0, $h6HKI.isString)(value)) return false;
    if ((0, $h6HKI.isRegExp)(pattern)) return pattern.test(value);
    if (typeof pattern === 'string') return value.indexOf(pattern) !== -1;
    return false;
}
function $38a1b21eefbb9b2d$export$466fc863a824cea6(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
} //# sourceMappingURL=string.js.map
module.exports["truncate"] = $38a1b21eefbb9b2d$export$6a506b36fdea397d;
module.exports["safeJoin"] = $38a1b21eefbb9b2d$export$465e9d514283d4fd;

});

parcelRegister("fgmiz", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");

var $b1c9a5aa64b78b97$var$STACKTRACE_LIMIT = 50;
function $b1c9a5aa64b78b97$export$a5739666fb2d03d4() {
    var parsers = [];
    for(var _i = 0; _i < arguments.length; _i++)parsers[_i] = arguments[_i];
    var sortedParsers = parsers.sort(function(a, b) {
        return a[0] - b[0];
    }).map(function(p) {
        return p[1];
    });
    return function(stack, skipFirst) {
        var e_1, _a, e_2, _b;
        if (skipFirst === void 0) skipFirst = 0;
        var frames = [];
        try {
            for(var _c = (0, $fbwmZ.__values)(stack.split('\n').slice(skipFirst)), _d = _c.next(); !_d.done; _d = _c.next()){
                var line = _d.value;
                try {
                    for(var sortedParsers_1 = (e_2 = void 0, (0, $fbwmZ.__values)(sortedParsers)), sortedParsers_1_1 = sortedParsers_1.next(); !sortedParsers_1_1.done; sortedParsers_1_1 = sortedParsers_1.next()){
                        var parser = sortedParsers_1_1.value;
                        var frame = parser(line);
                        if (frame) {
                            frames.push(frame);
                            break;
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (sortedParsers_1_1 && !sortedParsers_1_1.done && (_b = sortedParsers_1.return)) _b.call(sortedParsers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return $b1c9a5aa64b78b97$export$c55c24c0eeba0205(frames);
    };
}
function $b1c9a5aa64b78b97$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    var localStack = stack;
    var firstFrameFunction = localStack[0].function || '';
    var lastFrameFunction = localStack[localStack.length - 1].function || '';
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) localStack = localStack.slice(1);
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) localStack = localStack.slice(0, -1);
    // The frame where the crash happened, should be the last entry in the array
    return localStack.slice(0, $b1c9a5aa64b78b97$var$STACKTRACE_LIMIT).map(function(frame) {
        return (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, frame), {
            filename: frame.filename || localStack[0].filename,
            function: frame.function || '?'
        });
    }).reverse();
}
var $b1c9a5aa64b78b97$var$defaultFunctionName = '<anonymous>';
function $b1c9a5aa64b78b97$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $b1c9a5aa64b78b97$var$defaultFunctionName;
        return fn.name || $b1c9a5aa64b78b97$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $b1c9a5aa64b78b97$var$defaultFunctionName;
    }
} //# sourceMappingURL=stacktrace.js.map
module.exports["getFunctionName"] = $b1c9a5aa64b78b97$export$aad197c7121a6651;

});

parcelRegister("bJv8O", function(module, exports) {

var $dtZ6d = parcelRequire("dtZ6d");


var $2Q8PY = parcelRequire("2Q8PY");

function $88ac0da36f058dd3$var$isSupportedSeverity(level) {
    return (0, $2Q8PY.SeverityLevels).indexOf(level) !== -1;
}
function $88ac0da36f058dd3$export$e01cef29b4327697(level) {
    if (level === 'warn') return (0, $dtZ6d.Severity).Warning;
    if ($88ac0da36f058dd3$var$isSupportedSeverity(level)) return level;
    return (0, $dtZ6d.Severity).Log;
} //# sourceMappingURL=severity.js.map
module.exports["severityFromString"] = $88ac0da36f058dd3$export$e01cef29b4327697;

});

parcelRegister("6pmA9", function(module, exports) {

var $niMUw = parcelRequire("niMUw");


var $5kreq = parcelRequire("5kreq");

/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ var dateTimestampSource = {
    nowSeconds: function() {
        return Date.now() / 1000;
    }
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    var performance = (0, $niMUw.getGlobalObject)().performance;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function() {
            return performance.now();
        },
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        var perfHooks = (0, $5kreq.dynamicRequire)(module, 'perf_hooks');
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ var platformPerformance = (0, $5kreq.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: function() {
        return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000;
    }
};
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
var timestampWithMs = timestampInSeconds;
var usingPerformanceAPI = platformPerformance !== undefined;
var _browserPerformanceTimeOriginMode;
var browserPerformanceTimeOrigin = function() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0, $niMUw.getGlobalObject)().performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    var threshold = 3600000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
}(); //# sourceMappingURL=time.js.map

});

parcelRegister("6W0Xl", function(module, exports) {
parcelRequire("95IFc");
var $142hz = parcelRequire("142hz");


var $c9L3v = parcelRequire("c9L3v");

/** Deduplication filter */ var $50c8e6bccf5bbb5e$export$688d98c249d31ad3 = /** @class */ function() {
    function Dedupe() {
        /**
         * @inheritDoc
         */ this.name = Dedupe.id;
    }
    /**
     * @inheritDoc
     */ Dedupe.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(currentEvent) {
            var self = getCurrentHub().getIntegration(Dedupe);
            if (self) {
                // Juuust in case something goes wrong
                try {
                    if ($50c8e6bccf5bbb5e$export$3c6361fddf6cd929(currentEvent, self._previousEvent)) {
                        (0, $c9L3v.IS_DEBUG_BUILD) && (0, $142hz.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                        return null;
                    }
                } catch (_oO) {
                    return self._previousEvent = currentEvent;
                }
                return self._previousEvent = currentEvent;
            }
            return currentEvent;
        });
    };
    /**
     * @inheritDoc
     */ Dedupe.id = 'Dedupe';
    return Dedupe;
}();
function $50c8e6bccf5bbb5e$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($50c8e6bccf5bbb5e$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($50c8e6bccf5bbb5e$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
/** JSDoc */ function $50c8e6bccf5bbb5e$var$_isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$50c8e6bccf5bbb5e$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$50c8e6bccf5bbb5e$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $50c8e6bccf5bbb5e$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = $50c8e6bccf5bbb5e$var$_getExceptionFromEvent(previousEvent);
    var currentException = $50c8e6bccf5bbb5e$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$50c8e6bccf5bbb5e$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$50c8e6bccf5bbb5e$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $50c8e6bccf5bbb5e$var$_isSameStacktrace(currentEvent, previousEvent) {
    var currentFrames = $50c8e6bccf5bbb5e$var$_getFramesFromEvent(currentEvent);
    var previousFrames = $50c8e6bccf5bbb5e$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(var i = 0; i < previousFrames.length; i++){
        var frameA = previousFrames[i];
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
/** JSDoc */ function $50c8e6bccf5bbb5e$var$_isSameFingerprint(currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
/** JSDoc */ function $50c8e6bccf5bbb5e$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
/** JSDoc */ function $50c8e6bccf5bbb5e$var$_getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) try {
        // @ts-ignore Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    else if (event.stacktrace) return event.stacktrace.frames;
    return undefined;
} //# sourceMappingURL=dedupe.js.map
module.exports["Dedupe"] = $50c8e6bccf5bbb5e$export$688d98c249d31ad3;

});

parcelRegister("c9L3v", function(module, exports) {
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $8d9ad39358b035f4$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__; //# sourceMappingURL=flags.js.map
module.exports["IS_DEBUG_BUILD"] = $8d9ad39358b035f4$export$48a8984ec0bf2e44;

});

parcelRegister("fa95z", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");

parcelRequire("95IFc");
var $h6HKI = parcelRequire("h6HKI");
var $142hz = parcelRequire("142hz");
var $11Kkv = parcelRequire("11Kkv");


var $c9L3v = parcelRequire("c9L3v");

/** Patch toString calls to return proper name for wrapped functions */ var $b09ed70491c36903$export$56d961ef3a52a072 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function ExtraErrorData(options) {
        /**
         * @inheritDoc
         */ this.name = ExtraErrorData.id;
        this._options = (0, $fbwmZ.__assign)({
            depth: 3
        }, options);
    }
    /**
     * @inheritDoc
     */ ExtraErrorData.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event, hint) {
            var self = getCurrentHub().getIntegration(ExtraErrorData);
            if (!self) return event;
            return self.enhanceEventWithErrorData(event, hint);
        });
    };
    /**
     * Attaches extracted information from the Error object to extra field in the Event
     */ ExtraErrorData.prototype.enhanceEventWithErrorData = function(event, hint) {
        var _a;
        if (!hint || !hint.originalException || !(0, $h6HKI.isError)(hint.originalException)) return event;
        var name = hint.originalException.name || hint.originalException.constructor.name;
        var errorData = this._extractErrorData(hint.originalException);
        if (errorData) {
            var contexts = (0, $fbwmZ.__assign)({}, event.contexts);
            var normalizedErrorData = (0, $11Kkv.normalize)(errorData, this._options.depth);
            if ((0, $h6HKI.isPlainObject)(normalizedErrorData)) contexts = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, event.contexts), (_a = {}, _a[name] = (0, $fbwmZ.__assign)({}, normalizedErrorData), _a));
            return (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, event), {
                contexts: contexts
            });
        }
        return event;
    };
    /**
     * Extract extra information from the Error object
     */ ExtraErrorData.prototype._extractErrorData = function(error) {
        var e_1, _a, e_2, _b;
        // We are trying to enhance already existing event, so no harm done if it won't succeed
        try {
            var nativeKeys = [
                'name',
                'message',
                'stack',
                'line',
                'column',
                'fileName',
                'lineNumber',
                'columnNumber',
                'toJSON'
            ];
            var extraErrorInfo = {};
            try {
                // We want only enumerable properties, thus `getOwnPropertyNames` is redundant here, as we filter keys anyway.
                for(var _c = (0, $fbwmZ.__values)(Object.keys(error)), _d = _c.next(); !_d.done; _d = _c.next()){
                    var key = _d.value;
                    if (nativeKeys.indexOf(key) !== -1) continue;
                    var value = error[key];
                    extraErrorInfo[key] = (0, $h6HKI.isError)(value) ? value.toString() : value;
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            // Check if someone attached `toJSON` method to grab even more properties (eg. axios is doing that)
            if (typeof error.toJSON === 'function') {
                var serializedError = error.toJSON();
                try {
                    for(var _e = (0, $fbwmZ.__values)(Object.keys(serializedError)), _f = _e.next(); !_f.done; _f = _e.next()){
                        var key = _f.value;
                        var value = serializedError[key];
                        extraErrorInfo[key] = (0, $h6HKI.isError)(value) ? value.toString() : value;
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            return extraErrorInfo;
        } catch (oO) {
            (0, $c9L3v.IS_DEBUG_BUILD) && (0, $142hz.logger).error('Unable to extract extra data from the Error object:', oO);
        }
        return null;
    };
    /**
     * @inheritDoc
     */ ExtraErrorData.id = 'ExtraErrorData';
    return ExtraErrorData;
}();
 //# sourceMappingURL=extraerrordata.js.map
module.exports["ExtraErrorData"] = $b09ed70491c36903$export$56d961ef3a52a072;

});

parcelRegister("hLq0X", function(module, exports) {
/** Add node transaction to the event */ var $ceeb015bb088f872$export$febc5573c75cefb0 = /** @class */ function() {
    function Transaction() {
        /**
         * @inheritDoc
         */ this.name = Transaction.id;
    }
    /**
     * @inheritDoc
     */ Transaction.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event) {
            var self = getCurrentHub().getIntegration(Transaction);
            if (self) return self.process(event);
            return event;
        });
    };
    /**
     * @inheritDoc
     */ Transaction.prototype.process = function(event) {
        var frames = this._getFramesFromEvent(event);
        // use for loop so we don't have to reverse whole frames array
        for(var i = frames.length - 1; i >= 0; i--){
            var frame = frames[i];
            if (frame.in_app === true) {
                event.transaction = this._getTransaction(frame);
                break;
            }
        }
        return event;
    };
    /** JSDoc */ Transaction.prototype._getFramesFromEvent = function(event) {
        var exception = event.exception && event.exception.values && event.exception.values[0];
        return exception && exception.stacktrace && exception.stacktrace.frames || [];
    };
    /** JSDoc */ Transaction.prototype._getTransaction = function(frame) {
        return frame.module || frame.function ? (frame.module || '?') + "/" + (frame.function || '?') : '<unknown>';
    };
    /**
     * @inheritDoc
     */ Transaction.id = 'Transaction';
    return Transaction;
}();
 //# sourceMappingURL=transaction.js.map
module.exports["Transaction"] = $ceeb015bb088f872$export$febc5573c75cefb0;

});

parcelRegister("3jjX7", function(module, exports) {
// WARNING: This value is shared between @atlaskit/analytics-cross-product and
// @atlassiansox/analytics-cross-product-interaction-client. Take care when updating.
const $6e6234f2764332e7$export$7bc189309d2ad463 = 'analyticsInteractionSesssionTrackingClient';
class $6e6234f2764332e7$export$2e2bcd8739ae039 {
    static getInstance() {
        let interactionSessionTracking;
        try {
            // Check if InteractionSessionTracking in global window object
            if ($6e6234f2764332e7$export$7bc189309d2ad463 in window) interactionSessionTracking = window[$6e6234f2764332e7$export$7bc189309d2ad463];
        } catch (err) {
        // Silently swallow exception
        }
        return interactionSessionTracking;
    }
}
module.exports["default"] = $6e6234f2764332e7$export$2e2bcd8739ae039;

});

parcelRegister("boaiH", function(module, exports) {

var $2gr4B = parcelRequire("2gr4B");

class $ffade2ccf1ecf3ef$export$12b6b072930fd68f {
    start({ name: name, id: id, timeout: timeout, startTime: startTime, attributes: attributes, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort, collect: collect }) {
        const current = this.experiences[name];
        if (current && !current.hasStopped && current.id === id) return;
        // Before replacing a current experience, abort it to ensure
        // it is cleaned up.
        if (current) current.abort({
            reason: 'Aborted because the same experience was started with a new id'
        });
        const experience = new (0, $2gr4B.Experience)({
            name: name,
            id: id,
            timeout: timeout,
            startTime: startTime,
            attributes: attributes,
            onSuccess: onSuccess,
            onFailure: onFailure,
            onAbort: onAbort,
            onStart: (startEvent)=>{
                this.emit(startEvent);
                let disposeCollectSubscription = ()=>{};
                if (collect) {
                    const events = [];
                    disposeCollectSubscription = this.subscribe((event)=>{
                        // Ignore already running experiences that started before this
                        // experience started
                        if (event.action === 'taskStart' || events.some((previousEvent)=>previousEvent.name === event.name && previousEvent.action === 'taskStart')) {
                            events.push(event);
                            collect(events, experience);
                        }
                    });
                }
                return (stopEvent)=>{
                    disposeCollectSubscription();
                    this.emit(stopEvent);
                };
            }
        });
        this.experiences[name] = experience;
    }
    succeed({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.succeed(attributes);
    }
    fail({ name: name, error: error, attributes: attributes }) {
        Object.values(this.experiences).forEach((current)=>{
            if (name != null && current.name !== name) return;
            current.fail({
                error: error,
                attributes: attributes
            });
        });
    }
    abort({ name: name, reason: reason, attributes: attributes, checkForTimeout: checkForTimeout }) {
        function abort(experience) {
            if (name != null && experience.name !== name) return;
            experience.abort({
                reason: reason,
                checkForTimeout: checkForTimeout,
                attributes: attributes
            });
        }
        const experiencesWithTimeouts = Object.values(this.experiences).filter((experience)=>experience.timeout);
        const experiencesWithoutTimeouts = Object.values(this.experiences).filter((experience)=>!experience.timeout);
        // We need to abort all experiences with timeouts first in order to properly
        // capture compound experiences composed of sub-experiences which have timeouts
        experiencesWithTimeouts.forEach(abort);
        experiencesWithoutTimeouts.forEach(abort);
    }
    subscribe(subscriber) {
        if (typeof subscriber !== 'function') throw new Error('Subscriber must be a function');
        this.subscribers.push(subscriber);
        return ()=>{
            this.subscribers = this.subscribers.filter((x)=>x !== subscriber);
        };
    }
    stopOnError({ name: name, error: error, attributes: attributes }) {
        if (this.isNetworkOfflineError(error)) {
            this.abort({
                name: name,
                reason: `Aborted ${name} because of network error: ${error.toString()}`,
                checkForTimeout: false,
                attributes: attributes
            });
            return;
        }
        return this.fail({
            name: name,
            error: error,
            attributes: attributes
        });
    }
    updateAttributes({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.updateAttributes(attributes);
    }
    emit(event) {
        this.subscribers.forEach((subscriber)=>{
            try {
                subscriber(event);
            } catch (e) {}
        });
    }
    constructor(options){
        this.experiences = {};
        this.subscribers = [];
        this.isNetworkOfflineError = void 0;
        this.isNetworkOfflineError = options && options.isNetworkOfflineError || (()=>false);
    }
}
module.exports["ExperienceTracker"] = $ffade2ccf1ecf3ef$export$12b6b072930fd68f;

});

parcelRegister("2gr4B", function(module, exports) {

var $apqal = parcelRequire("apqal");

function $8617e1b2001e7e7c$var$mergeAttributes(first, last) {
    if (first === undefined) return last;
    if (last === undefined) return first;
    return {
        ...first,
        ...last
    };
}
class $8617e1b2001e7e7c$export$c90b54e658fc4d7c {
    get hasStopped() {
        return this._hasStopped;
    }
    succeed(attributes) {
        if (this._hasStopped) return;
        this.onSuccess && this.onSuccess();
        this.stop({
            action: 'taskSuccess',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            attributes: $8617e1b2001e7e7c$var$mergeAttributes(this.attributes, attributes)
        });
    }
    fail({ error: error, attributes: attributes }) {
        if (this._hasStopped) return;
        this.onFailure && this.onFailure();
        this.stop({
            action: 'taskFail',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            error: error,
            attributes: $8617e1b2001e7e7c$var$mergeAttributes(this.attributes, attributes)
        });
    }
    abort({ reason: reason, attributes: attributes, checkForTimeout: checkForTimeout = true }) {
        if (this._hasStopped) return;
        // Check if the experience should have failed due to timeout
        if (checkForTimeout && this.timeout != null && this.getDuration() >= this.timeout) {
            this.fail({
                attributes: attributes,
                error: new (0, $apqal.ExperienceTimeoutError)(`${this.name} failed to complete in ${this.timeout}ms`)
            });
            return;
        }
        this.onAbort && this.onAbort();
        this.stop({
            action: 'taskAbort',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            reason: reason,
            checkForTimeout: checkForTimeout,
            attributes: $8617e1b2001e7e7c$var$mergeAttributes(this.attributes, attributes)
        });
    }
    stopOn(event) {
        if (!event) return;
        if (event.action === 'taskSuccess') this.succeed();
        else if (event.action === 'taskAbort') this.abort({
            reason: event.reason,
            checkForTimeout: event.checkForTimeout
        });
        else if (event.action === 'taskFail') this.fail({
            error: event.error
        });
    }
    updateAttributes(attributes) {
        this.attributes = {
            ...this.attributes,
            ...attributes
        };
    }
    stop(event) {
        this._hasStopped = true;
        if (this.onStop) this.onStop(event);
    }
    getDuration() {
        return Math.round(window.performance.now() - this.startTime);
    }
    constructor({ name: name, id: id, timeout: timeout, startTime: startTime = window.performance.now(), attributes: attributes, onStart: onStart, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort }){
        this.name = void 0;
        this.id = void 0;
        this.timeout = void 0;
        this._hasStopped = false;
        this.startTime = void 0;
        this.attributes = void 0;
        this.onStop = void 0;
        this.onSuccess = void 0;
        this.onFailure = void 0;
        this.onAbort = void 0;
        this.name = name;
        this.id = id;
        this.timeout = timeout;
        this.startTime = startTime;
        this.attributes = attributes;
        this.onSuccess = onSuccess;
        this.onFailure = onFailure;
        this.onAbort = onAbort;
        const startEvent = {
            action: 'taskStart',
            name: name,
            id: id,
            startTime: startTime,
            timeout: timeout,
            attributes: attributes
        };
        if (onStart) this.onStop = onStart(startEvent);
    }
}
module.exports["Experience"] = $8617e1b2001e7e7c$export$c90b54e658fc4d7c;

});

parcelRegister("apqal", function(module, exports) {
class $f9800b995ac71735$export$d27a2b6293f7631c extends Error {
    constructor(message){
        super(message);
        this.name = 'ExperienceTimeoutError';
    }
}
module.exports["ExperienceTimeoutError"] = $f9800b995ac71735$export$d27a2b6293f7631c;

});

parcelRegister("kpg4X", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $kC6NK = parcelRequire("kC6NK");

const $277e2498b554872e$export$56ccbea3229cc4c3 = async (isProductInUnitsRollout)=>{
    // 1. Units GA killswitch.
    if (!(0, $iDrrr.fg)('cc-units-ga')) return false;
    // 2. This product's own rollout gates.
    if (!isProductInUnitsRollout()) return false;
    // 3. This organisation's actual units state, read from AGG once per page load.
    const { boundaryEnforced: boundaryEnforced, endUsersLaunched: endUsersLaunched } = await (0, $kC6NK.getUnitsRolloutSettings)();
    return endUsersLaunched && boundaryEnforced;
};
module.exports["shouldUseUnitCompliantApi"] = $277e2498b554872e$export$56ccbea3229cc4c3;

});

parcelRegister("kC6NK", function(module, exports) {
/**
 * Reads where the current organisation is in the units migration from AGG.
 *
 * It takes two queries, because the settings are keyed by org id and the browser only knows the
 * host it is served from: first resolve the host to an org id, then read that org's unit settings.
 *
 * Only `shouldUseUnitCompliantApi` should need this - see that file for how the result is used.
 */ 
var $j39Hd = parcelRequire("j39Hd");


var $9uAJX = parcelRequire("9uAJX");

const $09ebff3e34cc36dc$var$AGG_URL = '/gateway/api/graphql';
/**
 * The operation names are the ones `@atlaskit/link-datasource` already sends from production, and
 * they are deliberately kept as they are now that the caller has moved into this package: AGG side
 * observability - dashboards, per operation traffic and rate limiting - is keyed off them, so
 * renaming them would silently orphan it.
 */ const $09ebff3e34cc36dc$var$TENANT_CONTEXT_OPERATION_NAME = 'link_datasource_tenantContext';
const $09ebff3e34cc36dc$var$UNITS_ROLLOUT_SETTINGS_OPERATION_NAME = 'link_datasource_unitSettings';
/**
 * `Query.admin_unitSettings` is keyed by org id, which the browser does not know, so the org id
 * is resolved from the host the product is currently served from.
 */ const $09ebff3e34cc36dc$var$tenantContextQuery = `
	query ${$09ebff3e34cc36dc$var$TENANT_CONTEXT_OPERATION_NAME}($hostNames: [String!]) {
		tenantContexts(hostNames: $hostNames) {
			orgId
		}
	}
`;
/**
 * `admin_unitSettings` exposes both flags of the rollout and is callable with the session of the
 * end user, so no opt-in directive or admin OAuth scope is needed from the browser.
 */ const $09ebff3e34cc36dc$var$unitsRolloutSettingsQuery = `
	query ${$09ebff3e34cc36dc$var$UNITS_ROLLOUT_SETTINGS_OPERATION_NAME}($orgId: ID!) {
		admin_unitSettings(orgId: $orgId) {
			boundaryEnforced
			endUsersLaunched
		}
	}
`;
/**
 * When the rollout settings cannot be resolved we keep the pre-isolation behaviour, which is
 * what every org gets today while the unit settings are unset. The settings are only
 * written when an org is activated - they are not backfilled - so `null` is expected for orgs
 * that have not been activated yet and must be read as `false`.
 */ const $09ebff3e34cc36dc$var$DEFAULT_SETTINGS = {
    boundaryEnforced: false,
    endUsersLaunched: false
};
/**
 * AGG answers with a 200 and an `errors` array for query level failures, so those have to be
 * turned into a rejection explicitly rather than being read as an empty response.
 */ const $09ebff3e34cc36dc$var$requestGraphQL = async (operationName, query, variables)=>{
    const response = await (0, $j39Hd.request)('post', $09ebff3e34cc36dc$var$AGG_URL, {
        operationName: operationName,
        query: query,
        variables: variables
    });
    if (response?.errors?.length) {
        const messages = response.errors.map((error)=>error?.message).filter(Boolean).join(', ');
        throw new Error(`${operationName} failed: ${messages || 'unknown error'}`);
    }
    return response?.data ?? undefined;
};
const $09ebff3e34cc36dc$var$fetchOrgId = async ()=>{
    const hostName = typeof window !== 'undefined' ? window.location?.hostname : undefined;
    if (!hostName) return undefined;
    const data = await $09ebff3e34cc36dc$var$requestGraphQL($09ebff3e34cc36dc$var$TENANT_CONTEXT_OPERATION_NAME, $09ebff3e34cc36dc$var$tenantContextQuery, {
        hostNames: [
            hostName
        ]
    });
    for (const tenantContext of data?.tenantContexts ?? []){
        if (tenantContext?.orgId) return tenantContext.orgId;
    }
    return undefined;
};
const $09ebff3e34cc36dc$var$fetchUnitsRolloutSettings = async ()=>{
    const orgId = await $09ebff3e34cc36dc$var$fetchOrgId();
    if (!orgId) return $09ebff3e34cc36dc$var$DEFAULT_SETTINGS;
    const data = await $09ebff3e34cc36dc$var$requestGraphQL($09ebff3e34cc36dc$var$UNITS_ROLLOUT_SETTINGS_OPERATION_NAME, $09ebff3e34cc36dc$var$unitsRolloutSettingsQuery, {
        orgId: orgId
    });
    const settings = data?.admin_unitSettings;
    return {
        boundaryEnforced: settings?.boundaryEnforced ?? false,
        endUsersLaunched: settings?.endUsersLaunched ?? false
    };
};
const $09ebff3e34cc36dc$export$2523e3b63c956620 = ()=>{
    if (!(0, $9uAJX.cache).promise) (0, $9uAJX.cache).promise = $09ebff3e34cc36dc$var$fetchUnitsRolloutSettings().catch(()=>{
        (0, $9uAJX.cache).promise = undefined;
        return $09ebff3e34cc36dc$var$DEFAULT_SETTINGS;
    });
    return (0, $9uAJX.cache).promise;
};
module.exports["getUnitsRolloutSettings"] = $09ebff3e34cc36dc$export$2523e3b63c956620;

});

parcelRegister("9uAJX", function(module, exports) {
const $6f4e12ab20c1322c$export$69a3209f1a06c04d = {};
module.exports["cache"] = $6f4e12ab20c1322c$export$69a3209f1a06c04d;

});

parcelRegister("nStJY", function(module, exports) {

var $gO7n9 = parcelRequire("gO7n9");


var $jPzTX = parcelRequire("jPzTX");

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $047c686ddfb588a6$var$pick = $jPzTX(function(object, paths) {
    return object == null ? {} : $gO7n9(object, paths);
});
module.exports = $047c686ddfb588a6$var$pick;

});

parcelRegister("gO7n9", function(module, exports) {

var $3Bix5 = parcelRequire("3Bix5");


var $h7loT = parcelRequire("h7loT");

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $c3c708e20cb40f59$var$basePick(object, paths) {
    return $3Bix5(object, paths, function(value, path) {
        return $h7loT(object, path);
    });
}
module.exports = $c3c708e20cb40f59$var$basePick;

});

parcelRegister("8Bx1z", function(module, exports) {
"use strict";
var $643b655b3a668be3$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");

/* tslint:enable:max-line-length */ /**
 * Filter items emitted by the source Observable by only emitting those that
 * satisfy a specified predicate.
 *
 * <span class="informal">Like
 * [Array.prototype.filter()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter),
 * it only emits a value from the source if it passes a criterion function.</span>
 *
 * <img src="./img/filter.png" width="100%">
 *
 * Similar to the well-known `Array.prototype.filter` method, this operator
 * takes values from the source Observable, passes them through a `predicate`
 * function and only emits those values that yielded `true`.
 *
 * @example <caption>Emit only click events whose target was a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksOnDivs = clicks.filter(ev => ev.target.tagName === 'DIV');
 * clicksOnDivs.subscribe(x => console.log(x));
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 * @see {@link ignoreElements}
 * @see {@link partition}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted, if `false` the value is not passed to the output
 * Observable. The `index` parameter is the number `i` for the i-th source
 * emission that has happened since the subscription, starting from the number
 * `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of values from the source that were
 * allowed by the `predicate` function.
 * @method filter
 * @owner Observable
 */ function $643b655b3a668be3$var$filter(predicate, thisArg) {
    return function filterOperatorFunction(source) {
        return source.lift(new $643b655b3a668be3$var$FilterOperator(predicate, thisArg));
    };
}
module.exports.filter = $643b655b3a668be3$var$filter;
var $643b655b3a668be3$var$FilterOperator = function() {
    function FilterOperator(predicate, thisArg) {
        this.predicate = predicate;
        this.thisArg = thisArg;
    }
    FilterOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $643b655b3a668be3$var$FilterSubscriber(subscriber, this.predicate, this.thisArg));
    };
    return FilterOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $643b655b3a668be3$var$FilterSubscriber = function(_super) {
    $643b655b3a668be3$var$__extends(FilterSubscriber, _super);
    function FilterSubscriber(destination, predicate, thisArg) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.count = 0;
    }
    // the try catch block below is left specifically for
    // optimization and perf reasons. a tryCatcher is not necessary here.
    FilterSubscriber.prototype._next = function(value) {
        var result;
        try {
            result = this.predicate.call(this.thisArg, value, this.count++);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) this.destination.next(value);
    };
    return FilterSubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=filter.js.map

});

parcelRegister("lv9Cv", function(module, exports) {
$parcel$export(module.exports, "of", () => $fa73f494791b08e6$export$ba255e9e49e00608, (v) => $fa73f494791b08e6$export$ba255e9e49e00608 = v);
var $fa73f494791b08e6$export$ba255e9e49e00608;
"use strict";

var $hmT2x = parcelRequire("hmT2x");

$fa73f494791b08e6$export$ba255e9e49e00608 = $hmT2x.ArrayObservable.of; //# sourceMappingURL=of.js.map

});

parcelRegister("hrJHY", function(module, exports) {
"use strict";
var __extends = this && this.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $zAMIg = parcelRequire("zAMIg");


var $fEWBj = parcelRequire("fEWBj");


var $fNVRJ = parcelRequire("fNVRJ");


var $1XTds = parcelRequire("1XTds");

/**
 * Delays the emission of items from the source Observable by a given timeout or
 * until a given Date.
 *
 * <span class="informal">Time shifts each item by some specified amount of
 * milliseconds.</span>
 *
 * <img src="./img/delay.png" width="100%">
 *
 * If the delay argument is a Number, this operator time shifts the source
 * Observable by that amount of time expressed in milliseconds. The relative
 * time intervals between the values are preserved.
 *
 * If the delay argument is a Date, this operator time shifts the start of the
 * Observable execution until the given date occurs.
 *
 * @example <caption>Delay each click by one second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delay(1000); // each click emitted after 1 second
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @example <caption>Delay all clicks until a future date happens</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var date = new Date('March 15, 2050 12:00:00'); // in the future
 * var delayedClicks = clicks.delay(date); // click emitted only after that date
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 *
 * @param {number|Date} delay The delay duration in milliseconds (a `number`) or
 * a `Date` until which the emission of the source items is delayed.
 * @param {Scheduler} [scheduler=async] The IScheduler to use for
 * managing the timers that handle the time-shift for each item.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified timeout or Date.
 * @method delay
 * @owner Observable
 */ function delay(delay, scheduler) {
    if (scheduler === void 0) scheduler = $zAMIg.async;
    var absoluteDelay = $fEWBj.isDate(delay);
    var delayFor = absoluteDelay ? +delay - scheduler.now() : Math.abs(delay);
    return function(source) {
        return source.lift(new DelayOperator(delayFor, scheduler));
    };
}
exports.delay = delay;
var DelayOperator = function() {
    function DelayOperator(delay, scheduler) {
        this.delay = delay;
        this.scheduler = scheduler;
    }
    DelayOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new DelaySubscriber(subscriber, this.delay, this.scheduler));
    };
    return DelayOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var DelaySubscriber = function(_super) {
    __extends(DelaySubscriber, _super);
    function DelaySubscriber(destination, delay, scheduler) {
        _super.call(this, destination);
        this.delay = delay;
        this.scheduler = scheduler;
        this.queue = [];
        this.active = false;
        this.errored = false;
    }
    DelaySubscriber.dispatch = function(state) {
        var source = state.source;
        var queue = source.queue;
        var scheduler = state.scheduler;
        var destination = state.destination;
        while(queue.length > 0 && queue[0].time - scheduler.now() <= 0)queue.shift().notification.observe(destination);
        if (queue.length > 0) {
            var delay_1 = Math.max(0, queue[0].time - scheduler.now());
            this.schedule(state, delay_1);
        } else {
            this.unsubscribe();
            source.active = false;
        }
    };
    DelaySubscriber.prototype._schedule = function(scheduler) {
        this.active = true;
        this.add(scheduler.schedule(DelaySubscriber.dispatch, this.delay, {
            source: this,
            destination: this.destination,
            scheduler: scheduler
        }));
    };
    DelaySubscriber.prototype.scheduleNotification = function(notification) {
        if (this.errored === true) return;
        var scheduler = this.scheduler;
        var message = new DelayMessage(scheduler.now() + this.delay, notification);
        this.queue.push(message);
        if (this.active === false) this._schedule(scheduler);
    };
    DelaySubscriber.prototype._next = function(value) {
        this.scheduleNotification($1XTds.Notification.createNext(value));
    };
    DelaySubscriber.prototype._error = function(err) {
        this.errored = true;
        this.queue = [];
        this.destination.error(err);
    };
    DelaySubscriber.prototype._complete = function() {
        this.scheduleNotification($1XTds.Notification.createComplete());
    };
    return DelaySubscriber;
}($fNVRJ.Subscriber);
var DelayMessage = function() {
    function DelayMessage(time, notification) {
        this.time = time;
        this.notification = notification;
    }
    return DelayMessage;
}(); //# sourceMappingURL=delay.js.map

});

parcelRegister("zAMIg", function(module, exports) {
$parcel$export(module.exports, "async", () => $06afcdac526dbf67$export$12af436354f1a4f7, (v) => $06afcdac526dbf67$export$12af436354f1a4f7 = v);
/**
 *
 * Async Scheduler
 *
 * <span class="informal">Schedule task as if you used setTimeout(task, duration)</span>
 *
 * `async` scheduler schedules tasks asynchronously, by putting them on the JavaScript
 * event loop queue. It is best used to delay tasks in time or to schedule tasks repeating
 * in intervals.
 *
 * If you just want to "defer" task, that is to perform it right after currently
 * executing synchronous code ends (commonly achieved by `setTimeout(deferredTask, 0)`),
 * better choice will be the {@link asap} scheduler.
 *
 * @example <caption>Use async scheduler to delay task</caption>
 * const task = () => console.log('it works!');
 *
 * Rx.Scheduler.async.schedule(task, 2000);
 *
 * // After 2 seconds logs:
 * // "it works!"
 *
 *
 * @example <caption>Use async scheduler to repeat task in intervals</caption>
 * function task(state) {
 *   console.log(state);
 *   this.schedule(state + 1, 1000); // `this` references currently executing Action,
 *                                   // which we reschedule with new state and delay
 * }
 *
 * Rx.Scheduler.async.schedule(task, 3000, 0);
 *
 * // Logs:
 * // 0 after 3s
 * // 1 after 4s
 * // 2 after 5s
 * // 3 after 6s
 *
 * @static true
 * @name async
 * @owner Scheduler
 */ var $06afcdac526dbf67$export$12af436354f1a4f7;
"use strict";

var $1HJiA = parcelRequire("1HJiA");


var $fJ8RQ = parcelRequire("fJ8RQ");

$06afcdac526dbf67$export$12af436354f1a4f7 = new $fJ8RQ.AsyncScheduler($1HJiA.AsyncAction); //# sourceMappingURL=async.js.map

});

parcelRegister("fEWBj", function(module, exports) {
$parcel$export(module.exports, "isDate", () => $b6680c598ae7a287$export$871608497c498473, (v) => $b6680c598ae7a287$export$871608497c498473 = v);
var $b6680c598ae7a287$export$871608497c498473;
"use strict";
function $b6680c598ae7a287$var$isDate(value) {
    return value instanceof Date && !isNaN(+value);
}
$b6680c598ae7a287$export$871608497c498473 = $b6680c598ae7a287$var$isDate; //# sourceMappingURL=isDate.js.map

});

parcelRegister("k5sGX", function(module, exports) {
$parcel$export(module.exports, "default", () => $e9fa87e3de3aa88c$export$2e2bcd8739ae039);

var $jO73f = parcelRequire("jO73f");


var $3yGK6 = parcelRequire("3yGK6");


var $kr6hK = parcelRequire("kr6hK");

function $e9fa87e3de3aa88c$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $3yGK6.default)(1, arguments);
    var additionalDigits = (0, $kr6hK.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $e9fa87e3de3aa88c$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $e9fa87e3de3aa88c$var$parseYear(dateStrings.date, additionalDigits);
        date = $e9fa87e3de3aa88c$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $e9fa87e3de3aa88c$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $e9fa87e3de3aa88c$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $e9fa87e3de3aa88c$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $e9fa87e3de3aa88c$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $e9fa87e3de3aa88c$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $e9fa87e3de3aa88c$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $e9fa87e3de3aa88c$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($e9fa87e3de3aa88c$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($e9fa87e3de3aa88c$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($e9fa87e3de3aa88c$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $e9fa87e3de3aa88c$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $e9fa87e3de3aa88c$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $e9fa87e3de3aa88c$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($e9fa87e3de3aa88c$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $e9fa87e3de3aa88c$var$parseDateUnit(captures[1]);
    var month = $e9fa87e3de3aa88c$var$parseDateUnit(captures[2]) - 1;
    var day = $e9fa87e3de3aa88c$var$parseDateUnit(captures[3]);
    var week = $e9fa87e3de3aa88c$var$parseDateUnit(captures[4]);
    var dayOfWeek = $e9fa87e3de3aa88c$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$e9fa87e3de3aa88c$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $e9fa87e3de3aa88c$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$e9fa87e3de3aa88c$var$validateDate(year, month, day) || !$e9fa87e3de3aa88c$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $e9fa87e3de3aa88c$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $e9fa87e3de3aa88c$var$parseTime(timeString) {
    var captures = timeString.match($e9fa87e3de3aa88c$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $e9fa87e3de3aa88c$var$parseTimeUnit(captures[1]);
    var minutes = $e9fa87e3de3aa88c$var$parseTimeUnit(captures[2]);
    var seconds = $e9fa87e3de3aa88c$var$parseTimeUnit(captures[3]);
    if (!$e9fa87e3de3aa88c$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $jO73f.millisecondsInHour) + minutes * (0, $jO73f.millisecondsInMinute) + seconds * 1000;
}
function $e9fa87e3de3aa88c$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function $e9fa87e3de3aa88c$var$parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match($e9fa87e3de3aa88c$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$e9fa87e3de3aa88c$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $jO73f.millisecondsInHour) + minutes * (0, $jO73f.millisecondsInMinute));
}
function $e9fa87e3de3aa88c$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $e9fa87e3de3aa88c$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $e9fa87e3de3aa88c$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $e9fa87e3de3aa88c$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($e9fa87e3de3aa88c$var$daysInMonths[month] || ($e9fa87e3de3aa88c$var$isLeapYearIndex(year) ? 29 : 28));
}
function $e9fa87e3de3aa88c$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($e9fa87e3de3aa88c$var$isLeapYearIndex(year) ? 366 : 365);
}
function $e9fa87e3de3aa88c$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $e9fa87e3de3aa88c$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $e9fa87e3de3aa88c$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});

parcelRegister("jO73f", function(module, exports) {
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $e6b828148d99ab2b$export$dfd9b671c89acc8e = 7;
var $e6b828148d99ab2b$export$3913210603d8e9ae = 365.2425;
var $e6b828148d99ab2b$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $e6b828148d99ab2b$export$91246f0b9bd9beff = 60000;
var $e6b828148d99ab2b$export$7f72910d6dfd237a = 3600000;
var $e6b828148d99ab2b$export$397c2d5776aa9055 = 1000;
var $e6b828148d99ab2b$export$4dec998e48f9c246 = -$e6b828148d99ab2b$export$81caae6e1cc7a622;
var $e6b828148d99ab2b$export$f2f5ae5a8e2d8f9f = 60;
var $e6b828148d99ab2b$export$3c58128db900d44e = 3;
var $e6b828148d99ab2b$export$80d7e435f744f319 = 12;
var $e6b828148d99ab2b$export$4db7641526e3241f = 4;
var $e6b828148d99ab2b$export$698aec755e92c695 = 3600;
var $e6b828148d99ab2b$export$a77c1a7ebebe2a5a = 60;
var $e6b828148d99ab2b$export$815a9362476d2fe3 = $e6b828148d99ab2b$export$698aec755e92c695 * 24;
var $e6b828148d99ab2b$export$34804a017b31e2fe = $e6b828148d99ab2b$export$815a9362476d2fe3 * 7;
var $e6b828148d99ab2b$export$7271e9e3478110d1 = $e6b828148d99ab2b$export$815a9362476d2fe3 * $e6b828148d99ab2b$export$3913210603d8e9ae;
var $e6b828148d99ab2b$export$8e6600bbdee7dabb = $e6b828148d99ab2b$export$7271e9e3478110d1 / 12;
var $e6b828148d99ab2b$export$be1dccf2de902d31 = $e6b828148d99ab2b$export$8e6600bbdee7dabb * 3;
module.exports["millisecondsInMinute"] = $e6b828148d99ab2b$export$91246f0b9bd9beff;
module.exports["millisecondsInHour"] = $e6b828148d99ab2b$export$7f72910d6dfd237a;
module.exports["millisecondsInSecond"] = $e6b828148d99ab2b$export$397c2d5776aa9055;

});

parcelRegister("hq9Cp", function(module, exports) {
const $84118747f7725463$export$3055eac4de8cbd2b = (creatorType)=>creatorType === 'THIRD_PARTY' || creatorType === 'FORGE' || creatorType === 'REMOTE_A2A';
module.exports["isForgeAgentByCreatorType"] = $84118747f7725463$export$3055eac4de8cbd2b;

});

parcelRegister("jPaq9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $jC4nA = parcelRequire("jC4nA");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $hBYtq = parcelRequire("hBYtq");


var $iDrrr = parcelRequire("iDrrr");


var $l0Ey3 = parcelRequire("l0Ey3");


var $hNTpD = parcelRequire("hNTpD");

const $ac4acb6d8564709e$var$stylesCompiled = {
    pillLineHeight: "_26BoRwey7F"
};
const $ac4acb6d8564709e$var$styles = {
    button: "_0bjKvDKxmn _2sNsIgmnOE _23rrnHyKLB _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _1UtDYzZpcK _0Of8r2gVvo _1Znuxb8HPE _1wydGWgVvo _2Zuz6Q8HPE _1kk5Tkf7mX _39HuIbz8Lp _1ANEUSLRg7 _3YEZNO7dHp _0KLXru66of _1eOmH6o126 _3sFUREiSCN _3gzVzLN4oS",
    button_motion: "_0bjKvDKxmn _2sNsIgmnOE _23rrnHyKLB _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _1UtDYzZpcK _0Of8r2gVvo _1Znuxb8HPE _1wydGWgVvo _2Zuz6Q8HPE _1kk5Tkf7mX _39HuIbz8Lp _1ANEUSLRg7 _3YEZNO7dHp _0KLXru66of _1eOmH6o126 _3sFUREiSCN _3gzVzLN4oS",
    buttonInline: "_2Y7lL4FQfX",
    queryText: "_3W2Oc8wPeg _2fwxA5ecOK",
    whiteSpacePreWrap: "_1ANEUSlpBW"
};
const $ac4acb6d8564709e$export$e33faa86e0996d96 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(20);
    let children;
    let props;
    let t1;
    let t2;
    if ($[0] !== t0) {
        ({ children: children, whiteSpacePreWrap: t1, renderIcon: t2, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
        $[3] = t1;
        $[4] = t2;
    } else {
        children = $[1];
        props = $[2];
        t1 = $[3];
        t2 = $[4];
    }
    const whiteSpacePreWrap = t1 === undefined ? true : t1;
    const renderIcon = t2 === undefined ? true : t2;
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $hekY6.default)([
            $ac4acb6d8564709e$var$stylesCompiled.pillLineHeight
        ]);
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== renderIcon) {
        t4 = renderIcon ? /*#__PURE__*/ $cozmU.createElement((0, $l0Ey3.ChatPillIcon), null) : null;
        $[6] = renderIcon;
        $[7] = t4;
    } else t4 = $[7];
    const t5 = whiteSpacePreWrap && $ac4acb6d8564709e$var$styles.whiteSpacePreWrap;
    let t6;
    if ($[8] !== t5) {
        t6 = (0, $w6R6I.cx)($ac4acb6d8564709e$var$styles.queryText, t5);
        $[8] = t5;
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] !== children || $[11] !== t6) {
        t7 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: t6
        }, children);
        $[10] = children;
        $[11] = t6;
        $[12] = t7;
    } else t7 = $[12];
    let t8;
    if ($[13] !== t4 || $[14] !== t7) {
        t8 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t3
        }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.075",
            alignBlock: "baseline"
        }, t4, t7));
        $[13] = t4;
        $[14] = t7;
        $[15] = t8;
    } else t8 = $[15];
    let t9;
    if ($[16] !== props || $[17] !== ref || $[18] !== t8) {
        t9 = /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
            ref: ref,
            ...props,
            xcss: (0, $iDrrr.fg)("platform-dst-motion-uplift-custom-button") ? $ac4acb6d8564709e$var$styles.button_motion : $ac4acb6d8564709e$var$styles.button
        }, t8);
        $[16] = props;
        $[17] = ref;
        $[18] = t8;
        $[19] = t9;
    } else t9 = $[19];
    return t9;
} : ({ children: children, whiteSpacePreWrap: whiteSpacePreWrap = true, renderIcon: renderIcon = true, ...props }, ref)=>/*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
        ref: ref,
        ...props,
        xcss: (0, $iDrrr.fg)('platform-dst-motion-uplift-custom-button') ? $ac4acb6d8564709e$var$styles.button_motion : $ac4acb6d8564709e$var$styles.button
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $ac4acb6d8564709e$var$stylesCompiled.pillLineHeight
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.075",
        alignBlock: "baseline"
    }, renderIcon ? /*#__PURE__*/ $cozmU.createElement((0, $l0Ey3.ChatPillIcon), null) : null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($ac4acb6d8564709e$var$styles.queryText, whiteSpacePreWrap && $ac4acb6d8564709e$var$styles.whiteSpacePreWrap)
    }, children)))));
const $ac4acb6d8564709e$export$76b47032dcd9063b = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(10);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $hekY6.default)([
            $ac4acb6d8564709e$var$stylesCompiled.pillLineHeight
        ]);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($jC4nA))), {
            color: "currentColor",
            label: ""
        });
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== formatMessage) {
        t2 = formatMessage((0, $hNTpD.default).browseAgentsPillLabel);
        $[2] = formatMessage;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t0
        }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.050",
            xcss: $ac4acb6d8564709e$var$styles.buttonInline
        }, t1, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $ac4acb6d8564709e$var$styles.queryText
        }, t2)));
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== props || $[7] !== ref || $[8] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
            ref: ref,
            ...props,
            xcss: (0, $iDrrr.fg)("platform-dst-motion-uplift-custom-button") ? $ac4acb6d8564709e$var$styles.button_motion : $ac4acb6d8564709e$var$styles.button
        }, t3);
        $[6] = props;
        $[7] = ref;
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
} : (props, ref)=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
        ref: ref,
        ...props,
        xcss: (0, $iDrrr.fg)('platform-dst-motion-uplift-custom-button') ? $ac4acb6d8564709e$var$styles.button_motion : $ac4acb6d8564709e$var$styles.button
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $ac4acb6d8564709e$var$stylesCompiled.pillLineHeight
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.050",
        xcss: $ac4acb6d8564709e$var$styles.buttonInline
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($jC4nA))), {
        color: "currentColor",
        label: ""
    }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $ac4acb6d8564709e$var$styles.queryText
    }, formatMessage((0, $hNTpD.default).browseAgentsPillLabel)))));
});
module.exports["ChatPill"] = $ac4acb6d8564709e$export$e33faa86e0996d96;
module.exports["BrowseAgentsPill"] = $ac4acb6d8564709e$export$76b47032dcd9063b;

});

parcelRegister("l0Ey3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $mfdwv = parcelRequire("mfdwv");

const $65ffbdb08fd6ebe6$export$38f9b635c1c454e7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($mfdwv))), {
            ...props,
            label: ""
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($mfdwv))), {
        ...props,
        label: ""
    });
module.exports["ChatPillIcon"] = $65ffbdb08fd6ebe6$export$38f9b635c1c454e7;

});

parcelRegister("hNTpD", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $d5949bd621a1b2eb$var$message = (0, $kSwu1.defineMessages)({
    browseAgentsPillLabel: {
        id: "ai-mate.rovo-agent-components.browse-agents-pill.label",
        defaultMessage: "Browse agents"
    }
});
var $d5949bd621a1b2eb$export$2e2bcd8739ae039 = $d5949bd621a1b2eb$var$message;
module.exports["default"] = $d5949bd621a1b2eb$export$2e2bcd8739ae039;

});

parcelRegister("h9r4d", function(module, exports) {
$parcel$export(module.exports, "captureException", () => (parcelRequire("lIkvQ")).captureException);
$parcel$export(module.exports, "fireErrorAnalytics", () => (parcelRequire("kFTt2")).default);

var $lIkvQ = parcelRequire("lIkvQ");


var $kFTt2 = parcelRequire("kFTt2");


var $4sTW6 = parcelRequire("4sTW6");


});

parcelRegister("lIkvQ", function(module, exports) {

var $l54O9 = parcelRequire("l54O9");

const $34ee97725f8181a5$export$7da675e3dd1bd6b5 = (sentryUrl, config, getExtraContext)=>(0, $l54O9.default).installGlobalHandler(sentryUrl, config, getExtraContext);
const $34ee97725f8181a5$export$f5282963edea4a68 = (location, error, details = {})=>(0, $l54O9.default).captureException(location, error, details);
module.exports["captureException"] = $34ee97725f8181a5$export$f5282963edea4a68;

});

parcelRegister("l54O9", function(module, exports) {
// This is the only file that should directly import Raven.

var $9HPf3 = parcelRequire("9HPf3");

var $amM2J = parcelRequire("amM2J");

var $eAdCn = parcelRequire("eAdCn");


var $iyIOY = parcelRequire("iyIOY");

var $6W0Xl = parcelRequire("6W0Xl");

var $fa95z = parcelRequire("fa95z");

var $hLq0X = parcelRequire("hLq0X");


var $1wIeS = parcelRequire("1wIeS");

const $15510fe24ae0eb31$var$getFragmentNames = (stackTrace)=>{
    const re = /(?:src\/entry|src|assets)\/([^,./]+)/g;
    const fragmentNames = [];
    let fragmentName = re.exec(stackTrace);
    while(fragmentName){
        fragmentNames.push(fragmentName[1]);
        fragmentName = re.exec(stackTrace);
    }
    const distinctfragmentNames = (0, (/*@__PURE__*/$parcel$interopDefault($1wIeS)))(fragmentNames);
    return distinctfragmentNames;
};
// Add custom tags based on stack trace
const $15510fe24ae0eb31$var$getTaggedData = (data, hint)=>{
    if (!hint) return data;
    const exception = hint.originalException || hint.syntheticException;
    if (!exception) return data;
    const stackTrace = exception.stack;
    if (!stackTrace) return data;
    const taggedData = data;
    const fragmentNames = $15510fe24ae0eb31$var$getFragmentNames(stackTrace);
    if (!fragmentNames.length) taggedData.tags = {
        ...taggedData.tags,
        fragment: 'unknown'
    };
    else {
        taggedData.tags = {
            ...taggedData.tags,
            fragment: fragmentNames[0]
        };
        if (fragmentNames.length > 1) taggedData.extra = {
            ...taggedData.extra,
            allRelevantFragments: fragmentNames
        };
    }
    return taggedData;
};
// https://docs.sentry.io/platforms/javascript/#removing-an-integration
const $15510fe24ae0eb31$var$getFilteredIntegrations = (integrations)=>integrations.filter(({ name: name })=>name !== 'Breadcrumbs');
const $15510fe24ae0eb31$var$installGlobalHandler = (sentryUrl, config, getExtraContext)=>{
    // Check for sentry already enabled to be defensive in case two fragments are loaded in the same page, we
    // don't want duplicated error reports
    const sentryClient = $amM2J.getCurrentHub().getClient();
    if (sentryClient && sentryClient.getOptions().enabled) return;
    const defaultConfig = {
        dsn: sentryUrl,
        environment: "production",
        // This adds our tags to the data sent to sentry
        beforeSend: (event, hint)=>{
            // Yes, we're mutating the argument, but at this point in the error handling lifecycle
            // immutability is not important and it simplifies the logic
            // Event type is documented here: https://github.com/getsentry/sentry-javascript/blob/master/packages/types/src/event.ts
            const extraBeforeSend = config.beforeSend || (()=>null);
            let updatedData = extraBeforeSend(event, hint);
            updatedData = $15510fe24ae0eb31$var$getTaggedData(updatedData, hint);
            return updatedData;
        },
        //Integration typing doesn't seem to work well so I'm just typing it to any
        integrations: (integrations)=>[
                ...$15510fe24ae0eb31$var$getFilteredIntegrations(integrations),
                new $6W0Xl.Dedupe(),
                new $fa95z.ExtraErrorData(),
                new $hLq0X.Transaction(),
                new $iyIOY.CaptureConsole({
                    levels: [
                        'error'
                    ]
                }),
                // not supporting the case where config.integrations is a function that returns an array
                ...config.integrations && config.integrations instanceof Array ? config.integrations : []
            ]
    };
    // Because we don't want to completely override the platform defaults remove them from the config object.
    // They've been integrated into the defaultConfig above.
    config.beforeSend = undefined;
    config.integrations = undefined;
    $eAdCn.init({
        ...defaultConfig,
        ...config
    });
    try {
        $9HPf3.setExtras(getExtraContext());
    } catch (e) {
        $9HPf3.captureException(e);
    }
};
// structured tags that we send to Sentry
// everything else from details object will go into "extras"
const $15510fe24ae0eb31$var$tags = [
    'packageName',
    'teamName'
];
const $15510fe24ae0eb31$var$captureException = (location, error, details)=>{
    $9HPf3.configureScope((scope)=>{
        scope.setTag('logger', location);
        if (details) Object.keys(details).forEach((key)=>{
            if ($15510fe24ae0eb31$var$tags.includes(key)) scope.setTag(key, details[key]);
            else scope.setExtra(key, details[key]);
        });
    });
    $9HPf3.captureException(error);
};
const $15510fe24ae0eb31$var$sentryErrorHandler = {
    installGlobalHandler: $15510fe24ae0eb31$var$installGlobalHandler,
    captureException: $15510fe24ae0eb31$var$captureException
};
var $15510fe24ae0eb31$export$2e2bcd8739ae039 = $15510fe24ae0eb31$var$sentryErrorHandler;
module.exports["default"] = $15510fe24ae0eb31$export$2e2bcd8739ae039;

});

parcelRegister("1wIeS", function(module, exports) {

var $1Rned = parcelRequire("1Rned");

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function $11cb188fd562c44b$var$uniq(array) {
    return array && array.length ? $1Rned(array) : [];
}
module.exports = $11cb188fd562c44b$var$uniq;

});

parcelRegister("kFTt2", function(module, exports) {

var $huGTe = parcelRequire("huGTe");


var $66Bcq = parcelRequire("66Bcq");


var $k8V2e = parcelRequire("k8V2e");

var $hcOES = parcelRequire("hcOES");


var $lIkvQ = parcelRequire("lIkvQ");

let $1fc2285692461264$var$analyticsClient;
const $1fc2285692461264$export$d4079397f9611138 = (client)=>{
    $1fc2285692461264$var$analyticsClient = client;
};
const $1fc2285692461264$export$bf406c01a195b215 = ()=>{
    $1fc2285692461264$var$analyticsClient = undefined;
};
const $1fc2285692461264$var$fireErrorAnalytics = ({ event: event, error: error, errorInfo: errorInfo, meta: meta, attributes: attributes })=>{
    const { id: id, packageName: packageName, teamName: teamName } = meta;
    if (__SERVER__) {
        if (error) throw error;
        else {
            const payload = event && (0, $k8V2e.extractAWCDataFromEvent)(event).payload;
            throw new Error(JSON.stringify({
                event: payload,
                errorInfo: errorInfo,
                meta: meta,
                attributes: attributes
            }));
        }
    }
    const fullAnalyticsId = `${packageName}.${id}`;
    if (error) {
        const details = (0, (/*@__PURE__*/$parcel$interopDefault($66Bcq)))({
            ...attributes,
            packageName: packageName,
            teamName: teamName,
            errorInfo: errorInfo
        }, (0, (/*@__PURE__*/$parcel$interopDefault($huGTe))));
        if (event && event.context) {
            const fullEvent = (0, $k8V2e.extractAWCDataFromEvent)(event);
            (0, $lIkvQ.captureException)(fullAnalyticsId, error, {
                ...details,
                ...fullEvent.payload
            });
        } else (0, $lIkvQ.captureException)(fullAnalyticsId, error, details);
    }
    if (event && event.handlers && event.handlers.length > 0) {
        const attrs = attributes || {};
        (0, $hcOES.fireOperationalAnalytics)(event, `${fullAnalyticsId} failed`, attrs);
    } else //Allow this to pass in a promise so that we can avoid blocking render for firing these events.
    if ($1fc2285692461264$var$analyticsClient && $1fc2285692461264$var$analyticsClient.sendOperationalEvent) {
        const gasV3Event = {
            action: 'failed',
            actionSubject: fullAnalyticsId,
            source: 'unknownErrorSource',
            attributes: attributes
        };
        $1fc2285692461264$var$analyticsClient.sendOperationalEvent(gasV3Event);
    } else {
        const analyticsClientUninitialisedError = new Error("Analytics client hasn't been initialised, unable to fire error operational event");
        (0, $lIkvQ.captureException)(fullAnalyticsId, analyticsClientUninitialisedError);
    }
};
const $1fc2285692461264$export$706c486c6b5abdfb = async ({ error: error, id: id, packageName: packageName })=>{
    if (error.statusCode) {
        const { statusCode: statusCode } = error;
        let statusCodeGroup;
        if (statusCode >= 300 && statusCode < 400) statusCodeGroup = '3xx';
        else if (statusCode >= 400 && statusCode < 500) statusCodeGroup = '4xx';
        else if (statusCode >= 500 && statusCode < 600) statusCodeGroup = '5xx';
        else statusCodeGroup = 'unknown';
        await $1fc2285692461264$var$fireErrorAnalytics({
            meta: {
                id: id,
                packageName: packageName
            },
            attributes: {
                statusCodeGroup: statusCodeGroup
            }
        });
    } else await $1fc2285692461264$var$fireErrorAnalytics({
        error: error,
        meta: {
            id: id,
            packageName: packageName
        }
    });
};
var $1fc2285692461264$export$2e2bcd8739ae039 = $1fc2285692461264$var$fireErrorAnalytics;
module.exports["default"] = $1fc2285692461264$export$2e2bcd8739ae039;

});

parcelRegister("k8V2e", function(module, exports) {
// oxlint-disable-next-line @atlassian/no-restricted-imports

var $emZLc = parcelRequire("emZLc");


var $66Bcq = parcelRequire("66Bcq");


var $jYwtP = parcelRequire("jYwtP");


var $8El2z = parcelRequire("8El2z");

const $035dbde6912e4d4c$export$1c850cf68c053906 = (event)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    const analyticsType = (0, $8El2z.getAnalyticsType)(castedEvent);
    const attributes = (0, $8El2z.getAttributes)(castedEvent);
    const source = (0, $8El2z.getSource)(castedEvent);
    const actionSubject = (0, $8El2z.getActionSubject)(castedEvent);
    if (analyticsType === (0, $jYwtP.SCREEN_EVENT_TYPE)) return {
        type: (0, $jYwtP.SCREEN_EVENT_TYPE),
        payload: {
            name: source,
            attributes: attributes
        }
    };
    switch(analyticsType){
        case 0, $jYwtP.UI_EVENT_TYPE:
        case 0, $jYwtP.TRACK_EVENT_TYPE:
        case 0, $jYwtP.OPERATIONAL_EVENT_TYPE:
            {
                const action = (0, $8El2z.getAction)(castedEvent);
                const actionSubjectId = (0, $8El2z.getActionSubjectId)(castedEvent);
                const containerId = (0, $8El2z.getContainerId)(castedEvent);
                const containerType = (0, $8El2z.getContainerType)(castedEvent);
                const objectId = (0, $8El2z.getObjectId)(castedEvent);
                const objectType = (0, $8El2z.getObjectType)(castedEvent);
                const tags = (0, $8El2z.getTags)(castedEvent);
                return {
                    type: analyticsType,
                    payload: (0, (/*@__PURE__*/$parcel$interopDefault($66Bcq)))({
                        action: action,
                        actionSubject: actionSubject,
                        actionSubjectId: actionSubjectId,
                        source: source,
                        tags: tags,
                        containerType: containerType,
                        containerId: containerId,
                        objectType: objectType,
                        objectId: objectId,
                        attributes: attributes
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($emZLc))))
                };
            }
        default:
            return {
                payload: {
                    source: source,
                    actionSubject: actionSubject,
                    attributes: attributes
                },
                type: undefined
            };
    }
};
module.exports["extractAWCDataFromEvent"] = $035dbde6912e4d4c$export$1c850cf68c053906;

});

parcelRegister("8El2z", function(module, exports) {

var $lyW2B = parcelRequire("lyW2B");


var $emZLc = parcelRequire("emZLc");


var $gO1os = parcelRequire("gO1os");


var $lYpJw = parcelRequire("lYpJw");


var $66Bcq = parcelRequire("66Bcq");


var $1wIeS = parcelRequire("1wIeS");

const $c9f6533ef6431d6e$var$extractFromContext = (event, property)=>event.context.map((item)=>item[property]);
const $c9f6533ef6431d6e$export$a3569ac53b82a914 = (event)=>event.payload.analyticsType;
const $c9f6533ef6431d6e$export$fe94072fee8a6976 = (event)=>{
    const contextAttributes = $c9f6533ef6431d6e$var$extractFromContext(event, 'attributes');
    const payloadAttributes = event.payload.attributes;
    const allAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($lYpJw)))(contextAttributes.reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($lYpJw)))(result, extraAttributes), {}), payloadAttributes);
    const sources = $c9f6533ef6431d6e$var$extractFromContext(event, 'source');
    const namespaces = sources.filter(Boolean).join('.');
    return (0, (/*@__PURE__*/$parcel$interopDefault($66Bcq)))({
        ...allAttributes,
        namespaces: namespaces
    }, (0, (/*@__PURE__*/$parcel$interopDefault($emZLc))));
};
const $c9f6533ef6431d6e$export$dd2b6e807fb37ba3 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($gO1os)))($c9f6533ef6431d6e$var$extractFromContext(event, 'source').filter(Boolean));
const $c9f6533ef6431d6e$export$6f40cdf6d42c018d = (event)=>{
    const { actionSubject: actionSubject } = event.payload;
    if (actionSubject) return actionSubject;
    const component = (0, (/*@__PURE__*/$parcel$interopDefault($gO1os)))($c9f6533ef6431d6e$var$extractFromContext(event, 'component').filter(Boolean)) || (0, (/*@__PURE__*/$parcel$interopDefault($gO1os)))($c9f6533ef6431d6e$var$extractFromContext(event, 'componentName').filter(Boolean));
    return component;
};
const $c9f6533ef6431d6e$export$6ca3170acb89054 = (event)=>event.payload.action;
const $c9f6533ef6431d6e$export$b6f8db3ad0711b02 = (event)=>event.payload.actionSubjectId;
const $c9f6533ef6431d6e$export$7c8178cc9001d237 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($gO1os)))($c9f6533ef6431d6e$var$extractFromContext(event, 'containerId').filter(Boolean));
const $c9f6533ef6431d6e$export$acc6f3e19803b3dc = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($gO1os)))($c9f6533ef6431d6e$var$extractFromContext(event, 'containerType').filter(Boolean));
const $c9f6533ef6431d6e$export$fa986b91291934c7 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($gO1os)))($c9f6533ef6431d6e$var$extractFromContext(event, 'objectId').filter(Boolean));
const $c9f6533ef6431d6e$export$11cc42aebef2ef3a = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($gO1os)))($c9f6533ef6431d6e$var$extractFromContext(event, 'objectType').filter(Boolean));
const $c9f6533ef6431d6e$export$af63d7414243dad3 = (event)=>{
    const tags = (0, (/*@__PURE__*/$parcel$interopDefault($1wIeS)))((0, (/*@__PURE__*/$parcel$interopDefault($lyW2B)))($c9f6533ef6431d6e$var$extractFromContext(event, 'tags'))).filter(Boolean);
    return tags.length ? tags : undefined;
};
module.exports["getAnalyticsType"] = $c9f6533ef6431d6e$export$a3569ac53b82a914;
module.exports["getAttributes"] = $c9f6533ef6431d6e$export$fe94072fee8a6976;
module.exports["getSource"] = $c9f6533ef6431d6e$export$dd2b6e807fb37ba3;
module.exports["getActionSubject"] = $c9f6533ef6431d6e$export$6f40cdf6d42c018d;
module.exports["getAction"] = $c9f6533ef6431d6e$export$6ca3170acb89054;
module.exports["getActionSubjectId"] = $c9f6533ef6431d6e$export$b6f8db3ad0711b02;
module.exports["getContainerId"] = $c9f6533ef6431d6e$export$7c8178cc9001d237;
module.exports["getContainerType"] = $c9f6533ef6431d6e$export$acc6f3e19803b3dc;
module.exports["getObjectId"] = $c9f6533ef6431d6e$export$fa986b91291934c7;
module.exports["getObjectType"] = $c9f6533ef6431d6e$export$11cc42aebef2ef3a;
module.exports["getTags"] = $c9f6533ef6431d6e$export$af63d7414243dad3;

});

parcelRegister("4sTW6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lzgC6 = parcelRequire("lzgC6");


var $kFTt2 = parcelRequire("kFTt2");

class $28efc9af7e790139$var$CatchAndReportErrors extends (0, $cozmU.Component) {
    componentDidCatch(error, errorInfo) {
        const { packageName: packageName, id: id, attributes: attributes, createAnalyticsEvent: createAnalyticsEvent } = this.props;
        const analyticsEvent = createAnalyticsEvent({
            action: 'failed'
        });
        (0, $kFTt2.default)({
            event: analyticsEvent,
            errorInfo: errorInfo,
            error: error,
            meta: {
                id: id,
                packageName: packageName
            },
            attributes: attributes
        });
        throw error;
    }
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    }
}
const $28efc9af7e790139$var$reportingErrorBoundary = (0, $lzgC6.default)()($28efc9af7e790139$var$CatchAndReportErrors);
var $28efc9af7e790139$export$2e2bcd8739ae039 = $28efc9af7e790139$var$reportingErrorBoundary;

});

parcelRegister("cuWGz", function(module, exports) {

var $e66dL = parcelRequire("e66dL");


var $aO6uT = parcelRequire("aO6uT");

function $61987beec044a597$export$57570b1603cf6adb(env) {
    if (env) return env;
    if (typeof window === 'undefined' || !window.location) return (0, $aO6uT.Environment).Unknown;
    const host = window.location.hostname.toLowerCase();
    // Fast path: exact hostname matches
    const exactMatch = (0, $e66dL.EXACT_HOST_MAP)[host];
    if (exactMatch) return exactMatch;
    // Extract TLD for efficient branching (find last dot position)
    const lastDot = host.lastIndexOf('.');
    if (lastDot === -1) return (0, $aO6uT.Environment).Unknown;
    const tld = host.slice(lastDot + 1); // 'com', 'net', etc.
    // Branch by TLD to reduce checks
    switch(tld){
        case 'com':
            return $61987beec044a597$var$classifyComDomain(host);
        case 'net':
            return $61987beec044a597$var$classifyNetDomain(host);
        default:
            return (0, $aO6uT.Environment).Unknown;
    }
}
/**
 * Classify .com domains
 */ function $61987beec044a597$var$classifyComDomain(host) {
    // jira-dev.com (staging)
    if (host.endsWith('.jira-dev.com')) return (0, $aO6uT.Environment).Staging;
    // atlassian-us-gov-mod.com (FedRAMP)
    if (host.endsWith('.atlassian-us-gov-mod.com')) {
        // FedRAMP Bifrost CDN: check most specific first
        if (host.endsWith('.frontend.cdn.atlassian-us-gov-mod.com')) return host.includes('.stg.') ? (0, $aO6uT.Environment).Staging : (0, $aO6uT.Environment).Prod;
        if (host.endsWith('.stg.atlassian-us-gov-mod.com')) return (0, $aO6uT.Environment).Staging;
        return (0, $aO6uT.Environment).Prod;
    }
    // atlassian.com domains
    if (host.endsWith('.atlassian.com')) {
        // services.atlassian.com vanity domains (check most specific first)
        if (host.endsWith('.dev.services.atlassian.com')) return (0, $aO6uT.Environment).Development;
        if (host.endsWith('.staging.services.atlassian.com')) return (0, $aO6uT.Environment).Staging;
        if (host.endsWith('.services.atlassian.com')) return (0, $aO6uT.Environment).Prod;
        // Environment-specific subdomains
        if (host.endsWith('.dev.atlassian.com')) return (0, $aO6uT.Environment).Development;
        if (host.endsWith('.stg.atlassian.com')) return (0, $aO6uT.Environment).Staging;
        return (0, $aO6uT.Environment).Prod;
    }
    return (0, $aO6uT.Environment).Unknown;
}
/**
 * Classify .net domains
 */ function $61987beec044a597$var$classifyNetDomain(host) {
    // atlassian.net (prod tenants)
    if (host.endsWith('.atlassian.net')) return (0, $aO6uT.Environment).Prod;
    // atl-paas-us-gov-mod.net (FedRAMP Micros)
    if (host.endsWith('.atl-paas-us-gov-mod.net')) {
        if (host.includes('.staging.')) return (0, $aO6uT.Environment).Staging;
        if (host.includes('.prod.')) return (0, $aO6uT.Environment).Prod;
        return (0, $aO6uT.Environment).Unknown;
    }
    // atl-paas.net (commercial Micros and Bifrost)
    if (host.endsWith('.atl-paas.net')) {
        // Bifrost commercial: check most specific first
        if (host.endsWith('.frontend.public.atl-paas.net')) {
            if (host.includes('.ddev.') || host.includes('.dev-west2.')) return (0, $aO6uT.Environment).Development;
            if (host.includes('.stg-east.')) return (0, $aO6uT.Environment).Staging;
            if (host.includes('.prod-east.')) return (0, $aO6uT.Environment).Prod;
            return (0, $aO6uT.Environment).Development;
        }
        // Micros commercial
        if (host.includes('.dev.') || host.includes('.platdev.')) return (0, $aO6uT.Environment).Development;
        if (host.includes('.staging.')) return (0, $aO6uT.Environment).Staging;
        if (host.includes('.prod.')) return (0, $aO6uT.Environment).Prod;
    }
    return (0, $aO6uT.Environment).Unknown;
}
module.exports["getEnvironment"] = $61987beec044a597$export$57570b1603cf6adb;

});

parcelRegister("e66dL", function(module, exports) {

var $aO6uT = parcelRequire("aO6uT");

const $1c6adf460a912312$export$636c0c57a2ce36e9 = {
    localhost: (0, $aO6uT.Environment).Development,
    '127.0.0.1': (0, $aO6uT.Environment).Development,
    'id.atlassian.com': (0, $aO6uT.Environment).Prod,
    'admin.atlassian.com': (0, $aO6uT.Environment).Prod,
    'id.stg.internal.atlassian.com': (0, $aO6uT.Environment).Staging,
    'admin.stg.atlassian.com': (0, $aO6uT.Environment).Staging
};
module.exports["EXACT_HOST_MAP"] = $1c6adf460a912312$export$636c0c57a2ce36e9;

});

parcelRegister("aO6uT", function(module, exports) {
var $cf10c8edb5d48b94$export$7dc6752a22ab011a = /*#__PURE__*/ function(Environment) {
    Environment["Development"] = "development";
    Environment["Staging"] = "staging";
    Environment["Prod"] = "prod";
    Environment["Unknown"] = "unknown";
    return Environment;
}({});
module.exports["Environment"] = $cf10c8edb5d48b94$export$7dc6752a22ab011a;

});

parcelRegister("cCPLV", function(module, exports) {

var $9z7xR = parcelRequire("9z7xR");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/confluence/whiteboard/manifest.ts
var $9311318266bf230b$var$confluenceWhiteboardAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $9z7xR.ConfluenceWhiteboardAriResourceOwner),
    resourceType: (0, $9z7xR.ConfluenceWhiteboardAriResourceType),
    resourceIdSlug: "{whiteboardId}",
    resourceIdSegmentFormats: {
        whiteboardId: /[0-9]+/
    }
};
// src/confluence/whiteboard/index.ts
var $9311318266bf230b$export$ba3d25b6768ddb10 = class _ConfluenceWhiteboardAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get whiteboardId() {
        return this._whiteboardId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $9311318266bf230b$var$confluenceWhiteboardAriStaticOpts.qualifier,
            platformQualifier: $9311318266bf230b$var$confluenceWhiteboardAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $9311318266bf230b$var$confluenceWhiteboardAriStaticOpts.resourceOwner,
            resourceType: $9311318266bf230b$var$confluenceWhiteboardAriStaticOpts.resourceType,
            resourceId: `${opts.whiteboardId}`,
            resourceIdSegmentValues: {
                whiteboardId: opts.whiteboardId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $9311318266bf230b$var$confluenceWhiteboardAriStaticOpts);
        return new _ConfluenceWhiteboardAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $9311318266bf230b$var$confluenceWhiteboardAriStaticOpts);
        return new _ConfluenceWhiteboardAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            whiteboardId: this.whiteboardId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._whiteboardId = opts.resourceIdSegmentValues.whiteboardId;
    }
};
module.exports["ConfluenceWhiteboardAri"] = $9311318266bf230b$export$ba3d25b6768ddb10;

});

parcelRegister("9z7xR", function(module, exports) {
// src/confluence/whiteboard/types.ts
var $6f6d3c41ba97755c$export$6130ea1abbb885ef = "confluence", $6f6d3c41ba97755c$export$d3070d1568a10e2d = "whiteboard";
module.exports["ConfluenceWhiteboardAriResourceOwner"] = $6f6d3c41ba97755c$export$6130ea1abbb885ef;
module.exports["ConfluenceWhiteboardAriResourceType"] = $6f6d3c41ba97755c$export$d3070d1568a10e2d;

});

parcelRegister("dcJRl", function(module, exports) {
const $1eca0028b5407519$export$bab1229873daab56 = (tapTraits)=>{
    if (!tapTraits || Object.entries(tapTraits).length === 0) return null;
    return Object.entries(tapTraits).reduce((acc, [name, value])=>[
            ...acc,
            {
                name: name,
                value: String(value)
            }
        ], []);
};
module.exports["formatTapTraits"] = $1eca0028b5407519$export$bab1229873daab56;

});

parcelRegister("7aRa9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $gqqjz = parcelRequire("gqqjz");

function $eb37d7497b3d263d$export$e624a3067d475d88(InnerComponent) {
    var _WithFlags;
    return _WithFlags = class WithFlags extends (0, $cozmU.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(InnerComponent, {
                    ...this.props,
                    flags: flags
                }));
        }
    }, _WithFlags.displayName = `withFlags(${InnerComponent.displayName || InnerComponent.name})`, _WithFlags;
}
module.exports["withFlags"] = $eb37d7497b3d263d$export$e624a3067d475d88;

});

parcelRegister("brNvA", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $2c05d1bead0fe3b6$export$fb4e7a383f5cb089 = /*#__PURE__*/ (0, $cozmU.createContext)({
    commentToReattach: null,
    reattachHighlight: null,
    isInReattachMode: ()=>false
});
$2c05d1bead0fe3b6$export$fb4e7a383f5cb089.displayName = 'ReattachCommentContext';
const $2c05d1bead0fe3b6$export$29a077948aa018ea = /*#__PURE__*/ (0, $cozmU.createContext)({
    setCommentToReattach: ()=>{},
    setReattachHighlight: ()=>{},
    clearReattachMode: ()=>{}
});
$2c05d1bead0fe3b6$export$fb4e7a383f5cb089.displayName = 'ReattachCommentDispatchContext';
const $2c05d1bead0fe3b6$export$eeb6c3345224df9d = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { children: children } = t0;
    const [commentToReattach, setCommentToReattach] = (0, $cozmU.useState)(null);
    const [reattachHighlight, setReattachHighlight] = (0, $cozmU.useState)(null);
    let t1;
    if ($[0] !== commentToReattach) {
        t1 = ()=>Boolean(commentToReattach);
        $[0] = commentToReattach;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== commentToReattach || $[3] !== reattachHighlight || $[4] !== t1) {
        t2 = {
            commentToReattach: commentToReattach,
            reattachHighlight: reattachHighlight,
            isInReattachMode: t1
        };
        $[2] = commentToReattach;
        $[3] = reattachHighlight;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    const providerValue = t2;
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            setCommentToReattach: setCommentToReattach,
            setReattachHighlight: (highlight)=>{
                setReattachHighlight(highlight?.numMatches !== 0 ? highlight : null);
            },
            clearReattachMode: ()=>{
                setCommentToReattach(null);
                setReattachHighlight(null);
            }
        };
        $[6] = t3;
    } else t3 = $[6];
    const dispatchProviderValue = t3;
    let t4;
    if ($[7] !== children) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2c05d1bead0fe3b6$export$29a077948aa018ea.Provider, {
            value: dispatchProviderValue
        }, children);
        $[7] = children;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== providerValue || $[10] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2c05d1bead0fe3b6$export$fb4e7a383f5cb089.Provider, {
            value: providerValue
        }, t4);
        $[9] = providerValue;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
} : ({ children: children })=>{
    const [commentToReattach, setCommentToReattach] = (0, $cozmU.useState)(null);
    const [reattachHighlight, setReattachHighlight] = (0, $cozmU.useState)(null);
    const providerValue = (0, $cozmU.useMemo)(()=>({
            commentToReattach: commentToReattach,
            reattachHighlight: reattachHighlight,
            isInReattachMode: ()=>Boolean(commentToReattach)
        }), [
        commentToReattach,
        reattachHighlight
    ]);
    const dispatchProviderValue = (0, $cozmU.useMemo)(()=>({
            setCommentToReattach: setCommentToReattach,
            setReattachHighlight: (highlight)=>{
                setReattachHighlight(highlight?.numMatches !== 0 ? highlight : null);
            },
            clearReattachMode: ()=>{
                setCommentToReattach(null);
                setReattachHighlight(null);
            }
        }), [
        setCommentToReattach,
        setReattachHighlight
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2c05d1bead0fe3b6$export$fb4e7a383f5cb089.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2c05d1bead0fe3b6$export$29a077948aa018ea.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $2c05d1bead0fe3b6$export$d801c7a3a205f98e = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $cozmU.useContext)($2c05d1bead0fe3b6$export$fb4e7a383f5cb089);
} : ()=>{
    return (0, $cozmU.useContext)($2c05d1bead0fe3b6$export$fb4e7a383f5cb089);
};
const $2c05d1bead0fe3b6$export$344893016ba0bdd4 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $cozmU.useContext)($2c05d1bead0fe3b6$export$29a077948aa018ea);
} : ()=>{
    return (0, $cozmU.useContext)($2c05d1bead0fe3b6$export$29a077948aa018ea);
};
module.exports["ReattachCommentContext"] = $2c05d1bead0fe3b6$export$fb4e7a383f5cb089;
module.exports["ReattachCommentProvider"] = $2c05d1bead0fe3b6$export$eeb6c3345224df9d;
module.exports["useReattachComment"] = $2c05d1bead0fe3b6$export$d801c7a3a205f98e;
module.exports["useReattachCommentDispatch"] = $2c05d1bead0fe3b6$export$344893016ba0bdd4;

});

parcelRegister("de2j9", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");

const $da4a5d353aff754e$var$isOnEditorPageRouteArgs = {
    selector: (routeName)=>routeName === (0, $1NBp8.EDIT_PAGE_V2).name || routeName === (0, $1NBp8.EDIT_BLOG_V2).name || routeName === (0, $1NBp8.EDIT_PAGE_EMBED).name || routeName === (0, $1NBp8.COMPANY_HUB_EDIT).name || routeName === (0, $1NBp8.HUB_EDIT).name || routeName === (0, $1NBp8.EDIT_PAGE_SMART_CREATE).name || routeName === (0, $1NBp8.SPACE_SETTINGS_AGENT_CONTEXT).name
};
const $da4a5d353aff754e$export$90b90ac8ec152a49 = ()=>{
    return (0, $dPJCf.useRouteName)($da4a5d353aff754e$var$isOnEditorPageRouteArgs);
};
module.exports["useIsEditorPage"] = $da4a5d353aff754e$export$90b90ac8ec152a49;

});

parcelRegister("bjY3F", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $6cFsl = parcelRequire("6cFsl");


var $1hQ0e = parcelRequire("1hQ0e");


var $cXtTj = parcelRequire("cXtTj");


var $a33Aa = parcelRequire("a33Aa");


var $boaiH = parcelRequire("boaiH");


var $10XTN = parcelRequire("10XTN");


var $hlvTd = parcelRequire("hlvTd");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $irnO2 = parcelRequire("irnO2");


var $1XM8n = parcelRequire("1XM8n");


var $8YL3U = parcelRequire("8YL3U");

var $78cafaa44d513db0$var$_ExperienceTrackerHandler;
const $78cafaa44d513db0$var$isRovoInstrumentedError = (error)=>error !== null && error !== undefined && typeof error === 'object' && 'errorAttributes' in error && typeof error.errorAttributes === 'object';
const $78cafaa44d513db0$var$isTerminalEvent = (event)=>event.action === 'taskSuccess' || event.action === 'taskFail' || event.action === 'taskAbort';
const $78cafaa44d513db0$var$isAbortEvent = (event)=>event.action === 'taskAbort';
class $78cafaa44d513db0$export$5a92a056565f01cc {
    setSendAnalyticsEvent(sendAnalyticsEvent) {
        this.sendAnalyticsEvent = sendAnalyticsEvent;
    }
    static getInstance() {
        if (!$78cafaa44d513db0$export$5a92a056565f01cc.instance) {
            const dropEvents = (0, $cXtTj.default).getExperimentValue('platform_ai_drop_instrumentation_tracking', 'value', false);
            $78cafaa44d513db0$export$5a92a056565f01cc.instance = new $78cafaa44d513db0$export$5a92a056565f01cc(dropEvents);
        }
        // instance is guaranteed to be set after the guard above
        return $78cafaa44d513db0$export$5a92a056565f01cc.instance;
    }
    /**
   * @internal For tests only.
   */ static resetInstance() {
        $78cafaa44d513db0$export$5a92a056565f01cc.instance = undefined;
    }
    static setLabelStack(labelStack) {
        $78cafaa44d513db0$export$5a92a056565f01cc.labelStack = labelStack;
    }
    constructor(dropEvents){
        this.experienceTracker = new (0, $boaiH.ExperienceTracker)();
        this.sendAnalyticsEvent = null;
        this.tabVisibilityByExperience = new Map();
        const doc = (0, $1hQ0e.getDocument)();
        if (doc) (0, $cbY7C.bind)(doc, {
            type: 'visibilitychange',
            listener: ()=>{
                const isHidden = doc.visibilityState === 'hidden';
                this.tabVisibilityByExperience.forEach((tracker)=>{
                    tracker.onVisibilityChange(isHidden);
                });
            }
        });
        if (!dropEvents) this.experienceTracker.subscribe((event)=>{
            if (event.action === 'taskStart') this.tabVisibilityByExperience.set(event.name, new (0, $8YL3U.TabVisibilityTracker)(doc));
            let filteredErrorAttributes = {};
            let preventSendingLogException = false;
            // When non-null, converts taskFail → taskAbort so the error is excluded from SLO
            // failure counts but still recorded for anomaly detection purposes.
            let sloExclusion = null;
            const isErrorEvent = 'error' in event;
            // Skip SLO exclusion logic for the aiMateFilteredClientError experience itself
            // to avoid re-processing and potential infinite loops.
            const isFilteredClientErrorExperience = event.name === (0, $irnO2.ExperienceName).FILTERED_CLIENT_ERROR;
            if (isErrorEvent && !isFilteredClientErrorExperience) {
                // Classify common non-service errors so they can be tracked separately from
                // real backend failures:
                //   - client fetch errors (e.g. "Failed to fetch") — request never reached Atlassian
                //   - product-not-active — HTTP 200 but SSE payload contains an errorCode
                //   - auth/permission — HTTP 401/403 (session expired, HIPAA, IP allowlist, etc.)
                if ((0, $10XTN.isClientFetchError)(event.error)) {
                    preventSendingLogException = true;
                    sloExclusion = {
                        reason: (0, $irnO2.SLOExclusionReason).CLIENT_FETCH_ERROR
                    };
                } else if ((0, $10XTN.isProductNotActiveError)(event.error)) {
                    preventSendingLogException = true;
                    sloExclusion = {
                        reason: (0, $irnO2.SLOExclusionReason).PRODUCT_NOT_ACTIVE
                    };
                } else if ((0, $10XTN.isAuthOrPermissionError)(event.error)) {
                    preventSendingLogException = true;
                    sloExclusion = {
                        reason: (0, $irnO2.SLOExclusionReason).AUTH_OR_PERMISSION_ERROR
                    };
                } else if ((0, $10XTN.isRateLimitError)(event.error)) {
                    preventSendingLogException = true;
                    sloExclusion = {
                        reason: (0, $irnO2.SLOExclusionReason).RATE_LIMIT_ERROR
                    };
                }
                if (event.attributes) {
                    const { webSearchEnabled: webSearchEnabled, deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, fastModeEnabled: fastModeEnabled } = event.attributes;
                    if (webSearchEnabled !== undefined) filteredErrorAttributes = {
                        ...filteredErrorAttributes,
                        webSearchEnabled: webSearchEnabled
                    };
                    if (deepResearchEnabled !== undefined) filteredErrorAttributes = {
                        ...filteredErrorAttributes,
                        deepResearchEnabled: deepResearchEnabled
                    };
                    if (fastModeEnabled !== undefined) filteredErrorAttributes = {
                        ...filteredErrorAttributes,
                        fastModeEnabled: fastModeEnabled
                    };
                    if (thinkDeeperEnabled !== undefined) filteredErrorAttributes = {
                        ...filteredErrorAttributes,
                        thinkDeeperEnabled: thinkDeeperEnabled
                    };
                }
                if ($78cafaa44d513db0$var$isRovoInstrumentedError(event.error)) {
                    const errorAttributes = event.error.errorAttributes;
                    // Remove undefined properties
                    filteredErrorAttributes = Object.fromEntries(Object.entries(errorAttributes).filter(([, value])=>value !== undefined));
                }
                const teamName = (0, $1XM8n.getOwningTeam)(event.error.message ?? '', event.name);
                filteredErrorAttributes = {
                    teamName: teamName,
                    // We intentionally put this first so a `teamName` attribute can override this.
                    ...filteredErrorAttributes
                };
                if (!preventSendingLogException) {
                    const error = event.error instanceof Error ? event.error : new Error(JSON.stringify(event.error));
                    const attributes = event.attributes;
                    // this is added by `useExperienceTracker` below
                    const touchpointSource = typeof attributes?.touchpointSource === 'string' ? attributes.touchpointSource : undefined;
                    const teamName = typeof attributes?.teamName === 'string' ? attributes.teamName : undefined;
                    const { traceId: traceIdFromErrorObject, ...filteredErrorAttributesRest } = filteredErrorAttributes;
                    const altTraceId = attributes?.traceId || traceIdFromErrorObject;
                    (0, $hlvTd.logException)({
                        exception: error,
                        name: event.name,
                        // eslint-disable-next-line @atlaskit/platform/no-double-type-assertions -- Existing experience-tracker baseline: legacy UFO attributes are assembled from mixed attribute sources before being passed to a string map API.
                        tags: {
                            source: 'aiMateExperienceTracker',
                            ...filteredErrorAttributesRest,
                            ...touchpointSource && {
                                touchpointSource: touchpointSource
                            },
                            ...teamName && {
                                teamName: teamName
                            },
                            // Rename traceId to atlTraceId if present in attributes to distinguish from Sentry's Trace ID
                            ...altTraceId && {
                                altTraceId: altTraceId
                            }
                        }
                    });
                }
            }
            if ($78cafaa44d513db0$var$isTerminalEvent(event)) // the experience tracker already uses performance.now() to calculate the duration, so we can just piggyback on that,
            // we will loose some precision due to rounding of duration, but it's good enough for our purposes
            (0, $a33Aa.addSpanToAll)('custom', `exp-${event.name}`, $78cafaa44d513db0$export$5a92a056565f01cc.labelStack, event.startTime, event.startTime + event.duration);
            const tabVisibilityAttributes = $78cafaa44d513db0$var$isTerminalEvent(event) ? this.tabVisibilityByExperience.get(event.name)?.getAttributes(doc) ?? {} : {};
            // If the error should be excluded from SLO, report it as taskAbort instead of taskFail.
            // taskAbort events are not counted as failures in the SLO but are still recorded
            // so anomaly detectors can track spikes in these error types.
            const effectiveAction = sloExclusion && event.action === 'taskFail' ? 'taskAbort' : event.action;
            this.sendAnalyticsEvent?.({
                eventType: 'operational',
                action: effectiveAction,
                actionSubject: 'ui',
                attributes: {
                    task: event.name,
                    taskId: event.id,
                    startTime: event.startTime,
                    ...$78cafaa44d513db0$var$isTerminalEvent(event) && {
                        duration: event.duration
                    },
                    // Include error info on both taskFail and taskAbort (for excluded errors)
                    // so analytics/anomaly detectors can distinguish error types.
                    ...isErrorEvent && {
                        error: event.error.message,
                        ...filteredErrorAttributes
                    },
                    // Surface why the error was excluded from the SLO so the raw analytics
                    // event can be queried/grouped without joining to the synthetic experience.
                    ...sloExclusion && {
                        sloExclusionReason: sloExclusion.reason
                    },
                    // `abort()` takes its reason as a top-level field rather than inside
                    // `attributes`, so it is otherwise dropped here and aborts land in
                    // analytics with no indication of why they happened. Spread before
                    // `event.attributes` so callers that already nest their own `reason`
                    // keep precedence.
                    ...$78cafaa44d513db0$var$isAbortEvent(event) && {
                        reason: event.reason
                    },
                    ...event.attributes,
                    ...tabVisibilityAttributes
                }
            }, {
                removeDefaultTags: true
            });
            // When a client error is excluded from the main SLO (ie. converted to taskAbort),
            // track a separate experience so the volume of these errors can be monitored with its own SLO threshold.
            if (sloExclusion && isErrorEvent) {
                this.experienceTracker.start({
                    name: (0, $irnO2.ExperienceName).FILTERED_CLIENT_ERROR,
                    id: (0, $irnO2.ExperienceName).FILTERED_CLIENT_ERROR,
                    startTime: event.startTime
                });
                this.experienceTracker.fail({
                    name: (0, $irnO2.ExperienceName).FILTERED_CLIENT_ERROR,
                    error: event.error,
                    attributes: {
                        // Preserve the original experience name, error, and exclusion reason for queryability
                        originalTask: event.name,
                        error: event.error.message,
                        sloExclusionReason: sloExclusion.reason,
                        ...filteredErrorAttributes
                    }
                });
            }
            if ($78cafaa44d513db0$var$isTerminalEvent(event)) this.tabVisibilityByExperience.delete(event.name);
        });
    }
}
$78cafaa44d513db0$var$_ExperienceTrackerHandler = $78cafaa44d513db0$export$5a92a056565f01cc;
$78cafaa44d513db0$export$5a92a056565f01cc.instance = void 0;
$78cafaa44d513db0$export$5a92a056565f01cc.labelStack = [];
const $78cafaa44d513db0$export$63af6e7bbb4f375d = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return $78cafaa44d513db0$var$_temp;
} : ()=>{
    return (0, $cozmU.useCallback)((componentLabelStack)=>{
        $78cafaa44d513db0$export$5a92a056565f01cc.setLabelStack(componentLabelStack);
    }, []);
};
const $78cafaa44d513db0$export$412c53791574f6f0 = (params)=>{
    (0, $6cFsl.di)((0, $Ou0Zz.useAnalytics));
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    (0, $cozmU.useMemo)(()=>{
        const experienceTracker = $78cafaa44d513db0$export$5a92a056565f01cc.getInstance();
        // this is not ideal, okay just because `sendAnalyticsEvent` is never change
        // since every hook instance will override the singleton sendAnalyticsEvent
        experienceTracker.setSendAnalyticsEvent(sendAnalyticsEvent);
    }, [
        sendAnalyticsEvent
    ]);
    const experienceTrackerProxy = (0, $cozmU.useMemo)(()=>{
        const proxyHandler = {
            get: (target, prop)=>{
                // Overriding the experienceTracker target methods to add additional attributes
                if (prop === 'fail') return (failParams)=>{
                    target.fail({
                        ...failParams,
                        name: failParams.name,
                        attributes: {
                            ...failParams.attributes,
                            touchpointSource: params?.touchpointSource,
                            teamName: failParams.teamName
                        }
                    });
                };
                if (prop === 'succeed') return (succeedParams)=>{
                    target.succeed({
                        ...succeedParams,
                        name: succeedParams.name,
                        attributes: {
                            ...succeedParams.attributes,
                            touchpointSource: params?.touchpointSource
                        }
                    });
                };
                if (prop === 'start') return (startParams)=>{
                    target.start({
                        ...startParams,
                        name: startParams.name
                    });
                };
                if (prop === 'abort') return (abortParams)=>{
                    target.abort({
                        ...abortParams,
                        name: abortParams.name
                    });
                };
                if (prop === 'stopOnError') return (stopOnErrorParams)=>{
                    target.stopOnError({
                        ...stopOnErrorParams,
                        name: stopOnErrorParams.name
                    });
                };
                return typeof target[prop] === 'function' ? target[prop].bind(target) : target[prop];
            }
        };
        return new Proxy($78cafaa44d513db0$export$5a92a056565f01cc.getInstance().experienceTracker, proxyHandler);
    }, [
        params?.touchpointSource
    ]);
    return experienceTrackerProxy;
};
function $78cafaa44d513db0$var$_temp(componentLabelStack) {
    $78cafaa44d513db0$export$5a92a056565f01cc.setLabelStack(componentLabelStack);
}
module.exports["ExperienceTrackerHandler"] = $78cafaa44d513db0$export$5a92a056565f01cc;
module.exports["useUFOLabelStackSetter"] = $78cafaa44d513db0$export$63af6e7bbb4f375d;
module.exports["useAIMateExperienceTracker"] = $78cafaa44d513db0$export$412c53791574f6f0;

});

parcelRegister("10XTN", function(module, exports) {

var $3PJhM = parcelRequire("3PJhM");

// Referenced from jira/src/packages/platform/utils/fetch/src/utils/is-error.tsx
// Issues we are not gonna track in Sentry
const $ab109556016fa76e$var$KNOWN_NETWORK_ERRORS_LIMITED = [
    'server with the specified hostname could not be found',
    'connection failure',
    'Failed to fetch',
    'Load failed',
    // Safari equivalent of "Failed to fetch"
    'Network request failed',
    'NetworkError',
    'The request timed out',
    'The network connection was lost',
    'The operation was aborted'
];
const $ab109556016fa76e$var$isClientFetchErrorMessage = (message)=>{
    const errorTypes = $ab109556016fa76e$var$KNOWN_NETWORK_ERRORS_LIMITED;
    return Boolean(message) && !!errorTypes.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
        // are sometimes wrapped to provide additional context, e.g.
        // "Something went wrong: ${error.message}"
        message.includes(networkErrorMessage));
};
const $ab109556016fa76e$var$KNOWN_NETWORK_ERRORS_TYPES = [
    'AbortError',
    'AuthError',
    'ChunkLoadError',
    'NetworkError'
];
const $ab109556016fa76e$var$MAX_ERROR_CAUSE_DEPTH = 3;
const $ab109556016fa76e$var$getErrorAndCauseRecords = (error)=>{
    const records = [];
    let currentError = error;
    for(let depth = 0; depth < $ab109556016fa76e$var$MAX_ERROR_CAUSE_DEPTH && (0, $3PJhM.isRecord)(currentError); depth++){
        records.push(currentError);
        currentError = currentError.cause;
    }
    return records;
};
const $ab109556016fa76e$var$getErrorStatusCode = (error)=>{
    const errorAttributes = (0, $3PJhM.isRecord)(error.errorAttributes) ? error.errorAttributes : undefined;
    const attributes = (0, $3PJhM.isRecord)(error.attributes) ? error.attributes : undefined;
    const status = errorAttributes?.statusCode ?? error.status ?? attributes?.status;
    return typeof status === 'number' ? status : undefined;
};
const $ab109556016fa76e$var$getErrorCode = (error)=>{
    const errorAttributes = (0, $3PJhM.isRecord)(error.errorAttributes) ? error.errorAttributes : undefined;
    return typeof errorAttributes?.errorCode === 'string' ? errorAttributes.errorCode.toLowerCase() : undefined;
};
const $ab109556016fa76e$export$2e7adc44463c3f4f = (error)=>{
    if (!(0, $3PJhM.isRecord)(error)) return false;
    // Check top-level error name and message
    const hasKnownName = typeof error.name === 'string' && $ab109556016fa76e$var$KNOWN_NETWORK_ERRORS_TYPES.includes(error.name);
    const hasKnownMessage = typeof error.message === 'string' && $ab109556016fa76e$var$isClientFetchErrorMessage(error.message);
    if (hasKnownName || hasKnownMessage) return true;
    // Also check the nested cause (e.g. wrapped fetch errors)
    if (!(0, $3PJhM.isRecord)(error.cause)) return false;
    return typeof error.cause.name === 'string' && $ab109556016fa76e$var$KNOWN_NETWORK_ERRORS_TYPES.includes(error.cause.name) || typeof error.cause.message === 'string' && $ab109556016fa76e$var$isClientFetchErrorMessage(error.cause.message);
};
const $ab109556016fa76e$export$de229d5c9394f905 = (error)=>{
    return $ab109556016fa76e$var$getErrorAndCauseRecords(error).some((errorRecord)=>{
        const status = $ab109556016fa76e$var$getErrorStatusCode(errorRecord);
        return status === 401 || status === 403;
    });
};
const $ab109556016fa76e$export$a8908c3867f6f20b = (error)=>{
    return $ab109556016fa76e$var$getErrorAndCauseRecords(error).some((errorRecord)=>$ab109556016fa76e$var$getErrorStatusCode(errorRecord) === 429);
};
const $ab109556016fa76e$export$9f0dca42eff14720 = (error)=>{
    return $ab109556016fa76e$var$getErrorAndCauseRecords(error).some((errorRecord)=>{
        const errorCode = $ab109556016fa76e$var$getErrorCode(errorRecord) ?? '';
        return errorCode.includes('product.not.active') || errorCode.includes('product_not_active');
    });
};
module.exports["isClientFetchError"] = $ab109556016fa76e$export$2e7adc44463c3f4f;
module.exports["isAuthOrPermissionError"] = $ab109556016fa76e$export$de229d5c9394f905;
module.exports["isRateLimitError"] = $ab109556016fa76e$export$a8908c3867f6f20b;
module.exports["isProductNotActiveError"] = $ab109556016fa76e$export$9f0dca42eff14720;

});

parcelRegister("3PJhM", function(module, exports) {
/**
 * Type guard that checks whether a value is a plain record object.
 */ const $99d6458d8ffffa8f$export$6ba840931da50680 = (value)=>typeof value === 'object' && value !== null && !Array.isArray(value);
module.exports["isRecord"] = $99d6458d8ffffa8f$export$6ba840931da50680;

});

parcelRegister("hlvTd", function(module, exports) {

var $jTKfH = parcelRequire("jTKfH");


var $cj7GQ = parcelRequire("cj7GQ");


var $8DeC3 = parcelRequire("8DeC3");


const $024249913f1d8b5b$var$importPrivateSentryAsync = async ()=>{
    const sentry = await (parcelRequire("55apF"));
    return {
        BrowserClient: sentry.BrowserClient,
        eventFromException: sentry.eventFromException
    };
};
const $024249913f1d8b5b$var$DEFAULT_PACKAGE_NAME = '@atlassian/conversation-assistant';
const $024249913f1d8b5b$var$DEFAULT_SENTRY_DSN = 'https://0d679a1c0fe3816e2b2e34d4ca85d5da@o55978.ingest.sentry.io/4506794008903680';
let $024249913f1d8b5b$var$privateReporter;
let $024249913f1d8b5b$var$accountIdPromise;
const $024249913f1d8b5b$var$defaultAccountIdProvider = ()=>new Promise((resolve, reject)=>{
        (0, $jTKfH.performHttpFetch)({
            path: '/gateway/api/me',
            options: {
                method: 'GET'
            }
        }).then((profileData)=>{
            if (profileData?.account_id) resolve(profileData.account_id);
            else reject(new Error('Profile data not loaded'));
        }).catch((error)=>{
            reject(error);
        });
    });
let $024249913f1d8b5b$var$accountIdProvider = $024249913f1d8b5b$var$defaultAccountIdProvider;
const $024249913f1d8b5b$export$59333a3d3d770a30 = (fn)=>{
    $024249913f1d8b5b$var$accountIdProvider = fn;
    $024249913f1d8b5b$var$accountIdPromise = undefined;
};
const $024249913f1d8b5b$export$e941c8ce80d1ac70 = ()=>{
    $024249913f1d8b5b$var$accountIdProvider = $024249913f1d8b5b$var$defaultAccountIdProvider;
    $024249913f1d8b5b$var$accountIdPromise = undefined;
};
const $024249913f1d8b5b$export$388db6ab9ccbe151 = ()=>{
    $024249913f1d8b5b$var$privateReporter?.resetForTests();
    $024249913f1d8b5b$var$privateReporter = undefined;
    $024249913f1d8b5b$var$accountIdPromise = undefined;
    $024249913f1d8b5b$var$accountIdProvider = $024249913f1d8b5b$var$defaultAccountIdProvider;
};
const $024249913f1d8b5b$var$getEnvironment = ()=>{
    return 'production';
};
const $024249913f1d8b5b$var$getRelease = ()=>{
    if (typeof window === 'undefined') return;
    return window.SENTRY_RELEASE?.id;
};
const $024249913f1d8b5b$var$setupPrivateReporter = async ({ accountId: accountId, customSentryDsn: customSentryDsn, ignoreErrors: ignoreErrors, packageName: packageName, packageVersion: packageVersion, product: product })=>{
    const dsn = customSentryDsn || $024249913f1d8b5b$var$DEFAULT_SENTRY_DSN;
    if ($024249913f1d8b5b$var$privateReporter) {
        $024249913f1d8b5b$var$privateReporter.updateContext({
            accountId: accountId,
            packageVersion: packageVersion,
            product: product
        });
        return;
    }
    try {
        const importedSentry = await $024249913f1d8b5b$var$importPrivateSentryAsync();
        $024249913f1d8b5b$var$privateReporter = new (0, $8DeC3.ConversationAssistantPrivateReporter)({
            accountId: accountId,
            dsn: dsn,
            environment: $024249913f1d8b5b$var$getEnvironment(),
            ignoreErrors: ignoreErrors,
            packageName: packageName,
            packageVersion: packageVersion,
            product: product,
            release: $024249913f1d8b5b$var$getRelease(),
            sentry: importedSentry
        });
    } catch  {
    // Private reporting is best effort and must not affect Sentry callers.
    }
};
const $024249913f1d8b5b$export$d8bd0edf6c978788 = async ({ customSentryDsn: customSentryDsn, packageName: packageName, product: productOverride, ignoreErrors: ignoreErrors, packageVersion: packageVersion } = {})=>{
    let accountId = 'UNKNOWN_AAID';
    const product = productOverride ?? (0, $cj7GQ.getRovoChatProduct)();
    const resolvedPackageName = packageName || $024249913f1d8b5b$var$DEFAULT_PACKAGE_NAME;
    try {
        if (!$024249913f1d8b5b$var$accountIdPromise) $024249913f1d8b5b$var$accountIdPromise = $024249913f1d8b5b$var$accountIdProvider();
        accountId = await $024249913f1d8b5b$var$accountIdPromise;
    } catch  {
    // do nothing
    }
    await $024249913f1d8b5b$var$setupPrivateReporter({
        accountId: accountId,
        customSentryDsn: customSentryDsn,
        ignoreErrors: ignoreErrors,
        packageName: resolvedPackageName,
        packageVersion: packageVersion,
        product: product
    });
};
const $024249913f1d8b5b$export$f86b2a1a2ce291b3 = async ({ exception: exception, name: name, tags: tags })=>{
    if (!$024249913f1d8b5b$var$privateReporter) await $024249913f1d8b5b$export$d8bd0edf6c978788();
    try {
        await $024249913f1d8b5b$var$privateReporter?.captureException({
            exception: exception,
            name: name,
            tags: tags
        });
    } catch  {
    // Private reporting is best effort and must not affect Sentry callers.
    }
};
async function $024249913f1d8b5b$export$de29810e0b4aa46e(crumb) {
    if (!$024249913f1d8b5b$var$privateReporter) await $024249913f1d8b5b$export$d8bd0edf6c978788();
    try {
        $024249913f1d8b5b$var$privateReporter?.addBreadcrumb(crumb);
    } catch  {
    // Breadcrumb collection is best effort and must never affect the caller.
    }
}
const $024249913f1d8b5b$export$2a10cc65cb1c6167 = (...args)=>{
    console.error(...args); // eslint-disable-line no-console
    if ($024249913f1d8b5b$var$privateReporter) try {
        $024249913f1d8b5b$var$privateReporter.addBreadcrumb({
            category: 'console',
            level: 'error',
            message: args.map(String).join(' ')
        });
    } catch  {
    // Mirroring selected console output is best effort.
    }
};
const $024249913f1d8b5b$export$b9f335638bb5225f = (...args)=>{
    console.warn(...args); // eslint-disable-line no-console
    if ($024249913f1d8b5b$var$privateReporter) try {
        $024249913f1d8b5b$var$privateReporter.addBreadcrumb({
            category: 'console',
            level: 'warning',
            message: args.map(String).join(' ')
        });
    } catch  {
    // Mirroring selected console output is best effort.
    }
};
module.exports["setupSentryClient"] = $024249913f1d8b5b$export$d8bd0edf6c978788;
module.exports["logException"] = $024249913f1d8b5b$export$f86b2a1a2ce291b3;
module.exports["addSentryBreadcrumb"] = $024249913f1d8b5b$export$de29810e0b4aa46e;
module.exports["logSentryConsoleError"] = $024249913f1d8b5b$export$2a10cc65cb1c6167;
module.exports["logSentryConsoleWarning"] = $024249913f1d8b5b$export$b9f335638bb5225f;

});

parcelRegister("jTKfH", function(module, exports) {

var $5rzIE = parcelRequire("5rzIE");

const $93101e1e1df3fd55$export$9f229e40eb65abfc = (response)=>response?.headers?.get('x-trace-id') ?? response?.headers?.get('atl-traceid') ?? response?.headers?.get('x-b3-traceid') ?? undefined;
class $93101e1e1df3fd55$export$26e841bcf1aeb894 extends Error {
    constructor(message, errorAttributes){
        super(message), this.errorAttributes = errorAttributes;
        this.name = 'FetchError';
    }
}
class $93101e1e1df3fd55$var$HttpApiError extends Error {
    constructor(message, errorAttributes){
        super(message), this.message = message, this.errorAttributes = errorAttributes;
    }
}
const $93101e1e1df3fd55$export$a38d93aa782475f6 = async ({ path: path, options: options })=>{
    const startedAt = (0, $5rzIE.hasRequestObservationSubscribers)() ? (0, $5rzIE.requestObservationNow)() : undefined;
    try {
        const response = await fetch(path, options);
        if (!response.ok || response.status >= 400) await $93101e1e1df3fd55$var$processHttpErrorResponse({
            response: response
        });
        const result = await response.json();
        if (startedAt !== undefined) (0, $5rzIE.publishRequestObservation)({
            kind: 'http',
            method: (options.method ?? 'GET').toUpperCase(),
            route: (0, $5rzIE.normalizeRequestRoute)(path),
            durationMs: (0, $5rzIE.requestObservationDuration)(startedAt),
            outcome: 'success',
            status: response.status
        });
        return result;
    } catch (err) {
        const outcome = err instanceof $93101e1e1df3fd55$var$HttpApiError ? 'httpError' : err instanceof Error && err.name === 'AbortError' ? 'abort' : 'networkError';
        const statusCode = err instanceof $93101e1e1df3fd55$var$HttpApiError ? err.errorAttributes.statusCode : undefined;
        if (startedAt !== undefined) (0, $5rzIE.publishRequestObservation)({
            kind: 'http',
            method: (options.method ?? 'GET').toUpperCase(),
            route: (0, $5rzIE.normalizeRequestRoute)(path),
            durationMs: (0, $5rzIE.requestObservationDuration)(startedAt),
            outcome: outcome,
            status: statusCode
        });
        const originalErrorMessage = err instanceof Error ? 'Original error: ' + err.message : 'Unknown error';
        throw new $93101e1e1df3fd55$export$26e841bcf1aeb894(`performHttpFetch error while fetching ${path}. ${originalErrorMessage}`, {
            errorCode: 'performHttpFetchError',
            statusCode: statusCode
        });
    }
};
const $93101e1e1df3fd55$var$processHttpErrorResponse = async ({ response: response })=>{
    throw new $93101e1e1df3fd55$var$HttpApiError(`[Code ${response.status}] ${await response.text()}`, {
        statusCode: response.status,
        traceId: $93101e1e1df3fd55$export$9f229e40eb65abfc(response)
    });
};
module.exports["getTraceIdFromResponse"] = $93101e1e1df3fd55$export$9f229e40eb65abfc;
module.exports["FetchError"] = $93101e1e1df3fd55$export$26e841bcf1aeb894;
module.exports["performHttpFetch"] = $93101e1e1df3fd55$export$a38d93aa782475f6;

});

parcelRegister("5rzIE", function(module, exports) {
const $40a8b1f594239208$var$listeners = new Set();
const $40a8b1f594239208$var$UUID_SEGMENT_PATTERN = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;
const $40a8b1f594239208$var$NUMERIC_SEGMENT_PATTERN = /\/\d+(?=\/|$)/g;
const $40a8b1f594239208$export$eb91308c925b64ce = ()=>{
    if (typeof performance !== 'undefined' && typeof performance.now === 'function') return performance.now();
    return Date.now();
};
const $40a8b1f594239208$export$327998895df08b85 = (startedAt)=>Math.max(0, Math.round($40a8b1f594239208$export$eb91308c925b64ce() - startedAt));
const $40a8b1f594239208$export$c805539eac489f93 = (path)=>{
    try {
        const parsed = new URL(path, 'https://conversation-assistant.invalid');
        return parsed.pathname.replace($40a8b1f594239208$var$UUID_SEGMENT_PATTERN, '{id}').replace($40a8b1f594239208$var$NUMERIC_SEGMENT_PATTERN, '/{id}');
    } catch  {
        return '/unparseable';
    }
};
const $40a8b1f594239208$export$d23c16bc33c579b9 = (listener)=>{
    $40a8b1f594239208$var$listeners.add(listener);
    return ()=>{
        $40a8b1f594239208$var$listeners.delete(listener);
    };
};
const $40a8b1f594239208$export$1914d1896389da95 = ()=>$40a8b1f594239208$var$listeners.size > 0;
const $40a8b1f594239208$export$58e155918d09bf5f = (observation)=>{
    for (const listener of Array.from($40a8b1f594239208$var$listeners))try {
        listener(observation);
    } catch  {
    // Observability must never change the request's result or error behavior.
    }
};
const $40a8b1f594239208$export$ef42b2d680ea8d8d = ()=>{
    $40a8b1f594239208$var$listeners.clear();
};
module.exports["requestObservationNow"] = $40a8b1f594239208$export$eb91308c925b64ce;
module.exports["requestObservationDuration"] = $40a8b1f594239208$export$327998895df08b85;
module.exports["normalizeRequestRoute"] = $40a8b1f594239208$export$c805539eac489f93;
module.exports["subscribeToRequestObservations"] = $40a8b1f594239208$export$d23c16bc33c579b9;
module.exports["hasRequestObservationSubscribers"] = $40a8b1f594239208$export$1914d1896389da95;
module.exports["publishRequestObservation"] = $40a8b1f594239208$export$58e155918d09bf5f;

});

parcelRegister("cj7GQ", function(module, exports) {
const $cfb262a7d2b032b8$export$d4fdfa93c283ffc = ()=>{
    let product = 'UNKNOWN';
    const win = window;
    if (win.__ROVO_CHAT_CONFIG_PRODUCT__) product = win.__ROVO_CHAT_CONFIG_PRODUCT__;
    return product;
};
module.exports["getRovoChatProduct"] = $cfb262a7d2b032b8$export$d4fdfa93c283ffc;

});

parcelRegister("8DeC3", function(module, exports) {

var $5rzIE = parcelRequire("5rzIE");


var $10XTN = parcelRequire("10XTN");


var $u3ka6 = parcelRequire("u3ka6");


var $fPSAz = parcelRequire("fPSAz");

const $0e0107334ae89504$var$MAX_LINKED_ERRORS = 5;
const $0e0107334ae89504$var$MAX_MATCHED_UUID_TAG_LENGTH = 200;
const $0e0107334ae89504$var$BLOCKED_LOCATION_PARTS = [
    'localhost',
    'jira-dev.com',
    'stg.atlassian.com',
    'stg.internal.atlassian.com',
    'stg-east.frontend.public.atl-paas.net'
];
const $0e0107334ae89504$var$eventId = ()=>crypto.randomUUID().replace(/-/g, '');
const $0e0107334ae89504$var$matchesIgnorePattern = (value, patterns)=>patterns?.some((pattern)=>typeof pattern === 'string' ? value.includes(pattern) : (()=>{
            pattern.lastIndex = 0;
            const matches = pattern.test(value);
            pattern.lastIndex = 0;
            return matches;
        })()) ?? false;
const $0e0107334ae89504$var$isBlockedLocation = ()=>{
    if (typeof window === 'undefined') return false;
    return $0e0107334ae89504$var$BLOCKED_LOCATION_PARTS.some((part)=>window.location.href.includes(part));
};
const $0e0107334ae89504$var$requestObservationToBreadcrumb = (observation)=>({
        category: observation.kind === 'graphql' ? 'conversation-assistant.request.graphql' : 'conversation-assistant.request.http',
        data: observation,
        level: observation.outcome === 'success' || observation.outcome === 'abort' ? 'info' : 'warning',
        message: observation.kind === 'graphql' ? `${observation.operation} ${observation.outcome}` : `${observation.method} ${observation.route} ${observation.outcome}`,
        type: 'http'
    });
const $0e0107334ae89504$var$toPrivateBreadcrumb = (breadcrumb)=>({
        ...breadcrumb,
        level: breadcrumb.level
    });
const $0e0107334ae89504$var$getCause = (error)=>{
    const cause = error.cause;
    return cause instanceof Error ? cause : undefined;
};
class $0e0107334ae89504$export$7c63502cdfeff038 {
    updateContext({ accountId: accountId, packageVersion: packageVersion, product: product }) {
        this.accountId = accountId;
        if (this.packageVersion === undefined && packageVersion !== undefined) this.packageVersion = packageVersion;
        this.product = product;
    }
    addBreadcrumb(crumb) {
        this.breadcrumbGateway.add(crumb);
    }
    async captureException({ exception: exception, name: name, tags: tags }) {
        if (!this.enabled || (0, $10XTN.isClientFetchError)(exception) || $0e0107334ae89504$var$isBlockedLocation()) return;
        const rootMessage = exception instanceof Error ? exception.message : String(exception);
        if ($0e0107334ae89504$var$matchesIgnorePattern(rootMessage, this.ignoreErrors)) return;
        const id = $0e0107334ae89504$var$eventId();
        const event = await this.sentry.eventFromException(exception, {
            event_id: id
        }, true);
        await this.addLinkedErrors(event, exception);
        const eventTags = {
            experience: tags?.source === 'aiMateExperienceTracker' ? name : undefined,
            name: name,
            packageName: this.packageName,
            packageVersion: this.packageVersion,
            product: this.product,
            sentryOwner: 'conversation-assistant',
            ...tags
        };
        event.tags = {
            ...event.tags,
            ...eventTags
        };
        event.user = {
            id: this.accountId
        };
        event.breadcrumbs = this.breadcrumbGateway.snapshot().map($0e0107334ae89504$var$toPrivateBreadcrumb);
        if (typeof window !== 'undefined') event.request = {
            ...event.request,
            url: (0, $fPSAz.normaliseUrl)(window.location.href)
        };
        this.normalizeEventUUIDs(event);
        // Do not pass `originalException`: BaseClient otherwise consults the SDK-wide
        // already-caught registry shared through Sentry's global carrier.
        this.client.captureEvent(event, {
            event_id: id
        });
    }
    resetForTests() {
        this.unsubscribeFromRequestObservations();
        this.breadcrumbGateway.reset();
    }
    async addLinkedErrors(event, exception) {
        if (!(exception instanceof Error) || !event.exception?.values) return;
        const linkedValues = [];
        let current = $0e0107334ae89504$var$getCause(exception);
        const seen = new Set([
            exception
        ]);
        while(current && linkedValues.length < $0e0107334ae89504$var$MAX_LINKED_ERRORS - 1 && !seen.has(current)){
            seen.add(current);
            const linkedEvent = await this.sentry.eventFromException(current, undefined, true);
            if (linkedEvent.exception?.values?.[0]) linkedValues.unshift(linkedEvent.exception.values[0]);
            current = $0e0107334ae89504$var$getCause(current);
        }
        event.exception.values = [
            ...linkedValues,
            ...event.exception.values
        ];
    }
    normalizeEventUUIDs(event) {
        if (!event.exception?.values) return;
        const matchedUUIDs = new Set();
        event.exception.values = event.exception.values.map((exceptionValue)=>{
            const { normalized: normalized, matchedUUIDs: matches } = (0, $fPSAz.normalizeUUID)(exceptionValue.value);
            matches.forEach((match)=>matchedUUIDs.add(match));
            return {
                ...exceptionValue,
                stacktrace: exceptionValue.stacktrace ? {
                    ...exceptionValue.stacktrace,
                    frames: exceptionValue.stacktrace.frames?.map((frame)=>{
                        const normalizedFrame = {
                            ...frame
                        };
                        [
                            'abs_path',
                            'filename',
                            'function',
                            'module'
                        ].forEach((key)=>{
                            if (typeof normalizedFrame[key] !== 'string') return;
                            const normalizedStackValue = (0, $fPSAz.normalizeUUID)(normalizedFrame[key]);
                            normalizedStackValue.matchedUUIDs.forEach((match)=>matchedUUIDs.add(match));
                            normalizedFrame[key] = normalizedStackValue.normalized;
                        });
                        return normalizedFrame;
                    })
                } : undefined,
                value: normalized
            };
        });
        if (matchedUUIDs.size === 0) return;
        const boundedMatches = [];
        for (const match of matchedUUIDs){
            const candidate = [
                ...boundedMatches,
                match
            ];
            if (JSON.stringify(candidate).length > $0e0107334ae89504$var$MAX_MATCHED_UUID_TAG_LENGTH) break;
            boundedMatches.push(match);
        }
        event.tags = {
            ...event.tags,
            matchedUUID: JSON.stringify(boundedMatches)
        };
    }
    constructor({ accountId: accountId, dsn: dsn, environment: environment, ignoreErrors: ignoreErrors, packageName: packageName, packageVersion: packageVersion, product: product, release: release, sentry: sentry }){
        this.breadcrumbGateway = new (0, $u3ka6.ConversationAssistantBreadcrumbGateway)();
        this.client = void 0;
        this.enabled = void 0;
        this.ignoreErrors = void 0;
        this.sentry = void 0;
        this.accountId = void 0;
        this.packageName = void 0;
        this.packageVersion = void 0;
        this.product = void 0;
        this.unsubscribeFromRequestObservations = void 0;
        this.accountId = accountId;
        this.enabled = environment === 'production';
        this.ignoreErrors = ignoreErrors;
        this.packageName = packageName;
        this.packageVersion = packageVersion;
        this.product = product;
        this.sentry = sentry;
        this.client = new sentry.BrowserClient({
            attachStacktrace: true,
            autoSessionTracking: false,
            dsn: dsn,
            enabled: this.enabled,
            environment: environment,
            integrations: [],
            maxBreadcrumbs: 100,
            release: release,
            sendClientReports: true
        });
        this.unsubscribeFromRequestObservations = (0, $5rzIE.subscribeToRequestObservations)((observation)=>{
            this.breadcrumbGateway.add($0e0107334ae89504$var$requestObservationToBreadcrumb(observation));
        });
    }
}
module.exports["ConversationAssistantPrivateReporter"] = $0e0107334ae89504$export$7c63502cdfeff038;

});

parcelRegister("u3ka6", function(module, exports) {

var $fPSAz = parcelRequire("fPSAz");

const $e73c9a6ea29f4dd8$var$MAX_BREADCRUMBS = 100;
const $e73c9a6ea29f4dd8$var$MAX_MESSAGE_LENGTH = 500;
const $e73c9a6ea29f4dd8$var$MAX_DATA_VALUE_LENGTH = 200;
const $e73c9a6ea29f4dd8$var$COALESCE_WINDOW_MS = 5000;
const $e73c9a6ea29f4dd8$var$ALLOWED_DATA_KEYS = new Set([
    'action',
    'actionSubject',
    'actionSubjectId',
    'durationMs',
    'experience',
    'kind',
    'lifecycle',
    'method',
    'nextState',
    'operation',
    'outcome',
    'previousState',
    'repeatCount',
    'route',
    'screen',
    'state',
    'status',
    'surface',
    'touchpoint'
]);
const $e73c9a6ea29f4dd8$var$truncate = (value, maxLength)=>value.length > maxLength ? `${value.slice(0, maxLength - 1)}\u{2026}` : value;
const $e73c9a6ea29f4dd8$var$sanitizeString = (value, maxLength = $e73c9a6ea29f4dd8$var$MAX_DATA_VALUE_LENGTH)=>{
    const { normalized: normalized } = (0, $fPSAz.normalizeUUID)(value);
    const withoutQuery = normalized.replace(/([a-z][a-z0-9+.-]*:\/\/[^?\s]+)\?[^\s]*/gi, '$1');
    return $e73c9a6ea29f4dd8$var$truncate(withoutQuery, maxLength);
};
const $e73c9a6ea29f4dd8$var$sanitizeData = (data)=>{
    if (!data) return;
    const sanitized = Object.entries(data).reduce((result, [key, value])=>{
        if (!$e73c9a6ea29f4dd8$var$ALLOWED_DATA_KEYS.has(key) || value !== null && typeof value !== 'string' && typeof value !== 'number' && typeof value !== 'boolean') return result;
        if (typeof value === 'string') {
            const sanitizedValue = $e73c9a6ea29f4dd8$var$sanitizeString(value);
            result[key] = sanitizedValue;
        } else if (value !== null) result[key] = value;
        return result;
    }, {});
    return Object.keys(sanitized).length > 0 ? sanitized : undefined;
};
const $e73c9a6ea29f4dd8$var$sanitizeCategory = (category)=>{
    if (!category) return 'conversation-assistant.custom';
    const safeCategory = category.toLowerCase().replace(/[^a-z0-9._-]+/g, '-').slice(0, 80);
    return safeCategory.startsWith('conversation-assistant.') ? safeCategory : `conversation-assistant.${safeCategory}`;
};
const $e73c9a6ea29f4dd8$var$isCoalescable = (breadcrumb)=>breadcrumb.level === 'warning' || breadcrumb.level === 'error' || breadcrumb.category?.includes('store') === true;
class $e73c9a6ea29f4dd8$export$78d89786cb79630b {
    add(crumb) {
        const breadcrumb = this.sanitize(typeof crumb === 'string' ? {
            message: crumb
        } : crumb);
        if (!$e73c9a6ea29f4dd8$var$isCoalescable(breadcrumb)) {
            this.push(breadcrumb);
            return;
        }
        const key = JSON.stringify({
            category: breadcrumb.category,
            data: breadcrumb.data,
            level: breadcrumb.level,
            message: breadcrumb.message,
            type: breadcrumb.type
        });
        const pending = this.pendingCoalescedBreadcrumb;
        if (pending?.key === key) {
            pending.repeatCount += 1;
            return;
        }
        this.flushCoalescedSummary();
        this.push(breadcrumb);
        this.pendingCoalescedBreadcrumb = {
            key: key,
            breadcrumb: breadcrumb,
            repeatCount: 1,
            timer: setTimeout(()=>this.flushCoalescedSummary(), $e73c9a6ea29f4dd8$var$COALESCE_WINDOW_MS)
        };
    }
    snapshot() {
        this.flushCoalescedSummary();
        return this.breadcrumbs.map((breadcrumb)=>({
                ...breadcrumb,
                data: breadcrumb.data ? {
                    ...breadcrumb.data
                } : undefined
            }));
    }
    reset() {
        if (this.pendingCoalescedBreadcrumb) clearTimeout(this.pendingCoalescedBreadcrumb.timer);
        this.pendingCoalescedBreadcrumb = undefined;
        this.breadcrumbs = [];
    }
    sanitize(breadcrumb) {
        const category = $e73c9a6ea29f4dd8$var$sanitizeCategory(breadcrumb.category);
        const data = $e73c9a6ea29f4dd8$var$sanitizeData(breadcrumb.data);
        const message = typeof breadcrumb.message === 'string' ? $e73c9a6ea29f4dd8$var$sanitizeString(breadcrumb.message, $e73c9a6ea29f4dd8$var$MAX_MESSAGE_LENGTH) : undefined;
        return {
            category: category,
            data: data,
            level: breadcrumb.level,
            message: message,
            timestamp: breadcrumb.timestamp ?? Date.now() / 1000,
            type: breadcrumb.type
        };
    }
    flushCoalescedSummary() {
        const pending = this.pendingCoalescedBreadcrumb;
        if (!pending) return;
        clearTimeout(pending.timer);
        this.pendingCoalescedBreadcrumb = undefined;
        if (pending.repeatCount <= 1) return;
        this.push({
            ...pending.breadcrumb,
            data: {
                ...pending.breadcrumb.data,
                repeatCount: pending.repeatCount
            },
            message: pending.breadcrumb.message ? `${pending.breadcrumb.message} (repeated ${pending.repeatCount} times)` : `Breadcrumb repeated ${pending.repeatCount} times`,
            timestamp: Date.now() / 1000
        });
    }
    push(breadcrumb) {
        this.breadcrumbs.push(breadcrumb);
        if (this.breadcrumbs.length > $e73c9a6ea29f4dd8$var$MAX_BREADCRUMBS) this.breadcrumbs.splice(0, this.breadcrumbs.length - $e73c9a6ea29f4dd8$var$MAX_BREADCRUMBS);
    }
    constructor(){
        this.breadcrumbs = [];
        this.pendingCoalescedBreadcrumb = void 0;
    }
}
module.exports["ConversationAssistantBreadcrumbGateway"] = $e73c9a6ea29f4dd8$export$78d89786cb79630b;

});

parcelRegister("fPSAz", function(module, exports) {
const $155164db85c7fae0$var$pathnamePrefixes = [
    '/jira/',
    '/wiki/',
    '/browse/'
];
const $155164db85c7fae0$var$ATLAS_HOST = 'home.atlassian.com';
const $155164db85c7fae0$var$ATLAS_TEAM_HOST = 'team.atlassian.com';
const $155164db85c7fae0$var$UUID_REGEX = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;
const $155164db85c7fae0$export$d57ae76c6dc57a5 = (url)=>{
    try {
        let parsedUrl = new URL(url);
        let normalizedPath = '/any/';
        if (parsedUrl.host === $155164db85c7fae0$var$ATLAS_HOST || parsedUrl.host === $155164db85c7fae0$var$ATLAS_TEAM_HOST) // Replace org ID with "orgId" in the path
        normalizedPath = parsedUrl.pathname.replace(/\/o\/[^/]+/, '/o/orgId');
        const prefixRegex = new RegExp(`^(${$155164db85c7fae0$var$pathnamePrefixes.join('|')})`);
        if (prefixRegex.test(parsedUrl.pathname)) normalizedPath = parsedUrl.pathname.match(prefixRegex)[0];
        const normalizedUrl = `${parsedUrl.protocol}//${parsedUrl.host}${normalizedPath}`;
        return normalizedUrl;
    } catch (error) {
        return 'https://could-not-parse.example.com';
    }
};
const $155164db85c7fae0$export$5efaf8444170fe75 = (str)=>{
    if (!str) return {
        normalized: '',
        matchedUUIDs: []
    };
    const matchedUUIDs = str.match($155164db85c7fae0$var$UUID_REGEX) || [];
    const normalized = str.replace($155164db85c7fae0$var$UUID_REGEX, '{uuid}');
    return {
        normalized: normalized,
        matchedUUIDs: matchedUUIDs
    };
};
module.exports["normaliseUrl"] = $155164db85c7fae0$export$d57ae76c6dc57a5;
module.exports["normalizeUUID"] = $155164db85c7fae0$export$5efaf8444170fe75;

});

parcelRegister("55apF", function(module, exports) {

let $3b357f295bbe6b1c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3b357f295bbe6b1c$var$load("kT6dz"),
    $3b357f295bbe6b1c$var$load("aAWLw")
]).then(()=>parcelRequire('eieXD'));

});

parcelRegister("Ou0Zz", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7TCQz = parcelRequire("7TCQz");


var $9DHhW = parcelRequire("9DHhW");


var $iDrrr = parcelRequire("iDrrr");


var $cFVPs = parcelRequire("cFVPs");


var $hlvTd = parcelRequire("hlvTd");


var $89QZA = parcelRequire("89QZA");


var $eMlr8 = parcelRequire("eMlr8");


var $1jIs1 = parcelRequire("1jIs1");


var $nl5f2 = parcelRequire("nl5f2");

const $0fbd029e2a18e798$var$isTownSquareEvent = ()=>[
        'home.atlassian.com',
        'team.atlassian.com'
    ].some((host)=>window.location?.host?.includes(host));
const $0fbd029e2a18e798$var$DEFAULT_TAGS = [
    'atlaskit',
    'aiMate'
];
const $0fbd029e2a18e798$export$f30c856a07c48ee5 = ({ action: action, actionSubject: actionSubject, type: type })=>// message sent (client) — sendAnalyticsEvent only, no trackAIMAUEvent equivalent.
    action === 'sent' && actionSubject === 'message' || // aiMateActions displayed (client) — sendAnalyticsEvent only, no trackAIMAUEvent equivalent.
    action === 'displayed' && actionSubject === 'aiMateActions' || // aiInteraction initiated — via sendAnalyticsEvent or trackAIMAUEvent({ type: 'initiated' }).
    action === 'initiated' && actionSubject === 'aiInteraction' || type === 'initiated' || // aiResult viewed — via sendAnalyticsEvent or trackAIMAUEvent({ type: 'viewed' }).
    action === 'viewed' && actionSubject === 'aiResult' || type === 'viewed' || // aiResult actioned (client) — via sendAnalyticsEvent or trackAIMAUEvent({ type: 'actioned' }).
    action === 'actioned' && actionSubject === 'aiResult' || type === 'actioned';
const $0fbd029e2a18e798$var$getRovoJourneyEventAttributes = ({ eventPayload: eventPayload, attributes: attributes, contextRovoJourneyId: contextRovoJourneyId })=>{
    const { [(0, $eMlr8.AI_MATE_ATTRIBUTES).rovoJourneyId]: suppliedRovoJourneyId, ...attributesWithoutRovoJourneyId } = attributes;
    const rovoJourneyId = suppliedRovoJourneyId ?? contextRovoJourneyId;
    return {
        ...attributesWithoutRovoJourneyId,
        ...$0fbd029e2a18e798$export$f30c856a07c48ee5(eventPayload) && rovoJourneyId ? {
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).rovoJourneyId]: rovoJourneyId
        } : {}
    };
};
const $0fbd029e2a18e798$var$SENTRY_ANALYTICS_ATTRIBUTE_KEYS = [
    'experience',
    'nextState',
    'outcome',
    'previousState',
    'screen',
    'state',
    'surface',
    'touchpoint'
];
const $0fbd029e2a18e798$var$getSentryAnalyticsBreadcrumb = (event)=>{
    const payload = event.payload;
    const attributes = payload?.attributes ?? {};
    const safeAttributes = $0fbd029e2a18e798$var$SENTRY_ANALYTICS_ATTRIBUTE_KEYS.reduce((result, key)=>{
        const value = attributes[key];
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') result[key] = value;
        return result;
    }, {});
    return {
        category: 'analytics',
        data: {
            action: payload?.action,
            actionSubject: payload?.actionSubject,
            actionSubjectId: payload?.actionSubjectId,
            ...safeAttributes
        },
        message: [
            payload?.action,
            payload?.actionSubject,
            payload?.actionSubjectId
        ].filter(Boolean).join(' ')
    };
};
const $0fbd029e2a18e798$export$e955abb82869dc84 = (options)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { propertiesRef: propertiesRef, mode: mode } = (0, $89QZA.useAnalyticsPropertiesContext)();
    // TODO: Improve this functionality, potentially with a higher order provider for tags or similar
    // This is a temporary solution to add the 'townsquare' tag to operational events so Experience Tracker works in Atlas
    const maybeAtlasOperationalTags = (0, $cozmU.useCallback)((inputPayload)=>{
        const payload = (0, $7TCQz.isUIAnalyticsEvent)(inputPayload) ? inputPayload.payload : inputPayload;
        if (payload.actionSubject === 'ui' && payload.eventType === 'operational' && $0fbd029e2a18e798$var$isTownSquareEvent()) return [
            'townsquare'
        ];
        return [];
    }, []);
    const tagsForAIAnalytics = [
        ...$0fbd029e2a18e798$var$DEFAULT_TAGS
    ];
    if ($0fbd029e2a18e798$var$isTownSquareEvent()) tagsForAIAnalytics.push('townsquare');
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultView: trackAIResultView, trackAIResultError: trackAIResultError, trackAIInteractionDismiss: trackAIInteractionDismiss, trackAIResultAction: trackAIResultAction, trackAIResultAdopted: trackAIResultAdopted, trackAIFeedbackSubmit: trackAIFeedbackSubmit } = (0, $cFVPs.useAIEventsInstrumentation)({
        // Required configruation
        product: propertiesRef.current.product,
        subproduct: propertiesRef.current.product,
        aiFeatureName: 'aiChat',
        proactiveGeneratedAI: 0,
        userGeneratedAI: 1,
        enablePlatformEvents: true,
        tags: tagsForAIAnalytics,
        skipAISessionValidation: options?.skipAISessionValidation,
        customAnalyticsFire: (rawEvent, _createdEvent)=>{
            // Build event and apply context attributes
            const event = createAnalyticsEvent(rawEvent);
            if (!event) // In SSR / no-listener environments, `createAnalyticsEvent` can return `undefined`.
            // Nothing to fire.
            return;
            const aiMateContextAttributes = (0, $nl5f2.getAttributesFromContexts)(event.context);
            // Fire. `event.update(...)` returns `undefined` for stub events (no `<AnalyticsListener>`
            // mounted, e.g. during SSR), so fall back to the original event and guard `.fire` with
            // optional chaining.
            const updatedEvent = event.update({
                attributes: $0fbd029e2a18e798$var$getRovoJourneyEventAttributes({
                    eventPayload: event.payload ?? rawEvent,
                    attributes: {
                        ...event.payload?.attributes ?? {},
                        ...aiMateContextAttributes
                    },
                    contextRovoJourneyId: propertiesRef.current.rovoJourneyId
                })
            }) ?? event;
            updatedEvent?.fire?.((0, $1jIs1.ANALYTICS_CHANNEL));
        }
    });
    const getDefaultAttributes = (0, $cozmU.useCallback)(()=>{
        const { agentCreatorType: agentCreatorType, agentId: agentId, agentVisibility: agentVisibility, agentExternalConfigReference: agentExternalConfigReference, agentActions: agentActions, agentIsDefault: agentIsDefault, agentIsVerified: agentIsVerified, conversationChannelId: conversationChannelId, chatEntryPoint: chatEntryPoint, experienceId: experienceId, fullScreen: fullScreen, product: product, productHeader: productHeader, inProductExperience: inProductExperience, mode: mode_0, assistanceServiceConfigMinionAlias: assistanceServiceConfigMinionAlias, spaceId: spaceId, isThirdPartyPromptConversation: isThirdPartyPromptConversation, thirdPartyPromptCohort: thirdPartyPromptCohort, thirdPartyConnectCount: thirdPartyConnectCount } = propertiesRef.current;
        return {
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).agentCreatorType]: agentCreatorType,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).agentId]: agentId,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).agentVisibility]: agentVisibility,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).conversationChannelId]: conversationChannelId,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).chatEntryPoint]: chatEntryPoint,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).experienceId]: experienceId,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).fullScreen]: fullScreen,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).product]: product,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).productHeader]: productHeader,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).inProductExperience]: inProductExperience,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).singleInstrumentationID]: conversationChannelId,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).agentExternalConfigReference]: agentExternalConfigReference,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).agentActions]: agentActions,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).agentIsDefault]: agentIsDefault,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).agentIsVerified]: agentIsVerified,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).mode]: mode_0,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).assistanceServiceConfigMinionAlias]: assistanceServiceConfigMinionAlias,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).spaceId]: spaceId,
            // Gated on TRUE, not merely defined: the modal stamps `false` on every submit to clear
            // a previous 3P conversation, so a defined-check would let every later conversation
            // carry these keys with two `undefined`s.
            ...isThirdPartyPromptConversation ? {
                [(0, $eMlr8.AI_MATE_ATTRIBUTES).isThirdPartyPromptConversation]: isThirdPartyPromptConversation,
                [(0, $eMlr8.AI_MATE_ATTRIBUTES).thirdPartyPromptCohort]: thirdPartyPromptCohort,
                [(0, $eMlr8.AI_MATE_ATTRIBUTES).thirdPartyConnectCount]: thirdPartyConnectCount
            } : {}
        };
    }, [
        propertiesRef
    ]);
    const trackAIMAUEvent = (0, $cozmU.useCallback)((payload_0)=>{
        // Handle tags
        const tags = [
            ...$0fbd029e2a18e798$var$DEFAULT_TAGS
        ];
        if ($0fbd029e2a18e798$var$isTownSquareEvent()) tags.push('townsquare');
        const { source: sourceUnknown, subjectId: subjectIdUnknown, proactive: proactive, userGenerated: userGenerated, doesNotMeetMAUCriteria: doesNotMeetMAUCriteria, messageId: messageId, messageActions: messageActions, singleInstrumentationID: singleInstrumentationID, deepResearchEnabled: deepResearchEnabled, webSearchEnabled: webSearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, fastModeEnabled: fastModeEnabled, timestamp: timestamp, citedProductList: citedProductList, citedProduct: citedProduct, connectorInfo: connectorInfo, sourceProducts: sourceProducts, sourceProduct: sourceProduct, pluginsInvoked: pluginsInvoked, tools: tools, skillsInvoked: skillsInvoked, executedStratusSkill: executedStratusSkill, responseSources: responseSources, usesJsm: usesJsm, invokedFrom: invokedFrom, conversationChannelId: conversationChannelId_0, assistanceServiceConfigMinionAlias: assistanceServiceConfigMinionAlias_0, scenarioId: scenarioId, pageContext: pageContext, viewContext: viewContext, attributes: customAttributes } = payload_0;
        // source and subjectId are optional in the payload type but trackAI* functions require string.
        // The runtime value (including undefined) is intentionally passed through as-is.
        // eslint-disable-next-line @atlaskit/platform/no-double-type-assertions -- Existing analytics baseline: preserves the runtime value while satisfying a string-only downstream API type.
        const source = sourceUnknown;
        // eslint-disable-next-line @atlaskit/platform/no-double-type-assertions -- Existing analytics baseline: preserves the runtime value while satisfying a string-only downstream API type.
        const subjectId = subjectIdUnknown;
        const customAttributesRecord = customAttributes ?? {};
        const { [(0, $eMlr8.AI_MATE_ATTRIBUTES).rovoJourneyId]: customRovoJourneyId, ...customAttributesWithoutRovoJourneyId } = customAttributesRecord;
        const contextRovoJourneyId = propertiesRef.current.rovoJourneyId;
        let attributes = {
            ...getDefaultAttributes(),
            isAIFeature: 1,
            proactiveAIGenerated: proactive ? 1 : 0,
            userGeneratedAI: userGenerated ? 1 : 0,
            citedProductList: citedProductList,
            citedProduct: citedProduct,
            sourceProducts: sourceProducts,
            sourceProduct: sourceProduct,
            ...customAttributesWithoutRovoJourneyId,
            ...$0fbd029e2a18e798$export$f30c856a07c48ee5(payload_0) && (customRovoJourneyId || contextRovoJourneyId) ? {
                [(0, $eMlr8.AI_MATE_ATTRIBUTES).rovoJourneyId]: customRovoJourneyId ?? contextRovoJourneyId
            } : {},
            aiFeatureName: customAttributesRecord.aiFeatureName || 'aiChat'
        };
        if (messageId) attributes.messageId = messageId;
        if (messageActions) attributes.messageActions = messageActions;
        if (invokedFrom) attributes.invokedFrom = invokedFrom;
        if (timestamp) attributes.timestamp = timestamp;
        if (singleInstrumentationID) attributes.singleInstrumentationID = singleInstrumentationID;
        if (pluginsInvoked) attributes.pluginsInvoked = pluginsInvoked;
        if (tools) attributes.tools = tools;
        if (skillsInvoked) attributes.skillsInvoked = skillsInvoked;
        if (executedStratusSkill !== undefined) attributes.executedStratusSkill = executedStratusSkill;
        if (responseSources) attributes.responseSources = responseSources;
        if (connectorInfo && (payload_0.type === 'actioned' ? (0, $iDrrr.fg)('rovo_chat_connector_info_analytics_on_click') : (0, $iDrrr.fg)('rovo_chat_connector_info_analytics'))) attributes.connectorInfo = connectorInfo;
        if (usesJsm !== undefined) attributes.usesJsm = usesJsm;
        if (deepResearchEnabled) attributes.deepResearchEnabled = deepResearchEnabled;
        if (fastModeEnabled) attributes.fastModeEnabled = fastModeEnabled;
        if (thinkDeeperEnabled) attributes.thinkDeeperEnabled = thinkDeeperEnabled;
        if (webSearchEnabled) attributes.webSearchEnabled = webSearchEnabled;
        if (conversationChannelId_0) attributes.conversationChannelId = conversationChannelId_0;
        if (assistanceServiceConfigMinionAlias_0) attributes.assistanceServiceConfigMinionAlias = assistanceServiceConfigMinionAlias_0;
        if (pageContext) attributes.pageContext = pageContext;
        if (scenarioId) attributes.scenarioId = scenarioId;
        if (viewContext) attributes.viewContext = viewContext;
        let libAttributes = {
            ...attributes,
            aiFeatureName: customAttributesRecord.aiFeatureName || 'aiChat',
            proactiveGeneratedAI: proactive ? 1 : 0
        };
        const launchSource = propertiesRef.current.launchSource;
        const launchSourceAttribute = launchSource ? {
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).launchSource]: launchSource
        } : {};
        switch(payload_0.type){
            case 'initiated':
                trackAIInteractionInit({
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId
                });
                break;
            case 'viewed':
                trackAIResultView({
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId,
                    doesNotMeetMAUCriteria: doesNotMeetMAUCriteria
                });
                break;
            case 'error':
                trackAIResultError({
                    aiErrorMessage: payload_0.errorMessage
                }, {
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId
                });
                break;
            case 'dismissed':
                trackAIInteractionDismiss({
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId
                });
                break;
            case 'actioned':
                {
                    const actionedPayload = payload_0;
                    trackAIResultAction(actionedPayload.actionResult, {
                        attributes: {
                            ...libAttributes,
                            ...launchSourceAttribute
                        },
                        tags: tags,
                        source: source,
                        actionSubjectId: subjectId
                    });
                    break;
                }
            case 'adopted':
                {
                    const adoptedPayload = payload_0;
                    trackAIResultAdopted(adoptedPayload.actionResult, {
                        attributes: {
                            ...libAttributes,
                            actionKey: adoptedPayload.actionKey,
                            rovoModifiedObjects: adoptedPayload.rovoModifiedObjects,
                            ...launchSourceAttribute
                        },
                        tags: tags,
                        source: source,
                        actionSubjectId: subjectId
                    });
                    break;
                }
            case 'feedback':
                {
                    const feedbackPayload = payload_0;
                    trackAIFeedbackSubmit(feedbackPayload.feedbackResult, {
                        attributes: libAttributes,
                        tags: tags,
                        source: source,
                        actionSubjectId: subjectId
                    });
                    break;
                }
        }
    // Handle specific AI MAU events
    }, [
        getDefaultAttributes,
        propertiesRef,
        trackAIInteractionInit,
        trackAIResultView,
        trackAIResultError,
        trackAIInteractionDismiss,
        trackAIResultAction,
        trackAIResultAdopted,
        trackAIFeedbackSubmit
    ]);
    const sendAnalyticsEvent = (0, $cozmU.useCallback)((payload_1, options_0)=>{
        const extraTags = options_0?.removeDefaultTags ? [] : $0fbd029e2a18e798$var$DEFAULT_TAGS;
        const allTags = Array.from(new Set([
            ...extraTags,
            ...'tags' in payload_1 && Array.isArray(payload_1.tags) ? payload_1.tags : [],
            ...maybeAtlasOperationalTags(payload_1)
        ]));
        const defaultAttributes = getDefaultAttributes();
        // `UIAnalyticsEvent | undefined` because in SSR (no `<AnalyticsListener>`),
        // `createAnalyticsEvent` and `event.update(...)` may return `undefined` stubs.
        let eventToBeLoggedWithSentry;
        if ((0, $7TCQz.isUIAnalyticsEvent)(payload_1)) {
            const aiMateContextAttributes_0 = (0, $nl5f2.getAttributesFromContexts)(payload_1.context);
            // `payload.update(...)` can return `undefined` for stub events in SSR / no-listener
            // contexts. Fall back to the original event and guard `.fire` with optional chaining.
            const updatedEvent_0 = payload_1.update({
                ...payload_1.payload,
                tags: allTags,
                attributes: $0fbd029e2a18e798$var$getRovoJourneyEventAttributes({
                    eventPayload: payload_1.payload ?? {},
                    attributes: {
                        ...defaultAttributes,
                        // `payload.payload` is typed as defined on a UIAnalyticsEvent, but during SSR
                        // (and other no-listener contexts) the underlying event can be a stub whose
                        // `payload` is `undefined`. Guard the spread so the subscriber does not throw
                        // `Cannot read properties of undefined (reading 'attributes')`.
                        ...payload_1.payload?.attributes ?? {},
                        ...aiMateContextAttributes_0
                    },
                    contextRovoJourneyId: propertiesRef.current.rovoJourneyId
                })
            }) ?? payload_1;
            updatedEvent_0?.fire?.((0, $1jIs1.ANALYTICS_CHANNEL));
            eventToBeLoggedWithSentry = updatedEvent_0;
        } else {
            const event_0 = createAnalyticsEvent({
                ...payload_1,
                tags: allTags,
                attributes: $0fbd029e2a18e798$var$getRovoJourneyEventAttributes({
                    eventPayload: payload_1,
                    attributes: {
                        ...defaultAttributes,
                        ...payload_1.attributes
                    },
                    contextRovoJourneyId: propertiesRef.current.rovoJourneyId
                })
            });
            if (!event_0) // In SSR / no-listener environments, `createAnalyticsEvent` can return `undefined`.
            // Nothing to fire or log.
            return;
            const aiMateContextAttributes_1 = (0, $nl5f2.getAttributesFromContexts)(event_0.context);
            // `event.update(...)` can return `undefined` for stub events in SSR / no-listener
            // contexts (previously crashed with `Cannot read properties of undefined (reading
            // 'fire')`). Fall back to the original event and guard `.fire` with optional chaining.
            const updatedEvent_1 = event_0.update({
                attributes: $0fbd029e2a18e798$var$getRovoJourneyEventAttributes({
                    eventPayload: event_0.payload ?? payload_1,
                    attributes: {
                        // `event.payload` is normally defined when `createAnalyticsEvent` is wired up
                        // via `<AnalyticsListener>`, but in SSR (where no listener is mounted) the
                        // returned event can be a stub whose `payload` is `undefined`. Spreading
                        // without a guard previously crashed the ExperienceTracker subscriber with
                        // `Cannot read properties of undefined (reading 'attributes')`.
                        ...event_0.payload?.attributes ?? {},
                        ...aiMateContextAttributes_1
                    },
                    contextRovoJourneyId: propertiesRef.current.rovoJourneyId
                })
            }) ?? event_0;
            updatedEvent_1?.fire?.((0, $1jIs1.ANALYTICS_CHANNEL));
            eventToBeLoggedWithSentry = updatedEvent_1;
        }
        if (eventToBeLoggedWithSentry && eventToBeLoggedWithSentry.payload?.eventType !== 'operational') // choosing to log the event with Sentry if it is not an operational event to prevent noise in Sentry and not eat up the Sentry quota
        (0, $hlvTd.addSentryBreadcrumb)($0fbd029e2a18e798$var$getSentryAnalyticsBreadcrumb(eventToBeLoggedWithSentry));
    }, [
        createAnalyticsEvent,
        maybeAtlasOperationalTags,
        getDefaultAttributes,
        propertiesRef
    ]);
    return {
        sendAnalyticsEvent: sendAnalyticsEvent,
        trackAIMAUEvent: trackAIMAUEvent,
        mode: mode
    };
};
module.exports["isRovoJourneyAllowlistedEvent"] = $0fbd029e2a18e798$export$f30c856a07c48ee5;
module.exports["useAnalytics"] = $0fbd029e2a18e798$export$e955abb82869dc84;

});

parcelRegister("7TCQz", function(module, exports) {
/// <reference types="node" />

var $dgpXm = parcelRequire("dgpXm");

const $6cd011fc484d182c$export$35f8383928ba8d7 = (obj)=>obj instanceof (0, $dgpXm.default) || !!obj?._isUIAnalyticsEvent || // Backwards compatibility with older analytics-next packages
    obj?.constructor?.name === 'UIAnalyticsEvent';
module.exports["isUIAnalyticsEvent"] = $6cd011fc484d182c$export$35f8383928ba8d7;

});

parcelRegister("cFVPs", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3U8XR = parcelRequire("3U8XR");


var $iTJtk = parcelRequire("iTJtk");


var $9DHhW = parcelRequire("9DHhW");


var $jU6s6 = parcelRequire("jU6s6");


var $4dW9D = parcelRequire("4dW9D");


var $96Ikf = parcelRequire("96Ikf");


var $iCEWf = parcelRequire("iCEWf");


var $jLdbZ = parcelRequire("jLdbZ");

const $a12da25560425c44$export$ddf49ad062368ad2 = (customConfig)=>{
    let context = (0, $cozmU.useContext)((0, $jU6s6.AIEventsInstrumentationContext));
    const aiEventAttributesOverride = (0, $cozmU.useRef)({});
    if (customConfig) context = {
        config: {
            ...(0, $4dW9D.defaultAIEventsInstrumentationConfigValues),
            ...customConfig
        },
        // eslint-disable-next-line react-hooks/rules-of-hooks
        ...(0, $jLdbZ.useAIInstrumentationSetup)(customConfig.singleInstrumentationID, customConfig.cookieSingleInstrumentationConfig)
    };
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    if (context === null) throw new Error('useAIEventsInstrumentation must be used within a AIEventsInstrumentationProvider');
    const { config: { source: source, aiExperienceName: aiExperienceName, aiFeatureName: aiFeatureName, aiFeatureId: aiFeatureId, proactiveGeneratedAI: proactiveGeneratedAI, userGeneratedAI: userGeneratedAI, isAIFeature: isAIFeature, channel: channel, subproduct: subproduct, actionSubjectId: actionSubjectId, tags: tags, product: product, eventDispatcherSource: eventDispatcherSource, skipAISessionValidation: skipAISessionValidation, customAnalyticsFire: customAnalyticsFire, additionalAttributes: additionalAttributes, useDefaultGASv3EventSchema: useDefaultGASv3EventSchema, enablePlatformEvents: enablePlatformEvents }, refreshSingleInstrumentationID: refreshSingleInstrumentationID, getSingleInstrumentationID: getSingleInstrumentationID, setAISessionState: setAISessionState, getAISessionState: getAISessionState } = context;
    const validateAndUpdateAISession = (0, $cozmU.useCallback)((nextState)=>{
        const currentAISessionState = getAISessionState();
        return (0, $3U8XR.match)({
            currentState: currentAISessionState,
            nextState: nextState,
            skipAISessionValidation: skipAISessionValidation
        }).with({
            skipAISessionValidation: true
        }, ()=>true).with({
            currentState: (0, $iCEWf.AISessionState).unset,
            nextState: (0, $3U8XR.P).union((0, $iCEWf.AISessionState).viewed, (0, $iCEWf.AISessionState).error, (0, $iCEWf.AISessionState).dismissed)
        }, ()=>{
            // eslint-disable-next-line no-console
            console.error(`[@atlassian/ai-analytics]: ${nextState} event should be called only after trackAIInteractionInit()`);
            return false;
        }).with({
            currentState: (0, $iCEWf.AISessionState).initiated,
            nextState: (0, $3U8XR.P).union((0, $iCEWf.AISessionState).submitted, (0, $iCEWf.AISessionState).actioned, (0, $iCEWf.AISessionState).adopted, (0, $iCEWf.AISessionState).discarded)
        }, ()=>{
            // eslint-disable-next-line no-console
            console.error(`[@atlassian/ai-analytics]: ${nextState} event should be called only after trackAIResultView()`);
            return false;
        }).otherwise(()=>{
            setAISessionState(nextState);
            return true;
        });
    }, [
        setAISessionState,
        getAISessionState,
        skipAISessionValidation
    ]);
    const fireEventWithOptionalChannel = (0, $cozmU.useCallback)((event)=>{
        if (typeof customAnalyticsFire === 'function') {
            customAnalyticsFire(event, createAnalyticsEvent({}));
            return;
        }
        if (enablePlatformEvents) {
            // it goes thru the aiMate analytics listener to avoid validation per prodcut listener
            // https://bitbucket.org/atlassian/atlassian-frontend-mirror/src/f904f690cf57ef84acad6c7bf1b5bd90ad9cada2/analytics/analytics-listeners/src/atlaskit/process-event.ts#lines-58
            createAnalyticsEvent(event).fire((0, $iTJtk.FabricChannel).aiMate);
            return;
        }
        if (channel) {
            createAnalyticsEvent(event).fire(channel);
            return;
        }
        createAnalyticsEvent(event).fire();
    }, [
        channel,
        customAnalyticsFire,
        createAnalyticsEvent,
        enablePlatformEvents
    ]);
    const createAndMergeEventPayload = (0, $cozmU.useCallback)((payload, partialPayload)=>{
        const singleInstrumentationID = getSingleInstrumentationID();
        const eventPayload = {
            action: payload.action,
            actionSubject: payload.actionSubject,
            actionSubjectId: partialPayload?.actionSubjectId ?? actionSubjectId,
            attributes: {
                aiExperienceName: aiExperienceName,
                aiFeatureName: aiFeatureName,
                aiFeatureId: aiFeatureId,
                proactiveGeneratedAI: proactiveGeneratedAI,
                userGeneratedAI: userGeneratedAI,
                isAIFeature: isAIFeature,
                eventDispatcherSource: eventDispatcherSource,
                singleInstrumentationID: singleInstrumentationID,
                ...payload.attributes,
                ...partialPayload?.attributes,
                ...additionalAttributes,
                ...aiEventAttributesOverride.current
            }
        };
        return (0, $3U8XR.match)({
            product: product,
            channel: channel,
            useDefaultGASv3EventSchema: useDefaultGASv3EventSchema,
            enablePlatformEvents: enablePlatformEvents
        }).with({
            enablePlatformEvents: true
        }, ()=>{
            return {
                eventType: 'track',
                ...eventPayload,
                tags: (0, $96Ikf.getTagsWithPlatformTag)(tags),
                source: partialPayload?.source ?? source,
                subproduct: subproduct,
                product: product
            };
        }).with({
            product: 'confluence',
            channel: (0, $3U8XR.P).nullish,
            useDefaultGASv3EventSchema: false
        }, ()=>{
            // confluence event validation fronted logic
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/confluence/next/packages/analytics/src/analyticsListener.tsx#lines-53
            return {
                type: 'sendTrackEvent',
                data: {
                    ...eventPayload,
                    tags: partialPayload?.tags ?? tags,
                    source: partialPayload?.source ?? source,
                    subproduct: subproduct
                }
            };
        }).with({
            product: 'jira',
            channel: (0, $3U8XR.P).nullish,
            useDefaultGASv3EventSchema: false
        }, ()=>{
            // jira event validation fronted logic
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/jira/src/packages/platform/observability/product-analytics-bridge/src/utils/extract-data-from-event.tsx#lines-164
            // it requires to use no more than 4 properties on the top level of event shape for custom event fire.
            return eventPayload;
        }).otherwise(()=>{
            // for any other product type we should use the default event shape
            // also if there is a custom event channel, we also should use the default event shape
            return {
                eventType: 'track',
                ...eventPayload,
                tags: partialPayload?.tags ?? tags,
                source: partialPayload?.source ?? source,
                subproduct: subproduct,
                product: product
            };
        });
    }, [
        subproduct,
        channel,
        product,
        getSingleInstrumentationID,
        useDefaultGASv3EventSchema,
        source,
        tags,
        eventDispatcherSource,
        actionSubjectId,
        additionalAttributes,
        enablePlatformEvents,
        aiExperienceName,
        aiFeatureName,
        aiFeatureId,
        proactiveGeneratedAI,
        userGeneratedAI,
        isAIFeature
    ]);
    const trackAIInteractionInit = (0, $cozmU.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).initiated)) return;
        refreshSingleInstrumentationID(payload?.attributes?.singleInstrumentationID);
        const event = createAndMergeEventPayload({
            action: 'initiated',
            actionSubject: 'aiInteraction'
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        refreshSingleInstrumentationID,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel,
        validateAndUpdateAISession
    ]);
    const trackAIResultView = (0, $cozmU.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).viewed)) return;
        const { doesNotMeetMAUCriteria: doesNotMeetMAUCriteria, attributes: attributes, ...payloadRest } = payload || {};
        const event = createAndMergeEventPayload({
            action: 'viewed',
            actionSubject: 'aiResult'
        }, {
            ...payloadRest,
            attributes: {
                ...attributes,
                doesNotMeetMAUCriteria: !!doesNotMeetMAUCriteria
            }
        });
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultError = (0, $cozmU.useCallback)((error, payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).error)) return;
        const event = createAndMergeEventPayload({
            action: 'error',
            actionSubject: 'aiResult',
            attributes: {
                ...error
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIInteractionDismiss = (0, $cozmU.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).dismissed)) return;
        const event = createAndMergeEventPayload({
            action: 'dismissed',
            actionSubject: 'aiInteraction'
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultAction = (0, $cozmU.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).actioned)) return;
        const event = createAndMergeEventPayload({
            action: 'actioned',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultDiscarded = (0, $cozmU.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).discarded)) return;
        const event = createAndMergeEventPayload({
            action: 'discarded',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultAdopted = (0, $cozmU.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).adopted)) return;
        const event = createAndMergeEventPayload({
            action: 'adopted',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIFeedbackSubmit = (0, $cozmU.useCallback)((aiFeedbackResult, payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).submitted)) return;
        const event = createAndMergeEventPayload({
            action: 'submitted',
            actionSubject: 'aiFeedback',
            attributes: {
                aiFeedbackResult: aiFeedbackResult
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const updateAIAttributes = (0, $cozmU.useCallback)((newAttributes)=>{
        aiEventAttributesOverride.current = {
            ...aiEventAttributesOverride.current,
            ...newAttributes
        };
    }, []);
    const baseReturn = {
        updateAIAttributes: updateAIAttributes,
        trackAIInteractionInit: trackAIInteractionInit,
        trackAIResultView: trackAIResultView,
        trackAIResultError: trackAIResultError,
        trackAIResultDiscarded: trackAIResultDiscarded,
        trackAIInteractionDismiss: trackAIInteractionDismiss,
        trackAIResultAction: trackAIResultAction,
        trackAIResultAdopted: trackAIResultAdopted,
        trackAIFeedbackSubmit: trackAIFeedbackSubmit,
        refreshSingleInstrumentationID: refreshSingleInstrumentationID
    };
    return $a12da25560425c44$var$useStableMethods(baseReturn);
};
/**
 * Returns an object with the same shape as `methods`, but with every method
 * replaced by a stable wrapper that delegates to the latest version. The
 * wrappers are created once on mount; they always read the freshest closure
 * via a ref, so calls observe the same behaviour as calling the unstable
 * methods directly.
 */ function $a12da25560425c44$var$useStableMethods(methods) {
    const ref = (0, $cozmU.useRef)(methods);
    ref.current = methods;
    return (0, $cozmU.useMemo)(()=>{
        const out = {};
        for (const key of Object.keys(ref.current))out[key] = (...args)=>ref.current[key](...args);
        return out;
    // Wrappers always read from `ref.current`; no deps needed.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
module.exports["useAIEventsInstrumentation"] = $a12da25560425c44$export$ddf49ad062368ad2;

});

parcelRegister("3U8XR", function(module, exports) {
const $2d7d8e3cc345803e$var$t = Symbol.for("@ts-pattern/matcher"), $2d7d8e3cc345803e$var$e = Symbol.for("@ts-pattern/isVariadic"), $2d7d8e3cc345803e$var$n = "@ts-pattern/anonymous-select-key", $2d7d8e3cc345803e$var$r = (t)=>Boolean(t && "object" == typeof t), $2d7d8e3cc345803e$var$i = (e)=>e && !!e[$2d7d8e3cc345803e$var$t], $2d7d8e3cc345803e$var$o = (n, s, c)=>{
    if ($2d7d8e3cc345803e$var$i(n)) {
        const e = n[$2d7d8e3cc345803e$var$t](), { matched: r, selections: i } = e.match(s);
        return r && i && Object.keys(i).forEach((t)=>c(t, i[t])), r;
    }
    if ($2d7d8e3cc345803e$var$r(n)) {
        if (!$2d7d8e3cc345803e$var$r(s)) return !1;
        if (Array.isArray(n)) {
            if (!Array.isArray(s)) return !1;
            let t = [], r = [], a = [];
            for (const o of n.keys()){
                const s = n[o];
                $2d7d8e3cc345803e$var$i(s) && s[$2d7d8e3cc345803e$var$e] ? a.push(s) : a.length ? r.push(s) : t.push(s);
            }
            if (a.length) {
                if (a.length > 1) throw new Error("Pattern error: Using `...P.array(...)` several times in a single pattern is not allowed.");
                if (s.length < t.length + r.length) return !1;
                const e = s.slice(0, t.length), n = 0 === r.length ? [] : s.slice(-r.length), i = s.slice(t.length, 0 === r.length ? Infinity : -r.length);
                return t.every((t, n)=>$2d7d8e3cc345803e$var$o(t, e[n], c)) && r.every((t, e)=>$2d7d8e3cc345803e$var$o(t, n[e], c)) && (0 === a.length || $2d7d8e3cc345803e$var$o(a[0], i, c));
            }
            return n.length === s.length && n.every((t, e)=>$2d7d8e3cc345803e$var$o(t, s[e], c));
        }
        return Reflect.ownKeys(n).every((e)=>{
            const r = n[e];
            var a;
            return (e in s || $2d7d8e3cc345803e$var$i(a = r) && "optional" === a[$2d7d8e3cc345803e$var$t]().matcherType) && $2d7d8e3cc345803e$var$o(r, s[e], c);
        });
    }
    return Object.is(s, n);
}, $2d7d8e3cc345803e$var$s = (e)=>{
    var n, o, a;
    return $2d7d8e3cc345803e$var$r(e) ? $2d7d8e3cc345803e$var$i(e) ? null != (n = null == (o = (a = e[$2d7d8e3cc345803e$var$t]()).getSelectionKeys) ? void 0 : o.call(a)) ? n : [] : Array.isArray(e) ? $2d7d8e3cc345803e$var$c(e, $2d7d8e3cc345803e$var$s) : $2d7d8e3cc345803e$var$c(Object.values(e), $2d7d8e3cc345803e$var$s) : [];
}, $2d7d8e3cc345803e$var$c = (t, e)=>t.reduce((t, n)=>t.concat(e(n)), []);
function $2d7d8e3cc345803e$export$ce1e7a33533a73d9(...t) {
    if (1 === t.length) {
        const [e] = t;
        return (t)=>$2d7d8e3cc345803e$var$o(e, t, ()=>{});
    }
    if (2 === t.length) {
        const [e, n] = t;
        return $2d7d8e3cc345803e$var$o(e, n, ()=>{});
    }
    throw new Error(`isMatching wasn't given the right number of arguments: expected 1 or 2, received ${t.length}.`);
}
function $2d7d8e3cc345803e$var$u(t) {
    return Object.assign(t, {
        optional: ()=>$2d7d8e3cc345803e$var$l(t),
        and: (e)=>$2d7d8e3cc345803e$var$m(t, e),
        or: (e)=>$2d7d8e3cc345803e$var$d(t, e),
        select: (e)=>void 0 === e ? $2d7d8e3cc345803e$var$y(t) : $2d7d8e3cc345803e$var$y(e, t)
    });
}
function $2d7d8e3cc345803e$var$h(t) {
    return Object.assign(((t)=>Object.assign(t, {
            [Symbol.iterator] () {
                let n = 0;
                const r = [
                    {
                        value: Object.assign(t, {
                            [$2d7d8e3cc345803e$var$e]: !0
                        }),
                        done: !1
                    },
                    {
                        done: !0,
                        value: void 0
                    }
                ];
                return {
                    next: ()=>{
                        var t;
                        return null != (t = r[n++]) ? t : r.at(-1);
                    }
                };
            }
        }))(t), {
        optional: ()=>$2d7d8e3cc345803e$var$h($2d7d8e3cc345803e$var$l(t)),
        select: (e)=>$2d7d8e3cc345803e$var$h(void 0 === e ? $2d7d8e3cc345803e$var$y(t) : $2d7d8e3cc345803e$var$y(e, t))
    });
}
function $2d7d8e3cc345803e$var$l(e) {
    return $2d7d8e3cc345803e$var$u({
        [$2d7d8e3cc345803e$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return void 0 === t ? ($2d7d8e3cc345803e$var$s(e).forEach((t)=>r(t, void 0)), {
                        matched: !0,
                        selections: n
                    }) : {
                        matched: $2d7d8e3cc345803e$var$o(e, t, r),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$2d7d8e3cc345803e$var$s(e),
                matcherType: "optional"
            })
    });
}
const $2d7d8e3cc345803e$var$f = (t, e)=>{
    for (const n of t)if (!e(n)) return !1;
    return !0;
}, $2d7d8e3cc345803e$var$g = (t, e)=>{
    for (const [n, r] of t.entries())if (!e(r, n)) return !1;
    return !0;
};
function $2d7d8e3cc345803e$var$m(...e) {
    return $2d7d8e3cc345803e$var$u({
        [$2d7d8e3cc345803e$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return {
                        matched: e.every((e)=>$2d7d8e3cc345803e$var$o(e, t, r)),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$2d7d8e3cc345803e$var$c(e, $2d7d8e3cc345803e$var$s),
                matcherType: "and"
            })
    });
}
function $2d7d8e3cc345803e$var$d(...e) {
    return $2d7d8e3cc345803e$var$u({
        [$2d7d8e3cc345803e$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return $2d7d8e3cc345803e$var$c(e, $2d7d8e3cc345803e$var$s).forEach((t)=>r(t, void 0)), {
                        matched: e.some((e)=>$2d7d8e3cc345803e$var$o(e, t, r)),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$2d7d8e3cc345803e$var$c(e, $2d7d8e3cc345803e$var$s),
                matcherType: "or"
            })
    });
}
function $2d7d8e3cc345803e$var$p(e) {
    return {
        [$2d7d8e3cc345803e$var$t]: ()=>({
                match: (t)=>({
                        matched: Boolean(e(t))
                    })
            })
    };
}
function $2d7d8e3cc345803e$var$y(...e) {
    const r = "string" == typeof e[0] ? e[0] : void 0, i = 2 === e.length ? e[1] : "string" == typeof e[0] ? void 0 : e[0];
    return $2d7d8e3cc345803e$var$u({
        [$2d7d8e3cc345803e$var$t]: ()=>({
                match: (t)=>{
                    let e = {
                        [null != r ? r : $2d7d8e3cc345803e$var$n]: t
                    };
                    return {
                        matched: void 0 === i || $2d7d8e3cc345803e$var$o(i, t, (t, n)=>{
                            e[t] = n;
                        }),
                        selections: e
                    };
                },
                getSelectionKeys: ()=>[
                        null != r ? r : $2d7d8e3cc345803e$var$n
                    ].concat(void 0 === i ? [] : $2d7d8e3cc345803e$var$s(i))
            })
    });
}
function $2d7d8e3cc345803e$var$v(t) {
    return "number" == typeof t;
}
function $2d7d8e3cc345803e$var$b(t) {
    return "string" == typeof t;
}
function $2d7d8e3cc345803e$var$w(t) {
    return "bigint" == typeof t;
}
const $2d7d8e3cc345803e$var$S = $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
    return !0;
})), $2d7d8e3cc345803e$var$O = $2d7d8e3cc345803e$var$S, $2d7d8e3cc345803e$var$j = (t)=>Object.assign($2d7d8e3cc345803e$var$u(t), {
        startsWith: (e)=>{
            var n;
            return $2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, (n = e, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$b(t) && t.startsWith(n)))));
        },
        endsWith: (e)=>{
            var n;
            return $2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, (n = e, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$b(t) && t.endsWith(n)))));
        },
        minLength: (e)=>$2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$b(e) && e.length >= t))(e))),
        length: (e)=>$2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$b(e) && e.length === t))(e))),
        maxLength: (e)=>$2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$b(e) && e.length <= t))(e))),
        includes: (e)=>{
            var n;
            return $2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, (n = e, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$b(t) && t.includes(n)))));
        },
        regex: (e)=>{
            var n;
            return $2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, (n = e, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$b(t) && Boolean(t.match(n))))));
        }
    }), $2d7d8e3cc345803e$var$K = $2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$p($2d7d8e3cc345803e$var$b)), $2d7d8e3cc345803e$var$x = (t)=>Object.assign($2d7d8e3cc345803e$var$u(t), {
        between: (e, n)=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, ((t, e)=>$2d7d8e3cc345803e$var$p((n)=>$2d7d8e3cc345803e$var$v(n) && t <= n && e >= n))(e, n))),
        lt: (e)=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$v(e) && e < t))(e))),
        gt: (e)=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$v(e) && e > t))(e))),
        lte: (e)=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$v(e) && e <= t))(e))),
        gte: (e)=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$v(e) && e >= t))(e))),
        int: ()=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$v(t) && Number.isInteger(t)))),
        finite: ()=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$v(t) && Number.isFinite(t)))),
        positive: ()=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$v(t) && t > 0))),
        negative: ()=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$v(t) && t < 0)))
    }), $2d7d8e3cc345803e$var$E = $2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$p($2d7d8e3cc345803e$var$v)), $2d7d8e3cc345803e$var$A = (t)=>Object.assign($2d7d8e3cc345803e$var$u(t), {
        between: (e, n)=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, ((t, e)=>$2d7d8e3cc345803e$var$p((n)=>$2d7d8e3cc345803e$var$w(n) && t <= n && e >= n))(e, n))),
        lt: (e)=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$w(e) && e < t))(e))),
        gt: (e)=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$w(e) && e > t))(e))),
        lte: (e)=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$w(e) && e <= t))(e))),
        gte: (e)=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$w(e) && e >= t))(e))),
        positive: ()=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$w(t) && t > 0))),
        negative: ()=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$w(t) && t < 0)))
    }), $2d7d8e3cc345803e$var$P = $2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$p($2d7d8e3cc345803e$var$w)), $2d7d8e3cc345803e$var$T = $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
    return "boolean" == typeof t;
})), $2d7d8e3cc345803e$var$B = $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
    return "symbol" == typeof t;
})), $2d7d8e3cc345803e$var$_ = $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
    return null == t;
})), $2d7d8e3cc345803e$var$k = $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
    return null != t;
}));
var $2d7d8e3cc345803e$export$56c0d5a1e737357d = {
    __proto__: null,
    matcher: $2d7d8e3cc345803e$var$t,
    optional: $2d7d8e3cc345803e$var$l,
    array: function(...e) {
        return $2d7d8e3cc345803e$var$h({
            [$2d7d8e3cc345803e$var$t]: ()=>({
                    match: (t)=>{
                        if (!Array.isArray(t)) return {
                            matched: !1
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        const n = e[0];
                        let r = {};
                        if (0 === t.length) return $2d7d8e3cc345803e$var$s(n).forEach((t)=>{
                            r[t] = [];
                        }), {
                            matched: !0,
                            selections: r
                        };
                        const i = (t, e)=>{
                            r[t] = (r[t] || []).concat([
                                e
                            ]);
                        };
                        return {
                            matched: t.every((t)=>$2d7d8e3cc345803e$var$o(n, t, i)),
                            selections: r
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : $2d7d8e3cc345803e$var$s(e[0])
                })
        });
    },
    set: function(...e) {
        return $2d7d8e3cc345803e$var$u({
            [$2d7d8e3cc345803e$var$t]: ()=>({
                    match: (t)=>{
                        if (!(t instanceof Set)) return {
                            matched: !1
                        };
                        let n = {};
                        if (0 === t.size) return {
                            matched: !0,
                            selections: n
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        const r = (t, e)=>{
                            n[t] = (n[t] || []).concat([
                                e
                            ]);
                        }, i = e[0];
                        return {
                            matched: $2d7d8e3cc345803e$var$f(t, (t)=>$2d7d8e3cc345803e$var$o(i, t, r)),
                            selections: n
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : $2d7d8e3cc345803e$var$s(e[0])
                })
        });
    },
    map: function(...e) {
        return $2d7d8e3cc345803e$var$u({
            [$2d7d8e3cc345803e$var$t]: ()=>({
                    match: (t)=>{
                        if (!(t instanceof Map)) return {
                            matched: !1
                        };
                        let n = {};
                        if (0 === t.size) return {
                            matched: !0,
                            selections: n
                        };
                        const r = (t, e)=>{
                            n[t] = (n[t] || []).concat([
                                e
                            ]);
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        var i;
                        if (1 === e.length) throw new Error(`\`P.map\` wasn't given enough arguments. Expected (key, value), received ${null == (i = e[0]) ? void 0 : i.toString()}`);
                        const [s, c] = e;
                        return {
                            matched: $2d7d8e3cc345803e$var$g(t, (t, e)=>{
                                const n = $2d7d8e3cc345803e$var$o(s, e, r), i = $2d7d8e3cc345803e$var$o(c, t, r);
                                return n && i;
                            }),
                            selections: n
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : [
                            ...$2d7d8e3cc345803e$var$s(e[0]),
                            ...$2d7d8e3cc345803e$var$s(e[1])
                        ]
                })
        });
    },
    intersection: $2d7d8e3cc345803e$var$m,
    union: $2d7d8e3cc345803e$var$d,
    not: function(e) {
        return $2d7d8e3cc345803e$var$u({
            [$2d7d8e3cc345803e$var$t]: ()=>({
                    match: (t)=>({
                            matched: !$2d7d8e3cc345803e$var$o(e, t, ()=>{})
                        }),
                    getSelectionKeys: ()=>[],
                    matcherType: "not"
                })
        });
    },
    when: $2d7d8e3cc345803e$var$p,
    select: $2d7d8e3cc345803e$var$y,
    any: $2d7d8e3cc345803e$var$S,
    _: $2d7d8e3cc345803e$var$O,
    string: $2d7d8e3cc345803e$var$K,
    number: $2d7d8e3cc345803e$var$E,
    bigint: $2d7d8e3cc345803e$var$P,
    boolean: $2d7d8e3cc345803e$var$T,
    symbol: $2d7d8e3cc345803e$var$B,
    nullish: $2d7d8e3cc345803e$var$_,
    nonNullable: $2d7d8e3cc345803e$var$k,
    instanceOf: function(t) {
        return $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
            return (e)=>e instanceof t;
        }(t)));
    },
    shape: function(t) {
        return $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p($2d7d8e3cc345803e$export$ce1e7a33533a73d9(t)));
    }
};
class $2d7d8e3cc345803e$export$6c1467edb54d3773 extends Error {
    constructor(t){
        let e;
        try {
            e = JSON.stringify(t);
        } catch (n) {
            e = t;
        }
        super(`Pattern matching error: no pattern matches value ${e}`), this.input = void 0, this.input = t;
    }
}
const $2d7d8e3cc345803e$var$$ = {
    matched: !1,
    value: void 0
};
function $2d7d8e3cc345803e$export$4659b591c19bdf3d(t) {
    return new $2d7d8e3cc345803e$var$I(t, $2d7d8e3cc345803e$var$$);
}
class $2d7d8e3cc345803e$var$I {
    with(...t) {
        if (this.state.matched) return this;
        const e = t[t.length - 1], r = [
            t[0]
        ];
        let i;
        3 === t.length && "function" == typeof t[1] ? i = t[1] : t.length > 2 && r.push(...t.slice(1, t.length - 1));
        let s = !1, c = {};
        const a = (t, e)=>{
            s = !0, c[t] = e;
        }, u = !r.some((t)=>$2d7d8e3cc345803e$var$o(t, this.input, a)) || i && !Boolean(i(this.input)) ? $2d7d8e3cc345803e$var$$ : {
            matched: !0,
            value: e(s ? $2d7d8e3cc345803e$var$n in c ? c[$2d7d8e3cc345803e$var$n] : c : this.input, this.input)
        };
        return new $2d7d8e3cc345803e$var$I(this.input, u);
    }
    when(t, e) {
        if (this.state.matched) return this;
        const n = Boolean(t(this.input));
        return new $2d7d8e3cc345803e$var$I(this.input, n ? {
            matched: !0,
            value: e(this.input, this.input)
        } : $2d7d8e3cc345803e$var$$);
    }
    otherwise(t) {
        return this.state.matched ? this.state.value : t(this.input);
    }
    exhaustive(t = $2d7d8e3cc345803e$var$L) {
        return this.state.matched ? this.state.value : t(this.input);
    }
    run() {
        return this.exhaustive();
    }
    returnType() {
        return this;
    }
    narrow() {
        return this;
    }
    constructor(t, e){
        this.input = void 0, this.state = void 0, this.input = t, this.state = e;
    }
}
function $2d7d8e3cc345803e$var$L(t) {
    throw new $2d7d8e3cc345803e$export$6c1467edb54d3773(t);
}
 //# sourceMappingURL=index.js.map
module.exports["P"] = $2d7d8e3cc345803e$export$56c0d5a1e737357d;
module.exports["match"] = $2d7d8e3cc345803e$export$4659b591c19bdf3d;

});

parcelRegister("jU6s6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $1f90c1a79bae927c$export$4f059feb37b5835e = (0, $cozmU.createContext)(null);
module.exports["AIEventsInstrumentationContext"] = $1f90c1a79bae927c$export$4f059feb37b5835e;

});

parcelRegister("4dW9D", function(module, exports) {

var $iCEWf = parcelRequire("iCEWf");

const $7545c0c100898f47$export$5013b36eeed4ec19 = {
    isAIFeature: 1,
    actionSubjectId: 'client',
    eventDispatcherSource: (0, $iCEWf.EventDispatcherSources).JSLib,
    skipAISessionValidation: false,
    useDefaultGASv3EventSchema: false,
    enablePlatformEvents: false
};
module.exports["defaultAIEventsInstrumentationConfigValues"] = $7545c0c100898f47$export$5013b36eeed4ec19;

});

parcelRegister("iCEWf", function(module, exports) {
var $d6416e2c87d11da8$export$af92e0e920a45719 = /*#__PURE__*/ function(AISessionState) {
    AISessionState["unset"] = "[AIInteraction]:UNSET";
    AISessionState["initiated"] = "[AIInteraction]:INITIATED";
    AISessionState["viewed"] = "[AIInteraction]:VIEWED";
    AISessionState["error"] = "[AIInteraction]:ERROR";
    AISessionState["dismissed"] = "[AIInteraction]:DISMISSED";
    AISessionState["actioned"] = "[AIInteraction]:ACTIONED";
    AISessionState["adopted"] = "[AIInteraction]:ADOPTED";
    AISessionState["discarded"] = "[AIInteraction]:DISCARDED";
    AISessionState["submitted"] = "[AIInteraction]:SUBMITTED";
    return AISessionState;
}({});
var $d6416e2c87d11da8$export$7052d5b66e36f60f = /*#__PURE__*/ function(EventDispatcherSources) {
    EventDispatcherSources["JSLib"] = "name:@atlassian/ai-analytics|language:javascript";
    return EventDispatcherSources;
}({});
module.exports["AISessionState"] = $d6416e2c87d11da8$export$af92e0e920a45719;
module.exports["EventDispatcherSources"] = $d6416e2c87d11da8$export$7052d5b66e36f60f;

});

parcelRegister("96Ikf", function(module, exports) {
const $3836d38b50a38c42$export$e053e424fcbfebe9 = (tags)=>{
    const defaultTags = [
        'atlaskit'
    ];
    if (!tags) return defaultTags;
    return defaultTags.concat(tags);
};
module.exports["getTagsWithPlatformTag"] = $3836d38b50a38c42$export$e053e424fcbfebe9;

});

parcelRegister("jLdbZ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1r1cI = parcelRequire("1r1cI");


var $7mJer = parcelRequire("7mJer");


var $iCEWf = parcelRequire("iCEWf");

const $e5d5cfe1f6d4c858$export$259576f4e7ac6488 = (customSingleInstrumentationIDFromUserConfig, cookieSingleInstrumentationConfig)=>{
    const singleInstrumentationIDRef = (0, $cozmU.useRef)(undefined);
    const aiSessionStateRef = (0, $cozmU.useRef)((0, $iCEWf.AISessionState).unset);
    const setAISessionState = (0, $cozmU.useCallback)((nextState)=>{
        aiSessionStateRef.current = nextState;
    }, []);
    const getAISessionState = (0, $cozmU.useCallback)(()=>{
        return aiSessionStateRef.current;
    }, []);
    const refreshSingleInstrumentationID = (0, $cozmU.useCallback)((customSingleInstrumentationIDFromEvent)=>{
        const nextSingleInstrumentationID = (0, $1r1cI.getNewSingleInstrumentationID)(customSingleInstrumentationIDFromEvent, customSingleInstrumentationIDFromUserConfig);
        singleInstrumentationIDRef.current = nextSingleInstrumentationID;
        if (cookieSingleInstrumentationConfig) (0, $7mJer.setSingleInstrumentationIDCookie)(cookieSingleInstrumentationConfig.uniqueCookieFeatureName, nextSingleInstrumentationID);
    }, [
        customSingleInstrumentationIDFromUserConfig,
        cookieSingleInstrumentationConfig
    ]);
    const getSingleInstrumentationID = (0, $cozmU.useCallback)(()=>{
        // this handles a race condition when we have a new singleInstrumentationID from the user config
        // but Provider knows only about the initial singleInstrumentationID. In this case we need to update
        // singleInstrumentationID at first step and then return a new one.
        if (customSingleInstrumentationIDFromUserConfig && customSingleInstrumentationIDFromUserConfig !== singleInstrumentationIDRef.current) {
            refreshSingleInstrumentationID();
            return singleInstrumentationIDRef.current;
        }
        if (cookieSingleInstrumentationConfig) return (0, $7mJer.readSingleInstrumentationIDCookie)(cookieSingleInstrumentationConfig.uniqueCookieFeatureName);
        return singleInstrumentationIDRef.current;
    }, [
        customSingleInstrumentationIDFromUserConfig,
        cookieSingleInstrumentationConfig,
        refreshSingleInstrumentationID
    ]);
    return {
        refreshSingleInstrumentationID: refreshSingleInstrumentationID,
        getSingleInstrumentationID: getSingleInstrumentationID,
        setAISessionState: setAISessionState,
        getAISessionState: getAISessionState
    };
};
module.exports["useAIInstrumentationSetup"] = $e5d5cfe1f6d4c858$export$259576f4e7ac6488;

});

parcelRegister("1r1cI", function(module, exports) {

var $3U8XR = parcelRequire("3U8XR");


var $03RpJ = parcelRequire("03RpJ");

function $d83e4e74e28b2b37$export$cee2a1482be61648(customSingleInstrumentationIDFromEvent, customSingleInstrumentationIDFromUserConfig) {
    // priority for setting singleInstrumentationID override rule
    // 1. from consumer event attribute
    // 2. from consumer configuration
    // 3. from cookie lib
    // 4. default behaviour generates through the crypto API
    return (0, $3U8XR.match)({
        customSingleInstrumentationIDFromEvent: customSingleInstrumentationIDFromEvent,
        customSingleInstrumentationIDFromUserConfig: customSingleInstrumentationIDFromUserConfig
    }).with({
        customSingleInstrumentationIDFromEvent: (0, $3U8XR.P).string
    }, (result)=>result.customSingleInstrumentationIDFromEvent).with({
        customSingleInstrumentationIDFromUserConfig: (0, $3U8XR.P).string
    }, (result)=>result.customSingleInstrumentationIDFromUserConfig)// we can't use the crypto API in the browser due to SSR issues?
    // https://atlassian.slack.com/archives/C051ARA9QGH/p1749587419868869
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    .otherwise(()=>(0, $03RpJ.default)());
}
module.exports["getNewSingleInstrumentationID"] = $d83e4e74e28b2b37$export$cee2a1482be61648;

});

parcelRegister("7mJer", function(module, exports) {

var $1Qi0Q = parcelRequire("1Qi0Q");

var $lnexi = parcelRequire("lnexi");

const $0ca840bf5f9ee98d$export$72d8c154d3f75075 = 'SINGLE_INSTRUMENTATION_ID_IS_NOT_SET';
const $0ca840bf5f9ee98d$export$35ae1861d13fb6c8 = (uniqueCookieFeatureName)=>`AI_INSTRUMENTATION_FEATURE_ID_${uniqueCookieFeatureName}`;
const $0ca840bf5f9ee98d$export$9a4eaf99327c19fe = (uniqueCookieFeatureName, nextSingleInstrumentationID)=>(0, $lnexi.setCookie)($0ca840bf5f9ee98d$export$35ae1861d13fb6c8(uniqueCookieFeatureName), nextSingleInstrumentationID, {
        expires: 7,
        domain: location.hostname,
        sameSite: 'strict'
    });
const $0ca840bf5f9ee98d$export$d6fb1caea334c7c7 = (uniqueCookieFeatureName)=>(0, $1Qi0Q.getCookie)($0ca840bf5f9ee98d$export$35ae1861d13fb6c8(uniqueCookieFeatureName)) || $0ca840bf5f9ee98d$export$72d8c154d3f75075;
module.exports["setSingleInstrumentationIDCookie"] = $0ca840bf5f9ee98d$export$9a4eaf99327c19fe;
module.exports["readSingleInstrumentationIDCookie"] = $0ca840bf5f9ee98d$export$d6fb1caea334c7c7;

});

parcelRegister("89QZA", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $gBjHb = parcelRequire("gBjHb");

const $87e579b14b793016$var$initialState = {
    conversationChannelId: '',
    chatEntryPoint: undefined,
    experienceId: '',
    product: '',
    productHeader: '',
    inProductExperience: '',
    agentId: null,
    agentExternalConfigReference: null,
    agentActions: [],
    agentIsDefault: null,
    agentIsVerified: null,
    fullScreen: false,
    agentCreatorType: '',
    agentVisibility: '',
    singleInstrumentationID: '',
    mode: undefined
};
const $87e579b14b793016$var$AnalyticsPropertiesContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    propertiesRef: {
        current: {
            ...$87e579b14b793016$var$initialState
        }
    },
    mode: undefined,
    setAnalyticsPropertiesWithoutRerender: ()=>{}
});
const $87e579b14b793016$export$5ae3634fdb64882c = /*#__PURE__*/ (0, $cozmU.createContext)({
    sharedFeaturesInstrumentationId: undefined,
    isInSmartCreateFlow: undefined
});
const $87e579b14b793016$export$1aefd27d2ed3c1c9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { children: children, mode: mode, launchSource: launchSource, rovoJourneyId: rovoJourneyId } = t0;
    let t1;
    if ($[0] !== launchSource || $[1] !== rovoJourneyId) {
        t1 = {
            ...$87e579b14b793016$var$initialState,
            launchSource: launchSource,
            rovoJourneyId: rovoJourneyId
        };
        $[0] = launchSource;
        $[1] = rovoJourneyId;
        $[2] = t1;
    } else t1 = $[2];
    const propertiesRef = (0, $cozmU.useRef)(t1);
    let t2;
    let t3;
    if ($[3] !== launchSource) {
        t2 = ()=>{
            propertiesRef.current.launchSource = launchSource;
        };
        t3 = [
            launchSource
        ];
        $[3] = launchSource;
        $[4] = t2;
        $[5] = t3;
    } else {
        t2 = $[4];
        t3 = $[5];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    let t5;
    if ($[6] !== rovoJourneyId) {
        t4 = ()=>{
            propertiesRef.current.rovoJourneyId = rovoJourneyId;
        };
        t5 = [
            rovoJourneyId
        ];
        $[6] = rovoJourneyId;
        $[7] = t4;
        $[8] = t5;
    } else {
        t4 = $[7];
        t5 = $[8];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (properties)=>{
            propertiesRef.current = {
                ...propertiesRef.current,
                ...properties
            };
        };
        $[9] = t6;
    } else t6 = $[9];
    const setAnalyticsPropertiesWithoutRerender = t6;
    let t7;
    if ($[10] !== mode) {
        t7 = {
            propertiesRef: propertiesRef,
            mode: mode,
            setAnalyticsPropertiesWithoutRerender: setAnalyticsPropertiesWithoutRerender
        };
        $[10] = mode;
        $[11] = t7;
    } else t7 = $[11];
    const value = t7;
    let t8;
    if ($[12] !== children || $[13] !== value) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87e579b14b793016$var$AnalyticsPropertiesContext.Provider, {
            value: value
        }, children);
        $[12] = children;
        $[13] = value;
        $[14] = t8;
    } else t8 = $[14];
    return t8;
} : ({ children: children, mode: mode, launchSource: launchSource, rovoJourneyId: rovoJourneyId })=>{
    const propertiesRef = (0, $cozmU.useRef)({
        ...$87e579b14b793016$var$initialState,
        launchSource: launchSource,
        rovoJourneyId: rovoJourneyId
    });
    // Sync the (possibly late/changing) prop into the ref after commit, so concurrent
    // renders that are paused or discarded never leak an uncommitted launch source.
    (0, $cozmU.useEffect)(()=>{
        propertiesRef.current.launchSource = launchSource;
    }, [
        launchSource
    ]);
    (0, $cozmU.useEffect)(()=>{
        propertiesRef.current.rovoJourneyId = rovoJourneyId;
    }, [
        rovoJourneyId
    ]);
    const setAnalyticsPropertiesWithoutRerender = (0, $cozmU.useCallback)((properties)=>{
        propertiesRef.current = {
            ...propertiesRef.current,
            ...properties
        };
    }, []);
    const value = (0, $cozmU.useMemo)(()=>({
            propertiesRef: propertiesRef,
            mode: mode,
            setAnalyticsPropertiesWithoutRerender: setAnalyticsPropertiesWithoutRerender
        }), [
        setAnalyticsPropertiesWithoutRerender,
        mode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87e579b14b793016$var$AnalyticsPropertiesContext.Provider, {
        value: value
    }, children);
};
const $87e579b14b793016$export$a00cd3c213413389 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { source: source, sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId, iframeHostProduct: iframeHostProduct, children: children, mode: mode, isAlwaysInSmartCreateFlow: isAlwaysInSmartCreateFlow, launchSource: launchSource, rovoJourneyId: rovoJourneyId } = t0;
    const { sharedFeaturesInstrumentationId: parentSharedFeaturesInstrumentationId, isInSmartCreateFlow: parentIsInSmartCreateFlow } = (0, $cozmU.useContext)($87e579b14b793016$export$5ae3634fdb64882c);
    const isInSmartCreateFlow = isAlwaysInSmartCreateFlow === undefined ? parentIsInSmartCreateFlow : isAlwaysInSmartCreateFlow;
    const t1 = sharedFeaturesInstrumentationId ?? parentSharedFeaturesInstrumentationId;
    let t2;
    if ($[0] !== iframeHostProduct || $[1] !== isInSmartCreateFlow || $[2] !== t1) {
        t2 = {
            sharedFeaturesInstrumentationId: t1,
            isInSmartCreateFlow: isInSmartCreateFlow,
            iframeHostProduct: iframeHostProduct
        };
        $[0] = iframeHostProduct;
        $[1] = isInSmartCreateFlow;
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== source || $[5] !== t2) {
        t3 = {
            source: source,
            attributes: t2
        };
        $[4] = source;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    const data = t3;
    const t4 = sharedFeaturesInstrumentationId ?? parentSharedFeaturesInstrumentationId;
    let t5;
    if ($[7] !== isInSmartCreateFlow || $[8] !== t4) {
        t5 = {
            sharedFeaturesInstrumentationId: t4,
            isInSmartCreateFlow: isInSmartCreateFlow
        };
        $[7] = isInSmartCreateFlow;
        $[8] = t4;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== children || $[11] !== launchSource || $[12] !== mode || $[13] !== rovoJourneyId) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87e579b14b793016$export$1aefd27d2ed3c1c9, {
            mode: mode,
            launchSource: launchSource,
            rovoJourneyId: rovoJourneyId
        }, children);
        $[10] = children;
        $[11] = launchSource;
        $[12] = mode;
        $[13] = rovoJourneyId;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== t5 || $[16] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87e579b14b793016$export$5ae3634fdb64882c.Provider, {
            value: t5
        }, t6);
        $[15] = t5;
        $[16] = t6;
        $[17] = t7;
    } else t7 = $[17];
    let t8;
    if ($[18] !== data || $[19] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
            data: data
        }, t7);
        $[18] = data;
        $[19] = t7;
        $[20] = t8;
    } else t8 = $[20];
    return t8;
} : ({ source: source, sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId, iframeHostProduct: iframeHostProduct, children: children, mode: mode, isAlwaysInSmartCreateFlow: isAlwaysInSmartCreateFlow, launchSource: launchSource, rovoJourneyId: rovoJourneyId })=>{
    const { sharedFeaturesInstrumentationId: parentSharedFeaturesInstrumentationId, isInSmartCreateFlow: parentIsInSmartCreateFlow } = (0, $cozmU.useContext)($87e579b14b793016$export$5ae3634fdb64882c);
    const isInSmartCreateFlow = isAlwaysInSmartCreateFlow === undefined ? parentIsInSmartCreateFlow : isAlwaysInSmartCreateFlow;
    const data = (0, $cozmU.useMemo)(()=>({
            source: source,
            attributes: {
                sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId ?? parentSharedFeaturesInstrumentationId,
                isInSmartCreateFlow: isInSmartCreateFlow,
                iframeHostProduct: iframeHostProduct
            }
        }), [
        source,
        sharedFeaturesInstrumentationId,
        parentSharedFeaturesInstrumentationId,
        isInSmartCreateFlow,
        iframeHostProduct
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
        data: data
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87e579b14b793016$export$5ae3634fdb64882c.Provider, {
        value: {
            sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId ?? parentSharedFeaturesInstrumentationId,
            isInSmartCreateFlow: isInSmartCreateFlow
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87e579b14b793016$export$1aefd27d2ed3c1c9, {
        mode: mode,
        launchSource: launchSource,
        rovoJourneyId: rovoJourneyId
    }, children)));
};
const $87e579b14b793016$export$ab8aa3dfd687f012 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($87e579b14b793016$var$AnalyticsPropertiesContext);
} : ()=>{
    return (0, $cozmU.useContext)($87e579b14b793016$var$AnalyticsPropertiesContext);
};
module.exports["SharedFeaturesInstrumentationIdContext"] = $87e579b14b793016$export$5ae3634fdb64882c;
module.exports["AnalyticsContextWithSourceAndProperties"] = $87e579b14b793016$export$a00cd3c213413389;
module.exports["useAnalyticsPropertiesContext"] = $87e579b14b793016$export$ab8aa3dfd687f012;

});

parcelRegister("eMlr8", function(module, exports) {
/**
 * NOTE: Some of these fields are used to track AI MAU
 * See this page for more details: https://hello.atlassian.net/wiki/spaces/AAI/pages/3770721410/Unified+event+Instrumentation+for+AI
 */ const $49f89fe5a40ece12$export$8cffc8b2c93affd4 = {
    agentCreatorType: 'agentCreatorType',
    agentId: 'agentId',
    agentVisibility: 'agentVisibility',
    agentExternalConfigReference: 'agentExternalConfigReference',
    agentActions: 'agentActions',
    agentIsDefault: 'agentIsDefault',
    agentIsVerified: 'agentIsVerified',
    conversationChannelId: 'conversationChannelId',
    chatEntryPoint: 'chatEntryPoint',
    experienceId: 'experienceId',
    fullScreen: 'fullScreen',
    mode: 'mode',
    product: 'product',
    productHeader: 'productHeader',
    inProductExperience: 'inProductExperience',
    singleInstrumentationID: 'singleInstrumentationID',
    sharedFeaturesInstrumentationId: 'sharedFeaturesInstrumentationId',
    assistanceServiceConfigMinionAlias: 'assistanceServiceConfigMinionAlias',
    skillSelectionSource: 'skillSelectionSource',
    // The Rovo Space a chat is scoped to (when any). Set on every event fired
    // while a space-scoped chat is active so "Space MAU" (unique users who
    // initiate a chat in a space) can be measured downstream.
    spaceId: 'spaceId',
    // Source surface that launched the conversation; emitted on result events only.
    // Runtime-validated against the launch-source allowlists at the pubsub boundary, so
    // only closed-vocabulary values ever reach analytics despite FollowUpSource's
    // `| string` fallback.
    launchSource: 'launchSource',
    // Quick Find-to-Chat journey correlation. Emitted only on the five funnel events
    // allowlisted by the analytics controller while the attributed conversation is active.
    rovoJourneyId: 'rovoJourneyId',
    // Set once a conversation is started from a third-party suggested prompt in the
    // Create-with-Rovo modal, so downstream events the 3P experiment does not own
    // (`message/sent`, `adopted/contentFinalized`) can be segmented by cohort.
    isThirdPartyPromptConversation: 'isThirdPartyPromptConversation',
    thirdPartyPromptCohort: 'thirdPartyPromptCohort',
    // Third-party apps connected from the in-thread connect prompt so far in this
    // conversation, so a later message can be read as post-connect without a join.
    thirdPartyConnectCount: 'thirdPartyConnectCount'
};
module.exports["AI_MATE_ATTRIBUTES"] = $49f89fe5a40ece12$export$8cffc8b2c93affd4;

});

parcelRegister("1jIs1", function(module, exports) {

var $iTJtk = parcelRequire("iTJtk");

const $70c81957c9ee94b4$export$85183a312807388d = (0, $iTJtk.FabricChannel).aiMate;
const $70c81957c9ee94b4$var$REMIX_SOURCES = [
    'remix',
    'inlineRovoFromRemix',
    'remixModalFromToolbar',
    'remixModalFromBlockControls',
    'remixModalFromBlockMenu',
    'remixModalFromFloatingToolbar',
    'remixModalFromViewPageFloatingToolbar',
    'remixModalFromViewPageNudge',
    'remixModalFromNudge',
    'remixModalFromObjectLevelSidebar',
    'remixModalFromPasteMenu',
    'remixStagingArea',
    'remixModalFromMediaInserts'
];
const $70c81957c9ee94b4$export$e86f3aae41de8a7 = 'smartLinkRovoButton';
const $70c81957c9ee94b4$export$5a1bc70923e441e9 = new Set($70c81957c9ee94b4$var$REMIX_SOURCES);
const $70c81957c9ee94b4$export$c576fc434c88316f = new Set([
    'automation-discovery-meeting-notes-nudge',
    'automation-discovery-archive-page-nudge',
    'automation-discovery-status-updates-nudge',
    'automation-discovery-keep-up-to-date-dropdown-action',
    'automation-discovery-custom-prompt-dropdown-action',
    'jiraListChildCreateRovo',
    'jiraTimelineChildCreateRovo',
    'jsmSurveyAggregatedInsights',
    'recommendation-card-nudge'
]);
const $70c81957c9ee94b4$export$c377c6e02c795ae4 = new Set([
    'jiraAddViewCreateWithRovo'
]);
const $70c81957c9ee94b4$export$f57fd972b3024068 = (value, includeGatedLaunchSources = false)=>value !== undefined && ($70c81957c9ee94b4$export$c576fc434c88316f.has(value) || includeGatedLaunchSources && $70c81957c9ee94b4$export$c377c6e02c795ae4.has(value));
var $70c81957c9ee94b4$export$406073150b1a408 = /*#__PURE__*/ function(AUTOSUGGEST_SOURCE) {
    AUTOSUGGEST_SOURCE["ROVO_CHAT"] = "rovo-chat";
    AUTOSUGGEST_SOURCE["CONFLUENCE_AIFC"] = "confluence-aifc";
    AUTOSUGGEST_SOURCE["CONFLUENCE_AIFC_SLIDES"] = "confluence-aifc-slides";
    AUTOSUGGEST_SOURCE["CONFLUENCE_AIFC_WHITEBOARD"] = "confluence-aifc-whiteboard";
    AUTOSUGGEST_SOURCE["CONFLUENCE_AIFC_DATABASE"] = "confluence-aifc-database";
    AUTOSUGGEST_SOURCE["CONFLUENCE_AIFC_LIVE_DOC"] = "confluence-aifc-live-doc";
    return AUTOSUGGEST_SOURCE;
}({});
const $70c81957c9ee94b4$export$f3c4b70a2cbe1eb3 = 'thirdPartyConnectPrompt';
module.exports["ANALYTICS_CHANNEL"] = $70c81957c9ee94b4$export$85183a312807388d;
module.exports["SMART_LINK_ROVO_BUTTON_INTERACTION_SOURCE"] = $70c81957c9ee94b4$export$e86f3aae41de8a7;
module.exports["REMIX_INTERACTION_SOURCES"] = $70c81957c9ee94b4$export$5a1bc70923e441e9;
module.exports["isAllowedLaunchSource"] = $70c81957c9ee94b4$export$f57fd972b3024068;
module.exports["AUTOSUGGEST_SOURCE"] = $70c81957c9ee94b4$export$406073150b1a408;
module.exports["THIRD_PARTY_CONNECT_PROMPT_SUBJECT"] = $70c81957c9ee94b4$export$f3c4b70a2cbe1eb3;

});

parcelRegister("nl5f2", function(module, exports) {

var $1Pvvv = parcelRequire("1Pvvv");


var $5oT0d = parcelRequire("5oT0d");

const $0e75beeba4a8395f$var$isSourceAndAttributes = (x)=>{
    if (typeof x !== 'object' || x === null) return false;
    if (!('source' in x) || !('attributes' in x) || typeof x.attributes !== 'object' || x.attributes === null) return false;
    return (0, $5oT0d.ALLOWED_AI_MATE_SOURCES).includes(x.source);
};
const $0e75beeba4a8395f$export$d97c97ed77ff09e8 = (context)=>{
    if (!context || !Array.isArray(context)) return {};
    let contextsThatHaveAttributes = context.filter((x)=>$0e75beeba4a8395f$var$isSourceAndAttributes(x) || x[0, $1Pvvv.AI_MATE_CONTEXT]);
    return contextsThatHaveAttributes.reduce((acc, x)=>{
        return {
            ...acc,
            ...x[0, $1Pvvv.AI_MATE_CONTEXT]?.attributes ?? {},
            ...x.attributes ?? {}
        };
    }, {});
};
module.exports["getAttributesFromContexts"] = $0e75beeba4a8395f$export$d97c97ed77ff09e8;

});

parcelRegister("5oT0d", function(module, exports) {
const $19fd3c58da81b4e5$export$e31e24b63b7085fd = [
    'AIMate',
    'smart-create',
    'CSMAI',
    'CSMAIEmbed',
    'rovoServiceAgent',
    'solutionComposer'
];
module.exports["ALLOWED_AI_MATE_SOURCES"] = $19fd3c58da81b4e5$export$e31e24b63b7085fd;

});

parcelRegister("irnO2", function(module, exports) {

var $cNAch = parcelRequire("cNAch");


var $4MiWC = parcelRequire("4MiWC");

const $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1 = {
    LOAD_PANEL: 'aiMateLoadPanel',
    LOAD_PANEL_COMPOSABLE_EDITOR: 'aiMateLoadPanelComposableEditor',
    LOAD_INLINE_EDITOR: 'aiMateLoadInlineComposableEditor',
    LOAD_BROWSE_AGENTS: 'aiMateLoadBrowseAgents',
    SEARCH_BROWSE_AGENTS: 'aiMateSearchBrowseAgents',
    LOAD_CREATE_AGENT: 'aiMateLoadCreateAgent',
    LOAD_AUTO_SUGGEST_SKILLS_LEGACY: 'aiMateAutoSuggestSkillsLegacy',
    LOAD_AUTO_SUGGEST_SKILLS_UNIFIED: 'aiMateAutoSuggestSkillsUnified',
    LOAD_CHAT_PROMPT_INPUT_SKILLS: 'aiMateChatPromptInputSkillsLoad',
    LOAD_INLINE_CHAT_PROMPT_INPUT_SKILLS: 'aiMateInlineChatPromptInputSkillsLoad',
    FETCH_CHAT: 'aiMateFetchChat',
    PREFETCH_CHAT: 'aiMatePrefetchChat',
    FETCH_AGENTS: 'aiMateFetchAgents',
    FETCH_AGENTS_PAGINATED: 'aiMateFetchAgentsPaginated',
    FETCH_AGENTS_OVERRIDES: 'aiMateFetchAgentsOverrides',
    FETCH_AGENT_BY_AGENT_ID: 'aiMateFetchAgentByAgentId',
    FETCH_SCENARIO_LIST: 'aiMateFetchScenarioList',
    FETCH_AGENT_BY_IDENTITY_ACCOUNT_ID: 'aiMateFetchAgentByIdentityAccountId',
    FETCH_AGENT_BY_EXTERNAL_CONFIG_REFERENCE: 'aiMateFetchAgentByExternalConfigReference',
    FETCH_AGENT_DEBUG_MODAL_DATA: 'aiMateFetchAgentDebugModalData',
    FETCH_AGENT_DEBUG_MODAL_CONVERSATION_REVIEW: 'aiMateFetchAgentDebugModalDataConversationReview',
    CREATE_AGENT: 'aiMateCreateAgent',
    UPDATE_AGENT: 'aiMateUpdateAgent',
    DELETE_AGENT: 'aiMateDeleteAgent',
    DUPLICATE_AGENT: 'aiMateDuplicateAgent',
    HYDRATE_AGENT_DATA: 'aiMateHydrateAgentData',
    HYDRATE_SKILL_METADATA: 'aiMateHydrateSkillMetadata',
    FAVOURITE_AGENT: 'aiMateFavouriteAgent',
    UNFAVOURITE_AGENT: 'aiMateUnfavouriteAgent',
    CLEAR_CHAT: 'aiMateClearChat',
    SEND_MESSAGE: 'aiMateSendMessage',
    SEND_MESSAGE_ROVO_CUSTOM_AGENT: 'aiMateSendMessageRovoCustomAgent',
    SEND_DR_MESSAGE: 'aiMateSendDRMessage',
    SEND_TD_MESSAGE: 'aiMateSendThinkDeeperMessage',
    SEND_TASK_MODE_MESSAGE: 'aiMateSendTaskModeMessage',
    SEND_CONFIRMED_TOOLS_MESSAGE: 'aiMateSendConfirmedToolsMessage',
    SEND_CONFIRMED_TOOLS_TASK_MODE_MESSAGE: 'aiMateSendConfirmedToolsTaskModeMessage',
    SEND_A2UI_ACTION: 'aiMateSendA2UIAction',
    RECONNECT_TO_ACTIVE_STREAM: 'aiMateReconnectToActiveStream',
    ABORT_AGENT_STREAM: 'aiMateAbortAgentStream',
    ANSWER_NOW: 'aiMateAnswerNow',
    HYDRATE_CONVERSATION: 'aiMateHydrateConversation',
    GET_CONVERSATION_CHANNELS: 'aiMateGetConversationChannels',
    GET_CONVERSATION_CHANNELS_INITIAL_LOAD: 'aiMateGetConversationChannelsInitialLoad',
    LOAD_MORE_CONVERSATION_CHANNELS: 'aiMateLoadMoreConversationChannels',
    UPDATE_CONVERSATION_CHANNEL: 'aiMateUpdateConversationChannel',
    CREATE_SEEDED_CONVERSATION_CHANNEL: 'aiMateCreateSeededConversationChannel',
    PUBSUB_LISTENER: 'aiMatePubSubListener',
    FETCH_AGENT_TENANT_DATA: 'aiMateFetchAgentTenantData',
    RESOLVE_CONVERSATION_ACTION: 'aiMateResolveConversationAction',
    BULK_RESOLVE_CONVERSATION_ACTIONS: 'aiMateBulkResolveConversationActions',
    MESSAGE_RENDERER: 'aiMateMessageRenderer',
    FETCH_CONTEXTUAL_STARTERS: 'aiMateFetchContextualStarters',
    FETCH_DYNAMIC_CONVERSATION_STARTERS: 'aiMateFetchDynamicConversationStarters',
    GENERATE_CONVERSATION_STARTERS: 'aiMateGenerateConversationStarters',
    FETCH_AGENT_TEAM_DATA: 'aiMateFetchAgentTeamData',
    FETCH_CONNECTED_KNOWLEDGE_SOURCES: 'aiMateFetchConnectedKnowledgeSources',
    FETCH_CONNECTED_KNOWLEDGE_SOURCES_STORE: 'aiMateFetchKnowledgeSourcesStore',
    PREFETCH_CONNECTED_KNOWLEDGE_SOURCES_STORE: 'aiMatePrefetchKnowledgeSourcesStore',
    FETCH_AGENT_ACTIONS: 'aiMateFetchAgentActions',
    CHANGE_AGENT_OWNER: 'aiMateChangeAgentOwner',
    GET_AGENT_PERMISSIONS: 'aiMateGetAgentPermissions',
    AIFC_FINALIZE_CONTENT: 'aiMateAIFCFinalizeContent',
    PREVIEW_CONTENT: 'aiMatePreviewContent',
    PREVIEW_CARD_RENDER: 'aiMatePreviewCardRender',
    JIRA_PREVIEW_CARD_RENDER: 'aiMateJiraPreviewCardRender',
    JSM_PREVIEW_CARD_RENDER: 'aiMateJsmPreviewCardRender',
    FETCH_AGENT_SITE_PERMISSIONS: 'aiMateFetchAgentSitePermissions',
    PREFETCH_AGENT_SITE_PERMISSIONS: 'aiMatePrefetchAgentSitePermissions',
    SEND_MESSAGE_NL_AGENT: 'aiMateSendMessageNLAgent',
    FILTERED_CLIENT_ERROR: 'aiMateFilteredClientError',
    GET_RECOMMENDED_AGENTS: 'aiMateGetRecommendedAgents',
    PREFETCH_RECOMMENDED_AGENTS: 'aiMatePrefetchRecommendedAgents',
    PREFETCH_RECOMMENDED_SPACES: 'aiMatePrefetchRecommendedSpaces',
    OPEN_RECOMMENDED_SPACES: 'aiMateOpenRecommendedSpaces',
    UPLOAD_FILES_TO_CONVERSATION: 'aiMateUploadFilesToConversation',
    VALIDATE_FILES: 'aiMateValidateFiles',
    GET_CONVERSATION_FILES: 'aiMateGetConversationFiles',
    AIFC_MESSAGE: 'aiMateAifcMessage',
    AIFC_LOAD_STAGING_AREA_MODAL: 'aiMateLoadStagingAreaModal',
    AIFC_TWC_ONBOARDING_MODAL_LAUNCH: 'aiMateTwcAifcOnboardingModalLaunch',
    AIFC_LOAD_CHAT_ONLY_CREATION_MODAL: 'aiMateLoadChatOnlyCreationModal',
    AIFC_LOAD_DRAFTS_SECTION: 'aiMateLoadDraftsSection',
    AIFC_GENERATE_CONTENT: 'aiMateAifcGenerateContent',
    AIFC_GENERATE_CONTENT_IN_CHAT: 'aiMateAifcGenerateContentInChat',
    AIFC_INITIAL_DATA_RECEIVED: 'aiMateAifcInitialDataReceived',
    AIFC_ALL_DATA_HANDLED: 'aiMateAifcAllDataHandled',
    AIFC_UPDATE_CONTENT: 'aiMateAifcUpdateContent',
    UPDATE_CONTENT_IN_CHAT: 'aiMateUpdateContentInChat',
    AIFC_MODAL_SESSION: 'aiMateAifcModalSession',
    CSM_WIDGET_RENDER: 'csmWidgetRender',
    CSM_AGENT_IDENTITY_NAME: 'csmAgentIdentityName',
    CSM_AGENT_IDENTITY_COMPANY: 'csmAgentIdentityCompany',
    CSM_AGENT_IDENTITY_TONE: 'csmAgentIdentityTone',
    CSM_AGENT_IDENTITY_GREETING_MESSAGE: 'csmAgentIdentityGreetingMessage',
    CSM_AGENT_IDENTITY_CONVERSATION_STARTERS: 'csmAgentIdentityConversationStarters',
    CSM_AGENT_IDENTITY_GENERATE_CONVERSATION_STARTERS: 'csmAgentIdentityGenerateConversationStarters',
    GET_AUTO_APPLY_STATE: 'aiMateGetAutoApplyState',
    SET_AUTO_APPLY_STATE: 'aiMateSetAutoApplyState',
    AGENTS_MODAL_AND_SIDEBAR_LIST: 'aiMateAgentsModalAndSidebarList',
    AGENTS_MODAL_FAVOURITE_AGENTS: 'aiMateAgentsModalFavouriteAgents',
    AGENTS_FULLSCREEN_AGENT_LIST: 'aiMateAgentsFullscreenAgentList',
    STUDIO_TRIGGER_SOLUTION_PLAN: 'aiMateStudioTriggerSolutionPlan',
    MY_PROJECTS_LIST_QUERY: 'aiMateMyProjectsListQuery',
    STUDIO_UPDATE_AGENT: 'aiMateStudioUpdateAgent',
    STUDIO_CREATE_AGENT_TRIGGER: 'aiMateStudioCreateAgentTrigger',
    STUDIO_UPDATE_AGENT_TRIGGER: 'aiMateStudioUpdateAgentTrigger',
    STUDIO_SET_AGENT_TRIGGER_ENABLED: 'aiMateStudioSetAgentTriggerEnabled',
    STUDIO_REMOVE_AGENT_TRIGGER: 'aiMateStudioRemoveAgentTrigger',
    STUDIO_AUTOMATION_CREATE_RULE: 'aiMateStudioAutomationCreateRule',
    THREADS_LIST_QUERY: 'aiMateThreadsListQuery',
    WARM_CONVERSATION_CACHE: 'aiMateWarmConversationCache',
    WARM_CONTEXT_BANNER_LINK: 'aiMateWarmContextBannerLink',
    AIFC_LOAD_PROMPT_SUGGESTIONS: 'aiMateAifcLoadPromptSuggestions',
    REMIX_START: 'aiMateRemixStart',
    REMIX_AIFC_HANDOFF: 'aiMateRemixAifcHandoff',
    FETCH_INSIGHTS_STATUS: 'aiMateFetchInsightsStatus',
    FETCH_INSIGHTS_FEED: 'aiMateFetchInsightsFeed',
    REMIX_RENDERS_IN_MODAL: 'aiMateRemixRendersInModal',
    REMIX_CREATE: 'aiMateRemixCreate',
    REMIX_OPEN_MENU: 'aiMateRemixOpenMenu',
    REMIX_SELECT_OPTION: 'aiMateRemixSelectOption',
    REMIX_SHOW_LOADING: 'aiMateRemixShowLoading',
    REMIX_VIEW: 'aiMateRemixView',
    REMIX_REGENERATE: 'aiMateRemixRegenerate',
    REMIX_INSERT: 'aiMateRemixInsert',
    REMIX_PASTE: 'aiMateRemixPaste',
    REMIX_COPY_FROM_PREVIEW: 'aiMateRemixCopyFromPreview',
    REMIX_DIAGRAM_PASTE_FINALIZE: 'aiMateRemixDiagramPasteFinalize',
    FETCH_TASKS: 'aiMateFetchTasks',
    FETCH_ARTIFACT_LIBRARY: 'aiMateFetchArtifactLibrary',
    LOAD_STICKY_SKILL_LISTENER: 'aiMateLoadStickySkillListener',
    /**
   * Tracks duplicating a Remix/MAUI app when its link is pasted into another
   * Confluence page. Started when the editor plugin detects a MAUI link in
   * the paste, succeeded once the duplicated app's URL has been swapped into
   * the editor doc, and failed if the duplicate API call (or any JS error in
   * the duplication flow) fails. When this experience fails, the
   * REMIX_INSERT experience is also failed so the overall paste-and-insert
   * flow is reflected in the SLO.
   */ REMIX_DUPLICATE_APP: 'aiMateRemixDuplicateApp',
    STUDIO_CREATE_AGENT: 'aiMateStudioCreateAgent',
    STUDIO_CREATE_AGENT_ASSIGN: 'aiMateStudioCreateAgentAssign',
    STUDIO_CREATE_AGENT_INVOKE: 'aiMateStudioCreateAgentInvoke',
    STUDIO_CREATE_AGENT_BUILD_AND_CHAT: 'aiMateStudioCreateAgentBuildAndChat',
    STUDIO_CREATE_AGENT_REFINE_IN_STUDIO: 'aiMateStudioCreateAgentRefineInStudio',
    STUDIO_CREATE_AGENT_RENDER: 'aiMateStudioCreateAgentRender',
    JIRA_SAVE_DRAFT_WORK_ITEM: 'aiMateJiraSaveDraftWorkItem',
    JIRA_RESOLVE_DRAFT_WORK_ITEM: 'aiMateJiraResolveDraftWorkItem',
    JIRA_CREATE_WORK_ITEMS_BULK: 'aiMateJiraCreateWorkItemsBulk',
    ROVO_SKILLS_PLAN_WORK_ITEM_CREATE: 'RovoSkillsPlanWorkItemCreate',
    ROVO_SKILLS_EXECUTION_WORK_ITEM_CREATE: 'RovoSkillsExecutionWorkItemCreate',
    ROVO_SKILLS_PLAN_WORK_ITEM_UPDATE: 'RovoSkillsPlanWorkItemUpdate',
    ROVO_SKILLS_EXECUTION_WORK_ITEM_UPDATE: 'RovoSkillsExecutionWorkItemUpdate',
    /**
   * Tracks the sender's end-to-end conversation-sharing funnel as a single
   * experience. Started when the share modal opens and succeeded only after
   * an existing or newly created share link is copied to the clipboard.
   * Unexpected hydration, persistence, share-creation, and clipboard errors
   * fail the experience. A `404` when loading existing share details is the
   * expected "not shared yet" state and does not fail the experience. Closing
   * the modal before any terminal state is recorded aborts the experience so
   * abandonment is excluded from the SLO.
   */ SHARE_CONVERSATION_SESSION: 'aiMateShareConversationSession',
    /**
   * Tracks the first action that reaches a terminal event while the Shared
   * chats tab in Rovo settings is active. Preview succeeds with `action` set
   * to `preview`; deleting a share or conversation succeeds or fails with
   * `action` set to `delete`. Later or overlapping terminal calls are ignored
   * by the underlying tracker. Closing the tab first aborts the experience.
   */ MANAGE_CONVERSATION_SHARES: 'aiMateManageConversationShares',
    /**
   * Tracks loading a shared conversation on the shared conversation preview
   * page, for both the sender previewing their own share and a recipient
   * opening a share link. Started when the route mounts and succeeded only
   * after the conversation has rendered. Errors retrieving or mapping the
   * share fail the experience. A link that never carried the parameters needed
   * to request a share aborts the experience, as does leaving the page before
   * the conversation renders, so malformed links and abandonment are still
   * recorded without counting against the SLO.
   */ VIEW_CONVERSATION_SHARE: 'aiMateViewConversationShare',
    /**
   * Tracks rendering the skill detail view of the skills directory, from either
   * Atlassian Studio or the Rovo Chat skills modal. Started when the detail
   * segment mounts and succeeded once the skill has rendered. Errors thrown
   * while loading or rendering the skill fail the experience.
   */ LOAD_SKILL_DETAIL_IN_SKILL_DIRECTORY: 'aiMateLoadSkillDetailInSkillDirectory',
    /**
   * Tracks rendering the products filter of the skills directory. Started when
   * the filter segment mounts and succeeded once the product list has
   * rendered. Errors loading the product dimension metadata fail the
   * experience.
   */ LOAD_SKILLS_DIRECTORY_PRODUCTS_FILTER: 'aiMateLoadSkillsDirectoryProductsFilter',
    AIFC_DEEP_LINK_LAUNCH: 'aiMateAifcDeepLinkLaunch'
};
const $b6334bd5b5c71b1c$export$97bfa295b10f6f9e = ({ deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, taskModeEnabled: taskModeEnabled, fastModeEnabled: fastModeEnabled, isCustomRovoAgent: isCustomRovoAgent })=>{
    if (isCustomRovoAgent) return $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.SEND_MESSAGE_ROVO_CUSTOM_AGENT;
    if (deepResearchEnabled) return $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.SEND_DR_MESSAGE;
    if (thinkDeeperEnabled) return $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.SEND_TD_MESSAGE;
    if (taskModeEnabled) return $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.SEND_TASK_MODE_MESSAGE;
    if (fastModeEnabled) // Sending the same experience name for fast mode as it is the same as the default (auto) mode
    return $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.SEND_MESSAGE;
    return $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.SEND_MESSAGE;
};
const $b6334bd5b5c71b1c$export$233a4307e330ea30 = [
    $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.AIFC_GENERATE_CONTENT,
    $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.AIFC_GENERATE_CONTENT_IN_CHAT,
    $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.AIFC_UPDATE_CONTENT,
    $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.AIFC_FINALIZE_CONTENT,
    $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.AIFC_LOAD_STAGING_AREA_MODAL,
    $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.AIFC_MODAL_SESSION,
    $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.REMIX_REGENERATE
];
const $b6334bd5b5c71b1c$export$1b8ade75bafe2a6d = {
    /** Browser-level network failure — request never reached Atlassian servers (e.g. VPN, firewall, no connectivity) */ CLIENT_FETCH_ERROR: 'clientFetchError',
    /** Rovo is not enabled for the user's organisation (product-not-active stream error) */ PRODUCT_NOT_ACTIVE: 'productNotActive',
    /** User is not authenticated or lacks permission (HTTP 401/403) */ AUTH_OR_PERMISSION_ERROR: 'authOrPermissionError',
    /** Request was rejected by rate limiting or quota admission control (HTTP 429) */ RATE_LIMIT_ERROR: 'rateLimitError'
};
const $b6334bd5b5c71b1c$export$315c6d415b08d278 = {
    /** Experience started (intent detection decided on a creatable/Remix action) */ STARTED_AT: 'previewCardRenderStartedAtMs',
    /** Most recent ACTION_PART received */ ACTION_PART_AT: 'previewCardRenderActionPartAtMs',
    /** ACTION_COMPLETE received */ ACTION_COMPLETE_AT: 'previewCardRenderActionCompleteAtMs',
    /** SmartCreatePreviewCard mounted */ CARD_MOUNTED_AT: 'previewCardRenderCardMountedAtMs',
    /** SmartCreatePreviewCard mounted but used a non-instrumented branch. */ ROUTED_TO_NON_INSTRUMENTED_BRANCH_AT: 'previewCardRenderRoutedToNonInstrumentedBranchAtMs'
};
const $b6334bd5b5c71b1c$export$754812bba125b4c4 = {
    /** Why the experience succeeded or aborted. */ TERMINAL_REASON: 'previewCardRenderTerminalReason'
};
const $b6334bd5b5c71b1c$export$51e40ef74b0123bc = {
    /** Action status on the ACTION_PREPARE chunk */ ACTION_PREPARE_STATUS: 'previewCardRenderActionPrepareStatus',
    /** Action status on the most recent ACTION_PART chunk */ ACTION_PART_STATUS: 'previewCardRenderActionPartStatus',
    /** Action status on the ACTION_COMPLETE chunk */ ACTION_COMPLETE_STATUS: 'previewCardRenderActionCompleteStatus',
    /** Action key on the ACTION_COMPLETE chunk */ ACTION_COMPLETE_KEY: 'previewCardRenderActionCompleteKey'
};
const $b6334bd5b5c71b1c$export$b49585ccbc2980b5 = {
    STARTED_AT: 'previewContentStartedAtMs',
    EMBED_URL_RESOLVED_AT: 'previewContentEmbedUrlResolvedAtMs',
    IFRAME_MOUNTED_AT: 'previewContentIframeMountedAtMs',
    HANDSHAKE_RECEIVED_AT: 'previewContentHandshakeReceivedAtMs',
    IFRAME_LOADED_AT: 'previewContentIframeLoadedAtMs'
};
const $b6334bd5b5c71b1c$export$449b821dadec8760 = [
    $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.AIFC_DEEP_LINK_LAUNCH,
    $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.AIFC_INITIAL_DATA_RECEIVED,
    $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.AIFC_ALL_DATA_HANDLED,
    $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.PREVIEW_CONTENT,
    ...$b6334bd5b5c71b1c$export$233a4307e330ea30
];
const $b6334bd5b5c71b1c$export$ebde7a14f059b67f = {
    SUBMIT: 'submit',
    ACTION_COMPLETE_RECEIVED: 'action_complete_received',
    PREVIEW_VISIBLE: 'preview_visible'
};
const $b6334bd5b5c71b1c$export$35724980a513a99d = [
    {
        key: 'backend_latency',
        startMark: $b6334bd5b5c71b1c$export$ebde7a14f059b67f.SUBMIT,
        endMark: $b6334bd5b5c71b1c$export$ebde7a14f059b67f.ACTION_COMPLETE_RECEIVED
    },
    {
        key: 'render_latency',
        startMark: $b6334bd5b5c71b1c$export$ebde7a14f059b67f.ACTION_COMPLETE_RECEIVED,
        endMark: $b6334bd5b5c71b1c$export$ebde7a14f059b67f.PREVIEW_VISIBLE
    }
];
const $b6334bd5b5c71b1c$export$13437d7a030ee3e7 = new (0, $cNAch.UFOExperience)('remix-generate-preview', {
    type: (0, $4MiWC.ExperienceTypes).Experience,
    performanceType: (0, $4MiWC.ExperiencePerformanceTypes).InlineResult,
    timings: [
        ...$b6334bd5b5c71b1c$export$35724980a513a99d
    ]
});
const $b6334bd5b5c71b1c$export$bef09d36689d0f74 = {
    SUBMIT: 'submit',
    // mark the start of the experience when the user submits the edit request
    ACTION_COMPLETE_RECEIVED: 'action_complete_received',
    // mark when we receive the ACTION_COMPLETE event from the backend
    NODE_INSERTED: 'node_inserted' // mark when the new app node is inserted into the editor
};
const $b6334bd5b5c71b1c$export$222a56424ec38dc0 = [
    {
        key: 'backend_latency',
        startMark: $b6334bd5b5c71b1c$export$bef09d36689d0f74.SUBMIT,
        endMark: $b6334bd5b5c71b1c$export$bef09d36689d0f74.ACTION_COMPLETE_RECEIVED
    },
    {
        key: 'insertion_latency',
        startMark: $b6334bd5b5c71b1c$export$bef09d36689d0f74.ACTION_COMPLETE_RECEIVED,
        endMark: $b6334bd5b5c71b1c$export$bef09d36689d0f74.NODE_INSERTED
    }
];
const $b6334bd5b5c71b1c$export$a143927e9fe401a2 = new (0, $cNAch.UFOExperience)('remix-edit-existing', {
    type: (0, $4MiWC.ExperienceTypes).Experience,
    performanceType: (0, $4MiWC.ExperiencePerformanceTypes).InlineResult,
    timings: [
        ...$b6334bd5b5c71b1c$export$222a56424ec38dc0
    ]
});
const $b6334bd5b5c71b1c$export$5806cfefce9dc0ad = {
    PASTE_DETECTED: 'paste_detected',
    EMBED_LOADED: 'embed_loaded'
};
const $b6334bd5b5c71b1c$export$c39e7538132ae645 = [
    {
        key: 'render_latency',
        startMark: $b6334bd5b5c71b1c$export$5806cfefce9dc0ad.PASTE_DETECTED,
        endMark: $b6334bd5b5c71b1c$export$5806cfefce9dc0ad.EMBED_LOADED
    }
];
const $b6334bd5b5c71b1c$export$cf4d370f87e7f73d = new (0, $cNAch.UFOExperience)('remix-paste-render-embed', {
    type: (0, $4MiWC.ExperienceTypes).Experience,
    performanceType: (0, $4MiWC.ExperiencePerformanceTypes).InlineResult,
    timings: [
        ...$b6334bd5b5c71b1c$export$c39e7538132ae645
    ]
});
let $b6334bd5b5c71b1c$var$isRemixPasteRenderEmbedExperienceActive = false;
const $b6334bd5b5c71b1c$export$c0c3ed9d934fa9fe = (metadata)=>{
    if ($b6334bd5b5c71b1c$var$isRemixPasteRenderEmbedExperienceActive) return;
    $b6334bd5b5c71b1c$var$isRemixPasteRenderEmbedExperienceActive = true;
    $b6334bd5b5c71b1c$export$cf4d370f87e7f73d.start();
    $b6334bd5b5c71b1c$export$cf4d370f87e7f73d.mark($b6334bd5b5c71b1c$export$5806cfefce9dc0ad.PASTE_DETECTED);
    if (metadata) $b6334bd5b5c71b1c$export$cf4d370f87e7f73d.addMetadata(metadata);
};
const $b6334bd5b5c71b1c$export$aa07d60d01b2c5e3 = (metadata)=>{
    if (!$b6334bd5b5c71b1c$var$isRemixPasteRenderEmbedExperienceActive) return;
    $b6334bd5b5c71b1c$export$cf4d370f87e7f73d.mark($b6334bd5b5c71b1c$export$5806cfefce9dc0ad.EMBED_LOADED);
    if (metadata) $b6334bd5b5c71b1c$export$cf4d370f87e7f73d.addMetadata(metadata);
    $b6334bd5b5c71b1c$export$cf4d370f87e7f73d.success();
    $b6334bd5b5c71b1c$var$isRemixPasteRenderEmbedExperienceActive = false;
};
const $b6334bd5b5c71b1c$export$2ed37a75e20c9dc7 = (error, metadata)=>{
    if (!$b6334bd5b5c71b1c$var$isRemixPasteRenderEmbedExperienceActive) return;
    if (metadata) $b6334bd5b5c71b1c$export$cf4d370f87e7f73d.addMetadata(metadata);
    $b6334bd5b5c71b1c$export$cf4d370f87e7f73d.failure({
        metadata: {
            reason: error.message
        }
    });
    $b6334bd5b5c71b1c$var$isRemixPasteRenderEmbedExperienceActive = false;
};
module.exports["ExperienceName"] = $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1;
module.exports["sendMessageExperienceName"] = $b6334bd5b5c71b1c$export$97bfa295b10f6f9e;
module.exports["AIFC_EXPERIENCES_TO_FAIL"] = $b6334bd5b5c71b1c$export$233a4307e330ea30;
module.exports["SLOExclusionReason"] = $b6334bd5b5c71b1c$export$1b8ade75bafe2a6d;
module.exports["PreviewCardRenderStage"] = $b6334bd5b5c71b1c$export$315c6d415b08d278;
module.exports["PreviewCardRenderDiagnosticAttribute"] = $b6334bd5b5c71b1c$export$754812bba125b4c4;
module.exports["PreviewCardRenderActionAttribute"] = $b6334bd5b5c71b1c$export$51e40ef74b0123bc;
module.exports["PreviewContentStage"] = $b6334bd5b5c71b1c$export$b49585ccbc2980b5;
module.exports["AIFC_EXPERIENCES_TO_ABORT"] = $b6334bd5b5c71b1c$export$449b821dadec8760;
module.exports["REMIX_GENERATE_PREVIEW_MARKS"] = $b6334bd5b5c71b1c$export$ebde7a14f059b67f;
module.exports["remixGeneratePreviewExperience"] = $b6334bd5b5c71b1c$export$13437d7a030ee3e7;
module.exports["REMIX_EDIT_EXISTING_MARKS"] = $b6334bd5b5c71b1c$export$bef09d36689d0f74;
module.exports["remixEditExistingExperience"] = $b6334bd5b5c71b1c$export$a143927e9fe401a2;
module.exports["startRemixPasteRenderEmbedExperience"] = $b6334bd5b5c71b1c$export$c0c3ed9d934fa9fe;
module.exports["succeedRemixPasteRenderEmbedExperience"] = $b6334bd5b5c71b1c$export$aa07d60d01b2c5e3;
module.exports["failRemixPasteRenderEmbedExperience"] = $b6334bd5b5c71b1c$export$2ed37a75e20c9dc7;

});

parcelRegister("1XM8n", function(module, exports) {
/**
 * Determines the owning team for a failure event based on the experience task name,
 * error message, and optional attributes (e.g. actionKey).
 *
 * The rules are derived from the AIFC Top Baseline Errors report and use regex matching
 * to handle error messages that contain dynamic values (UUIDs, IDs, hashes, etc).
 *
 * @see https://hello.atlassian.net/wiki/spaces/ac8/pages/6822974693/Apr+13-14+2026+-+AIFC+Top+Baseline+Errors
 */ 
var $irnO2 = parcelRequire("irnO2");

var $8fc2212d0df9a0a6$export$e196c5257e9c94dd = /*#__PURE__*/ function(OwningTeam) {
    OwningTeam["AifcFoundations"] = "AIFC Foundations";
    OwningTeam["EditorAi"] = "Editor AI";
    OwningTeam["RovoChat"] = "Rovo Chat";
    OwningTeam["Whiteboards"] = "Whiteboards";
    OwningTeam["Databases"] = "Databases";
    OwningTeam["JiraAifc"] = "Jira AIFC";
    OwningTeam["Pulsar"] = "Pulsar";
    return OwningTeam;
}({});
/**
 * Step 1 — Experience-specific error rules.
 * These are checked first and only when the experience name matches.
 */ const $8fc2212d0df9a0a6$var$RULES_FOR_SPECIFIC_EXPERIENCES = [
    {
        pattern: /Something went wrong on Rovo's end. Please try sending your message again./i,
        team: "AIFC Foundations",
        experiences: [
            (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT
        ]
    },
    {
        pattern: /The ConfluenceCreationTool was invoked, but valid content was not created for action key:.*whiteboard/i,
        team: "Whiteboards",
        experiences: [
            (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT
        ]
    },
    {
        pattern: /The ConfluenceCreationTool was invoked, but valid content was not created for action key:.*database/i,
        team: "Databases",
        experiences: [
            (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT
        ]
    },
    {
        pattern: /The ConfluenceCreationTool was invoked, but valid content was not created for action key:.*page/i,
        team: "AIFC Foundations",
        experiences: [
            (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT
        ]
    },
    {
        pattern: /The orchestrator reached its depth limit and the ConfluenceCreationTool was not invoked./i,
        team: "AIFC Foundations",
        experiences: [
            (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT
        ]
    },
    {
        pattern: /Could not create content of type \w+ in the Confluence staging area./i,
        team: "AIFC Foundations",
        experiences: [
            (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT,
            (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT_IN_CHAT
        ]
    },
    {
        pattern: /Message action error: [Code 400] convoai.rest.bad.request - Failed to update page: missing pageId and ADF content for actionKey:.*/i,
        team: "AIFC Foundations",
        experiences: [
            (0, $irnO2.ExperienceName).AIFC_UPDATE_CONTENT
        ]
    },
    {
        pattern: /Message action error: [Code 400] convoai.rest.bad.request - Failed to update page: missing pageId and ADF content for actionKey:.*/i,
        team: "Editor AI",
        experiences: [
            (0, $irnO2.ExperienceName).UPDATE_CONTENT_IN_CHAT
        ]
    },
    {
        pattern: /AIFC stream received edit tags but no elements were affected/i,
        team: "Whiteboards",
        experiences: [
            (0, $irnO2.ExperienceName).AIFC_UPDATE_CONTENT
        ]
    }
];
/**
 * Step 2 — Global error rules that apply across all experiences.
 */ const $8fc2212d0df9a0a6$var$GLOBAL_ERROR_MESSAGE_RULES = [
    {
        pattern: /network error/i,
        team: "Rovo Chat"
    },
    {
        pattern: /An error occurred. Please try again later./i,
        team: "Rovo Chat"
    },
    {
        pattern: /Failed to fetch/i,
        team: "Rovo Chat"
    },
    {
        pattern: /An unknown error occurred/i,
        team: "Rovo Chat"
    },
    {
        pattern: /\[Code 403\] {"code":403,"message":"You're unable to access content because your IP address is not listed in the IP allowlist. Contact your admin for help."}/i,
        team: "Rovo Chat"
    },
    {
        pattern: /AIFC stream received only preamble but no <todo_list>, SVG or whiteboards XML.*/i,
        team: "Whiteboards"
    },
    {
        pattern: /No sizing converter defined for element type 'mindmap'/i,
        team: "Whiteboards"
    },
    {
        pattern: /AIFC stream received edit tags but no elements were affected/i,
        team: "Whiteboards"
    },
    {
        pattern: /Could not find database:/i,
        team: "Databases"
    }
];
/**
 * Step 3 — Default team ownership per experience.
 * Used as a fallback when no error-pattern rule matches.
 */ const $8fc2212d0df9a0a6$var$DEFAULT_TEAM_FOR_EXPERIENCE = new Map([
    [
        (0, $irnO2.ExperienceName).AIFC_FINALIZE_CONTENT,
        "AIFC Foundations"
    ],
    [
        (0, $irnO2.ExperienceName).AIFC_ALL_DATA_HANDLED,
        "AIFC Foundations"
    ],
    [
        (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT,
        "AIFC Foundations"
    ],
    [
        (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT_IN_CHAT,
        "AIFC Foundations"
    ],
    [
        (0, $irnO2.ExperienceName).AIFC_INITIAL_DATA_RECEIVED,
        "AIFC Foundations"
    ],
    [
        (0, $irnO2.ExperienceName).AIFC_MODAL_SESSION,
        "AIFC Foundations"
    ],
    [
        (0, $irnO2.ExperienceName).AIFC_UPDATE_CONTENT,
        "AIFC Foundations"
    ],
    [
        (0, $irnO2.ExperienceName).UPDATE_CONTENT_IN_CHAT,
        "Editor AI"
    ],
    [
        (0, $irnO2.ExperienceName).PREVIEW_CARD_RENDER,
        "AIFC Foundations"
    ],
    [
        (0, $irnO2.ExperienceName).PREVIEW_CONTENT,
        "AIFC Foundations"
    ],
    [
        (0, $irnO2.ExperienceName).SEND_MESSAGE,
        "Rovo Chat"
    ],
    [
        (0, $irnO2.ExperienceName).SEND_TASK_MODE_MESSAGE,
        "Rovo Chat"
    ],
    [
        (0, $irnO2.ExperienceName).SEND_CONFIRMED_TOOLS_TASK_MODE_MESSAGE,
        "Rovo Chat"
    ],
    [
        (0, $irnO2.ExperienceName).LOAD_AUTO_SUGGEST_SKILLS_LEGACY,
        "Rovo Chat"
    ],
    [
        (0, $irnO2.ExperienceName).LOAD_AUTO_SUGGEST_SKILLS_UNIFIED,
        "Rovo Chat"
    ],
    [
        (0, $irnO2.ExperienceName).LOAD_CHAT_PROMPT_INPUT_SKILLS,
        "Rovo Chat"
    ],
    [
        (0, $irnO2.ExperienceName).LOAD_INLINE_CHAT_PROMPT_INPUT_SKILLS,
        "Rovo Chat"
    ],
    [
        (0, $irnO2.ExperienceName).JIRA_SAVE_DRAFT_WORK_ITEM,
        "Jira AIFC"
    ],
    [
        (0, $irnO2.ExperienceName).JIRA_CREATE_WORK_ITEMS_BULK,
        "Jira AIFC"
    ],
    [
        (0, $irnO2.ExperienceName).ROVO_SKILLS_PLAN_WORK_ITEM_CREATE,
        "Jira AIFC"
    ],
    [
        (0, $irnO2.ExperienceName).ROVO_SKILLS_EXECUTION_WORK_ITEM_CREATE,
        "Jira AIFC"
    ],
    [
        (0, $irnO2.ExperienceName).SHARE_CONVERSATION_SESSION,
        "Rovo Chat"
    ],
    [
        (0, $irnO2.ExperienceName).MANAGE_CONVERSATION_SHARES,
        "Rovo Chat"
    ],
    [
        (0, $irnO2.ExperienceName).VIEW_CONVERSATION_SHARE,
        "Rovo Chat"
    ],
    [
        (0, $irnO2.ExperienceName).ROVO_SKILLS_PLAN_WORK_ITEM_UPDATE,
        "Pulsar"
    ],
    [
        (0, $irnO2.ExperienceName).ROVO_SKILLS_EXECUTION_WORK_ITEM_UPDATE,
        "Pulsar"
    ]
]);
const $8fc2212d0df9a0a6$export$d6e429d0895093 = (errorMessage, experienceName)=>{
    if (!errorMessage) return $8fc2212d0df9a0a6$var$DEFAULT_TEAM_FOR_EXPERIENCE.get(experienceName);
    // Step 1: Experience-specific error-pattern rules
    if (experienceName) for (const rule of $8fc2212d0df9a0a6$var$RULES_FOR_SPECIFIC_EXPERIENCES){
        if (rule.experiences.includes(experienceName) && rule.pattern.test(errorMessage)) return rule.team;
    }
    // Step 2: Global error-pattern rules
    for (const rule of $8fc2212d0df9a0a6$var$GLOBAL_ERROR_MESSAGE_RULES){
        if (rule.pattern.test(errorMessage)) return rule.team;
    }
    // Step 3: Default team for this experience
    if (experienceName) return $8fc2212d0df9a0a6$var$DEFAULT_TEAM_FOR_EXPERIENCE.get(experienceName);
    return undefined;
};
module.exports["getOwningTeam"] = $8fc2212d0df9a0a6$export$d6e429d0895093;

});

parcelRegister("8YL3U", function(module, exports) {
class $f2446ffb8af04183$export$79c3dc6f15d36f18 {
    onVisibilityChange(isHidden) {
        const now = performance.now();
        if (isHidden) {
            if (this.lastHiddenAt === null) this.lastHiddenAt = now;
            if (this.firstHiddenOffsetMs === null) this.firstHiddenOffsetMs = now - this.startTime;
        } else if (this.lastHiddenAt !== null) {
            this.totalHiddenMs += now - this.lastHiddenAt;
            this.lastHiddenAt = null;
        }
    }
    getAttributes(doc) {
        const now = performance.now();
        const elapsed = now - this.startTime;
        let totalHiddenMs = this.totalHiddenMs;
        if (this.lastHiddenAt !== null) totalHiddenMs += now - this.lastHiddenAt;
        const tabHiddenProportion = elapsed > 0 ? totalHiddenMs / elapsed : 0;
        return {
            isActiveTab: doc ? doc.visibilityState === 'visible' : true,
            tabHiddenProportion: tabHiddenProportion,
            tabFirstHiddenOffsetMs: this.firstHiddenOffsetMs
        };
    }
    constructor(doc){
        this.startTime = void 0;
        this.totalHiddenMs = 0;
        this.lastHiddenAt = void 0;
        this.firstHiddenOffsetMs = void 0;
        this.startTime = performance.now();
        const isHidden = doc?.visibilityState === 'hidden';
        this.lastHiddenAt = isHidden ? this.startTime : null;
        this.firstHiddenOffsetMs = isHidden ? 0 : null;
    }
}
module.exports["TabVisibilityTracker"] = $f2446ffb8af04183$export$79c3dc6f15d36f18;

});

parcelRegister("iBsvI", function(module, exports) {

var $4o0zT = parcelRequire("4o0zT");

function $a0b10823d5792e1c$export$63b2cbfa1855c730({ remixType: remixType, existingFeatureArea: existingFeatureArea }) {
    if (!(0, $4o0zT.isExperimentEnabled)('maui_remix_feature_area_by_type_exp_gate')) return existingFeatureArea;
    return remixType ? `remix-${remixType}` : existingFeatureArea ?? 'remix';
}
module.exports["getRemixFeatureArea"] = $a0b10823d5792e1c$export$63b2cbfa1855c730;

});

parcelRegister("4tOXV", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iMnC5 = parcelRequire("iMnC5");


var $w6R6I = parcelRequire("w6R6I");


var $fZAJP = parcelRequire("fZAJP");

const $05ef07480c610d29$export$9ac100e40613ea10 = ()=>{
    let userAgent = '';
    if (window?.__SSR_USER_AGENT__) userAgent = window.__SSR_USER_AGENT__;
    else userAgent = window?.navigator?.userAgent ?? '';
    return userAgent.indexOf('Mac') > -1;
};
const $05ef07480c610d29$var$styles = {
    flexCenter: "_4c065UFQfX _3iDTPbQ4SZ _0hPCNLDIqT",
    base: "_0bjKvDKxmn _4c065UFQfX _2Y7lL42ADO _3iDTPbvbI6 _2XsHFMFQfX _0adFHsFQfX",
    contentBefore: "_2XsHFM1Y8M _0adFHsPgdg",
    darkBackground: "_0KLXrueZ10",
    lightBackground: "_0KLXrumhAQ"
};
const $05ef07480c610d29$var$i18n = (0, $kSwu1.defineMessages)({
    keyboardShortcutShift: {
        id: "shortcuts.shift",
        defaultMessage: "Shift"
    },
    keyboardShortcutCtrl: {
        id: "shortcuts.ctrl",
        defaultMessage: "Ctrl"
    },
    keyboardShortcutCommandWin: {
        id: "shortcuts.cmd.win",
        defaultMessage: "Ctrl"
    },
    keyboardShortcutCommandMac: {
        id: "shortcuts.cmd.mac",
        defaultMessage: "Cmd"
    },
    keyboardShortcutOptionMac: {
        id: "shortcuts.opt.mac",
        defaultMessage: "Opt"
    },
    keyboardShortcutOptionWin: {
        id: "shortcuts.opt.win",
        defaultMessage: "Alt"
    },
    keyboardShortcutPlus: {
        id: "shortcuts.plus",
        defaultMessage: "+"
    },
    keyboardShortcutMinus: {
        id: "shortcuts.minus",
        defaultMessage: "-"
    },
    keyboardShortcutEnter: {
        id: "shortcuts.enter",
        defaultMessage: "Enter"
    },
    keyboardShortcutMeta: {
        id: "shortcuts.meta",
        defaultMessage: "Meta"
    }
});
const $05ef07480c610d29$var$processKey = (key, formatMessage)=>{
    const mac = $05ef07480c610d29$export$9ac100e40613ea10();
    const lowerCaseKey = key.toLowerCase();
    switch(lowerCaseKey){
        case 'shift':
            return '\u21E7';
        // ⇧
        case 'cmd':
        case 'mod':
            return mac ? '\u2318' // ⌘
             : formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutCommandWin);
        case 'ctrl':
            return formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutCtrl);
        case 'opt':
        case 'option':
            return mac ? formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutOptionMac) : formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutOptionWin);
        case 'enter':
            return formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutEnter);
        case 'meta':
            return formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutMeta);
        case 'uparrow':
            return '\u2191';
        // ↑
        case 'downarrow':
            return '\u2193';
        // ↓
        case 'leftarrow':
            return '\u2190';
        // ←
        case 'rightarrow':
            return '\u2192';
        // →
        case 'plus':
            return '+';
        case 'minus':
            return '-';
        default:
            return key;
    }
};
const $05ef07480c610d29$var$getShortcutStrings = (accelerator, formatMessage)=>{
    const shortcutKeys = accelerator.includes(' ') ? accelerator.split(' ') : accelerator.split('+');
    return shortcutKeys.map((key)=>{
        const processedKey = $05ef07480c610d29$var$processKey(key, formatMessage);
        if (processedKey.length === 1) return processedKey.toUpperCase();
        else return processedKey;
    });
};
const $05ef07480c610d29$export$7571b974b8c6ca70 = (accelerator, formatMessage)=>{
    return $05ef07480c610d29$var$getShortcutStrings(accelerator, formatMessage).join(' ');
};
const $05ef07480c610d29$export$7005a48098466b5d = (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { shortcut: shortcut, contentBefore: contentBefore, isEditorShortcut: isEditorShortcut, isTooltip: t1 } = t0;
    const isTooltip = t1 === undefined ? false : t1;
    const [areKeyboardShortcutsEnabled] = (0, $fZAJP.useKeyboardShortcutsEnabled)();
    const intl = (0, $kSwu1.useIntl)();
    let T0;
    let t2;
    let t3;
    let t4;
    let t5;
    if ($[0] !== areKeyboardShortcutsEnabled || $[1] !== contentBefore || $[2] !== intl.formatMessage || $[3] !== isEditorShortcut || $[4] !== isTooltip || $[5] !== shortcut) {
        const shortcutStrings = $05ef07480c610d29$var$getShortcutStrings(shortcut, intl.formatMessage);
        const shouldRenderShortcutSegment = areKeyboardShortcutsEnabled || isEditorShortcut;
        T0 = (0, $iMnC5.Box);
        t2 = "span";
        t3 = $05ef07480c610d29$var$styles.flexCenter;
        t4 = contentBefore;
        t5 = shouldRenderShortcutSegment && shortcutStrings.map((shortcutSegment, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                as: "span",
                key: `${shortcutSegment}-${index}`,
                xcss: (0, $w6R6I.cx)($05ef07480c610d29$var$styles.base, Boolean(contentBefore) && $05ef07480c610d29$var$styles.contentBefore, isTooltip ? $05ef07480c610d29$var$styles.darkBackground : $05ef07480c610d29$var$styles.lightBackground)
            }, shortcutSegment));
        $[0] = areKeyboardShortcutsEnabled;
        $[1] = contentBefore;
        $[2] = intl.formatMessage;
        $[3] = isEditorShortcut;
        $[4] = isTooltip;
        $[5] = shortcut;
        $[6] = T0;
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else {
        T0 = $[6];
        t2 = $[7];
        t3 = $[8];
        t4 = $[9];
        t5 = $[10];
    }
    let t6;
    if ($[11] !== T0 || $[12] !== t2 || $[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            as: t2,
            xcss: t3
        }, t4, t5);
        $[11] = T0;
        $[12] = t2;
        $[13] = t3;
        $[14] = t4;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    return t6;
}; /**
    * Converts shortcut strings like "ctrl+[" to an array of strings like ["Ctrl", "["].
    *
    * This is used for mapping the shortcut constants in `confluence-shortcuts.ts` to the
    * format expected by the ADS Tooltip `shortcut` prop.
    *
    * It checks if keyboard shortcuts are enabled and returns undefined if they are not.
    *
    * @example
    * ```
    * const shortcut = useShortcutStrings({ shortcut: 'ctrl+[' });
    * <Tooltip content="My tooltip" shortcut={shortcut} />
    * ```
    */ 
const $05ef07480c610d29$export$e84ae736f9706c5d = (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { shortcut: shortcut, isEditorShortcut: t1 } = t0;
    const isEditorShortcut = t1 === undefined ? false : t1;
    const intl = (0, $kSwu1.useIntl)();
    const [areKeyboardShortcutsEnabled] = (0, $fZAJP.useKeyboardShortcutsEnabled)();
    if (!shortcut) return;
    let t2;
    if ($[0] !== intl.formatMessage || $[1] !== shortcut) {
        t2 = $05ef07480c610d29$var$getShortcutStrings(shortcut, intl.formatMessage);
        $[0] = intl.formatMessage;
        $[1] = shortcut;
        $[2] = t2;
    } else t2 = $[2];
    const shortcutStrings = t2;
    const shouldDisplayShortcut = areKeyboardShortcutsEnabled || isEditorShortcut;
    if (!shouldDisplayShortcut) return;
    return shortcutStrings;
};
module.exports["isMac"] = $05ef07480c610d29$export$9ac100e40613ea10;
module.exports["getShortcutString"] = $05ef07480c610d29$export$7571b974b8c6ca70;
module.exports["ShortcutVisualizer"] = $05ef07480c610d29$export$7005a48098466b5d;
module.exports["useShortcutStrings"] = $05ef07480c610d29$export$e84ae736f9706c5d;

});

parcelRegister("fZAJP", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $3y1ko = parcelRequire("3y1ko");

let $640354b193201be7$var$inflightPromise = null;
const $640354b193201be7$var$updaters = new Set();
const $640354b193201be7$export$130f87a5d53e682d = ()=>{
    const $ = (0, $bDgLe.c)(6);
    const { isLoggedIn: isLoggedIn, isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const [enabled, setEnabled] = (0, $cozmU.useState)(window.__SHORTCUT_ENABLED__ ?? false);
    let t0;
    let t1;
    if ($[0] !== isLicensed || $[1] !== isLoggedIn) {
        t0 = ()=>{
            if (typeof window.__SHORTCUT_ENABLED__ !== "boolean") {
                if (!$640354b193201be7$var$inflightPromise) $640354b193201be7$var$inflightPromise = isLoggedIn && isLicensed ? (0, $3y1ko.fetchShortcutEnabledState)() : Promise.resolve(false);
                $640354b193201be7$var$inflightPromise.then(setEnabled);
            }
            $640354b193201be7$var$updaters.add(setEnabled);
            return ()=>{
                $640354b193201be7$var$updaters.delete(setEnabled);
            };
        };
        t1 = [
            isLoggedIn,
            isLicensed
        ];
        $[0] = isLicensed;
        $[1] = isLoggedIn;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
    const notify = $640354b193201be7$var$_temp;
    const t2 = Boolean(enabled);
    let t3;
    if ($[4] !== t2) {
        t3 = [
            t2,
            notify
        ];
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
};
async function $640354b193201be7$var$_temp(enabled_0) {
    try {
        const res = await (0, $f7B1p.cfetch)("/wiki/rest/confluenceshortcuts/latest/enabled", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                enabled: enabled_0
            })
        });
        if (res.ok) {
            const newEnabled = await res.text() === "true";
            window.__SHORTCUT_ENABLED__ = newEnabled;
            $640354b193201be7$var$updaters.forEach((updater)=>updater(newEnabled));
        }
    } catch (t0) {
        const e = t0;
        (0, $5ZqQS.getMonitoringClient)().submitError(new Error(`Error updating keyboard shortcuts enabled state: ${e.message}`), {
            attribution: (0, $3IBnw.Attribution).BACKBONE
        });
    }
}
module.exports["useKeyboardShortcutsEnabled"] = $640354b193201be7$export$130f87a5d53e682d;

});

parcelRegister("8i27m", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $3u5lg = parcelRequire("3u5lg");

var $33a0cfbfba499043$export$ffa1150e6a48f9cd = /*#__PURE__*/ function(CommentType) {
    CommentType["INLINE"] = "inline";
    CommentType["GENERAL"] = "general";
    return CommentType;
}({});
var $33a0cfbfba499043$export$74159dff405238c0 = /*#__PURE__*/ function(CommentActionType) {
    CommentActionType["DELETE_COMMENT"] = "deleted";
    // If you ever update this, please also update commentsNavigationUtils, which relies on the string to avoid circular deps
    CommentActionType["RESOLVE_COMMENT_THREAD"] = "resolved";
    return CommentActionType;
}({});
const $33a0cfbfba499043$export$53ac33307b5acee9 = ()=>({
        orderedActiveAnnotationIdList: [],
        commentThreadsRemovedByOtherUsers: {}
    });
const $33a0cfbfba499043$export$e324594224ef24da = {
    setOrderedActiveAnnotationIdList: (newCommentsList)=>({ getState: getState, setState: setState })=>{
            const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList } = getState();
            if (!newCommentsList || newCommentsList.length === 0) {
                // Only update state if the current list is not already empty
                if (orderedActiveAnnotationIdList.length > 0) setState({
                    orderedActiveAnnotationIdList: []
                });
                return;
            }
            // Create a map of existing annotationId to their isLoaded states for quick lookup
            const existingAnnotationsMap = new Map(orderedActiveAnnotationIdList.map(({ threadKey: threadKey, isLoaded: isLoaded })=>[
                    threadKey,
                    isLoaded
                ]));
            // Use a Set to ensure unique annotation IDs
            const uniqueCommentsSet = new Set(newCommentsList);
            // Map the unique comments set to the new state, preserving isLoaded where possible
            const updatedAnnotationList = Array.from(uniqueCommentsSet).map((threadKey)=>({
                    threadKey: threadKey,
                    isLoaded: existingAnnotationsMap.get(threadKey) ?? false // Preserve existing isLoaded or default to false
                }));
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(orderedActiveAnnotationIdList, updatedAnnotationList)) setState({
                orderedActiveAnnotationIdList: updatedAnnotationList
            });
        },
    getCurrentCommentsPanelState: ()=>({ getState: getState })=>{
            return getState();
        },
    // keep track of removed annotations
    updateRemovedCommentIdsMap: ({ commentId: commentId, commentActionType: commentActionType })=>({ setState: setState, getState: getState })=>{
            const { commentThreadsRemovedByOtherUsers: commentThreadsRemovedByOtherUsers } = getState();
            // Update commentThreadsRemovedByOtherUsers map
            const updatedRemovedComments = {
                ...commentThreadsRemovedByOtherUsers
            };
            updatedRemovedComments[commentId] = commentActionType;
            // Update the removed-by-other-users map.
            setState({
                commentThreadsRemovedByOtherUsers: updatedRemovedComments
            });
        },
    reopenParentComment: ({ parentCommentId: parentCommentId })=>({ setState: setState, getState: getState })=>{
            // Records a reopened parent comment in the commentThreadsRemovedByOtherUsers map.
            if (!parentCommentId) return;
            const { commentThreadsRemovedByOtherUsers: currentRemovedComments } = getState();
            const updatedRemovedComments = {
                ...currentRemovedComments
            };
            delete updatedRemovedComments[parentCommentId];
            setState({
                commentThreadsRemovedByOtherUsers: updatedRemovedComments
            });
        },
    clearRemovedComments: ()=>({ setState: setState })=>{
            setState({
                commentThreadsRemovedByOtherUsers: {}
            });
        },
    clearCommentsData: ()=>({ setState: setState })=>{
            setState($33a0cfbfba499043$export$53ac33307b5acee9());
        }
};
const $33a0cfbfba499043$export$13b7c646235a7fd4 = (0, $8s9DV.createStore)({
    initialState: $33a0cfbfba499043$export$53ac33307b5acee9(),
    actions: $33a0cfbfba499043$export$e324594224ef24da,
    name: 'CommentsDataStore'
});
const $33a0cfbfba499043$export$80f09eb388fa70f9 = (0, $kBr4q.createHook)($33a0cfbfba499043$export$13b7c646235a7fd4);
const $33a0cfbfba499043$export$b5e3986841a4e13f = (0, $kBr4q.createActionsHook)($33a0cfbfba499043$export$13b7c646235a7fd4);
const $33a0cfbfba499043$export$c14a8182bd597724 = (0, $kBr4q.createStateHook)($33a0cfbfba499043$export$13b7c646235a7fd4);
module.exports["CommentType"] = $33a0cfbfba499043$export$ffa1150e6a48f9cd;
module.exports["CommentActionType"] = $33a0cfbfba499043$export$74159dff405238c0;
module.exports["useCommentsData"] = $33a0cfbfba499043$export$80f09eb388fa70f9;
module.exports["useCommentsDataActions"] = $33a0cfbfba499043$export$b5e3986841a4e13f;
module.exports["useCommentsDataState"] = $33a0cfbfba499043$export$c14a8182bd597724;

});

parcelRegister("aWwYt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $lRhY3 = parcelRequire("lRhY3");

const $5371993c50b87836$export$c0cd7aea5be0e780 = 40;
const $5371993c50b87836$export$9e0a6941e0e87c97 = 400;
const $5371993c50b87836$export$21f0d255469350e0 = 3840;
const $5371993c50b87836$export$70e5631b7ec2f387 = Math.max($5371993c50b87836$export$9e0a6941e0e87c97, 368) + $5371993c50b87836$export$c0cd7aea5be0e780;
const $5371993c50b87836$export$d4c72bab9d6cc13a = {
    isPanelScrolled: false,
    isObjectSidebarShown: false,
    behavior: 'push',
    panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
    panel: undefined,
    updatedPanelHeaderComponentElements: undefined,
    sidebarControlState: window.__SSR_RENDERED__ ? 'shown' : 'hidden',
    sidebarControlExpandCollapsedState: window.__SSR_RENDERED__ ? 'expanded' : 'collapsed',
    activeActionInPanel: undefined
};
const $5371993c50b87836$export$e324594224ef24da = {
    setIsPanelScrolled: (isPanelScrolled)=>({ setState: setState })=>{
            setState({
                isPanelScrolled: isPanelScrolled
            });
        },
    setSidebarControlState: (sidebarControlState)=>({ setState: setState })=>{
            setState({
                sidebarControlState: sidebarControlState
            });
        },
    showSidebarControlIfNoPanel: ()=>({ setState: setState, getState: getState })=>{
            // Read the store at dispatch time rather than relying on a React render snapshot.
            // A deeplink can open the panel between render and a passive effect being flushed.
            if (!getState().isObjectSidebarShown) setState({
                sidebarControlState: 'shown'
            });
        },
    setSidebarControlExpandCollapsedState: (sidebarControlExpandCollapsedState)=>({ setState: setState })=>{
            setState({
                sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState
            });
        },
    toggleObjectSidebarControl: ()=>({ setState: setState, getState: getState })=>{
            const { sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState } = getState();
            if (sidebarControlExpandCollapsedState === 'collapsed') setState({
                sidebarControlExpandCollapsedState: 'expanded'
            });
            else setState({
                sidebarControlExpandCollapsedState: 'collapsed'
            });
        },
    showObjectSidebar: (panel, behavior, panelWidth)=>({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: currentPanel, behavior: currentBehavior, panelWidth: currentPanelWidth } = getState();
            // Check if panel is open
            if (isObjectSidebarShown) {
                // If it's the same panel do nothing
                if (currentPanel?.id === panel.id) return;
                // Otherwise change it
                setState({
                    panel: panel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: behavior ?? currentBehavior,
                    panelWidth: panelWidth ?? currentPanelWidth,
                    isPanelScrolled: false
                });
            }
            // Set the panel to be open
            setState({
                isObjectSidebarShown: true,
                panel: panel,
                updatedPanelHeaderComponentElements: undefined,
                behavior: behavior ?? currentBehavior,
                panelWidth: panelWidth ?? currentPanelWidth,
                sidebarControlState: 'hidden',
                isPanelScrolled: false
            });
            // Close the global panel
            window.dispatchEvent(new Event('closeGlobalSidebar'));
        },
    hideObjectSidebar: (afterCloseCallback)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel } = getState();
            // If we're not showing a panel, don't do anything
            if (!isObjectSidebarShown || !panel) return;
            // If the user has provided closeOptions check them
            if (panel.closeOptions) {
                const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                // If the panel closing check returns false, do nothing
                if (canClosePanel) {
                    const panelCanClose = await canClosePanel();
                    if (!panelCanClose) return;
                }
                // Call the onClose callback
                onPanelClose && onPanelClose();
            }
            // Close the panel
            setState({
                isObjectSidebarShown: false,
                panel: undefined,
                updatedPanelHeaderComponentElements: undefined,
                panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
                sidebarControlState: 'shown',
                isPanelScrolled: false
            });
            if (afterCloseCallback) afterCloseCallback();
        },
    hideObjectSidebarByPanelId: (id)=>({ getState: getState, dispatch: dispatch })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) dispatch($5371993c50b87836$export$e324594224ef24da.hideObjectSidebar());
        },
    /**
   * Hide the sidebar immediately, bypassing the canClosePanel guard.
   * Use only when the caller has already confirmed with the user that it is
   * safe to discard any draft (e.g. after showing their own warning dialog).
   */ hideObjectSidebarForce: ()=>({ getState: getState, setState: setState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel } = getState();
            if (!isObjectSidebarShown || !panel) return;
            panel.closeOptions?.onPanelClose?.();
            setState({
                isObjectSidebarShown: false,
                panel: undefined,
                updatedPanelHeaderComponentElements: undefined,
                panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
                sidebarControlState: 'shown',
                isPanelScrolled: false
            });
        },
    /**
   * Legacy writer used by `ObjectSidebarPushPlaceholder`'s ResizeObserver
   * loop, which reports the inner content width (without push padding).
   * Prefer `setVisiblePanelWidth` from drag-resize call sites.
   */ setPanelWidth: (newPanelWidth)=>({ setState: setState })=>{
            const clamped = Math.min(Math.max(newPanelWidth, $5371993c50b87836$export$9e0a6941e0e87c97), $5371993c50b87836$export$21f0d255469350e0);
            setState({
                panelWidth: clamped + $5371993c50b87836$export$c0cd7aea5be0e780
            });
        },
    /**
   * Drag-resize writer. Takes the *visible* panel width directly (no
   * `−CONTENT_RIGHT_PADDING` at the call site). Same encoding as
   * `setPanelWidth`, so `panelWidth` consistently represents
   * "visible + push padding" regardless of which writer set it.
   */ setVisiblePanelWidth: (visiblePanelWidth)=>({ setState: setState })=>{
            const clamped = Math.min(Math.max(visiblePanelWidth, $5371993c50b87836$export$9e0a6941e0e87c97), $5371993c50b87836$export$21f0d255469350e0);
            setState({
                panelWidth: clamped + $5371993c50b87836$export$c0cd7aea5be0e780
            });
        },
    changePanelBehavior: (newBehavior)=>({ setState: setState, getState: getState })=>{
            const { panelWidth: panelWidth } = getState();
            // When we set the new state, if it's set to cover, we no longer have a
            // component that will size the panel accordingly so we just use the default
            setState({
                behavior: newBehavior,
                panelWidth: newBehavior === 'cover' ? $5371993c50b87836$export$70e5631b7ec2f387 : panelWidth
            });
        },
    changePanel: (newPanel, newBehavior, newPanelWidth)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel, behavior: behavior, panelWidth: panelWidth } = getState();
            // Only change panels if the panel is open
            if (isObjectSidebarShown && panel) {
                // If it's the same panel do nothing
                if (panel.id === newPanel.id) return;
                // If the user has provided closeOptions check them
                if (panel.closeOptions) {
                    const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                    // If the panel closing check returns false, do nothing
                    if (canClosePanel) {
                        const panelCanClose = await canClosePanel();
                        if (!panelCanClose) return;
                    }
                    // Call the onClose callback
                    onPanelClose && onPanelClose();
                }
                setState({
                    panel: newPanel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: newBehavior ?? behavior,
                    panelWidth: newPanelWidth ?? panelWidth,
                    isPanelScrolled: false
                });
            }
        // Otherwise do nothing
        },
    changeHeaderElements: (id, headerComponentElements)=>({ setState: setState, getState: getState })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) setState({
                updatedPanelHeaderComponentElements: headerComponentElements
            });
        },
    setActiveActionInPanel: (activeActionInPanel)=>({ setState: setState, getState: getState })=>{
            const { activeActionInPanel: currentActiveAction } = getState();
            // If the active action is the same, do nothing
            if (currentActiveAction?.title === activeActionInPanel?.title) return;
            setState({
                activeActionInPanel: activeActionInPanel
            });
        }
};
const $5371993c50b87836$export$8930ecd60eb3f136 = (0, $8s9DV.createStore)({
    initialState: $5371993c50b87836$export$d4c72bab9d6cc13a,
    actions: $5371993c50b87836$export$e324594224ef24da,
    name: 'ObjectSidebarStore'
});
const $5371993c50b87836$var$useObjectSidebarActionsInternal = (0, $kBr4q.createActionsHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$export$332594c77a860a26 = ()=>{
    const internalActions = $5371993c50b87836$var$useObjectSidebarActionsInternal();
    const { close: close } = (0, $lRhY3.usePreviewPanelsActions)();
    const showObjectSidebarWrapper = (0, $cozmU.useCallback)((panel, behavior, panelWidth)=>{
        internalActions.showObjectSidebar(panel, behavior, panelWidth);
        close();
    }, [
        internalActions,
        close
    ]);
    const showObjectSidebar = showObjectSidebarWrapper;
    const memoizedActions = (0, $cozmU.useMemo)(()=>({
            ...internalActions,
            showObjectSidebar: showObjectSidebar
        }), [
        internalActions,
        showObjectSidebar
    ]);
    return (0, $cozmU.useMemo)(()=>memoizedActions, [
        memoizedActions
    ]);
};
const $5371993c50b87836$export$41c5dcc793387db5 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$var$getIsObjectSidebarShown = (state)=>state.isObjectSidebarShown;
const $5371993c50b87836$var$getPanel = (state)=>state.panel;
const $5371993c50b87836$var$getBehavior = (state)=>state.behavior;
const $5371993c50b87836$var$isPanelScrolled = (state)=>state.isPanelScrolled;
const $5371993c50b87836$var$getPanelWidth = (state)=>state.panelWidth;
const $5371993c50b87836$var$getUpdatedHeaderComponentElements = (state)=>state.updatedPanelHeaderComponentElements;
const $5371993c50b87836$var$getSidebarControlState = (state)=>state.sidebarControlState;
const $5371993c50b87836$var$getSidebarControlExpandCollapsedState = (state)=>state.sidebarControlExpandCollapsedState;
const $5371993c50b87836$var$getActiveAction = (state)=>state.activeActionInPanel;
const $5371993c50b87836$export$a572d51222d5ea45 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getIsObjectSidebarShown
});
const $5371993c50b87836$export$9168a42f32e3d071 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanel
});
const $5371993c50b87836$export$8b43142d6fd506da = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getBehavior
});
const $5371993c50b87836$export$ec8631e69ae8c803 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$isPanelScrolled
});
const $5371993c50b87836$export$82b270f291af5a5 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanelWidth
});
const $5371993c50b87836$export$bc4f8f2fe52e3d40 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getUpdatedHeaderComponentElements
});
const $5371993c50b87836$export$d4d7180dad517777 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlState
});
const $5371993c50b87836$export$b00fb66a9723fc58 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlExpandCollapsedState
});
const $5371993c50b87836$export$8ae0b1fffb30adb6 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getActiveAction
});
module.exports["CONTENT_RIGHT_PADDING"] = $5371993c50b87836$export$c0cd7aea5be0e780;
module.exports["MIN_PANEL_WIDTH"] = $5371993c50b87836$export$9e0a6941e0e87c97;
module.exports["useObjectSidebarActions"] = $5371993c50b87836$export$332594c77a860a26;
module.exports["useObjectSidebarState"] = $5371993c50b87836$export$41c5dcc793387db5;
module.exports["useIsObjectSidebarShown"] = $5371993c50b87836$export$a572d51222d5ea45;
module.exports["usePanel"] = $5371993c50b87836$export$9168a42f32e3d071;
module.exports["useBehavior"] = $5371993c50b87836$export$8b43142d6fd506da;
module.exports["useIsPanelScrolled"] = $5371993c50b87836$export$ec8631e69ae8c803;
module.exports["usePanelWidth"] = $5371993c50b87836$export$82b270f291af5a5;
module.exports["useUpdatedHeaderComponentElements"] = $5371993c50b87836$export$bc4f8f2fe52e3d40;
module.exports["useSidebarControlState"] = $5371993c50b87836$export$d4d7180dad517777;
module.exports["useSidebarControlExpandCollapsedState"] = $5371993c50b87836$export$b00fb66a9723fc58;
module.exports["useActiveActionInPanel"] = $5371993c50b87836$export$8ae0b1fffb30adb6;

});

parcelRegister("lRhY3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $3Ap09 = parcelRequire("3Ap09");

const $bc35f8d5f81a3a68$var$noop = (props)=>{};
const $bc35f8d5f81a3a68$export$5f5debba1692bf40 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(5);
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    if (!context) {
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = {
                open: $bc35f8d5f81a3a68$var$noop,
                close: $bc35f8d5f81a3a68$var$noop,
                setPanelWidth: $bc35f8d5f81a3a68$var$noop
            };
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    }
    let t0;
    if ($[1] !== context.close || $[2] !== context.open || $[3] !== context.setPanelWidth) {
        t0 = {
            open: context.open,
            close: context.close,
            setPanelWidth: context.setPanelWidth
        };
        $[1] = context.close;
        $[2] = context.open;
        $[3] = context.setPanelWidth;
        $[4] = t0;
    } else t0 = $[4];
    return t0;
} : ()=>{
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    if (!context) return {
        open: $bc35f8d5f81a3a68$var$noop,
        close: $bc35f8d5f81a3a68$var$noop,
        setPanelWidth: $bc35f8d5f81a3a68$var$noop
    };
    return {
        open: context.open,
        close: context.close,
        setPanelWidth: context.setPanelWidth
    };
};
module.exports["usePreviewPanelsActions"] = $bc35f8d5f81a3a68$export$5f5debba1692bf40;

});

parcelRegister("3Ap09", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cha5E = parcelRequire("cha5E");


var $iDrrr = parcelRequire("iDrrr");


var $63gyv = parcelRequire("63gyv");


var $7ssWV = parcelRequire("7ssWV");

const $4db84584556d15be$var$noop = ()=>{};
const $4db84584556d15be$var$initialState = {
    // Configured when opening a panel.
    panel: null,
    onOpen: $4db84584556d15be$var$noop,
    onClose: $4db84584556d15be$var$noop
};
const $4db84584556d15be$export$f473d225913e225d = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $4db84584556d15be$var$previewPanelsReducer = (state, action)=>{
    switch(action.type){
        case 'CLOSE':
            // Action explicitly called in order to close the active panel.
            action.onClose?.();
            state.panel && state?.onPreviewPanelClose?.(state.panel);
            return {
                ...state,
                panel: null,
                onOpen: $4db84584556d15be$var$noop,
                onClose: $4db84584556d15be$var$noop
            };
        case 'OPEN':
            // Action explicitly called in order to open a new panel.
            const { params: params } = action;
            // If the panel is already open, do nothing.
            if (state.panel?.id === params.panel.id) return state;
            /*
      	When opening a new preview panel, if the current panel is of the same type we don't
      	want to close the panel, but rather swap out the content. If the panel types don't match
      	we close the current panel and open the new one.
      	ex: A Goals panel is already open, and user tries to open a different Goals panel.
      	Parent Products must pass their preview panel close functions to the Preview Panel provider
      	via the `onPreviewPanelClose` prop.
      */ if (state.panel && !(0, $7ssWV.doPreviewPanelTypesMatch)(state.panel, params.panel)) // Close the active panel.
            state.onPreviewPanelClose?.(state.panel);
            state.panel && state.onClose();
            // Open the new panel.
            params.onOpen?.();
            state?.onPreviewPanelOpen?.(params.panel);
            return {
                ...state,
                panel: params.panel,
                onOpen: params.onOpen || $4db84584556d15be$var$initialState.onOpen,
                onClose: params.onClose || $4db84584556d15be$var$initialState.onClose
            };
        default:
            return state;
    }
};
const $4db84584556d15be$export$65ae37e9c61321f9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    const { onPreviewPanelOpen: onPreviewPanelOpen, onPreviewPanelClose: onPreviewPanelClose, parentProduct: parentProduct, children: children, initialPanel: initialPanel, initialWidth: initialWidth } = t0;
    let t1;
    if ($[0] !== initialWidth) {
        t1 = (0, $cha5E.expVal)("nin_glance_panel", "isEnabled", false) ? {
            initialWidth: initialWidth
        } : undefined;
        $[0] = initialWidth;
        $[1] = t1;
    } else t1 = $[1];
    const { panelWidth: panelWidth, onPanelClosed: onPanelClosed, onPanelOpened: onPanelOpened, onPanelWidthChanged: onPanelWidthChanged } = (0, $63gyv.usePanelWidth)(t1);
    let t2;
    if ($[2] !== initialPanel) {
        t2 = initialPanel && (0, $iDrrr.fg)("preview_panel_initial_state") ? {
            panel: initialPanel
        } : {};
        $[2] = initialPanel;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== onPreviewPanelClose || $[5] !== onPreviewPanelOpen || $[6] !== t2) {
        t3 = {
            ...$4db84584556d15be$var$initialState,
            ...t2,
            onPreviewPanelOpen: onPreviewPanelOpen,
            onPreviewPanelClose: onPreviewPanelClose
        };
        $[4] = onPreviewPanelClose;
        $[5] = onPreviewPanelOpen;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    const [state, dispatch] = (0, $cozmU.useReducer)($4db84584556d15be$var$previewPanelsReducer, t3);
    let t4;
    if ($[8] !== onPanelWidthChanged || $[9] !== parentProduct || $[10] !== state) {
        t4 = (width)=>{
            onPanelWidthChanged(width, state.panel?.product, state.panel?.type, parentProduct);
        };
        $[8] = onPanelWidthChanged;
        $[9] = parentProduct;
        $[10] = state;
        $[11] = t4;
    } else t4 = $[11];
    const setPanelWidth = t4;
    let t5;
    if ($[12] !== onPanelClosed) {
        t5 = (onClose)=>{
            dispatch?.({
                type: "CLOSE",
                onClose: onClose
            });
            onPanelClosed();
        };
        $[12] = onPanelClosed;
        $[13] = t5;
    } else t5 = $[13];
    const close = t5;
    let t6;
    if ($[14] !== onPanelOpened) {
        t6 = (params)=>{
            dispatch?.({
                type: "OPEN",
                params: params
            });
            onPanelOpened(params.width);
        };
        $[14] = onPanelOpened;
        $[15] = t6;
    } else t6 = $[15];
    const open = t6;
    let t7;
    if ($[16] !== close || $[17] !== open || $[18] !== panelWidth || $[19] !== setPanelWidth || $[20] !== state) {
        t7 = {
            state: state,
            open: open,
            close: close,
            width: panelWidth,
            setPanelWidth: setPanelWidth
        };
        $[16] = close;
        $[17] = open;
        $[18] = panelWidth;
        $[19] = setPanelWidth;
        $[20] = state;
        $[21] = t7;
    } else t7 = $[21];
    const context = t7;
    let t8;
    if ($[22] !== children || $[23] !== context) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4db84584556d15be$export$f473d225913e225d.Provider, {
            value: context
        }, children);
        $[22] = children;
        $[23] = context;
        $[24] = t8;
    } else t8 = $[24];
    return t8;
} : ({ onPreviewPanelOpen: onPreviewPanelOpen, onPreviewPanelClose: onPreviewPanelClose, parentProduct: parentProduct, children: children, initialPanel: initialPanel, initialWidth: initialWidth })=>{
    const { panelWidth: panelWidth, onPanelClosed: onPanelClosed, onPanelOpened: onPanelOpened, onPanelWidthChanged: onPanelWidthChanged } = (0, $63gyv.usePanelWidth)((0, $cha5E.expVal)('nin_glance_panel', 'isEnabled', false) ? {
        initialWidth: initialWidth
    } : undefined);
    const [state, dispatch] = (0, $cozmU.useReducer)($4db84584556d15be$var$previewPanelsReducer, {
        ...$4db84584556d15be$var$initialState,
        ...initialPanel && (0, $iDrrr.fg)('preview_panel_initial_state') ? {
            panel: initialPanel
        } : {},
        onPreviewPanelOpen: onPreviewPanelOpen,
        onPreviewPanelClose: onPreviewPanelClose
    });
    const setPanelWidth = (0, $cozmU.useCallback)((width)=>{
        onPanelWidthChanged(width, state.panel?.product, state.panel?.type, parentProduct);
    }, [
        onPanelWidthChanged,
        parentProduct,
        state
    ]);
    const close = (0, $cozmU.useCallback)((onClose)=>{
        dispatch?.({
            type: 'CLOSE',
            onClose: onClose
        });
        onPanelClosed();
    }, [
        dispatch,
        onPanelClosed
    ]);
    const open = (0, $cozmU.useCallback)((params)=>{
        dispatch?.({
            type: 'OPEN',
            params: params
        });
        onPanelOpened(params.width);
    }, [
        dispatch,
        onPanelOpened
    ]);
    const context = (0, $cozmU.useMemo)(()=>({
            state: state,
            open: open,
            close: close,
            width: panelWidth,
            setPanelWidth: setPanelWidth
        }), [
        close,
        panelWidth,
        open,
        setPanelWidth,
        state
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4db84584556d15be$export$f473d225913e225d.Provider, {
        value: context
    }, children);
};
const $4db84584556d15be$export$609db4be92d0fad8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($4db84584556d15be$export$f473d225913e225d);
} : ()=>{
    return (0, $cozmU.useContext)($4db84584556d15be$export$f473d225913e225d);
};
module.exports["PreviewPanelsProvider"] = $4db84584556d15be$export$65ae37e9c61321f9;
module.exports["usePreviewPanelsContext"] = $4db84584556d15be$export$609db4be92d0fad8;

});

parcelRegister("63gyv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $55fM8 = parcelRequire("55fM8");


var $9DHhW = parcelRequire("9DHhW");


var $7y9ez = parcelRequire("7y9ez");

const $4ad8ebf5df3a3b12$export$82b270f291af5a5 = ({ initialWidth: initialWidth } = {})=>{
    const [defaultWidth, setDefaultWidth] = (0, $cozmU.useState)((0, $7y9ez.getDefaultPanelWidth));
    const [panelWidth, setPanelWidth] = (0, $cozmU.useState)(initialWidth ?? defaultWidth);
    const [manuallyResized, setManuallyResized] = (0, $cozmU.useState)(false);
    const [panelOpen, setPanelOpen] = (0, $cozmU.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const onPanelWidthChanged = (0, $cozmU.useCallback)((newPanelWidth, panelProduct, panelType, parentProduct)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                product: panelProduct,
                source: 'preview-panel',
                action: 'resize',
                actionSubject: 'resizer',
                actionSubjectId: 'previewPanelResizer',
                attributes: {
                    initialPanelWidth: panelWidth,
                    newPanelWidth: newPanelWidth,
                    newWidthSmaller: newPanelWidth < panelWidth,
                    parentProduct: parentProduct,
                    panelType: panelType,
                    windowWidth: window.innerWidth,
                    windowHeight: window.innerHeight
                }
            }
        }).fire();
        setPanelWidth(newPanelWidth);
        setManuallyResized(true);
    }, [
        createAnalyticsEvent,
        panelWidth
    ]);
    const onPanelOpened = (0, $cozmU.useCallback)((openWidth)=>{
        const width = openWidth ?? (manuallyResized ? panelWidth : defaultWidth);
        setPanelWidth(width);
        setPanelOpen(true);
    }, [
        defaultWidth,
        manuallyResized,
        panelWidth
    ]);
    const onPanelClosed = (0, $cozmU.useCallback)(()=>{
        setPanelOpen(false);
    }, []);
    // getDefaultPanelWidth does not dependencies related to this hook
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const windowResizeListener = (0, $cozmU.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(()=>{
        if (!panelOpen) {
            setDefaultWidth((0, $7y9ez.getDefaultPanelWidth)());
            setManuallyResized(false);
        }
    }, 500), [
        panelOpen
    ]);
    (0, $cozmU.useEffect)(()=>{
        const unbind = (0, $cbY7C.bind)(window, {
            type: 'resize',
            listener: windowResizeListener
        });
        return ()=>{
            unbind();
        };
    }, [
        windowResizeListener
    ]);
    return {
        panelWidth: panelWidth,
        onPanelWidthChanged: onPanelWidthChanged,
        onPanelOpened: onPanelOpened,
        onPanelClosed: onPanelClosed
    };
};
module.exports["usePanelWidth"] = $4ad8ebf5df3a3b12$export$82b270f291af5a5;

});

parcelRegister("7y9ez", function(module, exports) {
const $c1ed100d044a4357$var$PANEL_DEFAULT_WIDTH = 400;
const $c1ed100d044a4357$var$PANEL_MAX_WIDTH = 1000;
const $c1ed100d044a4357$var$MINIMUM_WIDTH = 1800;
const $c1ed100d044a4357$var$PANEL_TO_WINDOW_WITH_RATIO = 0.3;
const $c1ed100d044a4357$export$29ceecbfeef33bfc = ()=>{
    const windowWidth = window.innerWidth;
    let width = $c1ed100d044a4357$var$PANEL_DEFAULT_WIDTH;
    if (windowWidth >= $c1ed100d044a4357$var$MINIMUM_WIDTH) {
        const proposedPanelWidth = Math.round(windowWidth * $c1ed100d044a4357$var$PANEL_TO_WINDOW_WITH_RATIO);
        width = proposedPanelWidth < $c1ed100d044a4357$var$PANEL_MAX_WIDTH ? proposedPanelWidth : $c1ed100d044a4357$var$PANEL_MAX_WIDTH;
    }
    return width;
};
module.exports["getDefaultPanelWidth"] = $c1ed100d044a4357$export$29ceecbfeef33bfc;

});

parcelRegister("7ssWV", function(module, exports) {

var $7avaU = parcelRequire("7avaU");

const $2fea0aef81deca52$export$eb89e687f2b278d7 = (currPanel, nextPanel)=>{
    // if both panels have their types set, we will check if they match
    if (currPanel?.type && nextPanel?.type) return currPanel.type === nextPanel.type;
    // else check against both panels' ari values
    if (currPanel?.ari && nextPanel?.ari) try {
        const currAri = (0, $7avaU.AnyAri).parse(currPanel.ari);
        const nextAri = (0, $7avaU.AnyAri).parse(nextPanel.ari);
        // ex: `${'confluence'}-${'page'}`, `${'confluence'}-${'blogpost'}`, `${'jira'}-${'project'}`, etc.
        return `${currAri.resourceOwner}-${currAri.resourceType}` === `${nextAri.resourceOwner}-${nextAri.resourceType}`;
    } catch (error) {
        // If parsing fails, we assume the ARI values do not match.
        return false;
    }
    // If neither panel has a type or ari, we assume they do not match.
    return false;
};
module.exports["doPreviewPanelTypesMatch"] = $2fea0aef81deca52$export$eb89e687f2b278d7;

});

parcelRegister("gczDe", function(module, exports) {

var $cz6eP = parcelRequire("cz6eP");

let $d31fe98ca852fa54$var$rendererEmitter = undefined;
const $d31fe98ca852fa54$export$894d051c63add88c = ()=>{
    if (!$d31fe98ca852fa54$var$rendererEmitter) $d31fe98ca852fa54$var$rendererEmitter = new (0, $cz6eP.AnnotationUpdateEmitter)();
    return $d31fe98ca852fa54$var$rendererEmitter;
};
module.exports["getRendererAnnotationEventEmitter"] = $d31fe98ca852fa54$export$894d051c63add88c;

});

parcelRegister("cz6eP", function(module, exports) {

var $eSa5t = parcelRequire("eSa5t");


var $5uEm7 = parcelRequire("5uEm7");

class $91ffffc20e95f4c4$export$7cc60aa9ef845515 extends (0, $eSa5t.EventEmitter) {
    on(event, listener) {
        return super.on(event, listener);
    }
    off(event, listener) {
        return super.removeListener(event, listener);
    }
}
function $91ffffc20e95f4c4$export$3238f27f6e07aed2() {
    return new (0, $5uEm7.SharedAnnotationManager)();
}
module.exports["AnnotationUpdateEmitter"] = $91ffffc20e95f4c4$export$7cc60aa9ef845515;
module.exports["createAnnotationManager"] = $91ffffc20e95f4c4$export$3238f27f6e07aed2;

});

parcelRegister("5uEm7", function(module, exports) {

var $eSa5t = parcelRequire("eSa5t");

class $ca65321d79324be4$export$c7aecf09b7cf478f {
    setPreemptiveGate(handler) {
        this.preemptiveGate = handler;
        return this;
    }
    checkPreemptiveGate() {
        if (this.activePreemptiveGate) // If the preemptive gate check already in flight then just return the promise
        // and don't call the preemptive gate again.
        // This is to prevent multiple calls to the preemptive gate creating multiple
        // promises that will resolve at different times.
        return Promise.resolve(this.activePreemptiveGate);
        const gate = this.activePreemptiveGate = this.preemptiveGate().then((result)=>{
            this.activePreemptiveGate = undefined;
            return result;
        });
        return gate;
    }
    onDraftAnnotationStarted(handler) {
        this.emitter.on('draftAnnotationStarted', handler);
        return this;
    }
    offDraftAnnotationStarted(handler) {
        this.emitter.off('draftAnnotationStarted', handler);
        return this;
    }
    onAnnotationSelectionChange(handler) {
        this.emitter.on('annotationSelectionChanged', handler);
        return this;
    }
    offAnnotationSelectionChange(handler) {
        this.emitter.off('annotationSelectionChanged', handler);
        return this;
    }
    emit(event) {
        this.emitter.emit(event.name, 'data' in event ? event.data : undefined);
        return this;
    }
    hook(method, handler) {
        this.hooks.set(method, handler);
        return this;
    }
    unhook(method, handler) {
        if (!this.hooks.has(method) || this.hooks.get(method) !== handler) return this;
        this.hooks.delete(method);
        return this;
    }
    allowAnnotation() {
        const fn = this.hooks.get('allowAnnotation');
        if (!fn) return false;
        try {
            return fn();
        } catch  {
            return false;
        }
    }
    startDraft() {
        const fn = this.hooks.get('startDraft');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            return fn();
        } catch  {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    clearDraft() {
        const fn = this.hooks.get('clearDraft');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            return fn();
        } catch  {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    applyDraft(id) {
        const fn = this.hooks.get('applyDraft');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            return fn(id);
        } catch  {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    getDraft() {
        const fn = this.hooks.get('getDraft');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            return fn();
        } catch  {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    setIsAnnotationSelected(id, isSelected) {
        const fn = this.hooks.get('setIsAnnotationSelected');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            // NOTE: The hook needs to manage the firing the annotationSelectionChanged event when a change is made. This is
            // because the hook is responsible for the state of the selection. The manager is not responsible for the state of
            // the selection.
            return fn(id, isSelected);
        } catch  {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    setIsAnnotationHovered(id, isHovered) {
        const fn = this.hooks.get('setIsAnnotationHovered');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            return fn(id, isHovered);
        } catch  {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    clearAnnotation(id) {
        const fn = this.hooks.get('clearAnnotation');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            return fn(id);
        } catch  {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    constructor(){
        /**
     * This is the event emitter that is used to emit events from the manager. It is used to communicate with
     * other parts of the application.
     */ this.emitter = new (0, $eSa5t.EventEmitter)();
        /**
     * This is the map of hooks that can be added to the manager. Hooks are a 1:1 mapping of methods that can be
     * called on the manager. They are used to extend the functionality of the manager.
     */ this.hooks = new Map();
        this.preemptiveGate = ()=>Promise.resolve(true);
        this.activePreemptiveGate = undefined;
    }
}
module.exports["SharedAnnotationManager"] = $ca65321d79324be4$export$c7aecf09b7cf478f;

});

parcelRegister("gfqXk", function(module, exports) {

var $cz6eP = parcelRequire("cz6eP");

let $d97010bba34874b5$var$editorEmitter = undefined;
const $d97010bba34874b5$export$60921b94e11f8e19 = ()=>{
    if (!$d97010bba34874b5$var$editorEmitter) $d97010bba34874b5$var$editorEmitter = new (0, $cz6eP.AnnotationUpdateEmitter)();
    return $d97010bba34874b5$var$editorEmitter;
};
module.exports["getEditorAnnotationEventEmitter"] = $d97010bba34874b5$export$60921b94e11f8e19;

});

parcelRegister("aSsfA", function(module, exports) {

var $3jwuS = parcelRequire("3jwuS");


var $de2j9 = parcelRequire("de2j9");


var $cD1qu = parcelRequire("cD1qu");

const $1874c19402f3b5d2$export$da5a0d0942eec3a4 = ()=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    let pageMode = (0, $cD1qu.PageMode).VIEW;
    if (isLivePage) pageMode = (0, $cD1qu.PageMode).LIVE;
    else if (isEditorPage) pageMode = (0, $cD1qu.PageMode).EDIT;
    return pageMode;
};
module.exports["useGetPageMode"] = $1874c19402f3b5d2$export$da5a0d0942eec3a4;

});

parcelRegister("htsj6", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $2PDpU = parcelRequire("2PDpU");


var $jMyy4 = parcelRequire("jMyy4");


var $jtuBN = parcelRequire("jtuBN");


var $ep3mz = parcelRequire("ep3mz");

const $feac3235d890b171$export$50af12b79850199d = (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const props = t1;
    return $feac3235d890b171$export$689c7050603c5c14(props, false);
};
const $feac3235d890b171$export$689c7050603c5c14 = ({ skip: skip = false } = {}, returnRefreshFunction = true)=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const query = (0, $2PDpU.default);
    const options = {
        skip: skip || !contentId,
        variables: {
            contentId: contentId ?? ''
        }
    };
    let result;
    if (returnRefreshFunction) // eslint-disable-next-line react-hooks/rules-of-hooks
    result = (0, $jMyy4.useQueryInterop)(query, {
        ...options,
        __callerPackage__: "page-utils"
    });
    else // eslint-disable-next-line react-hooks/rules-of-hooks
    result = (0, $jtuBN.useQueryNoFurtherUpdateInterop)(query, {
        ...options,
        __callerPackage__: "page-utils"
    });
    const { data: data, loading: loading, error: error } = result;
    const contentNode = data?.content?.nodes?.[0];
    return {
        contentStatus: contentNode?.status,
        loading: loading,
        error: error,
        refetch: result.refetch,
        type: contentNode?.type
    };
};
module.exports["useContentStatus"] = $feac3235d890b171$export$50af12b79850199d;
module.exports["useContentStatusWithRefetch"] = $feac3235d890b171$export$689c7050603c5c14;

});

parcelRegister("2PDpU", function(module, exports) {
/**
 * @generated SignedSource<<46aaf98c7fe5f9fcbf890b27644f6f9d>>
 * @relayHash 11ef6cf70fe5a26f89cf732fe25cb27f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3f9fb295906ce3d568914d192655c22003c1f01326d83359089f2ceb66026cc5
const $ac2eaa9e4c9bbbba$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "current",
                        "draft",
                        "archived"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContentStatusContentStatusQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContentStatusContentStatusQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "11ef6cf70fe5a26f89cf732fe25cb27f",
            "id": "3f9fb295906ce3d568914d192655c22003c1f01326d83359089f2ceb66026cc5",
            "metadata": {},
            "name": "useContentStatusContentStatusQuery",
            "operationKind": "query",
            "text": "query useContentStatusContentStatusQuery($contentId:ID!){content(id:$contentId,status:[\"current\",\"draft\",\"archived\"]){nodes{id,status,type}}}"
        }
    };
}();
$ac2eaa9e4c9bbbba$var$node.hash = "42fd7c46b2fddcc220c48467ae805b6e";
var $ac2eaa9e4c9bbbba$export$2e2bcd8739ae039 = $ac2eaa9e4c9bbbba$var$node;
module.exports["default"] = $ac2eaa9e4c9bbbba$export$2e2bcd8739ae039;

});

parcelRegister("cZa7r", function(module, exports) {

var $9HkI0 = parcelRequire("9HkI0");


var $cozmU = parcelRequire("cozmU");


var $cz6eP = parcelRequire("cz6eP");


var $fJCU9 = parcelRequire("fJCU9");


var $epbW8 = parcelRequire("epbW8");


var $afGoD = parcelRequire("afGoD");


var $9QIM2 = parcelRequire("9QIM2");


var $gczDe = parcelRequire("gczDe");


var $4EKKB = parcelRequire("4EKKB");


var $3YBks = parcelRequire("3YBks");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $ep3mz = parcelRequire("ep3mz");


var $8WQTF = parcelRequire("8WQTF");

const $d99a6317060f344e$export$4162754b616020bc = 2000;
const $d99a6317060f344e$export$a428e87cc7038c56 = 3500;
const $d99a6317060f344e$export$39085f26fb4d6afa = /*#__PURE__*/ (0, $cozmU.createContext)({
    selectionProps: null,
    hoverProps: null,
    viewProps: null,
    editorCreateProps: null,
    editorViewProps: null,
    showCreateComponent: false,
    showHighlightActions: false,
    selectionOptions: undefined,
    stepGenerationError: false,
    newlyCreatedAnnotationId: undefined,
    commentSidebarContext: null,
    isOffline: false,
    storedCommentData: null
});
$d99a6317060f344e$export$39085f26fb4d6afa.displayName = 'AnnotationsContext';
const $d99a6317060f344e$export$57d1b2fe9544d93c = /*#__PURE__*/ (0, $cozmU.createContext)(false);
$d99a6317060f344e$export$57d1b2fe9544d93c.displayName = 'AnnotationsOfflineContext';
const $d99a6317060f344e$export$6e641cb791644965 = /*#__PURE__*/ (0, $cozmU.createContext)({
    requestCloseEditorComment: ()=>Promise.resolve(true),
    setEditorCommentCloseGuard: ()=>{},
    setSelectionProps: ()=>{},
    setHoverProps: ()=>{},
    setViewProps: ()=>{},
    setEditorCreateProps: ()=>{},
    setEditorViewProps: ()=>{},
    setShowCreateComponent: ()=>{},
    setShowHighlightActions: ()=>{},
    setSelectionOptions: ()=>{},
    setStepGenerationError: ()=>{},
    setSelectionOptionsForCreateEditor: ()=>{},
    setNewlyCreatedAnnotationId: ()=>{},
    setCommentSidebarContext: ()=>{},
    handleSaveSuccess: ()=>{},
    handleClose: ()=>{},
    setIsOffline: ()=>{},
    setStoredCommentData: ()=>{},
    clearStoredCommentData: ()=>{},
    waitForAnnotationElementAndEmit: ()=>{},
    applyDraftModeRef: {
        current: null
    }
});
$d99a6317060f344e$export$6e641cb791644965.displayName = 'AnnotationDispatchContext';
const $d99a6317060f344e$export$567c82ef93e7d5a1 = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
$d99a6317060f344e$export$567c82ef93e7d5a1.displayName = 'AnnotationManagerContext';
const $d99a6317060f344e$export$22e6290b4a8e41d3 = ({ children: children })=>{
    const editorCommentCloseGuardRef = (0, $cozmU.useRef)(()=>Promise.resolve(true));
    const setEditorCommentCloseGuard = (0, $cozmU.useCallback)((guard)=>{
        editorCommentCloseGuardRef.current = guard;
    }, []);
    const [selectionProps, setSelectionProps] = (0, $cozmU.useState)(null);
    const selectionPropsRef = (0, $cozmU.useRef)(null);
    /** Stable ref to applyDraftMode — never cleared, so nudge click can call it synchronously
   *  without waiting for the 100ms selectionchange debounce. */ const applyDraftModeRef = (0, $cozmU.useRef)(null);
    // Keep refs in sync with state — useEffect so it never runs during render
    (0, $cozmU.useEffect)(()=>{
        selectionPropsRef.current = selectionProps;
        if (selectionProps?.applyDraftMode) applyDraftModeRef.current = selectionProps.applyDraftMode;
    }, [
        selectionProps
    ]);
    const [hoverProps, setHoverProps] = (0, $cozmU.useState)(null);
    const [viewProps, setViewProps] = (0, $cozmU.useState)(null);
    const [editorCreateProps, setEditorCreateProps] = (0, $cozmU.useState)(null);
    const [editorViewProps, setEditorViewProps] = (0, $cozmU.useState)(null);
    const editorCreatePropsRef = (0, $cozmU.useRef)(null);
    editorCreatePropsRef.current = editorCreateProps;
    const requestCloseEditorComment = (0, $cozmU.useCallback)(async ()=>{
        const editorCreatePropsAtRequest = editorCreatePropsRef.current;
        const canClose = await editorCommentCloseGuardRef.current();
        if (!canClose) return false;
        if (editorCreatePropsAtRequest) {
            if (!editorCreatePropsAtRequest.onClose) return false;
            editorCreatePropsAtRequest.onClose();
        } else setEditorViewProps(null);
        return true;
    }, []);
    const [showCreateComponent, setShowCreateComponent] = (0, $cozmU.useState)(false);
    const [showHighlightActions, setShowHighlightActions] = (0, $cozmU.useState)(false);
    const [selectionOptions, setSelectionOptions] = (0, $cozmU.useState)();
    const [stepGenerationError, setStepGenerationError] = (0, $cozmU.useState)(false);
    const [newlyCreatedAnnotationId, setNewlyCreatedAnnotationId] = (0, $cozmU.useState)();
    const [commentSidebarContext, setCommentSidebarContext] = (0, $cozmU.useState)(null);
    const [prevContentId, setPrevContentId] = (0, $cozmU.useState)(null);
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const pageClass = (0, $9QIM2.usePageClass)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const annotationManager = (0, $cozmU.useMemo)(()=>(0, $9wGTI.fg)('platform_editor_comments_api_manager') ? (0, $cz6eP.createAnnotationManager)() : undefined, []);
    // This is effectively used with editorCreateProps and editorViewProps but we're tracking it independently as it doesn't really tie into the same lifecycle events
    const [isOffline, setIsOffline] = (0, $cozmU.useState)(false);
    // Stored comment data for direct data flow
    const [storedCommentData, setStoredCommentData] = (0, $cozmU.useState)(null);
    // Track active MutationObserver and timeout for cleanup on unmount
    const activeObserverRef = (0, $cozmU.useRef)(null);
    const activeTimeoutRef = (0, $cozmU.useRef)(null);
    /**
   * Waits for an annotation element to appear in the DOM using MutationObserver,
   * then emits annotation selection events. If element doesn't appear within the wait
   * timeout, fails the VIEW_INLINE_COMMENT_EXPERIENCE.
   */ const waitForAnnotationElementAndEmit = (0, $cozmU.useCallback)((annotationId, emitter)=>{
        const waitTimeoutMs = (0, $6mKj3.expValEquals)('cc_comments_fix_annotation_element_timeout', 'isEnabled', true) ? $d99a6317060f344e$export$a428e87cc7038c56 : $d99a6317060f344e$export$4162754b616020bc;
        // Clean up any existing observer/timeout before creating new ones
        if (activeObserverRef.current) activeObserverRef.current.disconnect();
        if (activeTimeoutRef.current) clearTimeout(activeTimeoutRef.current);
        // Use MutationObserver to wait for element to appear in DOM
        activeObserverRef.current = new MutationObserver(()=>{
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const element = document.getElementById(annotationId);
            if (element) {
                if (activeObserverRef.current) activeObserverRef.current.disconnect();
                if (activeTimeoutRef.current) clearTimeout(activeTimeoutRef.current);
                activeObserverRef.current = null;
                activeTimeoutRef.current = null;
                // Emit annotation events and check if listeners exist
                if (emitter.emit((0, $fJCU9.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
                    annotationIds: [
                        annotationId
                    ],
                    eventTarget: element
                })) {
                    emitter.emit((0, $fJCU9.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, {
                        annotationId: annotationId
                    });
                    setNewlyCreatedAnnotationId(annotationId);
                } else // No listeners registered - fail the experience
                experienceTracker.fail({
                    name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                    error: new Error('Failed to emit annotation click')
                });
            }
        });
        // Observe the renderer wrapper for child additions (fallback to document.body for safety)
        const rendererWrapper = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        document.querySelector('#content .ak-renderer-wrapper') || document.body;
        activeObserverRef.current.observe(rendererWrapper, {
            childList: true,
            subtree: true
        });
        // Fallback: If element doesn't appear within timeout, fail the experience
        // This almost always happens due to super slow re-renders (slow client on large page)
        activeTimeoutRef.current = setTimeout(()=>{
            if (activeObserverRef.current) activeObserverRef.current.disconnect();
            activeObserverRef.current = null;
            activeTimeoutRef.current = null;
            experienceTracker.fail({
                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                error: new Error(`Annotation element not found in DOM after ${waitTimeoutMs}ms`)
            });
        }, waitTimeoutMs);
    }, [
        experienceTracker,
        setNewlyCreatedAnnotationId
    ]);
    // Cleanup observer and timeout on unmount
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (activeObserverRef.current) {
                activeObserverRef.current.disconnect();
                activeObserverRef.current = null;
            }
            if (activeTimeoutRef.current) {
                clearTimeout(activeTimeoutRef.current);
                activeTimeoutRef.current = null;
            }
        };
    }, []);
    // Get rendererActions for renderer mode (always call hook, but only use when feature gate is enabled)
    const rendererActionsHook = (0, $8WQTF.useRendererActions)();
    const rendererActions = rendererActionsHook?.rendererActions;
    (0, $cozmU.useEffect)(()=>{
        const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
        function handleAnnotationFocus({ annotationId: annotationId }) {
            // The fact annotations is an array here is meaningless at this time - Confluence
            // always picks the top annotation
            const focusedAnnotation = annotationId;
            if (!focusedAnnotation) {
                // If there is no running experience -- then this is a noop.
                (0, $4EKKB.selectInlineComment).debug('Renderer emitted event indicating no focused annotation.');
                return;
            }
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.complete({
                pageClass: pageClass,
                entryPoint: 'unknown:RendererFocus',
                annotationId: focusedAnnotation
            });
        }
        // Fired when an annotation is focused (ie. comment navigation, comment click)
        emitter.on((0, $fJCU9.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, handleAnnotationFocus);
        return ()=>{
            emitter.off((0, $fJCU9.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, handleAnnotationFocus);
        };
    }, [
        pageClass
    ]);
    const resetProviderState = (0, $cozmU.useCallback)(()=>{
        setSelectionProps(null);
        setHoverProps(null);
        setViewProps(null);
        setEditorCreateProps(null);
        setEditorViewProps(null);
        setShowCreateComponent(false);
        setShowHighlightActions(false);
        setSelectionOptions(undefined);
        setStepGenerationError(false);
        setNewlyCreatedAnnotationId(undefined);
        setCommentSidebarContext(null);
        setStoredCommentData(null);
    }, []);
    // When the content ID changes, reset the provider state
    (0, $cozmU.useEffect)(()=>{
        if (!contentId) return;
        if (prevContentId && contentId !== prevContentId) {
            resetProviderState();
            // Deselect any currently selected annotations
            (0, $gczDe.getRendererAnnotationEventEmitter)().emit((0, $fJCU9.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
        }
        setPrevContentId(contentId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId
    ]);
    // Stable ref for selectionOptions — updated synchronously alongside every setSelectionOptions call
    // so handleSaveSuccess always reads the latest step even when its useCallback closure is stale.
    const selectionOptionsRef = (0, $cozmU.useRef)(undefined);
    const handleClose = (0, $cozmU.useCallback)(()=>{
        setShowCreateComponent(false);
        setStepGenerationError(false);
        if ((0, $6mKj3.expVal)('confluence_inline_comments_fix_stale_selection', 'isEnabled', false)) selectionOptionsRef.current = undefined;
        setSelectionOptions(undefined);
        if (annotationManager) annotationManager.clearDraft();
        else selectionProps && selectionProps.onClose();
        setSelectionProps(null);
    }, [
        setShowCreateComponent,
        setStepGenerationError,
        setSelectionOptions,
        selectionProps,
        annotationManager
    ]);
    /*
   * NOTE: This function will not be calling setShowCreateComponent because it's
   *       consumers will not be refreshing themselves with new selectionOptions.
   *       It will now be the responsibility of the consumers of this function to call
   *       setShowCreateComponent(true). See SelectionComponent.tsx (~line 132)
   */ const setSelectionOptionsForCreateEditor = (0, $cozmU.useCallback)(({ experienceAttributes: experienceAttributes } = {})=>{
        setShowCreateComponent(false); // Hide an existing create component if it exists
        const annotationId = (0, (/*@__PURE__*/$parcel$interopDefault($9HkI0)))();
        // Narrow pageClass to 'renderer' | 'editor' for the experience attributes
        const pageClassAttr = pageClass === 'renderer' ? 'renderer' : 'editor';
        (0, $3YBks.createInlineCommentCompoundExperience).start({
            attributes: {
                pageClass: pageClassAttr,
                commentType: 'inline',
                annotationId: annotationId,
                ...experienceAttributes
            }
        });
        (0, $3YBks.createInlineCommentCompoundExperience).initExperience.start();
        let result = undefined;
        if (annotationManager) {
            const startDraftResult = annotationManager.startDraft();
            if (startDraftResult.success) result = startDraftResult.actionResult;
        } else {
            /* selectionPropsRef fallback: selectionProps (React state) may be null immediately
         after a sidebar close due to a render-cycle gap, while the ref holds the last-known
         value. Prefer the ref (updated synchronously) so nudge click always gets the freshest
         value. For experiment-OFF callers, selectionProps is non-null so ref vs state is moot. */ const currentSelectionProps = selectionPropsRef.current ?? selectionProps;
            if (!currentSelectionProps) {
                // selectionProps is not defined. This may occur if a comment sidebar box was just closed, which
                // unsets selectionProps. In this case, we treat this as no-op, and unselect any annotation.
                (0, $gczDe.getRendererAnnotationEventEmitter)().emit((0, $fJCU9.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
                // We soft-fail create-inline-comment/init experience here to track how often this occurs.
                (0, $3YBks.createInlineCommentCompoundExperience).initExperience.softFail(new Error('Attempted to create inline comment when no selection was present'));
                return;
            }
            // Reset ref before applyDraftMode so handleSaveSuccess reads the fresh step (COMMENTS-6594).
            if ((0, $6mKj3.expVal)('confluence_inline_comments_fix_stale_selection', 'isEnabled', false)) selectionOptionsRef.current = undefined;
            result = currentSelectionProps.applyDraftMode({
                annotationId: annotationId,
                keepNativeSelection: false
            });
        }
        const ancestorNodeTypes = result?.ancestorNodeTypes ?? [];
        const alphabeticalAncestorNodeTypes = [
            ...ancestorNodeTypes
        ].sort();
        (0, $3YBks.createInlineCommentCompoundExperience).addCommonAttributes({
            inlineNodeTypes: result?.inlineNodeTypes ?? [],
            ancestorNodeTypes: ancestorNodeTypes,
            alphabeticalAncestorNodeTypes: alphabeticalAncestorNodeTypes,
            // @ts-ignore
            initialPosition: [
                result?.step?.from,
                result?.step?.to
            ]
        });
        if (result) {
            const newSelectionOptions = {
                step: result.step,
                inlineNodeTypes: result.inlineNodeTypes,
                originalSelection: result.originalSelection,
                numMatches: result.numMatches,
                matchIndex: result.matchIndex,
                createdFrom: (0, $afGoD.CommentCreationLocation).RENDERER,
                pos: result.pos,
                targetNodeType: result.targetNodeType
            };
            // Update ref synchronously BEFORE setSelectionOptions so handleSaveSuccess
            // always reads the latest step even if its closure captured a stale value.
            selectionOptionsRef.current = newSelectionOptions;
            setSelectionOptions(newSelectionOptions);
            // Tell the renderer to close any currently-open comments
            (0, $gczDe.getRendererAnnotationEventEmitter)().emit((0, $fJCU9.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
            setShowHighlightActions(false);
        } else {
            setStepGenerationError(true);
            (0, $3YBks.createInlineCommentCompoundExperience).initExperience.fail(new Error('Failed to generate step'));
        }
    }, [
        selectionProps,
        setShowCreateComponent,
        setShowHighlightActions,
        setStepGenerationError,
        annotationManager,
        pageClass
    ]);
    const handleSaveSuccess = (0, $cozmU.useCallback)((annotationId, commentData)=>{
        setStepGenerationError(false);
        setCommentSidebarContext('create');
        // Set stored comment data for direct data flow when experiment is enabled
        if (commentData) setStoredCommentData(commentData);
        let result = false;
        if (annotationManager) {
            const result = annotationManager.applyDraft(annotationId);
            if (result.success && !!result.actionResult?.doc) {
                selectionProps.updateDocument && selectionProps.updateDocument(result.actionResult.doc);
                setNewlyCreatedAnnotationId(annotationId);
            } else throw new Error('Error ocurred when applying the step to the active document');
        } else {
            // When the experiment is on, read from ref to get the latest selectionOptions regardless of
            // closure staleness — the create panel may hold an old handleSaveSuccess reference from before
            // setSelectionOptions was called for the new selection, causing the stale step to be used.
            const currentSelectionOptions = selectionOptions && (0, $6mKj3.expVal)('confluence_inline_comments_fix_stale_selection', 'isEnabled', false) ? selectionOptionsRef.current ?? selectionOptions : selectionOptions;
            // Renderer mode: Try using rendererActions.applyAnnotation() first (similar to editor's annotationManager.applyDraft())
            // This provides more reliable annotation application, matching the editor implementation
            if (rendererActions && currentSelectionOptions?.step) {
                const step = currentSelectionOptions.step;
                // Extract position from step - use pos if available, otherwise use from/to
                const position = currentSelectionOptions.pos ? {
                    to: currentSelectionOptions.pos,
                    from: currentSelectionOptions.pos
                } : {
                    to: step.to,
                    from: step.from
                };
                const annotationResult = rendererActions.applyAnnotation(position, {
                    annotationId: annotationId,
                    annotationType: (0, $epbW8.AnnotationTypes).INLINE_COMMENT
                });
                if (annotationResult && annotationResult.doc) {
                    const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
                    if (!storedCommentData) selectionProps.removeDraftMode();
                    selectionProps.updateDocument && selectionProps.updateDocument(annotationResult.doc);
                    waitForAnnotationElementAndEmit(annotationId, emitter);
                } else throw new Error('Error ocurred when applying the step to the active document');
            } else {
                // Fallback to original onCreate method
                // Since we generated the uuid ourselves, we need to replace the document generated with
                // the annotationId that we received from the backend so things line up correctly
                result = selectionProps.onCreate(annotationId);
                if (result) {
                    const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
                    if (!storedCommentData) selectionProps.removeDraftMode();
                    selectionProps.updateDocument && selectionProps.updateDocument(result.doc);
                    waitForAnnotationElementAndEmit(annotationId, emitter);
                } else throw new Error('Error ocurred when applying the step to the active document');
            }
        }
    }, [
        annotationManager,
        setStepGenerationError,
        setNewlyCreatedAnnotationId,
        selectionProps,
        setStoredCommentData,
        storedCommentData,
        rendererActions,
        selectionOptions,
        waitForAnnotationElementAndEmit
    ]);
    const providerValue = (0, $cozmU.useMemo)(()=>({
            selectionProps: selectionProps,
            hoverProps: hoverProps,
            viewProps: viewProps,
            editorCreateProps: editorCreateProps,
            editorViewProps: editorViewProps,
            showCreateComponent: showCreateComponent,
            showHighlightActions: showHighlightActions,
            selectionOptions: selectionOptions,
            stepGenerationError: stepGenerationError,
            newlyCreatedAnnotationId: newlyCreatedAnnotationId,
            commentSidebarContext: commentSidebarContext,
            isOffline: isOffline,
            storedCommentData: storedCommentData
        }), [
        selectionProps,
        hoverProps,
        viewProps,
        editorCreateProps,
        editorViewProps,
        showCreateComponent,
        showHighlightActions,
        selectionOptions,
        stepGenerationError,
        newlyCreatedAnnotationId,
        commentSidebarContext,
        isOffline,
        storedCommentData
    ]);
    const dispatchProviderValue = (0, $cozmU.useMemo)(()=>({
            requestCloseEditorComment: requestCloseEditorComment,
            setEditorCommentCloseGuard: setEditorCommentCloseGuard,
            setSelectionProps: setSelectionProps,
            setHoverProps: setHoverProps,
            setViewProps: setViewProps,
            setEditorCreateProps: setEditorCreateProps,
            setEditorViewProps: setEditorViewProps,
            setShowCreateComponent: setShowCreateComponent,
            setShowHighlightActions: setShowHighlightActions,
            setSelectionOptions: setSelectionOptions,
            setStepGenerationError: setStepGenerationError,
            setSelectionOptionsForCreateEditor: setSelectionOptionsForCreateEditor,
            setNewlyCreatedAnnotationId: setNewlyCreatedAnnotationId,
            setCommentSidebarContext: setCommentSidebarContext,
            handleSaveSuccess: handleSaveSuccess,
            handleClose: handleClose,
            setIsOffline: setIsOffline,
            // Stored comment data management functions
            setStoredCommentData: (commentData)=>setStoredCommentData(commentData ?? null),
            clearStoredCommentData: ()=>setStoredCommentData(null),
            waitForAnnotationElementAndEmit: waitForAnnotationElementAndEmit,
            applyDraftModeRef: applyDraftModeRef
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        requestCloseEditorComment,
        setEditorCommentCloseGuard,
        setSelectionProps,
        setHoverProps,
        setViewProps,
        setEditorCreateProps,
        setEditorViewProps,
        setShowCreateComponent,
        setShowHighlightActions,
        setSelectionOptions,
        setStepGenerationError,
        setSelectionOptionsForCreateEditor,
        setNewlyCreatedAnnotationId,
        setCommentSidebarContext,
        handleSaveSuccess,
        handleClose,
        setIsOffline,
        // Stored comment data management functions
        setStoredCommentData,
        waitForAnnotationElementAndEmit
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d99a6317060f344e$export$567c82ef93e7d5a1.Provider, {
        value: annotationManager
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d99a6317060f344e$export$39085f26fb4d6afa.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d99a6317060f344e$export$6e641cb791644965.Provider, {
        value: dispatchProviderValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d99a6317060f344e$export$57d1b2fe9544d93c.Provider, {
        value: isOffline
    }, children))));
};
const $d99a6317060f344e$export$ede9be424e8ef89a = ()=>{
    return (0, $cozmU.useContext)($d99a6317060f344e$export$39085f26fb4d6afa);
};
const $d99a6317060f344e$export$3be336e5c3e78567 = ()=>{
    return (0, $cozmU.useContext)($d99a6317060f344e$export$6e641cb791644965);
};
const $d99a6317060f344e$export$3998d49469d13f97 = ()=>{
    return (0, $cozmU.useContext)($d99a6317060f344e$export$567c82ef93e7d5a1);
};
const $d99a6317060f344e$export$3757730e05e42ee2 = ()=>{
    return (0, $cozmU.useContext)($d99a6317060f344e$export$57d1b2fe9544d93c);
};
module.exports["AnnotationsProvider"] = $d99a6317060f344e$export$22e6290b4a8e41d3;
module.exports["useAnnotations"] = $d99a6317060f344e$export$ede9be424e8ef89a;
module.exports["useAnnotationsDispatch"] = $d99a6317060f344e$export$3be336e5c3e78567;
module.exports["useAnnotationManager"] = $d99a6317060f344e$export$3998d49469d13f97;
module.exports["useAnnotationsIsOffline"] = $d99a6317060f344e$export$3757730e05e42ee2;

});

parcelRegister("afGoD", function(module, exports) {
/**
 * @generated SignedSource<<71be4194137313c8ff0872a3df259dda>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $f8b43d46712cd783$export$cdccd0683766be81 = /*#__PURE__*/ function(CommentCreationLocation) {
    CommentCreationLocation["DATABASE"] = "DATABASE";
    CommentCreationLocation["EDITOR"] = "EDITOR";
    CommentCreationLocation["LIVE"] = "LIVE";
    CommentCreationLocation["RENDERER"] = "RENDERER";
    CommentCreationLocation["WHITEBOARD"] = "WHITEBOARD";
    return CommentCreationLocation;
}({});
var $f8b43d46712cd783$export$f4016897b165b6d5 = /*#__PURE__*/ function(ContentRepresentation) {
    ContentRepresentation["ATLAS_DOC_FORMAT"] = "ATLAS_DOC_FORMAT";
    ContentRepresentation["EDITOR"] = "EDITOR";
    ContentRepresentation["EDITOR2"] = "EDITOR2";
    ContentRepresentation["EXPORT_VIEW"] = "EXPORT_VIEW";
    ContentRepresentation["PLAIN"] = "PLAIN";
    ContentRepresentation["RAW"] = "RAW";
    ContentRepresentation["STORAGE"] = "STORAGE";
    ContentRepresentation["STYLED_VIEW"] = "STYLED_VIEW";
    ContentRepresentation["VIEW"] = "VIEW";
    ContentRepresentation["WIKI"] = "WIKI";
    return ContentRepresentation;
}({});
var $f8b43d46712cd783$export$2dffd0b5373a4389 = /*#__PURE__*/ function(Platform) {
    Platform["ANDROID"] = "ANDROID";
    Platform["IOS"] = "IOS";
    Platform["WEB"] = "WEB";
    return Platform;
}({});
var $f8b43d46712cd783$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["CommentCreationLocation"] = $f8b43d46712cd783$export$cdccd0683766be81;
module.exports["ContentRepresentation"] = $f8b43d46712cd783$export$f4016897b165b6d5;

});

parcelRegister("9QIM2", function(module, exports) {

var $de2j9 = parcelRequire("de2j9");


var $3jwuS = parcelRequire("3jwuS");


var $dPJCf = parcelRequire("dPJCf");


var $gEtAQ = parcelRequire("gEtAQ");

function $06d23c10422abe2f$export$d9ae12e82c9f2aba() {
    // Note -- this hook does not inform the consumer if they are on a live doc page which
    // is using the editor.
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    const isCurrentPageLive = (0, $3jwuS.useIsCurrentPageLive)();
    // useRouteName use RoutesContext which is more reliable than reading window.location.pathname directly.
    const routeName = (0, $dPJCf.useRouteName)({
        selector: (name)=>name
    });
    if (isEditorPage) return 'editor';
    if (isCurrentPageLive) return 'editor';
    const isTinyMCEPage = $06d23c10422abe2f$var$__checkIfTinyMCEEditorPage();
    if (isTinyMCEPage) // TinyMCE pages are not considered editor pages or docs in the context of this hook
    return 'tinyMCE';
    // Pass routeName to isDatabase/isWhiteboard - they will use it to avoid race conditions during SPA transitions
    if ((0, $gEtAQ.isDatabase)(routeName)) return 'database';
    if ((0, $gEtAQ.isWhiteboard)(routeName)) return 'whiteboard';
    if ((0, $gEtAQ.isSlides)(routeName)) return 'slide';
    return 'renderer';
}
function $06d23c10422abe2f$var$__checkIfTinyMCEEditorPage() {
    const possibleTinyMCESelectors = [
        `[data-testid="TinyMCERendererTestId"]`,
        '.tinymce-editor'
    ];
    // This check is only relevant in the context of comment experiences
    // and so if we are in an environment without a document -- we
    // can safely treat it as not a tinymce page.
    if (typeof document === 'undefined') return false;
    const isTinyMCEPage = possibleTinyMCESelectors.some(// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    (selector)=>document.querySelector(selector) !== null);
    return isTinyMCEPage;
}
module.exports["usePageClass"] = $06d23c10422abe2f$export$d9ae12e82c9f2aba;

});

parcelRegister("4EKKB", function(module, exports) {
/* eslint-disable import-extensions/file-extension-required */ 
var $gykrH = parcelRequire("gykrH");


var $irVI7 = parcelRequire("irVI7");


var $aJPUt = parcelRequire("aJPUt");


var $fGzMp = parcelRequire("fGzMp");


var $8Ss4E = parcelRequire("8Ss4E");

let $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {};
function $d671aa981fcb4da6$var$getSelectInlineCommentExperienceDebug(_experienceName, experienceStage) {
    function createInlineCommentExperienceDebug({ error: error, extraAttributes: extraAttributes }) {
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        experienceTracker.attachDebugPoint({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            message: `Legacy select debug message: ${error.message || String(error)}`,
            attributes: {
                ...$d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes,
                ...extraAttributes,
                experienceStage: experienceStage
            }
        });
    }
    return createInlineCommentExperienceDebug;
}
var $d671aa981fcb4da6$var$ExperienceType = /*#__PURE__*/ function(ExperienceType) {
    ExperienceType["DOCUMENT"] = "document";
    ExperienceType["DOCUMENT_WITH_PANEL"] = "documentWithPanel";
    ExperienceType["PANEL"] = "panel";
    return ExperienceType;
}($d671aa981fcb4da6$var$ExperienceType || {});
function $d671aa981fcb4da6$var$getExperienceType(entryPoint, sidebarOpenAtStart) {
    switch(entryPoint){
        case 'create-comment':
        case 'comment-navigation':
        case 'unknown:InlineComment':
            return "document";
        case 'annotation-change':
        case 'keyboard-navigation':
        case 'unknown:RendererFocus':
            return sidebarOpenAtStart ? "documentWithPanel" : "document";
        case 'sidebar':
        case 'unknown:CommentsPanelList':
            return "panel";
        default:
            return "document";
    }
}
const $d671aa981fcb4da6$export$e2b3aff7888f2745 = {
    _start: (startAttributes, _options)=>{
        if (startAttributes.pageClass === 'tinyMCE' || startAttributes.pageClass === 'database' || startAttributes.pageClass === 'whiteboard' || startAttributes.pageClass === 'slide') return;
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        const experienceState = experienceTracker.getExperienceState((0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE));
        const runningExperienceAttributes = experienceState?.attributes;
        if (!experienceState?.hasStopped && runningExperienceAttributes?.annotationId !== undefined && runningExperienceAttributes?.annotationId === startAttributes.annotationId) {
            // If there is an existing (unstopped) experience
            // - and that experience has an annotationId
            //   - keyboard and comment navigation will start experiences without an annotationId -- and these should be restarted on an new start
            // - and that annotationId matches the one in the startAttributes
            // we assume the experience is still active, and don't start a new one.
            // the reason we can hit this is because the selectInlineCommentCompoundExperience._start is called when there is a "select inline comment"
            // signal, and individual signals fire in different orders (sometimes they are the first signal, sometimes they are later).
            // However -- if the second signal has a clearer entry point
            // we update the entry point attribute of the existing experience.
            if (runningExperienceAttributes?.entryPoint?.startsWith('unknown') && !startAttributes.entryPoint.startsWith('unknown')) {
                $d671aa981fcb4da6$export$e2b3aff7888f2745.addCommonAttributes({
                    entryPoint: startAttributes.entryPoint
                });
                experienceTracker.attachDebugPoint({
                    name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                    message: `After starting from ${runningExperienceAttributes.entryPoint}, received signal from ${startAttributes.entryPoint}`
                });
            }
            return;
        }
        if (// When the side bar is open, and the user selects a comment using the keyboard,
        // the keyboard navigation triggers a select annotation first (without an annotationId),
        // followed by the show comment start or select annotation complete (with an annotationId.
        startAttributes.entryPoint === 'unknown:CommentsPanelList' && runningExperienceAttributes?.entryPoint === 'keyboard-navigation' && runningExperienceAttributes?.annotationId === undefined) {
            $d671aa981fcb4da6$export$e2b3aff7888f2745.addCommonAttributes({
                annotationId: startAttributes.annotationId
            });
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                message: `After starting from ${runningExperienceAttributes.entryPoint}, received signal from ${startAttributes.entryPoint} with annotationId ${startAttributes.annotationId}`
            });
            return;
        }
        // First prepare the new attributes without modifying the global state
        // This ensures that any abort of current experiences will use their original attributes
        const newAttributes = {
            pageClass: startAttributes.pageClass,
            commentType: startAttributes.commentType,
            annotationId: 'annotationId' in startAttributes ? startAttributes.annotationId : undefined,
            entryPoint: startAttributes.entryPoint,
            version: 'single-experience'
        };
        // We check if there is a dom element with a testId of "object-sidebar-panel-body" and if so mark the
        // experience as being during a sidebar open experience.
        newAttributes.sidebarOpenAtStart = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        document.querySelector('[data-testid="object-sidebar-panel-body"]') !== null;
        newAttributes.experienceType = $d671aa981fcb4da6$var$getExperienceType(startAttributes.entryPoint, newAttributes.sidebarOpenAtStart);
        // If the create inline comment experience is running, we want to link the two experiences
        const createInlineCommentExperienceState = experienceTracker.getExperienceState((0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE));
        if (createInlineCommentExperienceState && !createInlineCommentExperienceState.hasStopped) newAttributes.linkedCompoundTaskId = createInlineCommentExperienceState.attributes?.compoundTaskId;
        // Adds a debug point to the last running experience (debug points are only added if there is a running experience)
        // Note:
        // A new experience is followed after this is fired -- so this should always be the last debug point (as the new experience will trigger a fail or abort).
        // In the case there is no running experience, the experience tracker will discard the debugPoint.
        experienceTracker.attachDebugPoint({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            message: `Restarted from ${startAttributes.entryPoint} with annotationId: ${startAttributes.annotationId} (sidebarOpenAtStart: ${newAttributes.sidebarOpenAtStart})`
        });
        // Start press trace if no trace is currently active
        (0, $8Ss4E.startUFOPressTrace)((0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE));
        // Then start a new compound experience with the new attributes
        // This will abort any running experiences with the same name, but they'll keep their original attributes
        experienceTracker.start({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            attributes: {
                ...newAttributes
            },
            // If the annotation is not selected and comment shown to the user within 12 seconds -- we assume there has been a failure to select the inline comment
            timeout: (0, $aJPUt.ExperienceTimeout).SELECT_INLINE_COMMMENT,
            collect: (events)=>{
                const isThisCommentBeingResolved = (event)=>{
                    return event.name === (0, $irVI7.RESOLVE_INLINE_COMMENT_EXPERIENCE) && event.action === 'taskStart' && (0, $gykrH.hasAttribute)(event, 'annotationId', $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes.annotationId);
                };
                events.forEach((event)=>{
                    if (isThisCommentBeingResolved(event)) $d671aa981fcb4da6$export$e2b3aff7888f2745.abort({
                        abortReason: 'Comment being resolved'
                    });
                });
            }
        });
        if (startAttributes.annotationId === undefined) experienceTracker.attachDebugPoint({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            message: `selectInlineCommentCompoundExperience._start started from ${startAttributes.entryPoint} with unknown annotationId`
        });
        else experienceTracker.attachDebugPoint({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            message: `selectInlineCommentCompoundExperience._start started from ${startAttributes.entryPoint} with annotationId ${startAttributes.annotationId}`
        });
        // Now it's safe to update the global state since any aborts have already happened
        // We reset experience state if we are starting a new experience
        $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {
            ...newAttributes
        };
        // By the time we get a task fail (particularly for timeout aborts) -- the contentId may have changed
        const originalContentId = experienceTracker.getExperienceState((0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE))?.attributes?.contentId;
        $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes.originalContentId = originalContentId;
        experienceTracker.updateAttributes({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            attributes: {
                originalContentId: originalContentId
            }
        });
    },
    debugPoint: (message, attributes)=>{
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        experienceTracker.attachDebugPoint({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            message: message,
            attributes: attributes
        });
        experienceTracker.attachDebugPoint({
            name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
            message: message,
            attributes: attributes
        });
    },
    addCommonAttributes: (additionalCommonAttributes)=>{
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {
            ...$d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes,
            ...additionalCommonAttributes
        };
        experienceTracker.updateAttributes({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            attributes: additionalCommonAttributes
        });
    },
    abort: ({ abortReason: abortReason })=>{
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        experienceTracker.abort({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            reason: abortReason,
            checkForTimeout: true
        });
        $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {};
    },
    selectAnnotation: {
        debug: $d671aa981fcb4da6$var$getSelectInlineCommentExperienceDebug((0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE), 'selectAnnotation'),
        /**
     * This is currently used to start from
     * - annotationId unknown
     *   - comment navigation
     *   - keyboard navigation
     * - annotationId known
     *   - create comment
     *   - comment sidebar comment selection
     *
     * These should be separate signals once the multi experience is deprecated.
     */ start: (startAttributes)=>{
            function isUnknownAnnotationId(startAttributes) {
                return startAttributes.entryPoint === 'keyboard-navigation' || startAttributes.entryPoint === 'comment-navigation';
            }
            if (isUnknownAnnotationId(startAttributes)) {
                $d671aa981fcb4da6$export$e2b3aff7888f2745._start(startAttributes, {
                    annotationUnknown: true
                });
                return;
            }
            $d671aa981fcb4da6$export$e2b3aff7888f2745._start(startAttributes);
        },
        abort: ({ abortReason: abortReason })=>{
            $d671aa981fcb4da6$export$e2b3aff7888f2745.abort({
                abortReason: // @ts-ignore the abort reasons have mismatch due to type from the old multi experience. and once that is removed we can remove this cast
                abortReason
            });
            $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {};
        },
        /**
     * Note -- the selectAnnotation does not trigger a completion of the selectInlineComment experience.
     * Instead -- the selectInlineComment experience is completed when the showComment experience completes
     * (which looks for the selected annotation as part of its completion logic).
     *
     * With the single experience -- this is less a complete and rather just an indirect signal that a selection has been made (in case it's not detected by the showComment experience).
     * When the multi selectInlineCommentCompoundExperience is deprecated, this can be renamed to indicate it's a "annotationSelection" signal rather than a "completed" signal.
     */ complete: (startAttributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            const experienceState = experienceTracker.getExperienceState((0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE));
            // There can be cases where no start has been called for the select experience.
            // - When a product consumer of the editor setselectedannotation api calls the select experience
            //   and has not been instrumented.
            // - When the annotation selection is via editor logic (ie. editor selection being moved onto
            //   an annotation).
            if (experienceState === null) {
                experienceTracker.attachDebugPoint({
                    name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                    message: 'selectAnnotation completed from no experience - no explicit start point',
                    attributes: startAttributes
                });
                $d671aa981fcb4da6$export$e2b3aff7888f2745._start(startAttributes);
            }
        }
    },
    showComment: {
        debug: $d671aa981fcb4da6$var$getSelectInlineCommentExperienceDebug((0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE), 'showComment'),
        debugPoint: (message, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                message: message,
                attributes: attributes
            });
        },
        start: (startAttributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            $d671aa981fcb4da6$export$e2b3aff7888f2745._start(startAttributes);
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                message: 'showComment start triggered',
                attributes: startAttributes
            });
        },
        abort: ({ abortReason: abortReason })=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.abort({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                reason: abortReason
            });
            $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {};
        },
        fail: (error, extraAttributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.fail({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                error: error,
                attributes: {
                    ...$d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes,
                    ...extraAttributes
                }
            });
            $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {};
        },
        complete: (completedFrom)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.succeed({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                attributes: {
                    completedFrom: completedFrom,
                    ...$d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes
                }
            });
            $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {};
        },
        standaloneSidebarComplete: (commentUIVerticalDistanceFromAnnotation)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                message: `standaloneSidebarComplete triggered`
            });
            if (commentUIVerticalDistanceFromAnnotation > 40) experienceTracker.attachDebugPoint({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                message: `Comment UI is misaligned by >40px pixels`,
                attributes: {
                    misalignedBy: commentUIVerticalDistanceFromAnnotation
                }
            });
            if (typeof $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes.annotationId !== 'string') {
                experienceTracker.fail({
                    name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                    error: new Error('selectInlineCommentCompoundExperience.standaloneSidebarComplete called when no annotationId was known'),
                    attributes: $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes
                });
                return;
            }
            if (!$d671aa981fcb4da6$var$__checkAnnotationVisibleAndFocused($d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes.annotationId)) experienceTracker.fail({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                error: new Error(`selectInlineCommentCompoundExperience.standaloneSidebarComplete ended without a focused and in viewport annotation.`),
                attributes: $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes
            });
            experienceTracker.succeed({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                attributes: {
                    completedFrom: 'Standalone sidebar inline comment selection completed',
                    ...$d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes
                }
            });
        },
        sidePanelComplete: ()=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                message: `sidePanelComplete triggered`
            });
            if (typeof $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes.annotationId !== 'string') {
                experienceTracker.fail({
                    name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                    error: new Error('selectInlineCommentCompoundExperience.sidePanelComplete called when no annotationId was known'),
                    attributes: $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes
                });
                return;
            }
            if (!$d671aa981fcb4da6$var$__checkAnnotationVisibleAndFocused($d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes.annotationId)) experienceTracker.fail({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                error: new Error('selectInlineCommentCompoundExperience.sidePanelComplete did not result in a visible and focused annotation'),
                attributes: $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes
            });
            experienceTracker.succeed({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                attributes: {
                    completedFrom: 'Side Panel inline comment selection completed',
                    ...$d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes
                }
            });
        }
    }
};
/**
 *
 * Checks if there is an annotation currently visible in the document.
 *
 * The comment UI is currently opinionated about the comment UI being attached to the first instance of the focused annotation element.
 *
 * So we can safely skip checking if the initial focused annotation is not visible
 *
 * Note: this method causes reflow, and should not be used in performance sensitive code.
 *
 */ function $d671aa981fcb4da6$var$__checkAnnotationVisibleAndFocused(annotationId) {
    const experienceTracker = (0, $fGzMp.getExperienceTracker)();
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const possibleFocusedAnnotationElements = document.querySelectorAll(// This will match the annotation id in either the Editor or Renderer
    `[data-id="${annotationId}"][data-mark-annotation-type="inlineComment"][data-has-focus="true"],
		[data-id="${annotationId}"][data-mark-annotation-type="inlineComment"] .ak-editor-annotation-focus`);
    if (possibleFocusedAnnotationElements.length === 0) {
        experienceTracker.attachDebugPoint({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            message: `No annotation element found`
        });
        return false;
    }
    /**
   * Annotations can have multiple elements in the dom, with each of the elements having the focus state set to true.
   * Ie. Comments spanning multiple lines will have multiple elements with the focus state set to true.
   *
   * In addition to this -- sometimes there will be "hidden" focused annotation elements where the dom is duplicated
   * such as for annotations on table header cells in the renderer.
   *
   * If the first element is not visible due to being hidden, we continue checking until we reach a visible element, and then check whether it is in the viewport.
   *
   */ for(let i = 0; i < possibleFocusedAnnotationElements.length; i++){
        const element = possibleFocusedAnnotationElements[i];
        if (element instanceof HTMLElement) {
            if (!element.checkVisibility()) {
                // Skip to the next element if the current one is not visible
                // This can happen in scenarios where the dom is duplicated, such as for annotations on table header cells in the renderer.
                experienceTracker.attachDebugPoint({
                    name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                    message: `Annotation element had a hidden focused element, skipping to next element`
                });
                continue;
            }
            const rect = element.getBoundingClientRect();
            const isVisible = rect.top >= 0 && rect.left >= 0 && // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            rect.right <= (window.innerWidth || document.documentElement.clientWidth);
            // This is the first visible element -- which should be focused and
            // in the viewport
            if (isVisible) return true;
            else {
                experienceTracker.attachDebugPoint({
                    name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                    message: `Annotation element found - but not in viewport`
                });
                return false;
            }
        }
    }
    return false;
}
const $d671aa981fcb4da6$export$b65d55854b7eb069 = {
    debug: $d671aa981fcb4da6$export$e2b3aff7888f2745.debugPoint
};
module.exports["selectInlineCommentCompoundExperience"] = $d671aa981fcb4da6$export$e2b3aff7888f2745;
module.exports["selectInlineComment"] = $d671aa981fcb4da6$export$b65d55854b7eb069;

});

parcelRegister("3YBks", function(module, exports) {

var $kyKWe = parcelRequire("kyKWe");


var $irVI7 = parcelRequire("irVI7");


var $fGzMp = parcelRequire("fGzMp");


var $1A7bE = parcelRequire("1A7bE");

let $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes = {};
let $3ac00da98b683ca3$var$runningExperiences = [];
// Note: The soft failure is set on the first soft failure not updated following
let $3ac00da98b683ca3$var$softFailure = undefined;
let $3ac00da98b683ca3$var$publishFailed = false;
let $3ac00da98b683ca3$var$publishSuccessCount = 0;
function $3ac00da98b683ca3$var$getCreateInlineCommentExperienceDebug(experienceName) {
    function createInlineCommentExperienceDebug({ error: error, createAnalyticsEvent: createAnalyticsEvent, extraAttributes: extraAttributes }) {
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        const experienceAttributes = experienceTracker.getExperienceState((0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE));
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'error',
                actionSubject: (0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE),
                source: experienceName,
                attributes: {
                    ...experienceAttributes,
                    ...$3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes,
                    ...extraAttributes,
                    error: error.message || String(error),
                    stack: error.stack
                }
            }
        }).fire();
    }
    return createInlineCommentExperienceDebug;
}
const $3ac00da98b683ca3$export$90894e50be2305e9 = {
    start: function createInlineCommentCompoundExperience({ attributes: attributes }) {
        // reset common experience state when starting a new parent experience
        $3ac00da98b683ca3$var$runningExperiences = [
            (0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE)
        ];
        $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes = {};
        $3ac00da98b683ca3$var$softFailure = undefined;
        $3ac00da98b683ca3$var$publishFailed = false;
        $3ac00da98b683ca3$var$publishSuccessCount = 0;
        const compoundTaskId = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        experienceTracker.start({
            name: (0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE),
            id: compoundTaskId,
            attributes: {
                ...attributes,
                compoundTaskId: compoundTaskId
            },
            collect: (events, experience)=>{
                (0, $1A7bE.collectAll)([
                    (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                    (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE)
                ])(events, experience);
            }
        });
        $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes = {
            compoundTaskId: compoundTaskId,
            annotationId: attributes.annotationId,
            pageClass: attributes.pageClass,
            entryPoint: attributes.entryPoint,
            edition: attributes.edition
        };
    },
    debug: $3ac00da98b683ca3$var$getCreateInlineCommentExperienceDebug((0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE)),
    addCommonAttributes: (commonAttributes)=>{
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes = {
            ...$3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes,
            ...commonAttributes
        };
        for (const runningExperience of $3ac00da98b683ca3$var$runningExperiences)experienceTracker.updateAttributes({
            name: runningExperience,
            attributes: $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes
        });
    },
    attachCommonAttributes: (experienceName)=>{
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        experienceTracker.updateAttributes({
            name: experienceName,
            attributes: $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes
        });
    },
    initExperience: {
        start: ()=>{
            $3ac00da98b683ca3$var$runningExperiences.push((0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE));
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.start({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                timeout: 5000,
                attributes: {
                    ...$3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes
                }
            });
            $3ac00da98b683ca3$export$90894e50be2305e9.attachCommonAttributes((0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE));
        },
        fail: (error)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.fail({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                error: error
            });
        },
        softFail: (error)=>{
            if (!$3ac00da98b683ca3$var$softFailure) $3ac00da98b683ca3$var$softFailure = {
                error: error,
                pointOfFailure: 'init'
            };
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.succeed({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                attributes: {
                    softFailure: error.message
                }
            });
        },
        abort: ({ abortReason: abortReason, attributes: attributes })=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.abort({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                reason: abortReason,
                attributes: attributes
            });
        },
        /**
     * This completes the init experience and starts the draft to publish experience.
     */ complete: ()=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.succeed({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE)
            });
        },
        debug: $3ac00da98b683ca3$var$getCreateInlineCommentExperienceDebug((0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE)),
        debugPoint: (message, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                message: message,
                attributes: attributes
            });
        }
    },
    draftToPublishExperience: {
        start: ()=>{
            $3ac00da98b683ca3$var$runningExperiences.push((0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE));
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.start({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                attributes: $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes
            });
            $3ac00da98b683ca3$export$90894e50be2305e9.attachCommonAttributes((0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE));
        },
        publishFailed: (error)=>{
            $3ac00da98b683ca3$var$publishFailed = true;
            if (!$3ac00da98b683ca3$var$softFailure) $3ac00da98b683ca3$var$softFailure = {
                error: error,
                pointOfFailure: 'publish-failed'
            };
        },
        publishSucceeded: ()=>{
            $3ac00da98b683ca3$var$publishSuccessCount += 1;
        },
        abort: ({ abortReason: abortReason, attributes: attributes })=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.abort({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                reason: abortReason,
                attributes: attributes
            });
        },
        fail: (error, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.fail({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                error: error,
                attributes: attributes
            });
        },
        stopOnError: (error, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.stopOnError({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                error: error,
                attributes: attributes
            });
        },
        dismissed: ()=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            if ($3ac00da98b683ca3$var$publishSuccessCount > 0) experienceTracker.fail({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                error: new Error('Draft comment dismissed after publish success')
            });
            else if ($3ac00da98b683ca3$var$publishFailed) experienceTracker.fail({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                error: new Error('Draft comment dismissed after publish attempt')
            });
            else experienceTracker.abort({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                reason: 'Draft comment dismissed'
            });
        },
        softFail: (error)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            if (!$3ac00da98b683ca3$var$softFailure) $3ac00da98b683ca3$var$softFailure = {
                error: error,
                pointOfFailure: 'multiple-saves-without-error'
            };
            experienceTracker.succeed({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                attributes: {
                    softFailure: error.message
                }
            });
        },
        complete: ()=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            if ($3ac00da98b683ca3$var$softFailure) {
                experienceTracker.succeed({
                    name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                    attributes: {
                        softFailure: $3ac00da98b683ca3$var$softFailure.error.message,
                        pointOfFailure: $3ac00da98b683ca3$var$softFailure.pointOfFailure
                    }
                });
                return;
            }
            experienceTracker.succeed({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE)
            });
        },
        debug: $3ac00da98b683ca3$var$getCreateInlineCommentExperienceDebug((0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE)),
        debugPoint: (message, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                message: message,
                attributes: attributes
            });
        }
    },
    attachCommentExperience: {
        start: ()=>{
            $3ac00da98b683ca3$var$runningExperiences.push((0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE));
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.start({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE),
                // If the view comment does not load in 6 seconds, it's
                // an indicator something has gone wrong.
                timeout: 6000,
                attributes: $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes
            });
            $3ac00da98b683ca3$export$90894e50be2305e9.attachCommonAttributes((0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE));
        },
        fail: (error, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.fail({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE),
                error: error,
                attributes: attributes
            });
        },
        complete: ()=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            if ($3ac00da98b683ca3$var$softFailure) {
                experienceTracker.succeed({
                    name: (0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE),
                    attributes: {
                        softFailure: $3ac00da98b683ca3$var$softFailure.error.message,
                        pointOfFailure: $3ac00da98b683ca3$var$softFailure.pointOfFailure
                    }
                });
                return;
            }
            experienceTracker.succeed({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE)
            });
        },
        debug: $3ac00da98b683ca3$var$getCreateInlineCommentExperienceDebug((0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE)),
        debugPoint: (message, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE),
                message: message,
                attributes: attributes
            });
        }
    }
};
module.exports["createInlineCommentCompoundExperience"] = $3ac00da98b683ca3$export$90894e50be2305e9;

});

parcelRegister("8WQTF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $4677820b18a14e4d$export$66feffbad722f9d4 = /*#__PURE__*/ (0, $cozmU.createContext)({
    rendererActions: null,
    pageId: undefined,
    pageAdf: undefined
});
$4677820b18a14e4d$export$66feffbad722f9d4.displayName = 'RendererActionsContext';
const $4677820b18a14e4d$export$c7c5640cf8aff722 = /*#__PURE__*/ (0, $cozmU.createContext)({
    setRendererActions: ()=>{},
    setPageAdf: ()=>{}
});
$4677820b18a14e4d$export$c7c5640cf8aff722.displayName = 'RendererActionsDispatchContext';
const $4677820b18a14e4d$export$a41bfe8d4028fb59 = ({ children: children })=>{
    const [rendererActions, setRendererActions] = (0, $cozmU.useState)(null);
    const [pageId, setPageId] = (0, $cozmU.useState)(undefined);
    const [pageAdf, setPageAdf] = (0, $cozmU.useState)(undefined);
    const providerValue = (0, $cozmU.useMemo)(()=>({
            rendererActions: rendererActions,
            pageId: pageId,
            pageAdf: pageAdf
        }), [
        rendererActions,
        pageId,
        pageAdf
    ]);
    const dispatchProviderValue = (0, $cozmU.useMemo)(()=>({
            setRendererActions: (actions, newPageId)=>{
                setRendererActions(actions);
                setPageId(newPageId);
            },
            setPageAdf: (newPageAdf)=>{
                setPageAdf(newPageAdf);
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4677820b18a14e4d$export$66feffbad722f9d4.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4677820b18a14e4d$export$c7c5640cf8aff722.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $4677820b18a14e4d$export$55249bdd00e8a5d6 = ()=>{
    return (0, $cozmU.useContext)($4677820b18a14e4d$export$66feffbad722f9d4);
};
const $4677820b18a14e4d$export$6e9863dfedeaae60 = ()=>{
    return (0, $cozmU.useContext)($4677820b18a14e4d$export$c7c5640cf8aff722);
};
module.exports["RendererActionsProvider"] = $4677820b18a14e4d$export$a41bfe8d4028fb59;
module.exports["useRendererActions"] = $4677820b18a14e4d$export$55249bdd00e8a5d6;
module.exports["useRendererActionsDispatch"] = $4677820b18a14e4d$export$6e9863dfedeaae60;

});

parcelRegister("dANtQ", function(module, exports) {

var $i1slQ = parcelRequire("i1slQ");


var $6ozxE = parcelRequire("6ozxE");



var $jtuBN = parcelRequire("jtuBN");

const $be6154107952d370$var$useAddCommentPermissionCheckPermissionCheckAddCommentQuery = (0, $i1slQ.default);
const $be6154107952d370$var$noOpRefetch = ()=>Promise.resolve();
const $be6154107952d370$export$4cae5d8963399c48 = (contentId, // Retained for callers that pass preloaded permissions as the third argument.
_cacheOnly = false, preloadedCanAddComments)=>{
    const baseOptions = {
        skip: !contentId || preloadedCanAddComments !== undefined
    };
    const status = [
        'draft',
        'current'
    ];
    const { data: data, loading: loading, error: error, networkStatus: networkStatus } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)($be6154107952d370$var$useAddCommentPermissionCheckPermissionCheckAddCommentQuery, {
        ...baseOptions,
        variables: {
            contentId: contentId,
            status: status
        },
        skipFetchIfCached: false,
        __callerPackage__: "comments-hooks"
    });
    const createPermission = (0, $6ozxE.canAddCommentsFromOperations)(data?.content?.nodes?.[0]?.operations);
    return {
        canAddComments: preloadedCanAddComments ?? createPermission,
        loading: preloadedCanAddComments === undefined ? loading : false,
        contentQueryError: preloadedCanAddComments === undefined ? error : undefined,
        refetch: $be6154107952d370$var$noOpRefetch,
        networkStatus: networkStatus
    };
};
module.exports["useAddCommentPermissionCheck"] = $be6154107952d370$export$4cae5d8963399c48;

});

parcelRegister("i1slQ", function(module, exports) {
/**
 * @generated SignedSource<<5821fd331c47db168316a2c3a4e69985>>
 * @relayHash f2ed22cac79248fed29ace7669709d01
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 624f6c98a1c2b9a83cb2c19aecdae78adfcdabf9f4d3d08dad00de2c6cff9369
const $fc06507f37418bb6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useAddCommentPermissionCheckPermissionCheckAddCommentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useAddCommentPermissionCheckPermissionCheckAddCommentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "f2ed22cac79248fed29ace7669709d01",
            "id": "624f6c98a1c2b9a83cb2c19aecdae78adfcdabf9f4d3d08dad00de2c6cff9369",
            "metadata": {},
            "name": "useAddCommentPermissionCheckPermissionCheckAddCommentQuery",
            "operationKind": "query",
            "text": "query useAddCommentPermissionCheckPermissionCheckAddCommentQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$fc06507f37418bb6$var$node.hash = "60c40f4780bf1c488b0028e9d219e3d4";
var $fc06507f37418bb6$export$2e2bcd8739ae039 = $fc06507f37418bb6$var$node;
module.exports["default"] = $fc06507f37418bb6$export$2e2bcd8739ae039;

});

parcelRegister("cMvMc", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $f2899d935411e961$export$fb31a121515f224d = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "_Vqh0",
    name: "CommentWarningDialog",
    loader: async ()=>(await (parcelRequire("7NKS7"))).CommentWarningDialog
});
module.exports["CommentWarningDialog"] = $f2899d935411e961$export$fb31a121515f224d;

});

parcelRegister("7NKS7", function(module, exports) {

let $5ae177c72d819b7b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $5ae177c72d819b7b$var$load("hhss7"),
    $5ae177c72d819b7b$var$load("cqNU4")
]).then(()=>parcelRequire('9c4UU'));

});

parcelRegister("2BAFx", function(module, exports) {
class $d32907502a426d2e$var$DialogKeyState {
    get nextKey() {
        return this._nextKey++;
    }
    set nextKey(newKey) {
        if (newKey > this._nextKey) this._nextKey = newKey;
    }
    constructor(){
        this._nextKey = 0;
    }
}
const $d32907502a426d2e$export$2e170616461fb3b6 = new $d32907502a426d2e$var$DialogKeyState();
module.exports["dialogKeyState"] = $d32907502a426d2e$export$2e170616461fb3b6;

});

parcelRegister("bSvtO", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $45ca38ec521afdf7$var$initialState = {
    hasContentChanged: false,
    isCommentContentReady: false
};
const $45ca38ec521afdf7$export$53ac33307b5acee9 = ()=>({
        hasContentChanged: false,
        isCommentContentReady: false
    });
const $45ca38ec521afdf7$export$e324594224ef24da = {
    onChange: (hasChanges)=>({ setState: setState })=>{
            setState({
                hasContentChanged: hasChanges
            });
        },
    resetContentChanged: ()=>({ setState: setState })=>{
            setState({
                hasContentChanged: false
            });
        },
    onCommentContentReady: ()=>({ setState: setState })=>{
            setState({
                isCommentContentReady: true
            });
        }
};
const $45ca38ec521afdf7$var$CommentsContentStore = (0, $8s9DV.createStore)({
    initialState: $45ca38ec521afdf7$var$initialState,
    actions: $45ca38ec521afdf7$export$e324594224ef24da,
    name: 'CommentsContentStore'
});
const $45ca38ec521afdf7$export$ef1bfc0b6758ca67 = (0, $kBr4q.createHook)($45ca38ec521afdf7$var$CommentsContentStore);
const $45ca38ec521afdf7$export$e2038e591f93e866 = (0, $kBr4q.createActionsHook)($45ca38ec521afdf7$var$CommentsContentStore);
const $45ca38ec521afdf7$export$1756d05b0495e6b = (0, $kBr4q.createStateHook)($45ca38ec521afdf7$var$CommentsContentStore);
module.exports["useCommentsContentActions"] = $45ca38ec521afdf7$export$e2038e591f93e866;
module.exports["useCommentsContentState"] = $45ca38ec521afdf7$export$1756d05b0495e6b;

});

parcelRegister("2wo33", function(module, exports) {

var $cFXjQ = parcelRequire("cFXjQ");


var $9Z22p = parcelRequire("9Z22p");


var $6mKj3 = parcelRequire("6mKj3");


var $jMyy4 = parcelRequire("jMyy4");


var $c0rhi = parcelRequire("c0rhi");




var $63cta = parcelRequire("63cta");


var $5rZJf = parcelRequire("5rZJf");

const $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0 = ({ operationCheckResult: operationCheckResult, operation: operation, contentType: contentType })=>{
    const permittedOperations = operationCheckResult?.content?.nodes?.[0]?.operations ?? [];
    const targetContentType = !!contentType ? contentType : operationCheckResult?.content?.nodes?.[0]?.type;
    if (!targetContentType) return false;
    return permittedOperations.some((permittedOperation)=>permittedOperation?.operation === operation && permittedOperation?.targetType === targetContentType);
};
const $fec7e6ab8c349d98$export$9df6fd1dd45ee771 = ({ operationCheckResult: operationCheckResult, operation: operation, contentType: contentType })=>{
    // prettier-ignore
    const permittedOperations = operationCheckResult?.space?.operations ?? [];
    return permittedOperations.some((permittedOperation)=>permittedOperation?.operation === operation && permittedOperation?.targetType === contentType);
};
const $fec7e6ab8c349d98$export$e1260b60fe3f2784 = async ({ contentId: contentId, operation: operation, contentType: contentType })=>{
    const contentOperationsQueryResult = await (0, $c0rhi.queryInterop)({
        ...(0, $6mKj3.expValEquals)('confluence_content_operations_cache_first', 'cohort', 'experiment') ? {
            query: (0, $63cta.ContentOperationsQuery),
            variables: {
                contentId: contentId,
                status: [
                    'current',
                    'archived',
                    'draft'
                ]
            },
            fetchPolicy: 'cache-first'
        } : {
            query: (0, $63cta.ContentOperationsQuery),
            variables: {
                contentId: contentId
            }
        },
        __callerPackage__: "entity-operations"
    });
    return $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0({
        operationCheckResult: contentOperationsQueryResult.data,
        operation: operation,
        contentType: contentType
    });
};
const $fec7e6ab8c349d98$export$bcbdef0ac5f1ac47 = async ({ spaceKey: spaceKey, operation: operation, contentType: contentType })=>{
    const spaceOperationsQueryResult = await (0, $c0rhi.queryInterop)({
        query: (0, $5rZJf.SpaceOperationsQuery),
        variables: {
            spaceKey: spaceKey
        },
        ...(0, $6mKj3.expValEquals)('confluence_content_operations_cache_first', 'cohort', 'experiment') ? {
            fetchPolicy: 'cache-first'
        } : {},
        __callerPackage__: "entity-operations"
    });
    return $fec7e6ab8c349d98$export$9df6fd1dd45ee771({
        operationCheckResult: spaceOperationsQueryResult.data,
        operation: operation,
        contentType: contentType
    });
};
const $fec7e6ab8c349d98$export$301dbe403ac05dd5 = ({ contentId: contentId, operation: operation, contentType: contentType, status: status })=>{
    const graphQLResult = (0, $jMyy4.useQueryInterop)((0, $9Z22p.default), {
        ...(0, $6mKj3.expValEquals)('confluence_content_operations_cache_first', 'cohort', 'experiment') ? {
            variables: {
                contentId: contentId,
                status: status ?? [
                    'current',
                    'archived',
                    'draft'
                ]
            },
            skip: !contentId,
            fetchPolicy: 'cache-first'
        } : {
            variables: {
                contentId: contentId,
                status: status
            },
            skip: !contentId
        },
        __callerPackage__: "entity-operations"
    });
    if (!contentId) return false;
    if (graphQLResult?.data) return $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0({
        operationCheckResult: graphQLResult?.data,
        operation: operation,
        contentType: contentType
    });
    return undefined;
};
const $fec7e6ab8c349d98$export$1fefcc1c89f32022 = ({ spaceKey: spaceKey, operation: operation, contentType: contentType, skip: skip })=>{
    const graphQLResult = (0, $jMyy4.useQueryInterop)((0, $cFXjQ.default), {
        variables: {
            spaceKey: spaceKey
        },
        skip: skip,
        ...(0, $6mKj3.expValEquals)('confluence_content_operations_cache_first', 'cohort', 'experiment') ? {
            fetchPolicy: 'cache-first'
        } : {},
        __callerPackage__: "entity-operations"
    });
    // Only show the publish button if the user has permission to update (edit) this content.
    let canPerformOperation = undefined;
    if (graphQLResult?.data) canPerformOperation = $fec7e6ab8c349d98$export$9df6fd1dd45ee771({
        operationCheckResult: graphQLResult?.data,
        operation: operation,
        contentType: contentType
    });
    return [
        canPerformOperation,
        graphQLResult
    ];
};
module.exports["canPerformSpaceOperation"] = $fec7e6ab8c349d98$export$9df6fd1dd45ee771;
module.exports["useCanPerformContentOperation"] = $fec7e6ab8c349d98$export$301dbe403ac05dd5;
module.exports["useCanPerformSpaceOperation"] = $fec7e6ab8c349d98$export$1fefcc1c89f32022;

});

parcelRegister("cFXjQ", function(module, exports) {
/**
 * @generated SignedSource<<1341e8100a34db255d375a90f5c4a762>>
 * @relayHash 66373ccec9c74286b704fa866e6f85ed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1ee10eaaf4a09a28378f0b27b016e5e12099f96dcd1c9b62be99a779fa6ee76b
const $718578d961a6d231$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "66373ccec9c74286b704fa866e6f85ed",
            "id": "1ee10eaaf4a09a28378f0b27b016e5e12099f96dcd1c9b62be99a779fa6ee76b",
            "metadata": {},
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "operationKind": "query",
            "text": "query entityOperationsHelpersSpaceOperationsQuery($spaceKey:String!){space(key:$spaceKey){id,operations{operation,targetType}}}"
        }
    };
}();
$718578d961a6d231$var$node.hash = "e5daa0845f1390f74a58e4fd57f9defb";
var $718578d961a6d231$export$2e2bcd8739ae039 = $718578d961a6d231$var$node;
module.exports["default"] = $718578d961a6d231$export$2e2bcd8739ae039;

});

parcelRegister("9Z22p", function(module, exports) {
/**
 * @generated SignedSource<<48d9ee7fb5d606ab817066b5f7172f92>>
 * @relayHash 74ad4c4ef681c6629c8477bfc21dc6ca
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e69bbb2b0dd0e8b95fa91edf2f1ffa8bb8da1c6cfb861cc292fe957f3d509a58
const $16467728a654d6f6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "entityOperationsHelpersContentOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "entityOperationsHelpersContentOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "74ad4c4ef681c6629c8477bfc21dc6ca",
            "id": "e69bbb2b0dd0e8b95fa91edf2f1ffa8bb8da1c6cfb861cc292fe957f3d509a58",
            "metadata": {},
            "name": "entityOperationsHelpersContentOperationsQuery",
            "operationKind": "query",
            "text": "query entityOperationsHelpersContentOperationsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$16467728a654d6f6$var$node.hash = "0a581f032f7c1b6232f4634d5c3d1376";
var $16467728a654d6f6$export$2e2bcd8739ae039 = $16467728a654d6f6$var$node;
module.exports["default"] = $16467728a654d6f6$export$2e2bcd8739ae039;

});

parcelRegister("63cta", function(module, exports) {

var $8r0lJ = parcelRequire("8r0lJ");

const $bc89d0f4a052c761$export$a42cd9ccc4f06e9e = (0, $8r0lJ.default);
module.exports["ContentOperationsQuery"] = $bc89d0f4a052c761$export$a42cd9ccc4f06e9e;

});

parcelRegister("8r0lJ", function(module, exports) {
/**
 * @generated SignedSource<<d4c33eb851813f5d8bdf7b8ddf9d7fb7>>
 * @relayHash afd2c148a694798349dbf7c95e9faf5e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e41235331832b6af4916acf0b3dea69070b782e8f0b6bcb6aed8527d9e43767a
const $9494deed8cae7257$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "afd2c148a694798349dbf7c95e9faf5e",
            "id": "e41235331832b6af4916acf0b3dea69070b782e8f0b6bcb6aed8527d9e43767a",
            "metadata": {},
            "name": "ContentOperationsQuery",
            "operationKind": "query",
            "text": "query ContentOperationsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$9494deed8cae7257$var$node.hash = "4ac4e53f1dd0ba665b3f48217ce7b74b";
var $9494deed8cae7257$export$2e2bcd8739ae039 = $9494deed8cae7257$var$node;
module.exports["default"] = $9494deed8cae7257$export$2e2bcd8739ae039;

});

parcelRegister("5rZJf", function(module, exports) {

var $3QLqz = parcelRequire("3QLqz");

const $8e7057c5d2ae7999$export$636a01496687d185 = (0, $3QLqz.default);
module.exports["SpaceOperationsQuery"] = $8e7057c5d2ae7999$export$636a01496687d185;

});

parcelRegister("3QLqz", function(module, exports) {
/**
 * @generated SignedSource<<eaa114c9e42c98e4d30da80006b4df1f>>
 * @relayHash 5ff0445d5306228126745d8454e82696
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b5af55847710c9021d37adc7a1741b87998b677f5f9dd136a0e2b9050e1c6ea6
const $5b7055a8a77b29df$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "5ff0445d5306228126745d8454e82696",
            "id": "b5af55847710c9021d37adc7a1741b87998b677f5f9dd136a0e2b9050e1c6ea6",
            "metadata": {},
            "name": "SpaceOperationsQuery",
            "operationKind": "query",
            "text": "query SpaceOperationsQuery($spaceKey:String!){space(key:$spaceKey){id,operations{operation,targetType}}}"
        }
    };
}();
$5b7055a8a77b29df$var$node.hash = "5796c3a83a0773d6d932bd63d2fbf511";
var $5b7055a8a77b29df$export$2e2bcd8739ae039 = $5b7055a8a77b29df$var$node;
module.exports["default"] = $5b7055a8a77b29df$export$2e2bcd8739ae039;

});

parcelRegister("4L9ve", function(module, exports) {
/**
 * Sweet state store for processed comments data.
 * This store should ONLY be updated by CommentsDataBackgroundLoader.
 * All other consumers should use the state/actions hooks to read data.
 */ 
var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

var $c6StJ = parcelRequire("c6StJ");


var $kgNLQ = parcelRequire("kgNLQ");

const $20eb19f7ec5706e8$export$53ac33307b5acee9 = ()=>({
        lastProcessedData: null,
        allComments: [],
        allFilteredComments: [],
        openInlineComments: [],
        openFooterComments: [],
        resolvedComments: [],
        openComments: [],
        commentsDataMap: {
            inline: {},
            general: {}
        },
        flatCommentsMap: {},
        flatMarkerRefMap: {},
        hasNestedComments: false,
        isDataProcessed: false,
        commentCount: 0,
        hasAnyComments: false,
        error: undefined,
        refetch: undefined
    });
const $20eb19f7ec5706e8$export$e324594224ef24da = {
    /**
	 * Updates all processed comments data.
	 * WARNING: This should ONLY be called by CommentsDataBackgroundLoader.
	 * Note: refetch is set separately via setRefetch, so it's not included here.
	 */ setProcessedData: (data)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...data,
                error: undefined,
                // Keep existing refetch if it exists, don't overwrite it
                refetch: currentState.refetch
            });
        },
    /**
	 * Sets an error state for processed comments data.
	 * WARNING: This should ONLY be called by CommentsDataBackgroundLoader.
	 */ setError: (error)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                error: error,
                isDataProcessed: true
            });
        },
    /**
	 * Clears error and resets isDataProcessed to initial values.
	 * Skips setState when already at initial values to avoid unnecessary re-renders.
	 * WARNING: This should ONLY be called by CommentsDataBackgroundLoader.
	 */ clearErrorAndResetIsDataProcessed: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const initialState = $20eb19f7ec5706e8$export$53ac33307b5acee9();
            if (currentState.error === initialState.error && currentState.isDataProcessed === initialState.isDataProcessed) return;
            setState({
                ...currentState,
                error: initialState.error,
                isDataProcessed: initialState.isDataProcessed
            });
        },
    /**
	 * Sets isDataProcessed to true without changing other state.
	 * Only updates if isDataProcessed is currently false to prevent unnecessary re-renders.
	 * WARNING: This should ONLY be called by CommentsDataBackgroundLoader.
	 */ setDataToProcessed: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isDataProcessed) return;
            setState({
                ...currentState,
                isDataProcessed: true
            });
        },
    /**
	 * Sets the refetch function from useAllCommentsData.
	 * WARNING: This should ONLY be called by CommentsDataBackgroundLoader.
	 */ setRefetch: (refetch)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                refetch: refetch
            });
        },
    /**
	 * Clears all processed comments data and resets to initial state.
	 * WARNING: This should ONLY be called by CommentsDataBackgroundLoader.
	 */ clearProcessedData: ()=>({ setState: setState })=>{
            setState($20eb19f7ec5706e8$export$53ac33307b5acee9());
        },
    /**
	 * Processes the raw comments data if it hasn't already been processed and updates the store with
	 * categorized comments. Can be used with output from useAllCommentsData() hook (that is, the full
	 * comments data query result) or the full comments data cache (for when we need to synchronously
	 * process updated cache data).
	 *
	 * Note that for Apollo GQL, if the data hasn't changed then readQuery() will return the same
	 * data reference as the full comment query does. So it is safe to compare data references from
	 * real queries and cache reads to avoid unnecessary reprocessing.
	 *
	 */ // TODO: Verify the data reference behavior for Relay GQL when we start enabling Relay support.
    processCommentsData: ({ data: data, pageMode: pageMode })=>({ setState: setState, getState: getState })=>{
            // Nothing to process if data is null
            if (!data) return null;
            // Don't process the same data twice - if the data reference is the same as the last processed
            const currentState = getState();
            if (currentState.isDataProcessed && currentState.lastProcessedData === data) return null;
            // Filter out null nodes and create array (empty array if no data)
            const allComments = (data?.comments?.nodes || []).filter((node)=>node !== null);
            // Categorize comments using default contentStatus filters
            const contentStatusFilters = (0, $kgNLQ.buildDefaultCommentsContentStatusFilters)(pageMode);
            const categorizedData = (0, $kgNLQ.categorizeComments)(allComments, contentStatusFilters);
            // Update the store with categorized comments
            setState({
                ...currentState,
                ...categorizedData,
                allComments: allComments,
                lastProcessedData: data,
                error: undefined,
                isDataProcessed: true
            });
            return {
                total: categorizedData.allFilteredComments.length,
                openInline: categorizedData.openInlineComments.length,
                openFooter: categorizedData.openFooterComments.length,
                open: categorizedData.openComments.length,
                resolved: categorizedData.resolvedComments.length,
                totalIncludingReplies: Object.keys(categorizedData.flatCommentsMap).length,
                markerRef: Object.keys(categorizedData.flatMarkerRefMap).length
            };
        }
};
const $20eb19f7ec5706e8$export$4be6ac988c62a591 = (0, $8s9DV.createStore)({
    initialState: $20eb19f7ec5706e8$export$53ac33307b5acee9(),
    actions: $20eb19f7ec5706e8$export$e324594224ef24da,
    name: 'ProcessedCommentsDataStore'
});
const $20eb19f7ec5706e8$export$421cff7071854c91 = (0, $kBr4q.createHook)($20eb19f7ec5706e8$export$4be6ac988c62a591);
const $20eb19f7ec5706e8$export$2919c8d01260d4fe = (0, $kBr4q.createActionsHook)($20eb19f7ec5706e8$export$4be6ac988c62a591);
const $20eb19f7ec5706e8$export$93d43ef0fc9d136b = (0, $kBr4q.createStateHook)($20eb19f7ec5706e8$export$4be6ac988c62a591);
// Non-React utility for accessing store outside of React components
const $20eb19f7ec5706e8$var$processedCommentsDataStoreInstance = (0, $c6StJ.defaultRegistry).getStore($20eb19f7ec5706e8$export$4be6ac988c62a591);
const $20eb19f7ec5706e8$export$db6951977b558d4d = ()=>{
    return $20eb19f7ec5706e8$var$processedCommentsDataStoreInstance.storeState.getState();
};
const $20eb19f7ec5706e8$export$ae4b56ccf0bbe776 = ()=>{
    return $20eb19f7ec5706e8$var$processedCommentsDataStoreInstance.actions;
};
module.exports["useProcessedCommentsData"] = $20eb19f7ec5706e8$export$421cff7071854c91;
module.exports["useProcessedCommentsDataActions"] = $20eb19f7ec5706e8$export$2919c8d01260d4fe;
module.exports["useProcessedCommentsDataState"] = $20eb19f7ec5706e8$export$93d43ef0fc9d136b;
module.exports["getProcessedCommentsDataState"] = $20eb19f7ec5706e8$export$db6951977b558d4d;
module.exports["getProcessedCommentsDataActions"] = $20eb19f7ec5706e8$export$ae4b56ccf0bbe776;

});

parcelRegister("9jl6v", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $cozmU = parcelRequire("cozmU");


var $l0zDh = parcelRequire("l0zDh");


var $aHcFH = parcelRequire("aHcFH");


var $9FoVw = parcelRequire("9FoVw");


var $i49vP = parcelRequire("i49vP");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4EKKB = parcelRequire("4EKKB");

const $427c50c01d3953e2$export$87eb11c3f8007b3b = /*#__PURE__*/ (0, $cozmU.createContext)({
    createComment: ()=>{},
    clearCreateHighlight: ()=>{},
    onHighlightClick: ()=>{},
    toggleSidebar: ()=>{},
    setResolvedComment: ()=>{},
    setActiveHighlight: ()=>{},
    navigateToInlineComment: ()=>{}
});
$427c50c01d3953e2$export$87eb11c3f8007b3b.displayName = 'InlineCommentsDispatchContext';
const $427c50c01d3953e2$export$e6352a1cdc05c52c = /*#__PURE__*/ (0, $cozmU.createContext)({
    newCommentHighlight: undefined,
    highlightOrigin: 'userHighlight',
    activeHighlight: null,
    firstHighlightClicked: false,
    shouldDisplaySidebar: false,
    resolvedComment: null
});
$427c50c01d3953e2$export$e6352a1cdc05c52c.displayName = 'InlineCommentsContext';
const $427c50c01d3953e2$export$f54686667fb05777 = ({ children: children })=>{
    const [newCommentHighlight, setNewCommentHighlight] = (0, $cozmU.useState)();
    const [highlightOrigin, setHighlightOrigin] = (0, $cozmU.useState)('userHighlight');
    /**
   * We eventually want this value to be the official state for loading/displaying
   * the UI for inline comments. InlineCommentSidebar and some child components have created
   * stateful logic (active highlight, isSidebarShown, etc) that assumes
   * the code is always loaded which we will eventually adjust.
   */ const [shouldDisplaySidebar, setShouldDisplaySidebar] = (0, $cozmU.useState)(false);
    const firstHighlightClicked = (0, $cozmU.useRef)(false);
    const [activeHighlight, setActiveHighlight] = (0, $cozmU.useState)(null);
    const [resolvedComment, setResolvedComment] = (0, $cozmU.useState)(null);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const providerValue = (0, $cozmU.useMemo)(()=>({
            newCommentHighlight: newCommentHighlight,
            highlightOrigin: highlightOrigin,
            activeHighlight: activeHighlight,
            resolvedComment: resolvedComment,
            firstHighlightClicked: firstHighlightClicked.current,
            shouldDisplaySidebar: shouldDisplaySidebar
        }), [
        activeHighlight,
        highlightOrigin,
        newCommentHighlight,
        resolvedComment,
        shouldDisplaySidebar,
        firstHighlightClicked
    ]);
    const dispatchProviderValue = (0, $cozmU.useMemo)(()=>({
            createComment: (newHighlight, origin = 'userHighlight')=>{
                /**
       * Creating a comment is one of the three user explicit scenarios
       * where we want to load inline comments code.
       */ setShouldDisplaySidebar(true);
                setNewCommentHighlight(newHighlight);
                setHighlightOrigin(origin);
                if (resolvedComment) setResolvedComment(null);
            },
            clearCreateHighlight: ()=>setNewCommentHighlight(undefined),
            onHighlightClick: (markerRef)=>{
                if (!firstHighlightClicked.current) firstHighlightClicked.current = true;
                /**
       * Clicking on a highlight is one of the three user explicit scenarios
       * where we want to load inline comments code.
       */ if (markerRef) setShouldDisplaySidebar(true);
                else setShouldDisplaySidebar(false);
                setActiveHighlight(markerRef);
            },
            setResolvedComment: setResolvedComment,
            toggleSidebar: (shouldDisplay)=>setShouldDisplaySidebar(shouldDisplay),
            setActiveHighlight: setActiveHighlight,
            navigateToInlineComment: ({ action: action, triggeredByKeyboardShortcut: triggeredByKeyboardShortcut, currentCommentIndex: currentCommentIndex, onNavigationClick: onNavigationClick, getCommentIndex: getCommentIndex, isEditor: isEditor, removeCommentQueryParams: removeCommentQueryParams, unresolvedInlineComments: unresolvedInlineComments, createAnalyticsEvent: createAnalyticsEvent, contentId: contentId, isNavigateToNextUnread: isNavigateToNextUnread, unreadInlineComments: unreadInlineComments = [], unreadGeneralComments: unreadGeneralComments = [], footerComments: footerComments = [], scrollToFooterComment: scrollToFooterComment, commentsDataMap: commentsDataMap })=>{
                (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
                    navigationAction: action
                });
                const couldBeNavigatingToFooterComment = triggeredByKeyboardShortcut && footerComments?.length > 0;
                if (unresolvedInlineComments?.length < 2 && !couldBeNavigatingToFooterComment) {
                    (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.abort({
                        abortReason: 'Comment navigation when only one comment'
                    });
                    experienceTracker.abort({
                        name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                        reason: 'Comment navigation when only one comment',
                        checkForTimeout: true,
                        publishDebugPoints: true,
                        attributes: {
                            stopPoint: 'comment-context/InlineCommentsContext'
                        }
                    });
                    return;
                }
                // Clear the focusedCommentId queryParams so that reply does not opens up if any...
                removeCommentQueryParams();
                const combinedInlineFooterComments = [
                    ...unresolvedInlineComments,
                    ...footerComments
                ];
                let nextThreadKey = '';
                let currentThreadKey = '';
                if (triggeredByKeyboardShortcut) {
                    if (isNavigateToNextUnread) {
                        // Add 1 to currentCommentIndex to move to the next comment, otherwise it gets stuck on the current comment
                        const nextIndex = currentCommentIndex + 1;
                        nextThreadKey = (0, $aHcFH.getNextUnreadThreadKey)(nextIndex, combinedInlineFooterComments, [
                            ...unreadInlineComments,
                            ...unreadGeneralComments
                        ]) ?? '';
                    } else nextThreadKey = (0, $aHcFH.getNextMarkerRef)(action, currentCommentIndex, combinedInlineFooterComments) ?? '';
                    currentThreadKey = combinedInlineFooterComments[currentCommentIndex];
                } else {
                    nextThreadKey = (0, $aHcFH.getNextMarkerRef)(action, currentCommentIndex, unresolvedInlineComments) ?? '';
                    currentThreadKey = unresolvedInlineComments[currentCommentIndex];
                }
                if (!nextThreadKey) {
                    (0, $4EKKB.selectInlineComment).debug(`Couldn't find next annotation to select in document`);
                    return;
                }
                (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
                    annotationId: nextThreadKey
                });
                if (triggeredByKeyboardShortcut) {
                    if (footerComments.includes(nextThreadKey) && scrollToFooterComment && commentsDataMap?.general?.[nextThreadKey]) {
                        setActiveHighlight(null);
                        scrollToFooterComment(nextThreadKey);
                        (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.abort({
                            abortReason: 'Navigating to general comment'
                        });
                        return;
                    }
                }
                const nextCommentElement = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                document.getElementById(nextThreadKey) || // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                document.getElementById(`footer-comment-thread-${nextThreadKey}-container`);
                if (nextCommentElement) (0, $i49vP.checkElementExpandInEditor)(nextCommentElement);
                else (0, $4EKKB.selectInlineComment).debug('No annotation found in doc to check if in expand');
                onNavigationClick(nextThreadKey);
                const nextCommentIndex = getCommentIndex(nextThreadKey);
                const enableOnArrowNavigation = !triggeredByKeyboardShortcut;
                // Handle scrolling navigation
                if (enableOnArrowNavigation) (0, $9FoVw.handleInlineHeaderArrowsNavigation)({
                    previousMarkerRef: currentThreadKey,
                    nextMarkerRef: nextThreadKey,
                    context: isEditor ? (0, $9FoVw.NavigationContext).EDITOR : (0, $9FoVw.NavigationContext).RENDERER,
                    action: action,
                    nextCommentIndex: nextCommentIndex,
                    totalComments: unresolvedInlineComments.length
                });
                if (nextCommentElement) {
                    // As we navigate inline comments with arrow icons, we want to update the cursor location to where the open inline comment is
                    // unless it is a media node in which case, we want our selection to be the media node element.
                    const media = nextCommentElement.querySelector(`.${(0, $l0zDh.ClassNames).MEDIA_CONTAINER}`);
                    if (media) {
                        (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
                            commentType: 'block',
                            blockType: 'media'
                        });
                        enableOnArrowNavigation && window.getSelection()?.setPosition(media);
                    } else {
                        (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
                            commentType: 'inline'
                        });
                        enableOnArrowNavigation && window.getSelection()?.setPosition(nextCommentElement);
                    }
                }
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'clicked',
                        actionSubject: 'navigate',
                        actionSubjectId: 'inlineCommentArrowsNavigate',
                        attributes: {
                            triggeredByKeyboardShortcut: triggeredByKeyboardShortcut,
                            action: action
                        },
                        objectType: 'inlineComment',
                        objectId: contentId,
                        source: isEditor ? 'editPageScreen' : 'renderPageScreen'
                    }
                }).fire();
            }
        }), [
        resolvedComment,
        firstHighlightClicked,
        setShouldDisplaySidebar,
        setHighlightOrigin,
        setResolvedComment,
        setActiveHighlight,
        experienceTracker
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($427c50c01d3953e2$export$e6352a1cdc05c52c.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($427c50c01d3953e2$export$87eb11c3f8007b3b.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $427c50c01d3953e2$export$89bc450b4e1563a9 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $cozmU.useContext)($427c50c01d3953e2$export$e6352a1cdc05c52c);
} : ()=>{
    return (0, $cozmU.useContext)($427c50c01d3953e2$export$e6352a1cdc05c52c);
};
const $427c50c01d3953e2$export$43e36990fc9d516b = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $cozmU.useContext)($427c50c01d3953e2$export$87eb11c3f8007b3b);
} : ()=>{
    return (0, $cozmU.useContext)($427c50c01d3953e2$export$87eb11c3f8007b3b);
};
module.exports["InlineCommentsProvider"] = $427c50c01d3953e2$export$f54686667fb05777;
module.exports["useInlineCommentsContext"] = $427c50c01d3953e2$export$89bc450b4e1563a9;
module.exports["useInlineCommentsDispatchContext"] = $427c50c01d3953e2$export$43e36990fc9d516b;

});

parcelRegister("aHcFH", function(module, exports) {

var $1d2ww = parcelRequire("1d2ww");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $cD1qu = parcelRequire("cD1qu");


var $i49vP = parcelRequire("i49vP");

const $a78c261c3211f7d6$export$d2bdbdaa2c26e7f7 = 'inline-create-comment-selection';
const $a78c261c3211f7d6$export$b803c692fbaaa5a4 = 'inline-highlight';
const $a78c261c3211f7d6$export$fb3d0eebfe85522a = 'active-highlight';
const $a78c261c3211f7d6$export$b899b07e3f725968 = ()=>{
    const commentData = {
        commentIndex: undefined,
        totalComments: undefined
    };
    if (window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']) {
        commentData['commentIndex'] = Number(window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']['position']);
        commentData['totalComments'] = Number(window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']['totalComments']);
    }
    return commentData;
};
const $a78c261c3211f7d6$export$1f7acceb752add79 = (pageMode)=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const marks = Array.from(document.querySelectorAll($a78c261c3211f7d6$export$8c7b048437c01388(pageMode))).map((node)=>{
        if (pageMode === 'edit') return node.id;
        else return $a78c261c3211f7d6$export$8f4213b45c05ab5d(node);
    });
    /* In case of overlapping comments there will be multiple tags with the same markerRefs. We need to remove
  duplicates in that case so we can navigate between comments correctly */ return new Set(marks);
};
const $a78c261c3211f7d6$export$9b48c18cc387f791 = (markerRefList, pageMode = 'view')=>{
    const distinctMarks = [
        ...$a78c261c3211f7d6$export$1f7acceb752add79(pageMode)
    ];
    return distinctMarks.filter((mark)=>mark && markerRefList.includes(mark));
};
const $a78c261c3211f7d6$export$8c7b048437c01388 = (pageMode = 'view')=>{
    if (pageMode === 'edit') return "[annotationtype='inlineComment']";
    else return '[data-mark-annotation-type="inlineComment"], .inline-comment-marker';
};
const $a78c261c3211f7d6$export$f7ceeb7ba8156450 = ()=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const activeHighlights = document.querySelectorAll(`.${$a78c261c3211f7d6$export$fb3d0eebfe85522a}`);
    activeHighlights.forEach((activeHighlight)=>{
        activeHighlight.classList.remove($a78c261c3211f7d6$export$fb3d0eebfe85522a);
    });
};
const $a78c261c3211f7d6$var$getNextTextNodeOld = (node, boundingParentNode)=>{
    let currentNode = node;
    let nextTextNode = currentNode?.nextSibling;
    // If the node has no next sibling, grab it's parent's next sibling until we find a node
    while(!nextTextNode){
        nextTextNode = currentNode?.parentElement?.nextSibling;
        if (nextTextNode) {
            // WS-2551 - If the bounding parent exists and we're out of bounds of it, we're done looking
            if (boundingParentNode && !boundingParentNode.contains(nextTextNode)) {
                nextTextNode = null;
                break;
            }
            // If we've landed on a text node, then break out
            if (nextTextNode.nodeType === Node.TEXT_NODE) break;
            // If the node exists and it's a hard break (<br />), we do one of two things:
            //   1. If it has a bounding parent, break out because the <br /> signifies the end of the selection
            //   2. If not, then move to the next sibling because we don't count hard breaks in selections
            if (nextTextNode?.tagName === 'BR') {
                if (boundingParentNode) break;
                else nextTextNode = nextTextNode.nextSibling;
            }
        } else // If the text node we tried to access is null, we need to jump up a generation
        currentNode = currentNode?.parentNode;
    }
    // Search for the first text node in the next node
    while(nextTextNode && nextTextNode.nodeType !== Node.TEXT_NODE)nextTextNode = nextTextNode.firstChild;
    return nextTextNode;
};
const $a78c261c3211f7d6$export$3e98291f1f032a77 = (currentNode, boundingNode, isInlineMark)=>{
    let nextTextNode = isInlineMark ? currentNode : currentNode?.nextSibling;
    while(nextTextNode && nextTextNode.nodeType !== Node.TEXT_NODE){
        // If the text node is the bounding node, return that node
        if (boundingNode && nextTextNode?.isSameNode(boundingNode)) return nextTextNode;
        // Check if the node is a hard break (<br />) or an element with role="presentation" we do one of two things:
        if (nextTextNode?.tagName === 'BR') {
            // If it has a bounding parent, break out because the <br /> signifies the end of the selection
            if (boundingNode) return nextTextNode;
            // If not, then move to the next sibling because we don't count hard breaks in selections
            nextTextNode = nextTextNode.nextSibling;
        } else if (nextTextNode?.attributes?.getNamedItem('role')?.value === 'presentation') // If the element has role="presentation", move to the parent element's sibling because this current node does not contain a text node
        nextTextNode = nextTextNode.parentNode?.nextSibling;
        else if ($a78c261c3211f7d6$var$isEmojiNode(nextTextNode)) {
            // If we encounter an emoji and it's also the bounding node, return nothing
            if (boundingNode && nextTextNode?.isSameNode(boundingNode)) return null;
            // Otherwise, just return the node after it and keep going
            nextTextNode = nextTextNode.nextSibling;
        } else // Otherwise, search for the first text node in the next node
        nextTextNode = nextTextNode.firstChild;
    }
    // If we've found the text node, return that node
    if (nextTextNode?.nodeType === Node.TEXT_NODE) return nextTextNode;
    // If the text node we tried to access is null, we need to jump up a generation
    if (!nextTextNode) return $a78c261c3211f7d6$export$3e98291f1f032a77(currentNode?.parentNode, boundingNode);
};
const $a78c261c3211f7d6$var$extractTextNodesIntoRangesOld = (selectedRange)=>{
    const rangesToHighlight = [];
    const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = selectedRange;
    // NOTE: It's not possible for us to get here with anything other than "#text" nodes
    //       for the start container due to our highlighting restrictions, so we only
    //       need to check the type for endContainer when we get a selected range
    // WS-2551 - Triple clicks are the only thing that can cause the endContainer to be a non-text node
    const isTripleClick = endContainer.nodeType !== Node.TEXT_NODE;
    // If the start and end containers don't match, we need to loop through and extract
    // the text nodes out all common elements and create ranges to represent each of them
    if (!startContainer.isSameNode(endContainer)) {
        let boundingParentNode;
        // Push the starting node into a range
        const startingRange = new Range();
        startingRange.setStart(startContainer, startOffset);
        startingRange.setEnd(startContainer, startContainer.length);
        rangesToHighlight.push(startingRange);
        // WS-2551 - In the case of a triple click, we only want to contain our selection to the
        // first non-comment parent wrapping the starting container to ensure we don't over select
        if (isTripleClick) {
            boundingParentNode = startContainer.parentNode;
            while(!boundingParentNode || boundingParentNode.nodeType === Node.TEXT_NODE || $a78c261c3211f7d6$export$8f4213b45c05ab5d(boundingParentNode) !== null)boundingParentNode = boundingParentNode?.parentNode;
        } else {
            // Push the ending node into a range only if it's not a triple click
            const endingRange = new Range();
            endingRange.setStart(endContainer, 0);
            endingRange.setEnd(endContainer, endOffset);
            rangesToHighlight.push(endingRange);
        }
        // Iterate through all the inner nodes and extract the text ranges
        let node = $a78c261c3211f7d6$var$getNextTextNodeOld(startContainer, boundingParentNode);
        while(node && !node.isSameNode(endContainer) && node.nodeType === Node.TEXT_NODE){
            if (node.length) {
                const range = new Range();
                range.selectNodeContents(node);
                rangesToHighlight.push(range);
            }
            node = $a78c261c3211f7d6$var$getNextTextNodeOld(node, boundingParentNode);
        }
    } else // If they are the same container it's much simpler and we can just use the range
    rangesToHighlight.push(selectedRange);
    return rangesToHighlight;
};
const $a78c261c3211f7d6$var$isEmojiNode = (node)=>{
    if (!node) return false;
    const attributes = node?.attributes;
    const classList = node?.classList;
    return attributes && attributes.getNamedItem('data-emoji-id') || classList && classList.contains('emoji-common-node');
};
const $a78c261c3211f7d6$var$extractTextNodesIntoRanges = (selectedRange)=>{
    const rangesToHighlight = [];
    const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = selectedRange;
    // NOTE: It's not possible for us to get here with anything other than "#text" nodes
    //       for the start container due to our highlighting restrictions, so we only
    //       need to check the type for endContainer when we get a selected range
    // The endContainer is a non-text node when the user either:
    // 1. Triple clicks a node
    // 2. Highlights a header
    // 3. The highlight goes to the next node but does not actually highlight anything (offset === 0)
    const isNonTextNodeEndContainer = endContainer.nodeType !== Node.TEXT_NODE;
    // If highlight is just one node (i.e. same containers), it's much simpler and we can just use the range
    if (startContainer.isSameNode(endContainer)) {
        rangesToHighlight.push(selectedRange);
        return rangesToHighlight;
    }
    // If the start and end containers don't match, we need to loop through and extract
    // the text nodes out all common elements and create ranges to represent each of them
    let boundingNode;
    // Push the starting node into a range
    const startingRange = new Range();
    startingRange.setStart(startContainer, startOffset);
    startingRange.setEnd(startContainer, startContainer.length);
    rangesToHighlight.push(startingRange);
    // In the case of a non-text node endContainer, we want to set a bounding node to the endContainer so we know
    // to stop traversing the DOM when hidding that bounding node
    if (isNonTextNodeEndContainer) {
        // If the end container is non-text and an emoji, we need to jump up a level or else it is
        // going to be bound to a node that we will never be able to check and thus never exit
        if ($a78c261c3211f7d6$var$isEmojiNode(endContainer)) boundingNode = endContainer.parentNode;
        else boundingNode = endContainer;
    } else {
        // Push the ending node into a range
        const endingRange = new Range();
        endingRange.setStart(endContainer, 0);
        endingRange.setEnd(endContainer, endOffset);
        rangesToHighlight.push(endingRange);
    }
    // Get the first "inner" node between the start and end containers
    let node = $a78c261c3211f7d6$export$3e98291f1f032a77(startContainer, boundingNode);
    // Iterate through all the inner nodes and extract the text ranges
    while(node && !node.isSameNode(endContainer) && node.nodeType === Node.TEXT_NODE){
        if (node.length) {
            const range = new Range();
            range.selectNodeContents(node);
            rangesToHighlight.push(range);
        }
        node = $a78c261c3211f7d6$export$3e98291f1f032a77(node, boundingNode);
    }
    return rangesToHighlight;
};
const $a78c261c3211f7d6$export$739c145b6a07c076 = (isFabricPage, isCreateDialogOpen = false, markerRef = '')=>{
    const highlightClass = $a78c261c3211f7d6$export$d2bdbdaa2c26e7f7;
    let markOffsetTop = 0;
    // Measure the offset of the highlight from the renderer wrapper
    // WS-2618 We have old macros that render tiny inline comments so we need to look for both fabric and tiny marker refs
    if (markerRef) {
        const highlight = $a78c261c3211f7d6$export$21445ab787d3b446(markerRef);
        markOffsetTop = $a78c261c3211f7d6$export$331805bfbe18b1c0(highlight);
    } else {
        const selection = window.getSelection();
        // If there is a user selection, we need to create a new temp "highlight" for this
        // new selection as it is removed when the temp "highlight" is created
        const isNewSelection = selection && selection.type == 'Range' && !isCreateDialogOpen;
        if (isNewSelection) {
            // Reset any existing DOM selections
            $a78c261c3211f7d6$export$743373b19993e2b0();
            // Mark the selection in the DOM temporarily
            $a78c261c3211f7d6$export$4147ba71ff179432(false);
        }
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const createCommentHighlight = document.querySelector(`.${highlightClass}`);
        markOffsetTop = $a78c261c3211f7d6$export$331805bfbe18b1c0(createCommentHighlight);
    }
    // On a fabric page, the highlight is positioned relative to the renderer
    // wrapper. To correctly position the sidebar we need to measure the offset
    // of the renderer wrapper and the offset of the highlight from the wrapper
    if (isFabricPage) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const rendererWrapper = document.querySelector('#content .ak-renderer-wrapper');
        if (rendererWrapper) markOffsetTop += rendererWrapper.offsetTop;
    } else {
        // In tiny, we need to remove the title and author info offset to position it correctly
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const pageMetadata = document.querySelector('#content-body .page-metadata-modification-info');
        if (pageMetadata) markOffsetTop -= pageMetadata.offsetTop - pageMetadata.offsetHeight;
    }
    return markOffsetTop;
};
const $a78c261c3211f7d6$export$4147ba71ff179432 = (useNewHighlightLogic)=>{
    const highlightClass = $a78c261c3211f7d6$export$d2bdbdaa2c26e7f7;
    const selection = window.getSelection();
    if (!selection || selection.type !== 'Range') // Throw error?
    return;
    // Extract the range
    const selectedRange = selection.getRangeAt(0);
    // Get an array of the ranges to make highlights
    const rangesToHighlight = useNewHighlightLogic ? $a78c261c3211f7d6$var$extractTextNodesIntoRanges(selectedRange) : $a78c261c3211f7d6$var$extractTextNodesIntoRangesOld(selectedRange);
    rangesToHighlight.forEach((range)=>{
        // Create a new wrapper element with the correct class
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const highlightWrapper = document.createElement('span');
        highlightWrapper.classList.add(highlightClass);
        // Extract the contents of the range and add it to the new wrapper
        highlightWrapper.appendChild(range.extractContents());
        // Re-insert the wrapper back into the range
        range.insertNode(highlightWrapper);
    });
    // Clear the selection
    selection.removeAllRanges();
};
const $a78c261c3211f7d6$var$unwrapTextNodes = (wrappedNodes)=>{
    while(wrappedNodes.length){
        const node = wrappedNodes.shift();
        if (!node) return;
        const { parentNode: parentNode } = node;
        // Extract the text contents of the selection node out of the temp wrapper
        while(node.firstChild)parentNode?.insertBefore(node.firstChild, node);
        // After the text has been extracted, delete the wrapper
        parentNode?.removeChild(node);
        // Normalize the parent to fix any text node fragmentation
        parentNode?.normalize();
    }
};
const $a78c261c3211f7d6$export$743373b19993e2b0 = ()=>{
    const highlightClass = $a78c261c3211f7d6$export$d2bdbdaa2c26e7f7;
    // Grab all the newly created selection nodes
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const tempSelectionNodes = Array.from(document.querySelectorAll(`.${highlightClass}`));
    $a78c261c3211f7d6$var$unwrapTextNodes(tempSelectionNodes);
};
const $a78c261c3211f7d6$export$a160a5110cbadcb8 = (isFabricPage, markerRef, isActive = true)=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const createCommentSelectionNodes = document.querySelectorAll(`.${$a78c261c3211f7d6$export$d2bdbdaa2c26e7f7}`);
    const ref = markerRef || '';
    // If we find selection nodes in the DOM, we need to add some attributes to them,
    // based on the page type, so they behave correctly when the user clicks a highlight
    if (createCommentSelectionNodes.length) createCommentSelectionNodes.forEach((selectionNode)=>{
        if (isFabricPage) {
            selectionNode.setAttribute($a78c261c3211f7d6$export$98471574bfa5228e, ref);
            selectionNode.setAttribute('data-mark-annotation-type', 'inlineComment');
        } else {
            selectionNode.setAttribute($a78c261c3211f7d6$export$90ee95b6cd79c832, ref);
            selectionNode.classList.add('inline-comment-marker');
        }
        const classesToAdd = [
            $a78c261c3211f7d6$export$b803c692fbaaa5a4
        ];
        if (isActive) classesToAdd.push($a78c261c3211f7d6$export$fb3d0eebfe85522a);
        // Add the classes needed
        selectionNode.classList.add(...classesToAdd);
        // Finally, remove the selection class to make it a full mark
        selectionNode.classList.remove($a78c261c3211f7d6$export$d2bdbdaa2c26e7f7);
    });
};
const $a78c261c3211f7d6$var$setHighlightsAsActive = (highlightElement, skipClassCheck = false)=>{
    if (skipClassCheck || highlightElement.classList.contains($a78c261c3211f7d6$export$b803c692fbaaa5a4)) highlightElement.classList.add($a78c261c3211f7d6$export$fb3d0eebfe85522a);
    // We need to set all the children of this highlight to active as well
    const { children: children } = highlightElement;
    for(let i = 0; i < children.length; ++i)$a78c261c3211f7d6$var$setHighlightsAsActive(children[i], skipClassCheck);
};
const $a78c261c3211f7d6$export$fd55463aeed84830 = (markerRef, skipClassCheck = false)=>{
    const highlightMarks = $a78c261c3211f7d6$export$6dfccc77fe608546(markerRef) || [];
    highlightMarks.forEach((highlight)=>$a78c261c3211f7d6$var$setHighlightsAsActive(highlight, skipClassCheck));
};
const $a78c261c3211f7d6$export$280edc47a64130be = (markerRef)=>{
    const highlight = $a78c261c3211f7d6$export$21445ab787d3b446(markerRef || '');
    return Boolean(highlight && highlight.classList.contains($a78c261c3211f7d6$export$fb3d0eebfe85522a));
};
const $a78c261c3211f7d6$export$a26c4eafef12029f = (markerRef)=>{
    const highlightMarksToRemove = Array.from($a78c261c3211f7d6$export$6dfccc77fe608546(markerRef));
    $a78c261c3211f7d6$var$unwrapTextNodes(highlightMarksToRemove);
    $a78c261c3211f7d6$export$f7ceeb7ba8156450();
};
const $a78c261c3211f7d6$export$a0939f064b367798 = ()=>{
    const highlightedAnnotations = Array.from(// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelectorAll('.ak-editor-annotation-blur, .ak-editor-annotation-focus'));
    const highlightedAnnotationIds = highlightedAnnotations.map((annotation)=>annotation?.closest('.annotationView-content-wrap')?.id).filter((id)=>Boolean(id));
    return new Set(highlightedAnnotationIds);
};
const $a78c261c3211f7d6$export$98471574bfa5228e = 'data-id';
const $a78c261c3211f7d6$export$90ee95b6cd79c832 = 'data-ref';
const $a78c261c3211f7d6$var$hasAdfContent = (input)=>{
    const content = input && input.content;
    return content && content.some($a78c261c3211f7d6$var$validateContent);
};
// Check to make sure if we have item.type as paragraph content is not empty (user did not type anything)
// or user has put in blank spaces(empty string) and clicked save
// Any type other than paragraph is valid (e.g:- when user inserts divider, status etc without content)
const $a78c261c3211f7d6$var$validateContent = (item)=>item.type !== 'paragraph' || $a78c261c3211f7d6$var$validateParagraph(item);
const $a78c261c3211f7d6$var$validateParagraph = (item)=>{
    if (item.content) return item.content.some($a78c261c3211f7d6$var$isParagraphNotEmpty);
    return false;
};
const $a78c261c3211f7d6$var$isParagraphNotEmpty = (item)=>item.type !== 'text' || item.text.trim() !== '';
const $a78c261c3211f7d6$export$915f03d46d87bfd4 = (adf)=>!adf || !$a78c261c3211f7d6$var$hasAdfContent(adf);
const $a78c261c3211f7d6$export$d204c0ea9b3f0d7d = (isFabricPage)=>isFabricPage ? $a78c261c3211f7d6$export$98471574bfa5228e : $a78c261c3211f7d6$export$90ee95b6cd79c832;
const $a78c261c3211f7d6$export$8f4213b45c05ab5d = (element)=>{
    let markerRef = null;
    if (element) {
        markerRef = element.getAttribute($a78c261c3211f7d6$export$98471574bfa5228e);
        if (!markerRef) markerRef = element.getAttribute($a78c261c3211f7d6$export$90ee95b6cd79c832);
    }
    return markerRef;
};
const $a78c261c3211f7d6$export$21445ab787d3b446 = (markerRef, additionalQueryScope = '')=>{
    if (!markerRef) return null;
    // We need to allow for additional query scope to be added to specify particular markerRef comments
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    return document.querySelector(`${additionalQueryScope} [${$a78c261c3211f7d6$export$98471574bfa5228e}="${markerRef}"], ${additionalQueryScope} [${$a78c261c3211f7d6$export$90ee95b6cd79c832}="${markerRef}"]`);
};
const $a78c261c3211f7d6$export$6dfccc77fe608546 = (markerRef)=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    return document.querySelectorAll(`[${$a78c261c3211f7d6$export$98471574bfa5228e}="${markerRef}"], [${$a78c261c3211f7d6$export$90ee95b6cd79c832}="${markerRef}"]`);
};
const $a78c261c3211f7d6$var$isHighlightCandidateVisible = (element)=>{
    const rect = element.getBoundingClientRect();
    const computedStyle = window.getComputedStyle(element);
    return element.isConnected && computedStyle.display !== 'none' && computedStyle.visibility !== 'hidden' && element.getAttribute('aria-hidden') !== 'true' && (rect.width > 0 || rect.height > 0);
};
const $a78c261c3211f7d6$export$c36aa9f15eddb765 = (markerRef)=>{
    if (!markerRef) return null;
    const allHighlights = Array.from($a78c261c3211f7d6$export$6dfccc77fe608546(markerRef));
    const visibleHighlight = allHighlights.find((element)=>$a78c261c3211f7d6$var$isHighlightCandidateVisible(element));
    return visibleHighlight || $a78c261c3211f7d6$export$21445ab787d3b446(markerRef);
};
const $a78c261c3211f7d6$export$6d23af9d8c2844b1 = [
    'enter',
    'escape'
];
const $a78c261c3211f7d6$var$getDimensions = ()=>{
    try {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const nav4ScrollParent = document.getElementById('AkMainContent');
        const currentPageOffset = !!nav4ScrollParent ? nav4ScrollParent.scrollTop : window.scrollY || (window.top?.scrollY ?? 0);
        return {
            currentWindowHeight: window.innerHeight || (window.top?.innerHeight ?? 0),
            currentPageOffset: currentPageOffset
        };
    } catch  {
        // Catch cross origin iframe error https://hello.atlassian.net/browse/CBT-907
        return {
            currentWindowHeight: 0,
            currentPageOffset: 0
        };
    }
};
const $a78c261c3211f7d6$var$COMMENT_CONTAINER_OFFSET = 350;
const $a78c261c3211f7d6$export$858fd2398afb28e4 = (commentElement, useInstantScroll = false, isAbove = false)=>{
    if (!commentElement) return;
    const { currentWindowHeight: currentWindowHeight, currentPageOffset: currentPageOffset } = $a78c261c3211f7d6$var$getDimensions();
    const offset = $a78c261c3211f7d6$export$331805bfbe18b1c0(commentElement) + commentElement.offsetHeight + (isAbove ? -$a78c261c3211f7d6$var$COMMENT_CONTAINER_OFFSET : 0);
    // If the position of the comment box is more than halfway down the screen, reposition it to the center
    if (offset <= currentPageOffset || offset > currentPageOffset + currentWindowHeight * (2 / 3)) {
        const windowOffset = currentWindowHeight / 5;
        window.scrollTo({
            top: offset - windowOffset,
            behavior: useInstantScroll ? 'instant' : 'smooth' // focused comments use an instant scroll
        });
    }
};
const $a78c261c3211f7d6$export$b451b837f5309ae9 = ({ commentId: commentId, targetCommentId: targetCommentId, isEditor: isEditor, viewingRoomOffset: viewingRoomOffset = -150, useInstantScroll: useInstantScroll = false })=>{
    if (commentId !== targetCommentId) return;
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const commentElement = document.querySelector(`[data-comment-id="${commentId}"]`);
    if (isEditor && commentElement) (0, $i49vP.scrollToElementInEditor)({
        targetElement: commentElement,
        viewingRoomOffset: viewingRoomOffset
    });
    else $a78c261c3211f7d6$export$fc9b5eebad60b835({
        element: commentElement,
        viewingRoomOffset: viewingRoomOffset,
        useInstantScroll: useInstantScroll
    });
};
const $a78c261c3211f7d6$export$e5d4e097ce63febc = ({ commentElement: commentElement, scrollRootElement: scrollRootElement, currentPageOffset: currentPageOffset, currentWindowHeight: currentWindowHeight, isAbove: isAbove, isFabricPage: isFabricPage, useInstantScroll: useInstantScroll })=>{
    if (!commentElement) return;
    // We may be in an iframe so use window.top
    const offset = $a78c261c3211f7d6$export$331805bfbe18b1c0(commentElement) + commentElement.offsetHeight + (isAbove ? -$a78c261c3211f7d6$var$COMMENT_CONTAINER_OFFSET : 0);
    const rendererOffset = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector('#content .ak-renderer-wrapper')?.offsetTop || 0;
    // If the position of the highlight is more than halfway down the screen, reposition it to the center
    if (offset + rendererOffset <= currentPageOffset || offset + rendererOffset > currentPageOffset + currentWindowHeight * (2 / 3)) {
        const windowOffset = isFabricPage ? currentWindowHeight / 5 : currentWindowHeight / 3;
        scrollRootElement.scrollTo({
            top: offset - windowOffset,
            behavior: useInstantScroll ? 'instant' : 'smooth' // focused comments use an instant scroll
        });
    }
};
const $a78c261c3211f7d6$export$c7436bd0a15f3e7e = ({ commentElement: commentElement, isFabricPage: isFabricPage, useInstantScroll: useInstantScroll = false, isAbove: isAbove = false, isCommentsPanel: isCommentsPanel })=>{
    if (!commentElement) return;
    const nodeToConsider = $a78c261c3211f7d6$export$ee0755cb593feed6(commentElement) || commentElement;
    const targetCommentHighlight = nodeToConsider.getBoundingClientRect();
    const { scrollRootElement: scrollRootElement, getDimensions: getDimensionsFromScrollRootContext } = $a78c261c3211f7d6$var$getScrollRootContext();
    const { currentWindowHeight: currentWindowHeight, currentPageOffset: currentPageOffset } = getDimensionsFromScrollRootContext();
    if (isCommentsPanel) {
        const commentHighlightAboveViewPort = Math.floor(targetCommentHighlight.bottom) < currentPageOffset;
        const commentHighlightBelowViewPort = targetCommentHighlight.top + 200 > window.innerHeight;
        // Scroll the highlight into view in the main content body
        if (commentHighlightAboveViewPort || commentHighlightBelowViewPort) $a78c261c3211f7d6$export$e5d4e097ce63febc({
            commentElement: commentElement,
            scrollRootElement: scrollRootElement,
            currentPageOffset: currentPageOffset,
            currentWindowHeight: currentWindowHeight,
            isAbove: isAbove,
            isFabricPage: !!isFabricPage,
            useInstantScroll: useInstantScroll
        });
    } else $a78c261c3211f7d6$export$e5d4e097ce63febc({
        commentElement: commentElement,
        scrollRootElement: scrollRootElement,
        currentPageOffset: currentPageOffset,
        currentWindowHeight: currentWindowHeight,
        isAbove: isAbove,
        isFabricPage: !!isFabricPage,
        useInstantScroll: useInstantScroll
    });
    //If comment is in expand, open respective expand
    $a78c261c3211f7d6$export$876171b9c9b54aab(commentElement, isFabricPage);
};
const $a78c261c3211f7d6$export$66b4d1e3b6633573 = (target, scrollContainer)=>{
    const rect = target.getBoundingClientRect();
    const parentRect = scrollContainer.getBoundingClientRect();
    let moveY = 0;
    // The distance (in pixels) between the target and the end of the visible viewport at which point,
    // when scrolling the target into view, scrolling takes place.
    const SCROLL_THRESHOLD = 60;
    // The extra space (in pixels) that is left above or below the target when it is scrolled into view.
    const SCROLL_MARGIN = 120;
    // Note: visible area of the container refers to parentRect.top/bottom +/- SCROLL_THRESHOLD
    if (rect.top < parentRect.top + SCROLL_THRESHOLD) // If the target is above the top of the visible area of the container, moveY should be negative to bring target down into view
    moveY = -(parentRect.top - rect.top + SCROLL_MARGIN);
    else if (rect.bottom > parentRect.bottom - SCROLL_THRESHOLD) // If the target's bottom is below the bottom of the visible area of the container, move Y should be positive to bring target up into view
    moveY = rect.bottom - parentRect.bottom + SCROLL_MARGIN;
    if (moveY) scrollContainer.scrollTop += moveY;
};
const $a78c261c3211f7d6$export$fb40c5e75b82df8 = (isEditor, isViewCommentMode)=>{
    if (isEditor && isViewCommentMode) return 'editor-comments-sidebar';
    else if (isEditor && !isViewCommentMode) return 'editor-create-sidebar';
    else if (!isEditor && isViewCommentMode) return 'renderer-comments-sidebar';
    else return 'renderer-create-sidebar';
};
const $a78c261c3211f7d6$export$59a770a0e59b0dd2 = (container)=>{
    const selector = [
        'button:not([disabled])',
        'a[href]',
        'input:not([disabled])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        '[contenteditable="true"]',
        '[tabindex]:not([tabindex="-1"])'
    ].join(',');
    return Array.from(container.querySelectorAll(selector)).filter((element)=>!element.hasAttribute('disabled') && element.getAttribute('aria-hidden') !== 'true');
};
const $a78c261c3211f7d6$export$642e21ba866d02df = (container, element)=>{
    if (!element) return false;
    return $a78c261c3211f7d6$export$59a770a0e59b0dd2(container)[0] === element;
};
const $a78c261c3211f7d6$export$876aeb5dffd449af = (container, element)=>{
    if (!element) return false;
    const tabbableElements = $a78c261c3211f7d6$export$59a770a0e59b0dd2(container);
    return tabbableElements[tabbableElements.length - 1] === element;
};
const $a78c261c3211f7d6$export$cfa8eefe354167cd = (element, focusOptions)=>{
    element.setAttribute('tabIndex', '-1');
    element.focus(focusOptions);
};
const $a78c261c3211f7d6$export$db9eae89818590a4 = (commentElement, previousCommentElement, isFabricPage, isEditor)=>{
    if (!commentElement) return;
    const { scrollRootElement: scrollRootElement, scrollRootOffset: scrollRootOffset } = $a78c261c3211f7d6$var$getScrollRootContext();
    // if current open comment is out of viewport, we need to scroll so that the next comment is in viewport
    const sidebarId = $a78c261c3211f7d6$export$fb40c5e75b82df8(isEditor, true); // Hard-coding isViewCommentMode to true because navigation only exists in the view scenario
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const inlineCommentSidebar = document.getElementById(sidebarId);
    const inlineCommentPosition = inlineCommentSidebar?.getBoundingClientRect();
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const documentContent = document.getElementById('content');
    const documentContentTopPosition = documentContent?.getBoundingClientRect().top;
    const commentAboveViewport = inlineCommentPosition && documentContentTopPosition && inlineCommentPosition.top < documentContentTopPosition + scrollRootOffset;
    const commentBelowViewport = inlineCommentPosition && inlineCommentPosition.top + 200 > window.innerHeight;
    if (commentAboveViewport || commentBelowViewport) {
        $a78c261c3211f7d6$export$c7436bd0a15f3e7e({
            commentElement: commentElement,
            isFabricPage: isFabricPage
        });
        return;
    }
    const previousOffset = previousCommentElement ? $a78c261c3211f7d6$export$331805bfbe18b1c0(previousCommentElement) : 0;
    const offset = $a78c261c3211f7d6$export$331805bfbe18b1c0(commentElement);
    const differenceOffset = offset - previousOffset;
    scrollRootElement.scrollBy({
        top: differenceOffset,
        behavior: 'smooth' // navigation uses a smooth scroll
    });
    // If comment is in expand, open respective expand
    $a78c261c3211f7d6$export$876171b9c9b54aab(commentElement, isFabricPage);
};
const $a78c261c3211f7d6$var$adjustNodeForStickyHeader = (stickyHeaderElement)=>{
    let adjustedElement = stickyHeaderElement;
    const markerRef = $a78c261c3211f7d6$export$8f4213b45c05ab5d(adjustedElement);
    // If this is exists it's a commited comment, look for its counterpart in the real table
    // TODO: Support new highlights when we allow it
    if (markerRef) // WS-2618 We have old macros that render tiny inline comments so we need to look for both fabric and tiny marker refs
    adjustedElement = $a78c261c3211f7d6$export$21445ab787d3b446(markerRef, '.pm-table-wrapper');
    return adjustedElement;
};
const $a78c261c3211f7d6$export$ee0755cb593feed6 = (element)=>{
    let nodeToReturn = element;
    // Sticky table headers duplicate the elements in the DOM so we need to check if this is the real one or not
    // If the highlight has a parent with the class .pm-table-sticky-wrapper it is the fake one
    if (nodeToReturn && nodeToReturn.closest && nodeToReturn.closest('.pm-table-sticky-wrapper')) nodeToReturn = $a78c261c3211f7d6$var$adjustNodeForStickyHeader(nodeToReturn);
    if (nodeToReturn) {
        // WS-2718 - If a comment is in an extension macro
        const extensionParent = nodeToReturn.closest('.ak-renderer-extension');
        if (extensionParent) nodeToReturn = extensionParent;
    }
    return nodeToReturn;
};
const $a78c261c3211f7d6$export$331805bfbe18b1c0 = (element, relativeToElement, isRendererAnnotationProviderEnabled)=>{
    let elementOffsetTop = 0;
    let nodeToMeasure = element;
    // new sticky header implementation
    if ((0, $6mKj3.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow')) {
        if (relativeToElement && nodeToMeasure && nodeToMeasure.closest && nodeToMeasure.closest('tr.pm-table-row-native-sticky-active')) {
            const elementRect = nodeToMeasure.getBoundingClientRect();
            const containerRect = relativeToElement.getBoundingClientRect();
            return elementRect.top - containerRect.top;
        }
    }
    // Sticky table headers duplicate the elements in the DOM so we need to check if this is the real one or not
    // If the highlight has a parent with the class .pm-table-sticky-wrapper it is the fake one
    if (nodeToMeasure && nodeToMeasure.closest && nodeToMeasure.closest('.pm-table-sticky-wrapper')) // The RAP annotation draft mark is applied to the both pm-table-sticky-wrapper as well as the pm-table-wrapper.
    // Need to check only pm-table-wrapper annotation draft mark for the RAP enabled
    nodeToMeasure = isRendererAnnotationProviderEnabled ? // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector(`.pm-table-wrapper [data-annotation-draft-mark="true"]`) : $a78c261c3211f7d6$var$adjustNodeForStickyHeader(nodeToMeasure);
    // Iterate through the offset parents until we are back to the ak-renderer-wrapper to get the
    // proper offset Fabric Pages wrap the content in a .ak-renderer-wrapper element, but Tiny
    // pages do not have anything like that, but will return null when we get to <body>
    while(nodeToMeasure && !nodeToMeasure.classList.contains('ak-renderer-wrapper') && nodeToMeasure !== relativeToElement){
        elementOffsetTop += nodeToMeasure.offsetTop;
        nodeToMeasure = nodeToMeasure.offsetParent;
    }
    // WS-2718 - If a comment is in an extension macro, we need to add its container offset as well
    if (nodeToMeasure) {
        const extensionParent = nodeToMeasure.closest('.ak-renderer-extension');
        if (extensionParent) elementOffsetTop += extensionParent.offsetTop;
    }
    return elementOffsetTop;
};
const $a78c261c3211f7d6$export$d0d02dc9adb82d62 = (element, isFabricPage)=>{
    //get the child of element passed in
    const expandElement = element?.hasChildNodes() ? element?.firstChild : element;
    //check if element is expand button and return element if so
    if (isFabricPage) {
        if (expandElement?.tagName?.toLowerCase() === 'button') return expandElement;
    } else if (expandElement?.classList?.contains('expand-control')) return expandElement?.firstChild; //it's one child down for tiny pages
    return null;
};
const $a78c261c3211f7d6$export$1a2319f5c2109ee1 = (element, options)=>{
    const { expandSelectors: expandSelectors, getExpandButton: getExpandButton, isExpanded: isExpanded, onExpand: onExpand } = options;
    const nodeToCheck = element;
    // Check if comment is in any expand
    const isInExpand = expandSelectors.some((selector)=>nodeToCheck?.closest?.(selector));
    if (!isInExpand) return;
    // Find all expand buttons that need to be opened, starting from the innermost
    const expandButtonsToOpen = [];
    let currentNode = nodeToCheck;
    while(currentNode){
        // Check if current node has an expand button
        const expandButton = getExpandButton(currentNode);
        if (expandButton) // Check if this expand is already opened
        {
            if (!isExpanded(expandButton)) expandButtonsToOpen.push(expandButton);
        }
        currentNode = currentNode?.parentElement;
    }
    // Open all expand buttons from innermost to outermost
    const buttonsToClick = [
        ...expandButtonsToOpen
    ].reverse();
    buttonsToClick.forEach((expandButton)=>{
        if (onExpand) onExpand(expandButton);
        expandButton.click();
    });
};
const $a78c261c3211f7d6$export$d2685a53bf6957f4 = (element, isFabricPage)=>{
    const expandElementClassname = isFabricPage ? '.expand-content-wrapper' : '.expand-content';
    const nestedExpandElementClassname = '.nestedExpand-content-wrapper';
    const expandSelectors = [
        expandElementClassname,
        nestedExpandElementClassname
    ];
    const getExpandButton = (node)=>$a78c261c3211f7d6$export$d0d02dc9adb82d62(node, isFabricPage);
    const isExpanded = (button)=>{
        return isFabricPage ? button.getAttribute('aria-expanded') === 'true' : button.className.includes('expanded');
    };
    $a78c261c3211f7d6$export$1a2319f5c2109ee1(element, {
        isFabricPage: isFabricPage,
        expandSelectors: expandSelectors,
        getExpandButton: getExpandButton,
        isExpanded: isExpanded
    });
};
const $a78c261c3211f7d6$export$876171b9c9b54aab = (element, isFabricPage)=>{
    $a78c261c3211f7d6$export$d2685a53bf6957f4(element, isFabricPage);
};
const $a78c261c3211f7d6$export$187f977414e8342c = (action, index, markerRefList)=>{
    if (markerRefList.length === 0 || index === undefined || index === -1) return;
    let commentIndex = -1;
    //Navigate to first inline comment if we're on the last comment and the user clicks next,
    // or to the last comment if we're on the first comment and the user clicks previous
    if (action === 'next') commentIndex = index === markerRefList.length - 1 ? 0 : index + 1;
    else if (action === 'previous') commentIndex = index === 0 ? markerRefList.length - 1 : index - 1;
    return markerRefList[commentIndex];
};
const $a78c261c3211f7d6$export$883ebc059dd86e88 = (index, markerRefList, unreadMarkerRefList)=>{
    if (index === undefined || markerRefList.length === 0 || index === -1 || !unreadMarkerRefList || unreadMarkerRefList.length === 0) return;
    let commentIndex = index % markerRefList.length; // Handle case where index is beyond array length
    const refListLength = markerRefList.length;
    let iterations = 0;
    while(markerRefList[commentIndex] !== undefined && !unreadMarkerRefList.includes(markerRefList[commentIndex]) && iterations < refListLength){
        commentIndex = (commentIndex + 1) % markerRefList.length;
        iterations++;
    }
    return markerRefList[commentIndex];
};
const $a78c261c3211f7d6$export$b401b3c3a0774fd7 = ()=>// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    navigator.clipboard && typeof navigator.clipboard.writeText === 'function';
const $a78c261c3211f7d6$export$2cdf1b96a9f86d16 = async (text)=>{
    if ($a78c261c3211f7d6$export$b401b3c3a0774fd7()) // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    await navigator.clipboard.writeText(text);
};
const $a78c261c3211f7d6$export$ab567600730c0b3b = (annotationElement, scrollParentSelector)=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const scrollParent = document.querySelector(scrollParentSelector);
    return $a78c261c3211f7d6$export$331805bfbe18b1c0(annotationElement, scrollParent);
};
const $a78c261c3211f7d6$export$3cdeee3ea1732782 = (annotationElement, scrollParentSelector, isView)=>{
    let offset = 0;
    if (annotationElement) {
        // If the annotation is the wrapperDOM, we actually need #content to be the scrollParent
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const scrollParent = document.querySelector('div#content[data-inline-comments-target="true"]');
        if (scrollParent) {
            let annotationOffset;
            if (isView) annotationOffset = $a78c261c3211f7d6$export$331805bfbe18b1c0(annotationElement);
            else {
                // If the annotation is the wrapperDOM, we need to find the actual highlight instead
                const actualHiglightElement = scrollParent.querySelector(scrollParentSelector);
                annotationOffset = $a78c261c3211f7d6$export$331805bfbe18b1c0(actualHiglightElement, undefined, true);
            }
            offset = annotationOffset + scrollParent.offsetTop;
        }
    }
    return offset;
};
const $a78c261c3211f7d6$export$9f8164812b21bc7a = (entries)=>{
    const windowHeight = window.innerHeight;
    if ((0, $6mKj3.expValEquals)('confluence_unify_footer_comments_space_width', 'isEnabled', true) || (0, $9wGTI.fg)('confluence_frontend_unify_footer_comment_space_ld')) {
        if (!(0, $9wGTI.fg)('confluence_frontend_unify_footer_comment_space_ld')) {
            // When fg is ON, we would have verified that there's no
            // endOfPageRecommendations before adding this ResizeObserver.
            // So no need to check it here.
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const endOfPageRecommendations = document.querySelector('.end-of-page-rec-wrapper');
            if (endOfPageRecommendations) return 0;
        }
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const editorTextArea = document.getElementById('ak-editor-textarea');
        const editorBottom = editorTextArea?.getBoundingClientRect().bottom;
        if (editorBottom && windowHeight) {
            // The minimum spacing between bottom of editor content and top of footer is 120px
            const minimumSpacing = 120;
            // - There's an existing fixed 24px margin below editor content.
            // - ObjectAddCommentContainer.tsx has a 64px height.
            // - We lift footer comment top by 14px to make it visually distinct
            //   when a short LiveDoc has some vs zero existing footer comment.
            const editorBottomMargin = 24;
            const addFooterCommentHeight = 64;
            const extraFooterCommentHeightToShow = 14;
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const editorScrollParent = document.querySelector('.fabric-editor-popup-scroll-parent');
            const currentScroll = editorScrollParent?.scrollTop ?? 0;
            const editorBottomUnscrolled = editorBottom + currentScroll;
            const verticalDistanceFromWindowBottomUnscrolled = windowHeight - editorBottomUnscrolled;
            return Math.max(verticalDistanceFromWindowBottomUnscrolled - editorBottomMargin - addFooterCommentHeight - extraFooterCommentHeightToShow, minimumSpacing);
        }
    } else {
        // The calculation is
        // 15px of marginTop on the comment container
        // 2px full-page-editor-style bottom which above the viewport
        // 1px border which is cumulates to 120px
        const thresholdTop = 102;
        const editorEntry = entries.find((entry)=>entry.target.id === 'ak-editor-textarea');
        const editorBottom = editorEntry?.target.getBoundingClientRect().bottom;
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const editorContentHeight = document.querySelector(`.ak-editor-content-area .ProseMirror`)?.getBoundingClientRect().height;
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const documentContentBottom = document.querySelector(`[data-testid='full-page-editor-style']`)?.getBoundingClientRect().bottom;
        if (editorContentHeight) {
            // If the document content is larger than the window height, just set it to a static 120 to keep the proper spacing
            if (editorContentHeight > windowHeight) return 120;
            if (documentContentBottom && editorBottom) {
                const verticalDistance = documentContentBottom - editorBottom;
                if (verticalDistance >= thresholdTop && editorContentHeight <= windowHeight) return verticalDistance - thresholdTop;
                else if (verticalDistance <= thresholdTop) return thresholdTop;
            }
        }
    }
};
const $a78c261c3211f7d6$export$e3a17b46d43aa5f6 = ()=>{
    // This is deprecated, and will be replaced by a new approach that works in SSR.
    let newTop = 0;
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const endOfPageRecommendations = document.querySelector('.end-of-page-rec-wrapper');
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const legacyLabels = document.querySelector('[data-vc="view-page-labels-container"]');
    // no extra spacing if the page shows end-of-page recommendations or legacy labels
    if (!endOfPageRecommendations && !legacyLabels) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const rendererContent = document.getElementById('main-content');
        const rendererContentBottom = rendererContent?.getBoundingClientRect()?.bottom ?? 0;
        if (rendererContentBottom) {
            // - There's an existing fixed 80px margin below Page content (See
            //   next/packages/view-page-common/src/ViewPageContent.tsx).
            // - ObjectAddCommentContainer.tsx has a 64px height.
            // - We lift footer comment top by 14px (matching Editor version ^)
            //   to make it visually distinct when a short Page has some vs zero
            //   existing footer comment.
            const contentBottomMargin = 80;
            const addFooterCommentHeight = 64;
            const extraFooterCommentHeightToShow = 14;
            // Find the current scroll offset on the Page.
            // This is similar to implementation in getDimensionsForNav4(),
            // but when the window is very narrow, nav4ScrollParent.scrollTop
            // can be 0 (nav4ScrollParent element itself exists on page) while
            // window.scrollY is positive.
            // So this is a more robust implementation. Will explore whether
            // getDimensionsForNav4() can be updated to use this implementation
            // in a separate PR.
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const nav4ScrollParent = document.getElementById('AkMainContent');
            const currentPageOffset = (nav4ScrollParent?.scrollTop ?? 0) + (window.scrollY ?? window.top?.scrollY ?? 0);
            const rendererContentBottomUnscrolled = rendererContentBottom + currentPageOffset;
            const windowHeight = window.innerHeight;
            const verticalDistanceFromWindowBottomUnscrolled = windowHeight - rendererContentBottomUnscrolled - contentBottomMargin;
            newTop = Math.max(verticalDistanceFromWindowBottomUnscrolled - addFooterCommentHeight - extraFooterCommentHeightToShow, 0);
        }
    }
    return newTop;
};
const $a78c261c3211f7d6$export$fc9b5eebad60b835 = ({ element: element, viewingRoomOffset: viewingRoomOffset = -150, useInstantScroll: useInstantScroll = false })=>{
    if (!element) return;
    const { scrollRootElement: scrollRootElement, scrollRootOffset: scrollRootOffset } = $a78c261c3211f7d6$var$getScrollRootContext();
    const elementRect = element.getBoundingClientRect();
    const elementTopViewport = elementRect.top;
    const scrollRootTopViewport = scrollRootElement instanceof Window ? 0 // Window doesn't have a bounding rect; its top is always 0
     : scrollRootElement.getBoundingClientRect().top;
    const elementTopFromScrollRoot = elementTopViewport - scrollRootTopViewport;
    const targetScrollPosition = elementTopFromScrollRoot + scrollRootOffset + viewingRoomOffset;
    scrollRootElement.scrollTo({
        top: targetScrollPosition,
        behavior: useInstantScroll ? 'instant' : 'smooth' // focused comments use an instant scroll
    });
    // open expand if the element is inside an expand
    $a78c261c3211f7d6$export$876171b9c9b54aab(element, true);
};
const $a78c261c3211f7d6$export$b3ba907d5759e257 = (commentId, annotationId)=>{
    let isDisconnected = false;
    let commentFound = false;
    // Find the most specific container to observe
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const commentsPanelListContainer = document.querySelector('[data-testid="comments-panel-list-container"]');
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const targetContainer = commentsPanelListContainer || document.body;
    const observer = new MutationObserver(()=>{
        if (isDisconnected || commentFound) return;
        const commentElement = targetContainer.querySelector(`[data-comment-id="${commentId}"]`) || (annotationId ? targetContainer.querySelector(`[data-testid="comment-thread-${annotationId}-container"]`) : null);
        if (commentElement) {
            commentFound = true;
            commentElement.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'center'
            });
            isDisconnected = true;
            observer.disconnect();
        }
    });
    // Start observing only the specific container
    observer.observe(targetContainer, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: annotationId ? [
            'data-comment-id',
            'data-testid'
        ] : [
            'data-comment-id'
        ]
    });
    // Return cleanup function
    return ()=>{
        if (!isDisconnected) {
            observer.disconnect();
            isDisconnected = true;
        }
    };
};
const $a78c261c3211f7d6$export$b1b7c9bcc75c855d = ({ targetCommentId: targetCommentId, onScrollReady: onScrollReady, onFallback: onFallback, timeoutMs: timeoutMs = 10000, markElement: markElement, containerId: containerId })=>{
    if ((0, $6mKj3.expValEquals)('confluence_comments_use_new_observer', 'isEnabled', true)) return $a78c261c3211f7d6$export$4d09fb2a10e54800({
        targetCommentId: targetCommentId,
        onScrollReady: onScrollReady,
        onFallback: onFallback,
        timeoutMs: timeoutMs,
        markElement: markElement,
        containerId: containerId
    });
    let commentFound = false;
    let isDisconnected = false;
    const observer = new MutationObserver((mutations)=>{
        if (isDisconnected) return;
        // First, look for the comment element if we haven't found it yet
        if (!commentFound) {
            for (const mutation of mutations)if (mutation.type === 'childList') {
                for (const addedNode of Array.from(mutation.addedNodes))if (addedNode.nodeType === Node.ELEMENT_NODE) {
                    const element = addedNode;
                    // Check if this element or any of its descendants has the specific data-comment-id
                    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                    const containerElement = containerId ? document.getElementById(containerId) : null;
                    const commentElement = containerElement || element.querySelector?.(`[data-comment-id="${targetCommentId}"]`) || (element.matches?.(`[data-comment-id="${targetCommentId}"]`) ? element : null);
                    if (commentElement) {
                        commentFound = true;
                        // Early return if the comment is in the container element
                        if (containerElement) {
                            onScrollReady(containerElement);
                            isDisconnected = true;
                            observer.disconnect();
                            return;
                        }
                        markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
                        // Check the initial state of the show more button
                        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                        const showMoreButton = document.querySelector('[data-testid="show-hidden-replies"]');
                        if (!showMoreButton) {
                            onScrollReady(commentElement);
                            isDisconnected = true;
                            observer.disconnect();
                            return;
                        } else // Trigger click on the show more button to expand all replies
                        showMoreButton.click();
                        break;
                    }
                }
            }
        }
        // If comment is found, watch for the show more button to disappear
        if (commentFound) {
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const commentElement = document.querySelector(`[data-comment-id="${targetCommentId}"]`);
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const showMoreButton = document.querySelector('[data-testid="show-hidden-replies"]');
            if (commentElement && !showMoreButton) {
                markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
                onScrollReady(commentElement);
                isDisconnected = true;
                observer.disconnect();
                return;
            }
        }
    });
    // Start observing
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    // Clean up observer after specified timeout to prevent memory leaks
    const timeoutId = setTimeout(()=>{
        if (!isDisconnected) {
            observer.disconnect();
            isDisconnected = true;
            // Fallback behavior if comment was found but button never disappeared
            if (commentFound) {
                // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                const commentElement = document.querySelector(`[data-comment-id="${targetCommentId}"]`);
                if (commentElement) {
                    // Check and open expand sections if needed before scrolling
                    markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
                    onScrollReady(commentElement);
                }
            } else if (onFallback) onFallback();
        }
    }, timeoutMs);
    // Return cleanup function
    return ()=>{
        if (!isDisconnected) {
            observer.disconnect();
            isDisconnected = true;
            clearTimeout(timeoutId);
        }
    };
};
/**
 * Find the comment element by ID or data-comment-id attribute
 */ const $a78c261c3211f7d6$var$findCommentElement = (targetCommentId, containerId, isFooterCommentInPanel)=>{
    // If isFooterCommentInPanel is true, use comment-thread-${targetCommentId}-container
    if (isFooterCommentInPanel) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const panelContainer = document.getElementById(`comment-thread-${targetCommentId}-container`);
        if (panelContainer) return panelContainer;
    }
    // Try container element first if containerId is provided
    if (containerId) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const container = document.getElementById(containerId);
        if (container) return container;
    }
    // Fall back to finding by data-comment-id
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    return document.querySelector(`[data-comment-id="${targetCommentId}"]`);
};
const $a78c261c3211f7d6$export$5eaef9e6a0975768 = (commentElement, targetCommentId)=>{
    if (!commentElement) return null;
    // 1. Check within commentElement (descendants)
    const buttonInComment = commentElement.querySelector('[data-testid="show-hidden-replies"]');
    if (buttonInComment) return buttonInComment;
    // 2. Check in parent element (siblings)
    const parentElement = commentElement.parentElement;
    const buttonInParent = parentElement?.querySelector('[data-testid="show-hidden-replies"]');
    if (buttonInParent) return buttonInParent;
    // 3. Check in replies container (specific to this comment thread)
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const repliesContainer = document.querySelector(`[data-testid="comment-thread-${targetCommentId}-replies"]`);
    const buttonInReplies = repliesContainer?.querySelector('[data-testid="show-hidden-replies"]');
    if (buttonInReplies) return buttonInReplies;
    return null;
};
/**
 * Handle the comment element being found
 * Checks for show more button and either scrolls immediately or clicks to expand
 */ const $a78c261c3211f7d6$var$handleCommentFound = (commentElement, targetCommentId, containerId, markElement, onScrollReady)=>{
    // If container element exists and we're using it, scroll immediately
    if (containerId && commentElement.id === containerId) {
        markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
        onScrollReady(commentElement);
        return true; // Indicates we should disconnect
    }
    // Expand mark element if needed
    markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
    // Check for show more button
    const showMoreButton = $a78c261c3211f7d6$export$5eaef9e6a0975768(commentElement, targetCommentId);
    if (!showMoreButton) {
        // No show more button, scroll immediately
        onScrollReady(commentElement);
        return true; // Indicates we should disconnect
    } else {
        // Show more button exists, click it to expand replies
        showMoreButton.click();
        return false; // Keep watching for button to disappear
    }
};
/**
 * Check if comment element exists in newly added nodes
 */ const $a78c261c3211f7d6$var$checkAddedNodes = (addedNodes, targetCommentId, containerId, isFooterCommentInPanel, onCommentFound)=>{
    for (const addedNode of Array.from(addedNodes)){
        if (addedNode.nodeType !== Node.ELEMENT_NODE) continue;
        const element = addedNode;
        // Check if this element or its descendants contains the comment
        let commentElement = null;
        // First check for container element
        if (containerId) {
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const container = document.getElementById(containerId);
            if (container) commentElement = container;
        }
        // If not found, check for comment by data-comment-id
        if (!commentElement) commentElement = element.querySelector?.(`[data-comment-id="${targetCommentId}"]`) || (element.matches?.(`[data-comment-id="${targetCommentId}"]`) ? element : null);
        // If isFooterCommentInPanel, also check for panel container
        if (!commentElement && isFooterCommentInPanel) {
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const panelContainer = document.getElementById(`comment-thread-${targetCommentId}-container`);
            if (panelContainer) commentElement = panelContainer;
        }
        if (commentElement) {
            const shouldDisconnect = onCommentFound(commentElement);
            if (shouldDisconnect) return true; // Indicates we should stop processing
        }
    }
    return false;
};
const $a78c261c3211f7d6$export$4d09fb2a10e54800 = ({ targetCommentId: targetCommentId, onScrollReady: onScrollReady, onFallback: onFallback, timeoutMs: timeoutMs = 10000, markElement: markElement, containerId: containerId, isFooterCommentInPanel: isFooterCommentInPanel = false })=>{
    let commentFound = false;
    let isDisconnected = false;
    const handleCommentFoundWrapper = (commentElement)=>{
        commentFound = true;
        return $a78c261c3211f7d6$var$handleCommentFound(commentElement, targetCommentId, containerId, markElement, onScrollReady);
    };
    const observer = new MutationObserver((mutations)=>{
        if (isDisconnected) return;
        // First, look for the comment element if we haven't found it yet
        if (!commentFound) {
            for (const mutation of mutations)if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                const shouldStop = $a78c261c3211f7d6$var$checkAddedNodes(mutation.addedNodes, targetCommentId, containerId, isFooterCommentInPanel, handleCommentFoundWrapper);
                if (shouldStop) {
                    isDisconnected = true;
                    observer.disconnect();
                    return;
                }
            }
        }
        // If comment is found, watch for the show more button to disappear
        if (commentFound) {
            const commentElement = $a78c261c3211f7d6$var$findCommentElement(targetCommentId, containerId, isFooterCommentInPanel);
            const showMoreButton = $a78c261c3211f7d6$export$5eaef9e6a0975768(commentElement, targetCommentId);
            // If comment exists and show more button is gone, we're ready to scroll
            if (commentElement && !showMoreButton) {
                markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
                onScrollReady(commentElement);
                isDisconnected = true;
                observer.disconnect();
                return;
            }
        }
    });
    // Start observing
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    // Clean up observer after specified timeout to prevent memory leaks
    const timeoutId = setTimeout(()=>{
        if (!isDisconnected) {
            observer.disconnect();
            isDisconnected = true;
            // Fallback behavior if comment was found but button never disappeared
            if (commentFound) {
                const commentElement = $a78c261c3211f7d6$var$findCommentElement(targetCommentId, containerId, isFooterCommentInPanel);
                if (commentElement) {
                    // Check and open expand sections if needed before scrolling
                    markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
                    onScrollReady(commentElement);
                }
            } else if (onFallback) onFallback();
        }
    }, timeoutMs);
    // Return cleanup function
    return ()=>{
        if (!isDisconnected) {
            observer.disconnect();
            isDisconnected = true;
            clearTimeout(timeoutId);
        }
    };
};
/**
 * Returns the HTMLElement or window that should be used as the scroll root. By default,
 *  this is the div with id=AkMainContent, if the id exists in the DOM
 */ function $a78c261c3211f7d6$var$getScrollRootContext() {
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const nav4ScrollRootElement = document.getElementById('AkMainContent');
    const scrollRootElement = nav4ScrollRootElement || window;
    const scrollRootOffset = nav4ScrollRootElement ? nav4ScrollRootElement.scrollTop : window.scrollY;
    return {
        scrollRootElement: scrollRootElement,
        scrollRootOffset: scrollRootOffset,
        getDimensions: $a78c261c3211f7d6$var$getDimensions
    };
}
// Constants for comment thread visibility
const $a78c261c3211f7d6$var$SCROLLED_COMMENTS_HEADER_GAP_SIZE_IN_PIXELS = 8;
const $a78c261c3211f7d6$var$NUM_HIDDEN_PIXELS_TO_BE_CONSIDERED_OUT_OF_VIEW = 60;
const $a78c261c3211f7d6$var$getTotalOffsetAboveCommentsPanelThreads = (generalCommentsHeaderHeight)=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    let objectSidebarPanelHeader = document.querySelector("[data-testid='object-sidebar-panel-header']");
    let additionalOffset = 0;
    if (!objectSidebarPanelHeader) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        objectSidebarPanelHeader = document.querySelector("[data-testid='scrolled-object-sidebar-panel-header']");
        additionalOffset = $a78c261c3211f7d6$var$SCROLLED_COMMENTS_HEADER_GAP_SIZE_IN_PIXELS;
    }
    const objectSidebarPanelHeaderHeight = objectSidebarPanelHeader?.getBoundingClientRect().height ?? 0;
    const objectHeaderHeight = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector("[data-testid='object-header-container']")?.getBoundingClientRect().height ?? 0;
    const topNavContainerHeight = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector("[data-testid='grid-topNav']")?.getBoundingClientRect().height ?? 0;
    const bannerContainerHeight = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector("[data-testid='banner-container']")?.getBoundingClientRect().height ?? 0;
    const editorControlsOnboardingBannerHeight = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector("[data-testid='editor-controls-onboarding-banner']")?.getBoundingClientRect().height ?? 0;
    const announcementBannerHeight = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector("[id='AkBanner']")?.getBoundingClientRect().height ?? 0;
    return objectSidebarPanelHeaderHeight + objectHeaderHeight + topNavContainerHeight + bannerContainerHeight + additionalOffset + generalCommentsHeaderHeight + editorControlsOnboardingBannerHeight + announcementBannerHeight;
};
const $a78c261c3211f7d6$export$4d211f4974dcf196 = (commentThreadElement, commentType)=>{
    const commentThreadRect = commentThreadElement.getBoundingClientRect();
    const generalCommentsHeaderHeight = commentType === 'general' ? // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector("[data-testid='comment-section-separator']")?.getBoundingClientRect().height ?? 0 : 0;
    const totalPaddingAboveCommentThreadView = $a78c261c3211f7d6$var$getTotalOffsetAboveCommentsPanelThreads(generalCommentsHeaderHeight);
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const objectSidebarPanelFooter = document.querySelector("[data-testid='object-sidebar-panel-footer']");
    const objectSidebarPanelFooterHeight = objectSidebarPanelFooter?.getBoundingClientRect().height ?? 0;
    const viewportTop = totalPaddingAboveCommentThreadView;
    const viewportBottom = window.innerHeight - objectSidebarPanelFooterHeight;
    const commentTopInView = commentThreadRect.top >= viewportTop;
    const commentBottomInView = commentThreadRect.bottom <= viewportBottom;
    if (commentTopInView && commentBottomInView) // Comment is 100% in view
    return false;
    else if (!commentTopInView && commentBottomInView) // Comment is <100% in view and the hidden part is the top part of the comment
    return true;
    else if (commentTopInView && !commentBottomInView) {
        // Comment is <100% in view and the hidden part is the bottom of the comment
        const hiddenBottomHeight = commentThreadRect.bottom - viewportBottom;
        if (hiddenBottomHeight <= $a78c261c3211f7d6$var$NUM_HIDDEN_PIXELS_TO_BE_CONSIDERED_OUT_OF_VIEW) // The hidden part is <= 60 pixels
        return false;
        else // The hidden part is > 60 pixels
        return true;
    } else // Comment is <100% in view and the hidden part is the top part of the comment
    return true;
};
const $a78c261c3211f7d6$export$9c5b7a3c864ae31b = (commentThreadElement, commentType)=>{
    const commentThreadRect = commentThreadElement.getBoundingClientRect();
    const generalCommentsHeaderHeight = commentType === 'general' ? // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector("[data-testid='comment-section-separator']")?.getBoundingClientRect().height ?? 0 : 0;
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const objectSidebarPanelFooter = document.querySelector("[data-testid='object-sidebar-panel-footer']");
    const objectSidebarPanelFooterHeight = objectSidebarPanelFooter?.getBoundingClientRect().height ?? 0;
    return(// Element is partially out of view below the comments panel viewport
    commentThreadRect.bottom + generalCommentsHeaderHeight > window.innerHeight - objectSidebarPanelFooterHeight);
};
const $a78c261c3211f7d6$export$e3c287b6d80b16ce = ({ pageMode: pageMode, pageWidthType: pageWidthType, hasEndOfPageRecommendations: hasEndOfPageRecommendations })=>{
    const endOfPageRecommendationsMaxWidth = '1000px';
    if (pageMode === (0, $cD1qu.PageMode).VIEW && ((0, $9wGTI.fg)('confluence_frontend_unify_footer_comment_width') || (0, $6mKj3.expValEquals)('confluence_unify_footer_comments_space_width', 'isEnabled', true))) {
        // pageWidthType is a string like '"default"' / '"full-width"' in renderer mode, and is undefined in live doc mode
        const isDefaultWidth = pageWidthType && JSON.parse(pageWidthType) === (0, $1d2ww.ContentAppearanceType).DEFAULT;
        if (hasEndOfPageRecommendations) // when end-of-page recommendations is present, always match its width (see EndOfPageRecContainer.tsx)
        return {
            width: isDefaultWidth ? '87.5%' : '100%',
            maxWidth: endOfPageRecommendationsMaxWidth
        };
        else return {
            width: '100%',
            maxWidth: isDefaultWidth ? '760px' : '1800px' // if not defaultWidth, use full page width
        };
    }
    if (pageMode !== (0, $cD1qu.PageMode).VIEW && ((0, $9wGTI.fg)('confluence_frontend_unify_footer_comment_width_ld') || (0, $6mKj3.expValEquals)('confluence_unify_footer_comments_space_width', 'isEnabled', true))) return {
        width: '100%',
        maxWidth: hasEndOfPageRecommendations && (0, $6mKj3.expValEquals)('confluence_ai_related_content_for_live_pages', 'isEnabled', true) ? endOfPageRecommendationsMaxWidth : '100%'
    };
    // Base case: when the fg for the current pageMode isn't ON, i.e. either of:
    // - pageMode === PageMode.VIEW && !fg('confluence_frontend_unify_footer_comment_width') && !expValEquals('confluence_unify_footer_comments_space_width', 'isEnabled', true)
    // - pageMode !== PageMode.VIEW && !fg('confluence_frontend_unify_footer_comment_width_ld') && !expValEquals('confluence_unify_footer_comments_space_width', 'isEnabled', true)
    // This block can be removed entirely once both fgs are rolled out.
    let maxWidth = '100%';
    if (pageWidthType) maxWidth = JSON.parse(pageWidthType) === (0, $1d2ww.ContentAppearanceType).DEFAULT ? '1000px' : 'unset';
    return {
        width: '100%',
        maxWidth: maxWidth
    };
};
module.exports["CREATE_COMMENT_SELECTION_CLASS"] = $a78c261c3211f7d6$export$d2bdbdaa2c26e7f7;
module.exports["HIGHLIGHT_CLASS"] = $a78c261c3211f7d6$export$b803c692fbaaa5a4;
module.exports["ACTIVE_CLASS"] = $a78c261c3211f7d6$export$fb3d0eebfe85522a;
module.exports["getCommentIndexAndCount"] = $a78c261c3211f7d6$export$b899b07e3f725968;
module.exports["getInlineMarkSelector"] = $a78c261c3211f7d6$export$8c7b048437c01388;
module.exports["getMarkerRef"] = $a78c261c3211f7d6$export$8f4213b45c05ab5d;
module.exports["getSortedMarkerRefs"] = $a78c261c3211f7d6$export$9b48c18cc387f791;
module.exports["clearActiveHighlight"] = $a78c261c3211f7d6$export$f7ceeb7ba8156450;
module.exports["getNextTextNode"] = $a78c261c3211f7d6$export$3e98291f1f032a77;
module.exports["getHighlightOffset"] = $a78c261c3211f7d6$export$739c145b6a07c076;
module.exports["getHighlightFromMarkerRef"] = $a78c261c3211f7d6$export$21445ab787d3b446;
module.exports["calculateElementOffset"] = $a78c261c3211f7d6$export$331805bfbe18b1c0;
module.exports["resetTemporaryDOMHighlight"] = $a78c261c3211f7d6$export$743373b19993e2b0;
module.exports["convertDOMHighlightToMark"] = $a78c261c3211f7d6$export$a160a5110cbadcb8;
module.exports["setCommentAsActive"] = $a78c261c3211f7d6$export$fd55463aeed84830;
module.exports["removeMarkInDOM"] = $a78c261c3211f7d6$export$a26c4eafef12029f;
module.exports["isEmptyAdf"] = $a78c261c3211f7d6$export$915f03d46d87bfd4;
module.exports["getFocusableElementFromMarkerRef"] = $a78c261c3211f7d6$export$c36aa9f15eddb765;
module.exports["keyPropagationList"] = $a78c261c3211f7d6$export$6d23af9d8c2844b1;
module.exports["scrollToElementWithViewingRoom"] = $a78c261c3211f7d6$export$fc9b5eebad60b835;
module.exports["scrollCommentIntoView"] = $a78c261c3211f7d6$export$c7436bd0a15f3e7e;
module.exports["getNodeForTableORMacro"] = $a78c261c3211f7d6$export$ee0755cb593feed6;
module.exports["checkElementExpand"] = $a78c261c3211f7d6$export$876171b9c9b54aab;
module.exports["getSidebarId"] = $a78c261c3211f7d6$export$fb40c5e75b82df8;
module.exports["isFirstTabbableElement"] = $a78c261c3211f7d6$export$642e21ba866d02df;
module.exports["isLastTabbableElement"] = $a78c261c3211f7d6$export$876aeb5dffd449af;
module.exports["focusElementAndUpdateTabIndex"] = $a78c261c3211f7d6$export$cfa8eefe354167cd;
module.exports["scrollToComment"] = $a78c261c3211f7d6$export$db9eae89818590a4;
module.exports["checkElementExpandMultiLevelCommon"] = $a78c261c3211f7d6$export$1a2319f5c2109ee1;
module.exports["getNextMarkerRef"] = $a78c261c3211f7d6$export$187f977414e8342c;
module.exports["getNextUnreadThreadKey"] = $a78c261c3211f7d6$export$883ebc059dd86e88;
module.exports["copyToClipboard"] = $a78c261c3211f7d6$export$2cdf1b96a9f86d16;
module.exports["calculateEditorOffsetFromParent"] = $a78c261c3211f7d6$export$ab567600730c0b3b;
module.exports["calculateRendererOffsetFromParent"] = $a78c261c3211f7d6$export$3cdeee3ea1732782;
module.exports["getCommentPositionTopOfSectionEditor"] = $a78c261c3211f7d6$export$9f8164812b21bc7a;
module.exports["getCommentPositionTopOfSectionRenderer"] = $a78c261c3211f7d6$export$e3a17b46d43aa5f6;
module.exports["watchForCommentContainerAndScroll"] = $a78c261c3211f7d6$export$b3ba907d5759e257;
module.exports["watchForCommentRepliesAndScroll"] = $a78c261c3211f7d6$export$b1b7c9bcc75c855d;
module.exports["shouldScrollCommentThreadToTop"] = $a78c261c3211f7d6$export$4d211f4974dcf196;
module.exports["isCommentThreadReplyOutOfView"] = $a78c261c3211f7d6$export$9c5b7a3c864ae31b;
module.exports["getWidthAndMaxWidth"] = $a78c261c3211f7d6$export$e3c287b6d80b16ce;

});

parcelRegister("i49vP", function(module, exports) {

var $gfqXk = parcelRequire("gfqXk");


var $4EKKB = parcelRequire("4EKKB");


var $aHcFH = parcelRequire("aHcFH");

const $36cd0189b09a46b6$var$getElementOffsetFromTopOfPage = (element)=>{
    let elementOffsetTop = 0;
    let nodeToMeasure = element;
    while(nodeToMeasure && !nodeToMeasure.classList.contains('fabric-editor-popup-scroll-parent')){
        elementOffsetTop += nodeToMeasure.offsetTop;
        nodeToMeasure = nodeToMeasure.offsetParent;
    }
    return elementOffsetTop;
};
const $36cd0189b09a46b6$export$cc3d34287540b287 = (element)=>{
    const expandSelectors = [
        '.ak-editor-expand'
    ];
    const getExpandButton = (node)=>{
        if (node.classList.contains('ak-editor-expand')) {
            const button = node.querySelector('.ak-editor-expand__icon-container');
            return button;
        }
        return null;
    };
    const isExpanded = (button)=>{
        const expandContainer = button.closest('.ak-editor-expand');
        return expandContainer?.classList.contains('ak-editor-expand__expanded') || false;
    };
    const onExpand = ()=>{
        (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
            isInExpand: true
        });
    };
    (0, $aHcFH.checkElementExpandMultiLevelCommon)(element, {
        isEditor: true,
        expandSelectors: expandSelectors,
        getExpandButton: getExpandButton,
        isExpanded: isExpanded,
        onExpand: onExpand
    });
};
const $36cd0189b09a46b6$export$a1bb3d68e0c3dbb8 = (element)=>{
    $36cd0189b09a46b6$export$cc3d34287540b287(element);
};
const $36cd0189b09a46b6$export$2163ce5a75e4a465 = ({ targetElement: targetElement, targetElementID: targetElementID, shouldScroll: shouldScroll = true })=>{
    const emitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
    $36cd0189b09a46b6$export$a1bb3d68e0c3dbb8(targetElement);
    emitter.emit('setselectedannotation', targetElementID);
    window.getSelection()?.setPosition(targetElement);
    shouldScroll && $36cd0189b09a46b6$export$4ee22c4fac4681d8({
        targetElement: targetElement,
        viewingRoomOffset: -100
    });
};
const $36cd0189b09a46b6$export$4ee22c4fac4681d8 = ({ targetElement: targetElement, viewingRoomOffset: viewingRoomOffset = 0 })=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const editorScrollableContainer = document.querySelector('.fabric-editor-popup-scroll-parent');
    if (editorScrollableContainer) editorScrollableContainer.scrollTo(0, $36cd0189b09a46b6$var$getElementOffsetFromTopOfPage(targetElement) + viewingRoomOffset // add viewing room
    );
};
const $36cd0189b09a46b6$export$443ba0c8d1b21569 = ({ data: data, previousAnnotations: previousAnnotations })=>{
    const emitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
    const topLevelCommentMarkerRefs = data?.comments?.nodes?.map((node)=>(node?.location).inlineMarkerRef);
    if (topLevelCommentMarkerRefs && topLevelCommentMarkerRefs.length > 0) {
        const newAnnotationsSet = new Set(topLevelCommentMarkerRefs);
        const removedMarkerRefs = [];
        previousAnnotations.forEach((item)=>{
            if (!newAnnotationsSet.has(item)) removedMarkerRefs.push(item);
        });
        let updatedAnnotations = [
            ...previousAnnotations
        ];
        const addedMarkerRefs = [];
        newAnnotationsSet.forEach((item)=>{
            if (!previousAnnotations.includes(item)) addedMarkerRefs.push(item);
        });
        for (const markerRef of addedMarkerRefs){
            emitter.emit('create', markerRef);
            updatedAnnotations.push(markerRef);
        }
        for (const markerRef of removedMarkerRefs){
            emitter.emit('resolve', markerRef);
            updatedAnnotations = updatedAnnotations.filter((annotation)=>annotation !== markerRef);
        }
        return updatedAnnotations;
    }
    return [];
};
module.exports["checkElementExpandInEditor"] = $36cd0189b09a46b6$export$a1bb3d68e0c3dbb8;
module.exports["openInlineCommentInEditor"] = $36cd0189b09a46b6$export$2163ce5a75e4a465;
module.exports["scrollToElementInEditor"] = $36cd0189b09a46b6$export$4ee22c4fac4681d8;

});

parcelRegister("9FoVw", function(module, exports) {
/**
 * @fileoverview Unified comment navigation utilities for scrolling to different comment types
 * and handling various navigation scenarios across editor and renderer contexts.
 */ 
var $fJCU9 = parcelRequire("fJCU9");


var $gczDe = parcelRequire("gczDe");


var $gfqXk = parcelRequire("gfqXk");


var $6mKj3 = parcelRequire("6mKj3");


var $4L9ve = parcelRequire("4L9ve");


var $kgNLQ = parcelRequire("kgNLQ");


var $i49vP = parcelRequire("i49vP");


var $aHcFH = parcelRequire("aHcFH");

var $0343eaf78527fd4c$export$99058db374262376 = /*#__PURE__*/ function(ShortcutType) {
    ShortcutType["NEXT"] = "next";
    ShortcutType["PREVIOUS"] = "previous";
    ShortcutType["UNREAD"] = "unread";
    return ShortcutType;
}({});
var $0343eaf78527fd4c$export$ca559f4ef107f965 = /*#__PURE__*/ function(ViewValues) {
    ViewValues["OPEN"] = "OPEN";
    ViewValues["UNREAD"] = "UNREAD";
    ViewValues["DELETED_CONTENT"] = "DELETED_CONTENT";
    ViewValues["RESOLVED"] = "RESOLVED";
    ViewValues["MENTIONS_ME"] = "MENTIONS_ME";
    return ViewValues;
}({});
// Navigation types based on comment scrolling architecture
var $0343eaf78527fd4c$var$NavigationType = /*#__PURE__*/ function(NavigationType) {
    NavigationType["INLINE_ANNOTATION"] = "inline_annotation";
    NavigationType["COMMENTS_PANEL"] = "comments_panel";
    NavigationType["FOOTER_COMMENTS"] = "footer_comments";
    NavigationType["DEEP_LINK"] = "deep_link";
    NavigationType["KEYBOARD_SHORTCUT"] = "keyboard_shortcut";
    NavigationType["INLINE_HEADER_ARROWS"] = "inline_header_arrows";
    return NavigationType;
}($0343eaf78527fd4c$var$NavigationType || {});
var $0343eaf78527fd4c$export$e6e360ac7d345e5 = /*#__PURE__*/ function(ScrollBehavior) {
    ScrollBehavior["INSTANT"] = "instant";
    ScrollBehavior["SMOOTH"] = "smooth";
    return ScrollBehavior;
}({});
var $0343eaf78527fd4c$export$3044ab7fdabeaee6 = /*#__PURE__*/ function(NavigationContext) {
    NavigationContext["EDITOR"] = "editor";
    NavigationContext["RENDERER"] = "renderer";
    NavigationContext["PANEL"] = "panel";
    NavigationContext["REPLY"] = "reply";
    return NavigationContext;
}({});
var $0343eaf78527fd4c$export$368ed1d84e0ae668 = /*#__PURE__*/ function(CommentNavigationStatus) {
    CommentNavigationStatus["FOUND_IN_DOM"] = "FOUND_IN_DOM";
    CommentNavigationStatus["DELETED_CONTENT"] = "DELETED_CONTENT";
    CommentNavigationStatus["RESOLVED"] = "RESOLVED";
    CommentNavigationStatus["UNKNOWN"] = "UNKNOWN";
    CommentNavigationStatus["REMOVED_BY_ANOTHER_USER"] = "REMOVED_BY_ANOTHER_USER";
    return CommentNavigationStatus;
}({});
var $0343eaf78527fd4c$export$352adda3721e4ee = /*#__PURE__*/ function(CommentNavigationCategory) {
    CommentNavigationCategory["FOUND"] = "FOUND";
    CommentNavigationCategory["ANNOTATION_FOUND_COMMENT_MISSING"] = "ANNOTATION_FOUND_COMMENT_MISSING";
    CommentNavigationCategory["ANNOTATION_MISSING_COMMENT_FOUND"] = "ANNOTATION_MISSING_COMMENT_FOUND";
    CommentNavigationCategory["ANNOTATION_AND_COMMENT_MISSING"] = "ANNOTATION_AND_COMMENT_MISSING";
    CommentNavigationCategory["COMMENTS_DATA_NOT_LOADED"] = "COMMENTS_DATA_NOT_LOADED";
    CommentNavigationCategory["COMMENTS_DATA_ERROR"] = "COMMENTS_DATA_ERROR";
    CommentNavigationCategory["COMMENT_RESOLVED"] = "COMMENT_RESOLVED";
    CommentNavigationCategory["COMMENT_REMOVED_BY_ANOTHER_USER"] = "COMMENT_REMOVED_BY_ANOTHER_USER";
    return CommentNavigationCategory;
}({});
const $0343eaf78527fd4c$export$9f32f1ed184088e0 = (options)=>{
    const { scrollBehavior: scrollBehavior, context: context, block: block, inline: inline, markElement: markElement, annotationId: annotationId } = options;
    if (!markElement) return false;
    // Handle different contexts
    switch(context){
        case "editor":
            // Check if element needs to be expanded in editor
            (0, $i49vP.checkElementExpandInEditor)(markElement);
            // Emit the setselectedannotation event
            const editorEmitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
            editorEmitter.emit('setselectedannotation', markElement.id);
            // Scroll to the element in editor
            (0, $i49vP.scrollToElementInEditor)({
                targetElement: markElement,
                viewingRoomOffset: -100
            });
            return true;
        case "renderer":
            // Renderer-specific logic with improved focus management
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const focusedMarkerRef = document.querySelector("[data-has-focus='true']");
            if (focusedMarkerRef?.id !== markElement.id) {
                const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
                emitter.emit((0, $fJCU9.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, {
                    annotationId: markElement.id
                });
                // Check if element needs to be expanded
                (0, $aHcFH.checkElementExpand)(markElement, true);
            }
            // Scroll to the annotation mark
            markElement.scrollIntoView({
                behavior: scrollBehavior === "instant" ? 'instant' : 'smooth',
                block: block,
                inline: inline
            });
            return true;
        case "panel":
            // For panel context, ensure annotation is visible and highlighted
            if (annotationId) {
                // Emit events to ensure the annotation is properly focused
                const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
                emitter.emit((0, $fJCU9.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, {
                    annotationId: annotationId
                });
            }
            // Scroll the annotation into view
            markElement.scrollIntoView({
                behavior: scrollBehavior === "instant" ? 'instant' : 'smooth',
                block: block,
                inline: inline
            });
            return true;
        default:
            return false;
    }
};
/**
 * Wait for the comments panel to be rendered in the DOM
 * Returns a Promise that resolves when the panel is available or times out after 5 seconds
 */ const $0343eaf78527fd4c$var$waitForCommentsPanel = ()=>{
    const commentsPanelListContainerId = 'comments-panel-list-container';
    return new Promise((resolve)=>{
        const observer = new MutationObserver(()=>{
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const panel = document.querySelector(`[data-testid='${commentsPanelListContainerId}']`);
            if (panel) {
                observer.disconnect();
                resolve(true);
            }
        });
        // Start observing the document body for changes
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        // Set a timeout to avoid infinite waiting
        setTimeout(()=>{
            observer.disconnect();
            resolve(false);
        }, 5000); // 5 second timeout
    });
};
/**
 * Wait for the comments panel view/filter to change to the specified view
 * Returns a Promise that resolves when the view change is complete or times out after 3 seconds
 */ const $0343eaf78527fd4c$var$waitForViewChange = (expectedView)=>{
    return new Promise((resolve)=>{
        // Check if the view has already changed by checking the data-current-view attribute on the container
        const checkView = ()=>{
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const container = document.querySelector('[data-testid="comments-panel-list-container"]');
            if (container && container.getAttribute('data-current-view') === expectedView) return true;
        };
        if (checkView()) {
            resolve(true);
            return;
        }
        // Observe document body for both container creation and attribute changes
        // This handles cases where the container gets unmounted/remounted
        const observer = new MutationObserver(()=>{
            if (checkView()) {
                observer.disconnect();
                resolve(true);
            }
        });
        // Observe the entire document body to catch:
        // 1. Container being created/removed
        // 2. Attribute changes on the container when it exists
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: [
                'data-current-view'
            ]
        });
        // Set a timeout to avoid infinite waiting
        setTimeout(()=>{
            observer.disconnect();
            resolve(false);
        }, 3000); // 3 second timeout
    });
};
/**
 * Check if the top edge of an element is visible in the viewport
 * Used to determine if scrolling is needed based on element visibility
 */ const $0343eaf78527fd4c$var$isElementTopVisible = (element)=>{
    const rect = element.getBoundingClientRect();
    return rect.top >= 0;
};
/**
 * Wait for an element to finish scrolling into view
 * Returns a Promise that resolves when the element is reasonably visible or times out
 */ const $0343eaf78527fd4c$var$waitForScrollCompletion = (element, timeout = 3000)=>{
    return new Promise((resolve)=>{
        const startTime = Date.now();
        const check = ()=>{
            if ($0343eaf78527fd4c$var$isElementTopVisible(element)) // Add a small delay after element becomes visible to let scrolling settle
            setTimeout(()=>resolve(true), 150);
            else if (Date.now() - startTime > timeout) resolve(false);
            else requestAnimationFrame(check);
        };
        // Small delay to let scroll animation start
        setTimeout(check, 16);
    });
};
/**
 * Helper function for viewport checking - returns true if should skip scrolling due to viewport visibility
 */ const $0343eaf78527fd4c$var$checkAndHandleViewportVisibility = (element, shouldScrollIfCommentIsInViewport)=>{
    if (!shouldScrollIfCommentIsInViewport) {
        const commentIsInViewport = $0343eaf78527fd4c$var$isElementTopVisible(element);
        if (commentIsInViewport) return true;
    }
    return false;
};
/**
 * Handle scroll completion based on awaitScrollCompletion flag and scroll behavior
 */ const $0343eaf78527fd4c$var$handleScrollCompletion = (awaitScrollCompletion, scrollBehavior, element)=>{
    if (awaitScrollCompletion) return scrollBehavior === "smooth" ? $0343eaf78527fd4c$var$waitForScrollCompletion(element) : Promise.resolve(true);
    return true;
};
/**
 * Check if an element is already fully visible within the panel
 * Avoids unnecessary scrolling if the element is already in view
 */ const $0343eaf78527fd4c$var$isElementFullyVisible = (element)=>{
    const elementRect = element.getBoundingClientRect();
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const panelContainer = document.querySelector('[data-testid="comments-panel-list-container"]');
    const panelRect = panelContainer?.getBoundingClientRect();
    if (!panelRect) return false;
    return elementRect.top >= panelRect.top && elementRect.bottom <= panelRect.bottom;
};
/**
 * Determine the optimal scroll position based on context and comment type
 * Considers whether to scroll to start, center, or end based on various factors
 */ const $0343eaf78527fd4c$var$determineScrollPosition = (element, block, scrollToEnd, commentType)=>{
    let scrollBlock = block;
    if (scrollToEnd) {
        // Check if the comment thread reply is out of view
        // Map CommentsType to CommentType enum for domUtils functions
        const commentTypeEnum = commentType === 'INLINE' ? (0, $kgNLQ.CommentType).INLINE : (0, $kgNLQ.CommentType).GENERAL;
        const isOutOfView = (0, $aHcFH.isCommentThreadReplyOutOfView)(element, commentTypeEnum);
        if (isOutOfView) scrollBlock = 'end';
    } else {
        // Check if we should scroll to top
        // Map CommentsType to CommentType enum for domUtils functions
        const commentTypeEnum = commentType === 'INLINE' ? (0, $kgNLQ.CommentType).INLINE : (0, $kgNLQ.CommentType).GENERAL;
        const shouldScrollToTop = (0, $aHcFH.shouldScrollCommentThreadToTop)(element, commentTypeEnum);
        if (shouldScrollToTop) scrollBlock = 'start';
    }
    return scrollBlock;
};
/**
 * Perform the actual scrolling operation with optimized behavior
 * Handles different scroll scenarios based on user interaction context
 */ const $0343eaf78527fd4c$var$performScrollToElement = (element, scrollBehavior, block, scrollToEnd, hasKeyPressed, annotationClicked, scrollOnLoad, commentType)=>{
    // Skip scrolling if element is already fully visible
    if ($0343eaf78527fd4c$var$isElementFullyVisible(element)) return;
    // Determine scroll behavior based on trigger type
    if (hasKeyPressed || annotationClicked || scrollOnLoad) {
        const scrollBlock = $0343eaf78527fd4c$var$determineScrollPosition(element, block, scrollToEnd, commentType);
        element.scrollIntoView({
            behavior: scrollBehavior === "instant" ? 'instant' : 'smooth',
            block: scrollBlock
        });
    } else // Default scroll behavior
    element.scrollIntoView({
        behavior: scrollBehavior === "instant" ? 'instant' : 'smooth',
        block: block
    });
};
const $0343eaf78527fd4c$export$390f6df30bfcd812 = (options)=>{
    const { scrollBehavior: scrollBehavior, context: context, block: block, commentId: commentId, annotationId: annotationId, commentType: commentType, scrollToEnd: scrollToEnd = false, hasKeyPressed: hasKeyPressed = false, annotationClicked: annotationClicked = false, scrollOnLoad: scrollOnLoad = false, shouldScrollIfCommentIsInViewport: shouldScrollIfCommentIsInViewport = true, awaitScrollCompletion: awaitScrollCompletion = false } = options;
    // Only handle panel context navigation
    if (context !== "panel") return false;
    // Define panel container and thread selectors
    const commentsPanelListContainerId = 'comments-panel-list-container';
    // annotationId is used for DOM selectors, commentId is the actual comment identifier
    const commentThreadContainerId = `comment-thread-${annotationId}-container`;
    // Check if panel is available, wait if not
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const panelContainer = document.querySelector(`[data-testid='${commentsPanelListContainerId}']`);
    if (!panelContainer) // Panel is not rendered yet, wait for it to appear
    return $0343eaf78527fd4c$var$waitForCommentsPanel().then((panelAvailable)=>{
        if (panelAvailable) // Recursively call the function now that panel is available
        return $0343eaf78527fd4c$export$390f6df30bfcd812(options);
        return false;
    });
    // Look for the specific comment thread container
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const commentThreadElement = document.querySelector(`[data-testid='${commentThreadContainerId}']`);
    // If comment thread exists, scroll immediately
    if (commentThreadElement) {
        const skipScrollDueToViewport = $0343eaf78527fd4c$var$checkAndHandleViewportVisibility(commentThreadElement, shouldScrollIfCommentIsInViewport);
        if (skipScrollDueToViewport) return true;
        $0343eaf78527fd4c$var$performScrollToElement(commentThreadElement, scrollBehavior, block, scrollToEnd, hasKeyPressed, annotationClicked, scrollOnLoad, commentType);
        // For panel navigation, always return Promise when awaitScrollCompletion is true
        return $0343eaf78527fd4c$var$handleScrollCompletion(awaitScrollCompletion, scrollBehavior, commentThreadElement);
    }
    // Use optimized observer to watch for comment thread container creation
    if (commentId) (0, $aHcFH.watchForCommentContainerAndScroll)(commentId);
    else if (annotationId) (0, $aHcFH.watchForCommentContainerAndScroll)('', annotationId);
    return true;
};
const $0343eaf78527fd4c$export$dcd3c0d6a66d0412 = async (options)=>{
    const { expectedView: expectedView, commentId: commentId, annotationId: annotationId, ...navigationOptions } = options;
    // Only wait for view change for panel context
    if (navigationOptions.context === "panel" && expectedView) await $0343eaf78527fd4c$var$waitForViewChange(expectedView);
    // Then perform the navigation - pass both commentId and annotationId
    return $0343eaf78527fd4c$export$390f6df30bfcd812({
        ...navigationOptions,
        commentId: commentId,
        annotationId: annotationId
    });
};
const $0343eaf78527fd4c$export$34fd7e98d0739b5c = (options)=>{
    const { block: block, inline: inline, commentId: commentId, scrollBehavior: scrollBehavior, navigationContext: navigationContext, shouldScrollIfCommentIsInViewport: shouldScrollIfCommentIsInViewport = true, awaitScrollCompletion: awaitScrollCompletion = false } = options;
    let containerId;
    if (!commentId) return false;
    // Check if comment already exists in DOM
    // Determine container ID based on navigation context:
    // - PANEL: uses comment-thread container
    // - REPLY: uses data-comment-id attribute selector
    // - Default (footer): uses footer-comment-thread container
    if (navigationContext === "panel") containerId = `comment-thread-${commentId}-container`;
    else if (navigationContext === "reply") containerId = `[data-comment-id="${commentId}"]`;
    else containerId = `footer-comment-thread-${commentId}-container`;
    // Use querySelector for REPLY context (attribute selector), getElementById for others (ID)
    const existingComment = navigationContext === "reply" ? // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector(containerId) : // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.getElementById(containerId);
    if (existingComment) {
        const skipScrollDueToViewport = $0343eaf78527fd4c$var$checkAndHandleViewportVisibility(existingComment, shouldScrollIfCommentIsInViewport);
        if (skipScrollDueToViewport) return true;
        // Comment is already rendered, scroll to it immediately
        existingComment.scrollIntoView({
            behavior: scrollBehavior,
            block: block,
            inline: inline
        });
        // Wait for scroll completion when awaitScrollCompletion is true, otherwise return true
        return $0343eaf78527fd4c$var$handleScrollCompletion(awaitScrollCompletion, scrollBehavior, existingComment);
    } else {
        // Comment not yet rendered, use DOM resolver to watch for it
        (0, $aHcFH.watchForCommentRepliesAndScroll)({
            targetCommentId: commentId,
            onScrollReady: (commentElement)=>{
                // Find the container element by ID or selector based on navigation context
                const containerElement = navigationContext === "reply" ? // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                document.querySelector(containerId) : // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                document.getElementById(containerId);
                const elementToScroll = containerElement || commentElement;
                elementToScroll.scrollIntoView({
                    behavior: scrollBehavior,
                    block: block,
                    inline: inline
                });
            },
            containerId: containerId
        });
        return true;
    }
};
const $0343eaf78527fd4c$export$ea1c337d9000e2 = (options)=>{
    const { scrollBehavior: scrollBehavior, block: block, inline: inline, commentId: commentId, markElement: markElement, context: context } = options;
    if (!commentId || !markElement) return false;
    // Check if comment already exists in DOM
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const existingComment = document.querySelector(`[data-comment-id="${commentId}"]`);
    if (existingComment) {
        // Comment is already rendered, scroll to it immediately
        existingComment.scrollIntoView({
            behavior: scrollBehavior,
            block: block,
            inline: inline
        });
        return true;
    }
    // we need to click on the annotation in the editor if the comment is not yet rendered
    if (context === "editor" && markElement) (0, $i49vP.openInlineCommentInEditor)({
        targetElement: markElement,
        targetElementID: markElement.id,
        shouldScroll: false
    });
    // Comment not yet rendered, use DOM resolver to watch for it
    (0, $aHcFH.watchForCommentRepliesAndScroll)({
        targetCommentId: commentId,
        onScrollReady: (commentElement)=>{
            commentElement.scrollIntoView({
                behavior: scrollBehavior,
                block: block,
                inline: inline
            });
        },
        markElement: markElement
    });
    return true;
};
const $0343eaf78527fd4c$export$807107038899c351 = (options)=>{
    const { scrollBehavior: scrollBehavior, block: block, inline: inline, annotationId: annotationId, commentId: commentId, commentType: commentType, isCommentsPanelOpen: isCommentsPanelOpen, hasKeyPressed: hasKeyPressed = true, scrollToEnd: scrollToEnd = false, context: context, shortcutType: shortcutType, isResolved: isResolved, previousAnnotationId: previousAnnotationId } = options;
    // Get the mark element for both inline navigation and annotation events
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    let markElement = document.getElementById(annotationId);
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const commentElement = document.querySelector(`[data-comment-id="${commentId}"]`);
    // Get the previous comment element for difference-based scrolling
    const previousCommentElement = previousAnnotationId ? // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.getElementById(previousAnnotationId) : null;
    // Check if the mark element is in a sticky table header and adjust if needed
    const isInStickyTableHeader = markElement?.closest && markElement.closest('.pm-table-sticky-wrapper');
    if (isInStickyTableHeader && markElement && (0, $6mKj3.expValEquals)('confluence_comment_enable_table_header_navigation', 'isEnabled', true)) // Get the real element from the non-sticky table using getNodeForTableORMacro
    markElement = (0, $aHcFH.getNodeForTableORMacro)(markElement) || markElement;
    if (commentType === 'FOOTER') $0343eaf78527fd4c$export$34fd7e98d0739b5c({
        scrollBehavior: scrollBehavior,
        block: block,
        inline: inline || 'center',
        commentId: annotationId
    });
    // If comments panel is open, use panel navigation
    if (isCommentsPanelOpen) {
        // For inline comments, also call handleInlineAnnotationNavigation to ensure proper inline comment behavior
        if (commentType === 'INLINE' && !isResolved) $0343eaf78527fd4c$export$9f32f1ed184088e0({
            scrollBehavior: scrollBehavior,
            context: context || "panel",
            block: block,
            inline: inline || 'center',
            markElement: markElement,
            annotationId: annotationId
        });
        // This ensure the ViewComponent useEffect is not triggered
        if (markElement && !isResolved) {
            // Emit annotation events for panel navigation
            if (context === "editor") {
                const editorEmitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
                editorEmitter.emit('setselectedannotation', annotationId);
            } else if (context === "renderer") {
                const rendererEmitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
                rendererEmitter.emit((0, $fJCU9.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
                    annotationIds: [
                        annotationId
                    ],
                    eventTarget: null
                });
            }
        }
        // Use the existing panel navigation logic
        const result = $0343eaf78527fd4c$export$390f6df30bfcd812({
            scrollBehavior: scrollBehavior,
            context: "panel",
            block: block,
            inline: inline,
            annotationId: annotationId,
            commentType: commentType,
            hasKeyPressed: hasKeyPressed,
            scrollToEnd: scrollToEnd
        });
        if (result instanceof Promise) // For async panel navigation, return true immediately
        // The actual navigation will happen asynchronously
        return true;
        return result;
    }
    if (!markElement) return false;
    // For standalone navigation (comments panel closed), expand the element if needed
    if (commentType === 'INLINE' && context === "renderer") (0, $aHcFH.checkElementExpand)(markElement, true);
    // Use difference-based scrolling if we have both previous and next elements
    if (previousCommentElement && markElement && previousCommentElement !== markElement && (0, $6mKj3.expValEquals)('confluence_comment_use_kbs_exp', 'isEnabled', true)) {
        if (context === "editor") {
            // For editor: use scrollableContainer.scrollBy with difference offset
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const scrollableContainer = document.querySelector('.fabric-editor-popup-scroll-parent');
            if (scrollableContainer) {
                // Calculate difference between next and previous comment positions
                const nextRect = markElement.getBoundingClientRect();
                const previousRect = previousCommentElement.getBoundingClientRect();
                const differenceOffset = nextRect.top - previousRect.top;
                scrollableContainer.scrollBy(0, differenceOffset);
            }
        } else // For renderer: use scrollToComment with difference-based scrolling
        (0, $aHcFH.scrollToComment)(markElement, previousCommentElement, true, false);
        return true;
    }
    // For unread navigation, scroll to the comment element with data-comment-id instead of markElement
    if (shortcutType === "unread" && commentElement) commentElement.scrollIntoView({
        behavior: scrollBehavior,
        block: block,
        inline: inline || 'nearest'
    });
    else // For standalone navigation, we don't emit events - just scroll to the element
    markElement.scrollIntoView({
        behavior: scrollBehavior,
        block: block,
        inline: inline || 'nearest'
    });
    return true;
};
/**
 * Calculate the height of media comment placeholder to adjust scroll offset.
 * When the media comment placeholder is visible, it pushes the contents of the page down,
 * so we need to scroll a bit less to keep the cursor over the navigation arrow icon.
 */ const $0343eaf78527fd4c$var$getMediaCommentPlaceholderHeight = (options)=>{
    const { previousCommentElement: previousCommentElement, action: action, nextCommentIndex: nextCommentIndex, totalComments: totalComments } = options;
    const isCurrentCommentContentMediaComment = previousCommentElement?.closest('.media-single-node');
    const isNavigatingToLastCommentFromPreviousAction = action === 'previous' && nextCommentIndex === totalComments - 1;
    const isNavigatingToFirstCommentFromNextAction = action === 'next' && nextCommentIndex === 0;
    if (isCurrentCommentContentMediaComment && (action === 'next' || isNavigatingToLastCommentFromPreviousAction || isNavigatingToFirstCommentFromNextAction)) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const mediaCommentSelectedPlaceholder = document.querySelector('[data-id="caption-placeholder"]');
        return mediaCommentSelectedPlaceholder ? mediaCommentSelectedPlaceholder.offsetHeight : 0;
    }
    return 0;
};
const $0343eaf78527fd4c$export$36dad1a923539611 = (options)=>{
    const { previousMarkerRef: previousMarkerRef, nextMarkerRef: nextMarkerRef, context: context, action: action, nextCommentIndex: nextCommentIndex, totalComments: totalComments } = options;
    // Get the next comment element
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const nextMarkElement = document.getElementById(nextMarkerRef);
    if (!nextMarkElement) return false;
    // Get the previous and next comment elements
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const previousCommentElement = document.getElementById(previousMarkerRef);
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const nextCommentElement = document.getElementById(nextMarkerRef);
    if (previousCommentElement && nextCommentElement) {
        const heightOfMediaCommentSelectedPlaceholder = $0343eaf78527fd4c$var$getMediaCommentPlaceholderHeight({
            previousCommentElement: previousCommentElement,
            action: action,
            nextCommentIndex: nextCommentIndex,
            totalComments: totalComments
        });
        if (context === "editor") {
            // For editor: use scrollableContainer.scrollBy with difference offset
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const scrollableContainer = document.querySelector('.fabric-editor-popup-scroll-parent');
            if (scrollableContainer) {
                // Calculate difference between current and previous comment positions using calculateElementOffset
                // This handles special cases like sticky table headers
                const previousOffset = (0, $aHcFH.calculateElementOffset)(previousCommentElement);
                const nextOffset = (0, $aHcFH.calculateElementOffset)(nextCommentElement);
                const differenceOffset = nextOffset - previousOffset - heightOfMediaCommentSelectedPlaceholder;
                scrollableContainer.scrollBy(0, differenceOffset);
            }
        } else // For renderer: use scrollToComment
        (0, $aHcFH.scrollToComment)(nextCommentElement, previousCommentElement, true, false);
    }
    return true;
};
/**
 * Wait for a comment marker element to appear in the DOM.
 * Resolves immediately if the element already exists, otherwise waits via MutationObserver until timeout.
 */ const $0343eaf78527fd4c$var$waitForCommentElement = ({ markerRef: markerRef, timeoutMs: timeoutMs })=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const existingElement = document.getElementById(markerRef);
    if (existingElement) return Promise.resolve(existingElement);
    return new Promise((resolve)=>{
        const observer = new MutationObserver(()=>{
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const element = document.getElementById(markerRef);
            if (!element) return;
            observer.disconnect();
            resolve(element);
        });
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        setTimeout(()=>{
            observer.disconnect();
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const fallbackElement = document.getElementById(markerRef);
            resolve(fallbackElement);
        }, timeoutMs);
    });
};
const $0343eaf78527fd4c$export$6591627df1eb1f44 = async ({ markerRef: markerRef, commentId: commentId, timeoutMs: timeoutMs = 3000, getCommentThreadsRemovedByOtherUsers: getCommentThreadsRemovedByOtherUsers })=>{
    let element = null;
    const waitStartedAt = Date.now();
    if (markerRef) element = await $0343eaf78527fd4c$var$waitForCommentElement({
        markerRef: markerRef,
        timeoutMs: timeoutMs
    });
    const annotationWaitMs = Date.now() - waitStartedAt;
    // Read processed state after DOM wait to avoid stale classification.
    const state = (0, $4L9ve.getProcessedCommentsDataState)();
    const rootComment = state.isDataProcessed && markerRef ? state.flatMarkerRefMap[markerRef] : undefined;
    const commentFoundInData = Boolean(rootComment || commentId && state.flatCommentsMap[commentId]);
    const diagnosticsFor = (navigationCategory)=>({
            navigationCategory: navigationCategory,
            annotationFoundInDom: Boolean(element),
            commentFoundInData: commentFoundInData,
            commentsDataLoaded: state.isDataProcessed,
            commentsDataFailed: Boolean(state.error),
            commentsDataCount: state.commentCount,
            annotationWaitMs: annotationWaitMs
        });
    // NOTE - we can't import the official type here due to circular dep concerns
    if (commentId) {
        const commentThreadsRemovedByOtherUsers = getCommentThreadsRemovedByOtherUsers?.();
        if (commentThreadsRemovedByOtherUsers?.[commentId] === 'deleted') return {
            status: "REMOVED_BY_ANOTHER_USER",
            element: undefined,
            diagnostics: diagnosticsFor("COMMENT_REMOVED_BY_ANOTHER_USER")
        };
    }
    if (element) {
        if (rootComment && (0, $kgNLQ.isCommentResolved)(rootComment)) return {
            status: "RESOLVED",
            element: undefined,
            diagnostics: diagnosticsFor("COMMENT_RESOLVED")
        };
        return {
            status: "FOUND_IN_DOM",
            element: element,
            diagnostics: diagnosticsFor(commentFoundInData ? "FOUND" : "ANNOTATION_FOUND_COMMENT_MISSING")
        };
    }
    if (!state.isDataProcessed) return {
        status: "UNKNOWN",
        element: undefined,
        diagnostics: diagnosticsFor(state.error ? "COMMENTS_DATA_ERROR" : "COMMENTS_DATA_NOT_LOADED")
    };
    if (commentFoundInData) return {
        status: "DELETED_CONTENT",
        element: undefined,
        diagnostics: diagnosticsFor("ANNOTATION_MISSING_COMMENT_FOUND")
    };
    return {
        status: "UNKNOWN",
        element: undefined,
        diagnostics: diagnosticsFor(state.error ? "COMMENTS_DATA_ERROR" : "ANNOTATION_AND_COMMENT_MISSING")
    };
};
module.exports["ShortcutType"] = $0343eaf78527fd4c$export$99058db374262376;
module.exports["ScrollBehavior"] = $0343eaf78527fd4c$export$e6e360ac7d345e5;
module.exports["NavigationContext"] = $0343eaf78527fd4c$export$3044ab7fdabeaee6;
module.exports["CommentNavigationStatus"] = $0343eaf78527fd4c$export$368ed1d84e0ae668;
module.exports["handleInlineAnnotationNavigation"] = $0343eaf78527fd4c$export$9f32f1ed184088e0;
module.exports["handleCommentsPanelNavigation"] = $0343eaf78527fd4c$export$390f6df30bfcd812;
module.exports["handleCommentsPanelNavigationWithViewChange"] = $0343eaf78527fd4c$export$dcd3c0d6a66d0412;
module.exports["handleFooterCommentsNavigation"] = $0343eaf78527fd4c$export$34fd7e98d0739b5c;
module.exports["handleDeepLinkNavigation"] = $0343eaf78527fd4c$export$ea1c337d9000e2;
module.exports["handleKeyboardShortcutNavigation"] = $0343eaf78527fd4c$export$807107038899c351;
module.exports["handleInlineHeaderArrowsNavigation"] = $0343eaf78527fd4c$export$36dad1a923539611;
module.exports["waitForCommentStatus"] = $0343eaf78527fd4c$export$6591627df1eb1f44;

});

parcelRegister("9EemN", function(module, exports) {
/*global define:false */ /**
 * Copyright 2012-2017 Craig Campbell
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Mousetrap is a simple keyboard shortcut library for Javascript with
 * no external dependencies
 *
 * @version 1.6.5
 * @url craig.is/killing/mice
 */ (function(window1, document1, undefined) {
    // Check if mousetrap is used inside browser, if not, return
    if (!window1) return;
    /**
     * mapping of special keycodes to their corresponding keys
     *
     * everything in this dictionary cannot use keypress events
     * so it has to be here to map to the correct keycodes for
     * keyup/keydown events
     *
     * @type {Object}
     */ var _MAP = {
        8: 'backspace',
        9: 'tab',
        13: 'enter',
        16: 'shift',
        17: 'ctrl',
        18: 'alt',
        20: 'capslock',
        27: 'esc',
        32: 'space',
        33: 'pageup',
        34: 'pagedown',
        35: 'end',
        36: 'home',
        37: 'left',
        38: 'up',
        39: 'right',
        40: 'down',
        45: 'ins',
        46: 'del',
        91: 'meta',
        93: 'meta',
        224: 'meta'
    };
    /**
     * mapping for special characters so they can support
     *
     * this dictionary is only used incase you want to bind a
     * keyup or keydown event to one of these keys
     *
     * @type {Object}
     */ var _KEYCODE_MAP = {
        106: '*',
        107: '+',
        109: '-',
        110: '.',
        111: '/',
        186: ';',
        187: '=',
        188: ',',
        189: '-',
        190: '.',
        191: '/',
        192: '`',
        219: '[',
        220: '\\',
        221: ']',
        222: '\''
    };
    /**
     * this is a mapping of keys that require shift on a US keypad
     * back to the non shift equivelents
     *
     * this is so you can use keyup events with these keys
     *
     * note that this will only work reliably on US keyboards
     *
     * @type {Object}
     */ var _SHIFT_MAP = {
        '~': '`',
        '!': '1',
        '@': '2',
        '#': '3',
        '$': '4',
        '%': '5',
        '^': '6',
        '&': '7',
        '*': '8',
        '(': '9',
        ')': '0',
        '_': '-',
        '+': '=',
        ':': ';',
        '\"': '\'',
        '<': ',',
        '>': '.',
        '?': '/',
        '|': '\\'
    };
    /**
     * this is a list of special strings you can use to map
     * to modifier keys when you specify your keyboard shortcuts
     *
     * @type {Object}
     */ var _SPECIAL_ALIASES = {
        'option': 'alt',
        'command': 'meta',
        'return': 'enter',
        'escape': 'esc',
        'plus': '+',
        'mod': /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? 'meta' : 'ctrl'
    };
    /**
     * variable to store the flipped version of _MAP from above
     * needed to check if we should use keypress or not when no action
     * is specified
     *
     * @type {Object|undefined}
     */ var _REVERSE_MAP;
    /**
     * loop through the f keys, f1 to f19 and add them to the map
     * programatically
     */ for(var i = 1; i < 20; ++i)_MAP[111 + i] = 'f' + i;
    /**
     * loop through to map numbers on the numeric keypad
     */ for(i = 0; i <= 9; ++i)// This needs to use a string cause otherwise since 0 is falsey
    // mousetrap will never fire for numpad 0 pressed as part of a keydown
    // event.
    //
    // @see https://github.com/ccampbell/mousetrap/pull/258
    _MAP[i + 96] = i.toString();
    /**
     * cross browser add event method
     *
     * @param {Element|HTMLDocument} object
     * @param {string} type
     * @param {Function} callback
     * @returns void
     */ function _addEvent(object, type, callback) {
        if (object.addEventListener) {
            object.addEventListener(type, callback, false);
            return;
        }
        object.attachEvent('on' + type, callback);
    }
    /**
     * takes the event and returns the key character
     *
     * @param {Event} e
     * @return {string}
     */ function _characterFromEvent(e) {
        // for keypress events we should return the character as is
        if (e.type == 'keypress') {
            var character = String.fromCharCode(e.which);
            // if the shift key is not pressed then it is safe to assume
            // that we want the character to be lowercase.  this means if
            // you accidentally have caps lock on then your key bindings
            // will continue to work
            //
            // the only side effect that might not be desired is if you
            // bind something like 'A' cause you want to trigger an
            // event when capital A is pressed caps lock will no longer
            // trigger the event.  shift+a will though.
            if (!e.shiftKey) character = character.toLowerCase();
            return character;
        }
        // for non keypress events the special maps are needed
        if (_MAP[e.which]) return _MAP[e.which];
        if (_KEYCODE_MAP[e.which]) return _KEYCODE_MAP[e.which];
        // if it is not in the special map
        // with keydown and keyup events the character seems to always
        // come in as an uppercase character whether you are pressing shift
        // or not.  we should make sure it is always lowercase for comparisons
        return String.fromCharCode(e.which).toLowerCase();
    }
    /**
     * checks if two arrays are equal
     *
     * @param {Array} modifiers1
     * @param {Array} modifiers2
     * @returns {boolean}
     */ function _modifiersMatch(modifiers1, modifiers2) {
        return modifiers1.sort().join(',') === modifiers2.sort().join(',');
    }
    /**
     * takes a key event and figures out what the modifiers are
     *
     * @param {Event} e
     * @returns {Array}
     */ function _eventModifiers(e) {
        var modifiers = [];
        if (e.shiftKey) modifiers.push('shift');
        if (e.altKey) modifiers.push('alt');
        if (e.ctrlKey) modifiers.push('ctrl');
        if (e.metaKey) modifiers.push('meta');
        return modifiers;
    }
    /**
     * prevents default for this event
     *
     * @param {Event} e
     * @returns void
     */ function _preventDefault(e) {
        if (e.preventDefault) {
            e.preventDefault();
            return;
        }
        e.returnValue = false;
    }
    /**
     * stops propogation for this event
     *
     * @param {Event} e
     * @returns void
     */ function _stopPropagation(e) {
        if (e.stopPropagation) {
            e.stopPropagation();
            return;
        }
        e.cancelBubble = true;
    }
    /**
     * determines if the keycode specified is a modifier key or not
     *
     * @param {string} key
     * @returns {boolean}
     */ function _isModifier(key) {
        return key == 'shift' || key == 'ctrl' || key == 'alt' || key == 'meta';
    }
    /**
     * reverses the map lookup so that we can look for specific keys
     * to see what can and can't use keypress
     *
     * @return {Object}
     */ function _getReverseMap() {
        if (!_REVERSE_MAP) {
            _REVERSE_MAP = {};
            for(var key in _MAP){
                // pull out the numeric keypad from here cause keypress should
                // be able to detect the keys from the character
                if (key > 95 && key < 112) continue;
                if (_MAP.hasOwnProperty(key)) _REVERSE_MAP[_MAP[key]] = key;
            }
        }
        return _REVERSE_MAP;
    }
    /**
     * picks the best action based on the key combination
     *
     * @param {string} key - character for key
     * @param {Array} modifiers
     * @param {string=} action passed in
     */ function _pickBestAction(key, modifiers, action) {
        // if no action was picked in we should try to pick the one
        // that we think would work best for this key
        if (!action) action = _getReverseMap()[key] ? 'keydown' : 'keypress';
        // modifier keys don't work as expected with keypress,
        // switch to keydown
        if (action == 'keypress' && modifiers.length) action = 'keydown';
        return action;
    }
    /**
     * Converts from a string key combination to an array
     *
     * @param  {string} combination like "command+shift+l"
     * @return {Array}
     */ function _keysFromString(combination) {
        if (combination === '+') return [
            '+'
        ];
        combination = combination.replace(/\+{2}/g, '+plus');
        return combination.split('+');
    }
    /**
     * Gets info for a specific key combination
     *
     * @param  {string} combination key combination ("command+s" or "a" or "*")
     * @param  {string=} action
     * @returns {Object}
     */ function _getKeyInfo(combination, action) {
        var keys;
        var key;
        var i;
        var modifiers = [];
        // take the keys from this pattern and figure out what the actual
        // pattern is all about
        keys = _keysFromString(combination);
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            // normalize key names
            if (_SPECIAL_ALIASES[key]) key = _SPECIAL_ALIASES[key];
            // if this is not a keypress event then we should
            // be smart about using shift keys
            // this will only work for US keyboards however
            if (action && action != 'keypress' && _SHIFT_MAP[key]) {
                key = _SHIFT_MAP[key];
                modifiers.push('shift');
            }
            // if this key is a modifier then add it to the list of modifiers
            if (_isModifier(key)) modifiers.push(key);
        }
        // depending on what the key combination is
        // we will try to pick the best event for it
        action = _pickBestAction(key, modifiers, action);
        return {
            key: key,
            modifiers: modifiers,
            action: action
        };
    }
    function _belongsTo(element, ancestor) {
        if (element === null || element === document1) return false;
        if (element === ancestor) return true;
        return _belongsTo(element.parentNode, ancestor);
    }
    function Mousetrap(targetElement) {
        var self = this;
        targetElement = targetElement || document1;
        if (!(self instanceof Mousetrap)) return new Mousetrap(targetElement);
        /**
         * element to attach key events to
         *
         * @type {Element}
         */ self.target = targetElement;
        /**
         * a list of all the callbacks setup via Mousetrap.bind()
         *
         * @type {Object}
         */ self._callbacks = {};
        /**
         * direct map of string combinations to callbacks used for trigger()
         *
         * @type {Object}
         */ self._directMap = {};
        /**
         * keeps track of what level each sequence is at since multiple
         * sequences can start out with the same sequence
         *
         * @type {Object}
         */ var _sequenceLevels = {};
        /**
         * variable to store the setTimeout call
         *
         * @type {null|number}
         */ var _resetTimer;
        /**
         * temporary state where we will ignore the next keyup
         *
         * @type {boolean|string}
         */ var _ignoreNextKeyup = false;
        /**
         * temporary state where we will ignore the next keypress
         *
         * @type {boolean}
         */ var _ignoreNextKeypress = false;
        /**
         * are we currently inside of a sequence?
         * type of action ("keyup" or "keydown" or "keypress") or false
         *
         * @type {boolean|string}
         */ var _nextExpectedAction = false;
        /**
         * resets all sequence counters except for the ones passed in
         *
         * @param {Object} doNotReset
         * @returns void
         */ function _resetSequences(doNotReset) {
            doNotReset = doNotReset || {};
            var activeSequences = false, key;
            for(key in _sequenceLevels){
                if (doNotReset[key]) {
                    activeSequences = true;
                    continue;
                }
                _sequenceLevels[key] = 0;
            }
            if (!activeSequences) _nextExpectedAction = false;
        }
        /**
         * finds all callbacks that match based on the keycode, modifiers,
         * and action
         *
         * @param {string} character
         * @param {Array} modifiers
         * @param {Event|Object} e
         * @param {string=} sequenceName - name of the sequence we are looking for
         * @param {string=} combination
         * @param {number=} level
         * @returns {Array}
         */ function _getMatches(character, modifiers, e, sequenceName, combination, level) {
            var i;
            var callback;
            var matches = [];
            var action = e.type;
            // if there are no events related to this keycode
            if (!self._callbacks[character]) return [];
            // if a modifier key is coming up on its own we should allow it
            if (action == 'keyup' && _isModifier(character)) modifiers = [
                character
            ];
            // loop through all callbacks for the key that was pressed
            // and see if any of them match
            for(i = 0; i < self._callbacks[character].length; ++i){
                callback = self._callbacks[character][i];
                // if a sequence name is not specified, but this is a sequence at
                // the wrong level then move onto the next match
                if (!sequenceName && callback.seq && _sequenceLevels[callback.seq] != callback.level) continue;
                // if the action we are looking for doesn't match the action we got
                // then we should keep going
                if (action != callback.action) continue;
                // if this is a keypress event and the meta key and control key
                // are not pressed that means that we need to only look at the
                // character, otherwise check the modifiers as well
                //
                // chrome will not fire a keypress if meta or control is down
                // safari will fire a keypress if meta or meta+shift is down
                // firefox will fire a keypress if meta or control is down
                if (action == 'keypress' && !e.metaKey && !e.ctrlKey || _modifiersMatch(modifiers, callback.modifiers)) {
                    // when you bind a combination or sequence a second time it
                    // should overwrite the first one.  if a sequenceName or
                    // combination is specified in this call it does just that
                    //
                    // @todo make deleting its own method?
                    var deleteCombo = !sequenceName && callback.combo == combination;
                    var deleteSequence = sequenceName && callback.seq == sequenceName && callback.level == level;
                    if (deleteCombo || deleteSequence) self._callbacks[character].splice(i, 1);
                    matches.push(callback);
                }
            }
            return matches;
        }
        /**
         * actually calls the callback function
         *
         * if your callback function returns false this will use the jquery
         * convention - prevent default and stop propogation on the event
         *
         * @param {Function} callback
         * @param {Event} e
         * @returns void
         */ function _fireCallback(callback, e, combo, sequence) {
            // if this event should not happen stop here
            if (self.stopCallback(e, e.target || e.srcElement, combo, sequence)) return;
            if (callback(e, combo) === false) {
                _preventDefault(e);
                _stopPropagation(e);
            }
        }
        /**
         * handles a character key event
         *
         * @param {string} character
         * @param {Array} modifiers
         * @param {Event} e
         * @returns void
         */ self._handleKey = function(character, modifiers, e) {
            var callbacks = _getMatches(character, modifiers, e);
            var i;
            var doNotReset = {};
            var maxLevel = 0;
            var processedSequenceCallback = false;
            // Calculate the maxLevel for sequences so we can only execute the longest callback sequence
            for(i = 0; i < callbacks.length; ++i)if (callbacks[i].seq) maxLevel = Math.max(maxLevel, callbacks[i].level);
            // loop through matching callbacks for this key event
            for(i = 0; i < callbacks.length; ++i){
                // fire for all sequence callbacks
                // this is because if for example you have multiple sequences
                // bound such as "g i" and "g t" they both need to fire the
                // callback for matching g cause otherwise you can only ever
                // match the first one
                if (callbacks[i].seq) {
                    // only fire callbacks for the maxLevel to prevent
                    // subsequences from also firing
                    //
                    // for example 'a option b' should not cause 'option b' to fire
                    // even though 'option b' is part of the other sequence
                    //
                    // any sequences that do not match here will be discarded
                    // below by the _resetSequences call
                    if (callbacks[i].level != maxLevel) continue;
                    processedSequenceCallback = true;
                    // keep a list of which sequences were matches for later
                    doNotReset[callbacks[i].seq] = 1;
                    _fireCallback(callbacks[i].callback, e, callbacks[i].combo, callbacks[i].seq);
                    continue;
                }
                // if there were no sequence matches but we are still here
                // that means this is a regular match so we should fire that
                if (!processedSequenceCallback) _fireCallback(callbacks[i].callback, e, callbacks[i].combo);
            }
            // if the key you pressed matches the type of sequence without
            // being a modifier (ie "keyup" or "keypress") then we should
            // reset all sequences that were not matched by this event
            //
            // this is so, for example, if you have the sequence "h a t" and you
            // type "h e a r t" it does not match.  in this case the "e" will
            // cause the sequence to reset
            //
            // modifier keys are ignored because you can have a sequence
            // that contains modifiers such as "enter ctrl+space" and in most
            // cases the modifier key will be pressed before the next key
            //
            // also if you have a sequence such as "ctrl+b a" then pressing the
            // "b" key will trigger a "keypress" and a "keydown"
            //
            // the "keydown" is expected when there is a modifier, but the
            // "keypress" ends up matching the _nextExpectedAction since it occurs
            // after and that causes the sequence to reset
            //
            // we ignore keypresses in a sequence that directly follow a keydown
            // for the same character
            var ignoreThisKeypress = e.type == 'keypress' && _ignoreNextKeypress;
            if (e.type == _nextExpectedAction && !_isModifier(character) && !ignoreThisKeypress) _resetSequences(doNotReset);
            _ignoreNextKeypress = processedSequenceCallback && e.type == 'keydown';
        };
        /**
         * handles a keydown event
         *
         * @param {Event} e
         * @returns void
         */ function _handleKeyEvent(e) {
            // normalize e.which for key events
            // @see http://stackoverflow.com/questions/4285627/javascript-keycode-vs-charcode-utter-confusion
            if (typeof e.which !== 'number') e.which = e.keyCode;
            var character = _characterFromEvent(e);
            // no character found then stop
            if (!character) return;
            // need to use === for the character check because the character can be 0
            if (e.type == 'keyup' && _ignoreNextKeyup === character) {
                _ignoreNextKeyup = false;
                return;
            }
            self.handleKey(character, _eventModifiers(e), e);
        }
        /**
         * called to set a 1 second timeout on the specified sequence
         *
         * this is so after each key press in the sequence you have 1 second
         * to press the next key before you have to start over
         *
         * @returns void
         */ function _resetSequenceTimer() {
            clearTimeout(_resetTimer);
            _resetTimer = setTimeout(_resetSequences, 1000);
        }
        /**
         * binds a key sequence to an event
         *
         * @param {string} combo - combo specified in bind call
         * @param {Array} keys
         * @param {Function} callback
         * @param {string=} action
         * @returns void
         */ function _bindSequence(combo, keys, callback, action) {
            // start off by adding a sequence level record for this combination
            // and setting the level to 0
            _sequenceLevels[combo] = 0;
            /**
             * callback to increase the sequence level for this sequence and reset
             * all other sequences that were active
             *
             * @param {string} nextAction
             * @returns {Function}
             */ function _increaseSequence(nextAction) {
                return function() {
                    _nextExpectedAction = nextAction;
                    ++_sequenceLevels[combo];
                    _resetSequenceTimer();
                };
            }
            /**
             * wraps the specified callback inside of another function in order
             * to reset all sequence counters as soon as this sequence is done
             *
             * @param {Event} e
             * @returns void
             */ function _callbackAndReset(e) {
                _fireCallback(callback, e, combo);
                // we should ignore the next key up if the action is key down
                // or keypress.  this is so if you finish a sequence and
                // release the key the final key will not trigger a keyup
                if (action !== 'keyup') _ignoreNextKeyup = _characterFromEvent(e);
                // weird race condition if a sequence ends with the key
                // another sequence begins with
                setTimeout(_resetSequences, 10);
            }
            // loop through keys one at a time and bind the appropriate callback
            // function.  for any key leading up to the final one it should
            // increase the sequence. after the final, it should reset all sequences
            //
            // if an action is specified in the original bind call then that will
            // be used throughout.  otherwise we will pass the action that the
            // next key in the sequence should match.  this allows a sequence
            // to mix and match keypress and keydown events depending on which
            // ones are better suited to the key provided
            for(var i = 0; i < keys.length; ++i){
                var isFinal = i + 1 === keys.length;
                var wrappedCallback = isFinal ? _callbackAndReset : _increaseSequence(action || _getKeyInfo(keys[i + 1]).action);
                _bindSingle(keys[i], wrappedCallback, action, combo, i);
            }
        }
        /**
         * binds a single keyboard combination
         *
         * @param {string} combination
         * @param {Function} callback
         * @param {string=} action
         * @param {string=} sequenceName - name of sequence if part of sequence
         * @param {number=} level - what part of the sequence the command is
         * @returns void
         */ function _bindSingle(combination, callback, action, sequenceName, level) {
            // store a direct mapped reference for use with Mousetrap.trigger
            self._directMap[combination + ':' + action] = callback;
            // make sure multiple spaces in a row become a single space
            combination = combination.replace(/\s+/g, ' ');
            var sequence = combination.split(' ');
            var info;
            // if this pattern is a sequence of keys then run through this method
            // to reprocess each pattern one key at a time
            if (sequence.length > 1) {
                _bindSequence(combination, sequence, callback, action);
                return;
            }
            info = _getKeyInfo(combination, action);
            // make sure to initialize array if this is the first time
            // a callback is added for this key
            self._callbacks[info.key] = self._callbacks[info.key] || [];
            // remove an existing match if there is one
            _getMatches(info.key, info.modifiers, {
                type: info.action
            }, sequenceName, combination, level);
            // add this call back to the array
            // if it is a sequence put it at the beginning
            // if not put it at the end
            //
            // this is important because the way these are processed expects
            // the sequence ones to come first
            self._callbacks[info.key][sequenceName ? 'unshift' : 'push']({
                callback: callback,
                modifiers: info.modifiers,
                action: info.action,
                seq: sequenceName,
                level: level,
                combo: combination
            });
        }
        /**
         * binds multiple combinations to the same callback
         *
         * @param {Array} combinations
         * @param {Function} callback
         * @param {string|undefined} action
         * @returns void
         */ self._bindMultiple = function(combinations, callback, action) {
            for(var i = 0; i < combinations.length; ++i)_bindSingle(combinations[i], callback, action);
        };
        // start!
        _addEvent(targetElement, 'keypress', _handleKeyEvent);
        _addEvent(targetElement, 'keydown', _handleKeyEvent);
        _addEvent(targetElement, 'keyup', _handleKeyEvent);
    }
    /**
     * binds an event to mousetrap
     *
     * can be a single key, a combination of keys separated with +,
     * an array of keys, or a sequence of keys separated by spaces
     *
     * be sure to list the modifier keys first to make sure that the
     * correct key ends up getting bound (the last key in the pattern)
     *
     * @param {string|Array} keys
     * @param {Function} callback
     * @param {string=} action - 'keypress', 'keydown', or 'keyup'
     * @returns void
     */ Mousetrap.prototype.bind = function(keys, callback, action) {
        var self = this;
        keys = keys instanceof Array ? keys : [
            keys
        ];
        self._bindMultiple.call(self, keys, callback, action);
        return self;
    };
    /**
     * unbinds an event to mousetrap
     *
     * the unbinding sets the callback function of the specified key combo
     * to an empty function and deletes the corresponding key in the
     * _directMap dict.
     *
     * TODO: actually remove this from the _callbacks dictionary instead
     * of binding an empty function
     *
     * the keycombo+action has to be exactly the same as
     * it was defined in the bind method
     *
     * @param {string|Array} keys
     * @param {string} action
     * @returns void
     */ Mousetrap.prototype.unbind = function(keys, action) {
        var self = this;
        return self.bind.call(self, keys, function() {}, action);
    };
    /**
     * triggers an event that has already been bound
     *
     * @param {string} keys
     * @param {string=} action
     * @returns void
     */ Mousetrap.prototype.trigger = function(keys, action) {
        var self = this;
        if (self._directMap[keys + ':' + action]) self._directMap[keys + ':' + action]({}, keys);
        return self;
    };
    /**
     * resets the library back to its initial state.  this is useful
     * if you want to clear out the current keyboard shortcuts and bind
     * new ones - for example if you switch to another page
     *
     * @returns void
     */ Mousetrap.prototype.reset = function() {
        var self = this;
        self._callbacks = {};
        self._directMap = {};
        return self;
    };
    /**
     * should we stop this event before firing off callbacks
     *
     * @param {Event} e
     * @param {Element} element
     * @return {boolean}
     */ Mousetrap.prototype.stopCallback = function(e, element) {
        var self = this;
        // if the element has the class "mousetrap" then no need to stop
        if ((' ' + element.className + ' ').indexOf(' mousetrap ') > -1) return false;
        if (_belongsTo(element, self.target)) return false;
        // Events originating from a shadow DOM are re-targetted and `e.target` is the shadow host,
        // not the initial event target in the shadow tree. Note that not all events cross the
        // shadow boundary.
        // For shadow trees with `mode: 'open'`, the initial event target is the first element in
        // the event’s composed path. For shadow trees with `mode: 'closed'`, the initial event
        // target cannot be obtained.
        if ('composedPath' in e && typeof e.composedPath === 'function') {
            // For open shadow trees, update `element` so that the following check works.
            var initialEventTarget = e.composedPath()[0];
            if (initialEventTarget !== e.target) element = initialEventTarget;
        }
        // stop for input, select, and textarea
        return element.tagName == 'INPUT' || element.tagName == 'SELECT' || element.tagName == 'TEXTAREA' || element.isContentEditable;
    };
    /**
     * exposes _handleKey publicly so it can be overwritten by extensions
     */ Mousetrap.prototype.handleKey = function() {
        var self = this;
        return self._handleKey.apply(self, arguments);
    };
    /**
     * allow custom key mappings
     */ Mousetrap.addKeycodes = function(object) {
        for(var key in object)if (object.hasOwnProperty(key)) _MAP[key] = object[key];
        _REVERSE_MAP = null;
    };
    /**
     * Init the global mousetrap functions
     *
     * This method is needed to allow the global mousetrap functions to work
     * now that mousetrap is a constructor function.
     */ Mousetrap.init = function() {
        var documentMousetrap = Mousetrap(document1);
        for(var method in documentMousetrap)if (method.charAt(0) !== '_') Mousetrap[method] = function(method) {
            return function() {
                return documentMousetrap[method].apply(documentMousetrap, arguments);
            };
        }(method);
    };
    Mousetrap.init();
    // expose mousetrap to the global object
    window1.Mousetrap = Mousetrap;
    // expose as a common js module
    if (module.exports) module.exports = Mousetrap;
    // expose mousetrap as an AMD module
    if (typeof define === 'function' && define.amd) define(function() {
        return Mousetrap;
    });
})(typeof window !== 'undefined' ? window : null, typeof window !== 'undefined' ? document : null);

});

parcelRegister("kDDrf", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- fallback for insecure contexts where crypto.randomUUID is unavailable

var $03RpJ = parcelRequire("03RpJ");


var $irnO2 = parcelRequire("irnO2");


var $iBsvI = parcelRequire("iBsvI");

const $99e5a5c6ac11dcd8$var$randomId = ()=>{
    if (globalThis?.crypto?.randomUUID) return globalThis.crypto.randomUUID();
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- fallback for insecure contexts where crypto.randomUUID is unavailable
    return (0, $03RpJ.default)();
};
const $99e5a5c6ac11dcd8$var$SEND_MESSAGE_EXPERIENCE_NAMES = new Set([
    (0, $irnO2.ExperienceName).SEND_MESSAGE
]);
const $99e5a5c6ac11dcd8$var$CREATE_TERMINAL_EXPERIENCE_NAMES = new Set([
    (0, $irnO2.ExperienceName).REMIX_RENDERS_IN_MODAL,
    (0, $irnO2.ExperienceName).REMIX_INSERT,
    (0, $irnO2.ExperienceName).REMIX_DUPLICATE_APP,
    (0, $irnO2.ExperienceName).REMIX_DIAGRAM_PASTE_FINALIZE
]);
const $99e5a5c6ac11dcd8$var$toError = (error)=>error ?? new Error('aiMateSendMessage failed');
const $99e5a5c6ac11dcd8$var$withFeatureArea = (attributes, context)=>{
    const featureArea = context.featureArea ?? attributes?.featureArea;
    return {
        ...attributes,
        ...featureArea !== undefined && {
            featureArea: featureArea
        }
    };
};
let $99e5a5c6ac11dcd8$var$activeCreateCollectContext;
const $99e5a5c6ac11dcd8$var$matchesTerminal = (event, context)=>{
    if (!$99e5a5c6ac11dcd8$var$CREATE_TERMINAL_EXPERIENCE_NAMES.has(event.name)) return false;
    const attributes = event.attributes;
    const eventRemixCreateId = attributes?.remixCreateId;
    if (context.remixCreateId && typeof eventRemixCreateId === 'string') return eventRemixCreateId === context.remixCreateId;
    const eventConversationId = attributes?.conversationId;
    if (context.conversationChannelId && typeof eventConversationId === 'string') return eventConversationId === context.conversationChannelId;
    return Boolean(context.allowCollectFallback);
};
const $99e5a5c6ac11dcd8$var$matchesSendMessageFailure = (event, context)=>{
    if (!$99e5a5c6ac11dcd8$var$SEND_MESSAGE_EXPERIENCE_NAMES.has(event.name) || event.action !== 'taskFail') return false;
    const attributes = event.attributes;
    if (attributes?.isRemixCreate !== true) return false;
    const requestConversationId = attributes?.conversationId;
    if (context.conversationChannelId && requestConversationId === context.conversationChannelId) return true;
    // If the event's conversationId is unavailable, fall back to the single-inflight
    // assumption (there is only one remix create stream at a time).
    return Boolean(context.allowCollectFallback);
};
const $99e5a5c6ac11dcd8$export$fce521e73e6e1f1e = (context)=>{
    let hasStopped = false;
    return (events, experience)=>{
        if (hasStopped || context.isCreateSettled) {
            hasStopped = true;
            return;
        }
        for (const event of events){
            // 1) Upstream generation-stream failure → fail the parent.
            if ($99e5a5c6ac11dcd8$var$matchesSendMessageFailure(event, context)) {
                hasStopped = true;
                context.isCreateSettled = true;
                const attributes = event.attributes;
                experience.fail({
                    error: $99e5a5c6ac11dcd8$var$toError(event.error),
                    attributes: {
                        ...$99e5a5c6ac11dcd8$var$withFeatureArea(attributes, context),
                        failureSource: 'send_message_collect',
                        failureStage: 'request',
                        upstreamExperience: event.name
                    }
                });
                return;
            }
            if (!$99e5a5c6ac11dcd8$var$matchesTerminal(event, context)) continue;
            const attributes = event.attributes;
            // 2) A terminal experience FAILED → fail the parent.
            if (event.action === 'taskFail') {
                hasStopped = true;
                context.isCreateSettled = true;
                experience.fail({
                    error: $99e5a5c6ac11dcd8$var$toError(event.error),
                    attributes: {
                        ...$99e5a5c6ac11dcd8$var$withFeatureArea(attributes, context),
                        failureSource: 'terminal_collect',
                        failureStage: 'render',
                        upstreamExperience: event.name
                    }
                });
                return;
            }
            // 3) A terminal experience ABORTED → abort the parent.
            if (event.action === 'taskAbort') {
                hasStopped = true;
                context.isCreateSettled = true;
                experience.abort({
                    reason: `terminal_${event.name}_aborted`,
                    attributes: {
                        ...$99e5a5c6ac11dcd8$var$withFeatureArea(attributes, context),
                        upstreamExperience: event.name
                    }
                });
                return;
            }
            // 4) A terminal experience SUCCEEDED → succeed the parent immediately.
            if (event.action === 'taskSuccess') {
                hasStopped = true;
                context.isCreateSettled = true;
                experience.succeed({
                    attributes: {
                        ...$99e5a5c6ac11dcd8$var$withFeatureArea(attributes, context),
                        succeededVia: event.name
                    }
                });
                return;
            }
        }
    };
};
const $99e5a5c6ac11dcd8$export$f53526ec87ae9eaf = ({ experienceTracker: experienceTracker, attributes: attributes, includeOpenMenuExperience: includeOpenMenuExperience = true })=>{
    const remixCreateId = $99e5a5c6ac11dcd8$var$randomId();
    const featureArea = (0, $iBsvI.getRemixFeatureArea)({
        remixType: attributes?.remixType,
        existingFeatureArea: attributes?.featureArea
    });
    const startAttributes = {
        ...attributes,
        ...featureArea !== undefined && {
            featureArea: featureArea
        },
        remixCreateId: remixCreateId
    };
    const collectContext = {
        remixCreateId: remixCreateId,
        ...includeOpenMenuExperience && {
            openMenuAttributes: startAttributes
        },
        featureArea: featureArea,
        allowCollectFallback: true
    };
    $99e5a5c6ac11dcd8$var$activeCreateCollectContext = collectContext;
    experienceTracker.start({
        name: (0, $irnO2.ExperienceName).REMIX_CREATE,
        id: remixCreateId,
        attributes: startAttributes,
        collect: $99e5a5c6ac11dcd8$export$fce521e73e6e1f1e(collectContext)
    });
    if (includeOpenMenuExperience) experienceTracker.start({
        name: (0, $irnO2.ExperienceName).REMIX_OPEN_MENU,
        id: (0, $irnO2.ExperienceName).REMIX_OPEN_MENU,
        attributes: startAttributes
    });
};
const $99e5a5c6ac11dcd8$export$8194201fd9adfb49 = ()=>$99e5a5c6ac11dcd8$var$activeCreateCollectContext?.isCreateSettled ? undefined : $99e5a5c6ac11dcd8$var$activeCreateCollectContext?.remixCreateId;
const $99e5a5c6ac11dcd8$export$701b0d2def6c3f0f = (experienceTracker)=>{
    const context = $99e5a5c6ac11dcd8$var$activeCreateCollectContext;
    if (!context?.openMenuAttributes || context.isOpenMenuSettled) return;
    context.isOpenMenuSettled = true;
    experienceTracker.succeed({
        name: (0, $irnO2.ExperienceName).REMIX_OPEN_MENU,
        attributes: context.openMenuAttributes
    });
};
const $99e5a5c6ac11dcd8$export$78cf909554bc5274 = (experienceTracker, attributes)=>{
    const context = $99e5a5c6ac11dcd8$var$activeCreateCollectContext;
    if (!context || context.isCreateSettled) return;
    context.isCreateSettled = true;
    experienceTracker.succeed({
        name: (0, $irnO2.ExperienceName).REMIX_CREATE,
        attributes: {
            ...context.openMenuAttributes,
            ...attributes,
            succeededVia: (0, $irnO2.ExperienceName).REMIX_AIFC_HANDOFF
        }
    });
};
const $99e5a5c6ac11dcd8$export$3d7752ee631c9bec = (experienceTracker, error, attributes)=>{
    const context = $99e5a5c6ac11dcd8$var$activeCreateCollectContext;
    if (!context || context.isCreateSettled) return;
    context.isCreateSettled = true;
    experienceTracker.fail({
        name: (0, $irnO2.ExperienceName).REMIX_CREATE,
        error: error,
        attributes: {
            ...context.openMenuAttributes,
            ...$99e5a5c6ac11dcd8$var$withFeatureArea(attributes, context)
        }
    });
};
const $99e5a5c6ac11dcd8$export$ebb7b0773a85e89e = (experienceTracker, reason)=>{
    const context = $99e5a5c6ac11dcd8$var$activeCreateCollectContext;
    if (!context) return;
    const attributes = {
        ...context.openMenuAttributes,
        ...context.pendingSelectionAttributes,
        reason: reason
    };
    if (context.openMenuAttributes && !context.isOpenMenuSettled) {
        context.isOpenMenuSettled = true;
        experienceTracker.abort({
            name: (0, $irnO2.ExperienceName).REMIX_OPEN_MENU,
            reason: reason,
            attributes: attributes
        });
    }
    if (!context.isCreateSettled) {
        context.isCreateSettled = true;
        experienceTracker.abort({
            name: (0, $irnO2.ExperienceName).REMIX_CREATE,
            reason: reason,
            attributes: attributes
        });
    }
};
const $99e5a5c6ac11dcd8$export$c3cccc5477469a41 = (experienceTracker, hasCommitted, reason = 'User closed remix overlay')=>{
    if (!hasCommitted) $99e5a5c6ac11dcd8$export$ebb7b0773a85e89e(experienceTracker, reason);
};
/**
 * Records a non-gating milestone sub-experience (select-option / show-loading) as
 * the flow advances: an instantaneous start-then-succeed. These are funnel
 * breadcrumbs; the parent's success is owned by the terminal experiences via
 * `collect`, not by these milestones.
 */ const $99e5a5c6ac11dcd8$var$recordRemixCreateMilestone = (experienceTracker, name, attributes)=>{
    const remixCreateId = $99e5a5c6ac11dcd8$export$8194201fd9adfb49();
    const milestoneAttributes = {
        ...attributes,
        remixCreateId: remixCreateId
    };
    experienceTracker.start({
        name: name,
        id: name,
        attributes: milestoneAttributes
    });
    experienceTracker.succeed({
        name: name,
        attributes: milestoneAttributes
    });
};
const $99e5a5c6ac11dcd8$export$8ce0294ce28ac3ae = ({ remixType: remixType, remixSubtype: remixSubtype })=>{
    if (!$99e5a5c6ac11dcd8$var$activeCreateCollectContext || $99e5a5c6ac11dcd8$var$activeCreateCollectContext.isCreateSettled) return;
    $99e5a5c6ac11dcd8$var$activeCreateCollectContext.pendingSelectionAttributes = remixType === undefined && remixSubtype === undefined ? undefined : {
        remixType: remixType,
        remixSubtype: remixSubtype
    };
};
const $99e5a5c6ac11dcd8$export$88ef25856d821447 = ({ experienceTracker: experienceTracker, conversationId: conversationId, remixType: remixType, remixSubtype: remixSubtype, includesFreegenPrompt: includesFreegenPrompt })=>{
    if (conversationId) $99e5a5c6ac11dcd8$export$799e564bf3ca201c(experienceTracker, conversationId);
    const featureArea = (0, $iBsvI.getRemixFeatureArea)({
        remixType: remixType,
        existingFeatureArea: $99e5a5c6ac11dcd8$var$activeCreateCollectContext?.featureArea
    });
    if ($99e5a5c6ac11dcd8$var$activeCreateCollectContext) $99e5a5c6ac11dcd8$var$activeCreateCollectContext.featureArea = featureArea;
    const attributes = {
        remixType: remixType,
        remixSubtype: remixSubtype,
        includesFreegenPrompt: includesFreegenPrompt,
        ...featureArea !== undefined && {
            featureArea: featureArea
        }
    };
    if ($99e5a5c6ac11dcd8$var$activeCreateCollectContext) $99e5a5c6ac11dcd8$var$activeCreateCollectContext.pendingSelectionAttributes = attributes;
    experienceTracker.updateAttributes({
        name: (0, $irnO2.ExperienceName).REMIX_CREATE,
        attributes: attributes
    });
    $99e5a5c6ac11dcd8$var$recordRemixCreateMilestone(experienceTracker, (0, $irnO2.ExperienceName).REMIX_SELECT_OPTION, attributes);
    $99e5a5c6ac11dcd8$var$recordRemixCreateMilestone(experienceTracker, (0, $irnO2.ExperienceName).REMIX_SHOW_LOADING, attributes);
};
const $99e5a5c6ac11dcd8$export$799e564bf3ca201c = (experienceTracker, conversationId)=>{
    experienceTracker.updateAttributes({
        name: (0, $irnO2.ExperienceName).REMIX_CREATE,
        attributes: {
            conversationId: conversationId
        }
    });
    if ($99e5a5c6ac11dcd8$var$activeCreateCollectContext) $99e5a5c6ac11dcd8$var$activeCreateCollectContext.conversationChannelId = conversationId;
};
module.exports["startRemixCreateExperience"] = $99e5a5c6ac11dcd8$export$f53526ec87ae9eaf;
module.exports["getActiveRemixCreateId"] = $99e5a5c6ac11dcd8$export$8194201fd9adfb49;
module.exports["succeedRemixOpenMenuExperience"] = $99e5a5c6ac11dcd8$export$701b0d2def6c3f0f;
module.exports["succeedRemixCreateExperienceAtHandoff"] = $99e5a5c6ac11dcd8$export$78cf909554bc5274;
module.exports["failRemixCreateExperience"] = $99e5a5c6ac11dcd8$export$3d7752ee631c9bec;
module.exports["abortRemixCreateExperience"] = $99e5a5c6ac11dcd8$export$ebb7b0773a85e89e;
module.exports["abortRemixCreateExperienceIfNotCommitted"] = $99e5a5c6ac11dcd8$export$c3cccc5477469a41;
module.exports["updateRemixCreatePendingSelection"] = $99e5a5c6ac11dcd8$export$8ce0294ce28ac3ae;
module.exports["trackRemixCreateOptionSelected"] = $99e5a5c6ac11dcd8$export$88ef25856d821447;

});

parcelRegister("8lhhf", function(module, exports) {
const $57d7e56ed333ab64$export$d0e832101df0ac96 = 'com.atlassian.rovo.skill';
const $57d7e56ed333ab64$export$d4f002c79ea2ad20 = 'skill';
const $57d7e56ed333ab64$export$e4d0b30afd49f7df = 'skillTag';
const $57d7e56ed333ab64$export$18f911e214c46d8 = /\/([a-zA-Z0-9-]+)/g;
const $57d7e56ed333ab64$export$aae1b80712c1b67b = `${$57d7e56ed333ab64$export$d4f002c79ea2ad20}:${$57d7e56ed333ab64$export$e4d0b30afd49f7df}`;
const $57d7e56ed333ab64$export$b22d8560058c60e1 = (extensionType, extensionKey)=>{
    return extensionType === $57d7e56ed333ab64$export$d0e832101df0ac96 && extensionKey === $57d7e56ed333ab64$export$aae1b80712c1b67b;
};
const $57d7e56ed333ab64$export$f88fd0c0ee7d509a = (skill)=>{
    return [
        {
            type: 'inlineExtension',
            attrs: {
                extensionKey: $57d7e56ed333ab64$export$aae1b80712c1b67b,
                extensionType: $57d7e56ed333ab64$export$d0e832101df0ac96,
                parameters: skill
            }
        },
        // render an empty space after the skill tag
        {
            type: 'text',
            text: ' '
        }
    ];
};
const $57d7e56ed333ab64$export$a425ebfe740d9932 = (skill)=>({
        type: 'doc',
        version: 1,
        content: [
            {
                type: 'paragraph',
                content: $57d7e56ed333ab64$export$f88fd0c0ee7d509a(skill)
            }
        ]
    });
module.exports["ROVO_SKILL_EXTENSION_TYPE"] = $57d7e56ed333ab64$export$d0e832101df0ac96;
module.exports["ROVO_SKILL_EXTENSION_KEY"] = $57d7e56ed333ab64$export$d4f002c79ea2ad20;
module.exports["ROVO_SKILL_TAG_PATTERN"] = $57d7e56ed333ab64$export$18f911e214c46d8;
module.exports["ROVO_SKILL_COMBINED_EXTENSION_KEY"] = $57d7e56ed333ab64$export$aae1b80712c1b67b;
module.exports["isSkillTagExtension"] = $57d7e56ed333ab64$export$b22d8560058c60e1;
module.exports["createSkillNode"] = $57d7e56ed333ab64$export$f88fd0c0ee7d509a;
module.exports["createSkillAdf"] = $57d7e56ed333ab64$export$a425ebfe740d9932;

});

parcelRegister("7mpOv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");

const $7ae32555811cd45f$export$cc5edac91cdebf9b = (_props = {})=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    return {
        isAIEnabledForContent: isAdminHubAIEnabled,
        isRovoEnabledForContent: isRovoLLMEnabled
    };
};
function $7ae32555811cd45f$export$fb975e2d7306f54a(WrappedComponent) {
    return function EnhancedComponent(props) {
        const [contentId] = (0, $ep3mz.usePageContentId)();
        const { isAIEnabledForContent: isAIEnabledForContent, isRovoEnabledForContent: isRovoEnabledForContent } = $7ae32555811cd45f$export$cc5edac91cdebf9b({
            contentId: contentId ?? ''
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
            ...props,
            isAIEnabledForContent: isAIEnabledForContent,
            isRovoEnabledForContent: isRovoEnabledForContent
        });
    };
}
module.exports["useIsAIEnabledForContent"] = $7ae32555811cd45f$export$cc5edac91cdebf9b;
module.exports["withIsAIEnabledForContent"] = $7ae32555811cd45f$export$fb975e2d7306f54a;

});

parcelRegister("kRW4Y", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $2BAFx = parcelRequire("2BAFx");

class $c329db8a0d5b9472$export$11ff2eb6414212c6 extends (0, $kNIYN.Container) {
    onChildClose(key, ...args) {
        // A child dialog called its onClose prop
        // Find the stack frame for the respective child
        const childFrame = this.state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onClose) childFrame.originalProps.onClose(...args);
        // Don't remove this dialog from the stack; instead mark it as not alive. This will pull the
        // component from its enclosing <ModalTransition>, but keep the <ModalTransition> around, for now.
        // The child that we provide to the <ModalTransition> has an onCloseComplete prop, to trigger the
        // final cleanup.
        this.setState((state)=>({
                stack: state.stack.map((frame)=>frame === childFrame ? {
                        ...frame,
                        alive: false
                    } : frame)
            }));
    }
    onChildCloseComplete(key, ...args) {
        // A child dialog called its onCloseComplete prop
        // Find the stack frame for the respective child
        const childFrame = this.state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onCloseComplete) childFrame.originalProps.onCloseComplete(...args);
        // The transition has completed, so complete the cleanup: remove the
        // frame from the stack to pull the <ModalTransition>.
        this.setState((state)=>({
                stack: state.stack.filter((frame)=>frame.key !== childFrame.key)
            }));
    }
    constructor(stack = []){
        super();
        /*
        Arguably, nextKey belongs in state (as per 'flags' package). But then there's
        an unenviable choice of, in showDialog, putting the React.createElement in the
        setState callback, or giving setState an object instead of a callback and
        risk having two dialogs opened with the same key in the (unlikely) scenario
        that they're both opened in the same tick.
      */ this.showModal = (componentClass, originalProps, children)=>{
            this.showDialog(componentClass, originalProps, children);
        };
        /**
     * @deprecated use `.showModal()` instead (see "next/packages/dialogs/README.md" for migration instructions)
     */ this.showDialog = (componentClass, originalProps, children)=>{
            const key = (0, $2BAFx.dialogKeyState).nextKey;
            const props = originalProps || {};
            const component = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(componentClass, {
                ...props,
                onClose: (...args)=>this.onChildClose(key, ...args),
                onCloseComplete: (...args)=>this.onChildCloseComplete(key, ...args)
            }, children);
            this.setState((state)=>({
                    stack: [
                        ...state.stack,
                        {
                            key: key,
                            component: component,
                            alive: true,
                            originalProps: {
                                onClose: 'onClose' in props ? props.onClose : undefined,
                                onCloseComplete: 'onCloseComplete' in props ? props.onCloseComplete : undefined
                            }
                        }
                    ]
                }));
            // Returns a method that the caller can use to close the dialog (though, most often,
            // a child would self-close)
            return ()=>{
                this.onChildClose(key);
            };
        };
        this.state = {
            stack: stack
        };
        // If you're pre-supplying a stack, make nextKey bigger than any of its keys
        if (stack.length) {
            const maxKey = Math.max(...stack.map((frame)=>frame.key));
            (0, $2BAFx.dialogKeyState).nextKey = maxKey + 1;
        }
    }
}
module.exports["DialogsStateContainer"] = $c329db8a0d5b9472$export$11ff2eb6414212c6;

});

parcelRegister("fNTq8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jU6s6 = parcelRequire("jU6s6");


var $4dW9D = parcelRequire("4dW9D");


var $jLdbZ = parcelRequire("jLdbZ");

const $8a30b5a238fd1faa$var$validateAIEventsConfig = (config)=>{
    if (!config.aiFeatureName.match(/^[a-z][A-Za-z]*$/)) // eslint-disable-next-line no-console
    console.error('[@atlassian/ai-analytics]: please set aiFeatureName in camelCase');
};
const $8a30b5a238fd1faa$export$b5d4bc85dfbaa4f8 = ({ children: children, config: config })=>{
    const { refreshSingleInstrumentationID: refreshSingleInstrumentationID, getSingleInstrumentationID: getSingleInstrumentationID, setAISessionState: setAISessionState, getAISessionState: getAISessionState } = (0, $jLdbZ.useAIInstrumentationSetup)(config.singleInstrumentationID);
    const contextValue = (0, $cozmU.useMemo)(()=>{
        $8a30b5a238fd1faa$var$validateAIEventsConfig(config);
        return {
            config: {
                ...(0, $4dW9D.defaultAIEventsInstrumentationConfigValues),
                ...config,
                product: config.product.toLowerCase()
            },
            refreshSingleInstrumentationID: refreshSingleInstrumentationID,
            getSingleInstrumentationID: getSingleInstrumentationID,
            setAISessionState: setAISessionState,
            getAISessionState: getAISessionState
        };
    }, [
        config,
        refreshSingleInstrumentationID,
        getSingleInstrumentationID,
        setAISessionState,
        getAISessionState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jU6s6.AIEventsInstrumentationContext).Provider, {
        value: contextValue
    }, children);
};
module.exports["AIEventsInstrumentationProvider"] = $8a30b5a238fd1faa$export$b5d4bc85dfbaa4f8;

});

parcelRegister("2eX69", function(module, exports) {

var $e9nC3 = parcelRequire("e9nC3");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $5BnIc = parcelRequire("5BnIc");


var $9C5oc = parcelRequire("9C5oc");


var $h45y6 = parcelRequire("h45y6");

const $a45798977a968ec1$var$MAX_SUMMARY_LENGTH_CHARS = 100;
const $a45798977a968ec1$var$singleLineTruncatedText = (text, length = $a45798977a968ec1$var$MAX_SUMMARY_LENGTH_CHARS)=>{
    const singleLineText = text.replace(/\n/g, ' ');
    return (0, $9C5oc.default)(singleLineText, length);
};
class $a45798977a968ec1$export$2e2bcd8739ae039 extends (0, $cozmU.Component) {
    async componentDidMount() {
        const anonymousFeedback = !await this.shouldShowOptInCheckboxesNew();
        this.setState({
            anonymousFeedback: anonymousFeedback
        });
    }
    getGatewayUrl() {
        const { customGatewayUrl: customGatewayUrl, url: url } = this.props;
        if (customGatewayUrl) return customGatewayUrl;
        if (url) return url;
        return $a45798977a968ec1$export$2e2bcd8739ae039.defaultProps.url;
    }
    getFeedbackUrl() {
        const { customFeedbackUrl: customFeedbackUrl, url: url } = this.props;
        if (customFeedbackUrl) return customFeedbackUrl;
        if (url) return url;
        return $a45798977a968ec1$export$2e2bcd8739ae039.defaultProps.url;
    }
    getPackageVersion() {
        return "0.0.0-use.local";
    }
    async getEntitlementInformation() {
        const url = this.getGatewayUrl();
        // jira / confluence / bitbucket / trello
        let productName;
        let productEntitlement;
        let entitlementDetails;
        let productKey;
        if (window.location.host.includes('bitbucket.org')) {
            productName = 'Bitbucket';
            productKey = 'bitbucket';
            entitlementDetails = JSON.parse(JSON.stringify(document.querySelector('meta[id="bb-bootstrap"]')?.getAttribute('data-current-user')));
            const hasPremium = entitlementDetails['hasPremium'];
            productEntitlement = hasPremium ? 'PREMIUM' : 'STANDARD';
        } else if ([
            'trellis.coffee',
            'trello.com'
        ].includes(window.location.host)) {
            productName = 'Trello';
            productKey = 'trello';
        } else {
            if (document.querySelector('meta[id="confluence-context-path"]')) {
                productName = 'Confluence';
                productKey = 'pricingplan.confluence.ondemand';
            } else {
                productName = 'Jira';
                productKey = 'jira-software.ondemand';
            }
            try {
                entitlementDetails = await fetch(`${url}/customer-context/entitlements/${window.location.host}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    ...(0, $5BnIc.isApiGatewayUrl)(url) ? {
                        credentials: 'include'
                    } : {}
                });
            } catch (e) {
                entitlementDetails = undefined;
            }
        }
        let entitlement;
        const entitlementInformation = [];
        const cloudSiteId = entitlementDetails?.cloudSiteId || '';
        if (entitlementDetails?.children) entitlement = entitlementDetails?.children.find((entitlement)=>{
            return entitlement.key === productKey;
        });
        entitlementInformation.push({
            id: 'product',
            value: productName ? productName?.toLowerCase() : ''
        }, {
            id: 'hostingType',
            value: entitlement?.product ? entitlement.product.hostingType : 'CLOUD'
        }, {
            id: 'entitlementEdition',
            value: productEntitlement ?? ''
        }, {
            id: 'cloudId',
            value: cloudSiteId
        });
        return entitlementInformation;
    }
    getTypeFieldValue(dtype) {
        switch(dtype){
            case 'bug':
                return this.props.typeBugDefaultValue;
            case 'comment':
                return this.props.typeCommentDefaultValue;
            case 'suggestion':
                return this.props.typeSuggestionDefaultValue;
            case 'question':
                return this.props.typeQuestionDefaultValue;
            case 'empty':
            default:
                return this.props.typeEmptyDefaultValue;
        }
    }
    async getAtlassianID() {
        const { atlassianAccountId: atlassianAccountId, shouldGetEntitlementDetails: shouldGetEntitlementDetails } = this.props;
        try {
            if (atlassianAccountId || !shouldGetEntitlementDetails) return atlassianAccountId;
            const url = this.getGatewayUrl();
            const result = await fetch(`${url}/me`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
                ...(0, $5BnIc.isApiGatewayUrl)(url) ? {
                    credentials: 'include'
                } : {}
            });
            const json = await result.json();
            return json.account_id;
        } catch (e) {
            return undefined;
        }
    }
    shouldShowOptInCheckboxes() {
        if (this.props.anonymousFeedback) return !this.props.anonymousFeedback;
        if (this.props.atlassianAccountId) return true;
        let response;
        this.getAtlassianID().then((result)=>{
            response = result !== undefined;
        }).catch(()=>{
            response = false;
        });
        // @ts-ignore
        return response;
    }
    shouldShowOptInCheckboxesNew() {
        return new Promise((resolve)=>{
            if (this.props.anonymousFeedback) resolve(!this.props.anonymousFeedback);
            if (this.props.atlassianAccountId) resolve(true);
            this.getAtlassianID().then((result)=>{
                resolve(result !== undefined);
            }).catch(()=>{
                resolve(false);
            });
        });
    }
    getDescription(formValues) {
        return formValues.description || this.props.descriptionDefaultValue;
    }
    getSummary(formValues) {
        return $a45798977a968ec1$var$singleLineTruncatedText(formValues.description, this.props.summaryTruncateLength) || this.props.summaryDefaultValue;
    }
    getCustomerName() {
        return this.props.name ?? this.props.customerNameDefaultValue;
    }
    addEmailToContext() {
        const contextField = this.props.additionalFields.find((field)=>{
            return field.id === 'customfield_10047';
        });
        if (contextField) contextField.value = `${contextField.value}
        email: ${this.props.email}`;
        else this.props.additionalFields.push({
            id: 'customfield_10047',
            value: `email: ${this.props.email}`
        });
    }
    addAccountIdToContext(atlassianID) {
        if (atlassianID) {
            const contextField = this.props.additionalFields.find((field)=>{
                return field.id === 'customfield_10047';
            });
            if (contextField) contextField.value = `${contextField.value}
			atlassian-account-id: ${atlassianID}`;
        }
    }
    async mapFormToJSD(formValues) {
        let entitlementInformation = null;
        if (this.props?.shouldGetEntitlementDetails) entitlementInformation = await this.getEntitlementInformation();
        if (this.props?.email) this.addEmailToContext();
        const atlassianID = await this.getAtlassianID();
        this.addAccountIdToContext(atlassianID);
        return {
            fields: [
                ...entitlementInformation !== null && entitlementInformation || [],
                this.props.showTypeField ? {
                    id: this.props.typeFieldId,
                    value: this.getTypeFieldValue(formValues.type)
                } : undefined,
                {
                    id: this.props.summaryFieldId,
                    value: this.getSummary(formValues)
                },
                {
                    id: this.props.descriptionFieldId,
                    value: this.getDescription(formValues)
                },
                {
                    id: 'aaidOrHash',
                    value: formValues.canBeContacted ? atlassianID : undefined
                },
                {
                    id: this.props.customerNameFieldId,
                    value: this.getCustomerName()
                },
                formValues.canBeContacted ? {
                    id: this.props.canBeContactedFieldId,
                    value: this.props.canBeContactedAgreeValue
                } : {
                    id: this.props.canBeContactedFieldId,
                    value: this.props.canBeContactedDeclineValue
                },
                formValues.enrollInResearchGroup ? {
                    id: this.props.enrollInResearchFieldId,
                    value: this.props.enrollInResearchAgreeValue
                } : {
                    id: this.props.enrollInResearchFieldId,
                    value: this.props.enrollInResearchDeclineValue
                },
                ...this.props.additionalFields
            ].filter(Boolean)
        };
    }
    render() {
        const anonymousFeedback = !this.shouldShowOptInCheckboxes();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $h45y6.default), {
            customContent: this.props.customContent,
            feedbackTitle: this.props.feedbackTitle,
            feedbackTitleDetails: this.props.feedbackTitleDetails,
            showTypeField: this.props.showTypeField,
            showDefaultTextFields: this.props.showDefaultTextFields,
            hasDescriptionDefaultValue: !!this.props.descriptionDefaultValue,
            canBeContactedLabel: this.props.canBeContactedLabel,
            enrolInResearchLabel: this.props.enrolInResearchLabel,
            summaryPlaceholder: this.props.summaryPlaceholder,
            submitButtonLabel: this.props.submitButtonLabel,
            cancelButtonLabel: this.props.cancelButtonLabel,
            feedbackGroupLabels: this.props.feedbackGroupLabels,
            onSubmit: this.postFeedback,
            onClose: this.props.onClose,
            onCancel: this.props.onCancel,
            locale: this.props.locale,
            anonymousFeedback: (0, $iDrrr.fg)('platform.proforma-form-builder-feedback_hupaz') ? this.state.anonymousFeedback : anonymousFeedback,
            selectLabel: this.props.selectLabel,
            customTextAreaLabel: this.props.customTextAreaLabel,
            customFeedbackOptions: this.props.customFeedbackOptions,
            shouldReturnFocusRef: this.props.shouldReturnFocusRef,
            dialogRef: this.props.dialogRef,
            disableSubmitButton: this.props.disableSubmitButton,
            ...(0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements') && {
                enrolInResearchLink: this.props.enrolInResearchLink,
                canBeContactedLink: this.props.canBeContactedLink
            },
            showRequiredFieldsSummary: this.props.showRequiredFieldsSummary
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            anonymousFeedback: true
        };
        this.postFeedback = async (formValues)=>{
            const entrypointId = this.props.entrypointId;
            let fetchUrl = this.getFeedbackUrl();
            // Don't dispatch unless we have suitable props (allows tests to pass through empty strings and avoid redundant network calls)
            if (entrypointId) {
                const formData = await this.mapFormToJSD(formValues);
                const body = {
                    feedback: {
                        entrypointId: this.props.entrypointId,
                        entrypointUiVersion: this.getPackageVersion(),
                        ...formData
                    }
                };
                if ((0, $5BnIc.isApiGatewayUrl)(fetchUrl)) fetchUrl += '/feedback-collector-api';
                else if (!this.props.customFeedbackUrl) fetchUrl = 'https://feedback-collector-api.services.atlassian.com';
                const postData = (0, $e9nC3.Buffer).from(JSON.stringify(body)).toString('base64');
                fetch(`${fetchUrl}/v2/feedback`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        data: postData
                    }),
                    credentials: 'include'
                });
            }
            this.props.onClose();
            // slightly delay confirming submit since we don't wait for the REST call to succeed
            //
            // Because `onClose` is invoked prior to this timeout triggering, the `componentWillUnmount`
            // may occur before the `onSubmit` is called. To prevent prematurely cancelling the
            // network request, we deliberately don't clear this timeout inside `componentWillUnmount`.
            //
            setTimeout(()=>this.props.onSubmit(formValues), this.props.timeoutOnSubmit);
        };
    }
}
$a45798977a968ec1$export$2e2bcd8739ae039.defaultProps = {
    locale: 'en',
    url: '/gateway/api',
    shouldGetEntitlementDetails: true,
    canBeContactedFieldId: 'customfield_10043',
    canBeContactedAgreeValue: [
        {
            id: '10109'
        }
    ],
    canBeContactedDeclineValue: [
        {
            id: '10111'
        }
    ],
    additionalFields: [],
    customerNameFieldId: 'customfield_10045',
    customerNameDefaultValue: 'unknown',
    descriptionFieldId: 'description',
    descriptionDefaultValue: '',
    enrollInResearchFieldId: 'customfield_10044',
    enrollInResearchAgreeValue: [
        {
            id: '10110'
        }
    ],
    enrollInResearchDeclineValue: [
        {
            id: '10112'
        }
    ],
    summaryFieldId: 'summary',
    summaryDefaultValue: '',
    summaryTruncateLength: 100,
    timeoutOnSubmit: 700,
    typeFieldId: 'customfield_10042',
    typeBugDefaultValue: {
        id: '10105'
    },
    typeCommentDefaultValue: {
        id: '10106'
    },
    typeSuggestionDefaultValue: {
        id: '10107'
    },
    typeQuestionDefaultValue: {
        id: '10108'
    },
    typeEmptyDefaultValue: {
        id: 'empty'
    },
    showTypeField: true,
    showDefaultTextFields: true,
    anonymousFeedback: false,
    onClose: ()=>{},
    onSubmit: ()=>{}
};
module.exports["default"] = $a45798977a968ec1$export$2e2bcd8739ae039;

});

parcelRegister("5BnIc", function(module, exports) {
const $db292a71bf6452ef$export$f0f6fc934288a17c = (url)=>[
        '/gateway/api'
    ].includes(url);
module.exports["isApiGatewayUrl"] = $db292a71bf6452ef$export$f0f6fc934288a17c;

});

parcelRegister("9C5oc", function(module, exports) {
$parcel$export(module.exports, "default", () => $0c5409c9e56ee67a$export$2e2bcd8739ae039);
function $0c5409c9e56ee67a$export$2e2bcd8739ae039(text, maxLength) {
    if (!text || !maxLength) return text;
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
}

});

parcelRegister("h45y6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7ZB0A = parcelRequire("7ZB0A");


var $2uDbg = parcelRequire("2uDbg");


var $dTHYM = parcelRequire("dTHYM");


var $7BfeF = parcelRequire("7BfeF");


var $dUI0h = parcelRequire("dUI0h");


var $2Nu0e = parcelRequire("2Nu0e");


var $dQLwo = parcelRequire("dQLwo");


var $hpa99 = parcelRequire("hpa99");


var $i1t43 = parcelRequire("i1t43");


var $7aRdF = parcelRequire("7aRdF");


var $fEPJS = parcelRequire("fEPJS");


var $eQiT1 = parcelRequire("eQiT1");


var $9Umtx = parcelRequire("9Umtx");


var $jq995 = parcelRequire("jq995");


var $iDrrr = parcelRequire("iDrrr");


var $1VhsF = parcelRequire("1VhsF");


var $6wGOF = parcelRequire("6wGOF");


var $e3Wrf = parcelRequire("e3Wrf");


var $5r21M = parcelRequire("5r21M");


var $hTUp6 = parcelRequire("hTUp6");

const $dcf72f8838f67ff8$var$LinkWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            paddingInlineStart: "var(--ds-space-300, 24px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginInlineStart: "var(--ds-space-050, 4px)"
        }
    }, children);
};
const $dcf72f8838f67ff8$var$FeedbackForm = ({ showTypeField: showTypeField = true, showDefaultTextFields: showDefaultTextFields = true, customContent: customContent, onClose: onClose, onCancel: onCancel, onSubmit: onSubmit, feedbackTitle: feedbackTitle, feedbackTitleDetails: feedbackTitleDetails, feedbackGroupLabels: feedbackGroupLabels, summaryPlaceholder: summaryPlaceholder, canBeContactedLabel: canBeContactedLabel, canBeContactedLink: canBeContactedLink, enrolInResearchLabel: enrolInResearchLabel, enrolInResearchLink: enrolInResearchLink, submitButtonLabel: submitButtonLabel, cancelButtonLabel: cancelButtonLabel, anonymousFeedback: anonymousFeedback, hasDescriptionDefaultValue: hasDescriptionDefaultValue, selectLabel: selectLabel, customTextAreaLabel: customTextAreaLabel, customFeedbackOptions: customFeedbackOptions = [], shouldReturnFocusRef: shouldReturnFocusRef, dialogRef: dialogRef, disableSubmitButton: disableSubmitButton, showRequiredFieldsSummary: showRequiredFieldsSummary = true })=>{
    const [canBeContacted, setCanBeContacted] = (0, $cozmU.useState)(false);
    const [description, setDescription] = (0, $cozmU.useState)('');
    const [enrollInResearchGroup, setEnrollInResearchGroup] = (0, $cozmU.useState)(false);
    const [type, setType] = (0, $cozmU.useState)('empty');
    const [isSubmitting, setIsSubmitting] = (0, $cozmU.useState)(false);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isTypeSelected = ()=>type !== 'empty';
    const validateType = (value)=>showTypeField && (!value || value === 'empty') ? formatMessage((0, $5r21M.messages).validationErrorTypeRequired) : undefined;
    const validateDescription = (value)=>{
        if (!showDefaultTextFields || hasDescriptionDefaultValue) return undefined;
        return !value || !value.trim() ? formatMessage((0, $5r21M.messages).validationErrorDescriptionRequired) : undefined;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleCancel = (...args)=>{
        onCancel?.(...args);
        // Forward every arg the click handler received so consumers retain the full
        // pre-change runtime contract (originating event + Atlaskit UI analytics event).
        onClose(...args);
    };
    const canShowTextField = isTypeSelected() || !showTypeField;
    const isDisabled = isSubmitting || disableSubmitButton;
    const getFieldLabels = (record)=>({
            bug: record?.bug?.fieldLabel || formatMessage((0, $5r21M.messages).formBugLabel),
            comment: record?.comment?.fieldLabel || formatMessage((0, $5r21M.messages).formCommentLabel),
            suggestion: record?.suggestion?.fieldLabel || formatMessage((0, $5r21M.messages).formSuggestionLabel),
            question: record?.question?.fieldLabel || formatMessage((0, $5r21M.messages).formQuestionLabel),
            empty: record?.empty?.fieldLabel || formatMessage((0, $5r21M.messages).formEmptyLabel),
            not_relevant: record?.not_relevant?.fieldLabel || formatMessage((0, $5r21M.messages).formNotRelevantLabel),
            not_accurate: record?.not_accurate?.fieldLabel || formatMessage((0, $5r21M.messages).formNotAccurateLabel),
            too_slow: record?.too_slow?.fieldLabel || formatMessage((0, $5r21M.messages).formTooSlowLabel),
            unhelpful_links: record?.unhelpful_links?.fieldLabel || formatMessage((0, $5r21M.messages).formUnhelpfulLinksLabel),
            other: record?.other?.fieldLabel || formatMessage((0, $5r21M.messages).formOtherLabel)
        });
    const getSelectOptions = (record)=>[
            {
                label: record?.question?.selectOptionLabel || formatMessage((0, $5r21M.messages).selectionOptionQuestionLabel),
                value: 'question'
            },
            {
                label: record?.comment?.selectOptionLabel || formatMessage((0, $5r21M.messages).selectionOptionCommentLabel),
                value: 'comment'
            },
            {
                label: record?.bug?.selectOptionLabel || formatMessage((0, $5r21M.messages).selectionOptionBugLabel),
                value: 'bug'
            },
            {
                label: record?.suggestion?.selectOptionLabel || formatMessage((0, $5r21M.messages).selectionOptionSuggestionLabel),
                value: 'suggestion'
            }
        ];
    const getDefaultPlaceholder = (record)=>record?.empty?.selectOptionLabel || formatMessage((0, $5r21M.messages).selectionOptionDefaultPlaceholder);
    const focusRef = (0, $cozmU.useRef)();
    const selectOptions = customFeedbackOptions.length > 0 ? customFeedbackOptions : getSelectOptions(feedbackGroupLabels);
    const renderContactLabelAppify = ()=>{
        if ((0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements')) return (0, $5r21M.messages).canBeContactedLabelAppifyWithResponseWithoutLink;
        return (0, $5r21M.messages).canBeContactedLabelAppifyWithResponse;
    };
    const renderContactLabel = ()=>{
        if ((0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements')) return (0, $5r21M.messages).canBeContactedLabelWithResponseWithoutLink;
        return (0, $5r21M.messages).canBeContactedLabelWithResponse;
    };
    const requiredFieldsSummary = // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("p", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            color: "var(--ds-text-subtle, #505258)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginBottom: "var(--ds-space-300, 24px)"
        }
    }, formatMessage((0, $5r21M.messages).requiredFieldsSummary), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hpa99.RequiredAsterisk), null));
    const feedbackIsAnonymous = // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("p", null, formatMessage((0, $5r21M.messages).feedbackIsAnonymous));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
        ref: dialogRef,
        shouldCloseOnOverlayClick: false,
        onClose: onClose,
        testId: "feedbackCollectorModalDialog",
        shouldReturnFocus: shouldReturnFocusRef,
        shouldScrollInViewport: true
    }, (0, $iDrrr.fg)('platform-design_system_team-form_conversion') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dTHYM.default), {
        onSubmit: async ()=>{
            setIsSubmitting(true);
            try {
                await onSubmit({
                    canBeContacted: canBeContacted,
                    description: description,
                    enrollInResearchGroup: enrollInResearchGroup,
                    type: type
                });
            } finally{
                setIsSubmitting(false);
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, feedbackTitle || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5r21M.messages).feedbackTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, (0, $iDrrr.fg)('ak_feedback_collector_hide_required_summary') ? showRequiredFieldsSummary && requiredFieldsSummary : requiredFieldsSummary, feedbackTitleDetails, customContent, showTypeField ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        name: "topic",
        id: "topic",
        label: selectLabel || formatMessage((0, $5r21M.messages).selectionOptionDefaultLabel),
        isRequired: true,
        validate: validateType
    }, ({ fieldProps: { id: id, ...restProps }, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wGOF.default), {
            ...restProps,
            value: selectOptions.find((opt)=>opt.value === type) ?? null,
            onChange: (option)=>{
                if (!option || option instanceof Array) return;
                setType(option.value);
                restProps.onChange?.(option.value);
            },
            menuPosition: "fixed",
            options: selectOptions,
            shouldPreventEscapePropagation: true,
            // @ts-ignore
            ref: focusRef,
            placeholder: getDefaultPlaceholder(feedbackGroupLabels),
            inputId: id,
            isInvalid: !!error
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQLwo.MessageWrapper), null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, error)))) : null, showDefaultTextFields && canShowTextField && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        label: showTypeField ? getFieldLabels(feedbackGroupLabels)[type] : customTextAreaLabel || formatMessage((0, $5r21M.messages).defaultCustomTextAreaLabel),
        isRequired: true,
        name: "description",
        id: "description",
        validate: validateDescription
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
            ...fieldProps,
            name: "foo",
            minimumRows: 6,
            placeholder: summaryPlaceholder || undefined,
            onChange: (e)=>{
                setDescription(e.target.value);
                fieldProps.onChange(e.target.value);
            },
            value: description
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQLwo.MessageWrapper), null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, error)))), !anonymousFeedback && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Nu0e.Fieldset), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("legend", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5r21M.messages).optInOptionsLegend)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        name: "can-be-contacted"
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
            ...fieldProps,
            "aria-describedby": undefined,
            label: canBeContactedLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                ...(0, $iDrrr.fg)('product-terminology-refresh') ? renderContactLabelAppify() : renderContactLabel(),
                ...!(0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements') && {
                    values: {
                        a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                                href: "https://www.atlassian.com/legal/privacy-policy",
                                target: "_blank"
                            }, chunks)
                    }
                }
            }),
            onChange: (event)=>setCanBeContacted(event.target.checked)
        }), canBeContactedLabel && canBeContactedLink && (0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dcf72f8838f67ff8$var$LinkWrapper, null, canBeContactedLink), !canBeContactedLabel && (0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dcf72f8838f67ff8$var$LinkWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            href: "https://www.atlassian.com/legal/privacy-policy",
            target: "_blank"
        }, formatMessage((0, $5r21M.messages).privacyPolicy))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        name: "enroll-in-research-group"
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
            ...fieldProps,
            "aria-describedby": undefined,
            label: enrolInResearchLabel || formatMessage((0, $5r21M.messages).enrolInResearchLabel),
            onChange: (event)=>setEnrollInResearchGroup(event.target.checked)
        }), enrolInResearchLabel && enrolInResearchLink && (0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dcf72f8838f67ff8$var$LinkWrapper, null, enrolInResearchLink)))) || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        name: 'anonymousFeedback'
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
            title: formatMessage((0, $5r21M.messages).feedbackIsAnonymousTitle),
            appearance: 'information'
        }, feedbackIsAnonymous))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "subtle",
        onClick: handleCancel
    }, cancelButtonLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5r21M.messages).cancelButtonLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "primary",
        type: "submit",
        isDisabled: isSubmitting || isDisabled,
        testId: "feedbackCollectorSubmitBtn"
    }, submitButtonLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5r21M.messages).submitButtonLabel)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dTHYM.default), {
        onSubmit: async ()=>{
            setIsSubmitting(true);
            try {
                await onSubmit({
                    canBeContacted: canBeContacted,
                    description: description,
                    enrollInResearchGroup: enrollInResearchGroup,
                    type: type
                });
            } finally{
                setIsSubmitting(false);
            }
        }
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
            hasCloseButton: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, feedbackTitle || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5r21M.messages).feedbackTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, (0, $iDrrr.fg)('ak_feedback_collector_hide_required_summary') ? showRequiredFieldsSummary && requiredFieldsSummary : requiredFieldsSummary, feedbackTitleDetails, customContent, showTypeField ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            name: "topic",
            id: "topic",
            label: selectLabel || formatMessage((0, $5r21M.messages).selectionOptionDefaultLabel),
            isRequired: true,
            validate: validateType
        }, ({ fieldProps: { id: id, ...restProps }, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wGOF.default), {
                ...restProps,
                value: selectOptions.find((opt)=>opt.value === type) ?? null,
                onChange: (option)=>{
                    if (!option || option instanceof Array) return;
                    setType(option.value);
                    restProps.onChange?.(option.value);
                },
                menuPosition: "fixed",
                options: selectOptions,
                shouldPreventEscapePropagation: true,
                // @ts-ignore
                ref: focusRef,
                placeholder: getDefaultPlaceholder(feedbackGroupLabels),
                inputId: id,
                isInvalid: !!error
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQLwo.MessageWrapper), null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, error)))) : null, showDefaultTextFields && canShowTextField && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            label: showTypeField ? getFieldLabels(feedbackGroupLabels)[type] : customTextAreaLabel || formatMessage((0, $5r21M.messages).defaultCustomTextAreaLabel),
            isRequired: true,
            name: "description",
            id: "description",
            validate: validateDescription
        }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
                ...fieldProps,
                name: "foo",
                minimumRows: 6,
                placeholder: summaryPlaceholder || undefined,
                onChange: (e)=>{
                    setDescription(e.target.value);
                    fieldProps.onChange(e.target.value);
                },
                value: description
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQLwo.MessageWrapper), null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, error)))), !anonymousFeedback && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Nu0e.Fieldset), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("legend", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5r21M.messages).optInOptionsLegend)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            name: "can-be-contacted"
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
                ...fieldProps,
                "aria-describedby": undefined,
                label: canBeContactedLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...(0, $iDrrr.fg)('product-terminology-refresh') ? renderContactLabelAppify() : renderContactLabel(),
                    ...!(0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements') && {
                        values: {
                            a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                                    href: "https://www.atlassian.com/legal/privacy-policy",
                                    target: "_blank"
                                }, chunks)
                        }
                    }
                }),
                onChange: (event)=>setCanBeContacted(event.target.checked)
            }), canBeContactedLabel && canBeContactedLink && (0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dcf72f8838f67ff8$var$LinkWrapper, null, canBeContactedLink), !canBeContactedLabel && (0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dcf72f8838f67ff8$var$LinkWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                href: "https://www.atlassian.com/legal/privacy-policy",
                target: "_blank"
            }, formatMessage((0, $5r21M.messages).privacyPolicy))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            name: "enroll-in-research-group"
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
                ...fieldProps,
                "aria-describedby": undefined,
                label: enrolInResearchLabel || formatMessage((0, $5r21M.messages).enrolInResearchLabel),
                onChange: (event)=>setEnrollInResearchGroup(event.target.checked)
            }), enrolInResearchLabel && enrolInResearchLink && (0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dcf72f8838f67ff8$var$LinkWrapper, null, enrolInResearchLink)))) || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            name: 'anonymousFeedback'
        }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
                title: formatMessage((0, $5r21M.messages).feedbackIsAnonymousTitle),
                appearance: 'information'
            }, feedbackIsAnonymous))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            appearance: "subtle",
            onClick: handleCancel
        }, cancelButtonLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5r21M.messages).cancelButtonLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            appearance: "primary",
            type: "submit",
            isDisabled: isSubmitting || isDisabled,
            testId: "feedbackCollectorSubmitBtn"
        }, submitButtonLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5r21M.messages).submitButtonLabel))))));
};
const $dcf72f8838f67ff8$var$FeedbackFormWithIntl = ({ locale: locale, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hTUp6.IntlProviderWithResolvedMessages), {
        locale: locale
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dcf72f8838f67ff8$var$FeedbackForm, props));
};
var $dcf72f8838f67ff8$export$2e2bcd8739ae039 = $dcf72f8838f67ff8$var$FeedbackFormWithIntl;
module.exports["default"] = $dcf72f8838f67ff8$export$2e2bcd8739ae039;

});

parcelRegister("5r21M", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $0eef762dd50d9f91$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    feedbackTitle: {
        id: "feedback-collector.feedback-title",
        defaultMessage: "Share your thoughts"
    },
    enrolInResearchLabel: {
        id: "feedback-collector.enrol-in-research.label",
        defaultMessage: "I'd like to participate in product research"
    },
    canBeContactedLabelWithResponse: {
        id: "feedback-collector.can-be-contacted.label-with-response",
        defaultMessage: "Yes, Atlassian teams can reply to my feedback and ask for more details about my experience to improve Atlassian products and services. Without this, I won't get a response. I acknowledge the <a>Atlassian Privacy Policy</a>."
    },
    canBeContactedLabelWithResponseWithoutLink: {
        id: "feedback-collector.can-be-contacted.label-with-response-without-link",
        defaultMessage: "Yes, Atlassian teams can reply to my feedback and ask for more details about my experience to improve Atlassian products and services. Without this, I won't get a response. I acknowledge the Atlassian Privacy Policy."
    },
    privacyPolicy: {
        id: "feedback-collector.privacy-policy",
        defaultMessage: "Atlassian Privacy Policy"
    },
    summaryPlaceholder: {
        id: "feedback-collector.summary-placeholder",
        defaultMessage: "Let us know what's on your mind"
    },
    formCommentLabel: {
        id: "feedback-collector.form.comment.label",
        defaultMessage: "Let us know what's on your mind"
    },
    submitButtonLabel: {
        id: "feedback-collector.submit-button.label",
        defaultMessage: "Send feedback"
    },
    cancelButtonLabel: {
        id: "feedback-collector.cancel-button.label",
        defaultMessage: "Cancel"
    },
    giveFeedback: {
        id: "proforma-form-builder.give-feedback",
        defaultMessage: "Give feedback"
    },
    formBugLabel: {
        id: "feedback-collector.form.bug.label",
        defaultMessage: "Describe the bug or issue"
    },
    formSuggestionLabel: {
        id: "feedback-collector.form.suggestion.label",
        defaultMessage: "Let us know what you'd like to improve"
    },
    formQuestionLabel: {
        id: "feedback-collector.form.question.label",
        defaultMessage: "What would you like to know?"
    },
    formEmptyLabel: {
        id: "feedback-collector.form.empty.label",
        defaultMessage: "Select an option"
    },
    formNotRelevantLabel: {
        id: "feedback-collector.form.not-relevant.label",
        defaultMessage: "Wasn't relevant"
    },
    formNotAccurateLabel: {
        id: "feedback-collector.form.not-accurate.label",
        defaultMessage: "Wasn't accurate"
    },
    formTooSlowLabel: {
        id: "feedback-collector.form.too-slow.label",
        defaultMessage: "Too slow"
    },
    formUnhelpfulLinksLabel: {
        id: "feedback-collector.form.unhelpful-links.label",
        defaultMessage: "Unhelpful links"
    },
    formOtherLabel: {
        id: "feedback-collector.form.other.label",
        defaultMessage: "Other"
    },
    selectionOptionQuestionLabel: {
        id: "feedback-collector.option.question.label",
        defaultMessage: "Ask a question"
    },
    selectionOptionCommentLabel: {
        id: "feedback-collector.option.comment.label",
        defaultMessage: "Leave a comment"
    },
    selectionOptionBugLabel: {
        id: "feedback-collector.option.bug.label",
        defaultMessage: "Report a bug"
    },
    selectionOptionSuggestionLabel: {
        id: "feedback-collector.option.suggestion.label",
        defaultMessage: "Suggest an improvement"
    },
    selectionOptionDefaultLabel: {
        id: "feedback-collector.option.default.label",
        defaultMessage: "Select feedback"
    },
    selectionOptionDefaultPlaceholder: {
        id: "feedback-collector.option.default.placeholder",
        defaultMessage: "Choose one"
    },
    feedbackIconLabel: {
        id: "proforma-form-builder.feedback-icon-label",
        defaultMessage: "Feedback"
    },
    feedbackSuccessFlagDescription: {
        id: "feedback-collector.success-flag.description",
        defaultMessage: "Your valuable feedback helps us continually improve our products."
    },
    feedbackSuccessFlagTitle: {
        id: "feedback-collector.success-flag.title",
        defaultMessage: "Thanks!"
    },
    feedbackIsAnonymousTitle: {
        id: "feedback-collector.anonymous.title",
        defaultMessage: "Anonymous feedback"
    },
    feedbackIsAnonymous: {
        id: "feedback-collector.anonymous",
        defaultMessage: "This feedback is being submitted anonymously. Atlassian will not be able to contact you directly regarding this feedback"
    },
    requiredFieldsSummary: {
        id: "feedback-collector.required.fields.summary",
        defaultMessage: "Required fields are marked with an asterisk"
    },
    defaultCustomTextAreaLabel: {
        id: "feedback-collector.default.custom.textarea.label",
        defaultMessage: "What's on your mind?"
    },
    canBeContactedLabelAppifyWithResponse: {
        id: "feedback-collector.can-be-contacted.label-appify-with-response",
        defaultMessage: "Yes, Atlassian teams can reply to my feedback and ask for more details about my experience to improve Atlassian apps and services. Without this, I won't get a response. I acknowledge the <a>Atlassian Privacy Policy</a>."
    },
    canBeContactedLabelAppifyWithResponseWithoutLink: {
        id: "feedback-collector.can-be-contacted.label-appify-with-response-without-link",
        defaultMessage: "Yes, Atlassian teams can reply to my feedback and ask for more details about my experience to improve Atlassian apps and services. Without this, I won't get a response. I acknowledge the Atlassian Privacy Policy."
    },
    feedbackSuccessFlagDescriptionAppify: {
        id: "feedback-collector.success-flag.description-appify",
        defaultMessage: "Your valuable feedback helps us continually improve our apps."
    },
    validationErrorTypeRequired: {
        id: "feedback-collector.validation.type.required",
        defaultMessage: "Please select a feedback type"
    },
    validationErrorDescriptionRequired: {
        id: "feedback-collector.validation.description.required",
        defaultMessage: "Please provide a description"
    },
    optInOptionsLegend: {
        id: "feedback-collector.opt-in.options.legend",
        defaultMessage: "Atlassian opt-in options"
    }
});
module.exports["messages"] = $0eef762dd50d9f91$export$defe85febe8b728c;

});

parcelRegister("hTUp6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $b2A1s = parcelRequire("b2A1s");

const $fb8b4f9502ba72fc$export$f793de1293176fe6 = ({ children: children, locale: locale })=>{
    const [resolvedMessagesForLocale, setResolvedMessagesForLocale] = (0, $cozmU.useState)();
    (0, $cozmU.useEffect)(()=>{
        const fetchMessageLocale = async ()=>{
            if (locale) {
                const messages = await (0, $b2A1s.getMessagesForLocale)(locale);
                setResolvedMessagesForLocale(messages);
            }
        };
        fetchMessageLocale();
    }, [
        locale
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        locale: locale || 'en',
        defaultLocale: "en",
        messages: resolvedMessagesForLocale
    }, children);
};
module.exports["IntlProviderWithResolvedMessages"] = $fb8b4f9502ba72fc$export$f793de1293176fe6;

});

parcelRegister("b2A1s", function(module, exports) {
const $e1a3f1d7e16f1235$var$isNestedMessagesModule = (value)=>'default' in value && typeof value.default === 'object' && value.default !== null;
const $e1a3f1d7e16f1235$var$unwrapMessages = (messages)=>{
    const defaultExport = messages.default;
    return $e1a3f1d7e16f1235$var$isNestedMessagesModule(defaultExport) ? defaultExport.default : defaultExport;
};





























const $e1a3f1d7e16f1235$var$messagesLoaders = {
    cs: ()=>(parcelRequire("gR4U1")),
    da: ()=>(parcelRequire("f1jrk")),
    de: ()=>(parcelRequire("aOLRB")),
    en: ()=>(parcelRequire("6kEFl")),
    en_GB: ()=>(parcelRequire("bjsxN")),
    en_ZZ: ()=>(parcelRequire("9DhD6")),
    es: ()=>(parcelRequire("ddpWy")),
    fi: ()=>(parcelRequire("5XvgX")),
    fr: ()=>(parcelRequire("cZf5E")),
    hr: ()=>(parcelRequire("CsODP")),
    hu: ()=>(parcelRequire("hPRyr")),
    it: ()=>(parcelRequire("z7zpe")),
    ja: ()=>(parcelRequire("8pzcT")),
    ko: ()=>(parcelRequire("1I2b8")),
    nb: ()=>(parcelRequire("gPBz3")),
    nl: ()=>(parcelRequire("78iTh")),
    pl: ()=>(parcelRequire("gHYE1")),
    pt_BR: ()=>(parcelRequire("9qN1z")),
    ru: ()=>(parcelRequire("dNwJi")),
    sl: ()=>(parcelRequire("fXweJ")),
    sr_RS: ()=>(parcelRequire("nFTVL")),
    sr_YR: ()=>(parcelRequire("bsw4B")),
    sv: ()=>(parcelRequire("97qPc")),
    th: ()=>(parcelRequire("bZmWu")),
    tr: ()=>(parcelRequire("aspSd")),
    uk: ()=>(parcelRequire("kWvvj")),
    vi: ()=>(parcelRequire("c5Sph")),
    zh: ()=>(parcelRequire("ecWO0")),
    zh_TW: ()=>(parcelRequire("dpkEO"))
};
const $e1a3f1d7e16f1235$var$getMessages = async (locale)=>{
    const loadMessages = $e1a3f1d7e16f1235$var$messagesLoaders[locale];
    if (!loadMessages) return undefined;
    try {
        const messages = await loadMessages();
        return $e1a3f1d7e16f1235$var$unwrapMessages(messages);
    } catch  {
        return undefined;
    }
};
const $e1a3f1d7e16f1235$export$d0a3169680473b6c = async (locale)=>{
    const localeKey = locale.replace('-', '_');
    const messages = await $e1a3f1d7e16f1235$var$getMessages(localeKey);
    return messages ?? $e1a3f1d7e16f1235$var$getMessages(localeKey.split(/[-_]/)[0]);
};
module.exports["getMessagesForLocale"] = $e1a3f1d7e16f1235$export$d0a3169680473b6c;

});

parcelRegister("gR4U1", function(module, exports) {

let $c455661dc243c654$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c455661dc243c654$var$load("iGnEn").then(()=>parcelRequire('6S4lG'));

});

parcelRegister("f1jrk", function(module, exports) {

let $aef60752586d2f07$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $aef60752586d2f07$var$load("81CwI").then(()=>parcelRequire('9Q7ky'));

});

parcelRegister("aOLRB", function(module, exports) {

let $7e03b39534ef9cf9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7e03b39534ef9cf9$var$load("coMdg").then(()=>parcelRequire('4ELWT'));

});

parcelRegister("6kEFl", function(module, exports) {

let $49c427b32ae5dc71$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $49c427b32ae5dc71$var$load("4t3GG").then(()=>parcelRequire('aPmYJ'));

});

parcelRegister("bjsxN", function(module, exports) {

let $83c79c54c6feadd2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $83c79c54c6feadd2$var$load("lJDHR").then(()=>parcelRequire('fYO3Z'));

});

parcelRegister("9DhD6", function(module, exports) {

let $70356e70b5fecfa6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $70356e70b5fecfa6$var$load("izI99").then(()=>parcelRequire('fcttw'));

});

parcelRegister("ddpWy", function(module, exports) {

let $99f09d110267a62d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $99f09d110267a62d$var$load("3LmH0").then(()=>parcelRequire('iTEZG'));

});

parcelRegister("5XvgX", function(module, exports) {

let $456ab880bb5ad2de$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $456ab880bb5ad2de$var$load("9nUzh").then(()=>parcelRequire('jCyLN'));

});

parcelRegister("cZf5E", function(module, exports) {

let $9746e31b2d06b6ef$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9746e31b2d06b6ef$var$load("b0H0M").then(()=>parcelRequire('sjYCD'));

});

parcelRegister("CsODP", function(module, exports) {

let $0739e6f0f7a8ce09$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0739e6f0f7a8ce09$var$load("rlX60").then(()=>parcelRequire('kdtG9'));

});

parcelRegister("hPRyr", function(module, exports) {

let $cfc0bde35e1c9468$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cfc0bde35e1c9468$var$load("8XGfa").then(()=>parcelRequire('9cMV0'));

});

parcelRegister("z7zpe", function(module, exports) {

let $0699244176860d72$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0699244176860d72$var$load("kX4YP").then(()=>parcelRequire('65zeK'));

});

parcelRegister("8pzcT", function(module, exports) {

let $61fbf7e9b29a6824$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $61fbf7e9b29a6824$var$load("cYuG5").then(()=>parcelRequire('amjcb'));

});

parcelRegister("1I2b8", function(module, exports) {

let $13eb9721d58dad03$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $13eb9721d58dad03$var$load("5bV9Q").then(()=>parcelRequire('3z1HI'));

});

parcelRegister("gPBz3", function(module, exports) {

let $c40e8c41f36f3f1d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c40e8c41f36f3f1d$var$load("gjrov").then(()=>parcelRequire('ePp5T'));

});

parcelRegister("78iTh", function(module, exports) {

let $5317ef0d88303541$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5317ef0d88303541$var$load("ekD3q").then(()=>parcelRequire('3sPeQ'));

});

parcelRegister("gHYE1", function(module, exports) {

let $c29fb436da7f42d1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c29fb436da7f42d1$var$load("CRIov").then(()=>parcelRequire('21Pza'));

});

parcelRegister("9qN1z", function(module, exports) {

let $6ddc91febcf834c3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6ddc91febcf834c3$var$load("kLzqf").then(()=>parcelRequire('2YIPE'));

});

parcelRegister("dNwJi", function(module, exports) {

let $a0b93d651cd2386e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a0b93d651cd2386e$var$load("89F7K").then(()=>parcelRequire('lXD2K'));

});

parcelRegister("fXweJ", function(module, exports) {

let $b9e55f3b28230681$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b9e55f3b28230681$var$load("5ZUDB").then(()=>parcelRequire('16fIE'));

});

parcelRegister("nFTVL", function(module, exports) {

let $0472a6c8d6c4c707$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0472a6c8d6c4c707$var$load("h2pVk").then(()=>parcelRequire('byreT'));

});

parcelRegister("bsw4B", function(module, exports) {

let $857b304eeac06c5e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $857b304eeac06c5e$var$load("hKNph").then(()=>parcelRequire('diuUZ'));

});

parcelRegister("97qPc", function(module, exports) {

let $6a39935eb8b824b7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6a39935eb8b824b7$var$load("bEB1L").then(()=>parcelRequire('57pGr'));

});

parcelRegister("bZmWu", function(module, exports) {

let $8ba730127f966548$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8ba730127f966548$var$load("1DxcO").then(()=>parcelRequire('grvEM'));

});

parcelRegister("aspSd", function(module, exports) {

let $79d096d1d3432597$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $79d096d1d3432597$var$load("4KHc0").then(()=>parcelRequire('13DVp'));

});

parcelRegister("kWvvj", function(module, exports) {

let $f3f1a976fda4a8c1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f3f1a976fda4a8c1$var$load("fWsCx").then(()=>parcelRequire('im5if'));

});

parcelRegister("c5Sph", function(module, exports) {

let $8ce027b238ed199c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8ce027b238ed199c$var$load("eVExC").then(()=>parcelRequire('1U1j1'));

});

parcelRegister("ecWO0", function(module, exports) {

let $a57fcd3be5a7543a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a57fcd3be5a7543a$var$load("BGq3S").then(()=>parcelRequire('kBazV'));

});

parcelRegister("dpkEO", function(module, exports) {

let $9c2da245872fb648$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9c2da245872fb648$var$load("1BBYh").then(()=>parcelRequire('3tROA'));

});

parcelRegister("gnkil", function(module, exports) {
// Note: When modifying shortcut settings, make sure to test across all input fields on the page.
// Some input fields may not have shortcuts fully disabled, which could cause conflicts with shortcuts.
// Ensure that the new shortcuts do not interfere with normal input field operations.
// When making change in this file, make sure the corresponding tab in @confluence/keyboard-shortcuts-dialog is also updated
// Shortcuts for editor2
const $e13bb5c64c0a0eec$export$170fefa3f8a9258a = {
    PUBLISH: 'mod+enter',
    PUBLISH_WITH_COMMENT: 'mod+shift+enter',
    EDIT: 'e',
    PREVIEW: 'mod+shift+e',
    UNDO: 'mod+z',
    REDO: 'mod+shift+z',
    FIND_REPLACE: 'mod+f'
};
const $e13bb5c64c0a0eec$export$1cbe44c5850db728 = 'mod+s';
const $e13bb5c64c0a0eec$export$73148f05a63f43f = 'command+enter';
const $e13bb5c64c0a0eec$export$67c56ed34ece0f2a = 'mod+enter';
const $e13bb5c64c0a0eec$export$c19d729632cce38f = 'b';
const $e13bb5c64c0a0eec$export$e896f39257754358 = 'c';
const $e13bb5c64c0a0eec$export$c9d367283380f242 = 'f';
const $e13bb5c64c0a0eec$export$44da7c32f8b979f6 = 'm';
const $e13bb5c64c0a0eec$export$f10fe393178b1b45 = 'k';
const $e13bb5c64c0a0eec$export$3837d28de95f38e = 'e';
const $e13bb5c64c0a0eec$export$99088c948bf0270f = 'r';
const $e13bb5c64c0a0eec$export$ddb528ae2130e6f3 = 'w';
const $e13bb5c64c0a0eec$export$95a205588c16f013 = 's';
const $e13bb5c64c0a0eec$export$f7fab4391dadca28 = 'l';
const $e13bb5c64c0a0eec$export$2f62883c954429eb = 't';
const $e13bb5c64c0a0eec$export$96f161bee6b4340d = 'n';
const $e13bb5c64c0a0eec$export$ef9cfcdc2a9ff172 = 'p';
const $e13bb5c64c0a0eec$export$f0bc8e18b9c1c031 = 'g f';
const $e13bb5c64c0a0eec$export$b947af6524920798 = 'g g';
const $e13bb5c64c0a0eec$export$53e346b715d2b7c7 = 'g d';
const $e13bb5c64c0a0eec$export$8cb32cdc75719ad2 = 'g n';
const $e13bb5c64c0a0eec$export$b4842d8ad92c38a3 = 'g r';
const $e13bb5c64c0a0eec$export$298e62593d4ef85 = 'g s';
const $e13bb5c64c0a0eec$export$5d4720de35488ecb = 'g s';
const $e13bb5c64c0a0eec$export$9a4b5405eaaa0bd7 = 'g o';
const $e13bb5c64c0a0eec$export$f5473855a7a167a7 = 'g c';
const $e13bb5c64c0a0eec$export$cee4257b1a828f0d = '/';
const $e13bb5c64c0a0eec$export$159e447a25b21930 = '[';
const $e13bb5c64c0a0eec$export$922297bddc2a63e6 = 'mod+z';
const $e13bb5c64c0a0eec$export$420825475f86fe8d = 'left';
const $e13bb5c64c0a0eec$export$db9252a2db2b8e9e = 'right';
const $e13bb5c64c0a0eec$export$faa4136cec2aa7a0 = '?';
const $e13bb5c64c0a0eec$export$362c0171844ea600 = 'a';
const $e13bb5c64c0a0eec$export$5d80e625aa457659 = ']';
const $e13bb5c64c0a0eec$export$cc9bab4159e8aec9 = 'e';
const $e13bb5c64c0a0eec$export$285e80cf6c078ba6 = 'mod+shift+e';
const $e13bb5c64c0a0eec$export$8d0081a3f70f258c = 'ctrl+.';
const $e13bb5c64c0a0eec$export$d9b4e2a8acc45d14 = 'ctrl+,';
const $e13bb5c64c0a0eec$export$de4065c6a68e4031 = 'mod+option+c';
const $e13bb5c64c0a0eec$export$b5f3b4e8358360b3 = 'ctrl+shift+d';
const $e13bb5c64c0a0eec$export$9cee57908df99565 = 'ctrl+option+n';
const $e13bb5c64c0a0eec$export$b0a212f4fb6d9350 = 'mod+shift+u';
const $e13bb5c64c0a0eec$export$986cc862e5f6eec1 = 'mod+option+r';
const $e13bb5c64c0a0eec$export$d3b6b270c6770b4f = 'ctrl+option+r';
const $e13bb5c64c0a0eec$export$adb85b0fd79d17f8 = 'ctrl+]';
const $e13bb5c64c0a0eec$export$1822b04007c39b0c = 'mod+option+shift+b';
const $e13bb5c64c0a0eec$export$5dd7c1bb4d898f99 = 'ctrl+option+c';
const $e13bb5c64c0a0eec$export$f5ba0af3c65d3125 = 'meta+alt+c';
const $e13bb5c64c0a0eec$export$c372eed375f60e68 = 'ctrl+shift+/';
const $e13bb5c64c0a0eec$export$406fcfa6807667 = 'ctrl+[';
const $e13bb5c64c0a0eec$export$4ec29504bd71f204 = 'ctrl+option+f';
const $e13bb5c64c0a0eec$export$4148526d63a5bc01 = 'mod+option+o';
const $e13bb5c64c0a0eec$export$b7088d9be4883093 = 'ctrl+option+z';
const $e13bb5c64c0a0eec$export$e14ed0c2460e0a5c = 'alt+shift+z';
const $e13bb5c64c0a0eec$export$2bdd2e57d23976c4 = 'mod+option+h';
const $e13bb5c64c0a0eec$export$e3a3f5ea05a3d899 = 'mod+option+g';
const $e13bb5c64c0a0eec$export$18a9bb0de7844bb6 = 'mod+option+8';
const $e13bb5c64c0a0eec$export$3fe2d0f3fe115364 = 'mod+option+v';
const $e13bb5c64c0a0eec$export$a3e38cca130cbc49 = 'mod+option+w';
const $e13bb5c64c0a0eec$export$a769ea2ac46f94da = 'ctrl+option+w';
const $e13bb5c64c0a0eec$export$ddfbfebfa9c821fd = 'mod+option+s';
const $e13bb5c64c0a0eec$export$4bc8c55d04859f5a = 'ctrl+shift+i';
const $e13bb5c64c0a0eec$export$1f53991bf9b208a0 = 'ctrl+option+a';
const $e13bb5c64c0a0eec$export$650d7b87402f841f = 'ctrl+option+t';
const $e13bb5c64c0a0eec$export$dc2c2f2eed832016 = 'meta+alt+t';
const $e13bb5c64c0a0eec$export$1a9b1a10dcf9f02d = 'mod+.';
const $e13bb5c64c0a0eec$export$c252fe6b173dfad3 = 'ctrl+meta+.';
const $e13bb5c64c0a0eec$export$a1552937ff7cca64 = 'mod+option+k';
const $e13bb5c64c0a0eec$export$f7727b957c03a88b = 'mod+option+e';
const $e13bb5c64c0a0eec$export$f0043475aa91a151 = 'alt+meta+x';
const $e13bb5c64c0a0eec$export$bc654500edb91b60 = 'mod+shift+x';
module.exports["EDITOR2_SHORTCUTS"] = $e13bb5c64c0a0eec$export$170fefa3f8a9258a;
module.exports["BROWSER_SAVE_SHORTCUT"] = $e13bb5c64c0a0eec$export$1cbe44c5850db728;
module.exports["COMMENT_EDITOR_SHORTCUT"] = $e13bb5c64c0a0eec$export$73148f05a63f43f;
module.exports["INLINE_COMMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$67c56ed34ece0f2a;
module.exports["BLOG_SHORTCUT"] = $e13bb5c64c0a0eec$export$c19d729632cce38f;
module.exports["GLOBAL_CREATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$e896f39257754358;
module.exports["STAR_BUTTON_SHORTCUT"] = $e13bb5c64c0a0eec$export$c9d367283380f242;
module.exports["CREATE_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$44da7c32f8b979f6;
module.exports["LINK_TO_THIS_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$f10fe393178b1b45;
module.exports["EDIT_SHORTCUT"] = $e13bb5c64c0a0eec$export$3837d28de95f38e;
module.exports["PRESENTATION_MODE_SHORTCUT"] = $e13bb5c64c0a0eec$export$99088c948bf0270f;
module.exports["WATCH_CONTENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$ddb528ae2130e6f3;
module.exports["SHARE_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$95a205588c16f013;
module.exports["LABELS_SHORTCUT"] = $e13bb5c64c0a0eec$export$f7fab4391dadca28;
module.exports["VIEW_ATTACHMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$2f62883c954429eb;
module.exports["NEXT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$96f161bee6b4340d;
module.exports["PREV_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$ef9cfcdc2a9ff172;
module.exports["SUBMIT_FEEDBACK_SHORTCUT"] = $e13bb5c64c0a0eec$export$f0bc8e18b9c1c031;
module.exports["NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$b947af6524920798;
module.exports["GO_HOME_SHORTCUT"] = $e13bb5c64c0a0eec$export$53e346b715d2b7c7;
module.exports["NOTIFICATIONS_SHORTCUT"] = $e13bb5c64c0a0eec$export$8cb32cdc75719ad2;
module.exports["GO_TO_RECENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$b4842d8ad92c38a3;
module.exports["GO_TO_STARRED_SHORTCUT"] = $e13bb5c64c0a0eec$export$298e62593d4ef85;
module.exports["SPACE_OVERVIEW_SHORTCUT_NAV_3"] = $e13bb5c64c0a0eec$export$5d4720de35488ecb;
module.exports["SPACE_OVERVIEW_SHORTCUT"] = $e13bb5c64c0a0eec$export$9a4b5405eaaa0bd7;
module.exports["AI_MATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$f5473855a7a167a7;
module.exports["NAVIGATION_SLASH_SHORTCUT"] = $e13bb5c64c0a0eec$export$cee4257b1a828f0d;
module.exports["SIDE_NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$159e447a25b21930;
module.exports["UNDO_SHORTCUT"] = $e13bb5c64c0a0eec$export$922297bddc2a63e6;
module.exports["PREV_TEMPLATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$420825475f86fe8d;
module.exports["NEXT_TEMPLATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$db9252a2db2b8e9e;
module.exports["HELP_SHORTCUT"] = $e13bb5c64c0a0eec$export$faa4136cec2aa7a0;
module.exports["AUTOMATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$362c0171844ea600;
module.exports["TOGGLE_INLINE_COMMENTS_SHORTCUT_RENDERER"] = $e13bb5c64c0a0eec$export$5d80e625aa457659;
module.exports["LIVE_PAGE_MODE_SWITCH_TO_EDIT"] = $e13bb5c64c0a0eec$export$cc9bab4159e8aec9;
module.exports["LIVE_PAGE_MODE_SWITCH_TO_VIEW"] = $e13bb5c64c0a0eec$export$285e80cf6c078ba6;
module.exports["UNIVERSAL_NEXT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$8d0081a3f70f258c;
module.exports["UNIVERSAL_PREV_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$d9b4e2a8acc45d14;
module.exports["UNIVERSAL_OPEN_COMMENT_EDITOR"] = $e13bb5c64c0a0eec$export$de4065c6a68e4031;
module.exports["UNIVERSAL_CREATE_LIVE_DOC_SHORTCUT"] = $e13bb5c64c0a0eec$export$b5f3b4e8358360b3;
module.exports["UNIVERSAL_CREATE_NOTE_SHORTCUT"] = $e13bb5c64c0a0eec$export$9cee57908df99565;
module.exports["UNIVERSAL_NEXT_UNREAD_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$b0a212f4fb6d9350;
module.exports["UNIVERSAL_PRESENTATION_MODE_SHORTCUT"] = $e13bb5c64c0a0eec$export$986cc862e5f6eec1;
module.exports["UNIVERSAL_PRESENTATION_MODE_SHORTCUT_SAFARI"] = $e13bb5c64c0a0eec$export$d3b6b270c6770b4f;
module.exports["UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$adb85b0fd79d17f8;
module.exports["UNIVERSAL_BLOG_SHORTCUT"] = $e13bb5c64c0a0eec$export$1822b04007c39b0c;
module.exports["UNIVERSAL_GLOBAL_CREATE_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$5dd7c1bb4d898f99;
module.exports["UNIVERSAL_GLOBAL_CREATE_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$f5ba0af3c65d3125;
module.exports["UNIVERSAL_HELP_SHORTCUT"] = $e13bb5c64c0a0eec$export$c372eed375f60e68;
module.exports["UNIVERSAL_SIDE_NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$406fcfa6807667;
module.exports["UNIVERSAL_STAR_BUTTON_SHORTCUT"] = $e13bb5c64c0a0eec$export$4ec29504bd71f204;
module.exports["UNIVERSAL_NOTIFICATIONS_SHORTCUT"] = $e13bb5c64c0a0eec$export$4148526d63a5bc01;
module.exports["UNIVERSAL_NAVIGATION_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$b7088d9be4883093;
module.exports["UNIVERSAL_NAVIGATION_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$e14ed0c2460e0a5c;
module.exports["UNIVERSAL_GO_HOME_SHORTCUT"] = $e13bb5c64c0a0eec$export$2bdd2e57d23976c4;
module.exports["UNIVERSAL_GO_TO_RECENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$e3a3f5ea05a3d899;
module.exports["UNIVERSAL_GO_TO_STARRED_SHORTCUT"] = $e13bb5c64c0a0eec$export$18a9bb0de7844bb6;
module.exports["UNIVERSAL_SPACE_OVERVIEW_SHORTCUT"] = $e13bb5c64c0a0eec$export$3fe2d0f3fe115364;
module.exports["UNIVERSAL_WATCH_CONTENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$a3e38cca130cbc49;
module.exports["UNIVERSAL_WATCH_CONTENT_SHORTCUT_SAFARI"] = $e13bb5c64c0a0eec$export$a769ea2ac46f94da;
module.exports["UNIVERSAL_SHARE_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$ddfbfebfa9c821fd;
module.exports["UNIVERSAL_OPEN_DETAILS_PANEL_SHORTCUT"] = $e13bb5c64c0a0eec$export$4bc8c55d04859f5a;
module.exports["UNIVERSAL_LABELS_SHORTCUT"] = $e13bb5c64c0a0eec$export$1f53991bf9b208a0;
module.exports["UNIVERSAL_VIEW_ATTACHMENTS_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$650d7b87402f841f;
module.exports["UNIVERSAL_VIEW_ATTACHMENTS_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$dc2c2f2eed832016;
module.exports["UNIVERSAL_AI_MATE_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$1a9b1a10dcf9f02d;
module.exports["UNIVERSAL_AI_MATE_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$c252fe6b173dfad3;
module.exports["UNIVERSAL_LINK_TO_THIS_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$a1552937ff7cca64;
module.exports["UNIVERSAL_SELECT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$f7727b957c03a88b;
module.exports["UNIVERSAL_OPEN_DEVTOOLS_SHORTCUT"] = $e13bb5c64c0a0eec$export$f0043475aa91a151;
module.exports["UNIVERSAL_TOGGLE_MARKDOWN_MODE_SHORTCUT"] = $e13bb5c64c0a0eec$export$bc654500edb91b60;

});

parcelRegister("9t7Od", function(module, exports) {
const $3e354f9230625cfb$export$53fd140c96bc558 = 'https://media.staging.atl-paas.net';
module.exports["MEDIA_BASE_URL_STAGING"] = $3e354f9230625cfb$export$53fd140c96bc558;

});

parcelRegister("jln20", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lRhY3 = parcelRequire("lRhY3");


var $87whh = parcelRequire("87whh");


var $aWwYt = parcelRequire("aWwYt");

function $8facebd0ecb5e0ee$export$909966f260e2b2b({ sidebars: sidebars, setSidebars: setSidebars, triggerButtonRef: triggerButtonRef, setTriggerButtonRef: setTriggerButtonRef, hideObjectSidebar: hideObjectSidebar, hidePreviewPanel: hidePreviewPanel, isPreviewPanelOpen: isPreviewPanelOpen }) {
    const entries = sidebars.map((s, i)=>[
            s.panelId,
            i
        ]);
    const index = entries.reduce((obj, [key, val])=>{
        obj[key] = val;
        return obj;
    }, {});
    return {
        sidebars: sidebars,
        open: (panelId, width, isMinimized = false, toTop = true)=>{
            hideObjectSidebar();
            if (isPreviewPanelOpen) hidePreviewPanel();
            const newSidebars = Array.from(sidebars);
            if (panelId in index) newSidebars.splice(index[panelId], 1);
            (toTop ? Array.prototype.unshift : Array.prototype.push).call(newSidebars, {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimized: isMinimized
            });
            setSidebars(newSidebars);
        },
        close: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeAll: ()=>{
            setSidebars([]);
        },
        minimize: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars[idx].isMinimized = true;
                setSidebars(newSidebars);
            }
        },
        getCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            return idx >= 0 ? sidebars[idx] : null;
        },
        triggerButtonRef: triggerButtonRef,
        setTriggerButtonRef: setTriggerButtonRef
    };
}
function $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars) {
    if (sidebars.length === 1) return 0;
    return sidebars.findIndex((s)=>!s.isCollapsed && !s.isMinimized);
}
const $8facebd0ecb5e0ee$export$409021d56647e6f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    sidebars: [],
    open: ()=>{},
    close: ()=>{},
    closeCurrent: ()=>{},
    closeAll: ()=>{},
    minimize: ()=>{},
    getCurrent: ()=>null,
    triggerButtonRef: null,
    setTriggerButtonRef: ()=>{}
});
const $8facebd0ecb5e0ee$export$8c38c254c6602904 = ()=>{
    return (0, $cozmU.useContext)($8facebd0ecb5e0ee$export$409021d56647e6f);
};
const $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f = (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [sidebars, setSidebars] = (0, $cozmU.useState)(t1);
    const [triggerButtonRef, setTriggerButtonRef] = (0, $cozmU.useState)(null);
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { close: hidePreviewPanel } = (0, $lRhY3.usePreviewPanelsActions)();
    const isPreviewPanelOpen = (0, $87whh.useIsPreviewPanelOpen)();
    let t2;
    if ($[1] !== hideObjectSidebar || $[2] !== hidePreviewPanel || $[3] !== isPreviewPanelOpen || $[4] !== sidebars || $[5] !== triggerButtonRef) {
        t2 = $8facebd0ecb5e0ee$export$909966f260e2b2b({
            sidebars: sidebars,
            setSidebars: setSidebars,
            triggerButtonRef: triggerButtonRef,
            setTriggerButtonRef: setTriggerButtonRef,
            hideObjectSidebar: hideObjectSidebar,
            hidePreviewPanel: hidePreviewPanel,
            isPreviewPanelOpen: isPreviewPanelOpen
        });
        $[1] = hideObjectSidebar;
        $[2] = hidePreviewPanel;
        $[3] = isPreviewPanelOpen;
        $[4] = sidebars;
        $[5] = triggerButtonRef;
        $[6] = t2;
    } else t2 = $[6];
    const contextValue = t2;
    let t3;
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            const handleCloseGlobalSidebar = ()=>{
                setSidebars($8facebd0ecb5e0ee$var$_temp);
            };
            window.addEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            return ()=>{
                window.removeEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            };
        };
        t4 = [];
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[9] !== children || $[10] !== contextValue) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8facebd0ecb5e0ee$export$409021d56647e6f.Provider, {
            value: contextValue
        }, children);
        $[9] = children;
        $[10] = contextValue;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
};
function $8facebd0ecb5e0ee$var$_temp(prev) {
    return prev.length === 0 ? prev : [];
}
module.exports["useRightSidebarContext"] = $8facebd0ecb5e0ee$export$8c38c254c6602904;
module.exports["RightSidebarContextProvider"] = $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f;

});

parcelRegister("87whh", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $3Ap09 = parcelRequire("3Ap09");

const $5fad2268a70a3d3b$export$c68e55e6e77f3d5d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (panelId)=>{
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    return panelId ? context?.state.panel?.id === panelId : context?.state.panel != null;
} : (panelId)=>{
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    return panelId ? context?.state.panel?.id === panelId : context?.state.panel != null;
};
module.exports["useIsPreviewPanelOpen"] = $5fad2268a70a3d3b$export$c68e55e6e77f3d5d;

});

parcelRegister("isp1U", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $dOBRD = parcelRequire("dOBRD");


var $2A9fJ = parcelRequire("2A9fJ");

const $2def26aed08f588d$var$fetchProfileData = (0, $dOBRD.default)(async ()=>{
    const data = await (0, $2A9fJ.me)();
    return {
        aaid: data.account_id,
        name: data.name || '',
        displayName: data.nickname,
        avatarUrl: data.picture,
        email: data.email
    };
});
const $2def26aed08f588d$export$3c814b55c7cbb1fb = (0, $cozmU.createContext)(null);
const $2def26aed08f588d$var$emptyProfileData = {
    name: '',
    displayName: '',
    avatarUrl: ''
};
const $2def26aed08f588d$export$68afc71177137005 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (preFetchedProfileData)=>{
    const $ = (0, $bDgLe.c)(4);
    const [profileData, setProfileData] = (0, $cozmU.useState)($2def26aed08f588d$var$emptyProfileData);
    const profileContextData = (0, $cozmU.useContext)($2def26aed08f588d$export$3c814b55c7cbb1fb);
    let t0;
    let t1;
    if ($[0] !== preFetchedProfileData || $[1] !== profileContextData) {
        t0 = ()=>{
            if (preFetchedProfileData) setProfileData(preFetchedProfileData);
            else if (profileContextData) setProfileData(profileContextData);
            else $2def26aed08f588d$var$fetchProfileData().then((data)=>setProfileData(data)).catch(()=>setProfileData($2def26aed08f588d$var$emptyProfileData));
        };
        t1 = [
            setProfileData,
            profileContextData,
            preFetchedProfileData
        ];
        $[0] = preFetchedProfileData;
        $[1] = profileContextData;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
    return profileData;
} : (preFetchedProfileData)=>{
    const [profileData, setProfileData] = (0, $cozmU.useState)($2def26aed08f588d$var$emptyProfileData);
    const profileContextData = (0, $cozmU.useContext)($2def26aed08f588d$export$3c814b55c7cbb1fb);
    (0, $cozmU.useEffect)(()=>{
        if (preFetchedProfileData) setProfileData(preFetchedProfileData);
        else if (profileContextData) setProfileData(profileContextData);
        else $2def26aed08f588d$var$fetchProfileData().then((data)=>setProfileData(data)).catch(()=>setProfileData($2def26aed08f588d$var$emptyProfileData));
    }, [
        setProfileData,
        profileContextData,
        preFetchedProfileData
    ]);
    return profileData;
};
module.exports["useProfileController"] = $2def26aed08f588d$export$68afc71177137005;

});

parcelRegister("2A9fJ", function(module, exports) {

var $jTKfH = parcelRequire("jTKfH");

const $baf5ee02956fd5a8$export$3e32638432616b6 = async ()=>{
    const response = await (0, $jTKfH.performHttpFetch)({
        path: '/gateway/api/me',
        options: {
            method: 'GET'
        }
    });
    return response;
};
module.exports["me"] = $baf5ee02956fd5a8$export$3e32638432616b6;

});

parcelRegister("jyA9t", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $691f60820ad9b181$var$initialState = {
    showSmartCreationModal: false,
    isLoomRecorderOpen: false,
    attachedLoomVideo: null,
    submittedWithLoomAttachment: false,
    spaceKey: '',
    parentContent: {
        id: '',
        title: '',
        contentType: ''
    },
    content: undefined,
    stagingAreaActive: false,
    isFloating: false,
    shouldShowBackButton: undefined,
    entryPoint: 'confluenceUnknown',
    initialPrompt: undefined,
    initialOutcomeType: undefined,
    lockInitialOutcomeType: false,
    remixConversationId: null,
    onboardingData: undefined,
    onOnboardingSubmit: undefined,
    totalSteps: undefined,
    submitCallback: undefined,
    onCloseCallback: undefined,
    onOpenCallback: undefined,
    onSubmitCallback: undefined,
    editorInsertionAcknowledgement: undefined
};
const $691f60820ad9b181$export$e324594224ef24da = {
    openModal: ({ entryPoint: entryPoint, spaceKey: spaceKey, parentContent: parentContent, stagingAreaActive: stagingAreaActive, isFloating: isFloating, shouldShowBackButton: shouldShowBackButton, content: content, initialPrompt: initialPrompt, initialOutcomeType: initialOutcomeType, lockInitialOutcomeType: lockInitialOutcomeType, submitCallback: submitCallback, onCloseCallback: onCloseCallback, onOpenCallback: onOpenCallback, onSubmitCallback: onSubmitCallback, editorInsertionAcknowledgement: editorInsertionAcknowledgement, remixConversationId: remixConversationIdFromOpen, onboardingData: onboardingData, onOnboardingSubmit: onOnboardingSubmit, totalSteps: totalSteps })=>({ setState: setState })=>{
            const floating = isFloating ?? false;
            const remixConversationId = floating && remixConversationIdFromOpen !== undefined && remixConversationIdFromOpen !== null && remixConversationIdFromOpen !== '' ? remixConversationIdFromOpen : null;
            setState({
                showSmartCreationModal: true,
                // A fresh open is never behind the recorder; clearing here also
                // recovers if a prior recorder session left the flag stuck on.
                isLoomRecorderOpen: false,
                // A fresh open never carries a prior session's attachment.
                attachedLoomVideo: null,
                submittedWithLoomAttachment: false,
                entryPoint: entryPoint,
                spaceKey: spaceKey,
                parentContent: parentContent ?? {
                    id: '',
                    title: '',
                    contentType: ''
                },
                content: content ?? undefined,
                stagingAreaActive: stagingAreaActive ?? false,
                isFloating: floating,
                shouldShowBackButton: shouldShowBackButton ?? undefined,
                initialPrompt: initialPrompt,
                initialOutcomeType: initialOutcomeType ?? undefined,
                // Lock requires an initial outcome type — guard against misuse.
                lockInitialOutcomeType: Boolean(initialOutcomeType && lockInitialOutcomeType),
                remixConversationId: remixConversationId,
                onboardingData: onboardingData ?? undefined,
                onOnboardingSubmit: onOnboardingSubmit ?? undefined,
                totalSteps: totalSteps ?? undefined,
                submitCallback: submitCallback ?? undefined,
                onCloseCallback: onCloseCallback ?? undefined,
                onOpenCallback: onOpenCallback ?? undefined,
                onSubmitCallback: onSubmitCallback ?? undefined,
                editorInsertionAcknowledgement: editorInsertionAcknowledgement ?? undefined
            });
        },
    closeModal: ()=>({ setState: setState })=>{
            setState({
                showSmartCreationModal: false,
                isLoomRecorderOpen: false,
                attachedLoomVideo: null,
                submittedWithLoomAttachment: false,
                content: undefined,
                stagingAreaActive: false,
                isFloating: false,
                shouldShowBackButton: undefined,
                entryPoint: 'confluenceUnknown',
                initialPrompt: undefined,
                initialOutcomeType: undefined,
                lockInitialOutcomeType: false,
                remixConversationId: null,
                onboardingData: undefined,
                onOnboardingSubmit: undefined,
                onCloseCallback: undefined,
                onOpenCallback: undefined,
                onSubmitCallback: undefined,
                editorInsertionAcknowledgement: undefined
            });
        },
    setLoomRecorderOpen: (isLoomRecorderOpen)=>({ setState: setState })=>{
            setState({
                isLoomRecorderOpen: isLoomRecorderOpen
            });
        },
    setAttachedLoomVideo: (attachedLoomVideo)=>({ setState: setState })=>{
            setState({
                attachedLoomVideo: attachedLoomVideo
            });
        },
    setSubmittedWithLoomAttachment: (submittedWithLoomAttachment)=>({ setState: setState })=>{
            setState({
                submittedWithLoomAttachment: submittedWithLoomAttachment
            });
        },
    // Atomically reads-and-clears the marker from live store state (not a
    // render-lagged hook value) so the create/finalize step sees the value set
    // by the submit that immediately preceded it, and never fires twice or leaks
    // onto a later create.
    consumeSubmittedWithLoomAttachment: ()=>({ getState: getState, setState: setState })=>{
            const submitted = getState().submittedWithLoomAttachment;
            if (submitted) setState({
                submittedWithLoomAttachment: false
            });
            return submitted;
        },
    // Attaches a just-recorded Loom and forces the modal open. A recording can
    // finish after the modal was closed mid-record (reopened via global create,
    // then dismissed); the orphaned SDK "Add to prompt" callback fires here, so
    // reopening lets the attachment land on a visible modal instead of nowhere.
    attachLoomVideoAndOpenModal: (attachedLoomVideo)=>({ setState: setState })=>{
            setState({
                showSmartCreationModal: true,
                attachedLoomVideo: attachedLoomVideo
            });
        }
};
const $691f60820ad9b181$export$390f32400eaf98c9 = (0, $8s9DV.createStore)({
    initialState: $691f60820ad9b181$var$initialState,
    actions: $691f60820ad9b181$export$e324594224ef24da,
    name: 'smartCreationModalStore'
});
const $691f60820ad9b181$export$137abd744dc8b433 = (0, $kBr4q.createHook)($691f60820ad9b181$export$390f32400eaf98c9);
const $691f60820ad9b181$export$809bddce75a17b3 = (0, $kBr4q.createActionsHook)($691f60820ad9b181$export$390f32400eaf98c9);
const $691f60820ad9b181$export$46ab492df7c46301 = (0, $kBr4q.createStateHook)($691f60820ad9b181$export$390f32400eaf98c9);
module.exports["useSmartCreationModalStore"] = $691f60820ad9b181$export$137abd744dc8b433;
module.exports["useSmartCreationModalActions"] = $691f60820ad9b181$export$809bddce75a17b3;
module.exports["useSmartCreationModalState"] = $691f60820ad9b181$export$46ab492df7c46301;

});

parcelRegister("8A2GO", function(module, exports) {
const $a4d06b5ca4d94b78$export$8de5b7b1f5c5cfb7 = 'convoai.rest.pinned.conversation.limit.exceeded';
class $a4d06b5ca4d94b78$export$f2e832acab1bdd79 extends Error {
    constructor(message, errorAttributes, data){
        super(message), this.message = message, this.errorAttributes = errorAttributes;
        /** Structured, non-user-facing details supplied by the API. */ this.data = void 0;
        this.data = data;
    }
}
const $a4d06b5ca4d94b78$export$89d83cc97c52a37 = (error)=>error instanceof $a4d06b5ca4d94b78$export$f2e832acab1bdd79;
const $a4d06b5ca4d94b78$var$getRecord = (value)=>typeof value === 'object' && value !== null && !Array.isArray(value) ? value : undefined;
const $a4d06b5ca4d94b78$var$getApiErrorAttributes = (error)=>{
    if ($a4d06b5ca4d94b78$export$89d83cc97c52a37(error)) return error.errorAttributes;
    return $a4d06b5ca4d94b78$var$getRecord($a4d06b5ca4d94b78$var$getRecord(error)?.errorAttributes);
};
const $a4d06b5ca4d94b78$var$getStructuredErrorData = (error)=>{
    const errorRecord = $a4d06b5ca4d94b78$var$getRecord(error);
    return $a4d06b5ca4d94b78$var$getRecord(errorRecord?.data) ?? $a4d06b5ca4d94b78$var$getRecord($a4d06b5ca4d94b78$var$getRecord(errorRecord?.errorAttributes)?.data);
};
const $a4d06b5ca4d94b78$var$getValidCount = (value, minimum)=>typeof value === 'number' && Number.isInteger(value) && value >= minimum ? value : undefined;
const $a4d06b5ca4d94b78$export$45f7ada0fbd007df = (error)=>{
    const errorAttributes = $a4d06b5ca4d94b78$var$getApiErrorAttributes(error);
    if (errorAttributes?.errorCode !== $a4d06b5ca4d94b78$export$8de5b7b1f5c5cfb7) return undefined;
    const data = $a4d06b5ca4d94b78$var$getStructuredErrorData(error);
    if (!data) return {};
    const maxPinnedConversations = $a4d06b5ca4d94b78$var$getValidCount(data.maxPinnedConversations, 1);
    const pinnedCount = $a4d06b5ca4d94b78$var$getValidCount(data.pinnedCount, 0);
    return {
        ...maxPinnedConversations !== undefined && {
            maxPinnedConversations: maxPinnedConversations
        },
        ...pinnedCount !== undefined && {
            pinnedCount: pinnedCount
        }
    };
};
const $a4d06b5ca4d94b78$export$3c02d1a328d4d808 = (error)=>{
    if ($a4d06b5ca4d94b78$export$89d83cc97c52a37(error)) return error;
    // Fallback since we expect the error to be an instance of ApiError
    return new $a4d06b5ca4d94b78$export$f2e832acab1bdd79(error.message, {
        statusCode: 0
    });
};
module.exports["ApiError"] = $a4d06b5ca4d94b78$export$f2e832acab1bdd79;
module.exports["isApiError"] = $a4d06b5ca4d94b78$export$89d83cc97c52a37;
module.exports["getPinnedConversationLimitErrorData"] = $a4d06b5ca4d94b78$export$45f7ada0fbd007df;
module.exports["mapErrorToApiError"] = $a4d06b5ca4d94b78$export$3c02d1a328d4d808;

});

parcelRegister("5XWbo", function(module, exports) {
const $8801d8511b175030$export$e0744546db5b6189 = 'rovo_chat_sites_source_filter';
module.exports["ROVO_CHAT_SITES_SOURCE_FILTER_GATE"] = $8801d8511b175030$export$e0744546db5b6189;

});

parcelRegister("bxkJA", function(module, exports) {

var $fCunh = parcelRequire("fCunh");


var $8A2GO = parcelRequire("8A2GO");

const $c3ad42ae8c5c5089$export$f78edfe5a93b58af = (message)=>{
    return message !== null && typeof message === 'object' && '__isSSEWrapper' in message && message.__isSSEWrapper === true;
};
const $c3ad42ae8c5c5089$export$5945515082cc2cbf = 'convoai.rest.not.found';
const $c3ad42ae8c5c5089$export$c424fe9570a5f2d9 = 'ACCEPTABLE_USE_VIOLATIONS';
const $c3ad42ae8c5c5089$export$c162f3e7456e473f = [
    'rovo_default',
    'professional',
    'creative',
    'empathetic'
];
const $c3ad42ae8c5c5089$export$a461d78149e66005 = [
    'shorter',
    'neutral',
    'longer'
];
const $c3ad42ae8c5c5089$export$42a434f431015fce = [
    'less_structured',
    'neutral',
    'more_structured'
];
const $c3ad42ae8c5c5089$export$312f4aeec9b65640 = [
    'none',
    'neutral',
    'more'
];
const $c3ad42ae8c5c5089$export$f3430750c3a3992d = [
    'enabled',
    'disabled'
];
var $c3ad42ae8c5c5089$export$2e28f9aa1dcf9823 = /*#__PURE__*/ function(PromptCategory) {
    PromptCategory["ANALYZE"] = "Analyze";
    PromptCategory["BRAINSTORM"] = "Brainstorm";
    PromptCategory["REVIEW"] = "Review";
    PromptCategory["SUMMARIZE"] = "Summarize";
    PromptCategory["CREATE"] = "Create";
    PromptCategory["EXECUTE"] = "Execute";
    PromptCategory["FIND"] = "Find";
    PromptCategory["LEARN"] = "Learn";
    return PromptCategory;
}({});
var $c3ad42ae8c5c5089$export$bd1535eb0caf2683 = /*#__PURE__*/ function(PromptRole) {
    PromptRole["GENERAL"] = "General";
    PromptRole["ENGINEERING"] = "Engineering";
    PromptRole["PRODUCT"] = "Product";
    PromptRole["PROGRAM_MANAGEMENT"] = "Program Management";
    PromptRole["DESIGN"] = "Design";
    PromptRole["MARKETING"] = "Marketing";
    PromptRole["IT_OPS"] = "IT Ops";
    PromptRole["SALES"] = "Sales";
    PromptRole["CUSTOMER_SUPPORT"] = "Customer Support";
    PromptRole["HELPDESK_SUPPORT"] = "Helpdesk Support";
    PromptRole["SECURITY"] = "Security";
    return PromptRole;
}({});
const $c3ad42ae8c5c5089$export$77c9504201bdfdea = 'PROMPT_TILE';
const $c3ad42ae8c5c5089$export$7fe06c6ae176663 = 'third-party';
const $c3ad42ae8c5c5089$var$entityTypeMap = {
    person: 'Person',
    Person: 'Person',
    inferred_project: 'InferredProject',
    InferredProject: 'InferredProject'
};
const $c3ad42ae8c5c5089$export$d6de2556d50e53b4 = (message)=>({
        sentence: message.sentence,
        entities: message.entities.map((entity)=>({
                type: $c3ad42ae8c5c5089$var$entityTypeMap[entity.type],
                mention: entity.mention,
                start: entity.start,
                end: entity.end,
                ari: entity.ari,
                canonicalName: entity.canonical_name,
                confidenceScore: entity.confidence_score
            }))
    });
const $c3ad42ae8c5c5089$export$fb661125ffb29bd6 = (message)=>{
    return $c3ad42ae8c5c5089$export$a69fab2afb88c2eb(message) || $c3ad42ae8c5c5089$export$6f965deda7f0960c(message) || $c3ad42ae8c5c5089$export$b4631726cbc1440a(message);
};
const $c3ad42ae8c5c5089$export$a69fab2afb88c2eb = (message)=>message instanceof Object && message.role === 'HUMAN';
const $c3ad42ae8c5c5089$export$6f965deda7f0960c = (message)=>message instanceof Object && message.role === 'ASSISTANT';
const $c3ad42ae8c5c5089$export$1af37a4715539580 = (message)=>Boolean(message.message_metadata?.sharedFromMessageId);
const $c3ad42ae8c5c5089$export$a6e5100ca2770191 = (message)=>message instanceof Object && $c3ad42ae8c5c5089$export$6f965deda7f0960c(message.message);
const $c3ad42ae8c5c5089$export$2403e128f2e81f8f = (message)=>message instanceof Object && message.message instanceof Object;
const $c3ad42ae8c5c5089$export$5c1c15675df13ae5 = (message)=>$c3ad42ae8c5c5089$export$b4631726cbc1440a(message) && message.message?.message?.async_status === 'IN_PROGRESS';
const $c3ad42ae8c5c5089$export$b4631726cbc1440a = (message)=>message instanceof Object && message.type === 'FINAL_RESPONSE';
const $c3ad42ae8c5c5089$var$isRecord = (value)=>typeof value === 'object' && value !== null;
const $c3ad42ae8c5c5089$var$isOptionalNullableString = (value)=>value === undefined || value === null || typeof value === 'string';
const $c3ad42ae8c5c5089$export$2d3cb9d520902824 = (message)=>{
    if (!$c3ad42ae8c5c5089$var$isRecord(message) || message.type !== 'INTERACTION_CONCLUSION' || !$c3ad42ae8c5c5089$var$isRecord(message.message) || message.message.outcome !== 'SUCCEEDED' && message.message.outcome !== 'FAILED') return false;
    if (message.millisOffset !== undefined && typeof message.millisOffset !== 'number') return false;
    if (message.metadata != null && (!$c3ad42ae8c5c5089$var$isRecord(message.metadata) || !$c3ad42ae8c5c5089$var$isOptionalNullableString(message.metadata.request_id) || !$c3ad42ae8c5c5089$var$isOptionalNullableString(message.metadata.message_id))) return false;
    return true;
};
const $c3ad42ae8c5c5089$export$d422a2733a3b5def = (message)=>message instanceof Object && message.type === 'ERROR';
const $c3ad42ae8c5c5089$export$1e1cf807ece63df4 = (message)=>$c3ad42ae8c5c5089$export$d422a2733a3b5def(message) && message.message?.message_template === $c3ad42ae8c5c5089$export$c424fe9570a5f2d9;
const $c3ad42ae8c5c5089$export$e45102edbc73b240 = (message)=>message instanceof Object && message.type === 'ANSWER_PART';
const $c3ad42ae8c5c5089$var$isRawEntityAnnotation = (value)=>$c3ad42ae8c5c5089$var$isRecord(value) && (value.type === 'person' || value.type === 'Person' || value.type === 'inferred_project' || value.type === 'InferredProject') && typeof value.mention === 'string' && typeof value.start === 'number' && Number.isFinite(value.start) && typeof value.end === 'number' && Number.isFinite(value.end) && typeof value.ari === 'string' && typeof value.canonical_name === 'string' && typeof value.confidence_score === 'number' && Number.isFinite(value.confidence_score);
const $c3ad42ae8c5c5089$export$6fb760a9d35f0551 = (message)=>$c3ad42ae8c5c5089$var$isRecord(message) && message.type === 'ENTITY_ANNOTATIONS' && $c3ad42ae8c5c5089$var$isRecord(message.message) && typeof message.message.sentence === 'string' && Array.isArray(message.message.entities) && message.message.entities.every($c3ad42ae8c5c5089$var$isRawEntityAnnotation);
const $c3ad42ae8c5c5089$export$51a109436d382715 = (message)=>message instanceof Object && message.type === 'REASONING_PART';
const $c3ad42ae8c5c5089$export$dbf4211c9117b9bc = (message)=>message instanceof Object && message.type === 'ACTION_PART';
const $c3ad42ae8c5c5089$export$3d7b0b359441d5a6 = (message)=>message instanceof Object && message.type === 'ACTION_CLASSIFICATION';
const $c3ad42ae8c5c5089$export$584e11c2903f4ed6 = (message)=>message instanceof Object && message.type === 'ACTION_PREPARE';
const $c3ad42ae8c5c5089$export$7d94ce53d589f586 = (message)=>message instanceof Object && message.type === 'ACTION_COMPLETE';
const $c3ad42ae8c5c5089$var$AUTO_ACTION_APPROVAL_STATUSES = new Set([
    'REVIEWING',
    'AUTO_APPROVED',
    'AUTO_APPROVED_REQUIRES_HUMAN',
    'REQUIRES_HUMAN'
]);
const $c3ad42ae8c5c5089$var$isNullableString = (value)=>value === null || typeof value === 'string';
const $c3ad42ae8c5c5089$export$9082a8e48d820016 = (message)=>{
    if (!$c3ad42ae8c5c5089$var$isRecord(message) || message.type !== 'AUTO_ACTION_APPROVAL' || !$c3ad42ae8c5c5089$var$isRecord(message.message)) return false;
    const payload = message.message;
    const metadataIsValid = message.metadata === undefined || message.metadata === null || $c3ad42ae8c5c5089$var$isRecord(message.metadata) && (message.metadata.request_id === undefined || $c3ad42ae8c5c5089$var$isNullableString(message.metadata.request_id));
    const sequenceIdIsValid = message.sequence_id === undefined || typeof message.sequence_id === 'string';
    return typeof message.millisOffset === 'number' && Number.isFinite(message.millisOffset) && typeof payload.content === 'string' && typeof payload.status === 'string' && $c3ad42ae8c5c5089$var$AUTO_ACTION_APPROVAL_STATUSES.has(payload.status) && typeof payload.action_display_name === 'string' && typeof payload.tool_name === 'string' && $c3ad42ae8c5c5089$var$isNullableString(payload.action_key) && $c3ad42ae8c5c5089$var$isNullableString(payload.reason) && typeof payload.source === 'string' && typeof payload.risk_category === 'string' && typeof payload.policy_version === 'string' && $c3ad42ae8c5c5089$var$isNullableString(payload.model_id) && metadataIsValid && sequenceIdIsValid;
};
const $c3ad42ae8c5c5089$export$abec64f24e2ec3e7 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_START';
const $c3ad42ae8c5c5089$export$9c1f93971e9e3fbe = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH';
const $c3ad42ae8c5c5089$export$79a0ed7d987faa8f = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP';
const $c3ad42ae8c5c5089$export$7b1c8227569f1a92 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_TITLE';
const $c3ad42ae8c5c5089$export$cde91b49af35d559 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_PLAN';
const $c3ad42ae8c5c5089$export$4a6a601f69cf3c74 = (message)=>message instanceof Object && message.type === 'TODO_SNAPSHOT';
const $c3ad42ae8c5c5089$export$6b0058543411cb3a = (message)=>message instanceof Object && message.type === 'TASK_STATUS';
const $c3ad42ae8c5c5089$export$5cfcb66b0fc392d6 = (message)=>typeof message === 'object' && message !== null && 'type' in message && message.type === 'CONCIERGE_AGENT_SELECTED';
const $c3ad42ae8c5c5089$export$ac74da022f74040a = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_TITLE_SHORT';
const $c3ad42ae8c5c5089$export$7898cc38956b9052 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'SKILL_START';
const $c3ad42ae8c5c5089$export$bb608d13a1268633 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'SKILL_END';
const $c3ad42ae8c5c5089$export$b65c73c7e2d8d96f = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'FAST_MODE_RESPONSE_AVAILABLE';
const $c3ad42ae8c5c5089$export$40cf419186312161 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'FAST_MODE_ENABLED';
const $c3ad42ae8c5c5089$export$a83708fc4401682d = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'REMOVE_ANSWER_NOW';
const $c3ad42ae8c5c5089$export$68192da24ac8c141 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_SOURCE';
const $c3ad42ae8c5c5089$export$cfccfd17b68ccb0 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_COMPLETE';
const $c3ad42ae8c5c5089$export$1fd230d6956c2575 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_ICONS';
const $c3ad42ae8c5c5089$export$3bc697eeff31bdf6 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_DOCUMENT';
const $c3ad42ae8c5c5089$export$c679ee34f7312895 = (message)=>message instanceof Object && message.type === 'RECONNECT_SUPPORTED';
const $c3ad42ae8c5c5089$export$46e0fb5e4b019a49 = (message)=>message instanceof Object && message.type === 'TRACE' && (message.message.message_template === 'RESEARCH' || message.message.message_template === 'RESEARCH_STEP' || message.message.message_template === 'RESEARCH_STEP_TITLE' || message.message.message_template === 'RESEARCH_STEP_TITLE_SHORT' || message.message.message_template === 'RESEARCH_STEP_SOURCE' || message.message.message_template === 'RESEARCH_STEP_COMPLETE' || message.message.message_template === 'RESEARCH_STEP_ICONS' || message.message.message_template === 'RESEARCH_STEP_DOCUMENT');
const $c3ad42ae8c5c5089$export$6f74311d40862a9f = (message)=>message instanceof Object && message.type === 'TRACE' && ($c3ad42ae8c5c5089$export$7898cc38956b9052(message) || $c3ad42ae8c5c5089$export$bb608d13a1268633(message));
const $c3ad42ae8c5c5089$export$d95e474df0d530df = (message)=>message instanceof Object && message.type === 'TRACE' && message.message?.message_template === 'MEMORY_UPDATE';
const $c3ad42ae8c5c5089$export$fd5a05be03f147a0 = (message)=>{
    // TRACE and research steps are sharing the same type, but we want to separate them
    if ($c3ad42ae8c5c5089$export$46e0fb5e4b019a49(message)) return false;
    if ($c3ad42ae8c5c5089$export$cde91b49af35d559(message)) return false;
    if ($c3ad42ae8c5c5089$export$6f74311d40862a9f(message)) return false;
    if ($c3ad42ae8c5c5089$export$b65c73c7e2d8d96f(message)) return false;
    if ($c3ad42ae8c5c5089$export$682514f3a8131b98(message)) return false;
    return message instanceof Object && message.type === 'TRACE';
};
const $c3ad42ae8c5c5089$export$682514f3a8131b98 = (message)=>{
    return message instanceof Object && message.type === 'TRACE' && message.message?.message_template === 'THINK_DEEPER_TRIGGERED';
};
const $c3ad42ae8c5c5089$export$aeae5b4fda357302 = (message)=>message !== undefined && message !== null && typeof message === 'object' && 'type' in message && message.type === 'FOLLOW_UP_QUERIES';
const $c3ad42ae8c5c5089$export$6275ff996073145e = (message)=>{
    if (!$c3ad42ae8c5c5089$export$f78edfe5a93b58af(message) || message.eventType !== 'AGENTIC_UI') return false;
    if (message.data === null || typeof message.data !== 'object') return false;
    const data = message.data;
    return Array.isArray(data.message?.content);
};
const $c3ad42ae8c5c5089$export$b46beea5c82aa1b9 = (message)=>message instanceof Object && message.type === 'HEART_BEAT';
const $c3ad42ae8c5c5089$export$b8391261162989d9 = (message)=>$c3ad42ae8c5c5089$export$6f965deda7f0960c(message) && (message?.message_metadata?.is_action_execution ?? false) && message?.message_metadata?.action_execution_result === 'SUCCESS';
const $c3ad42ae8c5c5089$export$1060c4fa97e34fa7 = (payloadContext)=>{
    return payloadContext?.resolution?.type === 'cancel';
};
const $c3ad42ae8c5c5089$export$6ce1ccc24e75456f = (error)=>(0, $8A2GO.isApiError)(error) && error.errorAttributes?.errorCode === $c3ad42ae8c5c5089$export$5945515082cc2cbf;
const $c3ad42ae8c5c5089$export$c3c933dad2745d3f = (msg)=>msg && msg.type === 'ACTION_ERROR' && msg.message && msg.message.status === 'ERRORED';
const $c3ad42ae8c5c5089$export$bc96a6a479480590 = (error)=>(0, $8A2GO.isApiError)(error) && error.errorAttributes.statusCode === 429;
const $c3ad42ae8c5c5089$export$f8b1b75846492611 = (error)=>(0, $8A2GO.isApiError)(error) && !!error.errorAttributes.errorCode && error.errorAttributes.errorCode === (0, $fCunh.ASSISTANCE_SERVICE_ERROR_CODES).HAS_HIPAA_ENABLED;
const $c3ad42ae8c5c5089$export$d263dc5d64f36d48 = (error)=>error instanceof Object && error?.detail?.type === 'ERROR' && !!error.errorAttributes.errorCode && error.errorAttributes.errorCode === $c3ad42ae8c5c5089$export$c424fe9570a5f2d9;
const $c3ad42ae8c5c5089$export$b454081350f4a578 = (message)=>message instanceof Object && message.type === 'CONVERSATION_CHANNEL_DATA';
const $c3ad42ae8c5c5089$export$145ab74998a54a20 = (message)=>message instanceof Object && message.type === 'SCOPE_DETERMINED';
const $c3ad42ae8c5c5089$export$75ceabc5bb9500e4 = (message)=>message instanceof Object && message.type === 'SPACE_SOURCE_RECOMMENDATIONS' && message.message instanceof Object;
const $c3ad42ae8c5c5089$export$f4111656f23d9b9b = (message)=>message instanceof Object && (message.type === 'PROMPT_REDACTION' || message.type === 'PROMPT_REDACTED');
const $c3ad42ae8c5c5089$export$c43cf9ba6a2176ef = (message)=>message instanceof Object && (message.type === 'PROMPT_BLOCKED' || message.type === 'PROMPT_BLOCK');
const $c3ad42ae8c5c5089$export$f16ff8eb19967a97 = (message)=>message instanceof Object && message.type === 'RESPONSE_REDACTION';
const $c3ad42ae8c5c5089$export$55f7bd80eacbc51b = (message)=>message instanceof Object && message.type === 'RESPONSE_BLOCKED';
const $c3ad42ae8c5c5089$export$a1be74470d3c1fe9 = (message)=>message instanceof Object && message.type === 'ATTACHMENT_BLOCKED';
function $c3ad42ae8c5c5089$export$4af48296a8d61cec(payloadContext) {
    return payloadContext?.resolution?.type === 'confirm';
}
module.exports["isSSEMessage"] = $c3ad42ae8c5c5089$export$f78edfe5a93b58af;
module.exports["ACCEPTABLE_USE_VIOLATIONS_ERROR"] = $c3ad42ae8c5c5089$export$c424fe9570a5f2d9;
module.exports["RESPONSE_TONES"] = $c3ad42ae8c5c5089$export$c162f3e7456e473f;
module.exports["RESPONSE_LENGTHS"] = $c3ad42ae8c5c5089$export$a461d78149e66005;
module.exports["RESPONSE_STRUCTURES"] = $c3ad42ae8c5c5089$export$42a434f431015fce;
module.exports["RESPONSE_EMOJIS"] = $c3ad42ae8c5c5089$export$312f4aeec9b65640;
module.exports["RESPONSE_TLDR_OPTIONS"] = $c3ad42ae8c5c5089$export$f3430750c3a3992d;
module.exports["SUGGESTED_PROMPT_TILE_STREAM_MESSAGE_TYPE"] = $c3ad42ae8c5c5089$export$77c9504201bdfdea;
module.exports["THIRD_PARTY_PROMPT_SOURCE_CONTENT_TYPE"] = $c3ad42ae8c5c5089$export$7fe06c6ae176663;
module.exports["normalizeEntityAnnotationsMessage"] = $c3ad42ae8c5c5089$export$d6de2556d50e53b4;
module.exports["isHumanMessage"] = $c3ad42ae8c5c5089$export$a69fab2afb88c2eb;
module.exports["isAssistantMessage"] = $c3ad42ae8c5c5089$export$6f965deda7f0960c;
module.exports["isStreamResponse"] = $c3ad42ae8c5c5089$export$b4631726cbc1440a;
module.exports["isSharedSnapshotMessage"] = $c3ad42ae8c5c5089$export$1af37a4715539580;
module.exports["isAgentResponse"] = $c3ad42ae8c5c5089$export$a6e5100ca2770191;
module.exports["isStreamMessageWithMessage"] = $c3ad42ae8c5c5089$export$2403e128f2e81f8f;
module.exports["isInProgressStreamResponse"] = $c3ad42ae8c5c5089$export$5c1c15675df13ae5;
module.exports["isStreamInteractionConclusion"] = $c3ad42ae8c5c5089$export$2d3cb9d520902824;
module.exports["isStreamError"] = $c3ad42ae8c5c5089$export$d422a2733a3b5def;
module.exports["isStreamAUPError"] = $c3ad42ae8c5c5089$export$1e1cf807ece63df4;
module.exports["isStreamAnswerPart"] = $c3ad42ae8c5c5089$export$e45102edbc73b240;
module.exports["isStreamEntityAnnotations"] = $c3ad42ae8c5c5089$export$6fb760a9d35f0551;
module.exports["isStreamReasoningPart"] = $c3ad42ae8c5c5089$export$51a109436d382715;
module.exports["isStreamActionPart"] = $c3ad42ae8c5c5089$export$dbf4211c9117b9bc;
module.exports["isStreamActionClassification"] = $c3ad42ae8c5c5089$export$3d7b0b359441d5a6;
module.exports["isStreamActionPrepare"] = $c3ad42ae8c5c5089$export$584e11c2903f4ed6;
module.exports["isStreamActionComplete"] = $c3ad42ae8c5c5089$export$7d94ce53d589f586;
module.exports["isStreamAutoActionApproval"] = $c3ad42ae8c5c5089$export$9082a8e48d820016;
module.exports["isStreamResearchStart"] = $c3ad42ae8c5c5089$export$abec64f24e2ec3e7;
module.exports["isStreamResearchBeginningTrace"] = $c3ad42ae8c5c5089$export$9c1f93971e9e3fbe;
module.exports["isStreamResearchStepContent"] = $c3ad42ae8c5c5089$export$79a0ed7d987faa8f;
module.exports["isStreamResearchStepTitle"] = $c3ad42ae8c5c5089$export$7b1c8227569f1a92;
module.exports["isStreamResearchPlan"] = $c3ad42ae8c5c5089$export$cde91b49af35d559;
module.exports["isStreamTodoSnapshot"] = $c3ad42ae8c5c5089$export$4a6a601f69cf3c74;
module.exports["isStreamTaskStatus"] = $c3ad42ae8c5c5089$export$6b0058543411cb3a;
module.exports["isStreamConciergeAgentSelected"] = $c3ad42ae8c5c5089$export$5cfcb66b0fc392d6;
module.exports["isStreamResearchStepTitleShort"] = $c3ad42ae8c5c5089$export$ac74da022f74040a;
module.exports["isStreamSkillStart"] = $c3ad42ae8c5c5089$export$7898cc38956b9052;
module.exports["isStreamSkillEnd"] = $c3ad42ae8c5c5089$export$bb608d13a1268633;
module.exports["isStreamFastModeResponseAvailable"] = $c3ad42ae8c5c5089$export$b65c73c7e2d8d96f;
module.exports["isStreamFastModeEnabled"] = $c3ad42ae8c5c5089$export$40cf419186312161;
module.exports["isStreamRemoveAnswerNow"] = $c3ad42ae8c5c5089$export$a83708fc4401682d;
module.exports["isStreamResearchStepSource"] = $c3ad42ae8c5c5089$export$68192da24ac8c141;
module.exports["isStreamResearchStepCompleted"] = $c3ad42ae8c5c5089$export$cfccfd17b68ccb0;
module.exports["isStreamResearchStepIcons"] = $c3ad42ae8c5c5089$export$1fd230d6956c2575;
module.exports["isStreamResearchStepDocument"] = $c3ad42ae8c5c5089$export$3bc697eeff31bdf6;
module.exports["isStreamReconnectSupportPart"] = $c3ad42ae8c5c5089$export$c679ee34f7312895;
module.exports["isStreamResearchPayload"] = $c3ad42ae8c5c5089$export$46e0fb5e4b019a49;
module.exports["isStreamSkill"] = $c3ad42ae8c5c5089$export$6f74311d40862a9f;
module.exports["isStreamMemoryUpdate"] = $c3ad42ae8c5c5089$export$d95e474df0d530df;
module.exports["isStreamTrace"] = $c3ad42ae8c5c5089$export$fd5a05be03f147a0;
module.exports["isStreamThinkDeeperTriggered"] = $c3ad42ae8c5c5089$export$682514f3a8131b98;
module.exports["isFollowUpMessage"] = $c3ad42ae8c5c5089$export$aeae5b4fda357302;
module.exports["isStreamAgenticUi"] = $c3ad42ae8c5c5089$export$6275ff996073145e;
module.exports["isStreamHeartbeat"] = $c3ad42ae8c5c5089$export$b46beea5c82aa1b9;
module.exports["isActionExecutedSuccessfully"] = $c3ad42ae8c5c5089$export$b8391261162989d9;
module.exports["isActionResolutionCancelled"] = $c3ad42ae8c5c5089$export$1060c4fa97e34fa7;
module.exports["isChannelNotFoundError"] = $c3ad42ae8c5c5089$export$6ce1ccc24e75456f;
module.exports["isStreamActionError"] = $c3ad42ae8c5c5089$export$c3c933dad2745d3f;
module.exports["isRateLimitedError"] = $c3ad42ae8c5c5089$export$bc96a6a479480590;
module.exports["isHipaaError"] = $c3ad42ae8c5c5089$export$f8b1b75846492611;
module.exports["isAUPViolationError"] = $c3ad42ae8c5c5089$export$d263dc5d64f36d48;
module.exports["isConversationChannelDataMessage"] = $c3ad42ae8c5c5089$export$b454081350f4a578;
module.exports["isScopeDeterminedMessage"] = $c3ad42ae8c5c5089$export$145ab74998a54a20;
module.exports["isSpaceSourceRecommendationsMessage"] = $c3ad42ae8c5c5089$export$75ceabc5bb9500e4;
module.exports["isStreamPromptRedaction"] = $c3ad42ae8c5c5089$export$f4111656f23d9b9b;
module.exports["isStreamPromptBlock"] = $c3ad42ae8c5c5089$export$c43cf9ba6a2176ef;
module.exports["isStreamResponseRedaction"] = $c3ad42ae8c5c5089$export$f16ff8eb19967a97;
module.exports["isStreamResponseBlock"] = $c3ad42ae8c5c5089$export$55f7bd80eacbc51b;
module.exports["isStreamAttachmentBlock"] = $c3ad42ae8c5c5089$export$a1be74470d3c1fe9;
module.exports["isConfirmAction"] = $c3ad42ae8c5c5089$export$4af48296a8d61cec;

});

parcelRegister("fCunh", function(module, exports) {
const $885d54b804b288bc$export$e8114853eca81277 = 'ai-mate';
const $885d54b804b288bc$export$1106bf31edf2a9b8 = {
    AGENT_DOES_NOT_EXIST: 'errorAgentNotFound',
    USER_NOT_CREATOR: 'errorIncorrectOwner',
    AGENT_HAS_CONVERSATIONS: 'errorAgentInUse',
    AGENT_DEACTIVATED: 'convoai.rest.bad.request.archived.agent',
    AGENT_FORBIDDEN: 'convoai.rest.agent-forbidden',
    ROVO_PRODUCT_NOT_ACTIVE: 'convoai.rest.rovo.product.not.active',
    HAS_HIPAA_ENABLED: 'convoai.rest.browsing.product.has.hipaa.enabled',
    FILE_SIZE_TOO_LARGE: 'convoai.rest.bad.request.file.size.too.large'
};
const $885d54b804b288bc$export$333e4f57333eadfa = {
    UNSUPPORTED_FILE_TYPE: 415,
    FILE_RAI_POLICY_VIOLATION: 406
};
module.exports["ASSISTANCE_SERVICE_ERROR_CODES"] = $885d54b804b288bc$export$1106bf31edf2a9b8;
module.exports["STATUS_CODES"] = $885d54b804b288bc$export$333e4f57333eadfa;

});

parcelRegister("bQQtO", function(module, exports) {

var $4o0zT = parcelRequire("4o0zT");

const $c1455ae7f1250686$var$getMessageStreamHref = (product)=>{
    const backendOriginHost = window?.__backendOriginHost;
    if (product === 'confluence' && window.location.hostname === 'localhost' && typeof backendOriginHost === 'string') {
        const urlWithLocalhost = new URL(window.location.href);
        urlWithLocalhost.hostname = backendOriginHost;
        urlWithLocalhost.port = '';
        urlWithLocalhost.protocol = 'https:';
        return urlWithLocalhost.toString();
    }
    return window?.location?.href;
};
const $c1455ae7f1250686$export$d272e1989c4ab4bf = ({ browserContext: browserContext, browserContextSanitizer: browserContextSanitizer, product: product })=>{
    const browserContextUrl = browserContext?.context?.browserUrl;
    const isBrowserContextBlocklisted = Boolean(browserContextUrl && browserContextSanitizer?.isBlocklisted(browserContextUrl));
    const isBrowserUrlSuppressed = browserContextUrl === 'NO-URL' && (0, $4o0zT.isExperimentEnabled)('jira_free_gen_editor');
    if (isBrowserContextBlocklisted || isBrowserUrlSuppressed) return {
        browserUrl: '',
        isBrowserContextBlocklisted: isBrowserContextBlocklisted
    };
    return {
        browserUrl: browserContextUrl || $c1455ae7f1250686$var$getMessageStreamHref(product) || '',
        isBrowserContextBlocklisted: isBrowserContextBlocklisted
    };
};
module.exports["resolveMessageStreamBrowserUrl"] = $c1455ae7f1250686$export$d272e1989c4ab4bf;

});

parcelRegister("7td41", function(module, exports) {
const $00fdf2622c1683af$export$11cc4786742ed7c2 = ()=>{
    const date = new Date();
    const formattedDate = date.toLocaleDateString(undefined, {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit'
    });
    const formattedTime = date.toLocaleTimeString(undefined, {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    });
    const name = `${formattedDate} ${formattedTime}`;
    return name;
};
module.exports["generateConversationName"] = $00fdf2622c1683af$export$11cc4786742ed7c2;

});

parcelRegister("bkEBw", function(module, exports) {

var $bxkJA = parcelRequire("bxkJA");


var $3PJhM = parcelRequire("3PJhM");

const $ac118120c3114919$export$218c8c3169c024d2 = (streamResponse)=>streamResponse.message.message.id;
const $ac118120c3114919$var$addAnswerPartAssistantMessage = (response, answerPart)=>{
    const content = `${response.content}${answerPart.message.content}`;
    // Remove source indexes, e.g [^1^] from the content
    const cleanedContent = content.replace(/\[\^\d+\^\]/g, '');
    return {
        ...response,
        content: cleanedContent
    };
};
const $ac118120c3114919$var$addAnswerPartAgentResponse = (response, answerPart)=>({
        ...response,
        message: $ac118120c3114919$var$addAnswerPartAssistantMessage(response.message, answerPart)
    });
// ****************************************************************************
// Action streaming accumulation configuration
// ****************************************************************************
const $ac118120c3114919$var$toPathArr = (path)=>Array.isArray(path) ? path : path.split('.').filter(Boolean);
const $ac118120c3114919$var$getAtPath = (obj, path)=>{
    let cur = obj;
    for (const key of path){
        if (!(0, $3PJhM.isRecord)(cur)) return undefined;
        cur = cur[key];
    }
    return cur;
};
const $ac118120c3114919$var$setAtPath = (obj, path, value)=>{
    if (path.length === 0) return value;
    const [head, ...rest] = path;
    const base = (0, $3PJhM.isRecord)(obj) ? obj : {};
    return {
        ...base,
        [head]: $ac118120c3114919$var$setAtPath(base[head], rest, value)
    };
};
// Defines which sub-field(s) of a message action's data should be accumulated by string appending.
// Keyed by action key. Values can be a dot path or an array path, or an array of multiple paths.
// E.g.:
// {
//   'create-document-action': 'content',
//   'update-document-action': ['content', 'meta.subtitle']
// }
let $ac118120c3114919$var$actionDataAccumulationConfig = {
    ['aifc-confluence-page-create']: 'adf'
};
const $ac118120c3114919$export$a1715e22f3105088 = (prev, next)=>{
    const key = next.key;
    const rulePaths = $ac118120c3114919$var$actionDataAccumulationConfig[key];
    const prevData = prev?.data;
    const newData = next?.data;
    if (rulePaths && typeof prevData === 'object' && prevData !== null && typeof newData === 'object' && newData !== null) {
        const paths = Array.isArray(rulePaths) ? rulePaths : [
            rulePaths
        ];
        let base = {
            ...newData
        };
        for (const p of paths){
            const pathArr = $ac118120c3114919$var$toPathArr(p);
            const prevVal = $ac118120c3114919$var$getAtPath(prevData, pathArr);
            const nextVal = $ac118120c3114919$var$getAtPath(newData, pathArr);
            const accumulated = String(prevVal ?? '') + String(nextVal ?? '');
            const updated = $ac118120c3114919$var$setAtPath(base, pathArr, accumulated);
            // `setAtPath` only returns the raw `value` when the path is empty; here
            // `pathArr` is always non-empty (derived from a configured rule path), so
            // the result is always the spread record branch.
            if ((0, $3PJhM.isRecord)(updated)) base = updated;
        }
        return {
            ...prev,
            data: base,
            status: next.status
        };
    }
    // Default: replace only data from next, keep other fields from prev
    return {
        ...prev,
        data: next.data,
        status: next.status
    };
};
const $ac118120c3114919$export$6554ad578994a75f = (actions, actionPart, actionUpdaterOverride)=>{
    const { key: key, invocationId: invocationId } = actionPart.message;
    // Accumulate by `invocationId` when the part has one, so multiple same-`key` actions (e.g. several
    // page creates in a single message) stream independently; fall back to `key` for parts without an
    // invocationId. For single-action messages both resolve to the same action, so no experiment gate
    // is needed here.
    const existingActionIndex = invocationId ? actions.findIndex((action)=>action.invocationId === invocationId) : actions.findIndex((action)=>action.key === key);
    if (existingActionIndex === -1) return [
        ...actions || [],
        actionPart.message
    ];
    const updatedActions = [
        ...actions
    ];
    const prevAction = updatedActions[existingActionIndex];
    const nextAction = actionPart.message;
    updatedActions[existingActionIndex] = actionUpdaterOverride ? actionUpdaterOverride(prevAction, nextAction) : $ac118120c3114919$export$a1715e22f3105088(prevAction, nextAction);
    return updatedActions;
};
const $ac118120c3114919$export$6e5609c05ab74cc7 = (response, answerPart)=>({
        ...response,
        message: $ac118120c3114919$var$addAnswerPartAgentResponse(response.message, answerPart)
    });
const $ac118120c3114919$export$13b6a4e4e3704011 = (response, actionPart, actionUpdaterOverride)=>{
    const { message: message } = response.message;
    const { actions: actions } = message;
    const isActionsArrayPresent = actions && actions.length > 0;
    return {
        ...response,
        message: {
            ...response.message,
            message: {
                ...message,
                actions: !isActionsArrayPresent ? [
                    actionPart.message
                ] : $ac118120c3114919$export$6554ad578994a75f(actions, actionPart, actionUpdaterOverride)
            }
        }
    };
};
const $ac118120c3114919$var$removeSensitiveDataAssistantMessage = (message)=>{
    const { plugin_invocations: plugin_invocations, ...rest } = message;
    return {
        ...rest,
        plugin_invocations: plugin_invocations.map((pluginInvocation)=>({
                ...pluginInvocation,
                plugin_output: '--PRIVATE--'
            }))
    };
};
const $ac118120c3114919$var$removeSensitiveDataAgentResponse = (message)=>({
        ...message,
        message: $ac118120c3114919$var$removeSensitiveDataAssistantMessage(message.message)
    });
const $ac118120c3114919$export$efd4f6b5d168b654 = (message)=>({
        ...message,
        message: $ac118120c3114919$var$removeSensitiveDataAgentResponse(message.message)
    });
const $ac118120c3114919$export$4c47ae95c311c518 = '00000000-0000-0000-0000-000000000000';
const $ac118120c3114919$export$4010f996e89e886a = (id, content, isFromSeededConversation, requestId, fileUploads, displayContext)=>{
    return {
        role: 'HUMAN',
        id: id,
        content: content,
        time_created: new Date().toISOString(),
        user_ari: 'unknown',
        plugin_invocations: [],
        isFromSeededConversation: isFromSeededConversation,
        requestId: requestId,
        file_uploads: fileUploads,
        ...displayContext ? {
            display_context: displayContext
        } : {}
    };
};
const $ac118120c3114919$export$3220a4ff7b3a96df = (message)=>{
    if ((0, $bxkJA.isAgentResponse)(message)) return {
        type: 'FINAL_RESPONSE',
        message: message
    };
    return {
        type: 'FINAL_RESPONSE',
        message: {
            message: message
        }
    };
};
module.exports["getId"] = $ac118120c3114919$export$218c8c3169c024d2;
module.exports["addAnswerPart"] = $ac118120c3114919$export$6e5609c05ab74cc7;
module.exports["addActionPart"] = $ac118120c3114919$export$13b6a4e4e3704011;
module.exports["removeSensitiveData"] = $ac118120c3114919$export$efd4f6b5d168b654;
module.exports["NO_PARENT_MESSAGE_ID"] = $ac118120c3114919$export$4c47ae95c311c518;
module.exports["createHumanMessage"] = $ac118120c3114919$export$4010f996e89e886a;
module.exports["toStreamResponse"] = $ac118120c3114919$export$3220a4ff7b3a96df;

});

parcelRegister("9DPMp", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ // `./jsonTransformer` is a deprecated re-export shim (VOLTC-139); import from here instead.

var $2lPWP = parcelRequire("2lPWP");


var $2AUaD = parcelRequire("2AUaD");


var $aPdNQ = parcelRequire("aPdNQ");


var $3u5lg = parcelRequire("3u5lg");


var $bjg0G = parcelRequire("bjg0G");


var $3cHXJ = parcelRequire("3cHXJ");


var $h2a2b = parcelRequire("h2a2b");

/**
 * If the first node is a paragraph we need to wrap it in a paragraph node for the markdown conversion to work properly
 */ function $b6f242e395dcdf98$var$createTextWrapper(editorView, fragment) {
    const { schema: schema } = editorView.state;
    const { $from: $from } = editorView.state.selection;
    const parent = (0, $bjg0G.findParentNodeClosestToPos)($from, (node)=>{
        return node.type.name === 'paragraph' || node.type.name === 'heading';
    })?.node;
    if (parent) return schema.nodes.doc.createChecked(null, schema.nodes[parent.type.name].createChecked(parent.attrs, fragment));
    else // If the node is a paragraph we need the parent to be a doc for the conversion to work correctly
    return schema.nodes.doc.createChecked(null, schema.nodes.paragraph.createChecked(null, fragment));
}
/**
 * This finds the closest list item parent to the current selection
 * Once found it will create a new list with the current fragment as its children
 */ function $b6f242e395dcdf98$var$createListItemWrapper(editorView, fragment) {
    const { schema: schema } = editorView.state;
    const { $from: $from } = editorView.state.selection;
    const parent = (0, $bjg0G.findParentNodeClosestToPos)($from, (node)=>node.type.name === 'bulletList' || node.type.name === 'orderedList')?.node;
    if (parent) return schema.nodes[parent.type.name].createChecked(parent.attrs, fragment);
    return fragment;
}
/**
 * If the first node is a task item we need to wrap it in a task list node for the markdown conversion to work properly
 */ function $b6f242e395dcdf98$var$createTaskItemWrapper(schema, fragment) {
    return schema.nodes.doc.createChecked(null, schema.nodes.taskList.createChecked(null, fragment));
}
function $b6f242e395dcdf98$var$createLayoutColumnWrapper(editorView, fragment) {
    const { schema: schema } = editorView.state;
    const parentSection = (0, $bjg0G.findParentNodeOfType)(schema.nodes.layoutSection)(editorView.state.selection);
    if (parentSection) // Needs to be a doc for the serializer to work as it
    // loops through the fragments children to render
    return schema.nodes.doc.createChecked(null, schema.nodes.layoutSection.createChecked(parentSection.node.attrs, fragment));
    return fragment;
}
function $b6f242e395dcdf98$var$isPMNode(node) {
    return 'type' in node;
}
/**
 * Sanitizes one top-level child via the canonical ProseMirror -> ADF transform (`JSONTransformer`),
 * e.g. renaming `panel_c1` back to `panel`. Only reconstructs the node if sanitizing actually
 * changed something, since rebuilding via JSON allocates new Mark instances that can otherwise
 * change mark-continuation behaviour (e.g. across a hardBreak) for content that didn't need it.
 * Falls back to the original node if sanitizing/rebuilding throws (some ProseMirror node shapes,
 * e.g. a test-only `unsupportedBlock` with no `originalValue`, can't round-trip through ADF JSON).
 */ function $b6f242e395dcdf98$var$sanitizeChildForMarkdown(child, transformer, schema) {
    try {
        const sanitizedJSON = transformer.encodeNode(child);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(sanitizedJSON, (0, $2AUaD.toJSON)(child))) return child;
        return schema.nodeFromJSON(sanitizedJSON);
    } catch  {
        return child;
    }
}
/**
 * Normalises ProseMirror-only schema constructs (e.g. `panel_c1`) to their ADF-equivalent shape
 * before markdown serialization, so they don't hit the "Token type ... not supported" fallback.
 * Gated by `markdownPlusSanitizeProseMirrorOnlyNodes`; a no-op otherwise.
 */ function $b6f242e395dcdf98$var$sanitizeForMarkdown(node, featureToggles) {
    if (!featureToggles.markdownPlusSanitizeProseMirrorOnlyNodes) return node;
    const firstChild = node.firstChild;
    if (!firstChild) return node;
    const schema = firstChild.type.schema;
    const transformer = new (0, $2lPWP.JSONTransformer)(schema);
    let anyChildChanged = false;
    const sanitizedChildren = [];
    node.forEach((child)=>{
        const sanitizedChild = $b6f242e395dcdf98$var$sanitizeChildForMarkdown(child, transformer, schema);
        anyChildChanged = anyChildChanged || sanitizedChild !== child;
        sanitizedChildren.push(sanitizedChild);
    });
    // Nothing needed sanitizing - keep the original node/fragment (and its child object identity)
    // rather than reconstructing an equivalent copy.
    if (!anyChildChanged) return node;
    const sanitizedFragment = (0, $aPdNQ.Fragment).fromArray(sanitizedChildren);
    return $b6f242e395dcdf98$var$isPMNode(node) ? node.copy(sanitizedFragment) : sanitizedFragment;
}
/**
 * This function handles partial selections and it will fix any incomplete fragments that won't be converted properly
 * If you do a partial selection, it will not select the parent node of certain nodes text, listItems etc so once it hits the serializer
 * the serializer will just fallback to plain text and not convert the node properly.
 *
 * This function checks the first child of the current selection, if its a node that needs a parent it will find the closest parent
 * and create a new fragment that will be converted properly by the serializer
 */ function $b6f242e395dcdf98$var$checkFragment(editorView, schema, fragment) {
    switch(fragment?.firstChild?.type?.name){
        case 'text':
            return $b6f242e395dcdf98$var$createTextWrapper(editorView, fragment);
        case 'listItem':
            return $b6f242e395dcdf98$var$createListItemWrapper(editorView, fragment);
        case 'taskItem':
            return $b6f242e395dcdf98$var$createTaskItemWrapper(schema, fragment);
        case 'layoutColumn':
            return $b6f242e395dcdf98$var$createLayoutColumnWrapper(editorView, fragment);
        default:
            return fragment;
    }
}
function $b6f242e395dcdf98$export$cc6cac500a4da966({ editorView: editorView, fragment: fragment, featureToggles: featureToggles = {}, mentionMap: mentionMap = {}, idMap: idMap = {} }) {
    fragment = $b6f242e395dcdf98$var$checkFragment(editorView, editorView.state.schema, fragment);
    return $b6f242e395dcdf98$export$3d24004275aefeab({
        node: fragment,
        featureToggles: featureToggles,
        mentionMap: mentionMap,
        idMap: idMap
    });
}
function $b6f242e395dcdf98$export$3d24004275aefeab({ node: node, featureToggles: featureToggles = {}, mentionMap: mentionMap = {}, idMap: idMap = {} }) {
    const sanitizedNode = $b6f242e395dcdf98$var$sanitizeForMarkdown(node, featureToggles);
    const markdownSerializerState = new (0, $h2a2b.MarkdownSerializerState)(featureToggles, mentionMap, idMap);
    markdownSerializerState.renderContent(sanitizedNode);
    const pmStats = new (0, $3cHXJ.ProseMirrorContentStatistics)(sanitizedNode);
    const contentStatistics = pmStats.collectStatistics();
    const markdown = markdownSerializerState.out === '\u200c' ? '' : markdownSerializerState.out;
    return {
        markdown: markdown,
        fallbackState: markdownSerializerState.fallbackState,
        nonErrorFallbackState: markdownSerializerState.nonErrorFallbackState,
        idMap: markdownSerializerState.idMap,
        contentStatistics: contentStatistics
    };
}
module.exports["convertProsemirrorToMarkdown"] = $b6f242e395dcdf98$export$cc6cac500a4da966;
module.exports["convertProsemirrorNodeToMarkdown"] = $b6f242e395dcdf98$export$3d24004275aefeab;

});

parcelRegister("3cHXJ", function(module, exports) {

var $aPdNQ = parcelRequire("aPdNQ");

class $c4cbf946cacc0222$export$acf14785d7d5b1be {
    /**
   * Calculate statistics for the ProseMirror content such as node counts, mark counts and total character count.
   */ collectStatistics() {
        const { nodeCounts: nodeCounts, markCounts: markCounts, linksCount: linksCount, mentionsCount: mentionsCount } = this.countNodesAndMarks();
        const { totalCharacterCount: totalCharacterCount } = this.calculateCharacterCounts();
        return {
            nodeCounts: nodeCounts,
            markCounts: markCounts,
            linksCount: linksCount,
            mentionsCount: mentionsCount,
            totalCharacterCount: totalCharacterCount,
            contextSelectionScope: undefined
        };
    }
    countNodesAndMarks() {
        const nodeCounts = new Map();
        const markCounts = new Map();
        let linksCount = 0;
        let mentionsCount = 0;
        this.content.descendants((node)=>{
            nodeCounts.set(node.type.name, (nodeCounts.get(node.type.name) || 0) + 1);
            const marks = node.marks;
            marks.forEach((mark)=>{
                markCounts.set(mark.type.name, (markCounts.get(mark.type.name) || 0) + 1);
            });
            const { nodes: { inlineCard: inlineCard, mention: mention }, marks: { link: link } } = node.type.schema;
            if (node.type === mention) mentionsCount++;
            if (node.type === inlineCard && node.attrs.url) linksCount++;
            if (marks.find((mark)=>mark.type === link)) linksCount++;
        });
        return {
            nodeCounts: Object.fromEntries(nodeCounts),
            markCounts: Object.fromEntries(markCounts),
            linksCount: linksCount,
            mentionsCount: mentionsCount
        };
    }
    calculateCharacterCounts() {
        let allTextContent = '';
        if (this.content instanceof (0, $aPdNQ.Node)) allTextContent = this.content.textContent;
        else this.content.forEach((child)=>{
            allTextContent += child.textContent;
        });
        return {
            totalCharacterCount: allTextContent.length
        };
    }
    constructor(content){
        this.content = void 0;
        this.content = content;
    }
}
module.exports["ProseMirrorContentStatistics"] = $c4cbf946cacc0222$export$acf14785d7d5b1be;

});

parcelRegister("h2a2b", function(module, exports) {

var $2jzwX = parcelRequire("2jzwX");


var $aPdNQ = parcelRequire("aPdNQ");


var $9bzIP = parcelRequire("9bzIP");


var $9t7Od = parcelRequire("9t7Od");


var $jOZYJ = parcelRequire("jOZYJ");


var $2MdWj = parcelRequire("2MdWj");

// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $63a440ce8b406510$var$AT_BLANK_REGEX = /(^|\n)$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $63a440ce8b406510$var$TRAILING_WHITESPACE_REGEX = /\s+$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $63a440ce8b406510$var$INLINE_WHITESPACE_REGEX = /^(\s*)(.*?)(\s*)$/m;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $63a440ce8b406510$var$LEADING_BACKTICK_REGEX = /^`/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $63a440ce8b406510$var$TRAILING_BACKTICK_REGEX = /`$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $63a440ce8b406510$var$FOUR_SPACES_REGEX = /^\s{4}/;
const $63a440ce8b406510$export$1c401dbe379e8c65 = (()=>{
    function getMaxLength(text) {
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const matches = text.match(/`+/g) || [];
        return matches.reduce((prev, val)=>val.length > prev.length ? val : prev, '').length;
    }
    return function(text, minLength = 1) {
        const length = Math.max(minLength, getMaxLength(text) + 1);
        return (0, $2MdWj.stringRepeat)('`', length);
    };
})();
class $63a440ce8b406510$export$61055fa707e69319 extends (0, $2jzwX.MarkdownSerializerState) {
    /**
   *
   * @param state: MarkdownSerializerState
   * @param targetType: string
   * @param targetAttributes: Record<string, unknown>
   * @returns id of the state if the state is found in the idMap, otherwise returns null
   */ findStateIdMap(state, targetType, targetAttributes) {
        // eslint-disable-next-line guard-for-in
        for(const key in state.idMap){
            const { type: type, attributes: attributes } = state.idMap[key];
            // Check type first for early exit
            if (type !== targetType) continue;
            // Check if attributes match
            let attributesMatch = true;
            for(const attrKey in targetAttributes)// localId is a special attribute that is used to identify the node in the markdown and should be ignored on match
            if (attrKey !== 'localId' && targetAttributes[attrKey] !== attributes[attrKey]) {
                attributesMatch = false;
                break; // No need to check other attributes
            }
            if (attributesMatch) return key;
        }
        return null;
    }
    /**
   *
   * @param state: MarkdownSerializerState
   * @param type: string
   * @param attributes: Record<string, unknown>
   * @returns `id-[id]idMap` if the id is not found in the state
   */ getIdBasedOnIdMap(state, type, attributes) {
        const id = state.findStateIdMap(state, type, attributes);
        if (id) return id;
        return `id-${state.idCounter++}`;
    }
    updateFallbackState(error, child) {
        if (error instanceof Error) {
            const childTypeName = child.type.name;
            const errorMessage = error.message;
            const childFallbackState = this.fallbackState?.[childTypeName];
            Object.assign(this.fallbackState, {
                [childTypeName]: {
                    ...childFallbackState,
                    [errorMessage]: (childFallbackState?.[errorMessage] || 0) + 1
                }
            });
        } else throw error;
    }
    updateNonErrorFallbackState(node) {
        Object.assign(this.nonErrorFallbackState, {
            [node.type.name]: (this.nonErrorFallbackState[node.type.name] || 0) + 1
        });
    }
    /**
   * Defines the internal atBlank method used in the markdown serializer
   * @see https://github.com/ProseMirror/prosemirror-markdown/blob/master/src/to_markdown.ts#L241
   */ atBlank() {
        return $63a440ce8b406510$var$AT_BLANK_REGEX.test(this.out);
    }
    /**
   * Defines the internal flushClose method used in the markdown serializer
   * @see https://github.com/ProseMirror/prosemirror-markdown/blob/master/src/to_markdown.ts#L202
   */ flushClose(size = 2) {
        if (this.closed) {
            if (!this.atBlank()) this.out += '\n';
            if (size > 1) {
                let delimMin = this.delim;
                const trim = $63a440ce8b406510$var$TRAILING_WHITESPACE_REGEX.exec(delimMin);
                if (trim) delimMin = delimMin.slice(0, delimMin.length - trim[0].length);
                for(let i = 1; i < size; i++)this.out += delimMin + '\n';
            }
            this.closed = null;
        }
    }
    /**
   * This method overide adds support for "options"
   * options is an object that can be used to pass additional information to the node serializer
   *
   * This is useful when a grandparent node has information that needs to be passed to a grandchild node
   *
   * For example, a table node has information about whether or not the table has a header row
   * This information needs to be passed to the tableRow and tableCell node serializers so that it can render the correct markdown
   * @see MarkdownSerializerState.render()
   */ render(node, parent, index, options) {
        if (!this.nodes[node.type.name]) throw new Error(`Token type \`${node.type.name}\` not supported by Markdown renderer`);
        if (options?.skipFallback) this.nodes[node.type.name].serialize({
            state: this,
            node: node,
            parent: parent,
            index: index,
            options: options
        });
        else try {
            this.nodes[node.type.name].serialize({
                state: this,
                node: node,
                parent: parent,
                index: index,
                options: options
            });
        } catch (error) {
            this.updateFallbackState(error, node);
            return this.nodes.fallback.serialize({
                state: this,
                node: node,
                parent: parent,
                index: index
            });
        }
    }
    renderContent(parent) {
        parent.forEach((child, _offset, index)=>{
            if (// If child is an empty Textblock we need to insert a zwnj-character in order to preserve that line in markdown
            child.isTextblock && !child.textContent && // If child is a Codeblock we need to handle this separately as we want to preserve empty code blocks
            !(child.type.name === 'codeBlock') && !(child.content && child.content.size > 0)) return this.nodes.empty_line.serialize({
                state: this,
                node: child,
                parent: parent,
                index: index
            });
            try {
                return this.render(child, parent, index);
            } catch (error) {
                this.updateFallbackState(error, child);
                return this.nodes.fallback.serialize({
                    state: this,
                    node: child,
                    parent: parent,
                    index: index
                });
            }
        });
    }
    /**
   * This method override will properly escape backticks in text nodes with "code" mark enabled.
   * Bitbucket uses python-markdown which does not honor escaped backtick escape sequences \`
   * inside a backtick fence.
   *
   * @see MarkdownSerializerState.renderInline()
   */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    renderInline(parent, options) {
        const active = [];
        let trailing = '';
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const progress = (node, _, index)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            let marks = node ? node.marks.filter((mark)=>this.marks[mark.type.name]) : [];
            let leading = trailing;
            trailing = '';
            // If whitespace has to be expelled from the node, adjust
            // leading and trailing accordingly.
            if (node && node.isText && marks.some((mark)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const info = this.marks[mark.type.name];
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return info && info.expelEnclosingWhitespace;
            })) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const [, lead, inner, trail] = $63a440ce8b406510$var$INLINE_WHITESPACE_REGEX.exec(node.text);
                leading += lead;
                trailing = trail;
                if (lead || trail) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    node = inner ? node.withText(inner) : null;
                    if (!node) marks = active;
                }
            }
            const code = marks.length && marks[marks.length - 1].type.name === 'code' && marks[marks.length - 1];
            const len = marks.length - (code ? 1 : 0);
            // Try to reorder 'mixable' marks, such as em and strong, which
            // in Markdown may be opened and closed in different order, so
            // that order of the marks for the token matches the order in
            // active.
            // eslint-disable-next-line no-labels
            outer: for(let i = 0; i < len; i++){
                const mark = marks[i];
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                if (!this.marks[mark.type.name].mixable) break;
                for(let j = 0; j < active.length; j++){
                    const other = active[j];
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    if (!this.marks[other.type.name].mixable) break;
                    if (mark.eq(other)) {
                        if (i > j) marks = marks.slice(0, j).concat(mark).concat(marks.slice(j, i)).concat(marks.slice(i + 1, len));
                        else if (j > i) marks = marks.slice(0, i).concat(marks.slice(i + 1, j)).concat(mark).concat(marks.slice(j, len));
                        continue outer;
                    }
                }
            }
            // Find the prefix of the mark set that didn't change
            let keep = 0;
            while(keep < Math.min(active.length, len) && marks[keep].eq(active[keep]))++keep;
            // Close the marks that need to be closed
            while(keep < active.length)// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.text(this.markString(active.pop(), false, parent, index), false);
            // Output any previously expelled trailing whitespace outside the marks
            if (leading) this.text(leading);
            // Open the marks that need to be opened
            while(active.length < len){
                const add = marks[active.length];
                active.push(add);
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                this.text(this.markString(add, true, parent, index), false);
            }
            if (node) {
                if (!code || !node.isText) // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                this.render(node, parent, index);
                else if (node.text) {
                    // Generate valid monospace, fenced with series of backticks longer that backtick series inside it.
                    let text = node.text;
                    const backticks = $63a440ce8b406510$export$1c401dbe379e8c65(node.text, 1);
                    // Make sure there is a space between fences, otherwise python-markdown renderer will get confused
                    if (text.match($63a440ce8b406510$var$LEADING_BACKTICK_REGEX)) text = ' ' + text;
                    if (text.match($63a440ce8b406510$var$TRAILING_BACKTICK_REGEX)) text += ' ';
                    this.text(backticks + text + backticks, false);
                }
            }
        };
        parent.forEach((child, _offset, index)=>{
            if (options?.skipFallback) progress(child, parent, index);
            else try {
                progress(child, parent, index);
            } catch (error) {
                this.updateFallbackState(error, child);
            }
        });
        progress(null);
    }
    addBlockMarks(state, node, renderFunction) {
        const closingTags = [];
        // This is temporary, only adding the marks that we support, once we get full support this will be removed
        const markFilters = [
            'alignment',
            'breakout',
            'border'
        ];
        const marks = node.marks.filter((mark)=>markFilters.includes(mark.type.name));
        if (marks.length === 0) {
            renderFunction();
            return;
        }
        marks.forEach((mark)=>{
            const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, mark.type.name, mark.attrs) : `id-${state.idCounter++}`;
            state.idMap[id] = {
                type: mark.type.name,
                attributes: mark.attrs
            };
            state.write(`<custom data-type="${mark.type.name}_open" data-id="${id}" />\n\n`);
            closingTags.unshift(`<custom data-type="${mark.type.name}_close" />\n\n`);
        });
        renderFunction();
        state.write(closingTags.join(''));
    }
    constructor(featureToggles, mentionMap, idMap){
        // @ts-ignore -next-line
        super($63a440ce8b406510$export$695720b7e7a61533, $63a440ce8b406510$export$3a8025f2f3e0c64, {});
        // ignoring as generated types for node serializer is inaccurate
        // parent and index in node serializers should be optional
        // Typing this as a string -- to override the PMMarkdownSerializerState type of any
        // In the confluence build -- this results in the out property being set to undefined in the constructor
        // whereas in the dev server this is stripped when the code is transpiled.
        // When it is used in transpilation -- "undefined" is added to the start of the generated text
        // out: string;
        this.idMap = {};
        this.idCounter = 0;
        this.nodes = void 0;
        this.marks = void 0;
        this.featureToggles = {};
        this.mentionMap = {};
        /**
     * Defines the internal variables used in the markdown serializer
     * @see https://github.com/ProseMirror/prosemirror-markdown/blob/master/src/to_markdown.ts#L172
     */ this.delim = '';
        this.out = '';
        this.closed = null;
        /**
     * This is used to track the number of times a node has failed to render
     * This is useful for debugging purposes
     * - the key is the node type name
     * - the value is an object with
     *   - the error message as the key
     *   - and the number of times it has failed to render with that message as the value.
     */ this.fallbackState = {};
        /**
     * This is used to track the number of times a node has rendered
     * but has not completely converted to markdown
     * For example: Tables are supported in markdown, however we currently do not have full support
     * So we fallback to the simplest version of the node that our serializer can support
     */ this.nonErrorFallbackState = {};
        this.context = {
            insideTable: false
        };
        this.nodes = $63a440ce8b406510$export$695720b7e7a61533;
        this.marks = $63a440ce8b406510$export$3a8025f2f3e0c64;
        this.featureToggles = featureToggles || {};
        this.mentionMap = mentionMap || {};
        this.idMap = idMap || {};
        this.idCounter = Object.keys(this.idMap).length;
    }
}
const $63a440ce8b406510$var$editorNodes = {
    blockquote: {
        serialize ({ state: state, node: node }) {
            state.wrapBlock('> ', null, node, ()=>state.renderContent(node));
        },
        support: 'full'
    },
    codeBlock: {
        serialize ({ state: state, node: node }) {
            const backticks = $63a440ce8b406510$export$1c401dbe379e8c65(node.textContent, 3);
            state.write(backticks + (node.attrs.language || '') + '\n');
            state.text(node.textContent ? node.textContent : '\u200c', false);
            state.ensureNewLine();
            state.write(backticks);
            state.closeBlock(node);
        },
        support: 'full'
    },
    heading: {
        serialize ({ state: state, node: node }) {
            state.write(state.repeat('#', node.attrs.level) + ' ');
            state.renderInline(node);
            state.closeBlock(node);
        },
        support: 'full'
    },
    rule: {
        serialize ({ state: state, node: node }) {
            state.write(node.attrs.markup || '---');
            state.closeBlock(node);
        },
        support: 'full'
    },
    bulletList: {
        serialize ({ state: state, node: node }) {
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        support: 'full'
    },
    orderedList: {
        serialize ({ state: state, node: node }) {
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        support: 'full'
    },
    listItem: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            const order = (0, $jOZYJ.getOrderFromMaybeOrderedListNode)(parent);
            const delimiter = parent.type.name === 'bulletList' ? '* ' : `${order + index}. `;
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                // if at second child or more of list item, add a newline
                if (i > 0) state.write('\n');
                // if at first child of list item, add delimiter (e.g "1.").
                // if at second child or more of list item, only add spacing (not delimiter)
                if (i === 0) state.wrapBlock('  ', delimiter, node, ()=>state.render(child, parent, i));
                else state.wrapBlock('    ', null, node, ()=>state.render(child, parent, i));
                if (child.type.name === 'paragraph' && i > 0) state.write('\n');
                state.flushClose(1);
            }
            // if we're at the final list item, add a final closing newline
            if (index === parent.childCount - 1) state.write('\n');
        },
        support: 'full'
    },
    taskList: {
        serialize ({ state: state, node: node }) {
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
                state.write('\n');
            }
            state.write('\n');
        },
        support: 'full'
    },
    taskItem: {
        serialize ({ state: state, node: node }) {
            const taskItemState = node.attrs.state;
            state.write(taskItemState === 'TODO' ? '- [ ] ' : '- [x] ');
            state.renderInline(node);
        },
        support: 'full'
    },
    paragraph: {
        serialize ({ state: state, node: node }) {
            state.renderInline(node);
            state.closeBlock(node);
        },
        support: 'full'
    },
    mediaGroup: {
        serialize ({ state: state, node: node }) {
            state.updateNonErrorFallbackState(node);
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        support: 'fallback'
    },
    mediaInline: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) state.addBlockMarks(state, node, ()=>{
                const id = `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'mediaInline',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="mediaInline" data-id="${id}"></custom>`);
            });
        },
        support: 'preview'
    },
    mediaSingle: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) state.addBlockMarks(state, node, ()=>{
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'mediaSingle', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'mediaSingle',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="media_single_open" data-id="${id}" />\n\n`);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.write(`<custom data-type="media_single_close" />\n\n`);
            });
            else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
                /**
         * Currently, if the parent is a node we assume that mediaSingle is nested (e.g. inside a
         * table or list). In these cases we only output \n as there is often already new lines added
         * by the parent node.
         * Otherwise, if mediaSingle is not nested we add an extra new line.
         */ if (parent instanceof (0, $aPdNQ.Node)) state.write('\n');
                else state.write('\n\n');
            }
        },
        support: 'preview'
    },
    caption: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'caption', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'caption',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="caption_open" data-id="${id}" />\n\n`);
                try {
                    state.renderInline(node, {
                        skipFallback: true
                    });
                } catch (error) {
                    state.updateFallbackState(error, node);
                    state.nodes.fallback.serialize({
                        state: state,
                        node: node,
                        parent: parent,
                        index: index
                    });
                }
                // captions do not contain paragraphs, so we need to add a newline after the content
                state.write(`\n\n<custom data-type="caption_close" />\n\n`);
            } else {
                state.updateNonErrorFallbackState(node);
                state.write(node.textContent);
            }
        },
        support: 'preview'
    },
    media: {
        serialize ({ state: state, node: node }) {
            // Creating this fake URl allows us to pass the media attributes to the markdown without using markdown plus
            // Which allows image retention when using rovo since it doesn't support markdown plus
            const baseUrl = `blob:${(0, $9t7Od.MEDIA_BASE_URL_STAGING)}/?`;
            const queryString = Object.entries(node.attrs).map(([key, value])=>key !== 'alt' ? `${encodeURIComponent(key)}=${encodeURIComponent(value)}` : ``).join('&');
            const fakeUrl = `${baseUrl}${queryString}`;
            state.write(`![](${fakeUrl})${state.featureToggles.markdownPlusAddComplexNodes ? '\n\n' : ''}`);
        },
        support: 'full'
    },
    image: {
        serialize ({ state: state, node: node }) {
            // Note: the 'title' is not escaped in this flavor of markdown.
            state.write('![' + (0, $2MdWj.escapeMarkdown)(node.attrs.alt) + '](' + node.attrs.src + (node.attrs.title ? ` '${(0, $2MdWj.escapeMarkdown)(node.attrs.title)}'` : '') + ')');
        },
        support: 'full'
    },
    hardBreak: {
        serialize ({ state: state }) {
            state.write('  \n');
        },
        support: 'full'
    },
    text: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            const previousNode = index === 0 ? null : parent.child(index - 1);
            let text = node.textContent;
            // BB converts 4 spaces at the beginning of the line to code block
            // that's why we escape 4 spaces with zero-width-non-joiner
            const fourSpaces = '    ';
            if (!previousNode && $63a440ce8b406510$var$FOUR_SPACES_REGEX.test(node.textContent)) text = node.textContent.replace(fourSpaces, '\u200c' + fourSpaces);
            const lines = text.split('\n');
            for(let i = 0; i < lines.length; i++){
                const startOfLine = state.atBlank() || !!state.closed;
                state.write();
                state.out += (0, $2MdWj.escapeMarkdown)(lines[i], startOfLine, state.context.insideTable);
                if (i !== lines.length - 1) {
                    if (lines[i] && lines[i].length && lines[i + 1] && lines[i + 1].length) state.out += '  ';
                    state.out += '\n';
                }
            }
            // This is so we can determine which marks are most used that aren't being converted to markdown
            node.marks.forEach((mark)=>{
                // @ts-expect-error
                if (!$63a440ce8b406510$export$3a8025f2f3e0c64[mark.type.name]) state.updateNonErrorFallbackState(mark);
            });
        },
        support: 'full'
    },
    empty_line: {
        serialize ({ state: state, node: node }) {
            state.write('\u200c'); // zero-width-non-joiner
            state.closeBlock(node);
        },
        support: 'full'
    },
    placeholder: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'placeholder', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'placeholder',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="placeholder" data-id="${id}">${node.attrs.text}</custom>`);
            }
        },
        support: 'custom'
    },
    mention: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            const isLastNode = parent.childCount === index + 1;
            let delimiter = '';
            if (!isLastNode) {
                const nextNode = parent.child(index + 1);
                const nextNodeHasLeadingSpace = nextNode.textContent.indexOf(' ') === 0;
                delimiter = nextNodeHasLeadingSpace ? '' : ' ';
            }
            // Get the name from the map
            const name = state.mentionMap[node.attrs.id] || '';
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'mention', {
                    ...node.attrs,
                    text: `@${name}`
                }) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'mention',
                    // Update the attributes to include resolved name
                    attributes: {
                        ...node.attrs,
                        text: `@${name}`
                    }
                };
                if (state.featureToggles.markdownPlusAttributeTest) {
                    // @ts-expect-error
                    node.attrs.text = `@${name}`;
                    state.write(`<custom data-type="mention" data-id="${id}" data-attrs="${JSON.stringify(node.attrs)}">@${name}</custom>`);
                } else state.write(`<custom data-type="mention" data-id="${id}">@${name}</custom>`);
            } else state.write(`${name}${delimiter}`);
        },
        support: 'custom'
    },
    date: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'date', node.attrs) : `id-${state.idCounter++}`;
                // Ensure localId is explicitly set to null if not present
                const attributes = {
                    ...node.attrs,
                    localId: node.attrs.localId ?? null
                };
                state.idMap[id] = {
                    type: 'date',
                    attributes: attributes
                };
                if (state.featureToggles.markdownPlusAttributeTest) state.write(`<custom data-type="date" data-id="${id}" data-attrs="${JSON.stringify(node.attrs)}">${new Intl.DateTimeFormat().format(Number(node.attrs.timestamp))}</custom>`);
                else state.write(`<custom data-type="date" data-id="${id}">${new Intl.DateTimeFormat().format(Number(node.attrs.timestamp))}</custom>`);
            } else state.write(new Intl.DateTimeFormat().format(Number(node.attrs.timestamp)));
        },
        support: 'custom'
    },
    emoji: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'emoji', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'emoji',
                    attributes: node.attrs
                };
                if (state.featureToggles.markdownPlusAttributeTest) state.write(`<custom data-type="emoji" data-id="${id}" data-attrs="${JSON.stringify(node.attrs)}">${node.attrs.shortName}</custom>`);
                else state.write(`<custom data-type="emoji" data-id="${id}">${node.attrs.shortName}</custom>`);
            } else state.write(node.attrs.shortName);
        },
        support: 'custom'
    },
    inlineCard: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'inlineCard', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'inlineCard',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="smartlink" data-id="${id}">${node.attrs.url}</custom>`);
            } else state.write(`[${node.attrs.url}](${node.attrs.url})`);
        },
        support: 'custom'
    },
    status: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'status', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'status',
                    attributes: node.attrs
                };
                if (state.featureToggles.markdownPlusAttributeTest) state.write(`<custom data-type="status" data-id="${id}" data-attrs="${JSON.stringify(node.attrs)}">${node.attrs.text}</custom>`);
                else state.write(`<custom data-type="status" data-id="${id}">${node.attrs.text}</custom>`);
            } else // this will trigger the fallback conversion (text)
            throw new Error('Token type `status` not supported by Markdown renderer');
        },
        support: 'custom'
    },
    layoutSection: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) state.addBlockMarks(state, node, ()=>{
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'layoutSection', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'layoutSection',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="layoutSection_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="layoutSection_close" />\n\n`);
            });
            else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
            }
        },
        support: 'preview'
    },
    layoutColumn: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'layoutColumn', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'layoutColumn',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="layoutColumn_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="layoutColumn_close" />\n\n`);
            } else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
            }
        },
        support: 'preview'
    },
    expand: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) state.addBlockMarks(state, node, ()=>{
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'expand', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'expand',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="expand_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="expand_close" />\n\n`);
            });
            else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
            }
        },
        support: 'preview'
    },
    nestedExpand: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'nestedExpand', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'nestedExpand',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="nestedExpand_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="nestedExpand_close" />\n\n`);
            } else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
            }
        },
        support: 'preview'
    },
    panel: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusPanels) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'panel', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'panel',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="panel_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="panel_close" />\n\n`);
            } else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
            }
        },
        support: 'custom'
    },
    blockCard: {
        serialize ({ state: state, node: node }) {
            state.write(`[${node.attrs.url}](${node.attrs.url})`);
        },
        support: 'full'
    },
    embedCard: {
        serialize ({ state: state, node: node }) {
            state.write(`[${node.attrs.url}](${node.attrs.url})`);
        },
        support: 'full'
    },
    decisionList: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusDecisions) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'decisionList', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'decisionList',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="decisionList_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
                state.write(`<custom data-type="decisionList_close" />\n\n`);
            } else {
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
                state.write(`\n\n`);
            }
        },
        support: 'custom'
    },
    decisionItem: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusDecisions) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'decisionItem', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'decisionItem',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="decisionItem_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`\n\n<custom data-type="decisionItem_close" />\n\n`);
            } else for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        support: 'custom'
    },
    extension: {
        serialize ({ state: state, node: node }) {
            // For native embed extension nodes, output the embedded URL as a markdown link
            // so that it's visible to Rovo (same as embedCard/blockCard serialization)
            if (node.attrs.extensionKey?.startsWith('native-embed:')) {
                const url = node.attrs.parameters?.macroParams?.url?.value;
                if (url) {
                    state.write(`[${url}](${url})`);
                    return;
                }
            }
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusExtensions) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'extension', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'extension',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="extension" data-id="${id}" />\n\n`);
            }
        },
        support: 'custom'
    },
    inlineExtension: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusExtensions) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'inlineExtension', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'inlineExtension',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="inlineExtension" data-id="${id}"></custom>`);
            }
        },
        support: 'custom'
    },
    bodiedExtension: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusExtensions) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'bodiedExtension', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'bodiedExtension',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="bodiedExtension_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="bodiedExtension_close" />\n\n`);
            } else for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        support: 'custom'
    },
    fallback: {
        serialize ({ state: state, node: node }) {
            // If PMNode is an unhandled block node, we need to add a newline
            // after the content to prevent the next line from being rendered as
            // part of the block node.
            if (node.isBlock) state.write(`${node.textContent || node.attrs.text || ''}\n\n`);
            else state.write(node.textContent || node.attrs.text || '');
        },
        support: 'fallback'
    }
};
const $63a440ce8b406510$export$695720b7e7a61533 = {
    ...$63a440ce8b406510$var$editorNodes,
    ...(0, $9bzIP.default)
};
const $63a440ce8b406510$export$3a8025f2f3e0c64 = {
    em: {
        open: '_',
        close: '_',
        mixable: true,
        expelEnclosingWhitespace: true
    },
    strong: {
        open: '**',
        close: '**',
        mixable: true,
        expelEnclosingWhitespace: true
    },
    strike: {
        open: '~~',
        close: '~~',
        mixable: true,
        expelEnclosingWhitespace: true
    },
    link: {
        open: '[',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        close (_state, mark) {
            return '](' + mark.attrs['href'] + ')';
        }
    },
    code: {
        open: '`',
        close: '`'
    }
};
module.exports["MarkdownSerializerState"] = $63a440ce8b406510$export$61055fa707e69319;

});

parcelRegister("9bzIP", function(module, exports) {

var $3nCzG = parcelRequire("3nCzG");

const $3b8284ec19aad1fa$var$isHeaderRow = (row)=>row.child(0).type.name === 'tableHeader';
const $3b8284ec19aad1fa$var$isFirstRow = (row, parent)=>parent.content.child(0) === row;
const $3b8284ec19aad1fa$var$isHeaderRowPresent = (table)=>{
    let headerRowPresent = false;
    table.content.forEach((row)=>{
        if ($3b8284ec19aad1fa$var$isHeaderRow(row)) headerRowPresent = true;
    });
    return headerRowPresent;
};
const $3b8284ec19aad1fa$var$renderNode = (state, node, index)=>{
    if (index > 0) state.write(' ');
    node.content.forEach((child, i)=>{
        if (child.isTextblock || child.type.name === 'mediaSingle') {
            if (i > 0) state.write(' ');
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            state.context.insideTable = true;
            state.renderInline(child);
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            state.context.insideTable = false;
        } else $3b8284ec19aad1fa$var$renderNode(state, child, i);
    });
};
const $3b8284ec19aad1fa$var$renderInlineContent = ({ state: state, node: node })=>{
    state.write('| ');
    $3b8284ec19aad1fa$var$renderNode(state, node, 0);
    state.write(' ');
};
const $3b8284ec19aad1fa$var$tableNodes = {
    table: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'table', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'table',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="table_open" data-id="${id}" />\n\n`);
                node.content.forEach((child, i)=>state.render(child, node, i));
                state.write(`<custom data-type="table_close" />\n\n`);
            } else {
                if (!(0, $3nCzG.attributesMatchDefault)(node, state.featureToggles, {
                    layout: node.attrs.layout,
                    localId: node.attrs.localId,
                    width: 760
                })) state.updateNonErrorFallbackState(node);
                const headerRowPresent = $3b8284ec19aad1fa$var$isHeaderRowPresent(node);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            headerRowPresent: headerRowPresent,
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.closeBlock(node);
            }
        },
        support: 'partial'
    },
    tableRow: {
        serialize ({ state: state, node: node, parent: parent, index: index, options: options }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'table', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'table',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="tr_open" data-id="${id}" />\n\n`);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.write(`<custom data-type="tr_close" />\n\n`);
            } else {
                if (!(0, $3nCzG.attributesMatchDefault)(node, state.featureToggles)) state.updateNonErrorFallbackState(node);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            ...options,
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.write('|');
                state.ensureNewLine();
                if ($3b8284ec19aad1fa$var$isHeaderRow(node) || $3b8284ec19aad1fa$var$isFirstRow(node, parent)) {
                    for(let i = 0; i < node.childCount; i++)state.write('| --- ');
                    state.write('|');
                    state.ensureNewLine();
                }
            }
        },
        support: 'partial'
    },
    tableHeader: {
        serialize ({ state: state, node: node, parent: parent, index: index, options: options }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'table', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'table',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="th_open" data-id="${id}" />\n\n`);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.write(`<custom data-type="th_close" />\n\n`);
            } else {
                if (!(0, $3nCzG.attributesMatchDefault)(node, state.featureToggles)) state.updateNonErrorFallbackState(node);
                $3b8284ec19aad1fa$var$renderInlineContent({
                    state: state,
                    node: node,
                    parent: parent,
                    index: index,
                    options: options
                });
            }
        },
        support: 'partial'
    },
    tableCell: {
        serialize ({ state: state, node: node, parent: parent, index: index, options: options }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'table', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'table',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="td_open" data-id="${id}" />\n\n`);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.write(`<custom data-type="td_close" />\n\n`);
            } else {
                if (!(0, $3nCzG.attributesMatchDefault)(node, state.featureToggles)) state.updateNonErrorFallbackState(node);
                $3b8284ec19aad1fa$var$renderInlineContent({
                    state: state,
                    node: node,
                    parent: parent,
                    index: index,
                    options: options
                });
            }
        },
        support: 'partial'
    }
};
var $3b8284ec19aad1fa$export$2e2bcd8739ae039 = $3b8284ec19aad1fa$var$tableNodes;
module.exports["default"] = $3b8284ec19aad1fa$export$2e2bcd8739ae039;

});

parcelRegister("3nCzG", function(module, exports) {
const $1a2f04a85d2bd5e4$export$5be26e657c035da4 = (node, featureToggles, overrideDefaults = {})=>{
    if (!featureToggles.allowAttributesMatchDefault) return true;
    // @ts-expect-error - node.type.attrs does not exist in nodeType type, but it does exist.
    const nodeTypeAttrs = node.type.attrs;
    if (!nodeTypeAttrs || Object.keys(nodeTypeAttrs).length === 0 && Object.keys(node.attrs).length === 0) return true;
    const defaultAttrs = {};
    Object.keys(nodeTypeAttrs).forEach((key)=>{
        defaultAttrs[key] = nodeTypeAttrs[key].default;
    });
    // The actual node defaults don't match the node defaults when interacting with a page
    // So we override for a correct comparison
    Object.keys(overrideDefaults).forEach((key)=>{
        defaultAttrs[key] = overrideDefaults[key];
    });
    // Compare the node attributes to the default attributes
    for(const key in node.attrs){
        if (node.attrs[key] !== defaultAttrs[key]) return false;
    }
    return true;
};
module.exports["attributesMatchDefault"] = $1a2f04a85d2bd5e4$export$5be26e657c035da4;

});

parcelRegister("jOZYJ", function(module, exports) {

var $aPdNQ = parcelRequire("aPdNQ");

const $2fc5fefa720a7491$export$8ef94ae42a3729bd = 1;
const $2fc5fefa720a7491$export$d445360e2a3c026b = (order)=>{
    const num = Number(order);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
const $2fc5fefa720a7491$export$4ea3c6bbdf8f7944 = (maybeOrderedListNode)=>{
    if (!(maybeOrderedListNode instanceof (0, $aPdNQ.Node))) return $2fc5fefa720a7491$export$8ef94ae42a3729bd;
    const order = maybeOrderedListNode?.attrs?.order;
    return $2fc5fefa720a7491$export$d445360e2a3c026b(order) ?? $2fc5fefa720a7491$export$8ef94ae42a3729bd;
};
module.exports["getOrderFromMaybeOrderedListNode"] = $2fc5fefa720a7491$export$4ea3c6bbdf8f7944;

});

parcelRegister("2MdWj", function(module, exports) {
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $e99fb8d9fbca0ae0$var$USERNAME_MATCH_REGEX = /^@(.*?)$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $e99fb8d9fbca0ae0$var$EMOJI_SHORTNAME_REGEX = /([^\/]+)\.[^\/]+$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $e99fb8d9fbca0ae0$var$WORD_CHAR_REGEX = /\w/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $e99fb8d9fbca0ae0$var$ESCAPE_LINE_START_REGEX = /^(\+[ ]|[\-*>])/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $e99fb8d9fbca0ae0$var$ESCAPE_HEADING_REGEX = /^(\s*)(#{1,6})(\s|$)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $e99fb8d9fbca0ae0$var$ESCAPE_ORDERED_LIST_REGEX = /^(\s*\d+)\.\s/;
function $e99fb8d9fbca0ae0$export$345d822805ab3239(text, length) {
    let result = '';
    for(let x = 0; x < length; x++)result += text;
    return result;
}
function $e99fb8d9fbca0ae0$export$560888d6fe0cfe97(str, startOfLine, insideTable) {
    let strToEscape = str || '';
    // Ignored via go/ees005, go/ees019
    // eslint-disable-next-line require-unicode-regexp, e18e/prefer-static-regex
    strToEscape = strToEscape.replace(/[`*\\~\[\]_]/g, (m, i)=>m === '_' && i > 0 && i + 1 < str.length && str[i - 1].match($e99fb8d9fbca0ae0$var$WORD_CHAR_REGEX) && str[i + 1].match($e99fb8d9fbca0ae0$var$WORD_CHAR_REGEX) ? m : '\\' + m);
    if (startOfLine) strToEscape = strToEscape.replace($e99fb8d9fbca0ae0$var$ESCAPE_LINE_START_REGEX, '\\$&').replace($e99fb8d9fbca0ae0$var$ESCAPE_HEADING_REGEX, '$1\\$2$3').replace($e99fb8d9fbca0ae0$var$ESCAPE_ORDERED_LIST_REGEX, '$1\\. ');
    if (insideTable) // Ignored via go/ees005, go/ees019
    // eslint-disable-next-line require-unicode-regexp, e18e/prefer-static-regex
    strToEscape = strToEscape.replace(/[|]/g, '\\$&');
    return strToEscape;
}
function $e99fb8d9fbca0ae0$var$removeSpecialCharacters(node) {
    if (node.nodeType === 3 && node.textContent) // Ignored via go/ees005, go/ees019
    // eslint-disable-next-line require-unicode-regexp, e18e/prefer-static-regex
    node.textContent = node.textContent.replace(/\u200c|↵/g, '');
    Array.from(node.childNodes).forEach((child)=>$e99fb8d9fbca0ae0$var$removeSpecialCharacters(child));
}
function $e99fb8d9fbca0ae0$export$9c95763b5a419f4c(html, options) {
    const el = document.createElement('div');
    el.innerHTML = html;
    // Remove zero-width-non-joiner
    Array.from(el.querySelectorAll('p')).forEach((p)=>{
        $e99fb8d9fbca0ae0$var$removeSpecialCharacters(p);
    });
    // Convert mention containers, i.e.:
    //   <a href="/abodera/" rel="nofollow" title="@abodera" class="mention mention-me">Artur Bodera</a>
    Array.from(el.querySelectorAll('a.mention, a.ap-mention')).forEach((a)=>{
        const span = document.createElement('span');
        span.setAttribute('class', 'editor-entity-mention');
        span.setAttribute('contenteditable', 'false');
        const atlassianId = a.getAttribute('data-atlassian-id') || '';
        if (atlassianId) // Atlassian ID is wrapped in curlies so that it get serialized as @{aid-id} instead of @aid-id
        span.setAttribute('data-mention-id', `{${atlassianId}}`);
        else {
            const title = a.getAttribute('title') || '';
            if (title) {
                const usernameMatch = title.match($e99fb8d9fbca0ae0$var$USERNAME_MATCH_REGEX);
                if (usernameMatch) {
                    const username = usernameMatch[1];
                    span.setAttribute('data-mention-id', username);
                }
            }
        }
        const text = a.textContent || '';
        if (text.indexOf('@') === 0) span.textContent = a.textContent;
        else span.textContent = `@${a.textContent}`;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        a.parentNode.insertBefore(span, a);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        a.parentNode.removeChild(a);
    });
    // Convert mention containers, i.e.:
    //   <span class="ap-mention" data-atlassian-id="5c09bf77ec71bd223bbe866f">@Scott Demo</span>
    Array.from(el.querySelectorAll('span.ap-mention')).forEach((s)=>{
        const span = document.createElement('span');
        span.setAttribute('class', 'editor-entity-mention');
        span.setAttribute('contenteditable', 'false');
        const atlassianId = s.getAttribute('data-atlassian-id') || '';
        span.setAttribute('data-mention-id', `{${atlassianId}}`);
        const text = s.textContent || '';
        span.textContent = text.indexOf('@') === 0 ? text : `@${text}`;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        s.parentNode.insertBefore(span, s);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        s.parentNode.removeChild(s);
    });
    // Parse emojis i.e.
    //     <img src="https://d301sr5gafysq2.cloudfront.net/207268dc597d/emoji/img/diamond_shape_with_a_dot_inside.svg" alt="diamond shape with a dot inside" title="diamond shape with a dot inside" class="emoji">
    Array.from(el.querySelectorAll('img.emoji')).forEach((img)=>{
        const span = document.createElement('span');
        let shortName = img.getAttribute('data-emoji-short-name') || '';
        if (!shortName) {
            // Fallback to parsing Bitbucket's src attributes to find the
            // short name
            const src = img.getAttribute('src');
            const idMatch = !src ? false : src.match($e99fb8d9fbca0ae0$var$EMOJI_SHORTNAME_REGEX);
            if (idMatch) shortName = `:${decodeURIComponent(idMatch[1])}:`;
        }
        if (shortName) span.setAttribute('data-emoji-short-name', shortName);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        img.parentNode.insertBefore(span, img);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        img.parentNode.removeChild(img);
    });
    if (!options.disableBitbucketLinkStripping) // Convert all automatic links to plain text, because they will be re-created on render by the server
    Array.from(el.querySelectorAll('a'))// Don't convert external links (i.e. not automatic links)
    .filter((a)=>a.getAttribute('data-is-external-link') !== 'true' && a.getAttribute('data-inline-card') === null).forEach((a)=>{
        Array.from(a.childNodes).forEach((child)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            a.parentNode.insertBefore(child, a);
        });
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        a.parentNode.removeChild(a);
    });
    // Parse images
    // Not using :pseudo because of IE11 bug:
    // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/16104908/
    Array.from(el.querySelectorAll('img')).filter((img)=>!img.classList.contains('emoji')).forEach((img)=>{
        const { parentNode: parentNode } = img;
        if (!parentNode) return;
        /**
     * Lift image node if parent isn't the root-element
     */ if (parentNode !== el) {
            const isValidPath = validateImageNodeParent(parentNode);
            if (!isValidPath) liftImageNode(parentNode, img);
        }
        /**
     * Replace image with media node
     */ const mediaSingle = document.createElement('div');
        mediaSingle.setAttribute('data-node-type', 'mediaSingle');
        const media = document.createElement('div');
        media.setAttribute('data-node-type', 'media');
        media.setAttribute('data-type', 'external');
        media.setAttribute('data-alt', img.getAttribute('alt') || '');
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        media.setAttribute('data-url', img.getAttribute('src'));
        mediaSingle.appendChild(media);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        img.parentNode.insertBefore(mediaSingle, img);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        img.parentNode.removeChild(img);
    });
    function validateImageNodeParent(node) {
        const ALLOWED_PARENTS = [
            'LI',
            'UL',
            'OL',
            'TD',
            'TH',
            'TR',
            'TBODY',
            'THEAD',
            'TABLE'
        ];
        if (node === el) return true;
        if (ALLOWED_PARENTS.indexOf(node.nodeName) === -1) return false;
        if (!node.parentNode) return false;
        return validateImageNodeParent(node.parentNode);
    }
    function liftImageNode(node, img) {
        let foundParent = false;
        let parent = node;
        while(!foundParent){
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            foundParent = validateImageNodeParent(parent.parentNode);
            if (!foundParent) // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            parent = parent.parentNode;
        }
        const cloned = parent.cloneNode();
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const target = parent !== el ? parent.parentNode : el;
        while(img.nextSibling)cloned.appendChild(img.nextSibling);
        if (node !== parent) while(node.nextSibling)cloned.appendChild(node.nextSibling);
        if (parent.nextSibling) {
            target.insertBefore(cloned, parent.nextSibling);
            target.insertBefore(img, cloned);
        } else {
            target.appendChild(img);
            target.appendChild(cloned);
        }
        /**
     * If the splitting operation results in
     * the old parent being empty, remove it
     */ if (node.childNodes.length === 0) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        node.parentNode.removeChild(node);
        /**
     * Remove cloned element if it's empty.
     */ if (cloned.childNodes.length === 0) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        cloned.parentNode.removeChild(cloned);
    }
    return el;
}
module.exports["stringRepeat"] = $e99fb8d9fbca0ae0$export$345d822805ab3239;
module.exports["escapeMarkdown"] = $e99fb8d9fbca0ae0$export$560888d6fe0cfe97;

});

parcelRegister("kuIhJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $hlvTd = parcelRequire("hlvTd");


var $8A2GO = parcelRequire("8A2GO");

const $b4a77d21276ce51d$export$609860bf8b0084c = ({ mutationFn: mutationFn, onSuccess: onSuccess, onError: onError, throwOnError: throwOnError = false })=>{
    const mutationFnRef = (0, $cozmU.useRef)(mutationFn);
    mutationFnRef.current = mutationFn;
    const onSuccessRef = (0, $cozmU.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0, $cozmU.useRef)(onError);
    onErrorRef.current = onError;
    const throwOnErrorRef = (0, $cozmU.useRef)(throwOnError);
    throwOnErrorRef.current = throwOnError;
    const [data, setData] = (0, $cozmU.useState)(null);
    const [error, setError] = (0, $cozmU.useState)(null);
    const [isSubmitting, setIsSubmitting] = (0, $cozmU.useState)(false);
    const mutate = (0, $cozmU.useCallback)(async (payload, mutateCallback)=>{
        const reliableContracts = (0, $iDrrr.fg)('rovo_ai_mate_reliability_contracts');
        const shouldThrow = reliableContracts && throwOnErrorRef.current;
        const handleSuccess = onSuccessRef.current;
        const handleError = onErrorRef.current;
        setIsSubmitting(true);
        if (reliableContracts) setError(null);
        try {
            const response = await mutationFnRef.current(payload);
            setData(response);
            if (reliableContracts) {
                // The write has succeeded. An observer failure must not trigger rollback or
                // encourage callers to repeat an already committed operation.
                for (const callback of [
                    handleSuccess,
                    mutateCallback?.onSuccess
                ])try {
                    await callback?.(response);
                } catch (callbackError) {
                    (0, $hlvTd.logException)({
                        exception: callbackError,
                        name: 'aiMateMutationSuccessCallback'
                    }).catch(()=>undefined);
                }
            } else {
                onSuccessRef.current?.(response);
                mutateCallback?.onSuccess?.(response);
            }
            return response;
        } catch (error_0) {
            const apiError = (0, $8A2GO.mapErrorToApiError)(error_0);
            setError(apiError);
            (reliableContracts ? handleError : onErrorRef.current)?.(apiError, payload);
            mutateCallback?.onError?.(apiError);
            if (shouldThrow) throw apiError;
        } finally{
            setIsSubmitting(false);
        }
    }, []);
    return {
        data: data,
        error: error,
        isSubmitting: isSubmitting,
        mutate: mutate
    };
};
module.exports["useMutation"] = $b4a77d21276ce51d$export$609860bf8b0084c;

});

parcelRegister("3sXr4", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");

const $f685837601709ec0$var$GRADIENT_ANGLE_VARIABLE = '--gradient-angle';
const $f685837601709ec0$var$BORDER_ORANGE = "var(--ds-rovo-border-saffron, #FCA700)";
const $f685837601709ec0$var$BORDER_GREEN = "var(--ds-rovo-border-lime, #6A9A23)";
const $f685837601709ec0$var$BORDER_BLUE = "var(--ds-rovo-border-blue, #1868DB)";
const $f685837601709ec0$var$BORDER_PURPLE = "var(--ds-rovo-border-purple, #AF59E1)"; /**
                                                                * Because the aspect ratio of the actual thinking bars is very wide,
                                                                * the gradient will stretch out at each corner which would make the
                                                                * rovo colours very disproportionate.
                                                                *
                                                                * To workaround this we use a dynamic angle amplitude to narrow the angles as we approach
                                                                * 90 and 180 degrees, and we have a general aspect ratio of the expected design as
                                                                * it's not worth calculating the width and height of the actual components.
                                                                *
                                                                * Approximating the minimum edge span as inversely proportional to the expected
                                                                * wrapper aspect ratio.
                                                                *
                                                                * 360 / 48 is the approximated aspect ratio.
                                                                */ 
const $f685837601709ec0$var$DEFAULT_SIDE_ANGLE_SPAN = `2 * atan(1 / (360 / 48))`; /**
                                                             * Squared cosine produces a symmetric 0..1 signal based on rotation angle:
                                                             * 0 at top/bottom, 1 at left/right, which tells us how close the highlight is
                                                             * to the side edges.
                                                             */ 
const $f685837601709ec0$var$DEFAULT_SIDE_WEIGHT = `calc(cos(var(${$f685837601709ec0$var$GRADIENT_ANGLE_VARIABLE}, 39deg)) * cos(var(${$f685837601709ec0$var$GRADIENT_ANGLE_VARIABLE}, 39deg)))`; /**
                                                                                                                                * Interpolates the highlight span between the minimum side-edge span and a
                                                                                                                                * wider 90deg span, with amplitude scaling and side weighting for earlier/
                                                                                                                                * longer narrowing near the left and right edges.
                                                                                                                                */ 
const $f685837601709ec0$var$DEFAULT_HIGHLIGHT_SPAN = `calc(${$f685837601709ec0$var$DEFAULT_SIDE_ANGLE_SPAN} + ((90deg - ${$f685837601709ec0$var$DEFAULT_SIDE_ANGLE_SPAN})  * ${$f685837601709ec0$var$DEFAULT_SIDE_WEIGHT}))`; // Conic gradient that drives both the visible border and blurred glow.
const $f685837601709ec0$var$ROVO_MOSAIC_GRADIENT_BACKGROUND = `conic-gradient(
	from calc(var(${$f685837601709ec0$var$GRADIENT_ANGLE_VARIABLE}, 39deg) - (${$f685837601709ec0$var$DEFAULT_HIGHLIGHT_SPAN} / 2)) at 50% 50%,
	${$f685837601709ec0$var$BORDER_ORANGE} 0deg ${$f685837601709ec0$var$DEFAULT_HIGHLIGHT_SPAN},
	${$f685837601709ec0$var$BORDER_GREEN} ${$f685837601709ec0$var$DEFAULT_HIGHLIGHT_SPAN} 180deg,
	${$f685837601709ec0$var$BORDER_BLUE} 180deg calc(180deg + ${$f685837601709ec0$var$DEFAULT_HIGHLIGHT_SPAN}),
	${$f685837601709ec0$var$BORDER_PURPLE} calc(180deg + ${$f685837601709ec0$var$DEFAULT_HIGHLIGHT_SPAN}) 360deg
)`; // Rotate the custom angle property so the highlight continuously sweeps around the border.
const $f685837601709ec0$var$gradientRotation = null; // @property is required so the browser knows --gradient-angle is an interpolatable
// <angle> — without it, keyframe animation of a custom property has no effect.
const $f685837601709ec0$var$gradientAngleProperty = null;
const $f685837601709ec0$var$BLUR_SIZE = 32;
const $f685837601709ec0$var$BORDER_WIDTH = 1; // Outer position context for the decorative glow and border layers.
const $f685837601709ec0$var$wrapperBaseStyle = null; // Thinking shell uses pseudo-elements for the blurred glow and rotating gradient border.
const $f685837601709ec0$var$thinkingWrapperStyle = null;
const $f685837601709ec0$var$plainBorderStyle = null; // Shared layout/padding base for the actual content area so children can stay mounted
// while the surrounding thinking chrome changes.
const $f685837601709ec0$var$contentBaseStyle = null;
const $f685837601709ec0$export$f2f0a5c9bccb33b1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { children: children, isThinking: isThinking } = t0;
    const t1 = isThinking ? "rovo-thinking-bar-wrapper__thinking" : "rovo-thinking-bar-wrapper__idle";
    const t2 = isThinking && "";
    const t3 = isThinking && "";
    const t4 = isThinking && "";
    const t5 = isThinking && "_0bjKvDyzSk _4c065UHZdu _2Y7lL4HZdu _1mT5xdRAKS _39xV02N91d _2YgrGrP0S5 _1OimfudRhP _4eDJc6P4qp _2OUbymKNkB _3Ku51Iogpp _3dCYwDWVPG _3ScelFGJbM _1lBcDcGJbM _35I30Bey7F _1L3m71ey7F _3fRV4CV6HZ _0UsFEzYbGa _3qT6l0vQQr _0EnhYgdnbC _2Gfj6idRhP _2OWEWsP4qp _0h8XtNKNkB _0GBAIrogpp _2WYcYGWVPG _2tbAUcYbGa _39mJBjvQQr _32JO6cYbGa _2AwNtJYbGa";
    const t6 = !isThinking && "_0bjKvDyzSk _4bt5LAnQyn _2WAcuGnQyn _4c065UHZdu _2Y7lL4HZdu _39xV02N91d _0KLXruoI2d _2OUyjtGk8v";
    let t7;
    if ($[0] !== t2 || $[1] !== t3 || $[2] !== t4 || $[3] !== t5 || $[4] !== t6) {
        t7 = (0, $hekY6.default)([
            "_0bjKvDyzSk _1mT5xdRAKS _39xV02N91d",
            t2,
            t3,
            t4,
            t5,
            t6
        ]);
        $[0] = t2;
        $[1] = t3;
        $[2] = t4;
        $[3] = t5;
        $[4] = t6;
        $[5] = t7;
    } else t7 = $[5];
    let t8;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = (0, $hekY6.default)([
            "_0bjKvDyzSk _2Y7lL42ADO _4c065U2ADO _39xV02N91d _1mT5xdRAKS _42Yu6BdnbC _0KLXruoI2d _24h04i2Njc"
        ]);
        $[6] = t8;
    } else t8 = $[6];
    let t9;
    if ($[7] !== children) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t8
        }, children);
        $[7] = children;
        $[8] = t9;
    } else t9 = $[8];
    let t10;
    if ($[9] !== t1 || $[10] !== t7 || $[11] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": t1,
            className: t7
        }, t9);
        $[9] = t1;
        $[10] = t7;
        $[11] = t9;
        $[12] = t10;
    } else t10 = $[12];
    return t10;
} : ({ children: children, isThinking: isThinking })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": isThinking ? 'rovo-thinking-bar-wrapper__thinking' : 'rovo-thinking-bar-wrapper__idle',
        className: (0, $hekY6.default)([
            "_0bjKvDyzSk _1mT5xdRAKS _39xV02N91d",
            isThinking && "",
            isThinking && "",
            isThinking && "",
            isThinking && "_0bjKvDyzSk _4c065UHZdu _2Y7lL4HZdu _1mT5xdRAKS _39xV02N91d _2YgrGrP0S5 _1OimfudRhP _4eDJc6P4qp _2OUbymKNkB _3Ku51Iogpp _3dCYwDWVPG _3ScelFGJbM _1lBcDcGJbM _35I30Bey7F _1L3m71ey7F _3fRV4CV6HZ _0UsFEzYbGa _3qT6l0vQQr _0EnhYgdnbC _2Gfj6idRhP _2OWEWsP4qp _0h8XtNKNkB _0GBAIrogpp _2WYcYGWVPG _2tbAUcYbGa _39mJBjvQQr _32JO6cYbGa _2AwNtJYbGa",
            !isThinking && "_0bjKvDyzSk _4bt5LAnQyn _2WAcuGnQyn _4c065UHZdu _2Y7lL4HZdu _39xV02N91d _0KLXruoI2d _2OUyjtGk8v"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_0bjKvDyzSk _2Y7lL42ADO _4c065U2ADO _39xV02N91d _1mT5xdRAKS _42Yu6BdnbC _0KLXruoI2d _24h04i2Njc"
        ])
    }, children));
};
module.exports["RovoThinkingBarWrapper"] = $f685837601709ec0$export$f2f0a5c9bccb33b1;

});

parcelRegister("02Wb7", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $353693fd10aa5589$var$message = (0, $kSwu1.defineMessages)({
    followAiMateButton: {
        id: "ai-mate.inline-chat-input.follow-button.label",
        defaultMessage: "Follow"
    },
    stopGeneratingButtonLabel: {
        id: "ai-mate.inline-chat-input.stop-generating-button.label",
        defaultMessage: "Stop generating"
    },
    thinkingText: {
        id: "ai-mate.inline-chat-input.thinking",
        defaultMessage: "Rovo is analyzing"
    },
    thinkingTextShort: {
        id: "ai-mate.inline-chat-input.thinking.short",
        defaultMessage: "Analyzing"
    },
    editingText: {
        id: "ai-mate.inline-chat-input.editing",
        defaultMessage: "Rovo is editing"
    },
    editingTextShort: {
        id: "ai-mate.inline-chat-input.editing.short",
        defaultMessage: "Editing"
    },
    thinkingReadyMessage: {
        id: "ai-mate.thinking-bar.ready.message",
        defaultMessage: "Your edits are ready"
    },
    thinkingClose: {
        id: "ai-mate.thinking-bar.close",
        defaultMessage: "Close"
    },
    thinkingReadyView: {
        id: "ai-mate.thinking-bar.ready.view",
        defaultMessage: "View"
    },
    thinkingErrorMessage: {
        id: "ai-mate.thinking-bar.error.message",
        defaultMessage: "An unknown error occurred."
    },
    thinkingErrorTryAgain: {
        id: "ai-mate.thinking-bar.error.try-again",
        defaultMessage: "Try again"
    }
});
var $353693fd10aa5589$export$2e2bcd8739ae039 = $353693fd10aa5589$var$message;
module.exports["default"] = $353693fd10aa5589$export$2e2bcd8739ae039;

});

parcelRegister("kb1I3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $1sCHt = parcelRequire("1sCHt");


var $1pTZX = parcelRequire("1pTZX");


var $2pQiO = parcelRequire("2pQiO");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");


var $1kxki = parcelRequire("1kxki");


var $2diYd = parcelRequire("2diYd");


var $02Wb7 = parcelRequire("02Wb7");


var $7VOWp = parcelRequire("7VOWp");

const $6437c80744d7a710$var$ROTATION_INTERVAL_MS = 4000;
const $6437c80744d7a710$var$rotatingMessages = (0, $kSwu1.defineMessages)({
    rovoIsThinking: {
        id: "ai-mate.inline-chat-input.thinking.rotating.rovo-is-thinking",
        defaultMessage: "Rovo is thinking"
    },
    analyzingContent: {
        id: "ai-mate.inline-chat-input.thinking.rotating.analyzing-content",
        defaultMessage: "Analyzing your content"
    },
    puttingPiecesTogether: {
        id: "ai-mate.inline-chat-input.thinking.rotating.putting-pieces-together",
        defaultMessage: "Putting the pieces together"
    },
    structuringResponse: {
        id: "ai-mate.inline-chat-input.thinking.rotating.structuring-response",
        defaultMessage: "Structuring your response"
    },
    designingResponse: {
        id: "ai-mate.inline-chat-input.thinking.rotating.designing-response",
        defaultMessage: "Designing your response"
    },
    addingItAllTogether: {
        id: "ai-mate.inline-chat-input.thinking.rotating.adding-it-all-together",
        defaultMessage: "Adding it all together"
    },
    applyingFinalTouches: {
        id: "ai-mate.inline-chat-input.thinking.rotating.applying-final-touches",
        defaultMessage: "Applying the final touches"
    },
    almostDone: {
        id: "ai-mate.inline-chat-input.thinking.rotating.almost-done",
        defaultMessage: "Almost done"
    }
});
/**
 * Cycles through `texts` at a fixed interval, stopping on the last item.
 *
 * When `startedAt` (epoch ms) is provided, the current index is derived from the
 * elapsed time since that shared anchor, so multiple instances driven by the same
 * session show the same message and stay in sync across mount/unmount. When
 * omitted, rotation is anchored to this mount.
 */ function $6437c80744d7a710$var$useSequentialText(texts, enabled, startedAt) {
    const indexFromStart = ()=>{
        if (startedAt == null) return 0;
        const elapsed = Math.max(0, Date.now() - startedAt);
        return Math.min(texts.length - 1, Math.floor(elapsed / $6437c80744d7a710$var$ROTATION_INTERVAL_MS));
    };
    const [index, setIndex] = (0, $cozmU.useState)(indexFromStart);
    const indexRef = (0, $cozmU.useRef)(index);
    indexRef.current = index;
    const textsRef = (0, $cozmU.useRef)(texts);
    textsRef.current = texts;
    (0, $cozmU.useEffect)(()=>{
        if (!enabled || textsRef.current.length <= 1) return;
        if (indexRef.current >= textsRef.current.length - 1) return;
        const interval = setInterval(()=>{
            const next = indexRef.current + 1;
            if (next < textsRef.current.length) {
                indexRef.current = next;
                setIndex(next);
            } else clearInterval(interval);
        }, $6437c80744d7a710$var$ROTATION_INTERVAL_MS);
        return ()=>clearInterval(interval);
    }, [
        enabled,
        startedAt
    ]);
    return {
        index: index,
        text: texts[index] ?? texts[texts.length - 1] ?? ''
    };
}
const $6437c80744d7a710$var$styles = {
    container: "_2mHwu82ADO _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _39xV02N91d",
    actions: "_2XsHFMIZbP",
    indicatorWrapper: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4bt5LAnQyn _2WAcuGnQyn _4ouGXIdnbC"
};
const $6437c80744d7a710$export$6430bc5d6cac94e6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(58);
    const { status: t1, onStop: onStop, onFollow: onFollow, useShortMessages: t2, showProgressBar: t3, isComplete: isComplete, onCompleteAnimationFinished: onCompleteAnimationFinished, useRotatingTitle: t4, customRotatingMessages: customRotatingMessages, startedAt: startedAt, progressTarget: progressTarget, firstMessage: firstMessage } = t0;
    const status = t1 === undefined ? "analyzing" : t1;
    const useShortMessages = t2 === undefined ? false : t2;
    const showProgressBar = t3 === undefined ? false : t3;
    const useRotatingTitle = t4 === undefined ? false : t4;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t5;
    if ($[0] !== isComplete || $[1] !== onCompleteAnimationFinished || $[2] !== progressTarget || $[3] !== startedAt) {
        t5 = {
            isComplete: isComplete,
            onCompleteAnimationFinished: onCompleteAnimationFinished,
            startedAt: startedAt,
            target: progressTarget
        };
        $[0] = isComplete;
        $[1] = onCompleteAnimationFinished;
        $[2] = progressTarget;
        $[3] = startedAt;
        $[4] = t5;
    } else t5 = $[4];
    const progress = (0, $7VOWp.useProgressFacade)(t5);
    const t6 = status === "editing" ? useShortMessages ? (0, $02Wb7.default).editingTextShort : (0, $02Wb7.default).editingText : useShortMessages ? (0, $02Wb7.default).thinkingTextShort : (0, $02Wb7.default).thinkingText;
    let t7;
    if ($[5] !== formatMessage || $[6] !== t6) {
        t7 = formatMessage(t6);
        $[5] = formatMessage;
        $[6] = t6;
        $[7] = t7;
    } else t7 = $[7];
    const staticTitle = t7;
    const rotatingEnabled = useRotatingTitle && !useShortMessages;
    let t8;
    if ($[8] !== formatMessage) {
        t8 = formatMessage($6437c80744d7a710$var$rotatingMessages.rovoIsThinking);
        $[8] = formatMessage;
        $[9] = t8;
    } else t8 = $[9];
    let t9;
    if ($[10] !== formatMessage) {
        t9 = formatMessage($6437c80744d7a710$var$rotatingMessages.analyzingContent);
        $[10] = formatMessage;
        $[11] = t9;
    } else t9 = $[11];
    let t10;
    if ($[12] !== formatMessage) {
        t10 = formatMessage($6437c80744d7a710$var$rotatingMessages.puttingPiecesTogether);
        $[12] = formatMessage;
        $[13] = t10;
    } else t10 = $[13];
    let t11;
    if ($[14] !== formatMessage) {
        t11 = formatMessage($6437c80744d7a710$var$rotatingMessages.structuringResponse);
        $[14] = formatMessage;
        $[15] = t11;
    } else t11 = $[15];
    let t12;
    if ($[16] !== formatMessage) {
        t12 = formatMessage($6437c80744d7a710$var$rotatingMessages.designingResponse);
        $[16] = formatMessage;
        $[17] = t12;
    } else t12 = $[17];
    let t13;
    if ($[18] !== formatMessage) {
        t13 = formatMessage($6437c80744d7a710$var$rotatingMessages.addingItAllTogether);
        $[18] = formatMessage;
        $[19] = t13;
    } else t13 = $[19];
    let t14;
    if ($[20] !== formatMessage) {
        t14 = formatMessage($6437c80744d7a710$var$rotatingMessages.applyingFinalTouches);
        $[20] = formatMessage;
        $[21] = t14;
    } else t14 = $[21];
    let t15;
    if ($[22] !== formatMessage) {
        t15 = formatMessage($6437c80744d7a710$var$rotatingMessages.almostDone);
        $[22] = formatMessage;
        $[23] = t15;
    } else t15 = $[23];
    let t16;
    if ($[24] !== t10 || $[25] !== t11 || $[26] !== t12 || $[27] !== t13 || $[28] !== t14 || $[29] !== t15 || $[30] !== t8 || $[31] !== t9) {
        t16 = [
            t8,
            t9,
            t10,
            t11,
            t12,
            t13,
            t14,
            t15
        ];
        $[24] = t10;
        $[25] = t11;
        $[26] = t12;
        $[27] = t13;
        $[28] = t14;
        $[29] = t15;
        $[30] = t8;
        $[31] = t9;
        $[32] = t16;
    } else t16 = $[32];
    const defaultRotatingTitles = t16;
    const rotatingTitles = customRotatingMessages && customRotatingMessages.length > 0 ? customRotatingMessages : defaultRotatingTitles;
    const { index: rotatingIndex, text: rotatingTitle } = $6437c80744d7a710$var$useSequentialText(rotatingTitles, rotatingEnabled, startedAt);
    const isFirstStatus = rotatingEnabled && rotatingIndex === 0 && (0, $2pQiO.UNSAFE_expValNoExposure)("platform_editor_ai_content_suggested_edits", "isEnabled", false);
    const firstStatusTitle = isFirstStatus && firstMessage?.text != null ? firstMessage.text : rotatingTitle;
    const firstStatusIcon = isFirstStatus ? firstMessage?.icon : undefined;
    const title = rotatingEnabled ? firstStatusTitle : staticTitle;
    const hasFirstStatusIcon = firstStatusIcon != null;
    let t17;
    if ($[33] !== formatMessage || $[34] !== onFollow) {
        t17 = onFollow && /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            onClick: onFollow
        }, formatMessage((0, $02Wb7.default).followAiMateButton));
        $[33] = formatMessage;
        $[34] = onFollow;
        $[35] = t17;
    } else t17 = $[35];
    let t18;
    if ($[36] !== formatMessage) {
        t18 = formatMessage((0, $02Wb7.default).stopGeneratingButtonLabel);
        $[36] = formatMessage;
        $[37] = t18;
    } else t18 = $[37];
    let t19;
    if ($[38] !== onStop || $[39] !== t18) {
        t19 = /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
            isTooltipDisabled: false,
            shape: "default",
            onClick: onStop,
            icon: $6437c80744d7a710$var$_temp,
            label: t18
        });
        $[38] = onStop;
        $[39] = t18;
        $[40] = t19;
    } else t19 = $[40];
    let t20;
    if ($[41] !== t17 || $[42] !== t19) {
        t20 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            testId: "inline-chat__thinking-view",
            alignBlock: "center",
            space: "space.100",
            xcss: $6437c80744d7a710$var$styles.actions
        }, t17, t19);
        $[41] = t17;
        $[42] = t19;
        $[43] = t20;
    } else t20 = $[43];
    const actionsNode = t20;
    let t21;
    if ($[44] !== firstStatusIcon || $[45] !== hasFirstStatusIcon) {
        t21 = hasFirstStatusIcon ? {
            icon: firstStatusIcon,
            disableMorphingAnimation: true
        } : {};
        $[44] = firstStatusIcon;
        $[45] = hasFirstStatusIcon;
        $[46] = t21;
    } else t21 = $[46];
    let t22;
    if ($[47] !== progress || $[48] !== showProgressBar || $[49] !== title) {
        t22 = showProgressBar ? /*#__PURE__*/ $cozmU.createElement((0, $1kxki.RainbowProgressBar), {
            testId: "rovo-thinking-progress-bar",
            progress: progress,
            appearance: "static-rainbow",
            label: title
        }) : undefined;
        $[47] = progress;
        $[48] = showProgressBar;
        $[49] = title;
        $[50] = t22;
    } else t22 = $[50];
    let t23;
    if ($[51] !== t21 || $[52] !== t22 || $[53] !== title) {
        t23 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $6437c80744d7a710$var$styles.indicatorWrapper
        }, /*#__PURE__*/ $cozmU.createElement((0, $2diYd.RovoThinkingIndicator), {
            title: title,
            animation: true,
            ...t21,
            bottomAdornment: t22
        }));
        $[51] = t21;
        $[52] = t22;
        $[53] = title;
        $[54] = t23;
    } else t23 = $[54];
    let t24;
    if ($[55] !== actionsNode || $[56] !== t23) {
        t24 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $6437c80744d7a710$var$styles.container
        }, t23, actionsNode);
        $[55] = actionsNode;
        $[56] = t23;
        $[57] = t24;
    } else t24 = $[57];
    return t24;
} : ({ status: status = 'analyzing', onStop: onStop, onFollow: onFollow, useShortMessages: useShortMessages = false, showProgressBar: showProgressBar = false, isComplete: isComplete, onCompleteAnimationFinished: onCompleteAnimationFinished, useRotatingTitle: useRotatingTitle = false, customRotatingMessages: customRotatingMessages, startedAt: startedAt, progressTarget: progressTarget, firstMessage: firstMessage })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const progress = (0, $7VOWp.useProgressFacade)({
        isComplete: isComplete,
        onCompleteAnimationFinished: onCompleteAnimationFinished,
        startedAt: startedAt,
        target: progressTarget
    });
    const staticTitle = formatMessage(status === 'editing' ? useShortMessages ? (0, $02Wb7.default).editingTextShort : (0, $02Wb7.default).editingText : useShortMessages ? (0, $02Wb7.default).thinkingTextShort : (0, $02Wb7.default).thinkingText);
    const rotatingEnabled = useRotatingTitle && !useShortMessages;
    const defaultRotatingTitles = [
        formatMessage($6437c80744d7a710$var$rotatingMessages.rovoIsThinking),
        formatMessage($6437c80744d7a710$var$rotatingMessages.analyzingContent),
        formatMessage($6437c80744d7a710$var$rotatingMessages.puttingPiecesTogether),
        formatMessage($6437c80744d7a710$var$rotatingMessages.structuringResponse),
        formatMessage($6437c80744d7a710$var$rotatingMessages.designingResponse),
        formatMessage($6437c80744d7a710$var$rotatingMessages.addingItAllTogether),
        formatMessage($6437c80744d7a710$var$rotatingMessages.applyingFinalTouches),
        formatMessage($6437c80744d7a710$var$rotatingMessages.almostDone)
    ];
    const rotatingTitles = customRotatingMessages && customRotatingMessages.length > 0 ? customRotatingMessages : defaultRotatingTitles;
    const { index: rotatingIndex, text: rotatingTitle } = $6437c80744d7a710$var$useSequentialText(rotatingTitles, rotatingEnabled, startedAt); // The first rotating status can be overridden with custom text and/or an icon
    // (e.g. an agent name and avatar) shown in place of the morphing thinking icon.
    // Gated behind the suggested-edits experiment; when off, the bar ignores
    // `firstMessage` and shows the generic first status with the morphing icon.
    const isFirstStatus = rotatingEnabled && rotatingIndex === 0 && (0, $2pQiO.UNSAFE_expValNoExposure)('platform_editor_ai_content_suggested_edits', 'isEnabled', false);
    const firstStatusTitle = isFirstStatus && firstMessage?.text != null ? firstMessage.text : rotatingTitle;
    const firstStatusIcon = isFirstStatus ? firstMessage?.icon : undefined;
    const title = rotatingEnabled ? firstStatusTitle : staticTitle;
    const hasFirstStatusIcon = firstStatusIcon != null;
    const actionsNode = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        testId: "inline-chat__thinking-view",
        alignBlock: "center",
        space: "space.100",
        xcss: $6437c80744d7a710$var$styles.actions
    }, onFollow && /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: onFollow
    }, formatMessage((0, $02Wb7.default).followAiMateButton)), /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        isTooltipDisabled: false,
        shape: 'default',
        onClick: onStop,
        icon: (iconProps)=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1pTZX))), {
                ...iconProps,
                color: "var(--ds-icon-danger, #C9372C)",
                label: ''
            }),
        label: formatMessage((0, $02Wb7.default).stopGeneratingButtonLabel)
    }));
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $6437c80744d7a710$var$styles.container
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $6437c80744d7a710$var$styles.indicatorWrapper
    }, /*#__PURE__*/ $cozmU.createElement((0, $2diYd.RovoThinkingIndicator), {
        title: title,
        animation: true // Only override the icon under the gated first-status path; otherwise the
        ,
        ...hasFirstStatusIcon ? {
            icon: firstStatusIcon,
            disableMorphingAnimation: true
        } : {},
        bottomAdornment: showProgressBar ? /*#__PURE__*/ $cozmU.createElement((0, $1kxki.RainbowProgressBar), {
            testId: "rovo-thinking-progress-bar",
            progress: progress,
            appearance: "static-rainbow",
            label: title
        }) : undefined
    })), actionsNode);
};
function $6437c80744d7a710$var$_temp(iconProps) {
    return /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1pTZX))), {
        ...iconProps,
        color: "var(--ds-icon-danger, #C9372C)",
        label: ""
    });
}
module.exports["RovoThinkingBar"] = $6437c80744d7a710$export$6430bc5d6cac94e6;

});

parcelRegister("1kxki", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $12c61bdb5e5d4432$var$slideAnimation = null; // 'planning' / 'running' animation: scroll a 200% wide inner div by -50% of its
// own width so it loops seamlessly within the fixed-width clip region.
const $12c61bdb5e5d4432$var$scrollAnimation = null; // Order: orange, green, blue, purple
const $12c61bdb5e5d4432$var$COLORS = [
    "var(--ds-chart-categorical-4, #F68909)",
    // orange
    "var(--ds-chart-categorical-2, #82B536)",
    // green
    "var(--ds-chart-categorical-1, #357DE8)",
    // blue
    "var(--ds-chart-categorical-3, #BF63F3)" // purple
];
const $12c61bdb5e5d4432$var$COMPLETE_COLOR = "var(--ds-chart-categorical-2, #82B536)"; // green
const $12c61bdb5e5d4432$var$containerStyles = null;
const $12c61bdb5e5d4432$var$containerThickStyles = null; // 'start': sliding train of divs
const $12c61bdb5e5d4432$var$trainStyles = null;
const $12c61bdb5e5d4432$var$blockStyles = null; // Scroll train blocks are 1/8th of the inner div width (which is 200% of the clip container)
const $12c61bdb5e5d4432$var$scrollBlockStyles = null;
const $12c61bdb5e5d4432$var$scrollInnerStyles = null;
const $12c61bdb5e5d4432$var$completeStyles = null; // Clipping container for 'planning' and 'running' — width is set dynamically via inline style
const $12c61bdb5e5d4432$var$scrollRegionStyles = null; // Determinate mode: width is driven by the `progress` prop. Parents are
// responsible for animating it smoothly (e.g. via requestAnimationFrame).
const $12c61bdb5e5d4432$var$determinateRegionStyles = null; // Static rainbow: same 4 color blocks as the animated version, no scroll.
const $12c61bdb5e5d4432$var$staticRainbowFillStyles = null;
const $12c61bdb5e5d4432$var$solidFillStyles = null; /**
                               * Determinate-mode fill style:
                               * - `'rainbow'`: scrolling rainbow color blocks
                               * - `'static-rainbow'`: static rainbow gradient
                               * - any other string: a solid CSS color (e.g. a design token value)
                               */ 
const $12c61bdb5e5d4432$var$ColorTrain = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                "_3iDTPbQ4SZ _1mT5xdWVPG _0jFU0VN91d _1gBibyGxWQ _0nFVCGf8V9 _03m2nySHWH _43vdfTHVQb"
            ])
        }, $12c61bdb5e5d4432$var$COLORS.map($12c61bdb5e5d4432$var$_temp));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _1mT5xdWVPG _0jFU0VN91d _1gBibyGxWQ _0nFVCGf8V9 _03m2nySHWH _43vdfTHVQb"
        ])
    }, $12c61bdb5e5d4432$var$COLORS.map((color)=>/*#__PURE__*/ $cozmU.createElement("div", {
            key: color,
            style: {
                backgroundColor: color
            },
            className: (0, $hekY6.default)([
                "_2O5Vij7dHp _3YEZNOdnbC _1bHrqExav9 _0jFU0VN91d"
            ])
        })));
const $12c61bdb5e5d4432$var$ScrollTrainInner = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                "_3iDTPbQ4SZ _0jFU0VN91d _39xV02xxUt _1gBiby7Xiq _0nFVCGf8V9 _03m2nySHWH _43vdfTHVQb"
            ])
        }, [
            0,
            1
        ].map($12c61bdb5e5d4432$var$_temp2));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0jFU0VN91d _39xV02xxUt _1gBiby7Xiq _0nFVCGf8V9 _03m2nySHWH _43vdfTHVQb"
        ])
    }, [
        0,
        1
    ].map((copy)=>$12c61bdb5e5d4432$var$COLORS.map((color)=>/*#__PURE__*/ $cozmU.createElement("div", {
                key: `${copy}-${color}`,
                style: {
                    backgroundColor: color
                },
                className: (0, $hekY6.default)([
                    "_2O5Vij7dHp _3YEZNOdnbC _1bHrqETz69 _0jFU0VN91d"
                ])
            }))));
const $12c61bdb5e5d4432$var$ARIA_VALUE_TEXT = {
    planning: 'Planning...',
    running: 'Running...'
};
const $12c61bdb5e5d4432$var$StaticRainbowFill = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                "_3iDTPbQ4SZ _0jFU0VN91d _39xV02N91d"
            ])
        }, $12c61bdb5e5d4432$var$COLORS.map($12c61bdb5e5d4432$var$_temp3));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0jFU0VN91d _39xV02N91d"
        ])
    }, $12c61bdb5e5d4432$var$COLORS.map((color)=>/*#__PURE__*/ $cozmU.createElement("div", {
            key: color,
            style: {
                backgroundColor: color
            },
            className: (0, $hekY6.default)([
                "_2O5Vij7dHp _3YEZNOdnbC _1bHrqExav9 _0jFU0VN91d"
            ])
        })));
const $12c61bdb5e5d4432$var$DeterminateFill = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { appearance: appearance } = t0;
    if (appearance === "rainbow") {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ $cozmU.createElement($12c61bdb5e5d4432$var$ScrollTrainInner, null);
            $[0] = t1;
        } else t1 = $[0];
        return t1;
    }
    if (appearance === "static-rainbow") {
        let t1;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ $cozmU.createElement($12c61bdb5e5d4432$var$StaticRainbowFill, null);
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    let t1;
    if ($[2] !== appearance) {
        t1 = {
            backgroundColor: appearance
        };
        $[2] = appearance;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            "_49OCfRdnbC _1mT5xdWVPG"
        ]);
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t1 || $[6] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement("div", {
            style: t1,
            className: t2
        });
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ appearance: appearance })=>{
    if (appearance === 'rainbow') return /*#__PURE__*/ $cozmU.createElement($12c61bdb5e5d4432$var$ScrollTrainInner, null);
    if (appearance === 'static-rainbow') return /*#__PURE__*/ $cozmU.createElement($12c61bdb5e5d4432$var$StaticRainbowFill, null);
     // Treat any other string as a CSS color.
    return /*#__PURE__*/ $cozmU.createElement("div", {
        style: {
            backgroundColor: appearance
        },
        className: (0, $hekY6.default)([
            "_49OCfRdnbC _1mT5xdWVPG"
        ])
    });
};
const $12c61bdb5e5d4432$export$38b7902100288853 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { testId: testId, status: t1, label: t2, progress: progress, appearance: t3, thickness: t4 } = t0;
    const status = t1 === undefined ? "start" : t1;
    const label = t2 === undefined ? "Loading" : t2;
    const appearance = t3 === undefined ? "rainbow" : t3;
    const thickness = t4 === undefined ? "default" : t4;
    const isDeterminate = progress !== undefined;
    const isComplete = status === "complete";
    const ariaValueText = isDeterminate ? undefined : $12c61bdb5e5d4432$var$ARIA_VALUE_TEXT[status];
    const clampedProgress = isDeterminate ? Math.min(100, Math.max(0, progress)) : undefined;
    let t5;
    if ($[0] !== clampedProgress || $[1] !== isComplete || $[2] !== isDeterminate) {
        t5 = isDeterminate ? Math.round(clampedProgress) : isComplete ? 100 : undefined;
        $[0] = clampedProgress;
        $[1] = isComplete;
        $[2] = isDeterminate;
        $[3] = t5;
    } else t5 = $[3];
    const t6 = isDeterminate || isComplete ? 0 : undefined;
    const t7 = isDeterminate || isComplete ? 100 : undefined;
    const t8 = thickness === "thick" && "_0bjKvDS5Zs _0jFU0VZimw";
    let t9;
    if ($[4] !== t8) {
        t9 = (0, $hekY6.default)([
            "_0bjKvDcjp5 _4bt5LAnQyn _2WAcuGnQyn _39xV02N91d _0jFU0V4Y4b _1mT5xdRAKS _0KLXruDMqu",
            t8
        ]);
        $[4] = t8;
        $[5] = t9;
    } else t9 = $[5];
    let t10;
    if ($[6] !== appearance || $[7] !== clampedProgress || $[8] !== isComplete || $[9] !== isDeterminate || $[10] !== status) {
        t10 = isDeterminate ? /*#__PURE__*/ $cozmU.createElement("div", {
            style: {
                width: `${clampedProgress}%`
            },
            className: (0, $hekY6.default)([
                "_4bt5LAnQyn _2WAcuGnQyn _1mT5xdWVPG _2IhTondnbC _3OE6xYdnbC _0jFU0VN91d"
            ])
        }, /*#__PURE__*/ $cozmU.createElement($12c61bdb5e5d4432$var$DeterminateFill, {
            appearance: appearance
        })) : isComplete ? /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                "_49OCfRdnbC _1mT5xdWVPG _0KLXruVNK6"
            ])
        }) : status === "planning" || status === "running" ? /*#__PURE__*/ $cozmU.createElement("div", {
            style: {
                width: status === "planning" ? "30%" : "60%"
            },
            className: (0, $hekY6.default)([
                "_4bt5LAnQyn _2WAcuGnQyn _1mT5xdWVPG _2IhTondnbC _3OE6xYdnbC _0jFU0VN91d"
            ])
        }, /*#__PURE__*/ $cozmU.createElement($12c61bdb5e5d4432$var$ScrollTrainInner, null)) : /*#__PURE__*/ $cozmU.createElement($12c61bdb5e5d4432$var$ColorTrain, null);
        $[6] = appearance;
        $[7] = clampedProgress;
        $[8] = isComplete;
        $[9] = isDeterminate;
        $[10] = status;
        $[11] = t10;
    } else t10 = $[11];
    let t11;
    if ($[12] !== ariaValueText || $[13] !== label || $[14] !== t10 || $[15] !== t5 || $[16] !== t6 || $[17] !== t7 || $[18] !== t9 || $[19] !== testId) {
        t11 = /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": testId,
            role: "progressbar",
            "aria-label": label,
            "aria-valuetext": ariaValueText,
            "aria-valuenow": t5,
            "aria-valuemin": t6,
            "aria-valuemax": t7,
            className: t9
        }, t10);
        $[12] = ariaValueText;
        $[13] = label;
        $[14] = t10;
        $[15] = t5;
        $[16] = t6;
        $[17] = t7;
        $[18] = t9;
        $[19] = testId;
        $[20] = t11;
    } else t11 = $[20];
    return t11;
} : ({ testId: testId, status: status = 'start', label: label = 'Loading', progress: progress, appearance: appearance = 'rainbow', thickness: thickness = 'default' })=>{
    const isDeterminate = progress !== undefined;
    const isComplete = status === 'complete'; // Indeterminate states: omit aria-valuenow/min/max (per the ARIA spec) and
    // surface contextual feedback via aria-valuetext for planning/running.
    const ariaValueText = isDeterminate ? undefined : $12c61bdb5e5d4432$var$ARIA_VALUE_TEXT[status];
    const clampedProgress = isDeterminate ? Math.min(100, Math.max(0, progress)) : undefined;
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId,
        role: "progressbar",
        "aria-label": label,
        "aria-valuetext": ariaValueText,
        "aria-valuenow": isDeterminate ? Math.round(clampedProgress) : isComplete ? 100 : undefined,
        "aria-valuemin": isDeterminate || isComplete ? 0 : undefined,
        "aria-valuemax": isDeterminate || isComplete ? 100 : undefined,
        className: (0, $hekY6.default)([
            "_0bjKvDcjp5 _4bt5LAnQyn _2WAcuGnQyn _39xV02N91d _0jFU0V4Y4b _1mT5xdRAKS _0KLXruDMqu",
            thickness === 'thick' && "_0bjKvDS5Zs _0jFU0VZimw"
        ])
    }, isDeterminate ? /*#__PURE__*/ $cozmU.createElement("div", {
        style: {
            width: `${clampedProgress}%`
        },
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _1mT5xdWVPG _2IhTondnbC _3OE6xYdnbC _0jFU0VN91d"
        ])
    }, /*#__PURE__*/ $cozmU.createElement($12c61bdb5e5d4432$var$DeterminateFill, {
        appearance: appearance
    })) : isComplete ? /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_49OCfRdnbC _1mT5xdWVPG _0KLXruVNK6"
        ])
    }) : status === 'planning' || status === 'running' ? /*#__PURE__*/ $cozmU.createElement("div", {
        style: {
            width: status === 'planning' ? '30%' : '60%'
        },
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _1mT5xdWVPG _2IhTondnbC _3OE6xYdnbC _0jFU0VN91d"
        ])
    }, /*#__PURE__*/ $cozmU.createElement($12c61bdb5e5d4432$var$ScrollTrainInner, null)) : // Full-bar sliding train (start).
    /*#__PURE__*/ $cozmU.createElement($12c61bdb5e5d4432$var$ColorTrain, null));
};
function $12c61bdb5e5d4432$var$_temp(color) {
    return /*#__PURE__*/ $cozmU.createElement("div", {
        key: color,
        style: {
            backgroundColor: color
        },
        className: (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNOdnbC _1bHrqExav9 _0jFU0VN91d"
        ])
    });
}
function $12c61bdb5e5d4432$var$_temp2(copy) {
    return $12c61bdb5e5d4432$var$COLORS.map((color)=>/*#__PURE__*/ $cozmU.createElement("div", {
            key: `${copy}-${color}`,
            style: {
                backgroundColor: color
            },
            className: (0, $hekY6.default)([
                "_2O5Vij7dHp _3YEZNOdnbC _1bHrqETz69 _0jFU0VN91d"
            ])
        }));
}
function $12c61bdb5e5d4432$var$_temp3(color) {
    return /*#__PURE__*/ $cozmU.createElement("div", {
        key: color,
        style: {
            backgroundColor: color
        },
        className: (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNOdnbC _1bHrqExav9 _0jFU0VN91d"
        ])
    });
}
module.exports["RainbowProgressBar"] = $12c61bdb5e5d4432$export$38b7902100288853;

});

parcelRegister("2diYd", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $6wOvs = parcelRequire("6wOvs");


var $f6wWZ = parcelRequire("f6wWZ");


var $ikV3b = parcelRequire("ikV3b");


var $k22Xw = parcelRequire("k22Xw");

const $4ec713fa0db90eb4$var$styles = {
    root: "_0jFU0VoWWg _3iDTPbQ4SZ _0aFT5v1qpb _37wbyuecOK _3TGfC9LRg7 _0hPCNLDIqT",
    rootWithAdornment: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _2mHwu82ADO _3iDTPbQ4SZ _0aFT5v1qpb _37wbyuecOK _3TGfC9LRg7 _0hPCNLDIqT",
    iconContainer: "_2mHwu82ADO _0adFHsFQfX _3iDTPbQ4SZ _0hPCNLDIqT",
    textColumn: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _2mHwu81Y8M _3iDTPbQ4SZ _0aFT5vbt8w",
    textRow: "_0jFU0VoWWg _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT",
    text: "_2sNsIgmnOE _1UtDYzy7kJ _3W2Oc8wPeg",
    textSmall: "_2sNsIg7NXe _1UtDYzy7kJ _3W2Oc8wPeg",
    textNoWrap: "_2sNsIgmnOE _4bt5LAnQyn _2WAcuGnQyn _1UtDYzy7kJ _1ANEUSLRg7",
    textNoWrapSmall: "_2sNsIg7NXe _4bt5LAnQyn _2WAcuGnQyn _1UtDYzy7kJ _1ANEUSLRg7",
    ellipsesContainer: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG"
};
const $4ec713fa0db90eb4$var$getTextStyleKey = (textSize, showEllipsis)=>{
    if (textSize === 'small') {
        if (showEllipsis) return 'textNoWrapSmall';
        return 'textSmall';
    }
    if (showEllipsis) return 'textNoWrap';
    return 'text';
};
const $4ec713fa0db90eb4$var$getLoadingMorphingIcon = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ikV3b.MorphingShapeLoader), {
        testId: "morphing-loader"
    });
};
const $4ec713fa0db90eb4$var$getIcon = (icon)=>{
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(icon)) return icon;
    else if (icon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $k22Xw.LazyAnimatedRovoIcon), {
        alt: "Rovo",
        testId: "rovo-loading-animation",
        width: "24px",
        height: "24px"
    });
    return null;
};
const $4ec713fa0db90eb4$export$cc468b3595726b51 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(33);
    const { title: title, isAnimated: t1, icon: t2, animation: t3, disableMorphingAnimation: t4, showEllipsis: t5, textSize: t6, testId: testId, bottomAdornment: bottomAdornment } = t0;
    const isAnimated = t1 === undefined ? true : t1;
    const icon = t2 === undefined ? true : t2;
    const animation = t3 === undefined ? false : t3;
    const disableMorphingAnimation = t4 === undefined ? false : t4;
    const showEllipsis = t5 === undefined ? true : t5;
    const textSize = t6 === undefined ? "default" : t6;
    const enableAnimation = animation;
    let t7;
    if ($[0] !== disableMorphingAnimation || $[1] !== enableAnimation || $[2] !== icon) {
        t7 = enableAnimation && !disableMorphingAnimation ? $4ec713fa0db90eb4$var$getLoadingMorphingIcon() : $4ec713fa0db90eb4$var$getIcon(icon);
        $[0] = disableMorphingAnimation;
        $[1] = enableAnimation;
        $[2] = icon;
        $[3] = t7;
    } else t7 = $[3];
    const iconNode = t7;
    const t8 = $4ec713fa0db90eb4$var$styles[$4ec713fa0db90eb4$var$getTextStyleKey(textSize, showEllipsis)];
    let t9;
    if ($[4] !== enableAnimation || $[5] !== textSize || $[6] !== title) {
        t9 = enableAnimation ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wOvs.ShimmerText), {
            size: textSize === "small" ? "small" : "medium"
        }, title) : title;
        $[4] = enableAnimation;
        $[5] = textSize;
        $[6] = title;
        $[7] = t9;
    } else t9 = $[7];
    let t10;
    if ($[8] !== t8 || $[9] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t8
        }, t9);
        $[8] = t8;
        $[9] = t9;
        $[10] = t10;
    } else t10 = $[10];
    const textNode = t10;
    let t11;
    if ($[11] !== isAnimated || $[12] !== showEllipsis) {
        t11 = showEllipsis ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $4ec713fa0db90eb4$var$styles.ellipsesContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f6wWZ.EllipsesAnimation), {
            isAnimated: isAnimated
        })) : null;
        $[11] = isAnimated;
        $[12] = showEllipsis;
        $[13] = t11;
    } else t11 = $[13];
    const ellipsesNode = t11;
    if (bottomAdornment) {
        let t12;
        if ($[14] !== iconNode) {
            t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $4ec713fa0db90eb4$var$styles.iconContainer
            }, iconNode);
            $[14] = iconNode;
            $[15] = t12;
        } else t12 = $[15];
        let t13;
        if ($[16] !== ellipsesNode || $[17] !== textNode) {
            t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $4ec713fa0db90eb4$var$styles.textRow
            }, textNode, ellipsesNode);
            $[16] = ellipsesNode;
            $[17] = textNode;
            $[18] = t13;
        } else t13 = $[18];
        let t14;
        if ($[19] !== bottomAdornment || $[20] !== t13) {
            t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $4ec713fa0db90eb4$var$styles.textColumn
            }, t13, bottomAdornment);
            $[19] = bottomAdornment;
            $[20] = t13;
            $[21] = t14;
        } else t14 = $[21];
        let t15;
        if ($[22] !== t12 || $[23] !== t14 || $[24] !== testId) {
            t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $4ec713fa0db90eb4$var$styles.rootWithAdornment,
                testId: testId
            }, t12, t14);
            $[22] = t12;
            $[23] = t14;
            $[24] = testId;
            $[25] = t15;
        } else t15 = $[25];
        return t15;
    }
    let t12;
    if ($[26] !== iconNode || $[27] !== textNode) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $4ec713fa0db90eb4$var$styles.iconContainer
        }, iconNode, textNode);
        $[26] = iconNode;
        $[27] = textNode;
        $[28] = t12;
    } else t12 = $[28];
    let t13;
    if ($[29] !== ellipsesNode || $[30] !== t12 || $[31] !== testId) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $4ec713fa0db90eb4$var$styles.root,
            testId: testId
        }, t12, ellipsesNode);
        $[29] = ellipsesNode;
        $[30] = t12;
        $[31] = testId;
        $[32] = t13;
    } else t13 = $[32];
    return t13;
} : ({ title: title, isAnimated: isAnimated = true, icon: icon = true, animation: animation = false, disableMorphingAnimation: disableMorphingAnimation = false, showEllipsis: showEllipsis = true, textSize: textSize = 'default', testId: testId, bottomAdornment: bottomAdornment })=>{
    const enableAnimation = animation;
    const iconNode = enableAnimation && !disableMorphingAnimation ? $4ec713fa0db90eb4$var$getLoadingMorphingIcon() : $4ec713fa0db90eb4$var$getIcon(icon);
    const textNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4ec713fa0db90eb4$var$styles[$4ec713fa0db90eb4$var$getTextStyleKey(textSize, showEllipsis)]
    }, enableAnimation ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wOvs.ShimmerText), {
        size: textSize === 'small' ? 'small' : 'medium'
    }, title) : title);
    const ellipsesNode = showEllipsis ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4ec713fa0db90eb4$var$styles.ellipsesContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f6wWZ.EllipsesAnimation), {
        isAnimated: isAnimated
    })) : null;
    if (bottomAdornment) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4ec713fa0db90eb4$var$styles.rootWithAdornment,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4ec713fa0db90eb4$var$styles.iconContainer
    }, iconNode), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4ec713fa0db90eb4$var$styles.textColumn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4ec713fa0db90eb4$var$styles.textRow
    }, textNode, ellipsesNode), bottomAdornment));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4ec713fa0db90eb4$var$styles.root,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4ec713fa0db90eb4$var$styles.iconContainer
    }, iconNode, textNode), ellipsesNode);
};
module.exports["RovoThinkingIndicator"] = $4ec713fa0db90eb4$export$cc468b3595726b51;

});

parcelRegister("6wOvs", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $4aRua = parcelRequire("4aRua");

const $b90e25146b4dbd96$var$shimmerAnimation = null;
const $b90e25146b4dbd96$var$shimmerGradient = null; /** Single-line ellipsis + flex/grid-safe width. */ 
const $b90e25146b4dbd96$var$truncateSingleLine = null;
const $b90e25146b4dbd96$export$f35c7d979dec8662 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { as: t1, children: children, size: t2, weight: t3, truncate: t4 } = t0;
    const as = t1 === undefined ? "div" : t1;
    const size = t2 === undefined ? "medium" : t2;
    const weight = t3 === undefined ? "regular" : t3;
    const truncate = t4 === undefined ? false : t4;
    let t5;
    if ($[0] !== children || $[1] !== size || $[2] !== weight) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            size: size,
            weight: weight,
            color: "color.text.subtlest"
        }, children);
        $[0] = children;
        $[1] = size;
        $[2] = weight;
        $[3] = t5;
    } else t5 = $[3];
    const content = t5;
    if (as === "span") {
        const t6 = truncate && "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _1ANEUSLRg7 _4ouGXIdnbC _39xV02N91d _1EqgXlN91d";
        let t7;
        if ($[4] !== t6) {
            t7 = (0, $hekY6.default)([
                "_2uo31fSyNX _2fBhteSSZw _3OqcjTzGaF _02U3A5JxkL _1CY1NjjOvk _07XDTDJxkL",
                t6
            ]);
            $[4] = t6;
            $[5] = t7;
        } else t7 = $[5];
        let t8;
        if ($[6] !== content || $[7] !== t7) {
            t8 = /*#__PURE__*/ $cozmU.createElement("span", {
                className: t7
            }, content);
            $[6] = content;
            $[7] = t7;
            $[8] = t8;
        } else t8 = $[8];
        return t8;
    }
    const t6 = truncate && "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _1ANEUSLRg7 _4ouGXIdnbC _39xV02N91d _1EqgXlN91d";
    let t7;
    if ($[9] !== t6) {
        t7 = (0, $hekY6.default)([
            "_2uo31fSyNX _2fBhteSSZw _3OqcjTzGaF _02U3A5JxkL _1CY1NjjOvk _07XDTDJxkL",
            t6
        ]);
        $[9] = t6;
        $[10] = t7;
    } else t7 = $[10];
    let t8;
    if ($[11] !== content || $[12] !== t7) {
        t8 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t7
        }, content);
        $[11] = content;
        $[12] = t7;
        $[13] = t8;
    } else t8 = $[13];
    return t8;
} : ({ as: as = 'div', children: children, size: size = 'medium', weight: weight = 'regular', truncate: truncate = false })=>{
    const content = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: size,
        weight: weight,
        color: "color.text.subtlest"
    }, children);
    if (as === 'span') return /*#__PURE__*/ $cozmU.createElement("span", {
        className: (0, $hekY6.default)([
            "_2uo31fSyNX _2fBhteSSZw _3OqcjTzGaF _02U3A5JxkL _1CY1NjjOvk _07XDTDJxkL",
            truncate && "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _1ANEUSLRg7 _4ouGXIdnbC _39xV02N91d _1EqgXlN91d"
        ])
    }, content);
    return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_2uo31fSyNX _2fBhteSSZw _3OqcjTzGaF _02U3A5JxkL _1CY1NjjOvk _07XDTDJxkL",
            truncate && "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _1ANEUSLRg7 _4ouGXIdnbC _39xV02N91d _1EqgXlN91d"
        ])
    }, content);
};
module.exports["ShimmerText"] = $b90e25146b4dbd96$export$f35c7d979dec8662;

});

parcelRegister("f6wWZ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $942fc30d2b38e6cb$var$animation = null;
const $942fc30d2b38e6cb$var$animation1 = null;
const $942fc30d2b38e6cb$var$animation2 = null;
const $942fc30d2b38e6cb$var$dot1 = null;
const $942fc30d2b38e6cb$var$dot2 = null;
const $942fc30d2b38e6cb$var$dot3 = null;
const $942fc30d2b38e6cb$var$animatedOpacity = null;
const $942fc30d2b38e6cb$export$c0e6915bcce7d1d0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    const { isAnimated: t1 } = t0;
    const isAnimated = t1 === undefined ? true : t1;
    const t2 = isAnimated && "";
    const t3 = isAnimated && "_2fBhteHasb";
    const t4 = isAnimated && $942fc30d2b38e6cb$var$animatedOpacity;
    let t5;
    if ($[0] !== t2 || $[1] !== t3 || $[2] !== t4) {
        t5 = (0, $hekY6.default)([
            t2,
            t3,
            t4
        ]);
        $[0] = t2;
        $[1] = t3;
        $[2] = t4;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement("path", {
            className: t5,
            d: "M0.0800781 2V0.414062H1.67969V2H0.0800781Z",
            fill: "#1868DB"
        });
        $[4] = t5;
        $[5] = t6;
    } else t6 = $[5];
    const t7 = isAnimated && "";
    const t8 = isAnimated && "_2fBhteVjaG";
    const t9 = isAnimated && $942fc30d2b38e6cb$var$animatedOpacity;
    let t10;
    if ($[6] !== t7 || $[7] !== t8 || $[8] !== t9) {
        t10 = (0, $hekY6.default)([
            t7,
            t8,
            t9
        ]);
        $[6] = t7;
        $[7] = t8;
        $[8] = t9;
        $[9] = t10;
    } else t10 = $[9];
    let t11;
    if ($[10] !== t10) {
        t11 = /*#__PURE__*/ $cozmU.createElement("path", {
            className: t10,
            d: "M3.83984 2V0.414062H5.43945V2H3.83984Z",
            fill: "#BF63F3"
        });
        $[10] = t10;
        $[11] = t11;
    } else t11 = $[11];
    const t12 = isAnimated && "";
    const t13 = isAnimated && "_2fBhtegMFr";
    const t14 = isAnimated && $942fc30d2b38e6cb$var$animatedOpacity;
    let t15;
    if ($[12] !== t12 || $[13] !== t13 || $[14] !== t14) {
        t15 = (0, $hekY6.default)([
            t12,
            t13,
            t14
        ]);
        $[12] = t12;
        $[13] = t13;
        $[14] = t14;
        $[15] = t15;
    } else t15 = $[15];
    let t16;
    if ($[16] !== t15) {
        t16 = /*#__PURE__*/ $cozmU.createElement("path", {
            className: t15,
            d: "M7.59961 2V0.414062H9.19922V2H7.59961Z",
            fill: "#FCA700"
        });
        $[16] = t15;
        $[17] = t16;
    } else t16 = $[17];
    let t17;
    if ($[18] !== t11 || $[19] !== t16 || $[20] !== t6) {
        t17 = /*#__PURE__*/ $cozmU.createElement("svg", {
            width: "10",
            height: "2",
            viewBox: "0 0 10 2",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t6, t11, t16);
        $[18] = t11;
        $[19] = t16;
        $[20] = t6;
        $[21] = t17;
    } else t17 = $[21];
    return t17;
} : ({ isAnimated: isAnimated = true })=>{
    return /*#__PURE__*/ $cozmU.createElement("svg", {
        width: "10",
        height: "2",
        viewBox: "0 0 10 2",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $cozmU.createElement("path" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $hekY6.default)([
            isAnimated && "",
            isAnimated && "_2fBhteHasb",
            isAnimated && $942fc30d2b38e6cb$var$animatedOpacity
        ]),
        d: "M0.0800781 2V0.414062H1.67969V2H0.0800781Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ $cozmU.createElement("path" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $hekY6.default)([
            isAnimated && "",
            isAnimated && "_2fBhteVjaG",
            isAnimated && $942fc30d2b38e6cb$var$animatedOpacity
        ]),
        d: "M3.83984 2V0.414062H5.43945V2H3.83984Z",
        fill: "#BF63F3"
    }), /*#__PURE__*/ $cozmU.createElement("path" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $hekY6.default)([
            isAnimated && "",
            isAnimated && "_2fBhtegMFr",
            isAnimated && $942fc30d2b38e6cb$var$animatedOpacity
        ]),
        d: "M7.59961 2V0.414062H9.19922V2H7.59961Z",
        fill: "#FCA700"
    }));
};
module.exports["EllipsesAnimation"] = $942fc30d2b38e6cb$export$c0e6915bcce7d1d0;

});

parcelRegister("ikV3b", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lvJXz = parcelRequire("lvJXz");


var $dRDh9 = parcelRequire("dRDh9");

// Module-level state — persists the current frame across remounts
// so the morphing animation continues smoothly without restarting.
let $922511a0939f4ef0$var$savedFrame = 0;
let $922511a0939f4ef0$var$hasPlayedBefore = false;
const $922511a0939f4ef0$var$getSafeFrame = (frame)=>Number.isFinite(frame) && frame >= 0 ? frame : 0;
const $922511a0939f4ef0$var$SIZE_MAP = {
    small: 16,
    medium: 24,
    large: 32
};
const $922511a0939f4ef0$export$c07a397cf5c24cd8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { testId: testId, size: t1 } = t0;
    const size = t1 === undefined ? "small" : t1;
    const containerRef = (0, $cozmU.useRef)(null);
    const lottieSize = $922511a0939f4ef0$var$SIZE_MAP[size];
    const containerSize = lottieSize + 8;
    let t2;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            const currentRef = containerRef.current;
            if (!currentRef) return;
            const baseAnimationConfig = {
                container: currentRef,
                animationData: (0, (/*@__PURE__*/$parcel$interopDefault($dRDh9))),
                renderer: "svg",
                loop: true
            };
            if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($lvJXz))).loadAnimation !== "function") return;
            const animationInstance = (0, (/*@__PURE__*/$parcel$interopDefault($lvJXz))).loadAnimation({
                ...baseAnimationConfig,
                autoplay: true
            });
            if ($922511a0939f4ef0$var$hasPlayedBefore) animationInstance.goToAndPlay($922511a0939f4ef0$var$getSafeFrame($922511a0939f4ef0$var$savedFrame), true);
            $922511a0939f4ef0$var$hasPlayedBefore = true;
            return ()=>{
                $922511a0939f4ef0$var$savedFrame = $922511a0939f4ef0$var$getSafeFrame(animationInstance.currentFrame);
                animationInstance.destroy();
            };
        };
        t3 = [];
        $[0] = t2;
        $[1] = t3;
    } else {
        t2 = $[0];
        t3 = $[1];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[2] !== containerSize) {
        t4 = {
            width: containerSize,
            height: containerSize,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "visible"
        };
        $[2] = containerSize;
        $[3] = t4;
    } else t4 = $[3];
    const containerStyle = t4;
    let t5;
    if ($[4] !== lottieSize) {
        t5 = {
            width: lottieSize,
            height: lottieSize
        };
        $[4] = lottieSize;
        $[5] = t5;
    } else t5 = $[5];
    const lottieWrapperStyle = t5;
    let t6;
    if ($[6] !== lottieWrapperStyle) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: lottieWrapperStyle,
            ref: containerRef
        });
        $[6] = lottieWrapperStyle;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== containerStyle || $[9] !== t6 || $[10] !== testId) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: containerStyle,
            "data-testid": testId
        }, t6);
        $[8] = containerStyle;
        $[9] = t6;
        $[10] = testId;
        $[11] = t7;
    } else t7 = $[11];
    return t7;
} : ({ testId: testId, size: size = 'small' })=>{
    const containerRef = (0, $cozmU.useRef)(null);
    const lottieSize = $922511a0939f4ef0$var$SIZE_MAP[size];
    const containerSize = lottieSize + 8;
    (0, $cozmU.useEffect)(()=>{
        const currentRef = containerRef.current;
        if (!currentRef) return;
        const baseAnimationConfig = {
            container: currentRef,
            animationData: (0, (/*@__PURE__*/$parcel$interopDefault($dRDh9))),
            renderer: 'svg',
            loop: true
        };
        if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($lvJXz))).loadAnimation !== 'function') return;
        const animationInstance = (0, (/*@__PURE__*/$parcel$interopDefault($lvJXz))).loadAnimation({
            ...baseAnimationConfig,
            autoplay: true
        });
        if ($922511a0939f4ef0$var$hasPlayedBefore) // Remount — resume from saved frame, while still autoplaying as a visible fallback.
        animationInstance.goToAndPlay($922511a0939f4ef0$var$getSafeFrame($922511a0939f4ef0$var$savedFrame), true);
        $922511a0939f4ef0$var$hasPlayedBefore = true;
        return ()=>{
            // Save current frame before destroying
            $922511a0939f4ef0$var$savedFrame = $922511a0939f4ef0$var$getSafeFrame(animationInstance.currentFrame);
            animationInstance.destroy();
        };
    }, []);
    const containerStyle = {
        width: containerSize,
        height: containerSize,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'visible'
    };
    const lottieWrapperStyle = {
        width: lottieSize,
        height: lottieSize
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- static styles for lottie container
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        style: containerStyle,
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        style: lottieWrapperStyle,
        ref: containerRef
    })));
};
module.exports["MorphingShapeLoader"] = $922511a0939f4ef0$export$c07a397cf5c24cd8;

});

parcelRegister("dRDh9", function(module, exports) {
module.exports = JSON.parse("{\"v\":\"5.7.1\",\"fr\":30,\"ip\":0,\"op\":108,\"w\":100,\"h\":100,\"nm\":\"Shape Morph\",\"ddd\":0,\"assets\":[],\"layers\":[{\"ddd\":0,\"ind\":1,\"ty\":4,\"nm\":\"Morph Shape\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[0],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":27,\"s\":[180],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":54,\"s\":[240],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":80,\"s\":[360],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":107,\"s\":[450]}]},\"p\":{\"a\":0,\"k\":[50,50,0]},\"a\":{\"a\":0,\"k\":[0,0,0]},\"s\":{\"a\":0,\"k\":[100,100,100]}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,-50],[6.499999999999993,-49.6],[12.899999999999999,-48.3],[19.099999999999994,-46.2],[25,-43.3],[30.400000000000006,-39.7],[35.400000000000006,-35.4],[39.7,-30.4],[43.3,-25],[46.2,-19.1],[48.3,-12.899999999999999],[49.599999999999994,-6.5],[50,0],[49.599999999999994,6.499999999999993],[48.3,12.899999999999999],[46.2,19.099999999999994],[43.3,25],[39.7,30.400000000000006],[35.400000000000006,35.400000000000006],[30.400000000000006,39.7],[25,43.3],[19.099999999999994,46.2],[12.899999999999999,48.3],[6.499999999999993,49.599999999999994],[0,50],[-6.5,49.599999999999994],[-12.899999999999999,48.3],[-19.1,46.2],[-25,43.3],[-30.4,39.7],[-35.4,35.400000000000006],[-39.7,30.400000000000006],[-43.3,25],[-46.2,19.099999999999994],[-48.3,12.899999999999999],[-49.6,6.499999999999993],[-50,0],[-49.6,-6.5],[-48.3,-12.899999999999999],[-46.2,-19.1],[-43.3,-25],[-39.7,-30.4],[-35.4,-35.4],[-30.4,-39.7],[-25,-43.3],[-19.1,-46.2],[-12.899999999999999,-48.3],[-6.5,-49.6]],\"c\":true}],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":27,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[-50,-50],[-41.7,-50],[-33.3,-50],[-25,-50],[-16.700000000000003,-50],[-8.299999999999997,-50],[0,-50],[8.299999999999997,-50],[16.700000000000003,-50],[25,-50],[33.3,-50],[41.7,-50],[50,-50],[50,-41.7],[50,-33.3],[50,-25],[50,-16.700000000000003],[50,-8.299999999999997],[50,0],[50,8.299999999999997],[50,16.700000000000003],[50,25],[50,33.3],[50,41.7],[50,50],[41.7,50],[33.3,50],[25,50],[16.700000000000003,50],[8.299999999999997,50],[0,50],[-8.299999999999997,50],[-16.700000000000003,50],[-25,50],[-33.3,50],[-41.7,50],[-50,50],[-50,41.7],[-50,33.3],[-50,25],[-50,16.700000000000003],[-50,8.299999999999997],[-50,0],[-50,-8.299999999999997],[-50,-16.700000000000003],[-50,-25],[-50,-33.3],[-50,-41.7]],\"c\":true}],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":54,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,-50],[5.3999999999999915,-46.9],[10.799999999999997,-43.7],[16.200000000000003,-40.6],[21.700000000000003,-37.5],[27.099999999999994,-34.4],[32.5,-31.2],[37.900000000000006,-28.1],[43.3,-25],[43.3,-18.7],[43.3,-12.5],[43.3,-6.200000000000003],[43.3,0],[43.3,6.299999999999997],[43.3,12.5],[43.3,18.799999999999997],[43.3,25],[37.900000000000006,28.099999999999994],[32.5,31.299999999999997],[27.099999999999994,34.400000000000006],[21.700000000000003,37.5],[16.200000000000003,40.599999999999994],[10.799999999999997,43.8],[5.3999999999999915,46.900000000000006],[0,50],[-5.399999999999999,46.900000000000006],[-10.799999999999997,43.8],[-16.200000000000003,40.599999999999994],[-21.699999999999996,37.5],[-27.1,34.400000000000006],[-32.5,31.299999999999997],[-37.9,28.099999999999994],[-43.3,25],[-43.3,18.799999999999997],[-43.3,12.5],[-43.3,6.299999999999997],[-43.3,0],[-43.3,-6.200000000000003],[-43.3,-12.5],[-43.3,-18.8],[-43.3,-25],[-37.9,-28.1],[-32.5,-31.3],[-27.1,-34.4],[-21.699999999999996,-37.5],[-16.200000000000003,-40.6],[-10.799999999999997,-43.7],[-5.399999999999999,-46.9]],\"c\":true}],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":80,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,-50],[3.1000000000000014,-43.7],[6.299999999999997,-37.5],[9.399999999999999,-31.2],[12.5,-25],[15.599999999999994,-18.7],[18.799999999999997,-12.5],[21.900000000000006,-6.200000000000003],[25,0],[28.099999999999994,6.299999999999997],[31.299999999999997,12.5],[34.400000000000006,18.799999999999997],[37.5,25],[40.599999999999994,31.299999999999997],[43.8,37.5],[46.900000000000006,43.8],[50,50],[43.8,50],[37.5,50],[31.299999999999997,50],[25,50],[18.799999999999997,50],[12.5,50],[6.299999999999997,50],[0,50],[-6.200000000000003,50],[-12.5,50],[-18.7,50],[-25,50],[-31.2,50],[-37.5,50],[-43.7,50],[-50,50],[-46.9,43.8],[-43.7,37.5],[-40.6,31.299999999999997],[-37.5,25],[-34.4,18.799999999999997],[-31.2,12.5],[-28.1,6.299999999999997],[-25,0],[-21.9,-6.200000000000003],[-18.7,-12.5],[-15.600000000000001,-18.7],[-12.5,-25],[-9.399999999999999,-31.2],[-6.200000000000003,-37.5],[-3.1000000000000014,-43.7]],\"c\":true}],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":107,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,-50],[6.499999999999993,-49.6],[12.899999999999999,-48.3],[19.099999999999994,-46.2],[25,-43.3],[30.400000000000006,-39.7],[35.400000000000006,-35.4],[39.7,-30.4],[43.3,-25],[46.2,-19.1],[48.3,-12.899999999999999],[49.599999999999994,-6.5],[50,0],[49.599999999999994,6.499999999999993],[48.3,12.899999999999999],[46.2,19.099999999999994],[43.3,25],[39.7,30.400000000000006],[35.400000000000006,35.400000000000006],[30.400000000000006,39.7],[25,43.3],[19.099999999999994,46.2],[12.899999999999999,48.3],[6.499999999999993,49.599999999999994],[0,50],[-6.5,49.599999999999994],[-12.899999999999999,48.3],[-19.1,46.2],[-25,43.3],[-30.4,39.7],[-35.4,35.400000000000006],[-39.7,30.400000000000006],[-43.3,25],[-46.2,19.099999999999994],[-48.3,12.899999999999999],[-49.6,6.499999999999993],[-50,0],[-49.6,-6.5],[-48.3,-12.899999999999999],[-46.2,-19.1],[-43.3,-25],[-39.7,-30.4],[-35.4,-35.4],[-30.4,-39.7],[-25,-43.3],[-19.1,-46.2],[-12.899999999999999,-48.3],[-6.5,-49.6]],\"c\":true}]}]},\"nm\":\"Path\",\"mn\":\"ADBE Vector Shape - Group\"},{\"ty\":\"fl\",\"c\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[0.9607843137254902,0.6509803921568628,0.13725490196078433],\"o\":{\"x\":[0.5],\"y\":[0.5]},\"i\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":5,\"s\":[0.9607843137254902,0.6509803921568628,0.13725490196078433],\"o\":{\"x\":[0.5],\"y\":[0.5]},\"i\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":11,\"s\":[0.5098039215686274,0.7098039215686275,0.21176470588235294],\"o\":{\"x\":[0.5],\"y\":[0.5]},\"i\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":32,\"s\":[0.5098039215686274,0.7098039215686275,0.21176470588235294],\"o\":{\"x\":[0.5],\"y\":[0.5]},\"i\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":37,\"s\":[0.09411764705882353,0.40784313725490196,0.8588235294117647],\"o\":{\"x\":[0.5],\"y\":[0.5]},\"i\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":59,\"s\":[0.09411764705882353,0.40784313725490196,0.8588235294117647],\"o\":{\"x\":[0.5],\"y\":[0.5]},\"i\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":64,\"s\":[0.7490196078431373,0.38823529411764707,0.9529411764705882],\"o\":{\"x\":[0.5],\"y\":[0.5]},\"i\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":86,\"s\":[0.7490196078431373,0.38823529411764707,0.9529411764705882],\"o\":{\"x\":[0.5],\"y\":[0.5]},\"i\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":91,\"s\":[0.9607843137254902,0.6509803921568628,0.13725490196078433],\"o\":{\"x\":[0.5],\"y\":[0.5]},\"i\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":107,\"s\":[0.9607843137254902,0.6509803921568628,0.13725490196078433]}]},\"o\":{\"a\":0,\"k\":100},\"r\":1,\"nm\":\"Fill\"},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[0,0]},\"a\":{\"a\":0,\"k\":[0,0]},\"s\":{\"a\":0,\"k\":[100,100]},\"r\":{\"a\":0,\"k\":0},\"o\":{\"a\":0,\"k\":100}}],\"nm\":\"Shape Group\",\"np\":3}],\"ip\":0,\"op\":108,\"st\":0,\"bm\":0}]}");

});

parcelRegister("k22Xw", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $91ZZN = parcelRequire("91ZZN");


const $e5a0bad3f68b70bd$var$LazyRovoLoadingGif = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("Bttch")));
const $e5a0bad3f68b70bd$export$7ea4e54699cd5224 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { alt: t1, testId: t2, width: t3, height: t4 } = t0;
    const alt = t1 === undefined ? "" : t1;
    const testId = t2 === undefined ? "" : t2;
    const width = t3 === undefined ? "" : t3;
    const height = t4 === undefined ? "" : t4;
    let t5;
    if ($[0] !== alt || $[1] !== height || $[2] !== testId || $[3] !== width) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
            interactionName: "rovo-platform-ui-animated-icon",
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e5a0bad3f68b70bd$var$LazyRovoLoadingGif, {
            alt: alt,
            testId: testId,
            width: width,
            height: height
        }));
        $[0] = alt;
        $[1] = height;
        $[2] = testId;
        $[3] = width;
        $[4] = t5;
    } else t5 = $[4];
    return t5;
} : ({ alt: alt = '', testId: testId = '', width: width = '', height: height = '' })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
        interactionName: "rovo-platform-ui-animated-icon",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e5a0bad3f68b70bd$var$LazyRovoLoadingGif, {
        alt: alt,
        testId: testId,
        width: width,
        height: height
    }));
});
module.exports["LazyAnimatedRovoIcon"] = $e5a0bad3f68b70bd$export$7ea4e54699cd5224;

});

parcelRegister("Bttch", function(module, exports) {

let $070a50ed8fa7d465$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $070a50ed8fa7d465$var$load("70zyE").then(()=>parcelRequire('hGjSS'));

});

parcelRegister("7VOWp", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $cccd0e8042c52039$var$DEFAULT_ESTIMATED_DURATION_MS = 30000;
const $cccd0e8042c52039$var$COMPLETION_ANIMATION_MS = 150;
function $cccd0e8042c52039$export$c350fe90f7013d5f({ isComplete: isComplete = false, onCompleteAnimationFinished: onCompleteAnimationFinished, estimatedDurationMs: estimatedDurationMs = $cccd0e8042c52039$var$DEFAULT_ESTIMATED_DURATION_MS, startedAt: startedAt = null, target: target }) {
    const randomTargetRef = (0, $cozmU.useRef)(85 + Math.random() * 10);
    const targetValue = target ?? randomTargetRef.current;
    // When anchored to a shared start time, seed the initial value from elapsed
    // time so a freshly-mounted bar jumps to the in-progress value instead of
    // restarting the animation from 0.
    const [progress, setProgress] = (0, $cozmU.useState)(()=>{
        if (startedAt == null) return 0;
        const elapsed = Math.max(0, Date.now() - startedAt);
        return Math.min(1, elapsed / estimatedDurationMs) * targetValue;
    });
    const completionStartValueRef = (0, $cozmU.useRef)(0);
    const completionStartTimeRef = (0, $cozmU.useRef)(null);
    const hasCalledFinishedRef = (0, $cozmU.useRef)(false);
    const onCompleteAnimationFinishedRef = (0, $cozmU.useRef)(onCompleteAnimationFinished);
    onCompleteAnimationFinishedRef.current = onCompleteAnimationFinished;
    // Phase 1: Animate from 0 → target over estimatedDurationMs.
    // When `startedAt` is provided, elapsed is measured from that shared anchor
    // (wall-clock) so every bar agrees regardless of mount time; otherwise it is
    // measured from the first animation frame of this mount.
    (0, $cozmU.useEffect)(()=>{
        if (isComplete) return;
        let rafId;
        let mountStartTime = null;
        const tick = (timestamp)=>{
            let elapsed;
            if (startedAt != null) elapsed = Math.max(0, Date.now() - startedAt);
            else {
                if (mountStartTime === null) mountStartTime = timestamp;
                elapsed = timestamp - mountStartTime;
            }
            const linearProgress = Math.min(1, elapsed / estimatedDurationMs);
            setProgress(linearProgress * targetValue);
            if (linearProgress < 1) rafId = requestAnimationFrame(tick);
        };
        rafId = requestAnimationFrame(tick);
        return ()=>{
            cancelAnimationFrame(rafId);
        };
    }, [
        isComplete,
        estimatedDurationMs,
        startedAt,
        targetValue
    ]);
    // Phase 2: When isComplete, rapidly animate from current value → 100
    const handleCompletion = (0, $cozmU.useCallback)(()=>{
        completionStartTimeRef.current = null;
        hasCalledFinishedRef.current = false;
        let rafId;
        const tick = (timestamp)=>{
            if (completionStartTimeRef.current === null) completionStartTimeRef.current = timestamp;
            const elapsed = timestamp - completionStartTimeRef.current;
            const t = Math.min(1, elapsed / $cccd0e8042c52039$var$COMPLETION_ANIMATION_MS);
            const startValue = completionStartValueRef.current;
            const value = startValue + (100 - startValue) * t;
            setProgress(value);
            if (t < 1) rafId = requestAnimationFrame(tick);
            else if (!hasCalledFinishedRef.current) {
                hasCalledFinishedRef.current = true;
                onCompleteAnimationFinishedRef.current?.();
            }
        };
        rafId = requestAnimationFrame(tick);
        return ()=>{
            cancelAnimationFrame(rafId);
        };
    }, []);
    (0, $cozmU.useEffect)(()=>{
        if (!isComplete) return;
        completionStartValueRef.current = progress;
        const cleanup = handleCompletion();
        return cleanup;
    // eslint-disable-next-line react-hooks/exhaustive-deps -- only trigger when isComplete changes to true
    }, [
        isComplete,
        handleCompletion
    ]);
    return progress;
}
module.exports["useProgressFacade"] = $cccd0e8042c52039$export$c350fe90f7013d5f;

});

parcelRegister("bR6es", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");


var $b2jdX = parcelRequire("b2jdX");


var $gMrzi = parcelRequire("gMrzi");


var $jEaFE = parcelRequire("jEaFE");


var $2Wuyj = parcelRequire("2Wuyj");

const $726c97f63f4e2017$var$styles = {
    toolbarBase: "_0bjKvDKTcp _2mHwu81Y8M _3iDTPbQ4SZ _0hPCNLDIqT",
    toolbar: "_0KLXruoI2d _0jFU0VnlTt _1Znuxb1Y8M _2Zuz6Q1Y8M _2OUyjtGk8v",
    toolbarResponsive: "_2YLqiK5zaO",
    primaryToolbar: "_0KLXrulfZc _4kiQYAUofl",
    toolbarSeparator: "_3RwxbwnlTt",
    hiddenSelectors: "_13h9R7YbGa _2XhVcfYbGa _2kQ26MYbGa",
    hiddenSelectorsPatch: "_2jRqDdYbGa"
};
const $726c97f63f4e2017$export$4c260019440d418f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { children: children, label: label, actionSubjectId: actionSubjectId, testId: testId } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $w6R6I.cx)($726c97f63f4e2017$var$styles.toolbarBase, $726c97f63f4e2017$var$styles.toolbar, $726c97f63f4e2017$var$styles.toolbarResponsive, $726c97f63f4e2017$var$styles.hiddenSelectors, $726c97f63f4e2017$var$styles.toolbarSeparator, $726c97f63f4e2017$var$styles.hiddenSelectorsPatch);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== actionSubjectId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2Wuyj.ViewEventEmitter), {
            actionSubject: (0, $2Wuyj.ACTION_SUBJECT).TOOLBAR,
            actionSubjectId: actionSubjectId
        });
        $[1] = actionSubjectId;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== children || $[4] !== label || $[5] !== t2 || $[6] !== testId) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
            xcss: t1,
            "aria-label": label,
            testId: testId,
            "data-toolbar-type": "inline",
            children: [
                t2,
                children
            ]
        });
        $[3] = children;
        $[4] = label;
        $[5] = t2;
        $[6] = testId;
        $[7] = t3;
    } else t3 = $[7];
    const toolbar = t3;
    let wrappedToolbar = toolbar;
    const { keyboardNavigation: keyboardNavigation } = (0, $b2jdX.useToolbarUI)();
    if (keyboardNavigation) {
        const { childComponentSelector: childComponentSelector, dom: dom, handleEscape: handleEscape, handleFocus: handleFocus, isShortcutToFocusToolbar: isShortcutToFocusToolbar, ariaControls: ariaControls, ariaLabel: ariaLabel } = keyboardNavigation;
        let t4;
        if ($[8] !== ariaControls || $[9] !== ariaLabel || $[10] !== childComponentSelector || $[11] !== dom || $[12] !== handleEscape || $[13] !== handleFocus || $[14] !== isShortcutToFocusToolbar || $[15] !== toolbar) {
            t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jEaFE.ToolbarKeyboardNavigationProvider), {
                childComponentSelector: childComponentSelector,
                dom: dom,
                isShortcutToFocusToolbar: isShortcutToFocusToolbar,
                handleEscape: handleEscape,
                handleFocus: handleFocus,
                ariaControls: ariaControls,
                ariaLabel: ariaLabel,
                children: toolbar
            });
            $[8] = ariaControls;
            $[9] = ariaLabel;
            $[10] = childComponentSelector;
            $[11] = dom;
            $[12] = handleEscape;
            $[13] = handleFocus;
            $[14] = isShortcutToFocusToolbar;
            $[15] = toolbar;
            $[16] = t4;
        } else t4 = $[16];
        wrappedToolbar = t4;
    }
    let t4;
    if ($[17] !== wrappedToolbar) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gMrzi.ResponsiveWrapper), {
            children: wrappedToolbar
        });
        $[17] = wrappedToolbar;
        $[18] = t4;
    } else t4 = $[18];
    return t4;
} : ({ children: children, label: label, actionSubjectId: actionSubjectId, testId: testId })=>{
    const toolbar = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($726c97f63f4e2017$var$styles.toolbarBase, $726c97f63f4e2017$var$styles.toolbar, $726c97f63f4e2017$var$styles.toolbarResponsive, $726c97f63f4e2017$var$styles.hiddenSelectors, $726c97f63f4e2017$var$styles.toolbarSeparator, $726c97f63f4e2017$var$styles.hiddenSelectorsPatch),
        "aria-label": label,
        testId: testId,
        "data-toolbar-type": "inline",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2Wuyj.ViewEventEmitter), {
                actionSubject: (0, $2Wuyj.ACTION_SUBJECT).TOOLBAR,
                actionSubjectId: actionSubjectId
            }),
            children
        ]
    });
    let wrappedToolbar = toolbar;
    const { keyboardNavigation: keyboardNavigation } = (0, $b2jdX.useToolbarUI)();
    if (keyboardNavigation) {
        const { childComponentSelector: childComponentSelector, dom: dom, handleEscape: handleEscape, handleFocus: handleFocus, isShortcutToFocusToolbar: isShortcutToFocusToolbar, ariaControls: ariaControls, ariaLabel: ariaLabel } = keyboardNavigation;
        wrappedToolbar = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jEaFE.ToolbarKeyboardNavigationProvider), {
            childComponentSelector: childComponentSelector,
            dom: dom,
            isShortcutToFocusToolbar: isShortcutToFocusToolbar,
            handleEscape: handleEscape,
            handleFocus: handleFocus,
            ariaControls: ariaControls,
            ariaLabel: ariaLabel,
            children: toolbar
        });
    }
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gMrzi.ResponsiveWrapper), {
        children: wrappedToolbar
    });
};
const $726c97f63f4e2017$export$7469f9986edfc2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { children: children, breakpointPreset: breakpointPreset, testId: testId } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $w6R6I.cx)($726c97f63f4e2017$var$styles.toolbarBase, $726c97f63f4e2017$var$styles.primaryToolbar, $726c97f63f4e2017$var$styles.hiddenSelectors);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: t1,
            "data-toolbar-type": "primary",
            testId: testId,
            children: children
        });
        $[1] = children;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== breakpointPreset || $[5] !== t2) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gMrzi.ResponsiveContainer), {
            breakpointPreset: breakpointPreset,
            children: t2
        });
        $[4] = breakpointPreset;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ children: children, breakpointPreset: breakpointPreset, testId: testId })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gMrzi.ResponsiveContainer), {
        breakpointPreset: breakpointPreset,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($726c97f63f4e2017$var$styles.toolbarBase, $726c97f63f4e2017$var$styles.primaryToolbar, $726c97f63f4e2017$var$styles.hiddenSelectors),
            "data-toolbar-type": "primary",
            testId: testId,
            children: children
        })
    });
};
module.exports["Toolbar"] = $726c97f63f4e2017$export$4c260019440d418f;
module.exports["PrimaryToolbar"] = $726c97f63f4e2017$export$7469f9986edfc2;

});

parcelRegister("gMrzi", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $2pQiO = parcelRequire("2pQiO");


var $iMnC5 = parcelRequire("iMnC5");


var $ieeJu = parcelRequire("ieeJu");

const $a746760df070e426$var$styles = {
    responsiveContainer: "_39xV02N91d _0u2WMmrU95 _3n40gWGjUA _3a6JJVvLZJ _3kAwDdvLZJ _40ffbvvLZJ _4BExMVvLZJ _2l4xMaYbGa _32vblKYbGa _1U3CxmYbGa _4tvqstYbGa _3C3owgYbGa _4t1h0mYbGa _3jMGqTYbGa _0FIqsbYbGa",
    responsiveContainerFullPage: "_39xV02E6Kk _3a6JJVvLZJ _3kAwDdvLZJ _40ffbvvLZJ _4BExMVvLZJ _2l4xMaYbGa _32vblKYbGa _1U3CxmYbGa _4tvqstYbGa _3C3owgYbGa _4t1h0mYbGa _3jMGqTYbGa _0FIqsbYbGa",
    fullpage: "_1rq8jLYbGa _0aYpZQvLZJ _2uUPwdYbGa _0032uovLZJ _3WuWXSYbGa _1hfhOsvLZJ _1UwYfAYbGa _12th9UvLZJ _3EFhkHvLZJ _39JjOcvLZJ _0L5H27vLZJ _34STP7vLZJ",
    fullpageUpdated: "_3x54HuYbGa _01WCBwvLZJ _3mkwgcYbGa _4sC1oWvLZJ _2uUPwdYbGa _0032uovLZJ _3WuWXSYbGa _1hfhOsvLZJ _3B0hPZvLZJ _0BUt8zvLZJ _39JjOcvLZJ _2bfXdIvLZJ",
    reduced: "_1mdU70YbGa _3gHiHXvLZJ _3cgyzIvLZJ _1gaO6tYbGa _2cYx2vvLZJ _1CnDTDvLZJ _2CNPNSYbGa _0j4V1pvLZJ _2afuuivLZJ _1YIAQDYbGa _1nd9NrvLZJ _0xzigGvLZJ",
    jiraIssue: "_2I6R9qYbGa _3d33AUvLZJ _0hNaxovLZJ _0GIckyYbGa _1EftZivLZJ _27RrwMvLZJ _3QLJlTYbGa _1MMVXavLZJ _4EWOPkvLZJ _1YIAQDYbGa _1nd9NrvLZJ _0xzigGvLZJ",
    jiraIssueUpdated: "_2I6R9qYbGa _3d33AUvLZJ _3DyQwZvLZJ _3U0x9yYbGa _3UVUXivLZJ _1pEq9LvLZJ _2nGSpMYbGa _41Ji6pvLZJ _149pM8vLZJ _1YIAQDYbGa _1nd9NrvLZJ _0xzigGvLZJ",
    jsmComment: "_1QRAXcYbGa _1AFPIdvLZJ _3GGyPKvLZJ _1p8ZHhYbGa _4BiRXLvLZJ _4tAAtIvLZJ _36lPUiYbGa _3QZ1XdvLZJ _39lxztvLZJ _1YIAQDYbGa _1nd9NrvLZJ _0xzigGvLZJ",
    jsmCommentUpdated: "_1QRAXcYbGa _1AFPIdvLZJ _4mq0TavLZJ _1ZCm13YbGa _0NVVnzvLZJ _2GrInovLZJ _36lPUiYbGa _3QZ1XdvLZJ _39lxztvLZJ _1YIAQDYbGa _1nd9NrvLZJ _0xzigGvLZJ",
    confluenceComment: "_2KtBBnYbGa _0PCBjdvLZJ _0vF73WvLZJ _2BIo24YbGa _0AeybuvLZJ _0PYKuevLZJ _2Y6dwmYbGa _4oeWH5vLZJ _40xblwvLZJ _1YIAQDYbGa _1nd9NrvLZJ _0xzigGvLZJ",
    responsiveRulesWrapper: "_3a6JJVvLZJ _3kAwDdvLZJ _40ffbvvLZJ _4BExMVvLZJ _2l4xMaYbGa _32vblKYbGa _1U3CxmYbGa _4tvqstYbGa _0cHb2BYbGa _3hCVfsvLZJ _1ZeYDsYbGa _1PZiqKvLZJ _11yBoBYbGa _0obMtNvLZJ _1aaAVJYbGa _4cWoU5vLZJ _223UMPYbGa _3X9hbPvLZJ _2ZXGV7YbGa _4aIPGovLZJ"
};
const $a746760df070e426$var$presetStyleMap = {
    fullpage: $a746760df070e426$var$styles.fullpage,
    reduced: $a746760df070e426$var$styles.reduced,
    'jira-issue': $a746760df070e426$var$styles.jiraIssue,
    'jsm-comment': $a746760df070e426$var$styles.jsmComment,
    'confluence-comment': $a746760df070e426$var$styles.confluenceComment
};
const $a746760df070e426$var$updatedPresetStyleMap = {
    fullpage: $a746760df070e426$var$styles.fullpageUpdated,
    'jira-issue': $a746760df070e426$var$styles.jiraIssueUpdated,
    'jsm-comment': $a746760df070e426$var$styles.jsmCommentUpdated
};
const $a746760df070e426$export$e60a4704009a0009 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, breakpointPreset: breakpointPreset } = t0;
    let t1;
    bb0: {
        if (breakpointPreset === "fullpage") {
            t1 = (0, $2pQiO.UNSAFE_expValNoExposure)("platform_editor_ai_content_suggested_edits", "isEnabled", false);
            break bb0;
        }
        t1 = (0, $ieeJu.expValEquals)("platform_editor_toolbar_update_jira_config", "isEnabled", true) && breakpointPreset in $a746760df070e426$var$updatedPresetStyleMap;
    }
    const isUpdatedConfig = t1;
    const t2 = breakpointPreset === "fullpage" ? $a746760df070e426$var$styles.responsiveContainerFullPage : $a746760df070e426$var$styles.responsiveContainer;
    const t3 = isUpdatedConfig ? $a746760df070e426$var$updatedPresetStyleMap[breakpointPreset] : $a746760df070e426$var$presetStyleMap[breakpointPreset];
    let t4;
    if ($[0] !== t2 || $[1] !== t3) {
        t4 = (0, $w6R6I.cx)(t2, t3);
        $[0] = t2;
        $[1] = t3;
        $[2] = t4;
    } else t4 = $[2];
    let t5;
    if ($[3] !== children || $[4] !== t4) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: t4,
            children: children
        });
        $[3] = children;
        $[4] = t4;
        $[5] = t5;
    } else t5 = $[5];
    return t5;
} : ({ children: children, breakpointPreset: breakpointPreset })=>{
    const isUpdatedConfig = (()=>{
        if (breakpointPreset === 'fullpage') return (0, $2pQiO.UNSAFE_expValNoExposure)('platform_editor_ai_content_suggested_edits', 'isEnabled', false);
        return (0, $ieeJu.expValEquals)('platform_editor_toolbar_update_jira_config', 'isEnabled', true) && breakpointPreset in $a746760df070e426$var$updatedPresetStyleMap;
    })();
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)(breakpointPreset === 'fullpage' ? $a746760df070e426$var$styles.responsiveContainerFullPage : $a746760df070e426$var$styles.responsiveContainer, isUpdatedConfig ? $a746760df070e426$var$updatedPresetStyleMap[breakpointPreset] : $a746760df070e426$var$presetStyleMap[breakpointPreset]),
        children: children
    });
}; /**
    * A wrapper that supports responsiveness with media queries. It needs to used together with Show component
    */ 
const $a746760df070e426$export$fa6e408d6a7d6214 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $a746760df070e426$var$styles.responsiveRulesWrapper,
            children: children
        });
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $a746760df070e426$var$styles.responsiveRulesWrapper,
        children: children
    });
};
module.exports["ResponsiveContainer"] = $a746760df070e426$export$e60a4704009a0009;
module.exports["ResponsiveWrapper"] = $a746760df070e426$export$fa6e408d6a7d6214;

});

parcelRegister("jEaFE", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1hQ0e = parcelRequire("1hQ0e");

const $3dd4b47fb9e5cae4$export$881345eb2554ea9e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { children: children, childComponentSelector: childComponentSelector, dom: dom, isShortcutToFocusToolbar: isShortcutToFocusToolbar, handleFocus: handleFocus, handleEscape: handleEscape, ariaLabel: ariaLabel, ariaControls: ariaControls } = t0;
    const wrapperRef = (0, $cozmU.useRef)(null);
    let t1;
    let t2;
    if ($[0] !== childComponentSelector || $[1] !== dom || $[2] !== handleEscape || $[3] !== handleFocus || $[4] !== isShortcutToFocusToolbar) {
        t1 = ()=>{
            if (!wrapperRef.current) return;
            const { current: element } = wrapperRef;
            const getFocusableElements = ()=>{
                if (!element) return [];
                const focusableSelectors = [
                    "button:not([disabled])",
                    "[role=\"button\"]:not([disabled])",
                    "[tabindex]:not([tabindex=\"-1\"])"
                ].join(",");
                const allFocusable = Array.from(element.querySelectorAll(focusableSelectors));
                return allFocusable.filter((el)=>{
                    if (!el.closest(`${childComponentSelector}`)) return false;
                    let currentEl = el;
                    while(currentEl && currentEl !== element){
                        const computedStyle = window.getComputedStyle(currentEl);
                        if (computedStyle.display === "none" || computedStyle.visibility === "hidden") return false;
                        currentEl = currentEl.parentElement;
                    }
                    return true;
                });
            };
            const moveFocus = (direction)=>{
                const focusableElements = getFocusableElements();
                if (focusableElements.length === 0) return;
                const doc = (0, $1hQ0e.getDocument)();
                const currentIndex = focusableElements.findIndex((el_0)=>el_0 === doc?.activeElement);
                let nextIndex;
                if (currentIndex === -1) nextIndex = 0;
                else if (direction === "right") nextIndex = (currentIndex + 1) % focusableElements.length;
                else nextIndex = currentIndex === 0 ? focusableElements.length - 1 : currentIndex - 1;
                focusableElements[nextIndex]?.focus();
            };
            const handleTab = ()=>{
                const focusableElements_0 = getFocusableElements();
                if (focusableElements_0.length === 0) return;
                const doc_0 = (0, $1hQ0e.getDocument)();
                let index = doc_0?.activeElement ? focusableElements_0.findIndex((el_1)=>el_1 === doc_0?.activeElement) : 0;
                if (index < 0) index = 0;
                focusableElements_0.forEach($3dd4b47fb9e5cae4$var$_temp);
                focusableElements_0[index].setAttribute("tabindex", "0");
            };
            const handleKeyDown = (event)=>{
                const targetElement = event.target;
                if (targetElement instanceof HTMLElement && !targetElement.closest(`${childComponentSelector}`)) return;
                bb86: switch(event.key){
                    case "Escape":
                        handleEscape(event);
                        break bb86;
                    case "ArrowLeft":
                        event.preventDefault();
                        moveFocus("left");
                        break bb86;
                    case "ArrowRight":
                        event.preventDefault();
                        moveFocus("right");
                        break bb86;
                    case "Tab":
                        handleTab();
                        break bb86;
                    default:
                }
            };
            const globalKeyDownHandler = (event_0)=>{
                if (isShortcutToFocusToolbar && isShortcutToFocusToolbar(event_0)) handleFocus(event_0);
            };
            element?.addEventListener("keydown", handleKeyDown);
            dom?.addEventListener("keydown", globalKeyDownHandler);
            return ()=>{
                element?.removeEventListener("keydown", handleKeyDown);
                dom?.removeEventListener("keydown", globalKeyDownHandler);
            };
        };
        t2 = [
            wrapperRef,
            childComponentSelector,
            dom,
            isShortcutToFocusToolbar,
            handleFocus,
            handleEscape
        ];
        $[0] = childComponentSelector;
        $[1] = dom;
        $[2] = handleEscape;
        $[3] = handleFocus;
        $[4] = isShortcutToFocusToolbar;
        $[5] = t1;
        $[6] = t2;
    } else {
        t1 = $[5];
        t2 = $[6];
    }
    (0, $cozmU.useLayoutEffect)(t1, t2);
    let t3;
    if ($[7] !== ariaControls || $[8] !== ariaLabel || $[9] !== children) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: "custom-key-handler-wrapper",
            ref: wrapperRef,
            role: "toolbar",
            "aria-label": ariaLabel,
            "aria-controls": ariaControls,
            children: children
        });
        $[7] = ariaControls;
        $[8] = ariaLabel;
        $[9] = children;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : ({ children: children, childComponentSelector: childComponentSelector, dom: dom, isShortcutToFocusToolbar: isShortcutToFocusToolbar, handleFocus: handleFocus, handleEscape: handleEscape, ariaLabel: ariaLabel, ariaControls: ariaControls })=>{
    const wrapperRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!wrapperRef.current) return;
        const { current: element } = wrapperRef;
        const getFocusableElements = ()=>{
            if (!element) return [];
            // Find all focusable elements within the toolbar that match the child component selector
            const focusableSelectors = [
                'button:not([disabled])',
                '[role="button"]:not([disabled])',
                '[tabindex]:not([tabindex="-1"])'
            ].join(',');
            const allFocusable = Array.from(element.querySelectorAll(focusableSelectors));
            // Filter to only include elements that are:
            // 1. Within the child component selector
            // 2. Visible (not hidden by display:none on itself or any parent)
            return allFocusable.filter((el)=>{
                if (!el.closest(`${childComponentSelector}`)) return false;
                // Check if the element or any of its parents have display: none
                let currentEl = el;
                while(currentEl && currentEl !== element){
                    const computedStyle = window.getComputedStyle(currentEl);
                    if (computedStyle.display === 'none' || computedStyle.visibility === 'hidden') return false;
                    currentEl = currentEl.parentElement;
                }
                return true;
            });
        };
        const moveFocus = (direction)=>{
            const focusableElements = getFocusableElements();
            if (focusableElements.length === 0) return;
            const doc = (0, $1hQ0e.getDocument)();
            const currentIndex = focusableElements.findIndex((el_0)=>el_0 === doc?.activeElement);
            let nextIndex;
            if (currentIndex === -1) // No element currently focused, focus the first one
            nextIndex = 0;
            else if (direction === 'right') // Move right, wrap to beginning if at end
            nextIndex = (currentIndex + 1) % focusableElements.length;
            else // Move left, wrap to end if at beginning
            nextIndex = currentIndex === 0 ? focusableElements.length - 1 : currentIndex - 1;
            focusableElements[nextIndex]?.focus();
        };
        const handleTab = ()=>{
            const focusableElements_0 = getFocusableElements();
            if (focusableElements_0.length === 0) return;
            const doc_0 = (0, $1hQ0e.getDocument)();
            let index = doc_0?.activeElement ? focusableElements_0.findIndex((el_1)=>el_1 === doc_0?.activeElement) : 0;
            if (index < 0) index = 0;
            focusableElements_0.forEach((el_2)=>el_2.setAttribute('tabindex', '-1'));
            focusableElements_0[index].setAttribute('tabindex', '0');
        };
        const handleKeyDown = (event)=>{
            const targetElement = event.target;
            if (targetElement instanceof HTMLElement && !targetElement.closest(`${childComponentSelector}`)) return;
            switch(event.key){
                case 'Escape':
                    handleEscape(event);
                    break;
                case 'ArrowLeft':
                    event.preventDefault();
                    moveFocus('left');
                    break;
                case 'ArrowRight':
                    event.preventDefault();
                    moveFocus('right');
                    break;
                case 'Tab':
                    handleTab();
                    break;
                default:
            }
        };
        const globalKeyDownHandler = (event_0)=>{
            if (isShortcutToFocusToolbar && isShortcutToFocusToolbar(event_0)) handleFocus(event_0);
        };
        // ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('keydown', handleKeyDown);
        // ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        dom?.addEventListener('keydown', globalKeyDownHandler);
        return ()=>{
            // ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('keydown', handleKeyDown);
            // ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            dom?.removeEventListener('keydown', globalKeyDownHandler);
        };
    }, [
        wrapperRef,
        childComponentSelector,
        dom,
        isShortcutToFocusToolbar,
        handleFocus,
        handleEscape
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- ignored via go/DSP-18766
        className: "custom-key-handler-wrapper",
        ref: wrapperRef,
        role: "toolbar",
        "aria-label": ariaLabel,
        "aria-controls": ariaControls,
        children: children
    });
};
function $3dd4b47fb9e5cae4$var$_temp(el_2) {
    return el_2.setAttribute("tabindex", "-1");
}
module.exports["ToolbarKeyboardNavigationProvider"] = $3dd4b47fb9e5cae4$export$881345eb2554ea9e;

});

parcelRegister("2Wuyj", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $b2jdX = parcelRequire("b2jdX");

const $171e330111381e98$export$7525482b5931e326 = {
    TOOLBAR: 'toolbar',
    TOOLBAR_DROPDOWN_MENU: 'toolbarDropdownMenu'
};
const $171e330111381e98$export$58d0f383acf77599 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { actionSubjectId: actionSubjectId, actionSubject: actionSubject } = t0;
    const isMountedRef = (0, $cozmU.useRef)(false);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $b2jdX.useToolbarUI)();
    let t1;
    let t2;
    if ($[0] !== actionSubject || $[1] !== actionSubjectId || $[2] !== fireAnalyticsEvent) {
        t1 = ()=>{
            if (isMountedRef.current) return;
            isMountedRef.current = true;
            const payload = {
                action: "viewed",
                actionSubject: actionSubject,
                actionSubjectId: actionSubjectId,
                eventType: "ui"
            };
            fireAnalyticsEvent && fireAnalyticsEvent(payload);
        };
        t2 = [
            actionSubjectId,
            actionSubject,
            fireAnalyticsEvent
        ];
        $[0] = actionSubject;
        $[1] = actionSubjectId;
        $[2] = fireAnalyticsEvent;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
} : ({ actionSubjectId: actionSubjectId, actionSubject: actionSubject })=>{
    const isMountedRef = (0, $cozmU.useRef)(false);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $b2jdX.useToolbarUI)();
    (0, $cozmU.useEffect)(()=>{
        if (isMountedRef.current) return;
        isMountedRef.current = true;
        const payload = {
            action: 'viewed',
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            eventType: 'ui'
        };
        fireAnalyticsEvent && fireAnalyticsEvent(payload);
    }, [
        actionSubjectId,
        actionSubject,
        fireAnalyticsEvent
    ]);
    return null;
};
module.exports["ACTION_SUBJECT"] = $171e330111381e98$export$7525482b5931e326;
module.exports["ViewEventEmitter"] = $171e330111381e98$export$58d0f383acf77599;

});

parcelRegister("iuCeV", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $bjY3F = parcelRequire("bjY3F");

const $4726ba45c1bca0cb$export$4962f3898bd5c829 = ({ name: name, trigger: trigger = 'mount', attributes: attributes })=>{
    (0, $6cFsl.di)((0, $bjY3F.useAIMateExperienceTracker));
    const successTriggerRef = (0, $cozmU.useRef)(trigger);
    const attributesRef = (0, $cozmU.useRef)(attributes);
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    (0, $cozmU.useEffect)(()=>{
        const successAttributes = attributesRef.current;
        if (successTriggerRef.current === 'mount') experienceTracker.succeed({
            name: name,
            ...successAttributes && {
                attributes: successAttributes
            }
        });
        if (successTriggerRef.current === 'unmount') return ()=>{
            experienceTracker.succeed({
                name: name,
                ...successAttributes && {
                    attributes: successAttributes
                }
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
const $4726ba45c1bca0cb$export$eed1d73ebdd8c7ab = ({ error: error, name: name })=>{
    (0, $6cFsl.di)((0, $bjY3F.useAIMateExperienceTracker));
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    (0, $cozmU.useEffect)(()=>{
        experienceTracker.fail({
            name: name,
            error: error
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
const $4726ba45c1bca0cb$export$f20b867e738a222c = ({ name: name, attributes: attributes })=>{
    (0, $6cFsl.di)((0, $bjY3F.useAIMateExperienceTracker));
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    (0, $cozmU.useMemo)(()=>{
        experienceTracker.start({
            id: name,
            name: name,
            attributes: attributes
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
module.exports["ExperienceSuccess"] = $4726ba45c1bca0cb$export$4962f3898bd5c829;
module.exports["ExperienceFailure"] = $4726ba45c1bca0cb$export$eed1d73ebdd8c7ab;
module.exports["ExperienceStart"] = $4726ba45c1bca0cb$export$f20b867e738a222c;

});

parcelRegister("8VrqA", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $kMkDS = parcelRequire("kMkDS");


var $cGJsZ = parcelRequire("cGJsZ");

const $e14a5679e33f0f1b$var$state = (0, $8s9DV.createStore)({
    initialState: {
        highlightActionsEditorPlaceholder: null,
        highlightActionsEditorPlaceholderSource: null,
        highlightActionsEditorPlaceholderConversationId: null
    },
    actions: {
        setHighlightActionsEditorPlaceholder: (highlightActionsEditorPlaceholder, highlightActionsEditorPlaceholderSource = null, highlightActionsEditorPlaceholderConversationId = null)=>({ setState: setState })=>{
                setState({
                    highlightActionsEditorPlaceholder: highlightActionsEditorPlaceholder,
                    highlightActionsEditorPlaceholderSource: highlightActionsEditorPlaceholderSource,
                    highlightActionsEditorPlaceholderConversationId: highlightActionsEditorPlaceholderConversationId
                });
            }
    }
});
const $e14a5679e33f0f1b$export$e638cf26ae51308d = (0, $kBr4q.createHook)($e14a5679e33f0f1b$var$state);
const $e14a5679e33f0f1b$var$getHighlightActionPlaceholderData = (prompt, placeholderText)=>{
    const promptContent = (0, $kMkDS.appendADFContent)(prompt, placeholderText);
    return promptContent;
};
const $e14a5679e33f0f1b$export$21b2d5ca0689f678 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(11);
    const [t0, t1] = $e14a5679e33f0f1b$export$e638cf26ae51308d();
    const { highlightActionsEditorPlaceholder: highlightActionsEditorPlaceholder, highlightActionsEditorPlaceholderSource: highlightActionsEditorPlaceholderSource, highlightActionsEditorPlaceholderConversationId: highlightActionsEditorPlaceholderConversationId } = t0;
    const { setHighlightActionsEditorPlaceholder: setHighlightActionsEditorPlaceholder } = t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== formatMessage || $[1] !== setHighlightActionsEditorPlaceholder) {
        t2 = (prompt, options)=>{
            const adfDocument = options?.skipPlaceholderPrompt ? prompt : $e14a5679e33f0f1b$var$getHighlightActionPlaceholderData(prompt, formatMessage((0, $cGJsZ.default).highlightActionsPlaceholderPrompt));
            setHighlightActionsEditorPlaceholder(adfDocument, options?.source ?? null, options?.conversationId ?? null);
        };
        $[0] = formatMessage;
        $[1] = setHighlightActionsEditorPlaceholder;
        $[2] = t2;
    } else t2 = $[2];
    const insertHighlightActionsEditorPlaceholder = t2;
    let t3;
    if ($[3] !== setHighlightActionsEditorPlaceholder) {
        t3 = ()=>{
            setHighlightActionsEditorPlaceholder(null);
        };
        $[3] = setHighlightActionsEditorPlaceholder;
        $[4] = t3;
    } else t3 = $[4];
    const clearHighlightActionsEditorPlaceholder = t3;
    let t4;
    if ($[5] !== clearHighlightActionsEditorPlaceholder || $[6] !== highlightActionsEditorPlaceholder || $[7] !== highlightActionsEditorPlaceholderConversationId || $[8] !== highlightActionsEditorPlaceholderSource || $[9] !== insertHighlightActionsEditorPlaceholder) {
        t4 = {
            highlightActionsEditorPlaceholder: highlightActionsEditorPlaceholder,
            highlightActionsEditorPlaceholderSource: highlightActionsEditorPlaceholderSource,
            highlightActionsEditorPlaceholderConversationId: highlightActionsEditorPlaceholderConversationId,
            insertHighlightActionsEditorPlaceholder: insertHighlightActionsEditorPlaceholder,
            clearHighlightActionsEditorPlaceholder: clearHighlightActionsEditorPlaceholder
        };
        $[5] = clearHighlightActionsEditorPlaceholder;
        $[6] = highlightActionsEditorPlaceholder;
        $[7] = highlightActionsEditorPlaceholderConversationId;
        $[8] = highlightActionsEditorPlaceholderSource;
        $[9] = insertHighlightActionsEditorPlaceholder;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
} : ()=>{
    const [{ highlightActionsEditorPlaceholder: highlightActionsEditorPlaceholder, highlightActionsEditorPlaceholderSource: highlightActionsEditorPlaceholderSource, highlightActionsEditorPlaceholderConversationId: highlightActionsEditorPlaceholderConversationId }, { setHighlightActionsEditorPlaceholder: setHighlightActionsEditorPlaceholder }] = $e14a5679e33f0f1b$export$e638cf26ae51308d();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const insertHighlightActionsEditorPlaceholder = (0, $cozmU.useCallback)((prompt, options)=>{
        // When `skipPlaceholderPrompt` is set, seed the editor with the prompt
        // exactly as provided instead of appending the highlight-action
        // "Ask a question about this." trailer. This lets non-highlight callers
        // (e.g. a prompt supplied via URL param) pre-fill the input as an
        // editable draft without injecting extra text.
        const adfDocument = options?.skipPlaceholderPrompt ? prompt : $e14a5679e33f0f1b$var$getHighlightActionPlaceholderData(prompt, formatMessage((0, $cGJsZ.default).highlightActionsPlaceholderPrompt));
        setHighlightActionsEditorPlaceholder(adfDocument, options?.source ?? null, options?.conversationId ?? null);
    }, [
        setHighlightActionsEditorPlaceholder,
        formatMessage
    ]);
    const clearHighlightActionsEditorPlaceholder = (0, $cozmU.useCallback)(()=>{
        setHighlightActionsEditorPlaceholder(null);
    }, [
        setHighlightActionsEditorPlaceholder
    ]);
    return {
        highlightActionsEditorPlaceholder: highlightActionsEditorPlaceholder,
        highlightActionsEditorPlaceholderSource: highlightActionsEditorPlaceholderSource,
        highlightActionsEditorPlaceholderConversationId: highlightActionsEditorPlaceholderConversationId,
        insertHighlightActionsEditorPlaceholder: insertHighlightActionsEditorPlaceholder,
        clearHighlightActionsEditorPlaceholder: clearHighlightActionsEditorPlaceholder
    };
};
module.exports["useHighlightActionsEditorPlaceholder"] = $e14a5679e33f0f1b$export$21b2d5ca0689f678;

});

parcelRegister("kMkDS", function(module, exports) {
const $00de4dd959d7802e$export$f00236a854eaa848 = (content, suggestionContent)=>{
    const updatedContent = Array.isArray(content.content) ? content.content : [
        content.content
    ];
    // Append the new paragraph node
    updatedContent.push({
        type: 'paragraph',
        content: [
            {
                type: 'text',
                text: suggestionContent
            }
        ]
    });
    // Return the updated DocNode
    return {
        ...content,
        content: updatedContent
    };
};
module.exports["appendADFContent"] = $00de4dd959d7802e$export$f00236a854eaa848;

});

parcelRegister("cGJsZ", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $12b4cc67f5ec0d6d$var$message = (0, $kSwu1.defineMessages)({
    highlightActionsPlaceholderPrompt: {
        id: "highlight-actions.rovo-chat.placeholder-prompt",
        defaultMessage: "Ask a question about this."
    }
});
var $12b4cc67f5ec0d6d$export$2e2bcd8739ae039 = $12b4cc67f5ec0d6d$var$message;
module.exports["default"] = $12b4cc67f5ec0d6d$export$2e2bcd8739ae039;

});

parcelRegister("hOUgz", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");


var $gzMZq = parcelRequire("gzMZq");


var $aJU2k = parcelRequire("aJU2k");


var $4TNMQ = parcelRequire("4TNMQ");


var $d9k9Z = parcelRequire("d9k9Z");

const $0893a5bb718d1a9a$var$JIRA_VIEW_CONTEXT_KEY = 'jira_view_context';
const $0893a5bb718d1a9a$var$TRELLO_VIEW_CONTEXT_KEY = 'trello_view_context';
function $0893a5bb718d1a9a$var$hasValidJiraViewContextData(value) {
    if (value == null || typeof value !== 'object') return false;
    const selected = Object.getOwnPropertyDescriptor(value, 'selectedIssueIdentifiers')?.value;
    return Array.isArray(selected);
}
function $0893a5bb718d1a9a$var$hasValidTrelloViewContextData(value) {
    if (value == null || typeof value !== 'object') return false;
    const url = Object.getOwnPropertyDescriptor(value, 'url')?.value;
    return typeof url === 'string';
}
const $0893a5bb718d1a9a$export$a96e0fbf256603d8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(26);
    const pageContextType = (0, $d9k9Z.usePageContextType)();
    const { getChatMode: getChatMode, setUseCurrentPageContext: setUseCurrentPageContext } = (0, $aJU2k.useChatModeStoreActions)();
    const [editorContext] = (0, $gzMZq.useChatContextEditorContext)();
    const [artifactContext] = (0, $gzMZq.useChatContextArtifactContext)();
    const [databaseContext] = (0, $gzMZq.useChatContextDatabaseContext)();
    const [aiFeatureContext] = (0, $gzMZq.useChatContextAIFeatureContext)();
    const rawJiraViewContext = aiFeatureContext?.[$0893a5bb718d1a9a$var$JIRA_VIEW_CONTEXT_KEY];
    let t0;
    if ($[0] !== rawJiraViewContext) {
        t0 = $0893a5bb718d1a9a$var$hasValidJiraViewContextData(rawJiraViewContext) ? rawJiraViewContext : undefined;
        $[0] = rawJiraViewContext;
        $[1] = t0;
    } else t0 = $[1];
    const jiraViewContextData = t0;
    const rawTrelloViewContext = aiFeatureContext?.[$0893a5bb718d1a9a$var$TRELLO_VIEW_CONTEXT_KEY];
    let t1;
    if ($[2] !== rawTrelloViewContext) {
        t1 = $0893a5bb718d1a9a$var$hasValidTrelloViewContextData(rawTrelloViewContext) ? rawTrelloViewContext : undefined;
        $[2] = rawTrelloViewContext;
        $[3] = t1;
    } else t1 = $[3];
    const trelloViewContextData = t1;
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            type: "none"
        };
        $[4] = t2;
    } else t2 = $[4];
    let currentContext = t2;
    if (trelloViewContextData && (0, $iDrrr.fg)("trello_enterprise_rovo_trello_context")) {
        let t3;
        if ($[5] !== trelloViewContextData) {
            t3 = {
                type: "trello_view_context",
                payload: trelloViewContextData
            };
            $[5] = trelloViewContextData;
            $[6] = t3;
        } else t3 = $[6];
        currentContext = t3;
    } else if (artifactContext) {
        let t3;
        if ($[7] !== artifactContext) {
            t3 = {
                type: "artifact_context",
                payload: artifactContext
            };
            $[7] = artifactContext;
            $[8] = t3;
        } else t3 = $[8];
        currentContext = t3;
    } else {
        if (editorContext) {
            let t3;
            if ($[9] !== editorContext) {
                t3 = {
                    type: "editor_context",
                    payload: editorContext
                };
                $[9] = editorContext;
                $[10] = t3;
            } else t3 = $[10];
            currentContext = t3;
        } else if (databaseContext) {
            let t3;
            if ($[11] !== databaseContext.selectedElementIds) {
                t3 = databaseContext.selectedElementIds ?? [];
                $[11] = databaseContext.selectedElementIds;
                $[12] = t3;
            } else t3 = $[12];
            let t4;
            if ($[13] !== t3) {
                t4 = {
                    type: "database_context",
                    selectedElementIds: t3
                };
                $[13] = t3;
                $[14] = t4;
            } else t4 = $[14];
            currentContext = t4;
        } else {
            if (jiraViewContextData && (0, $cXtTj.default).getExperimentValue("jira-ai-jira-view-context-in-rovo-chat-experiment", "isEnabled", false)) {
                let t3;
                if ($[15] !== jiraViewContextData) {
                    t3 = {
                        type: "jira_view_context",
                        payload: jiraViewContextData
                    };
                    $[15] = jiraViewContextData;
                    $[16] = t3;
                } else t3 = $[16];
                currentContext = t3;
            } else if (pageContextType !== (0, $4TNMQ.PageContextType).UNKNOWN) {
                let t3;
                if ($[17] !== pageContextType) {
                    t3 = {
                        type: "current_page",
                        pageContextType: pageContextType
                    };
                    $[17] = pageContextType;
                    $[18] = t3;
                } else t3 = $[18];
                currentContext = t3;
            }
        }
    }
    let t3;
    if ($[19] !== getChatMode) {
        t3 = (key)=>getChatMode(key).useCurrentPageContext;
        $[19] = getChatMode;
        $[20] = t3;
    } else t3 = $[20];
    let t4;
    if ($[21] !== currentContext || $[22] !== jiraViewContextData || $[23] !== setUseCurrentPageContext || $[24] !== t3) {
        t4 = {
            canUseCurrentPageContextUserPreference: t3,
            setUseCurrentPageContextUserPreference: setUseCurrentPageContext,
            currentContext: currentContext,
            jiraViewContextData: jiraViewContextData
        };
        $[21] = currentContext;
        $[22] = jiraViewContextData;
        $[23] = setUseCurrentPageContext;
        $[24] = t3;
        $[25] = t4;
    } else t4 = $[25];
    return t4;
} : ()=>{
    const pageContextType = (0, $d9k9Z.usePageContextType)();
    const { getChatMode: getChatMode, setUseCurrentPageContext: setUseCurrentPageContext } = (0, $aJU2k.useChatModeStoreActions)();
    const [editorContext] = (0, $gzMZq.useChatContextEditorContext)();
    const [artifactContext] = (0, $gzMZq.useChatContextArtifactContext)();
    const [databaseContext] = (0, $gzMZq.useChatContextDatabaseContext)();
    const [aiFeatureContext] = (0, $gzMZq.useChatContextAIFeatureContext)();
    const rawJiraViewContext = aiFeatureContext?.[$0893a5bb718d1a9a$var$JIRA_VIEW_CONTEXT_KEY];
    const jiraViewContextData = $0893a5bb718d1a9a$var$hasValidJiraViewContextData(rawJiraViewContext) ? rawJiraViewContext : undefined;
    const rawTrelloViewContext = aiFeatureContext?.[$0893a5bb718d1a9a$var$TRELLO_VIEW_CONTEXT_KEY];
    const trelloViewContextData = $0893a5bb718d1a9a$var$hasValidTrelloViewContextData(rawTrelloViewContext) ? rawTrelloViewContext : undefined;
    let currentContext = {
        type: 'none'
    };
    if (trelloViewContextData && (0, $iDrrr.fg)('trello_enterprise_rovo_trello_context')) // prefer trello context over page context if available
    currentContext = {
        type: 'trello_view_context',
        payload: trelloViewContextData
    };
    else if (artifactContext) currentContext = {
        type: 'artifact_context',
        payload: artifactContext
    };
    else if (editorContext) // prefer editor context over page context if available
    currentContext = {
        type: 'editor_context',
        payload: editorContext
    };
    else if (databaseContext) currentContext = {
        type: 'database_context',
        selectedElementIds: databaseContext.selectedElementIds ?? []
    };
    else if (jiraViewContextData && // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $cXtTj.default).getExperimentValue('jira-ai-jira-view-context-in-rovo-chat-experiment', 'isEnabled', false)) currentContext = {
        type: 'jira_view_context',
        payload: jiraViewContextData
    };
    else if (pageContextType !== (0, $4TNMQ.PageContextType).UNKNOWN) // if no editor context, use page context if available
    currentContext = {
        type: 'current_page',
        pageContextType: pageContextType
    };
    return {
        canUseCurrentPageContextUserPreference: (key)=>{
            return getChatMode(key).useCurrentPageContext;
        },
        setUseCurrentPageContextUserPreference: setUseCurrentPageContext,
        currentContext: currentContext,
        jiraViewContextData: jiraViewContextData
    };
};
module.exports["useCurrentPageAsContext"] = $0893a5bb718d1a9a$export$a96e0fbf256603d8;

});

parcelRegister("aJU2k", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");


var $fiVb2 = parcelRequire("fiVb2");

const $5436fb6e01d0eb8e$export$aaf871ddd4ec7885 = (0, $kBr4q.createActionsHook)((0, $fiVb2.store));
module.exports["useChatModeStoreActions"] = $5436fb6e01d0eb8e$export$aaf871ddd4ec7885;

});

parcelRegister("fiVb2", function(module, exports) {

var $8s9DV = parcelRequire("8s9DV");


var $gchVc = parcelRequire("gchVc");


var $5osBM = parcelRequire("5osBM");


var $eu92c = parcelRequire("eu92c");


var $8XyiW = parcelRequire("8XyiW");

const $485b379839d8bc9f$var$getDefaultChatMode = (options)=>{
    const defaultChatMode = (0, $5osBM.getDerivedDefaultChatMode)();
    if (options?.webSearchDefaultEnabled === undefined) return defaultChatMode;
    return {
        ...defaultChatMode,
        webSearchEnabled: options.webSearchDefaultEnabled
    };
};
const $485b379839d8bc9f$var$actions = {
    setAutoActionApprovalMode: (key, autoActionApprovalMode)=>({ dispatch: dispatch })=>{
            dispatch((0, $8XyiW.updateMode)(key, {
                autoActionApprovalMode: autoActionApprovalMode
            }));
        },
    setReasoningMode: (key, reasoningMode)=>({ dispatch: dispatch })=>{
            dispatch((0, $8XyiW.updateMode)(key, {
                reasoningMode: reasoningMode
            }));
        },
    resetReasoningMode: (key)=>({ dispatch: dispatch })=>{
            dispatch((0, $8XyiW.updateMode)(key, {
                reasoningMode: (0, $5osBM.getDerivedDefaultChatMode)().reasoningMode
            }));
        },
    setDeepResearchEnabled: (key, isEnabled)=>({ dispatch: dispatch })=>{
            dispatch((0, $8XyiW.updateMode)(key, {
                reasoningMode: isEnabled ? 'deep-research' : 'auto'
            }));
        },
    setWebSearchEnabled: (key, isEnabled)=>({ dispatch: dispatch })=>{
            dispatch((0, $8XyiW.updateMode)(key, {
                webSearchEnabled: isEnabled,
                webSearchEnabledOverridden: true
            }));
        },
    setConciergeEnabled: (key, isEnabled)=>({ dispatch: dispatch })=>{
            dispatch((0, $8XyiW.updateMode)(key, {
                conciergeEnabled: isEnabled
            }));
        },
    seedWebSearchDefault: (key, webSearchDefaultEnabled)=>({ dispatch: dispatch, getState: getState })=>{
            const state = getState()[key];
            if (state?.webSearchEnabledOverridden) return false;
            if (state?.rovoControlsSnapshot) {
                dispatch((0, $8XyiW.updateMode)(key, {
                    rovoControlsSnapshot: {
                        ...state.rovoControlsSnapshot,
                        webSearchEnabled: webSearchDefaultEnabled
                    }
                }));
                return false;
            }
            dispatch((0, $8XyiW.updateMode)(key, {
                webSearchEnabled: webSearchDefaultEnabled
            }));
            return true;
        },
    setSourceMode: (key, sourceMode)=>({ dispatch: dispatch })=>{
            dispatch((0, $8XyiW.updateMode)(key, {
                sourceMode: sourceMode
            }));
        },
    setOrgKnowledge: (key, orgKnowledge)=>({ dispatch: dispatch })=>{
            dispatch((0, $8XyiW.updateMode)(key, {
                orgKnowledge: orgKnowledge,
                appFiltersSetByPrompt: false
            }));
        },
    setAppFiltersFromPrompt: (key, filteredApps)=>({ dispatch: dispatch })=>{
            dispatch((0, $8XyiW.updateMode)(key, {
                orgKnowledge: {
                    filteredApps: filteredApps
                },
                appFiltersSetByPrompt: true
            }));
        },
    addAppFilter: (key, app)=>({ getState: getState, dispatch: dispatch })=>{
            const { orgKnowledge: orgKnowledge } = getState()[key] || (0, $5osBM.getDerivedDefaultChatMode)();
            // An empty filter means "all connected apps apply" (see getAppFilters), so a
            // just-connected app is already included. Writing it in explicitly would turn
            // "all apps" into "only this app" and silently drop the rest — leave it be. Same
            // for 'disabled' (org knowledge off entirely). Only a narrowed filter needs the
            // app appended so it isn't excluded from the next message.
            if (orgKnowledge === 'disabled' || orgKnowledge.filteredApps.length === 0) return;
            if (orgKnowledge.filteredApps.some((a)=>a.source === app.source)) return;
            // Preserve appFiltersSetByPrompt (don't force it true): appending on connect must
            // not turn a manually-narrowed filter into a prompt-set one, which the input-clear
            // handler (RovoChatPromptInput) would then discard back to "all apps".
            dispatch((0, $8XyiW.updateMode)(key, {
                orgKnowledge: {
                    filteredApps: [
                        ...orgKnowledge.filteredApps,
                        app
                    ]
                }
            }));
        },
    setUseCurrentPageContext: (key, isEnabled)=>({ dispatch: dispatch })=>{
            dispatch((0, $8XyiW.updateMode)(key, {
                useCurrentPageContext: isEnabled
            }));
        },
    setSpaceSourceCount: (key, count)=>({ dispatch: dispatch })=>{
            dispatch((0, $8XyiW.updateMode)(key, {
                spaceSourceCount: count
            }));
        },
    setBrowserDisplayContextActive: (key, active)=>({ dispatch: dispatch })=>{
            dispatch((0, $8XyiW.updateMode)(key, {
                browserDisplayContextActive: active
            }));
        },
    getBrowserDisplayContextActive: (key)=>({ getState: getState })=>getState()[key]?.browserDisplayContextActive === true,
    setSelectedCloudIds: (key, selectedCloudIds)=>({ dispatch: dispatch })=>{
            dispatch((0, $8XyiW.updateMode)(key, {
                selectedCloudIds: selectedCloudIds
            }));
        },
    setChatMode: (key, chatMode)=>({ dispatch: dispatch })=>{
            let updatedChatMode = chatMode;
            let orgKnowledge = (0, $5osBM.getDerivedDefaultChatMode)().orgKnowledge;
            if (chatMode.appFilters === undefined) orgKnowledge = (0, $5osBM.getDerivedDefaultChatMode)().orgKnowledge;
            else if (chatMode.appFilters.length > 0) orgKnowledge = {
                filteredApps: chatMode.appFilters
            };
            else orgKnowledge = 'disabled';
            updatedChatMode = {
                ...chatMode,
                orgKnowledge: orgKnowledge,
                ...chatMode.webSearchEnabled !== undefined ? {
                    webSearchEnabledOverridden: true
                } : {}
            };
            dispatch((0, $8XyiW.updateMode)(key, {
                ...updatedChatMode,
                appFiltersSetByPrompt: false
            }));
        },
    getChatMode: (key)=>({ getState: getState })=>{
            const state = getState()[key] || (0, $5osBM.getDerivedDefaultChatMode)();
            return {
                ...state,
                ...(0, $eu92c.getDerivedReasoningMode)(state.reasoningMode),
                appFilters: (0, $gchVc.getAppFilters)(state.orgKnowledge)
            };
        },
    clearMode: (key, options)=>({ dispatch: dispatch, getState: getState })=>{
            const currentMode = getState()[key];
            const shouldPreserveWebSearchEnabled = options?.preserveWebSearchEnabled === true && currentMode?.webSearchEnabledOverridden === true;
            const shouldPreserveUseCurrentPageContext = options?.preserveUseCurrentPageContext === true && currentMode?.useCurrentPageContext === false;
            const defaultChatMode = $485b379839d8bc9f$var$getDefaultChatMode(options);
            dispatch((0, $8XyiW.updateMode)(key, {
                ...defaultChatMode,
                webSearchEnabled: shouldPreserveWebSearchEnabled ? currentMode.webSearchEnabled : defaultChatMode.webSearchEnabled,
                webSearchEnabledOverridden: shouldPreserveWebSearchEnabled,
                useCurrentPageContext: shouldPreserveUseCurrentPageContext ? currentMode.useCurrentPageContext : defaultChatMode.useCurrentPageContext
            }));
        },
    /**
   * Keeps the Rovo-owned controls (reasoning mode, web search, app filters) in
   * sync with who owns the next turn, and is the single owner of the
   * snapshot/restore state.
   *
   * The stored `rovoControlsSnapshot` doubles as the edge-detector so callers
   * can invoke this idempotently every render without tracking previous state:
   *  - `suppressed` with no snapshot: a specialist just took the turn — stash the
   *    current controls and reset them to defaults so the specialist's own
   *    reasoning/sources apply.
   *  - not `suppressed` with a snapshot: the turn returned to Rovo — restore the
   *    stashed controls and clear the snapshot.
   *  - otherwise: no-op.
   *
   * Returns `RovoControlsSnapshot | null`: the effective control values it applied
   * (or `null` when nothing changed) so the caller can forward them to its
   * `on*Change` props. On the reset path `appFilters` is `[]`; on the restore path
   * it is the stashed value, which may be `undefined` (meaning "no filter / all
   * apps"). Callers coalesce with `?? []` before calling `onFilteredAppsChange`.
   */ setRovoControlsSuppressed: (key, { suppressed: suppressed })=>({ dispatch: dispatch, getState: getState })=>{
            const state = getState()[key] || (0, $5osBM.getDerivedDefaultChatMode)();
            const snapshot = state.rovoControlsSnapshot ?? null;
            if (suppressed && snapshot === null) {
                const derived = {
                    ...state,
                    ...(0, $eu92c.getDerivedReasoningMode)(state.reasoningMode),
                    appFilters: (0, $gchVc.getAppFilters)(state.orgKnowledge)
                };
                dispatch((0, $8XyiW.updateMode)(key, {
                    rovoControlsSnapshot: {
                        reasoningMode: state.reasoningMode,
                        autoActionApprovalMode: state.autoActionApprovalMode,
                        webSearchEnabled: derived.webSearchEnabled,
                        sourceMode: state.sourceMode,
                        appFilters: derived.appFilters,
                        selectedCloudIds: state.selectedCloudIds
                    },
                    reasoningMode: (0, $5osBM.getDerivedDefaultChatMode)().reasoningMode,
                    autoActionApprovalMode: 'ALWAYS_HUMAN',
                    webSearchEnabled: false,
                    sourceMode: (0, $5osBM.getDerivedDefaultChatMode)().sourceMode,
                    orgKnowledge: (0, $5osBM.getDerivedDefaultChatMode)().orgKnowledge,
                    selectedCloudIds: [],
                    appFiltersSetByPrompt: false
                }));
                return {
                    reasoningMode: (0, $5osBM.getDerivedDefaultChatMode)().reasoningMode,
                    autoActionApprovalMode: 'ALWAYS_HUMAN',
                    webSearchEnabled: false,
                    sourceMode: (0, $5osBM.getDerivedDefaultChatMode)().sourceMode,
                    appFilters: [],
                    selectedCloudIds: []
                };
            }
            if (!suppressed && snapshot !== null) {
                dispatch((0, $8XyiW.updateMode)(key, {
                    rovoControlsSnapshot: null,
                    reasoningMode: snapshot.reasoningMode,
                    autoActionApprovalMode: snapshot.autoActionApprovalMode,
                    webSearchEnabled: snapshot.webSearchEnabled,
                    sourceMode: snapshot.sourceMode,
                    orgKnowledge: snapshot.appFilters === undefined ? (0, $5osBM.getDerivedDefaultChatMode)().orgKnowledge : snapshot.appFilters.length > 0 ? {
                        filteredApps: snapshot.appFilters
                    } : 'disabled',
                    selectedCloudIds: snapshot.selectedCloudIds,
                    appFiltersSetByPrompt: false
                }));
                return snapshot;
            }
            return null;
        }
};
const $485b379839d8bc9f$export$6f57813fe9f31bf9 = (0, $8s9DV.createStore)({
    initialState: {},
    actions: $485b379839d8bc9f$var$actions
});
module.exports["store"] = $485b379839d8bc9f$export$6f57813fe9f31bf9;

});

parcelRegister("gchVc", function(module, exports) {
const $3b98ce1c6aca161d$export$6c9b22c84a96fd6c = (orgKnowledge)=>{
    if (orgKnowledge === 'disabled') // no org knowledge applied at all.
    return [];
    else if (orgKnowledge.filteredApps.length === 0) // all org knowledge applied and no apps filtered.
    return undefined;
    else // org knowledge applied and apps filtered.
    return orgKnowledge.filteredApps;
};
module.exports["getAppFilters"] = $3b98ce1c6aca161d$export$6c9b22c84a96fd6c;

});

parcelRegister("5osBM", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");

const $075476664b139afe$var$getWebSearchDefaultFromStorage = ()=>{
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    if (typeof globalThis === 'undefined' || !globalThis.document || !globalThis.localStorage) return null;
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    const value = globalThis.localStorage.getItem('rovo-chat-web-search-default-on');
    if (value === null) return null;
    return value !== 'false';
};
const $075476664b139afe$export$99faa9801df051b0 = ()=>{
    const storageValue = $075476664b139afe$var$getWebSearchDefaultFromStorage();
    // If localStorage explicitly says it's off, default should be off
    // Otherwise, use the experiment flag value
    const webSearchEnabled = storageValue === false ? false : (0, $cXtTj.default).getExperimentValue('rovo_web_search_default_on', 'isEnabled', false);
    return {
        reasoningMode: 'auto',
        autoActionApprovalMode: 'ALWAYS_HUMAN',
        webSearchEnabled: webSearchEnabled,
        conciergeEnabled: false,
        sourceMode: 'GENERAL',
        orgKnowledge: {
            filteredApps: []
        },
        selectedCloudIds: [],
        autoApplyEnabled: true,
        appFiltersSetByPrompt: false,
        useCurrentPageContext: (0, $iDrrr.fg)('disable_default_on_current_page_as_context') ? false : true
    };
};
module.exports["getDerivedDefaultChatMode"] = $075476664b139afe$export$99faa9801df051b0;

});

parcelRegister("eu92c", function(module, exports) {

var $ePmEF = parcelRequire("ePmEF");

const $dcc4545520df4d8c$export$d6ea7bd50e1b3540 = (reasoningMode)=>{
    const isThinkDeeperMode = reasoningMode === 'think-deeper' || reasoningMode === 'think-deeper-marathon' || reasoningMode === 'think-deeper-orchestrator';
    return {
        deepResearchEnabled: reasoningMode === 'deep-research',
        thinkDeeperEnabled: isThinkDeeperMode,
        fastModeEnabled: reasoningMode === 'fast',
        autoReasoningEnabled: reasoningMode === 'auto',
        alphaExtendedThinkingMode: (0, $ePmEF.getAlphaExtendedThinkingMode)(reasoningMode),
        taskModeEnabled: reasoningMode === 'task'
    };
};
module.exports["getDerivedReasoningMode"] = $dcc4545520df4d8c$export$d6ea7bd50e1b3540;

});

parcelRegister("ePmEF", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $f28d0c39486e1a59$export$61a509aba0cee914 = (reasoningMode)=>{
    if (!(0, $iDrrr.fg)('rovo_chat_marathon_orchestrator_reasoning_modes')) return undefined;
    switch(reasoningMode){
        case 'think-deeper-marathon':
            return 'MARATHON';
        case 'think-deeper-orchestrator':
            return 'LONG_HORIZON';
        default:
            return undefined;
    }
};
module.exports["getAlphaExtendedThinkingMode"] = $f28d0c39486e1a59$export$61a509aba0cee914;

});

parcelRegister("8XyiW", function(module, exports) {

var $5osBM = parcelRequire("5osBM");

const $3fc1c590f304ee0c$export$f80026ff7d109add = (key, mode)=>{
    return ({ setState: setState, getState: getState })=>{
        const state = getState()[key] || (0, $5osBM.getDerivedDefaultChatMode)();
        setState({
            [key]: {
                ...state,
                ...mode
            }
        });
    };
};
module.exports["updateMode"] = $3fc1c590f304ee0c$export$f80026ff7d109add;

});

parcelRegister("4TNMQ", function(module, exports) {
var $4d02c50d752d2f92$export$7f7a6f1c2ab5127 = /*#__PURE__*/ function(PageContextType) {
    PageContextType["BITBUCKET"] = "bitbucket";
    PageContextType["CONFLUENCE_HOME"] = "confluence-home";
    PageContextType["CONFLUENCE_PAGE_VIEW"] = "confluence-page-view";
    PageContextType["CONFLUENCE_PAGE_EDIT"] = "confluence-page-edit";
    PageContextType["CONFLUENCE_WHITEBOARD"] = "confluence-whiteboard";
    PageContextType["CONFLUENCE_DATABASE"] = "confluence-database";
    PageContextType["CONFLUENCE_FOLDER"] = "confluence-folder";
    PageContextType["JIRA_HOME"] = "jira-home";
    PageContextType["JIRA_ISSUE_VIEW"] = "jira-issue-view";
    PageContextType["JIRA_BACKLOG"] = "jira-backlog";
    PageContextType["JIRA_BOARD"] = "jira-board-view";
    PageContextType["JIRA_PROJECT"] = "jira-project";
    PageContextType["JIRA_SERVICE_DESK"] = "jira-service-desk";
    PageContextType["JIRA_PLAN"] = "jira-plan";
    PageContextType["JIRA_CMP_SPACE_SETTINGS_PEOPLE_LEGACY"] = "jira-cmp-space-settings-people-legacy";
    PageContextType["JIRA_CMP_SPACE_SETTINGS_PERMISSIONS_LEGACY"] = "jira-cmp-space-settings-permissions-legacy";
    PageContextType["JIRA_ISSUES_LIST"] = "jira-issues-list";
    PageContextType["JIRA_ITAM_HAM"] = "jira-itam-ham";
    PageContextType["ATLAS_HOME"] = "atlas-home";
    PageContextType["ATLAS_PROJECT"] = "atlas-project";
    PageContextType["ATLAS_GOAL"] = "atlas-goal";
    PageContextType["FEEDBACK_APP"] = "feedback-app";
    PageContextType["STORE_HOME"] = "store-home";
    PageContextType["TRELLO_BOARD"] = "trello-board";
    PageContextType["TRELLO_CARD"] = "trello-card";
    PageContextType["LOOM_VIDEO"] = "loom-video";
    PageContextType["TEAM_PROFILE"] = "team-profile";
    PageContextType["USER_PROFILE"] = "user-profile";
    PageContextType["UNKNOWN"] = "unknown";
    return PageContextType;
}({});
module.exports["PageContextType"] = $4d02c50d752d2f92$export$7f7a6f1c2ab5127;

});

parcelRegister("d9k9Z", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $izud5 = parcelRequire("izud5");


var $lN13T = parcelRequire("lN13T");


var $hywIT = parcelRequire("hywIT");

const $050ca14b256e7a37$export$bc4bf2ff8e40b690 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const useCase = t0 === undefined ? (0, $lN13T.UseCase).THINKING_VIEW : t0;
    const location = (0, $hywIT.useWindowLocation)();
    let t1;
    if ($[0] !== location || $[1] !== useCase) {
        t1 = (0, $izud5.determinePageType)(location, useCase);
        $[0] = location;
        $[1] = useCase;
        $[2] = t1;
    } else t1 = $[2];
    const [pageContextType, setPageContextType] = (0, $cozmU.useState)(t1);
    let t2;
    let t3;
    if ($[3] !== location || $[4] !== useCase) {
        t2 = ()=>{
            setPageContextType((0, $izud5.determinePageType)(location, useCase));
        };
        t3 = [
            location,
            useCase
        ];
        $[3] = location;
        $[4] = useCase;
        $[5] = t2;
        $[6] = t3;
    } else {
        t2 = $[5];
        t3 = $[6];
    }
    (0, $cozmU.useEffect)(t2, t3);
    return pageContextType;
} : (useCase = (0, $lN13T.UseCase).THINKING_VIEW)=>{
    const location = (0, $hywIT.useWindowLocation)();
    const [pageContextType, setPageContextType] = (0, $cozmU.useState)((0, $izud5.determinePageType)(location, useCase));
    (0, $cozmU.useEffect)(()=>{
        setPageContextType((0, $izud5.determinePageType)(location, useCase));
    }, [
        location,
        useCase
    ]);
    return pageContextType;
};
module.exports["usePageContextType"] = $050ca14b256e7a37$export$bc4bf2ff8e40b690;

});

parcelRegister("izud5", function(module, exports) {

var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $4TNMQ = parcelRequire("4TNMQ");


var $lN13T = parcelRequire("lN13T");

const $9f65aecae4ace5e7$var$ALLOWED_PAGE_CONTEXT_TYPES = {
    [(0, $lN13T.UseCase).THINKING_VIEW]: [
        (0, $4TNMQ.PageContextType).CONFLUENCE_PAGE_EDIT,
        (0, $4TNMQ.PageContextType).CONFLUENCE_PAGE_VIEW,
        (0, $4TNMQ.PageContextType).CONFLUENCE_WHITEBOARD,
        (0, $4TNMQ.PageContextType).CONFLUENCE_DATABASE,
        (0, $4TNMQ.PageContextType).CONFLUENCE_FOLDER,
        (0, $4TNMQ.PageContextType).JIRA_ISSUE_VIEW,
        (0, $4TNMQ.PageContextType).JIRA_SERVICE_DESK,
        (0, $4TNMQ.PageContextType).JIRA_PROJECT,
        (0, $4TNMQ.PageContextType).JIRA_PLAN,
        (0, $4TNMQ.PageContextType).JIRA_CMP_SPACE_SETTINGS_PEOPLE_LEGACY,
        (0, $4TNMQ.PageContextType).JIRA_CMP_SPACE_SETTINGS_PERMISSIONS_LEGACY,
        (0, $4TNMQ.PageContextType).JIRA_ISSUES_LIST,
        (0, $4TNMQ.PageContextType).JIRA_ITAM_HAM,
        (0, $4TNMQ.PageContextType).ATLAS_PROJECT,
        (0, $4TNMQ.PageContextType).ATLAS_GOAL,
        (0, $4TNMQ.PageContextType).FEEDBACK_APP,
        (0, $4TNMQ.PageContextType).STORE_HOME,
        (0, $4TNMQ.PageContextType).TRELLO_BOARD,
        (0, $4TNMQ.PageContextType).TRELLO_CARD,
        (0, $4TNMQ.PageContextType).LOOM_VIDEO,
        (0, $4TNMQ.PageContextType).TEAM_PROFILE,
        (0, $4TNMQ.PageContextType).USER_PROFILE
    ],
    [(0, $lN13T.UseCase).AUTOCOMPLETE]: [
        (0, $4TNMQ.PageContextType).BITBUCKET,
        (0, $4TNMQ.PageContextType).CONFLUENCE_HOME,
        (0, $4TNMQ.PageContextType).CONFLUENCE_PAGE_EDIT,
        (0, $4TNMQ.PageContextType).CONFLUENCE_PAGE_VIEW,
        (0, $4TNMQ.PageContextType).CONFLUENCE_WHITEBOARD,
        (0, $4TNMQ.PageContextType).CONFLUENCE_DATABASE,
        (0, $4TNMQ.PageContextType).JIRA_BACKLOG,
        (0, $4TNMQ.PageContextType).JIRA_HOME,
        (0, $4TNMQ.PageContextType).JIRA_ISSUE_VIEW,
        (0, $4TNMQ.PageContextType).ATLAS_HOME,
        (0, $4TNMQ.PageContextType).STORE_HOME,
        (0, $4TNMQ.PageContextType).TRELLO_BOARD,
        (0, $4TNMQ.PageContextType).TRELLO_CARD
    ]
};
const $9f65aecae4ace5e7$var$FALLBACK_PAGE_CONTEXT_TYPE = {
    [(0, $lN13T.UseCase).THINKING_VIEW]: (0, $4TNMQ.PageContextType).UNKNOWN,
    [(0, $lN13T.UseCase).AUTOCOMPLETE]: (0, $4TNMQ.PageContextType).ATLAS_HOME
};
const $9f65aecae4ace5e7$export$a905239756c1fbae = (location, useCase = (0, $lN13T.UseCase).THINKING_VIEW)=>{
    const allowedTypes = new Set($9f65aecae4ace5e7$var$ALLOWED_PAGE_CONTEXT_TYPES[useCase]);
    const allUrlPatterns = [
        [
            (0, $4TNMQ.PageContextType).BITBUCKET,
            /bitbucket\.org\/.*/
        ],
        [
            (0, $4TNMQ.PageContextType).CONFLUENCE_PAGE_EDIT,
            /\/wiki\/spaces\/[^\/]+\/(?:pages|blog)\/edit-v2\//
        ],
        [
            (0, $4TNMQ.PageContextType).CONFLUENCE_PAGE_VIEW,
            /\/wiki\/spaces\/[^\/]+\/(?:pages|blog)\//
        ],
        // Support whiteboard url
        [
            (0, $4TNMQ.PageContextType).CONFLUENCE_WHITEBOARD,
            /\/wiki\/spaces\/[^\/]+\/whiteboard\//
        ],
        // Support whiteboard iframe url
        [
            (0, $4TNMQ.PageContextType).CONFLUENCE_WHITEBOARD,
            /\/whiteboards\/whiteboard\/[^\/\?]+/
        ],
        // Support whiteboard internal url after spa transition
        [
            (0, $4TNMQ.PageContextType).CONFLUENCE_WHITEBOARD,
            /\/whiteboard\/[a-f0-9-]+/
        ],
        // Support database url
        [
            (0, $4TNMQ.PageContextType).CONFLUENCE_DATABASE,
            /\/wiki\/spaces\/[^\/]+\/database\//
        ],
        // Support database internal url after spa transition
        [
            (0, $4TNMQ.PageContextType).CONFLUENCE_DATABASE,
            /\/database\/[a-f0-9-]+/
        ],
        // Support folder url
        ...(0, $4o0zT.isExperimentEnabled)('folder_content_wrapper') ? [
            [
                (0, $4TNMQ.PageContextType).CONFLUENCE_FOLDER,
                /\/wiki\/spaces\/[^\/]+\/folder\//
            ]
        ] : [],
        [
            (0, $4TNMQ.PageContextType).JIRA_BACKLOG,
            /\/jira\/.*\/backlog$/
        ],
        [
            (0, $4TNMQ.PageContextType).JIRA_BOARD,
            /\/jira\/.*\/boards\//
        ],
        [
            (0, $4TNMQ.PageContextType).JIRA_ISSUE_VIEW,
            /\/browse\/[^\/]+$/
        ],
        [
            (0, $4TNMQ.PageContextType).JIRA_ISSUE_VIEW,
            /\/jira\/.+\/projects\/.+\?selectedIssue/
        ],
        [
            (0, $4TNMQ.PageContextType).JIRA_HOME,
            /\/jira\/dashboards\/last-visited$/
        ],
        [
            (0, $4TNMQ.PageContextType).JIRA_SERVICE_DESK,
            /\/jira(?:\/.+)?\/servicedesk\/projects\/.+\/queues\/issue\//
        ],
        [
            (0, $4TNMQ.PageContextType).JIRA_PROJECT,
            /\/jira\/.+\/projects\//
        ],
        [
            (0, $4TNMQ.PageContextType).JIRA_ISSUES_LIST,
            /\/issues\/\?jql=/
        ],
        ...(0, $iDrrr.fg)('itam_ftw') ? [
            [
                (0, $4TNMQ.PageContextType).JIRA_ITAM_HAM,
                /\/jira\/itam\/ham(\/|$)/
            ]
        ] : [],
        ...(0, $iDrrr.fg)('rovo_chat_jira_plans_minion') ? [
            [
                (0, $4TNMQ.PageContextType).JIRA_PLAN,
                /\/jira\/plans\/\d+\//
            ]
        ] : [],
        [
            (0, $4TNMQ.PageContextType).JIRA_HOME,
            /\/jira\/dashboards\/last-visited$/
        ],
        [
            (0, $4TNMQ.PageContextType).JIRA_CMP_SPACE_SETTINGS_PEOPLE_LEGACY,
            /\/plugins\/servlet\/project-config\/[^\/]+\/people/
        ],
        [
            (0, $4TNMQ.PageContextType).JIRA_CMP_SPACE_SETTINGS_PERMISSIONS_LEGACY,
            /\/plugins\/servlet\/project-config\/[^\/]+\/permissions/
        ],
        // atlas home is either home.atlassian.com, home.stg.atlassian.com, team.atlassian.com, or team.stg.atlassian.com
        [
            (0, $4TNMQ.PageContextType).ATLAS_HOME,
            /\/(home|team)\./
        ],
        [
            (0, $4TNMQ.PageContextType).ATLAS_PROJECT,
            /\/(home|team).+\/project\/ATLAS-/
        ],
        [
            (0, $4TNMQ.PageContextType).ATLAS_GOAL,
            /\/(home|team).+\/goal\/ATLAS-/
        ],
        // Store and Marketplace surfaces can appear on both internal and production domains.
        [
            (0, $4TNMQ.PageContextType).STORE_HOME,
            /(?:store\.stg\.atlassian\.com|marketplace-store\.atlassian\.com).*\/(?:(?:objects|categories)\/|search(?:\/|\?|$))/
        ],
        [
            (0, $4TNMQ.PageContextType).TEAM_PROFILE,
            /\/(home|team)\..+\/people\/team/
        ],
        [
            (0, $4TNMQ.PageContextType).USER_PROFILE,
            /\/(home|team)\..+\/people\/(?!team)/
        ],
        [
            (0, $4TNMQ.PageContextType).FEEDBACK_APP,
            /\/feedback-app/
        ],
        // Trello: trello.com and trellis.coffee (enterprise)
        [
            (0, $4TNMQ.PageContextType).TRELLO_CARD,
            /(?:trello\.com|trellis\.coffee)\/c\/[^/]+/
        ],
        [
            (0, $4TNMQ.PageContextType).TRELLO_BOARD,
            /(?:trello\.com|trellis\.coffee)\/b\/[^/]+/
        ],
        // Loom share URLs: www.loom.com, stage.loom.com, loomlocal.com:<port>
        [
            (0, $4TNMQ.PageContextType).LOOM_VIDEO,
            /(?:(?:www|stage)\.loom\.com|loomlocal\.com(?::\d+)?)\/share\/[^\/?#]+/
        ]
    ];
    const urlPatterns = allUrlPatterns.filter(([type])=>allowedTypes.has(type));
    for (const [type, pattern] of urlPatterns){
        const matched = pattern.test(location);
        if (!matched) continue;
        return type;
    }
    return $9f65aecae4ace5e7$var$FALLBACK_PAGE_CONTEXT_TYPE[useCase];
};
module.exports["determinePageType"] = $9f65aecae4ace5e7$export$a905239756c1fbae;

});

parcelRegister("lN13T", function(module, exports) {
var $60986b1218619e0e$export$59961d6586ccfd15 = /*#__PURE__*/ function(UseCase) {
    UseCase["THINKING_VIEW"] = "thinking-view";
    UseCase["AUTOCOMPLETE"] = "autocomplete";
    return UseCase;
}({});
module.exports["UseCase"] = $60986b1218619e0e$export$59961d6586ccfd15;

});

parcelRegister("hywIT", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $9Yqfz = parcelRequire("9Yqfz");


var $jR5eS = parcelRequire("jR5eS");

const $e75d45e703058f92$export$6fa751d66e55d2e1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const contextValue = (0, $cozmU.useContext)((0, $jR5eS.WindowLocationContext));
    const location = (0, $cozmU.useSyncExternalStore)((0, $9Yqfz.subscribeToLocation), (0, $9Yqfz.getLocationSnapshot), (0, $9Yqfz.getLocationServerSnapshot));
    return contextValue ?? location;
} : ()=>{
    const contextValue = (0, $cozmU.useContext)((0, $jR5eS.WindowLocationContext));
    const location = (0, $cozmU.useSyncExternalStore)((0, $9Yqfz.subscribeToLocation), (0, $9Yqfz.getLocationSnapshot), (0, $9Yqfz.getLocationServerSnapshot));
    return contextValue ?? location;
};
module.exports["useWindowLocation"] = $e75d45e703058f92$export$6fa751d66e55d2e1;

});

parcelRegister("9Yqfz", function(module, exports) {

var $cbY7C = parcelRequire("cbY7C");

const $35332082f96c50ad$var$locationListeners = new Set();
const $35332082f96c50ad$var$titleListeners = new Set();
let $35332082f96c50ad$var$patched = false;
let $35332082f96c50ad$var$currentHref = '';
let $35332082f96c50ad$var$currentTitle = '';
let $35332082f96c50ad$var$titleMutationObserver;
const $35332082f96c50ad$var$isBrowser = ()=>typeof window !== 'undefined';
const $35332082f96c50ad$var$hasDocument = ()=>typeof document !== 'undefined';
const $35332082f96c50ad$var$readHref = ()=>$35332082f96c50ad$var$isBrowser() ? window.location.href : '';
const $35332082f96c50ad$var$readTitle = ()=>$35332082f96c50ad$var$hasDocument() ? document.title : '';
// Snapshot the set so a listener that (un)subscribes during notification does
// not mutate the collection we are iterating.
const $35332082f96c50ad$var$emit = (set)=>{
    for (const listener of Array.from(set))listener();
};
const $35332082f96c50ad$var$notifyLocation = ()=>{
    const nextHref = $35332082f96c50ad$var$readHref();
    if (nextHref === $35332082f96c50ad$var$currentHref) return;
    $35332082f96c50ad$var$currentHref = nextHref;
    $35332082f96c50ad$var$emit($35332082f96c50ad$var$locationListeners);
};
const $35332082f96c50ad$var$notifyTitle = ()=>{
    const nextTitle = $35332082f96c50ad$var$readTitle();
    if (nextTitle === $35332082f96c50ad$var$currentTitle) return;
    $35332082f96c50ad$var$currentTitle = nextTitle;
    $35332082f96c50ad$var$emit($35332082f96c50ad$var$titleListeners);
};
const $35332082f96c50ad$var$installOnce = ()=>{
    if ($35332082f96c50ad$var$patched || !$35332082f96c50ad$var$isBrowser()) return;
    $35332082f96c50ad$var$patched = true;
    $35332082f96c50ad$var$currentHref = $35332082f96c50ad$var$readHref();
    $35332082f96c50ad$var$currentTitle = $35332082f96c50ad$var$readTitle();
    const nativePushState = window.history.pushState.bind(window.history);
    const nativeReplaceState = window.history.replaceState.bind(window.history);
    // Intentionally permanent: we never restore these. See module docblock.
    window.history.pushState = function(...args) {
        nativePushState(...args);
        $35332082f96c50ad$var$notifyLocation();
    };
    window.history.replaceState = function(...args) {
        nativeReplaceState(...args);
        $35332082f96c50ad$var$notifyLocation();
    };
    (0, $cbY7C.bindAll)(window, [
        {
            type: 'popstate',
            listener: $35332082f96c50ad$var$notifyLocation
        },
        {
            type: 'hashchange',
            listener: $35332082f96c50ad$var$notifyLocation
        }
    ]);
    // Watch the <title> element for changes. The shell updates `document.title`
    // after the location change, so this is what keeps title-derived UI fresh.
    if ($35332082f96c50ad$var$hasDocument() && typeof MutationObserver !== 'undefined') {
        const titleEl = document.querySelector('title');
        if (titleEl) {
            $35332082f96c50ad$var$titleMutationObserver = new MutationObserver($35332082f96c50ad$var$notifyTitle);
            $35332082f96c50ad$var$titleMutationObserver.observe(titleEl, {
                childList: true,
                characterData: true,
                subtree: true
            });
        }
    }
};
const $35332082f96c50ad$export$9dcd3b3f4f8a572f = (listener)=>{
    $35332082f96c50ad$var$installOnce();
    $35332082f96c50ad$var$locationListeners.add(listener);
    return ()=>{
        $35332082f96c50ad$var$locationListeners.delete(listener);
    };
};
const $35332082f96c50ad$export$c6a96cf4e0abf9ac = (listener)=>{
    $35332082f96c50ad$var$installOnce();
    $35332082f96c50ad$var$titleListeners.add(listener);
    return ()=>{
        $35332082f96c50ad$var$titleListeners.delete(listener);
    };
};
const $35332082f96c50ad$export$ef3949f6f6b35a98 = ()=>$35332082f96c50ad$var$readHref();
const $35332082f96c50ad$export$1296b6401b011699 = ()=>'';
const $35332082f96c50ad$export$b8645558bd27590a = ()=>$35332082f96c50ad$var$readTitle();
const $35332082f96c50ad$export$60c631f42ecb55a7 = ()=>'';
const $35332082f96c50ad$export$9f0e18eb4b88e00d = ()=>{
    $35332082f96c50ad$var$patched = false;
    $35332082f96c50ad$var$currentHref = '';
    $35332082f96c50ad$var$currentTitle = '';
    $35332082f96c50ad$var$locationListeners.clear();
    $35332082f96c50ad$var$titleListeners.clear();
    $35332082f96c50ad$var$titleMutationObserver?.disconnect();
    $35332082f96c50ad$var$titleMutationObserver = undefined;
};
module.exports["subscribeToLocation"] = $35332082f96c50ad$export$9dcd3b3f4f8a572f;
module.exports["subscribeToTitle"] = $35332082f96c50ad$export$c6a96cf4e0abf9ac;
module.exports["getLocationSnapshot"] = $35332082f96c50ad$export$ef3949f6f6b35a98;
module.exports["getLocationServerSnapshot"] = $35332082f96c50ad$export$1296b6401b011699;
module.exports["getTitleSnapshot"] = $35332082f96c50ad$export$b8645558bd27590a;
module.exports["getTitleServerSnapshot"] = $35332082f96c50ad$export$60c631f42ecb55a7;

});

parcelRegister("jR5eS", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $9519c4d899a3b020$export$46133998910543ac = (0, $cozmU.createContext)(null);
module.exports["WindowLocationContext"] = $9519c4d899a3b020$export$46133998910543ac;

});

parcelRegister("7685l", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");


var $gchVc = parcelRequire("gchVc");


var $5osBM = parcelRequire("5osBM");


var $eu92c = parcelRequire("eu92c");


var $fiVb2 = parcelRequire("fiVb2");

const $69cb0d12a6c3bd0b$var$selector = (state, key)=>{
    const chatMode = state[key] || (0, $5osBM.getDerivedDefaultChatMode)();
    return {
        ...chatMode,
        ...(0, $eu92c.getDerivedReasoningMode)(chatMode.reasoningMode),
        appFilters: (0, $gchVc.getAppFilters)(chatMode.orgKnowledge)
    };
};
const $69cb0d12a6c3bd0b$export$cdc6dc7c4e8829fa = (0, $kBr4q.createHook)((0, $fiVb2.store), {
    selector: $69cb0d12a6c3bd0b$var$selector
});
module.exports["useChatModeStore"] = $69cb0d12a6c3bd0b$export$cdc6dc7c4e8829fa;

});

parcelRegister("2Pvub", function(module, exports) {
/**
 * Machine → React bridge.
 *
 * The @atlassian/state-machine machine is the single source of truth for a flow's phase
 * (`machine.state()`). But the machine is not React-aware, and its
 * `onTransition(listener)` registers a listener that can only be removed by
 * `destroy()`-ing the whole machine (there is no per-listener unsubscribe).
 * `useSyncExternalStore` requires a `subscribe(cb) => unsubscribe` contract, so
 * this module provides that missing piece.
 *
 * Design:
 * - We register exactly ONE `onTransition` listener per machine (a "fan-out"),
 *   and maintain our own `Set` of React subscriber callbacks that we can add to
 *   and remove from individually. That gives real unsubscribe semantics on top
 *   of the lib's append-only listener list.
 * - There is also a set of GLOBAL subscribers (for aggregate reads like
 *   "is any remix in progress"), notified on every machine's transition and on
 *   registry membership changes (start/end of a flow).
 *
 * With this bridge:
 * - A late-mounting component reads `machine.state()` synchronously on mount
 *   (correct initial value — no missed-command problem).
 * - A mounted component re-renders on the next transition (subscription).
 *
 * Both fall out of one `useSyncExternalStore` hook (see `useMachineState.ts`);
 * no separate reactive mirror of the phase is required.
 *
 * Additive; not wired into live flows.
 */ /** Per-machine React subscribers, keyed by remix id. */ const $5b9d77ef809dc852$var$perMachineSubscribers = new Map();
/** Machines we have already attached our single fan-out listener to. */ const $5b9d77ef809dc852$var$bridgedMachines = new Set();
/** Global subscribers (aggregate reads across all flows). */ const $5b9d77ef809dc852$var$globalSubscribers = new Set();
const $5b9d77ef809dc852$var$notify = (subscribers)=>{
    if (!subscribers) return;
    // Copy before iterating: a subscriber may unsubscribe during notification.
    for (const cb of Array.from(subscribers))cb();
};
const $5b9d77ef809dc852$export$fffa0fc87565fa3b = (id, machine)=>{
    if ($5b9d77ef809dc852$var$bridgedMachines.has(id)) return;
    $5b9d77ef809dc852$var$bridgedMachines.add(id);
    machine.onTransition(()=>{
        $5b9d77ef809dc852$var$notify($5b9d77ef809dc852$var$perMachineSubscribers.get(id));
        $5b9d77ef809dc852$var$notify($5b9d77ef809dc852$var$globalSubscribers);
    });
    // Membership changed → aggregate reads (e.g. isAnyRemixing) must re-evaluate.
    $5b9d77ef809dc852$var$notify($5b9d77ef809dc852$var$globalSubscribers);
};
const $5b9d77ef809dc852$export$b2ca8b3ec66a9029 = (id)=>{
    $5b9d77ef809dc852$var$perMachineSubscribers.delete(id);
    $5b9d77ef809dc852$var$bridgedMachines.delete(id);
    $5b9d77ef809dc852$var$notify($5b9d77ef809dc852$var$globalSubscribers);
};
const $5b9d77ef809dc852$export$d6df5c560ea5cbbc = (id, callback)=>{
    let set = $5b9d77ef809dc852$var$perMachineSubscribers.get(id);
    if (!set) {
        set = new Set();
        $5b9d77ef809dc852$var$perMachineSubscribers.set(id, set);
    }
    set.add(callback);
    return ()=>{
        set?.delete(callback);
    };
};
const $5b9d77ef809dc852$export$fae2e146ec761b28 = (callback)=>{
    $5b9d77ef809dc852$var$globalSubscribers.add(callback);
    return ()=>{
        $5b9d77ef809dc852$var$globalSubscribers.delete(callback);
    };
};
const $5b9d77ef809dc852$export$2faa64766bd050ee = ()=>{
    $5b9d77ef809dc852$var$perMachineSubscribers.clear();
    $5b9d77ef809dc852$var$bridgedMachines.clear();
    $5b9d77ef809dc852$var$globalSubscribers.clear();
};
module.exports["registerMachineWithBridge"] = $5b9d77ef809dc852$export$fffa0fc87565fa3b;
module.exports["unregisterMachineFromBridge"] = $5b9d77ef809dc852$export$b2ca8b3ec66a9029;
module.exports["subscribeToMachine"] = $5b9d77ef809dc852$export$d6df5c560ea5cbbc;
module.exports["subscribeToAnyMachine"] = $5b9d77ef809dc852$export$fae2e146ec761b28;

});

parcelRegister("bWlOZ", function(module, exports) {
/**
 * Machine-backed Remix flow controller (plain module, no react-sweet-state).
 *
 * This replaces the previous `remixMachineStore` (which mirrored machine phase
 * into a SweetState store). The machine is now the SINGLE source of truth:
 *
 * - Each remix flow is a state **machine** (`./remixMachine`). Machines are
 *   imperative, non-serialisable objects; they live in a module-level registry
 *   (`machineRegistry`), NOT in any React store.
 * - React consumers read the machine directly via the `useSyncExternalStore`
 *   hooks in `./useMachineState` (phase, instance view, active ids, isAnyRemixing),
 *   which subscribe through `./machineBridge`. There is no mirrored phase copy.
 * - This file owns only the **write/lifecycle** side: create a flow, wire its
 *   transitions/teardown to the bridge, send events, end/reset. All of this is
 *   plain functions callable from anywhere (React or not) — the registry and
 *   bridge are module-scoped.
 *
 * The explicit-machine model (events in, `onTransition`/`onDone` out, effects for
 * side-effects) is exactly what the reviewers asked for; dropping SweetState
 * removes the redundant second source of truth.
 */ 
var $cKwXx = parcelRequire("cKwXx");


var $2sIE1 = parcelRequire("2sIE1");


var $h4gwB = parcelRequire("h4gwB");


var $2Pvub = parcelRequire("2Pvub");


var $MbeHu = parcelRequire("MbeHu");


var $1Ukdn = parcelRequire("1Ukdn");

/**
 * Single-active policy, same as before: a removable guard on top of a plural
 * model. Flip to `false` (or make per-call) to allow concurrent flows.
 */ const $b94e0c21d1c0143c$var$SINGLE_ACTIVE_POLICY = true;
/**
 * Non-reactive registry of live flows, keyed by remix id. Alongside each
 * machine, retain its dispatcher and immutable command identity so teardown
 * never depends on mutable machine context.
 */ const $b94e0c21d1c0143c$var$machineRegistry = new Map();
const $b94e0c21d1c0143c$export$bb6da1182d6c1fa5 = (id)=>$b94e0c21d1c0143c$var$machineRegistry.get(id)?.machine;
const $b94e0c21d1c0143c$export$354cb0a867425c7e = ()=>Array.from($b94e0c21d1c0143c$var$machineRegistry.keys());
const $b94e0c21d1c0143c$export$bdc0c29f889a7d10 = ()=>{
    for (const { machine: machine } of $b94e0c21d1c0143c$var$machineRegistry.values()){
        if ((0, $MbeHu.isActivePhase)(machine.state())) return true;
    }
    return false;
};
const $b94e0c21d1c0143c$var$generateRemixId = ()=>`remix-${crypto.randomUUID()}`;
const $b94e0c21d1c0143c$var$generateConversationId = ()=>crypto.randomUUID();
/**
 * Remove a flow from every synchronous read path, announce its final teardown,
 * then dispose the machine after the current state-machine send has unwound.
 */ const $b94e0c21d1c0143c$var$teardownRemix = (id, reason)=>{
    const record = $b94e0c21d1c0143c$var$machineRegistry.get(id);
    if (!record) {
        // Preserve stale bridge cleanup for unknown/already-ended ids.
        (0, $2Pvub.unregisterMachineFromBridge)(id);
        return;
    }
    // Delete before dispatch: a command handler may re-enter endRemix synchronously.
    $b94e0c21d1c0143c$var$machineRegistry.delete(id);
    (0, $2Pvub.unregisterMachineFromBridge)(id);
    try {
        record.dispatcher?.dispatch({
            type: 'RemixFlowEnded',
            ...record.commandBase,
            reason: reason
        });
    } finally{
        // Command handlers run inside machine effects. Destroying synchronously here
        // can therefore corrupt an in-flight state-machine send.
        queueMicrotask(()=>record.machine.destroy());
    }
};
const $b94e0c21d1c0143c$export$9573327fad1c6a2e = (args)=>{
    if ($b94e0c21d1c0143c$var$SINGLE_ACTIVE_POLICY && $b94e0c21d1c0143c$export$bdc0c29f889a7d10()) return undefined;
    const remixId = $b94e0c21d1c0143c$var$generateRemixId();
    const conversationId = args.conversationId ?? $b94e0c21d1c0143c$var$generateConversationId();
    const startedAt = Date.now();
    // Resolve the command dispatcher: an explicit (e.g. bridge-backed) one, or
    // the process-default in-memory dispatcher when `useCommandBus` is set, or none.
    const dispatcher = args.commandDispatcher ?? (args.useCommandBus ? (0, $2sIE1.defaultRemixCommandDispatcher) : undefined);
    // Two independent effect sources: port-based effects (direct calls) and, when
    // a dispatcher is present, command effects (dispatch typed commands). They are
    // NOT merged — the machine registers each set's callbacks separately, because
    // the builder's `.on('enter'|'exit', cb)` accumulates rather than overwrites.
    // Order matters: ports run before commands.
    //
    // The two are complementary, not alternatives: `ports` is the LOCAL writer of
    // editor/chat state, while commands are announcements for any number of
    // observers (analytics, other frames). Do not also register
    // `createPortsCommandHandler` with these same ports — that would make the
    // command path a second writer and double-fire every effect.
    const effectSets = [
        (0, $h4gwB.buildRemixEffects)(args.ports ?? {})
    ];
    if (dispatcher) effectSets.push((0, $cKwXx.buildRemixCommandEffects)(dispatcher));
    // `targetNodeId` is part of the base context, not an edit-only field: an
    // anchored create carries one too (it is what inline/embed loading targets).
    // Left `undefined` — never coerced to '' — so "unanchored" stays honest and
    // the loading port can distinguish "no anchor" from "an anchor called ''".
    const baseContext = {
        remixId: remixId,
        kind: args.kind,
        conversationId: conversationId,
        cancellationSessionId: args.cancellationSessionId,
        metadata: args.metadata,
        startedAt: startedAt,
        targetNodeId: args.targetNodeId
    };
    const machine = args.kind === 'update' ? (0, $1Ukdn.createRemixEditMachine)({
        ...baseContext,
        updateSentinel: args.updateSentinel,
        targetNodeId: args.targetNodeId
    }, ...effectSets) : (0, $1Ukdn.createRemixCreateMachine)(baseContext, ...effectSets);
    // `INSERTED` is the machine's only transition to `done`. Final transitions bypass
    // `onTransition` and synchronously fire `onDone` inside `send()`, making this the
    // required automatic-teardown hook. `teardownRemix` removes and announces the flow
    // immediately, then defers destruction until the in-flight `send()` has unwound.
    machine.onDone(()=>{
        $b94e0c21d1c0143c$var$teardownRemix(remixId, 'inserted');
    });
    $b94e0c21d1c0143c$var$machineRegistry.set(remixId, {
        machine: machine,
        dispatcher: dispatcher,
        commandBase: {
            remixId: remixId,
            conversationId: conversationId,
            targetNodeId: args.targetNodeId
        }
    });
    // Bridge the machine to React so `useSyncExternalStore` consumers re-render on
    // transitions and can read the current phase on mount. Registering also
    // notifies aggregate subscribers that membership changed (e.g. isAnyRemixing).
    (0, $2Pvub.registerMachineWithBridge)(remixId, machine);
    // @atlassian/state-machine does NOT fire the initial state's `onEnter` effect
    // at construction (effects only run on transitions). A flow starts life in
    // `thinking`, so invoke every source's "entered thinking" effect explicitly
    // here. Subsequent enter/exit of `thinking` are handled by the machine.
    //
    // This deliberately calls the SAME callbacks the machine registered rather
    // than re-implementing their bodies per source — otherwise adding a third
    // effect source would silently miss its initial fire.
    //
    // The context is read back off the machine so it is exactly what the effects
    // would receive on a real transition. The event producer is a no-op: there is
    // no triggering event at construction, and sending into a machine mid-setup
    // is not safe.
    const initialContext = machine.context();
    const noopEventProducer = ()=>{};
    for (const set of effectSets)set.onEnterThinking?.(initialContext, noopEventProducer);
    return {
        remixId: remixId,
        conversationId: conversationId
    };
};
const $b94e0c21d1c0143c$export$205cdacb7d65bba0 = (id, event)=>{
    $b94e0c21d1c0143c$var$machineRegistry.get(id)?.machine.send(event);
};
const $b94e0c21d1c0143c$export$8c1c097bfe1d213c = (id, reason)=>$b94e0c21d1c0143c$var$teardownRemix(id, reason);
const $b94e0c21d1c0143c$export$9a86eddda6568093 = ()=>{
    // Test-only hard reset deliberately bypasses command dispatch and deferred
    // disposal so each test starts from a fully clean synchronous state.
    $b94e0c21d1c0143c$var$machineRegistry.forEach(({ machine: machine }, id)=>{
        machine.destroy();
        (0, $2Pvub.unregisterMachineFromBridge)(id);
    });
    $b94e0c21d1c0143c$var$machineRegistry.clear();
};
module.exports["getRemixMachine"] = $b94e0c21d1c0143c$export$bb6da1182d6c1fa5;
module.exports["listRemixMachineIds"] = $b94e0c21d1c0143c$export$354cb0a867425c7e;
module.exports["startRemix"] = $b94e0c21d1c0143c$export$9573327fad1c6a2e;
module.exports["sendRemixEvent"] = $b94e0c21d1c0143c$export$205cdacb7d65bba0;
module.exports["endRemix"] = $b94e0c21d1c0143c$export$8c1c097bfe1d213c;

});

parcelRegister("cKwXx", function(module, exports) {
/**
 * Machine effects that DISPATCH COMMANDS (Abhi's "output commands" model).
 *
 * The command-based alternative to `../effects/remixEffects.ts` (which calls
 * injected ports directly). Here the machine's `onEnter` effects announce what
 * happened by dispatching typed commands through an injected
 * `RemixCommandDispatcher`; any number of handlers react. The machine has zero
 * knowledge of consumers OR of the command transport (real bridge vs in-memory).
 *
 * State → command mapping:
 *   enter `thinking` → RemixStarted           (generation began)
 *   enter `ready`    → RemixReady + RemixGenerationEnded(reason: 'ready')
 *   enter `error`    → RemixErrored + RemixGenerationEnded(reason: 'error')
 *   enter `aborted`  → RemixAborted + RemixGenerationEnded(reason: 'aborted')
 *
 * `RemixGenerationEnded` means "the thinking/loading phase finished" (so a
 * handler can clear editor loading); its `reason` is derived from the
 * destination so a single handler can branch. It does NOT mean the flow is over
 * — a `ready` flow lives on until the user accepts/inserts or cancels. The
 * separate `RemixFlowEnded` command (dispatched by the store on teardown) marks
 * the true end of a flow's life.
 *
 * Additive; not wired into live flows.
 */ const $d2add0c69158bec9$export$51f85b9f058f5e45 = (dispatcher)=>({
        onEnterThinking: (ctx)=>dispatcher.dispatch({
                type: 'RemixStarted',
                remixId: ctx.remixId,
                conversationId: ctx.conversationId,
                targetNodeId: ctx.targetNodeId
            }),
        onEnterReady: (ctx)=>{
            dispatcher.dispatch({
                type: 'RemixReady',
                remixId: ctx.remixId,
                conversationId: ctx.conversationId,
                targetNodeId: ctx.targetNodeId,
                resultId: ctx.resultId
            });
            dispatcher.dispatch({
                type: 'RemixGenerationEnded',
                remixId: ctx.remixId,
                conversationId: ctx.conversationId,
                targetNodeId: ctx.targetNodeId,
                reason: 'ready'
            });
        },
        onEnterError: (ctx)=>{
            dispatcher.dispatch({
                type: 'RemixErrored',
                remixId: ctx.remixId,
                conversationId: ctx.conversationId,
                targetNodeId: ctx.targetNodeId
            });
            dispatcher.dispatch({
                type: 'RemixGenerationEnded',
                remixId: ctx.remixId,
                conversationId: ctx.conversationId,
                targetNodeId: ctx.targetNodeId,
                reason: 'error'
            });
        },
        onEnterAborted: (ctx)=>{
            dispatcher.dispatch({
                type: 'RemixAborted',
                remixId: ctx.remixId,
                conversationId: ctx.conversationId,
                targetNodeId: ctx.targetNodeId
            });
            dispatcher.dispatch({
                type: 'RemixGenerationEnded',
                remixId: ctx.remixId,
                conversationId: ctx.conversationId,
                targetNodeId: ctx.targetNodeId,
                reason: 'aborted'
            });
        }
    });
module.exports["buildRemixCommandEffects"] = $d2add0c69158bec9$export$51f85b9f058f5e45;

});

parcelRegister("2sIE1", function(module, exports) {
/**
 * Remix command vocabulary + the injected-dispatcher seam.
 *
 * Abhi's model: the state machine emits **output commands** on state entry/exit
 * ("input events in, output commands out"). A command is a fire-and-forget
 * announcement ("a remix started", "a remix errored"); handlers decide what to
 * do (toggle editor loading, open chat, fire analytics, cross a frame).
 *
 * Transport is NOT the machine's concern. The real command transport is
 * `@atlassian/rovo-content-bridge-api` — a client/command API that works both
 * same-context (local handlers) and cross-frame (iframe/webview) via pluggable
 * transports, using the identical `send`/`on` surface. Rather than couple this
 * pure state layer to that package, the machine dispatches through a minimal
 * injected `RemixCommandDispatcher`. Product wiring supplies an adapter that
 * maps these typed commands onto real bridge `createCommand` classes and
 * `api.send(...)`; tests/local usage can use the in-memory dispatcher below.
 *
 * This keeps `malleable-ui-components` transport-agnostic while using the real
 * bridge in production (option B).
 *
 * Additive; not wired into live flows.
 */ /** Discriminant for every remix command. */ class $d1ea2b186e2500b1$export$fa920a2636a7fe90 {
    register(handler) {
        this.handlers.add(handler);
        return ()=>{
            this.handlers.delete(handler);
        };
    }
    dispatch(command) {
        for (const handler of Array.from(this.handlers))try {
            handler(command);
        } catch (error) {
            // Isolate handler failures from the state transition that emitted.
            // eslint-disable-next-line no-console
            console.error('[remix] command handler threw', command.type, error);
        }
    }
    clear() {
        this.handlers.clear();
    }
    constructor(){
        this.handlers = new Set();
    }
}
const $d1ea2b186e2500b1$export$bfed4a0e1ed5bbcf = new $d1ea2b186e2500b1$export$fa920a2636a7fe90();
const $d1ea2b186e2500b1$export$7aa05bbd09851bd = (handler)=>$d1ea2b186e2500b1$export$bfed4a0e1ed5bbcf.register(handler);
const $d1ea2b186e2500b1$export$3d4fd2920549228c = (command)=>$d1ea2b186e2500b1$export$bfed4a0e1ed5bbcf.dispatch(command);
const $d1ea2b186e2500b1$export$41e24c5543d9e719 = ()=>$d1ea2b186e2500b1$export$bfed4a0e1ed5bbcf.clear();
module.exports["defaultRemixCommandDispatcher"] = $d1ea2b186e2500b1$export$bfed4a0e1ed5bbcf;
module.exports["registerRemixCommandHandler"] = $d1ea2b186e2500b1$export$7aa05bbd09851bd;

});

parcelRegister("h4gwB", function(module, exports) {
/**
 * Builds the machine `onEnter`/`onExit` effects that project remix state into
 * other stores (editor loading, chat panel).
 *
 * This is the concrete realisation of option (A) — reactive projection. The
 * machine transitions; entering/leaving a phase runs an effect that calls a
 * narrow injected port. No imperative "also update the editor" calls are
 * sprinkled through the flow code.
 *
 * Example mapping:
 *   - enter `thinking`   → editor shows loading for the target node
 *   - exit  `thinking`   → editor clears loading (covers ready/error/abort)
 *   - enter `error`      → open the chat panel so the user sees the failure
 */ const $7bc2363dd5b18667$export$9392b02cdcf1c7c9 = (ports)=>{
    const { editorLoading: editorLoading, chatPanel: chatPanel } = ports;
    return {
        // Editor loading state is tied to the `thinking` phase: show on enter,
        // clear on exit (whichever phase we move to). Targeting uses the
        // context's targetNodeId (undefined for creates without an anchor).
        onEnterThinking: editorLoading ? (ctx)=>editorLoading.setLoading(ctx.targetNodeId) : undefined,
        onExitThinking: editorLoading ? (prev)=>editorLoading.clearLoading(prev.targetNodeId) : undefined,
        // Open chat when the flow errors so the user can see the failure / retry.
        onEnterError: chatPanel ? (ctx)=>chatPanel.open(ctx.conversationId) : undefined
    };
};
module.exports["buildRemixEffects"] = $7bc2363dd5b18667$export$9392b02cdcf1c7c9;

});

parcelRegister("MbeHu", function(module, exports) {
/**
 * Machine-spike types for the centralised Remix state model.
 *
 * This is the state-machine-based iteration of `../types.ts`, produced from the
 * review feedback on the initial store PR (Loom + Lauren):
 *
 * 1. **Discriminated union for create vs edit** (Loom feedback #3). Instead of
 *    one `RemixActionInstance` with a `kind` field and a pile of optional
 *    edit-only fields, we model `RemixCreateActionInstance` and
 *    `RemixEditActionInstance` as separate types. Edit-only context is then
 *    *required* on the edit type and *absent* on the create type, so the
 *    compiler enforces "these fields only exist for edits".
 *
 * 2. **No derived booleans in stored state** (Loom feedback #1). The phase is
 *    the single source of truth for lifecycle; we do not also store
 *    `isComplete` / `isError` / `isAborted`. Those are read off the phase.
 *
 * 3. **Explicit `targetNodeId`** (PR comment + Lauren's editor-loading
 *    requirement). The node identity (mediaId / contentMauiId) of the content a
 *    remix is anchored to is promoted to a first-class field, rather than being
 *    buried inside the opaque `historyEntry`. Cross-store effects (e.g. the
 *    editor inline/embed loading state) need this to target the right node.
 *
 *    Named `targetNodeId`, NOT `targetContentId`: in Confluence `contentId`
 *    conventionally means the *page* id, whereas this is a node identity within
 *    the page. It is required for edits and optional for creates (an anchored
 *    create — remixing a selected node — has one; an unanchored create does
 *    not).
 *
 * These types live under `machine/` alongside the parallel machine
 * implementation and do NOT replace `../types.ts` yet — both coexist during the
 * spike.
 */ const $8700088f0d91025e$export$7621bdd83abc7375 = (instance)=>instance.kind === 'update';
const $8700088f0d91025e$export$711431828c4c4090 = (instance)=>instance.kind === 'create';
const $8700088f0d91025e$export$e1fd53a08df613cf = [
    'error',
    'aborted'
];
/**
 * `TERMINAL_PHASES` as a Set, for O(1) membership checks on hot paths (the
 * `useSyncExternalStore` snapshot readers call this on every render).
 *
 * Derived from `TERMINAL_PHASES` rather than written out again, so adding a
 * phase to the array above automatically applies everywhere.
 */ const $8700088f0d91025e$var$TERMINAL_PHASE_SET = new Set($8700088f0d91025e$export$e1fd53a08df613cf);
const $8700088f0d91025e$export$ce0969ab998f2048 = (phase)=>!$8700088f0d91025e$var$TERMINAL_PHASE_SET.has(phase);
module.exports["isActivePhase"] = $8700088f0d91025e$export$ce0969ab998f2048;

});

parcelRegister("1Ukdn", function(module, exports) {
/**
 * The Remix state machines (create + edit).
 *
 * Review feedback (Loom #3/#4) asked for:
 *  - the lifecycle to be an *explicit* state machine (events in, state out) using
 *    the same primitive the whiteboard domain uses (the published
 *    `@atlassian/state-machine` package), rather than imperative phase
 *    assignment;
 *  - **two** small machines — one for create, one for edit — because they are
 *    driven by different network streams and, for edits, an extra suppression
 *    rule applies before the first real result.
 *
 * Both machines share the same `RemixPhase` states and the same event
 * vocabulary; they differ in their starting context and (for edit) the presence
 * of the sentinel guard. Keeping them separate means create-only and edit-only
 * behaviour is expressed structurally instead of via `if (kind === ...)`.
 *
 * Cross-store side-effects (editor loading state, opening chat on error) are NOT
 * hard-coded here — they are injected as `onEnter`/`onExit` effects by the
 * store, so this file stays free of editor/chat dependencies. See
 * `./effects/*`.
 */ 
var $ikKzo = parcelRequire("ikKzo");

/** Identity context update — most transitions carry context forward unchanged. */ const $28a5a24b75d16432$var$keepContext = (ctx)=>ctx;
/**
 * Apply every source's `onEnter`/`onExit` effect for a state to its builder.
 *
 * `.on('enter'|'exit', cb)` ACCUMULATES — the library's effect registrar does
 * `config.effects[name].push(callback)`, and its `EffectLookup` type is an
 * element of `Effects[...]` (an array). So calling it once per source registers
 * them all, in call order, and the machine invokes them in that order.
 *
 * That is why there is no composition helper here: multiple effect sources
 * (ports, command bus, ...) are simply registered one after another rather than
 * being merged into a single callback.
 */ const $28a5a24b75d16432$var$withEffects = (sb, effectSets, { enter: enter, exit: exit })=>{
    let next = sb;
    if (enter) for (const set of effectSets){
        const fn = set[enter];
        if (fn) next = next.on('enter', fn);
    }
    if (exit) for (const set of effectSets){
        const fn = set[exit];
        if (fn) next = next.on('exit', fn);
    }
    return next;
};
/**
 * Shared state graph used by both machines, expressed via the published
 * `@atlassian/state-machine` builder API (the same primitive canvas uses). The
 * only structural difference between create and edit is the initial context, so
 * the transition topology is defined once here.
 *
 * Transition chain reads: `.when(EVENT, t => t.label(...).if().context(...).to(STATE))`.
 * `.if()` with no args means "no guards"; `.context(fn)` is the context updater.
 */ const $28a5a24b75d16432$var$buildMachine = (context, effectSets)=>(0, $ikKzo.builder)().initial('thinking').context(context).state('thinking', (s)=>$28a5a24b75d16432$var$withEffects(s, effectSets, {
            enter: 'onEnterThinking',
            exit: 'onExitThinking'
        }).when('RESULT_READY', (t)=>t.label('result is previewable').if().context((ctx, event)=>({
                    ...ctx,
                    resultId: event.resultId
                })).to('ready')).when('GENERATION_ERROR', (t)=>t.label('generation failed').if().context($28a5a24b75d16432$var$keepContext).to('error')).when('GENERATION_ABORTED', (t)=>t.label('user aborted').if().context($28a5a24b75d16432$var$keepContext).to('aborted')).when('CANCELLED', (t)=>t.label('user cancelled').if().context($28a5a24b75d16432$var$keepContext).to('aborted'))).state('ready', (s)=>$28a5a24b75d16432$var$withEffects(s, effectSets, {
            enter: 'onEnterReady'
        }).when('DIRECT_INSERTION_STARTED', (t)=>t.label('direct insertion started').if().context($28a5a24b75d16432$var$keepContext).to('inserting')).when('PREVIEW_OPENED', (t)=>t.label('preview shown').if().context($28a5a24b75d16432$var$keepContext).to('previewing')).when('GENERATION_ERROR', (t)=>t.label('late error').if().context($28a5a24b75d16432$var$keepContext).to('error')).when('CANCELLED', (t)=>t.label('cancelled before preview').if().context($28a5a24b75d16432$var$keepContext).to('aborted'))).state('previewing', (s)=>s.when('ACCEPTED', (t)=>t.label('user accepted result').if().context($28a5a24b75d16432$var$keepContext).to('inserting')).when('CANCELLED', (t)=>t.label('user discarded preview').if().context($28a5a24b75d16432$var$keepContext).to('aborted')).when('GENERATION_ERROR', (t)=>t.label('error during preview').if().context($28a5a24b75d16432$var$keepContext).to('error')).when('INSERTION_FAILED', (t)=>t.label('preview insertion failed').if().context($28a5a24b75d16432$var$keepContext).to('error'))).state('inserting', (s)=>// `inserting` is terminal from the machine's perspective: once INSERTED
        // fires the store removes the instance. Modelled as the `done` command.
        $28a5a24b75d16432$var$withEffects(s, effectSets, {
            enter: 'onEnterInserting'
        }).when('INSERTED', (t)=>t.label('insertion complete').if().context($28a5a24b75d16432$var$keepContext).to('done')).when('GENERATION_ERROR', (t)=>t.label('insertion failed').if().context($28a5a24b75d16432$var$keepContext).to('error')).when('INSERTION_FAILED', (t)=>t.label('insertion failed').if().context($28a5a24b75d16432$var$keepContext).to('error'))).state('error', (s)=>$28a5a24b75d16432$var$withEffects(s, effectSets, {
            enter: 'onEnterError'
        })).state('aborted', (s)=>$28a5a24b75d16432$var$withEffects(s, effectSets, {
            enter: 'onEnterAborted'
        })).build();
const $28a5a24b75d16432$export$4c98f8ad39f53d35 = (context, ...effectSets)=>$28a5a24b75d16432$var$buildMachine({
        ...context
    }, effectSets);
const $28a5a24b75d16432$export$8efbabba11f68e43 = (context, ...effectSets)=>$28a5a24b75d16432$var$buildMachine({
        ...context
    }, effectSets);
module.exports["createRemixCreateMachine"] = $28a5a24b75d16432$export$4c98f8ad39f53d35;
module.exports["createRemixEditMachine"] = $28a5a24b75d16432$export$8efbabba11f68e43;

});

parcelRegister("ikKzo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gypE9 = parcelRequire("gypE9");

parcelRequire("aQvaf");

parcelRequire("3ThHj");

module.exports.asyncStateBuilder = $gypE9.asyncStateBuilder;
module.exports.builder = $gypE9.builder;
module.exports.effectNameMap = $gypE9.effectNameMap;
module.exports.stateBuilder = $gypE9.stateBuilder;
module.exports.transientStateBuilder = $gypE9.transientStateBuilder;

});

parcelRegister("gypE9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $c0d3b73437a6c94b$var$_nullishCoalesce(lhs, rhsFn) {
    if (lhs != null) return lhs;
    else return rhsFn();
}

var $aQvaf = parcelRequire("aQvaf");

// src/builder/state-machine-builder.ts
var $c0d3b73437a6c94b$var$effectNameMap = {
    enter: "onEnter",
    "re-enter": "onReEnter",
    exit: "onExit",
    execute: "onExecute"
};
var $c0d3b73437a6c94b$var$builder = ()=>{
    const config = {};
    config.states = {};
    const initial = (state2)=>{
        config.initial = state2;
        return {
            context: context
        };
    };
    const context = (context2)=>{
        config.context = context2;
        return {
            state: state,
            transientState: transientState,
            build: build,
            when: when,
            use: use,
            with: state,
            asyncState: asyncState
        };
    };
    const state = (name, doBuild)=>{
        const builder2 = $c0d3b73437a6c94b$var$stateBuilder(name, config);
        doBuild(builder2).build();
        return {
            state: state,
            transientState: transientState,
            build: build,
            when: when,
            use: use,
            with: state,
            asyncState: asyncState
        };
    };
    const transientState = (name, doBuild)=>{
        const builder2 = $c0d3b73437a6c94b$var$transientStateBuilder(name, config);
        doBuild(builder2).build();
        return {
            state: state,
            transientState: transientState,
            build: build,
            when: when,
            use: use,
            with: state,
            asyncState: asyncState
        };
    };
    const when = (on, doBuild)=>{
        var _config_globalTransitions, _on;
        const builder2 = $c0d3b73437a6c94b$var$transitionBuilder();
        const newTransitions = doBuild(builder2);
        if (!config.globalTransitions) config.globalTransitions = {};
        const transitionsForEvent = (_config_globalTransitions = config.globalTransitions)[_on = on] ?? (_config_globalTransitions[_on] = []);
        if (Array.isArray(newTransitions)) transitionsForEvent.push(...newTransitions);
        else transitionsForEvent.push(newTransitions);
        return {
            state: state,
            transientState: transientState,
            build: build,
            when: when,
            use: use,
            with: state,
            asyncState: asyncState
        };
    };
    const asyncState = (name, doBuild)=>{
        const builder2 = $c0d3b73437a6c94b$var$asyncStateBuilder(name, config);
        doBuild(builder2).build();
        return {
            state: state,
            transientState: transientState,
            build: build,
            when: when,
            use: use,
            with: state,
            asyncState: asyncState
        };
    };
    const use = (name, definition)=>{
        config.states[name] = definition;
        return {
            state: state,
            transientState: transientState,
            build: build,
            when: when,
            use: use,
            with: state,
            asyncState: asyncState
        };
    };
    const build = ()=>{
        return $aQvaf.createMachine.call(void 0, config);
    };
    return {
        initial: initial
    };
};
var $c0d3b73437a6c94b$var$stateBuilder = (name, config, baseConfig)=>{
    if (config && !config.states) config.states = {};
    const stateConfig = $c0d3b73437a6c94b$var$_nullishCoalesce(baseConfig, ()=>({}));
    if (!stateConfig.effects) stateConfig.effects = {};
    if (!stateConfig.transitions) stateConfig.transitions = {};
    if (!stateConfig.guards) stateConfig.guards = [];
    const when = (on2, build2, opts)=>{
        if (!stateConfig.transitions[on2]) stateConfig.transitions[on2] = [];
        const builder2 = $c0d3b73437a6c94b$var$transitionBuilder();
        const transition = build2(builder2);
        const transitions = Array.isArray(transition) ? transition : [
            transition
        ];
        const current = $c0d3b73437a6c94b$var$_nullishCoalesce(stateConfig.transitions[on2], ()=>[]);
        if (!opts) current.push(...transitions);
        else if ("before" in opts) {
            const idx = current.findIndex((t)=>t.label === opts.before);
            if (idx === -1) current.push(...transitions);
            else current.splice(idx, 0, ...transitions);
        } else {
            const idx = current.findIndex((t)=>t.label === opts.after);
            if (idx === -1) current.push(...transitions);
            else current.splice(idx + 1, 0, ...transitions);
        }
        return stateApi;
    };
    const trap = ()=>{
        stateConfig.trap = true;
        return stateApi;
    };
    const on = (name2, callback)=>{
        $c0d3b73437a6c94b$var$effectBuilder($c0d3b73437a6c94b$var$effectNameMap[name2], stateConfig, callback);
        return stateApi;
    };
    const childState = (name2, build2)=>{
        const builder2 = $c0d3b73437a6c94b$var$stateBuilder(name2, stateConfig);
        build2(builder2).build();
        return stateApi;
    };
    const transientChildState = (name2, doBuild)=>{
        const builder2 = $c0d3b73437a6c94b$var$transientStateBuilder(name2, stateConfig);
        doBuild(builder2).build();
        return stateApi;
    };
    const asyncState = (name2, doBuild)=>{
        const builder2 = $c0d3b73437a6c94b$var$asyncStateBuilder(name2, stateConfig);
        doBuild(builder2).build();
        return stateApi;
    };
    const build = ()=>{
        if (baseConfig) return stateConfig;
        if (config == null ? void 0 : config.states) config.states[name] = stateConfig;
        return stateConfig;
    };
    const guard = (guard2)=>{
        var _a;
        (_a = stateConfig.guards) == null || _a.push(guard2);
        return stateApi;
    };
    const stateApi = {
        when: when,
        on: on,
        build: build,
        state: childState,
        transientState: transientChildState,
        trap: trap,
        guard: guard,
        asyncState: asyncState
    };
    return stateApi;
};
var $c0d3b73437a6c94b$var$asyncStateBuilder = (name, config, baseConfig)=>{
    const stateConfig = {
        ...baseConfig,
        effects: {},
        resolvedTransitions: [],
        rejectedTransitions: []
    };
    if (config && !config.states) config.states = {};
    const onEnter = (action)=>{
        stateConfig.asyncAction = action;
        return {
            whenResolved: whenResolved,
            whenRejected: whenRejected
        };
    };
    const whenResolved = (doBuild)=>{
        const builder2 = $c0d3b73437a6c94b$var$transitionBuilder();
        stateConfig.resolvedTransitions.push(doBuild(builder2));
        return {
            whenResolved: whenResolved,
            whenRejected: whenRejected
        };
    };
    const whenRejected = (doBuild)=>{
        const builder2 = $c0d3b73437a6c94b$var$transitionBuilder();
        stateConfig.rejectedTransitions.push(doBuild(builder2));
        return {
            whenRejected: whenRejected,
            build: build,
            timeoutMs: timeoutMs
        };
    };
    const timeoutMs = (timeout)=>{
        stateConfig.timeout = timeout;
        return {
            build: build
        };
    };
    const build = ()=>{
        if (config == null ? void 0 : config.states) config.states[name] = stateConfig;
    };
    return {
        onEnter: onEnter
    };
};
var $c0d3b73437a6c94b$var$transientStateBuilder = (name, config)=>{
    const stateConfig = {};
    if (config && !config.states) config.states = {};
    if (!stateConfig.effects) stateConfig.effects = {};
    if (!stateConfig.passthroughs) stateConfig.passthroughs = [];
    const when = (build2)=>{
        const builder2 = $c0d3b73437a6c94b$var$transitionBuilder();
        stateConfig.passthroughs.push(build2(builder2));
        return statePassthroughApi;
    };
    const on = (name2, callback)=>{
        $c0d3b73437a6c94b$var$effectBuilder($c0d3b73437a6c94b$var$effectNameMap[name2], stateConfig, callback);
        return statePassthroughApi;
    };
    const build = ()=>{
        if (config == null ? void 0 : config.states) config.states[name] = stateConfig;
        return stateConfig;
    };
    const statePassthroughApi = {
        when: when,
        on: on,
        build: build
    };
    return statePassthroughApi;
};
var $c0d3b73437a6c94b$var$transitionBuilder = ()=>{
    const transitionConfig = {};
    let transitionLabel = "unknown";
    const label = (label2)=>{
        transitionLabel = label2;
        return {
            if: guard
        };
    };
    const guard = (...guards)=>{
        transitionConfig.guard = guards;
        return {
            context: context
        };
    };
    const context = (...context2)=>{
        transitionConfig.context = context2;
        return {
            to: to
        };
    };
    const to = (state)=>{
        transitionConfig.state = state;
        return {
            ...transitionConfig,
            label: transitionLabel
        };
    };
    const transitionApi = {
        label: label,
        if: guard
    };
    return transitionApi;
};
var $c0d3b73437a6c94b$var$effectBuilder = (name, config, callback)=>{
    if (!config.effects[name]) config.effects[name] = [];
    const effects = config.effects[name];
    effects.push(callback);
};
module.exports.effectNameMap = $c0d3b73437a6c94b$var$effectNameMap;
module.exports.builder = $c0d3b73437a6c94b$var$builder;
module.exports.stateBuilder = $c0d3b73437a6c94b$var$stateBuilder;
module.exports.asyncStateBuilder = $c0d3b73437a6c94b$var$asyncStateBuilder;
module.exports.transientStateBuilder = $c0d3b73437a6c94b$var$transientStateBuilder;

});

parcelRegister("aQvaf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $7e56ef485025db3c$var$_nullishCoalesce(lhs, rhsFn) {
    if (lhs != null) return lhs;
    else return rhsFn();
} // src/state-machine.ts
function $7e56ef485025db3c$var$getTransitionType(event) {
    if (event.type === "async-resolved") return 2 /* AsyncResolved */ ;
    if (event.type === "async-rejected") return 4 /* AsyncRejected */ ;
    return 1 /* Normal */ ;
}
function $7e56ef485025db3c$var$createMachine(config) {
    const pathLookup = /* @__PURE__ */ new Map();
    const currentConfig = config;
    const transitionListeners = [];
    const eventListeners = [];
    const doneListeners = [];
    let abortController;
    const prepare = (stateTree, statePrefix = "", statePath = [])=>{
        for (const [state2, branch] of Object.entries(stateTree)){
            const path = `${statePrefix}${state2}`;
            const nextTree = branch;
            const nextPath = [
                ...statePath,
                {
                    state: state2,
                    node: branch
                }
            ];
            pathLookup.set(state2, nextPath);
            if (nextTree.states) prepare(nextTree.states, `${path}:`, nextPath);
        }
    };
    prepare(config.states);
    const getNode = (statePath, position = statePath.length)=>{
        return statePath[position - 1].node;
    };
    const findState = (state2)=>{
        return $7e56ef485025db3c$var$_nullishCoalesce(pathLookup.get(state2), ()=>(console.log(pathLookup, config, state2), []));
    };
    const findStateConfig = (target)=>{
        var _a;
        return (_a = findState(target).at(-1)) == null ? void 0 : _a.node;
    };
    const findTransition = (statePath, event)=>{
        var _a;
        function firstMatchingTransition(transitions) {
            const transition = transitions.find((transition2)=>{
                var _a2;
                const transitionGuards = transition2.guard.every((guard)=>guard(currentContext, event));
                if (!transitionGuards) return;
                if (transitionGuards && transition2.state === "done") return transition2;
                const statePath2 = pathLookup.get(transition2.state);
                if (!statePath2) return;
                const stateGuards = (_a2 = getNode(statePath2)) == null ? void 0 : _a2.guards;
                if (!stateGuards) return transitionGuards ? transition2 : void 0;
                if (stateGuards.every((g)=>g())) return transition2;
            });
            if (transition) return transition;
        }
        for(let idx = statePath.length - 1; idx >= 0; idx--){
            const node = getNode(statePath, idx + 1);
            if ("transitions" in node) {
                const transitions = $7e56ef485025db3c$var$_nullishCoalesce(node.transitions[event.type], ()=>[]);
                const transition = firstMatchingTransition(transitions);
                if (transition) return transition;
                if (node.trap) return void 0;
            }
        }
        return firstMatchingTransition($7e56ef485025db3c$var$_nullishCoalesce((_a = config.globalTransitions) == null ? void 0 : _a[event.type], ()=>[]));
    };
    const sendEvent = (event, target = 1 /* Listeners */ )=>{
        if (target & 1 /* Listeners */ ) eventListeners.forEach((listener)=>listener(event));
        if (target & 2 /* StateMachine */ ) send(event);
    };
    let prevStatePath = findState(currentConfig.initial);
    let currentStatePath = findState(currentConfig.initial);
    const initialNode = {
        state: currentConfig.initial,
        node: currentStatePath[currentStatePath.length - 1].node
    };
    let prevContext = {
        ...currentConfig.context
    };
    let currentContext = {
        ...currentConfig.context
    };
    const send = (event)=>{
        const state2 = getNode(currentStatePath);
        if ("passthroughs" in state2) return;
        const transition = findTransition(currentStatePath, event);
        if (transition) {
            doTransition(event, transition);
            doPassthrough(event);
        }
    };
    const doTransition = (event, transition)=>{
        prevStatePath = [
            ...currentStatePath
        ];
        if (transition.state === "done") {
            resolveContext(transition, event);
            effect(getNode(currentStatePath), "onExit", currentContext, currentContext, sendEvent);
            doneListeners.forEach((listener)=>listener());
            return;
        }
        currentStatePath = findState(transition.state);
        prevContext = {
            ...currentContext
        };
        resolveContext(transition, event);
        transitionListeners.forEach((listener)=>{
            const transitionType = $7e56ef485025db3c$var$getTransitionType(event);
            if (listener.type & transitionType) listener.listener(event, currentContext, {
                previous: previous(),
                current: state()
            }, transition);
        });
        resolveEffects();
    };
    const doPassthrough = (event)=>{
        const nextState = getNode(currentStatePath);
        if ("passthroughs" in nextState) {
            const passthrough = nextState.passthroughs.find((passthrough2)=>passthrough2.guard.every((guard)=>guard(currentContext, event)));
            if (!passthrough) return;
            doTransition(event, passthrough);
            doPassthrough(event);
        }
    };
    const previous = ()=>prevStatePath[prevStatePath.length - 1].state;
    const current = ()=>currentStatePath[currentStatePath.length - 1].state;
    const state = ()=>current();
    const context = ()=>currentContext;
    const resolveContext = (transition, event)=>{
        transition.context.forEach((contextUpdater)=>{
            currentContext = contextUpdater(currentContext, event);
        });
    };
    const doAsyncTransition = (node, event)=>{
        let transition;
        if (event.type === "async-resolved") transition = node.resolvedTransitions.find((t)=>t.guard.every((guard)=>guard(currentContext, event)));
        else transition = node.rejectedTransitions.find((t)=>t.guard.every((guard)=>guard(currentContext, event)));
        if (!transition) return;
        doTransition(event, transition);
        doPassthrough(event);
    };
    const setupAsyncStateTimeout = (node, signal)=>{
        if (node.timeout) {
            const timeout = typeof node.timeout === "function" ? node.timeout(currentContext) : node.timeout;
            if (timeout <= 0) return;
            const timeoutId = setTimeout(()=>{
                if (!signal.aborted) {
                    doAsyncTransition(node, {
                        type: "async-rejected",
                        error: new Error("Async action timed out"),
                        reason: "timeout"
                    });
                    abortController == null || abortController.abort();
                }
            }, timeout);
            signal.addEventListener("abort", ()=>{
                clearTimeout(timeoutId);
            }, {
                once: true
            });
        }
    };
    const processAsyncState = (node)=>{
        abortController == null || abortController.abort();
        if ("asyncAction" in node) {
            abortController = new AbortController();
            const currentSignal = abortController.signal;
            setupAsyncStateTimeout(node, currentSignal);
            node.asyncAction(currentContext, currentSignal).then((result)=>{
                if (currentSignal.aborted) return;
                doAsyncTransition(node, {
                    type: "async-resolved",
                    result: result
                });
            }).catch((error)=>{
                if (currentSignal.aborted) return;
                doAsyncTransition(node, {
                    type: "async-rejected",
                    error: error,
                    reason: "error"
                });
            });
            return;
        }
    };
    const resolveEffects = ()=>{
        let prev = 0;
        let curr = 0;
        let overlapUntil = 0;
        while(prev < prevStatePath.length && curr < currentStatePath.length){
            if (prevStatePath[prev].state === currentStatePath[curr].state) overlapUntil++;
            prev++;
            curr++;
        }
        for(prev = overlapUntil; prev < prevStatePath.length; prev++)effect(getNode(prevStatePath, prev + 1), "onExit", prevContext, currentContext, sendEvent);
        const node = getNode(currentStatePath, currentStatePath.length);
        processAsyncState(node);
        for(curr = overlapUntil; curr < currentStatePath.length; curr++)effect(getNode(currentStatePath, curr + 1), "onEnter", currentContext, sendEvent);
        if (previous() === current()) effect(getNode(currentStatePath), "onReEnter", prevContext, currentContext, sendEvent);
    };
    const execute = ()=>{
        effect(getNode(currentStatePath), "onExecute", currentContext, sendEvent);
    };
    const effect = (effectState, effectKey, ...args)=>{
        const effects = effectState.effects;
        if (!effects[effectKey] || effects[effectKey].length === 0) return;
        effects[effectKey].forEach((fn)=>{
            try {
                fn(args[0], args[1], args[2]);
            } catch (error) {
                console.error(error);
            }
        });
    };
    const from = (initial, context2)=>{
        const nextConfig = {
            ...config,
            initial: initial
        };
        if (context2) nextConfig.context = context2;
        const machine = $7e56ef485025db3c$var$createMachine(nextConfig);
        transitionListeners.forEach((transitionListener)=>{
            machine.onTransition(transitionListener.listener);
        });
        doneListeners.forEach((doneListener)=>{
            machine.onDone(doneListener);
        });
        return machine;
    };
    const reset = ()=>{
        abortController == null || abortController.abort();
        abortController = void 0;
        prevStatePath = [
            {
                ...initialNode
            }
        ];
        currentStatePath = [
            {
                ...initialNode
            }
        ];
        prevContext = {
            ...currentConfig.context
        };
        currentContext = {
            ...currentConfig.context
        };
    };
    const destroy = ()=>{
        abortController == null || abortController.abort();
        abortController = void 0;
        prevStatePath.length = 0;
        currentStatePath.length = 0;
        transitionListeners.length = 0;
        eventListeners.length = 0;
        doneListeners.length = 0;
        pathLookup.clear();
    };
    const onTransition = (listener, type = 1 /* Normal */ )=>{
        transitionListeners.push({
            listener: listener,
            type: type
        });
    };
    const onEvent = (listener)=>{
        eventListeners.push(listener);
    };
    const onDone = (listener)=>{
        doneListeners.push(listener);
    };
    return {
        send: send,
        state: state,
        context: context,
        execute: execute,
        reset: reset,
        destroy: destroy,
        onTransition: onTransition,
        onEvent: onEvent,
        onDone: onDone,
        from: from,
        config: ()=>({
                initial: config.initial,
                states: {
                    ...config.states
                },
                globalTransitions: {
                    ...config.globalTransitions
                },
                context: {
                    ...config.context
                }
            }),
        lookup: findStateConfig
    };
}
module.exports.createMachine = $7e56ef485025db3c$var$createMachine;

});

parcelRegister("3ThHj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
}); // src/state-machine-types.ts
var $2d543c8c3b0ff81c$var$Target = /* @__PURE__ */ ((Target2)=>{
    Target2[Target2["Listeners"] = 1] = "Listeners";
    Target2[Target2["StateMachine"] = 2] = "StateMachine";
    return Target2;
})($2d543c8c3b0ff81c$var$Target || {});
var $2d543c8c3b0ff81c$var$TransitionType = /* @__PURE__ */ ((TransitionType2)=>{
    TransitionType2[TransitionType2["Normal"] = 1] = "Normal";
    TransitionType2[TransitionType2["AsyncResolved"] = 2] = "AsyncResolved";
    TransitionType2[TransitionType2["AsyncRejected"] = 4] = "AsyncRejected";
    TransitionType2[TransitionType2["All"] = 7] = "All";
    return TransitionType2;
})($2d543c8c3b0ff81c$var$TransitionType || {});
module.exports.Target = $2d543c8c3b0ff81c$var$Target;
module.exports.TransitionType = $2d543c8c3b0ff81c$var$TransitionType;

});

parcelRegister("k1Pvg", function(module, exports) {
const $facdac86f4ba08d8$export$49073de218c0e4d6 = {
    AI_MATE: 'ai-mate',
    AI_MATE_ACTIONS: 'ai-mate-actions',
    AI_MATE_INSERT_URLS: 'ai-mate-chat-inserts',
    AI_MATE_CHAT_INPUT_OVERLAY: 'ai-mate-chat-input-overlay',
    AI_MATE_AIFC: 'ai-mate-aifc',
    ROVO_REMIX_LAUNCH: 'rovo-remix-launch',
    ROVO_REMIX: 'rovo-remix',
    AVP: 'avp'
};
const $facdac86f4ba08d8$export$69d3cd8e04a34bd6 = 'jira-inline-agent-creation-agent-assigned';
const $facdac86f4ba08d8$export$273aa0a3b01f12a3 = 'jira-work-items-creating';
const $facdac86f4ba08d8$export$6c48beaef33b5d07 = 'jira-work-items-created';
const $facdac86f4ba08d8$export$141a1577d8898865 = 'jira-work-items-create-failed';
const $facdac86f4ba08d8$export$5007e3a11d326b89 = 'confluence-content-finalized';
module.exports["Topics"] = $facdac86f4ba08d8$export$49073de218c0e4d6;
module.exports["JIRA_INLINE_AGENT_CREATION_AGENT_ASSIGNED_EVENT"] = $facdac86f4ba08d8$export$69d3cd8e04a34bd6;
module.exports["JIRA_WORK_ITEMS_CREATING_EVENT"] = $facdac86f4ba08d8$export$273aa0a3b01f12a3;
module.exports["JIRA_WORK_ITEMS_CREATED_EVENT"] = $facdac86f4ba08d8$export$6c48beaef33b5d07;
module.exports["JIRA_WORK_ITEMS_CREATE_FAILED_EVENT"] = $facdac86f4ba08d8$export$141a1577d8898865;
module.exports["CONFLUENCE_CONTENT_FINALIZED_EVENT"] = $facdac86f4ba08d8$export$5007e3a11d326b89;

});

parcelRegister("1pCE4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6f1e13d4a3a429b849d45ea939386ed0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $10761a64419352ea$var$_react = $10761a64419352ea$var$_interopRequireDefault((parcelRequire("cozmU")));

var $10761a64419352ea$var$_iconNew = $10761a64419352ea$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $10761a64419352ea$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeRemix".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/ai-generative-remix
 * Usage guidance:
 * Reserved for Remix with Rovo
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $10761a64419352ea$var$AiGenerativeRemixIcon = (props)=>/*#__PURE__*/ $10761a64419352ea$var$_react.default.createElement($10761a64419352ea$var$_iconNew.default, Object.assign({
        name: "AiGenerativeRemixIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M15.78 11.22a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06 1.22-1.22h-2.845a2 2 0 0 1-1.552-.74l-1.124-1.382.967-1.189 1.321 1.626a.5.5 0 0 0 .388.185h2.845l-1.22-1.22 1.06-1.06z"/><path fill="currentcolor" d="M15.78 3.72a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06L13.44 5H10.6a.5.5 0 0 0-.39.19l-5.75 7.08a2 2 0 0 1-1.55.73H0v-1.5h2.91a.5.5 0 0 0 .39-.18l5.75-7.08a2 2 0 0 1 1.55-.74h2.85l-1.22-1.22 1.06-1.06zM6 4.25a.75.75 0 0 1-.49.71l-1.1.4a.5.5 0 0 0-.3.3l-.4 1.1a.75.75 0 0 1-1.41 0l-.4-1.1a.5.5 0 0 0-.3-.3l-1.1-.4a.75.75 0 0 1-.48-.59L0 4.25l.01-.12a.75.75 0 0 1 .48-.59l1.1-.4a.5.5 0 0 0 .3-.3l.4-1.1.05-.11A.75.75 0 0 1 3 1.24l.12.01a.75.75 0 0 1 .54.38l.05.11.4 1.1c.05.14.16.25.3.3l1.1.4a.75.75 0 0 1 .49.71"/>`
    }, props));
$10761a64419352ea$var$AiGenerativeRemixIcon.displayName = 'AiGenerativeRemixIcon';
var $10761a64419352ea$var$_default = module.exports.default = $10761a64419352ea$var$AiGenerativeRemixIcon;

});

parcelRegister("lEf8v", function(module, exports) {
/**
 * React convenience for subscribing to remix commands for the lifetime of a
 * component. Ref-backed so the handler can close over fresh props/state without
 * re-subscribing each render (subscribe once, never stale).
 *
 * Typical use: a small component mounted near the remix surface that reacts to
 * commands — e.g. open chat on `RemixErrored`, toggle a plugin on
 * `RemixStarted`/`RemixGenerationEnded`/`RemixFlowEnded`.
 *
 * Additive; not wired into live flows.
 */ 
var $cozmU = parcelRequire("cozmU");


var $2sIE1 = parcelRequire("2sIE1");

const $e3010bf86102dcbc$export$b0620fc038952e0c = (handler)=>{
    const ref = (0, $cozmU.useRef)(handler);
    ref.current = handler;
    (0, $cozmU.useEffect)(()=>{
        // Stable proxy dispatching to the latest handler via the ref, so the
        // subscription is created once yet never goes stale.
        return (0, $2sIE1.registerRemixCommandHandler)((command)=>ref.current(command));
    }, []);
};
module.exports["useRemixCommands"] = $e3010bf86102dcbc$export$b0620fc038952e0c;

});

parcelRegister("gRoSG", function(module, exports) {
/**
 * `useSyncExternalStore` bindings that make the state machine the SINGLE source
 * of truth for React consumers.
 *
 * This is the alternative to mirroring the machine's phase into react-sweet-state
 * (which the store currently does via `patchSnapshot`). Here, React subscribes to
 * the machine directly:
 *
 *   getSnapshot = () => machine.state()        // late-mount read + current value
 *   subscribe   = (cb) => subscribeToMachine() // re-render on transition
 *
 * Both the "I mounted after the flow started" case (initial `getSnapshot` read)
 * and the "flow changed while I'm mounted" case (subscription) are handled by the
 * one hook, with no duplicated phase state.
 *
 * The registry + bridge live outside React (module scope), so these hooks work
 * from anywhere in the tree regardless of where a flow was started — matching the
 * global scope of the machine registry itself.
 *
 * Additive; not wired into live flows.
 */ 
var $cozmU = parcelRequire("cozmU");


var $2Pvub = parcelRequire("2Pvub");


var $MbeHu = parcelRequire("MbeHu");


var $bWlOZ = parcelRequire("bWlOZ");

const $ecb3f45f81d3d0d9$var$readInstanceView = (id)=>{
    const machine = (0, $bWlOZ.getRemixMachine)(id);
    if (!machine) return undefined;
    const ctx = machine.context();
    return {
        id: ctx.remixId,
        kind: ctx.kind,
        phase: machine.state(),
        conversationId: ctx.conversationId,
        cancellationSessionId: ctx.cancellationSessionId,
        metadata: ctx.metadata,
        targetNodeId: ctx.targetNodeId,
        startedAt: ctx.startedAt,
        updateSentinel: ctx.updateSentinel
    };
};
/**
 * Per-id snapshot cache for `useRemixInstance`.
 *
 * `useSyncExternalStore` calls `getSnapshot` on every render and bails out of
 * re-rendering only when the returned reference is `Object.is`-equal to the
 * previous one. `readInstanceView` builds a fresh object each call, so returning
 * it directly makes React see a new reference on every render → it re-renders →
 * calls `getSnapshot` again → new reference again → infinite loop
 * ("Maximum update depth exceeded").
 *
 * We cache the last view per id and only return a NEW reference when a
 * field actually changed. Otherwise we return the cached reference, giving
 * `useSyncExternalStore` the referential stability it requires.
 */ const $ecb3f45f81d3d0d9$var$instanceViewCache = new Map();
const $ecb3f45f81d3d0d9$var$sameView = (a, b)=>{
    if (a === b) return true;
    if (!a || !b) return false;
    return a.id === b.id && a.kind === b.kind && a.phase === b.phase && a.conversationId === b.conversationId && a.cancellationSessionId === b.cancellationSessionId && a.targetNodeId === b.targetNodeId && a.startedAt === b.startedAt && a.updateSentinel === b.updateSentinel && a.metadata === b.metadata;
};
const $ecb3f45f81d3d0d9$var$getStableInstanceView = (id)=>{
    const next = $ecb3f45f81d3d0d9$var$readInstanceView(id);
    if (!next) {
        $ecb3f45f81d3d0d9$var$instanceViewCache.delete(id);
        return undefined;
    }
    const prev = $ecb3f45f81d3d0d9$var$instanceViewCache.get(id);
    if (prev && $ecb3f45f81d3d0d9$var$sameView(prev, next)) return prev;
    $ecb3f45f81d3d0d9$var$instanceViewCache.set(id, next);
    return next;
};
const $ecb3f45f81d3d0d9$export$cbd68d645b4b4a5f = (remixId)=>{
    const subscribe = (0, $cozmU.useCallback)((onStoreChange)=>(0, $2Pvub.subscribeToMachine)(remixId, onStoreChange), [
        remixId
    ]);
    const getSnapshot = (0, $cozmU.useCallback)(()=>{
        const machine = (0, $bWlOZ.getRemixMachine)(remixId);
        return machine ? machine.state() : undefined;
    }, [
        remixId
    ]);
    return (0, $cozmU.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
};
const $ecb3f45f81d3d0d9$export$bf79061fc86a218f = ()=>{
    const getSnapshot = (0, $cozmU.useCallback)(()=>$ecb3f45f81d3d0d9$export$ac1312c85677499d(), []);
    return (0, $cozmU.useSyncExternalStore)((0, $2Pvub.subscribeToAnyMachine), getSnapshot, getSnapshot);
};
const $ecb3f45f81d3d0d9$export$ac1312c85677499d = ()=>{
    for (const id of $ecb3f45f81d3d0d9$var$getActiveMachineIds()){
        const machine = (0, $bWlOZ.getRemixMachine)(id);
        if (machine && (0, $MbeHu.isActivePhase)(machine.state())) return true;
    }
    return false;
};
/** The ids of all currently-registered flows (from the machine registry). */ const $ecb3f45f81d3d0d9$var$getActiveMachineIds = ()=>(0, $bWlOZ.listRemixMachineIds)();
const $ecb3f45f81d3d0d9$export$b808324a3ffe9465 = (remixId)=>{
    const subscribe = (0, $cozmU.useCallback)((onStoreChange)=>(0, $2Pvub.subscribeToMachine)(remixId, onStoreChange), [
        remixId
    ]);
    const getSnapshot = (0, $cozmU.useCallback)(()=>$ecb3f45f81d3d0d9$var$getStableInstanceView(remixId), [
        remixId
    ]);
    return (0, $cozmU.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
};
const $ecb3f45f81d3d0d9$export$b753531cc797e26f = ()=>{
    const getKey = (0, $cozmU.useCallback)(()=>$ecb3f45f81d3d0d9$export$679130f47849a6c().join(','), []);
    const key = (0, $cozmU.useSyncExternalStore)((0, $2Pvub.subscribeToAnyMachine), getKey, getKey);
    return key === '' ? [] : key.split(',');
};
const $ecb3f45f81d3d0d9$export$679130f47849a6c = ()=>$ecb3f45f81d3d0d9$var$getActiveMachineIds().filter((id)=>{
        const machine = (0, $bWlOZ.getRemixMachine)(id);
        return machine ? (0, $MbeHu.isActivePhase)(machine.state()) : false;
    });
module.exports["useMachinePhase"] = $ecb3f45f81d3d0d9$export$cbd68d645b4b4a5f;
module.exports["useIsAnyRemixing"] = $ecb3f45f81d3d0d9$export$bf79061fc86a218f;
module.exports["useRemixInstance"] = $ecb3f45f81d3d0d9$export$b808324a3ffe9465;
module.exports["useActiveRemixIds"] = $ecb3f45f81d3d0d9$export$b753531cc797e26f;

});

parcelRegister("aXWtB", function(module, exports) {

var $b8pma = parcelRequire("b8pma");


var $9wGTI = parcelRequire("9wGTI");


var $jmjWc = parcelRequire("jmjWc");

const $35c87ab817b10787$var$createLoadingComponent = ()=>{
    return (0, $b8pma.default)({
        name: 'LoadingConfluenceConversationAssistantBundle'
    });
};



const $35c87ab817b10787$export$3ca68d91b1a1bca2 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "HQN7e",
    name: "ConfluenceConversationAssistant",
    loader: async ()=>{
        if (!(0, $9wGTI.fg)('rovo_chat_fix_confluence_chunk_loading')) return (await (parcelRequire("2RQ1M"))).ConfluenceConversationAssistant;
        // Fetch the outer loadable chunk (loadable-ConversationAssistant) AND
        // the AI-mate @atlassian/conversation-assistant chunk in parallel. Both
        // `import()` calls live inside this LoadableLazy object expression, so
        // LoadableMetaBabelPlugin tags them BOTH with this loadable's id — which
        // causes parcel-reporter-loadable to union both bundle groups into
        // preloadAssets for this loadable. Without the second `import()`, the
        // register chunk that owns modules like
        //   platform/…/atlassian-project-status-update-action-renderer/main.tsx
        // (module id 'iuVKP' on CDN / '2xPvv' in local builds) is not included
        // in this loadable's chunk set, and the runtime throws
        //   `Cannot find module 'iuVKP'`
        // when the outer loader's compiled `.then(() => parcelRequire('iuVKP'))`
        // fires.
        const [outer] = await Promise.all([
            (parcelRequire("2RQ1M")),
            // eslint-disable-next-line import/dynamic-import-chunkname
            (parcelRequire("g9nZM"))
        ]);
        return outer.ConfluenceConversationAssistant;
    },
    loading: $35c87ab817b10787$var$createLoadingComponent
});
module.exports["ConfluenceConversationAssistant"] = $35c87ab817b10787$export$3ca68d91b1a1bca2;

});

parcelRegister("2RQ1M", function(module, exports) {

let $2168e39e7dfb5ef0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2168e39e7dfb5ef0$var$load("avoXg"),
    $2168e39e7dfb5ef0$var$load("hESIs"),
    $2168e39e7dfb5ef0$var$load("9A059"),
    $2168e39e7dfb5ef0$var$load("Lm7SH"),
    $2168e39e7dfb5ef0$var$load("6wr18"),
    $2168e39e7dfb5ef0$var$load("ffEVr"),
    $2168e39e7dfb5ef0$var$load("Wowvf"),
    $2168e39e7dfb5ef0$var$load("jDL3j"),
    $2168e39e7dfb5ef0$var$load("bHBjF"),
    $2168e39e7dfb5ef0$var$load("hhss7"),
    $2168e39e7dfb5ef0$var$load("7EorR"),
    $2168e39e7dfb5ef0$var$load("ce05o"),
    $2168e39e7dfb5ef0$var$load("iEsP0"),
    $2168e39e7dfb5ef0$var$load("7SteV"),
    $2168e39e7dfb5ef0$var$load("5MILN"),
    $2168e39e7dfb5ef0$var$load("fwbNS"),
    $2168e39e7dfb5ef0$var$load("aoJPa")
]).then(()=>parcelRequire('kaQDe'));

});

parcelRegister("g9nZM", function(module, exports) {

let $bc20199cc6f9ae59$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $bc20199cc6f9ae59$var$load("hESIs"),
    $bc20199cc6f9ae59$var$load("9A059"),
    $bc20199cc6f9ae59$var$load("Lm7SH"),
    $bc20199cc6f9ae59$var$load("6wr18"),
    $bc20199cc6f9ae59$var$load("7SteV"),
    $bc20199cc6f9ae59$var$load("5MILN"),
    $bc20199cc6f9ae59$var$load("ffEVr"),
    $bc20199cc6f9ae59$var$load("Wowvf"),
    $bc20199cc6f9ae59$var$load("jDL3j"),
    $bc20199cc6f9ae59$var$load("bHBjF"),
    $bc20199cc6f9ae59$var$load("hhss7"),
    $bc20199cc6f9ae59$var$load("7EorR"),
    $bc20199cc6f9ae59$var$load("ce05o")
]).then(()=>parcelRequire('7Myh3'));

});

parcelRegister("n71o5", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");


var $lx3cN = parcelRequire("lx3cN");


var $3TrVh = parcelRequire("3TrVh");

/**
 * ************************************************************
 * Main Hook
 * ************************************************************
 */ const $cea7beaf4fdf86cd$var$publicStateSelector = (state)=>{
    return {
        ...state,
        checkActiveConversationMatchesSource: (id)=>{
            return (0, $3TrVh.checkActiveConversationMatchesSource)(state, id);
        }
    };
};
const $cea7beaf4fdf86cd$export$5ca9bbfceeb3b458 = (0, $kBr4q.createHook)((0, $lx3cN.chatStore), {
    selector: $cea7beaf4fdf86cd$var$publicStateSelector
});
module.exports["useChatStore"] = $cea7beaf4fdf86cd$export$5ca9bbfceeb3b458;

});

parcelRegister("3TrVh", function(module, exports) {
const $8991d15323cea08f$export$80b847bfebcaa3fd = (state, id)=>{
    return !!id && state.conversations[state.currentConversationId]?.sourceId === id;
};
module.exports["checkActiveConversationMatchesSource"] = $8991d15323cea08f$export$80b847bfebcaa3fd;

});

parcelRegister("4n04n", function(module, exports) {
/**
 * This file was cloned from https://bitbucket.org/atlassian/pf-adf-service/src/master/src/lib/converters/adf-to-markdownPlus.ts and slightly modified to work in the browser.
 */ 
var $8OOZ2 = parcelRequire("8OOZ2");


var $6OV8L = parcelRequire("6OV8L");


var $4XbfY = parcelRequire("4XbfY");


var $2lPWP = parcelRequire("2lPWP");


var $iDrrr = parcelRequire("iDrrr");


var $9DPMp = parcelRequire("9DPMp");

const $41ee172e87bea8b0$var$defaultSerializer = new (0, $2lPWP.JSONTransformer)();
function $41ee172e87bea8b0$export$bd172d9b9473ac80(adf, featureToggles, idMap) {
    // Default to markdownPlus being enabled unless explicitly disabled
    if (featureToggles === undefined) featureToggles = {};
    if (featureToggles?.markdownPlus === undefined) featureToggles.markdownPlus = true;
    if (featureToggles?.markdownPlusAvoidDuplicatedIdCounter === undefined) featureToggles.markdownPlusAvoidDuplicatedIdCounter = true;
    if (featureToggles?.markdownPlusSanitizeProseMirrorOnlyNodes === undefined) featureToggles.markdownPlusSanitizeProseMirrorOnlyNodes = (0, $iDrrr.fg)('platform_editor_markdown_plus_sanitize_pm_nodes');
    let serializer = $41ee172e87bea8b0$var$defaultSerializer;
    if (featureToggles.markdownPlusUseNextLayoutSection) serializer = new (0, $2lPWP.JSONTransformer)((0, $8OOZ2.createSchema)({
        ...(0, $4XbfY.defaultSchemaConfig),
        customNodeSpecs: {
            layoutSection: (0, $6OV8L.layoutSectionWithSingleColumn)
        }
    }));
    // Convert ADF to ProseMirrorNode
    const proseMirrorNode = serializer.parse(adf);
    // Generate the mentionMap required for correctly returning @mention strings in Markdown+
    const mentionMap = $41ee172e87bea8b0$var$getMentionMap(serializer.encode(proseMirrorNode));
    // Convert ProseMirrorNode to markdown-plus
    const { markdown: markdown, idMap: newIdMap } = (0, $9DPMp.convertProsemirrorNodeToMarkdown)({
        node: proseMirrorNode,
        featureToggles: featureToggles,
        mentionMap: mentionMap,
        idMap: idMap
    });
    return {
        markdown: markdown,
        idMap: newIdMap
    };
}
function $41ee172e87bea8b0$var$getMentionMap(jsonNode) {
    const mentionMap = {};
    function findMentions(node) {
        if (node.type === 'mention') {
            const userValues = $41ee172e87bea8b0$var$getUserMentionValues(node);
            if (userValues) // Stripping '@' from the mention as Markdown+ automatically adds it back for each map value
            mentionMap[userValues.id] = userValues.text.replace('@', '');
        }
        node.content?.forEach((childNode)=>{
            if (childNode) findMentions(childNode);
        });
    }
    findMentions(jsonNode);
    return mentionMap;
}
function $41ee172e87bea8b0$var$getUserMentionValues(node) {
    if (node.attrs && $41ee172e87bea8b0$var$hasTextAndIdFields(node.attrs)) return {
        text: node.attrs.text,
        id: node.attrs.id
    };
    return null;
}
function $41ee172e87bea8b0$var$hasTextAndIdFields(attrs) {
    return 'text' in attrs && 'id' in attrs && typeof attrs.text === 'string' && typeof attrs.id === 'string';
}
module.exports["adfToMarkdownPlus"] = $41ee172e87bea8b0$export$bd172d9b9473ac80;

});

parcelRegister("htTUm", function(module, exports) {
/**
 * This file was cloned from https://bitbucket.org/atlassian/pf-adf-service/src/master/src/lib/converters/markdownPlus-to-adf.ts and slightly modified to work in the browser.
 */ 
var $4XbfY = parcelRequire("4XbfY");


var $2lPWP = parcelRequire("2lPWP");


var $97CWy = parcelRequire("97CWy");

const $ecada00de6215dbb$var$serializer = new (0, $2lPWP.JSONTransformer)();
function $ecada00de6215dbb$export$dfca419434f7e5a8({ markdown: markdown, idMap: idMap = {}, editorSchema: editorSchema, featureToggles: featureToggles = {
    markdownPlus: true
} }) {
    // Default to markdownPlus being enabled unless explicitly disabled
    if (featureToggles === undefined) featureToggles = {};
    if (featureToggles?.markdownPlus === undefined) featureToggles.markdownPlus = true;
    // Convert markdown-plus to ProseMirrorNode
    const proseMirrorNode = (0, $97CWy.backendConvertMarkdownToProsemirrorNode)({
        markdown: markdown,
        schema: editorSchema || (0, $4XbfY.defaultSchema),
        idMap: idMap,
        featureToggles: featureToggles
    });
    // Convert ProseMirrorNode to ADF
    return $ecada00de6215dbb$var$serializer.encode(proseMirrorNode);
}
module.exports["markdownPlusToAdf"] = $ecada00de6215dbb$export$dfca419434f7e5a8;

});

parcelRegister("iNyje", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $6e6HL = parcelRequire("6e6HL");


var $9DHhW = parcelRequire("9DHhW");


var $eKMV3 = parcelRequire("eKMV3");


var $w6R6I = parcelRequire("w6R6I");


var $RfroO = parcelRequire("RfroO");


var $cXtTj = parcelRequire("cXtTj");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");


var $b8pma = parcelRequire("b8pma");


var $lfoFx = parcelRequire("lfoFx");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $lQXDC = parcelRequire("lQXDC");

var $hcOES = parcelRequire("hcOES");

var $jYwtP = parcelRequire("jYwtP");


var $7rqhv = parcelRequire("7rqhv");


var $d62s5 = parcelRequire("d62s5");


var $5TKGH = parcelRequire("5TKGH");


var $iXoLm = parcelRequire("iXoLm");


var $hRkxy = parcelRequire("hRkxy");


var $gkYOG = parcelRequire("gkYOG");

const $386fe214b22f2cd3$var$phases = {
    loading: 'loading',
    timeout: 'timeout',
    error: 'error',
    idle: 'idle'
};
const $386fe214b22f2cd3$export$9af19a1ca8685214 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5TKGH.AnalyticsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lQXDC.ContextWrapper), {
        sourceType: (0, $jYwtP.MODAL),
        sourceName: "gicAnywhere"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($386fe214b22f2cd3$export$c43a9e8a05acb520, props)));
};
const $386fe214b22f2cd3$var$styles = {
    hiddenDisplay: "_3iDTPbYbGa",
    gicAnywhere: "_39xV02N91d _0jFU0VN91d",
    loadingScreen: "_3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _37wbyuDIqT _2fwxA5DIqT"
};
const $386fe214b22f2cd3$export$c43a9e8a05acb520 = ({ cloudId: cloudId, overrideCloudId: overrideCloudId, configuration: configuration, summary: summary, assignee: assignee, descriptionAdf: descriptionAdf, consumer: consumer, timeoutMs: timeoutMs = (0, $hRkxy.DEFAULT_TIMEOUT), onInit: onInit, onSuccess: onSuccess, onFailure: onFailure, onClose: onClose, onTimeout: onTimeout, parentIssueId: parentIssueId, projectId: projectId, issueTypeId: issueTypeId, issueTypes: issueTypes, isPayloadReady: isPayloadReady = false, additionalMappedFields: additionalMappedFields, baseUrlForAvailableSites: baseUrlForAvailableSites, onSaveEditsWithoutIssueCreation: onSaveEditsWithoutIssueCreation, sendAifcAnalyticsEvent: sendAifcAnalyticsEvent })=>{
    const { availableSites: availableSites, domainName: domainName, isOverrideSiteAvailable: isOverrideSiteAvailable } = (0, $iXoLm.useGetDomainAndAvailableSites)({
        cloudId: cloudId,
        overrideCloudId: overrideCloudId,
        baseUrlForAvailableSites: baseUrlForAvailableSites
    });
    const displaySitePicker = availableSites && availableSites.length > 1;
    const [phase, setPhase] = (0, $cozmU.useState)($386fe214b22f2cd3$var$phases.loading);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    (0, $cozmU.useEffect)(()=>{
        const timeout = (()=>{
            switch(phase){
                case $386fe214b22f2cd3$var$phases.loading:
                    return setTimeout(()=>{
                        (0, $hcOES.fireOperationalAnalytics)(createAnalyticsEvent({}), 'globalIssueCreateEmbed timedOut', {
                            consumer: consumer,
                            timeoutMs: timeoutMs
                        });
                        setPhase($386fe214b22f2cd3$var$phases.timeout);
                        onTimeout?.();
                    }, timeoutMs);
                case $386fe214b22f2cd3$var$phases.timeout:
                    // if timeoutMs passes again after initial timeout, assume GIC is not loading and set to error state
                    return setTimeout(()=>{
                        (0, $hcOES.fireOperationalAnalytics)(createAnalyticsEvent({}), 'globalIssueCreateEmbed error', {
                            consumer: consumer,
                            timeoutMs: timeoutMs * 2
                        });
                        setPhase($386fe214b22f2cd3$var$phases.error);
                        onFailure(new Error('GIC has timed out'));
                    }, timeoutMs);
            }
        })(); // set Timeout for loading, reset for any other state.
        return ()=>timeout && clearTimeout(timeout);
    }, [
        consumer,
        createAnalyticsEvent,
        onFailure,
        onTimeout,
        phase,
        timeoutMs
    ]); // we mimic "external callback" for our needs
    const onGICReady = (0, $cozmU.useCallback)(()=>{
        setPhase($386fe214b22f2cd3$var$phases.idle);
        return {
            summary: summary ?? 'No summary provided',
            descriptionAdf: descriptionAdf || (0, $6e6HL.getEmptyADF)(),
            projectId: projectId,
            parentIssueId: parentIssueId,
            issueTypeId: issueTypeId,
            issueTypes: issueTypes?.join(','),
            assignee: assignee,
            fieldData: additionalMappedFields
        };
    }, [
        summary,
        descriptionAdf,
        projectId,
        parentIssueId,
        issueTypeId,
        issueTypes,
        assignee,
        additionalMappedFields
    ]);
    const renderPhaseInformation = (0, $cozmU.useMemo)(()=>{
        switch(phase){
            case $386fe214b22f2cd3$var$phases.timeout:
            case $386fe214b22f2cd3$var$phases.loading:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    testId: "gic-anywhere-loading",
                    xcss: (0, $w6R6I.cx)($386fe214b22f2cd3$var$styles.gicAnywhere, $386fe214b22f2cd3$var$styles.loadingScreen)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
                    size: "large"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage(phase === $386fe214b22f2cd3$var$phases.timeout ? (0, $gkYOG.messages).iFrameSlowLoading : (0, $gkYOG.messages).iFrameLoading, {
                    br: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("br", null)
                })));
            case $386fe214b22f2cd3$var$phases.error:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    testId: "gic-anywhere-error",
                    xcss: $386fe214b22f2cd3$var$styles.gicAnywhere
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $RfroO.default), {
                    header: formatMessage((0, $gkYOG.messages).errorHeader),
                    description: formatMessage((0, $gkYOG.messages).errorBody),
                    primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
                        onClick: ()=>{
                            onClose();
                        },
                        href: domainName || '/',
                        target: "_blank",
                        appearance: "primary"
                    }, formatMessage((0, $gkYOG.messages).openInJiraButton)),
                    imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($7rqhv))),
                    imageWidth: (0, $hRkxy.MAX_ERROR_IMAGE_WIDTH),
                    maxImageWidth: (0, $hRkxy.MAX_ERROR_IMAGE_WIDTH),
                    maxImageHeight: (0, $hRkxy.MAX_ERROR_IMAGE_HEIGHT)
                }));
            default:
                return undefined;
        }
    }, [
        phase,
        formatMessage,
        domainName,
        onClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, renderPhaseInformation, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
        name: "gic-anywhere-iframe-loading",
        hold: phase === $386fe214b22f2cd3$var$phases.loading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: phase !== $386fe214b22f2cd3$var$phases.idle ? $386fe214b22f2cd3$var$styles.hiddenDisplay : $386fe214b22f2cd3$var$styles.gicAnywhere
    }, domainName !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($386fe214b22f2cd3$export$ae3b6dcb03669e81, {
        domainName: domainName,
        consumer: consumer,
        onGICReady: onGICReady,
        onInit: onInit,
        onSuccess: onSuccess,
        onFailure: onFailure,
        onClose: onClose,
        configuration: configuration,
        displaySitePicker: displaySitePicker,
        isPayloadReady: isPayloadReady,
        overrideCloudId: isOverrideSiteAvailable ? overrideCloudId : undefined,
        ...(0, $cXtTj.default).getExperimentValue('jira-aifc-workflow-resumption-ui-updates', 'isEnabled', false, {
            fireExperimentExposure: false
        }) ? {
            onSaveEditsWithoutIssueCreation: onSaveEditsWithoutIssueCreation
        } : {},
        sendAifcAnalyticsEvent: sendAifcAnalyticsEvent
    })));
};
const $386fe214b22f2cd3$export$ae3b6dcb03669e81 = ({ onGICReady: onGICReady, consumer: consumer, domainName: domainName, overrideCloudId: overrideCloudId, onClose: onClose, onFailure: onFailure, onSuccess: onSuccess, onInit: onInit, configuration: configuration, displaySitePicker: displaySitePicker = true, isPayloadReady: isPayloadReady = false, onSaveEditsWithoutIssueCreation: onSaveEditsWithoutIssueCreation, sendAifcAnalyticsEvent: sendAifcAnalyticsEvent })=>{
    (0, $6cFsl.di)($386fe214b22f2cd3$export$b32b5f1ee4493319);
    const iframeRef = (0, $cozmU.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    const [isCreateSuccess, setIsCreateSuccess] = (0, $cozmU.useState)(false);
    const [isGicReady, setIsGicReady] = (0, $cozmU.useState)(false);
    const isGicReadyRef = (0, $cozmU.useRef)(isGicReady); // we will react on this event only once
    // we dont want to reattach handlers on every render
    const onGICReadyRef = (0, $cozmU.useRef)(onGICReady);
    onGICReadyRef.current = onGICReady;
    const params = (0, $cozmU.useMemo)(()=>({
            product: consumer,
            actionSource: 'issue-create-anywhere-embed'
        }), [
        consumer
    ]); // Create a debounced version of onInit that will only execute the latest call after 2 seconds
    const debouncedOnInit = (0, $cozmU.useMemo)(()=>{
        if (!onInit) return undefined;
        return (0, $5TKGH.debounce)(()=>onInit(), 2000);
    }, [
        onInit
    ]); // Cleanup the debounced function on unmount
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            const debouncedFn = debouncedOnInit; // Only call cancel if debouncedOnInit is actually a debounced function
            if (debouncedFn && typeof debouncedFn.cancel === 'function') debouncedFn.cancel();
        };
    }, [
        debouncedOnInit
    ]);
    (0, $cozmU.useEffect)(()=>{
        const messageHandler = async (message)=>{
            const iframe = iframeRef.current?.contentWindow;
            if (!iframe) return;
            const eventName = message?.data?.event;
            const event = createAnalyticsEvent({});
            switch(eventName){
                case 0, $d62s5.JIRA_EMBED_ISSUE_CREATE_READY:
                    (0, $hcOES.fireOperationalAnalytics)(event, 'globalIssueCreateEmbed initialised', {
                        consumer: consumer
                    });
                    setIsGicReady(true);
                    break;
                case 0, $d62s5.JIRA_EMBED_ISSUE_CREATE_SUCCESS:
                    setIsCreateSuccess(true);
                    onSuccess(message.data.payload);
                    (0, $hcOES.fireTrackAnalytics)(event, 'globalIssueCreateEmbed succeeded', {
                        consumer: consumer
                    });
                    sendAifcAnalyticsEvent?.({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'createWorkItemsGicCreated'
                    });
                    break;
                case 0, $d62s5.JIRA_EMBED_ISSUE_CREATE_FAILURE:
                    onFailure(new Error('issueCreate failed to save'));
                    (0, $hcOES.fireOperationalAnalytics)(event, 'globalIssueCreateEmbed failed', {
                        consumer: consumer
                    });
                    break;
                case 0, $d62s5.JIRA_EMBED_ISSUE_CREATE_CLOSE:
                    onClose(isCreateSuccess); // GIC sends a closeEvent even when created succesfully. Hence
                    // checking if no issue was created
                    if (!isCreateSuccess) (0, $hcOES.fireUIAnalytics)(event, 'globalIssueCreateEmbed closed', {
                        consumer: consumer
                    });
                    break;
                case 0, $d62s5.JIRA_EMBED_ISSUE_SAVE_WITHOUT_CREATION:
                    if ((0, $cXtTj.default).getExperimentValue('jira-aifc-workflow-resumption-ui-updates', 'isEnabled', false, {
                        fireExperimentExposure: false
                    })) {
                        onSaveEditsWithoutIssueCreation?.(message.data.payload);
                        sendAifcAnalyticsEvent?.({
                            action: 'clicked',
                            actionSubject: 'button',
                            actionSubjectId: 'createWorkItemsGicSaved'
                        });
                    }
                    break;
                default:
            }
        }; // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('message', messageHandler);
        return ()=>{
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('message', messageHandler);
        };
    }, [
        iframeRef,
        consumer,
        createAnalyticsEvent,
        onInit,
        onClose,
        onFailure,
        onSuccess,
        isCreateSuccess,
        setIsCreateSuccess,
        setIsGicReady,
        onSaveEditsWithoutIssueCreation,
        sendAifcAnalyticsEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (isPayloadReady && isGicReady) // Only resolve the Promise if isPayloadReady is true, and the message has been received
        Promise.resolve(onGICReadyRef.current()).then((issuePayload)=>{
            const iframe = iframeRef.current?.contentWindow;
            if (iframe) {
                const { fieldData: fieldData, ...defaultValues } = issuePayload ?? {}; // Send GIC data used for initialization
                iframe.postMessage({
                    event: (0, $d62s5.JIRA_EMBED_ISSUE_CREATE_INIT),
                    payload: {
                        defaultValues: defaultValues,
                        ...fieldData && {
                            fieldData: {
                                ...fieldData,
                                ...defaultValues
                            }
                        }
                    }
                }, // Broadcast this message to all listeners for now
                '*');
                debouncedOnInit?.();
            }
        });
    }, [
        isPayloadReady,
        isGicReady,
        onGICReadyRef,
        debouncedOnInit
    ]);
    const iframeSrc = (0, $5TKGH.getIframeSrc)({
        colorMode: colorMode,
        domainName: domainName,
        params: params,
        displaySitePicker: displaySitePicker,
        ...configuration,
        overrideCloudId: overrideCloudId,
        ...(0, $cXtTj.default).getExperimentValue('jira-aifc-workflow-resumption-ui-updates', 'isEnabled', false, {
            fireExperimentExposure: false
        }) ? {
            onSaveEditsWithoutIssueCreation: onSaveEditsWithoutIssueCreation
        } : {}
    });
    (0, $cozmU.useEffect)(()=>{
        isGicReadyRef.current = isGicReady;
    }, [
        isGicReady
    ]);
    (0, $cozmU.useEffect)(()=>{
        // We need to reset the isGicReady state to avoid sending another postMessage to the GIC iframe window
        setIsGicReady(false);
    }, [
        iframeSrc
    ]);
    (0, $cozmU.useEffect)(()=>{
        const TIMEOUT_10_SECONDS = 10000;
        const timeout = setTimeout(()=>{
            // We need to use a ref to check if GIC is ready because the isGicReady state is updated asynchronously
            if (!isGicReadyRef.current) // This is a fallback for the case when the GIC iframe window is not initialized
            throw new Error('jira-ai/gic-anywhere: The latest GIC iframe window was not initialized');
        }, TIMEOUT_10_SECONDS);
        return ()=>clearTimeout(timeout);
    }, [
        iframeSrc
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($386fe214b22f2cd3$export$b32b5f1ee4493319, {
        name: "gic-anywhere-iframe",
        sandbox: undefined,
        ref: iframeRef,
        height: "100%",
        width: "100%",
        frameBorder: 0,
        // onError={}
        src: iframeSrc,
        "data-testid": "gic-anywhere"
    });
};
const $386fe214b22f2cd3$export$b32b5f1ee4493319 = /*#__PURE__*/ (0, $cozmU.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("iframe", {
        title: "Jira Embed Global Issue Create",
        ref: ref,
        ...props
    });
});
module.exports["GicAnywhere"] = $386fe214b22f2cd3$export$9af19a1ca8685214;

});

parcelRegister("7rqhv", function(module, exports) {
module.exports = new URL("error.5fbc7fe9.png", import.meta.url).toString();

});

parcelRegister("d62s5", function(module, exports) {
// Error messages
const $fc941d96b9cf15df$export$bdb28edf034fd38 = 'Jira GIC Anywhere - Iframe Source character limit exceeded';
const $fc941d96b9cf15df$export$b342b407e829290 = 'jiraEmbedIssueCreateInit';
const $fc941d96b9cf15df$export$fa02f6b8f65042dd = 'jiraEmbedIssueCreateReady';
const $fc941d96b9cf15df$export$8679ecb6b6b13aa9 = 'jiraEmbedIssueCreateSuccess';
const $fc941d96b9cf15df$export$c1caf9536ed579cc = 'jiraEmbedIssueCreateAppFailed';
const $fc941d96b9cf15df$export$a402043ad8e6699 = 'jiraEmbedIssueCreateClose';
const $fc941d96b9cf15df$export$89aca4b41c88286e = 'jiraEmbedIssueSaveWithoutCreation';
module.exports["ERROR_IFRAME_SOURCE_CHAR_LIMIT_EXCEEDED"] = $fc941d96b9cf15df$export$bdb28edf034fd38;
module.exports["JIRA_EMBED_ISSUE_CREATE_INIT"] = $fc941d96b9cf15df$export$b342b407e829290;
module.exports["JIRA_EMBED_ISSUE_CREATE_READY"] = $fc941d96b9cf15df$export$fa02f6b8f65042dd;
module.exports["JIRA_EMBED_ISSUE_CREATE_SUCCESS"] = $fc941d96b9cf15df$export$8679ecb6b6b13aa9;
module.exports["JIRA_EMBED_ISSUE_CREATE_FAILURE"] = $fc941d96b9cf15df$export$c1caf9536ed579cc;
module.exports["JIRA_EMBED_ISSUE_CREATE_CLOSE"] = $fc941d96b9cf15df$export$a402043ad8e6699;
module.exports["JIRA_EMBED_ISSUE_SAVE_WITHOUT_CREATION"] = $fc941d96b9cf15df$export$89aca4b41c88286e;

});

parcelRegister("5TKGH", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $NF6kd = parcelRequire("NF6kd");


var $3d3WW = parcelRequire("3d3WW");


var $cXtTj = parcelRequire("cXtTj");


var $kpg4X = parcelRequire("kpg4X");


var $iDrrr = parcelRequire("iDrrr");


var $jYwtP = parcelRequire("jYwtP");

var $k8V2e = parcelRequire("k8V2e");


var $d62s5 = parcelRequire("d62s5");

const $19ceb46128b62655$var$analyticsClientInfo = {
    env: 'prod',
    product: 'jira'
};
const $19ceb46128b62655$var$LIGHT_MODE = 'light';
const $19ceb46128b62655$var$DARK_MODE = 'dark';
const $19ceb46128b62655$var$AUTO = 'auto';
const $19ceb46128b62655$var$AVAILABLE_SITES_PATH = '/gateway/api/available-sites';
const $19ceb46128b62655$var$AVAILABLE_SITES_UNIT_COMPLIANT_PATH = '/gateway/api/experimental/available-sites';
const $19ceb46128b62655$export$a31dd10290664cf6 = 2048;
const $19ceb46128b62655$export$584bd4ae64a8d7e2 = ({ colorMode: colorMode = $19ceb46128b62655$var$AUTO, domainName: domainName = '', overrideCloudId: overrideCloudId, params: params, onFailure: onFailure, displaySitePicker: displaySitePicker, disableProjectDropdown: disableProjectDropdown, displayOnlyRequiredFields: displayOnlyRequiredFields, onSaveEditsWithoutIssueCreation: onSaveEditsWithoutIssueCreation })=>{
    const iframeParams = new URLSearchParams(params);
    iframeParams.append('postMessageInit', '1');
    if (displaySitePicker === false) iframeParams.append('displaySitePicker', 'false');
    if (disableProjectDropdown) iframeParams.append('disableProjectDropdown', 'true');
    if (displayOnlyRequiredFields) iframeParams.append('displayOnlyRequiredFields', 'true');
    if (colorMode) iframeParams.append('themeMode', colorMode);
    if (overrideCloudId) iframeParams.append('overrideCloudId', overrideCloudId);
    if (onSaveEditsWithoutIssueCreation && (0, $cXtTj.default).getExperimentValue('jira-aifc-workflow-resumption-ui-updates', 'isEnabled', false, {
        fireExperimentExposure: false
    })) iframeParams.append('submitBehaviour', 'saveEditsWithoutIssueCreation');
    /**
   * We want to use the postMessageInit param to instruct the Jira embed iframe
   * to wait before mounting Issue Create.
   * It will send a message back to us when it's ready to receive the init message
   */ let srcUrl = `${domainName}/jira/issues/create/embed?${iframeParams}`;
    if ((0, $cXtTj.default).getExperimentValue('jira-aifc-workflow-resumption-ui-updates', 'isEnabled', false, {
        fireExperimentExposure: false
    })) {
        const localHostName = window.origin;
    }
    if (srcUrl.length > $19ceb46128b62655$export$a31dd10290664cf6) onFailure?.(new Error((0, $d62s5.ERROR_IFRAME_SOURCE_CHAR_LIMIT_EXCEEDED)));
    return srcUrl;
};
const $19ceb46128b62655$export$61874183278c256e = [
    'jira-software.ondemand',
    'jira-core.ondemand',
    'jira-servicedesk.ondemand',
    'jira-product-discovery'
];
const $19ceb46128b62655$export$2ccbc6509a6a8fcc = ()=>{
    const isOrgInRollout = (0, $iDrrr.fg)('issue_create_modal_site_picker_api_unit_compliant');
    const isSiteInRollout = (0, $iDrrr.fg)('issue_create_modal_site_picker_api_unit_compliant_cloud_id');
    return isOrgInRollout || isSiteInRollout;
};
async function $19ceb46128b62655$export$5e195155111b6846(baseUrlForAvailableSites) {
    const requestConfig = {
        method: 'POST',
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            products: $19ceb46128b62655$export$61874183278c256e
        })
    };
    const base = baseUrlForAvailableSites ? baseUrlForAvailableSites.replace(/\/$/, '') : '';
    // Organisations that have launched units with boundary enforcement on must be served the unit
    // compliant endpoint, which filters the sites down to the unit the user belongs to. That state
    // is read from AGG (`boundaryEnforced` and `endUsersLaunched`) behind the rollout gates above,
    // and the decision is owned by `shouldUseUnitCompliantApi`.
    const availableSitesPath = await (0, $kpg4X.shouldUseUnitCompliantApi)($19ceb46128b62655$export$2ccbc6509a6a8fcc) ? $19ceb46128b62655$var$AVAILABLE_SITES_UNIT_COMPLIANT_PATH : $19ceb46128b62655$var$AVAILABLE_SITES_PATH;
    const response = await fetch(`${base}${availableSitesPath}`, requestConfig);
    if (response.ok) return response.json();
    throw response;
}
const $19ceb46128b62655$export$1b581a2ec13e37f1 = (props)=>{
    const analyticsClient = (0, $cozmU.useRef)(new (0, $NF6kd.default)($19ceb46128b62655$var$analyticsClientInfo, {}));
    const sendEvent = (0, $cozmU.useCallback)((event)=>{
        const { type: type, payload: payload } = event;
        switch(type){
            case 0, $jYwtP.UI_EVENT_TYPE:
                // @ts-expect-error - Argument of type 'Record<string, any>' is not assignable to parameter of type 'UITrackAndOperationalEventPayload'
                analyticsClient.current.sendUIEvent(payload);
                break;
            case 0, $jYwtP.TRACK_EVENT_TYPE:
                // @ts-expect-error - Argument of type 'Record<string, any>' is not assignable to parameter of type 'UITrackAndOperationalEventPayload'
                analyticsClient.current.sendTrackEvent(payload);
                break;
            case 0, $jYwtP.OPERATIONAL_EVENT_TYPE:
                // @ts-expect-error - Argument of type 'Record<string, any>' is not assignable to parameter of type 'UITrackAndOperationalEventPayload'
                analyticsClient.current.sendOperationalEvent(payload);
                break;
            case 0, $jYwtP.SCREEN_EVENT_TYPE:
                analyticsClient.current.sendScreenEvent(payload.name, null, payload.attributes);
                break;
            default:
                break;
        }
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
        channel: (0, $jYwtP.ANALYTICS_BRIDGE_CHANNEL),
        onEvent: (event)=>sendEvent((0, $k8V2e.extractAWCDataFromEvent)(event))
    }, props.children);
};
const $19ceb46128b62655$export$61fc7d43ac8f84b0 = (func, wait)=>{
    let timeout;
    const debounced = (...args)=>{
        const later = ()=>{
            timeout = undefined;
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
    debounced.cancel = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
};
module.exports["getIframeSrc"] = $19ceb46128b62655$export$584bd4ae64a8d7e2;
module.exports["getAvailableJiraSites"] = $19ceb46128b62655$export$5e195155111b6846;
module.exports["AnalyticsProvider"] = $19ceb46128b62655$export$1b581a2ec13e37f1;
module.exports["debounce"] = $19ceb46128b62655$export$61fc7d43ac8f84b0;

});

parcelRegister("iXoLm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $5TKGH = parcelRequire("5TKGH");

const $58abbbf3766fa385$export$930bddfd3ad23bb7 = ({ preferredCloudId: preferredCloudId, onComplete: onComplete, onError: onError })=>{
    (0, $6cFsl.di)((0, $5TKGH.getAvailableJiraSites));
    const [domain, setDomain] = (0, $cozmU.useState)(undefined);
    const [availableSites, setAvailableSites] = (0, $cozmU.useState)([]);
    const [loading, setLoading] = (0, $cozmU.useState)(false);
    const [error, setError] = (0, $cozmU.useState)(undefined);
    (0, $cozmU.useEffect)(()=>{
        const fetchAvailableJiraSites = async ()=>{
            setLoading(true);
            try {
                const { sites: sites } = await (0, $5TKGH.getAvailableJiraSites)();
                setAvailableSites(sites ?? []);
                const computedDomain = (sites.find((site)=>site.cloudId === preferredCloudId) ?? sites[0])?.url ?? '';
                setDomain(computedDomain);
                onComplete?.({
                    domain: computedDomain,
                    availableSites: sites
                });
            } catch (e) {
                onError && onError(e);
                setError(e.message);
            } finally{
                setLoading(false);
            }
        };
        fetchAvailableJiraSites();
    }, [
        preferredCloudId,
        onComplete,
        onError
    ]);
    return {
        domain: domain,
        availableSites: availableSites,
        loading: loading,
        error: error
    };
};
const $58abbbf3766fa385$export$7872bb66f9195035 = ({ onComplete: onComplete, onError: onError, baseUrlForAvailableSites: baseUrlForAvailableSites })=>{
    (0, $6cFsl.di)((0, $5TKGH.getAvailableJiraSites));
    const [availableSites, setAvailableSites] = (0, $cozmU.useState)([]);
    const [loading, setLoading] = (0, $cozmU.useState)(false);
    const [error, setError] = (0, $cozmU.useState)(undefined);
    const hasMount = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (hasMount.current) return;
        setLoading(true);
        const fetchAvailableJiraSites = async ()=>{
            try {
                const { sites: sites } = await (0, $5TKGH.getAvailableJiraSites)(baseUrlForAvailableSites);
                setAvailableSites(sites ?? []);
                onComplete?.({
                    availableSites: sites
                });
            } catch (e) {
                onError && onError(e);
                setError(e.message);
            } finally{
                setLoading(false);
            }
        };
        fetchAvailableJiraSites();
        hasMount.current = true;
    }, [
        baseUrlForAvailableSites,
        onComplete,
        onError
    ]);
    return {
        availableSites: availableSites,
        loading: loading,
        error: error
    };
};
const $58abbbf3766fa385$export$60b2cad7400d36b3 = ({ sites: sites, preferredCloudId: preferredCloudId })=>{
    const domain = (sites.find((site)=>site.cloudId === preferredCloudId) ?? sites[0])?.url ?? '';
    return {
        domain: domain
    };
};
const $58abbbf3766fa385$export$48ca77029c1208c2 = ({ cloudId: cloudId, overrideCloudId: overrideCloudId, baseUrlForAvailableSites: baseUrlForAvailableSites })=>{
    const { availableSites: availableSites, loading: loading, error: error } = $58abbbf3766fa385$export$7872bb66f9195035({
        baseUrlForAvailableSites: baseUrlForAvailableSites
    });
    const { domain: domainName } = $58abbbf3766fa385$export$60b2cad7400d36b3({
        sites: availableSites,
        preferredCloudId: cloudId
    });
    const { domain: isOverrideSiteAvailable } = $58abbbf3766fa385$export$60b2cad7400d36b3({
        sites: availableSites,
        preferredCloudId: overrideCloudId
    });
    if (error) throw new Error('Failed to fetch available sites');
    return loading ? {
        availableSites: [],
        domainName: undefined,
        isOverrideSiteAvailable: undefined
    } : {
        availableSites: availableSites,
        domainName: domainName,
        isOverrideSiteAvailable: isOverrideSiteAvailable
    };
};
module.exports["useGetFirstAvailableSiteDomain"] = $58abbbf3766fa385$export$930bddfd3ad23bb7;
module.exports["useGetDomainAndAvailableSites"] = $58abbbf3766fa385$export$48ca77029c1208c2;

});

parcelRegister("hRkxy", function(module, exports) {
const $3c0a544666aac42c$export$7bd623b29ec8e1eb = 7000; // 7s timeout, typical GIC load is ~3s
const $3c0a544666aac42c$export$6dfc55fc5e2544ae = 188;
const $3c0a544666aac42c$export$85d8afb0902718e2 = 250;
module.exports["DEFAULT_TIMEOUT"] = $3c0a544666aac42c$export$7bd623b29ec8e1eb;
module.exports["MAX_ERROR_IMAGE_WIDTH"] = $3c0a544666aac42c$export$6dfc55fc5e2544ae;
module.exports["MAX_ERROR_IMAGE_HEIGHT"] = $3c0a544666aac42c$export$85d8afb0902718e2;

});

parcelRegister("gkYOG", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $dcfad1e373bc3d13$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    iFrameLoading: {
        id: "jira-ai.gic-anywhere.iframe-loading",
        defaultMessage: "Loading work item details, this might take a few seconds."
    },
    iFrameSlowLoading: {
        id: "jira-ai.gic-anywhere.iframe-slow-loading",
        defaultMessage: "It is taking longer than usual to load your work item.{br}Give it a few more seconds, or try again later."
    },
    openInJiraButton: {
        id: "jira-ai.gic-anywhere.open-in-jira-button",
        defaultMessage: "Log in to Jira to view"
    },
    errorHeader: {
        id: "jira-ai.gic-anywhere.error-header",
        defaultMessage: "Something's gone wrong"
    },
    errorBody: {
        id: "jira-ai.gic-anywhere.error-body",
        defaultMessage: "Try opening this in Jira. If the problem persists, please contact Atlassian support."
    }
});
module.exports["messages"] = $dcfad1e373bc3d13$export$defe85febe8b728c;

});

parcelRegister("kuGC4", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");


var $lx3cN = parcelRequire("lx3cN");

const $d57cf010992105d3$export$409e508fe0e24613 = (0, $kBr4q.createStateHook)((0, $lx3cN.chatStore), {
    selector: (state, { conversationId: conversationId })=>state.conversations[conversationId]
});
module.exports["useConversationById"] = $d57cf010992105d3$export$409e508fe0e24613;

});

parcelRegister("hwgBi", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $53c00af853b7d7d7$var$EMPTY_SNAPSHOT = Object.freeze({
    pendingSignals: Object.freeze([])
});
let $53c00af853b7d7d7$var$nextIdentity = 0;
let $53c00af853b7d7d7$var$activeSession;
// One-entry memo so repeated reads of the active adjustment stay reference-stable for callers that
// bind the intent during render. Keyed by session and adjustment, so it can never be inherited by a
// replacement session on the same conversation.
let $53c00af853b7d7d7$var$capturedAdjustmentIntent;
const $53c00af853b7d7d7$var$subscribers = new Set();
// Single construction site for the adjustment intent, so the surface that starts an adjustment and
// the surface that later captures it can never disagree about its shape.
const $53c00af853b7d7d7$var$createAdjustmentIntent = (sessionId, conversationId, adjustmentId)=>Object.freeze({
        sessionId: sessionId,
        conversationId: conversationId,
        scope: 'adjustment-request',
        adjustmentId: adjustmentId
    });
const $53c00af853b7d7d7$var$nextId = (prefix)=>{
    $53c00af853b7d7d7$var$nextIdentity += 1;
    return `remix-cancellation-${prefix}-${$53c00af853b7d7d7$var$nextIdentity}`;
};
const $53c00af853b7d7d7$var$notifySubscribers = ()=>{
    $53c00af853b7d7d7$var$subscribers.forEach((subscriber)=>{
        try {
            subscriber();
        } catch  {
        // Shadow observation must never affect the authoritative legacy flow.
        }
    });
};
const $53c00af853b7d7d7$var$safelyReport = (reporter, diagnostic)=>{
    try {
        reporter?.(diagnostic);
    } catch  {
    // Shadow diagnostics must never affect the authoritative legacy flow.
    }
};
const $53c00af853b7d7d7$export$f747238e7aa7ceda = ({ conversationId: conversationId, reportDiagnostic: reportDiagnostic })=>{
    if ($53c00af853b7d7d7$var$activeSession) return undefined;
    const sessionId = $53c00af853b7d7d7$var$nextId('session');
    const outerCancellationIntent = Object.freeze({
        sessionId: sessionId,
        conversationId: conversationId,
        scope: 'outer-lifecycle'
    });
    $53c00af853b7d7d7$var$activeSession = {
        sessionId: sessionId,
        conversationId: conversationId,
        outerCancellationIntent: outerCancellationIntent,
        isObservationReady: false,
        pendingSignals: $53c00af853b7d7d7$var$EMPTY_SNAPSHOT.pendingSignals,
        hasReportedMissingOrigin: false,
        reportDiagnostic: reportDiagnostic
    };
    $53c00af853b7d7d7$var$notifySubscribers();
    return sessionId;
};
const $53c00af853b7d7d7$export$dab169c835c22a80 = (sessionId)=>{
    if ($53c00af853b7d7d7$var$activeSession?.sessionId !== sessionId) return;
    $53c00af853b7d7d7$var$activeSession = undefined;
    $53c00af853b7d7d7$var$notifySubscribers();
};
const $53c00af853b7d7d7$export$afda5d2e16cadb2f = ({ conversationId: conversationId, sessionId: sessionId })=>{
    if (!$53c00af853b7d7d7$var$activeSession || $53c00af853b7d7d7$var$activeSession.conversationId !== conversationId || $53c00af853b7d7d7$var$activeSession.sessionId !== sessionId) return false;
    $53c00af853b7d7d7$var$activeSession = {
        ...$53c00af853b7d7d7$var$activeSession,
        isObservationReady: true
    };
    $53c00af853b7d7d7$var$notifySubscribers();
    return true;
};
const $53c00af853b7d7d7$export$5e5f3c286ec3414c = ({ conversationId: conversationId })=>{
    if ($53c00af853b7d7d7$var$activeSession?.conversationId !== conversationId) return undefined;
    return $53c00af853b7d7d7$var$activeSession.outerCancellationIntent;
};
const $53c00af853b7d7d7$export$c94482fc4cdcee7b = (conversationId)=>{
    if ($53c00af853b7d7d7$var$activeSession?.conversationId !== conversationId) return undefined;
    const adjustmentId = $53c00af853b7d7d7$var$nextId('adjustment');
    $53c00af853b7d7d7$var$activeSession = {
        ...$53c00af853b7d7d7$var$activeSession,
        activeAdjustmentId: adjustmentId
    };
    // Seed the memo here so the surface that starts the adjustment and any surface that later
    // captures it hold the very same intent, not two equal copies.
    $53c00af853b7d7d7$var$capturedAdjustmentIntent = $53c00af853b7d7d7$var$createAdjustmentIntent($53c00af853b7d7d7$var$activeSession.sessionId, conversationId, adjustmentId);
    $53c00af853b7d7d7$var$notifySubscribers();
    return $53c00af853b7d7d7$var$capturedAdjustmentIntent;
};
const $53c00af853b7d7d7$export$b83855caf18bccc = ({ conversationId: conversationId })=>{
    const session = $53c00af853b7d7d7$var$activeSession;
    if (session?.conversationId !== conversationId || !session.activeAdjustmentId) return undefined;
    if ($53c00af853b7d7d7$var$capturedAdjustmentIntent?.sessionId !== session.sessionId || $53c00af853b7d7d7$var$capturedAdjustmentIntent.adjustmentId !== session.activeAdjustmentId) $53c00af853b7d7d7$var$capturedAdjustmentIntent = $53c00af853b7d7d7$var$createAdjustmentIntent(session.sessionId, conversationId, session.activeAdjustmentId);
    return $53c00af853b7d7d7$var$capturedAdjustmentIntent;
};
const $53c00af853b7d7d7$export$2d08536f329f4c99 = ({ conversationId: conversationId, adjustmentId: adjustmentId })=>{
    const session = $53c00af853b7d7d7$var$activeSession;
    if (!session || session.conversationId !== conversationId || session.activeAdjustmentId !== adjustmentId) return;
    $53c00af853b7d7d7$var$activeSession = {
        ...session,
        activeAdjustmentId: undefined
    };
    $53c00af853b7d7d7$var$notifySubscribers();
};
const $53c00af853b7d7d7$export$710b7daa23418f8d = ({ sessionId: sessionId, conversationId: conversationId, scope: scope, adjustmentId: adjustmentId })=>{
    const session = $53c00af853b7d7d7$var$activeSession;
    if (!session || session.sessionId !== sessionId || session.conversationId !== conversationId) return undefined;
    if (scope === 'adjustment-request' && (!adjustmentId || adjustmentId !== session.activeAdjustmentId)) {
        $53c00af853b7d7d7$var$safelyReport(session.reportDiagnostic, {
            kind: 'stale',
            scope: scope
        });
        return undefined;
    }
    const duplicate = session.pendingSignals.find((signal)=>signal.scope === scope && signal.adjustmentId === adjustmentId);
    if (duplicate) {
        $53c00af853b7d7d7$var$safelyReport(session.reportDiagnostic, {
            kind: 'duplicate',
            scope: scope
        });
        return duplicate;
    }
    const signal = Object.freeze({
        sessionId: sessionId,
        conversationId: conversationId,
        scope: scope,
        ...adjustmentId ? {
            adjustmentId: adjustmentId
        } : {}
    });
    $53c00af853b7d7d7$var$activeSession = {
        ...session,
        pendingSignals: [
            ...session.pendingSignals,
            signal
        ]
    };
    $53c00af853b7d7d7$var$notifySubscribers();
    return signal;
};
const $53c00af853b7d7d7$export$a38d77c3ac2240a1 = ({ sessionId: sessionId, conversationId: conversationId })=>{
    const session = $53c00af853b7d7d7$var$activeSession;
    if (!session || session.sessionId !== sessionId || session.conversationId !== conversationId) return undefined;
    const [signal, ...pendingSignals] = session.pendingSignals;
    if (!signal) return undefined;
    $53c00af853b7d7d7$var$activeSession = {
        ...session,
        pendingSignals: pendingSignals
    };
    $53c00af853b7d7d7$var$notifySubscribers();
    return signal;
};
const $53c00af853b7d7d7$export$461c48ccf8a4c566 = ({ sessionId: sessionId, conversationId: conversationId, diagnostic: diagnostic })=>{
    if ($53c00af853b7d7d7$var$activeSession?.sessionId !== sessionId || $53c00af853b7d7d7$var$activeSession.conversationId !== conversationId) return;
    $53c00af853b7d7d7$var$safelyReport($53c00af853b7d7d7$var$activeSession.reportDiagnostic, diagnostic);
};
const $53c00af853b7d7d7$export$d39e6e0b0d6aac55 = ({ sessionId: sessionId, conversationId: conversationId, phase: phase })=>{
    const session = $53c00af853b7d7d7$var$activeSession;
    if (!session || session.sessionId !== sessionId || session.conversationId !== conversationId || session.hasReportedMissingOrigin) return;
    $53c00af853b7d7d7$var$activeSession = {
        ...session,
        hasReportedMissingOrigin: true
    };
    $53c00af853b7d7d7$var$notifySubscribers();
    $53c00af853b7d7d7$var$safelyReport(session.reportDiagnostic, {
        kind: 'missing-origin',
        phase: phase
    });
};
const $53c00af853b7d7d7$export$2f62dad86b4fdbe3 = ({ sessionId: sessionId, conversationId: conversationId })=>{
    const session = $53c00af853b7d7d7$var$activeSession;
    if (!session || session.sessionId !== sessionId || session.conversationId !== conversationId) return $53c00af853b7d7d7$var$EMPTY_SNAPSHOT;
    return session;
};
const $53c00af853b7d7d7$export$48a0771346832426 = (subscriber)=>{
    $53c00af853b7d7d7$var$subscribers.add(subscriber);
    return ()=>$53c00af853b7d7d7$var$subscribers.delete(subscriber);
};
const $53c00af853b7d7d7$export$90fc1422584f08d8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { sessionId: sessionId, conversationId: conversationId } = t0;
    let t1;
    if ($[0] !== conversationId || $[1] !== sessionId) {
        t1 = ()=>$53c00af853b7d7d7$export$2f62dad86b4fdbe3({
                sessionId: sessionId,
                conversationId: conversationId
            });
        $[0] = conversationId;
        $[1] = sessionId;
        $[2] = t1;
    } else t1 = $[2];
    const getSnapshot = t1;
    return (0, $cozmU.useSyncExternalStore)($53c00af853b7d7d7$export$48a0771346832426, getSnapshot, getSnapshot);
} : ({ sessionId: sessionId, conversationId: conversationId })=>{
    const getSnapshot = (0, $cozmU.useCallback)(()=>$53c00af853b7d7d7$export$2f62dad86b4fdbe3({
            sessionId: sessionId,
            conversationId: conversationId
        }), [
        conversationId,
        sessionId
    ]);
    return (0, $cozmU.useSyncExternalStore)($53c00af853b7d7d7$export$48a0771346832426, getSnapshot, getSnapshot);
};
const $53c00af853b7d7d7$export$3d669e925311fe19 = ()=>{
    $53c00af853b7d7d7$var$activeSession = undefined;
    // Identities restart from zero, so a retained intent could match a fresh key by value.
    $53c00af853b7d7d7$var$capturedAdjustmentIntent = undefined;
    $53c00af853b7d7d7$var$nextIdentity = 0;
    $53c00af853b7d7d7$var$subscribers.clear();
};
module.exports["registerRemixCancellationSession"] = $53c00af853b7d7d7$export$f747238e7aa7ceda;
module.exports["unregisterRemixCancellationSession"] = $53c00af853b7d7d7$export$dab169c835c22a80;
module.exports["activateRemixCancellationObservation"] = $53c00af853b7d7d7$export$afda5d2e16cadb2f;
module.exports["captureRemixCancellationIntent"] = $53c00af853b7d7d7$export$5e5f3c286ec3414c;
module.exports["startRemixAdjustment"] = $53c00af853b7d7d7$export$c94482fc4cdcee7b;
module.exports["captureActiveRemixAdjustmentIntent"] = $53c00af853b7d7d7$export$b83855caf18bccc;
module.exports["finishRemixAdjustment"] = $53c00af853b7d7d7$export$2d08536f329f4c99;
module.exports["recordRemixCancellation"] = $53c00af853b7d7d7$export$710b7daa23418f8d;
module.exports["claimNextRemixCancellation"] = $53c00af853b7d7d7$export$a38d77c3ac2240a1;
module.exports["reportRemixCancellationDiagnostic"] = $53c00af853b7d7d7$export$461c48ccf8a4c566;
module.exports["reportMissingRemixCancellationOriginOnce"] = $53c00af853b7d7d7$export$d39e6e0b0d6aac55;
module.exports["useRemixCancellationSnapshot"] = $53c00af853b7d7d7$export$90fc1422584f08d8;

});

parcelRegister("c5wKe", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $gjWe2 = parcelRequire("gjWe2");


var $n71o5 = parcelRequire("n71o5");


var $3TxKn = parcelRequire("3TxKn");

const $3f23c49d3b1dd7cc$export$5650c329b9f287fb = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useSmartCreationChatStoreApi() {
    const $ = (0, $bDgLe.c)(8);
    const [t0] = (0, $n71o5.useChatStore)();
    const { currentConversationId: currentConversationId, conversations: conversations } = t0;
    const { createConversationOptimistically: createConversationOptimistically, setSelectedConversation: setSelectedConversation, sendMessage: sendMessage, abortRequests: abortRequests, seedConversation: seedConversation } = (0, $3TxKn.useChatStoreActions)();
    const activeConversation = conversations[currentConversationId];
    let t1;
    if ($[0] !== abortRequests || $[1] !== activeConversation || $[2] !== createConversationOptimistically || $[3] !== currentConversationId || $[4] !== seedConversation || $[5] !== sendMessage || $[6] !== setSelectedConversation) {
        t1 = {
            createConversationOptimistically: createConversationOptimistically,
            setSelectedConversation: setSelectedConversation,
            abortRequests: abortRequests,
            activeConversationId: currentConversationId,
            activeConversation: activeConversation,
            sendMessage: sendMessage,
            seedConversation: seedConversation,
            processConversationMessages: $gjWe2.processConversationMessages
        };
        $[0] = abortRequests;
        $[1] = activeConversation;
        $[2] = createConversationOptimistically;
        $[3] = currentConversationId;
        $[4] = seedConversation;
        $[5] = sendMessage;
        $[6] = setSelectedConversation;
        $[7] = t1;
    } else t1 = $[7];
    return t1;
} : function useSmartCreationChatStoreApi() {
    const [{ currentConversationId: currentConversationId, conversations: conversations }] = (0, $n71o5.useChatStore)();
    const { createConversationOptimistically: createConversationOptimistically, setSelectedConversation: setSelectedConversation, sendMessage: sendMessage, abortRequests: abortRequests, seedConversation: seedConversation } = (0, $3TxKn.useChatStoreActions)();
    const activeConversation = conversations[currentConversationId];
    return {
        createConversationOptimistically: createConversationOptimistically,
        setSelectedConversation: setSelectedConversation,
        abortRequests: abortRequests,
        activeConversationId: currentConversationId,
        activeConversation: activeConversation,
        sendMessage: sendMessage,
        seedConversation: seedConversation,
        processConversationMessages: $gjWe2.processConversationMessages
    };
};
module.exports["useSmartCreationChatStoreApi"] = $3f23c49d3b1dd7cc$export$5650c329b9f287fb;

});

parcelRegister("1AJi3", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dPoYT = parcelRequire("dPoYT");


var $kQqCc = parcelRequire("kQqCc");


var $93Gae = parcelRequire("93Gae");


var $2bR8c = parcelRequire("2bR8c");


var $jln20 = parcelRequire("jln20");

const $ca70225f28efd254$export$a81c3fee0d63dde7 = ()=>{
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const { panelId: panelId } = rightSidebarContext.getCurrent() || {};
    const { mode: mode, isMiniModalAvailable: isMiniModalAvailable, toggleConversationAssistantUIMode: toggleConversationAssistantUIMode, openConversationAssistantUIMode: openConversationAssistantUIMode } = (0, $93Gae.useRovoExperienceAPIStore)();
    const isConversationAssistantSidebarActive = panelId === (0, $kQqCc.CONVERSATION_ASSISTANT_CONTAINER_ID);
    const sidebarApi = (0, $2bR8c.useCreateRovoExperienceSidebarController)();
    const toggleConversationAssistant = (0, $cozmU.useCallback)((openChatMode = 'sidebar', autoFocusInput = true)=>{
        toggleConversationAssistantUIMode({
            targetMode: openChatMode === 'mini-modal' && isMiniModalAvailable ? (0, $dPoYT.ConversationAssistantUIModes).MINI_MODAL : (0, $dPoYT.ConversationAssistantUIModes).SIDEBAR,
            sidebarApi: sidebarApi,
            autoFocusInput: autoFocusInput
        });
    }, [
        toggleConversationAssistantUIMode,
        sidebarApi,
        isMiniModalAvailable
    ]);
    const openConversationAssistant = (0, $cozmU.useCallback)((openChatMode = 'sidebar', autoFocusInput = true)=>{
        openConversationAssistantUIMode({
            targetMode: openChatMode === 'mini-modal' && isMiniModalAvailable ? (0, $dPoYT.ConversationAssistantUIModes).MINI_MODAL : (0, $dPoYT.ConversationAssistantUIModes).SIDEBAR,
            sidebarApi: sidebarApi,
            autoFocusInput: autoFocusInput
        });
    }, [
        openConversationAssistantUIMode,
        sidebarApi,
        isMiniModalAvailable
    ]);
    return (0, $cozmU.useMemo)(()=>({
            mode: mode,
            toggleConversationAssistant: toggleConversationAssistant,
            openConversationAssistant: openConversationAssistant,
            isConversationAssistantSidebarActive: isConversationAssistantSidebarActive
        }), [
        mode,
        toggleConversationAssistant,
        openConversationAssistant,
        isConversationAssistantSidebarActive
    ]);
};
module.exports["useToggleConversationAssistant"] = $ca70225f28efd254$export$a81c3fee0d63dde7;

});

parcelRegister("ficwO", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

var $6c05dda517103510$export$f69c19e57285b83a = /*#__PURE__*/ function(Message) {
    Message[Message["ContentCreated"] = 0] = "ContentCreated";
    Message[Message["ContentUnarchived"] = 1] = "ContentUnarchived";
    Message[Message["SmartFolderSyncStateChanged"] = 2] = "SmartFolderSyncStateChanged";
    Message[Message["PageTreeRefreshRequested"] = 3] = "PageTreeRefreshRequested";
    return Message;
}({});
class $6c05dda517103510$var$MessageBus {
    publish(type, data) {
        if (!this.subscribers[type]) return;
        this.subscribers[type].forEach((subscriber)=>subscriber(data));
    }
    subscribe(type, callback) {
        if (!this.subscribers[type]) this.subscribers[type] = [];
        this.subscribers[type].push(callback);
    }
    unsubscribe(type, callback) {
        this.subscribers[type] = this.subscribers[type].filter((subscriber)=>subscriber !== callback);
    }
    constructor(){
        this.subscribers = {};
    }
}
const $6c05dda517103510$var$messageBus = new $6c05dda517103510$var$MessageBus();
const $6c05dda517103510$export$c4ca85b4851515e2 = (type)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== type) {
        t0 = (data)=>{
            $6c05dda517103510$var$messageBus.publish(type, data);
        };
        $[0] = type;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
const $6c05dda517103510$export$5ecf0545a6d326d0 = (type, data)=>{
    $6c05dda517103510$var$messageBus.publish(type, data);
};
const $6c05dda517103510$export$99473f2ba2f9f18 = (type, callback)=>{
    const $ = (0, $bDgLe.c)(4);
    let t0;
    let t1;
    if ($[0] !== callback || $[1] !== type) {
        t0 = ()=>{
            $6c05dda517103510$var$messageBus.subscribe(type, callback);
            return ()=>{
                $6c05dda517103510$var$messageBus.unsubscribe(type, callback);
            };
        };
        t1 = [
            callback,
            type
        ];
        $[0] = callback;
        $[1] = type;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
};
module.exports["Message"] = $6c05dda517103510$export$f69c19e57285b83a;
module.exports["useMessagePublisher"] = $6c05dda517103510$export$c4ca85b4851515e2;
module.exports["publishMessage"] = $6c05dda517103510$export$5ecf0545a6d326d0;
module.exports["useMessageSubscriber"] = $6c05dda517103510$export$99473f2ba2f9f18;

});

parcelRegister("ew8wg", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $duklN = parcelRequire("duklN");


var $cozmU = parcelRequire("cozmU");


var $1uFM6 = parcelRequire("1uFM6");


var $95rLf = parcelRequire("95rLf");


var $7Sm4c = parcelRequire("7Sm4c");


var $jMyy4 = parcelRequire("jMyy4");

const $df587a746afa9e84$export$4882d379d640c470 = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { contentId: contentId } = t0;
    let t1;
    if ($[0] !== contentId) {
        t1 = {
            variables: {
                contentId: contentId
            }
        };
        $[0] = contentId;
        $[1] = t1;
    } else t1 = $[1];
    const { data: data, error: error } = (0, $jMyy4.useQueryInterop)((0, $duklN.default), {
        ...t1,
        __callerPackage__: "content-title"
    });
    let t2;
    let t3;
    if ($[2] !== error) {
        t2 = ()=>{
            if (error && ((0, $1uFM6.isUnauthorizedError)(error) || (0, $95rLf.isExpectedApolloError)(error))) (0, $7Sm4c.markErrorAsHandled)(error);
        };
        t3 = [
            error
        ];
        $[2] = error;
        $[3] = t2;
        $[4] = t3;
    } else {
        t2 = $[3];
        t3 = $[4];
    }
    (0, $cozmU.useEffect)(t2, t3);
    const t4 = data?.singleContent?.title;
    let t5;
    if ($[5] !== error || $[6] !== t4) {
        t5 = {
            title: t4,
            error: error
        };
        $[5] = error;
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    return t5;
};
module.exports["usePageTitle"] = $df587a746afa9e84$export$4882d379d640c470;

});

parcelRegister("iMLPM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $9wGTI = parcelRequire("9wGTI");


var $jmjWc = parcelRequire("jmjWc");


// Keep the machine registry graph out of the root App bundle and off the page-load
// critical path. The host renders nothing and only observes flows that start from
// user interaction, so it loads in the background phase: no SSR preload and no UFO
// load hold on every page view. A late mount reads the registry's current snapshot.
// Producers call `preloadRemixWatcherHost` at flow admission so the chunk is already
// in flight before any machine-derived phase becomes user-visible.
const $8fae2dbb97264744$var$LazyRemixWatcherHost = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "ikpQt",
    name: 'RemixWatcherHost',
    loader: async ()=>(await (parcelRequire("8pF6M"))).RemixWatcherHost,
    loading: ()=>null
});
const $8fae2dbb97264744$export$8ac6a35c27bccce6 = ()=>{
    if (!(0, $9wGTI.fg)('remix_state_rearchitecture_enabled')) return;
    // Fire-and-forget: the loadable surfaces load failures through its own error path.
    $8fae2dbb97264744$var$LazyRemixWatcherHost.preload();
};
const $8fae2dbb97264744$export$b6d016c0687b53a1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).CE_MAU
    }, (0, $9wGTI.fg)('remix_state_rearchitecture_enabled') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8fae2dbb97264744$var$LazyRemixWatcherHost, null) : null);
module.exports["preloadRemixWatcherHost"] = $8fae2dbb97264744$export$8ac6a35c27bccce6;
module.exports["RemixWatcherMount"] = $8fae2dbb97264744$export$b6d016c0687b53a1;

});

parcelRegister("8pF6M", function(module, exports) {

let $62008bcfbc8aceec$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $62008bcfbc8aceec$var$load("ecqah"),
    $62008bcfbc8aceec$var$load("j3CG3")
]).then(()=>parcelRequire('1HmBi'));

});

parcelRegister("nkPkg", function(module, exports) {
/**
 * Shared semantic vocabulary for renderer and editor parity events.
 *
 * Phase pairs remain useful diagnostic context, but consumers should use these fields to decide
 * whether an event is ordinary timing mechanics or a rollout-significant divergence.
 */ const $9d5a049440311a2a$export$9bde4969f49d9b2b = (durationMs)=>{
    if (durationMs < 250) return 'under-250ms';
    if (durationMs < 1000) return '250-999ms';
    if (durationMs < 5000) return '1-4s';
    return '5s-or-more';
};
module.exports["durationBucketForMs"] = $9d5a049440311a2a$export$9bde4969f49d9b2b;

});

parcelRegister("koSDQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $irnO2 = parcelRequire("irnO2");


var $caVF7 = parcelRequire("caVF7");

const $2e4059893c92a637$export$654bbdda10638776 = ({ entryPoint: entryPoint, experienceTracker: experienceTracker, dynamicUiType: dynamicUiType, selectedSubTypeRef: selectedSubTypeRef, openAIFCStagingModalRef: openAIFCStagingModalRef, isRemixCancelledRef: isRemixCancelledRef, conversationIdRef: conversationIdRef, shouldOpenPreview: shouldOpenPreview, onAfterOpenPreview: onAfterOpenPreview })=>{
    const openPreview = (0, $cozmU.useCallback)(()=>{
        experienceTracker.succeed({
            name: (0, $irnO2.ExperienceName).REMIX_START
        });
        experienceTracker.start({
            name: (0, $irnO2.ExperienceName).REMIX_RENDERS_IN_MODAL,
            id: (0, $irnO2.ExperienceName).REMIX_RENDERS_IN_MODAL,
            attributes: {
                product: 'confluence',
                remixType: dynamicUiType,
                remixSubtype: selectedSubTypeRef.current,
                entryPoint: entryPoint,
                conversationChannelId: conversationIdRef?.current
            }
        });
        openAIFCStagingModalRef.current();
        onAfterOpenPreview?.();
    }, [
        entryPoint,
        experienceTracker,
        dynamicUiType,
        selectedSubTypeRef,
        openAIFCStagingModalRef,
        conversationIdRef,
        onAfterOpenPreview
    ]);
    const openPreviewIfAllowed = (0, $cozmU.useCallback)(()=>{
        if (shouldOpenPreview?.() === false) return;
        openPreview();
    }, [
        openPreview,
        shouldOpenPreview
    ]);
    const { showProgressBar: showProgressBar, isComplete: isComplete, onCompleteAnimationFinished: onCompleteAnimationFinished, signalActionReady: signalActionReady, resetCompletion: resetCompletion } = (0, $caVF7.useRemixThinkingBarProgress)({
        onOpenPreview: openPreviewIfAllowed
    });
    const onActionReady = (0, $cozmU.useCallback)(()=>{
        if (!isRemixCancelledRef.current) {
            (0, $irnO2.remixGeneratePreviewExperience).mark((0, $irnO2.REMIX_GENERATE_PREVIEW_MARKS).ACTION_COMPLETE_RECEIVED);
            signalActionReady();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- ref identity is stable; reading .current does not need to be a dep
    }, [
        signalActionReady
    ]);
    return {
        showProgressBar: showProgressBar,
        isComplete: isComplete,
        onCompleteAnimationFinished: onCompleteAnimationFinished,
        onActionReady: onActionReady,
        resetCompletion: resetCompletion
    };
};
module.exports["useRemixPreviewFlow"] = $2e4059893c92a637$export$654bbdda10638776;

});

parcelRegister("kOUwv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $60cDW = parcelRequire("60cDW");


var $dcJRl = parcelRequire("dcJRl");

const $d684465712516a35$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $d684465712516a35$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                loading: true,
                error: null
            });
        },
    success: (data)=>({ setState: setState })=>{
            setState({
                data: data,
                loading: false,
                error: null
            });
        },
    error: (err)=>({ setState: setState })=>{
            setState({
                error: err,
                loading: false
            });
        },
    reset: ()=>({ setState: setState })=>{
            setState({
                data: null,
                loading: false,
                error: null
            });
        }
};
const $d684465712516a35$export$2d97e7bb018b0cfb = (0, $8s9DV.createStore)({
    initialState: $d684465712516a35$var$initialState,
    actions: $d684465712516a35$var$actions,
    name: 'siteTraitsStore'
});
const $d684465712516a35$export$c84f691b170cbee3 = (0, $kBr4q.createHook)($d684465712516a35$export$2d97e7bb018b0cfb);
const $d684465712516a35$export$2aca02eeb1d46515 = (0, $kBr4q.createActionsHook)($d684465712516a35$export$2d97e7bb018b0cfb);
async function $d684465712516a35$var$fetchSiteTraitsData(cloudId) {
    const res = await (0, $f7B1p.cfetch)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`, {
        method: 'GET'
    });
    if (!res.ok) {
        const text = await res.text().catch(()=>'');
        throw new Error(`Request failed with ${res.status}: ${text || res.statusText}`);
    }
    return await res.json();
}
// Use a module-level variable to ensure we only fetch once per app lifecycle
// This way multiple components using the hook won't trigger multiple fetches
let $d684465712516a35$var$hasFetched = false;
function $d684465712516a35$export$f1fbc6ad89f91b89() {
    $d684465712516a35$var$hasFetched = false;
}
function $d684465712516a35$var$getSiteTraitsFromSources() {
    let attributes = null;
    // First check window.__SSR_TAP_CONTEXT__ which contains raw tapContext data
    if (typeof window !== 'undefined' && window.__SSR_TAP_CONTEXT__) {
        attributes = (0, $dcJRl.formatTapTraits)(window.__SSR_TAP_CONTEXT__.site);
        if (attributes) return {
            attributes: attributes
        };
    }
    // Fallback to getSSRRenderInputs() for SSR scenarios
    const { tapContext: tapContext } = (0, $60cDW.getSSRRenderInputs)();
    attributes = (0, $dcJRl.formatTapTraits)(tapContext?.site);
    if (attributes) return {
        attributes: attributes
    };
    return null;
}
function $d684465712516a35$export$fcebe75065597a98({ skipBootstrap: skipBootstrap } = {}) {
    const preloadedData = (0, $cozmU.useMemo)(()=>$d684465712516a35$var$getSiteTraitsFromSources(), []);
    const [{ data: data, loading: loading, error: error }, storeActions] = $d684465712516a35$export$c84f691b170cbee3();
    const { accessStatus: accessStatus, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    (0, $cozmU.useEffect)(()=>{
        if (preloadedData || data || loading || error) return;
        if ($d684465712516a35$var$hasFetched || skipBootstrap) return;
        if (!hasLicensedAccess || !cloudId) return;
        $d684465712516a35$var$hasFetched = true;
        storeActions.start();
        $d684465712516a35$var$fetchSiteTraitsData(cloudId).then(storeActions.success).catch(storeActions.error);
    }, [
        skipBootstrap,
        preloadedData,
        data,
        loading,
        error,
        storeActions,
        hasLicensedAccess,
        cloudId
    ]);
    if (preloadedData) return {
        data: preloadedData,
        loading: false,
        error: null
    };
    return {
        data: data,
        loading: loading,
        error: error
    };
}
module.exports["useSiteTraits"] = $d684465712516a35$export$fcebe75065597a98;

});

parcelRegister("kDhla", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $9a24de4c41696be8$export$d4c72bab9d6cc13a = {
    fullPageEditorPresetAPI: undefined
};
const $9a24de4c41696be8$export$e324594224ef24da = {
    setEditorApi: (fullPageEditorPresetAPI)=>({ setState: setState })=>{
            setState({
                fullPageEditorPresetAPI: fullPageEditorPresetAPI
            });
        },
    resetEditorApi: ()=>({ setState: setState })=>{
            setState($9a24de4c41696be8$export$d4c72bab9d6cc13a);
        }
};
const $9a24de4c41696be8$var$FullPageEditorApiStore = (0, $8s9DV.createStore)({
    initialState: $9a24de4c41696be8$export$d4c72bab9d6cc13a,
    actions: $9a24de4c41696be8$export$e324594224ef24da,
    name: 'FullPageEditorApiStore'
});
const $9a24de4c41696be8$export$dc2b462ca736d2cc = (0, $kBr4q.createHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
const $9a24de4c41696be8$export$6e619048e155ac67 = (0, $kBr4q.createActionsHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
const $9a24de4c41696be8$export$4875e84e17c56c5c = (0, $kBr4q.createStateHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
module.exports["useFullPageEditorApi"] = $9a24de4c41696be8$export$dc2b462ca736d2cc;
module.exports["useFullPageEditorApiActions"] = $9a24de4c41696be8$export$6e619048e155ac67;
module.exports["useFullPageEditorApiState"] = $9a24de4c41696be8$export$4875e84e17c56c5c;

});

parcelRegister("cAdj8", function(module, exports) {

var $69Jl3 = parcelRequire("69Jl3");


var $cozmU = parcelRequire("cozmU");


var $7Sm4c = parcelRequire("7Sm4c");


var $ep3mz = parcelRequire("ep3mz");


var $1uFM6 = parcelRequire("1uFM6");


var $flE5X = parcelRequire("flE5X");


var $jMyy4 = parcelRequire("jMyy4");

const $a1394411ec7881e4$var$usePageInfoPageInfoQuery = (0, $69Jl3.default);
const $a1394411ec7881e4$export$e1b9843c9a40eb2 = {
    id: '',
    type: '',
    status: '',
    space: {
        id: '',
        operations: []
    },
    operations: [],
    version: {
        number: -1
    }
};
const $a1394411ec7881e4$export$7b2dac1793a2824 = ({ fetchPolicy: fetchPolicy = 'cache-and-network', onCompleted: onCompleted, onError: onError } = {})=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $jMyy4.useQueryInterop)($a1394411ec7881e4$var$usePageInfoPageInfoQuery, {
        variables: {
            pageId: contentId
        },
        fetchPolicy: fetchPolicy,
        onCompleted: onCompleted,
        __callerPackage__: "page-info"
    });
    return (0, $cozmU.useMemo)(()=>{
        // Handle error case first
        if (error) {
            if ((0, $1uFM6.isUnauthorizedError)(error) || error instanceof (0, $flE5X.NoNetworkError)) (0, $7Sm4c.markErrorAsHandled)(error);
            onError?.(error);
            return {
                pageInfo: null,
                loading: false,
                error: error,
                refetch: null
            };
        }
        // If we have data, use it even during loading
        if (data) {
            const pageInfoNode = data.content?.nodes?.[0] ?? null;
            if (pageInfoNode) return {
                pageInfo: pageInfoNode,
                loading: loading,
                error: undefined,
                refetch: refetch
            };
            return {
                pageInfo: {
                    ...$a1394411ec7881e4$export$e1b9843c9a40eb2
                },
                loading: loading,
                error: undefined,
                refetch: refetch
            };
        }
        // Only return null pageInfo if we have no data at all
        return {
            pageInfo: null,
            loading: loading,
            error: undefined,
            refetch: null
        };
    }, [
        data,
        loading,
        error,
        onError,
        refetch
    ]);
};
module.exports["usePageInfo"] = $a1394411ec7881e4$export$7b2dac1793a2824;

});

parcelRegister("69Jl3", function(module, exports) {
/**
 * @generated SignedSource<<a52aa17c9371e87ad68639adf48d413b>>
 * @relayHash ece963db192ceabc724d67f753bee503
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2811ac8ea0cd2136d716a0779dac023c092684c56d72b0b668fe85db77dee6d4
const $c7d0a8215908754e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "pageId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "current",
                        "archived",
                        "draft"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ 
                            ]
                        },
                        v2 /*: any*/ ,
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "number"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePageInfoPageInfoQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePageInfoPageInfoQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "ece963db192ceabc724d67f753bee503",
            "id": "2811ac8ea0cd2136d716a0779dac023c092684c56d72b0b668fe85db77dee6d4",
            "metadata": {},
            "name": "usePageInfoPageInfoQuery",
            "operationKind": "query",
            "text": "query usePageInfoPageInfoQuery($pageId:ID){content(id:$pageId,status:[\"current\",\"archived\",\"draft\"]){nodes{id,type,status,space{id,operations{operation,targetType}},operations{operation,targetType},version{number}}}}"
        }
    };
}();
$c7d0a8215908754e$var$node.hash = "a5580c0bc26236652ac23ad7c3f4bf51";
var $c7d0a8215908754e$export$2e2bcd8739ae039 = $c7d0a8215908754e$var$node;
module.exports["default"] = $c7d0a8215908754e$export$2e2bcd8739ae039;

});

parcelRegister("dklIa", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

var $c6StJ = parcelRequire("c6StJ");

const $c3a6d60a3494ed40$var$defaultCommentState = Object.freeze({
    optimisticReactions: Object.freeze([]),
    inFlightEmojiIds: Object.freeze(new Set()),
    rollbackMap: Object.freeze(new Map()),
    error: undefined
});
const $c3a6d60a3494ed40$var$getCommentState = (state, commentId)=>state.commentReactionState[commentId] ?? $c3a6d60a3494ed40$var$defaultCommentState;
const $c3a6d60a3494ed40$var$setCommentState = (state, commentId, patch)=>({
        ...state.commentReactionState,
        [commentId]: {
            ...$c3a6d60a3494ed40$var$getCommentState(state, commentId),
            ...patch
        }
    });
const $c3a6d60a3494ed40$var$DEFAULT_STALENESS = Object.freeze({
    changed: 0,
    fetched: 0
});
const $c3a6d60a3494ed40$export$64e3401c254cca65 = (commentId, emojiId)=>`${commentId}::${emojiId}`;
/**
 * Merges server reaction data into the existing display order.
 * Existing emojis keep their position; their values are updated from `server`
 * (or from `inFlightOverrides` when a mutation is in-flight).
 * Emojis absent from both `server` and `inFlightOverrides` are dropped.
 * New emojis (from server or still-in-flight) are appended at the end.
 */ const $c3a6d60a3494ed40$var$stabilizeReactions = (current, server, inFlightOverrides = new Map(), deletedInFlight = new Set())=>{
    const serverMap = new Map();
    for (const r of server)if (!deletedInFlight.has(r.emojiId)) serverMap.set(r.emojiId, r);
    const result = [];
    const seenIds = new Set();
    for (const r of current){
        if (deletedInFlight.has(r.emojiId)) continue;
        const inFlight = inFlightOverrides.get(r.emojiId);
        if (inFlight) {
            result.push(inFlight);
            seenIds.add(r.emojiId);
        } else if (serverMap.has(r.emojiId)) {
            result.push(serverMap.get(r.emojiId));
            seenIds.add(r.emojiId);
        }
    // not in server and not in-flight → removed, omit
    }
    for (const r of server)if (!seenIds.has(r.emojiId) && !deletedInFlight.has(r.emojiId)) {
        result.push(r);
        seenIds.add(r.emojiId);
    }
    for (const [emojiId, optimistic] of inFlightOverrides)if (!seenIds.has(emojiId)) {
        result.push(optimistic);
        seenIds.add(emojiId);
    }
    return result;
};
const $c3a6d60a3494ed40$var$initialState = {
    opener: null,
    picker: null,
    optimisticReactionMarkerMap: {},
    optimisticResolvedMarkerRefs: new Set(),
    optimisticDeletedMarkerRefs: new Set(),
    commentReactionState: {},
    reactedUsersStaleness: {}
};
const $c3a6d60a3494ed40$var$registerOpener = (opener)=>({ setState: setState })=>{
        setState({
            opener: opener
        });
    };
const $c3a6d60a3494ed40$var$triggerOpen = ()=>({ getState: getState })=>{
        getState().opener?.();
    };
const $c3a6d60a3494ed40$var$openPicker = ({ anchorTop: anchorTop, anchorLeft: anchorLeft, contentType: contentType, pageId: pageId, onCreate: onCreate, step: step, originalSelection: originalSelection, onClose: onClose })=>({ setState: setState, getState: getState })=>{
        if (getState().picker) return;
        setState({
            picker: {
                anchorTop: anchorTop,
                anchorLeft: anchorLeft,
                contentType: contentType,
                pageId: pageId,
                onCreate: onCreate,
                step: step,
                originalSelection: originalSelection,
                onClose: onClose
            }
        });
    };
const $c3a6d60a3494ed40$var$closePicker = ()=>({ setState: setState, getState: getState })=>{
        const { picker: picker } = getState();
        if (!picker) return;
        picker.onClose?.();
        setState({
            picker: null
        });
    };
const $c3a6d60a3494ed40$var$addOptimisticReaction = (markerRef, commentId)=>({ setState: setState, getState: getState })=>{
        setState({
            optimisticReactionMarkerMap: {
                ...getState().optimisticReactionMarkerMap,
                [markerRef]: commentId
            }
        });
    };
const $c3a6d60a3494ed40$var$addOptimisticResolvedMarkerRef = (markerRef)=>({ setState: setState, getState: getState })=>{
        const current = getState().optimisticResolvedMarkerRefs;
        if (current.has(markerRef)) return;
        setState({
            optimisticResolvedMarkerRefs: new Set([
                ...current,
                markerRef
            ])
        });
    };
/**
 * Roll back an optimistic resolve — removes the ref from the set so the
 * highlight reappears. Called when the resolve mutation fails.
 */ const $c3a6d60a3494ed40$var$removeOptimisticResolvedMarkerRef = (markerRef)=>({ setState: setState, getState: getState })=>{
        const current = getState().optimisticResolvedMarkerRefs;
        if (!current.has(markerRef)) return;
        const next = new Set(current);
        next.delete(markerRef);
        setState({
            optimisticResolvedMarkerRefs: next
        });
    };
/**
 * Drain any optimistic-resolved refs that are no longer present in the
 * server-confirmed marker refs (meaning the server has confirmed removal).
 * No-ops when the set is empty to avoid an extra re-render.
 */ const $c3a6d60a3494ed40$var$pruneOptimisticResolvedMarkerRefs = (serverMarkerRefs)=>({ setState: setState, getState: getState })=>{
        const current = getState().optimisticResolvedMarkerRefs;
        if (current.size === 0) return;
        const serverSet = new Set(serverMarkerRefs);
        const next = new Set();
        for (const ref of current)// Keep only refs that the server still returns (not yet confirmed removed).
        if (serverSet.has(ref)) next.add(ref);
        if (next.size !== current.size) setState({
            optimisticResolvedMarkerRefs: next
        });
    };
const $c3a6d60a3494ed40$var$addOptimisticDeletedMarkerRef = (markerRef)=>({ setState: setState, getState: getState })=>{
        const current = getState().optimisticDeletedMarkerRefs;
        if (current.has(markerRef)) return;
        setState({
            optimisticDeletedMarkerRefs: new Set([
                ...current,
                markerRef
            ])
        });
    };
const $c3a6d60a3494ed40$var$pruneOptimisticDeletedMarkerRefs = (serverMarkerRefs)=>({ setState: setState, getState: getState })=>{
        const current = getState().optimisticDeletedMarkerRefs;
        if (current.size === 0) return;
        const serverSet = new Set(serverMarkerRefs);
        const next = new Set();
        for (const ref of current)if (serverSet.has(ref)) next.add(ref);
        if (next.size !== current.size) setState({
            optimisticDeletedMarkerRefs: next
        });
    };
/**
 * Drop any optimistic entries whose markerRef is now in the server-confirmed map.
 * Called from `useRendererAnnotationProviderOptions` whenever `useActiveInlineData`
 * returns a new `reactionMarkerMap`, so the optimistic store does not grow forever.
 * No-ops (and skips the setState) when nothing needs to be pruned to avoid an
 * extra re-render cycle.
 */ const $c3a6d60a3494ed40$var$pruneOptimisticReactions = (confirmedMarkerRefs)=>({ setState: setState, getState: getState })=>{
        const current = getState().optimisticReactionMarkerMap;
        if (Object.keys(current).length === 0 || confirmedMarkerRefs.length === 0) return;
        const confirmedSet = new Set(confirmedMarkerRefs);
        let changed = false;
        const next = {};
        for (const [markerRef, commentId] of Object.entries(current)){
            if (confirmedSet.has(markerRef)) {
                changed = true;
                continue;
            }
            next[markerRef] = commentId;
        }
        if (changed) setState({
            optimisticReactionMarkerMap: next
        });
    };
/**
 * Sync server reactions into the store for a given comment.
 *
 * When nothing is in-flight, the server data replaces the optimistic array.
 * When mutations are in-flight, server data is merged: in-flight emojis keep
 * their optimistic values while everything else updates to the server truth.
 */ const $c3a6d60a3494ed40$var$syncServerReactions = (commentId, serverReactions)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const comment = $c3a6d60a3494ed40$var$getCommentState(state, commentId);
        if (comment.inFlightEmojiIds.size === 0) {
            setState({
                commentReactionState: $c3a6d60a3494ed40$var$setCommentState(state, commentId, {
                    optimisticReactions: $c3a6d60a3494ed40$var$stabilizeReactions(comment.optimisticReactions, serverReactions)
                })
            });
            return;
        }
        // Merge: keep optimistic values for in-flight emojis, use server for the rest.
        // Build the snapshot as a Map for O(1) lookup (avoids quadratic nested iteration).
        const inFlightSnapshot = new Map();
        for (const r of comment.optimisticReactions)if (comment.inFlightEmojiIds.has(r.emojiId)) inFlightSnapshot.set(r.emojiId, r);
        // Track emojis that were optimistically deleted (in-flight but absent from
        // optimisticReactions because their count hit 0). We must suppress these from
        // the server payload so they don't get resurrected before the mutation settles.
        const deletedInFlight = new Set();
        for (const id of comment.inFlightEmojiIds)if (!inFlightSnapshot.has(id)) deletedInFlight.add(id);
        setState({
            commentReactionState: $c3a6d60a3494ed40$var$setCommentState(state, commentId, {
                optimisticReactions: $c3a6d60a3494ed40$var$stabilizeReactions(comment.optimisticReactions, serverReactions, inFlightSnapshot, deletedInFlight)
            })
        });
    };
/**
 * Apply an optimistic toggle (add or remove) for an existing emoji.
 * Returns `null` if the emoji is already in-flight or not found (no-op).
 * Otherwise applies the optimistic update, marks in-flight, and returns
 * `true` if removing or `false` if adding, so the caller knows which
 * mutation to fire.
 *
 * This combines the guard, optimistic update, and in-flight marking into a
 * single synchronous store transaction so that rapid-fire calls (e.g. double
 * clicks) are properly de-duped even before React re-renders.
 */ const $c3a6d60a3494ed40$var$applyOptimisticToggle = (commentId, emojiId)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const comment = $c3a6d60a3494ed40$var$getCommentState(state, commentId);
        if (comment.inFlightEmojiIds.has(emojiId)) return null;
        const currentReaction = comment.optimisticReactions.find((r)=>r.emojiId === emojiId);
        if (!currentReaction) return null;
        const isRemoving = currentReaction.reacted;
        // Save rollback snapshot
        const nextRollback = new Map(comment.rollbackMap);
        nextRollback.set(emojiId, comment.optimisticReactions);
        // Mark in-flight
        const nextInFlight = new Set(comment.inFlightEmojiIds);
        nextInFlight.add(emojiId);
        let nextReactions;
        if (isRemoving) {
            const newCount = currentReaction.count - 1;
            if (newCount <= 0) nextReactions = comment.optimisticReactions.filter((r)=>r.emojiId !== emojiId);
            else nextReactions = comment.optimisticReactions.map((r)=>r.emojiId === emojiId ? {
                    ...r,
                    count: newCount,
                    reacted: false
                } : r);
        } else nextReactions = comment.optimisticReactions.map((r)=>r.emojiId === emojiId ? {
                ...r,
                count: r.count + 1,
                reacted: true
            } : r);
        setState({
            commentReactionState: $c3a6d60a3494ed40$var$setCommentState(state, commentId, {
                optimisticReactions: nextReactions,
                rollbackMap: nextRollback,
                inFlightEmojiIds: nextInFlight,
                error: undefined
            })
        });
        return isRemoving;
    };
/**
 * Apply an optimistic add for a new or existing-but-not-reacted emoji.
 * Returns `false` if already in-flight or already reacted (no-op).
 * Otherwise applies the optimistic update, marks in-flight, and returns `true`.
 *
 * Like `applyOptimisticToggle`, this combines guard + update + in-flight
 * into a single synchronous transaction.
 */ const $c3a6d60a3494ed40$var$applyOptimisticAdd = (commentId, emojiId, templateAri, templateContainerAri)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const comment = $c3a6d60a3494ed40$var$getCommentState(state, commentId);
        if (comment.inFlightEmojiIds.has(emojiId)) return false;
        const existingReaction = comment.optimisticReactions.find((r)=>r.emojiId === emojiId);
        if (existingReaction?.reacted) return false;
        // Save rollback snapshot
        const nextRollback = new Map(comment.rollbackMap);
        nextRollback.set(emojiId, comment.optimisticReactions);
        // Mark in-flight
        const nextInFlight = new Set(comment.inFlightEmojiIds);
        nextInFlight.add(emojiId);
        let nextReactions;
        if (existingReaction) nextReactions = comment.optimisticReactions.map((r)=>r.emojiId === emojiId ? {
                ...r,
                count: r.count + 1,
                reacted: true
            } : r);
        else nextReactions = [
            ...comment.optimisticReactions,
            {
                ari: templateAri,
                containerAri: templateContainerAri,
                emojiId: emojiId,
                count: 1,
                reacted: true
            }
        ];
        setState({
            commentReactionState: $c3a6d60a3494ed40$var$setCommentState(state, commentId, {
                optimisticReactions: nextReactions,
                rollbackMap: nextRollback,
                inFlightEmojiIds: nextInFlight,
                error: undefined
            })
        });
        return true;
    };
/** Clear in-flight and rollback state for a settled mutation. */ const $c3a6d60a3494ed40$var$onEmojiSettled = (commentId, emojiId)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const comment = $c3a6d60a3494ed40$var$getCommentState(state, commentId);
        const nextInFlight = new Set(comment.inFlightEmojiIds);
        nextInFlight.delete(emojiId);
        const nextRollback = new Map(comment.rollbackMap);
        nextRollback.delete(emojiId);
        setState({
            commentReactionState: $c3a6d60a3494ed40$var$setCommentState(state, commentId, {
                inFlightEmojiIds: nextInFlight,
                rollbackMap: nextRollback
            })
        });
    };
/** Roll back optimistic state on mutation error. */ const $c3a6d60a3494ed40$var$onEmojiMutationError = (commentId, emojiId, error)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const comment = $c3a6d60a3494ed40$var$getCommentState(state, commentId);
        const rollback = comment.rollbackMap.get(emojiId);
        // Clear in-flight and rollback for this emoji
        const nextInFlight = new Set(comment.inFlightEmojiIds);
        nextInFlight.delete(emojiId);
        const nextRollback = new Map(comment.rollbackMap);
        nextRollback.delete(emojiId);
        setState({
            commentReactionState: $c3a6d60a3494ed40$var$setCommentState(state, commentId, {
                optimisticReactions: rollback ?? comment.optimisticReactions,
                inFlightEmojiIds: nextInFlight,
                rollbackMap: nextRollback,
                error: error
            })
        });
    };
/** Remove all state for a comment (call on unmount). */ const $c3a6d60a3494ed40$var$cleanupComment = (commentId)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const { [commentId]: _, ...rest } = state.commentReactionState;
        // Drop any reacted-users freshness entries for this comment's pairs so the
        // registry does not grow unbounded across a long session.
        const keyPrefix = `${commentId}::`;
        let removedStaleness = false;
        const nextStaleness = {};
        for (const [key, value] of Object.entries(state.reactedUsersStaleness)){
            if (key.startsWith(keyPrefix)) {
                removedStaleness = true;
                continue;
            }
            nextStaleness[key] = value;
        }
        setState({
            commentReactionState: rest,
            ...removedStaleness ? {
                reactedUsersStaleness: nextStaleness
            } : {}
        });
    };
/**
 * Record that the reactor list for a comment+emoji pair changed (local mutation
 * or remote pubsub event), bumping its `changed` counter so the next mounted
 * facepile fetcher refetches from the network.
 */ const $c3a6d60a3494ed40$var$markReactedUsersChanged = (commentId, emojiId)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const key = $c3a6d60a3494ed40$export$64e3401c254cca65(commentId, emojiId);
        const current = state.reactedUsersStaleness[key] ?? $c3a6d60a3494ed40$var$DEFAULT_STALENESS;
        setState({
            reactedUsersStaleness: {
                ...state.reactedUsersStaleness,
                [key]: {
                    changed: current.changed + 1,
                    fetched: current.fetched
                }
            }
        });
    };
/**
 * Record that a facepile fetcher has refetched the reactor list for a
 * comment+emoji pair, catching `fetched` up to `changed`. No-ops when already
 * caught up to avoid a redundant re-render.
 */ const $c3a6d60a3494ed40$var$markReactedUsersFetched = (commentId, emojiId)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const key = $c3a6d60a3494ed40$export$64e3401c254cca65(commentId, emojiId);
        const current = state.reactedUsersStaleness[key];
        if (!current || current.fetched === current.changed) return;
        setState({
            reactedUsersStaleness: {
                ...state.reactedUsersStaleness,
                [key]: {
                    changed: current.changed,
                    fetched: current.changed
                }
            }
        });
    };
/**
 * Apply a remote pubsub delta (add or remove) from another user.
 *
 * On +1: increment the existing emoji count, or create a new entry with
 *        count=1 and reacted=false if it doesn't exist yet.
 * On -1: decrement the count, removing the entry if it reaches zero.
 *        No-ops if the comment has no state yet (nothing to decrement).
 */ const $c3a6d60a3494ed40$var$applyRemoteDelta = (commentId, emojiId, delta, templateAri = '', templateContainerAri = '')=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const comment = $c3a6d60a3494ed40$var$getCommentState(state, commentId);
        const existing = comment.optimisticReactions.find((r)=>r.emojiId === emojiId);
        let nextReactions;
        if (delta === 1) {
            if (existing) // Increment existing entry, preserve `reacted` (current user's state)
            nextReactions = comment.optimisticReactions.map((r)=>r.emojiId === emojiId ? {
                    ...r,
                    count: r.count + 1
                } : r);
            else {
                // If this comment has no store entry yet, skip writing: persisting a new
                // CommentReactionState here would create a leaked record (ari: '', containerAri: '')
                // for a comment that is not currently mounted. syncServerReactions will provide
                // authoritative state when the component does mount and refetches.
                if (state.commentReactionState[commentId] === undefined) return;
                // Create a new entry - 'reacted' is false since this is a remote user's reaction
                nextReactions = [
                    ...comment.optimisticReactions,
                    {
                        ari: templateAri,
                        containerAri: templateContainerAri,
                        emojiId: emojiId,
                        count: 1,
                        reacted: false
                    }
                ];
            }
        } else {
            // delta === -1
            if (!existing) // No emoji found in store - nothing to decrement
            return;
            const newCount = existing.count - 1;
            if (newCount <= 0) nextReactions = comment.optimisticReactions.filter((r)=>r.emojiId !== emojiId);
            else nextReactions = comment.optimisticReactions.map((r)=>r.emojiId === emojiId ? {
                    ...r,
                    count: newCount
                } : r);
        }
        setState({
            commentReactionState: $c3a6d60a3494ed40$var$setCommentState(state, commentId, {
                optimisticReactions: nextReactions
            })
        });
    };
const $c3a6d60a3494ed40$var$actions = {
    registerOpener: $c3a6d60a3494ed40$var$registerOpener,
    triggerOpen: $c3a6d60a3494ed40$var$triggerOpen,
    openPicker: $c3a6d60a3494ed40$var$openPicker,
    closePicker: $c3a6d60a3494ed40$var$closePicker,
    addOptimisticReaction: $c3a6d60a3494ed40$var$addOptimisticReaction,
    pruneOptimisticReactions: $c3a6d60a3494ed40$var$pruneOptimisticReactions,
    addOptimisticResolvedMarkerRef: $c3a6d60a3494ed40$var$addOptimisticResolvedMarkerRef,
    removeOptimisticResolvedMarkerRef: $c3a6d60a3494ed40$var$removeOptimisticResolvedMarkerRef,
    pruneOptimisticResolvedMarkerRefs: $c3a6d60a3494ed40$var$pruneOptimisticResolvedMarkerRefs,
    addOptimisticDeletedMarkerRef: $c3a6d60a3494ed40$var$addOptimisticDeletedMarkerRef,
    pruneOptimisticDeletedMarkerRefs: $c3a6d60a3494ed40$var$pruneOptimisticDeletedMarkerRefs,
    syncServerReactions: $c3a6d60a3494ed40$var$syncServerReactions,
    applyOptimisticToggle: $c3a6d60a3494ed40$var$applyOptimisticToggle,
    applyOptimisticAdd: $c3a6d60a3494ed40$var$applyOptimisticAdd,
    onEmojiSettled: $c3a6d60a3494ed40$var$onEmojiSettled,
    onEmojiMutationError: $c3a6d60a3494ed40$var$onEmojiMutationError,
    cleanupComment: $c3a6d60a3494ed40$var$cleanupComment,
    applyRemoteDelta: $c3a6d60a3494ed40$var$applyRemoteDelta,
    markReactedUsersChanged: $c3a6d60a3494ed40$var$markReactedUsersChanged,
    markReactedUsersFetched: $c3a6d60a3494ed40$var$markReactedUsersFetched
};
const $c3a6d60a3494ed40$export$6f57813fe9f31bf9 = (0, $8s9DV.createStore)({
    initialState: $c3a6d60a3494ed40$var$initialState,
    actions: $c3a6d60a3494ed40$var$actions,
    name: 'inlineReactionStore'
});
const $c3a6d60a3494ed40$export$4bea784acc47afc0 = (0, $kBr4q.createActionsHook)($c3a6d60a3494ed40$export$6f57813fe9f31bf9);
const $c3a6d60a3494ed40$export$95648a16d8bcb2ae = (0, $kBr4q.createStateHook)($c3a6d60a3494ed40$export$6f57813fe9f31bf9, {
    selector: (state)=>state.picker
});
const $c3a6d60a3494ed40$export$a2df1890187165d2 = (0, $kBr4q.createStateHook)($c3a6d60a3494ed40$export$6f57813fe9f31bf9, {
    selector: (state)=>state.optimisticReactionMarkerMap
});
function $c3a6d60a3494ed40$export$8adad8a188e9f237() {
    return (0, $c6StJ.defaultRegistry).getStore($c3a6d60a3494ed40$export$6f57813fe9f31bf9).storeState.getState().optimisticReactionMarkerMap;
}
function $c3a6d60a3494ed40$export$ff40a497e226daf7(markerRef) {
    return (0, $c6StJ.defaultRegistry).getStore($c3a6d60a3494ed40$export$6f57813fe9f31bf9).storeState.getState().optimisticResolvedMarkerRefs.has(markerRef);
}
function $c3a6d60a3494ed40$export$e0bbeb963dd9ccf1(markerRef) {
    (0, $c6StJ.defaultRegistry).getStore($c3a6d60a3494ed40$export$6f57813fe9f31bf9).actions.addOptimisticDeletedMarkerRef(markerRef);
}
const $c3a6d60a3494ed40$export$acabd5c13c46827c = (0, $kBr4q.createStateHook)($c3a6d60a3494ed40$export$6f57813fe9f31bf9, {
    selector: (state)=>state.optimisticResolvedMarkerRefs
});
const $c3a6d60a3494ed40$export$15ea3ad646d59eec = (0, $kBr4q.createStateHook)($c3a6d60a3494ed40$export$6f57813fe9f31bf9, {
    selector: (state)=>state.optimisticDeletedMarkerRefs
});
const $c3a6d60a3494ed40$export$c2b73a32145e6e04 = (0, $kBr4q.createStateHook)($c3a6d60a3494ed40$export$6f57813fe9f31bf9, {
    selector: (state, commentId)=>state.commentReactionState[commentId] ?? $c3a6d60a3494ed40$var$defaultCommentState
});
const $c3a6d60a3494ed40$export$2b46bd66d45480ef = (0, $kBr4q.createStateHook)($c3a6d60a3494ed40$export$6f57813fe9f31bf9, {
    selector: (state, pairKey)=>state.reactedUsersStaleness[pairKey] ?? $c3a6d60a3494ed40$var$DEFAULT_STALENESS
});
function $c3a6d60a3494ed40$export$20c2e9914ef136a5(pairKey) {
    return (0, $c6StJ.defaultRegistry).getStore($c3a6d60a3494ed40$export$6f57813fe9f31bf9).storeState.getState().reactedUsersStaleness[pairKey] ?? $c3a6d60a3494ed40$var$DEFAULT_STALENESS;
}
module.exports["reactedUsersPairKey"] = $c3a6d60a3494ed40$export$64e3401c254cca65;
module.exports["useInlineReactionActions"] = $c3a6d60a3494ed40$export$4bea784acc47afc0;
module.exports["useInlineReactionPicker"] = $c3a6d60a3494ed40$export$95648a16d8bcb2ae;
module.exports["useOptimisticReactionMarkerMap"] = $c3a6d60a3494ed40$export$a2df1890187165d2;
module.exports["getOptimisticReactionMarkerMap"] = $c3a6d60a3494ed40$export$8adad8a188e9f237;
module.exports["isOptimisticallyResolvedMarkerRef"] = $c3a6d60a3494ed40$export$ff40a497e226daf7;
module.exports["markOptimisticDeletedMarkerRef"] = $c3a6d60a3494ed40$export$e0bbeb963dd9ccf1;
module.exports["useOptimisticResolvedMarkerRefs"] = $c3a6d60a3494ed40$export$acabd5c13c46827c;
module.exports["useOptimisticDeletedMarkerRefs"] = $c3a6d60a3494ed40$export$15ea3ad646d59eec;
module.exports["useCommentReactionState"] = $c3a6d60a3494ed40$export$c2b73a32145e6e04;
module.exports["useReactedUsersStaleness"] = $c3a6d60a3494ed40$export$2b46bd66d45480ef;
module.exports["getReactedUsersStaleness"] = $c3a6d60a3494ed40$export$20c2e9914ef136a5;

});

parcelRegister("2j0AL", function(module, exports) {
'use strict';
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});

parcelRegister("1PPDm", function(module, exports) {
"use strict";
var $15629b4bdedac47d$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $hmcLb = parcelRequire("hmcLb");


var $863V0 = parcelRequire("863V0");

/**
 * Catches errors on the observable to be handled by returning a new observable or throwing an error.
 *
 * <img src="./img/catch.png" width="100%">
 *
 * @example <caption>Continues with a different Observable when there's an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n == 4) {
 * 	     throw 'four!';
 *     }
 *	   return n;
 *   })
 *   .catch(err => Observable.of('I', 'II', 'III', 'IV', 'V'))
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, I, II, III, IV, V
 *
 * @example <caption>Retries the caught source Observable again in case of error, similar to retry() operator</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n === 4) {
 * 	     throw 'four!';
 *     }
 * 	   return n;
 *   })
 *   .catch((err, caught) => caught)
 *   .take(30)
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, 1, 2, 3, ...
 *
 * @example <caption>Throws a new error when the source Observable throws an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 *     if (n == 4) {
 *       throw 'four!';
 *     }
 *     return n;
 *   })
 *   .catch(err => {
 *     throw 'error in source. Details: ' + err;
 *   })
 *   .subscribe(
 *     x => console.log(x),
 *     err => console.log(err)
 *   );
 *   // 1, 2, 3, error in source. Details: four!
 *
 * @param {function} selector a function that takes as arguments `err`, which is the error, and `caught`, which
 *  is the source observable, in case you'd like to "retry" that observable by returning it again. Whatever observable
 *  is returned by the `selector` will be used to continue the observable chain.
 * @return {Observable} An observable that originates from either the source or the observable returned by the
 *  catch `selector` function.
 * @name catchError
 */ function $15629b4bdedac47d$var$catchError(selector) {
    return function catchErrorOperatorFunction(source) {
        var operator = new $15629b4bdedac47d$var$CatchOperator(selector);
        var caught = source.lift(operator);
        return operator.caught = caught;
    };
}
module.exports.catchError = $15629b4bdedac47d$var$catchError;
var $15629b4bdedac47d$var$CatchOperator = function() {
    function CatchOperator(selector) {
        this.selector = selector;
    }
    CatchOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $15629b4bdedac47d$var$CatchSubscriber(subscriber, this.selector, this.caught));
    };
    return CatchOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $15629b4bdedac47d$var$CatchSubscriber = function(_super) {
    $15629b4bdedac47d$var$__extends(CatchSubscriber, _super);
    function CatchSubscriber(destination, selector, caught) {
        _super.call(this, destination);
        this.selector = selector;
        this.caught = caught;
    }
    // NOTE: overriding `error` instead of `_error` because we don't want
    // to have this flag this subscriber as `isStopped`. We can mimic the
    // behavior of the RetrySubscriber (from the `retry` operator), where
    // we unsubscribe from our source chain, reset our Subscriber flags,
    // then subscribe to the selector result.
    CatchSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var result = void 0;
            try {
                result = this.selector(err, this.caught);
            } catch (err2) {
                _super.prototype.error.call(this, err2);
                return;
            }
            this._unsubscribeAndRecycle();
            this.add($863V0.subscribeToResult(this, result));
        }
    };
    return CatchSubscriber;
}($hmcLb.OuterSubscriber); //# sourceMappingURL=catchError.js.map

});

parcelRegister("1xJn2", function(module, exports) {
"use strict";
var $11fc112c79ff43c4$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");


var $aRdp2 = parcelRequire("aRdp2");


var $iMtch = parcelRequire("iMtch");

/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item.
 *
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 *
 * If a comparator function is not provided, an equality check is used by default.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 1, 2, 3, 3, 4)
 *   .distinctUntilChanged()
 *   .subscribe(x => console.log(x)); // 1, 2, 1, 2, 3, 4
 *
 * @example <caption>An example using a compare function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     { age: 6, name: 'Foo'})
 *     .distinctUntilChanged((p: Person, q: Person) => p.name === q.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo' }
 *
 * @see {@link distinct}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinctUntilChanged
 * @owner Observable
 */ function $11fc112c79ff43c4$var$distinctUntilChanged(compare, keySelector) {
    return function(source) {
        return source.lift(new $11fc112c79ff43c4$var$DistinctUntilChangedOperator(compare, keySelector));
    };
}
module.exports.distinctUntilChanged = $11fc112c79ff43c4$var$distinctUntilChanged;
var $11fc112c79ff43c4$var$DistinctUntilChangedOperator = function() {
    function DistinctUntilChangedOperator(compare, keySelector) {
        this.compare = compare;
        this.keySelector = keySelector;
    }
    DistinctUntilChangedOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $11fc112c79ff43c4$var$DistinctUntilChangedSubscriber(subscriber, this.compare, this.keySelector));
    };
    return DistinctUntilChangedOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $11fc112c79ff43c4$var$DistinctUntilChangedSubscriber = function(_super) {
    $11fc112c79ff43c4$var$__extends(DistinctUntilChangedSubscriber, _super);
    function DistinctUntilChangedSubscriber(destination, compare, keySelector) {
        _super.call(this, destination);
        this.keySelector = keySelector;
        this.hasKey = false;
        if (typeof compare === 'function') this.compare = compare;
    }
    DistinctUntilChangedSubscriber.prototype.compare = function(x, y) {
        return x === y;
    };
    DistinctUntilChangedSubscriber.prototype._next = function(value) {
        var keySelector = this.keySelector;
        var key = value;
        if (keySelector) {
            key = $aRdp2.tryCatch(this.keySelector)(value);
            if (key === $iMtch.errorObject) return this.destination.error($iMtch.errorObject.e);
        }
        var result = false;
        if (this.hasKey) {
            result = $aRdp2.tryCatch(this.compare)(this.key, key);
            if (result === $iMtch.errorObject) return this.destination.error($iMtch.errorObject.e);
        } else this.hasKey = true;
        if (Boolean(result) === false) {
            this.key = key;
            this.destination.next(value);
        }
    };
    return DistinctUntilChangedSubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=distinctUntilChanged.js.map

});

parcelRegister("ebEo2", function(module, exports) {
"use strict";
var $a5416bba69d7cff3$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");

/**
 * Returns an Observable that skips all items emitted by the source Observable as long as a specified condition holds
 * true, but emits all further source items as soon as the condition becomes false.
 *
 * <img src="./img/skipWhile.png" width="100%">
 *
 * @param {Function} predicate - A function to test each item emitted from the source Observable.
 * @return {Observable<T>} An Observable that begins emitting items emitted by the source Observable when the
 * specified predicate becomes false.
 * @method skipWhile
 * @owner Observable
 */ function $a5416bba69d7cff3$var$skipWhile(predicate) {
    return function(source) {
        return source.lift(new $a5416bba69d7cff3$var$SkipWhileOperator(predicate));
    };
}
module.exports.skipWhile = $a5416bba69d7cff3$var$skipWhile;
var $a5416bba69d7cff3$var$SkipWhileOperator = function() {
    function SkipWhileOperator(predicate) {
        this.predicate = predicate;
    }
    SkipWhileOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $a5416bba69d7cff3$var$SkipWhileSubscriber(subscriber, this.predicate));
    };
    return SkipWhileOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $a5416bba69d7cff3$var$SkipWhileSubscriber = function(_super) {
    $a5416bba69d7cff3$var$__extends(SkipWhileSubscriber, _super);
    function SkipWhileSubscriber(destination, predicate) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.skipping = true;
        this.index = 0;
    }
    SkipWhileSubscriber.prototype._next = function(value) {
        var destination = this.destination;
        if (this.skipping) this.tryCallPredicate(value);
        if (!this.skipping) destination.next(value);
    };
    SkipWhileSubscriber.prototype.tryCallPredicate = function(value) {
        try {
            var result = this.predicate(value, this.index++);
            this.skipping = Boolean(result);
        } catch (err) {
            this.destination.error(err);
        }
    };
    return SkipWhileSubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=skipWhile.js.map

});

parcelRegister("c7Xul", function(module, exports) {
"use strict";
var $8d4448aad9d90f95$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $hmcLb = parcelRequire("hmcLb");


var $863V0 = parcelRequire("863V0");

/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable, emitting values only from the most recently projected Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link switch}.</span>
 *
 * <img src="./img/switchMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each time it observes one of these
 * inner Observables, the output Observable begins emitting the items emitted by
 * that inner Observable. When a new inner Observable is emitted, `switchMap`
 * stops emitting items from the earlier-emitted inner Observable and begins
 * emitting items from the new one. It continues to behave like this for
 * subsequent inner Observables.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.switchMap((ev) => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switch}
 * @see {@link switchMapTo}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking only the values from the most recently
 * projected inner Observable.
 * @method switchMap
 * @owner Observable
 */ function $8d4448aad9d90f95$var$switchMap(project, resultSelector) {
    return function switchMapOperatorFunction(source) {
        return source.lift(new $8d4448aad9d90f95$var$SwitchMapOperator(project, resultSelector));
    };
}
module.exports.switchMap = $8d4448aad9d90f95$var$switchMap;
var $8d4448aad9d90f95$var$SwitchMapOperator = function() {
    function SwitchMapOperator(project, resultSelector) {
        this.project = project;
        this.resultSelector = resultSelector;
    }
    SwitchMapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $8d4448aad9d90f95$var$SwitchMapSubscriber(subscriber, this.project, this.resultSelector));
    };
    return SwitchMapOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $8d4448aad9d90f95$var$SwitchMapSubscriber = function(_super) {
    $8d4448aad9d90f95$var$__extends(SwitchMapSubscriber, _super);
    function SwitchMapSubscriber(destination, project, resultSelector) {
        _super.call(this, destination);
        this.project = project;
        this.resultSelector = resultSelector;
        this.index = 0;
    }
    SwitchMapSubscriber.prototype._next = function(value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        } catch (error) {
            this.destination.error(error);
            return;
        }
        this._innerSub(result, value, index);
    };
    SwitchMapSubscriber.prototype._innerSub = function(result, value, index) {
        var innerSubscription = this.innerSubscription;
        if (innerSubscription) innerSubscription.unsubscribe();
        this.add(this.innerSubscription = $863V0.subscribeToResult(this, result, value, index));
    };
    SwitchMapSubscriber.prototype._complete = function() {
        var innerSubscription = this.innerSubscription;
        if (!innerSubscription || innerSubscription.closed) _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ SwitchMapSubscriber.prototype._unsubscribe = function() {
        this.innerSubscription = null;
    };
    SwitchMapSubscriber.prototype.notifyComplete = function(innerSub) {
        this.remove(innerSub);
        this.innerSubscription = null;
        if (this.isStopped) _super.prototype._complete.call(this);
    };
    SwitchMapSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (this.resultSelector) this._tryNotifyNext(outerValue, innerValue, outerIndex, innerIndex);
        else this.destination.next(innerValue);
    };
    SwitchMapSubscriber.prototype._tryNotifyNext = function(outerValue, innerValue, outerIndex, innerIndex) {
        var result;
        try {
            result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return SwitchMapSubscriber;
}($hmcLb.OuterSubscriber); //# sourceMappingURL=switchMap.js.map

});

parcelRegister("1mLOG", function(module, exports) {
"use strict";
var $0fecefdacae1f75b$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");


var $zAMIg = parcelRequire("zAMIg");

function $0fecefdacae1f75b$var$timeInterval(scheduler) {
    if (scheduler === void 0) scheduler = $zAMIg.async;
    return function(source) {
        return source.lift(new $0fecefdacae1f75b$var$TimeIntervalOperator(scheduler));
    };
}
module.exports.timeInterval = $0fecefdacae1f75b$var$timeInterval;
var $0fecefdacae1f75b$var$TimeInterval = function() {
    function TimeInterval(value, interval) {
        this.value = value;
        this.interval = interval;
    }
    return TimeInterval;
}();
module.exports.TimeInterval = $0fecefdacae1f75b$var$TimeInterval;
var $0fecefdacae1f75b$var$TimeIntervalOperator = function() {
    function TimeIntervalOperator(scheduler) {
        this.scheduler = scheduler;
    }
    TimeIntervalOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $0fecefdacae1f75b$var$TimeIntervalSubscriber(observer, this.scheduler));
    };
    return TimeIntervalOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $0fecefdacae1f75b$var$TimeIntervalSubscriber = function(_super) {
    $0fecefdacae1f75b$var$__extends(TimeIntervalSubscriber, _super);
    function TimeIntervalSubscriber(destination, scheduler) {
        _super.call(this, destination);
        this.scheduler = scheduler;
        this.lastTime = 0;
        this.lastTime = scheduler.now();
    }
    TimeIntervalSubscriber.prototype._next = function(value) {
        var now = this.scheduler.now();
        var span = now - this.lastTime;
        this.lastTime = now;
        this.destination.next(new $0fecefdacae1f75b$var$TimeInterval(value, span));
    };
    return TimeIntervalSubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=timeInterval.js.map

});

parcelRegister("cmyqT", function(module, exports) {
"use strict";
var $90023fbe608f4f3c$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $zAMIg = parcelRequire("zAMIg");


var $fEWBj = parcelRequire("fEWBj");


var $fNVRJ = parcelRequire("fNVRJ");


var $a6ieS = parcelRequire("a6ieS");

/**
 *
 * Errors if Observable does not emit a value in given time span.
 *
 * <span class="informal">Timeouts on Observable that doesn't emit values fast enough.</span>
 *
 * <img src="./img/timeout.png" width="100%">
 *
 * `timeout` operator accepts as an argument either a number or a Date.
 *
 * If number was provided, it returns an Observable that behaves like a source
 * Observable, unless there is a period of time where there is no value emitted.
 * So if you provide `100` as argument and first value comes after 50ms from
 * the moment of subscription, this value will be simply re-emitted by the resulting
 * Observable. If however after that 100ms passes without a second value being emitted,
 * stream will end with an error and source Observable will be unsubscribed.
 * These checks are performed throughout whole lifecycle of Observable - from the moment
 * it was subscribed to, until it completes or errors itself. Thus every value must be
 * emitted within specified period since previous value.
 *
 * If provided argument was Date, returned Observable behaves differently. It throws
 * if Observable did not complete before provided Date. This means that periods between
 * emission of particular values do not matter in this case. If Observable did not complete
 * before provided Date, source Observable will be unsubscribed. Other than that, resulting
 * stream behaves just as source Observable.
 *
 * `timeout` accepts also a Scheduler as a second parameter. It is used to schedule moment (or moments)
 * when returned Observable will check if source stream emitted value or completed.
 *
 * @example <caption>Check if ticks are emitted within certain timespan</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(1100) // Let's use bigger timespan to be safe,
 *                       // since `interval` might fire a bit later then scheduled.
 * .subscribe(
 *     value => console.log(value), // Will emit numbers just as regular `interval` would.
 *     err => console.log(err) // Will never be called.
 * );
 *
 * seconds.timeout(900).subscribe(
 *     value => console.log(value), // Will never be called.
 *     err => console.log(err) // Will emit error before even first value is emitted,
 *                             // since it did not arrive within 900ms period.
 * );
 *
 * @example <caption>Use Date to check if Observable completed</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(new Date("December 17, 2020 03:24:00"))
 * .subscribe(
 *     value => console.log(value), // Will emit values as regular `interval` would
 *                                  // until December 17, 2020 at 03:24:00.
 *     err => console.log(err) // On December 17, 2020 at 03:24:00 it will emit an error,
 *                             // since Observable did not complete by then.
 * );
 *
 * @see {@link timeoutWith}
 *
 * @param {number|Date} due Number specifying period within which Observable must emit values
 *                          or Date specifying before when Observable should complete
 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
 * @return {Observable<T>} Observable that mirrors behaviour of source, unless timeout checks fail.
 * @method timeout
 * @owner Observable
 */ function $90023fbe608f4f3c$var$timeout(due, scheduler) {
    if (scheduler === void 0) scheduler = $zAMIg.async;
    var absoluteTimeout = $fEWBj.isDate(due);
    var waitFor = absoluteTimeout ? +due - scheduler.now() : Math.abs(due);
    return function(source) {
        return source.lift(new $90023fbe608f4f3c$var$TimeoutOperator(waitFor, absoluteTimeout, scheduler, new $a6ieS.TimeoutError()));
    };
}
module.exports.timeout = $90023fbe608f4f3c$var$timeout;
var $90023fbe608f4f3c$var$TimeoutOperator = function() {
    function TimeoutOperator(waitFor, absoluteTimeout, scheduler, errorInstance) {
        this.waitFor = waitFor;
        this.absoluteTimeout = absoluteTimeout;
        this.scheduler = scheduler;
        this.errorInstance = errorInstance;
    }
    TimeoutOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $90023fbe608f4f3c$var$TimeoutSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.scheduler, this.errorInstance));
    };
    return TimeoutOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $90023fbe608f4f3c$var$TimeoutSubscriber = function(_super) {
    $90023fbe608f4f3c$var$__extends(TimeoutSubscriber, _super);
    function TimeoutSubscriber(destination, absoluteTimeout, waitFor, scheduler, errorInstance) {
        _super.call(this, destination);
        this.absoluteTimeout = absoluteTimeout;
        this.waitFor = waitFor;
        this.scheduler = scheduler;
        this.errorInstance = errorInstance;
        this.action = null;
        this.scheduleTimeout();
    }
    TimeoutSubscriber.dispatchTimeout = function(subscriber) {
        subscriber.error(subscriber.errorInstance);
    };
    TimeoutSubscriber.prototype.scheduleTimeout = function() {
        var action = this.action;
        if (action) // Recycle the action if we've already scheduled one. All the production
        // Scheduler Actions mutate their state/delay time and return themeselves.
        // VirtualActions are immutable, so they create and return a clone. In this
        // case, we need to set the action reference to the most recent VirtualAction,
        // to ensure that's the one we clone from next time.
        this.action = action.schedule(this, this.waitFor);
        else this.add(this.action = this.scheduler.schedule(TimeoutSubscriber.dispatchTimeout, this.waitFor, this));
    };
    TimeoutSubscriber.prototype._next = function(value) {
        if (!this.absoluteTimeout) this.scheduleTimeout();
        _super.prototype._next.call(this, value);
    };
    /** @deprecated internal use only */ TimeoutSubscriber.prototype._unsubscribe = function() {
        this.action = null;
        this.scheduler = null;
        this.errorInstance = null;
    };
    return TimeoutSubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=timeout.js.map

});

parcelRegister("a6ieS", function(module, exports) {
"use strict";
var $75a89ccb17a412ff$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when duetime elapses.
 *
 * @see {@link timeout}
 *
 * @class TimeoutError
 */ var $75a89ccb17a412ff$var$TimeoutError = function(_super) {
    $75a89ccb17a412ff$var$__extends(TimeoutError, _super);
    function TimeoutError() {
        var err = _super.call(this, 'Timeout has occurred');
        this.name = err.name = 'TimeoutError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return TimeoutError;
}(Error);
module.exports.TimeoutError = $75a89ccb17a412ff$var$TimeoutError; //# sourceMappingURL=TimeoutError.js.map

});

parcelRegister("4Otfs", function(module, exports) {
"use strict";
var $3812850d794e9fac$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $gGP9M = parcelRequire("gGP9M");


var $371EO = parcelRequire("371EO");

/**
 * @class BehaviorSubject<T>
 */ var $3812850d794e9fac$var$BehaviorSubject = function(_super) {
    $3812850d794e9fac$var$__extends(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        _super.call(this);
        this._value = _value;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function() {
            return this.getValue();
        },
        enumerable: true,
        configurable: true
    });
    /** @deprecated internal use only */ BehaviorSubject.prototype._subscribe = function(subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        if (subscription && !subscription.closed) subscriber.next(this._value);
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function() {
        if (this.hasError) throw this.thrownError;
        else if (this.closed) throw new $371EO.ObjectUnsubscribedError();
        else return this._value;
    };
    BehaviorSubject.prototype.next = function(value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}($gGP9M.Subject);
module.exports.BehaviorSubject = $3812850d794e9fac$var$BehaviorSubject; //# sourceMappingURL=BehaviorSubject.js.map

});

parcelRegister("hpFQM", function(module, exports) {
var $5a473958e6bef57b$export$e20550b618a28239 = /*#__PURE__*/ function(NLPSearchResultFormat) {
    NLPSearchResultFormat["PLAINTEXT"] = "PLAIN_TEXT";
    NLPSearchResultFormat["ADF"] = "ADF";
    NLPSearchResultFormat["JSON"] = "JSON";
    NLPSearchResultFormat["MARKDOWN"] = "MARKDOWN";
    return NLPSearchResultFormat;
}({});
module.exports["NLPSearchResultFormat"] = $5a473958e6bef57b$export$e20550b618a28239;

});

parcelRegister("1a6Dn", function(module, exports) {

var $hrAmX = parcelRequire("hrAmX");


var $a4dgs = parcelRequire("a4dgs");

class $d3905c2d386f370c$export$c59406a16f2704a5 extends (0, $a4dgs.BaseStateContainer) {
    constructor(...args){
        super(...args);
        this.state = {
            floatingBanners: []
        };
        this.showFloating = (name, height)=>{
            // The lookup has to happen inside the updater: updates queued in the same microtask are
            // applied in sequence, so an index resolved beforehand would already be stale.
            this.setState((state)=>{
                const index = (0, $hrAmX.findBanner)(name, state.floatingBanners);
                if (index === -1) return {
                    ...state,
                    floatingBanners: [
                        ...state.floatingBanners,
                        {
                            name: name,
                            height: height
                        }
                    ]
                };
                if (state.floatingBanners[index].height !== height) {
                    const newArray = [
                        ...state.floatingBanners
                    ];
                    // Replace rather than mutate, so the previous state keeps the old height.
                    newArray[index] = {
                        name: name,
                        height: height
                    };
                    return {
                        ...state,
                        floatingBanners: newArray
                    };
                }
                return undefined;
            });
        };
        this.hideFloating = (name)=>{
            this.setState((state)=>{
                const index = (0, $hrAmX.findBanner)(name, state.floatingBanners);
                if (index > -1) {
                    const newArray = [
                        ...state.floatingBanners
                    ];
                    newArray.splice(index, 1);
                    return {
                        ...state,
                        floatingBanners: newArray
                    };
                }
                return undefined;
            });
        };
        this.getFloatingHeightBefore = (name)=>{
            const index = (0, $hrAmX.findBanner)(name, this.state.floatingBanners);
            if (index === -1) return 0;
            return this.state.floatingBanners.slice(0, index).reduce((height, banner)=>{
                return height + banner.height;
            }, 0);
        };
        this.getFloatingHeight = ()=>this.state.floatingBanners.reduce((height, banner)=>height + banner.height, 0);
    }
}
module.exports["FloatingBannerStateContainer"] = $d3905c2d386f370c$export$c59406a16f2704a5;

});

parcelRegister("5kjCz", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $irVI7 = parcelRequire("irVI7");


var $glCMv = parcelRequire("glCMv");


var $fGzMp = parcelRequire("fGzMp");


var $kmyYx = parcelRequire("kmyYx");


var $aJPUt = parcelRequire("aJPUt");


var $04e9M = parcelRequire("04e9M");


var $78QFu = parcelRequire("78QFu");


var $9Cbhx = parcelRequire("9Cbhx");

const $44f37a86f8c1409e$export$c3c3c3f81a03570c = 'renderer';
const $44f37a86f8c1409e$export$e70b8cd540123fd4 = 'editor';
const $44f37a86f8c1409e$export$f783453b83c906eb = 'pdf';
const $44f37a86f8c1409e$var$ACTION = {
    SUCCESS: 'taskSuccess',
    FAIL: 'taskFail',
    ABORT: 'taskAbort',
    START: 'taskStart'
};
const $44f37a86f8c1409e$export$84a4de0ef6621278 = (name)=>name.split('.').slice(1).join('.');
const $44f37a86f8c1409e$export$b94fa6ed199caed2 = (macroEventRegister = new Map())=>{
    const macros = [];
    // @ts-ignore
    for (const v of macroEventRegister.values()){
        const { name: name } = v;
        if (name !== (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE)) {
            const macro = {
                uniqueHash: $44f37a86f8c1409e$export$84a4de0ef6621278(name),
                ...$44f37a86f8c1409e$export$ae13022b12e7d19a(v)
            };
            macros.push(macro);
        }
    }
    return macros;
};
const $44f37a86f8c1409e$export$c1196ba2be68e8d3 = (macro)=>{
    return {
        type: macro?.type || '',
        macroId: (0, $9Cbhx.getMacroId)(macro?.parameters),
        extensionKey: (0, $9Cbhx.getExtensionKey)(macro),
        extensionType: macro?.extensionType || ''
    };
};
const $44f37a86f8c1409e$export$ae13022b12e7d19a = (macroEvent)=>{
    return {
        extensionKey: (0, $9Cbhx.getExtensionKey)(macroEvent?.experienceAttributes),
        extensionType: macroEvent?.experienceAttributes?.extensionType || '',
        type: macroEvent?.experienceAttributes?.type || '',
        macroId: macroEvent?.experienceAttributes?.macroId || '',
        duration: macroEvent?.duration || '',
        status: macroEvent?.status || '',
        pageId: macroEvent?.pageId || ''
    };
};
const $44f37a86f8c1409e$export$b16b3cab64ff0bd4 = (mode, contentId)=>{
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    if (macroEventRegister.has(contentId)) return;
    $44f37a86f8c1409e$export$f7c63e38d5d9fd0b(mode, contentId).start({
        attributes: {
            mode: mode
        },
        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD,
        id: contentId
    });
};
const $44f37a86f8c1409e$export$f9ebd83e8406755f = (mode, contentId)=>{
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    if (macroEventRegister.has(contentId)) {
        if ($44f37a86f8c1409e$export$d693932e457c5586(macroEventRegister)) {
            const macroAttributes = {
                mode: mode,
                macros: null
            };
            if ($44f37a86f8c1409e$export$375cf77d729480fb(macroEventRegister)) macroAttributes.macros = $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister);
            (0, $fGzMp.getExperienceTracker)().succeed({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                attributes: {
                    ...macroAttributes
                }
            });
        } else (0, $fGzMp.getExperienceTracker)().abort({
            name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
            reason: `Some macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`,
            attributes: {
                macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                mode: mode
            }
        });
        const jiraMacro = $44f37a86f8c1409e$export$32db3a6a0c8b81ea(macroEventRegister);
        jiraMacro.forEach((macro)=>{
            const extensionKey = (0, $9Cbhx.getExtensionKey)(macro.experienceAttributes);
            const status = macro.status;
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: status,
                    attributes: {
                        ...macro.experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`
                    }
                });
            });
        });
        // clean up after aborting all event
        macroEventRegister.clear();
        $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
    }
};
const $44f37a86f8c1409e$export$d693932e457c5586 = (eventRegister = new Map())=>{
    if (eventRegister.size === 0) return true;
    // only check whether all sub-experience has finished
    // @ts-ignore
    for (const v of eventRegister.values()){
        if (v.name !== (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE) && v.status !== $44f37a86f8c1409e$var$ACTION.SUCCESS) return false;
    }
    return true;
};
const $44f37a86f8c1409e$export$375cf77d729480fb = (eventRegister = new Map())=>{
    // @ts-ignore
    for (const v of eventRegister.values()){
        if (v.name !== (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE)) return true;
    }
    return false;
};
const $44f37a86f8c1409e$export$faf154bb66b40b64 = (name)=>name.includes((0, $9Cbhx.JIRA_EXTENSION_KEY));
const $44f37a86f8c1409e$export$f2ada44de4a33ea1 = (eventRegister)=>{
    const macros = [];
    // Type 'IterableIterator<[string, MacroExperienceAttribute]>' is not an array type
    // or a string type. Use compiler option '--downlevelIteration'
    // to allow iterating of iterators
    // @ts-ignore
    for (const v of eventRegister.values())if ($44f37a86f8c1409e$export$faf154bb66b40b64(v.name) && v.status !== $44f37a86f8c1409e$var$ACTION.SUCCESS) macros.push(v);
    return macros;
};
const $44f37a86f8c1409e$export$32db3a6a0c8b81ea = (eventRegister)=>{
    const macros = [];
    // Type 'IterableIterator<[string, MacroExperienceAttribute]>' is not an array type
    // or a string type. Use compiler option '--downlevelIteration'
    // to allow iterating of iterators
    // @ts-ignore
    for (const v of eventRegister.values())if ($44f37a86f8c1409e$export$faf154bb66b40b64(v.name)) macros.push(v);
    return macros;
};
const $44f37a86f8c1409e$export$98d7b4463a1de442 = (contentId, mode)=>{
    (function macroTimeout() {
        setTimeout(()=>{
            const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
            if (!macroEventRegister.has(contentId)) return;
            const pageEvent = macroEventRegister.get(contentId);
            const isTimedOut = Math.round(window.performance.now() - pageEvent.startTime) > (0, $aJPUt.ExperienceTimeout).MACRO_LOAD;
            // 1. all macro loaded or main-experience timeout and have sub-experience
            //    succeed the main experience and report to experience tracker and done
            if ($44f37a86f8c1409e$export$d693932e457c5586(macroEventRegister) && $44f37a86f8c1409e$export$375cf77d729480fb(macroEventRegister)) (0, $fGzMp.getExperienceTracker)().succeed({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                attributes: {
                    macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                    mode: mode
                }
            });
            else if (isTimedOut) {
                // 2a. timeout does not has sub-experience, succeed the main experience
                if (!$44f37a86f8c1409e$export$375cf77d729480fb(macroEventRegister)) (0, $fGzMp.getExperienceTracker)().succeed({
                    name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                    attributes: {
                        mode: mode
                    }
                });
                else {
                    (0, $fGzMp.getExperienceTracker)().abort({
                        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                        reason: `Some macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`,
                        attributes: {
                            macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                            mode: mode
                        }
                    });
                    const unsuceededJIRAMacro = $44f37a86f8c1409e$export$f2ada44de4a33ea1(macroEventRegister);
                    unsuceededJIRAMacro.forEach((macro)=>{
                        const extensionKey = (0, $9Cbhx.getExtensionKey)(macro.experienceAttributes);
                        (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                            analyticsWebClient.sendOperationalEvent({
                                source: 'ui',
                                actionSubject: 'macroTracker',
                                action: 'taskAbort',
                                attributes: {
                                    ...macro.experienceAttributes,
                                    extensionKey: extensionKey,
                                    mode: mode,
                                    task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                                    reason: `JIRA macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`
                                }
                            });
                        });
                    });
                }
                // clean up after aborting all event
                macroEventRegister.clear();
                $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            } else macroTimeout();
        }, 2000);
    })();
};
const $44f37a86f8c1409e$var$macroEventRegisterHash = new Map();
const $44f37a86f8c1409e$export$adf8cb42c7fe1834 = (mode, contentId)=>{
    if ($44f37a86f8c1409e$var$macroEventRegisterHash.has(`${mode}.${contentId}`)) return $44f37a86f8c1409e$var$macroEventRegisterHash.get(`${mode}.${contentId}`);
    $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, new Map());
    return $44f37a86f8c1409e$var$macroEventRegisterHash.get(`${mode}.${contentId}`);
};
const $44f37a86f8c1409e$export$d7fca4196d2b6b6c = (mode, contentId, name, experienceAttributes)=>{
    if ($44f37a86f8c1409e$export$faf154bb66b40b64(name)) {
        const extensionKey = (0, $9Cbhx.getExtensionKey)(experienceAttributes);
        (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
            analyticsWebClient.sendOperationalEvent({
                source: 'ui',
                actionSubject: 'macroTracker',
                action: 'taskStart',
                attributes: {
                    ...experienceAttributes,
                    extensionKey: extensionKey,
                    mode: mode,
                    pageId: contentId,
                    task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                }
            });
        });
    }
};
const $44f37a86f8c1409e$export$d10b6dded8392899 = (mode, contentId, name, experienceAttributes)=>{
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    const macroId = experienceAttributes?.macroId;
    if (!macroEventRegister.has(macroId)) return;
    if ($44f37a86f8c1409e$export$faf154bb66b40b64(name)) {
        const extensionKey = (0, $9Cbhx.getExtensionKey)(experienceAttributes);
        const { status: status } = macroEventRegister.get(macroId);
        if (status === $44f37a86f8c1409e$var$ACTION.SUCCESS) {
            const { duration: duration } = macroEventRegister.get(macroId);
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: 'taskSuccess',
                    attributes: {
                        ...experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        duration: duration,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                        pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                    }
                });
            });
        } else if (status === $44f37a86f8c1409e$var$ACTION.ABORT) {
            const { duration: duration } = macroEventRegister.get(macroId);
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: 'taskAbort',
                    attributes: {
                        ...experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        duration: duration,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                        reason: `JIRA macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`
                    }
                });
            });
        } else if (status === $44f37a86f8c1409e$var$ACTION.FAIL) {
            const { duration: duration } = macroEventRegister.get(macroId);
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: 'taskFail',
                    attributes: {
                        ...experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        duration: duration,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                        error: new (0, $glCMv.ExperienceTimeoutError)(`JIRA macro failed to complete in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`)
                    }
                });
            });
        }
    }
};
const $44f37a86f8c1409e$export$f7c63e38d5d9fd0b = (0, $dOBRD.default)((mode, contentId)=>{
    const macroTracker = new (0, $kmyYx.ExperienceTracker)();
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    macroTracker.subscribe((event)=>{
        const { action: action, name: name, attributes: experienceAttributes, ...rest } = event;
        const macroId = experienceAttributes?.macroId;
        if (action === $44f37a86f8c1409e$var$ACTION.START) {
            // prevent triggering of event
            const current = macroEventRegister.get(macroId);
            if (current && current.id === macroId) return;
            if (name === (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE)) // prevent firing the same view-all-macro more than once
            {
                if (!macroEventRegister.has(contentId)) {
                    // clear the event register, prevent event being re-tracked between SPA transition
                    macroEventRegister.clear();
                    (0, $fGzMp.getExperienceTracker)().start({
                        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                        timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD,
                        id: contentId,
                        attributes: {
                            mode: mode
                        }
                    });
                    macroEventRegister.set(contentId, {
                        status: $44f37a86f8c1409e$var$ACTION.START,
                        name: name,
                        mode: mode,
                        ...rest
                    });
                    $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
                }
            } else {
                // tracking each macro, report to MacroTracker
                macroEventRegister.set(macroId, {
                    status: $44f37a86f8c1409e$var$ACTION.START,
                    name: name,
                    experienceAttributes: {
                        ...experienceAttributes,
                        extensionKey: (0, $9Cbhx.getExtensionKey)(experienceAttributes)
                    },
                    pageId: contentId,
                    mode: mode,
                    ...rest
                });
                $44f37a86f8c1409e$export$d7fca4196d2b6b6c(mode, contentId, name, experienceAttributes);
            }
        } else if (action === $44f37a86f8c1409e$var$ACTION.SUCCESS) {
            // if event is not yet track
            if (!macroEventRegister.has(macroId)) return;
            const { duration: duration, name: name } = event;
            // tracking each macro when it successfully loads
            macroEventRegister.set(macroId, {
                ...macroEventRegister.get(macroId),
                id: macroId,
                name: name,
                mode: mode,
                status: $44f37a86f8c1409e$var$ACTION.SUCCESS,
                duration: duration,
                pageId: contentId
            });
            $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            $44f37a86f8c1409e$export$d10b6dded8392899(mode, contentId, name, experienceAttributes);
        } else if (action === $44f37a86f8c1409e$var$ACTION.ABORT) {
            // if event is not yet track
            if (!macroEventRegister.has(macroId)) return;
            const { duration: duration, reason: reason, name: name } = event;
            // tracking each macro when it aborts loading
            macroEventRegister.set(macroId, {
                ...macroEventRegister.get(macroId),
                id: macroId,
                name: name,
                mode: mode,
                status: $44f37a86f8c1409e$var$ACTION.ABORT,
                duration: duration,
                pageId: contentId,
                reason: reason
            });
            $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            // one macro aborts to load, aborts the entire experience and report to ExperienceTracker
            (0, $fGzMp.getExperienceTracker)().abort({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                reason: 'Macro abort loading',
                attributes: {
                    macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                    mode: mode
                }
            });
            $44f37a86f8c1409e$export$d10b6dded8392899(mode, contentId, name, experienceAttributes);
        } else if (action == $44f37a86f8c1409e$var$ACTION.FAIL) {
            // if event is not yet track
            if (!macroEventRegister.has(macroId)) return;
            const { duration: duration, error: error, name: name } = event;
            // tracking each macro when it fails to load
            macroEventRegister.set(macroId, {
                ...macroEventRegister.get(macroId),
                id: macroId,
                name: name,
                mode: mode,
                status: $44f37a86f8c1409e$var$ACTION.FAIL,
                duration: duration,
                pageId: contentId,
                error: error
            });
            $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            // one macro fails to load, fails the entire experience and report to ExperienceTracker
            (0, $fGzMp.getExperienceTracker)().fail({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                error: error,
                attributes: {
                    macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                    mode: mode,
                    ...experienceAttributes
                }
            });
            $44f37a86f8c1409e$export$d10b6dded8392899(mode, contentId, name, experienceAttributes);
        }
        $44f37a86f8c1409e$export$98d7b4463a1de442(contentId, mode);
    });
    return macroTracker;
});
const $44f37a86f8c1409e$export$4ce0bedef4e84bb7 = (mode, extension)=>{
    const attributes = $44f37a86f8c1409e$export$c1196ba2be68e8d3(extension);
    return `${mode}.${(0, $9Cbhx.getExtensionKey)(attributes)}.${attributes.macroId}`;
};
module.exports["RENDERER"] = $44f37a86f8c1409e$export$c3c3c3f81a03570c;
module.exports["EDITOR"] = $44f37a86f8c1409e$export$e70b8cd540123fd4;
module.exports["PDF"] = $44f37a86f8c1409e$export$f783453b83c906eb;
module.exports["getMacroAttributesFromADFNode"] = $44f37a86f8c1409e$export$c1196ba2be68e8d3;
module.exports["startMacroExperience"] = $44f37a86f8c1409e$export$b16b3cab64ff0bd4;
module.exports["getMacroExperienceTracker"] = $44f37a86f8c1409e$export$f7c63e38d5d9fd0b;
module.exports["stopMacroExperience"] = $44f37a86f8c1409e$export$f9ebd83e8406755f;
module.exports["stopJIRAMacro"] = $44f37a86f8c1409e$export$d10b6dded8392899;
module.exports["getExperienceName"] = $44f37a86f8c1409e$export$4ce0bedef4e84bb7;

});

parcelRegister("9Cbhx", function(module, exports) {

var $kyKWe = parcelRequire("kyKWe");


var $hukUK = parcelRequire("hukUK");

const $9293ebd9645c82d6$export$7486394da5136452 = 'jira';
const $9293ebd9645c82d6$export$8d178e7efa3ed0e7 = 'issue-count';
const $9293ebd9645c82d6$export$c3f023baaa9b214b = 'table-view';
const $9293ebd9645c82d6$export$7d601f5ae4a82040 = 'single-issue';
const $9293ebd9645c82d6$export$47eae2202f029f6b = (parameters)=>{
    if (!parameters) return (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
    const idFromNode = parameters?.macroMetadata?.macroId?.value;
    if (idFromNode) return idFromNode;
    // for macro that does not have unique macro id, we want to generate some unique id
    return (0, $hukUK.objectHash)(parameters);
};
const $9293ebd9645c82d6$export$218d96312e385949 = (attributes)=>{
    if (!attributes) return '';
    const { extensionKey: extensionKey } = attributes;
    const macroParams = attributes?.parameters?.macroParams;
    if (extensionKey === $9293ebd9645c82d6$export$7486394da5136452) return `${extensionKey}${$9293ebd9645c82d6$export$cc2f094f034c7f8f(macroParams)}`;
    return extensionKey;
};
const $9293ebd9645c82d6$export$cc2f094f034c7f8f = (macroParams)=>{
    const prefix = '-';
    if (macroParams?.count?.value === 'true') return prefix + $9293ebd9645c82d6$export$8d178e7efa3ed0e7;
    else if (macroParams?.columns && macroParams?.maximumIssues) return prefix + $9293ebd9645c82d6$export$c3f023baaa9b214b;
    else if (macroParams?.key?.value) return prefix + $9293ebd9645c82d6$export$7d601f5ae4a82040;
    return '';
};
module.exports["JIRA_EXTENSION_KEY"] = $9293ebd9645c82d6$export$7486394da5136452;
module.exports["getMacroId"] = $9293ebd9645c82d6$export$47eae2202f029f6b;
module.exports["getExtensionKey"] = $9293ebd9645c82d6$export$218d96312e385949;

});

parcelRegister("2bAZx", function(module, exports) {
// inspired by https://github.com/kentcdodds/use-deep-compare-effect/blob/master/src/index.js
/* eslint react-hooks/exhaustive-deps: 0 */ //Todo: this is flawed because callback is not included in the dependency array generated by useDeepCompareMemoize
// if the callback function (all use cases I found were inline functions and therfore not passed as a ref, were passes to the dep array they would trigger a re-evaluation every render defeating the purpose
// in order to properly work and handle the callback function being changed, the callback argument must be a useCallback or other function passed by ref and have it be included in the memoized depenedency array

var $cozmU = parcelRequire("cozmU");


var $3u5lg = parcelRequire("3u5lg");

function $a4fa77695d2683a4$export$db77f469fe79526e(callback, dependencies) {
    (0, $cozmU.useEffect)(callback, $a4fa77695d2683a4$var$useDeepCompareMemoize(dependencies));
}
//eslint-ignore react-hooks/exhaustive-deps
function $a4fa77695d2683a4$var$useDeepCompareMemoize(value) {
    const ref = (0, $cozmU.useRef)();
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(value, ref.current)) ref.current = value;
    return ref.current;
}
module.exports["useDeepCompareEffect"] = $a4fa77695d2683a4$export$db77f469fe79526e;

});

parcelRegister("hUS75", function(module, exports) {

var $6fil2 = parcelRequire("6fil2");


var $5kjCz = parcelRequire("5kjCz");


var $2bAZx = parcelRequire("2bAZx");

function $50ff55d614a641f6$export$720dc4209419df4e(name, error, mode, contentId, attributes, source) {
    if ((0, $6fil2.containsNetworkError)(error)) {
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).abort({
            name: name,
            reason: `Aborted ${name} because of network error: ${error.toString()}`,
            checkForTimeout: false,
            attributes: {
                ...attributes,
                source: source
            }
        });
        return;
    }
    (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).fail({
        name: name,
        error: error,
        attributes: {
            ...attributes,
            source: source
        }
    });
}
function $50ff55d614a641f6$export$d22b49804594ed4d({ attributes: attributes, children: children = null, error: error, contentId: contentId, mode: mode, name: name, source: source }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        if (error) $50ff55d614a641f6$export$720dc4209419df4e(name, error, mode, contentId, attributes, source);
        else (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).succeed({
            name: name,
            attributes: attributes
        });
    }, [
        attributes,
        contentId,
        error,
        mode,
        name,
        source
    ]);
    // https://stackoverflow.com/questions/54905376
    return children;
}
module.exports["MacroExperienceStop"] = $50ff55d614a641f6$export$d22b49804594ed4d;

});

parcelRegister("bX5uj", function(module, exports) {

var $5kjCz = parcelRequire("5kjCz");


var $2bAZx = parcelRequire("2bAZx");

function $b23c2b4e39153eb4$export$3462df5a881e125d({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, mode: mode, name: name }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).succeed({
            name: name,
            attributes: attributes
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        mode,
        name
    ]);
    // https://stackoverflow.com/questions/54905376
    return children;
}
module.exports["MacroExperienceSuccess"] = $b23c2b4e39153eb4$export$3462df5a881e125d;

});

parcelRegister("bflGB", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9EemN = parcelRequire("9EemN");

parcelRequire("1syzX");


var $l65Bo = parcelRequire("l65Bo");


var $7aRa9 = parcelRequire("7aRa9");


var $1k6sE = parcelRequire("1k6sE");


var $4q9NN = parcelRequire("4q9NN");

if (typeof window !== 'undefined') {
    // allow to track events on specific elements
    const originalStopCallback = (0, (/*@__PURE__*/$parcel$interopDefault($9EemN))).prototype.stopCallback;
    // Note here should be function instead of arrow function as we want to preserve the context of this
    (0, (/*@__PURE__*/$parcel$interopDefault($9EemN))).prototype.stopCallback = function(...[e, element, combo]) {
        const isAllowed = (0, $1k6sE.MOUSETRAP_ALLOWED_ELEMENTS).map((className)=>element.classList.contains(className)).some((truthful)=>truthful);
        const isAllowedInModal = (0, $1k6sE.MOUSETRAP_ALLOWED_MODALS).map((className)=>element.closest(`.${className}`)).some((truthful)=>truthful);
        return isAllowed || isAllowedInModal ? false : originalStopCallback.call(this, e, element, combo);
    };
}
const $299ae5ea83dc6310$var$ALLOWED_MIN_TIME = 150;
var $299ae5ea83dc6310$export$99058db374262376 = /*#__PURE__*/ function(ShortcutType) {
    ShortcutType["Confluence"] = "Confluence";
    ShortcutType["Forge"] = "Forge";
    return ShortcutType;
}({});
class $299ae5ea83dc6310$export$d29b063d6e86bfeb extends (0, $cozmU.PureComponent) {
    componentDidMount() {
        const { accelerator: accelerator, shortcutType: shortcutType = "Confluence" } = this.props;
        this.checkConflictThenBindAccelerator(accelerator, shortcutType);
    }
    componentDidUpdate(prevProps) {
        const { accelerator: prevAccelerator } = prevProps;
        const { accelerator: accelerator, shortcutType: shortcutType = "Confluence" } = this.props;
        const prevAccelerators = this.getAccelerators(prevAccelerator);
        // Using JSON.stringify to compare because accelerator may be a list of strings
        if (JSON.stringify(prevAccelerator) !== JSON.stringify(accelerator)) {
            this.unbindAccelerators(prevAccelerators);
            this.checkConflictThenBindAccelerator(accelerator, shortcutType);
        }
    }
    componentWillUnmount() {
        const { accelerator: accelerator } = this.props;
        const accelerators = this.getAccelerators(accelerator);
        this.unbindAccelerators(accelerators);
    }
    getAccelerators(accelerator) {
        return Array.isArray(accelerator) ? accelerator : [
            accelerator
        ];
    }
    getShortcutConflicts(accelerators) {
        return accelerators.map((a)=>({
                accelerator: a,
                conflictType: $299ae5ea83dc6310$export$d29b063d6e86bfeb.listeners[a]
            })).filter((o)=>o.conflictType);
    }
    isConfluenceShortcutAndAllConflictsAreForgeShortcuts(shortcutType, shortcutConflicts) {
        return shortcutType === "Confluence" && shortcutConflicts.every((o)=>o.conflictType === "Forge");
    }
    checkConflictThenBindAccelerator(accelerator, shortcutType) {
        const accelerators = this.getAccelerators(accelerator);
        const shortcutConflicts = this.getShortcutConflicts(accelerators);
        if (!shortcutConflicts.length) this.bindAccelerators(accelerators, shortcutType);
        else if (this.isConfluenceShortcutAndAllConflictsAreForgeShortcuts(shortcutType, shortcutConflicts)) {
            shortcutConflicts.forEach((c)=>(0, (/*@__PURE__*/$parcel$interopDefault($9EemN))).unbind(c.accelerator));
            this.bindAccelerators(accelerators, shortcutType);
        }
    }
    bindAccelerators(accelerators, shortcutType) {
        accelerators.forEach((a)=>{
            if (a.includes('+') && shortcutType !== "Forge" && typeof (0, (/*@__PURE__*/$parcel$interopDefault($9EemN))).bindGlobal === 'function') // bindGlobal allows shortcut to work when a input field is focused, see https://github.com/ccampbell/mousetrap/blob/master/plugins/global-bind/README.md
            // This allows user to use shortcut to publish the page when focusing on editor title
            (0, (/*@__PURE__*/$parcel$interopDefault($9EemN))).bindGlobal(a, this._call);
            else (0, (/*@__PURE__*/$parcel$interopDefault($9EemN))).bind(a, this._call);
            $299ae5ea83dc6310$export$d29b063d6e86bfeb.listeners[a] = shortcutType;
        });
    }
    unbindAccelerators(accelerators) {
        accelerators.forEach((a)=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($9EemN))).unbind(a);
            delete $299ae5ea83dc6310$export$d29b063d6e86bfeb.listeners[a];
        });
    }
    render() {
        return null;
    }
    constructor(...args){
        super(...args);
        this.listeners = {};
        this.lastFired = 0;
        this._call = (e, combo)=>{
            // User can only fire a shortcut event in every 150ms
            // This can avoid a part of sequence being recognized as a single key shortcut
            // eg: "s" will be triggered when user enters "g s" without this
            const now = Date.now();
            if (now - this.lastFired >= $299ae5ea83dc6310$var$ALLOWED_MIN_TIME) {
                if (this.props.allowInDialog || !(0, $l65Bo.isDialogShown)()) {
                    this.lastFired = now;
                    this.props.listener(e, combo);
                }
            }
        };
    }
}
$299ae5ea83dc6310$export$d29b063d6e86bfeb.defaultProps = {
    allowInDialog: false,
    shortcutType: "Confluence"
};
$299ae5ea83dc6310$export$d29b063d6e86bfeb.listeners = {};
const $299ae5ea83dc6310$var$ShortcutListenerFC = (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    let accelerator;
    let deprecatedAccelerator;
    let flags;
    let listener;
    let otherProps;
    if ($[0] !== t0) {
        ({ flags: flags, deprecatedAccelerator: deprecatedAccelerator, accelerator: accelerator, listener: listener, ...otherProps } = t0);
        $[0] = t0;
        $[1] = accelerator;
        $[2] = deprecatedAccelerator;
        $[3] = flags;
        $[4] = listener;
        $[5] = otherProps;
    } else {
        accelerator = $[1];
        deprecatedAccelerator = $[2];
        flags = $[3];
        listener = $[4];
        otherProps = $[5];
    }
    let t1;
    if ($[6] !== accelerator || $[7] !== deprecatedAccelerator || $[8] !== flags || $[9] !== listener) {
        t1 = (e, combo)=>{
            (0, $4q9NN.maybeShowDeprecatedShortcutFlag)({
                flags: flags,
                acceleratorTriggered: combo,
                accelerator: accelerator,
                deprecatedAccelerator: deprecatedAccelerator
            });
            listener(e, combo);
        };
        $[6] = accelerator;
        $[7] = deprecatedAccelerator;
        $[8] = flags;
        $[9] = listener;
        $[10] = t1;
    } else t1 = $[10];
    const deprecatedListener = t1;
    let t2;
    if ($[11] !== deprecatedAccelerator || $[12] !== deprecatedListener || $[13] !== otherProps) {
        t2 = deprecatedAccelerator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($299ae5ea83dc6310$export$d29b063d6e86bfeb, {
            accelerator: deprecatedAccelerator,
            listener: deprecatedListener,
            ...otherProps
        });
        $[11] = deprecatedAccelerator;
        $[12] = deprecatedListener;
        $[13] = otherProps;
        $[14] = t2;
    } else t2 = $[14];
    let t3;
    if ($[15] !== accelerator || $[16] !== listener || $[17] !== otherProps) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($299ae5ea83dc6310$export$d29b063d6e86bfeb, {
            accelerator: accelerator,
            listener: listener,
            ...otherProps
        });
        $[15] = accelerator;
        $[16] = listener;
        $[17] = otherProps;
        $[18] = t3;
    } else t3 = $[18];
    let t4;
    if ($[19] !== t2 || $[20] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t2, t3);
        $[19] = t2;
        $[20] = t3;
        $[21] = t4;
    } else t4 = $[21];
    return t4;
};
const $299ae5ea83dc6310$export$52e6eadeebf8c534 = (0, $7aRa9.withFlags)($299ae5ea83dc6310$var$ShortcutListenerFC);
module.exports["ShortcutType"] = $299ae5ea83dc6310$export$99058db374262376;
module.exports["ShortcutListener"] = $299ae5ea83dc6310$export$52e6eadeebf8c534;

});

parcelRegister("1syzX", function(module, exports) {
/**
 * adds a bindGlobal method to Mousetrap that allows you to
 * bind specific keyboard shortcuts that will still work
 * inside a text input field
 *
 * usage:
 * Mousetrap.bindGlobal('ctrl+s', _saveChanges);
 */ /* global Mousetrap:true */ (function(Mousetrap1) {
    if (!Mousetrap1) return;
    var _globalCallbacks = {};
    var _originalStopCallback = Mousetrap1.prototype.stopCallback;
    Mousetrap1.prototype.stopCallback = function(e, element, combo, sequence) {
        var self = this;
        if (self.paused) return true;
        if (_globalCallbacks[combo] || _globalCallbacks[sequence]) return false;
        return _originalStopCallback.call(self, e, element, combo);
    };
    Mousetrap1.prototype.bindGlobal = function(keys, callback, action) {
        var self = this;
        self.bind(keys, callback, action);
        if (keys instanceof Array) {
            for(var i = 0; i < keys.length; i++)_globalCallbacks[keys[i]] = true;
            return;
        }
        _globalCallbacks[keys] = true;
    };
    Mousetrap1.init();
})(typeof Mousetrap !== "undefined" ? Mousetrap : undefined);

});

parcelRegister("l65Bo", function(module, exports) {
// we'd like to be able to check if the dialog is displaying right now
const $0afa19b4dc37db45$export$f0b76e53a3d1db73 = ()=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const portals = Array.from(document.getElementsByClassName('atlaskit-portal')).filter((portal)=>portal.firstChild);
    const isAtlaskitDialogShown = Boolean(portals.filter((item)=>item.querySelectorAll('[role="dialog"]').length).length);
    const isLoomRecorderDialogShown = Boolean(// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.getElementById('loom-sdk-record-overlay-shadow-root-id')?.shadowRoot?.getElementById('preview-recording'));
    return isAtlaskitDialogShown || isLoomRecorderDialogShown;
};
module.exports["isDialogShown"] = $0afa19b4dc37db45$export$f0b76e53a3d1db73;

});

parcelRegister("1k6sE", function(module, exports) {

var $gnkil = parcelRequire("gnkil");


var $9aQ0J = parcelRequire("9aQ0J");

const $ca7c59da1dc6c0fe$export$d05888cf23195902 = 'shortcuts-are-allowed';
const $ca7c59da1dc6c0fe$export$ccca490433ac184a = 'shortcuts-are-allowed-in-modal';
const $ca7c59da1dc6c0fe$export$95466aa5e4023a13 = [
    'ProseMirror-focused',
    $ca7c59da1dc6c0fe$export$d05888cf23195902
];
const $ca7c59da1dc6c0fe$export$eca1f9acdad825ae = [
    $ca7c59da1dc6c0fe$export$ccca490433ac184a
];
const $ca7c59da1dc6c0fe$export$a6834c81db6fbcc7 = Object.values($gnkil).reduce((0, $9aQ0J.getShortcutValues), []);
module.exports["ALLOW_SHORTCUTS_CLASS"] = $ca7c59da1dc6c0fe$export$d05888cf23195902;
module.exports["ALLOW_SHORTCUTS_CLASS_IN_MODAL"] = $ca7c59da1dc6c0fe$export$ccca490433ac184a;
module.exports["MOUSETRAP_ALLOWED_ELEMENTS"] = $ca7c59da1dc6c0fe$export$95466aa5e4023a13;
module.exports["MOUSETRAP_ALLOWED_MODALS"] = $ca7c59da1dc6c0fe$export$eca1f9acdad825ae;
module.exports["RESERVED_SHORTCUTS"] = $ca7c59da1dc6c0fe$export$a6834c81db6fbcc7;

});

parcelRegister("9aQ0J", function(module, exports) {
const $a5d5607ba4daeddb$export$58cbf3bcb054e9cd = (accumulated, current)=>{
    if (typeof current === 'string') accumulated.push(current);
    else if (typeof current === 'object') accumulated.push(...Object.values(current).reduce($a5d5607ba4daeddb$export$58cbf3bcb054e9cd, []));
    return accumulated;
};
module.exports["getShortcutValues"] = $a5d5607ba4daeddb$export$58cbf3bcb054e9cd;

});

parcelRegister("4q9NN", function(module, exports) {
/* DeprecatedShortcutFlag.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $i1t43 = parcelRequire("i1t43");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $4tOXV = parcelRequire("4tOXV");

const $3c4669a4d8882aac$var$i18n = (0, $kSwu1.defineMessages)({
    deprecatedShortcutFlagTitle: {
        id: "shortcuts.deprecated-shortcut-flag.title",
        defaultMessage: "This shortcut is about to change"
    },
    deprecatedShortcutFlagDescription: {
        id: "shortcuts.deprecated-shortcut-flag.description",
        defaultMessage: "Shortcuts are switching to a <supportLink>universal format</supportLink>. <inline>{oldShortcut} will now be {newShortcut}</inline>"
    },
    remindMeLaterButton: {
        id: "shortcuts.deprecated-shortcut-flag.button.remind-me-later",
        defaultMessage: "Remind me later"
    },
    dontTellMeAgainButton: {
        id: "shortcuts.deprecated-shortcut-flag.button.dont-tell-me-again",
        defaultMessage: "Don\u2019t tell me again"
    }
});
const $3c4669a4d8882aac$var$KEYBOARD_SHORTCUTS_SUPPORT_LINK = 'https://support.atlassian.com/confluence-cloud/docs/keyboard-shortcuts-markdown-and-autocomplete/';
const $3c4669a4d8882aac$var$shortcutSentenceCss = null;
const $3c4669a4d8882aac$var$getShortcutDescription = ({ oldShortcut: oldShortcut, newShortcut: newShortcut, acceleratorTriggered: acceleratorTriggered })=>{
    let newS = Array.isArray(newShortcut) ? newShortcut[0] : newShortcut; // ShortcutListener allows for multiple accelerators to be specified for one callback.  Ex. ["a", "mod+9"].
    // If any of those are triggerred, the callback will activate.
    // This makes it a little tricky to figure out what accelerator to recommend as a replacement.
    // Ex. deprecatedAccelerator: ["a", "b"], accelerator: ["mod+a", "mod+b"]
    // - If multiple accelerators are available in `newShortcut`, we default to the first one.
    // - However, if an equal number of accelerators are available in `oldShortcut` and `newShortcut`,
    //   then we look for the accelerator corresponding with the one that was actually triggered,
    //   based on array index.
    if (Array.isArray(oldShortcut) && Array.isArray(newShortcut) && oldShortcut.length === newShortcut.length) {
        const triggeredIndex = oldShortcut.indexOf(acceleratorTriggered);
        if (triggeredIndex >= 0 && triggeredIndex < newShortcut.length) newS = newShortcut[triggeredIndex];
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$3c4669a4d8882aac$var$i18n.deprecatedShortcutFlagDescription,
        values: {
            supportLink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                    target: "_blank",
                    href: $3c4669a4d8882aac$var$KEYBOARD_SHORTCUTS_SUPPORT_LINK
                }, chunks),
            oldShortcut: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4tOXV.ShortcutVisualizer), {
                shortcut: acceleratorTriggered
            }),
            newShortcut: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4tOXV.ShortcutVisualizer), {
                shortcut: newS
            }),
            inline: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                    className: (0, $hekY6.default)([
                        "_2mHwu8FQfX _3iDTPbQ4SZ _0hPCNLDIqT"
                    ])
                }, chunks)
        }
    });
};
const $3c4669a4d8882aac$var$FOREVER = 'forever';
const $3c4669a4d8882aac$var$DEPRECATED_SHORTCUT_FLAG_ID = 'deprecatedShortcutFlag';
const $3c4669a4d8882aac$var$shouldShowDeprecationFlag = ()=>{
    const hiddenUntilTime = (0, $17wUi.confluenceLocalStorageInstance)?.getItem((0, $1UApO.keys).UNIVERSAL_SHORTCUTS_HIDE_PROMPT_UNTIL) || '';
    if (hiddenUntilTime === $3c4669a4d8882aac$var$FOREVER) return false;
    else if (hiddenUntilTime !== '') {
        const hiddenUntilTimeInMs = Number(hiddenUntilTime);
        if (!isNaN(hiddenUntilTimeInMs)) return Date.now() > hiddenUntilTimeInMs;
    }
    return true;
};
const $3c4669a4d8882aac$export$799f01f4b30e66c7 = ({ flags: flags, acceleratorTriggered: acceleratorTriggered, accelerator: accelerator, deprecatedAccelerator: deprecatedAccelerator })=>{
    if ($3c4669a4d8882aac$var$shouldShowDeprecationFlag()) flags.showFlag({
        id: $3c4669a4d8882aac$var$DEPRECATED_SHORTCUT_FLAG_ID,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3c4669a4d8882aac$var$i18n.deprecatedShortcutFlagTitle),
        description: $3c4669a4d8882aac$var$getShortcutDescription({
            oldShortcut: deprecatedAccelerator,
            newShortcut: accelerator,
            acceleratorTriggered: acceleratorTriggered
        }),
        type: 'success',
        close: 'never',
        // Needed to bypass the flags.hideAllFlags() that happens on some page transitions.
        actions: [
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3c4669a4d8882aac$var$i18n.remindMeLaterButton),
                onClick: ()=>{
                    // Hide the prompt for 7 days.
                    (0, $17wUi.confluenceLocalStorageInstance)?.setItem((0, $1UApO.keys).UNIVERSAL_SHORTCUTS_HIDE_PROMPT_UNTIL, Date.now() + 1000 * 60 * 60 * 24 * 7);
                    flags.hideFlag($3c4669a4d8882aac$var$DEPRECATED_SHORTCUT_FLAG_ID);
                }
            },
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3c4669a4d8882aac$var$i18n.dontTellMeAgainButton),
                onClick: ()=>{
                    (0, $17wUi.confluenceLocalStorageInstance)?.setItem((0, $1UApO.keys).UNIVERSAL_SHORTCUTS_HIDE_PROMPT_UNTIL, $3c4669a4d8882aac$var$FOREVER);
                    flags.hideFlag($3c4669a4d8882aac$var$DEPRECATED_SHORTCUT_FLAG_ID);
                }
            }
        ]
    });
};
module.exports["maybeShowDeprecatedShortcutFlag"] = $3c4669a4d8882aac$export$799f01f4b30e66c7;

});

parcelRegister("iLgzu", function(module, exports) {

var $jaPWl = parcelRequire("jaPWl");


var $dK51B = parcelRequire("dK51B");

const $e671a111e943b77f$export$409ac92b3aba27f5 = ({ skip: skip, onError: onError, variables: variables = {}, fetchPolicy: fetchPolicy } = {})=>{
    const promotedSpacesLimit = variables.promotedSpacesLimit || 10;
    const otherSpacesLimit = variables.otherSpacesLimit || 10;
    const promotedSpaceKey = variables.promotedSpaceKey || '';
    return (0, $dK51B.useExperimentalQuery)({
        url: `/wiki/rest/create-dialog/1.0/spaces?promotedSpacesLimit=${promotedSpacesLimit}&otherSpacesLimit=${otherSpacesLimit}&promotedSpaceKey=${promotedSpaceKey}`,
        method: 'GET',
        headers: {
            'Content-Type': (0, $jaPWl.MediaType).JSON
        },
        parseResult: (json)=>{
            const matchedPromotedSpaces = json.matchedPromotedSpaces && json.matchedPromotedSpaces.spaces || [];
            const nodes = (json.promotedSpaces && json.promotedSpaces.spaces || []).concat(json.otherSpaces && json.otherSpaces.spaces || []);
            return {
                experimentalPromotedSpaces: {
                    nodes: nodes,
                    matchedPromotedSpaces: matchedPromotedSpaces,
                    __typename: 'ExperimentalPromotedSpaces'
                }
            };
        },
        skip: skip,
        onError: onError,
        variables: variables,
        fetchPolicy: fetchPolicy
    });
};
module.exports["useExperimentalPromotedSpacesQuery"] = $e671a111e943b77f$export$409ac92b3aba27f5;

});

parcelRegister("jaPWl", function(module, exports) {
var $5e96abf23293f6d5$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["JSON"] = "application/json";
    MediaType["X_WWW_FORM_URLENCODED"] = "application/x-www-form-urlencoded";
    return MediaType;
}({});
module.exports["MediaType"] = $5e96abf23293f6d5$export$483c11740a902fcd;

});

parcelRegister("hBxDy", function(module, exports) {
var $77348f0599087222$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $77348f0599087222$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $77348f0599087222$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $77348f0599087222$export$beaef1891b3e7ca3;

});

parcelRegister("kvJHJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3u5lg = parcelRequire("3u5lg");


var $gXfti = parcelRequire("gXfti");


var $knAY5 = parcelRequire("knAY5");


var $78QFu = parcelRequire("78QFu");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");


var $lXYVJ = parcelRequire("lXYVJ");


var $2O7Qv = parcelRequire("2O7Qv");


var $18R9N = parcelRequire("18R9N");

const $d2938061b4a1e388$var$noop = ()=>{};
const $d2938061b4a1e388$var$EMBEDDED_PREFIX = 'embedded-';
const $d2938061b4a1e388$var$PageSegmentLoadEndComponent = /*#__PURE__*/ (0, $cozmU.memo)((props)=>{
    const { customData: customData = {}, onComplete: onComplete = $d2938061b4a1e388$var$noop, stopTime: stopTime, timing: timing, augmentCustomDataAfterComplete: augmentCustomDataAfterComplete } = props;
    const isEmbedded = (0, $18R9N.useIsEmbeddedTracking)();
    // The discriminated union of Props guarantees that exactly one of `metricKey` or `metric`
    // is provided, so resolvedKey is always a defined string at runtime.
    const resolvedKey = props.metricKey ?? props.metric.key;
    const prefixedKey = isEmbedded ? `${$d2938061b4a1e388$var$EMBEDDED_PREFIX}${resolvedKey}` : resolvedKey;
    const stopTimeRef = (0, $cozmU.useRef)(stopTime);
    const customDataRef = (0, $cozmU.useRef)(customData);
    const augmentCustomDataAfterCompleteRef = (0, $cozmU.useRef)(augmentCustomDataAfterComplete);
    stopTimeRef.current = stopTime;
    customDataRef.current = customData;
    augmentCustomDataAfterCompleteRef.current = augmentCustomDataAfterComplete;
    const handleSegmentLoadEnd = (0, $cozmU.useCallback)(()=>{
        onComplete();
        let finalCustomData;
        if (augmentCustomDataAfterCompleteRef.current) finalCustomData = augmentCustomDataAfterCompleteRef.current(customDataRef.current);
        else finalCustomData = customDataRef.current;
        (0, $knAY5.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${prefixedKey}`);
        (0, $2O7Qv.addCustomTimingForMetric)(prefixedKey);
        (0, $gXfti.addUFOCustomData)({
            ...finalCustomData,
            viewTransitionSource: (0, $lXYVJ.getViewTransitionSource)(),
            ...typeof stopTimeRef.current === 'number' ? {
                stopTime: stopTimeRef.current
            } : {},
            previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
            previousContentId: (0, $6VdZc.browserMetricsState).previousContentId,
            pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
        });
    }, [
        onComplete,
        prefixedKey
    ]);
    (0, $N1nBh.usePerformanceAction)(handleSegmentLoadEnd, timing);
    return null;
}, (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg))));
const $d2938061b4a1e388$export$a267cdf45880b07b = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($d2938061b4a1e388$var$PageSegmentLoadEndComponent);
module.exports["PageSegmentLoadEnd"] = $d2938061b4a1e388$export$a267cdf45880b07b;

});

parcelRegister("lXYVJ", function(module, exports) {

var $1C3B1 = parcelRequire("1C3B1");

let $3ef2d7a9f25e0216$var$transitionSource;
const $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5 = (source)=>{
    $3ef2d7a9f25e0216$var$transitionSource = source;
};
const $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0 = ()=>{
    return $3ef2d7a9f25e0216$var$transitionSource || (0, $1C3B1.UNKNOWN);
};
const $3ef2d7a9f25e0216$export$6dffe64fdadf1e02 = ()=>{
    $3ef2d7a9f25e0216$var$transitionSource = undefined;
};
module.exports["setViewTransitionSource"] = $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5;
module.exports["getViewTransitionSource"] = $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0;
module.exports["resetViewTransitionSource"] = $3ef2d7a9f25e0216$export$6dffe64fdadf1e02;

});

parcelRegister("1C3B1", function(module, exports) {
const $f3fed16e32582dfc$export$f32efcfda8942c38 = 'PAGE_TREE_ITEM_CLICK';
const $f3fed16e32582dfc$export$e20b00d7fdb37fd5 = 'RECENT_DROPDOWN_ITEM_CLICK';
const $f3fed16e32582dfc$export$861af28956854f4d = 'EDITOR_UPDATE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$3a68be40f6a0cf8d = 'EDITOR_UPDATE_SHORTCUT_KEY_PRESS';
const $f3fed16e32582dfc$export$14ad6d5644be3ef2 = 'EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK';
const $f3fed16e32582dfc$export$26bf8dd7a8a304a2 = 'EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS';
const $f3fed16e32582dfc$export$35f8dbb53e30cb83 = 'EDITOR_CLOSE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$56128408995abf4c = 'RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$c6abfcd7964138ae = 'DISCOVER_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$78244dbb77cfa6b6 = 'UNKNOWN';
module.exports["PAGE_TREE_ITEM_CLICK"] = $f3fed16e32582dfc$export$f32efcfda8942c38;
module.exports["EDITOR_UPDATE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$861af28956854f4d;
module.exports["EDITOR_UPDATE_SHORTCUT_KEY_PRESS"] = $f3fed16e32582dfc$export$3a68be40f6a0cf8d;
module.exports["EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK"] = $f3fed16e32582dfc$export$14ad6d5644be3ef2;
module.exports["EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS"] = $f3fed16e32582dfc$export$26bf8dd7a8a304a2;
module.exports["EDITOR_CLOSE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$35f8dbb53e30cb83;
module.exports["RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$56128408995abf4c;
module.exports["DISCOVER_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$c6abfcd7964138ae;
module.exports["UNKNOWN"] = $f3fed16e32582dfc$export$78244dbb77cfa6b6;

});

parcelRegister("2O7Qv", function(module, exports) {

var $a33Aa = parcelRequire("a33Aa");

/**
 * Finds the `segment-start:<metricKey>` and `segment-end:<metricKey>` custom
 * marks in the provided marks array and converts them into a UFO custom timing
 * entry keyed as `wf/react/<metricKey>`.
 */ function $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interactionId, marks, metricKey) {
    let startTime;
    let endTime;
    for (const mark of marks){
        if (mark.type !== 'custom') continue;
        if (mark.name === `segment-start:${metricKey}`) startTime = mark.time;
        else if (mark.name === `segment-end:${metricKey}`) endTime = mark.time;
    }
    if (typeof startTime === 'number' && typeof endTime === 'number') (0, $a33Aa.addCustomTiming)(interactionId, [], {
        [`wf/react/${metricKey}`]: {
            startTime: startTime,
            endTime: endTime
        }
    });
}
function $7bc5b7230c0461d4$export$46796e5c908ea08e(metricKey) {
    const interaction = (0, $a33Aa.getActiveInteraction)();
    if (interaction) $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interaction.id, interaction.marks, metricKey);
}
module.exports["addCustomTimingForMetric"] = $7bc5b7230c0461d4$export$46796e5c908ea08e;

});

parcelRegister("6GD8y", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $2944f0e1873f71ce$export$90839ff33b4905a0 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "pU1rv",
    name: "GeneralShortcutListener",
    loader: async ()=>(await (parcelRequire("5tx03"))).GeneralShortcutListener
});
module.exports["GeneralShortcutListener"] = $2944f0e1873f71ce$export$90839ff33b4905a0;

});

parcelRegister("5tx03", function(module, exports) {

let $3fc94240cbfcef2f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3fc94240cbfcef2f$var$load("aLbuU"),
    $3fc94240cbfcef2f$var$load("hhss7"),
    $3fc94240cbfcef2f$var$load("kpHRm")
]).then(()=>parcelRequire('3w3bV'));

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("04qh3"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("04qh3", function(module, exports) {

let $00d4c153bc0a88fb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $00d4c153bc0a88fb$var$load("fGNl7"),
    $00d4c153bc0a88fb$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});

parcelRegister("9fBoq", function(module, exports) {

var $hBxDy = parcelRequire("hBxDy");

const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $hBxDy.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $hBxDy.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};
module.exports["extensionTitle"] = $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e;

});

parcelRegister("4JC0x", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");

const $98c2a7811aa5a89d$export$fe853ff85807a350 = new Map();
let $98c2a7811aa5a89d$export$576fafc5561e06f5 = null;
const $98c2a7811aa5a89d$var$getListOfPreloadedMacrosFromApolloState = (0, $dOBRD.default)(()=>{
    const rootQueryList = window?.__APOLLO_STATE__?.ROOT_QUERY || {};
    return Object.keys(rootQueryList).filter((query)=>query.startsWith('macroBodyRenderer'));
});
function $98c2a7811aa5a89d$var$isMacroPreloaded(macroId) {
    const preloadedMacros = $98c2a7811aa5a89d$var$getListOfPreloadedMacrosFromApolloState();
    return preloadedMacros.some((preloaded)=>preloaded.includes(macroId));
}
const $98c2a7811aa5a89d$export$1441f92d09a5c3ee = ()=>window.__SSR_RENDERED__ && !!window?.__SSR_MACRO_PRELOAD_TOPX_FAILS__;
function $98c2a7811aa5a89d$var$getPreloadFailedMacrosImpl() {
    const cacheMismatches = $98c2a7811aa5a89d$var$getPreloadCacheMismatches();
    const reportedFails = window?.__SSR_MACRO_PRELOAD_TOPX_FAILS__ || {};
    if (cacheMismatches.length == 0 && (!reportedFails || typeof reportedFails !== 'object' || Object.keys(reportedFails).length === 0)) return;
    const failedMacros = {};
    function addFailed(reason, macroId, extensionKey) {
        failedMacros[macroId] = {
            reason: reason,
            extensionKey: extensionKey
        };
    }
    Object.entries(reportedFails).forEach(([keyAndId, reason])=>{
        if (keyAndId === 'general') return;
        const [extensionKey, macroId] = keyAndId.split(':');
        if (reason === 'timeout') {
            if ($98c2a7811aa5a89d$var$isMacroPreloaded(macroId)) addFailed('falseTimeouts', macroId, extensionKey);
            else addFailed('trueTimeouts', macroId, extensionKey);
        } else addFailed(reason, macroId, extensionKey);
    });
    cacheMismatches.forEach(([macroId, extensionKey])=>addFailed('cacheMismatch', macroId, extensionKey));
    return failedMacros;
}
function $98c2a7811aa5a89d$export$622ff65a4d6eaaaf() {
    if (!$98c2a7811aa5a89d$export$576fafc5561e06f5) $98c2a7811aa5a89d$export$576fafc5561e06f5 = {
        value: $98c2a7811aa5a89d$var$getPreloadFailedMacrosImpl()
    };
    return $98c2a7811aa5a89d$export$576fafc5561e06f5.value;
}
function $98c2a7811aa5a89d$export$de5406af81980582() {
    $98c2a7811aa5a89d$export$576fafc5561e06f5 = null;
}
function $98c2a7811aa5a89d$export$3288a79f0c713f52(macroId) {
    const failedMacros = $98c2a7811aa5a89d$export$622ff65a4d6eaaaf();
    return failedMacros?.[macroId]?.reason;
}
function $98c2a7811aa5a89d$export$34734b475a3fd7b9() {
    const reportedFails = window?.__SSR_MACRO_PRELOAD_TOPX_FAILS__ || {};
    if (!reportedFails || typeof reportedFails !== 'object' || Object.keys(reportedFails).length === 0) return;
    return reportedFails?.['general'];
}
function $98c2a7811aa5a89d$export$4d6ac53bc9b1b8bd(macroId, extensionKey) {
    $98c2a7811aa5a89d$export$576fafc5561e06f5 = null;
    $98c2a7811aa5a89d$export$fe853ff85807a350.set(macroId, extensionKey || '');
    window['__MISSING_DATA_MACROS__'] = window['__MISSING_DATA_MACROS__'] || [];
    window['__MISSING_DATA_MACROS__'].push(macroId);
}
function $98c2a7811aa5a89d$var$getPreloadCacheMismatches() {
    return [
        ...$98c2a7811aa5a89d$export$fe853ff85807a350
    ].filter(([macroId])=>$98c2a7811aa5a89d$var$isMacroPreloaded(macroId));
}
module.exports["macrosPreloadPerformed"] = $98c2a7811aa5a89d$export$1441f92d09a5c3ee;
module.exports["getPreloadFailedMacros"] = $98c2a7811aa5a89d$export$622ff65a4d6eaaaf;
module.exports["getPreloadFailures"] = $98c2a7811aa5a89d$export$3288a79f0c713f52;
module.exports["getGeneralFailures"] = $98c2a7811aa5a89d$export$34734b475a3fd7b9;
module.exports["markMissingMacroData"] = $98c2a7811aa5a89d$export$4d6ac53bc9b1b8bd;

});

parcelRegister("6Ywr0", function(module, exports) {

var $3d5UI = parcelRequire("3d5UI");

function $bb082ed2371b78b6$export$dfb0c4efd029859d(module) {
    try {
        window.require(module);
        return true;
    } catch (err) {
        return false;
    }
}
function $bb082ed2371b78b6$export$2b551419a2839406({ listener: listener, module: module, interval: interval = 250 }, callback) {
    (0, $3d5UI.waitForGlobal)({
        listener: `wait-for-required-module ${module}`,
        globalProperty: 'require'
    }, ()=>{
        if ($bb082ed2371b78b6$export$dfb0c4efd029859d(module)) {
            callback();
            return;
        }
        const waitForRequiredModuleInterval = setInterval(()=>{
            if ($bb082ed2371b78b6$export$dfb0c4efd029859d(module)) {
                clearInterval(waitForRequiredModuleInterval);
                callback();
            }
        }, interval);
    });
}
module.exports["isRequiredModuleLoaded"] = $bb082ed2371b78b6$export$dfb0c4efd029859d;
module.exports["waitForRequiredModule"] = $bb082ed2371b78b6$export$2b551419a2839406;

});

parcelRegister("9oxdN", function(module, exports) {

var $h1PDd = parcelRequire("h1PDd");


var $iaK3p = parcelRequire("iaK3p");


var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");


var $fEmGS = parcelRequire("fEmGS");


var $l1uFv = parcelRequire("l1uFv");


var $7W8i8 = parcelRequire("7W8i8");


var $bQm3c = parcelRequire("bQm3c");


var $17wUi = parcelRequire("17wUi");

const $112f5732a615f62f$var$useFeatureDiscoveryFeatureDiscoveryQuery = (0, $iaK3p.default);
const $112f5732a615f62f$var$useFeatureDiscoveryMarkFeatureDiscoveredMutation = (0, $h1PDd.default);
const $112f5732a615f62f$var$logger = (0, $7W8i8.getLogger)('useFeatureDiscovery');
const $112f5732a615f62f$export$2dd355223baa0569 = 'com.atlassian.confluence.plugins.confluence-frontend-support';
const $112f5732a615f62f$var$updateCache = (_, { data: data })=>{
    const newMarkedFeature = data?.markFeatureDiscovered;
    if (!newMarkedFeature) return;
    const cachedFeatureData = (0, $l1uFv.readQueryInterop)({
        query: $112f5732a615f62f$var$useFeatureDiscoveryFeatureDiscoveryQuery,
        __callerPackage__: "feature-discovery"
    });
    if (!cachedFeatureData?.featureDiscovery) return;
    (0, $fEmGS.writeQueryInterop)({
        query: $112f5732a615f62f$var$useFeatureDiscoveryFeatureDiscoveryQuery,
        data: {
            featureDiscovery: cachedFeatureData.featureDiscovery.concat(newMarkedFeature)
        },
        __callerPackage__: "feature-discovery"
    });
};
const $112f5732a615f62f$var$getLocalOverrideValue = (featureKey)=>{
    try {
        if ((0, $17wUi.confluenceSessionStorageInstance).getItem(`${featureKey}-featureDiscoveryOverride`)) return true;
    } catch (e) {
        $112f5732a615f62f$var$logger.error(e);
    }
    return false;
};
const $112f5732a615f62f$var$noop = ()=>{};
const $112f5732a615f62f$export$6de1a7573792d1a9 = (featureKey, skip)=>{
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const skipFeatureDiscoveryQuery = !isLoggedIn || skip;
    const { data: data, loading: queryLoading, error: queryError } = (0, $jMyy4.useQueryInterop)($112f5732a615f62f$var$useFeatureDiscoveryFeatureDiscoveryQuery, {
        skip: skipFeatureDiscoveryQuery,
        __callerPackage__: "feature-discovery"
    });
    const [markFeatureDiscovered, { loading: mutationLoading, error: mutationError }] = (0, $308Wd.useMutationInterop)($112f5732a615f62f$var$useFeatureDiscoveryMarkFeatureDiscoveredMutation, {
        variables: {
            featureKey: featureKey,
            pluginKey: $112f5732a615f62f$export$2dd355223baa0569
        },
        update: $112f5732a615f62f$var$updateCache,
        __callerPackage__: "feature-discovery"
    });
    const loading = queryLoading || mutationLoading;
    const error = queryError || mutationError;
    const showFeature = !loading && !error && !data?.featureDiscovery?.some((feature)=>feature?.pluginKey === $112f5732a615f62f$export$2dd355223baa0569 && feature?.featureKey === featureKey);
    const handleStop = (0, $cozmU.useCallback)(()=>{
        if (showFeature) // error is handled in the useMutation result
        markFeatureDiscovered().catch(()=>{});
    }, [
        showFeature,
        markFeatureDiscovered
    ]);
    if (skipFeatureDiscoveryQuery) return [
        false,
        $112f5732a615f62f$var$noop,
        undefined
    ];
    // this is for dev/testing, since we cant easily remove data from the featureDiscovery array
    const forceShowFeature = showFeature || $112f5732a615f62f$var$getLocalOverrideValue(featureKey);
    return [
        forceShowFeature,
        handleStop,
        error
    ];
};
module.exports["useFeatureDiscovery"] = $112f5732a615f62f$export$6de1a7573792d1a9;

});

parcelRegister("h1PDd", function(module, exports) {
/**
 * @generated SignedSource<<de9fe90553f5e4890bae7c7ad707e3ad>>
 * @relayHash 7e3a97b41907f84e881bf7535b1379ce
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID aded1ac8c4d8c5f52bbd0e95ce0857860d2f9ccb92e721ad18f7b30caef06081
const $fca31db58911eb73$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "featureKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pluginKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "featureKey",
                    "variableName": "featureKey"
                },
                {
                    "kind": "Variable",
                    "name": "pluginKey",
                    "variableName": "pluginKey"
                }
            ],
            "concreteType": "FeatureDiscoveryPayload",
            "kind": "LinkedField",
            "name": "markFeatureDiscovered",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "pluginKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "featureKey"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useFeatureDiscoveryMarkFeatureDiscoveredMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useFeatureDiscoveryMarkFeatureDiscoveredMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "7e3a97b41907f84e881bf7535b1379ce",
            "id": "aded1ac8c4d8c5f52bbd0e95ce0857860d2f9ccb92e721ad18f7b30caef06081",
            "metadata": {},
            "name": "useFeatureDiscoveryMarkFeatureDiscoveredMutation",
            "operationKind": "mutation",
            "text": "mutation useFeatureDiscoveryMarkFeatureDiscoveredMutation($featureKey:String!,$pluginKey:String!){markFeatureDiscovered(featureKey:$featureKey,pluginKey:$pluginKey){pluginKey,featureKey}}"
        }
    };
}();
$fca31db58911eb73$var$node.hash = "55ae5a7186fb2a98e37da374a9b9784e";
var $fca31db58911eb73$export$2e2bcd8739ae039 = $fca31db58911eb73$var$node;
module.exports["default"] = $fca31db58911eb73$export$2e2bcd8739ae039;

});

parcelRegister("kfIha", function(module, exports) {
const $3551cf4db632cbd5$var$isClipboardApiSupported = ()=>// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    Boolean(navigator.clipboard && typeof navigator.clipboard.writeText === 'function');
const $3551cf4db632cbd5$export$b2199c37e85de4a7 = ()=>{
    const copyToClipboard = async (value)=>{
        if (value && $3551cf4db632cbd5$var$isClipboardApiSupported()) // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        await navigator.clipboard.writeText(value);
    };
    return {
        copyToClipboard: copyToClipboard
    };
};
module.exports["useCopyToClipboard"] = $3551cf4db632cbd5$export$b2199c37e85de4a7;

});

parcelRegister("kxhju", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $iEfsZ = parcelRequire("iEfsZ");


var $cozmU = parcelRequire("cozmU");


var $iKWdo = parcelRequire("iKWdo");


var $1wIeS = parcelRequire("1wIeS");


var $bavCP = parcelRequire("bavCP");


var $b3j2Y = parcelRequire("b3j2Y");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $8wW9d = parcelRequire("8wW9d");


var $1gjU5 = parcelRequire("1gjU5");


var $62BfR = parcelRequire("62BfR");


var $3QyBm = parcelRequire("3QyBm");

const $b5245263a8ff7a10$export$abf96c374bfacb58 = (0, $iEfsZ.default);
class $b5245263a8ff7a10$export$14318d199449e2e3 extends (0, $cozmU.Component) {
    render() {
        const { location: location, children: children, onLoad: onLoad, hasMultipleSections: hasMultipleSections, renderWhenLoading: renderWhenLoading, allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems, fetchPolicy: fetchPolicy = 'cache-and-network', spaceKey: spaceKey, contentId: contentId, id: id, className: className, style: style, tagName: tagName, version: version, waitForSuperBatch: waitForSuperBatch } = this.props;
        const variables = {
            // GraphQL doesn't cache single location strings properly when passed to locations
            // unless we're using multiple locations we should be using the location variable
            location: Array.isArray(location) ? null : location,
            locations: Array.isArray(location) ? location : [],
            contentId: contentId || null,
            spaceKey: spaceKey || null,
            version: version || null
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bavCP.QueryInterop), {
            query: $b5245263a8ff7a10$export$abf96c374bfacb58,
            variables: variables,
            fetchPolicy: fetchPolicy,
            __callerPackage__: "web-item-location"
        }, ({ data: data, loading: loading, error: error })=>{
            // Since the default fetchPolicy is cache-and-network
            // loading field will be true, false, true (background refetch), false
            // Thus destroying and rebuilding the children
            // Here we only block rendering on the very first loading.
            if (loading && !data) {
                if (renderWhenLoading && typeof children === 'function') {
                    // Render wrapper to keep DOM structure consistent while loading
                    const wrapperProps = {
                        'data-webitem-location': location,
                        'data-content-id': contentId,
                        children: children({
                            loading: loading,
                            webItems: [],
                            webSections: []
                        })
                    };
                    if (id) wrapperProps.id = id;
                    if (className) wrapperProps.className = className;
                    if (style) wrapperProps.style = style;
                    const wrapperTag = tagName || 'div';
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(wrapperTag, wrapperProps);
                } else return null;
            }
            if (error) {
                if ((0, $1uFM6.isUnauthorizedError)(error)) {
                    (0, $7Sm4c.markErrorAsHandled)(error);
                    return null;
                }
                // TODO: unknown errors should have a nicer UI within `<ErrorDisplay>`, but we don't have such UI for now
                // so returning empty `<ErrorDisplay>` here.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
                    error: error
                });
            }
            // replace any instances of {atlTokenPlaceholderWillBeReplacedInFrontend}
            // with the atlToken in all section items
            let webItems = ((0, $62BfR.replaceAtlTokenPlaceholder)(data)?.webItemSections ?? []).reduce((items, section)=>{
                return items.concat((section.items || []).map((item)=>({
                        ...item,
                        parentSection: {
                            label: section.label || section.styleClass
                        }
                    })));
            }, []);
            webItems = (0, (/*@__PURE__*/$parcel$interopDefault($iKWdo)))(webItems, 'completeKey');
            if (allowedWebItems) webItems = webItems.filter((webItem)=>allowedWebItems.includes(webItem.completeKey));
            if (notAllowedWebItems) webItems = webItems.filter((webItem)=>!notAllowedWebItems.includes(webItem.completeKey));
            webItems = (0, $3QyBm.filterConnectAppsFromExtensionPoints)(location, webItems);
            webItems.forEach((item)=>{
                const paramObj = {};
                if (Array.isArray(item.params)) {
                    item.params.forEach((param)=>{
                        paramObj[param.key] = param.value;
                    });
                    item.params = paramObj;
                }
                if (item.section && item.section.indexOf('/') !== -1) {
                    const parts = item.section.split('/');
                    item.webSection = parts[1];
                }
            });
            const formattedWebItems = webItems;
            // Instrument the presence of non-content 3P connect apps so their keys
            // are folded into the page-load `connectAppKeys` telemetry.
            (0, $8wW9d.recordNonContentAppKeys)('web-item', formattedWebItems.map((webItem)=>webItem.completeKey));
            let webSections = [];
            if (hasMultipleSections) webSections = (0, (/*@__PURE__*/$parcel$interopDefault($1wIeS)))(formattedWebItems.map((webItem)=>webItem.section));
            formattedWebItems.sort((webItemA, webItemB)=>{
                if (webItemA.weight - webItemB.weight === 0) return webItemA.label.localeCompare(webItemB.label);
                else return webItemA.weight - webItemB.weight;
            });
            if (!loading) this.experienceSuccess(true);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1gjU5.WebItemLocationComponent), {
                id: id,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: style,
                tagName: tagName,
                location: location,
                webItems: formattedWebItems,
                webSections: webSections,
                onLoad: onLoad,
                waitForSuperBatch: waitForSuperBatch
            }, children);
        });
    }
    constructor(...args){
        super(...args);
        this.experienceSuccess = (result)=>{
            if (this.props.experienceSuccess) this.props.experienceSuccess(result);
        };
    }
}
const $b5245263a8ff7a10$export$ab308e916c09580 = (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b5245263a8ff7a10$export$14318d199449e2e3, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
module.exports["WebItemLocationQuery"] = $b5245263a8ff7a10$export$abf96c374bfacb58;
module.exports["WebItemLocation"] = $b5245263a8ff7a10$export$ab308e916c09580;

});

parcelRegister("1gjU5", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $8SfNq = parcelRequire("8SfNq");

function $4c9fd42c224286dd$var$_defineProperty(e, r, t) {
    return (r = $4c9fd42c224286dd$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $4c9fd42c224286dd$var$_toPropertyKey(t) {
    var i = $4c9fd42c224286dd$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $4c9fd42c224286dd$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4c9fd42c224286dd$var$StyledWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbvbI6 _2gHOcPzXzM _1DH08Qjg0e _20DmKqEqul _14Wx5PeKmV _2qRYQF98eZ _0oQUy6YbGa _0tUIKU6wH8 _0WfKEq2Njc _1UNQhUvbI6 _2UvIvUOLYo _1KE8vRbllS _3cgr8TQame _3uAMeFLRg7 _2LESMOvbI6 _0k3IULDIqT",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
class $4c9fd42c224286dd$export$e83681c8b6998cea extends (0, $cozmU.Component) {
    componentDidMount() {
        this.mounted = true;
        const { webItems: webItems, onLoad: onLoad, waitForSuperBatch: waitForSuperBatch } = this.props;
        if (onLoad) onLoad({
            webItems: webItems
        });
        if (waitForSuperBatch) (0, $8SfNq.requireSuperBatch)().then(()=>{
            if (this.mounted) this.setState({
                superBatchLoaded: true
            });
        });
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    render() {
        const { id: id, tagName: tagName, className: className, style: style, children: children, webItems: webItems, webSections: webSections, location: location, contentId: contentId, waitForSuperBatch: waitForSuperBatch } = this.props;
        if (waitForSuperBatch && !this.state.superBatchLoaded) return null;
        const wrapperProps = {
            'data-webitem-location': location,
            'data-content-id': contentId,
            children: typeof children === 'function' ? children({
                webItems: webItems,
                webSections: webSections
            }) : null
        };
        if (id) wrapperProps.id = id;
        if (className) wrapperProps.className = className;
        if (style) wrapperProps.style = style;
         // Addon icons are broken during SSR, this is because we do not SSR legacy styles.
        // In order for styles to match during SSR and SPA for addon icons, we need to
        // declare a styled component such as emotion/styled. This way we can pass css to their children via wrapper.
        // Until superbatch is loaded, the styles for addon icons would still be broken.
        if (wrapperProps?.children?.props?.buttonType === 'aui-button-subtle') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4c9fd42c224286dd$var$StyledWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(tagName, wrapperProps));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(tagName, wrapperProps);
    }
    constructor(...args){
        super(...args);
        $4c9fd42c224286dd$var$_defineProperty(this, "state", {
            superBatchLoaded: false
        });
        $4c9fd42c224286dd$var$_defineProperty(this, "mounted", false);
    }
}
$4c9fd42c224286dd$var$_defineProperty($4c9fd42c224286dd$export$e83681c8b6998cea, "defaultProps", {
    tagName: 'div'
});
module.exports["WebItemLocationComponent"] = $4c9fd42c224286dd$export$e83681c8b6998cea;

});

parcelRegister("62BfR", function(module, exports) {
function $d97d2e8640b15cc8$export$87286345b169ae5e(data) {
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const atlToken = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector('meta[name="ajs-atl-token"]')?.content;
    if (!atlToken || !data || !data.webItemSections) return data;
    return {
        ...data,
        webItemSections: data.webItemSections.map((section)=>{
            if (section) return {
                ...section,
                items: section?.items.map((sectionItem)=>{
                    if (sectionItem) return {
                        ...sectionItem,
                        url: sectionItem.url?.replace('{atlTokenPlaceholderWillBeReplacedInFrontend}', atlToken) ?? sectionItem.url,
                        urlWithoutContextPath: sectionItem.urlWithoutContextPath?.replace('{atlTokenPlaceholderWillBeReplacedInFrontend}', atlToken) ?? sectionItem.urlWithoutContextPath
                    };
                    else return null;
                })
            };
            else return null;
        })
    };
}
module.exports["replaceAtlTokenPlaceholder"] = $d97d2e8640b15cc8$export$87286345b169ae5e;

});

parcelRegister("7bpSh", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $9dee672aff5abe3d$export$c4ffab2abecc9a7c = (0, $cozmU.createContext)(null);
module.exports["ContentModeFragmentContext"] = $9dee672aff5abe3d$export$c4ffab2abecc9a7c;

});

parcelRegister("k5ycH", function(module, exports) {

var $7W8i8 = parcelRequire("7W8i8");


var $l6Xaz = parcelRequire("l6Xaz");

const $980b898db1533800$var$logger = (0, $7W8i8.getLogger)('wrm');
function $980b898db1533800$export$d3d08d944062d7e(container, tags, // Process tags as an array of links when linksMode = true
// We don't have tags info in CustomHeaderFooter.
linksMode = false) {
    if (!tags.length) return Promise.resolve();
    const fragment = window.document.createDocumentFragment();
    const promises = (0, $l6Xaz.parseScriptTags)(tags, linksMode).map(({ src: src, ...attributes })=>new Promise((resolve, reject)=>{
            if (window.document.querySelector(`script[data-wrm-key='${attributes['data-wrm-key']}']`)) // next/packages/content-renderer/src/TinyMCEServerFullRenderer.tsx will put script as defer to <head>
            // We don't want to re-initialize those scripts when rehydrate
            resolve(null);
            else {
                const scriptElement = window.document.createElement('script');
                scriptElement.async = false;
                scriptElement.src = src;
                scriptElement.onload = resolve;
                scriptElement.onerror = reject;
                Object.keys(attributes).forEach((attributeKey)=>scriptElement.setAttribute(attributeKey, attributes[attributeKey]));
                fragment.appendChild(scriptElement);
            }
        }));
    container.appendChild(fragment);
    return Promise.all(promises).catch((...args)=>{});
}
module.exports["loadResources"] = $980b898db1533800$export$d3d08d944062d7e;

});

parcelRegister("6bd6t", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $i1t43 = parcelRequire("i1t43");


var $7ZB0A = parcelRequire("7ZB0A");


var $lpNn5 = parcelRequire("lpNn5");


var $4MnFz = parcelRequire("4MnFz");


var $chu6R = parcelRequire("chu6R");


var $2eX69 = parcelRequire("2eX69");


var $9DHhW = parcelRequire("9DHhW");


var $3izAL = parcelRequire("3izAL");


var $kz1Yj = parcelRequire("kz1Yj");


var $buxP3 = parcelRequire("buxP3");


var $cFVPs = parcelRequire("cFVPs");


var $b3j2Y = parcelRequire("b3j2Y");


var $bQm3c = parcelRequire("bQm3c");


var $7OLeD = parcelRequire("7OLeD");


var $PjC9c = parcelRequire("PjC9c");


var $dchHi = parcelRequire("dchHi");

const $6d65bb3bd17dd577$var$LINK_TO_PRIVACY_POLICY = 'https://www.atlassian.com/legal/privacy-policy';
const $6d65bb3bd17dd577$var$LINK_TO_RESEARCH_GROUP = 'https://www.atlassian.com/research-group';
const $6d65bb3bd17dd577$var$i18n = (0, $kSwu1.defineMessages)({
    flagTitle: {
        id: "quick-summary.feedback.flag.title",
        defaultMessage: "Thanks!"
    },
    flagDescription: {
        id: "quick-summary.feedback.flag.description",
        defaultMessage: "We appreciate you taking the time to send this feedback."
    },
    likeTooltip: {
        id: "quick-summary.like.tooltip",
        defaultMessage: "Good response"
    },
    dislikeTooltip: {
        id: "quick-summary.dislike.tooltip",
        defaultMessage: "Bad response"
    },
    likeSuggestionTooltip: {
        id: "quick-summary.like-suggestion.tooltip",
        defaultMessage: "Helpful"
    },
    dislikeSuggestionTooltip: {
        id: "quick-summary.dislike-suggestion.tooltip",
        defaultMessage: "Not helpful"
    },
    feedbackTitle: {
        id: "quick-summary.feedback.title",
        defaultMessage: "Help us improve Atlassian Intelligence"
    },
    feedbackSummaryTitle: {
        id: "quick-summary.feedback.summary.title",
        defaultMessage: "Tell us about your experience"
    },
    feedbackSummaryPlaceholder: {
        id: "quick-summary.feedback.summary.placeholder",
        defaultMessage: "What did Atlassian Intelligence do well? What could be improved?"
    },
    canContactText: {
        id: "quick-summary.feedback.can-contact.label",
        defaultMessage: "Atlassian can contact me about this feedback. See our {privacyPolicyLink}."
    },
    privacyPolicyLink: {
        id: "quick-summary.feedback.privacy-policy.link",
        defaultMessage: "privacy policy"
    },
    improveAtlassianText: {
        id: "quick-summary.feedback.improve-atlassian",
        defaultMessage: "I\u2019d like to help improve Atlassian products by joining the {researchGroupLink}."
    },
    researchGroupLink: {
        id: "quick-summary.feedback.research-group.link",
        defaultMessage: "Atlassian Research Group"
    }
});
const $6d65bb3bd17dd577$var$PrivacyPolicyLink = ({ link: link })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        target: "_blank",
        href: link
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $6d65bb3bd17dd577$var$i18n.privacyPolicyLink));
const $6d65bb3bd17dd577$var$ResearchGroupLink = ({ link: link })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        target: "_blank",
        href: link
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $6d65bb3bd17dd577$var$i18n.researchGroupLink));
const $6d65bb3bd17dd577$var$CanContactLabel = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$6d65bb3bd17dd577$var$i18n.canContactText,
        values: {
            privacyPolicyLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6d65bb3bd17dd577$var$PrivacyPolicyLink, {
                link: $6d65bb3bd17dd577$var$LINK_TO_PRIVACY_POLICY
            })
        }
    });
};
const $6d65bb3bd17dd577$var$EnrolLabel = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$6d65bb3bd17dd577$var$i18n.improveAtlassianText,
        values: {
            researchGroupLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6d65bb3bd17dd577$var$ResearchGroupLink, {
                link: $6d65bb3bd17dd577$var$LINK_TO_RESEARCH_GROUP
            })
        }
    });
};
const $6d65bb3bd17dd577$var$TooltipWrapperXCSS = (0, $buxP3.xcss)({
    listStyle: 'none',
    marginTop: 'space.0'
});
const $6d65bb3bd17dd577$var$FeedbackIconXCSS = (0, $buxP3.xcss)({
    marginRight: 'space.050'
});
const $6d65bb3bd17dd577$var$DislikeIconWrapperXCSS = (0, $buxP3.xcss)({
    transform: 'rotate(180deg)'
});
const $6d65bb3bd17dd577$var$ButtonWrapperXCSS = (0, $buxP3.xcss)({
    height: '24px',
    width: '24px'
});
const $6d65bb3bd17dd577$var$InlineULXCSS = (0, $buxP3.xcss)({
    paddingLeft: 'space.0',
    display: 'flex'
});
const $6d65bb3bd17dd577$export$cbc8ab5712ed2bd3 = ({ analyticsProperties: analyticsProperties, contentId: contentId, spaceKey: spaceKey, summaryId: summaryId, summaryLocale: summaryLocale, feedbackTitle: feedbackTitle, feedbackSummaryPlaceholder: feedbackSummaryPlaceholder, aiContentType: aiContentType })=>{
    const { showFlag: showFlag } = (0, $4MnFz.useFlags)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isFeedbackOpen, setIsFeedbackOpen] = (0, $cozmU.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const feedbackCollectorProperties = (0, $dchHi.useFeedbackCollectorProperties)();
    const [sentiment, setSentiment] = (0, $cozmU.useState)('');
    const [hasGoodFeedbackBeenSubmitted, setHasGoodFeedbackBeenSubmitted] = (0, $cozmU.useState)(false);
    const [hasBadFeedbackBeenSubmitted, setHasBadFeedbackBeenSubmitted] = (0, $cozmU.useState)(false);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { trackAIFeedbackSubmit: trackAIFeedbackSubmit } = (0, $cFVPs.useAIEventsInstrumentation)();
    // Only fetch contributor info when contentId is provided (not for space-level feedback)
    const shouldFetchContributors = !!contentId;
    const contributorResult = (0, $PjC9c.useCurrentUserContributor)(contentId || '');
    const { isCurrentUserContributor: isCurrentUserContributor, contentContributorsError: contentContributorsError } = shouldFetchContributors ? contributorResult : {
        isCurrentUserContributor: undefined,
        contentContributorsError: undefined
    };
    const feedbackContextParts = [
        contentId && `contentId: ${contentId}`,
        spaceKey && `spaceKey: ${spaceKey}`,
        `sentiment: ${sentiment}`,
        `cloudId: ${cloudId}`,
        `isCurrentUserContributor: ${isCurrentUserContributor}`,
        feedbackCollectorProperties.feedbackContext.length > 0 && feedbackCollectorProperties.feedbackContext
    ].filter(Boolean);
    const feedbackContextString = feedbackContextParts.join(' ');
    (0, $cozmU.useEffect)(()=>{
        if (isFeedbackOpen) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: `${analyticsProperties.source}FeedbackCollectorDialog`,
                attributes: {
                    ...contentId && {
                        contentId: contentId
                    },
                    ...spaceKey && {
                        spaceKey: spaceKey
                    },
                    summaryId: summaryId,
                    summaryLocale: summaryLocale,
                    sentiment: sentiment,
                    ...analyticsProperties.additionalAnalyticsAttributes
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isFeedbackOpen,
        contentId,
        spaceKey,
        summaryId,
        summaryLocale,
        sentiment,
        analyticsProperties
    ]);
    const showFeedbackFlag = ()=>{
        showFlag({
            title: formatMessage($6d65bb3bd17dd577$var$i18n.flagTitle),
            description: formatMessage($6d65bb3bd17dd577$var$i18n.flagDescription),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
                color: "var(--ds-icon-success, #6A9A23)",
                label: "success"
            }),
            isAutoDismiss: true
        });
    };
    const onLikeClicked = ()=>{
        setIsFeedbackOpen(true);
        setSentiment('good');
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: analyticsProperties.source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: `${analyticsProperties.source}LikeButton`,
                attributes: {
                    ...contentId && {
                        contentId: contentId
                    },
                    ...spaceKey && {
                        spaceKey: spaceKey
                    },
                    summaryId: summaryId,
                    summaryLocale: summaryLocale,
                    ...analyticsProperties.additionalAnalyticsAttributes
                }
            }
        }).fire();
        trackAIFeedbackSubmit('up');
    };
    const onDislikeClicked = ()=>{
        setIsFeedbackOpen(true);
        setSentiment('bad');
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: analyticsProperties.source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: `${analyticsProperties.source}DislikeButton`,
                attributes: {
                    ...contentId && {
                        contentId: contentId
                    },
                    ...spaceKey && {
                        spaceKey: spaceKey
                    },
                    summaryId: summaryId,
                    summaryLocale: summaryLocale,
                    ...analyticsProperties.additionalAnalyticsAttributes
                }
            }
        }).fire();
        trackAIFeedbackSubmit('down');
    };
    const onFeedbackSubmit = ()=>{
        showFeedbackFlag();
        setIsFeedbackOpen(false);
        if (sentiment === 'good') {
            setHasGoodFeedbackBeenSubmitted(true);
            setHasBadFeedbackBeenSubmitted(false);
        } else {
            setHasBadFeedbackBeenSubmitted(true);
            setHasGoodFeedbackBeenSubmitted(false);
        }
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: analyticsProperties.source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: `${analyticsProperties.source}SubmitFeedbackButton`,
                attributes: {
                    ...contentId && {
                        contentId: contentId
                    },
                    ...spaceKey && {
                        spaceKey: spaceKey
                    },
                    summaryId: summaryId,
                    summaryLocale: summaryLocale,
                    sentiment: sentiment,
                    ...analyticsProperties.additionalAnalyticsAttributes
                }
            }
        }).fire();
    };
    const likeTooltip = aiContentType && aiContentType === 'suggestion' ? $6d65bb3bd17dd577$var$i18n.likeSuggestionTooltip : $6d65bb3bd17dd577$var$i18n.likeTooltip;
    const dislikeTooltip = aiContentType && aiContentType === 'suggestion' ? $6d65bb3bd17dd577$var$i18n.dislikeSuggestionTooltip : $6d65bb3bd17dd577$var$i18n.dislikeTooltip;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        role: "none",
        onClick: (e)=>e.stopPropagation()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        as: "ul",
        xcss: $6d65bb3bd17dd577$var$InlineULXCSS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        as: "li",
        xcss: [
            $6d65bb3bd17dd577$var$TooltipWrapperXCSS,
            $6d65bb3bd17dd577$var$FeedbackIconXCSS
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        hideTooltipOnMouseDown: true,
        content: formatMessage(likeTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $6d65bb3bd17dd577$var$ButtonWrapperXCSS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "subtle",
        "aria-label": formatMessage(likeTooltip),
        spacing: "none",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7OLeD.ThumbsIcon), {
            isSelected: hasGoodFeedbackBeenSubmitted
        }),
        onClick: onLikeClicked,
        testId: "feedback-like-button",
        isDisabled: hasGoodFeedbackBeenSubmitted
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        as: "li",
        xcss: [
            $6d65bb3bd17dd577$var$TooltipWrapperXCSS,
            $6d65bb3bd17dd577$var$FeedbackIconXCSS
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        hideTooltipOnMouseDown: true,
        content: formatMessage(dislikeTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $6d65bb3bd17dd577$var$ButtonWrapperXCSS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "subtle",
        "aria-label": formatMessage(dislikeTooltip),
        spacing: "none",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $6d65bb3bd17dd577$var$DislikeIconWrapperXCSS
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7OLeD.ThumbsIcon), {
            isSelected: hasBadFeedbackBeenSubmitted
        })),
        onClick: onDislikeClicked,
        testId: "feedback-dislike-button",
        isDisabled: hasBadFeedbackBeenSubmitted
    }))))), isFeedbackOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2eX69.default), {
        locale: feedbackCollectorProperties.locale,
        onSubmit: onFeedbackSubmit,
        onClose: ()=>setIsFeedbackOpen(false),
        atlassianAccountId: feedbackCollectorProperties.userId,
        name: feedbackCollectorProperties.displayName,
        entrypointId: feedbackCollectorProperties.entrypointId,
        summaryPlaceholder: formatMessage(feedbackSummaryPlaceholder ?? $6d65bb3bd17dd577$var$i18n.feedbackSummaryPlaceholder),
        additionalFields: [
            {
                id: feedbackCollectorProperties.feedbackContextId,
                value: feedbackContextString
            }
        ],
        feedbackTitle: formatMessage(feedbackTitle ?? $6d65bb3bd17dd577$var$i18n.feedbackTitle),
        showTypeField: false,
        customTextAreaLabel: formatMessage($6d65bb3bd17dd577$var$i18n.feedbackSummaryTitle),
        canBeContactedLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6d65bb3bd17dd577$var$CanContactLabel, null),
        enrolInResearchLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6d65bb3bd17dd577$var$EnrolLabel, null)
    })), contentContributorsError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: contentContributorsError
    }));
};
module.exports["SmartsFeedbackComponent"] = $6d65bb3bd17dd577$export$cbc8ab5712ed2bd3;

});

parcelRegister("7OLeD", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $c8bBH = parcelRequire("c8bBH");

const $e94a9fb89963bcaa$export$1337fc502d44e2c0 = ({ isSelected: isSelected })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8bBH))), {
        color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon-subtle, #505258)",
        spacing: "spacious",
        label: ""
    });
module.exports["ThumbsIcon"] = $e94a9fb89963bcaa$export$1337fc502d44e2c0;

});

parcelRegister("PjC9c", function(module, exports) {

var $3XvFR = parcelRequire("3XvFR");


var $jMyy4 = parcelRequire("jMyy4");

const $03062ed3aa730446$var$useCurrentUserContributorContentContributorsQuery = (0, $3XvFR.default);
const $03062ed3aa730446$export$b7b7e80a2f61884d = (contentId)=>{
    const { data: data, loading: contentContributorsLoading, error: contentContributorsError } = (0, $jMyy4.useQueryInterop)($03062ed3aa730446$var$useCurrentUserContributorContentContributorsQuery, {
        variables: {
            contentId: contentId
        },
        __callerPackage__: "quick-summary"
    });
    const isCurrentUserContributor = data?.contentContributors?.isCurrentUserContributor ?? undefined;
    return {
        isCurrentUserContributor: isCurrentUserContributor,
        contentContributorsLoading: contentContributorsLoading,
        contentContributorsError: contentContributorsError
    };
};
module.exports["useCurrentUserContributor"] = $03062ed3aa730446$export$b7b7e80a2f61884d;

});

parcelRegister("3XvFR", function(module, exports) {
/**
 * @generated SignedSource<<55bd5100cd9bfeca975d2cfff5c68ec3>>
 * @relayHash 8d03040d688843528ead855771e8246c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e77762aba0ebc1a12b0097564e9f8fce072dd0e08c861f47b22ab9799b0f4a00
const $019e619a88781c82$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ContentContributors",
            "kind": "LinkedField",
            "name": "contentContributors",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isCurrentUserContributor"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useCurrentUserContributorContentContributorsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useCurrentUserContributorContentContributorsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "8d03040d688843528ead855771e8246c",
            "id": "e77762aba0ebc1a12b0097564e9f8fce072dd0e08c861f47b22ab9799b0f4a00",
            "metadata": {},
            "name": "useCurrentUserContributorContentContributorsQuery",
            "operationKind": "query",
            "text": "query useCurrentUserContributorContentContributorsQuery($contentId:ID!){contentContributors(id:$contentId){isCurrentUserContributor}}"
        }
    };
}();
$019e619a88781c82$var$node.hash = "3529cb3bd09c95342e2b9b31b917a3c4";
var $019e619a88781c82$export$2e2bcd8739ae039 = $019e619a88781c82$var$node;
module.exports["default"] = $019e619a88781c82$export$2e2bcd8739ae039;

});

parcelRegister("dchHi", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $bQm3c = parcelRequire("bQm3c");

const $e12d220a6c6e853e$var$FEEDBACK_CONTEXT_CF = 'customfield_10047';
const $e12d220a6c6e853e$export$5b0d1a23cf38988 = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $e12d220a6c6e853e$export$eecedbc46bd36460 = ({ children: children, entrypointId: entrypointId, locale: locale, feedbackContextId: feedbackContextId = $e12d220a6c6e853e$var$FEEDBACK_CONTEXT_CF, feedbackContext: feedbackContext = {}, userId: userId, displayName: displayName })=>{
    const { displayName: sessionDisplayName, userId: sessionUserId } = (0, $bQm3c.useSessionData)();
    const { locale: intlLocale } = (0, $kSwu1.useIntl)();
    const feedbackContextString = Object.entries(feedbackContext).map(([key, value])=>`${key}: ${JSON.stringify(value)}`).join(' ');
    const contextValue = (0, $cozmU.useMemo)(()=>({
            entrypointId: entrypointId,
            feedbackContextId: feedbackContextId,
            feedbackContext: feedbackContextString,
            locale: locale || intlLocale,
            userId: userId || sessionUserId || undefined,
            displayName: displayName || sessionDisplayName || undefined
        }), [
        entrypointId,
        feedbackContextId,
        feedbackContextString,
        locale,
        intlLocale,
        userId,
        sessionUserId,
        displayName,
        sessionDisplayName
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e12d220a6c6e853e$export$5b0d1a23cf38988.Provider, {
        value: contextValue
    }, children);
};
const $e12d220a6c6e853e$export$e8f7cf9dc2b23528 = ()=>{
    const context = (0, $cozmU.useContext)($e12d220a6c6e853e$export$5b0d1a23cf38988);
    if (context === undefined) throw new Error('useFeedbackCollectorProperties must be used within a FeedbackCollectorPropertiesProvider');
    return context;
};
module.exports["FeedbackCollectorPropertiesProvider"] = $e12d220a6c6e853e$export$eecedbc46bd36460;
module.exports["useFeedbackCollectorProperties"] = $e12d220a6c6e853e$export$e8f7cf9dc2b23528;

});

parcelRegister("aUTn5", function(module, exports) {
/* eslint-disable no-restricted-globals */ 
var $2zMIV = parcelRequire("2zMIV");


var $kbVzJ = parcelRequire("kbVzJ");

const $92069b7b1bcb2285$export$c5bc138cfa79c2b2 = [
    // Legacy mention
    '.user-mention',
    // Fabric mention
    '[data-mention-id]',
    // Connect macro
    '.ap-container',
    // Links
    'a[href^="/"]',
    // Macros that doesn't have body
    '.conf-macro[data-hasbody="false"]',
    // Normal status
    '.status-lozenge-span',
    // Date will get rendered as "Today" in fabric
    '.date-lozenger-container',
    // Inline Smart Card/Jira issue link
    '[data-inline-card="true"]',
    '.inlineCardView-content-wrap',
    '.smart-link-title-wrapper',
    // Actual jira issue macro
    '.jira-issue',
    // Title for expand
    '.ak-renderer-extension-overflow-container button',
    '[data-node-type="expand"] > button',
    '[data-node-type="nestedExpand"] > button',
    // JIRA Macro
    '.jira-issues',
    // datasource table for new JIM macro
    '.datasource-table',
    // Inline file attachments
    "[data-type='file']",
    // Fabric code snippets
    '.code-block',
    // Legacy code snippets
    '.conf-macro[data-macro-name="code"]',
    // Sticky table headers (WS-2345 - Sticky header comment flow is strange for now, restrict until we can find a better solution)
    '.pm-table-sticky-wrapper',
    // Block cards
    '.blockCardView-content-wrap',
    // Excerpt Includes (WS-2563)
    '.ak-excerpt-include',
    // View All Container
    '#view-all-inline-comments-container',
    // Strikethrough
    's',
    // Emoji
    '[data-emoji-id]',
    // Charts
    "[data-mark-type='dataConsumer']",
    // Reattach Dialog
    '#reattach-container',
    // BEGIN EDITOR EXCLUSIONS
    //
    // Gadget?
    "[extensionkey='gadget']",
    // placeholder content
    'span[data-placeholder]',
    // covers most macros, would this be too encompassing?
    "[contenteditable='false']",
    // page include macro
    "[data-node-type='include']",
    // page properties report adf macro
    '.page-properties-report'
].join(',');
function $92069b7b1bcb2285$var$getSelectionHTML(selectionRange) {
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const div = document.createElement('div');
    div.appendChild(selectionRange.cloneContents());
    return div.innerHTML;
}
function $92069b7b1bcb2285$var$getContainingElement(selectionRange) {
    if (selectionRange.commonAncestorContainer) {
        const selectRangeElement = selectionRange.commonAncestorContainer;
        if (selectRangeElement.nodeType === 3) //Is TextNode
        return selectRangeElement.parentNode;
        return selectRangeElement;
    }
}
function $92069b7b1bcb2285$var$getFirstAndLastSelectionRect(selectionRange, clientRects) {
    // In Chrome triple clicking text will cause all the text in an element to be selected. When calling
    // getClientRects after a triple click, the array will contain rects for each line of highlighted text
    // in the highlighted element and also a clientRects for the adjacent sibling element even though no text
    // is highlighted inside it. If the endOffset is zero, we ignore this final clientRect because no text
    // is highlighted inside of it.
    //
    // Also, in Chrome, Safari and Firefox, get client rects return a clientRects representing each inline element
    // including rectangles for all nested elements. IE8 return many less rects, maybe just one for the ancestor
    // element containing the highlight or a clientRects for each line of highlight without individual rects for each
    // inline element
    const rects = {
        first: clientRects[0],
        last: clientRects[clientRects.length - 1]
    };
    if (selectionRange.endOffset !== 'undefined') //In IE, if we highlight on resolved inline comment, we will length of clientRects is 1
    {
        if (selectionRange.endOffset === 0 && clientRects.length > 1) rects.last = clientRects[clientRects.length - 2];
    }
    return rects;
}
function $92069b7b1bcb2285$var$getSelectionRects(selectionRange) {
    // if using documentation theme, get scrolltop of documentation theme content which is fixed size
    // certain browsers give the scrollTop on html element, some give it on the body element. this works in both.
    const scrollTop = window.scrollY;
    const scrollLeft = window.scrollX;
    let clientRects = selectionRange.getClientRects();
    // IE fails to provide client rects when highlighting a paragraph containing only an image or triple clicking to
    // highlight any paragraph containing content other than plain text. In this case, it is safe to assume parent
    // element dimensions will represent the highlighted area
    if (!clientRects.length && selectionRange.parentElement && selectionRange.parentElement()) {
        const parentElement = selectionRange.parentElement();
        const rect = parentElement.getBoundingClientRect();
        clientRects = [
            {
                top: rect.top,
                left: rect.left,
                bottom: rect.top + scrollTop + rect.height,
                right: rect.left + scrollLeft + rect.width
            }
        ];
    }
    const rects = $92069b7b1bcb2285$var$getFirstAndLastSelectionRect(selectionRange, clientRects);
    /*
   * Calculates Create Issue dialog target area
   */ const getOverlap = function(firstRect, lastRect) {
        const overlap = {};
        overlap.top = firstRect.top;
        overlap.left = (firstRect.left || 0) + scrollLeft;
        overlap.bottom = lastRect.bottom;
        if (firstRect.left !== undefined && firstRect.right !== undefined && lastRect.left !== undefined && lastRect.right !== undefined) {
            if (firstRect.left >= lastRect.right) overlap.right = firstRect.right;
            else overlap.right = lastRect.right;
        }
        overlap.right = (overlap.right || 0) + scrollLeft;
        // adjust top for doc theme
        overlap.top = (overlap.top || 0) + scrollTop;
        overlap.bottom = (overlap.bottom || 0) + scrollTop;
        // set width and height
        overlap.width = overlap.right - overlap.left;
        overlap.height = overlap.bottom - overlap.top;
        return overlap;
    };
    /*
   * Calculates the action panel target area
   */ const getHighlightStart = function(rect) {
        const highlight = {};
        if (!rect) return highlight;
        highlight.width = rect.right - rect.left;
        highlight.height = rect.bottom - rect.top;
        highlight.left = rect.left + scrollLeft;
        highlight.right = rect.right + scrollLeft;
        highlight.top = rect.top + scrollTop;
        highlight.bottom = rect.bottom + scrollTop;
        return highlight;
    };
    return {
        first: getHighlightStart(rects.first),
        average: getOverlap(rects.first, rects.last)
    };
}
function $92069b7b1bcb2285$var$getSelectionText(selectionRange) {
    return (0, $2zMIV.textNormalize)(String(selectionRange));
}
/**
 * Generates javascript object containing the context of the selected text to help locate in storage format
 *
 * @param root container of content which can be selected
 * @param selectedText text that currently highlighted
 * @param selected range object representing the current selection
 * @param pageId the page id we're currently on
 * @param includeTraceForMatches a boolean stating whether or not to include a tree trace for each match
 * @return object containing metadata about the location of the selected text
 */ function $92069b7b1bcb2285$var$computeSearchTextObject(root, selectedText, selected, pageId, includeTraceForMatches) {
    // WS-2345 - Sticky header create comment flow is strange for now, disabling it until a better solution is found
    // https://product-fabric.atlassian.net/browse/CEMS-1100
    //
    // sticky headers create duplicate tables to work, which causes duplicate
    // text content to end up in the inline comment text string. ignore sticky
    // table content when not visible, and vice versa.
    // const inSticky = findStickyHeader(selected.startContainer);
    // const ignoreTable: HTMLElement[] = Array.from(
    //   inSticky
    //     ? root.querySelectorAll(
    //         ".pm-table-container .pm-table-wrapper tr:first-of-type"
    //       )
    //     : root.querySelectorAll(".pm-table-sticky-wrapper")
    // );
    const ignoreTable = Array.from(root.querySelectorAll('.pm-table-sticky-wrapper'));
    const ignoredNodes = Array.from(root.querySelectorAll($92069b7b1bcb2285$export$c5bc138cfa79c2b2));
    const { text: text, nodesStartPos: nodesStartPos, nodes: nodes } = (0, $kbVzJ.indexTextNodes)(root, [
        ...ignoredNodes,
        ...ignoreTable
    ]);
    const { index: index, numMatches: numMatches, matchTraceList: matchTraceList } = (0, $kbVzJ.findMatches)(text, selectedText, selected.startContainer, selected.startOffset, nodesStartPos, nodes, includeTraceForMatches);
    const searchTextObj = {
        pageId: pageId,
        selectedText: selectedText,
        index: index,
        numMatches: numMatches
    };
    if (matchTraceList) searchTextObj.matchTraceList = matchTraceList;
    return searchTextObj;
}
function $92069b7b1bcb2285$export$4ba66d628a1e5980(contentContainer, selectionRange, pageId, lastModified, getTraceForMatches) {
    const rawText = $92069b7b1bcb2285$var$getSelectionText(selectionRange);
    const text = rawText.trim();
    let searchText;
    // It finds all the occurrences of selected text.
    // Since if I select word "is" there maybe a lot occurrences on the page.
    // searchText.index tells the backend which one is really the one I selected.
    // That is among, for example 20 matches, the 5th match is my selection.
    if (text) searchText = $92069b7b1bcb2285$var$computeSearchTextObject(contentContainer, // It is important to pass raw text here
    rawText, selectionRange, pageId, getTraceForMatches);
    return getTraceForMatches ? searchText.matchTraceList : {
        text: text,
        searchText: searchText,
        area: $92069b7b1bcb2285$var$getSelectionRects(selectionRange),
        html: $92069b7b1bcb2285$var$getSelectionHTML(selectionRange),
        containingElement: $92069b7b1bcb2285$var$getContainingElement(selectionRange),
        range: selectionRange,
        lastModified: lastModified
    };
}
function $92069b7b1bcb2285$export$b297c7070f7a854(contentContainer, selectionRange, pageId) {
    const matchTraceList = $92069b7b1bcb2285$export$4ba66d628a1e5980(contentContainer, selectionRange, pageId, null, true);
    return matchTraceList || [];
}
module.exports["IGNORE_SELECTORS"] = $92069b7b1bcb2285$export$c5bc138cfa79c2b2;
module.exports["convertSelectionToLegacyFormat"] = $92069b7b1bcb2285$export$4ba66d628a1e5980;
module.exports["getMatchTraces"] = $92069b7b1bcb2285$export$b297c7070f7a854;

});

parcelRegister("2zMIV", function(module, exports) {

var $7W8i8 = parcelRequire("7W8i8");


var $aUTn5 = parcelRequire("aUTn5");

const $15cdccae323ae129$var$logger = (0, $7W8i8.getLogger)('highlight-action');
const $15cdccae323ae129$export$4042f14350dc38e1 = (container, contentId)=>{
    const selection = window.getSelection();
    // getSelection() only returns null for iframes in firefox; in all other cases the type field is set to "None"
    if (!selection || selection?.type === 'None') return false;
    let legacyHighlight;
    try {
        legacyHighlight = (0, $aUTn5.convertSelectionToLegacyFormat)(container, selection.getRangeAt(0), contentId);
    } catch (err) {
        $15cdccae323ae129$var$logger.error`An error occurred while highlighting content - ${err}`;
    }
    if (!legacyHighlight || !legacyHighlight.searchText) return false;
    const { searchText: { selectedText: selectedText, index: index, numMatches: numMatches } } = legacyHighlight;
    /*
   * A valid highlight contains:
   *
   *   A selection that has a length (non-empty)
   *   A matched index (-1 means not found)
   *   A positive non-zero number of matches
   *   A match index that is less than the number of matches
   *
   */ return selectedText.replace(/\n/g, '').length > 0 && index !== -1 && numMatches > 0 && index < numMatches;
};
const $15cdccae323ae129$export$6c73cedfcc8a18f2 = ()=>{
    const selection = window.getSelection();
    if (!selection || selection?.type === 'None') return false;
    const range = $15cdccae323ae129$export$fef151b94550e9f5();
    if (!range) return false;
    const parentElement = $15cdccae323ae129$export$ab738b211369230e(range);
    return parentElement instanceof HTMLElement && Boolean(parentElement.closest('table'));
};
const $15cdccae323ae129$export$42b4db950c80743f = (s)=>{
    /*
    CONF-36789: on IE, selectionRange.toString() always convert all &nbsp; to normal space
    on other browsers, it does not. So we must convert manually to made consistency across all browsers
    */ return s.replace(/\u00a0/g, '\u0020');
};
const $15cdccae323ae129$export$fef151b94550e9f5 = ()=>{
    const selection = window.getSelection();
    // no selection made webkit
    if (!selection || selection.isCollapsed) return null;
    const selectionRange = selection.getRangeAt(0);
    // Don't show popup if selection is white space
    if (!String(selectionRange).trim()) return null;
    return selectionRange;
};
const $15cdccae323ae129$export$cfa2225e87938781 = (node)=>{
    const TEXT_NODE_TYPE = 3;
    if (!node) return null;
    if (node.nodeType !== TEXT_NODE_TYPE && node.scrollWidth > node.clientWidth) return node;
    else return $15cdccae323ae129$export$cfa2225e87938781(node.parentNode);
};
const $15cdccae323ae129$export$6fc0706fcfa876ec = (node)=>{
    const ELEMENT_NODE_TYPE = 1;
    if (!node) return null;
    if (node.nodeType === ELEMENT_NODE_TYPE) {
        if (node.classList.contains('pm-table-sticky-wrapper')) return node;
    }
    if (node.parentElement) return $15cdccae323ae129$export$6fc0706fcfa876ec(node.parentElement);
    return null;
};
const $15cdccae323ae129$export$ab738b211369230e = (selectionRange)=>{
    if (selectionRange.commonAncestorContainer) {
        const selectRangeElement = selectionRange.commonAncestorContainer;
        if (selectRangeElement.nodeType === 3) //Is TextNode
        return selectRangeElement.parentNode;
        return selectRangeElement;
    }
    return null;
};
module.exports["isHighlightValidForInlineComment"] = $15cdccae323ae129$export$4042f14350dc38e1;
module.exports["isHighlightValidForBulkCreateJiraIssues"] = $15cdccae323ae129$export$6c73cedfcc8a18f2;
module.exports["getRange"] = $15cdccae323ae129$export$fef151b94550e9f5;
module.exports["getContainingElement"] = $15cdccae323ae129$export$ab738b211369230e;
module.exports["textNormalize"] = $15cdccae323ae129$export$42b4db950c80743f;
module.exports["findStickyHeader"] = $15cdccae323ae129$export$6fc0706fcfa876ec;

});

parcelRegister("kbVzJ", function(module, exports) {
// eslint-disable-next-line import/no-cycle

var $2zMIV = parcelRequire("2zMIV");

const $567297790b62d2d4$var$TEXT_NODE_TYPE = 3;
function $567297790b62d2d4$export$2a4369abc54086f5(list, search, from) {
    const startPosInRange = Math.min(from, list.length - 1);
    let l = startPosInRange;
    let r = list.length;
    while(l < r){
        // This is a LEGACY disable statement after rule addition. Use `Math.floor((l+r)/2)` next time
        // eslint-disable-next-line no-bitwise
        const mid = l + r >> 1;
        if (list[mid] <= search) l = mid + 1;
        else r = mid;
    }
    return Math.max(l - 1, startPosInRange);
}
function $567297790b62d2d4$export$2605a3f2b4d7f885(root, ignoredNodes) {
    let textNode;
    let text = '';
    const nodesStartPos = [];
    const nodes = [];
    const nodeFilter = (textNode)=>{
        /**
     * If the text node is a descendent of one of the ignored node.
     * It means the text was rendered by maybe a macro.
     * Ignore these text nodes.
     */ return ignoredNodes.some((node)=>node === textNode || node.contains(textNode)) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
    };
    // createNodeIterator accepts an object with acceptNode field as node filter.
    // However IE 11 is expecting a function directly.
    nodeFilter.acceptNode = nodeFilter;
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const iter = document.createNodeIterator(root, NodeFilter.SHOW_TEXT, nodeFilter, false);
    while(textNode = iter.nextNode()){
        const normalizedText = (0, $2zMIV.textNormalize)(textNode.nodeValue);
        // WS-2885 - \u0020 represents the spacebar character so this regex handles any number of space only characters
        //           that may exist as their own nodes. We don't need to worry about only commenting on a space here
        //           because the popup has logic to only show itself if more than just a space is selected.
        if (/^\u0020+$/.test(normalizedText) || normalizedText.trim()) {
            // If it is not completely empty
            nodesStartPos.push(text.length);
            nodes.push(textNode);
            text += normalizedText;
        }
    }
    return {
        text: text,
        nodesStartPos: nodesStartPos,
        nodes: nodes
    };
}
function $567297790b62d2d4$var$getNodeTextLength(node) {
    return node && node.nodeValue ? node.nodeValue.length : 0;
}
function $567297790b62d2d4$export$f4585c00f32d9257(text, rawSelectedText, startContainer, startOffset, nodesStartPos, nodes, includeTraceForMatches) {
    const matchTraceList = [];
    if (!startContainer) return {
        numMatches: 0,
        index: -1,
        matchTraceList: null
    };
    let start = 0;
    let nodeStart = 0;
    let found = 0;
    let index = -1;
    let numMatches = 0;
    // loop through the provided text body string, starting from the beginning,
    // and update the index to search from until the rawSelectedtext can
    // no longer be found
    while((found = text.indexOf(rawSelectedText, start)) !== -1){
        // nodesStartPos is built by slowly concatenanting each non-empty text node value
        // together into a single string, and storing the index number at which the next string starts
        // with the matched index, find the nearest index value but return that index-1.
        // For example, if our match index is 10 and nodesStartPos = [0, 5, 11, 13],
        // we return index 1 (11 is the nearest but we want the index-1, 5).
        const pos = $567297790b62d2d4$export$2a4369abc54086f5(nodesStartPos, found, nodeStart);
        const textNode = nodes[pos];
        // In Firefox there is a case that startOffset is the end of a text node.
        // In this case it means the selection is actually starting from the next sibling node.
        let startNode = startContainer;
        if (startNode.nodeType === $567297790b62d2d4$var$TEXT_NODE_TYPE && startOffset >= $567297790b62d2d4$var$getNodeTextLength(startNode)) {
            startOffset -= $567297790b62d2d4$var$getNodeTextLength(startNode);
            startNode = startContainer.nextSibling;
        }
        if (startNode && (startNode.nodeType === $567297790b62d2d4$var$TEXT_NODE_TYPE && textNode === startNode || // Text node in IE 11 doesn't have contains method
        startNode.nodeType !== $567297790b62d2d4$var$TEXT_NODE_TYPE && startNode.contains(textNode))) {
            // The current text node might be the one we are selecting.
            // However a single text may have more than one match of the selected text.
            // We need to double check if the offset is correct.
            const offsetForCurrentFoundText = found - nodesStartPos[pos];
            if (offsetForCurrentFoundText <= startOffset) index = numMatches;
        }
        // Trace the text node back to the root if the flag is true
        if (includeTraceForMatches) {
            let element = textNode.parentElement;
            const parentElements = [];
            // We want to loop and record all the elements up to the div#content node
            while(element && element.getAttribute('id') !== 'content'){
                let classes = '';
                let attributes = '';
                const { tagName: tagName } = element;
                const classList = element.classList ? element.classList.value : '';
                const dataAttributes = element.getAttributeNames().filter((attribute)=>attribute.indexOf('data-') !== -1);
                // Handle classes
                if (classList.length) classes = `.${classList.split(' ').join('.')}`;
                // Handle data attributes
                if (dataAttributes.length) dataAttributes.forEach((attribute)=>{
                    // We don't want to get the value of the data-macro-body and data-title attributes
                    // because they can contain user information and we don't want to record it
                    if (attribute !== 'data-macro-body' && attribute !== 'data-title') {
                        // While it's "possible", we'll never actually get here if element is null
                        const value = element?.getAttribute(attribute);
                        attributes += `[${attribute}="${value}"]`;
                    } else attributes += `[${attribute}]`;
                });
                parentElements.unshift(`${tagName}${classes}${attributes}`);
                element = element.parentElement;
            }
            matchTraceList.push(parentElements.join(' > '));
        }
        numMatches++;
        start = found + 1;
        nodeStart = pos;
    }
    return {
        numMatches: numMatches,
        index: index,
        matchTraceList: matchTraceList.length ? matchTraceList : null
    };
}
module.exports["indexTextNodes"] = $567297790b62d2d4$export$2605a3f2b4d7f885;
module.exports["findMatches"] = $567297790b62d2d4$export$f4585c00f32d9257;

});

parcelRegister("a8ZQ3", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $0e1f4810033038ec$export$82f0a2c62bb8fbf = /*#__PURE__*/ (0, $cozmU.createContext)({
    documentUpdated: false,
    documentNeedsUpdate: false,
    publishedDocumentVersion: 0,
    currentDocumentVersion: 0
});
$0e1f4810033038ec$export$82f0a2c62bb8fbf.displayName = 'DocumentUpdateStatusContext';
const $0e1f4810033038ec$export$d35f8c93092bdd5a = /*#__PURE__*/ (0, $cozmU.createContext)({
    setDocumentUpdated: ()=>{},
    setDocumentNeedsUpdate: ()=>{},
    setPublishedDocumentVersion: ()=>{},
    setCurrentDocumentVersion: ()=>{}
});
$0e1f4810033038ec$export$d35f8c93092bdd5a.displayName = 'DocumentUpdateStatusDispatchContext';
const $0e1f4810033038ec$export$e1e6df7f9af5d046 = ({ children: children })=>{
    const [documentUpdated, setDocumentUpdated] = (0, $cozmU.useState)(false);
    const [documentNeedsUpdate, setDocumentNeedsUpdate] = (0, $cozmU.useState)(false);
    const [publishedDocumentVersion, setPublishedDocumentVersion] = (0, $cozmU.useState)(0);
    const [currentDocumentVersion, setCurrentDocumentVersion] = (0, $cozmU.useState)(0);
    const providerValue = (0, $cozmU.useMemo)(()=>({
            documentUpdated: documentUpdated,
            documentNeedsUpdate: documentNeedsUpdate,
            publishedDocumentVersion: publishedDocumentVersion,
            currentDocumentVersion: currentDocumentVersion
        }), [
        documentUpdated,
        documentNeedsUpdate,
        publishedDocumentVersion,
        currentDocumentVersion
    ]);
    const dispatchProviderValue = (0, $cozmU.useMemo)(()=>({
            setDocumentUpdated: setDocumentUpdated,
            setDocumentNeedsUpdate: setDocumentNeedsUpdate,
            setPublishedDocumentVersion: setPublishedDocumentVersion,
            setCurrentDocumentVersion: setCurrentDocumentVersion
        }), [
        setDocumentUpdated,
        setDocumentNeedsUpdate,
        setPublishedDocumentVersion,
        setCurrentDocumentVersion
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0e1f4810033038ec$export$82f0a2c62bb8fbf.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0e1f4810033038ec$export$d35f8c93092bdd5a.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $0e1f4810033038ec$export$ff9e1d20f8dc4075 = ()=>{
    return (0, $cozmU.useContext)($0e1f4810033038ec$export$82f0a2c62bb8fbf);
};
const $0e1f4810033038ec$export$317fac591d89e2e3 = ()=>{
    return (0, $cozmU.useContext)($0e1f4810033038ec$export$d35f8c93092bdd5a);
};
module.exports["DocumentUpdateStatusProvider"] = $0e1f4810033038ec$export$e1e6df7f9af5d046;
module.exports["useDocumentUpdateStatus"] = $0e1f4810033038ec$export$ff9e1d20f8dc4075;
module.exports["useDocumentUpdateStatusDispatch"] = $0e1f4810033038ec$export$317fac591d89e2e3;

});

parcelRegister("b0EGa", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $6d5fb7464c13acdf$var$initialState = {
    hideRequestCount: 0,
    hasReceivedHideRequest: false
};
const $6d5fb7464c13acdf$var$actions = {
    /**
	 * Request to hide the OmniBar. Call this when your component/popup opens.
	 * Must be paired with releaseHideOmniBar when the component closes.
	 */ requestHideOmniBar: ()=>({ setState: setState, getState: getState })=>{
            const { hideRequestCount: hideRequestCount } = getState();
            setState({
                hideRequestCount: hideRequestCount + 1,
                hasReceivedHideRequest: true
            });
        },
    /**
	 * Release a hide request. Call this when your component/popup closes.
	 * Must be paired with a previous requestHideOmniBar call.
	 */ releaseHideOmniBar: ()=>({ setState: setState, getState: getState })=>{
            const { hideRequestCount: hideRequestCount } = getState();
            if (hideRequestCount > 0) setState({
                hideRequestCount: hideRequestCount - 1
            });
        }
};
const $6d5fb7464c13acdf$export$11b4e542b178c9bc = (0, $8s9DV.createStore)({
    initialState: $6d5fb7464c13acdf$var$initialState,
    actions: $6d5fb7464c13acdf$var$actions,
    name: 'OmniBarVisibilityStore'
});
const $6d5fb7464c13acdf$export$c640b7434448a8d = (0, $kBr4q.createStateHook)($6d5fb7464c13acdf$export$11b4e542b178c9bc, {
    selector: (state)=>state.hideRequestCount > 0
});
const $6d5fb7464c13acdf$export$13aafec54f1ab41c = (0, $kBr4q.createStateHook)($6d5fb7464c13acdf$export$11b4e542b178c9bc, {
    selector: (state)=>state.hasReceivedHideRequest
});
const $6d5fb7464c13acdf$export$6c29083870fa1fac = (0, $kBr4q.createActionsHook)($6d5fb7464c13acdf$export$11b4e542b178c9bc);
module.exports["useShouldHideOmniBar"] = $6d5fb7464c13acdf$export$c640b7434448a8d;
module.exports["useHasReceivedOmniBarHideRequest"] = $6d5fb7464c13acdf$export$13aafec54f1ab41c;
module.exports["useOmniBarVisibilityActions"] = $6d5fb7464c13acdf$export$6c29083870fa1fac;

});

parcelRegister("hl0fg", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $55fM8 = parcelRequire("55fM8");

const $9b206d933744c82f$export$42c02f33970a2afa = ()=>{
    const isClient = typeof window === 'object';
    const getSize = ()=>{
        return {
            width: isClient ? window.innerWidth : 0,
            height: isClient ? window.innerHeight : 0
        };
    };
    const [windowSize, setWindowSize] = (0, $cozmU.useState)(getSize);
    (0, $cozmU.useEffect)(()=>{
        const handleResize = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(()=>{
            setWindowSize(getSize());
        }, 200);
        window.addEventListener('resize', handleResize);
        return ()=>{
            window.removeEventListener('resize', handleResize);
            handleResize.cancel();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Empty array ensures that effect is only run on mount and unmount
    return windowSize;
};
module.exports["useWindowSize"] = $9b206d933744c82f$export$42c02f33970a2afa;

});

parcelRegister("bjVRl", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $d2a35dc366472da4$var$initialState = {
    portalContainerRef: null,
    autohighlightText: '',
    autohighlightContext: '',
    sessionId: '',
    autohighlightSelectionRect: {
        top: 0,
        left: 0,
        width: 0,
        height: 0
    },
    autohighlightHovered: false,
    showPopup: false,
    popupLoading: false,
    showSpotlight: false,
    existingMap: new Map(),
    lastAcronymReset: ()=>{},
    defineDefinitionOpen: false
};
const $d2a35dc366472da4$export$e324594224ef24da = {
    showAutohighlightPopup: ({ autohighlightText: autohighlightText, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, lastAcronymReset: lastAcronymReset, sessionId: sessionId })=>({ setState: setState })=>{
            setState({
                autohighlightText: autohighlightText,
                autohighlightContext: autohighlightContext,
                autohighlightSelectionRect: autohighlightSelectionRect,
                lastAcronymReset: lastAcronymReset,
                sessionId: sessionId,
                showPopup: true,
                popupLoading: true
            });
        },
    hideAutohighlightPopup: ()=>({ setState: setState, getState: getState })=>{
            getState().lastAcronymReset();
            setState({
                ...getState(),
                showPopup: false,
                popupLoading: false
            });
        },
    setDefineDefinitionOpen: ({ defineDefinitionOpen: defineDefinitionOpen })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                defineDefinitionOpen: defineDefinitionOpen
            });
        },
    setAutohighlightPopupLoaded: ()=>({ setState: setState, getState: getState })=>{
            getState().lastAcronymReset();
            setState({
                ...getState(),
                popupLoading: false
            });
        },
    setAutohighlightHovered: ({ autohighlightHovered: autohighlightHovered })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                autohighlightHovered: autohighlightHovered
            });
        },
    showAutohighlightSpotlight: ({ autohighlightSelectionRect: autohighlightSelectionRect })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                showSpotlight: true,
                autohighlightSelectionRect: autohighlightSelectionRect
            });
        },
    setPortalContainerRef: ({ portalContainerRef: portalContainerRef })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                portalContainerRef: portalContainerRef
            });
        }
};
const $d2a35dc366472da4$export$f24428a461500521 = (0, $8s9DV.createStore)({
    initialState: $d2a35dc366472da4$var$initialState,
    actions: $d2a35dc366472da4$export$e324594224ef24da,
    name: 'readingAidsStore'
});
const $d2a35dc366472da4$export$c6f45fcecbb3630d = (0, $kBr4q.createActionsHook)($d2a35dc366472da4$export$f24428a461500521);
const $d2a35dc366472da4$export$94639db5354ca53c = (0, $kBr4q.createStateHook)($d2a35dc366472da4$export$f24428a461500521);
module.exports["useReadingAidsActions"] = $d2a35dc366472da4$export$c6f45fcecbb3630d;
module.exports["useReadingAidsState"] = $d2a35dc366472da4$export$94639db5354ca53c;

});

parcelRegister("7rLBD", function(module, exports) {

var $hpFQM = parcelRequire("hpFQM");

const $40851a06f2d6c64a$export$cd08f5c9e05f94dd = (contentId, cloudID, contentType)=>{
    if (!contentType) return '';
    return `ari:cloud:confluence:${cloudID}:${contentType}/${contentId}`;
};
const $40851a06f2d6c64a$export$8530183f316e301c = (activationId, cloudId)=>`ari:cloud:confluence:${cloudId}:workspace/${activationId}`;
const $40851a06f2d6c64a$export$b381579634332aed = (curatedDefinition)=>{
    const curatedDefinitionReference = curatedDefinition.confluenceEntity;
    return {
        nlpResult: curatedDefinition.definition,
        uniqueSources: curatedDefinitionReference ? [
            {
                id: curatedDefinitionReference?.id || '',
                title: curatedDefinitionReference?.title || '',
                url: curatedDefinition.referenceUrl || '',
                type: curatedDefinitionReference?.type || '',
                product: 'Confluence',
                lastModified: '',
                iconUrl: '',
                spaceName: curatedDefinitionReference?.space?.name || '',
                spaceUrl: null
            }
        ] : [],
        nlpResultEditor: curatedDefinition.editor?.name ? {
            name: curatedDefinition.editor.name || '',
            id: curatedDefinition.editor.accountId || ''
        } : undefined,
        disclaimer: null,
        errorState: null,
        format: (0, $hpFQM.NLPSearchResultFormat).MARKDOWN
    };
};
const $40851a06f2d6c64a$export$479750843803fc13 = 5;
const $40851a06f2d6c64a$export$f600f3124ea5916b = (nodes)=>{
    const categories = new Map();
    try {
        nodes.forEach((node)=>{
            const curCategoryCount = categories.get(node.category);
            if (!!curCategoryCount) categories.set(node.category, curCategoryCount + 1);
            else categories.set(node.category, 1);
        });
    } catch  {
        return undefined;
    }
    return Object.fromEntries(categories);
};
module.exports["generatePageARI"] = $40851a06f2d6c64a$export$cd08f5c9e05f94dd;
module.exports["generateWorkspaceId"] = $40851a06f2d6c64a$export$8530183f316e301c;
module.exports["READING_AIDS_MAX_WORD_COUNT"] = $40851a06f2d6c64a$export$479750843803fc13;
module.exports["getHighlightCategories"] = $40851a06f2d6c64a$export$f600f3124ea5916b;

});

parcelRegister("aKDZB", function(module, exports) {

var $cbY7C = parcelRequire("cbY7C");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $hdBxM = parcelRequire("hdBxM");


var $k1Pvg = parcelRequire("k1Pvg");


var $irnO2 = parcelRequire("irnO2");


var $kDDrf = parcelRequire("kDDrf");


var $bjY3F = parcelRequire("bjY3F");


var $8akfd = parcelRequire("8akfd");


var $8GyO5 = parcelRequire("8GyO5");


var $gRoSG = parcelRequire("gRoSG");


var $aXWtB = parcelRequire("aXWtB");


var $1AJi3 = parcelRequire("1AJi3");


var $6mKj3 = parcelRequire("6mKj3");


var $ep3mz = parcelRequire("ep3mz");


var $jyA9t = parcelRequire("jyA9t");


var $3OD5k = parcelRequire("3OD5k");


var $3rRes = parcelRequire("3rRes");


var $81UEG = parcelRequire("81UEG");


var $iMLPM = parcelRequire("iMLPM");


var $fj6ez = parcelRequire("fj6ez");


var $dnbZ2 = parcelRequire("dnbZ2");


var $koSDQ = parcelRequire("koSDQ");


var $7GTyD = parcelRequire("7GTyD");


var $alDoy = parcelRequire("alDoy");


var $7eOZ4 = parcelRequire("7eOZ4");


var $jNS1v = parcelRequire("jNS1v");


var $etOkO = parcelRequire("etOkO");


var $8L2yq = parcelRequire("8L2yq");


var $hxqA6 = parcelRequire("hxqA6");

const $c9c8b9d550aa1c05$var$constructDynamicUiSource = (adfDocument, selectionContext, contentType)=>{
    const fragmentAdf = (0, $3rRes.prepareRemixFragmentNodes)(selectionContext?.selectionFragment ?? null);
    return {
        contentType: contentType,
        startLocalId: selectionContext?.localIds?.[0] ?? '',
        endLocalId: selectionContext?.localIds?.[selectionContext.localIds.length - 1] ?? '',
        startIndex: selectionContext?.startIndex ?? 0,
        endIndex: selectionContext?.endIndex ?? -1,
        // When the entire page is selected (e.g. cmd+a), selectionContext is null and
        // selectionFragment is not populated. Fall back to the full document content
        // so that Remix still receives the source content it needs.
        fragmentAdf: fragmentAdf ?? adfDocument.content,
        fullAdf: adfDocument
    };
};
const $c9c8b9d550aa1c05$var$RENDERER_SELECTION_CONSUME_ONCE_KEY = 'renderer-selection-remix';
const $c9c8b9d550aa1c05$var$publishRendererRemixHandoffFailed = ()=>{
    // `rovo-remix-handoff-failed` is not in the merged PubSub Payload union yet,
    // so TypeScript will not accept it as a `publish()` argument without a cast.
    (0, $hdBxM.publish)((0, $k1Pvg.Topics).ROVO_REMIX, {
        type: 'rovo-remix-handoff-failed',
        source: $c9c8b9d550aa1c05$var$RENDERER_SELECTION_CONSUME_ONCE_KEY
    });
};
const $c9c8b9d550aa1c05$var$isRendererSelectionSubmit = (payload)=>payload.type === 'submit-rovo-remix' && payload.data.remixConsumer === 'renderer' && payload.data.remixPreset === 'selection';
const $c9c8b9d550aa1c05$var$ListenForSelectedContentRemixSubmit = ({ currentContentId: currentContentId, hasGenerationStarted: hasGenerationStarted, onAcceptSubmit: onAcceptSubmit, onDisarm: onDisarm, originContentIdRef: originContentIdRef })=>{
    const currentContentIdRef = (0, $cozmU.useRef)(currentContentId);
    currentContentIdRef.current = currentContentId;
    const hasGenerationStartedRef = (0, $cozmU.useRef)(hasGenerationStarted);
    hasGenerationStartedRef.current = hasGenerationStarted;
    const acceptedSubmitRef = (0, $cozmU.useRef)(false);
    const onAcceptSubmitRef = (0, $cozmU.useRef)(onAcceptSubmit);
    onAcceptSubmitRef.current = onAcceptSubmit;
    const onDisarmRef = (0, $cozmU.useRef)(onDisarm);
    onDisarmRef.current = onDisarm;
    const disarmIfIdle = (0, $cozmU.useCallback)(()=>{
        if (hasGenerationStartedRef.current || acceptedSubmitRef.current) return;
        onDisarmRef.current();
    }, []);
    (0, $hdBxM.useSubscribe)({
        topic: (0, $k1Pvg.Topics).ROVO_REMIX,
        consumeOnceKey: $c9c8b9d550aa1c05$var$RENDERER_SELECTION_CONSUME_ONCE_KEY
    }, (payload)=>{
        if (!$c9c8b9d550aa1c05$var$isRendererSelectionSubmit(payload) || payload.type !== 'submit-rovo-remix') return;
        const originContentId = originContentIdRef.current;
        if (originContentId && currentContentIdRef.current && originContentId !== currentContentIdRef.current) return;
        if (acceptedSubmitRef.current || hasGenerationStartedRef.current) return;
        acceptedSubmitRef.current = true;
        onAcceptSubmitRef.current({
            type: payload.data.remixOption,
            subType: payload.data.remixSubType,
            userPrompt: payload.data.userPrompt,
            conversationId: payload.data.conversationId
        }).then((result)=>{
            if (result.status === 'rejected') acceptedSubmitRef.current = false;
        }).catch(()=>{
            // Keep the listener retryable if an unexpected callback failure escapes.
            acceptedSubmitRef.current = false;
        });
    });
    (0, $hdBxM.useSubscribe)({
        topic: (0, $k1Pvg.Topics).AI_MATE
    }, (payload)=>{
        if (payload.type === 'chat-close') {
            disarmIfIdle();
            return;
        }
        if (payload.type === 'chat-new' && payload.data.resetActiveMenu) {
            disarmIfIdle();
            return;
        }
        if (payload.type !== 'open-rovo-remix-sidebar') return;
        if (payload.data.remixConsumer === 'renderer' && payload.data.remixPreset === 'selection') return;
        disarmIfIdle();
    });
    return null;
};
/**
 * Runs the Remix clean-up when the user closes the Rovo panel before choosing a Remix
 * option.
 *
 * Closing the Rovo panel sends no message that Confluence can listen for, so the only
 * way to notice it is to watch whether the panel is currently showing.
 *
 * The same click that arms the Remix flow also asks the panel to open, so there is a
 * short moment where the panel is not showing yet. Treating that moment as a close would
 * cancel the flow the instant it started, so a close is only acted on once the panel has
 * been seen showing at least once.
 */ const $c9c8b9d550aa1c05$var$CancelRemixWhenRovoPanelCloses = ({ onRovoPanelClosed: onRovoPanelClosed })=>{
    const { isConversationAssistantSidebarActive: isConversationAssistantSidebarActive, mode: mode } = (0, $1AJi3.useToggleConversationAssistant)();
    const isConversationAssistantOpen = isConversationAssistantSidebarActive || mode !== undefined;
    const hasSeenRovoPanelOpen = (0, $cozmU.useRef)(false);
    const onRovoPanelClosedRef = (0, $cozmU.useRef)(onRovoPanelClosed);
    onRovoPanelClosedRef.current = onRovoPanelClosed;
    (0, $cozmU.useEffect)(()=>{
        if (isConversationAssistantOpen) {
            hasSeenRovoPanelOpen.current = true;
            return;
        }
        if (!hasSeenRovoPanelOpen.current) return;
        onRovoPanelClosedRef.current();
    }, [
        isConversationAssistantOpen
    ]);
    return null;
};
const $c9c8b9d550aa1c05$var$RendererRemixCommandEffects = ({ isAdmittedRemixId: isAdmittedRemixId, onReady: onReady, onErrored: onErrored, onAborted: onAborted, onGenerationEnded: onGenerationEnded })=>{
    (0, $7GTyD.useRendererRemixCommands)(isAdmittedRemixId, {
        onReady: onReady,
        onErrored: onErrored,
        onAborted: onAborted,
        onGenerationEnded: onGenerationEnded
    });
    return null;
};
const $c9c8b9d550aa1c05$var$RendererRemixModal = ({ adfDocument: adfDocument, selectionContext: selectionContext, interactionSource: interactionSource, onClose: onClose, onFinalizeCommandSession: onFinalizeCommandSession, onStartThinking: onStartThinking, onStopThinking: onStopThinking, hiddenOptions: hiddenOptions, isEphemeralViewVisible: isEphemeralViewVisible, isRendererOverlayOpen: isRendererOverlayOpen, currentContentId: currentContentId, anchorRect: anchorRect, anchorElement: anchorElement, isThinking: isThinking, treatment: treatment })=>{
    const isMachineReadTreatment = treatment !== undefined;
    const machineLifecycle = treatment?.machineLifecycle;
    const parityDiagnostics = treatment?.parityDiagnostics;
    const [currentContentType] = (0, $ep3mz.useContentType)();
    const isRemixCancelled = (0, $cozmU.useRef)(false);
    const hasCommittedRemixCreateTerminal = (0, $cozmU.useRef)(false);
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    const { trackGenerationFailed: trackGenerationFailed, trackGenerationStarted: trackGenerationStarted, trackGenerationStopped: trackGenerationStopped, trackGenerationSucceeded: trackGenerationSucceeded, trackRemixSubmitted: trackRemixSubmitted } = (0, $alDoy.useRemixGenerationAnalytics)();
    const unavailableSpaceOptions = (0, $hxqA6.useShouldHideDiagramRemixOption)();
    const mergedHiddenOptions = unavailableSpaceOptions.length > 0 ? [
        ...hiddenOptions,
        ...unavailableSpaceOptions
    ] : hiddenOptions;
    const openAIFCStagingModalRef = (0, $cozmU.useRef)(()=>{});
    const selectedSubTypeRef = (0, $cozmU.useRef)(undefined);
    const conversationIdRef = (0, $cozmU.useRef)(undefined);
    const remixOriginContentIdRef = (0, $cozmU.useRef)(undefined);
    const abortOriginRef = (0, $cozmU.useRef)();
    const [isLegacyActionReady, setIsLegacyActionReady] = (0, $cozmU.useState)(false);
    const [positionedAnchorRect, setPositionedAnchorRect] = (0, $cozmU.useState)(anchorRect);
    const [popupRepositionKey, setPopupRepositionKey] = (0, $cozmU.useState)(0);
    const restartExperiencesAfterRejectedStart = (0, $cozmU.useCallback)((rejectionReason)=>{
        const restartAttributes = {
            entryPoint: 'renderer',
            remixSource: 'rejectedRemixStart',
            product: 'confluence',
            rejectionReason: rejectionReason,
            ...interactionSource !== undefined ? {
                originalRemixSource: interactionSource
            } : {}
        };
        hasCommittedRemixCreateTerminal.current = false;
        experienceTracker.start({
            name: (0, $irnO2.ExperienceName).REMIX_START,
            id: (0, $irnO2.ExperienceName).REMIX_START,
            attributes: restartAttributes
        });
        (0, $kDDrf.startRemixCreateExperience)({
            experienceTracker: experienceTracker,
            attributes: restartAttributes
        });
    }, [
        experienceTracker,
        interactionSource
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (remixOriginContentIdRef.current === undefined) remixOriginContentIdRef.current = currentContentId;
    }, [
        currentContentId
    ]);
    (0, $cozmU.useEffect)(()=>{
        setPositionedAnchorRect(anchorRect);
    }, [
        anchorRect
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!anchorElement) return;
        let animationFrameId;
        const updateAnchorPosition = ()=>{
            if (animationFrameId !== undefined) window.cancelAnimationFrame(animationFrameId);
            animationFrameId = window.requestAnimationFrame(()=>{
                // Keep the last known rect: the anchor can detach while the picker is opening.
                if (!anchorElement.isConnected) return;
                setPositionedAnchorRect(anchorElement.getBoundingClientRect());
                setPopupRepositionKey((key)=>key + 1);
            });
        };
        // `anchorRect` positions the initial render, so only follow on scroll/resize.
        const unbindScroll = (0, $cbY7C.bind)(window, {
            type: 'scroll',
            listener: updateAnchorPosition,
            options: {
                capture: true,
                passive: true
            }
        });
        const unbindResize = (0, $cbY7C.bind)(window, {
            type: 'resize',
            listener: updateAnchorPosition
        });
        return ()=>{
            unbindScroll();
            unbindResize();
            if (animationFrameId !== undefined) window.cancelAnimationFrame(animationFrameId);
        };
    }, [
        anchorElement
    ]);
    const { dynamicUiType: dynamicUiType } = (0, $8akfd.useStagingAreaState)();
    const { openConversationAssistant: openConversationAssistant } = (0, $1AJi3.useToggleConversationAssistant)();
    const onPreviewOpened = (0, $cozmU.useCallback)(()=>machineLifecycle?.onPreviewOpened(), [
        machineLifecycle
    ]);
    const onPreviewDismissed = (0, $cozmU.useCallback)(()=>machineLifecycle?.onPreviewDismissed() ?? false, [
        machineLifecycle
    ]);
    const stopMachineThinking = (0, $cozmU.useCallback)(()=>machineLifecycle?.onStopThinking() ?? false, [
        machineLifecycle
    ]);
    const onRovoAborted = (0, $cozmU.useCallback)(()=>machineLifecycle?.onRovoAborted(), [
        machineLifecycle
    ]);
    const onErrorDismissed = (0, $cozmU.useCallback)(()=>machineLifecycle?.onErrorDismissed(), [
        machineLifecycle
    ]);
    const onSendRejected = (0, $cozmU.useCallback)(()=>machineLifecycle?.onSendRejected() ?? false, [
        machineLifecycle
    ]);
    const onNavigation = (0, $cozmU.useCallback)(()=>machineLifecycle?.onNavigation() ?? false, [
        machineLifecycle
    ]);
    const dismissRendererRemixUiAfterNavigation = (0, $cozmU.useCallback)(()=>{
        const reason = 'User navigated away before renderer remix preview opened';
        isRemixCancelled.current = true;
        if (isMachineReadTreatment) {
            abortOriginRef.current = 'navigation';
            if (onNavigation()) return;
        }
        onStopThinking();
        onClose();
        experienceTracker.abort({
            name: (0, $irnO2.ExperienceName).REMIX_START,
            reason: reason,
            attributes: {
                reason: reason
            }
        });
        (0, $kDDrf.abortRemixCreateExperience)(experienceTracker, reason);
        (0, $irnO2.remixGeneratePreviewExperience).abort({
            metadata: {
                reason: reason
            }
        });
        if (!isMachineReadTreatment) onNavigation();
    }, [
        experienceTracker,
        isMachineReadTreatment,
        onClose,
        onNavigation,
        onStopThinking
    ]);
    const shouldOpenPreview = (0, $cozmU.useCallback)(()=>{
        if (isRemixCancelled.current && (0, $6mKj3.expVal)('cc_maui_polish_changes_batch_5', 'isEnabled', false)) return false;
        if (!(0, $iDrrr.fg)('cc-maui-phase-3')) return true;
        const originContentId = remixOriginContentIdRef.current;
        return !originContentId || !currentContentId || originContentId === currentContentId;
    }, [
        currentContentId
    ]);
    // Collapse the highlight overlay after the preview opens.
    const onAfterOpenPreview = (0, $cozmU.useCallback)(()=>{
        onClose({
            preservePreviewSession: true
        });
    }, [
        onClose
    ]);
    const { showProgressBar: showProgressBar, isComplete: isComplete, onCompleteAnimationFinished: onCompleteAnimationFinished, onActionReady: handlePreviewActionReady, resetCompletion: resetCompletion } = (0, $koSDQ.useRemixPreviewFlow)({
        entryPoint: 'renderer',
        experienceTracker: experienceTracker,
        dynamicUiType: dynamicUiType,
        selectedSubTypeRef: selectedSubTypeRef,
        openAIFCStagingModalRef: openAIFCStagingModalRef,
        isRemixCancelledRef: isRemixCancelled,
        conversationIdRef: conversationIdRef,
        shouldOpenPreview: shouldOpenPreview,
        onAfterOpenPreview: onAfterOpenPreview
    });
    const onActionReady = (0, $cozmU.useCallback)(()=>{
        if (!isRemixCancelled.current) trackGenerationSucceeded({
            conversationChannelId: conversationIdRef.current
        });
        handlePreviewActionReady();
    }, [
        handlePreviewActionReady,
        trackGenerationSucceeded
    ]);
    const onLegacyActionReady = (0, $cozmU.useCallback)(()=>{
        setIsLegacyActionReady(true);
        if (!isMachineReadTreatment) onActionReady();
    }, [
        isMachineReadTreatment,
        onActionReady
    ]);
    const handlePreviewDismissed = (0, $cozmU.useCallback)(()=>{
        if (isMachineReadTreatment) abortOriginRef.current = 'preview-dismissed';
        onPreviewDismissed();
    }, [
        isMachineReadTreatment,
        onPreviewDismissed
    ]);
    const { sendAIFCPrompt: sendAIFCPrompt, stopRemixing: stopRemixing, isRemixError: isRemixError, isRemixAborted: isRemixAborted, isRemixCancelled: wasRemixExplicitlyCancelled, remixStoreError: remixStoreError, remixConversationId: remixConversationId, openAIFCStagingModal: openAIFCStagingModal, closeAIFCStagingModal: closeAIFCStagingModal, resetRemixConversationId: resetRemixConversationId } = (0, $7eOZ4.useRemixToAIFC)({
        onActionReady: onLegacyActionReady,
        onPreviewOpened: onPreviewOpened,
        onPreviewDismissed: handlePreviewDismissed,
        trackRemixConversationById: true
    });
    openAIFCStagingModalRef.current = openAIFCStagingModal;
    const legacyRendererPhase = (0, $81UEG.deriveLegacyRendererRemixPhase)({
        isThinking: isThinking,
        isReady: isLegacyActionReady,
        isPreviewVisible: isEphemeralViewVisible,
        isError: isRemixError,
        isAborted: isRemixAborted,
        isCancelled: wasRemixExplicitlyCancelled
    });
    const machineRendererPhase = (0, $81UEG.deriveMachineRendererRemixPhase)(machineLifecycle?.phase);
    const rendererPhase = isMachineReadTreatment ? machineRendererPhase : legacyRendererPhase;
    (0, $cozmU.useEffect)(()=>{
        if (!parityDiagnostics) return;
        return parityDiagnostics.recordObservation({
            enabled: isMachineReadTreatment,
            remixId: machineLifecycle?.remixId,
            legacyPhase: legacyRendererPhase,
            machinePhase: machineRendererPhase
        });
    }, [
        isMachineReadTreatment,
        legacyRendererPhase,
        machineLifecycle?.remixId,
        machineRendererPhase,
        parityDiagnostics
    ]);
    // Preserve the legacy progress contract in control. Legacy `isThinking` remains true
    // through the normal ready interval, but unlike the normalized phase it does not revive
    // progress from stale completion state after a stopped flow reopens the picker.
    const isRendererRemixInProgress = isMachineReadTreatment ? rendererPhase === 'thinking' || rendererPhase === 'ready' : isThinking;
    const hasGenerationError = rendererPhase === 'error';
    const wasGenerationAborted = rendererPhase === 'aborted';
    const handleCommandReady = (0, $cozmU.useCallback)((command)=>{
        abortOriginRef.current = undefined;
        handlePreviewActionReady();
        if (!isRemixCancelled.current) trackGenerationSucceeded({
            conversationChannelId: command.conversationId
        });
    }, [
        handlePreviewActionReady,
        trackGenerationSucceeded
    ]);
    const handleCommandErrored = (0, $cozmU.useCallback)((command)=>{
        const commandStoreError = remixConversationId === command.conversationId ? remixStoreError : null;
        const errorMessage = commandStoreError?.content ?? 'Rovo agent error during remix';
        if (isEphemeralViewVisible) closeAIFCStagingModal();
        onClose({
            preserveCommandSession: true,
            preserveThinking: true
        });
        openConversationAssistant('sidebar');
        resetRemixConversationId();
        experienceTracker.fail({
            name: (0, $irnO2.ExperienceName).REMIX_START,
            error: new Error(errorMessage),
            attributes: {
                errorType: commandStoreError?.errorType,
                traceId: commandStoreError?.traceId,
                errorStatusCode: commandStoreError?.status_code
            }
        });
        (0, $irnO2.remixGeneratePreviewExperience).failure({
            metadata: {
                errorType: commandStoreError?.errorType,
                traceId: commandStoreError?.traceId
            }
        });
        trackGenerationFailed({
            conversationChannelId: command.conversationId
        });
    }, [
        closeAIFCStagingModal,
        experienceTracker,
        isEphemeralViewVisible,
        onClose,
        openConversationAssistant,
        remixConversationId,
        remixStoreError,
        resetRemixConversationId,
        trackGenerationFailed
    ]);
    const handleCommandAborted = (0, $cozmU.useCallback)((command)=>{
        const abortOrigin = abortOriginRef.current;
        resetCompletion();
        if (abortOrigin === 'preview-dismissed' || abortOrigin === 'send-rejected') return;
        if (abortOrigin === 'navigation') {
            const reason = 'User navigated away before renderer remix preview opened';
            onClose({
                preserveCommandSession: true,
                preserveThinking: true
            });
            experienceTracker.abort({
                name: (0, $irnO2.ExperienceName).REMIX_START,
                reason: reason,
                attributes: {
                    reason: reason
                }
            });
            (0, $kDDrf.abortRemixCreateExperience)(experienceTracker, reason);
            (0, $irnO2.remixGeneratePreviewExperience).abort({
                metadata: {
                    reason: reason
                }
            });
            return;
        }
        const reason = abortOrigin === 'local-stop' ? 'User cancelled remix thinking' : 'User stopped from Rovo side chat';
        if (abortOrigin !== 'local-stop') {
            // The modal store can lag the terminal conversation snapshot, so closing is
            // intentionally idempotent even when render-time visibility is still false.
            if ((0, $6mKj3.expVal)('cc_maui_polish_changes_batch_5', 'isEnabled', false)) {
                isRemixCancelled.current = true;
                closeAIFCStagingModal();
            } else if (isEphemeralViewVisible) closeAIFCStagingModal();
        }
        const closesRendererUi = abortOrigin !== 'local-stop' || (0, $iDrrr.fg)('platform_editor_ai_remix_close_modal_on_stop');
        if (closesRendererUi) onClose({
            preserveCommandSession: true,
            preserveThinking: true
        });
        try {
            if (abortOrigin === 'local-stop') {
                experienceTracker.abort({
                    name: (0, $irnO2.ExperienceName).REMIX_START,
                    reason: reason,
                    attributes: {
                        reason: reason
                    }
                });
                (0, $irnO2.remixGeneratePreviewExperience).abort({
                    metadata: {
                        reason: reason
                    }
                });
            }
            (0, $kDDrf.abortRemixCreateExperience)(experienceTracker, reason);
            trackGenerationStopped({
                conversationChannelId: command.conversationId
            });
        } finally{
            if (!closesRendererUi) {
                const restartAttributes = {
                    entryPoint: 'renderer',
                    remixSource: 'cancelledRemixThinking',
                    originalRemixSource: 'selectionToolbar',
                    product: 'confluence'
                };
                experienceTracker.start({
                    name: (0, $irnO2.ExperienceName).REMIX_START,
                    id: (0, $irnO2.ExperienceName).REMIX_START,
                    attributes: restartAttributes
                });
                (0, $kDDrf.startRemixCreateExperience)({
                    experienceTracker: experienceTracker,
                    attributes: restartAttributes
                });
            }
        }
    }, [
        closeAIFCStagingModal,
        experienceTracker,
        isEphemeralViewVisible,
        onClose,
        resetCompletion,
        trackGenerationStopped
    ]);
    const handleCommandGenerationEnded = (0, $cozmU.useCallback)((command)=>{
        const abortOrigin = abortOriginRef.current;
        const closesTreatmentSession = command.reason === 'error' || command.reason === 'aborted' && abortOrigin !== 'preview-dismissed' && abortOrigin !== 'send-rejected' && (abortOrigin !== 'local-stop' || (0, $iDrrr.fg)('platform_editor_ai_remix_close_modal_on_stop'));
        if (abortOrigin !== 'preview-dismissed') onStopThinking({
            reopenModal: command.reason === 'ready' || abortOrigin === 'send-rejected' || abortOrigin === 'local-stop' && !(0, $iDrrr.fg)('platform_editor_ai_remix_close_modal_on_stop')
        });
        if (command.reason === 'error') onErrorDismissed();
        else if (command.reason === 'aborted' && abortOrigin === undefined) onRovoAborted();
        if (closesTreatmentSession) onFinalizeCommandSession();
        abortOriginRef.current = undefined;
    }, [
        onErrorDismissed,
        onFinalizeCommandSession,
        onRovoAborted,
        onStopThinking
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $iDrrr.fg)('cc-maui-phase-3')) return;
        const originContentId = remixOriginContentIdRef.current;
        if (!originContentId || !currentContentId || originContentId === currentContentId) return;
        dismissRendererRemixUiAfterNavigation();
    }, [
        currentContentId,
        dismissRendererRemixUiAfterNavigation
    ]);
    // Abort experience on unmount (overlay closed without selecting an option).
    // Uses a ref so the cleanup always calls the latest tracker reference.
    const experienceTrackerRef = (0, $cozmU.useRef)(experienceTracker);
    experienceTrackerRef.current = experienceTracker;
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            experienceTrackerRef.current.abort({
                name: (0, $irnO2.ExperienceName).REMIX_START,
                reason: 'User closed remix overlay',
                attributes: {
                    reason: 'User closed remix overlay'
                }
            });
            (0, $kDDrf.abortRemixCreateExperienceIfNotCommitted)(experienceTrackerRef.current, hasCommittedRemixCreateTerminal.current);
        };
    }, []);
    const onRemixFlowActiveChange = (0, $cozmU.useCallback)((active)=>{
        if (active) {
            isRemixCancelled.current = false;
            abortOriginRef.current = undefined;
            // Clear stale completion state from any previous flow.
            resetCompletion();
            setIsLegacyActionReady(false);
            onStartThinking();
        } else {
            isRemixCancelled.current = true;
            // A stopped flow can already have reached the completed-progress interval.
            // Clear it before reopening so control does not render a stale ready picker.
            resetCompletion();
            setIsLegacyActionReady(false);
            if (isMachineReadTreatment) {
                abortOriginRef.current = 'local-stop';
                remixOriginContentIdRef.current = undefined;
                let didApplyTerminalEvent = false;
                try {
                    stopRemixing();
                    parityDiagnostics?.recordLegacyTerminal(machineLifecycle?.remixId, 'aborted');
                } finally{
                    didApplyTerminalEvent = stopMachineThinking();
                }
                if (!didApplyTerminalEvent) {
                    const reason = 'User cancelled remix thinking';
                    if ((0, $iDrrr.fg)('platform_editor_ai_remix_close_modal_on_stop')) onClose();
                    else onStopThinking({
                        reopenModal: true
                    });
                    try {
                        experienceTracker.abort({
                            name: (0, $irnO2.ExperienceName).REMIX_START,
                            reason: reason,
                            attributes: {
                                reason: reason
                            }
                        });
                        (0, $kDDrf.abortRemixCreateExperience)(experienceTracker, reason);
                        (0, $irnO2.remixGeneratePreviewExperience).abort({
                            metadata: {
                                reason: reason
                            }
                        });
                        trackGenerationStopped({
                            conversationChannelId: conversationIdRef.current
                        });
                    } finally{
                        if (!(0, $iDrrr.fg)('platform_editor_ai_remix_close_modal_on_stop')) {
                            const restartAttributes = {
                                entryPoint: 'renderer',
                                remixSource: 'cancelledRemixThinking',
                                originalRemixSource: 'selectionToolbar',
                                product: 'confluence'
                            };
                            experienceTracker.start({
                                name: (0, $irnO2.ExperienceName).REMIX_START,
                                id: (0, $irnO2.ExperienceName).REMIX_START,
                                attributes: restartAttributes
                            });
                            (0, $kDDrf.startRemixCreateExperience)({
                                experienceTracker: experienceTracker,
                                attributes: restartAttributes
                            });
                        }
                    }
                }
                return;
            }
            // Abort the current experience before stopping
            experienceTracker.abort({
                name: (0, $irnO2.ExperienceName).REMIX_START,
                reason: 'User cancelled remix thinking',
                attributes: {
                    reason: 'User cancelled remix thinking'
                }
            });
            (0, $kDDrf.abortRemixCreateExperience)(experienceTracker, 'User cancelled remix thinking');
            (0, $irnO2.remixGeneratePreviewExperience).abort({
                metadata: {
                    reason: 'User cancelled remix thinking'
                }
            });
            trackGenerationStopped();
            remixOriginContentIdRef.current = undefined;
            try {
                stopRemixing();
                parityDiagnostics?.recordLegacyTerminal(machineLifecycle?.remixId, 'aborted');
            } finally{
                stopMachineThinking();
            }
            if ((0, $iDrrr.fg)('platform_editor_ai_remix_close_modal_on_stop')) onClose();
            else {
                // Start a new experience for the reopened overlay
                const restartAttributes = {
                    entryPoint: 'renderer',
                    remixSource: 'cancelledRemixThinking',
                    originalRemixSource: 'selectionToolbar',
                    product: 'confluence'
                };
                experienceTracker.start({
                    name: (0, $irnO2.ExperienceName).REMIX_START,
                    id: (0, $irnO2.ExperienceName).REMIX_START,
                    attributes: restartAttributes
                });
                (0, $kDDrf.startRemixCreateExperience)({
                    experienceTracker: experienceTracker,
                    attributes: restartAttributes
                });
                onStopThinking({
                    reopenModal: true
                });
            }
        }
    }, [
        onStartThinking,
        stopRemixing,
        stopMachineThinking,
        onClose,
        onStopThinking,
        experienceTracker,
        resetCompletion,
        parityDiagnostics,
        machineLifecycle?.remixId,
        trackGenerationStopped,
        isMachineReadTreatment
    ]);
    // Fail experience and clean up thinking UI when Rovo encounters an error
    const prevHasGenerationError = (0, $cozmU.useRef)(hasGenerationError);
    (0, $cozmU.useEffect)(()=>{
        if (!isMachineReadTreatment && !prevHasGenerationError.current && hasGenerationError && !isRemixCancelled.current) {
            const errorMessage = remixStoreError?.content ?? 'Rovo agent error during remix';
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).REMIX_START,
                error: new Error(errorMessage),
                attributes: {
                    errorType: remixStoreError?.errorType,
                    traceId: remixStoreError?.traceId,
                    errorStatusCode: remixStoreError?.status_code
                }
            });
            (0, $irnO2.remixGeneratePreviewExperience).failure({
                metadata: {
                    errorType: remixStoreError?.errorType,
                    traceId: remixStoreError?.traceId
                }
            });
            trackGenerationFailed({
                conversationChannelId: conversationIdRef.current
            });
            onStopThinking({
                reopenModal: true
            });
        }
        prevHasGenerationError.current = hasGenerationError;
    }, [
        hasGenerationError,
        isMachineReadTreatment,
        remixStoreError,
        onStopThinking,
        experienceTracker,
        trackGenerationFailed
    ]);
    // When an error occurs during remix, close the thinking bar and ephemeral
    // preview, then open the Rovo chat sidebar so the user can see the error.
    (0, $cozmU.useEffect)(()=>{
        if (!isMachineReadTreatment && !isRemixCancelled.current && hasGenerationError) {
            // Close the ephemeral preview (staging modal) if it is open
            if (isEphemeralViewVisible) // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- terminal cleanup intentionally settles each existing product store
            closeAIFCStagingModal();
            // Close the thinking bar and dismiss the remix UI
            onStopThinking();
            onClose();
            // Open the Rovo chat sidebar to display the error information.
            // `openConversationAssistant` is idempotent (no-op if already
            // open), so it is safe to call on every render where
            // the selected phase is `error` — no infinite toggle loop.
            openConversationAssistant('sidebar');
            // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- terminal cleanup intentionally settles each existing product store
            resetRemixConversationId();
            onErrorDismissed();
        }
    }, [
        hasGenerationError,
        isMachineReadTreatment,
        isEphemeralViewVisible,
        closeAIFCStagingModal,
        onStopThinking,
        onClose,
        openConversationAssistant,
        resetRemixConversationId,
        onErrorDismissed
    ]);
    // Dismiss the thinking bar and clear the selection highlight when the user
    // stops the remix from the Rovo side chat.
    (0, $cozmU.useEffect)(()=>{
        if (!isMachineReadTreatment && wasGenerationAborted && !isRemixCancelled.current) {
            const reason = 'User stopped from Rovo side chat';
            if ((0, $6mKj3.expVal)('cc_maui_polish_changes_batch_5', 'isEnabled', false)) {
                isRemixCancelled.current = true;
                resetCompletion();
                // The modal store visibility can lag behind action readiness for
                // non-streaming remix types. Closing is idempotent, so do it even
                // when the render-time visibility snapshot is still false.
                // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- terminal cleanup intentionally settles each existing product store
                closeAIFCStagingModal();
            } else if (isEphemeralViewVisible) // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- terminal cleanup intentionally settles each existing product store
            closeAIFCStagingModal();
            (0, $kDDrf.abortRemixCreateExperience)(experienceTracker, reason);
            trackGenerationStopped({
                conversationChannelId: conversationIdRef.current
            });
            onStopThinking();
            onClose();
            onRovoAborted();
        }
    }, [
        wasGenerationAborted,
        isMachineReadTreatment,
        isEphemeralViewVisible,
        closeAIFCStagingModal,
        onStopThinking,
        onClose,
        experienceTracker,
        onRovoAborted,
        resetCompletion,
        trackGenerationStopped
    ]);
    const handleOptionSelect = (0, $cozmU.useCallback)(async ({ type: type, subType: subType, userPrompt: userPrompt, conversationId: conversationId })=>{
        // Only a submission from the Rovo sidebar carries a conversationId, and the Rovo
        // sidebar is only shown to the variant2 cohort. Its `userPrompt` is already the
        // complete sentence shown in the chat input, so passing that sentence as
        // `promptText` stops `sendAIFCPrompt` from writing a second copy of the same
        // sentence and joining the two together. Checking the cohort as well as the
        // conversationId guarantees that anyone outside the experiment keeps the original
        // behaviour, even if some future caller starts supplying a conversationId.
        const isRovoChatSubmission = conversationId !== undefined && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-ce-maui-remix-menu-multivariant', 'cohort', 'variant2');
        remixOriginContentIdRef.current = remixOriginContentIdRef.current ?? currentContentId;
        selectedSubTypeRef.current = subType;
        const dynamicUiSource = $c9c8b9d550aa1c05$var$constructDynamicUiSource(adfDocument, selectionContext, (0, $3OD5k.resolveRemixDynamicUiContentType)(currentContentType));
        let authoritativeConversationId = conversationId;
        let cancellationSessionId;
        if (machineLifecycle) {
            const admission = machineLifecycle.startFlow({
                conversationId: conversationId,
                dynamicUiType: type,
                dynamicUiSubtype: subType,
                source: interactionSource
            });
            if (!admission.admitted) {
                if (admission.reason !== 'active-flow') {
                    const admissionError = new Error(`Renderer Remix machine admission was rejected: ${admission.reason}`);
                    experienceTracker.fail({
                        name: (0, $irnO2.ExperienceName).REMIX_START,
                        error: admissionError,
                        attributes: {
                            reason: admissionError.message,
                            rejectionReason: admission.reason
                        }
                    });
                    (0, $kDDrf.abortRemixCreateExperience)(experienceTracker, admissionError.message);
                    restartExperiencesAfterRejectedStart(admission.reason);
                }
                onStopThinking({
                    reopenModal: true
                });
                return {
                    status: 'rejected',
                    reason: 'admission-rejected'
                };
            }
            authoritativeConversationId = admission.conversationId;
            cancellationSessionId = admission.cancellationSessionId;
        }
        experienceTracker.updateAttributes({
            name: (0, $irnO2.ExperienceName).REMIX_START,
            attributes: {
                remixType: type,
                remixSubtype: subType,
                includesFreegenPrompt: !!userPrompt
            }
        });
        (0, $irnO2.remixGeneratePreviewExperience).start();
        (0, $irnO2.remixGeneratePreviewExperience).mark((0, $irnO2.REMIX_GENERATE_PREVIEW_MARKS).SUBMIT);
        (0, $irnO2.remixGeneratePreviewExperience).addMetadata({
            product: 'confluence',
            interactionSource: interactionSource,
            entryPoint: 'renderer',
            remixType: type,
            remixSubtype: subType,
            includesFreegenPrompt: !!userPrompt,
            ...type === 'infographic' ? {
                isConfluenceInfographicsTwoStageEnabled: (0, $iDrrr.fg)('confluence-infographics-two-stage')
            } : {}
        });
        const generationAnalyticsAttributes = {
            contentId: currentContentId,
            ...conversationId && {
                conversationChannelId: conversationId
            },
            entryPoint: 'renderer',
            includesFreegenPrompt: !!userPrompt,
            product: 'confluence',
            remixSource: interactionSource,
            remixSubtype: subType,
            remixType: type
        };
        trackRemixSubmitted(generationAnalyticsAttributes);
        trackGenerationStarted(generationAnalyticsAttributes);
        let conversationChannelId;
        try {
            conversationChannelId = await sendAIFCPrompt({
                userPrompt: isRovoChatSubmission ? undefined : userPrompt,
                promptText: isRovoChatSubmission ? userPrompt : undefined,
                dynamicUiType: type,
                dynamicUiSubtype: subType,
                dynamicUiSource: dynamicUiSource,
                interactionSource: interactionSource,
                ...authoritativeConversationId !== undefined ? {
                    conversationId: authoritativeConversationId
                } : {},
                ...cancellationSessionId !== undefined ? {
                    remixCancellationSessionId: cancellationSessionId
                } : {}
            });
        } catch (error) {
            if (isMachineReadTreatment) abortOriginRef.current = 'send-rejected';
            const didApplyTerminalEvent = onSendRejected();
            if (isMachineReadTreatment && !didApplyTerminalEvent) onStopThinking({
                reopenModal: true
            });
            if ((0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-ce-maui-remix-menu-multivariant', 'cohort', 'variant2')) $c9c8b9d550aa1c05$var$publishRendererRemixHandoffFailed();
            const sendError = error instanceof Error ? error : new Error('Failed to send renderer Remix prompt');
            const reason = 'Failed to send renderer Remix prompt';
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).REMIX_START,
                error: sendError,
                attributes: {
                    reason: reason,
                    rejectionReason: 'send-failed'
                }
            });
            (0, $irnO2.remixGeneratePreviewExperience).failure({
                metadata: {
                    reason: reason
                }
            });
            trackGenerationFailed();
            (0, $kDDrf.failRemixCreateExperience)(experienceTracker, sendError, {
                reason: reason,
                rejectionReason: 'send-failed'
            });
            restartExperiencesAfterRejectedStart('send-failed');
            if (!isMachineReadTreatment) onStopThinking({
                reopenModal: true
            });
            return {
                status: 'rejected',
                reason: 'send-failed'
            };
        }
        // Stash the conversationId so `useRemixPreviewFlow` can include it as
        // `conversationChannelId` on the REMIX_RENDERS_IN_MODAL start attributes
        // once `onActionReady` fires.
        conversationIdRef.current = conversationChannelId;
        experienceTracker.updateAttributes({
            name: (0, $irnO2.ExperienceName).REMIX_START,
            attributes: {
                conversationChannelId: conversationChannelId
            }
        });
        hasCommittedRemixCreateTerminal.current = true;
        (0, $kDDrf.trackRemixCreateOptionSelected)({
            experienceTracker: experienceTracker,
            conversationId: conversationChannelId,
            remixType: type,
            remixSubtype: subType,
            includesFreegenPrompt: !!userPrompt
        });
        return {
            status: 'started'
        };
    }, [
        sendAIFCPrompt,
        adfDocument,
        selectionContext,
        currentContentType,
        interactionSource,
        experienceTracker,
        currentContentId,
        isMachineReadTreatment,
        machineLifecycle,
        onSendRejected,
        onStopThinking,
        restartExperiencesAfterRejectedStart,
        trackGenerationFailed,
        trackGenerationStarted,
        trackRemixSubmitted
    ]);
    const acceptRovoRemixSubmit = (0, $cozmU.useCallback)((params)=>{
        onRemixFlowActiveChange(true);
        return handleOptionSelect(params);
    }, [
        handleOptionSelect,
        onRemixFlowActiveChange
    ]);
    const shouldShowOriginalRemixPopUpWindow = isRendererRemixInProgress || !(0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-ce-maui-remix-menu-multivariant', 'cohort', 'variant2');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, machineLifecycle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c9c8b9d550aa1c05$var$RendererRemixCommandEffects, {
        isAdmittedRemixId: machineLifecycle.isAdmittedRemixId,
        onReady: handleCommandReady,
        onErrored: handleCommandErrored,
        onAborted: handleCommandAborted,
        onGenerationEnded: handleCommandGenerationEnded
    }), isRendererOverlayOpen && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-ce-maui-remix-menu-multivariant', 'cohort', 'variant2') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c9c8b9d550aa1c05$var$ListenForSelectedContentRemixSubmit, {
        currentContentId: currentContentId,
        hasGenerationStarted: isRendererRemixInProgress,
        onAcceptSubmit: acceptRovoRemixSubmit,
        onDisarm: onClose,
        originContentIdRef: remixOriginContentIdRef
    }), isRendererOverlayOpen && shouldShowOriginalRemixPopUpWindow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8GyO5.RemixContainer), {
        onClose: ()=>onClose(),
        hiddenOptions: mergedHiddenOptions,
        onOptionSelect: handleOptionSelect,
        onRemixFlowActiveChange: onRemixFlowActiveChange,
        isEphemeralViewVisible: isEphemeralViewVisible,
        showProgressBar: showProgressBar,
        isComplete: isComplete,
        onCompleteAnimationFinished: onCompleteAnimationFinished,
        // Classic view page: center the fixed thinking bar over the rendered content area.
        // Safe here because the view page has a stable layout (unlike the editor, whose
        // reflows would make the one-shot content measurement drift).
        shouldMeasureContentBounds: true,
        // The view floating toolbar provides a live element that is remeasured as it moves.
        // Snapshot-only renderer entries, such as the nudge, still close on external scroll.
        anchorRect: positionedAnchorRect,
        popupRepositionKey: popupRepositionKey,
        shouldCloseOnScroll: !anchorElement,
        isThinking: isMachineReadTreatment ? isRendererRemixInProgress : isRendererRemixInProgress && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-ce-maui-remix-menu-multivariant', 'cohort', 'variant2') ? true : undefined,
        // The nudge icon sits at the top-right of a block; flying the popup out to the right
        // would frequently clip against the viewport edge, so it opens to the left instead.
        popupPlacement: interactionSource === 'remixModalFromViewPageNudge' ? 'bottom-end' : 'bottom-start',
        // Match the view selection toolbar's ellipsis DropdownMenu default offset.
        popupOffset: [
            0,
            8
        ]
    }));
};
const $c9c8b9d550aa1c05$var$RendererRemixContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    openRemixModal: ()=>{},
    closeRemixModal: ()=>{},
    clearRemixHighlight: ()=>{},
    isRemixDisabled: false,
    isRemixing: false,
    isRemixInProgress: false,
    isRemixBlockingNewTargets: false,
    isAnyRemixing: false,
    remixInteractionSource: undefined,
    registerOnModalClose: ()=>()=>{}
});
const $c9c8b9d550aa1c05$export$c881c5d3c5870780 = ()=>{
    return (0, $cozmU.useContext)($c9c8b9d550aa1c05$var$RendererRemixContext);
};
const $c9c8b9d550aa1c05$var$RendererRemixContainerImpl = ({ children: children, contentId: contentId, treatment: treatment })=>{
    const isRemixAvailable = (0, $dnbZ2.useIsRemixAvailable)();
    // Prefetch only attachment permission. Existing space-type checks remain modal-local.
    const hiddenOptions = (0, $hxqA6.useShouldHideAttachmentRemixOptions)({
        enabled: isRemixAvailable
    });
    const isMachineReadTreatment = treatment !== undefined;
    const isAnyRemixing = treatment?.isAnyRemixing ?? false;
    const [isModalOpen, setIsModalOpen] = (0, $cozmU.useState)(false);
    const [adfDocument, setAdfDocument] = (0, $cozmU.useState)(null);
    const [selectionContext, setSelectionContext] = (0, $cozmU.useState)(null);
    const [isThinking, setIsThinking] = (0, $cozmU.useState)(false);
    const [anchorRect, setAnchorRect] = (0, $cozmU.useState)(undefined);
    const [anchorElement, setAnchorElement] = (0, $cozmU.useState)(undefined);
    const [remixInteractionSource, setRemixInteractionSource] = (0, $cozmU.useState)(undefined);
    const { startHighlight: startHighlight, clearHighlight: clearHighlight } = (0, $jNS1v.useRendererRemixHighlight)();
    const { showSmartCreationModal: showSmartCreationModal } = (0, $jyA9t.useSmartCreationModalState)();
    const onModalCloseCallbacks = (0, $cozmU.useRef)(new Set());
    const registerOnModalClose = (0, $cozmU.useCallback)((callback)=>{
        onModalCloseCallbacks.current.add(callback);
        return ()=>{
            onModalCloseCallbacks.current.delete(callback);
        };
    }, []);
    const clearModalSession = (0, $cozmU.useCallback)(()=>{
        setAdfDocument(null);
        setSelectionContext(null);
        setRemixInteractionSource(undefined);
        setAnchorRect(undefined);
        setAnchorElement(undefined);
    }, []);
    const prevShowSmartCreationModal = (0, $cozmU.useRef)(showSmartCreationModal);
    (0, $cozmU.useEffect)(()=>{
        if (prevShowSmartCreationModal.current && !showSmartCreationModal) {
            clearHighlight();
            // Smart Creation owns the preview and can close outside this container's closeModal path.
            // Release the renderer session when that external modal-store transition completes.
            // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates
            clearModalSession();
        }
        prevShowSmartCreationModal.current = showSmartCreationModal;
    }, [
        showSmartCreationModal,
        clearHighlight,
        clearModalSession
    ]);
    const openModal = (0, $cozmU.useCallback)((newAdfDocument, selection, interactionSource, newAnchorRect, newAnchorElement)=>{
        // Record the Remix menu experiment exposure here. This is the one point that the
        // selection toolbar and the nudge both call for every cohort, and it is where the
        // cohort decides which Remix picker the person is about to see. Recording it further
        // downstream, once each cohort's own picker had appeared, undercounted the variant2
        // group, because their picker only appears after the Rovo side panel and two lazily
        // loaded chunks have all arrived.
        (0, $6mKj3.expVal)('cc-ce-maui-remix-menu-multivariant', 'cohort', 'control');
        (0, $6mKj3.expVal)('cc-ce-maui-remix-menu-multivariant-aa', 'variant', 'control');
        if (isMachineReadTreatment) // Only treatment admits a machine flow from this modal. The background-phase watcher
        // host may not have loaded yet on a fresh page, so start its fetch now for that flow.
        (0, $iMLPM.preloadRemixWatcherHost)();
        setAdfDocument(newAdfDocument);
        startHighlight();
        setSelectionContext(selection);
        setRemixInteractionSource(interactionSource);
        setAnchorRect(newAnchorRect);
        setAnchorElement(newAnchorElement);
        setIsModalOpen(true);
    }, [
        isMachineReadTreatment,
        startHighlight
    ]);
    const closeModal = (0, $cozmU.useCallback)((options)=>{
        if (!options?.preservePreviewSession) clearHighlight();
        onModalCloseCallbacks.current.forEach((cb)=>cb());
        setIsModalOpen(false);
        if (!options?.preserveThinking) setIsThinking(false);
        // Treatment keeps the phase-consuming modal subtree mounted while the Smart Creation
        // preview is open, so watcher terminal phases can drive renderer UX before teardown.
        if (!options?.preservePreviewSession && !options?.preserveCommandSession || !isMachineReadTreatment) clearModalSession();
    }, [
        clearHighlight,
        clearModalSession,
        isMachineReadTreatment
    ]);
    const onStartThinking = (0, $cozmU.useCallback)(()=>{
        setIsThinking(true);
        setIsModalOpen(false);
    }, []);
    const onStopThinking = (0, $cozmU.useCallback)((options)=>{
        setIsThinking(false);
        if (options?.reopenModal) setIsModalOpen(true);
    }, []);
    const rendererPhase = treatment ? (0, $81UEG.deriveMachineRendererRemixPhase)(treatment.machineLifecycle.phase) : (0, $81UEG.deriveLegacyRendererRemixPhase)({
        isThinking: isThinking,
        isReady: false,
        isPreviewVisible: showSmartCreationModal,
        isError: false,
        isAborted: false,
        isCancelled: false
    });
    const isRemixInProgress = rendererPhase === 'thinking' || rendererPhase === 'ready';
    const isRemixCommitted = showSmartCreationModal || isRemixInProgress || rendererPhase === 'previewing' || rendererPhase === 'submitting';
    // Variant 2 alone keeps its local picker active while the user chooses a target. Every
    // other cohort, and every committed flow, keeps the existing single-target policy.
    const context = (0, $cozmU.useMemo)(()=>{
        const isRemixing = isModalOpen || isRemixCommitted;
        const isRemixBlockingNewTargets = isAnyRemixing || isRemixing && (isRemixCommitted || !(0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-ce-maui-remix-menu-multivariant', 'cohort', 'variant2'));
        return {
            openRemixModal: openModal,
            closeRemixModal: closeModal,
            clearRemixHighlight: clearHighlight,
            isRemixDisabled: false,
            isRemixing: // These values describe how far along a Remix is, and they deliberately differ from
            // one another:
            //
            // - `isRemixing` becomes true as soon as any Remix flow opens, which includes the time
            //   the person spends looking at the list of Remix choices before picking one.
            // - `isRemixInProgress` is true only while content is being generated or has just
            //   finished being generated.
            // - `isRemixBlockingNewTargets` is true when another entry point must not replace the
            //   currently targeted content.
            isRemixing,
            isRemixInProgress: isRemixInProgress,
            isRemixBlockingNewTargets: isRemixBlockingNewTargets,
            isAnyRemixing: isAnyRemixing,
            remixInteractionSource: remixInteractionSource,
            registerOnModalClose: registerOnModalClose
        };
    }, [
        openModal,
        closeModal,
        clearHighlight,
        isModalOpen,
        isRemixCommitted,
        isRemixInProgress,
        isAnyRemixing,
        remixInteractionSource,
        registerOnModalClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c9c8b9d550aa1c05$var$RendererRemixContext.Provider, {
        value: context
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fj6ez.RendererRemixHighlightStyles), null), children, isModalOpen && !isThinking && !isRemixCommitted && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-ce-maui-remix-menu-multivariant', 'cohort', 'variant2') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c9c8b9d550aa1c05$var$CancelRemixWhenRovoPanelCloses, {
        onRovoPanelClosed: closeModal
    }), (isModalOpen || isThinking || isMachineReadTreatment) && adfDocument && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aXWtB.ConfluenceConversationAssistant), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c9c8b9d550aa1c05$var$RendererRemixModal, {
        adfDocument: adfDocument,
        hiddenOptions: hiddenOptions,
        selectionContext: selectionContext,
        interactionSource: remixInteractionSource,
        onClose: closeModal,
        onFinalizeCommandSession: clearModalSession,
        onStartThinking: onStartThinking,
        onStopThinking: onStopThinking,
        isEphemeralViewVisible: showSmartCreationModal,
        isRendererOverlayOpen: isModalOpen || isThinking,
        currentContentId: contentId,
        anchorRect: anchorRect,
        anchorElement: anchorElement,
        isThinking: isThinking,
        treatment: treatment
    })));
};
const $c9c8b9d550aa1c05$var$RendererRemixTreatmentHost = ({ children: children, contentId: contentId })=>{
    // CCCEMAU-3500 parity diagnostics - remove with the Remix state management refactor.
    const parityDiagnostics = (0, $8L2yq.useRendererRemixParityDiagnostics)();
    const machineLifecycle = (0, $etOkO.useRendererRemixMachineLifecycle)({
        onLifecycleBoundary: parityDiagnostics.recordLifecycleBoundary
    });
    const isAnyRemixing = (0, $gRoSG.useIsAnyRemixing)();
    const treatment = (0, $cozmU.useMemo)(()=>({
            machineLifecycle: machineLifecycle,
            parityDiagnostics: parityDiagnostics,
            isAnyRemixing: isAnyRemixing
        }), [
        machineLifecycle,
        parityDiagnostics,
        isAnyRemixing
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c9c8b9d550aa1c05$var$RendererRemixContainerImpl, {
        contentId: contentId,
        treatment: treatment
    }, children);
};
const $c9c8b9d550aa1c05$var$RendererRemixTreatmentDecision = ({ children: children, contentId: contentId, isRemixAvailable: isRemixAvailable, isLifecycleAdapterAvailable: isLifecycleAdapterAvailable })=>{
    // This decision is intentionally fixed for the mounted renderer surface. The regular experiment
    // evaluation is therefore the first Statsig exposure for both control and treatment, while every
    // earlier eligibility sentinel short-circuits without evaluating the surface experiment.
    const [isMachineReadTreatment] = (0, $cozmU.useState)(()=>isRemixAvailable && isLifecycleAdapterAvailable && (0, $iDrrr.fg)('remix_state_rearchitecture_enabled') && (0, $6mKj3.isExperimentEnabled)('remix_state_rearchitecture_renderer'));
    if (isMachineReadTreatment) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c9c8b9d550aa1c05$var$RendererRemixTreatmentHost, {
        contentId: contentId
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c9c8b9d550aa1c05$var$RendererRemixContainerImpl, {
        contentId: contentId
    }, children);
};
const $c9c8b9d550aa1c05$var$RendererRemixContainerOwner = ({ children: children, contentId: contentId, isLifecycleAdapterAvailable: isLifecycleAdapterAvailable })=>{
    const isRemixAvailable = (0, $dnbZ2.useIsRemixAvailable)();
    // Availability and adapter capability are both host-boundaries. If either changes, remounting
    // reevaluates eligibility before any treatment hook is mounted rather than pinning a stale control
    // decision in the existing renderer session.
    const eligibilityKey = `${isRemixAvailable}:${isLifecycleAdapterAvailable}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c9c8b9d550aa1c05$var$RendererRemixTreatmentDecision, {
        key: eligibilityKey,
        contentId: contentId,
        isRemixAvailable: isRemixAvailable,
        isLifecycleAdapterAvailable: isLifecycleAdapterAvailable
    }, children);
};
const $c9c8b9d550aa1c05$var$makeDisabledRemixContextValue = (reason)=>({
        openRemixModal: ()=>{},
        closeRemixModal: ()=>{},
        clearRemixHighlight: ()=>{},
        isRemixDisabled: true,
        isRemixing: false,
        isRemixInProgress: false,
        isRemixBlockingNewTargets: false,
        isAnyRemixing: false,
        remixInteractionSource: undefined,
        remixDisabledReason: reason,
        registerOnModalClose: ()=>()=>{}
    });
const $c9c8b9d550aa1c05$var$disabledRemixContextValue = $c9c8b9d550aa1c05$var$makeDisabledRemixContextValue();
const $c9c8b9d550aa1c05$export$62131e16a1db8364 = ({ children: children, contentId: contentId, isDisabled: isDisabled, remixDisabledReason: remixDisabledReason, isLifecycleAdapterAvailable: isLifecycleAdapterAvailable = false })=>{
    if (isDisabled) {
        const contextValue = remixDisabledReason ? $c9c8b9d550aa1c05$var$makeDisabledRemixContextValue(remixDisabledReason) : $c9c8b9d550aa1c05$var$disabledRemixContextValue;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c9c8b9d550aa1c05$var$RendererRemixContext.Provider, {
            value: contextValue
        }, children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c9c8b9d550aa1c05$var$RendererRemixContainerOwner, {
        contentId: contentId,
        isLifecycleAdapterAvailable: isLifecycleAdapterAvailable
    }, children);
};
module.exports["useRendererRemixContext"] = $c9c8b9d550aa1c05$export$c881c5d3c5870780;
module.exports["RendererRemixContainer"] = $c9c8b9d550aa1c05$export$62131e16a1db8364;

});

parcelRegister("81UEG", function(module, exports) {
const $9dc19d5e68a65b89$export$63336757f28ec02f = ({ isThinking: isThinking, isReady: isReady, isPreviewVisible: isPreviewVisible, isError: isError, isAborted: isAborted, isCancelled: isCancelled })=>{
    if (isError) return 'error';
    if (isAborted || isCancelled) return 'aborted';
    if (isPreviewVisible) return 'previewing';
    if (isReady) return 'ready';
    if (isThinking) return 'thinking';
    return 'inactive';
};
const $9dc19d5e68a65b89$var$machineToRendererPhase = {
    thinking: 'thinking',
    ready: 'ready',
    previewing: 'previewing',
    inserting: 'submitting',
    error: 'error',
    aborted: 'aborted'
};
const $9dc19d5e68a65b89$export$b1a7146262519ea1 = (phase)=>phase === undefined ? 'inactive' : $9dc19d5e68a65b89$var$machineToRendererPhase[phase];
module.exports["deriveLegacyRendererRemixPhase"] = $9dc19d5e68a65b89$export$63336757f28ec02f;
module.exports["deriveMachineRendererRemixPhase"] = $9dc19d5e68a65b89$export$b1a7146262519ea1;

});

parcelRegister("fj6ez", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");

function $738409fb11353f61$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $738409fb11353f61$var$rendererHighlightStyles = {
    name: "18r8tnl",
    styles: "::highlight(remix-thinking-renderer){background-color:var(--ds-background-accent-purple-subtler, #EED7FC);text-decoration:underline;text-decoration-style:dotted;text-decoration-thickness:var(--ds-space-025, 2px);text-decoration-color:var(--ds-border-accent-purple, #AF59E1);text-decoration-skip-ink:none;}"
};
const $738409fb11353f61$export$533b8d7a5499bf49 = ()=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lOiVq.Global), {
        styles: $738409fb11353f61$var$rendererHighlightStyles
    }));
};
module.exports["RendererRemixHighlightStyles"] = $738409fb11353f61$export$533b8d7a5499bf49;

});

parcelRegister("dnbZ2", function(module, exports) {

var $3ricL = parcelRequire("3ricL");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");


var $c4wtI = parcelRequire("c4wtI");

const $2a69d40b2e0abea7$export$4739f60b2e0ffe71 = ()=>{
    const { isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    if ((0, $6mKj3.isExperimentEnabled)('cc-maui-feature-encoding-sdk-exp')) {
        if (!(0, $3ricL.isFeatureEnabled)('confluence', 'confluence-remix')) return false;
    }
    return isRovoLLMEnabled && !(0, $c4wtI.isRemixOptedOut)() && (0, $6mKj3.isExperimentEnabled)('cc-maui-experiment');
};
module.exports["useIsRemixAvailable"] = $2a69d40b2e0abea7$export$4739f60b2e0ffe71;

});

parcelRegister("c4wtI", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $5dba2f21328d6f88$export$18f828f11aef2dd3 = ()=>(0, $9wGTI.fg)('cc-maui-opted-out');
module.exports["isRemixOptedOut"] = $5dba2f21328d6f88$export$18f828f11aef2dd3;

});

parcelRegister("7GTyD", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lEf8v = parcelRequire("lEf8v");

const $7320d3edb50fb9c8$export$d4909a6f4c87ce20 = (isAdmittedRemixId, { onReady: onReady, onErrored: onErrored, onAborted: onAborted, onGenerationEnded: onGenerationEnded })=>{
    const handledRef = (0, $cozmU.useRef)({
        remixId: undefined,
        commands: new Set()
    });
    (0, $lEf8v.useRemixCommands)((command)=>{
        if (!isAdmittedRemixId(command.remixId)) return;
        if (handledRef.current.remixId !== command.remixId) handledRef.current = {
            remixId: command.remixId,
            commands: new Set()
        };
        let claim;
        switch(command.type){
            case 'RemixReady':
            case 'RemixErrored':
            case 'RemixAborted':
                claim = command.type;
                break;
            case 'RemixGenerationEnded':
                claim = `${command.type}:${command.reason}`;
                break;
            default:
                return;
        }
        if (handledRef.current.commands.has(claim)) return;
        handledRef.current.commands.add(claim);
        switch(command.type){
            case 'RemixReady':
                onReady(command);
                break;
            case 'RemixErrored':
                onErrored(command);
                break;
            case 'RemixAborted':
                onAborted(command);
                break;
            case 'RemixGenerationEnded':
                onGenerationEnded(command);
                break;
        }
    });
};
module.exports["useRendererRemixCommands"] = $7320d3edb50fb9c8$export$d4909a6f4c87ce20;

});

parcelRegister("jNS1v", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $5ae98e04c533e5e9$var$HIGHLIGHT_NAME = 'remix-thinking-renderer';
const $5ae98e04c533e5e9$export$443e8aeb4c392a84 = ()=>{
    const savedRangeRef = (0, $cozmU.useRef)(null);
    const [isHighlighting, setIsHighlighting] = (0, $cozmU.useState)(false);
    const clearHighlight = (0, $cozmU.useCallback)(()=>{
        if (typeof Highlight !== 'undefined' && 'highlights' in CSS) CSS.highlights.delete($5ae98e04c533e5e9$var$HIGHLIGHT_NAME);
        savedRangeRef.current = null;
        setIsHighlighting(false);
    }, []);
    const startHighlight = (0, $cozmU.useCallback)(()=>{
        // Drop any highlight left over from an earlier Remix before looking for the new one.
        // Without this, starting a Remix of a different piece of content while there is no live
        // text selection would leave the earlier content highlighted, pointing at content that is
        // no longer the one being Remixed.
        clearHighlight();
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const sel = document.getSelection();
        if (!sel || sel.rangeCount === 0 || sel.isCollapsed) return;
        const range = sel.getRangeAt(0).cloneRange();
        savedRangeRef.current = range;
        if (typeof Highlight !== 'undefined' && 'highlights' in CSS) {
            const highlight = new Highlight(range);
            CSS.highlights.set($5ae98e04c533e5e9$var$HIGHLIGHT_NAME, highlight);
            sel.removeAllRanges();
            setIsHighlighting(true);
        }
    }, [
        clearHighlight
    ]);
    return {
        startHighlight: startHighlight,
        clearHighlight: clearHighlight,
        isHighlighting: isHighlighting,
        savedRange: savedRangeRef
    };
};
module.exports["useRendererRemixHighlight"] = $5ae98e04c533e5e9$export$443e8aeb4c392a84;

});

parcelRegister("etOkO", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9HkI0 = parcelRequire("9HkI0");


var $9DHhW = parcelRequire("9DHhW");


var $hwgBi = parcelRequire("hwgBi");


var $bWlOZ = parcelRequire("bWlOZ");

var $gRoSG = parcelRequire("gRoSG");

const $e7504183f26ea064$var$readMachineTerminalPhase = (remixId)=>{
    const phase = (0, $bWlOZ.getRemixMachine)(remixId)?.state();
    return phase === 'aborted' || phase === 'error' ? phase : undefined;
};
const $e7504183f26ea064$export$80b3b48a0293a136 = ({ onAdmissionRejected: onAdmissionRejected, onLifecycleBoundary: onLifecycleBoundary } = {})=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const logLifecycleOperationError = (0, $cozmU.useCallback)((operation, error)=>{
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'failed',
                actionSubject: 'rendererRemixLifecycleOperation',
                source: 'rendererRemix',
                attributes: {
                    operation: operation,
                    errorName: error instanceof Error ? error.name : typeof error
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const reportCancellationDiagnostic = (0, $cozmU.useCallback)((diagnostic)=>{
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'observed',
                actionSubject: 'rendererRemixCancellationShadow',
                source: 'rendererRemix',
                attributes: {
                    diagnosticKind: diagnostic.kind,
                    machinePhase: diagnostic.phase,
                    cancellationScope: diagnostic.scope
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const runLifecycleSafely = (0, $cozmU.useCallback)((operationName, operation)=>{
        try {
            operation();
            return true;
        } catch (error) {
            logLifecycleOperationError(operationName, error);
            return false;
        }
    }, [
        logLifecycleOperationError
    ]);
    const notifyLifecycleBoundary = (0, $cozmU.useCallback)((boundary)=>{
        runLifecycleSafely('notifyLifecycleBoundary', ()=>onLifecycleBoundary?.(boundary));
    }, [
        onLifecycleBoundary,
        runLifecycleSafely
    ]);
    const [remixId, setRemixId] = (0, $cozmU.useState)();
    const phase = (0, $gRoSG.useMachinePhase)(remixId ?? '');
    const phaseRef = (0, $cozmU.useRef)(phase);
    phaseRef.current = phase;
    const remixIdRef = (0, $cozmU.useRef)(undefined);
    const commandRemixIdRef = (0, $cozmU.useRef)(undefined);
    const cancellationSessionIdRef = (0, $cozmU.useRef)(undefined);
    const pendingIntentRef = (0, $cozmU.useRef)(undefined);
    const finalizedRef = (0, $cozmU.useRef)(true);
    const claimFinalization = (0, $cozmU.useCallback)(()=>{
        const activeRemixId = remixIdRef.current;
        if (!activeRemixId || finalizedRef.current) return undefined;
        // Detach the claimed flow before invoking any external callback. A boundary observer may
        // synchronously start another flow, and finalizing this flow must not clear that new owner's
        // identity or cancellation session.
        const cancellationSessionId = cancellationSessionIdRef.current;
        finalizedRef.current = true;
        remixIdRef.current = undefined;
        cancellationSessionIdRef.current = undefined;
        pendingIntentRef.current = undefined;
        return {
            remixId: activeRemixId,
            cancellationSessionId: cancellationSessionId
        };
    }, []);
    const releaseClaimedFlow = (0, $cozmU.useCallback)((finalization)=>{
        if (commandRemixIdRef.current === finalization.remixId) commandRemixIdRef.current = undefined;
        if (finalization.cancellationSessionId) (0, $hwgBi.unregisterRemixCancellationSession)(finalization.cancellationSessionId);
    }, []);
    const safelyEndRemix = (0, $cozmU.useCallback)((id, reason)=>{
        runLifecycleSafely('endRemix', ()=>(0, $bWlOZ.endRemix)(id, reason));
    }, [
        runLifecycleSafely
    ]);
    const endObservedTerminal = (0, $cozmU.useCallback)((reason)=>{
        const finalization = claimFinalization();
        if (!finalization) return;
        const activeRemixId = finalization.remixId;
        try {
            const observedTerminalPhase = $e7504183f26ea064$var$readMachineTerminalPhase(activeRemixId);
            if (observedTerminalPhase) notifyLifecycleBoundary({
                remixId: activeRemixId,
                outcome: 'terminal-applied',
                terminalPhase: observedTerminalPhase
            });
            else notifyLifecycleBoundary({
                remixId: activeRemixId,
                outcome: 'released-unresolved'
            });
            safelyEndRemix(activeRemixId, reason);
        } finally{
            releaseClaimedFlow(finalization);
        }
    }, [
        claimFinalization,
        notifyLifecycleBoundary,
        releaseClaimedFlow,
        safelyEndRemix
    ]);
    const endWith = (0, $cozmU.useCallback)(({ event: event, reason: reason })=>{
        const finalization = claimFinalization();
        if (!finalization) return false;
        const activeRemixId = finalization.remixId;
        let terminalPhaseBeforeSend;
        let didApplyTerminalEvent = false;
        try {
            terminalPhaseBeforeSend = $e7504183f26ea064$var$readMachineTerminalPhase(activeRemixId);
            runLifecycleSafely('sendTerminalEvent', ()=>(0, $bWlOZ.sendRemixEvent)(activeRemixId, {
                    type: event
                }));
            const terminalPhase = $e7504183f26ea064$var$readMachineTerminalPhase(activeRemixId);
            didApplyTerminalEvent = terminalPhaseBeforeSend === undefined && terminalPhase !== undefined;
            if (terminalPhase) notifyLifecycleBoundary({
                remixId: activeRemixId,
                outcome: 'terminal-applied',
                terminalPhase: terminalPhase
            });
            else notifyLifecycleBoundary({
                remixId: activeRemixId,
                outcome: 'released-unresolved'
            });
            safelyEndRemix(activeRemixId, reason);
        } finally{
            releaseClaimedFlow(finalization);
        }
        return didApplyTerminalEvent;
    }, [
        claimFinalization,
        notifyLifecycleBoundary,
        releaseClaimedFlow,
        runLifecycleSafely,
        safelyEndRemix
    ]);
    const startFlow = (0, $cozmU.useCallback)(({ conversationId: requestedConversationId, dynamicUiType: dynamicUiType, dynamicUiSubtype: dynamicUiSubtype, source: source })=>{
        const conversationId = requestedConversationId ?? (0, $9HkI0.v4)();
        // Preserve any existing admitted flow. SINGLE_ACTIVE_POLICY owns rejection.
        if (remixIdRef.current && !finalizedRef.current) {
            runLifecycleSafely('notifyAdmissionRejected', ()=>onAdmissionRejected?.('active-flow'));
            return {
                conversationId: conversationId,
                admitted: false,
                reason: 'active-flow'
            };
        }
        const cancellationSessionId = (0, $hwgBi.registerRemixCancellationSession)({
            conversationId: conversationId,
            reportDiagnostic: reportCancellationDiagnostic
        });
        if (!cancellationSessionId) {
            runLifecycleSafely('notifyAdmissionRejected', ()=>onAdmissionRejected?.('active-flow'));
            return {
                conversationId: conversationId,
                admitted: false,
                reason: 'active-flow'
            };
        }
        try {
            const result = (0, $bWlOZ.startRemix)({
                kind: 'create',
                conversationId: conversationId,
                cancellationSessionId: cancellationSessionId,
                metadata: {
                    dynamicUiType: dynamicUiType,
                    dynamicUiSubtype: dynamicUiSubtype,
                    source: source
                },
                useCommandBus: true
            });
            if (!result) {
                (0, $hwgBi.unregisterRemixCancellationSession)(cancellationSessionId);
                runLifecycleSafely('notifyAdmissionRejected', ()=>onAdmissionRejected?.('active-flow'));
                return {
                    conversationId: conversationId,
                    admitted: false,
                    reason: 'active-flow'
                };
            }
            if (result.conversationId !== conversationId) {
                (0, $hwgBi.unregisterRemixCancellationSession)(cancellationSessionId);
                logLifecycleOperationError('validateAdmissionIdentity', new Error('Machine admission returned a different conversation identity'));
                runLifecycleSafely('notifyAdmissionRejected', ()=>onAdmissionRejected?.('identity-mismatch'));
                safelyEndRemix(result.remixId, 'cancelled');
                return {
                    conversationId: conversationId,
                    admitted: false,
                    reason: 'identity-mismatch'
                };
            }
            finalizedRef.current = false;
            remixIdRef.current = result.remixId;
            commandRemixIdRef.current = result.remixId;
            cancellationSessionIdRef.current = cancellationSessionId;
            pendingIntentRef.current = undefined;
            setRemixId(result.remixId);
            return {
                conversationId: conversationId,
                admitted: true,
                cancellationSessionId: cancellationSessionId
            };
        } catch (error) {
            (0, $hwgBi.unregisterRemixCancellationSession)(cancellationSessionId);
            logLifecycleOperationError('startRemix', error);
            runLifecycleSafely('notifyAdmissionRejected', ()=>onAdmissionRejected?.('error'));
            return {
                conversationId: conversationId,
                admitted: false,
                reason: 'error'
            };
        }
    }, [
        logLifecycleOperationError,
        onAdmissionRejected,
        reportCancellationDiagnostic,
        runLifecycleSafely,
        safelyEndRemix
    ]);
    const reconcileIntent = (0, $cozmU.useCallback)((intent)=>{
        const activeRemixId = remixIdRef.current;
        if (!activeRemixId || finalizedRef.current) return;
        const currentPhase = phaseRef.current;
        if (intent === 'preview-opened' && currentPhase === 'ready') {
            pendingIntentRef.current = undefined;
            if (!runLifecycleSafely('sendPreviewOpened', ()=>(0, $bWlOZ.sendRemixEvent)(activeRemixId, {
                    type: 'PREVIEW_OPENED'
                }))) {
                const finalization = claimFinalization();
                if (finalization) try {
                    notifyLifecycleBoundary({
                        remixId: finalization.remixId,
                        outcome: 'released-unresolved'
                    });
                    safelyEndRemix(finalization.remixId, 'cancelled');
                } finally{
                    releaseClaimedFlow(finalization);
                }
            }
            return;
        }
    }, [
        claimFinalization,
        notifyLifecycleBoundary,
        releaseClaimedFlow,
        runLifecycleSafely,
        safelyEndRemix
    ]);
    const onPreviewOpened = (0, $cozmU.useCallback)(()=>{
        if (remixIdRef.current && !finalizedRef.current) {
            pendingIntentRef.current = 'preview-opened';
            reconcileIntent('preview-opened');
        }
    }, [
        reconcileIntent
    ]);
    const onPreviewDismissed = (0, $cozmU.useCallback)(()=>{
        return endWith({
            event: 'CANCELLED',
            reason: 'cancelled'
        });
    }, [
        endWith
    ]);
    const onStopThinking = (0, $cozmU.useCallback)(()=>{
        const activeRemixId = remixIdRef.current;
        const currentPhase = activeRemixId ? (0, $bWlOZ.getRemixMachine)(activeRemixId)?.state() : undefined;
        return endWith({
            event: currentPhase === 'thinking' ? 'GENERATION_ABORTED' : 'CANCELLED',
            reason: 'aborted'
        });
    }, [
        endWith
    ]);
    const onRovoAborted = (0, $cozmU.useCallback)(()=>{
        endObservedTerminal('aborted');
    }, [
        endObservedTerminal
    ]);
    const onErrorDismissed = (0, $cozmU.useCallback)(()=>{
        endObservedTerminal('cancelled');
    }, [
        endObservedTerminal
    ]);
    const onSendRejected = (0, $cozmU.useCallback)(()=>{
        return endWith({
            event: 'GENERATION_ERROR',
            reason: 'error'
        });
    }, [
        endWith
    ]);
    const onNavigation = (0, $cozmU.useCallback)(()=>{
        return endWith({
            event: 'CANCELLED',
            reason: 'cancelled'
        });
    }, [
        endWith
    ]);
    (0, $cozmU.useEffect)(()=>{
        const pendingIntent = pendingIntentRef.current;
        if (!pendingIntent) return;
        // Reconcile the queued renderer intent only after the watcher exposes a legal machine phase.
        // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates
        reconcileIntent(pendingIntent);
    }, [
        phase,
        reconcileIntent
    ]);
    // Component teardown mirrors legacy dismissal and releases machine admission.
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            const finalization = claimFinalization();
            if (!finalization) return;
            const activeRemixId = finalization.remixId;
            try {
                runLifecycleSafely('sendUnmountCancelled', ()=>(0, $bWlOZ.sendRemixEvent)(activeRemixId, {
                        type: 'CANCELLED'
                    }));
                safelyEndRemix(activeRemixId, 'cancelled');
            } finally{
                releaseClaimedFlow(finalization);
            }
        };
    }, [
        claimFinalization,
        releaseClaimedFlow,
        runLifecycleSafely,
        safelyEndRemix
    ]);
    const isAdmittedRemixId = (0, $cozmU.useCallback)((id)=>commandRemixIdRef.current === id, []);
    return {
        phase: phase,
        remixId: remixId,
        isAdmittedRemixId: isAdmittedRemixId,
        startFlow: startFlow,
        onPreviewOpened: onPreviewOpened,
        onPreviewDismissed: onPreviewDismissed,
        onStopThinking: onStopThinking,
        onRovoAborted: onRovoAborted,
        onErrorDismissed: onErrorDismissed,
        onSendRejected: onSendRejected,
        onNavigation: onNavigation
    };
};
module.exports["useRendererRemixMachineLifecycle"] = $e7504183f26ea064$export$80b3b48a0293a136;

});

parcelRegister("8L2yq", function(module, exports) {
/**
 * Reports when the renderer's legacy lifecycle and the Remix state machine settle on different
 * phases. This is a read-only observer: it derives nothing the renderer does not already compute for
 * itself, and it never participates in renderer behavior.
 *
 * Classification lives in `rendererRemixParity.ts`; this session-owned hook accepts observations
 * from the renderer UI and authoritative boundaries from the lifecycle owner. Keeping retained
 * state here means closing the visible renderer cannot erase a flow that is still active.
 */ 
var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $30OJC = parcelRequire("30OJC");


var $29oXT = parcelRequire("29oXT");


var $nkPkg = parcelRequire("nkPkg");

/**
 * How long a non-terminal phase pair must hold before it counts as settled.
 *
 * Legacy readiness and the machine's watcher-driven phase land on different ticks, so a healthy
 * flow briefly reports two different phases at every transition. Reporting only what survives this
 * delay keeps that ordinary skew out of the signal.
 *
 * This delay is deliberately not applied once the machine is terminal — see the comment at the
 * report site.
 */ const $d21c0166676c8f4f$var$PARITY_SETTLE_MS = 250;
const $d21c0166676c8f4f$export$a819d3c7b26e01bc = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const reportedRef = (0, $cozmU.useRef)();
    const pendingTerminalRef = (0, $cozmU.useRef)(undefined);
    const pendingMechanicsRef = (0, $cozmU.useRef)(undefined);
    const reportedMechanicRef = (0, $cozmU.useRef)(undefined);
    const pendingBoundaryRef = (0, $cozmU.useRef)(undefined);
    const lastTrackedObservationRef = (0, $cozmU.useRef)(undefined);
    const reportDivergence = (0, $cozmU.useCallback)((flowRemixId, pairLegacyPhase, pairMachinePhase, reasonOverride)=>{
        const settled = (0, $29oXT.compareRendererRemixParity)({
            legacyPhase: pairLegacyPhase,
            machinePhase: pairMachinePhase,
            isStable: true
        });
        if (settled.outcome !== 'divergence') return;
        // Each admitted flow reports a given divergence once, so a divergence that persists across
        // many renders does not become a flood of identical events.
        const previous = reportedRef.current;
        const reported = previous?.remixId === flowRemixId ? previous : {
            remixId: flowRemixId,
            signatures: new Set()
        };
        reportedRef.current = reported;
        const divergenceReason = reasonOverride ?? settled.divergence.divergenceReason;
        if (divergenceReason === 'unexpected-phase-pair') return;
        const severeDivergence = {
            ...settled.divergence,
            divergenceReason: divergenceReason
        };
        if (pendingMechanicsRef.current?.remixId === flowRemixId) // A definitive severe disposition closes every mechanic retained for this flow. None of
        // them converged, so discard them without emitting misleading resolved events.
        pendingMechanicsRef.current = undefined;
        const signature = (0, $30OJC.createDivergenceSignature)(severeDivergence);
        if (reported.signatures.has(signature)) return;
        reported.signatures.add(signature);
        (0, $30OJC.dispatchRendererRemixParityEvent)(createAnalyticsEvent, severeDivergence);
    }, [
        createAnalyticsEvent
    ]);
    const reportMechanicObserved = (0, $cozmU.useCallback)((flowRemixId, legacyPhase, machinePhase)=>{
        const result = (0, $29oXT.compareRendererRemixParity)({
            legacyPhase: legacyPhase,
            machinePhase: machinePhase,
            isStable: true
        });
        if (result.outcome !== 'divergence' || result.divergence.divergenceReason !== 'unexpected-phase-pair') return;
        const previous = reportedMechanicRef.current;
        const reported = previous?.remixId === flowRemixId ? previous : {
            remixId: flowRemixId,
            signatures: new Set()
        };
        reportedMechanicRef.current = reported;
        const signature = (0, $30OJC.createDivergenceSignature)(result.divergence);
        if (reported.signatures.has(signature)) return;
        reported.signatures.add(signature);
        const pending = pendingMechanicsRef.current?.remixId === flowRemixId ? pendingMechanicsRef.current : {
            remixId: flowRemixId,
            observations: new Map()
        };
        pendingMechanicsRef.current = pending;
        pending.observations.set(signature, {
            legacyPhase: legacyPhase,
            machinePhase: machinePhase,
            comparisonPoint: result.divergence.comparisonPoint,
            startedAt: Date.now() - $d21c0166676c8f4f$var$PARITY_SETTLE_MS
        });
        (0, $30OJC.dispatchRendererRemixParityMechanicEvent)(createAnalyticsEvent, {
            legacyPhase: legacyPhase,
            machinePhase: machinePhase,
            comparisonPoint: result.divergence.comparisonPoint,
            action: 'observed',
            outcome: 'timing-skew',
            reason: 'awaiting-convergence',
            durationBucket: (0, $nkPkg.durationBucketForMs)($d21c0166676c8f4f$var$PARITY_SETTLE_MS)
        });
    }, [
        createAnalyticsEvent
    ]);
    const resolveMechanics = (0, $cozmU.useCallback)((flowRemixId)=>{
        const pending = pendingMechanicsRef.current;
        if (!pending || pending.remixId !== flowRemixId) return;
        pendingMechanicsRef.current = undefined;
        for (const observation of pending.observations.values())(0, $30OJC.dispatchRendererRemixParityMechanicEvent)(createAnalyticsEvent, {
            legacyPhase: observation.legacyPhase,
            machinePhase: observation.machinePhase,
            comparisonPoint: observation.comparisonPoint,
            action: 'resolved',
            outcome: 'converged',
            reason: 'phase-converged',
            durationBucket: (0, $nkPkg.durationBucketForMs)(Date.now() - observation.startedAt)
        });
    }, [
        createAnalyticsEvent
    ]);
    const reportAndClearPendingTerminalMismatch = (0, $cozmU.useCallback)((machineTerminalPhase, reasonOverride)=>{
        const pending = pendingTerminalRef.current;
        if (!pending) return;
        reportDivergence(pending.remixId, pending.legacyPhase, machineTerminalPhase ?? pending.machinePhase, reasonOverride);
        pendingTerminalRef.current = undefined;
    }, [
        reportDivergence
    ]);
    const recordLifecycleBoundary = (0, $cozmU.useCallback)((boundary)=>{
        const pending = pendingTerminalRef.current;
        if (!pending || pending.remixId !== boundary.remixId) {
            const mechanics = pendingMechanicsRef.current;
            if (mechanics?.remixId === boundary.remixId) {
                if (boundary.outcome === 'released-unresolved') {
                    let latestMechanic;
                    for (const observation of mechanics.observations.values())latestMechanic = observation;
                    if (!latestMechanic) return;
                    reportDivergence(mechanics.remixId, latestMechanic.legacyPhase, latestMechanic.machinePhase, 'released-unresolved');
                } else // A terminal-applied boundary is not itself a mismatch. Retain it so the later legacy
                // terminal observation can decide whether the mechanic converged or contradicted it.
                pendingBoundaryRef.current = boundary;
                return;
            }
            // Renderer state is observed in a passive effect, while lifecycle finalization can happen
            // synchronously in the event callback that changes legacy state. Retain the boundary so the
            // later terminal observation can reconcile against it regardless of arrival order.
            // If no observation ever arrives, there is no phase pair to classify; emitting then would
            // fabricate parity evidence rather than report an observed divergence.
            pendingBoundaryRef.current = boundary;
            return;
        }
        if (boundary.outcome === 'terminal-applied') {
            if (pending.legacyPhase === boundary.terminalPhase) {
                pendingTerminalRef.current = undefined;
                resolveMechanics(boundary.remixId);
                return;
            }
            reportAndClearPendingTerminalMismatch(boundary.terminalPhase);
            return;
        }
        reportAndClearPendingTerminalMismatch(undefined, 'released-unresolved');
    }, [
        reportAndClearPendingTerminalMismatch,
        reportDivergence,
        resolveMechanics
    ]);
    const recordObservation = (0, $cozmU.useCallback)(({ enabled: enabled, remixId: remixId, legacyPhase: legacyPhase, machinePhase: machinePhase })=>{
        if (!enabled || remixId === undefined) {
            pendingTerminalRef.current = undefined;
            pendingMechanicsRef.current = undefined;
            reportedMechanicRef.current = undefined;
            pendingBoundaryRef.current = undefined;
            lastTrackedObservationRef.current = undefined;
            return;
        }
        const pending = pendingTerminalRef.current;
        if (pending && pending.remixId !== remixId) // A new admitted flow is a definitive boundary for the pending flow. It ended without the
        // machine ever exposing the matching terminal outcome to this observer.
        reportAndClearPendingTerminalMismatch();
        if (pendingMechanicsRef.current?.remixId !== remixId) {
            pendingMechanicsRef.current = undefined;
            reportedMechanicRef.current = undefined;
        }
        if (pendingBoundaryRef.current?.remixId !== remixId) pendingBoundaryRef.current = undefined;
        if (lastTrackedObservationRef.current?.remixId !== remixId) lastTrackedObservationRef.current = undefined;
        const pendingBoundary = pendingBoundaryRef.current;
        if (pendingBoundary?.remixId === remixId && (0, $29oXT.isTerminalPhase)(legacyPhase)) {
            const lastTrackedMachinePhase = lastTrackedObservationRef.current?.machinePhase;
            pendingBoundaryRef.current = undefined;
            pendingTerminalRef.current = undefined;
            if (pendingBoundary.outcome === 'terminal-applied') {
                if (legacyPhase !== pendingBoundary.terminalPhase) reportDivergence(remixId, legacyPhase, pendingBoundary.terminalPhase);
                else resolveMechanics(remixId);
            } else if (lastTrackedMachinePhase) reportDivergence(remixId, legacyPhase, lastTrackedMachinePhase, 'released-unresolved');
            return;
        }
        if (machinePhase === 'inactive') // `inactive` is only a render snapshot. The lifecycle owner separately records whether a
        // terminal event was applied or the flow was released unresolved, so do not infer here.
        return;
        lastTrackedObservationRef.current = {
            enabled: enabled,
            remixId: remixId,
            legacyPhase: legacyPhase,
            machinePhase: machinePhase
        };
        const currentPending = pendingTerminalRef.current;
        if (currentPending?.remixId === remixId) {
            if ((0, $29oXT.isTerminalPhase)(machinePhase)) {
                if (currentPending.legacyPhase === machinePhase) {
                    pendingTerminalRef.current = undefined;
                    resolveMechanics(remixId);
                } else reportAndClearPendingTerminalMismatch(machinePhase);
                return;
            }
            if ((0, $29oXT.isTerminalPhase)(legacyPhase) && currentPending.legacyPhase !== legacyPhase) // A terminal legacy outcome cannot legitimately change while the same machine flow is
            // live. Preserve the first contradiction before retaining the new expectation.
            reportAndClearPendingTerminalMismatch();
            else {
                // Once legacy has reached a terminal outcome, retain that expectation for the flow.
                // Later legacy cleanup renders cannot prove convergence or erase the observation.
                currentPending.machinePhase = machinePhase;
                return;
            }
        }
        if (legacyPhase === machinePhase) {
            resolveMechanics(remixId);
            pendingTerminalRef.current = undefined;
            return;
        }
        const reportSettledPair = ()=>{
            const result = (0, $29oXT.compareRendererRemixParity)({
                legacyPhase: legacyPhase,
                machinePhase: machinePhase,
                isStable: true
            });
            if (result.outcome !== 'divergence') return;
            if (result.divergence.divergenceReason === 'unexpected-phase-pair') reportMechanicObserved(remixId, legacyPhase, machinePhase);
            else reportDivergence(remixId, legacyPhase, machinePhase);
        };
        // A terminal machine phase is already final, and deferring it would lose the observation: in
        // treatment the renderer's error and abort effects are driven by the machine phase and call
        // `onClose`, which clears the modal session and unmounts this observer in the same cycle,
        // clearing any pending timer. Report now or never.
        //
        // The mirror case is deliberately not fast-pathed. During an ordinary error or abort the
        // legacy phase updates during render while the machine catches up in a later effect, so a
        // terminal legacy phase against a live machine is expected lag rather than a divergence. Those
        // pairs remain pending until the machine reaches a definitive lifecycle boundary.
        if ((0, $29oXT.isTerminalPhase)(machinePhase)) {
            pendingTerminalRef.current = undefined;
            reportSettledPair();
            return;
        }
        if ((0, $29oXT.isTerminalPhase)(legacyPhase)) {
            const previous = pendingTerminalRef.current;
            if (previous?.remixId === remixId && previous.legacyPhase === legacyPhase) {
                previous.machinePhase = machinePhase;
                return;
            }
            pendingTerminalRef.current = {
                remixId: remixId,
                legacyPhase: legacyPhase,
                machinePhase: machinePhase
            };
            return;
        }
        pendingTerminalRef.current = undefined;
        const timeout = setTimeout(reportSettledPair, $d21c0166676c8f4f$var$PARITY_SETTLE_MS);
        return ()=>clearTimeout(timeout);
    }, [
        reportAndClearPendingTerminalMismatch,
        reportDivergence,
        reportMechanicObserved,
        resolveMechanics
    ]);
    const recordLegacyTerminal = (0, $cozmU.useCallback)((remixId, phase)=>{
        const lastTracked = lastTrackedObservationRef.current;
        if (!remixId || lastTracked?.remixId !== remixId) return;
        // A terminal legacy phase never enters the delayed non-terminal branch today. Dispose
        // defensively anyway so a future branch reordering cannot leak a timer from this
        // synchronous path.
        recordObservation({
            ...lastTracked,
            legacyPhase: phase
        })?.();
    }, [
        recordObservation
    ]);
    (0, $cozmU.useEffect)(()=>()=>{
            // Ending observation is not proof of divergence. The session owner has gone away, so any
            // retained pair is deliberately discarded without classification.
            pendingTerminalRef.current = undefined;
            pendingMechanicsRef.current = undefined;
            reportedMechanicRef.current = undefined;
            pendingBoundaryRef.current = undefined;
            lastTrackedObservationRef.current = undefined;
        }, []);
    return (0, $cozmU.useMemo)(()=>({
            recordObservation: recordObservation,
            recordLifecycleBoundary: recordLifecycleBoundary,
            recordLegacyTerminal: recordLegacyTerminal
        }), [
        recordLegacyTerminal,
        recordLifecycleBoundary,
        recordObservation
    ]);
};
module.exports["useRendererRemixParityDiagnostics"] = $d21c0166676c8f4f$export$a819d3c7b26e01bc;

});

parcelRegister("30OJC", function(module, exports) {
/**
 * Builds and fires the bounded operational event for a renderer Remix parity divergence.
 *
 * Every attribute is drawn from a closed union, so the payload carries no flow identifier, no
 * content reference, and no user content.
 *
 * `treatmentPhase` records the migration phase the event was observed in. Diagnostics only run
 * under `isMachineReadTreatment`, so today the only value is `machine-read`; it exists to keep
 * events from this phase distinguishable once the authority cutover (CCCEMAU-3480) changes what the
 * renderer reads.
 */ const $5f613e881c11497b$export$faea11873c201815 = ({ legacyPhase: legacyPhase, machinePhase: machinePhase, comparisonPoint: comparisonPoint, divergenceReason: divergenceReason })=>`${legacyPhase}|${machinePhase}|${comparisonPoint}|${divergenceReason}`;
const $5f613e881c11497b$export$c736feea7617c718 = (createAnalyticsEvent, { legacyPhase: legacyPhase, machinePhase: machinePhase, comparisonPoint: comparisonPoint, divergenceReason: divergenceReason })=>{
    try {
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'diverged',
                actionSubject: 'rendererRemixStateParity',
                source: 'rendererRemix',
                tags: [
                    'remix',
                    'stateRearchitecture'
                ],
                attributes: {
                    entryPoint: 'renderer',
                    severity: 'critical',
                    outcome: divergenceReason === 'terminal-outcome-mismatch' ? 'terminal-mismatch' : 'released-unresolved',
                    reason: divergenceReason,
                    legacyPhase: legacyPhase,
                    machinePhase: machinePhase,
                    comparisonPoint: comparisonPoint,
                    divergenceReason: divergenceReason,
                    treatmentPhase: 'machine-read'
                }
            }
        }).fire();
    } catch  {
    // Diagnostics must never affect the renderer flow.
    }
};
const $5f613e881c11497b$export$c296f4fbda0fd8b1 = (createAnalyticsEvent, { legacyPhase: legacyPhase, machinePhase: machinePhase, comparisonPoint: comparisonPoint, action: action, outcome: outcome, reason: reason, durationBucket: durationBucket })=>{
    try {
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: action,
                actionSubject: 'rendererRemixParityMechanic',
                source: 'rendererRemix',
                tags: [
                    'remix',
                    'stateRearchitecture'
                ],
                attributes: {
                    entryPoint: 'renderer',
                    severity: 'info',
                    outcome: outcome,
                    reason: reason,
                    legacyPhase: legacyPhase,
                    machinePhase: machinePhase,
                    comparisonPoint: comparisonPoint,
                    durationBucket: durationBucket,
                    treatmentPhase: 'machine-read'
                }
            }
        }).fire();
    } catch  {
    // Diagnostics must never affect the renderer flow.
    }
};
module.exports["createDivergenceSignature"] = $5f613e881c11497b$export$faea11873c201815;
module.exports["dispatchRendererRemixParityEvent"] = $5f613e881c11497b$export$c736feea7617c718;
module.exports["dispatchRendererRemixParityMechanicEvent"] = $5f613e881c11497b$export$c296f4fbda0fd8b1;

});

parcelRegister("29oXT", function(module, exports) {
/**
 * Pure comparison of the renderer's legacy lifecycle against the Remix state machine.
 *
 * Both phases are expressed in the renderer's existing `RendererRemixLifecyclePhase` vocabulary, so
 * diagnostics introduce no second normalization of renderer state. Nothing here reads or mutates
 * runtime state: callers pass two phases plus whether the pair has settled, and get back a
 * classification. Timing is the caller's concern.
 */ const $0777f04525ed21e4$var$COMPARISON_POINT_BY_LEGACY_PHASE = {
    inactive: 'released',
    thinking: 'flow-started',
    ready: 'result-ready',
    previewing: 'preview-opened',
    submitting: 'submitted',
    error: 'error',
    aborted: 'aborted'
};
const $0777f04525ed21e4$export$b2aaa5bc54318fb1 = (legacyPhase)=>$0777f04525ed21e4$var$COMPARISON_POINT_BY_LEGACY_PHASE[legacyPhase];
const $0777f04525ed21e4$export$9828bb32a038414e = (phase)=>phase === 'error' || phase === 'aborted';
const $0777f04525ed21e4$export$d239298095fe15f0 = (legacyPhase, machinePhase)=>{
    // The machine is running a flow the renderer no longer considers active.
    if (legacyPhase === 'inactive') return 'legacy-not-tracking';
    if ($0777f04525ed21e4$export$9828bb32a038414e(legacyPhase) || $0777f04525ed21e4$export$9828bb32a038414e(machinePhase)) return 'terminal-outcome-mismatch';
    return 'unexpected-phase-pair';
};
const $0777f04525ed21e4$export$78e12f3697c824a9 = ({ legacyPhase: legacyPhase, machinePhase: machinePhase, isStable: isStable })=>{
    // `inactive` covers both admission skew and a released machine flow. Machine release clears the
    // imperative remixId ref but retains the React remixId state, so this observer can continue
    // reading the released flow for the remaining modal lifetime. Comparing here would therefore
    // report normal teardown as a divergence; terminal pairs must be captured before the machine is
    // released. The machine's own release paths are instrumented separately by
    // `useRendererRemixMachineLifecycle`.
    if (machinePhase === 'inactive') return {
        outcome: 'pending',
        reason: 'machine-not-tracking'
    };
    if (legacyPhase === machinePhase) return {
        outcome: 'match'
    };
    if (!isStable) return {
        outcome: 'pending',
        reason: 'awaiting-stable-phases'
    };
    return {
        outcome: 'divergence',
        divergence: {
            legacyPhase: legacyPhase,
            machinePhase: machinePhase,
            comparisonPoint: $0777f04525ed21e4$export$b2aaa5bc54318fb1(legacyPhase),
            divergenceReason: $0777f04525ed21e4$export$d239298095fe15f0(legacyPhase, machinePhase)
        }
    };
};
module.exports["isTerminalPhase"] = $0777f04525ed21e4$export$9828bb32a038414e;
module.exports["compareRendererRemixParity"] = $0777f04525ed21e4$export$78e12f3697c824a9;

});

parcelRegister("2Jxlo", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $8c38d1311bce6ee3$export$15b21f0ead27e4bf = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "qNGEh",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("qHDhV"))).ReadingAidsPopup
});
module.exports["ReadingAidsPopup"] = $8c38d1311bce6ee3$export$15b21f0ead27e4bf;

});

parcelRegister("qHDhV", function(module, exports) {

let $0504465d1c28cef4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $0504465d1c28cef4$var$load("kT6dz"),
    $0504465d1c28cef4$var$load("5MILN"),
    $0504465d1c28cef4$var$load("dbmgs"),
    $0504465d1c28cef4$var$load("8Lsss"),
    $0504465d1c28cef4$var$load("8TYN0"),
    $0504465d1c28cef4$var$load("9i6sC"),
    $0504465d1c28cef4$var$load("hUbK8"),
    $0504465d1c28cef4$var$load("4oHR8"),
    $0504465d1c28cef4$var$load("5KHgm"),
    $0504465d1c28cef4$var$load("fcAaN"),
    $0504465d1c28cef4$var$load("alg5Q"),
    $0504465d1c28cef4$var$load("lMMiy"),
    $0504465d1c28cef4$var$load("1Gr4q"),
    $0504465d1c28cef4$var$load("2mGc6"),
    $0504465d1c28cef4$var$load("1EaSa"),
    $0504465d1c28cef4$var$load("jzRlw"),
    $0504465d1c28cef4$var$load("kccW9"),
    $0504465d1c28cef4$var$load("4dKZ4"),
    $0504465d1c28cef4$var$load("8yk9S"),
    $0504465d1c28cef4$var$load("iOfkQ"),
    $0504465d1c28cef4$var$load("eeYoU"),
    $0504465d1c28cef4$var$load("7SteV"),
    $0504465d1c28cef4$var$load("1cQg7"),
    $0504465d1c28cef4$var$load("avoXg"),
    $0504465d1c28cef4$var$load("kUh5E"),
    $0504465d1c28cef4$var$load("dxcsb"),
    $0504465d1c28cef4$var$load("jqoep"),
    $0504465d1c28cef4$var$load("7EsNO"),
    $0504465d1c28cef4$var$load("3vH95"),
    $0504465d1c28cef4$var$load("fnO1K"),
    $0504465d1c28cef4$var$load("aLwQm"),
    $0504465d1c28cef4$var$load("ajcqE"),
    $0504465d1c28cef4$var$load("7iw60"),
    $0504465d1c28cef4$var$load("1YU2Y"),
    $0504465d1c28cef4$var$load("4GjU8"),
    $0504465d1c28cef4$var$load("fKQ9j"),
    $0504465d1c28cef4$var$load("740ev"),
    $0504465d1c28cef4$var$load("6WdSW"),
    $0504465d1c28cef4$var$load("4x9Jx"),
    $0504465d1c28cef4$var$load("ea3NB"),
    $0504465d1c28cef4$var$load("6wr18"),
    $0504465d1c28cef4$var$load("59hV4"),
    $0504465d1c28cef4$var$load("fibpY"),
    $0504465d1c28cef4$var$load("4O6U4"),
    $0504465d1c28cef4$var$load("ffEVr"),
    $0504465d1c28cef4$var$load("djJht"),
    $0504465d1c28cef4$var$load("do0Fh"),
    $0504465d1c28cef4$var$load("i7f39"),
    $0504465d1c28cef4$var$load("hwJJ4"),
    $0504465d1c28cef4$var$load("GiPCt"),
    $0504465d1c28cef4$var$load("fwbNS"),
    $0504465d1c28cef4$var$load("jDL3j"),
    $0504465d1c28cef4$var$load("bHBjF"),
    $0504465d1c28cef4$var$load("Wowvf"),
    $0504465d1c28cef4$var$load("29XrG"),
    $0504465d1c28cef4$var$load("Lm7SH"),
    $0504465d1c28cef4$var$load("hhss7"),
    $0504465d1c28cef4$var$load("7EorR"),
    $0504465d1c28cef4$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});

parcelRegister("eDk57", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4aiCO = parcelRequire("4aiCO");


var $1mDVg = parcelRequire("1mDVg");

const $45dbb5af31f3f8d0$export$bc90850968906652 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1mDVg.IssueCreateSidePanelContainer), {
        isGlobal: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aiCO.IssueCreateWarningDialogContainer), null, children));
};
module.exports["SingleIssueCreateProvidersWrapper"] = $45dbb5af31f3f8d0$export$bc90850968906652;

});

parcelRegister("aiS08", function(module, exports) {
$parcel$export(module.exports, "ISSUE_CREATE_SIDE_PANEL_ID", () => (parcelRequire("1L1jV")).ISSUE_CREATE_SIDE_PANEL_ID);

var $jmjWc = parcelRequire("jmjWc");


var $1L1jV = parcelRequire("1L1jV");


const $8c03994ca3756429$export$808956d96594cb81 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "dU97j",
    name: "IssueCreateSidePanel",
    loader: async ()=>(await Promise.resolve((parcelRequire("1L1jV")))).IssueCreateSidePanel
});
module.exports["IssueCreateSidePanel"] = $8c03994ca3756429$export$808956d96594cb81;

});

parcelRegister("1L1jV", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $9DHhW = parcelRequire("9DHhW");


var $fNTq8 = parcelRequire("fNTq8");


var $cFVPs = parcelRequire("cFVPs");


var $7aRa9 = parcelRequire("7aRa9");


var $ai7NK = parcelRequire("ai7NK");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $98CLM = parcelRequire("98CLM");


var $kJYUO = parcelRequire("kJYUO");


var $1mDVg = parcelRequire("1mDVg");


var $eDk57 = parcelRequire("eDk57");


var $5Ew1A = parcelRequire("5Ew1A");


var $jwedr = parcelRequire("jwedr");


var $3AAT8 = parcelRequire("3AAT8");


var $hib1D = parcelRequire("hib1D");


var $6pbwW = parcelRequire("6pbwW");

const $7dea7a25aec9b259$export$3318bd9d18742c1e = 'issue-create-side-panel';
const $7dea7a25aec9b259$export$e760a8f02240cc6d = 'issue-create-side-panel';
const $7dea7a25aec9b259$export$d030b92b162b528d = 320;
const $7dea7a25aec9b259$var$sidePanelStyle = (0, $buxP3.xcss)({
    position: 'relative'
});
const $7dea7a25aec9b259$var$IssueCreateSidePanelComponent = ({ onClose: onClose, flags: flags })=>{
    const { showSidePanel: showSidePanel, hideSidePanel: hideSidePanel } = (0, $ai7NK.useSidePanelStateActions)();
    const { isWarningDialogOpen: isWarningDialogOpen, handleConfirm: handleConfirm, handleCancel: handleCancel } = (0, $jwedr.useGetWarningDialogActions)(onClose);
    const [state, actions] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const { aiState: aiState, isCreatedWithAi: isCreatedWithAi, aiAnalyticsContext: aiAnalyticsContext, isCreatedFromActionItems: isCreatedFromActionItems } = state;
    const aiIssueCreationEnablement = (0, $1mDVg.useAiIssueCreationEnablementState)();
    const { trackAIInteractionDismiss: trackAIInteractionDismiss } = (0, $cFVPs.useAIEventsInstrumentation)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const shouldShowAiFooter = isCreatedWithAi && aiState !== 'error';
    const isAiLoading = aiState === 'loading';
    const handleOnClose = (0, $cozmU.useCallback)((isCreateSuccess)=>{
        if (isCreatedWithAi && !isCreateSuccess) trackAIInteractionDismiss({
            attributes: aiAnalyticsContext
        });
        if (!isCreateSuccess) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'confluenceHighlightIssueCreate',
                action: 'closed',
                actionSubject: 'modalDialog',
                actionSubjectId: 'linkCreate',
                type: 'ui',
                attributes: {
                    isManuallyCreated: !isCreatedWithAi,
                    isCreatedWithAi: isCreatedWithAi,
                    pageMode: state.pageMode,
                    hasEditPermission: state.hasEditPermission,
                    isAiLoading: isAiLoading,
                    aiEnablement: aiIssueCreationEnablement?.enablement,
                    isCreatedFromActionItems: isCreatedFromActionItems,
                    // We don't invoke table creation from highlighting a single row
                    isCreatedFromTable: false
                }
            }
        }).fire();
        hideSidePanel();
        onClose();
        actions.setAiState('idle');
    }, [
        isCreatedWithAi,
        hideSidePanel,
        onClose,
        actions,
        trackAIInteractionDismiss,
        aiAnalyticsContext,
        createAnalyticsEvent,
        state.pageMode,
        isAiLoading,
        aiIssueCreationEnablement?.enablement,
        state.hasEditPermission,
        isCreatedFromActionItems
    ]);
    const handleOnConfirm = (0, $cozmU.useCallback)(()=>{
        actions.setAiState('idle');
        handleConfirm();
    }, [
        actions,
        handleConfirm
    ]);
    (0, $cozmU.useEffect)(()=>{
        showSidePanel();
    }, [
        showSidePanel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        testId: $7dea7a25aec9b259$export$3318bd9d18742c1e,
        xcss: $7dea7a25aec9b259$var$sidePanelStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5Ew1A.SidePanelWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kJYUO.IssueCreateAiLoadingSidebar), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6pbwW.IssueCreateSidePanelHeader), {
        onClose: handleOnClose
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3AAT8.IssueCreateSidePanelBody), {
        onClose: handleOnClose,
        flags: flags
    }), shouldShowAiFooter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hib1D.IssueCreateSidePanelFooter), null))), isWarningDialogOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $98CLM.IssueCreateWarningDialog), {
        onCancel: handleCancel,
        onConfirm: handleOnConfirm,
        issuesCount: 1
    }));
};
const $7dea7a25aec9b259$var$IssueCreateSidePanelComponentWithProvider = ({ onClose: onClose, flags: flags })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eDk57.SingleIssueCreateProvidersWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fNTq8.AIEventsInstrumentationProvider), {
        config: {
            // Required configruation
            product: 'confluence',
            subproduct: 'jira',
            aiFeatureName: 'confluenceAiWorkCreation',
            proactiveGeneratedAI: 0,
            userGeneratedAI: 1,
            // Optional configuration
            source: 'confluenceHighlightIssueCreate',
            skipAISessionValidation: true
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7dea7a25aec9b259$var$IssueCreateSidePanelComponent, {
        onClose: onClose,
        flags: flags
    })));
};
const $7dea7a25aec9b259$var$IssueCreateSidePanelWithFlags = (0, $7aRa9.withFlags)($7dea7a25aec9b259$var$IssueCreateSidePanelComponentWithProvider);
const $7dea7a25aec9b259$var$IssueCreateSidePanelWithErrorBoundary = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).INTEGRATIONS
})($7dea7a25aec9b259$var$IssueCreateSidePanelWithFlags);
const $7dea7a25aec9b259$export$808956d96594cb81 = $7dea7a25aec9b259$var$IssueCreateSidePanelWithErrorBoundary;
module.exports["sidePanelTestId"] = $7dea7a25aec9b259$export$3318bd9d18742c1e;
module.exports["ISSUE_CREATE_SIDE_PANEL_ID"] = $7dea7a25aec9b259$export$e760a8f02240cc6d;
module.exports["ISSUE_CREATE_SIDE_PANEL_WIDTH"] = $7dea7a25aec9b259$export$d030b92b162b528d;
module.exports["IssueCreateSidePanel"] = $7dea7a25aec9b259$export$808956d96594cb81;

});

parcelRegister("ai7NK", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $30dd91193859fc54$export$4f97fa3245bb0e31 = {
    isSidePanelOpen: false
};
const $30dd91193859fc54$export$e324594224ef24da = {
    showSidePanel: ()=>({ setState: setState })=>{
            setState({
                isSidePanelOpen: true
            });
        },
    hideSidePanel: ()=>({ setState: setState })=>{
            setState({
                isSidePanelOpen: false
            });
        }
};
const $30dd91193859fc54$var$Store = (0, $8s9DV.createStore)({
    initialState: $30dd91193859fc54$export$4f97fa3245bb0e31,
    actions: $30dd91193859fc54$export$e324594224ef24da,
    name: 'SidePanelState'
});
const $30dd91193859fc54$export$d4bcf572fecd48f5 = (0, $kBr4q.createActionsHook)($30dd91193859fc54$var$Store);
const $30dd91193859fc54$export$f3f6191f6fee6235 = (0, $kBr4q.createStateHook)($30dd91193859fc54$var$Store, {
    selector: (state)=>state.isSidePanelOpen
});
module.exports["useSidePanelStateActions"] = $30dd91193859fc54$export$d4bcf572fecd48f5;
module.exports["useIsSidePanelOpen"] = $30dd91193859fc54$export$f3f6191f6fee6235;

});

parcelRegister("kJYUO", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $1mDVg = parcelRequire("1mDVg");


var $hq2Sz = parcelRequire("hq2Sz");


var $1uJpg = parcelRequire("1uJpg");

const $e4ab54f04ea47f96$export$dcc317fc4f9228b3 = ({ children: children })=>{
    const [{ aiState: aiState, pageMode: pageMode, hasEditPermission: hasEditPermission }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const [{ isCreatedFromActionItems: isCreatedFromActionItems, isCreatedFromTable: isCreatedFromTable }] = (0, $hq2Sz.useBulkCreateContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const aiIssueCreationEnablement = (0, $1mDVg.useAiIssueCreationEnablementState)();
    const isAiLoading = aiState === 'loading';
    const aiEnablement = aiIssueCreationEnablement?.enablement;
    (0, $cozmU.useEffect)(()=>{
        if (isAiLoading) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'AI loading state',
                source: 'confluenceHighlightIssueCreate',
                attributes: {
                    aiEnablement: aiEnablement,
                    pageMode: pageMode,
                    hasEditPermission: hasEditPermission,
                    isCreatedFromActionItems: isCreatedFromActionItems,
                    isCreatedFromTable: isCreatedFromTable
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isAiLoading,
        aiEnablement,
        pageMode,
        hasEditPermission,
        isCreatedFromActionItems,
        isCreatedFromTable
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1uJpg.RainbowLoadingSidebar), {
        isShown: isAiLoading
    }, children);
};
module.exports["IssueCreateAiLoadingSidebar"] = $e4ab54f04ea47f96$export$dcc317fc4f9228b3;

});

parcelRegister("3AAT8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $9DHhW = parcelRequire("9DHhW");


var $iNyje = parcelRequire("iNyje");


var $cFVPs = parcelRequire("cFVPs");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");


var $1mDVg = parcelRequire("1mDVg");


var $5FJ5W = parcelRequire("5FJ5W");


var $3E5yu = parcelRequire("3E5yu");


var $1Q0l6 = parcelRequire("1Q0l6");


var $9K9na = parcelRequire("9K9na");


var $2ay9q = parcelRequire("2ay9q");


var $bImpr = parcelRequire("bImpr");


var $kcLnq = parcelRequire("kcLnq");


var $bZC8A = parcelRequire("bZC8A");


var $jE0Gg = parcelRequire("jE0Gg");


var $aXkRG = parcelRequire("aXkRG");


var $dAg4H = parcelRequire("dAg4H");

const $889e5fc4cfbacead$var$aiContentWrapperBaseStyles = (0, $buxP3.xcss)({
    display: 'inherit',
    flexGrow: 1
});
const $889e5fc4cfbacead$var$aiContentWrapperHiddenStyles = (0, $buxP3.xcss)({
    display: 'none'
});
const $889e5fc4cfbacead$export$b5988d25d9f45521 = ({ onClose: onClose, flags: flags })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [state, actions] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const { contentId: contentId, contentType: contentType, summary: summary, descriptionAdf: descriptionAdf, aiState: aiState, isCreatedWithAi: isCreatedWithAi, highlightedText: highlightedText, selectedAdf: selectedAdf, insertStorageFragmentRequestPayload: insertStorageFragmentRequestPayload, totalRetries: totalRetries, firstAttempt: firstAttempt, aiAnalyticsContext: aiAnalyticsContext, currentSiteSelection: currentSiteSelection, currentProjectSelection: currentProjectSelection, isGicIframeReady: isGicIframeReady, isCreatedFromActionItems: isCreatedFromActionItems, editorAPI: editorAPI } = state;
    const aiIssueCreationEnablement = (0, $1mDVg.useAiIssueCreationEnablementState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultError: trackAIResultError, trackAIResultView: trackAIResultView, trackAIResultAction: trackAIResultAction } = (0, $cFVPs.useAIEventsInstrumentation)();
    (0, $dAg4H.useIsAIIssueCreationAllowed)({
        contentId: contentId,
        isBulkCreate: false
    });
    const aiError = aiState === 'error';
    // no need to override if it's the same site
    const persistedOverrideCloudId = (0, $2ay9q.getPersistedOverrideCloudId)();
    const [overrideCloudIdForSitePicker, setOverrideCloudIdForSitePicker] = (0, $cozmU.useState)(persistedOverrideCloudId !== cloudId ? persistedOverrideCloudId : undefined);
    const [overrideProjectId, setOverrideProjectId] = (0, $cozmU.useState)(undefined);
    const [showCreateWithAiToggle, setShowCreateWithAiToggle] = (0, $cozmU.useState)(false);
    const defaultErrorMessage = (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).singleCreateAiErrorDescriptionIssueTermRefreshRebrandToRovo : (0, $3E5yu.messages).singleCreateAiErrorDescriptionRebrandToRovo;
    const [errorMessage, setErrorMessage] = (0, $cozmU.useState)(defaultErrorMessage);
    const [errorMessageValues, setErrorMessageValues] = (0, $cozmU.useState)();
    const [hideTryAgain, setHideTryAgain] = (0, $cozmU.useState)(false);
    (0, $jE0Gg.useMessageListener)();
    (0, $cozmU.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'linkCreateScreen',
                attributes: {
                    isManuallyCreated: !isCreatedWithAi,
                    isCreatedWithAi: isCreatedWithAi,
                    isCreatedFromActionItems: isCreatedFromActionItems,
                    // We don't invoke table creation from highlighting a single row
                    isCreatedFromTable: false,
                    pageMode: state.pageMode,
                    hasEditPermission: state.hasEditPermission,
                    aiEnablement: aiIssueCreationEnablement?.enablement
                },
                source: 'confluenceHighlightIssueCreate'
            }
        }).fire();
    }, [
        isCreatedWithAi,
        createAnalyticsEvent,
        aiIssueCreationEnablement?.enablement,
        state.pageMode,
        state.hasEditPermission,
        isCreatedFromActionItems
    ]);
    const isAiLoading = aiState === 'loading';
    const triggerFlag = (0, $9K9na.useTriggerFlagIssueCreated)(flags);
    const handleTryAgain = (0, $cozmU.useCallback)(()=>{
        actions.setTotalRetries();
        actions.setFirstAttempt(false);
        actions.setAiState('idle');
        // trigger a new AI interaction init event retries
        trackAIInteractionInit({
            attributes: {
                pageMode: state.pageMode,
                totalRetries: totalRetries + 1,
                firstAttempt: false,
                aiEnablement: aiIssueCreationEnablement?.enablement
            }
        });
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'issueCreateSidePanelErrorScreen',
                action: 'retry',
                actionSubject: 'issueCreate',
                attributes: {
                    pageMode: state.pageMode,
                    hasEditPermission: state.hasEditPermission,
                    createManually: !isCreatedWithAi,
                    tryAgainWithAi: isCreatedWithAi,
                    totalRetries: totalRetries + 1,
                    firstAttempt: false,
                    ...aiAnalyticsContext
                }
            }
        }).fire();
    }, [
        actions,
        trackAIInteractionInit,
        totalRetries,
        aiIssueCreationEnablement?.enablement,
        createAnalyticsEvent,
        state.pageMode,
        isCreatedWithAi,
        aiAnalyticsContext,
        state.hasEditPermission
    ]);
    const handleCreateManually = (0, $cozmU.useCallback)(()=>{
        actions.setIsCreatedWithAi(false);
        actions.setAiState('idle');
        setShowCreateWithAiToggle(false);
    }, [
        actions
    ]);
    const handleCreateWithAi = (0, $cozmU.useCallback)(()=>{
        actions.setIsCreatedWithAi(true);
        actions.setAiState('loading');
        setShowCreateWithAiToggle(false);
    }, [
        actions
    ]);
    const handleCreateManuallyAfterError = (0, $cozmU.useCallback)(()=>{
        actions.setTotalRetries();
        actions.setFirstAttempt(false);
        actions.setIsCreateManuallyPressed(true);
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'issueCreateSidePanelErrorScreen',
                action: 'retry',
                actionSubject: 'issueCreate',
                attributes: {
                    pageMode: state.pageMode,
                    hasEditPermission: state.hasEditPermission,
                    createManually: true,
                    tryAgainWithAi: false,
                    totalRetries: totalRetries + 1,
                    firstAttempt: false,
                    ...aiAnalyticsContext
                }
            }
        }).fire();
        handleCreateManually();
    }, [
        actions,
        createAnalyticsEvent,
        state.pageMode,
        state.hasEditPermission,
        totalRetries,
        aiAnalyticsContext,
        handleCreateManually
    ]);
    const onIssueCreateInit = (0, $cozmU.useCallback)(()=>{
        setShowCreateWithAiToggle(aiIssueCreationEnablement?.isEnabled ?? false);
        /*
     * When ConfluenceAI=OFF & JiraAI=ON this component will manually create the issue first until
     * selected site & project info is available to check Jira's AI enablement.  If JiraAI=ON then
     * we can setIsCreatedWithAi to what the user's personal AI enablement to trigger a rerender.
     */ if (aiIssueCreationEnablement?.isEnabled) actions.setIsCreatedWithAi((0, $2ay9q.getIsCreateIssueWithAiEnabledByUser)());
        else actions.setIsCreatedWithAi(false);
        if (!(0, $2ay9q.getIsCreateIssueWithAiEnabledByUser)()) return;
        /*
     * requiresComponentChange is important since we are switching between manaul create (GicAnywhere) and
     * ConfluenceAiIssueCreate (which uses GicAnywhere under the hood).  The GicAnywhere has limitations where
     * changes to overrideCloudId after initial load can cause iframe rendering issues.  A component swap happens only when
     * the isCreatedWithAi state is changed so we can bundle these prop updates together.
     */ const requiresComponentChange = aiIssueCreationEnablement?.isEnabled !== isCreatedWithAi;
        if (requiresComponentChange) {
            setOverrideCloudIdForSitePicker(currentSiteSelection);
            setOverrideProjectId(currentProjectSelection?.selectedProjectId);
            // During component switch the iframe will be replaced and there is no event for this.
            // We need to reset it here manually.
            actions.setIsGicIframeReady(false);
        }
        if (currentSiteSelection && currentSiteSelection !== overrideCloudIdForSitePicker) setOverrideProjectId(currentProjectSelection?.selectedProjectId);
    }, [
        aiIssueCreationEnablement?.isEnabled,
        isCreatedWithAi,
        currentSiteSelection,
        overrideCloudIdForSitePicker,
        actions,
        currentProjectSelection?.selectedProjectId
    ]);
    const onAiIssueCreateInit = (0, $cozmU.useCallback)(()=>{
        onIssueCreateInit();
        const analyticAttributes = {
            attributes: {
                ...aiAnalyticsContext,
                aiEnablement: aiIssueCreationEnablement?.enablement,
                pageMode: state.pageMode,
                hasEditPermission: state.hasEditPermission
            }
        };
        trackAIInteractionInit(analyticAttributes);
        trackAIResultView({
            actionSubjectId: 'aiIssueCreatOnInitComplete',
            ...analyticAttributes
        });
    }, [
        onIssueCreateInit,
        aiAnalyticsContext,
        aiIssueCreationEnablement?.enablement,
        state.pageMode,
        trackAIInteractionInit,
        trackAIResultView,
        state.hasEditPermission
    ]);
    const isSuggestedIssuesErrorMessage = (error)=>{
        return error && typeof error === 'object' && 'message_template' in error;
    };
    const onFailure = (0, $cozmU.useCallback)((error)=>{
        // reset
        if (hideTryAgain) {
            setHideTryAgain(false);
            setErrorMessage((0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).singleCreateAiErrorDescriptionIssueTermRefreshRebrandToRovo : (0, $3E5yu.messages).singleCreateAiErrorDescriptionRebrandToRovo);
            setErrorMessageValues({});
        }
        if (isSuggestedIssuesErrorMessage(error)) {
            const aiIssueCreateError = (0, $bZC8A.handleAiIssueCreateError)(error);
            if (aiIssueCreateError !== undefined) {
                setErrorMessage(aiIssueCreateError.errorMessage);
                setErrorMessageValues(aiIssueCreateError.errorMessageValues);
                setHideTryAgain(aiIssueCreateError.hideTryAgain);
            }
        }
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'confluenceHighlightIssueCreate',
                action: 'error',
                actionSubject: 'globalIssueCreate',
                attributes: {
                    isManuallyCreated: !isCreatedWithAi,
                    isCreatedWithAi: isCreatedWithAi,
                    pageMode: state.pageMode,
                    hasEditPermission: state.hasEditPermission,
                    error: error,
                    aiEnablement: aiIssueCreationEnablement?.enablement
                }
            }
        }).fire();
        if (isCreatedWithAi) trackAIResultError({
            aiErrorMessage: error.message
        }, {
            attributes: {
                pageMode: state.pageMode,
                hasEditPermission: state.hasEditPermission,
                totalRetries: totalRetries,
                firstAttempt: firstAttempt,
                ...aiAnalyticsContext
            }
        });
    }, [
        hideTryAgain,
        createAnalyticsEvent,
        isCreatedWithAi,
        state.pageMode,
        state.hasEditPermission,
        aiIssueCreationEnablement?.enablement,
        trackAIResultError,
        totalRetries,
        firstAttempt,
        aiAnalyticsContext
    ]);
    const onSuccess = (0, $cozmU.useCallback)((payload)=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'confluenceHighlightIssueCreate',
                action: 'created',
                actionSubject: 'issue',
                actionSubjectId: 'confluenceIssueCreate',
                attributes: {
                    isManuallyCreated: !isCreatedWithAi,
                    isCreatedWithAi: isCreatedWithAi,
                    // We don't invoke table creation from highlighting a single row
                    isCreatedFromTable: false,
                    isCreatedFromActionItems: isCreatedFromActionItems,
                    pageMode: state.pageMode,
                    hasEditPermission: state.hasEditPermission,
                    aiEnablement: aiIssueCreationEnablement?.enablement
                }
            }
        }).fire();
        if (isCreatedWithAi) trackAIResultAction('issue created', {
            attributes: {
                pageMode: state.pageMode,
                hasEditPermission: state.hasEditPermission,
                isCreatedFromActionItems: isCreatedFromActionItems,
                // We don't invoke table creation from highlighting a single row
                isCreatedFromTable: false,
                totalRetries: totalRetries,
                firstAttempt: firstAttempt,
                issueId: payload?.issueId || '',
                aiEnablement: aiIssueCreationEnablement?.enablement,
                ...aiAnalyticsContext
            }
        });
        triggerFlag(payload, 'success-circle', (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).sidePanelSingleIssueCreateSuccessFlagTitleIssueTermRefresh : (0, $3E5yu.messages).sidePanelSingleIssueCreateSuccessFlagTitle);
        // Save the cloud id in localStorage if an issue is created
        (0, $2ay9q.saveCloudIdToLocalStorage)(payload);
        if (insertStorageFragmentRequestPayload && state.hasEditPermission) {
            insertStorageFragmentRequestPayload.xmlModification = isCreatedFromActionItems ? (0, $1Q0l6.constructBreakContainerTag)((0, $1Q0l6.constructSmartlinkTag)(payload.link)) : (0, $1Q0l6.constructSmartlinkTag)(payload.link);
            (0, $1Q0l6.updateLastFetchTimeIfNotViewMode)(insertStorageFragmentRequestPayload, state.pageMode);
            const insertPromise = (0, $1Q0l6.insertSingleWorkItemToEndOfSelection)({
                insertStorageFragmentRequestPayload: insertStorageFragmentRequestPayload,
                pageMode: state.pageMode ?? (0, $1mDVg.PageMode).VIEW,
                selectedAdf: selectedAdf,
                editorAPI: editorAPI,
                workItemUrl: payload.link
            });
            insertPromise.then((data)=>{
                // There is a case where the API response is OK, but the response data is false.
                // When this happens, the backend has trouble inserting the ticket to the page and we should show an error toast.
                if (data === false) throw new Error('Failed to insert storage fragment');
                return createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        source: 'confluenceHighlightIssueCreate',
                        action: 'created',
                        actionSubject: 'link',
                        actionSubjectId: 'confluenceIssueCreate',
                        attributes: {
                            isManuallyCreated: !isCreatedWithAi,
                            isCreatedWithAi: isCreatedWithAi,
                            pageMode: state.pageMode,
                            hasEditPermission: state.hasEditPermission
                        }
                    }
                }).fire();
            }).then(()=>{
                // Refresh the page only if the current mode is VIEW, as other modes receive live updates.
                if (state.pageMode === (0, $1mDVg.PageMode).VIEW) (0, $1Q0l6.refreshPageWithTimeout)();
            }).catch((_error)=>triggerFlag(payload, 'error', (0, $3E5yu.messages).sidePanelIssueCreateInsertionFailed));
        }
    }, [
        createAnalyticsEvent,
        isCreatedWithAi,
        isCreatedFromActionItems,
        state.pageMode,
        state.hasEditPermission,
        aiIssueCreationEnablement?.enablement,
        triggerFlag,
        insertStorageFragmentRequestPayload,
        selectedAdf,
        editorAPI,
        trackAIResultAction,
        totalRetries,
        firstAttempt,
        aiAnalyticsContext
    ]);
    const handleStateChange = (0, $cozmU.useCallback)((state, source)=>{
        // Keep loading animation active when get Confluence page completes but field suggestions are still loading
        if (source === 'aiIssueCreateGetConfluencePageState' && (state === 'idle' || state === 'loading')) return;
        actions.setAiState(state);
    }, [
        actions
    ]);
    const onAiToggleChange = (0, $cozmU.useCallback)((enabled)=>{
        if (enabled) {
            trackAIInteractionInit({
                attributes: {
                    pageMode: state.pageMode,
                    hasEditPermission: state.hasEditPermission,
                    aiEnablement: aiIssueCreationEnablement?.enablement
                }
            });
            handleCreateWithAi();
        } else handleCreateManually();
    }, [
        trackAIInteractionInit,
        state.pageMode,
        state.hasEditPermission,
        aiIssueCreationEnablement?.enablement,
        handleCreateWithAi,
        handleCreateManually
    ]);
    if (aiError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aXkRG.WorkItemCreationError), {
        creationSource: "confluenceHighlightIssueCreate",
        errorMessage: errorMessage,
        errorMessageValues: hideTryAgain ? errorMessageValues : undefined,
        onTryAgain: hideTryAgain ? undefined : handleTryAgain,
        onCreateManually: handleCreateManuallyAfterError,
        isCreatedWithAi: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, !isAiLoading && isGicIframeReady && showCreateWithAiToggle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bImpr.IssueCreateWithAiToggle), {
        onChange: onAiToggleChange
    }), isCreatedWithAi ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, isAiLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5FJ5W.IssueCreateAiLoading), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: [
            $889e5fc4cfbacead$var$aiContentWrapperBaseStyles,
            isAiLoading && $889e5fc4cfbacead$var$aiContentWrapperHiddenStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kcLnq.ConfluenceAiIssueCreate), {
        cloudId: cloudId,
        contentType: contentType,
        pageId: contentId,
        highlightedTextAdf: highlightedText,
        consumer: "confluence-highlight-issue-create-ai",
        onInit: onAiIssueCreateInit,
        onSuccess: onSuccess,
        onFailure: onFailure,
        onClose: onClose,
        onStateChange: handleStateChange,
        overrideCloudIdForSitePicker: overrideCloudIdForSitePicker,
        overrideProjectIdForProjectPicker: overrideProjectId,
        setAiAnalyticsContext: actions.setAiAnalyticsContext,
        aIIssueCreationEnablement: aiIssueCreationEnablement
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iNyje.GicAnywhere), {
        cloudId: cloudId,
        consumer: "confluence-highlight-issue-create",
        onInit: onIssueCreateInit,
        onSuccess: onSuccess,
        onClose: onClose,
        onFailure: onFailure,
        summary: summary,
        descriptionAdf: descriptionAdf,
        overrideCloudId: overrideCloudIdForSitePicker,
        isPayloadReady: true,
        projectId: overrideProjectId
    }));
};
module.exports["IssueCreateSidePanelBody"] = $889e5fc4cfbacead$export$b5988d25d9f45521;

});

parcelRegister("9K9na", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7vK9E = parcelRequire("7vK9E");

const $c2473cc34e5c9c56$export$8ecee5edd581c23a = (flags)=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return (0, $cozmU.useCallback)((payload, flagType, message)=>{
        flags.showFlag({
            type: flagType,
            title: formatMessage(message, {
                issueKey: payload?.issueKey,
                issueSummary: payload?.summary,
                link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
                        href: payload?.link,
                        target: "_blank"
                    }, chunks)
            }),
            close: 'auto'
        });
    }, [
        flags,
        formatMessage
    ]);
};
module.exports["useTriggerFlagIssueCreated"] = $c2473cc34e5c9c56$export$8ecee5edd581c23a;

});

parcelRegister("kcLnq", function(module, exports) {
/* ConfluenceAiIssueCreate.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $4AavA = parcelRequire("4AavA");


var $c8cGy = parcelRequire("c8cGy");


var $iMnC5 = parcelRequire("iMnC5");


var $b8pma = parcelRequire("b8pma");


var $4n04n = parcelRequire("4n04n");


var $htTUm = parcelRequire("htTUm");


var $fNTq8 = parcelRequire("fNTq8");


var $iNyje = parcelRequire("iNyje");


var $7JWNS = parcelRequire("7JWNS");


var $l4gv5 = parcelRequire("l4gv5");


var $kfViO = parcelRequire("kfViO");


var $9BGuq = parcelRequire("9BGuq");


var $arvSz = parcelRequire("arvSz");


var $gqQUx = parcelRequire("gqQUx");

const $0aab3fed706492b4$export$7bd623b29ec8e1eb = 7000; // 7s timeout, typical GIC load is ~3s
const $0aab3fed706492b4$var$style = {
    aiIssueCreateWrapper: "_2O5Vij7dHp"
};
const $0aab3fed706492b4$export$fbdfb25d3cad524a = ({ confluencePage: confluencePage, highlightedText: highlightedText, isReady: isReady, overrideXProduct: overrideXProduct, handleAiSuggestedFieldsStateChange: handleAiSuggestedFieldsStateChange })=>{
    const streamingHookProps = (0, $arvSz.useStreamingHookProps)({
        confluencePage: confluencePage,
        highlightedText: highlightedText,
        overrideXProduct: overrideXProduct
    });
    const { suggestions: suggestions, isStreaming: isStreaming, error: error, onAIResultView: onAIResultView } = (0, $7JWNS.useAiWorkSuggestionStreaming)(streamingHookProps); // Transform streaming suggestions to match the expected fields format
    const transformedFields = (0, $cozmU.useMemo)(()=>{
        // Only use suggestions when streaming is complete
        if (isStreaming) return {
            summary: '',
            description: ''
        };
        return {
            summary: suggestions?.[0]?.field_values?.Summary || '',
            description: suggestions?.[0]?.field_values?.Description || ''
        };
    }, [
        suggestions,
        isStreaming
    ]);
    const getServiceState = ()=>{
        if (error) return 'error';
        if (isStreaming) return 'loading';
        return 'idle';
    };
    (0, $cozmU.useEffect)(()=>{
        if (error) handleAiSuggestedFieldsStateChange({
            state: 'error',
            error: $0aab3fed706492b4$export$98d40c5fd23ef716(error)
        });
        else if (isStreaming) handleAiSuggestedFieldsStateChange({
            state: 'loading',
            fields: transformedFields
        });
        else handleAiSuggestedFieldsStateChange({
            state: 'idle',
            fields: transformedFields
        });
    }, [
        error,
        isStreaming,
        transformedFields,
        handleAiSuggestedFieldsStateChange
    ]);
    if (!isReady) return {
        state: 'loading',
        fields: null
    };
    return {
        state: getServiceState(),
        fields: transformedFields,
        onAIResultView: onAIResultView,
        suggestions: suggestions,
        isStreaming: isStreaming
    };
};
const $0aab3fed706492b4$export$98d40c5fd23ef716 = (error)=>{
    return {
        message_template: error?.message?.message_template,
        statusCode: error?.message?.status_code,
        message: error?.message?.content,
        content: error?.message?.content
    };
};
const $0aab3fed706492b4$export$a653b3ac3dd182f4 = ({ cloudId: cloudId, overrideCloudIdForSitePicker: overrideCloudIdForSitePicker, overrideProjectIdForProjectPicker: overrideProjectIdForProjectPicker, contentType: contentType, pageId: pageId, pageMode: pageMode, highlightedTextAdf: highlightedTextAdf, timeoutMs: timeoutMs = $0aab3fed706492b4$export$7bd623b29ec8e1eb, onInit: onInit, onSuccess: onSuccess, onFailure: onFailure, onClose: onClose, onTimeout: onTimeout, testId: testId, onStateChange: onStateChange, consumer: consumer, setAiAnalyticsContext: setAiAnalyticsContext, aIIssueCreationEnablement: aIIssueCreationEnablement })=>{
    const { fireTrack: fireTrack } = (0, $9BGuq.useAiIssueCreateAnalytics)();
    const [confluencePage, setConfluencePage] = (0, $cozmU.useState)('');
    const [idMap, setIdMap] = (0, $cozmU.useState)({});
    const [isIdMapReady, setIsIdMapReady] = (0, $cozmU.useState)(false); // Custom handler to wrap multiple onStateChange calls
    const handleStateChange = (0, $cozmU.useCallback)((source, state)=>{
        // trigger error if any state is errored
        if (onFailure && state?.state === 'error') {
            onFailure(state.error, state.message_template);
            fireTrack(`${source} failed`);
        }
        if (onStateChange) {
            onStateChange(state.state, source);
            fireTrack(`${source} updated`, {
                state: state.state
            });
        }
    }, [
        onFailure,
        onStateChange,
        fireTrack
    ]);
    const handleConfluencePageStateChange = (0, $cozmU.useCallback)((newState)=>handleStateChange('aiIssueCreateGetConfluencePageState', newState), [
        handleStateChange
    ]); // Fetch confluence page
    const { state: confluencePageState, confluencePage: confluencePageAsAdf } = (0, $gqQUx.useGetConfluencePage)({
        cloudId: cloudId,
        contentType: contentType,
        experienceId: 'ai-issue-create-confluence-single',
        pageId: pageId,
        pageMode: pageMode,
        onStateChange: handleConfluencePageStateChange
    }); // Effect to transform confluence page ADF to markdown after fetching
    (0, $cozmU.useEffect)(()=>{
        if (confluencePageState === 'idle' && confluencePageAsAdf) {
            const { markdown: markdown, idMap: newIdMap } = (0, $4n04n.adfToMarkdownPlus)(confluencePageAsAdf, {
                markdownPlusUseNextLayoutSection: true
            });
            setAiAnalyticsContext && setAiAnalyticsContext('pageContextLength', (0, $kfViO.countADFChars)(confluencePageAsAdf));
            setConfluencePage(markdown);
            setIdMap(newIdMap);
            setIsIdMapReady(true); // Set idMap ready when it's set
        }
    }, [
        confluencePageState,
        confluencePageAsAdf,
        setAiAnalyticsContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $0aab3fed706492b4$var$style.aiIssueCreateWrapper,
        testId: testId ?? 'default-confluence-ai-issue-create'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
        name: "ai-issue-create.adf-to-markdown-plus",
        hold: confluencePageState !== 'loading' && !isIdMapReady
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
        name: "ai-issue-create.confluence-page-loading",
        hold: confluencePageState === 'loading'
    }), isIdMapReady ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0aab3fed706492b4$export$9da61cee87ff5851, {
        handleStateChange: handleStateChange,
        confluencePageState: confluencePageState,
        confluencePage: confluencePage,
        idMap: idMap,
        useService: $0aab3fed706492b4$export$fbdfb25d3cad524a,
        cloudId: cloudId,
        contentType: contentType,
        pageId: pageId,
        pageMode: pageMode,
        highlightedTextAdf: highlightedTextAdf,
        timeoutMs: timeoutMs,
        onInit: onInit,
        onSuccess: onSuccess,
        onFailure: onFailure,
        onClose: onClose,
        onTimeout: onTimeout,
        onStateChange: onStateChange,
        consumer: consumer,
        setAiAnalyticsContext: setAiAnalyticsContext,
        aIIssueCreationEnablement: aIIssueCreationEnablement,
        overrideCloudIdForSitePicker: overrideCloudIdForSitePicker,
        overrideProjectIdForProjectPicker: overrideProjectIdForProjectPicker
    }) : null));
};
const $0aab3fed706492b4$export$9da61cee87ff5851 = ({ cloudId: cloudId, overrideCloudIdForSitePicker: overrideCloudIdForSitePicker, highlightedTextAdf: highlightedTextAdf = (0, $4AavA.doc)((0, $c8cGy.paragraph)('')), timeoutMs: timeoutMs = $0aab3fed706492b4$export$7bd623b29ec8e1eb, onInit: onInit, onSuccess: onSuccess, idMap: idMap, confluencePage: confluencePage, confluencePageState: confluencePageState, handleStateChange: handleStateChange, onFailure: onFailure, onClose: onClose, onTimeout: onTimeout, consumer: consumer, setAiAnalyticsContext: setAiAnalyticsContext, useService: useService, aIIssueCreationEnablement: aIIssueCreationEnablement, overrideProjectIdForProjectPicker: overrideProjectIdForProjectPicker })=>{
    const handleAiSuggestedFieldsStateChange = (0, $cozmU.useCallback)((newState)=>handleStateChange('aiIssueCreateFetchSuggestedFieldsState', newState), [
        handleStateChange
    ]);
    const highlightedText = (0, $cozmU.useMemo)(()=>{
        return (0, $4n04n.adfToMarkdownPlus)(highlightedTextAdf, {
            markdownPlusUseNextLayoutSection: true
        }, idMap).markdown;
    }, [
        highlightedTextAdf,
        idMap
    ]); // Only call SuggestionComponent when highlightedText is ready
    const { state: suggestedFieldsState, fields: fields, onAIResultView: onAIResultView, isStreaming: isStreaming, suggestions: suggestions } = useService({
        cloudId: cloudId,
        confluencePage: confluencePage,
        highlightedText: highlightedText,
        handleAiSuggestedFieldsStateChange: handleAiSuggestedFieldsStateChange,
        isReady: highlightedText !== '',
        overrideXProduct: aIIssueCreationEnablement?.enablement
    });
    const isLoading = confluencePageState === 'loading' || suggestedFieldsState === 'loading';
    const isErrored = confluencePageState === 'error' || suggestedFieldsState === 'error';
    const isPayloadReady = confluencePageState === 'idle' && suggestedFieldsState === 'idle';
    const descriptionADF = (0, $cozmU.useMemo)(()=>{
        if (isLoading || isErrored || !fields?.description) return (0, $4AavA.doc)((0, $c8cGy.paragraph)(''));
        return (0, $htTUm.markdownPlusToAdf)({
            markdown: fields.description,
            idMap: idMap
        });
    }, [
        isLoading,
        isErrored,
        fields,
        idMap
    ]);
    (0, $cozmU.useEffect)(()=>{
        setAiAnalyticsContext && setAiAnalyticsContext('aiResponseLength', (0, $kfViO.countADFChars)(descriptionADF));
    }, [
        descriptionADF,
        setAiAnalyticsContext
    ]);
    (0, $cozmU.useEffect)(()=>{
        setAiAnalyticsContext && setAiAnalyticsContext('highlightedTextLength', (0, $kfViO.countADFChars)(highlightedTextAdf));
    }, [
        highlightedTextAdf,
        setAiAnalyticsContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
        name: "ai-issue-create.suggested-fields-loading",
        hold: suggestedFieldsState === 'loading'
    }), !isErrored && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iNyje.GicAnywhere), {
        cloudId: cloudId,
        summary: fields?.summary || '',
        descriptionAdf: descriptionADF,
        timeoutMs: timeoutMs,
        onInit: onInit,
        onSuccess: onSuccess,
        onFailure: onFailure,
        onClose: onClose,
        onTimeout: onTimeout,
        consumer: consumer,
        isPayloadReady: isPayloadReady,
        overrideCloudId: overrideCloudIdForSitePicker,
        projectId: overrideProjectIdForProjectPicker
    }), !isStreaming && Boolean(suggestions?.length) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l4gv5.MountEvent), {
        onMount: onAIResultView
    }));
};
const $0aab3fed706492b4$export$56bb8aafd9fb646e = ({ cloudId: cloudId, contentType: contentType, pageId: pageId, pageMode: pageMode, overrideCloudIdForSitePicker: overrideCloudIdForSitePicker, overrideProjectIdForProjectPicker: overrideProjectIdForProjectPicker, highlightedTextAdf: highlightedTextAdf = (0, $4AavA.doc)((0, $c8cGy.paragraph)('')), timeoutMs: timeoutMs = $0aab3fed706492b4$export$7bd623b29ec8e1eb, onInit: onInit, onSuccess: onSuccess, onFailure: onFailure, onClose: onClose, onTimeout: onTimeout, testId: testId, onStateChange: onStateChange, consumer: consumer = 'confluenceHighlight', setAiAnalyticsContext: setAiAnalyticsContext, aIIssueCreationEnablement: aIIssueCreationEnablement })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fNTq8.AIEventsInstrumentationProvider), {
        config: {
            // Required configruation
            product: 'confluence',
            subproduct: 'jira',
            aiFeatureName: 'confluenceAiWorkCreation',
            proactiveGeneratedAI: 0,
            userGeneratedAI: 1,
            // Optional configuration
            source: 'confluenceHighlightIssueCreate',
            skipAISessionValidation: true
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0aab3fed706492b4$export$a653b3ac3dd182f4, {
        cloudId: cloudId,
        contentType: contentType,
        pageId: pageId,
        pageMode: pageMode,
        highlightedTextAdf: highlightedTextAdf,
        timeoutMs: timeoutMs,
        onInit: onInit,
        onSuccess: onSuccess,
        onFailure: onFailure,
        onClose: onClose,
        onTimeout: onTimeout,
        testId: testId,
        onStateChange: onStateChange,
        consumer: consumer,
        overrideCloudIdForSitePicker: overrideCloudIdForSitePicker,
        overrideProjectIdForProjectPicker: overrideProjectIdForProjectPicker,
        setAiAnalyticsContext: setAiAnalyticsContext,
        aIIssueCreationEnablement: aIIssueCreationEnablement
    }));
};
module.exports["ConfluenceAiIssueCreate"] = $0aab3fed706492b4$export$56bb8aafd9fb646e;

});

parcelRegister("7JWNS", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cFVPs = parcelRequire("cFVPs");


var $a90fH = parcelRequire("a90fH");


var $hoMYc = parcelRequire("hoMYc");

const $34ab1c719efd5788$export$5fe969aa6ed2f349 = ({ analyticsConfig: analyticsConfig, issueConfig: issueConfig, onCompletion: onCompletion, customExperienceTracker: customExperienceTracker, requestHeaderOverrides: requestHeaderOverrides, ...streamingProps })=>{
    // **** setup ****
    const { updateSuggestions: updateSuggestions, suggestions: suggestions, fullSuggestionList: fullSuggestionList, reset: resetSuggestion, hideSuggestion: hideSuggestion } = (0, $a90fH.useSuggestions)();
    const [error, setError] = (0, $cozmU.useState)();
    const analyticsContext = {
        ...analyticsConfig,
        proactiveGeneratedAI: 0,
        userGeneratedAI: 1,
        isAIFeature: 1
    };
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIInteractionDismiss: trackAIInteractionDismiss, trackAIResultView: trackAIResultView, trackAIResultAction: trackAIResultAction, trackAIResultError: trackAIResultError, trackAIFeedbackSubmit: trackAIFeedbackSubmit } = (0, $cFVPs.useAIEventsInstrumentation)(analyticsContext);
    const onStreamError = (0, $cozmU.useCallback)((error)=>{
        customExperienceTracker?.fail?.(error);
        trackAIResultError({
            aiErrorCode: error.message.status_code,
            aiErrorMessage: error.message.message_template
        }, !(0, $hoMYc.isWhitelistedSLOError)(error) ? {
            attributes: {
                aiResultErrorCategory: 'server-error'
            }
        } : undefined);
        setError(error);
    }, [
        trackAIResultError,
        customExperienceTracker
    ]);
    const onStreamInit = (0, $cozmU.useCallback)((retryCount)=>{
        resetSuggestion();
        setError(undefined);
        customExperienceTracker?.start?.();
        trackAIInteractionInit({
            attributes: {
                totalRetries: retryCount
            }
        });
    }, [
        trackAIInteractionInit,
        resetSuggestion,
        customExperienceTracker
    ]);
    const onStreamAborted = (0, $cozmU.useCallback)(()=>{
        customExperienceTracker?.abort?.();
        trackAIInteractionDismiss();
    }, [
        trackAIInteractionDismiss,
        customExperienceTracker
    ]);
    const { isStreaming: isStreaming, isInitiating: isInitiatingStreaming, reset: resetStreaming, refetch: refetch, getIsStreamingRef: getIsStreamingRef } = (0, $hoMYc.useStreaming)({
        analyticsContext: analyticsContext,
        streamingProps: streamingProps,
        issueConfig: issueConfig,
        requestHeaderOverrides: requestHeaderOverrides,
        onSuggestionStreamUpdated: updateSuggestions,
        onStreamError: onStreamError,
        onStreamInit: onStreamInit,
        onStreamAbortedByInitNew: onStreamAborted
    });
    // **** callbacks ****
    const terminate = (0, $cozmU.useCallback)(()=>{
        if (isStreaming) // stream aborted by terminating service
        onStreamAborted();
        resetSuggestion();
        resetStreaming();
        setError(undefined);
    // leave for side effect to invoke `onCompletion`
    }, [
        onStreamAborted,
        isStreaming,
        resetSuggestion,
        resetStreaming
    ]);
    const hideSuggestions = (0, $cozmU.useCallback)((ids, action)=>{
        if (action) ids.forEach((_)=>trackAIResultAction(action));
        ids.forEach((id)=>hideSuggestion(id));
    }, [
        trackAIResultAction,
        hideSuggestion
    ]);
    // **** event handlers ****
    const onAIResultView = (0, $cozmU.useCallback)(()=>{
        customExperienceTracker?.succeed?.();
        trackAIResultView({
            attributes: {
                suggestedNumber: suggestions.length
            }
        });
    }, [
        trackAIResultView,
        suggestions.length,
        customExperienceTracker
    ]);
    // **** side effects ****
    (0, $cozmU.useEffect)(()=>{
        // work is considered done, if
        // - no suggestions are available
        // - no error exist
        // - no streaming is active
        if (!isInitiatingStreaming && !isStreaming && !error && suggestions.length === 0) onCompletion();
    }, [
        error,
        suggestions,
        isStreaming,
        onCompletion,
        isInitiatingStreaming
    ]);
    // report aborted on unmount if still streaming
    (0, $cozmU.useEffect)(()=>()=>{
            if (getIsStreamingRef.current()) onStreamAborted();
        }, [
        onStreamAborted,
        getIsStreamingRef
    ]);
    return {
        suggestions: suggestions,
        fullSuggestionList: fullSuggestionList,
        isStreaming: isStreaming,
        error: error,
        // event handlers
        onAIResultView: onAIResultView,
        onAIFeedbackSubmit: trackAIFeedbackSubmit,
        // callbacks
        refetch: refetch,
        hideSuggestions: hideSuggestions,
        terminate: terminate
    };
};
module.exports["useAiWorkSuggestionStreaming"] = $34ab1c719efd5788$export$5fe969aa6ed2f349;

});

parcelRegister("a90fH", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $03RpJ = parcelRequire("03RpJ");

const $babb2fde9f8d1a07$export$378f0080e636ce63 = ()=>{
    const [hiddenSuggestionIds, setHiddenSuggestionIds] = (0, $cozmU.useState)(new Set());
    const [fullSuggestionList, setFullSuggestionList] = (0, $cozmU.useState)([]);
    // used to avoid calling `setSuggestions` too many times during streaming - could break devtools
    const streamedIssueCount = (0, $cozmU.useRef)(0);
    const suggestions = (0, $cozmU.useMemo)(()=>fullSuggestionList.filter((suggestion)=>!hiddenSuggestionIds.has(suggestion.localId)), [
        fullSuggestionList,
        hiddenSuggestionIds
    ]);
    const hideSuggestion = (0, $cozmU.useCallback)((id)=>{
        setHiddenSuggestionIds((set)=>new Set(set).add(id));
    }, []);
    const reset = (0, $cozmU.useCallback)(()=>{
        setFullSuggestionList([]);
        setHiddenSuggestionIds(new Set());
        streamedIssueCount.current = 0;
    }, []);
    const addSuggestion = (0, $cozmU.useCallback)((suggestion)=>{
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        setFullSuggestionList((suggestions)=>[
                ...suggestions,
                {
                    ...suggestion,
                    localId: (0, $03RpJ.default)()
                }
            ]);
    }, []);
    const updateSuggestions = (0, $cozmU.useCallback)((newSuggestionList)=>{
        while(streamedIssueCount.current < newSuggestionList.length){
            addSuggestion(newSuggestionList[streamedIssueCount.current]);
            streamedIssueCount.current++;
        }
    }, [
        addSuggestion
    ]);
    return {
        fullSuggestionList: fullSuggestionList,
        suggestions: suggestions,
        hideSuggestion: hideSuggestion,
        updateSuggestions: updateSuggestions,
        reset: reset
    };
};
module.exports["useSuggestions"] = $babb2fde9f8d1a07$export$378f0080e636ce63;

});

parcelRegister("hoMYc", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6ahXt = parcelRequire("6ahXt");

var $aJxVU = parcelRequire("aJxVU");

var $h3M3Y = parcelRequire("h3M3Y");

const $d8716fac23f14718$export$4177e9b841c72d1e = (error)=>{
    const whitelistedSLOErrors = [
        (0, $6ahXt.ConvoAIErrorMessage).ACCEPTABLE_USE_VIOLATIONS,
        (0, $6ahXt.ConvoAIErrorMessage).NOT_ENOUGH_CONTENT_ERROR,
        (0, $6ahXt.ConvoAIErrorMessage).ANSWER_UNAVAILABLE_FOR_CONTENT,
        (0, $6ahXt.ConvoAIErrorMessage).NOT_FOUND,
        (0, $6ahXt.ConvoAIErrorMessage).BAD_REQUEST
    ];
    return whitelistedSLOErrors.includes(error.message.message_template);
};
const $d8716fac23f14718$var$TIMEOUT_DELAY = 60000;
const $d8716fac23f14718$export$734279c1f8caf5b9 = ({ analyticsContext: analyticsContext, issueConfig: issueConfig, streamingProps: streamingProps, requestHeaderOverrides: requestHeaderOverrides, onSuggestionStreamUpdated: onSuggestionStreamUpdated, onStreamError: onStreamError, onStreamInit: onStreamInit, onStreamAbortedByInitNew: onStreamAbortedByInitNew })=>{
    const [isStreaming, setIsStreaming] = (0, $cozmU.useState)(false);
    const [isInitiating, setIsInitiating] = (0, $cozmU.useState)(true);
    const prevResponseState = (0, $cozmU.useRef)(null);
    const streamCountRef = (0, $cozmU.useRef)(0);
    const getIsStreamingRef = (0, $cozmU.useRef)(()=>false);
    getIsStreamingRef.current = ()=>isStreaming;
    const streamingRequest = (0, $cozmU.useMemo)(()=>({
            ai_feature_input: {
                ...streamingProps.input,
                suggested_issues_config: issueConfig
            }
        }), [
        issueConfig,
        streamingProps.input
    ]);
    const streamingConfig = (0, $cozmU.useMemo)(()=>({
            apiPath: `v2/ai-feature/jira/issue/source-type/${streamingProps.sourceType}/suggestions/stream`,
            enablePartialJson: true,
            enableFollowUp: false,
            headers: {
                'x-experience-id': streamingProps.experienceId,
                'x-product': requestHeaderOverrides?.overrideXProduct ?? analyticsContext.product,
                'x-channel-id': streamingProps?.channelId
            },
            skip: streamingProps.skip ?? false,
            timeoutDelay: $d8716fac23f14718$var$TIMEOUT_DELAY
        }), [
        analyticsContext.product,
        streamingProps.experienceId,
        streamingProps.sourceType,
        requestHeaderOverrides?.overrideXProduct,
        streamingProps?.channelId,
        streamingProps?.skip
    ]);
    const onStateChange = (0, $cozmU.useCallback)((state)=>{
        if (prevResponseState.current !== state.responseState) {
            if (state.responseState === (0, $aJxVU.ConvoAIResponseState).Initialization) {
                if (isStreaming) onStreamAbortedByInitNew();
                onStreamInit(streamCountRef.current); // argument is "retryCount", so before self-increment
                setIsStreaming(true);
                if (isInitiating) setIsInitiating(false);
                streamCountRef.current++;
            }
            prevResponseState.current = state.responseState;
        }
        if (!isStreaming) return;
        switch(state.responseState){
            case (0, $aJxVU.ConvoAIResponseState).AnswerPart:
                {
                    const fullyFormedIssues = state.content?.suggested_issues?.slice?.(0, -1) ?? [];
                    onSuggestionStreamUpdated(fullyFormedIssues);
                    break;
                }
            case (0, $aJxVU.ConvoAIResponseState).FinalResponse:
                setIsStreaming(false);
                // builds kept failing when using ConvoAIErrorMessage.SOME_ERROR
                // fixed by typecasting as ConvoAIErrorMessage
                if (!('suggested_issues' in state.content)) {
                    // if there are are no suggested_issues, it's potentially due to bad json
                    // log as an unexpected error as we are unsure if this pops up in ConvoAI
                    onStreamError({
                        type: 'ERROR',
                        message: {
                            message_template: 'UNEXPECTED',
                            content: `Bad JSON: ${Object.keys(state.content).toString()}`,
                            status_code: 500
                        }
                    });
                    break;
                }
                if (state.content?.suggested_issues.length === 0) {
                    // no child issue information came back from the LLM
                    // we clasify this as a not engouh information error
                    onStreamError({
                        type: 'ERROR',
                        message: {
                            message_template: 'NOT_ENOUGH_CONTENT_ERROR',
                            content: 'Not enough content to generate work items from Confluence link.',
                            status_code: 400
                        }
                    });
                    break;
                }
                onSuggestionStreamUpdated(state.content?.suggested_issues);
                break;
            case (0, $aJxVU.ConvoAIResponseState).Error:
                setIsStreaming(false);
                onStreamError(state.error);
                break;
            default:
        }
    }, [
        onSuggestionStreamUpdated,
        onStreamError,
        isStreaming,
        isInitiating,
        onStreamAbortedByInitNew,
        onStreamInit
    ]);
    const [_, refetch] = (0, $h3M3Y.useConvoAIStreaming)(streamingRequest, streamingConfig, onStateChange);
    const reset = (0, $cozmU.useCallback)(()=>{
        setIsStreaming(false);
    }, []);
    return {
        isInitiating: isInitiating,
        isStreaming: isStreaming,
        getIsStreamingRef: getIsStreamingRef,
        refetch: refetch,
        reset: reset
    };
};
module.exports["isWhitelistedSLOError"] = $d8716fac23f14718$export$4177e9b841c72d1e;
module.exports["useStreaming"] = $d8716fac23f14718$export$734279c1f8caf5b9;

});

parcelRegister("l4gv5", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lzgC6 = parcelRequire("lzgC6");

class $e65ab88bda38d309$var$MountEventComponent extends (0, $cozmU.Component) {
    componentDidMount() {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'mounted'
        });
        if (this.props.onMount) this.props.onMount(analyticsEvent);
    }
    render() {
        return null;
    }
}
const $e65ab88bda38d309$var$MountEventComponentWithHOC = (0, $lzgC6.default)()($e65ab88bda38d309$var$MountEventComponent);
const $e65ab88bda38d309$export$2c6963927dbc68f1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e65ab88bda38d309$var$MountEventComponentWithHOC, props);
module.exports["MountEvent"] = $e65ab88bda38d309$export$2c6963927dbc68f1;

});

parcelRegister("kfViO", function(module, exports) {

var $jTt8P = parcelRequire("jTt8P");

const $1716be1127a34d35$export$2d424d3a12064a81 = (value)=>{
    if (!value) return 0;
    let chars = 0;
    (0, $jTt8P.traverse)(value, {
        text: (node)=>{
            if (node.text) chars += node.text.length;
        },
        emoji: ({ attrs: attrs })=>{
            if (attrs?.text) chars += attrs.text.length;
        },
        paragraph: ()=>{
            chars += 1;
        },
        mention: ({ attrs: attrs })=>{
            if (attrs?.text) chars += attrs.text.length;
        }
    });
    // Subtract 1 due to doc node
    return chars ? chars - 1 : chars;
};
module.exports["countADFChars"] = $1716be1127a34d35$export$2d424d3a12064a81;

});

parcelRegister("9BGuq", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $1mDVg = parcelRequire("1mDVg");

const $8d6a0c1fb56b5ffe$export$f6ae4d64a1b3fc6e = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [{ pageMode: pageMode, hasEditPermission: hasEditPermission }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    return (0, $cozmU.useMemo)(()=>({
            fireTrack: (name, attributes)=>{
                const source = 'aiIssueCreate';
                const [actionSubject, action] = name.split(' ');
                const eventAttributes = {
                    pageMode: pageMode,
                    hasEditPermission: hasEditPermission,
                    ...attributes
                };
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        source: source,
                        action: action,
                        actionSubject: actionSubject,
                        attributes: eventAttributes
                    }
                }).fire();
            }
        }), [
        createAnalyticsEvent,
        pageMode,
        hasEditPermission
    ]);
};
module.exports["useAiIssueCreateAnalytics"] = $8d6a0c1fb56b5ffe$export$f6ae4d64a1b3fc6e;

});

parcelRegister("arvSz", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6ahXt = parcelRequire("6ahXt");


var $9BGuq = parcelRequire("9BGuq");

const $5dcd84d787afdff9$export$4177e9b841c72d1e = (error)=>{
    const whitelistedSLOErrors = [
        (0, $6ahXt.ConvoAIErrorMessage).ACCEPTABLE_USE_VIOLATIONS,
        (0, $6ahXt.ConvoAIErrorMessage).NOT_ENOUGH_CONTENT_ERROR,
        (0, $6ahXt.ConvoAIErrorMessage).ANSWER_UNAVAILABLE_FOR_CONTENT,
        (0, $6ahXt.ConvoAIErrorMessage).NOT_FOUND,
        (0, $6ahXt.ConvoAIErrorMessage).BAD_REQUEST
    ];
    return whitelistedSLOErrors.includes(error.message.message_template);
};
const $5dcd84d787afdff9$export$8b355f71d361cab7 = ({ confluencePage: confluencePage, highlightedText: highlightedText, overrideXProduct: overrideXProduct })=>{
    const { fireTrack: fireTrack } = (0, $9BGuq.useAiIssueCreateAnalytics)();
    const { locale: locale } = (0, $kSwu1.useIntl)();
    return (0, $cozmU.useMemo)(()=>({
            analyticsConfig: {
                aiFeatureName: 'confluenceAiWorkCreationConvoAI',
                product: 'confluence',
                subproduct: 'jira',
                useDefaultGASv3EventSchema: false,
                source: 'highlightActionsMenu',
                skipAISessionValidation: true
            },
            requestHeaderOverrides: {
                overrideXProduct: overrideXProduct
            },
            issueConfig: {
                max_issues: 1,
                suggested_issue_field_types: [
                    {
                        issue_type: 'Task',
                        fields: [
                            {
                                field_name: 'Summary',
                                field_type: 'Short-Text'
                            },
                            {
                                field_name: 'Description',
                                field_type: 'Paragraph'
                            }
                        ]
                    }
                ]
            },
            experienceId: 'ai-issue-create-confluence-single',
            sourceType: 'documentation',
            input: {
                source: 'CONFLUENCE',
                context: {
                    primary_text: confluencePage,
                    highlighted_text: highlightedText
                },
                locale: locale
            },
            onCompletion: ()=>{},
            customExperienceTracker: {
                start: ()=>{
                    fireTrack('aiIssueCreateFetchSuggestedFieldsRequest start', {
                        locale: locale
                    });
                },
                succeed: ()=>{
                    fireTrack('aiIssueCreateFetchSuggestedFieldsRequest complete', {
                        haveResult: true,
                        locale: locale
                    });
                },
                fail: (convoAIStreamError)=>{
                    fireTrack('aiIssueCreateFetchSuggestedFieldsRequest fail', {
                        errorMessage: convoAIStreamError?.message?.content,
                        statusCode: convoAIStreamError?.message?.status_code,
                        message_template: convoAIStreamError?.message?.message_template,
                        shouldSlo: !$5dcd84d787afdff9$export$4177e9b841c72d1e(convoAIStreamError),
                        locale: locale
                    });
                },
                abort: ()=>{
                    fireTrack('aiIssueCreateFetchSuggestedFieldsRequest abort', {
                        locale: locale
                    });
                }
            }
        }), [
        confluencePage,
        highlightedText,
        overrideXProduct,
        fireTrack,
        locale
    ]);
};
module.exports["useStreamingHookProps"] = $5dcd84d787afdff9$export$8b355f71d361cab7;

});

parcelRegister("gqQUx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7oI9Y = parcelRequire("7oI9Y");


var $kDhla = parcelRequire("kDhla");


var $1mDVg = parcelRequire("1mDVg");


var $9BGuq = parcelRequire("9BGuq");


var $iT03Z = parcelRequire("iT03Z");

const $1a87d70e3d885601$var$getConfluencePageAdf = async ({ cloudId: cloudId, contentType: contentType, pageId: pageId, pageMode: pageMode = (0, $1mDVg.PageMode).VIEW, signal: signal, product: product = 'confluence', experienceId: experienceId = 'ai-issue-create', editorApi: editorApi })=>{
    if (pageMode === (0, $1mDVg.PageMode).EDIT || pageMode === (0, $1mDVg.PageMode).LIVE_EDIT || pageMode === (0, $1mDVg.PageMode).LIVE_VIEW) return (0, $iT03Z.getConfluencePageAdfFromEditor)(editorApi);
    // 'folder' is not a supported content type in ai-issue-create; fall back to no contentType
    const apiContentType = contentType !== 'folder' ? contentType : 'page';
    return (0, $7oI9Y.getConfluencePageAdfFromApi)({
        cloudId: cloudId,
        contentType: apiContentType,
        pageId: pageId,
        signal: signal,
        product: product,
        experienceId: experienceId
    });
};
const $1a87d70e3d885601$export$e411256f856842c7 = ({ cloudId: cloudId, contentType: contentType, experienceId: experienceId, pageId: pageId, pageMode: pageMode, product: product, onStateChange: onStateChange })=>{
    const { fireTrack: fireTrack } = (0, $9BGuq.useAiIssueCreateAnalytics)();
    const { fullPageEditorPresetAPI: fullPageEditorPresetAPI } = (0, $kDhla.useFullPageEditorApiState)();
    const [fetchState, setGetConfluencePageState] = (0, $cozmU.useState)({
        state: 'loading',
        confluencePage: undefined
    });
    const abortControllerRef = (0, $cozmU.useRef)(null);
    const fetchConfluencePage = (0, $cozmU.useCallback)(async ()=>{
        if (abortControllerRef.current) abortControllerRef.current.abort();
        abortControllerRef.current = new AbortController();
        const currentAbortController = abortControllerRef.current;
        setGetConfluencePageState({
            state: 'loading',
            confluencePage: undefined
        });
        try {
            fireTrack('issueCreateSidePanelGetConfluencePageRequest start');
            const confluencePage = await $1a87d70e3d885601$var$getConfluencePageAdf({
                cloudId: cloudId,
                contentType: contentType,
                experienceId: experienceId,
                pageId: pageId,
                pageMode: pageMode,
                product: product,
                signal: currentAbortController.signal,
                editorApi: fullPageEditorPresetAPI
            });
            fireTrack('issueCreateSidePanelGetConfluencePageRequest complete', {
                haveResult: !!confluencePage
            });
            if (currentAbortController.signal.aborted) {
                setGetConfluencePageState({
                    state: 'abort',
                    confluencePage: undefined
                });
                return;
            }
            if (confluencePage) setGetConfluencePageState({
                state: 'idle',
                confluencePage: confluencePage
            });
            else setGetConfluencePageState({
                state: 'error',
                error: new Error('Error on getting confluence page as ADF'),
                confluencePage: undefined
            });
        } catch (e) {
            fireTrack('issueCreateSidePanelGetConfluencePageRequest fail', {
                message: e.message
            });
            if (currentAbortController.signal.aborted) {
                setGetConfluencePageState({
                    state: 'abort',
                    confluencePage: undefined
                });
                return;
            }
            setGetConfluencePageState({
                state: 'error',
                error: e,
                confluencePage: undefined
            });
        }
    }, [
        cloudId,
        contentType,
        experienceId,
        pageId,
        product,
        setGetConfluencePageState,
        fireTrack,
        pageMode,
        fullPageEditorPresetAPI
    ]);
    (0, $cozmU.useEffect)(()=>{
        fetchConfluencePage();
        return ()=>{
            if (abortControllerRef.current) abortControllerRef.current.abort();
        };
    }, [
        fetchConfluencePage
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (onStateChange) onStateChange(fetchState);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        fetchState.state,
        fetchState.confluencePage,
        onStateChange
    ]);
    return {
        ...fetchState,
        trigger: fetchConfluencePage
    };
};
module.exports["useGetConfluencePage"] = $1a87d70e3d885601$export$e411256f856842c7;

});

parcelRegister("7oI9Y", function(module, exports) {
const $7dda225bb6e8bde3$export$9ae725848caea23f = async ({ cloudId: cloudId, contentType: contentType, pageId: pageId, signal: signal, product: product = 'confluence', experienceId: experienceId = 'ai-issue-create' })=>{
    try {
        const endpointAPI = contentType === 'blogpost' ? `blogposts` : `pages`;
        const response = await fetch(`/wiki/api/v2/${endpointAPI}/${pageId}?body-format=atlas_doc_format`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'X-Experience-Id': experienceId,
                'X-Product': product,
                'Atl-CloudId': cloudId
            },
            credentials: 'include',
            signal: signal
        });
        const data = await response.json();
        if (!data.body?.atlas_doc_format) throw new Error('No atlas doc format found in confluence page');
        return JSON.parse(data.body.atlas_doc_format.value);
    } catch (error) {
        throw new Error('Request to get confluence page failed');
    }
};
module.exports["getConfluencePageAdfFromApi"] = $7dda225bb6e8bde3$export$9ae725848caea23f;

});

parcelRegister("iT03Z", function(module, exports) {
const $12940757b485c304$export$21b6e0bf8d10cc8 = async (editorApi)=>{
    return new Promise((resolve)=>{
        editorApi?.core.actions.requestDocument((doc)=>{
            if (!doc) throw new Error('No adf document found in editor');
            resolve(doc);
        });
    });
};
module.exports["getConfluencePageAdfFromEditor"] = $12940757b485c304$export$21b6e0bf8d10cc8;

});

parcelRegister("bZC8A", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $i1t43 = parcelRequire("i1t43");


var $9wGTI = parcelRequire("9wGTI");


var $3E5yu = parcelRequire("3E5yu");

const $d2ef8f1ef1cac15d$export$844cd257c85281a = (error)=>{
    let errorMessage = (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).singleCreateAiErrorDescriptionIssueTermRefreshRebrandToRovo : (0, $3E5yu.messages).singleCreateAiErrorDescriptionRebrandToRovo;
    let errorMessageValues;
    let hideTryAgain = false;
    if (error.message_template !== undefined && [
        'ACCEPTABLE_USE_VIOLATIONS',
        'ACCEPTABLE_USE_EVALUATION_EXCEPTION'
    ].includes(error.message_template)) {
        errorMessage = (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).ethicalViolationErrorDescriptionIssueTermRefresh : (0, $3E5yu.messages).ethicalViolationErrorDescription;
        errorMessageValues = {
            link: (anchorText)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                    href: "https://www.atlassian.com/legal/acceptable-use-policy",
                    target: "_blank",
                    rel: "noopener noreferrer"
                }, anchorText)
        };
        hideTryAgain = true;
        return {
            errorMessage: errorMessage,
            errorMessageValues: errorMessageValues,
            hideTryAgain: hideTryAgain
        };
    }
    if (error.message_template === 'RATE_LIMIT') {
        errorMessage = (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).rateLimitErrorDescriptionIssueTermRefreshRebrandToRovo : (0, $3E5yu.messages).rateLimitErrorDescriptionRebrandToRovo;
        errorMessageValues = {
            link: (anchorText)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                    href: "https://support.atlassian.com/organization-administration/docs/excessive-use-in-atlassian-intelligence/",
                    target: "_blank",
                    rel: "noopener noreferrer"
                }, anchorText)
        };
        hideTryAgain = true;
        return {
            errorMessage: errorMessage,
            errorMessageValues: errorMessageValues,
            hideTryAgain: hideTryAgain
        };
    }
    if (error.message_template === 'FE_REQUEST_EXCEEDING_TOKEN_LENGTH') {
        errorMessage = (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).exceedingTokenLimitDescriptionIssueTermRefreshRebrandToRovo : (0, $3E5yu.messages).exceedingTokenLimitDescriptionRebrandToRovo;
        hideTryAgain = true;
        return {
            errorMessage: errorMessage,
            errorMessageValues: errorMessageValues,
            hideTryAgain: hideTryAgain
        };
    }
    if (error.message_template === 'NO_ANSWER_SUGGESTED_ISSUES') {
        errorMessage = (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).noAnswerSuggestedIssuesIssueTermRefresh : (0, $3E5yu.messages).noAnswerSuggestedIssues;
        hideTryAgain = true;
    }
    return {
        errorMessage: errorMessage,
        errorMessageValues: errorMessageValues,
        hideTryAgain: hideTryAgain
    };
};
module.exports["handleAiIssueCreateError"] = $d2ef8f1ef1cac15d$export$844cd257c85281a;

});

parcelRegister("jE0Gg", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3E5yu = parcelRequire("3E5yu");


var $1mDVg = parcelRequire("1mDVg");

const $3fdc1d9372d96a0e$export$2ac688f17b22f89f = ()=>{
    const [{ currentSiteSelection: currentSiteSelection }, { setCurrentSiteSelection: setCurrentSiteSelection, setCurrentProjectSelection: setCurrentProjectSelection, setAiIssueCreationEnablement: setAiIssueCreationEnablement, setIsGicIframeReady: setIsGicIframeReady }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    (0, $cozmU.useEffect)(()=>{
        const messageHandler = (message)=>{
            const eventName = message?.data?.event;
            const payload = message.data?.payload;
            switch(eventName){
                // Recieve message from GIC anywhere component for current site selection since it is in an inner iframe.
                case 0, $3E5yu.JIRA_EMBED_ISSUE_CREATE_SITE_SELECTED:
                    if (payload?.selectedCloudId && payload?.selectedCloudId !== '') {
                        // reset currentProjectSelection on site change since projects are tied per site
                        if (currentSiteSelection && payload?.selectedCloudId !== currentSiteSelection) setCurrentProjectSelection(undefined);
                        setCurrentSiteSelection(payload.selectedCloudId);
                    }
                    break;
                case 0, $3E5yu.JIRA_EMBED_ISSUE_CREATE_PROJECT_SELECTED:
                    const project = {
                        selectedProjectType: payload?.selectedProjectType,
                        selectedProjectId: payload?.selectedProjectId,
                        selectedProjectKey: payload?.selectedProjectKey
                    };
                    setCurrentProjectSelection(project);
                    break;
                case 0, $3E5yu.JIRA_EMBED_ISSUE_CREATE_READY:
                    setIsGicIframeReady(true);
                    break;
                case 0, $3E5yu.JIRA_EMBED_ISSUE_CREATE_CLOSE:
                    setIsGicIframeReady(false);
                    break;
                default:
            }
        };
        window.addEventListener('message', messageHandler);
        return ()=>{
            window.removeEventListener('message', messageHandler);
        };
    }, [
        setCurrentSiteSelection,
        setCurrentProjectSelection,
        currentSiteSelection,
        setAiIssueCreationEnablement,
        setIsGicIframeReady
    ]);
};
module.exports["useMessageListener"] = $3fdc1d9372d96a0e$export$2ac688f17b22f89f;

});

parcelRegister("hib1D", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $2wCqQ = parcelRequire("2wCqQ");


var $buxP3 = parcelRequire("buxP3");


var $74xbC = parcelRequire("74xbC");


var $1mDVg = parcelRequire("1mDVg");


var $hiixe = parcelRequire("hiixe");

const $c160271417b290c8$var$footerContainerStyle = (0, $buxP3.xcss)({
    backgroundColor: 'elevation.surface.sunken'
});
const $c160271417b290c8$var$SINGLE_ISSUE_CREATE_FEEDBACK_ENTRYPOINT_ID = '5dd040e8-af22-4ef1-803e-136f659a1092';
const $c160271417b290c8$export$5e203ab8a2a5043e = ()=>{
    const [{ contentId: contentId }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
        xcss: $c160271417b290c8$var$footerContainerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $74xbC.IssueCreateAiFeedback), {
        contentId: contentId,
        entrypointId: $c160271417b290c8$var$SINGLE_ISSUE_CREATE_FEEDBACK_ENTRYPOINT_ID
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hiixe.AiSubFooter), null));
};
module.exports["IssueCreateSidePanelFooter"] = $c160271417b290c8$export$5e203ab8a2a5043e;

});

parcelRegister("6pbwW", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kA6Zo = parcelRequire("kA6Zo");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $I7hWB = parcelRequire("I7hWB");


var $l3wuH = parcelRequire("l3wuH");


var $1sCHt = parcelRequire("1sCHt");


var $ldJ1U = parcelRequire("ldJ1U");


var $4WZFP = parcelRequire("4WZFP");


var $9wGTI = parcelRequire("9wGTI");


var $3E5yu = parcelRequire("3E5yu");

const $47081d53dba235a2$var$headerMessageStyle = (0, $buxP3.xcss)({
    paddingInline: 'space.100',
    font: 'font.heading.small',
    fontWeight: 'font.weight.medium',
    paddingBottom: 'space.025'
});
const $47081d53dba235a2$export$7b151ed3fccdded0 = ({ onClose: onClose })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4WZFP.SidePanelHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        direction: "row",
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "medium",
        as: "h2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        direction: "row",
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ldJ1U.JiraIcon), {
        size: "small",
        appearance: "brand"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $47081d53dba235a2$var$headerMessageStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).sidePanelHeaderIssueTermRefresh : (0, $3E5yu.messages).sidePanelHeader)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                label: "",
                spacing: "none"
            }),
        appearance: "subtle",
        label: "close",
        onClick: ()=>onClose(),
        testId: "close-issue-create-panel-button"
    })));
};
module.exports["IssueCreateSidePanelHeader"] = $47081d53dba235a2$export$7b151ed3fccdded0;

});

parcelRegister("4WZFP", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

const $72d7920b18bf3596$export$70e0922268f2e08b = (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            paddingBlock: "space.100",
            paddingInlineStart: "space.300",
            paddingInlineEnd: "space.150"
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
module.exports["SidePanelHeader"] = $72d7920b18bf3596$export$70e0922268f2e08b;

});

parcelRegister("kmWRd", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $iODl6 = parcelRequire("iODl6");


var $j72ee = parcelRequire("j72ee");

const $7a88b175622d580e$var$sidePanelContentStyling = (0, $buxP3.xcss)({
    position: 'absolute',
    width: '100%',
    backgroundColor: 'elevation.surface',
    height: '100%',
    top: '0',
    right: '0',
    left: '0',
    bottom: '0',
    display: 'flex',
    flexDirection: 'column'
});
const $7a88b175622d580e$export$8689d3888980b1f3 = (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { headerHeight: t1, isFixed: isFixed, children: children, displayTopBorder: displayTopBorder, panelTop: t2, isOpen: t3, width: t4 } = t0;
    const headerHeight = t1 === undefined ? 0 : t1;
    const panelTop = t2 === undefined ? 0 : t2;
    const isOpen = t3 === undefined ? true : t3;
    const width = t4 === undefined ? 320 : t4;
    let t5;
    if ($[0] !== children || $[1] !== displayTopBorder || $[2] !== headerHeight || $[3] !== isFixed || $[4] !== isOpen || $[5] !== panelTop || $[6] !== width) {
        t5 = isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j72ee.default), {
            enterFrom: "right",
            fade: "inout"
        }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                ...props,
                style: {
                    backgroundColor: "elevation.surface",
                    position: isFixed ? "fixed" : "absolute",
                    right: "0",
                    top: `${panelTop}px`,
                    width: `${width}px`,
                    padding: "space.300",
                    borderLeft: "var(--ds-border-width, 1px) solid var(--ds-border, #0B120E24)",
                    height: `calc(100vh - ${headerHeight}px)`,
                    borderTop: displayTopBorder ? "var(--ds-border-width, 1px) solid var(--ds-border, #0B120E24)" : "none"
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                xcss: $7a88b175622d580e$var$sidePanelContentStyling
            }, children)));
        $[0] = children;
        $[1] = displayTopBorder;
        $[2] = headerHeight;
        $[3] = isFixed;
        $[4] = isOpen;
        $[5] = panelTop;
        $[6] = width;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), {
            appear: true
        }, t5);
        $[8] = t5;
        $[9] = t6;
    } else t6 = $[9];
    return t6;
};
module.exports["SidePanel"] = $7a88b175622d580e$export$8689d3888980b1f3;

});

parcelRegister("lEDve", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $9kbTQ = parcelRequire("9kbTQ");


var $9GVkD = parcelRequire("9GVkD");


var $bR6es = parcelRequire("bR6es");


var $6mKj3 = parcelRequire("6mKj3");


var $id4ij = parcelRequire("id4ij");


var $9wGTI = parcelRequire("9wGTI");


var $bEdUx = parcelRequire("bEdUx");

const $709c5a5818d3675c$var$popupAnimation = null;
const $709c5a5818d3675c$var$popupPanelStyles = null;
const $709c5a5818d3675c$var$popupTransition = null;
const $709c5a5818d3675c$var$buttonContainerStyle = null;
const $709c5a5818d3675c$var$buttonContainerBorderUpdated = null;
const $709c5a5818d3675c$var$toolbarContainerStyle = null;
const $709c5a5818d3675c$var$i18n = (0, $kSwu1.defineMessages)({
    toolbarAlert: {
        id: "highlight-actions.toolbar.alert",
        defaultMessage: "Floating toolbar is available. Press tab to access it"
    }
});
const $709c5a5818d3675c$export$129a32eedafa97c5 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { children: children, top: top, left: left, needTransition: t1, onMouseLeave: onMouseLeave, onMouseEnter: onMouseEnter, updatePosition: updatePosition } = t0;
    const needTransition = t1 === undefined ? true : t1;
    const popupContainerRef = (0, $cozmU.useRef)(null);
    $709c5a5818d3675c$var$useAdjustedTop(updatePosition, popupContainerRef);
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $9wGTI.fg)("aifc_create_enabled") || (0, $6mKj3.expValEquals)("platform_editor_toolbar_aifc_confluence", "isEnabled", true);
        $[0] = t2;
    } else t2 = $[0];
    const isNewToolbarEnabled = t2;
    const popupRef = (0, $cozmU.useRef)(null);
    const popupLeft = $709c5a5818d3675c$var$useAdjustedLeft(left, popupRef);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = [];
        $[1] = t3;
    } else t3 = $[1];
    (0, $cozmU.useEffect)($709c5a5818d3675c$var$_temp2, t3);
    let t4;
    if ($[2] !== children || $[3] !== formatMessage || $[4] !== needTransition || $[5] !== onMouseEnter || $[6] !== onMouseLeave || $[7] !== popupLeft || $[8] !== top) {
        const portalContainer_0 = document.getElementById((0, $bEdUx.popupPortalContainerId));
        let t5;
        if ($[10] !== onMouseEnter || $[11] !== onMouseLeave) {
            t5 = onMouseEnter && onMouseLeave && {
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave
            };
            $[10] = onMouseEnter;
            $[11] = onMouseLeave;
            $[12] = t5;
        } else t5 = $[12];
        const mouseMoveHandlers = t5;
        t4 = portalContainer_0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).createPortal(/*#__PURE__*/ $cozmU.createElement("div", {
            ref: popupContainerRef,
            style: {
                top: top
            },
            ...mouseMoveHandlers,
            className: (0, $hekY6.default)([
                "_2fBhteUZyi _1mT5xdWVPG",
                needTransition && "_23rrnHpBgU"
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $9GVkD.default), {
            id: "toolbar-alert"
        }, formatMessage($709c5a5818d3675c$var$i18n.toolbarAlert)), isNewToolbarEnabled ? /*#__PURE__*/ $cozmU.createElement("div", {
            ref: popupRef,
            style: {
                left: `${popupLeft || 0}px`
            },
            "data-testid": "highlightActionsPopup",
            id: "highlightActionsPopup",
            className: (0, $hekY6.default)([
                "_1VJPcaQMLl _1mT5xdWVPG _2IhTondnbC"
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $bR6es.Toolbar), {
            label: "Renderer toolbar"
        }, children)) : /*#__PURE__*/ $cozmU.createElement("div", {
            ref: popupRef,
            style: {
                left: `${popupLeft || 0}px`
            },
            "data-testid": "highlightActionsPopup",
            id: "highlightActionsPopup",
            className: (0, $hekY6.default)([
                "_0bjKvDzXzM _1VJPcaQMLl _2OUyjtGk8v _1mT5xdWVPG _2IhTondnbC _0KLXruoI2d _3iDTPbQ4SZ",
                (0, $9wGTI.fg)("confluence_comment_border_migration") && "_0bjKvDKxmn"
            ])
        }, children)), portalContainer_0) : null;
        $[2] = children;
        $[3] = formatMessage;
        $[4] = needTransition;
        $[5] = onMouseEnter;
        $[6] = onMouseLeave;
        $[7] = popupLeft;
        $[8] = top;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
} : ({ children: children, top: top, left: left, needTransition: needTransition = true, onMouseLeave: onMouseLeave, onMouseEnter: onMouseEnter, updatePosition: updatePosition })=>{
    const popupContainerRef = (0, $cozmU.useRef)(null);
    $709c5a5818d3675c$var$useAdjustedTop(updatePosition, popupContainerRef);
    const isNewToolbarEnabled = (0, $9wGTI.fg)('aifc_create_enabled') || (0, $6mKj3.expValEquals)('platform_editor_toolbar_aifc_confluence', 'isEnabled', true);
    const popupRef = (0, $cozmU.useRef)(null);
    const popupLeft = $709c5a5818d3675c$var$useAdjustedLeft(left, popupRef);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    (0, $cozmU.useEffect)(()=>{
        const portalContainer = document.getElementById((0, $bEdUx.popupPortalContainerId));
        if (!portalContainer) return;
        const screenreaderCb = (_mutationsList, observer)=>{
            //These accessibility attributes are added dynamically here rather than directly on the VisuallyHidden element because it did not get read by the NVDA screenreader properly on Firefox. This is due to the screenreader sometimes only reading content when there has been a dynamic change to an element
            const accessibleDiv = document.getElementById('toolbar-alert');
            if (accessibleDiv instanceof HTMLElement) {
                accessibleDiv?.setAttribute('role', 'alert');
                accessibleDiv?.setAttribute('aria-live', 'polite');
                observer.disconnect();
            }
        };
        const observer_0 = new MutationObserver(screenreaderCb);
        observer_0.observe(portalContainer, {
            childList: true,
            subtree: true
        });
        return ()=>{
            observer_0.disconnect();
        };
    }, []); // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const portalContainer_0 = document.getElementById((0, $bEdUx.popupPortalContainerId));
    const mouseMoveHandlers = onMouseEnter && onMouseLeave && {
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    };
    return portalContainer_0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).createPortal(/*#__PURE__*/ $cozmU.createElement("div", {
        ref: popupContainerRef,
        style: {
            top: top
        },
        ...mouseMoveHandlers,
        className: (0, $hekY6.default)([
            "_2fBhteUZyi _1mT5xdWVPG",
            needTransition && "_23rrnHpBgU"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $9GVkD.default), {
        id: "toolbar-alert"
    }, formatMessage($709c5a5818d3675c$var$i18n.toolbarAlert)), isNewToolbarEnabled ? /*#__PURE__*/ $cozmU.createElement("div", {
        ref: popupRef,
        style: {
            left: `${popupLeft || 0}px`
        },
        "data-testid": "highlightActionsPopup",
        id: "highlightActionsPopup",
        className: (0, $hekY6.default)([
            "_1VJPcaQMLl _1mT5xdWVPG _2IhTondnbC"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $bR6es.Toolbar), {
        label: "Renderer toolbar"
    }, children)) : /*#__PURE__*/ $cozmU.createElement("div", {
        ref: popupRef,
        style: {
            left: `${popupLeft || 0}px`
        },
        "data-testid": "highlightActionsPopup",
        id: "highlightActionsPopup",
        className: (0, $hekY6.default)([
            "_0bjKvDzXzM _1VJPcaQMLl _2OUyjtGk8v _1mT5xdWVPG _2IhTondnbC _0KLXruoI2d _3iDTPbQ4SZ",
            (0, $9wGTI.fg)('confluence_comment_border_migration') && "_0bjKvDKxmn"
        ])
    }, children)), portalContainer_0) : null;
};
const $709c5a5818d3675c$var$useAdjustedLeft = (0, $3u0dr.isReactCompilerActiveV2)() ? function useAdjustedLeft(left, popupRef) {
    const $ = (0, $bDgLe.c)(4);
    const [adjustedLeft, setAdjustedLeft] = (0, $cozmU.useState)(left);
    const [adjustedLeftOrigin, setAdjustedLeftOrigin] = (0, $cozmU.useState)(left);
    let t0;
    let t1;
    if ($[0] !== left || $[1] !== popupRef) {
        t0 = ()=>{
            if (!popupRef.current) return;
            const { left: elementLeft, right: right } = (0, $id4ij.getElementBounds)(popupRef.current);
            const windowWidth = window.innerWidth;
            let containerBounds = {
                left: 0,
                right: windowWidth
            };
            const nav4ContentContainer = document.getElementById("AkMainContent");
            if (nav4ContentContainer) containerBounds = (0, $id4ij.getElementBounds)(nav4ContentContainer);
            if (elementLeft < containerBounds.left) setAdjustedLeft(left + (containerBounds.left - elementLeft) + 20);
            else if (right > containerBounds.right) setAdjustedLeft(left - (right - containerBounds.right) - 20);
            else setAdjustedLeft(left);
            setAdjustedLeftOrigin(left);
        };
        t1 = [
            left,
            popupRef
        ];
        $[0] = left;
        $[1] = popupRef;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useLayoutEffect)(t0, t1);
    return adjustedLeftOrigin === left ? adjustedLeft : left;
} : function useAdjustedLeft(left, popupRef) {
    const WINDOW_PADDING = 20;
    const [adjustedLeft, setAdjustedLeft] = (0, $cozmU.useState)(left);
    const [adjustedLeftOrigin, setAdjustedLeftOrigin] = (0, $cozmU.useState)(left);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!popupRef.current) return;
        const { left: elementLeft, right: right } = (0, $id4ij.getElementBounds)(popupRef.current);
        const windowWidth = window.innerWidth;
        let containerBounds = {
            left: 0,
            right: windowWidth
        }; // When nav4 container doesn't exist, the window is the container
        const nav4ContentContainer = document.getElementById('AkMainContent');
        if (nav4ContentContainer) containerBounds = (0, $id4ij.getElementBounds)(nav4ContentContainer);
         // WS-1703 - If the popup menu is off either side of the screen or outside of the scrollable content area
        // set it so it's inside the WINDOW_PADDING
        if (elementLeft < containerBounds.left) setAdjustedLeft(left + (containerBounds.left - elementLeft) + WINDOW_PADDING);
        else if (right > containerBounds.right) setAdjustedLeft(left - (right - containerBounds.right) - WINDOW_PADDING);
        else setAdjustedLeft(left);
        setAdjustedLeftOrigin(left);
    }, [
        left,
        popupRef
    ]); // Only use the adjustedLeft if it was calculated relative to the current left prop
    return adjustedLeftOrigin === left ? adjustedLeft : left;
};
/**
 * `popupPortalContainerId` is after the ADF renderer in the HTML DOM.
 * Consequently, when there is vertical layout shift before `popupPortalContainerId` such as in the ADF renderer, the `Popup` will automatically shift away from the selected range.
 * This automatic shift is undesirable and `useAdjustedTop` is attempting to undo it in a way as imperceptible to the user as possible.
 *
 * Inspired by {@link https://floating-ui.com/} which is "The Future of Popper". Both Popper and Floating UI are used by Design System to deal with popups including to reposition them.
 */ const $709c5a5818d3675c$var$useAdjustedTop = (0, $3u0dr.isReactCompilerActiveV2)() ? function useAdjustedTop(updatePosition, popupContainerRef) {
    const $ = (0, $bDgLe.c)(5);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = document.getElementById((0, $bEdUx.popupPortalContainerId));
        $[0] = t0;
    } else t0 = $[0];
    const portalContainer = t0;
    let t1;
    let t2;
    if ($[1] !== popupContainerRef || $[2] !== updatePosition) {
        t1 = ()=>{
            if (!portalContainer || !updatePosition || !("ResizeObserver" in window)) return;
            const { parentElement: parentElement } = portalContainer;
            if (!parentElement) return;
            const observer = new ResizeObserver(()=>{
                if (!popupContainerRef.current) return;
                const newPosition = updatePosition();
                if (!newPosition) return;
                const { style: style } = popupContainerRef.current;
                const newTop = `${newPosition.top}px`;
                if (style.top !== newTop) {
                    style.transition = "none";
                    style.top = newTop;
                }
            });
            observer.observe(parentElement);
            return ()=>{
                observer.disconnect();
            };
        };
        t2 = [
            popupContainerRef,
            portalContainer,
            updatePosition
        ];
        $[1] = popupContainerRef;
        $[2] = updatePosition;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
} : function useAdjustedTop(updatePosition, popupContainerRef) {
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const portalContainer = document.getElementById((0, $bEdUx.popupPortalContainerId));
    (0, $cozmU.useEffect)(()=>{
        if (!portalContainer || !updatePosition || !('ResizeObserver' in window)) return; // The position of `popupPortalContainerId` relative to the selected range will change when the parent element of `popupPortalContainerId` is resized.
        const { parentElement: parentElement } = portalContainer;
        if (!parentElement) return;
        const observer = new ResizeObserver(()=>{
            if (!popupContainerRef.current) return;
            const newPosition = updatePosition();
            if (!newPosition) return;
            const { style: style } = popupContainerRef.current;
            const newTop = `${newPosition.top}px`;
            if (style.top !== newTop) {
                // `popupPortalContainerId` moved and automatically shifted `popupContainerRef` away from the selected range.
                // This automatic shift is undesirable and here we're attempting to undo it in a way as imperceptible to the user as possible.
                // Imperceptible here means that a transition animation cannot be used.
                style.transition = 'none';
                style.top = newTop;
            }
        });
        observer.observe(parentElement);
        return ()=>{
            observer.disconnect();
        };
    }, [
        popupContainerRef,
        portalContainer,
        updatePosition
    ]);
};
function $709c5a5818d3675c$var$_temp(_mutationsList, observer) {
    const accessibleDiv = document.getElementById("toolbar-alert");
    if (accessibleDiv instanceof HTMLElement) {
        accessibleDiv?.setAttribute("role", "alert");
        accessibleDiv?.setAttribute("aria-live", "polite");
        observer.disconnect();
    }
}
function $709c5a5818d3675c$var$_temp2() {
    const portalContainer = document.getElementById((0, $bEdUx.popupPortalContainerId));
    if (!portalContainer) return;
    const screenreaderCb = $709c5a5818d3675c$var$_temp;
    const observer_0 = new MutationObserver(screenreaderCb);
    observer_0.observe(portalContainer, {
        childList: true,
        subtree: true
    });
    return ()=>{
        observer_0.disconnect();
    };
}
module.exports["Popup"] = $709c5a5818d3675c$export$129a32eedafa97c5;

});

parcelRegister("id4ij", function(module, exports) {
function $21c1903a8ac50cbe$export$f25538161b7e9c17(element) {
    let top = element.offsetTop;
    while(element.offsetParent){
        element = element.offsetParent;
        top += element.offsetTop;
    }
    return top;
}
function $21c1903a8ac50cbe$export$7cc0e9dd2435cb30(element, container) {
    if (!element) return false;
    container = container || // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.scrollingElement || // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.body.parentNode;
    if (!container) return false;
    const height = element.offsetHeight;
    const top = $21c1903a8ac50cbe$export$f25538161b7e9c17(element);
    const containerTop = $21c1903a8ac50cbe$export$f25538161b7e9c17(container) + container.scrollTop;
    const containerHeight = container.offsetHeight;
    return top >= containerTop && top + height <= containerTop + containerHeight;
}
function $21c1903a8ac50cbe$export$e41e80160bed5714(node) {
    // @ts-ignore
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    if (!node || node === document) return null;
    const nodeStyle = window.getComputedStyle(node);
    if (node.scrollHeight > node.clientHeight && node.style.overflow !== 'hidden' && nodeStyle.overflow !== 'visible') return node;
    else return $21c1903a8ac50cbe$export$e41e80160bed5714(node.parentNode);
}
function $21c1903a8ac50cbe$export$c3e8c6d4b3b72bf2(element, container) {
    container = container || $21c1903a8ac50cbe$export$e41e80160bed5714(element);
    if (!element || !container || $21c1903a8ac50cbe$export$7cc0e9dd2435cb30(element, container)) return;
    container.scrollTop = $21c1903a8ac50cbe$export$f25538161b7e9c17(element) - $21c1903a8ac50cbe$export$f25538161b7e9c17(container) - container.clientHeight / 2;
}
function $21c1903a8ac50cbe$export$abe5643cba19555f(element) {
    return element.getBoundingClientRect();
}
function $21c1903a8ac50cbe$export$4c0864c7defafad3(element, documentObject) {
    const docEl = documentObject ? documentObject.documentElement : window.document.documentElement;
    if (!element || !docEl) return;
    const boundaries = element.getBoundingClientRect();
    const { top: top, bottom: bottom } = boundaries;
    const viewportHeight = docEl.offsetHeight;
    const topIsVisible = 0 <= top && top < viewportHeight;
    const bottomIsVisible = 0 <= bottom && bottom <= viewportHeight;
    const isBiggerThanViewPort = top <= 0 && 0 <= bottom && bottom >= viewportHeight;
    return topIsVisible || bottomIsVisible || isBiggerThanViewPort;
}
function $21c1903a8ac50cbe$export$4acade851e875ad4(element, documentObject) {
    const docEl = documentObject ? documentObject.documentElement : window.document.documentElement;
    if (!element || !docEl) return;
    const boundaries = element.getBoundingClientRect();
    const { top: top } = boundaries;
    const viewportHeight = docEl.offsetHeight;
    const topIsVisible = 0 <= top && top < viewportHeight;
    return topIsVisible;
}
function $21c1903a8ac50cbe$export$5513bf0589d602a4(targetDomElementId, htmlMarkup) {
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    let el = document.getElementById(targetDomElementId);
    if (!el) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        el = document.createElement('div');
        el.setAttribute('id', targetDomElementId);
        el.setAttribute('style', 'display: none');
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        document.body.appendChild(el);
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        el = document.getElementById(targetDomElementId);
    }
    if (!el) return;
    el.innerHTML = '';
    if (htmlMarkup) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const range = document.createRange();
        const fragment = range.createContextualFragment(htmlMarkup);
        el.appendChild(fragment);
    }
}
module.exports["getElementTop"] = $21c1903a8ac50cbe$export$f25538161b7e9c17;
module.exports["isElementInViewport"] = $21c1903a8ac50cbe$export$7cc0e9dd2435cb30;
module.exports["scrollElementToViewCenter"] = $21c1903a8ac50cbe$export$c3e8c6d4b3b72bf2;
module.exports["getElementBounds"] = $21c1903a8ac50cbe$export$abe5643cba19555f;
module.exports["isPartOfElementStillInViewPort"] = $21c1903a8ac50cbe$export$4c0864c7defafad3;
module.exports["isTopOfElementStillInViewPort"] = $21c1903a8ac50cbe$export$4acade851e875ad4;
module.exports["replaceDomElementContent"] = $21c1903a8ac50cbe$export$5513bf0589d602a4;

});

parcelRegister("bEdUx", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $1LXnB = parcelRequire("1LXnB");


var $9wGTI = parcelRequire("9wGTI");


var $e4o8D = parcelRequire("e4o8D");

const $cef29f59925fac19$var$baseStyles = null; // This z-index value is higher than the sticky table header
const $cef29f59925fac19$var$zIndex11Styles = null; // This z-index value is higher than the content header
const $cef29f59925fac19$var$zIndex13Styles = null;
const $cef29f59925fac19$export$873f34bfb1875202 = 'highlight-actions-portal-container';
let $cef29f59925fac19$var$popupPortalContainerWidth;
function $cef29f59925fac19$var$onResize(width) {
    // Hide popup when the container is resized.
    if (width !== $cef29f59925fac19$var$popupPortalContainerWidth) {
        $cef29f59925fac19$var$popupPortalContainerWidth = width;
        window.dispatchEvent(new CustomEvent('highlight-actions.container.resized'));
    }
}
const $cef29f59925fac19$export$8b383aca014c1850 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $cozmU.createElement("div", {
            id: $cef29f59925fac19$export$873f34bfb1875202,
            className: (0, $hekY6.default)([
                "_4bt5LAYvD1 _2WAcuGYvD1 _1mT5xdRAKS",
                (0, $9wGTI.fg)("confluence_highlight_actions_zindex_fix") ? "_42Yu6BYVCu" : "_42Yu6B7EgV"
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $1LXnB.WidthObserver), {
            setWidth: $cef29f59925fac19$var$onResize
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ $cozmU.createElement("div", {
        id: $cef29f59925fac19$export$873f34bfb1875202,
        className: (0, $hekY6.default)([
            "_4bt5LAYvD1 _2WAcuGYvD1 _1mT5xdRAKS",
            (0, $9wGTI.fg)('confluence_highlight_actions_zindex_fix') ? "_42Yu6BYVCu" : "_42Yu6B7EgV"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $1LXnB.WidthObserver), {
        setWidth: $cef29f59925fac19$var$onResize
    }));
}; // Only renders the Highlight Actions Provider if we're using Nav4
const $cef29f59925fac19$export$68a992a5cacaa78b = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    if (renderServerPlaceholder) return null;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $cozmU.createElement($cef29f59925fac19$export$8b383aca014c1850, null);
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)(); // render null for first render during hydration to prevent mismatch
    if (renderServerPlaceholder) return null;
    return /*#__PURE__*/ $cozmU.createElement($cef29f59925fac19$export$8b383aca014c1850, null);
};
module.exports["popupPortalContainerId"] = $cef29f59925fac19$export$873f34bfb1875202;
module.exports["HighlightActionsProviderForNav4"] = $cef29f59925fac19$export$68a992a5cacaa78b;

});

parcelRegister("4vC63", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lpNn5 = parcelRequire("lpNn5");


var $6GD8y = parcelRequire("6GD8y");


var $4tOXV = parcelRequire("4tOXV");


var $bflGB = parcelRequire("bflGB");


var $1k6sE = parcelRequire("1k6sE");

const $c1fece3650e281b8$var$getAccelerator = (module)=>module?.properties?.keyboardShortcut?.accelerator ?? '';
const $c1fece3650e281b8$export$b804abdac3f5f117 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { module: module, tooltip: t1, children: children } = t0;
    const tooltip = t1 === undefined ? "" : t1;
    let accelerator;
    let t2;
    if ($[0] !== module) {
        accelerator = $c1fece3650e281b8$var$getAccelerator(module);
        t2 = accelerator && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator);
        $[0] = module;
        $[1] = accelerator;
        $[2] = t2;
    } else {
        accelerator = $[1];
        t2 = $[2];
    }
    if (t2) {
        const t3 = `forge-keyboard-shortcut-visualizer-${accelerator}`;
        let t4;
        if ($[3] !== accelerator || $[4] !== tooltip) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4tOXV.ShortcutVisualizer), {
                shortcut: accelerator,
                contentBefore: tooltip,
                isTooltip: true
            });
            $[3] = accelerator;
            $[4] = tooltip;
            $[5] = t4;
        } else t4 = $[5];
        let t5;
        if ($[6] !== children || $[7] !== t3 || $[8] !== t4) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                tag: "span",
                testId: t3,
                content: t4
            }, children);
            $[6] = children;
            $[7] = t3;
            $[8] = t4;
            $[9] = t5;
        } else t5 = $[9];
        return t5;
    }
    let t3;
    if ($[10] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[10] = children;
        $[11] = t3;
    } else t3 = $[11];
    return t3;
} : ({ module: module, tooltip: tooltip = '', children: children })=>{
    const accelerator = $c1fece3650e281b8$var$getAccelerator(module);
    if (accelerator && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        tag: "span",
        testId: `forge-keyboard-shortcut-visualizer-${accelerator}`,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4tOXV.ShortcutVisualizer), {
            shortcut: accelerator,
            contentBefore: tooltip,
            isTooltip: true
        })
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
const $c1fece3650e281b8$export$4e51bfd8ba3e71ef = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { module: module, action: action } = t0;
    let accelerator;
    let t1;
    if ($[0] !== action || $[1] !== module) {
        accelerator = $c1fece3650e281b8$var$getAccelerator(module);
        t1 = accelerator && action && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator);
        $[0] = action;
        $[1] = module;
        $[2] = accelerator;
        $[3] = t1;
    } else {
        accelerator = $[2];
        t1 = $[3];
    }
    if (t1) {
        const t2 = `forge-keyboard-shortcut-${accelerator}`;
        let t3;
        if ($[4] !== accelerator || $[5] !== action) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
                accelerator: accelerator,
                listener: action,
                shortcutType: (0, $bflGB.ShortcutType).Forge
            });
            $[4] = accelerator;
            $[5] = action;
            $[6] = t3;
        } else t3 = $[6];
        let t4;
        if ($[7] !== t2 || $[8] !== t3) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                "data-testid": t2
            }, t3);
            $[7] = t2;
            $[8] = t3;
            $[9] = t4;
        } else t4 = $[9];
        return t4;
    }
    return null;
} : ({ module: module, action: action })=>{
    const accelerator = $c1fece3650e281b8$var$getAccelerator(module);
    if (accelerator && action && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "data-testid": `forge-keyboard-shortcut-${accelerator}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: accelerator,
        listener: action,
        shortcutType: (0, $bflGB.ShortcutType).Forge
    }));
    return null;
};
module.exports["ForgeKeyboardShortcutVisualizer"] = $c1fece3650e281b8$export$b804abdac3f5f117;
module.exports["ForgeKeyboardShortcut"] = $c1fece3650e281b8$export$4e51bfd8ba3e71ef;

});

parcelRegister("4GDP8", function(module, exports) {
function $d27310b4a47ce627$var$keepTrying(fn, times, interval) {
    if (!fn() && times) setTimeout(()=>$d27310b4a47ce627$var$keepTrying(fn, times - 1, interval), interval);
}
function $d27310b4a47ce627$var$waitForDom(itemId) {
    return new Promise((resolve)=>{
        function lookForItem() {
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const targetItem = document.querySelector(itemId);
            if (targetItem) {
                clearInterval(checkInterval);
                resolve(true);
            }
        }
        // Start an interval to check for the item every 10ms
        const checkInterval = setInterval(lookForItem, 10);
        // Fail silently if the item isn't found after 5000ms
        setTimeout(()=>{
            clearInterval(checkInterval);
            resolve(false);
        }, 5000);
    });
}
function $d27310b4a47ce627$var$isForgeModule(itemId) {
    return itemId.startsWith('ari:cloud:ecosystem::extension');
}
function $d27310b4a47ce627$var$escapeForgeModuleKey(itemId) {
    return itemId.replace(/\//g, '\\/').replace(/:/g, '\\:');
}
function $d27310b4a47ce627$var$getItemSelector(itemId) {
    if (!itemId || !itemId.length) return;
    let itemSelector = itemId[0] === '#' ? itemId : `#${itemId}`;
    if ($d27310b4a47ce627$var$isForgeModule(itemId)) itemSelector = $d27310b4a47ce627$var$escapeForgeModuleKey(itemSelector);
    return itemSelector;
}
async function $d27310b4a47ce627$export$6bd4cdcdf3940391({ parentmenuId: parentmenuId, submenuId: submenuId, forgeItemId: forgeItemId }) {
    // Make sure the forge item has a valid id
    const forgeItemSelector = $d27310b4a47ce627$var$getItemSelector(forgeItemId);
    if (!forgeItemSelector) return;
    $d27310b4a47ce627$var$openMenu(parentmenuId);
    const foundSubmenu = await $d27310b4a47ce627$var$waitForDom(submenuId);
    if (!foundSubmenu) return;
    $d27310b4a47ce627$var$openMenu(submenuId);
    const foundForgeItem = await $d27310b4a47ce627$var$waitForDom(forgeItemSelector);
    if (!foundForgeItem) return;
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const forgeItem = document.querySelector(forgeItemSelector);
    forgeItem?.click();
}
function $d27310b4a47ce627$var$openMenu(menuId) {
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const triggerButton = document.querySelector(menuId);
    if (!triggerButton) return;
    const isOpen = triggerButton.getAttribute('aria-expanded') === 'true';
    //only care about closed case, otherwise let legacy event listener handle
    if (!isOpen) triggerButton.click();
}
function $d27310b4a47ce627$export$73ebde48694f32cd(itemId) {
    const itemSelector = $d27310b4a47ce627$var$getItemSelector(itemId);
    if (!itemSelector) return;
    $d27310b4a47ce627$var$keepTrying(()=>{
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const item = document.querySelector(itemSelector);
        if (item) {
            item.click();
            return true;
        }
    }, 100, 5);
}
function $d27310b4a47ce627$export$96aa6f6c7286ecb4(itemId) {
    const itemSelector = $d27310b4a47ce627$var$getItemSelector(itemId);
    if (!itemSelector) return;
    const event = new MouseEvent('mouseup', {
        bubbles: true,
        cancelable: true
    });
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector(itemSelector)?.dispatchEvent(event);
}
function $d27310b4a47ce627$export$1d6f959e29b7f60d() {
    $d27310b4a47ce627$var$openMenu('#tools-menu-trigger');
}
function $d27310b4a47ce627$export$3d4ff948da3c7dd3() {
    $d27310b4a47ce627$var$openMenu('#context-menu-other-apps');
}
function $d27310b4a47ce627$export$94323a98da3bb62c() {
    $d27310b4a47ce627$var$openMenu('#more-actions-trigger');
}
module.exports["openForgeAppFromSubmenu"] = $d27310b4a47ce627$export$6bd4cdcdf3940391;
module.exports["simulateItemClick"] = $d27310b4a47ce627$export$73ebde48694f32cd;
module.exports["simulateItemMouseOver"] = $d27310b4a47ce627$export$96aa6f6c7286ecb4;
module.exports["openMenuClick"] = $d27310b4a47ce627$export$1d6f959e29b7f60d;
module.exports["openContextMenuClick"] = $d27310b4a47ce627$export$3d4ff948da3c7dd3;
module.exports["openMoreActionsMenuClick"] = $d27310b4a47ce627$export$94323a98da3bb62c;

});

parcelRegister("dj3mI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");

const $54a4a16d7bb73c56$export$35ad57ac36645074 = (isContentArchived, canAddComments, needsUpdateToComment, contentType)=>{
    if (isContentArchived) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "highlight-actions.inline-reactions.react.unsupported.archive",
        defaultMessage: "Reactions can't be added to archived content"
    });
    else if (!canAddComments) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "highlight-actions.inline-reactions.react.no.permission",
        defaultMessage: "{contentType, select, blogpost {You do not have permission to add reactions to this blogpost} page {You do not have permission to add reactions to this page} other {You do not have permission to add reactions to this page}}",
        values: {
            contentType: contentType
        }
    });
    else if (needsUpdateToComment) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "highlight-actions.inline-reactions.react.needs.update",
        defaultMessage: "Page is outdated, refresh to react"
    });
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "highlight-actions.inline-reactions.react.unable.to.create",
        defaultMessage: "Unable to react to this element"
    });
};
const $54a4a16d7bb73c56$export$52cdeba2896092f6 = (isContentArchived, userCanAddComments, needsUpdateToComment, contentType)=>{
    if (isContentArchived) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "highlight-actions.inline-comments.comment.unsupported.archive",
        defaultMessage: "Comments can\u2019t be added to archived items"
    });
    else if (!userCanAddComments) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "highlight-actions.inline-comments.comment.no.permission",
        defaultMessage: "{contentType, select, blogpost {You do not have permission to add comments to this blogpost} page {You do not have permission to add comments to this page} other {You do not have permission to add comments to this page}}",
        values: {
            contentType: contentType
        }
    });
    else if (needsUpdateToComment) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "highlight-actions.inline-comments.comment.needs.update",
        defaultMessage: "Page is outdated, refresh to comment"
    });
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "highlight-actions.inline-comments.comment.unable.to.create",
        defaultMessage: "Unable to comment on this element"
    });
};
module.exports["getReactionButtonDisabledMessage"] = $54a4a16d7bb73c56$export$35ad57ac36645074;
module.exports["getCreateButtonDisabledMessage"] = $54a4a16d7bb73c56$export$52cdeba2896092f6;

});

parcelRegister("6zmDz", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $164fd7006e7d8160$export$c5fb2fd13b5122a = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4FKVYEFQfX _3iDTPbQ4SZ _10hBcjOLYo _2MFqljOLYo _3SyF3NQ4SZ _2tw9YFQ4SZ _0mFGxnDIqT _3fqXvfDIqT _0f0eHYSPN1 _1orfgDSPN1",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4FKVYEFQfX _3iDTPbQ4SZ _10hBcjOLYo _2MFqljOLYo _3SyF3NQ4SZ _2tw9YFQ4SZ _0mFGxnDIqT _3fqXvfDIqT _0f0eHYSPN1 _1orfgDSPN1",
            __cmplp.className
        ])
    });
});
const $164fd7006e7d8160$export$8729c6345a54240d = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4FKVYEFQfX _3iDTPbQ4SZ _10hBcjOLYo _2MFqljOLYo _3SyF3NQ4SZ _2tw9YFQ4SZ _0mFGxnDIqT _3fqXvfDIqT _2aYmUNN91d _0Eh9s1N91d _3fQGtcQ4SZ _2H4ncFQ4SZ _3SLCZpDIqT _28Ik26DIqT _0f0eHYSPN1 _1orfgDSPN1",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4FKVYEFQfX _3iDTPbQ4SZ _10hBcjOLYo _2MFqljOLYo _3SyF3NQ4SZ _2tw9YFQ4SZ _0mFGxnDIqT _3fqXvfDIqT _2aYmUNN91d _0Eh9s1N91d _3fQGtcQ4SZ _2H4ncFQ4SZ _3SLCZpDIqT _28Ik26DIqT _0f0eHYSPN1 _1orfgDSPN1",
            __cmplp.className
        ])
    });
}); // remove this when cleanup platform_editor_controls
const $164fd7006e7d8160$export$d7f009f4a3abb74 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4FKVYE1Y8M _3iDTPbQ4SZ",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4FKVYE1Y8M _3iDTPbQ4SZ",
            __cmplp.className
        ])
    });
});
const $164fd7006e7d8160$var$disabledButtonWrapperStyle = null;
const $164fd7006e7d8160$export$b065c4c0e869841d = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $hekY6.default)([
            "_1mT5xdRAKS"
        ]);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ $cozmU.createElement("div", {
            ...props,
            className: t0
        });
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>/*#__PURE__*/ $cozmU.createElement("div", {
        ...props,
        className: (0, $hekY6.default)([
            "_1mT5xdRAKS"
        ])
    });
const $164fd7006e7d8160$var$disabledButtonOverlayStyle = null;
const $164fd7006e7d8160$export$dea79eb12e1f6e1f = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $hekY6.default)([
            "_1mT5xdWVPG _39xV02N91d _0jFU0VN91d _42Yu6BE7ZR _0KLXrujOvk _0wOv4Qsyl5"
        ]);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ $cozmU.createElement("div", {
            ...props,
            className: t0
        });
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>/*#__PURE__*/ $cozmU.createElement("div", {
        ...props,
        className: (0, $hekY6.default)([
            "_1mT5xdWVPG _39xV02N91d _0jFU0VN91d _42Yu6BE7ZR _0KLXrujOvk _0wOv4Qsyl5"
        ])
    });
const $164fd7006e7d8160$var$dividerStyleOld = null;
const $164fd7006e7d8160$export$fb1f035d38cc4d20 = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $hekY6.default)([
            "_2XghbEAr60 _39xV02HZdu _0KLXru9r67"
        ]);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ $cozmU.createElement("div", {
            ...props,
            className: t0
        });
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>/*#__PURE__*/ $cozmU.createElement("div", {
        ...props,
        className: (0, $hekY6.default)([
            "_2XghbEAr60 _39xV02HZdu _0KLXru9r67"
        ])
    });
const $164fd7006e7d8160$var$dividerStyle = null;
const $164fd7006e7d8160$export$2e0a83ec2e27ecbb = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $hekY6.default)([
            "_39xV02HZdu _0KLXru9r67 _2XsHFM1Y8M _0adFHs1Y8M _3138425UaJ _1DCdHi5UaJ"
        ]);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ $cozmU.createElement("div", {
            ...props,
            className: t0
        });
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>/*#__PURE__*/ $cozmU.createElement("div", {
        ...props,
        className: (0, $hekY6.default)([
            "_39xV02HZdu _0KLXru9r67 _2XsHFM1Y8M _0adFHs1Y8M _3138425UaJ _1DCdHi5UaJ"
        ])
    });
module.exports["BuiltInActionsOld"] = $164fd7006e7d8160$export$c5fb2fd13b5122a;
module.exports["BuiltInActionsPatch"] = $164fd7006e7d8160$export$8729c6345a54240d;
module.exports["BuiltInActionsSimple"] = $164fd7006e7d8160$export$d7f009f4a3abb74;
module.exports["DisabledButtonWrapper"] = $164fd7006e7d8160$export$b065c4c0e869841d;
module.exports["DisabledButtonOverlay"] = $164fd7006e7d8160$export$dea79eb12e1f6e1f;
module.exports["DividerOld"] = $164fd7006e7d8160$export$fb1f035d38cc4d20;
module.exports["Divider"] = $164fd7006e7d8160$export$2e0a83ec2e27ecbb;

});


//# sourceMappingURL=ViewPageContent.48dd52d3.js.map
